var _gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window;
(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function () {
		"use strict";
		_gsScope._gsDefine("TweenMax", ["core.Animation", "core.SimpleTimeline", "TweenLite"], function (n, u, y) {
				var g = function (t) {
						var e, i = [],
							n = t.length;
						for (e = 0; e !== n; i.push(t[e++]));
						return i
					},
					v = function (t, e, i) {
						var n, r, o = t.cycle;
						for (n in o) r = o[n], t[n] = "function" == typeof r ? r(i, e[i]) : r[i % r.length];
						delete t.cycle
					},
					x = function (t, e, i) {
						y.call(this, t, e, i), this._cycle = 0, this._yoyo = this.vars.yoyo === !0 || !!this.vars.yoyoEase, this._repeat = this.vars.repeat || 0, this._repeatDelay = this.vars.repeatDelay || 0, this._repeat && this._uncache(!0), this.render = x.prototype.render
					},
					_ = 1e-10,
					b = y._internals,
					w = b.isSelector,
					T = b.isArray,
					t = x.prototype = y.to({}, .1, {}),
					E = [];
				x.version = "1.20.5", t.constructor = x, t.kill()._gc = !1, x.killTweensOf = x.killDelayedCallsTo = y.killTweensOf, x.getTweensOf = y.getTweensOf, x.lagSmoothing = y.lagSmoothing, x.ticker = y.ticker, x.render = y.render, t.invalidate = function () {
					return this._yoyo = this.vars.yoyo === !0 || !!this.vars.yoyoEase, this._repeat = this.vars.repeat || 0, this._repeatDelay = this.vars.repeatDelay || 0, this._yoyoEase = null, this._uncache(!0), y.prototype.invalidate.call(this)
				}, t.updateTo = function (t, e) {
					var i, n = this.ratio,
						r = this.vars.immediateRender || t.immediateRender;
					e && this._startTime < this._timeline._time && (this._startTime = this._timeline._time, this._uncache(!1), this._gc ? this._enabled(!0, !1) : this._timeline.insert(this, this._startTime - this._delay));
					for (i in t) this.vars[i] = t[i];
					if (this._initted || r)
						if (e) this._initted = !1, r && this.render(0, !0, !0);
						else if (this._gc && this._enabled(!0, !1), this._notifyPluginsOfEnabled && this._firstPT && y._onPluginEvent("_onDisable", this), this._time / this._duration > .998) {
						var o = this._totalTime;
						this.render(0, !0, !1), this._initted = !1, this.render(o, !0, !1)
					} else if (this._initted = !1, this._init(), this._time > 0 || r)
						for (var a, s = 1 / (1 - n), l = this._firstPT; l;) a = l.s + l.c, l.c *= s, l.s = a - l.c, l = l._next;
					return this
				}, t.render = function (t, e, i) {
					this._initted || 0 === this._duration && this.vars.repeat && this.invalidate();
					var n, r, o, a, s, l, c, u, h, d = this._dirty ? this.totalDuration() : this._totalDuration,
						f = this._time,
						p = this._totalTime,
						m = this._cycle,
						g = this._duration,
						v = this._rawPrevTime;
					if (t >= d - 1e-7 && t >= 0 ? (this._totalTime = d, this._cycle = this._repeat, this._yoyo && 0 !== (1 & this._cycle) ? (this._time = 0, this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0) : (this._time = g, this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1), this._reversed || (n = !0, r = "onComplete", i = i || this._timeline.autoRemoveChildren), 0 === g && (this._initted || !this.vars.lazy || i) && (this._startTime === this._timeline._duration && (t = 0), (0 > v || 0 >= t && t >= -1e-7 || v === _ && "isPause" !== this.data) && v !== t && (i = !0, v > _ && (r = "onReverseComplete")), this._rawPrevTime = u = !e || t || v === t ? t : _)) : 1e-7 > t ? (this._totalTime = this._time = this._cycle = 0, this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0, (0 !== p || 0 === g && v > 0) && (r = "onReverseComplete", n = this._reversed), 0 > t && (this._active = !1, 0 === g && (this._initted || !this.vars.lazy || i) && (v >= 0 && (i = !0), this._rawPrevTime = u = !e || t || v === t ? t : _)), this._initted || (i = !0)) : (this._totalTime = this._time = t, 0 !== this._repeat && (a = g + this._repeatDelay, this._cycle = this._totalTime / a >> 0, 0 !== this._cycle && this._cycle === this._totalTime / a && t >= p && this._cycle--, this._time = this._totalTime - this._cycle * a, this._yoyo && 0 !== (1 & this._cycle) && (this._time = g - this._time, h = this._yoyoEase || this.vars.yoyoEase, h && (this._yoyoEase || (h !== !0 || this._initted ? this._yoyoEase = h = h === !0 ? this._ease : h instanceof Ease ? h : Ease.map[h] : (h = this.vars.ease, this._yoyoEase = h = h ? h instanceof Ease ? h : "function" == typeof h ? new Ease(h, this.vars.easeParams) : Ease.map[h] || y.defaultEase : y.defaultEase)), this.ratio = h ? 1 - h.getRatio((g - this._time) / g) : 0)), this._time > g ? this._time = g : this._time < 0 && (this._time = 0)), this._easeType && !h ? (s = this._time / g, l = this._easeType, c = this._easePower, (1 === l || 3 === l && s >= .5) && (s = 1 - s), 3 === l && (s *= 2), 1 === c ? s *= s : 2 === c ? s *= s * s : 3 === c ? s *= s * s * s : 4 === c && (s *= s * s * s * s), 1 === l ? this.ratio = 1 - s : 2 === l ? this.ratio = s : this._time / g < .5 ? this.ratio = s / 2 : this.ratio = 1 - s / 2) : h || (this.ratio = this._ease.getRatio(this._time / g))), f === this._time && !i && m === this._cycle) return void(p !== this._totalTime && this._onUpdate && (e || this._callback("onUpdate")));
					if (!this._initted) {
						if (this._init(), !this._initted || this._gc) return;
						if (!i && this._firstPT && (this.vars.lazy !== !1 && this._duration || this.vars.lazy && !this._duration)) return this._time = f, this._totalTime = p, this._rawPrevTime = v, this._cycle = m, b.lazyTweens.push(this), void(this._lazy = [t, e]);
						!this._time || n || h ? n && this._ease._calcEnd && !h && (this.ratio = this._ease.getRatio(0 === this._time ? 0 : 1)) : this.ratio = this._ease.getRatio(this._time / g)
					}
					for (this._lazy !== !1 && (this._lazy = !1), this._active || !this._paused && this._time !== f && t >= 0 && (this._active = !0), 0 === p && (2 === this._initted && t > 0 && this._init(), this._startAt && (t >= 0 ? this._startAt.render(t, !0, i) : r || (r = "_dummyGS")), this.vars.onStart && (0 !== this._totalTime || 0 === g) && (e || this._callback("onStart"))), o = this._firstPT; o;) o.f ? o.t[o.p](o.c * this.ratio + o.s) : o.t[o.p] = o.c * this.ratio + o.s, o = o._next;
					this._onUpdate && (0 > t && this._startAt && this._startTime && this._startAt.render(t, !0, i), e || (this._totalTime !== p || r) && this._callback("onUpdate")), this._cycle !== m && (e || this._gc || this.vars.onRepeat && this._callback("onRepeat")), r && (!this._gc || i) && (0 > t && this._startAt && !this._onUpdate && this._startTime && this._startAt.render(t, !0, i), n && (this._timeline.autoRemoveChildren && this._enabled(!1, !1), this._active = !1), !e && this.vars[r] && this._callback(r), 0 === g && this._rawPrevTime === _ && u !== _ && (this._rawPrevTime = 0))
				}, x.to = function (t, e, i) {
					return new x(t, e, i)
				}, x.from = function (t, e, i) {
					return i.runBackwards = !0, i.immediateRender = 0 != i.immediateRender, new x(t, e, i)
				}, x.fromTo = function (t, e, i, n) {
					return n.startAt = i, n.immediateRender = 0 != n.immediateRender && 0 != i.immediateRender, new x(t, e, n)
				}, x.staggerTo = x.allTo = function (t, e, i, n, r, o, a) {
					n = n || 0;
					var s, l, c, u, h = 0,
						d = [],
						f = function () {
							i.onComplete && i.onComplete.apply(i.onCompleteScope || this, arguments), r.apply(a || i.callbackScope || this, o || E)
						},
						p = i.cycle,
						m = i.startAt && i.startAt.cycle;
					for (T(t) || ("string" == typeof t && (t = y.selector(t) || t), w(t) && (t = g(t))), t = t || [], 0 > n && (t = g(t), t.reverse(), n *= -1), s = t.length - 1, c = 0; s >= c; c++) {
						l = {};
						for (u in i) l[u] = i[u];
						if (p && (v(l, t, c), null != l.duration && (e = l.duration, delete l.duration)), m) {
							m = l.startAt = {};
							for (u in i.startAt) m[u] = i.startAt[u];
							v(l.startAt, t, c)
						}
						l.delay = h + (l.delay || 0), c === s && r && (l.onComplete = f), d[c] = new x(t[c], e, l), h += n
					}
					return d
				}, x.staggerFrom = x.allFrom = function (t, e, i, n, r, o, a) {
					return i.runBackwards = !0, i.immediateRender = 0 != i.immediateRender, x.staggerTo(t, e, i, n, r, o, a)
				}, x.staggerFromTo = x.allFromTo = function (t, e, i, n, r, o, a, s) {
					return n.startAt = i, n.immediateRender = 0 != n.immediateRender && 0 != i.immediateRender, x.staggerTo(t, e, n, r, o, a, s)
				}, x.delayedCall = function (t, e, i, n, r) {
					return new x(e, 0, {
						delay: t,
						onComplete: e,
						onCompleteParams: i,
						callbackScope: n,
						onReverseComplete: e,
						onReverseCompleteParams: i,
						immediateRender: !1,
						useFrames: r,
						overwrite: 0
					})
				}, x.set = function (t, e) {
					return new x(t, 0, e)
				}, x.isTweening = function (t) {
					return y.getTweensOf(t, !0).length > 0
				};
				var o = function (t, e) {
						for (var i = [], n = 0, r = t._first; r;) r instanceof y ? i[n++] = r : (e && (i[n++] = r), i = i.concat(o(r, e)), n = i.length), r = r._next;
						return i
					},
					h = x.getAllTweens = function (t) {
						return o(n._rootTimeline, t).concat(o(n._rootFramesTimeline, t))
					};
				x.killAll = function (t, e, i, n) {
					null == e && (e = !0), null == i && (i = !0);
					var r, o, a, s = h(0 != n),
						l = s.length,
						c = e && i && n;
					for (a = 0; l > a; a++) o = s[a], (c || o instanceof u || (r = o.target === o.vars.onComplete) && i || e && !r) && (t ? o.totalTime(o._reversed ? 0 : o.totalDuration()) : o._enabled(!1, !1))
				}, x.killChildTweensOf = function (t, e) {
					if (null != t) {
						var i, n, r, o, a, s = b.tweenLookup;
						if ("string" == typeof t && (t = y.selector(t) || t), w(t) && (t = g(t)), T(t))
							for (o = t.length; --o > -1;) x.killChildTweensOf(t[o], e);
						else {
							i = [];
							for (r in s)
								for (n = s[r].target.parentNode; n;) n === t && (i = i.concat(s[r].tweens)), n = n.parentNode;
							for (a = i.length, o = 0; a > o; o++) e && i[o].totalTime(i[o].totalDuration()), i[o]._enabled(!1, !1)
						}
					}
				};
				var r = function (t, e, i, n) {
					e = e !== !1, i = i !== !1, n = n !== !1;
					for (var r, o, a = h(n), s = e && i && n, l = a.length; --l > -1;) o = a[l], (s || o instanceof u || (r = o.target === o.vars.onComplete) && i || e && !r) && o.paused(t)
				};
				return x.pauseAll = function (t, e, i) {
					r(!0, t, e, i)
				}, x.resumeAll = function (t, e, i) {
					r(!1, t, e, i)
				}, x.globalTimeScale = function (t) {
					var e = n._rootTimeline,
						i = y.ticker.time;
					return arguments.length ? (t = t || _, e._startTime = i - (i - e._startTime) * e._timeScale / t, e = n._rootFramesTimeline, i = y.ticker.frame, e._startTime = i - (i - e._startTime) * e._timeScale / t, e._timeScale = n._rootTimeline._timeScale = t, t) : e._timeScale
				}, t.progress = function (t, e) {
					return arguments.length ? this.totalTime(this.duration() * (this._yoyo && 0 !== (1 & this._cycle) ? 1 - t : t) + this._cycle * (this._duration + this._repeatDelay), e) : this._time / this.duration()
				}, t.totalProgress = function (t, e) {
					return arguments.length ? this.totalTime(this.totalDuration() * t, e) : this._totalTime / this.totalDuration()
				}, t.time = function (t, e) {
					return arguments.length ? (this._dirty && this.totalDuration(), t > this._duration && (t = this._duration), this._yoyo && 0 !== (1 & this._cycle) ? t = this._duration - t + this._cycle * (this._duration + this._repeatDelay) : 0 !== this._repeat && (t += this._cycle * (this._duration + this._repeatDelay)), this.totalTime(t, e)) : this._time
				}, t.duration = function (t) {
					return arguments.length ? n.prototype.duration.call(this, t) : this._duration
				}, t.totalDuration = function (t) {
					return arguments.length ? -1 === this._repeat ? this : this.duration((t - this._repeat * this._repeatDelay) / (this._repeat + 1)) : (this._dirty && (this._totalDuration = -1 === this._repeat ? 999999999999 : this._duration * (this._repeat + 1) + this._repeatDelay * this._repeat, this._dirty = !1), this._totalDuration)
				}, t.repeat = function (t) {
					return arguments.length ? (this._repeat = t, this._uncache(!0)) : this._repeat
				}, t.repeatDelay = function (t) {
					return arguments.length ? (this._repeatDelay = t, this._uncache(!0)) : this._repeatDelay
				}, t.yoyo = function (t) {
					return arguments.length ? (this._yoyo = t, this) : this._yoyo
				}, x
			}, !0), _gsScope._gsDefine("TimelineLite", ["core.Animation", "core.SimpleTimeline", "TweenLite"], function (u, h, d) {
				var f = function (t) {
						h.call(this, t), this._labels = {}, this.autoRemoveChildren = this.vars.autoRemoveChildren === !0, this.smoothChildTiming = this.vars.smoothChildTiming === !0, this._sortChildren = !0, this._onUpdate = this.vars.onUpdate;
						var e, i, n = this.vars;
						for (i in n) e = n[i], g(e) && -1 !== e.join("").indexOf("{self}") && (n[i] = this._swapSelfInParams(e));
						g(n.tweens) && this.add(n.tweens, 0, n.align, n.stagger)
					},
					m = 1e-10,
					t = d._internals,
					e = f._internals = {},
					p = t.isSelector,
					g = t.isArray,
					v = t.lazyTweens,
					y = t.lazyRender,
					a = _gsScope._gsDefine.globals,
					x = function (t) {
						var e, i = {};
						for (e in t) i[e] = t[e];
						return i
					},
					_ = function (t, e, i) {
						var n, r, o = t.cycle;
						for (n in o) r = o[n], t[n] = "function" == typeof r ? r(i, e[i]) : r[i % r.length];
						delete t.cycle
					},
					o = e.pauseCallback = function () {},
					b = function (t) {
						var e, i = [],
							n = t.length;
						for (e = 0; e !== n; i.push(t[e++]));
						return i
					},
					i = f.prototype = new h;
				return f.version = "1.20.4", i.constructor = f, i.kill()._gc = i._forcingPlayhead = i._hasPause = !1, i.to = function (t, e, i, n) {
					var r = i.repeat && a.TweenMax || d;
					return e ? this.add(new r(t, e, i), n) : this.set(t, i, n)
				}, i.from = function (t, e, i, n) {
					return this.add((i.repeat && a.TweenMax || d).from(t, e, i), n)
				}, i.fromTo = function (t, e, i, n, r) {
					var o = n.repeat && a.TweenMax || d;
					return e ? this.add(o.fromTo(t, e, i, n), r) : this.set(t, n, r)
				}, i.staggerTo = function (t, e, i, n, r, o, a, s) {
					var l, c, u = new f({
							onComplete: o,
							onCompleteParams: a,
							callbackScope: s,
							smoothChildTiming: this.smoothChildTiming
						}),
						h = i.cycle;
					for ("string" == typeof t && (t = d.selector(t) || t), t = t || [], p(t) && (t = b(t)), n = n || 0, 0 > n && (t = b(t), t.reverse(), n *= -1), c = 0; c < t.length; c++) l = x(i), l.startAt && (l.startAt = x(l.startAt), l.startAt.cycle && _(l.startAt, t, c)), h && (_(l, t, c), null != l.duration && (e = l.duration, delete l.duration)), u.to(t[c], e, l, c * n);
					return this.add(u, r)
				}, i.staggerFrom = function (t, e, i, n, r, o, a, s) {
					return i.immediateRender = 0 != i.immediateRender, i.runBackwards = !0, this.staggerTo(t, e, i, n, r, o, a, s)
				}, i.staggerFromTo = function (t, e, i, n, r, o, a, s, l) {
					return n.startAt = i, n.immediateRender = 0 != n.immediateRender && 0 != i.immediateRender, this.staggerTo(t, e, n, r, o, a, s, l)
				}, i.call = function (t, e, i, n) {
					return this.add(d.delayedCall(0, t, e, i), n)
				}, i.set = function (t, e, i) {
					return i = this._parseTimeOrLabel(i, 0, !0), null == e.immediateRender && (e.immediateRender = i === this._time && !this._paused), this.add(new d(t, 0, e), i)
				}, f.exportRoot = function (t, e) {
					t = t || {}, null == t.smoothChildTiming && (t.smoothChildTiming = !0);
					var i, n, r, o, a = new f(t),
						s = a._timeline;
					for (null == e && (e = !0), s._remove(a, !0), a._startTime = 0, a._rawPrevTime = a._time = a._totalTime = s._time, r = s._first; r;) o = r._next, e && r instanceof d && r.target === r.vars.onComplete || (n = r._startTime - r._delay, 0 > n && (i = 1), a.add(r, n)), r = o;
					return s.add(a, 0), i && a.totalDuration(), a
				}, i.add = function (t, e, i, n) {
					var r, o, a, s, l, c;
					if ("number" != typeof e && (e = this._parseTimeOrLabel(e, 0, !0, t)), !(t instanceof u)) {
						if (t instanceof Array || t && t.push && g(t)) {
							for (i = i || "normal", n = n || 0, r = e, o = t.length, a = 0; o > a; a++) g(s = t[a]) && (s = new f({
								tweens: s
							})), this.add(s, r), "string" != typeof s && "function" != typeof s && ("sequence" === i ? r = s._startTime + s.totalDuration() / s._timeScale : "start" === i && (s._startTime -= s.delay())), r += n;
							return this._uncache(!0)
						}
						if ("string" == typeof t) return this.addLabel(t, e);
						if ("function" != typeof t) throw "Cannot add " + t + " into the timeline; it is not a tween, timeline, function, or string.";
						t = d.delayedCall(0, t)
					}
					if (h.prototype.add.call(this, t, e), t._time && t.render((this.rawTime() - t._startTime) * t._timeScale, !1, !1), (this._gc || this._time === this._duration) && !this._paused && this._duration < this.duration())
						for (l = this, c = l.rawTime() > t._startTime; l._timeline;) c && l._timeline.smoothChildTiming ? l.totalTime(l._totalTime, !0) : l._gc && l._enabled(!0, !1), l = l._timeline;
					return this
				}, i.remove = function (t) {
					if (t instanceof u) {
						this._remove(t, !1);
						var e = t._timeline = t.vars.useFrames ? u._rootFramesTimeline : u._rootTimeline;
						return t._startTime = (t._paused ? t._pauseTime : e._time) - (t._reversed ? t.totalDuration() - t._totalTime : t._totalTime) / t._timeScale, this
					}
					if (t instanceof Array || t && t.push && g(t)) {
						for (var i = t.length; --i > -1;) this.remove(t[i]);
						return this
					}
					return "string" == typeof t ? this.removeLabel(t) : this.kill(null, t)
				}, i._remove = function (t, e) {
					h.prototype._remove.call(this, t, e);
					var i = this._last;
					return i ? this._time > this.duration() && (this._time = this._duration, this._totalTime = this._totalDuration) : this._time = this._totalTime = this._duration = this._totalDuration = 0, this
				}, i.append = function (t, e) {
					return this.add(t, this._parseTimeOrLabel(null, e, !0, t))
				}, i.insert = i.insertMultiple = function (t, e, i, n) {
					return this.add(t, e || 0, i, n)
				}, i.appendMultiple = function (t, e, i, n) {
					return this.add(t, this._parseTimeOrLabel(null, e, !0, t), i, n)
				}, i.addLabel = function (t, e) {
					return this._labels[t] = this._parseTimeOrLabel(e), this
				}, i.addPause = function (t, e, i, n) {
					var r = d.delayedCall(0, o, i, n || this);
					return r.vars.onComplete = r.vars.onReverseComplete = e, r.data = "isPause", this._hasPause = !0, this.add(r, t)
				}, i.removeLabel = function (t) {
					return delete this._labels[t], this
				}, i.getLabelTime = function (t) {
					return null != this._labels[t] ? this._labels[t] : -1
				}, i._parseTimeOrLabel = function (t, e, i, n) {
					var r, o;
					if (n instanceof u && n.timeline === this) this.remove(n);
					else if (n && (n instanceof Array || n.push && g(n)))
						for (o = n.length; --o > -1;) n[o] instanceof u && n[o].timeline === this && this.remove(n[o]);
					if (r = "number" != typeof t || e ? this.duration() > 99999999999 ? this.recent().endTime(!1) : this._duration : 0, "string" == typeof e) return this._parseTimeOrLabel(e, i && "number" == typeof t && null == this._labels[e] ? t - r : 0, i);
					if (e = e || 0, "string" != typeof t || !isNaN(t) && null == this._labels[t]) null == t && (t = r);
					else {
						if (o = t.indexOf("="), -1 === o) return null == this._labels[t] ? i ? this._labels[t] = r + e : e : this._labels[t] + e;
						e = parseInt(t.charAt(o - 1) + "1", 10) * Number(t.substr(o + 1)), t = o > 1 ? this._parseTimeOrLabel(t.substr(0, o - 1), 0, i) : r
					}
					return Number(t) + e
				}, i.seek = function (t, e) {
					return this.totalTime("number" == typeof t ? t : this._parseTimeOrLabel(t), e !== !1)
				}, i.stop = function () {
					return this.paused(!0)
				}, i.gotoAndPlay = function (t, e) {
					return this.play(t, e)
				}, i.gotoAndStop = function (t, e) {
					return this.pause(t, e)
				}, i.render = function (t, e, i) {
					this._gc && this._enabled(!0, !1);
					var n, r, o, a, s, l, c, u = this._time,
						h = this._dirty ? this.totalDuration() : this._totalDuration,
						d = this._startTime,
						f = this._timeScale,
						p = this._paused;
					if (u !== this._time && (t += this._time - u), t >= h - 1e-7 && t >= 0) this._totalTime = this._time = h, this._reversed || this._hasPausedChild() || (r = !0, a = "onComplete", s = !!this._timeline.autoRemoveChildren, 0 === this._duration && (0 >= t && t >= -1e-7 || this._rawPrevTime < 0 || this._rawPrevTime === m) && this._rawPrevTime !== t && this._first && (s = !0, this._rawPrevTime > m && (a = "onReverseComplete"))), this._rawPrevTime = this._duration || !e || t || this._rawPrevTime === t ? t : m, t = h + 1e-4;
					else if (1e-7 > t)
						if (this._totalTime = this._time = 0, (0 !== u || 0 === this._duration && this._rawPrevTime !== m && (this._rawPrevTime > 0 || 0 > t && this._rawPrevTime >= 0)) && (a = "onReverseComplete", r = this._reversed), 0 > t) this._active = !1, this._timeline.autoRemoveChildren && this._reversed ? (s = r = !0, a = "onReverseComplete") : this._rawPrevTime >= 0 && this._first && (s = !0), this._rawPrevTime = t;
						else {
							if (this._rawPrevTime = this._duration || !e || t || this._rawPrevTime === t ? t : m, 0 === t && r)
								for (n = this._first; n && 0 === n._startTime;) n._duration || (r = !1), n = n._next;
							t = 0, this._initted || (s = !0)
						}
					else {
						if (this._hasPause && !this._forcingPlayhead && !e) {
							if (t >= u)
								for (n = this._first; n && n._startTime <= t && !l;) n._duration || "isPause" !== n.data || n.ratio || 0 === n._startTime && 0 === this._rawPrevTime || (l = n), n = n._next;
							else
								for (n = this._last; n && n._startTime >= t && !l;) n._duration || "isPause" === n.data && n._rawPrevTime > 0 && (l = n), n = n._prev;
							l && (this._time = t = l._startTime, this._totalTime = t + this._cycle * (this._totalDuration + this._repeatDelay))
						}
						this._totalTime = this._time = this._rawPrevTime = t
					}
					if (this._time !== u && this._first || i || s || l) {
						if (this._initted || (this._initted = !0), this._active || !this._paused && this._time !== u && t > 0 && (this._active = !0), 0 === u && this.vars.onStart && (0 === this._time && this._duration || e || this._callback("onStart")), c = this._time, c >= u)
							for (n = this._first; n && (o = n._next, c === this._time && (!this._paused || p));)(n._active || n._startTime <= c && !n._paused && !n._gc) && (l === n && this.pause(), n._reversed ? n.render((n._dirty ? n.totalDuration() : n._totalDuration) - (t - n._startTime) * n._timeScale, e, i) : n.render((t - n._startTime) * n._timeScale, e, i)), n = o;
						else
							for (n = this._last; n && (o = n._prev, c === this._time && (!this._paused || p));) {
								if (n._active || n._startTime <= u && !n._paused && !n._gc) {
									if (l === n) {
										for (l = n._prev; l && l.endTime() > this._time;) l.render(l._reversed ? l.totalDuration() - (t - l._startTime) * l._timeScale : (t - l._startTime) * l._timeScale, e, i), l = l._prev;
										l = null, this.pause()
									}
									n._reversed ? n.render((n._dirty ? n.totalDuration() : n._totalDuration) - (t - n._startTime) * n._timeScale, e, i) : n.render((t - n._startTime) * n._timeScale, e, i)
								}
								n = o
							}
						this._onUpdate && (e || (v.length && y(), this._callback("onUpdate"))), a && (this._gc || (d === this._startTime || f !== this._timeScale) && (0 === this._time || h >= this.totalDuration()) && (r && (v.length && y(), this._timeline.autoRemoveChildren && this._enabled(!1, !1), this._active = !1), !e && this.vars[a] && this._callback(a)))
					}
				}, i._hasPausedChild = function () {
					for (var t = this._first; t;) {
						if (t._paused || t instanceof f && t._hasPausedChild()) return !0;
						t = t._next
					}
					return !1
				}, i.getChildren = function (t, e, i, n) {
					n = n || -9999999999;
					for (var r = [], o = this._first, a = 0; o;) o._startTime < n || (o instanceof d ? e !== !1 && (r[a++] = o) : (i !== !1 && (r[a++] = o), t !== !1 && (r = r.concat(o.getChildren(!0, e, i)), a = r.length))), o = o._next;
					return r
				}, i.getTweensOf = function (t, e) {
					var i, n, r = this._gc,
						o = [],
						a = 0;
					for (r && this._enabled(!0, !0), i = d.getTweensOf(t), n = i.length; --n > -1;)(i[n].timeline === this || e && this._contains(i[n])) && (o[a++] = i[n]);
					return r && this._enabled(!1, !0), o
				}, i.recent = function () {
					return this._recent
				}, i._contains = function (t) {
					for (var e = t.timeline; e;) {
						if (e === this) return !0;
						e = e.timeline
					}
					return !1
				}, i.shiftChildren = function (t, e, i) {
					i = i || 0;
					for (var n, r = this._first, o = this._labels; r;) r._startTime >= i && (r._startTime += t), r = r._next;
					if (e)
						for (n in o) o[n] >= i && (o[n] += t);
					return this._uncache(!0)
				}, i._kill = function (t, e) {
					if (!t && !e) return this._enabled(!1, !1);
					for (var i = e ? this.getTweensOf(e) : this.getChildren(!0, !0, !1), n = i.length, r = !1; --n > -1;) i[n]._kill(t, e) && (r = !0);
					return r
				}, i.clear = function (t) {
					var e = this.getChildren(!1, !0, !0),
						i = e.length;
					for (this._time = this._totalTime = 0; --i > -1;) e[i]._enabled(!1, !1);
					return t !== !1 && (this._labels = {}), this._uncache(!0)
				}, i.invalidate = function () {
					for (var t = this._first; t;) t.invalidate(), t = t._next;
					return u.prototype.invalidate.call(this)
				}, i._enabled = function (t, e) {
					if (t === this._gc)
						for (var i = this._first; i;) i._enabled(t, !0), i = i._next;
					return h.prototype._enabled.call(this, t, e)
				}, i.totalTime = function (t, e, i) {
					this._forcingPlayhead = !0;
					var n = u.prototype.totalTime.apply(this, arguments);
					return this._forcingPlayhead = !1, n
				}, i.duration = function (t) {
					return arguments.length ? (0 !== this.duration() && 0 !== t && this.timeScale(this._duration / t), this) : (this._dirty && this.totalDuration(), this._duration)
				}, i.totalDuration = function (t) {
					if (!arguments.length) {
						if (this._dirty) {
							for (var e, i, n = 0, r = this._last, o = 999999999999; r;) e = r._prev, r._dirty && r.totalDuration(), r._startTime > o && this._sortChildren && !r._paused && !this._calculatingDuration ? (this._calculatingDuration = 1, this.add(r, r._startTime - r._delay), this._calculatingDuration = 0) : o = r._startTime, r._startTime < 0 && !r._paused && (n -= r._startTime, this._timeline.smoothChildTiming && (this._startTime += r._startTime / this._timeScale, this._time -= r._startTime, this._totalTime -= r._startTime, this._rawPrevTime -= r._startTime), this.shiftChildren(-r._startTime, !1, -9999999999), o = 0), i = r._startTime + r._totalDuration / r._timeScale, i > n && (n = i), r = e;
							this._duration = this._totalDuration = n, this._dirty = !1
						}
						return this._totalDuration
					}
					return t && this.totalDuration() ? this.timeScale(this._totalDuration / t) : this
				}, i.paused = function (t) {
					if (!t)
						for (var e = this._first, i = this._time; e;) e._startTime === i && "isPause" === e.data && (e._rawPrevTime = 0), e = e._next;
					return u.prototype.paused.apply(this, arguments)
				}, i.usesFrames = function () {
					for (var t = this._timeline; t._timeline;) t = t._timeline;
					return t === u._rootFramesTimeline
				}, i.rawTime = function (t) {
					return t && (this._paused || this._repeat && this.time() > 0 && this.totalProgress() < 1) ? this._totalTime % (this._duration + this._repeatDelay) : this._paused ? this._totalTime : (this._timeline.rawTime(t) - this._startTime) * this._timeScale
				}, f
			}, !0), _gsScope._gsDefine("TimelineMax", ["TimelineLite", "TweenLite", "easing.Ease"], function (e, s, t) {
				var i = function (t) {
						e.call(this, t), this._repeat = this.vars.repeat || 0, this._repeatDelay = this.vars.repeatDelay || 0, this._cycle = 0, this._yoyo = this.vars.yoyo === !0, this._dirty = !0
					},
					M = 1e-10,
					n = s._internals,
					A = n.lazyTweens,
					C = n.lazyRender,
					l = _gsScope._gsDefine.globals,
					c = new t(null, null, 1, 0),
					r = i.prototype = new e;
				return r.constructor = i, r.kill()._gc = !1, i.version = "1.20.4", r.invalidate = function () {
					return this._yoyo = this.vars.yoyo === !0, this._repeat = this.vars.repeat || 0, this._repeatDelay = this.vars.repeatDelay || 0, this._uncache(!0), e.prototype.invalidate.call(this)
				}, r.addCallback = function (t, e, i, n) {
					return this.add(s.delayedCall(0, t, i, n), e)
				}, r.removeCallback = function (t, e) {
					if (t)
						if (null == e) this._kill(null, t);
						else
							for (var i = this.getTweensOf(t, !1), n = i.length, r = this._parseTimeOrLabel(e); --n > -1;) i[n]._startTime === r && i[n]._enabled(!1, !1);
					return this
				}, r.removePause = function (t) {
					return this.removeCallback(e._internals.pauseCallback, t)
				}, r.tweenTo = function (t, e) {
					e = e || {};
					var i, n, r, o = {
							ease: c,
							useFrames: this.usesFrames(),
							immediateRender: !1,
							lazy: !1
						},
						a = e.repeat && l.TweenMax || s;
					for (n in e) o[n] = e[n];
					return o.time = this._parseTimeOrLabel(t), i = Math.abs(Number(o.time) - this._time) / this._timeScale || .001, r = new a(this, i, o), o.onStart = function () {
						r.target.paused(!0), r.vars.time === r.target.time() || i !== r.duration() || r.isFromTo || r.duration(Math.abs(r.vars.time - r.target.time()) / r.target._timeScale).render(r.time(), !0, !0), e.onStart && e.onStart.apply(e.onStartScope || e.callbackScope || r, e.onStartParams || [])
					}, r
				}, r.tweenFromTo = function (t, e, i) {
					i = i || {}, t = this._parseTimeOrLabel(t), i.startAt = {
						onComplete: this.seek,
						onCompleteParams: [t],
						callbackScope: this
					}, i.immediateRender = i.immediateRender !== !1;
					var n = this.tweenTo(e, i);
					return n.isFromTo = 1, n.duration(Math.abs(n.vars.time - t) / this._timeScale || .001)
				}, r.render = function (t, e, i) {
					this._gc && this._enabled(!0, !1);
					var n, r, o, a, s, l, c, u, h = this._time,
						d = this._dirty ? this.totalDuration() : this._totalDuration,
						f = this._duration,
						p = this._totalTime,
						m = this._startTime,
						g = this._timeScale,
						v = this._rawPrevTime,
						y = this._paused,
						x = this._cycle;
					if (h !== this._time && (t += this._time - h), t >= d - 1e-7 && t >= 0) this._locked || (this._totalTime = d, this._cycle = this._repeat), this._reversed || this._hasPausedChild() || (r = !0, a = "onComplete", s = !!this._timeline.autoRemoveChildren, 0 === this._duration && (0 >= t && t >= -1e-7 || 0 > v || v === M) && v !== t && this._first && (s = !0, v > M && (a = "onReverseComplete"))), this._rawPrevTime = this._duration || !e || t || this._rawPrevTime === t ? t : M, this._yoyo && 0 !== (1 & this._cycle) ? this._time = t = 0 : (this._time = f, t = f + 1e-4);
					else if (1e-7 > t)
						if (this._locked || (this._totalTime = this._cycle = 0), this._time = 0, (0 !== h || 0 === f && v !== M && (v > 0 || 0 > t && v >= 0) && !this._locked) && (a = "onReverseComplete", r = this._reversed), 0 > t) this._active = !1, this._timeline.autoRemoveChildren && this._reversed ? (s = r = !0, a = "onReverseComplete") : v >= 0 && this._first && (s = !0), this._rawPrevTime = t;
						else {
							if (this._rawPrevTime = f || !e || t || this._rawPrevTime === t ? t : M, 0 === t && r)
								for (n = this._first; n && 0 === n._startTime;) n._duration || (r = !1), n = n._next;
							t = 0, this._initted || (s = !0)
						}
					else if (0 === f && 0 > v && (s = !0), this._time = this._rawPrevTime = t, this._locked || (this._totalTime = t, 0 !== this._repeat && (l = f + this._repeatDelay, this._cycle = this._totalTime / l >> 0, 0 !== this._cycle && this._cycle === this._totalTime / l && t >= p && this._cycle--, this._time = this._totalTime - this._cycle * l, this._yoyo && 0 !== (1 & this._cycle) && (this._time = f - this._time), this._time > f ? (this._time = f, t = f + 1e-4) : this._time < 0 ? this._time = t = 0 : t = this._time)), this._hasPause && !this._forcingPlayhead && !e) {
						if (t = this._time, t >= h || this._repeat && x !== this._cycle)
							for (n = this._first; n && n._startTime <= t && !c;) n._duration || "isPause" !== n.data || n.ratio || 0 === n._startTime && 0 === this._rawPrevTime || (c = n), n = n._next;
						else
							for (n = this._last; n && n._startTime >= t && !c;) n._duration || "isPause" === n.data && n._rawPrevTime > 0 && (c = n), n = n._prev;
						c && c._startTime < f && (this._time = t = c._startTime, this._totalTime = t + this._cycle * (this._totalDuration + this._repeatDelay))
					}
					if (this._cycle !== x && !this._locked) {
						var _ = this._yoyo && 0 !== (1 & x),
							b = _ === (this._yoyo && 0 !== (1 & this._cycle)),
							w = this._totalTime,
							T = this._cycle,
							E = this._rawPrevTime,
							S = this._time;
						if (this._totalTime = x * f, this._cycle < x ? _ = !_ : this._totalTime += f, this._time = h, this._rawPrevTime = 0 === f ? v - 1e-4 : v, this._cycle = x, this._locked = !0, h = _ ? 0 : f, this.render(h, e, 0 === f), e || this._gc || this.vars.onRepeat && (this._cycle = T, this._locked = !1, this._callback("onRepeat")), h !== this._time) return;
						if (b && (this._cycle = x, this._locked = !0, h = _ ? f + 1e-4 : -1e-4, this.render(h, !0, !1)), this._locked = !1, this._paused && !y) return;
						this._time = S, this._totalTime = w, this._cycle = T, this._rawPrevTime = E
					}
					if (!(this._time !== h && this._first || i || s || c)) return void(p !== this._totalTime && this._onUpdate && (e || this._callback("onUpdate")));
					if (this._initted || (this._initted = !0), this._active || !this._paused && this._totalTime !== p && t > 0 && (this._active = !0), 0 === p && this.vars.onStart && (0 === this._totalTime && this._totalDuration || e || this._callback("onStart")), u = this._time, u >= h)
						for (n = this._first; n && (o = n._next, u === this._time && (!this._paused || y));)(n._active || n._startTime <= this._time && !n._paused && !n._gc) && (c === n && this.pause(), n._reversed ? n.render((n._dirty ? n.totalDuration() : n._totalDuration) - (t - n._startTime) * n._timeScale, e, i) : n.render((t - n._startTime) * n._timeScale, e, i)), n = o;
					else
						for (n = this._last; n && (o = n._prev, u === this._time && (!this._paused || y));) {
							if (n._active || n._startTime <= h && !n._paused && !n._gc) {
								if (c === n) {
									for (c = n._prev; c && c.endTime() > this._time;) c.render(c._reversed ? c.totalDuration() - (t - c._startTime) * c._timeScale : (t - c._startTime) * c._timeScale, e, i), c = c._prev;
									c = null, this.pause()
								}
								n._reversed ? n.render((n._dirty ? n.totalDuration() : n._totalDuration) - (t - n._startTime) * n._timeScale, e, i) : n.render((t - n._startTime) * n._timeScale, e, i)
							}
							n = o
						}
					this._onUpdate && (e || (A.length && C(), this._callback("onUpdate"))), a && (this._locked || this._gc || (m === this._startTime || g !== this._timeScale) && (0 === this._time || d >= this.totalDuration()) && (r && (A.length && C(), this._timeline.autoRemoveChildren && this._enabled(!1, !1), this._active = !1), !e && this.vars[a] && this._callback(a)))
				}, r.getActive = function (t, e, i) {
					null == t && (t = !0), null == e && (e = !0), null == i && (i = !1);
					var n, r, o = [],
						a = this.getChildren(t, e, i),
						s = 0,
						l = a.length;
					for (n = 0; l > n; n++) r = a[n], r.isActive() && (o[s++] = r);
					return o
				}, r.getLabelAfter = function (t) {
					t || 0 !== t && (t = this._time);
					var e, i = this.getLabelsArray(),
						n = i.length;
					for (e = 0; n > e; e++)
						if (i[e].time > t) return i[e].name;
					return null
				}, r.getLabelBefore = function (t) {
					null == t && (t = this._time);
					for (var e = this.getLabelsArray(), i = e.length; --i > -1;)
						if (e[i].time < t) return e[i].name;
					return null
				}, r.getLabelsArray = function () {
					var t, e = [],
						i = 0;
					for (t in this._labels) e[i++] = {
						time: this._labels[t],
						name: t
					};
					return e.sort(function (t, e) {
						return t.time - e.time
					}), e
				}, r.invalidate = function () {
					return this._locked = !1, e.prototype.invalidate.call(this)
				}, r.progress = function (t, e) {
					return arguments.length ? this.totalTime(this.duration() * (this._yoyo && 0 !== (1 & this._cycle) ? 1 - t : t) + this._cycle * (this._duration + this._repeatDelay), e) : this._time / this.duration() || 0
				}, r.totalProgress = function (t, e) {
					return arguments.length ? this.totalTime(this.totalDuration() * t, e) : this._totalTime / this.totalDuration() || 0
				}, r.totalDuration = function (t) {
					return arguments.length ? -1 !== this._repeat && t ? this.timeScale(this.totalDuration() / t) : this : (this._dirty && (e.prototype.totalDuration.call(this), this._totalDuration = -1 === this._repeat ? 999999999999 : this._duration * (this._repeat + 1) + this._repeatDelay * this._repeat), this._totalDuration)
				}, r.time = function (t, e) {
					return arguments.length ? (this._dirty && this.totalDuration(), t > this._duration && (t = this._duration), this._yoyo && 0 !== (1 & this._cycle) ? t = this._duration - t + this._cycle * (this._duration + this._repeatDelay) : 0 !== this._repeat && (t += this._cycle * (this._duration + this._repeatDelay)), this.totalTime(t, e)) : this._time
				}, r.repeat = function (t) {
					return arguments.length ? (this._repeat = t, this._uncache(!0)) : this._repeat
				}, r.repeatDelay = function (t) {
					return arguments.length ? (this._repeatDelay = t, this._uncache(!0)) : this._repeatDelay
				}, r.yoyo = function (t) {
					return arguments.length ? (this._yoyo = t, this) : this._yoyo
				}, r.currentLabel = function (t) {
					return arguments.length ? this.seek(t, !0) : this.getLabelBefore(this._time + 1e-8)
				}, i
			}, !0),
			function () {
				var T = 180 / Math.PI,
					b = [],
					w = [],
					E = [],
					v = {},
					i = _gsScope._gsDefine.globals,
					y = function (t, e, i, n) {
						i === n && (i = n - (n - e) / 1e6), t === e && (e = t + (i - t) / 1e6), this.a = t, this.b = e, this.c = i, this.d = n, this.da = n - t, this.ca = i - t, this.ba = e - t
					},
					x = ",x,y,z,left,top,right,bottom,marginTop,marginLeft,marginRight,marginBottom,paddingLeft,paddingTop,paddingRight,paddingBottom,backgroundPosition,backgroundPosition_y,",
					S = function (t, e, i, n) {
						var r = {
								a: t
							},
							o = {},
							a = {},
							s = {
								c: n
							},
							l = (t + e) / 2,
							c = (e + i) / 2,
							u = (i + n) / 2,
							h = (l + c) / 2,
							d = (c + u) / 2,
							f = (d - h) / 8;
						return r.b = l + (t - l) / 4, o.b = h + f, r.c = o.a = (r.b + o.b) / 2, o.c = a.a = (h + d) / 2, a.b = d - f, s.b = u + (n - u) / 4, a.c = s.a = (a.b + s.b) / 2, [r, o, a, s]
					},
					_ = function (t, e, i, n, r) {
						var o, a, s, l, c, u, h, d, f, p, m, g, v, y = t.length - 1,
							x = 0,
							_ = t[0].a;
						for (o = 0; y > o; o++) c = t[x], a = c.a, s = c.d, l = t[x + 1].d, r ? (m = b[o], g = w[o], v = (g + m) * e * .25 / (n ? .5 : E[o] || .5), u = s - (s - a) * (n ? .5 * e : 0 !== m ? v / m : 0), h = s + (l - s) * (n ? .5 * e : 0 !== g ? v / g : 0), d = s - (u + ((h - u) * (3 * m / (m + g) + .5) / 4 || 0))) : (u = s - (s - a) * e * .5, h = s + (l - s) * e * .5, d = s - (u + h) / 2), u += d, h += d, c.c = f = u, 0 !== o ? c.b = _ : c.b = _ = c.a + .6 * (c.c - c.a), c.da = s - a, c.ca = f - a, c.ba = _ - a, i ? (p = S(a, _, f, s), t.splice(x, 1, p[0], p[1], p[2], p[3]), x += 4) : x++, _ = h;
						c = t[x], c.b = _, c.c = _ + .4 * (c.d - _), c.da = c.d - c.a, c.ca = c.c - c.a, c.ba = _ - c.a, i && (p = S(c.a, _, c.c, c.d), t.splice(x, 1, p[0], p[1], p[2], p[3]))
					},
					M = function (t, e, i, n) {
						var r, o, a, s, l, c, u = [];
						if (n)
							for (t = [n].concat(t), o = t.length; --o > -1;) "string" == typeof (c = t[o][e]) && "=" === c.charAt(1) && (t[o][e] = n[e] + Number(c.charAt(0) + c.substr(2)));
						if (r = t.length - 2, 0 > r) return u[0] = new y(t[0][e], 0, 0, t[0][e]), u;
						for (o = 0; r > o; o++) a = t[o][e], s = t[o + 1][e], u[o] = new y(a, 0, 0, s), i && (l = t[o + 2][e], b[o] = (b[o] || 0) + (s - a) * (s - a), w[o] = (w[o] || 0) + (l - s) * (l - s));
						return u[o] = new y(t[o][e], 0, 0, t[o + 1][e]), u
					},
					f = function (t, e, i, n, r, o) {
						var a, s, l, c, u, h, d, f, p = {},
							m = [],
							g = o || t[0];
						r = "string" == typeof r ? "," + r + "," : x, null == e && (e = 1);
						for (s in t[0]) m.push(s);
						if (t.length > 1) {
							for (f = t[t.length - 1], d = !0, a = m.length; --a > -1;)
								if (s = m[a], Math.abs(g[s] - f[s]) > .05) {
									d = !1;
									break
								}
							d && (t = t.concat(), o && t.unshift(o), t.push(t[1]), o = t[t.length - 3])
						}
						for (b.length = w.length = E.length = 0, a = m.length; --a > -1;) s = m[a], v[s] = -1 !== r.indexOf("," + s + ","), p[s] = M(t, s, v[s], o);
						for (a = b.length; --a > -1;) b[a] = Math.sqrt(b[a]), w[a] = Math.sqrt(w[a]);
						if (!n) {
							for (a = m.length; --a > -1;)
								if (v[s])
									for (l = p[m[a]], h = l.length - 1, c = 0; h > c; c++) u = l[c + 1].da / w[c] + l[c].da / b[c] || 0, E[c] = (E[c] || 0) + u * u;
							for (a = E.length; --a > -1;) E[a] = Math.sqrt(E[a])
						}
						for (a = m.length, c = i ? 4 : 1; --a > -1;) s = m[a], l = p[s], _(l, e, i, n, v[s]), d && (l.splice(0, c), l.splice(l.length - c, c));
						return p
					},
					p = function (t, e, i) {
						e = e || "soft";
						var n, r, o, a, s, l, c, u, h, d, f, p = {},
							m = "cubic" === e ? 3 : 2,
							g = "soft" === e,
							v = [];
						if (g && i && (t = [i].concat(t)), null == t || t.length < m + 1) throw "invalid Bezier data";
						for (h in t[0]) v.push(h);
						for (l = v.length; --l > -1;) {
							for (h = v[l], p[h] = s = [], d = 0, u = t.length, c = 0; u > c; c++) n = null == i ? t[c][h] : "string" == typeof (f = t[c][h]) && "=" === f.charAt(1) ? i[h] + Number(f.charAt(0) + f.substr(2)) : Number(f), g && c > 1 && u - 1 > c && (s[d++] = (n + s[d - 2]) / 2), s[d++] = n;
							for (u = d - m + 1, d = 0, c = 0; u > c; c += m) n = s[c], r = s[c + 1], o = s[c + 2], a = 2 === m ? 0 : s[c + 3], s[d++] = f = 3 === m ? new y(n, r, o, a) : new y(n, (2 * r + n) / 3, (2 * r + o) / 3, o);
							s.length = d
						}
						return p
					},
					m = function (t, e, i) {
						for (var n, r, o, a, s, l, c, u, h, d, f, p = 1 / i, m = t.length; --m > -1;)
							for (d = t[m], o = d.a, a = d.d - o, s = d.c - o, l = d.b - o, n = r = 0, u = 1; i >= u; u++) c = p * u, h = 1 - c, n = r - (r = (c * c * a + 3 * h * (c * s + h * l)) * c), f = m * i + u - 1, e[f] = (e[f] || 0) + n * n
					},
					g = function (t, e) {
						e = e >> 0 || 6;
						var i, n, r, o, a = [],
							s = [],
							l = 0,
							c = 0,
							u = e - 1,
							h = [],
							d = [];
						for (i in t) m(t[i], a, e);
						for (r = a.length, n = 0; r > n; n++) l += Math.sqrt(a[n]), o = n % e, d[o] = l, o === u && (c += l, o = n / e >> 0, h[o] = d, s[o] = c, l = 0, d = []);
						return {
							length: c,
							lengths: s,
							segments: h
						}
					},
					A = _gsScope._gsDefine.plugin({
						propName: "bezier",
						priority: -1,
						version: "1.3.8",
						API: 2,
						global: !0,
						init: function (t, e, i) {
							this._target = t, e instanceof Array && (e = {
								values: e
							}), this._func = {}, this._mod = {}, this._props = [], this._timeRes = null == e.timeResolution ? 6 : parseInt(e.timeResolution, 10);
							var n, r, o, a, s, l = e.values || [],
								c = {},
								u = l[0],
								h = e.autoRotate || i.vars.orientToBezier;
							this._autoRotate = h ? h instanceof Array ? h : [
								["x", "y", "rotation", h === !0 ? 0 : Number(h) || 0]
							] : null;
							for (n in u) this._props.push(n);
							for (o = this._props.length; --o > -1;) n = this._props[o], this._overwriteProps.push(n), r = this._func[n] = "function" == typeof t[n], c[n] = r ? t[n.indexOf("set") || "function" != typeof t["get" + n.substr(3)] ? n : "get" + n.substr(3)]() : parseFloat(t[n]), s || c[n] !== l[0][n] && (s = c);
							if (this._beziers = "cubic" !== e.type && "quadratic" !== e.type && "soft" !== e.type ? f(l, isNaN(e.curviness) ? 1 : e.curviness, !1, "thruBasic" === e.type, e.correlate, s) : p(l, e.type, c), this._segCount = this._beziers[n].length, this._timeRes) {
								var d = g(this._beziers, this._timeRes);
								this._length = d.length, this._lengths = d.lengths, this._segments = d.segments, this._l1 = this._li = this._s1 = this._si = 0, this._l2 = this._lengths[0], this._curSeg = this._segments[0], this._s2 = this._curSeg[0], this._prec = 1 / this._curSeg.length
							}
							if (h = this._autoRotate)
								for (this._initialRotations = [], h[0] instanceof Array || (this._autoRotate = h = [h]), o = h.length; --o > -1;) {
									for (a = 0; 3 > a; a++) n = h[o][a], this._func[n] = "function" == typeof t[n] ? t[n.indexOf("set") || "function" != typeof t["get" + n.substr(3)] ? n : "get" + n.substr(3)] : !1;
									n = h[o][2], this._initialRotations[o] = (this._func[n] ? this._func[n].call(this._target) : this._target[n]) || 0, this._overwriteProps.push(n)
								}
							return this._startRatio = i.vars.runBackwards ? 1 : 0, !0
						},
						set: function (t) {
							var e, i, n, r, o, a, s, l, c, u, h = this._segCount,
								d = this._func,
								f = this._target,
								p = t !== this._startRatio;
							if (this._timeRes) {
								if (c = this._lengths, u = this._curSeg, t *= this._length, n = this._li, t > this._l2 && h - 1 > n) {
									for (l = h - 1; l > n && (this._l2 = c[++n]) <= t;);
									this._l1 = c[n - 1], this._li = n, this._curSeg = u = this._segments[n], this._s2 = u[this._s1 = this._si = 0]
								} else if (t < this._l1 && n > 0) {
									for (; n > 0 && (this._l1 = c[--n]) >= t;);
									0 === n && t < this._l1 ? this._l1 = 0 : n++, this._l2 = c[n], this._li = n, this._curSeg = u = this._segments[n], this._s1 = u[(this._si = u.length - 1) - 1] || 0, this._s2 = u[this._si]
								}
								if (e = n, t -= this._l1, n = this._si, t > this._s2 && n < u.length - 1) {
									for (l = u.length - 1; l > n && (this._s2 = u[++n]) <= t;);
									this._s1 = u[n - 1], this._si = n
								} else if (t < this._s1 && n > 0) {
									for (; n > 0 && (this._s1 = u[--n]) >= t;);
									0 === n && t < this._s1 ? this._s1 = 0 : n++, this._s2 = u[n], this._si = n
								}
								a = (n + (t - this._s1) / (this._s2 - this._s1)) * this._prec || 0
							} else e = 0 > t ? 0 : t >= 1 ? h - 1 : h * t >> 0, a = (t - e * (1 / h)) * h;
							for (i = 1 - a, n = this._props.length; --n > -1;) r = this._props[n], o = this._beziers[r][e], s = (a * a * o.da + 3 * i * (a * o.ca + i * o.ba)) * a + o.a, this._mod[r] && (s = this._mod[r](s, f)), d[r] ? f[r](s) : f[r] = s;
							if (this._autoRotate) {
								var m, g, v, y, x, _, b, w = this._autoRotate;
								for (n = w.length; --n > -1;) r = w[n][2], _ = w[n][3] || 0, b = w[n][4] === !0 ? 1 : T, o = this._beziers[w[n][0]], m = this._beziers[w[n][1]], o && m && (o = o[e], m = m[e], g = o.a + (o.b - o.a) * a, y = o.b + (o.c - o.b) * a, g += (y - g) * a, y += (o.c + (o.d - o.c) * a - y) * a, v = m.a + (m.b - m.a) * a, x = m.b + (m.c - m.b) * a, v += (x - v) * a, x += (m.c + (m.d - m.c) * a - x) * a, s = p ? Math.atan2(x - v, y - g) * b + _ : this._initialRotations[n], this._mod[r] && (s = this._mod[r](s, f)), d[r] ? f[r](s) : f[r] = s)
							}
						}
					}),
					t = A.prototype;
				A.bezierThrough = f, A.cubicToQuadratic = S, A._autoCSS = !0, A.quadraticToCubic = function (t, e, i) {
					return new y(t, (2 * e + t) / 3, (2 * e + i) / 3, i)
				}, A._cssRegister = function () {
					var t = i.CSSPlugin;
					if (t) {
						var e = t._internals,
							f = e._parseToProxy,
							p = e._setPluginRatio,
							m = e.CSSPropTween;
						e._registerComplexSpecialProp("bezier", {
							parser: function (t, e, i, n, r, o) {
								e instanceof Array && (e = {
									values: e
								}), o = new A;
								var a, s, l, c = e.values,
									u = c.length - 1,
									h = [],
									d = {};
								if (0 > u) return r;
								for (a = 0; u >= a; a++) l = f(t, c[a], n, r, o, u !== a), h[a] = l.end;
								for (s in e) d[s] = e[s];
								return d.values = h, r = new m(t, "bezier", 0, 0, l.pt, 2), r.data = l, r.plugin = o, r.setRatio = p, 0 === d.autoRotate && (d.autoRotate = !0), !d.autoRotate || d.autoRotate instanceof Array || (a = d.autoRotate === !0 ? 0 : Number(d.autoRotate), d.autoRotate = null != l.end.left ? [
									["left", "top", "rotation", a, !1]
								] : null != l.end.x ? [
									["x", "y", "rotation", a, !1]
								] : !1), d.autoRotate && (n._transform || n._enableTransforms(!1), l.autoRotate = n._target._gsTransform, l.proxy.rotation = l.autoRotate.rotation || 0, n._overwriteProps.push("rotation")), o._onInitTween(l.proxy, d, n._tween), r
							}
						})
					}
				}, t._mod = function (t) {
					for (var e, i = this._overwriteProps, n = i.length; --n > -1;) e = t[i[n]], e && "function" == typeof e && (this._mod[i[n]] = e)
				}, t._kill = function (t) {
					var e, i, n = this._props;
					for (e in this._beziers)
						if (e in t)
							for (delete this._beziers[e], delete this._func[e], i = n.length; --i > -1;) n[i] === e && n.splice(i, 1);
					if (n = this._autoRotate)
						for (i = n.length; --i > -1;) t[n[i][2]] && n.splice(i, 1);
					return this._super._kill.call(this, t)
				}
			}(), _gsScope._gsDefine("plugins.CSSPlugin", ["plugins.TweenPlugin", "TweenLite"], function (o, H) {
				var p, E, A, m, j = function () {
						o.call(this, "css"), this._overwriteProps.length = 0, this.setRatio = j.prototype.setRatio
					},
					c = _gsScope._gsDefine.globals,
					g = {},
					t = j.prototype = new o("css");
				t.constructor = j, j.version = "1.20.5", j.API = 2, j.defaultTransformPerspective = 0, j.defaultSkewType = "compensated", j.defaultSmoothOrigin = !0, t = "px", j.suffixMap = {
					top: t,
					right: t,
					bottom: t,
					left: t,
					width: t,
					height: t,
					fontSize: t,
					padding: t,
					margin: t,
					perspective: t,
					lineHeight: ""
				};
				var C, v, y, z, x, S, P, L, R = /(?:\-|\.|\b)(\d|\.|e\-)+/g,
					O = /(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g,
					_ = /(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi,
					u = /(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g,
					M = /(?:\d|\-|\+|=|#|\.)*/g,
					k = /opacity *= *([^)]*)/i,
					b = /opacity:([^;]*)/i,
					a = /alpha\(opacity *=.+?\)/i,
					w = /^(rgb|hsl)/,
					s = /([A-Z])/g,
					l = /-([a-z])/gi,
					T = /(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi,
					h = function (t, e) {
						return e.toUpperCase()
					},
					f = /(?:Left|Right|Width)/i,
					d = /(M11|M12|M21|M22)=[\d\-\.e]+/gi,
					N = /progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i,
					I = /,(?=[^\)]*(?:\(|$))/gi,
					D = /[\s,\(]/i,
					G = Math.PI / 180,
					V = 180 / Math.PI,
					F = {},
					e = {
						style: {}
					},
					B = _gsScope.document || {
						createElement: function () {
							return e
						}
					},
					U = function (t, e) {
						return B.createElementNS ? B.createElementNS(e || "http://www.w3.org/1999/xhtml", t) : B.createElement(t)
					},
					W = U("div"),
					X = U("img"),
					i = j._internals = {
						_specialProps: g
					},
					r = (_gsScope.navigator || {}).userAgent || "",
					Y = function () {
						var t = r.indexOf("Android"),
							e = U("a");
						return y = -1 !== r.indexOf("Safari") && -1 === r.indexOf("Chrome") && (-1 === t || parseFloat(r.substr(t + 8, 2)) > 3), x = y && parseFloat(r.substr(r.indexOf("Version/") + 8, 2)) < 6, z = -1 !== r.indexOf("Firefox"), (/MSIE ([0-9]{1,}[\.0-9]{0,})/.exec(r) || /Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/.exec(r)) && (S = parseFloat(RegExp.$1)), e ? (e.style.cssText = "top:1px;opacity:.55;", /^0.55/.test(e.style.opacity)) : !1
					}(),
					q = function (t) {
						return k.test("string" == typeof t ? t : (t.currentStyle ? t.currentStyle.filter : t.style.filter) || "") ? parseFloat(RegExp.$1) / 100 : 1
					},
					$ = function (t) {
						_gsScope.console && console.log(t)
					},
					Z = "",
					J = "",
					Q = function (t, e) {
						e = e || W;
						var i, n, r = e.style;
						if (void 0 !== r[t]) return t;
						for (t = t.charAt(0).toUpperCase() + t.substr(1), i = ["O", "Moz", "ms", "Ms", "Webkit"], n = 5; --n > -1 && void 0 === r[i[n] + t];);
						return n >= 0 ? (J = 3 === n ? "ms" : i[n], Z = "-" + J.toLowerCase() + "-", J + t) : null
					},
					K = ("undefined" != typeof window ? window : B.defaultView || {
						getComputedStyle: function () {}
					}).getComputedStyle,
					tt = j.getStyle = function (t, e, i, n, r) {
						var o;
						return Y || "opacity" !== e ? (!n && t.style[e] ? o = t.style[e] : (i = i || K(t)) ? o = i[e] || i.getPropertyValue(e) || i.getPropertyValue(e.replace(s, "-$1").toLowerCase()) : t.currentStyle && (o = t.currentStyle[e]), null == r || o && "none" !== o && "auto" !== o && "auto auto" !== o ? o : r) : q(t)
					},
					et = i.convertToPixels = function (t, e, i, n, r) {
						if ("px" === n || !n && "lineHeight" !== e) return i;
						if ("auto" === n || !i) return 0;
						var o, a, s, l = f.test(e),
							c = t,
							u = W.style,
							h = 0 > i,
							d = 1 === i;
						if (h && (i = -i), d && (i *= 100), "lineHeight" !== e || n)
							if ("%" === n && -1 !== e.indexOf("border")) o = i / 100 * (l ? t.clientWidth : t.clientHeight);
							else {
								if (u.cssText = "border:0 solid red;position:" + tt(t, "position") + ";line-height:0;", "%" !== n && c.appendChild && "v" !== n.charAt(0) && "rem" !== n) u[l ? "borderLeftWidth" : "borderTopWidth"] = i + n;
								else {
									if (c = t.parentNode || B.body, -1 !== tt(c, "display").indexOf("flex") && (u.position = "absolute"), a = c._gsCache, s = H.ticker.frame, a && l && a.time === s) return a.width * i / 100;
									u[l ? "width" : "height"] = i + n
								}
								c.appendChild(W), o = parseFloat(W[l ? "offsetWidth" : "offsetHeight"]), c.removeChild(W), l && "%" === n && j.cacheWidths !== !1 && (a = c._gsCache = c._gsCache || {}, a.time = s, a.width = o / i * 100), 0 !== o || r || (o = et(t, e, i, n, !0))
							}
						else a = K(t).lineHeight, t.style.lineHeight = i, o = parseFloat(K(t).lineHeight), t.style.lineHeight = a;
						return d && (o /= 100), h ? -o : o
					},
					it = i.calculateOffset = function (t, e, i) {
						if ("absolute" !== tt(t, "position", i)) return 0;
						var n = "left" === e ? "Left" : "Top",
							r = tt(t, "margin" + n, i);
						return t["offset" + n] - (et(t, e, parseFloat(r), r.replace(M, "")) || 0)
					},
					nt = function (t, e) {
						var i, n, r, o = {};
						if (e = e || K(t, null))
							if (i = e.length)
								for (; --i > -1;) r = e[i], (-1 === r.indexOf("-transform") || Pt === r) && (o[r.replace(l, h)] = e.getPropertyValue(r));
							else
								for (i in e)(-1 === i.indexOf("Transform") || Ct === i) && (o[i] = e[i]);
						else if (e = t.currentStyle || t.style)
							for (i in e) "string" == typeof i && void 0 === o[i] && (o[i.replace(l, h)] = e[i]);
						return Y || (o.opacity = q(t)), n = jt(t, e, !1), o.rotation = n.rotation, o.skewX = n.skewX, o.scaleX = n.scaleX, o.scaleY = n.scaleY, o.x = n.x, o.y = n.y, Rt && (o.z = n.z, o.rotationX = n.rotationX, o.rotationY = n.rotationY, o.scaleZ = n.scaleZ), o.filters && delete o.filters, o
					},
					rt = function (t, e, i, n, r) {
						var o, a, s, l = {},
							c = t.style;
						for (a in i) "cssText" !== a && "length" !== a && isNaN(a) && (e[a] !== (o = i[a]) || r && r[a]) && -1 === a.indexOf("Origin") && ("number" == typeof o || "string" == typeof o) && (l[a] = "auto" !== o || "left" !== a && "top" !== a ? "" !== o && "auto" !== o && "none" !== o || "string" != typeof e[a] || "" === e[a].replace(u, "") ? o : 0 : it(t, a), void 0 !== c[a] && (s = new yt(c, a, c[a], s)));
						if (n)
							for (a in n) "className" !== a && (l[a] = n[a]);
						return {
							difs: l,
							firstMPT: s
						}
					},
					ot = {
						width: ["Left", "Right"],
						height: ["Top", "Bottom"]
					},
					at = ["marginLeft", "marginRight", "marginTop", "marginBottom"],
					st = function (t, e, i) {
						if ("svg" === (t.nodeName + "").toLowerCase()) return (i || K(t))[e] || 0;
						if (t.getCTM && zt(t)) return t.getBBox()[e] || 0;
						var n = parseFloat("width" === e ? t.offsetWidth : t.offsetHeight),
							r = ot[e],
							o = r.length;
						for (i = i || K(t, null); --o > -1;) n -= parseFloat(tt(t, "padding" + r[o], i, !0)) || 0, n -= parseFloat(tt(t, "border" + r[o] + "Width", i, !0)) || 0;
						return n
					},
					lt = function (t, e) {
						if ("contain" === t || "auto" === t || "auto auto" === t) return t + " ";
						(null == t || "" === t) && (t = "0 0");
						var i, n = t.split(" "),
							r = -1 !== t.indexOf("left") ? "0%" : -1 !== t.indexOf("right") ? "100%" : n[0],
							o = -1 !== t.indexOf("top") ? "0%" : -1 !== t.indexOf("bottom") ? "100%" : n[1];
						if (n.length > 3 && !e) {
							for (n = t.split(", ").join(",").split(","), t = [], i = 0; i < n.length; i++) t.push(lt(n[i]));
							return t.join(",")
						}
						return null == o ? o = "center" === r ? "50%" : "0" : "center" === o && (o = "50%"), ("center" === r || isNaN(parseFloat(r)) && -1 === (r + "").indexOf("=")) && (r = "50%"), t = r + " " + o + (n.length > 2 ? " " + n[2] : ""), e && (e.oxp = -1 !== r.indexOf("%"), e.oyp = -1 !== o.indexOf("%"), e.oxr = "=" === r.charAt(1), e.oyr = "=" === o.charAt(1), e.ox = parseFloat(r.replace(u, "")), e.oy = parseFloat(o.replace(u, "")), e.v = t), e || t
					},
					ct = function (t, e) {
						return "function" == typeof t && (t = t(L, P)), "string" == typeof t && "=" === t.charAt(1) ? parseInt(t.charAt(0) + "1", 10) * parseFloat(t.substr(2)) : parseFloat(t) - parseFloat(e) || 0
					},
					ut = function (t, e) {
						return "function" == typeof t && (t = t(L, P)), null == t ? e : "string" == typeof t && "=" === t.charAt(1) ? parseInt(t.charAt(0) + "1", 10) * parseFloat(t.substr(2)) + e : parseFloat(t) || 0
					},
					ht = function (t, e, i, n) {
						var r, o, a, s, l, c = 1e-6;
						return "function" == typeof t && (t = t(L, P)), null == t ? s = e : "number" == typeof t ? s = t : (r = 360, o = t.split("_"), l = "=" === t.charAt(1), a = (l ? parseInt(t.charAt(0) + "1", 10) * parseFloat(o[0].substr(2)) : parseFloat(o[0])) * (-1 === t.indexOf("rad") ? 1 : V) - (l ? 0 : e), o.length && (n && (n[i] = e + a), -1 !== t.indexOf("short") && (a %= r, a !== a % (r / 2) && (a = 0 > a ? a + r : a - r)), -1 !== t.indexOf("_cw") && 0 > a ? a = (a + 9999999999 * r) % r - (a / r | 0) * r : -1 !== t.indexOf("ccw") && a > 0 && (a = (a - 9999999999 * r) % r - (a / r | 0) * r)), s = e + a), c > s && s > -c && (s = 0), s
					},
					dt = {
						aqua: [0, 255, 255],
						lime: [0, 255, 0],
						silver: [192, 192, 192],
						black: [0, 0, 0],
						maroon: [128, 0, 0],
						teal: [0, 128, 128],
						blue: [0, 0, 255],
						navy: [0, 0, 128],
						white: [255, 255, 255],
						fuchsia: [255, 0, 255],
						olive: [128, 128, 0],
						yellow: [255, 255, 0],
						orange: [255, 165, 0],
						gray: [128, 128, 128],
						purple: [128, 0, 128],
						green: [0, 128, 0],
						red: [255, 0, 0],
						pink: [255, 192, 203],
						cyan: [0, 255, 255],
						transparent: [255, 255, 255, 0]
					},
					ft = function (t, e, i) {
						return t = 0 > t ? t + 1 : t > 1 ? t - 1 : t, 255 * (1 > 6 * t ? e + (i - e) * t * 6 : .5 > t ? i : 2 > 3 * t ? e + (i - e) * (2 / 3 - t) * 6 : e) + .5 | 0
					},
					pt = j.parseColor = function (t, e) {
						var i, n, r, o, a, s, l, c, u, h, d;
						if (t)
							if ("number" == typeof t) i = [t >> 16, t >> 8 & 255, 255 & t];
							else {
								if ("," === t.charAt(t.length - 1) && (t = t.substr(0, t.length - 1)), dt[t]) i = dt[t];
								else if ("#" === t.charAt(0)) 4 === t.length && (n = t.charAt(1), r = t.charAt(2), o = t.charAt(3), t = "#" + n + n + r + r + o + o), t = parseInt(t.substr(1), 16), i = [t >> 16, t >> 8 & 255, 255 & t];
								else if ("hsl" === t.substr(0, 3))
									if (i = d = t.match(R), e) {
										if (-1 !== t.indexOf("=")) return t.match(O)
									} else a = Number(i[0]) % 360 / 360, s = Number(i[1]) / 100, l = Number(i[2]) / 100, r = .5 >= l ? l * (s + 1) : l + s - l * s, n = 2 * l - r, i.length > 3 && (i[3] = Number(i[3])), i[0] = ft(a + 1 / 3, n, r), i[1] = ft(a, n, r), i[2] = ft(a - 1 / 3, n, r);
								else i = t.match(R) || dt.transparent;
								i[0] = Number(i[0]), i[1] = Number(i[1]), i[2] = Number(i[2]), i.length > 3 && (i[3] = Number(i[3]))
							}
						else i = dt.black;
						return e && !d && (n = i[0] / 255, r = i[1] / 255, o = i[2] / 255, c = Math.max(n, r, o), u = Math.min(n, r, o), l = (c + u) / 2, c === u ? a = s = 0 : (h = c - u, s = l > .5 ? h / (2 - c - u) : h / (c + u), a = c === n ? (r - o) / h + (o > r ? 6 : 0) : c === r ? (o - n) / h + 2 : (n - r) / h + 4, a *= 60), i[0] = a + .5 | 0, i[1] = 100 * s + .5 | 0, i[2] = 100 * l + .5 | 0), i
					},
					n = function (t, e) {
						var i, n, r, o = t.match(mt) || [],
							a = 0,
							s = "";
						if (!o.length) return t;
						for (i = 0; i < o.length; i++) n = o[i], r = t.substr(a, t.indexOf(n, a) - a), a += r.length + n.length, n = pt(n, e), 3 === n.length && n.push(1), s += r + (e ? "hsla(" + n[0] + "," + n[1] + "%," + n[2] + "%," + n[3] : "rgba(" + n.join(",")) + ")";
						return s + t.substr(a)
					},
					mt = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b";
				for (t in dt) mt += "|" + t + "\\b";
				mt = new RegExp(mt + ")", "gi"), j.colorStringFilter = function (t) {
					var e, i = t[0] + " " + t[1];
					mt.test(i) && (e = -1 !== i.indexOf("hsl(") || -1 !== i.indexOf("hsla("), t[0] = n(t[0], e), t[1] = n(t[1], e)), mt.lastIndex = 0
				}, H.defaultStringFilter || (H.defaultStringFilter = j.colorStringFilter);
				var gt = function (t, e, o, a) {
						if (null == t) return function (t) {
							return t
						};
						var s, l = e ? (t.match(mt) || [""])[0] : "",
							c = t.split(l).join("").match(_) || [],
							u = t.substr(0, t.indexOf(c[0])),
							h = ")" === t.charAt(t.length - 1) ? ")" : "",
							d = -1 !== t.indexOf(" ") ? " " : ",",
							f = c.length,
							p = f > 0 ? c[0].replace(R, "") : "";
						return f ? s = e ? function (t) {
							var e, i, n, r;
							if ("number" == typeof t) t += p;
							else if (a && I.test(t)) {
								for (r = t.replace(I, "|").split("|"), n = 0; n < r.length; n++) r[n] = s(r[n]);
								return r.join(",")
							}
							if (e = (t.match(mt) || [l])[0], i = t.split(e).join("").match(_) || [], n = i.length, f > n--)
								for (; ++n < f;) i[n] = o ? i[(n - 1) / 2 | 0] : c[n];
							return u + i.join(d) + d + e + h + (-1 !== t.indexOf("inset") ? " inset" : "")
						} : function (t) {
							var e, i, n;
							if ("number" == typeof t) t += p;
							else if (a && I.test(t)) {
								for (i = t.replace(I, "|").split("|"), n = 0; n < i.length; n++) i[n] = s(i[n]);
								return i.join(",")
							}
							if (e = t.match(_) || [], n = e.length, f > n--)
								for (; ++n < f;) e[n] = o ? e[(n - 1) / 2 | 0] : c[n];
							return u + e.join(d) + h
						} : function (t) {
							return t
						}
					},
					vt = function (c) {
						return c = c.split(","),
							function (t, e, i, n, r, o, a) {
								var s, l = (e + "").split(" ");
								for (a = {}, s = 0; 4 > s; s++) a[c[s]] = l[s] = l[s] || l[(s - 1) / 2 >> 0];
								return n.parse(t, a, r, o)
							}
					},
					yt = (i._setPluginRatio = function (t) {
						this.plugin.setRatio(t);
						for (var e, i, n, r, o, a = this.data, s = a.proxy, l = a.firstMPT, c = 1e-6; l;) e = s[l.v], l.r ? e = l.r(e) : c > e && e > -c && (e = 0), l.t[l.p] = e, l = l._next;
						if (a.autoRotate && (a.autoRotate.rotation = a.mod ? a.mod.call(this._tween, s.rotation, this.t, this._tween) : s.rotation), 1 === t || 0 === t)
							for (l = a.firstMPT, o = 1 === t ? "e" : "b"; l;) {
								if (i = l.t, i.type) {
									if (1 === i.type) {
										for (r = i.xs0 + i.s + i.xs1, n = 1; n < i.l; n++) r += i["xn" + n] + i["xs" + (n + 1)];
										i[o] = r
									}
								} else i[o] = i.s + i.xs0;
								l = l._next
							}
					}, function (t, e, i, n, r) {
						this.t = t, this.p = e, this.v = i, this.r = r, n && (n._prev = this, this._next = n)
					}),
					xt = (i._parseToProxy = function (t, e, i, n, r, o) {
						var a, s, l, c, u, h = n,
							d = {},
							f = {},
							p = i._transform,
							m = F;
						for (i._transform = null, F = e, n = u = i.parse(t, e, n, r), F = m, o && (i._transform = p, h && (h._prev = null, h._prev && (h._prev._next = null))); n && n !== h;) {
							if (n.type <= 1 && (s = n.p, f[s] = n.s + n.c, d[s] = n.s, o || (c = new yt(n, "s", s, c, n.r), n.c = 0), 1 === n.type))
								for (a = n.l; --a > 0;) l = "xn" + a, s = n.p + "_" + l, f[s] = n.data[l], d[s] = n[l], o || (c = new yt(n, l, s, c, n.rxp[l]));
							n = n._next
						}
						return {
							proxy: d,
							end: f,
							firstMPT: c,
							pt: u
						}
					}, i.CSSPropTween = function (t, e, i, n, r, o, a, s, l, c, u) {
						this.t = t, this.p = e, this.s = i, this.c = n, this.n = a || e, t instanceof xt || m.push(this.n), this.r = s ? "function" == typeof s ? s : Math.round : s, this.type = o || 0, l && (this.pr = l, p = !0), this.b = void 0 === c ? i : c, this.e = void 0 === u ? i + n : u, r && (this._next = r, r._prev = this)
					}),
					_t = function (t, e, i, n, r, o) {
						var a = new xt(t, e, i, n - i, r, -1, o);
						return a.b = i, a.e = a.xs0 = n, a
					},
					bt = j.parseComplex = function (t, e, i, n, r, o, a, s, l, c) {
						i = i || o || "", "function" == typeof n && (n = n(L, P)), a = new xt(t, e, 0, 0, a, c ? 2 : 1, null, !1, s, i, n), n += "", r && mt.test(n + i) && (n = [i, n], j.colorStringFilter(n), i = n[0], n = n[1]);
						var u, h, d, f, p, m, g, v, y, x, _, b, w, T = i.split(", ").join(",").split(" "),
							E = n.split(", ").join(",").split(" "),
							S = T.length,
							M = C !== !1;
						for ((-1 !== n.indexOf(",") || -1 !== i.indexOf(",")) && (-1 !== (n + i).indexOf("rgb") || -1 !== (n + i).indexOf("hsl") ? (T = T.join(" ").replace(I, ", ").split(" "), E = E.join(" ").replace(I, ", ").split(" ")) : (T = T.join(" ").split(",").join(", ").split(" "), E = E.join(" ").split(",").join(", ").split(" ")), S = T.length), S !== E.length && (T = (o || "").split(" "), S = T.length), a.plugin = l, a.setRatio = c, mt.lastIndex = 0, u = 0; S > u; u++)
							if (f = T[u], p = E[u] + "", v = parseFloat(f), v || 0 === v) a.appendXtra("", v, ct(p, v), p.replace(O, ""), M && -1 !== p.indexOf("px") ? Math.round : !1, !0);
							else if (r && mt.test(f)) b = p.indexOf(")") + 1, b = ")" + (b ? p.substr(b) : ""), w = -1 !== p.indexOf("hsl") && Y, x = p, f = pt(f, w), p = pt(p, w), y = f.length + p.length > 6, y && !Y && 0 === p[3] ? (a["xs" + a.l] += a.l ? " transparent" : "transparent", a.e = a.e.split(E[u]).join("transparent")) : (Y || (y = !1), w ? a.appendXtra(x.substr(0, x.indexOf("hsl")) + (y ? "hsla(" : "hsl("), f[0], ct(p[0], f[0]), ",", !1, !0).appendXtra("", f[1], ct(p[1], f[1]), "%,", !1).appendXtra("", f[2], ct(p[2], f[2]), y ? "%," : "%" + b, !1) : a.appendXtra(x.substr(0, x.indexOf("rgb")) + (y ? "rgba(" : "rgb("), f[0], p[0] - f[0], ",", Math.round, !0).appendXtra("", f[1], p[1] - f[1], ",", Math.round).appendXtra("", f[2], p[2] - f[2], y ? "," : b, Math.round), y && (f = f.length < 4 ? 1 : f[3], a.appendXtra("", f, (p.length < 4 ? 1 : p[3]) - f, b, !1))), mt.lastIndex = 0;
						else if (m = f.match(R)) {
							if (g = p.match(O), !g || g.length !== m.length) return a;
							for (d = 0, h = 0; h < m.length; h++) _ = m[h], x = f.indexOf(_, d), a.appendXtra(f.substr(d, x - d), Number(_), ct(g[h], _), "", M && "px" === f.substr(x + _.length, 2) ? Math.round : !1, 0 === h), d = x + _.length;
							a["xs" + a.l] += f.substr(d)
						} else a["xs" + a.l] += a.l || a["xs" + a.l] ? " " + p : p;
						if (-1 !== n.indexOf("=") && a.data) {
							for (b = a.xs0 + a.data.s, u = 1; u < a.l; u++) b += a["xs" + u] + a.data["xn" + u];
							a.e = b + a["xs" + u]
						}
						return a.l || (a.type = -1, a.xs0 = a.e), a.xfirst || a
					},
					wt = 9;
				for (t = xt.prototype, t.l = t.pr = 0; --wt > 0;) t["xn" + wt] = 0, t["xs" + wt] = "";
				t.xs0 = "", t._next = t._prev = t.xfirst = t.data = t.plugin = t.setRatio = t.rxp = null, t.appendXtra = function (t, e, i, n, r, o) {
					var a = this,
						s = a.l;
					return a["xs" + s] += o && (s || a["xs" + s]) ? " " + t : t || "", i || 0 === s || a.plugin ? (a.l++, a.type = a.setRatio ? 2 : 1, a["xs" + a.l] = n || "", s > 0 ? (a.data["xn" + s] = e + i, a.rxp["xn" + s] = r, a["xn" + s] = e, a.plugin || (a.xfirst = new xt(a, "xn" + s, e, i, a.xfirst || a, 0, a.n, r, a.pr), a.xfirst.xs0 = 0), a) : (a.data = {
						s: e + i
					}, a.rxp = {}, a.s = e, a.c = i, a.r = r, a)) : (a["xs" + s] += e + (n || ""), a)
				};
				var Tt = function (t, e) {
						e = e || {}, this.p = e.prefix ? Q(t) || t : t, g[t] = g[this.p] = this, this.format = e.formatter || gt(e.defaultValue, e.color, e.collapsible, e.multi), e.parser && (this.parse = e.parser), this.clrs = e.color, this.multi = e.multi, this.keyword = e.keyword, this.dflt = e.defaultValue, this.pr = e.priority || 0
					},
					Et = i._registerComplexSpecialProp = function (t, e, i) {
						"object" != typeof e && (e = {
							parser: i
						});
						var n, r, o = t.split(","),
							a = e.defaultValue;
						for (i = i || [a], n = 0; n < o.length; n++) e.prefix = 0 === n && e.prefix, e.defaultValue = i[n] || a, r = new Tt(o[n], e)
					},
					St = i._registerPluginProp = function (t) {
						if (!g[t]) {
							var l = t.charAt(0).toUpperCase() + t.substr(1) + "Plugin";
							Et(t, {
								parser: function (t, e, i, n, r, o, a) {
									var s = c.com.greensock.plugins[l];
									return s ? (s._cssRegister(), g[i].parse(t, e, i, n, r, o, a)) : ($("Error: " + l + " js file not loaded."), r)
								}
							})
						}
					};
				t = Tt.prototype, t.parseComplex = function (t, e, i, n, r, o) {
					var a, s, l, c, u, h, d = this.keyword;
					if (this.multi && (I.test(i) || I.test(e) ? (s = e.replace(I, "|").split("|"), l = i.replace(I, "|").split("|")) : d && (s = [e], l = [i])), l) {
						for (c = l.length > s.length ? l.length : s.length, a = 0; c > a; a++) e = s[a] = s[a] || this.dflt, i = l[a] = l[a] || this.dflt, d && (u = e.indexOf(d), h = i.indexOf(d), u !== h && (-1 === h ? s[a] = s[a].split(d).join("") : -1 === u && (s[a] += " " + d)));
						e = s.join(", "), i = l.join(", ")
					}
					return bt(t, this.p, e, i, this.clrs, this.dflt, n, this.pr, r, o)
				}, t.parse = function (t, e, i, n, r, o, a) {
					return this.parseComplex(t.style, this.format(tt(t, this.p, A, !1, this.dflt)), this.format(e), r, o)
				}, j.registerSpecialProp = function (t, l, c) {
					Et(t, {
						parser: function (t, e, i, n, r, o, a) {
							var s = new xt(t, i, 0, 0, r, 2, i, !1, c);
							return s.plugin = o, s.setRatio = l(t, e, n._tween, i), s
						},
						priority: c
					})
				}, j.useSVGTransformAttr = !0;
				var Mt, At = "scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent".split(","),
					Ct = Q("transform"),
					Pt = Z + "transform",
					Lt = Q("transformOrigin"),
					Rt = null !== Q("perspective"),
					Ot = i.Transform = function () {
						this.perspective = parseFloat(j.defaultTransformPerspective) || 0, this.force3D = j.defaultForce3D !== !1 && Rt ? j.defaultForce3D || "auto" : !1
					},
					kt = _gsScope.SVGElement,
					Nt = function (t, e, i) {
						var n, r = B.createElementNS("http://www.w3.org/2000/svg", t),
							o = /([a-z])([A-Z])/g;
						for (n in i) r.setAttributeNS(null, n.replace(o, "$1-$2").toLowerCase(), i[n]);
						return e.appendChild(r), r
					},
					It = B.documentElement || {},
					Dt = function () {
						var t, e, i, n = S || /Android/i.test(r) && !_gsScope.chrome;
						return B.createElementNS && !n && (t = Nt("svg", It), e = Nt("rect", t, {
							width: 100,
							height: 50,
							x: 100
						}), i = e.getBoundingClientRect().width, e.style[Lt] = "50% 50%", e.style[Ct] = "scaleX(0.5)", n = i === e.getBoundingClientRect().width && !(z && Rt), It.removeChild(t)), n
					}(),
					Ft = function (t, e, i, n, r, o) {
						var a, s, l, c, u, h, d, f, p, m, g, v, y, x, _ = t._gsTransform,
							b = Ht(t, !0);
						_ && (y = _.xOrigin, x = _.yOrigin), (!n || (a = n.split(" ")).length < 2) && (d = t.getBBox(), 0 === d.x && 0 === d.y && d.width + d.height === 0 && (d = {
							x: parseFloat(t.hasAttribute("x") ? t.getAttribute("x") : t.hasAttribute("cx") ? t.getAttribute("cx") : 0) || 0,
							y: parseFloat(t.hasAttribute("y") ? t.getAttribute("y") : t.hasAttribute("cy") ? t.getAttribute("cy") : 0) || 0,
							width: 0,
							height: 0
						}), e = lt(e).split(" "), a = [(-1 !== e[0].indexOf("%") ? parseFloat(e[0]) / 100 * d.width : parseFloat(e[0])) + d.x, (-1 !== e[1].indexOf("%") ? parseFloat(e[1]) / 100 * d.height : parseFloat(e[1])) + d.y]), i.xOrigin = c = parseFloat(a[0]), i.yOrigin = u = parseFloat(a[1]), n && b !== Gt && (h = b[0], d = b[1], f = b[2], p = b[3], m = b[4], g = b[5], v = h * p - d * f, v && (s = c * (p / v) + u * (-f / v) + (f * g - p * m) / v, l = c * (-d / v) + u * (h / v) - (h * g - d * m) / v, c = i.xOrigin = a[0] = s, u = i.yOrigin = a[1] = l)), _ && (o && (i.xOffset = _.xOffset, i.yOffset = _.yOffset, _ = i), r || r !== !1 && j.defaultSmoothOrigin !== !1 ? (s = c - y, l = u - x, _.xOffset += s * b[0] + l * b[2] - s, _.yOffset += s * b[1] + l * b[3] - l) : _.xOffset = _.yOffset = 0), o || t.setAttribute("data-svg-origin", a.join(" "))
					},
					Bt = function (t) {
						var e, i = U("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"),
							n = this.parentNode,
							r = this.nextSibling,
							o = this.style.cssText;
						if (It.appendChild(i), i.appendChild(this), this.style.display = "block", t) try {
							e = this.getBBox(), this._originalGetBBox = this.getBBox, this.getBBox = Bt
						} catch (t) {} else this._originalGetBBox && (e = this._originalGetBBox());
						return r ? n.insertBefore(this, r) : n.appendChild(this), It.removeChild(i), this.style.cssText = o, e
					},
					Ut = function (e) {
						try {
							return e.getBBox()
						} catch (t) {
							return Bt.call(e, !0)
						}
					},
					zt = function (t) {
						return !(!kt || !t.getCTM || t.parentNode && !t.ownerSVGElement || !Ut(t))
					},
					Gt = [1, 0, 0, 1, 0, 0],
					Ht = function (t, e) {
						var i, n, r, o, a, s, l = t._gsTransform || new Ot,
							c = 1e5,
							u = t.style;
						if (Ct ? n = tt(t, Pt, null, !0) : t.currentStyle && (n = t.currentStyle.filter.match(d), n = n && 4 === n.length ? [n[0].substr(4), Number(n[2].substr(4)), Number(n[1].substr(4)), n[3].substr(4), l.x || 0, l.y || 0].join(",") : ""), i = !n || "none" === n || "matrix(1, 0, 0, 1, 0, 0)" === n, !Ct || !(s = !K(t) || "none" === K(t).display) && t.parentNode || (s && (o = u.display, u.display = "block"), t.parentNode || (a = 1, It.appendChild(t)), n = tt(t, Pt, null, !0), i = !n || "none" === n || "matrix(1, 0, 0, 1, 0, 0)" === n, o ? u.display = o : s && Yt(u, "display"), a && It.removeChild(t)), (l.svg || t.getCTM && zt(t)) && (i && -1 !== (u[Ct] + "").indexOf("matrix") && (n = u[Ct], i = 0), r = t.getAttribute("transform"), i && r && (r = t.transform.baseVal.consolidate().matrix, n = "matrix(" + r.a + "," + r.b + "," + r.c + "," + r.d + "," + r.e + "," + r.f + ")", i = 0)), i) return Gt;
						for (r = (n || "").match(R) || [], wt = r.length; --wt > -1;) o = Number(r[wt]), r[wt] = (a = o - (o |= 0)) ? (a * c + (0 > a ? -.5 : .5) | 0) / c + o : o;
						return e && r.length > 6 ? [r[0], r[1], r[4], r[5], r[12], r[13]] : r
					},
					jt = i.getTransform = function (t, e, i, n) {
						if (t._gsTransform && i && !n) return t._gsTransform;
						var r, o, a, s, l, c, u = i ? t._gsTransform || new Ot : new Ot,
							h = u.scaleX < 0,
							d = 2e-5,
							f = 1e5,
							p = Rt ? parseFloat(tt(t, Lt, e, !1, "0 0 0").split(" ")[2]) || u.zOrigin || 0 : 0,
							m = parseFloat(j.defaultTransformPerspective) || 0;
						if (u.svg = !(!t.getCTM || !zt(t)), u.svg && (Ft(t, tt(t, Lt, e, !1, "50% 50%") + "", u, t.getAttribute("data-svg-origin")), Mt = j.useSVGTransformAttr || Dt), r = Ht(t), r !== Gt) {
							if (16 === r.length) {
								var g, v, y, x, _, b = r[0],
									w = r[1],
									T = r[2],
									E = r[3],
									S = r[4],
									M = r[5],
									A = r[6],
									C = r[7],
									P = r[8],
									L = r[9],
									R = r[10],
									O = r[12],
									k = r[13],
									N = r[14],
									I = r[11],
									D = Math.atan2(A, R);
								u.zOrigin && (N = -u.zOrigin, O = P * N - r[12], k = L * N - r[13], N = R * N + u.zOrigin - r[14]), u.rotationX = D * V, D && (x = Math.cos(-D), _ = Math.sin(-D), g = S * x + P * _, v = M * x + L * _, y = A * x + R * _, P = S * -_ + P * x, L = M * -_ + L * x, R = A * -_ + R * x, I = C * -_ + I * x, S = g, M = v, A = y), D = Math.atan2(-T, R), u.rotationY = D * V, D && (x = Math.cos(-D), _ = Math.sin(-D), g = b * x - P * _, v = w * x - L * _, y = T * x - R * _, L = w * _ + L * x, R = T * _ + R * x, I = E * _ + I * x, b = g, w = v, T = y), D = Math.atan2(w, b), u.rotation = D * V, D && (x = Math.cos(D), _ = Math.sin(D), g = b * x + w * _, v = S * x + M * _, y = P * x + L * _, w = w * x - b * _, M = M * x - S * _, L = L * x - P * _, b = g, S = v, P = y), u.rotationX && Math.abs(u.rotationX) + Math.abs(u.rotation) > 359.9 && (u.rotationX = u.rotation = 0, u.rotationY = 180 - u.rotationY), D = Math.atan2(S, M), u.scaleX = (Math.sqrt(b * b + w * w + T * T) * f + .5 | 0) / f, u.scaleY = (Math.sqrt(M * M + A * A) * f + .5 | 0) / f, u.scaleZ = (Math.sqrt(P * P + L * L + R * R) * f + .5 | 0) / f, b /= u.scaleX, S /= u.scaleY, w /= u.scaleX, M /= u.scaleY, Math.abs(D) > d ? (u.skewX = D * V, S = 0, "simple" !== u.skewType && (u.scaleY *= 1 / Math.cos(D))) : u.skewX = 0, u.perspective = I ? 1 / (0 > I ? -I : I) : 0, u.x = O, u.y = k, u.z = N, u.svg && (u.x -= u.xOrigin - (u.xOrigin * b - u.yOrigin * S), u.y -= u.yOrigin - (u.yOrigin * w - u.xOrigin * M))
							} else if (!Rt || n || !r.length || u.x !== r[4] || u.y !== r[5] || !u.rotationX && !u.rotationY) {
								var F = r.length >= 6,
									B = F ? r[0] : 1,
									U = r[1] || 0,
									z = r[2] || 0,
									G = F ? r[3] : 1;
								u.x = r[4] || 0, u.y = r[5] || 0, a = Math.sqrt(B * B + U * U), s = Math.sqrt(G * G + z * z), l = B || U ? Math.atan2(U, B) * V : u.rotation || 0, c = z || G ? Math.atan2(z, G) * V + l : u.skewX || 0, u.scaleX = a, u.scaleY = s, u.rotation = l, u.skewX = c, Rt && (u.rotationX = u.rotationY = u.z = 0, u.perspective = m, u.scaleZ = 1), u.svg && (u.x -= u.xOrigin - (u.xOrigin * B + u.yOrigin * z), u.y -= u.yOrigin - (u.xOrigin * U + u.yOrigin * G))
							}
							Math.abs(u.skewX) > 90 && Math.abs(u.skewX) < 270 && (h ? (u.scaleX *= -1, u.skewX += u.rotation <= 0 ? 180 : -180, u.rotation += u.rotation <= 0 ? 180 : -180) : (u.scaleY *= -1, u.skewX += u.skewX <= 0 ? 180 : -180)), u.zOrigin = p;
							for (o in u) u[o] < d && u[o] > -d && (u[o] = 0)
						}
						return i && (t._gsTransform = u, u.svg && (Mt && t.style[Ct] ? H.delayedCall(.001, function () {
							Yt(t.style, Ct)
						}) : !Mt && t.getAttribute("transform") && H.delayedCall(.001, function () {
							t.removeAttribute("transform")
						}))), u
					},
					Vt = function (t) {
						var e, i, n = this.data,
							r = -n.rotation * G,
							o = r + n.skewX * G,
							a = 1e5,
							s = (Math.cos(r) * n.scaleX * a | 0) / a,
							l = (Math.sin(r) * n.scaleX * a | 0) / a,
							c = (Math.sin(o) * -n.scaleY * a | 0) / a,
							u = (Math.cos(o) * n.scaleY * a | 0) / a,
							h = this.t.style,
							d = this.t.currentStyle;
						if (d) {
							i = l, l = -c, c = -i, e = d.filter, h.filter = "";
							var f, p, m = this.t.offsetWidth,
								g = this.t.offsetHeight,
								v = "absolute" !== d.position,
								y = "progid:DXImageTransform.Microsoft.Matrix(M11=" + s + ", M12=" + l + ", M21=" + c + ", M22=" + u,
								x = n.x + m * n.xPercent / 100,
								_ = n.y + g * n.yPercent / 100;
							if (null != n.ox && (f = (n.oxp ? m * n.ox * .01 : n.ox) - m / 2, p = (n.oyp ? g * n.oy * .01 : n.oy) - g / 2, x += f - (f * s + p * l), _ += p - (f * c + p * u)), v ? (f = m / 2, p = g / 2, y += ", Dx=" + (f - (f * s + p * l) + x) + ", Dy=" + (p - (f * c + p * u) + _) + ")") : y += ", sizingMethod='auto expand')", -1 !== e.indexOf("DXImageTransform.Microsoft.Matrix(") ? h.filter = e.replace(N, y) : h.filter = y + " " + e, (0 === t || 1 === t) && 1 === s && 0 === l && 0 === c && 1 === u && (v && -1 === y.indexOf("Dx=0, Dy=0") || k.test(e) && 100 !== parseFloat(RegExp.$1) || -1 === e.indexOf(e.indexOf("Alpha")) && h.removeAttribute("filter")), !v) {
								var b, w, T, E = 8 > S ? 1 : -1;
								for (f = n.ieOffsetX || 0, p = n.ieOffsetY || 0, n.ieOffsetX = Math.round((m - ((0 > s ? -s : s) * m + (0 > l ? -l : l) * g)) / 2 + x), n.ieOffsetY = Math.round((g - ((0 > u ? -u : u) * g + (0 > c ? -c : c) * m)) / 2 + _), wt = 0; 4 > wt; wt++) w = at[wt], b = d[w], i = -1 !== b.indexOf("px") ? parseFloat(b) : et(this.t, w, parseFloat(b), b.replace(M, "")) || 0, T = i !== n[w] ? 2 > wt ? -n.ieOffsetX : -n.ieOffsetY : 2 > wt ? f - n.ieOffsetX : p - n.ieOffsetY, h[w] = (n[w] = Math.round(i - T * (0 === wt || 2 === wt ? 1 : E))) + "px"
							}
						}
					},
					Wt = i.set3DTransformRatio = i.setTransformRatio = function (t) {
						var e, i, n, r, o, a, s, l, c, u, h, d, f, p, m, g, v, y, x, _, b, w, T, E = this.data,
							S = this.t.style,
							M = E.rotation,
							A = E.rotationX,
							C = E.rotationY,
							P = E.scaleX,
							L = E.scaleY,
							R = E.scaleZ,
							O = E.x,
							k = E.y,
							N = E.z,
							I = E.svg,
							D = E.perspective,
							F = E.force3D,
							B = E.skewY,
							U = E.skewX;
						if (B && (U += B, M += B), ((1 === t || 0 === t) && "auto" === F && (this.tween._totalTime === this.tween._totalDuration || !this.tween._totalTime) || !F) && !N && !D && !C && !A && 1 === R || Mt && I || !Rt) return void(M || U || I ? (M *= G, w = U * G, T = 1e5, i = Math.cos(M) * P, o = Math.sin(M) * P, n = Math.sin(M - w) * -L, a = Math.cos(M - w) * L, w && "simple" === E.skewType && (e = Math.tan(w - B * G), e = Math.sqrt(1 + e * e), n *= e, a *= e, B && (e = Math.tan(B * G), e = Math.sqrt(1 + e * e), i *= e, o *= e)), I && (O += E.xOrigin - (E.xOrigin * i + E.yOrigin * n) + E.xOffset, k += E.yOrigin - (E.xOrigin * o + E.yOrigin * a) + E.yOffset, Mt && (E.xPercent || E.yPercent) && (m = this.t.getBBox(), O += .01 * E.xPercent * m.width, k += .01 * E.yPercent * m.height), m = 1e-6, m > O && O > -m && (O = 0), m > k && k > -m && (k = 0)), x = (i * T | 0) / T + "," + (o * T | 0) / T + "," + (n * T | 0) / T + "," + (a * T | 0) / T + "," + O + "," + k + ")", I && Mt ? this.t.setAttribute("transform", "matrix(" + x) : S[Ct] = (E.xPercent || E.yPercent ? "translate(" + E.xPercent + "%," + E.yPercent + "%) matrix(" : "matrix(") + x) : S[Ct] = (E.xPercent || E.yPercent ? "translate(" + E.xPercent + "%," + E.yPercent + "%) matrix(" : "matrix(") + P + ",0,0," + L + "," + O + "," + k + ")");
						if (z && (m = 1e-4, m > P && P > -m && (P = R = 2e-5), m > L && L > -m && (L = R = 2e-5), !D || E.z || E.rotationX || E.rotationY || (D = 0)), M || U) M *= G, g = i = Math.cos(M), v = o = Math.sin(M), U && (M -= U * G, g = Math.cos(M), v = Math.sin(M), "simple" === E.skewType && (e = Math.tan((U - B) * G), e = Math.sqrt(1 + e * e), g *= e, v *= e, E.skewY && (e = Math.tan(B * G), e = Math.sqrt(1 + e * e), i *= e, o *= e))), n = -v, a = g;
						else {
							if (!(C || A || 1 !== R || D || I)) return void(S[Ct] = (E.xPercent || E.yPercent ? "translate(" + E.xPercent + "%," + E.yPercent + "%) translate3d(" : "translate3d(") + O + "px," + k + "px," + N + "px)" + (1 !== P || 1 !== L ? " scale(" + P + "," + L + ")" : ""));
							i = a = 1, n = o = 0
						}
						u = 1, r = s = l = c = h = d = 0, f = D ? -1 / D : 0, p = E.zOrigin, m = 1e-6, _ = ",", b = "0", M = C * G, M && (g = Math.cos(M), v = Math.sin(M), l = -v, h = f * -v, r = i * v, s = o * v, u = g, f *= g, i *= g, o *= g), M = A * G, M && (g = Math.cos(M), v = Math.sin(M), e = n * g + r * v, y = a * g + s * v, c = u * v, d = f * v, r = n * -v + r * g, s = a * -v + s * g, u *= g, f *= g, n = e, a = y), 1 !== R && (r *= R, s *= R, u *= R, f *= R), 1 !== L && (n *= L, a *= L, c *= L, d *= L), 1 !== P && (i *= P, o *= P, l *= P, h *= P), (p || I) && (p && (O += r * -p, k += s * -p, N += u * -p + p), I && (O += E.xOrigin - (E.xOrigin * i + E.yOrigin * n) + E.xOffset, k += E.yOrigin - (E.xOrigin * o + E.yOrigin * a) + E.yOffset), m > O && O > -m && (O = b), m > k && k > -m && (k = b), m > N && N > -m && (N = 0)), x = E.xPercent || E.yPercent ? "translate(" + E.xPercent + "%," + E.yPercent + "%) matrix3d(" : "matrix3d(", x += (m > i && i > -m ? b : i) + _ + (m > o && o > -m ? b : o) + _ + (m > l && l > -m ? b : l), x += _ + (m > h && h > -m ? b : h) + _ + (m > n && n > -m ? b : n) + _ + (m > a && a > -m ? b : a), A || C || 1 !== R ? (x += _ + (m > c && c > -m ? b : c) + _ + (m > d && d > -m ? b : d) + _ + (m > r && r > -m ? b : r), x += _ + (m > s && s > -m ? b : s) + _ + (m > u && u > -m ? b : u) + _ + (m > f && f > -m ? b : f) + _) : x += ",0,0,0,0,1,0,", x += O + _ + k + _ + N + _ + (D ? 1 + -N / D : 1) + ")", S[Ct] = x
					};
				t = Ot.prototype, t.x = t.y = t.z = t.skewX = t.skewY = t.rotation = t.rotationX = t.rotationY = t.zOrigin = t.xPercent = t.yPercent = t.xOffset = t.yOffset = 0, t.scaleX = t.scaleY = t.scaleZ = 1, Et("transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin", {
					parser: function (t, e, i, n, r, o, a) {
						if (n._lastParsedTransform === a) return r;
						n._lastParsedTransform = a;
						var s, l = a.scale && "function" == typeof a.scale ? a.scale : 0;
						"function" == typeof a[i] && (s = a[i], a[i] = e), l && (a.scale = l(L, t));
						var c, u, h, d, f, p, m, g, v, y = t._gsTransform,
							x = t.style,
							_ = 1e-6,
							b = At.length,
							w = a,
							T = {},
							E = "transformOrigin",
							S = jt(t, A, !0, w.parseTransform),
							M = w.transform && ("function" == typeof w.transform ? w.transform(L, P) : w.transform);
						if (S.skewType = w.skewType || S.skewType || j.defaultSkewType, n._transform = S, M && "string" == typeof M && Ct) u = W.style, u[Ct] = M, u.display = "block", u.position = "absolute", -1 !== M.indexOf("%") && (u.width = tt(t, "width"), u.height = tt(t, "height")), B.body.appendChild(W), c = jt(W, null, !1), "simple" === S.skewType && (c.scaleY *= Math.cos(c.skewX * G)), S.svg && (p = S.xOrigin, m = S.yOrigin, c.x -= S.xOffset, c.y -= S.yOffset, (w.transformOrigin || w.svgOrigin) && (M = {}, Ft(t, lt(w.transformOrigin), M, w.svgOrigin, w.smoothOrigin, !0), p = M.xOrigin, m = M.yOrigin, c.x -= M.xOffset - S.xOffset, c.y -= M.yOffset - S.yOffset), (p || m) && (g = Ht(W, !0), c.x -= p - (p * g[0] + m * g[2]), c.y -= m - (p * g[1] + m * g[3]))), B.body.removeChild(W), c.perspective || (c.perspective = S.perspective), null != w.xPercent && (c.xPercent = ut(w.xPercent, S.xPercent)), null != w.yPercent && (c.yPercent = ut(w.yPercent, S.yPercent));
						else if ("object" == typeof w) {
							if (c = {
									scaleX: ut(null != w.scaleX ? w.scaleX : w.scale, S.scaleX),
									scaleY: ut(null != w.scaleY ? w.scaleY : w.scale, S.scaleY),
									scaleZ: ut(w.scaleZ, S.scaleZ),
									x: ut(w.x, S.x),
									y: ut(w.y, S.y),
									z: ut(w.z, S.z),
									xPercent: ut(w.xPercent, S.xPercent),
									yPercent: ut(w.yPercent, S.yPercent),
									perspective: ut(w.transformPerspective, S.perspective)
								}, f = w.directionalRotation, null != f)
								if ("object" == typeof f)
									for (u in f) w[u] = f[u];
								else w.rotation = f;
								"string" == typeof w.x && -1 !== w.x.indexOf("%") && (c.x = 0, c.xPercent = ut(w.x, S.xPercent)), "string" == typeof w.y && -1 !== w.y.indexOf("%") && (c.y = 0, c.yPercent = ut(w.y, S.yPercent)), c.rotation = ht("rotation" in w ? w.rotation : "shortRotation" in w ? w.shortRotation + "_short" : "rotationZ" in w ? w.rotationZ : S.rotation, S.rotation, "rotation", T), Rt && (c.rotationX = ht("rotationX" in w ? w.rotationX : "shortRotationX" in w ? w.shortRotationX + "_short" : S.rotationX || 0, S.rotationX, "rotationX", T), c.rotationY = ht("rotationY" in w ? w.rotationY : "shortRotationY" in w ? w.shortRotationY + "_short" : S.rotationY || 0, S.rotationY, "rotationY", T)), c.skewX = ht(w.skewX, S.skewX), c.skewY = ht(w.skewY, S.skewY)
						}
						for (Rt && null != w.force3D && (S.force3D = w.force3D, d = !0), h = S.force3D || S.z || S.rotationX || S.rotationY || c.z || c.rotationX || c.rotationY || c.perspective, h || null == w.scale || (c.scaleZ = 1); --b > -1;) v = At[b], M = c[v] - S[v], (M > _ || -_ > M || null != w[v] || null != F[v]) && (d = !0, r = new xt(S, v, S[v], M, r), v in T && (r.e = T[v]), r.xs0 = 0, r.plugin = o, n._overwriteProps.push(r.n));
						return M = w.transformOrigin, S.svg && (M || w.svgOrigin) && (p = S.xOffset, m = S.yOffset, Ft(t, lt(M), c, w.svgOrigin, w.smoothOrigin), r = _t(S, "xOrigin", (y ? S : c).xOrigin, c.xOrigin, r, E), r = _t(S, "yOrigin", (y ? S : c).yOrigin, c.yOrigin, r, E), (p !== S.xOffset || m !== S.yOffset) && (r = _t(S, "xOffset", y ? p : S.xOffset, S.xOffset, r, E), r = _t(S, "yOffset", y ? m : S.yOffset, S.yOffset, r, E)), M = "0px 0px"), (M || Rt && h && S.zOrigin) && (Ct ? (d = !0, v = Lt, M = (M || tt(t, v, A, !1, "50% 50%")) + "", r = new xt(x, v, 0, 0, r, -1, E), r.b = x[v], r.plugin = o, Rt ? (u = S.zOrigin, M = M.split(" "), S.zOrigin = (M.length > 2 && (0 === u || "0px" !== M[2]) ? parseFloat(M[2]) : u) || 0, r.xs0 = r.e = M[0] + " " + (M[1] || "50%") + " 0px", r = new xt(S, "zOrigin", 0, 0, r, -1, r.n), r.b = u, r.xs0 = r.e = S.zOrigin) : r.xs0 = r.e = M) : lt(M + "", S)), d && (n._transformType = S.svg && Mt || !h && 3 !== this._transformType ? 2 : 3), s && (a[i] = s), l && (a.scale = l), r
					},
					prefix: !0
				}), Et("boxShadow", {
					defaultValue: "0px 0px 0px 0px #999",
					prefix: !0,
					color: !0,
					multi: !0,
					keyword: "inset"
				}), Et("borderRadius", {
					defaultValue: "0px",
					parser: function (t, e, i, n, r, o) {
						e = this.format(e);
						var a, s, l, c, u, h, d, f, p, m, g, v, y, x, _, b, w = ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
							T = t.style;
						for (p = parseFloat(t.offsetWidth), m = parseFloat(t.offsetHeight), a = e.split(" "), s = 0; s < w.length; s++) this.p.indexOf("border") && (w[s] = Q(w[s])), u = c = tt(t, w[s], A, !1, "0px"), -1 !== u.indexOf(" ") && (c = u.split(" "), u = c[0], c = c[1]), h = l = a[s], d = parseFloat(u), v = u.substr((d + "").length), y = "=" === h.charAt(1), y ? (f = parseInt(h.charAt(0) + "1", 10), h = h.substr(2), f *= parseFloat(h), g = h.substr((f + "").length - (0 > f ? 1 : 0)) || "") : (f = parseFloat(h), g = h.substr((f + "").length)), "" === g && (g = E[i] || v), g !== v && (x = et(t, "borderLeft", d, v), _ = et(t, "borderTop", d, v), "%" === g ? (u = x / p * 100 + "%", c = _ / m * 100 + "%") : "em" === g ? (b = et(t, "borderLeft", 1, "em"), u = x / b + "em", c = _ / b + "em") : (u = x + "px", c = _ + "px"), y && (h = parseFloat(u) + f + g, l = parseFloat(c) + f + g)), r = bt(T, w[s], u + " " + c, h + " " + l, !1, "0px", r);
						return r
					},
					prefix: !0,
					formatter: gt("0px 0px 0px 0px", !1, !0)
				}), Et("borderBottomLeftRadius,borderBottomRightRadius,borderTopLeftRadius,borderTopRightRadius", {
					defaultValue: "0px",
					parser: function (t, e, i, n, r, o) {
						return bt(t.style, i, this.format(tt(t, i, A, !1, "0px 0px")), this.format(e), !1, "0px", r)
					},
					prefix: !0,
					formatter: gt("0px 0px", !1, !0)
				}), Et("backgroundPosition", {
					defaultValue: "0 0",
					parser: function (t, e, i, n, r, o) {
						var a, s, l, c, u, h, d = "background-position",
							f = A || K(t, null),
							p = this.format((f ? S ? f.getPropertyValue(d + "-x") + " " + f.getPropertyValue(d + "-y") : f.getPropertyValue(d) : t.currentStyle.backgroundPositionX + " " + t.currentStyle.backgroundPositionY) || "0 0"),
							m = this.format(e);
						if (-1 !== p.indexOf("%") != (-1 !== m.indexOf("%")) && m.split(",").length < 2 && (h = tt(t, "backgroundImage").replace(T, ""), h && "none" !== h)) {
							for (a = p.split(" "), s = m.split(" "), X.setAttribute("src", h), l = 2; --l > -1;) p = a[l], c = -1 !== p.indexOf("%"), c !== (-1 !== s[l].indexOf("%")) && (u = 0 === l ? t.offsetWidth - X.width : t.offsetHeight - X.height, a[l] = c ? parseFloat(p) / 100 * u + "px" : parseFloat(p) / u * 100 + "%");
							p = a.join(" ")
						}
						return this.parseComplex(t.style, p, m, r, o)
					},
					formatter: lt
				}), Et("backgroundSize", {
					defaultValue: "0 0",
					formatter: function (t) {
						return t += "", "co" === t.substr(0, 2) ? t : lt(-1 === t.indexOf(" ") ? t + " " + t : t)
					}
				}), Et("perspective", {
					defaultValue: "0px",
					prefix: !0
				}), Et("perspectiveOrigin", {
					defaultValue: "50% 50%",
					prefix: !0
				}), Et("transformStyle", {
					prefix: !0
				}), Et("backfaceVisibility", {
					prefix: !0
				}), Et("userSelect", {
					prefix: !0
				}), Et("margin", {
					parser: vt("marginTop,marginRight,marginBottom,marginLeft")
				}), Et("padding", {
					parser: vt("paddingTop,paddingRight,paddingBottom,paddingLeft")
				}), Et("clip", {
					defaultValue: "rect(0px,0px,0px,0px)",
					parser: function (t, e, i, n, r, o) {
						var a, s, l;
						return 9 > S ? (s = t.currentStyle, l = 8 > S ? " " : ",", a = "rect(" + s.clipTop + l + s.clipRight + l + s.clipBottom + l + s.clipLeft + ")", e = this.format(e).split(",").join(l)) : (a = this.format(tt(t, this.p, A, !1, this.dflt)), e = this.format(e)), this.parseComplex(t.style, a, e, r, o)
					}
				}), Et("textShadow", {
					defaultValue: "0px 0px 0px #999",
					color: !0,
					multi: !0
				}), Et("autoRound,strictUnits", {
					parser: function (t, e, i, n, r) {
						return r
					}
				}), Et("border", {
					defaultValue: "0px solid #000",
					parser: function (t, e, i, n, r, o) {
						var a = tt(t, "borderTopWidth", A, !1, "0px"),
							s = this.format(e).split(" "),
							l = s[0].replace(M, "");
						return "px" !== l && (a = parseFloat(a) / et(t, "borderTopWidth", 1, l) + l), this.parseComplex(t.style, this.format(a + " " + tt(t, "borderTopStyle", A, !1, "solid") + " " + tt(t, "borderTopColor", A, !1, "#000")), s.join(" "), r, o)
					},
					color: !0,
					formatter: function (t) {
						var e = t.split(" ");
						return e[0] + " " + (e[1] || "solid") + " " + (t.match(mt) || ["#000"])[0]
					}
				}), Et("borderWidth", {
					parser: vt("borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth")
				}), Et("float,cssFloat,styleFloat", {
					parser: function (t, e, i, n, r, o) {
						var a = t.style,
							s = "cssFloat" in a ? "cssFloat" : "styleFloat";
						return new xt(a, s, 0, 0, r, -1, i, !1, 0, a[s], e)
					}
				});
				var Xt = function (t) {
					var e, i = this.t,
						n = i.filter || tt(this.data, "filter") || "",
						r = this.s + this.c * t | 0;
					100 === r && (-1 === n.indexOf("atrix(") && -1 === n.indexOf("radient(") && -1 === n.indexOf("oader(") ? (i.removeAttribute("filter"), e = !tt(this.data, "filter")) : (i.filter = n.replace(a, ""), e = !0)), e || (this.xn1 && (i.filter = n = n || "alpha(opacity=" + r + ")"), -1 === n.indexOf("pacity") ? 0 === r && this.xn1 || (i.filter = n + " alpha(opacity=" + r + ")") : i.filter = n.replace(k, "opacity=" + r))
				};
				Et("opacity,alpha,autoAlpha", {
					defaultValue: "1",
					parser: function (t, e, i, n, r, o) {
						var a = parseFloat(tt(t, "opacity", A, !1, "1")),
							s = t.style,
							l = "autoAlpha" === i;
						return "string" == typeof e && "=" === e.charAt(1) && (e = ("-" === e.charAt(0) ? -1 : 1) * parseFloat(e.substr(2)) + a), l && 1 === a && "hidden" === tt(t, "visibility", A) && 0 !== e && (a = 0), Y ? r = new xt(s, "opacity", a, e - a, r) : (r = new xt(s, "opacity", 100 * a, 100 * (e - a), r), r.xn1 = l ? 1 : 0, s.zoom = 1, r.type = 2, r.b = "alpha(opacity=" + r.s + ")", r.e = "alpha(opacity=" + (r.s + r.c) + ")", r.data = t, r.plugin = o, r.setRatio = Xt), l && (r = new xt(s, "visibility", 0, 0, r, -1, null, !1, 0, 0 !== a ? "inherit" : "hidden", 0 === e ? "hidden" : "inherit"), r.xs0 = "inherit", n._overwriteProps.push(r.n), n._overwriteProps.push(i)), r
					}
				});
				var Yt = function (t, e) {
						e && (t.removeProperty ? (("ms" === e.substr(0, 2) || "webkit" === e.substr(0, 6)) && (e = "-" + e), t.removeProperty(e.replace(s, "-$1").toLowerCase())) : t.removeAttribute(e))
					},
					qt = function (t) {
						if (this.t._gsClassPT = this, 1 === t || 0 === t) {
							this.t.setAttribute("class", 0 === t ? this.b : this.e);
							for (var e = this.data, i = this.t.style; e;) e.v ? i[e.p] = e.v : Yt(i, e.p), e = e._next;
							1 === t && this.t._gsClassPT === this && (this.t._gsClassPT = null)
						} else this.t.getAttribute("class") !== this.e && this.t.setAttribute("class", this.e)
					};
				Et("className", {
					parser: function (t, e, i, n, r, o, a) {
						var s, l, c, u, h, d = t.getAttribute("class") || "",
							f = t.style.cssText;
						if (r = n._classNamePT = new xt(t, i, 0, 0, r, 2), r.setRatio = qt, r.pr = -11, p = !0, r.b = d, l = nt(t, A), c = t._gsClassPT) {
							for (u = {}, h = c.data; h;) u[h.p] = 1, h = h._next;
							c.setRatio(1)
						}
						return t._gsClassPT = r, r.e = "=" !== e.charAt(1) ? e : d.replace(new RegExp("(?:\\s|^)" + e.substr(2) + "(?![\\w-])"), "") + ("+" === e.charAt(0) ? " " + e.substr(2) : ""), t.setAttribute("class", r.e), s = rt(t, l, nt(t), a, u), t.setAttribute("class", d), r.data = s.firstMPT, t.style.cssText = f, r = r.xfirst = n.parse(t, s.difs, r, o)
					}
				});
				var $t = function (t) {
					if ((1 === t || 0 === t) && this.data._totalTime === this.data._totalDuration && "isFromStart" !== this.data.data) {
						var e, i, n, r, o, a = this.t.style,
							s = g.transform.parse;
						if ("all" === this.e) a.cssText = "", r = !0;
						else
							for (e = this.e.split(" ").join("").split(","), n = e.length; --n > -1;) i = e[n], g[i] && (g[i].parse === s ? r = !0 : i = "transformOrigin" === i ? Lt : g[i].p), Yt(a, i);
						r && (Yt(a, Ct), o = this.t._gsTransform, o && (o.svg && (this.t.removeAttribute("data-svg-origin"), this.t.removeAttribute("transform")), delete this.t._gsTransform))
					}
				};
				for (Et("clearProps", {
						parser: function (t, e, i, n, r) {
							return r = new xt(t, i, 0, 0, r, 2), r.setRatio = $t, r.e = e, r.pr = -10, r.data = n._tween, p = !0, r
						}
					}), t = "bezier,throwProps,physicsProps,physics2D".split(","), wt = t.length; wt--;) St(t[wt]);
				t = j.prototype, t._firstPT = t._lastParsedTransform = t._transform = null, t._onInitTween = function (t, e, i, n) {
					if (!t.nodeType) return !1;
					this._target = P = t, this._tween = i, this._vars = e, L = n, C = e.autoRound, p = !1, E = e.suffixMap || j.suffixMap, A = K(t, ""), m = this._overwriteProps;
					var r, o, a, s, l, c, u, h, d, f = t.style;
					if (v && "" === f.zIndex && (r = tt(t, "zIndex", A), ("auto" === r || "" === r) && this._addLazySet(f, "zIndex", 0)), "string" == typeof e && (s = f.cssText, r = nt(t, A), f.cssText = s + ";" + e, r = rt(t, r, nt(t)).difs, !Y && b.test(e) && (r.opacity = parseFloat(RegExp.$1)), e = r, f.cssText = s), e.className ? this._firstPT = o = g.className.parse(t, e.className, "className", this, null, null, e) : this._firstPT = o = this.parse(t, e, null), this._transformType) {
						for (d = 3 === this._transformType, Ct ? y && (v = !0, "" === f.zIndex && (u = tt(t, "zIndex", A), ("auto" === u || "" === u) && this._addLazySet(f, "zIndex", 0)), x && this._addLazySet(f, "WebkitBackfaceVisibility", this._vars.WebkitBackfaceVisibility || (d ? "visible" : "hidden"))) : f.zoom = 1, a = o; a && a._next;) a = a._next;
						h = new xt(t, "transform", 0, 0, null, 2), this._linkCSSP(h, null, a), h.setRatio = Ct ? Wt : Vt, h.data = this._transform || jt(t, A, !0), h.tween = i, h.pr = -1, m.pop()
					}
					if (p) {
						for (; o;) {
							for (c = o._next, a = s; a && a.pr > o.pr;) a = a._next;
							(o._prev = a ? a._prev : l) ? o._prev._next = o: s = o, (o._next = a) ? a._prev = o : l = o, o = c
						}
						this._firstPT = s
					}
					return !0
				}, t.parse = function (t, e, i, n) {
					var r, o, a, s, l, c, u, h, d, f, p = t.style;
					for (r in e) {
						if (c = e[r], "function" == typeof c && (c = c(L, P)), o = g[r]) i = o.parse(t, c, r, this, i, n, e);
						else {
							if ("--" === r.substr(0, 2)) {
								this._tween._propLookup[r] = this._addTween.call(this._tween, t.style, "setProperty", K(t).getPropertyValue(r) + "", c + "", r, !1, r);
								continue
							}
							l = tt(t, r, A) + "", d = "string" == typeof c, "color" === r || "fill" === r || "stroke" === r || -1 !== r.indexOf("Color") || d && w.test(c) ? (d || (c = pt(c), c = (c.length > 3 ? "rgba(" : "rgb(") + c.join(",") + ")"), i = bt(p, r, l, c, !0, "transparent", i, 0, n)) : d && D.test(c) ? i = bt(p, r, l, c, !0, null, i, 0, n) : (a = parseFloat(l), u = a || 0 === a ? l.substr((a + "").length) : "", ("" === l || "auto" === l) && ("width" === r || "height" === r ? (a = st(t, r, A), u = "px") : "left" === r || "top" === r ? (a = it(t, r, A), u = "px") : (a = "opacity" !== r ? 0 : 1, u = "")), f = d && "=" === c.charAt(1), f ? (s = parseInt(c.charAt(0) + "1", 10), c = c.substr(2), s *= parseFloat(c), h = c.replace(M, "")) : (s = parseFloat(c), h = d ? c.replace(M, "") : ""), "" === h && (h = r in E ? E[r] : u), c = s || 0 === s ? (f ? s + a : s) + h : e[r], u !== h && ("" !== h || "lineHeight" === r) && (s || 0 === s) && a && (a = et(t, r, a, u), "%" === h ? (a /= et(t, r, 100, "%") / 100, e.strictUnits !== !0 && (l = a + "%")) : "em" === h || "rem" === h || "vw" === h || "vh" === h ? a /= et(t, r, 1, h) : "px" !== h && (s = et(t, r, s, h), h = "px"), f && (s || 0 === s) && (c = s + a + h)), f && (s += a), !a && 0 !== a || !s && 0 !== s ? void 0 !== p[r] && (c || c + "" != "NaN" && null != c) ? (i = new xt(p, r, s || a || 0, 0, i, -1, r, !1, 0, l, c), i.xs0 = "none" !== c || "display" !== r && -1 === r.indexOf("Style") ? c : l) : $("invalid " + r + " tween value: " + e[r]) : (i = new xt(p, r, a, s - a, i, 0, r, C !== !1 && ("px" === h || "zIndex" === r), 0, l, c), i.xs0 = h))
						}
						n && i && !i.plugin && (i.plugin = n)
					}
					return i
				}, t.setRatio = function (t) {
					var e, i, n, r = this._firstPT,
						o = 1e-6;
					if (1 !== t || this._tween._time !== this._tween._duration && 0 !== this._tween._time)
						if (t || this._tween._time !== this._tween._duration && 0 !== this._tween._time || this._tween._rawPrevTime === -1e-6)
							for (; r;) {
								if (e = r.c * t + r.s, r.r ? e = r.r(e) : o > e && e > -o && (e = 0), r.type)
									if (1 === r.type)
										if (n = r.l, 2 === n) r.t[r.p] = r.xs0 + e + r.xs1 + r.xn1 + r.xs2;
										else if (3 === n) r.t[r.p] = r.xs0 + e + r.xs1 + r.xn1 + r.xs2 + r.xn2 + r.xs3;
								else if (4 === n) r.t[r.p] = r.xs0 + e + r.xs1 + r.xn1 + r.xs2 + r.xn2 + r.xs3 + r.xn3 + r.xs4;
								else if (5 === n) r.t[r.p] = r.xs0 + e + r.xs1 + r.xn1 + r.xs2 + r.xn2 + r.xs3 + r.xn3 + r.xs4 + r.xn4 + r.xs5;
								else {
									for (i = r.xs0 + e + r.xs1, n = 1; n < r.l; n++) i += r["xn" + n] + r["xs" + (n + 1)];
									r.t[r.p] = i
								} else -1 === r.type ? r.t[r.p] = r.xs0 : r.setRatio && r.setRatio(t);
								else r.t[r.p] = e + r.xs0;
								r = r._next
							} else
								for (; r;) 2 !== r.type ? r.t[r.p] = r.b : r.setRatio(t), r = r._next;
						else
							for (; r;) {
								if (2 !== r.type)
									if (r.r && -1 !== r.type)
										if (e = r.r(r.s + r.c), r.type) {
											if (1 === r.type) {
												for (n = r.l, i = r.xs0 + e + r.xs1, n = 1; n < r.l; n++) i += r["xn" + n] + r["xs" + (n + 1)];
												r.t[r.p] = i
											}
										} else r.t[r.p] = e + r.xs0;
								else r.t[r.p] = r.e;
								else r.setRatio(t);
								r = r._next
							}
				}, t._enableTransforms = function (t) {
					this._transform = this._transform || jt(this._target, A, !0), this._transformType = this._transform.svg && Mt || !t && 3 !== this._transformType ? 2 : 3
				};
				var Zt = function (t) {
					this.t[this.p] = this.e, this.data._linkCSSP(this, this._next, null, !0)
				};
				t._addLazySet = function (t, e, i) {
					var n = this._firstPT = new xt(t, e, 0, 0, this._firstPT, 2);
					n.e = i, n.setRatio = Zt, n.data = this
				}, t._linkCSSP = function (t, e, i, n) {
					return t && (e && (e._prev = t), t._next && (t._next._prev = t._prev), t._prev ? t._prev._next = t._next : this._firstPT === t && (this._firstPT = t._next, n = !0), i ? i._next = t : n || null !== this._firstPT || (this._firstPT = t), t._next = e, t._prev = i), t
				}, t._mod = function (t) {
					for (var e = this._firstPT; e;) "function" == typeof t[e.p] && (e.r = t[e.p]), e = e._next
				}, t._kill = function (t) {
					var e, i, n, r = t;
					if (t.autoAlpha || t.alpha) {
						r = {};
						for (i in t) r[i] = t[i];
						r.opacity = 1, r.autoAlpha && (r.visibility = 1)
					}
					for (t.className && (e = this._classNamePT) && (n = e.xfirst, n && n._prev ? this._linkCSSP(n._prev, e._next, n._prev._prev) : n === this._firstPT && (this._firstPT = e._next), e._next && this._linkCSSP(e._next, e._next._next, n._prev), this._classNamePT = null), e = this._firstPT; e;) e.plugin && e.plugin !== i && e.plugin._kill && (e.plugin._kill(t), i = e.plugin), e = e._next;
					return o.prototype._kill.call(this, r)
				};
				var Jt = function (t, e, i) {
					var n, r, o, a;
					if (t.slice)
						for (r = t.length; --r > -1;) Jt(t[r], e, i);
					else
						for (n = t.childNodes, r = n.length; --r > -1;) o = n[r], a = o.type, o.style && (e.push(nt(o)), i && i.push(o)), 1 !== a && 9 !== a && 11 !== a || !o.childNodes.length || Jt(o, e, i)
				};
				return j.cascadeTo = function (t, e, i) {
					var n, r, o, a, s = H.to(t, e, i),
						l = [s],
						c = [],
						u = [],
						h = [],
						d = H._internals.reservedProps;
					for (t = s._targets || s.target, Jt(t, c, h), s.render(e, !0, !0), Jt(t, u), s.render(0, !0, !0), s._enabled(!0), n = h.length; --n > -1;)
						if (r = rt(h[n], c[n], u[n]), r.firstMPT) {
							r = r.difs;
							for (o in i) d[o] && (r[o] = i[o]);
							a = {};
							for (o in r) a[o] = c[n][o];
							l.push(H.fromTo(h[n], e, a, r))
						}
					return l
				}, o.activate([j]), j
			}, !0),
			function () {
				var t = _gsScope._gsDefine.plugin({
						propName: "roundProps",
						version: "1.7.0",
						priority: -1,
						API: 2,
						init: function (t, e, i) {
							return this._tween = i, !0
						}
					}),
					l = function (e) {
						var i = 1 > e ? Math.pow(10, (e + "").length - 2) : 1;
						return function (t) {
							return (Math.round(t / e) * e * i | 0) / i
						}
					},
					c = function (t, e) {
						for (; t;) t.f || t.blob || (t.m = e || Math.round), t = t._next
					},
					e = t.prototype;
				e._onInitAllProps = function () {
					var t, e, i, n, r = this._tween,
						o = r.vars.roundProps,
						a = {},
						s = r._propLookup.roundProps;
					if ("object" != typeof o || o.push)
						for ("string" == typeof o && (o = o.split(",")), i = o.length; --i > -1;) a[o[i]] = Math.round;
					else
						for (n in o) a[n] = l(o[n]);
					for (n in a)
						for (t = r._firstPT; t;) e = t._next, t.pg ? t.t._mod(a) : t.n === n && (2 === t.f && t.t ? c(t.t._firstPT, a[n]) : (this._add(t.t, n, t.s, t.c, a[n]), e && (e._prev = t._prev), t._prev ? t._prev._next = e : r._firstPT === t && (r._firstPT = e), t._next = t._prev = null, r._propLookup[n] = s)), t = e;
					return !1
				}, e._add = function (t, e, i, n, r) {
					this._addTween(t, e, i, i + n, e, r || Math.round), this._overwriteProps.push(e)
				}
			}(),
			function () {
				_gsScope._gsDefine.plugin({
					propName: "attr",
					API: 2,
					version: "0.6.1",
					init: function (t, e, i, n) {
						var r, o;
						if ("function" != typeof t.setAttribute) return !1;
						for (r in e) o = e[r], "function" == typeof o && (o = o(n, t)), this._addTween(t, "setAttribute", t.getAttribute(r) + "", o + "", r, !1, r), this._overwriteProps.push(r);
						return !0
					}
				})
			}(), _gsScope._gsDefine.plugin({
				propName: "directionalRotation",
				version: "0.3.1",
				API: 2,
				init: function (t, e, i, n) {
					"object" != typeof e && (e = {
						rotation: e
					}), this.finals = {};
					var r, o, a, s, l, c, u = e.useRadians === !0 ? 2 * Math.PI : 360,
						h = 1e-6;
					for (r in e) "useRadians" !== r && (s = e[r], "function" == typeof s && (s = s(n, t)), c = (s + "").split("_"), o = c[0], a = parseFloat("function" != typeof t[r] ? t[r] : t[r.indexOf("set") || "function" != typeof t["get" + r.substr(3)] ? r : "get" + r.substr(3)]()), s = this.finals[r] = "string" == typeof o && "=" === o.charAt(1) ? a + parseInt(o.charAt(0) + "1", 10) * Number(o.substr(2)) : Number(o) || 0, l = s - a, c.length && (o = c.join("_"), -1 !== o.indexOf("short") && (l %= u, l !== l % (u / 2) && (l = 0 > l ? l + u : l - u)), -1 !== o.indexOf("_cw") && 0 > l ? l = (l + 9999999999 * u) % u - (l / u | 0) * u : -1 !== o.indexOf("ccw") && l > 0 && (l = (l - 9999999999 * u) % u - (l / u | 0) * u)), (l > h || -h > l) && (this._addTween(t, r, a, a + l, r), this._overwriteProps.push(r)));
					return !0
				},
				set: function (t) {
					var e;
					if (1 !== t) this._super.setRatio.call(this, t);
					else
						for (e = this._firstPT; e;) e.f ? e.t[e.p](this.finals[e.p]) : e.t[e.p] = this.finals[e.p], e = e._next
				}
			})._autoCSS = !0, _gsScope._gsDefine("easing.Back", ["easing.Ease"], function (g) {
				var i, n, e, t, r = _gsScope.GreenSockGlobals || _gsScope,
					o = r.com.greensock,
					a = 2 * Math.PI,
					s = Math.PI / 2,
					l = o._class,
					c = function (t, e) {
						var i = l("easing." + t, function () {}, !0),
							n = i.prototype = new g;
						return n.constructor = i, n.getRatio = e, i
					},
					u = g.register || function () {},
					h = function (t, e, i, n, r) {
						var o = l("easing." + t, {
							easeOut: new e,
							easeIn: new i,
							easeInOut: new n
						}, !0);
						return u(o, t), o
					},
					v = function (t, e, i) {
						this.t = t, this.v = e, i && (this.next = i, i.prev = this, this.c = i.v - e, this.gap = i.t - t)
					},
					d = function (t, e) {
						var i = l("easing." + t, function (t) {
								this._p1 = t || 0 === t ? t : 1.70158, this._p2 = 1.525 * this._p1
							}, !0),
							n = i.prototype = new g;
						return n.constructor = i, n.getRatio = e, n.config = function (t) {
							return new i(t)
						}, i
					},
					f = h("Back", d("BackOut", function (t) {
						return (t -= 1) * t * ((this._p1 + 1) * t + this._p1) + 1
					}), d("BackIn", function (t) {
						return t * t * ((this._p1 + 1) * t - this._p1)
					}), d("BackInOut", function (t) {
						return (t *= 2) < 1 ? .5 * t * t * ((this._p2 + 1) * t - this._p2) : .5 * ((t -= 2) * t * ((this._p2 + 1) * t + this._p2) + 2)
					})),
					p = l("easing.SlowMo", function (t, e, i) {
						e = e || 0 === e ? e : .7, null == t ? t = .7 : t > 1 && (t = 1), this._p = 1 !== t ? e : 0, this._p1 = (1 - t) / 2, this._p2 = t, this._p3 = this._p1 + this._p2, this._calcEnd = i === !0
					}, !0),
					m = p.prototype = new g;
				return m.constructor = p, m.getRatio = function (t) {
					var e = t + (.5 - t) * this._p;
					return t < this._p1 ? this._calcEnd ? 1 - (t = 1 - t / this._p1) * t : e - (t = 1 - t / this._p1) * t * t * t * e : t > this._p3 ? this._calcEnd ? 1 === t ? 0 : 1 - (t = (t - this._p3) / this._p1) * t : e + (t - e) * (t = (t - this._p3) / this._p1) * t * t * t : this._calcEnd ? 1 : e
				}, p.ease = new p(.7, .7), m.config = p.config = function (t, e, i) {
					return new p(t, e, i)
				}, i = l("easing.SteppedEase", function (t, e) {
					t = t || 1, this._p1 = 1 / t, this._p2 = t + (e ? 0 : 1), this._p3 = e ? 1 : 0
				}, !0), m = i.prototype = new g, m.constructor = i, m.getRatio = function (t) {
					return 0 > t ? t = 0 : t >= 1 && (t = .999999999), ((this._p2 * t | 0) + this._p3) * this._p1
				}, m.config = i.config = function (t, e) {
					return new i(t, e)
				}, n = l("easing.ExpoScaleEase", function (t, e, i) {
					this._p1 = Math.log(e / t), this._p2 = e - t, this._p3 = t, this._ease = i
				}, !0), m = n.prototype = new g, m.constructor = n, m.getRatio = function (t) {
					return this._ease && (t = this._ease.getRatio(t)), (this._p3 * Math.exp(this._p1 * t) - this._p3) / this._p2
				}, m.config = n.config = function (t, e, i) {
					return new n(t, e, i)
				}, e = l("easing.RoughEase", function (t) {
					t = t || {};
					for (var e, i, n, r, o, a, s = t.taper || "none", l = [], c = 0, u = 0 | (t.points || 20), h = u, d = t.randomize !== !1, f = t.clamp === !0, p = t.template instanceof g ? t.template : null, m = "number" == typeof t.strength ? .4 * t.strength : .4; --h > -1;) e = d ? Math.random() : 1 / u * h, i = p ? p.getRatio(e) : e, "none" === s ? n = m : "out" === s ? (r = 1 - e, n = r * r * m) : "in" === s ? n = e * e * m : .5 > e ? (r = 2 * e, n = r * r * .5 * m) : (r = 2 * (1 - e), n = r * r * .5 * m), d ? i += Math.random() * n - .5 * n : h % 2 ? i += .5 * n : i -= .5 * n, f && (i > 1 ? i = 1 : 0 > i && (i = 0)), l[c++] = {
						x: e,
						y: i
					};
					for (l.sort(function (t, e) {
							return t.x - e.x
						}), a = new v(1, 1, null), h = u; --h > -1;) o = l[h], a = new v(o.x, o.y, a);
					this._prev = new v(0, 0, 0 !== a.t ? a : a.next)
				}, !0), m = e.prototype = new g, m.constructor = e, m.getRatio = function (t) {
					var e = this._prev;
					if (t > e.t) {
						for (; e.next && t >= e.t;) e = e.next;
						e = e.prev
					} else
						for (; e.prev && t <= e.t;) e = e.prev;
					return this._prev = e, e.v + (t - e.t) / e.gap * e.c
				}, m.config = function (t) {
					return new e(t)
				}, e.ease = new e, h("Bounce", c("BounceOut", function (t) {
					return 1 / 2.75 > t ? 7.5625 * t * t : 2 / 2.75 > t ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : 2.5 / 2.75 > t ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375
				}), c("BounceIn", function (t) {
					return (t = 1 - t) < 1 / 2.75 ? 1 - 7.5625 * t * t : 2 / 2.75 > t ? 1 - (7.5625 * (t -= 1.5 / 2.75) * t + .75) : 2.5 / 2.75 > t ? 1 - (7.5625 * (t -= 2.25 / 2.75) * t + .9375) : 1 - (7.5625 * (t -= 2.625 / 2.75) * t + .984375)
				}), c("BounceInOut", function (t) {
					var e = .5 > t;
					return t = e ? 1 - 2 * t : 2 * t - 1, t = 1 / 2.75 > t ? 7.5625 * t * t : 2 / 2.75 > t ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : 2.5 / 2.75 > t ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375, e ? .5 * (1 - t) : .5 * t + .5
				})), h("Circ", c("CircOut", function (t) {
					return Math.sqrt(1 - (t -= 1) * t)
				}), c("CircIn", function (t) {
					return -(Math.sqrt(1 - t * t) - 1)
				}), c("CircInOut", function (t) {
					return (t *= 2) < 1 ? -.5 * (Math.sqrt(1 - t * t) - 1) : .5 * (Math.sqrt(1 - (t -= 2) * t) + 1)
				})), t = function (t, e, i) {
					var n = l("easing." + t, function (t, e) {
							this._p1 = t >= 1 ? t : 1, this._p2 = (e || i) / (1 > t ? t : 1), this._p3 = this._p2 / a * (Math.asin(1 / this._p1) || 0), this._p2 = a / this._p2
						}, !0),
						r = n.prototype = new g;
					return r.constructor = n, r.getRatio = e, r.config = function (t, e) {
						return new n(t, e)
					}, n
				}, h("Elastic", t("ElasticOut", function (t) {
					return this._p1 * Math.pow(2, -10 * t) * Math.sin((t - this._p3) * this._p2) + 1
				}, .3), t("ElasticIn", function (t) {
					return -(this._p1 * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - this._p3) * this._p2))
				}, .3), t("ElasticInOut", function (t) {
					return (t *= 2) < 1 ? -.5 * (this._p1 * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - this._p3) * this._p2)) : this._p1 * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - this._p3) * this._p2) * .5 + 1
				}, .45)), h("Expo", c("ExpoOut", function (t) {
					return 1 - Math.pow(2, -10 * t)
				}), c("ExpoIn", function (t) {
					return Math.pow(2, 10 * (t - 1)) - .001
				}), c("ExpoInOut", function (t) {
					return (t *= 2) < 1 ? .5 * Math.pow(2, 10 * (t - 1)) : .5 * (2 - Math.pow(2, -10 * (t - 1)))
				})), h("Sine", c("SineOut", function (t) {
					return Math.sin(t * s)
				}), c("SineIn", function (t) {
					return -Math.cos(t * s) + 1
				}), c("SineInOut", function (t) {
					return -.5 * (Math.cos(Math.PI * t) - 1)
				})), l("easing.EaseLookup", {
					find: function (t) {
						return g.map[t]
					}
				}, !0), u(r.SlowMo, "SlowMo", "ease,"), u(e, "RoughEase", "ease,"), u(i, "SteppedEase", "ease,"), f
			}, !0)
	}), _gsScope._gsDefine && _gsScope._gsQueue.pop()(),
	function (d, f) {
		"use strict";
		var p = {},
			n = d.document,
			m = d.GreenSockGlobals = d.GreenSockGlobals || d;
		if (m.TweenLite) return m.TweenLite;
		var t, e, i, g, v, y = function (t) {
				var e, i = t.split("."),
					n = m;
				for (e = 0; e < i.length; e++) n[i[e]] = n = n[i[e]] || {};
				return n
			},
			h = y("com.greensock"),
			x = 1e-10,
			l = function (t) {
				var e, i = [],
					n = t.length;
				for (e = 0; e !== n; i.push(t[e++]));
				return i
			},
			_ = function () {},
			b = function () {
				var e = Object.prototype.toString,
					i = e.call([]);
				return function (t) {
					return null != t && (t instanceof Array || "object" == typeof t && !!t.push && e.call(t) === i)
				}
			}(),
			w = {},
			T = function (s, l, c, u) {
				this.sc = w[s] ? w[s].sc : [], w[s] = this, this.gsClass = null, this.func = c;
				var h = [];
				this.check = function (t) {
					for (var e, i, n, r, o = l.length, a = o; --o > -1;)(e = w[l[o]] || new T(l[o], [])).gsClass ? (h[o] = e.gsClass, a--) : t && e.sc.push(this);
					if (0 === a && c) {
						if (i = ("com.greensock." + s).split("."), n = i.pop(), r = y(i.join("."))[n] = this.gsClass = c.apply(c, h), u)
							if (m[n] = p[n] = r, "undefined" != typeof module && module.exports)
								if (s === f) {
									module.exports = p[f] = r;
									for (o in p) r[o] = p[o]
								} else p[f] && (p[f][n] = r);
						else "function" == typeof define && define.amd && define((d.GreenSockAMDPath ? d.GreenSockAMDPath + "/" : "") + s.split(".").pop(), [], function () {
							return r
						});
						for (o = 0; o < this.sc.length; o++) this.sc[o].check()
					}
				}, this.check(!0)
			},
			r = d._gsDefine = function (t, e, i, n) {
				return new T(t, e, i, n)
			},
			E = h._class = function (t, e, i) {
				return e = e || function () {}, r(t, [], function () {
					return e
				}, i), e
			};
		r.globals = m;
		var o = [0, 0, 1, 1],
			S = E("easing.Ease", function (t, e, i, n) {
				this._func = t, this._type = i || 0, this._power = n || 0, this._params = e ? o.concat(e) : o
			}, !0),
			M = S.map = {},
			a = S.register = function (t, e, i, n) {
				for (var r, o, a, s, l = e.split(","), c = l.length, u = (i || "easeIn,easeOut,easeInOut").split(","); --c > -1;)
					for (o = l[c], r = n ? E("easing." + o, null, !0) : h.easing[o] || {}, a = u.length; --a > -1;) s = u[a], M[o + "." + s] = M[s + o] = r[s] = t.getRatio ? t : t[s] || new t
			};
		for (i = S.prototype, i._calcEnd = !1, i.getRatio = function (t) {
				if (this._func) return this._params[0] = t, this._func.apply(null, this._params);
				var e = this._type,
					i = this._power,
					n = 1 === e ? 1 - t : 2 === e ? t : .5 > t ? 2 * t : 2 * (1 - t);
				return 1 === i ? n *= n : 2 === i ? n *= n * n : 3 === i ? n *= n * n * n : 4 === i && (n *= n * n * n * n), 1 === e ? 1 - n : 2 === e ? n : .5 > t ? n / 2 : 1 - n / 2
			}, t = ["Linear", "Quad", "Cubic", "Quart", "Quint,Strong"], e = t.length; --e > -1;) i = t[e] + ",Power" + e, a(new S(null, null, 1, e), i, "easeOut", !0), a(new S(null, null, 2, e), i, "easeIn" + (0 === e ? ",easeNone" : "")), a(new S(null, null, 3, e), i, "easeInOut");
		M.linear = h.easing.Linear.easeIn, M.swing = h.easing.Quad.easeInOut;
		var A = E("events.EventDispatcher", function (t) {
			this._listeners = {}, this._eventTarget = t || this
		});
		i = A.prototype, i.addEventListener = function (t, e, i, n, r) {
			r = r || 0;
			var o, a, s = this._listeners[t],
				l = 0;
			for (this !== g || v || g.wake(), null == s && (this._listeners[t] = s = []), a = s.length; --a > -1;) o = s[a], o.c === e && o.s === i ? s.splice(a, 1) : 0 === l && o.pr < r && (l = a + 1);
			s.splice(l, 0, {
				c: e,
				s: i,
				up: n,
				pr: r
			})
		}, i.removeEventListener = function (t, e) {
			var i, n = this._listeners[t];
			if (n)
				for (i = n.length; --i > -1;)
					if (n[i].c === e) return void n.splice(i, 1)
		}, i.dispatchEvent = function (t) {
			var e, i, n, r = this._listeners[t];
			if (r)
				for (e = r.length, e > 1 && (r = r.slice(0)), i = this._eventTarget; --e > -1;) n = r[e], n && (n.up ? n.c.call(n.s || i, {
					type: t,
					target: i
				}) : n.c.call(n.s || i))
		};
		var C = d.requestAnimationFrame,
			P = d.cancelAnimationFrame,
			L = Date.now || function () {
				return (new Date).getTime()
			},
			R = L();
		for (t = ["ms", "moz", "webkit", "o"], e = t.length; --e > -1 && !C;) C = d[t[e] + "RequestAnimationFrame"], P = d[t[e] + "CancelAnimationFrame"] || d[t[e] + "CancelRequestAnimationFrame"];
		E("Ticker", function (t, e) {
			var r, o, a, s, l, c = this,
				u = L(),
				i = e !== !1 && C ? "auto" : !1,
				h = 500,
				d = 33,
				f = "tick",
				p = function (t) {
					var e, i, n = L() - R;
					n > h && (u += n - d), R += n, c.time = (R - u) / 1e3, e = c.time - l, (!r || e > 0 || t === !0) && (c.frame++, l += e + (e >= s ? .004 : s - e), i = !0), t !== !0 && (a = o(p)), i && c.dispatchEvent(f)
				};
			A.call(c), c.time = c.frame = 0, c.tick = function () {
				p(!0)
			}, c.lagSmoothing = function (t, e) {
				return arguments.length ? (h = t || 1 / x, void(d = Math.min(e, h, 0))) : 1 / x > h
			}, c.sleep = function () {
				null != a && (i && P ? P(a) : clearTimeout(a), o = _, a = null, c === g && (v = !1))
			}, c.wake = function (t) {
				null !== a ? c.sleep() : t ? u += -R + (R = L()) : c.frame > 10 && (R = L() - h + 5), o = 0 === r ? _ : i && C ? C : function (t) {
					return setTimeout(t, 1e3 * (l - c.time) + 1 | 0)
				}, c === g && (v = !0), p(2)
			}, c.fps = function (t) {
				return arguments.length ? (r = t, s = 1 / (r || 60), l = this.time + s, void c.wake()) : r
			}, c.useRAF = function (t) {
				return arguments.length ? (c.sleep(), i = t, void c.fps(r)) : i
			}, c.fps(t), setTimeout(function () {
				"auto" === i && c.frame < 5 && "hidden" !== (n || {}).visibilityState && c.useRAF(!1)
			}, 1500)
		}), i = h.Ticker.prototype = new h.events.EventDispatcher, i.constructor = h.Ticker;
		var c = E("core.Animation", function (t, e) {
			if (this.vars = e = e || {}, this._duration = this._totalDuration = t || 0, this._delay = Number(e.delay) || 0, this._timeScale = 1, this._active = e.immediateRender === !0, this.data = e.data, this._reversed = e.reversed === !0, $) {
				v || g.wake();
				var i = this.vars.useFrames ? q : $;
				i.add(this, i._time), this.vars.paused && this.paused(!0)
			}
		});
		g = c.ticker = new h.Ticker, i = c.prototype, i._dirty = i._gc = i._initted = i._paused = !1, i._totalTime = i._time = 0, i._rawPrevTime = -1, i._next = i._last = i._onUpdate = i._timeline = i.timeline = null, i._paused = !1;
		var s = function () {
			v && L() - R > 2e3 && ("hidden" !== (n || {}).visibilityState || !g.lagSmoothing()) && g.wake();
			var t = setTimeout(s, 2e3);
			t.unref && t.unref()
		};
		s(), i.play = function (t, e) {
			return null != t && this.seek(t, e), this.reversed(!1).paused(!1)
		}, i.pause = function (t, e) {
			return null != t && this.seek(t, e), this.paused(!0)
		}, i.resume = function (t, e) {
			return null != t && this.seek(t, e), this.paused(!1)
		}, i.seek = function (t, e) {
			return this.totalTime(Number(t), e !== !1)
		}, i.restart = function (t, e) {
			return this.reversed(!1).paused(!1).totalTime(t ? -this._delay : 0, e !== !1, !0)
		}, i.reverse = function (t, e) {
			return null != t && this.seek(t || this.totalDuration(), e), this.reversed(!0).paused(!1)
		}, i.render = function (t, e, i) {}, i.invalidate = function () {
			return this._time = this._totalTime = 0, this._initted = this._gc = !1, this._rawPrevTime = -1, (this._gc || !this.timeline) && this._enabled(!0), this
		}, i.isActive = function () {
			var t, e = this._timeline,
				i = this._startTime;
			return !e || !this._gc && !this._paused && e.isActive() && (t = e.rawTime(!0)) >= i && t < i + this.totalDuration() / this._timeScale - 1e-7
		}, i._enabled = function (t, e) {
			return v || g.wake(), this._gc = !t, this._active = this.isActive(), e !== !0 && (t && !this.timeline ? this._timeline.add(this, this._startTime - this._delay) : !t && this.timeline && this._timeline._remove(this, !0)), !1
		}, i._kill = function (t, e) {
			return this._enabled(!1, !1)
		}, i.kill = function (t, e) {
			return this._kill(t, e), this
		}, i._uncache = function (t) {
			for (var e = t ? this : this.timeline; e;) e._dirty = !0, e = e.timeline;
			return this
		}, i._swapSelfInParams = function (t) {
			for (var e = t.length, i = t.concat(); --e > -1;) "{self}" === t[e] && (i[e] = this);
			return i
		}, i._callback = function (t) {
			var e = this.vars,
				i = e[t],
				n = e[t + "Params"],
				r = e[t + "Scope"] || e.callbackScope || this,
				o = n ? n.length : 0;
			switch (o) {
				case 0:
					i.call(r);
					break;
				case 1:
					i.call(r, n[0]);
					break;
				case 2:
					i.call(r, n[0], n[1]);
					break;
				default:
					i.apply(r, n)
			}
		}, i.eventCallback = function (t, e, i, n) {
			if ("on" === (t || "").substr(0, 2)) {
				var r = this.vars;
				if (1 === arguments.length) return r[t];
				null == e ? delete r[t] : (r[t] = e, r[t + "Params"] = b(i) && -1 !== i.join("").indexOf("{self}") ? this._swapSelfInParams(i) : i, r[t + "Scope"] = n), "onUpdate" === t && (this._onUpdate = e)
			}
			return this
		}, i.delay = function (t) {
			return arguments.length ? (this._timeline.smoothChildTiming && this.startTime(this._startTime + t - this._delay), this._delay = t, this) : this._delay
		}, i.duration = function (t) {
			return arguments.length ? (this._duration = this._totalDuration = t, this._uncache(!0), this._timeline.smoothChildTiming && this._time > 0 && this._time < this._duration && 0 !== t && this.totalTime(this._totalTime * (t / this._duration), !0), this) : (this._dirty = !1, this._duration)
		}, i.totalDuration = function (t) {
			return this._dirty = !1, arguments.length ? this.duration(t) : this._totalDuration
		}, i.time = function (t, e) {
			return arguments.length ? (this._dirty && this.totalDuration(), this.totalTime(t > this._duration ? this._duration : t, e)) : this._time
		}, i.totalTime = function (t, e, i) {
			if (v || g.wake(), !arguments.length) return this._totalTime;
			if (this._timeline) {
				if (0 > t && !i && (t += this.totalDuration()), this._timeline.smoothChildTiming) {
					this._dirty && this.totalDuration();
					var n = this._totalDuration,
						r = this._timeline;
					if (t > n && !i && (t = n), this._startTime = (this._paused ? this._pauseTime : r._time) - (this._reversed ? n - t : t) / this._timeScale, r._dirty || this._uncache(!1), r._timeline)
						for (; r._timeline;) r._timeline._time !== (r._startTime + r._totalTime) / r._timeScale && r.totalTime(r._totalTime, !0), r = r._timeline
				}
				this._gc && this._enabled(!0, !1), (this._totalTime !== t || 0 === this._duration) && (I.length && J(), this.render(t, e, !1), I.length && J())
			}
			return this
		}, i.progress = i.totalProgress = function (t, e) {
			var i = this.duration();
			return arguments.length ? this.totalTime(i * t, e) : i ? this._time / i : this.ratio
		}, i.startTime = function (t) {
			return arguments.length ? (t !== this._startTime && (this._startTime = t, this.timeline && this.timeline._sortChildren && this.timeline.add(this, t - this._delay)), this) : this._startTime
		}, i.endTime = function (t) {
			return this._startTime + (0 != t ? this.totalDuration() : this.duration()) / this._timeScale
		}, i.timeScale = function (t) {
			if (!arguments.length) return this._timeScale;
			var e, i;
			for (t = t || x, this._timeline && this._timeline.smoothChildTiming && (e = this._pauseTime, i = e || 0 === e ? e : this._timeline.totalTime(), this._startTime = i - (i - this._startTime) * this._timeScale / t), this._timeScale = t, i = this.timeline; i && i.timeline;) i._dirty = !0, i.totalDuration(), i = i.timeline;
			return this
		}, i.reversed = function (t) {
			return arguments.length ? (t != this._reversed && (this._reversed = t, this.totalTime(this._timeline && !this._timeline.smoothChildTiming ? this.totalDuration() - this._totalTime : this._totalTime, !0)), this) : this._reversed
		}, i.paused = function (t) {
			if (!arguments.length) return this._paused;
			var e, i, n = this._timeline;
			return t != this._paused && n && (v || t || g.wake(), e = n.rawTime(), i = e - this._pauseTime, !t && n.smoothChildTiming && (this._startTime += i, this._uncache(!1)), this._pauseTime = t ? e : null, this._paused = t, this._active = this.isActive(), !t && 0 !== i && this._initted && this.duration() && (e = n.smoothChildTiming ? this._totalTime : (e - this._startTime) / this._timeScale, this.render(e, e === this._totalTime, !0))), this._gc && !t && this._enabled(!0, !1), this
		};
		var u = E("core.SimpleTimeline", function (t) {
			c.call(this, 0, t), this.autoRemoveChildren = this.smoothChildTiming = !0
		});
		i = u.prototype = new c, i.constructor = u, i.kill()._gc = !1, i._first = i._last = i._recent = null, i._sortChildren = !1, i.add = i.insert = function (t, e, i, n) {
			var r, o;
			if (t._startTime = Number(e || 0) + t._delay, t._paused && this !== t._timeline && (t._pauseTime = this.rawTime() - (t._timeline.rawTime() - t._pauseTime)), t.timeline && t.timeline._remove(t, !0), t.timeline = t._timeline = this, t._gc && t._enabled(!0, !0), r = this._last, this._sortChildren)
				for (o = t._startTime; r && r._startTime > o;) r = r._prev;
			return r ? (t._next = r._next, r._next = t) : (t._next = this._first, this._first = t), t._next ? t._next._prev = t : this._last = t, t._prev = r, this._recent = t, this._timeline && this._uncache(!0), this
		}, i._remove = function (t, e) {
			return t.timeline === this && (e || t._enabled(!1, !0), t._prev ? t._prev._next = t._next : this._first === t && (this._first = t._next), t._next ? t._next._prev = t._prev : this._last === t && (this._last = t._prev), t._next = t._prev = t.timeline = null, t === this._recent && (this._recent = this._last), this._timeline && this._uncache(!0)), this
		}, i.render = function (t, e, i) {
			var n, r = this._first;
			for (this._totalTime = this._time = this._rawPrevTime = t; r;) n = r._next, (r._active || t >= r._startTime && !r._paused && !r._gc) && (r._reversed ? r.render((r._dirty ? r.totalDuration() : r._totalDuration) - (t - r._startTime) * r._timeScale, e, i) : r.render((t - r._startTime) * r._timeScale, e, i)), r = n
		}, i.rawTime = function () {
			return v || g.wake(), this._totalTime
		};
		var O = E("TweenLite", function (t, e, i) {
				if (c.call(this, e, i), this.render = O.prototype.render, null == t) throw "Cannot tween a null target.";
				this.target = t = "string" != typeof t ? t : O.selector(t) || t;
				var n, r, o, a = t.jquery || t.length && t !== d && t[0] && (t[0] === d || t[0].nodeType && t[0].style && !t.nodeType),
					s = this.vars.overwrite;
				if (this._overwrite = s = null == s ? Y[O.defaultOverwrite] : "number" == typeof s ? s >> 0 : Y[s], (a || t instanceof Array || t.push && b(t)) && "number" != typeof t[0])
					for (this._targets = o = l(t), this._propLookup = [], this._siblings = [], n = 0; n < o.length; n++) r = o[n], r ? "string" != typeof r ? r.length && r !== d && r[0] && (r[0] === d || r[0].nodeType && r[0].style && !r.nodeType) ? (o.splice(n--, 1), this._targets = o = o.concat(l(r))) : (this._siblings[n] = Q(r, this, !1), 1 === s && this._siblings[n].length > 1 && tt(r, this, null, 1, this._siblings[n])) : (r = o[n--] = O.selector(r), "string" == typeof r && o.splice(n + 1, 1)) : o.splice(n--, 1);
				else this._propLookup = {}, this._siblings = Q(t, this, !1), 1 === s && this._siblings.length > 1 && tt(t, this, null, 1, this._siblings);
				(this.vars.immediateRender || 0 === e && 0 === this._delay && this.vars.immediateRender !== !1) && (this._time = -x, this.render(Math.min(0, -this._delay)))
			}, !0),
			k = function (t) {
				return t && t.length && t !== d && t[0] && (t[0] === d || t[0].nodeType && t[0].style && !t.nodeType)
			},
			N = function (t, e) {
				var i, n = {};
				for (i in t) X[i] || i in e && "transform" !== i && "x" !== i && "y" !== i && "width" !== i && "height" !== i && "className" !== i && "border" !== i || !(!j[i] || j[i] && j[i]._autoCSS) || (n[i] = t[i], delete t[i]);
				t.css = n
			};
		i = O.prototype = new c, i.constructor = O, i.kill()._gc = !1, i.ratio = 0, i._firstPT = i._targets = i._overwrittenProps = i._startAt = null, i._notifyPluginsOfEnabled = i._lazy = !1, O.version = "1.20.5", O.defaultEase = i._ease = new S(null, null, 1, 1), O.defaultOverwrite = "auto", O.ticker = g, O.autoSleep = 120, O.lagSmoothing = function (t, e) {
			g.lagSmoothing(t, e)
		}, O.selector = d.$ || d.jQuery || function (t) {
			var e = d.$ || d.jQuery;
			return e ? (O.selector = e, e(t)) : (n || (n = d.document), n ? n.querySelectorAll ? n.querySelectorAll(t) : n.getElementById("#" === t.charAt(0) ? t.substr(1) : t) : t)
		};
		var I = [],
			D = {},
			F = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi,
			B = /[\+-]=-?[\.\d]/,
			U = function (t) {
				for (var e, i = this._firstPT, n = 1e-6; i;) e = i.blob ? 1 === t && null != this.end ? this.end : t ? this.join("") : this.start : i.c * t + i.s, i.m ? e = i.m.call(this._tween, e, this._target || i.t, this._tween) : n > e && e > -n && !i.blob && (e = 0), i.f ? i.fp ? i.t[i.p](i.fp, e) : i.t[i.p](e) : i.t[i.p] = e, i = i._next
			},
			z = function (t, e, i, n) {
				var r, o, a, s, l, c, u, h = [],
					d = 0,
					f = "",
					p = 0;
				for (h.start = t, h.end = e, t = h[0] = t + "", e = h[1] = e + "", i && (i(h), t = h[0], e = h[1]), h.length = 0, r = t.match(F) || [], o = e.match(F) || [], n && (n._next = null, n.blob = 1, h._firstPT = h._applyPT = n), l = o.length, s = 0; l > s; s++) u = o[s], c = e.substr(d, e.indexOf(u, d) - d), f += c || !s ? c : ",", d += c.length, p ? p = (p + 1) % 5 : "rgba(" === c.substr(-5) && (p = 1), u === r[s] || r.length <= s ? f += u : (f && (h.push(f), f = ""), a = parseFloat(r[s]), h.push(a), h._firstPT = {
					_next: h._firstPT,
					t: h,
					p: h.length - 1,
					s: a,
					c: ("=" === u.charAt(1) ? parseInt(u.charAt(0) + "1", 10) * parseFloat(u.substr(2)) : parseFloat(u) - a) || 0,
					f: 0,
					m: p && 4 > p ? Math.round : 0
				}), d += u.length;
				return f += e.substr(d), f && h.push(f), h.setRatio = U, B.test(e) && (h.end = null), h
			},
			G = function (t, e, i, n, r, o, a, s, l) {
				"function" == typeof n && (n = n(l || 0, t));
				var c, u = typeof t[e],
					h = "function" !== u ? "" : e.indexOf("set") || "function" != typeof t["get" + e.substr(3)] ? e : "get" + e.substr(3),
					d = "get" !== i ? i : h ? a ? t[h](a) : t[h]() : t[e],
					f = "string" == typeof n && "=" === n.charAt(1),
					p = {
						t: t,
						p: e,
						s: d,
						f: "function" === u,
						pg: 0,
						n: r || e,
						m: o ? "function" == typeof o ? o : Math.round : 0,
						pr: 0,
						c: f ? parseInt(n.charAt(0) + "1", 10) * parseFloat(n.substr(2)) : parseFloat(n) - d || 0
					};
				return ("number" != typeof d || "number" != typeof n && !f) && (a || isNaN(d) || !f && isNaN(n) || "boolean" == typeof d || "boolean" == typeof n ? (p.fp = a, c = z(d, f ? parseFloat(p.s) + p.c + (p.s + "").replace(/[0-9\-\.]/g, "") : n, s || O.defaultStringFilter, p), p = {
					t: c,
					p: "setRatio",
					s: 0,
					c: 1,
					f: 2,
					pg: 0,
					n: r || e,
					pr: 0,
					m: 0
				}) : (p.s = parseFloat(d), f || (p.c = parseFloat(n) - p.s || 0))), p.c ? ((p._next = this._firstPT) && (p._next._prev = p), this._firstPT = p, p) : void 0
			},
			H = O._internals = {
				isArray: b,
				isSelector: k,
				lazyTweens: I,
				blobDif: z
			},
			j = O._plugins = {},
			V = H.tweenLookup = {},
			W = 0,
			X = H.reservedProps = {
				ease: 1,
				delay: 1,
				overwrite: 1,
				onComplete: 1,
				onCompleteParams: 1,
				onCompleteScope: 1,
				useFrames: 1,
				runBackwards: 1,
				startAt: 1,
				onUpdate: 1,
				onUpdateParams: 1,
				onUpdateScope: 1,
				onStart: 1,
				onStartParams: 1,
				onStartScope: 1,
				onReverseComplete: 1,
				onReverseCompleteParams: 1,
				onReverseCompleteScope: 1,
				onRepeat: 1,
				onRepeatParams: 1,
				onRepeatScope: 1,
				easeParams: 1,
				yoyo: 1,
				immediateRender: 1,
				repeat: 1,
				repeatDelay: 1,
				data: 1,
				paused: 1,
				reversed: 1,
				autoCSS: 1,
				lazy: 1,
				onOverwrite: 1,
				callbackScope: 1,
				stringFilter: 1,
				id: 1,
				yoyoEase: 1
			},
			Y = {
				none: 0,
				all: 1,
				auto: 2,
				concurrent: 3,
				allOnStart: 4,
				preexisting: 5,
				true: 1,
				false: 0
			},
			q = c._rootFramesTimeline = new u,
			$ = c._rootTimeline = new u,
			Z = 30,
			J = H.lazyRender = function () {
				var t, e = I.length;
				for (D = {}; --e > -1;) t = I[e], t && t._lazy !== !1 && (t.render(t._lazy[0], t._lazy[1], !0), t._lazy = !1);
				I.length = 0
			};
		$._startTime = g.time, q._startTime = g.frame, $._active = q._active = !0, setTimeout(J, 1), c._updateRoot = O.render = function () {
			var t, e, i;
			if (I.length && J(), $.render((g.time - $._startTime) * $._timeScale, !1, !1), q.render((g.frame - q._startTime) * q._timeScale, !1, !1), I.length && J(), g.frame >= Z) {
				Z = g.frame + (parseInt(O.autoSleep, 10) || 120);
				for (i in V) {
					for (e = V[i].tweens, t = e.length; --t > -1;) e[t]._gc && e.splice(t, 1);
					0 === e.length && delete V[i]
				}
				if (i = $._first, (!i || i._paused) && O.autoSleep && !q._first && 1 === g._listeners.tick.length) {
					for (; i && i._paused;) i = i._next;
					i || g.sleep()
				}
			}
		}, g.addEventListener("tick", c._updateRoot);
		var Q = function (t, e, i) {
				var n, r, o = t._gsTweenID;
				if (V[o || (t._gsTweenID = o = "t" + W++)] || (V[o] = {
						target: t,
						tweens: []
					}), e && (n = V[o].tweens, n[r = n.length] = e, i))
					for (; --r > -1;) n[r] === e && n.splice(r, 1);
				return V[o].tweens
			},
			K = function (t, e, i, n) {
				var r, o, a = t.vars.onOverwrite;
				return a && (r = a(t, e, i, n)), a = O.onOverwrite, a && (o = a(t, e, i, n)), r !== !1 && o !== !1
			},
			tt = function (t, e, i, n, r) {
				var o, a, s, l;
				if (1 === n || n >= 4) {
					for (l = r.length, o = 0; l > o; o++)
						if ((s = r[o]) !== e) s._gc || s._kill(null, t, e) && (a = !0);
						else if (5 === n) break;
					return a
				}
				var c, u = e._startTime + x,
					h = [],
					d = 0,
					f = 0 === e._duration;
				for (o = r.length; --o > -1;)(s = r[o]) === e || s._gc || s._paused || (s._timeline !== e._timeline ? (c = c || et(e, 0, f), 0 === et(s, c, f) && (h[d++] = s)) : s._startTime <= u && s._startTime + s.totalDuration() / s._timeScale > u && ((f || !s._initted) && u - s._startTime <= 2e-10 || (h[d++] = s)));
				for (o = d; --o > -1;)
					if (s = h[o], 2 === n && s._kill(i, t, e) && (a = !0), 2 !== n || !s._firstPT && s._initted) {
						if (2 !== n && !K(s, e)) continue;
						s._enabled(!1, !1) && (a = !0)
					}
				return a
			},
			et = function (t, e, i) {
				for (var n = t._timeline, r = n._timeScale, o = t._startTime; n._timeline;) {
					if (o += n._startTime, r *= n._timeScale, n._paused) return -100;
					n = n._timeline
				}
				return o /= r, o > e ? o - e : i && o === e || !t._initted && 2 * x > o - e ? x : (o += t.totalDuration() / t._timeScale / r) > e + x ? 0 : o - e - x
			};
		i._init = function () {
			var t, e, i, n, r, o, a = this.vars,
				s = this._overwrittenProps,
				l = this._duration,
				c = !!a.immediateRender,
				u = a.ease;
			if (a.startAt) {
				this._startAt && (this._startAt.render(-1, !0), this._startAt.kill()), r = {};
				for (n in a.startAt) r[n] = a.startAt[n];
				if (r.data = "isStart", r.overwrite = !1, r.immediateRender = !0, r.lazy = c && a.lazy !== !1, r.startAt = r.delay = null, r.onUpdate = a.onUpdate, r.onUpdateParams = a.onUpdateParams, r.onUpdateScope = a.onUpdateScope || a.callbackScope || this, this._startAt = O.to(this.target || {}, 0, r), c)
					if (this._time > 0) this._startAt = null;
					else if (0 !== l) return
			} else if (a.runBackwards && 0 !== l)
				if (this._startAt) this._startAt.render(-1, !0), this._startAt.kill(), this._startAt = null;
				else {
					0 !== this._time && (c = !1), i = {};
					for (n in a) X[n] && "autoCSS" !== n || (i[n] = a[n]);
					if (i.overwrite = 0, i.data = "isFromStart", i.lazy = c && a.lazy !== !1, i.immediateRender = c, this._startAt = O.to(this.target, 0, i), c) {
						if (0 === this._time) return
					} else this._startAt._init(), this._startAt._enabled(!1), this.vars.immediateRender && (this._startAt = null)
				}
			if (this._ease = u = u ? u instanceof S ? u : "function" == typeof u ? new S(u, a.easeParams) : M[u] || O.defaultEase : O.defaultEase, a.easeParams instanceof Array && u.config && (this._ease = u.config.apply(u, a.easeParams)), this._easeType = this._ease._type, this._easePower = this._ease._power, this._firstPT = null, this._targets)
				for (o = this._targets.length, t = 0; o > t; t++) this._initProps(this._targets[t], this._propLookup[t] = {}, this._siblings[t], s ? s[t] : null, t) && (e = !0);
			else e = this._initProps(this.target, this._propLookup, this._siblings, s, 0);
			if (e && O._onPluginEvent("_onInitAllProps", this), s && (this._firstPT || "function" != typeof this.target && this._enabled(!1, !1)), a.runBackwards)
				for (i = this._firstPT; i;) i.s += i.c, i.c = -i.c, i = i._next;
			this._onUpdate = a.onUpdate, this._initted = !0
		}, i._initProps = function (t, e, i, n, r) {
			var o, a, s, l, c, u;
			if (null == t) return !1;
			D[t._gsTweenID] && J(), this.vars.css || t.style && t !== d && t.nodeType && j.css && this.vars.autoCSS !== !1 && N(this.vars, t);
			for (o in this.vars)
				if (u = this.vars[o], X[o]) u && (u instanceof Array || u.push && b(u)) && -1 !== u.join("").indexOf("{self}") && (this.vars[o] = u = this._swapSelfInParams(u, this));
				else if (j[o] && (l = new j[o])._onInitTween(t, this.vars[o], this, r)) {
				for (this._firstPT = c = {
						_next: this._firstPT,
						t: l,
						p: "setRatio",
						s: 0,
						c: 1,
						f: 1,
						n: o,
						pg: 1,
						pr: l._priority,
						m: 0
					}, a = l._overwriteProps.length; --a > -1;) e[l._overwriteProps[a]] = this._firstPT;
				(l._priority || l._onInitAllProps) && (s = !0), (l._onDisable || l._onEnable) && (this._notifyPluginsOfEnabled = !0), c._next && (c._next._prev = c)
			} else e[o] = G.call(this, t, o, "get", u, o, 0, null, this.vars.stringFilter, r);
			return n && this._kill(n, t) ? this._initProps(t, e, i, n, r) : this._overwrite > 1 && this._firstPT && i.length > 1 && tt(t, this, e, this._overwrite, i) ? (this._kill(e, t), this._initProps(t, e, i, n, r)) : (this._firstPT && (this.vars.lazy !== !1 && this._duration || this.vars.lazy && !this._duration) && (D[t._gsTweenID] = !0), s)
		}, i.render = function (t, e, i) {
			var n, r, o, a, s = this._time,
				l = this._duration,
				c = this._rawPrevTime;
			if (t >= l - 1e-7 && t >= 0) this._totalTime = this._time = l, this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1, this._reversed || (n = !0, r = "onComplete", i = i || this._timeline.autoRemoveChildren), 0 === l && (this._initted || !this.vars.lazy || i) && (this._startTime === this._timeline._duration && (t = 0), (0 > c || 0 >= t && t >= -1e-7 || c === x && "isPause" !== this.data) && c !== t && (i = !0, c > x && (r = "onReverseComplete")), this._rawPrevTime = a = !e || t || c === t ? t : x);
			else if (1e-7 > t) this._totalTime = this._time = 0, this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0, (0 !== s || 0 === l && c > 0) && (r = "onReverseComplete", n = this._reversed), 0 > t && (this._active = !1, 0 === l && (this._initted || !this.vars.lazy || i) && (c >= 0 && (c !== x || "isPause" !== this.data) && (i = !0), this._rawPrevTime = a = !e || t || c === t ? t : x)), (!this._initted || this._startAt && this._startAt.progress()) && (i = !0);
			else if (this._totalTime = this._time = t, this._easeType) {
				var u = t / l,
					h = this._easeType,
					d = this._easePower;
				(1 === h || 3 === h && u >= .5) && (u = 1 - u), 3 === h && (u *= 2), 1 === d ? u *= u : 2 === d ? u *= u * u : 3 === d ? u *= u * u * u : 4 === d && (u *= u * u * u * u), 1 === h ? this.ratio = 1 - u : 2 === h ? this.ratio = u : .5 > t / l ? this.ratio = u / 2 : this.ratio = 1 - u / 2
			} else this.ratio = this._ease.getRatio(t / l);
			if (this._time !== s || i) {
				if (!this._initted) {
					if (this._init(), !this._initted || this._gc) return;
					if (!i && this._firstPT && (this.vars.lazy !== !1 && this._duration || this.vars.lazy && !this._duration)) return this._time = this._totalTime = s, this._rawPrevTime = c, I.push(this), void(this._lazy = [t, e]);
					this._time && !n ? this.ratio = this._ease.getRatio(this._time / l) : n && this._ease._calcEnd && (this.ratio = this._ease.getRatio(0 === this._time ? 0 : 1))
				}
				for (this._lazy !== !1 && (this._lazy = !1), this._active || !this._paused && this._time !== s && t >= 0 && (this._active = !0), 0 === s && (this._startAt && (t >= 0 ? this._startAt.render(t, !0, i) : r || (r = "_dummyGS")), this.vars.onStart && (0 !== this._time || 0 === l) && (e || this._callback("onStart"))), o = this._firstPT; o;) o.f ? o.t[o.p](o.c * this.ratio + o.s) : o.t[o.p] = o.c * this.ratio + o.s, o = o._next;
				this._onUpdate && (0 > t && this._startAt && t !== -1e-4 && this._startAt.render(t, !0, i), e || (this._time !== s || n || i) && this._callback("onUpdate")), r && (!this._gc || i) && (0 > t && this._startAt && !this._onUpdate && t !== -1e-4 && this._startAt.render(t, !0, i), n && (this._timeline.autoRemoveChildren && this._enabled(!1, !1), this._active = !1), !e && this.vars[r] && this._callback(r), 0 === l && this._rawPrevTime === x && a !== x && (this._rawPrevTime = 0))
			}
		}, i._kill = function (t, e, i) {
			if ("all" === t && (t = null), null == t && (null == e || e === this.target)) return this._lazy = !1, this._enabled(!1, !1);
			e = "string" != typeof e ? e || this._targets || this.target : O.selector(e) || e;
			var n, r, o, a, s, l, c, u, h, d = i && this._time && i._startTime === this._startTime && this._timeline === i._timeline;
			if ((b(e) || k(e)) && "number" != typeof e[0])
				for (n = e.length; --n > -1;) this._kill(t, e[n], i) && (l = !0);
			else {
				if (this._targets) {
					for (n = this._targets.length; --n > -1;)
						if (e === this._targets[n]) {
							s = this._propLookup[n] || {}, this._overwrittenProps = this._overwrittenProps || [], r = this._overwrittenProps[n] = t ? this._overwrittenProps[n] || {} : "all";
							break
						}
				} else {
					if (e !== this.target) return !1;
					s = this._propLookup, r = this._overwrittenProps = t ? this._overwrittenProps || {} : "all"
				}
				if (s) {
					if (c = t || s, u = t !== r && "all" !== r && t !== s && ("object" != typeof t || !t._tempKill), i && (O.onOverwrite || this.vars.onOverwrite)) {
						for (o in c) s[o] && (h || (h = []), h.push(o));
						if ((h || !t) && !K(this, i, e, h)) return !1
					}
					for (o in c)(a = s[o]) && (d && (a.f ? a.t[a.p](a.s) : a.t[a.p] = a.s, l = !0), a.pg && a.t._kill(c) && (l = !0), a.pg && 0 !== a.t._overwriteProps.length || (a._prev ? a._prev._next = a._next : a === this._firstPT && (this._firstPT = a._next), a._next && (a._next._prev = a._prev), a._next = a._prev = null), delete s[o]), u && (r[o] = 1);
					!this._firstPT && this._initted && this._enabled(!1, !1)
				}
			}
			return l
		}, i.invalidate = function () {
			return this._notifyPluginsOfEnabled && O._onPluginEvent("_onDisable", this), this._firstPT = this._overwrittenProps = this._startAt = this._onUpdate = null, this._notifyPluginsOfEnabled = this._active = this._lazy = !1, this._propLookup = this._targets ? {} : [], c.prototype.invalidate.call(this), this.vars.immediateRender && (this._time = -x, this.render(Math.min(0, -this._delay))), this
		}, i._enabled = function (t, e) {
			if (v || g.wake(), t && this._gc) {
				var i, n = this._targets;
				if (n)
					for (i = n.length; --i > -1;) this._siblings[i] = Q(n[i], this, !0);
				else this._siblings = Q(this.target, this, !0)
			}
			return c.prototype._enabled.call(this, t, e), this._notifyPluginsOfEnabled && this._firstPT ? O._onPluginEvent(t ? "_onEnable" : "_onDisable", this) : !1
		}, O.to = function (t, e, i) {
			return new O(t, e, i)
		}, O.from = function (t, e, i) {
			return i.runBackwards = !0, i.immediateRender = 0 != i.immediateRender, new O(t, e, i)
		}, O.fromTo = function (t, e, i, n) {
			return n.startAt = i, n.immediateRender = 0 != n.immediateRender && 0 != i.immediateRender, new O(t, e, n)
		}, O.delayedCall = function (t, e, i, n, r) {
			return new O(e, 0, {
				delay: t,
				onComplete: e,
				onCompleteParams: i,
				callbackScope: n,
				onReverseComplete: e,
				onReverseCompleteParams: i,
				immediateRender: !1,
				lazy: !1,
				useFrames: r,
				overwrite: 0
			})
		}, O.set = function (t, e) {
			return new O(t, 0, e)
		}, O.getTweensOf = function (t, e) {
			if (null == t) return [];
			t = "string" != typeof t ? t : O.selector(t) || t;
			var i, n, r, o;
			if ((b(t) || k(t)) && "number" != typeof t[0]) {
				for (i = t.length, n = []; --i > -1;) n = n.concat(O.getTweensOf(t[i], e));
				for (i = n.length; --i > -1;)
					for (o = n[i], r = i; --r > -1;) o === n[r] && n.splice(i, 1)
			} else if (t._gsTweenID)
				for (n = Q(t).concat(), i = n.length; --i > -1;)(n[i]._gc || e && !n[i].isActive()) && n.splice(i, 1);
			return n || []
		}, O.killTweensOf = O.killDelayedCallsTo = function (t, e, i) {
			"object" == typeof e && (i = e, e = !1);
			for (var n = O.getTweensOf(t, e), r = n.length; --r > -1;) n[r]._kill(i, t)
		};
		var it = E("plugins.TweenPlugin", function (t, e) {
			this._overwriteProps = (t || "").split(","), this._propName = this._overwriteProps[0], this._priority = e || 0, this._super = it.prototype
		}, !0);
		if (i = it.prototype, it.version = "1.19.0", it.API = 2, i._firstPT = null, i._addTween = G, i.setRatio = U, i._kill = function (t) {
				var e, i = this._overwriteProps,
					n = this._firstPT;
				if (null != t[this._propName]) this._overwriteProps = [];
				else
					for (e = i.length; --e > -1;) null != t[i[e]] && i.splice(e, 1);
				for (; n;) null != t[n.n] && (n._next && (n._next._prev = n._prev), n._prev ? (n._prev._next = n._next, n._prev = null) : this._firstPT === n && (this._firstPT = n._next)), n = n._next;
				return !1
			}, i._mod = i._roundProps = function (t) {
				for (var e, i = this._firstPT; i;) e = t[this._propName] || null != i.n && t[i.n.split(this._propName + "_").join("")], e && "function" == typeof e && (2 === i.f ? i.t._applyPT.m = e : i.m = e), i = i._next
			}, O._onPluginEvent = function (t, e) {
				var i, n, r, o, a, s = e._firstPT;
				if ("_onInitAllProps" === t) {
					for (; s;) {
						for (a = s._next, n = r; n && n.pr > s.pr;) n = n._next;
						(s._prev = n ? n._prev : o) ? s._prev._next = s: r = s, (s._next = n) ? n._prev = s : o = s, s = a
					}
					s = e._firstPT = r
				}
				for (; s;) s.pg && "function" == typeof s.t[t] && s.t[t]() && (i = !0), s = s._next;
				return i
			}, it.activate = function (t) {
				for (var e = t.length; --e > -1;) t[e].API === it.API && (j[(new t[e])._propName] = t[e]);
				return !0
			}, r.plugin = function (t) {
				if (!(t && t.propName && t.init && t.API)) throw "illegal plugin definition.";
				var e, i = t.propName,
					n = t.priority || 0,
					r = t.overwriteProps,
					o = {
						init: "_onInitTween",
						set: "setRatio",
						kill: "_kill",
						round: "_mod",
						mod: "_mod",
						initAll: "_onInitAllProps"
					},
					a = E("plugins." + i.charAt(0).toUpperCase() + i.substr(1) + "Plugin", function () {
						it.call(this, i, n), this._overwriteProps = r || []
					}, t.global === !0),
					s = a.prototype = new it(i);
				s.constructor = a, a.API = t.API;
				for (e in o) "function" == typeof t[e] && (s[o[e]] = t[e]);
				return a.version = t.version, it.activate([a]), a
			}, t = d._gsQueue) {
			for (e = 0; e < t.length; e++) t[e]();
			for (i in w) w[i].func || d.console.log("GSAP encountered missing dependency: " + i)
		}
		v = !1
	}("undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window, "TweenMax");
var _gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window;
(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function () {
		"use strict";
		_gsScope._gsDefine("plugins.CSSRulePlugin", ["plugins.TweenPlugin", "TweenLite", "plugins.CSSPlugin"], function (t, e, r) {
			var i = function () {
					t.call(this, "cssRule"), this._overwriteProps.length = 0
				},
				c = _gsScope.document,
				n = r.prototype.setRatio,
				o = i.prototype = new r;
			return o._propName = "cssRule", o.constructor = i, i.version = "0.6.6", i.API = 2, i.getRule = function (t) {
				var e, i, n, r, o = c.all ? "rules" : "cssRules",
					a = c.styleSheets,
					s = a.length,
					l = ":" === t.charAt(0);
				for (t = (l ? "" : ",") + t.split("::").join(":").toLowerCase() + ",", l && (r = []); --s > -1;) {
					try {
						if (i = a[s][o], !i) continue;
						e = i.length
					} catch (t) {
						console.log(t);
						continue
					}
					for (; --e > -1;)
						if (n = i[e], n.selectorText && -1 !== ("," + n.selectorText.split("::").join(":").toLowerCase() + ",").indexOf(t)) {
							if (!l) return n.style;
							r.push(n.style)
						}
				}
				return r
			}, o._onInitTween = function (t, e, i) {
				if (void 0 === t.cssText) return !1;
				var n = t._gsProxy = t._gsProxy || c.createElement("div");
				return this._ss = t, this._proxy = n.style, n.style.cssText = t.cssText, r.prototype._onInitTween.call(this, n, e, i), !0
			}, o.setRatio = function (t) {
				n.call(this, t), this._ss.cssText = this._proxy.cssText
			}, t.activate([i]), i
		}, !0)
	}), _gsScope._gsDefine && _gsScope._gsQueue.pop()(),
	function (t) {
		"use strict";
		var e = function () {
			return (_gsScope.GreenSockGlobals || _gsScope)[t]
		};
		"undefined" != typeof module && module.exports ? (require("../TweenLite.min.js"), module.exports = e()) : "function" == typeof define && define.amd && define(["TweenLite"], e)
	}("CSSRulePlugin");
var _gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window;
(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function () {
		"use strict";
		_gsScope._gsDefine("utils.Draggable", ["events.EventDispatcher", "TweenLite", "plugins.CSSPlugin"], function (bt, wt, Tt) {
			var a, Et, St, E, m, g, S, M, Mt = {
					css: {},
					data: "_draggable"
				},
				At = {
					css: {},
					data: "_draggable"
				},
				Ct = {
					css: {},
					data: "_draggable"
				},
				Pt = {
					css: {}
				},
				Lt = _gsScope._gsDefine.globals,
				i = {},
				t = {
					style: {}
				},
				Rt = _gsScope.document || {
					createElement: function () {
						return t
					}
				},
				Ot = Rt.documentElement || {},
				u = function (t) {
					return Rt.createElementNS ? Rt.createElementNS("http://www.w3.org/1999/xhtml", t) : Rt.createElement(t)
				},
				h = u("div"),
				kt = [],
				r = function () {
					return !1
				},
				Nt = 180 / Math.PI,
				It = 999999999999999,
				Dt = Date.now || function () {
					return (new Date).getTime()
				},
				Ft = !(Rt.addEventListener || !Rt.all),
				Bt = Rt.createElement("div"),
				n = [],
				Ut = {},
				zt = 0,
				o = /^(?:a|input|textarea|button|select)$/i,
				Gt = 0,
				Ht = _gsScope.navigator && -1 !== _gsScope.navigator.userAgent.toLowerCase().indexOf("android"),
				jt = 0,
				Vt = {},
				Wt = {},
				Xt = function (t) {
					if ("string" == typeof t && (t = wt.selector(t)), !t || t.nodeType) return [t];
					var e, i = [],
						n = t.length;
					for (e = 0; e !== n; i.push(t[e++]));
					return i
				},
				Yt = function (t, e) {
					var i, n = {};
					if (e)
						for (i in t) n[i] = t[i] * e;
					else
						for (i in t) n[i] = t[i];
					return n
				},
				e = function () {
					for (var t = n.length; --t > -1;) n[t]()
				},
				qt = function (t) {
					n.push(t), 1 === n.length && wt.ticker.addEventListener("tick", e, this, !1, 1)
				},
				$t = function (t) {
					for (var e = n.length; --e > -1;) n[e] === t && n.splice(e, 1);
					wt.to(s, 0, {
						overwrite: "all",
						delay: 15,
						onComplete: s,
						data: "_draggable"
					})
				},
				s = function () {
					n.length || wt.ticker.removeEventListener("tick", e)
				},
				Zt = function (t, e) {
					var i;
					for (i in e) void 0 === t[i] && (t[i] = e[i]);
					return t
				},
				A = function () {
					return null != window.pageYOffset ? window.pageYOffset : null != Rt.scrollTop ? Rt.scrollTop : Ot.scrollTop || Rt.body.scrollTop || 0
				},
				C = function () {
					return null != window.pageXOffset ? window.pageXOffset : null != Rt.scrollLeft ? Rt.scrollLeft : Ot.scrollLeft || Rt.body.scrollLeft || 0
				},
				Jt = function (t, e) {
					de(t, "scroll", e), Kt(t.parentNode) || Jt(t.parentNode, e)
				},
				Qt = function (t, e) {
					fe(t, "scroll", e), Kt(t.parentNode) || Qt(t.parentNode, e)
				},
				Kt = function (t) {
					return !(t && t !== Ot && t !== Rt && t !== Rt.body && t !== window && t.nodeType && t.parentNode)
				},
				l = function (t, e) {
					var i = "x" === e ? "Width" : "Height",
						n = "scroll" + i,
						r = "client" + i,
						o = Rt.body;
					return Math.max(0, Kt(t) ? Math.max(Ot[n], o[n]) - (window["inner" + i] || Ot[r] || o[r]) : t[n] - t[r])
				},
				te = function (t) {
					var e = Kt(t),
						i = l(t, "x"),
						n = l(t, "y");
					e ? t = Wt : te(t.parentNode), t._gsMaxScrollX = i, t._gsMaxScrollY = n, t._gsScrollX = t.scrollLeft || 0, t._gsScrollY = t.scrollTop || 0
				},
				ee = function (t, e) {
					return t = t || window.event, i.pageX = t.clientX + Rt.body.scrollLeft + Ot.scrollLeft, i.pageY = t.clientY + Rt.body.scrollTop + Ot.scrollTop, e && (t.returnValue = !1), i
				},
				ie = function (t) {
					return t ? ("string" == typeof t && (t = wt.selector(t)), t.length && t !== window && t[0] && t[0].style && !t.nodeType && (t = t[0]), t === window || t.nodeType && t.style ? t : null) : t
				},
				c = function (t, e) {
					var i, n, r, o = t.style;
					if (void 0 === o[e]) {
						for (r = ["O", "Moz", "ms", "Ms", "Webkit"], n = 5, i = e.charAt(0).toUpperCase() + e.substr(1); --n > -1 && void 0 === o[r[n] + i];);
						if (0 > n) return "";
						a = 3 === n ? "ms" : r[n], e = a + i
					}
					return e
				},
				ne = function (t, e, i) {
					var n = t.style;
					n && (void 0 === n[e] && (e = c(t, e)), null == i ? n.removeProperty ? n.removeProperty(e.replace(/([A-Z])/g, "-$1").toLowerCase()) : n.removeAttribute(e) : void 0 !== n[e] && (n[e] = i))
				},
				P = Rt.defaultView ? Rt.defaultView.getComputedStyle : r,
				d = /(?:Left|Right|Width)/i,
				f = /(?:\d|\-|\+|=|#|\.)*/g,
				p = function (t, e, i, n, r) {
					if ("px" === n || !n) return i;
					if ("auto" === n || !i) return 0;
					var o, a = d.test(e),
						s = t,
						l = h.style,
						c = 0 > i;
					return c && (i = -i), "%" === n && -1 !== e.indexOf("border") ? o = i / 100 * (a ? t.clientWidth : t.clientHeight) : (l.cssText = "border:0 solid red;position:" + re(t, "position", !0) + ";line-height:0;", "%" !== n && s.appendChild ? l[a ? "borderLeftWidth" : "borderTopWidth"] = i + n : (s = t.parentNode || Rt.body, l[a ? "width" : "height"] = i + n), s.appendChild(h), o = parseFloat(h[a ? "offsetWidth" : "offsetHeight"]), s.removeChild(h), 0 !== o || r || (o = p(t, e, i, n, !0))), c ? -o : o
				},
				v = function (t, e) {
					if ("absolute" !== re(t, "position", !0)) return 0;
					var i = "left" === e ? "Left" : "Top",
						n = re(t, "margin" + i, !0);
					return t["offset" + i] - (p(t, e, parseFloat(n), (n + "").replace(f, "")) || 0)
				},
				re = function (t, e, i) {
					var n, r = (t._gsTransform || {})[e];
					return r || 0 === r ? r : (t.style[e] ? r = t.style[e] : (n = P(t)) ? (r = n.getPropertyValue(e.replace(/([A-Z])/g, "-$1").toLowerCase()), r = r || n.length ? r : n[e]) : t.currentStyle && (r = t.currentStyle[e]), "auto" !== r || "top" !== e && "left" !== e || (r = v(t, e)), i ? r : parseFloat(r) || 0)
				},
				oe = function (t, e, i) {
					var n = t.vars,
						r = n[i],
						o = t._listeners[e];
					"function" == typeof r && r.apply(n[i + "Scope"] || n.callbackScope || t, n[i + "Params"] || [t.pointerEvent]), o && t.dispatchEvent(e)
				},
				ae = function (t, e) {
					var i, n, r, o = ie(t);
					return o ? z(o, e) : void 0 !== t.left ? (r = D(e), {
						left: t.left - r.x,
						top: t.top - r.y,
						width: t.width,
						height: t.height
					}) : (n = t.min || t.minX || t.minRotation || 0, i = t.min || t.minY || 0, {
						left: n,
						top: i,
						width: (t.max || t.maxX || t.maxRotation || 0) - n,
						height: (t.max || t.maxY || 0) - i
					})
				},
				L = function () {
					if (!Rt.createElementNS) return E = 0, void(m = !1);
					var t, e, i, n, r = u("div"),
						o = Rt.createElementNS("http://www.w3.org/2000/svg", "svg"),
						a = u("div"),
						s = r.style,
						l = Rt.body || Ot,
						c = "flex" === re(l, "display", !0);
					Rt.body && R && (s.position = "absolute", l.appendChild(a), a.appendChild(r), n = r.offsetParent, a.style[R] = "rotate(1deg)", M = r.offsetParent === n, a.style.position = "absolute", s.height = "10px", n = r.offsetTop, a.style.border = "5px solid red", S = n !== r.offsetTop, l.removeChild(a)), s = o.style, o.setAttributeNS(null, "width", "400px"), o.setAttributeNS(null, "height", "400px"), o.setAttributeNS(null, "viewBox", "0 0 400 400"), s.display = "block", s.boxSizing = "border-box", s.border = "0px solid red", s.transform = "none", r.style.cssText = "width:100px;height:100px;overflow:scroll;-ms-overflow-style:none;", l.appendChild(r), r.appendChild(o), i = o.createSVGPoint().matrixTransform(o.getScreenCTM()), e = i.y, r.scrollTop = 100, i.x = i.y = 0, i = i.matrixTransform(o.getScreenCTM()), g = e - i.y < 100.1 ? 0 : e - i.y - 150, r.removeChild(o), l.removeChild(r), l.appendChild(o), c && (l.style.display = "block"), t = o.getScreenCTM(), e = t.e, s.border = "50px solid red", t = o.getScreenCTM(), 0 === e && 0 === t.e && 0 === t.f && 1 === t.a ? (E = 1, m = !0) : (E = e !== t.e ? 1 : 0, m = 1 !== t.a), c && (l.style.display = "flex"), l.removeChild(o)
				},
				w = "" !== c(h, "perspective"),
				y = c(h, "transformOrigin").replace(/^ms/g, "Ms").replace(/([A-Z])/g, "-$1").toLowerCase(),
				R = c(h, "transform"),
				O = R.replace(/^ms/g, "Ms").replace(/([A-Z])/g, "-$1").toLowerCase(),
				x = {},
				_ = {},
				b = _gsScope.SVGElement,
				se = function (t) {
					return !!(b && "function" == typeof t.getBBox && t.getCTM && (!t.parentNode || t.parentNode.getBBox && t.parentNode.getCTM))
				},
				k = (/MSIE ([0-9]{1,}[\.0-9]{0,})/.exec(navigator.userAgent) || /Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/.exec(navigator.userAgent)) && parseFloat(RegExp.$1) < 11,
				T = [],
				N = [],
				I = function (t) {
					if (!t.getBoundingClientRect || !t.parentNode || !R) return {
						offsetTop: 0,
						offsetLeft: 0,
						scaleX: 1,
						scaleY: 1,
						offsetParent: Ot
					};
					if (_e.cacheSVGData !== !1 && t._dCache && t._dCache.lastUpdate === wt.ticker.frame) return t._dCache;
					var e, i, n, r, o, a, s, l, c, u, h, d, f = t,
						p = F(t);
					if (p.lastUpdate = wt.ticker.frame, t.getBBox && !p.isSVGRoot) {
						for (f = t.parentNode, e = t.getBBox(); f && "svg" !== (f.nodeName + "").toLowerCase();) f = f.parentNode;
						return r = I(f), p.offsetTop = e.y * r.scaleY, p.offsetLeft = e.x * r.scaleX, p.scaleX = r.scaleX, p.scaleY = r.scaleY, p.offsetParent = f || Ot, p
					}
					for (n = p.offsetParent, n === Rt.body && (n = Ot), N.length = T.length = 0; f && (o = re(f, R, !0), "matrix(1, 0, 0, 1, 0, 0)" !== o && "none" !== o && "translate3d(0px, 0px, 0px)" !== o && (N.push(f), T.push(f.style[R]), f.style[R] = "none"), f !== n);) f = f.parentNode;
					for (i = n.getBoundingClientRect(), o = t.getScreenCTM(), l = t.createSVGPoint(), s = l.matrixTransform(o), p.scaleX = Math.sqrt(o.a * o.a + o.b * o.b), p.scaleY = Math.sqrt(o.d * o.d + o.c * o.c), void 0 === E && L(), p.borderBox && !m && t.getAttribute("width") && (r = P(t) || {}, c = parseFloat(r.borderLeftWidth) + parseFloat(r.borderRightWidth) || 0, u = parseFloat(r.borderTopWidth) + parseFloat(r.borderBottomWidth) || 0, h = parseFloat(r.width) || 0, d = parseFloat(r.height) || 0, p.scaleX *= (h - c) / h, p.scaleY *= (d - u) / d), g ? (e = t.getBoundingClientRect(), p.offsetLeft = e.left - i.left, p.offsetTop = e.top - i.top) : (p.offsetLeft = s.x - i.left, p.offsetTop = s.y - i.top), p.offsetParent = n, a = N.length; --a > -1;) N[a].style[R] = T[a];
					return p
				},
				D = function (t, e) {
					if (e = e || {}, !t || t === Ot || !t.parentNode || t === window) return {
						x: 0,
						y: 0
					};
					var i = P(t),
						n = y && i ? i.getPropertyValue(y) : "50% 50%",
						r = n.split(" "),
						o = -1 !== n.indexOf("left") ? "0%" : -1 !== n.indexOf("right") ? "100%" : r[0],
						a = -1 !== n.indexOf("top") ? "0%" : -1 !== n.indexOf("bottom") ? "100%" : r[1];
					return ("center" === a || null == a) && (a = "50%"), ("center" === o || isNaN(parseFloat(o))) && (o = "50%"), t.getBBox && se(t) ? (t._gsTransform || (wt.set(t, {
						x: "+=0",
						overwrite: !1
					}), void 0 === t._gsTransform.xOrigin && console.log("Draggable requires at least GSAP 1.17.0")), n = t.getBBox(), e.x = t._gsTransform.xOrigin - n.x, e.y = t._gsTransform.yOrigin - n.y) : (t.getBBox && -1 !== (o + a).indexOf("%") && (t = t.getBBox(), t = {
						offsetWidth: t.width,
						offsetHeight: t.height
					}), e.x = -1 !== o.indexOf("%") ? t.offsetWidth * parseFloat(o) / 100 : parseFloat(o), e.y = -1 !== a.indexOf("%") ? t.offsetHeight * parseFloat(a) / 100 : parseFloat(a)), e
				},
				F = function (t) {
					if (_e.cacheSVGData !== !1 && t._dCache && t._dCache.lastUpdate === wt.ticker.frame) return t._dCache;
					var e, i = t._dCache = t._dCache || {},
						n = P(t),
						r = t.getBBox && se(t),
						o = "svg" === (t.nodeName + "").toLowerCase();
					if (i.isSVG = r, i.isSVGRoot = o, i.borderBox = "border-box" === n.boxSizing, i.computedStyle = n, o) e = t.parentNode || Ot, e.insertBefore(h, t), i.offsetParent = h.offsetParent || Ot, e.removeChild(h);
					else if (r) {
						for (e = t.parentNode; e && "svg" !== (e.nodeName + "").toLowerCase();) e = e.parentNode;
						i.offsetParent = e
					} else i.offsetParent = t.offsetParent;
					return i
				},
				B = function (t, e, i, n, r) {
					if (t === window || !t || !t.style || !t.parentNode) return [1, 0, 0, 1, 0, 0];
					var o, a, s, l, c, u, h, d, f, p, m, g, v, y, x = t._dCache || F(t),
						_ = t.parentNode,
						b = _._dCache || F(_),
						w = x.computedStyle,
						T = x.isSVG ? b.offsetParent : _.offsetParent;
					return o = x.isSVG && -1 !== (t.style[R] + "").indexOf("matrix") ? t.style[R] : w ? w.getPropertyValue(O) : t.currentStyle ? t.currentStyle[R] : "1,0,0,1,0,0", t.getBBox && -1 !== (t.getAttribute("transform") + "").indexOf("matrix") && (o = t.getAttribute("transform")), o = (o + "").match(/(?:\-|\.|\b)(\d|\.|e\-)+/g) || [1, 0, 0, 1, 0, 0], o.length > 6 && (o = [o[0], o[1], o[4], o[5], o[12], o[13]]), n ? o[4] = o[5] = 0 : x.isSVG && (c = t._gsTransform) && (c.xOrigin || c.yOrigin) && (o[0] = parseFloat(o[0]), o[1] = parseFloat(o[1]), o[2] = parseFloat(o[2]), o[3] = parseFloat(o[3]), o[4] = parseFloat(o[4]) - (c.xOrigin - (c.xOrigin * o[0] + c.yOrigin * o[2])), o[5] = parseFloat(o[5]) - (c.yOrigin - (c.xOrigin * o[1] + c.yOrigin * o[3]))), e && (void 0 === E && L(), s = x.isSVG || x.isSVGRoot ? I(t) : t, x.isSVG ? (l = t.getBBox(), p = b.isSVGRoot ? {
						x: 0,
						y: 0
					} : _.getBBox(), s = {
						offsetLeft: l.x - p.x,
						offsetTop: l.y - p.y,
						offsetParent: x.offsetParent
					}) : x.isSVGRoot ? (m = parseInt(w.borderTopWidth, 10) || 0, g = parseInt(w.borderLeftWidth, 10) || 0, v = (o[0] - E) * g + o[2] * m, y = o[1] * g + (o[3] - E) * m, u = e.x, h = e.y, d = u - (u * o[0] + h * o[2]), f = h - (u * o[1] + h * o[3]), o[4] = parseFloat(o[4]) + d, o[5] = parseFloat(o[5]) + f, e.x -= d, e.y -= f, u = s.scaleX, h = s.scaleY, r || (e.x *= u, e.y *= h), o[0] *= u, o[1] *= h, o[2] *= u, o[3] *= h, k || (e.x += v, e.y += y), T === Rt.body && s.offsetParent === Ot && (T = Ot)) : !S && t.offsetParent && (e.x += parseInt(re(t.offsetParent, "borderLeftWidth"), 10) || 0, e.y += parseInt(re(t.offsetParent, "borderTopWidth"), 10) || 0), a = _ === Ot || _ === Rt.body, o[4] = Number(o[4]) + e.x + (s.offsetLeft || 0) - i.x - (a ? 0 : _.scrollLeft || 0), o[5] = Number(o[5]) + e.y + (s.offsetTop || 0) - i.y - (a ? 0 : _.scrollTop || 0), _ && "fixed" === re(t, "position", w) && (o[4] += C(), o[5] += A()), !_ || _ === Ot || T !== s.offsetParent || b.isSVG || M && "100100" !== B(_).join("") || (s = b.isSVGRoot ? I(_) : _, o[4] -= s.offsetLeft || 0, o[5] -= s.offsetTop || 0, S || !b.offsetParent || x.isSVG || x.isSVGRoot || (o[4] -= parseInt(re(b.offsetParent, "borderLeftWidth"), 10) || 0, o[5] -= parseInt(re(b.offsetParent, "borderTopWidth"), 10) || 0))), o
				},
				le = function (t, e) {
					if (!t || t === window || !t.parentNode) return [1, 0, 0, 1, 0, 0];
					for (var i, n, r, o, a, s, l, c, u = D(t, x), h = D(t.parentNode, _), d = B(t, u, h, !1, !e);
						(t = t.parentNode) && t.parentNode && t !== Ot;) u = h, h = D(t.parentNode, u === x ? _ : x), l = B(t, u, h), i = d[0], n = d[1], r = d[2], o = d[3], a = d[4], s = d[5], d[0] = i * l[0] + n * l[2], d[1] = i * l[1] + n * l[3], d[2] = r * l[0] + o * l[2], d[3] = r * l[1] + o * l[3], d[4] = a * l[0] + s * l[2] + l[4], d[5] = a * l[1] + s * l[3] + l[5];
					return e && (i = d[0], n = d[1], r = d[2], o = d[3], a = d[4], s = d[5], c = i * o - n * r, d[0] = o / c, d[1] = -n / c, d[2] = -r / c, d[3] = i / c, d[4] = (r * s - o * a) / c, d[5] = -(i * s - n * a) / c), d
				},
				ce = function (t, e, i, n, r) {
					t = ie(t);
					var o = le(t, !1, r),
						a = e.x,
						s = e.y;
					return i && (D(t, e), a -= e.x, s -= e.y), n = n === !0 ? e : n || {}, n.x = a * o[0] + s * o[2] + o[4], n.y = a * o[1] + s * o[3] + o[5], n
				},
				U = function (t, e, i) {
					var n = t.x * e[0] + t.y * e[2] + e[4],
						r = t.x * e[1] + t.y * e[3] + e[5];
					return t.x = n * i[0] + r * i[2] + i[4], t.y = n * i[1] + r * i[3] + i[5], t
				},
				z = function (t, e, i) {
					if (!(t = ie(t))) return null;
					e = ie(e);
					var n, r, o, a, s, l, c, u, h, d, f, p, m, g, v, y, x, _, b, w, T, E, S = t.getBBox && se(t);
					if (t === window) a = A(), r = C(), o = r + (Ot.clientWidth || t.innerWidth || Rt.body.clientWidth || 0), s = a + ((t.innerHeight || 0) - 20 < Ot.clientHeight ? Ot.clientHeight : t.innerHeight || Rt.body.clientHeight || 0);
					else {
						if (void 0 === e || e === window) return t.getBoundingClientRect();
						n = D(t), r = -n.x, a = -n.y, S ? (p = t.getBBox(), m = p.width, g = p.height) : "svg" !== (t.nodeName + "").toLowerCase() && t.offsetWidth ? (m = t.offsetWidth, g = t.offsetHeight) : (T = P(t), m = parseFloat(T.width), g = parseFloat(T.height)), o = r + m, s = a + g, "svg" !== t.nodeName.toLowerCase() || Ft || (v = I(t), E = v.computedStyle || {}, _ = (t.getAttribute("viewBox") || "0 0").split(" "), b = parseFloat(_[0]), w = parseFloat(_[1]), y = parseFloat(E.borderLeftWidth) || 0, x = parseFloat(E.borderTopWidth) || 0, o -= m - (m - y) / v.scaleX - b, s -= g - (g - x) / v.scaleY - w, r -= y / v.scaleX - b, a -= x / v.scaleY - w, T && (o += (parseFloat(E.borderRightWidth) + y) / v.scaleX, s += (x + parseFloat(E.borderBottomWidth)) / v.scaleY))
					}
					return t === e ? {
						left: r,
						top: a,
						width: o - r,
						height: s - a
					} : (l = le(t), c = le(e, !0), u = U({
						x: r,
						y: a
					}, l, c), h = U({
						x: o,
						y: a
					}, l, c), d = U({
						x: o,
						y: s
					}, l, c), f = U({
						x: r,
						y: s
					}, l, c), r = Math.min(u.x, h.x, d.x, f.x), a = Math.min(u.y, h.y, d.y, f.y), Vt.x = Vt.y = 0, i && D(e, Vt), {
						left: r + Vt.x,
						top: a + Vt.y,
						width: Math.max(u.x, h.x, d.x, f.x) - r,
						height: Math.max(u.y, h.y, d.y, f.y) - a
					})
				},
				G = function (t) {
					return t && t.length && t[0] && (t[0].nodeType && t[0].style && !t.nodeType || t[0].length && t[0][0]) ? !0 : !1
				},
				H = function (t) {
					var e, i, n, r = [],
						o = t.length;
					for (e = 0; o > e; e++)
						if (i = t[e], G(i))
							for (n = i.length, n = 0; n < i.length; n++) r.push(i[n]);
						else i && 0 !== i.length && r.push(i);
					return r
				},
				ue = "ontouchstart" in Ot && "orientation" in window,
				he = function (t) {
					for (var e = t.split(","), i = (void 0 !== h.onpointerdown ? "pointerdown,pointermove,pointerup,pointercancel" : void 0 !== h.onmspointerdown ? "MSPointerDown,MSPointerMove,MSPointerUp,MSPointerCancel" : t).split(","), n = {}, r = 4; --r > -1;) n[e[r]] = i[r], n[i[r]] = e[r];
					return n
				}("touchstart,touchmove,touchend,touchcancel"),
				de = function (t, e, i, n) {
					if (t.addEventListener) {
						var r = he[e];
						n = n || {
							passive: !1
						}, t.addEventListener(r || e, i, n), r && e !== r && t.addEventListener(e, i, n)
					} else t.attachEvent && t.attachEvent("on" + e, i)
				},
				fe = function (t, e, i) {
					if (t.removeEventListener) {
						var n = he[e];
						t.removeEventListener(n || e, i), n && e !== n && t.removeEventListener(e, i)
					} else t.detachEvent && t.detachEvent("on" + e, i)
				},
				pe = function (t, e) {
					for (var i = t.length; --i > -1;)
						if (t[i].identifier === e) return !0;
					return !1
				},
				j = function (t) {
					Et = t.touches && Gt < t.touches.length, fe(t.target, "touchend", j)
				},
				me = function (t) {
					Et = t.touches && Gt < t.touches.length, de(t.target, "touchend", j)
				},
				ge = function (r, o, t, e, a, i) {
					var n, s, l, c = {};
					if (o)
						if (1 !== a && o instanceof Array) {
							if (c.end = n = [], l = o.length, "object" == typeof o[0])
								for (s = 0; l > s; s++) n[s] = Yt(o[s], a);
							else
								for (s = 0; l > s; s++) n[s] = o[s] * a;
							t += 1.1, e -= 1.1
						} else "function" == typeof o ? c.end = function (t) {
							var e, i, n = o.call(r, t);
							if (1 !== a)
								if ("object" == typeof n) {
									e = {};
									for (i in n) e[i] = n[i] * a;
									n = e
								} else n *= a;
							return n
						} : c.end = o;
					return (t || 0 === t) && (c.max = t), (e || 0 === e) && (c.min = e), i && (c.velocity = 0), c
				},
				ve = function (t) {
					var e;
					return t && t.getAttribute && "BODY" !== t.nodeName ? "true" === (e = t.getAttribute("data-clickable")) || "false" !== e && (t.onclick || o.test(t.nodeName + "") || "true" === t.getAttribute("contentEditable")) ? !0 : ve(t.parentNode) : !1
				},
				ye = function (t, e) {
					for (var i, n = t.length; --n > -1;) i = t[n], i.ondragstart = i.onselectstart = e ? null : r, ne(i, "userSelect", e ? "text" : "none")
				},
				V = function () {
					var t, e = Rt.createElement("div"),
						i = Rt.createElement("div"),
						n = i.style,
						r = Rt.body || h;
					return n.display = "inline-block", n.position = "relative", e.style.cssText = i.innerHTML = "width:90px; height:40px; padding:10px; overflow:auto; visibility: hidden", e.appendChild(i), r.appendChild(e), t = i.offsetHeight + 18 > e.scrollHeight, r.removeChild(e), t
				}(),
				xe = function (r, o) {
					r = ie(r), o = o || {};
					var a, s, l, t, c, u, h = Rt.createElement("div"),
						d = h.style,
						e = r.firstChild,
						f = 0,
						p = 0,
						m = r.scrollTop,
						g = r.scrollLeft,
						v = r.scrollWidth,
						y = r.scrollHeight,
						x = 0,
						_ = 0,
						b = 0;
					w && o.force3D !== !1 ? (c = "translate3d(", u = "px,0px)") : R && (c = "translate(", u = "px)"), this.scrollTop = function (t, e) {
						return arguments.length ? void this.top(-t, e) : -this.top()
					}, this.scrollLeft = function (t, e) {
						return arguments.length ? void this.left(-t, e) : -this.left()
					}, this.left = function (t, e) {
						if (!arguments.length) return -(r.scrollLeft + p);
						var i = r.scrollLeft - g,
							n = p;
						return (i > 2 || -2 > i) && !e ? (g = r.scrollLeft, wt.killTweensOf(this, !0, {
							left: 1,
							scrollLeft: 1
						}), this.left(-g), void(o.onKill && o.onKill())) : (t = -t, 0 > t ? (p = t - .5 | 0, t = 0) : t > _ ? (p = t - _ | 0, t = _) : p = 0, (p || n) && (c ? this._suspendTransforms || (d[R] = c + -p + "px," + -f + u) : d.left = -p + "px", p + x >= 0 && (d.paddingRight = p + x + "px")), r.scrollLeft = 0 | t, void(g = r.scrollLeft))
					}, this.top = function (t, e) {
						if (!arguments.length) return -(r.scrollTop + f);
						var i = r.scrollTop - m,
							n = f;
						return (i > 2 || -2 > i) && !e ? (m = r.scrollTop, wt.killTweensOf(this, !0, {
							top: 1,
							scrollTop: 1
						}), this.top(-m), void(o.onKill && o.onKill())) : (t = -t, 0 > t ? (f = t - .5 | 0, t = 0) : t > b ? (f = t - b | 0, t = b) : f = 0, (f || n) && (c ? this._suspendTransforms || (d[R] = c + -p + "px," + -f + u) : d.top = -f + "px"), r.scrollTop = 0 | t, void(m = r.scrollTop))
					}, this.maxScrollTop = function () {
						return b
					}, this.maxScrollLeft = function () {
						return _
					}, this.disable = function () {
						for (e = h.firstChild; e;) t = e.nextSibling, r.appendChild(e), e = t;
						r === h.parentNode && r.removeChild(h)
					}, this.enable = function () {
						if (e = r.firstChild, e !== h) {
							for (; e;) t = e.nextSibling, h.appendChild(e), e = t;
							r.appendChild(h), this.calibrate()
						}
					}, this.calibrate = function (t) {
						var e, i, n = r.clientWidth === a;
						m = r.scrollTop, g = r.scrollLeft, (!n || r.clientHeight !== s || h.offsetHeight !== l || v !== r.scrollWidth || y !== r.scrollHeight || t) && ((f || p) && (e = this.left(), i = this.top(), this.left(-r.scrollLeft), this.top(-r.scrollTop)), (!n || t) && (d.display = "block", d.width = "auto", d.paddingRight = "0px", x = Math.max(0, r.scrollWidth - r.clientWidth), x && (x += re(r, "paddingLeft") + (V ? re(r, "paddingRight") : 0))), d.display = "inline-block", d.position = "relative", d.overflow = "visible", d.verticalAlign = "top", d.width = "100%", d.paddingRight = x + "px", V && (d.paddingBottom = re(r, "paddingBottom", !0)), Ft && (d.zoom = "1"), a = r.clientWidth, s = r.clientHeight, v = r.scrollWidth, y = r.scrollHeight, _ = r.scrollWidth - a, b = r.scrollHeight - s, l = h.offsetHeight, d.display = "block", (e || i) && (this.left(e), this.top(i)))
					}, this.content = h, this.element = r, this._suspendTransforms = !1, this.enable()
				},
				_e = function (p, h) {
					bt.call(this, p), p = ie(p), St || (St = Lt.com.greensock.plugins.ThrowPropsPlugin), this.vars = h = Yt(h || {}), this.target = p, this.x = this.y = this.rotation = 0, this.dragResistance = parseFloat(h.dragResistance) || 0, this.edgeResistance = isNaN(h.edgeResistance) ? 1 : parseFloat(h.edgeResistance) || 0, this.lockAxis = h.lockAxis, this.autoScroll = h.autoScroll || 0, this.lockedAxis = null, this.allowEventDefault = !!h.allowEventDefault;
					var d, m, f, g, u, v, y, x, _, b, w, T, r, o, E, S, M, A, t, C, P, L, R, O, k, N, e, i, I, D, F, B, U, c, n = (h.type || (Ft ? "top,left" : "x,y")).toLowerCase(),
						z = -1 !== n.indexOf("x") || -1 !== n.indexOf("y"),
						G = -1 !== n.indexOf("rotation"),
						H = G ? "rotation" : z ? "x" : "left",
						j = z ? "y" : "top",
						V = -1 !== n.indexOf("x") || -1 !== n.indexOf("left") || "scroll" === n,
						W = -1 !== n.indexOf("y") || -1 !== n.indexOf("top") || "scroll" === n,
						X = h.minimumMovement || 2,
						Y = this,
						q = Xt(h.trigger || h.handle || p),
						a = {},
						$ = 0,
						Z = !1,
						J = h.autoScrollMarginTop || 40,
						Q = h.autoScrollMarginRight || 40,
						K = h.autoScrollMarginBottom || 40,
						tt = h.autoScrollMarginLeft || 40,
						et = h.clickableTest || ve,
						it = 0,
						s = function (t) {
							return Y.isPressed && t.which < 2 ? void Y.endDrag() : (t.preventDefault(), t.stopPropagation(), !1)
						},
						nt = function (t) {
							if (Y.autoScroll && Y.isDragging && (Z || A)) {
								var e, i, n, r, o, a, s, l, c = p,
									u = 15 * Y.autoScroll;
								for (Z = !1, Wt.scrollTop = null != window.pageYOffset ? window.pageYOffset : null != Ot.scrollTop ? Ot.scrollTop : Rt.body.scrollTop, Wt.scrollLeft = null != window.pageXOffset ? window.pageXOffset : null != Ot.scrollLeft ? Ot.scrollLeft : Rt.body.scrollLeft, r = Y.pointerX - Wt.scrollLeft, o = Y.pointerY - Wt.scrollTop; c && !i;) i = Kt(c.parentNode), e = i ? Wt : c.parentNode, n = i ? {
									bottom: Math.max(Ot.clientHeight, window.innerHeight || 0),
									right: Math.max(Ot.clientWidth, window.innerWidth || 0),
									left: 0,
									top: 0
								} : e.getBoundingClientRect(), a = s = 0, W && (l = e._gsMaxScrollY - e.scrollTop, 0 > l ? s = l : o > n.bottom - K && l ? (Z = !0, s = Math.min(l, u * (1 - Math.max(0, n.bottom - o) / K) | 0)) : o < n.top + J && e.scrollTop && (Z = !0, s = -Math.min(e.scrollTop, u * (1 - Math.max(0, o - n.top) / J) | 0)), s && (e.scrollTop += s)), V && (l = e._gsMaxScrollX - e.scrollLeft, 0 > l ? a = l : r > n.right - Q && l ? (Z = !0, a = Math.min(l, u * (1 - Math.max(0, n.right - r) / Q) | 0)) : r < n.left + tt && e.scrollLeft && (Z = !0, a = -Math.min(e.scrollLeft, u * (1 - Math.max(0, r - n.left) / tt) | 0)), a && (e.scrollLeft += a)), i && (a || s) && (window.scrollTo(e.scrollLeft, e.scrollTop), gt(Y.pointerX + a, Y.pointerY + s)), c = e
							}
							if (A) {
								var h = Y.x,
									d = Y.y,
									f = 1e-6;
								f > h && h > -f && (h = 0), f > d && d > -f && (d = 0), G ? (Y.deltaX = h - I.data.rotation, I.data.rotation = Y.rotation = h, I.setRatio(1)) : m ? (W && (Y.deltaY = d - m.top(), m.top(d)), V && (Y.deltaX = h - m.left(), m.left(h))) : z ? (W && (Y.deltaY = d - I.data.y, I.data.y = d), V && (Y.deltaX = h - I.data.x, I.data.x = h), I.setRatio(1)) : (W && (Y.deltaY = d - parseFloat(p.style.top || 0), p.style.top = d + "px"), V && (Y.deltaY = h - parseFloat(p.style.left || 0), p.style.left = h + "px")), !x || t || B || (B = !0, oe(Y, "drag", "onDrag"), B = !1)
							}
							A = !1
						},
						l = function (t, e) {
							var i, n = Y.x,
								r = Y.y;
							p._gsTransform || !z && !G || wt.set(p, {
								x: "+=0",
								overwrite: !1,
								data: "_draggable"
							}), z ? (Y.y = p._gsTransform.y, Y.x = p._gsTransform.x) : G ? Y.x = Y.rotation = p._gsTransform.rotation : m ? (Y.y = m.top(), Y.x = m.left()) : (Y.y = parseInt(p.style.top, 10) || 0, Y.x = parseInt(p.style.left, 10) || 0), (C || P || L) && !e && (Y.isDragging || Y.isThrowing) && (L && (Vt.x = Y.x, Vt.y = Y.y, i = L(Vt), i.x !== Y.x && (Y.x = i.x, A = !0), i.y !== Y.y && (Y.y = i.y, A = !0)), C && (i = C(Y.x), i !== Y.x && (Y.x = i, G && (Y.rotation = i), A = !0)), P && (i = P(Y.y), i !== Y.y && (Y.y = i), A = !0)), A && nt(!0), t || (Y.deltaX = Y.x - n, Y.deltaY = Y.y - r, oe(Y, "throwupdate", "onThrowUpdate"))
						},
						rt = function () {
							var t, e, i, n;
							y = !1, m ? (m.calibrate(), Y.minX = b = -m.maxScrollLeft(), Y.minY = T = -m.maxScrollTop(), Y.maxX = _ = Y.maxY = w = 0, y = !0) : h.bounds && (t = ae(h.bounds, p.parentNode), G ? (Y.minX = b = t.left, Y.maxX = _ = t.left + t.width, Y.minY = T = Y.maxY = w = 0) : void 0 !== h.bounds.maxX || void 0 !== h.bounds.maxY ? (t = h.bounds, Y.minX = b = t.minX, Y.minY = T = t.minY, Y.maxX = _ = t.maxX, Y.maxY = w = t.maxY) : (e = ae(p, p.parentNode), Y.minX = b = re(p, H) + t.left - e.left, Y.minY = T = re(p, j) + t.top - e.top, Y.maxX = _ = b + (t.width - e.width), Y.maxY = w = T + (t.height - e.height)), b > _ && (Y.minX = _, Y.maxX = _ = b, b = Y.minX), T > w && (Y.minY = w, Y.maxY = w = T, T = Y.minY), G && (Y.minRotation = b, Y.maxRotation = _), y = !0), h.liveSnap && (i = h.liveSnap === !0 ? h.snap || {} : h.liveSnap, n = i instanceof Array || "function" == typeof i, G ? (C = dt(n ? i : i.rotation, b, _, 1), P = null) : i.points ? L = ft(n ? i : i.points, b, _, T, w, i.radius, m ? -1 : 1) : (V && (C = dt(n ? i : i.x || i.left || i.scrollLeft, b, _, m ? -1 : 1)), W && (P = dt(n ? i : i.y || i.top || i.scrollTop, T, w, m ? -1 : 1))))
						},
						ot = function () {
							Y.isThrowing = !1, oe(Y, "throwcomplete", "onThrowComplete")
						},
						at = function () {
							Y.isThrowing = !1
						},
						st = function (t, e) {
							var i, n, r, o;
							t && St ? (t === !0 && (i = h.snap || h.liveSnap || {}, n = i instanceof Array || "function" == typeof i, t = {
								resistance: (h.throwResistance || h.resistance || 1e3) / (G ? 10 : 1)
							}, G ? t.rotation = ge(Y, n ? i : i.rotation, _, b, 1, e) : (V && (t[H] = ge(Y, n ? i : i.points || i.x || i.left || i.scrollLeft, _, b, m ? -1 : 1, e || "x" === Y.lockedAxis)), W && (t[j] = ge(Y, n ? i : i.points || i.y || i.top || i.scrollTop, w, T, m ? -1 : 1, e || "y" === Y.lockedAxis)), (i.points || i instanceof Array && "object" == typeof i[0]) && (t.linkedProps = H + "," + j, t.radius = i.radius))), Y.isThrowing = !0, o = isNaN(h.overshootTolerance) ? 1 === h.edgeResistance ? 0 : 1 - Y.edgeResistance + .2 : h.overshootTolerance, Y.tween = r = St.to(m || p, {
								throwProps: t,
								data: "_draggable",
								ease: h.ease || Lt.Power3.easeOut,
								onComplete: ot,
								onOverwrite: at,
								onUpdate: h.fastMode ? oe : l,
								onUpdateParams: h.fastMode ? [Y, "onthrowupdate", "onThrowUpdate"] : i && i.radius ? [!1, !0] : kt
							}, isNaN(h.maxDuration) ? 2 : h.maxDuration, isNaN(h.minDuration) ? 0 === o || "object" == typeof t && t.resistance > 1e3 ? 0 : .5 : h.minDuration, o), h.fastMode || (m && (m._suspendTransforms = !0), r.render(r.duration(), !0, !0), l(!0, !0), Y.endX = Y.x, Y.endY = Y.y, G && (Y.endRotation = Y.x), r.play(0), l(!0, !0), m && (m._suspendTransforms = !1))) : y && Y.applyBounds()
						},
						lt = function (t) {
							var e, i, n, r, o, a, s, l, c, u = k || [1, 0, 0, 1, 0, 0];
							k = le(p.parentNode, !0), t && Y.isPressed && u.join(",") !== k.join(",") && (e = u[0], i = u[1], n = u[2], r = u[3], o = u[4], a = u[5], s = e * r - i * n, l = f * (r / s) + g * (-n / s) + (n * a - r * o) / s, c = f * (-i / s) + g * (e / s) + -(e * a - i * o) / s, g = l * k[1] + c * k[3] + k[5], f = l * k[0] + c * k[2] + k[4]), k[1] || k[2] || 1 != k[0] || 1 != k[3] || 0 != k[4] || 0 != k[5] || (k = null)
						},
						ct = function () {
							var t = 1 - Y.edgeResistance;
							lt(!1), k && (f = Y.pointerX * k[0] + Y.pointerY * k[2] + k[4], g = Y.pointerX * k[1] + Y.pointerY * k[3] + k[5]), A && (gt(Y.pointerX, Y.pointerY), nt(!0)), m ? (rt(), v = m.top(), u = m.left()) : (ut() ? (l(!0, !0), rt()) : Y.applyBounds(), G ? (M = Y.rotationOrigin = ce(p, {
								x: 0,
								y: 0
							}), l(!0, !0), u = Y.x, v = Y.y = Math.atan2(M.y - Y.pointerY, Y.pointerX - M.x) * Nt) : (e = p.parentNode ? p.parentNode.scrollTop || 0 : 0, i = p.parentNode ? p.parentNode.scrollLeft || 0 : 0, v = re(p, j), u = re(p, H))), y && t && (u > _ ? u = _ + (u - _) / t : b > u && (u = b - (b - u) / t), G || (v > w ? v = w + (v - w) / t : T > v && (v = T - (T - v) / t))), Y.startX = u, Y.startY = v
						},
						ut = function () {
							return Y.tween && Y.tween.isActive()
						},
						ht = function () {
							!Bt.parentNode || ut() || Y.isDragging || Bt.parentNode.removeChild(Bt)
						},
						dt = function (a, s, l, i) {
							return "function" == typeof a ? function (t) {
								var e = Y.isPressed ? 1 - Y.edgeResistance : 1;
								return a.call(Y, t > l ? l + (t - l) * e : s > t ? s + (t - s) * e : t) * i
							} : a instanceof Array ? function (t) {
								for (var e, i, n = a.length, r = 0, o = It; --n > -1;) e = a[n], i = e - t, 0 > i && (i = -i), o > i && e >= s && l >= e && (r = n, o = i);
								return a[r]
							} : isNaN(a) ? function (t) {
								return t
							} : function () {
								return a * i
							}
						},
						ft = function (l, s, c, u, h, d, f) {
							return d = d && It > d ? d * d : It, "function" == typeof l ? function (t) {
								var e, i, n, r = Y.isPressed ? 1 - Y.edgeResistance : 1,
									o = t.x,
									a = t.y;
								return t.x = o = o > c ? c + (o - c) * r : s > o ? s + (o - s) * r : o, t.y = a = a > h ? h + (a - h) * r : u > a ? u + (a - u) * r : a, e = l.call(Y, t), e !== t && (t.x = e.x, t.y = e.y), 1 !== f && (t.x *= f, t.y *= f), It > d && (i = t.x - o, n = t.y - a, i * i + n * n > d && (t.x = o, t.y = a)), t
							} : l instanceof Array ? function (t) {
								for (var e, i, n, r, o = l.length, a = 0, s = It; --o > -1;) n = l[o], e = n.x - t.x, i = n.y - t.y, r = e * e + i * i, s > r && (a = o, s = r);
								return d >= s ? l[a] : t
							} : function (t) {
								return t
							}
						},
						pt = function (t, e) {
							var i;
							if (d && !Y.isPressed && t && ("mousedown" !== t.type && "pointerdown" !== t.type || e || !(Dt() - it < 30) || !he[Y.pointerEvent.type])) {
								if (N = ut(), Y.pointerEvent = t, he[t.type] ? (O = -1 !== t.type.indexOf("touch") ? t.currentTarget || t.target : Rt, de(O, "touchend", vt), de(O, "touchmove", mt), de(O, "touchcancel", vt), de(Rt, "touchstart", me)) : (O = null, de(Rt, "mousemove", mt)), F = null, de(Rt, "mouseup", vt), t && t.target && de(t.target, "mouseup", vt), R = et.call(Y, t.target) && !h.dragClickables && !e) return de(t.target, "change", vt), oe(Y, "press", "onPress"), void ye(q, !0);
								if (D = !O || V === W || Y.vars.allowNativeTouchScrolling === !1 || Y.vars.allowContextMenu && t && (t.ctrlKey || t.which > 2) ? !1 : V ? "y" : "x", Ft ? t = ee(t, !0) : D || Y.allowEventDefault || (t.preventDefault(), t.preventManipulation && t.preventManipulation()), t.changedTouches ? (t = E = t.changedTouches[0], S = t.identifier) : t.pointerId ? S = t.pointerId : E = S = null, Gt++, qt(nt), g = Y.pointerY = t.pageY, f = Y.pointerX = t.pageX, (D || Y.autoScroll) && te(p.parentNode), !p.parentNode || !Y.autoScroll || m || G || !p.parentNode._gsMaxScrollX || Bt.parentNode || p.getBBox || (Bt.style.width = p.parentNode.scrollWidth + "px", p.parentNode.appendChild(Bt)), ct(), Y.tween && Y.tween.kill(), Y.isThrowing = !1, wt.killTweensOf(m || p, !0, a), m && wt.killTweensOf(p, !0, {
										scrollTo: 1
									}), Y.tween = Y.lockedAxis = null, (h.zIndexBoost || !G && !m && h.zIndexBoost !== !1) && (p.style.zIndex = _e.zIndex++), Y.isPressed = !0, x = !(!h.onDrag && !Y._listeners.drag), !G)
									for (i = q.length; --i > -1;) ne(q[i], "cursor", h.cursor || "move");
								oe(Y, "press", "onPress")
							}
						},
						mt = function (t) {
							var e, i, n, r, o, a, s = t;
							if (d && !Et && Y.isPressed && t) {
								if (Y.pointerEvent = t, e = t.changedTouches) {
									if (t = e[0], t !== E && t.identifier !== S) {
										for (r = e.length; --r > -1 && (t = e[r]).identifier !== S;);
										if (0 > r) return
									}
								} else if (t.pointerId && S && t.pointerId !== S) return;
								if (Ft) t = ee(t, !0);
								else {
									if (O && D && !F && (i = t.pageX, n = t.pageY, k && (r = i * k[0] + n * k[2] + k[4], n = i * k[1] + n * k[3] + k[5], i = r), o = Math.abs(i - f), a = Math.abs(n - g), (o !== a && (o > X || a > X) || Ht && D === F) && (F = o > a && V ? "x" : "y", Y.vars.lockAxisOnTouchScroll !== !1 && (Y.lockedAxis = "x" === F ? "y" : "x", "function" == typeof Y.vars.onLockAxis && Y.vars.onLockAxis.call(Y, s)), Ht && D === F))) return void vt(s);
									Y.allowEventDefault || D && (!F || D === F) || s.cancelable === !1 || (s.preventDefault(), s.preventManipulation && s.preventManipulation())
								}
								Y.autoScroll && (Z = !0), gt(t.pageX, t.pageY)
							}
						},
						gt = function (t, e) {
							var i, n, r, o, a, s, l = 1 - Y.dragResistance,
								c = 1 - Y.edgeResistance;
							Y.pointerX = t, Y.pointerY = e, G ? (o = Math.atan2(M.y - e, t - M.x) * Nt, a = Y.y - o, a > 180 ? (v -= 360, Y.y = o) : -180 > a && (v += 360, Y.y = o), Y.x !== u || Math.abs(v - o) > X ? (Y.y = o, r = u + (v - o) * l) : r = u) : (k && (s = t * k[0] + e * k[2] + k[4], e = t * k[1] + e * k[3] + k[5], t = s), n = e - g, i = t - f, X > n && n > -X && (n = 0), X > i && i > -X && (i = 0), (Y.lockAxis || Y.lockedAxis) && (i || n) && (s = Y.lockedAxis, s || (Y.lockedAxis = s = V && Math.abs(i) > Math.abs(n) ? "y" : W ? "x" : null, s && "function" == typeof Y.vars.onLockAxis && Y.vars.onLockAxis.call(Y, Y.pointerEvent)), "y" === s ? n = 0 : "x" === s && (i = 0)), r = u + i * l, o = v + n * l), (C || P || L) && (Y.x !== r || Y.y !== o && !G) ? (L && (Vt.x = r, Vt.y = o, s = L(Vt), r = s.x, o = s.y), C && (r = C(r)), P && (o = P(o))) : y && (r > _ ? r = _ + (r - _) * c : b > r && (r = b + (r - b) * c), G || (o > w ? o = w + (o - w) * c : T > o && (o = T + (o - T) * c))), G || k || (r = Math.round(r), o = Math.round(o)), (Y.x !== r || Y.y !== o && !G) && (G ? (Y.endRotation = Y.x = Y.endX = r, A = !0) : (W && (Y.y = Y.endY = o, A = !0), V && (Y.x = Y.endX = r, A = !0)), !Y.isDragging && Y.isPressed && (Y.isDragging = !0, oe(Y, "dragstart", "onDragStart")))
						},
						vt = function (t, e) {
							if (d && Y.isPressed && (!t || null == S || e || !(t.pointerId && t.pointerId !== S || t.changedTouches && !pe(t.changedTouches, S)))) {
								Y.isPressed = !1;
								var i, n, r, o, a, s = t,
									l = Y.isDragging,
									c = Y.vars.allowContextMenu && t && (t.ctrlKey || t.which > 2),
									u = wt.delayedCall(.001, ht);
								if (O ? (fe(O, "touchend", vt), fe(O, "touchmove", mt), fe(O, "touchcancel", vt), fe(Rt, "touchstart", me)) : fe(Rt, "mousemove", mt), fe(Rt, "mouseup", vt), t && t.target && fe(t.target, "mouseup", vt), A = !1, R && !c) return t && (fe(t.target, "change", vt), Y.pointerEvent = s), ye(q, !1), oe(Y, "release", "onRelease"), oe(Y, "click", "onClick"), void(R = !1);
								if ($t(nt), !G)
									for (n = q.length; --n > -1;) ne(q[n], "cursor", h.cursor || "move");
								if (l && ($ = jt = Dt(), Y.isDragging = !1), Gt--, t) {
									if (Ft && (t = ee(t, !1)), i = t.changedTouches, i && (t = i[0], t !== E && t.identifier !== S)) {
										for (n = i.length; --n > -1 && (t = i[n]).identifier !== S;);
										if (0 > n) return
									}
									Y.pointerEvent = s, Y.pointerX = t.pageX, Y.pointerY = t.pageY
								}
								return c && s ? (s.preventDefault(), s.preventManipulation && s.preventManipulation(), oe(Y, "release", "onRelease")) : s && !l ? (N && (h.snap || h.bounds) && st(h.throwProps), oe(Y, "release", "onRelease"), Ht && "touchmove" === s.type || -1 !== s.type.indexOf("cancel") || (oe(Y, "click", "onClick"), Dt() - it < 300 && oe(Y, "doubleclick", "onDoubleClick"), o = s.target || s.srcElement || p, it = Dt(), a = function () {
									it !== U && Y.enabled() && !Y.isPressed && (o.click ? o.click() : Rt.createEvent && (r = Rt.createEvent("MouseEvents"), r.initMouseEvent("click", !0, !0, window, 1, Y.pointerEvent.screenX, Y.pointerEvent.screenY, Y.pointerX, Y.pointerY, !1, !1, !1, !1, 0, null), o.dispatchEvent(r)))
								}, Ht || s.defaultPrevented || wt.delayedCall(1e-5, a))) : (st(h.throwProps), Ft || Y.allowEventDefault || !s || !h.dragClickables && et.call(Y, s.target) || !l || D && (!F || D !== F) || s.cancelable === !1 || (s.preventDefault(), s.preventManipulation && s.preventManipulation()), oe(Y, "release", "onRelease")), ut() && u.duration(Y.tween.duration()), l && oe(Y, "dragend", "onDragEnd"), !0
							}
						},
						yt = function (t) {
							if (t && Y.isDragging && !m) {
								var e = t.target || t.srcElement || p.parentNode,
									i = e.scrollLeft - e._gsScrollX,
									n = e.scrollTop - e._gsScrollY;
								(i || n) && (k ? (f -= i * k[0] + n * k[2], g -= n * k[3] + i * k[1]) : (f -= i, g -= n), e._gsScrollX += i, e._gsScrollY += n, gt(Y.pointerX, Y.pointerY))
							}
						},
						xt = function (t) {
							var e = Dt(),
								i = 40 > e - it,
								n = 40 > e - $,
								r = i && U === it,
								o = !!t.preventDefault,
								a = Y.pointerEvent && Y.pointerEvent.defaultPrevented,
								s = i && c === it,
								l = t.isTrusted || null == t.isTrusted && i && r;
							return o && (r || n && Y.vars.suppressClickOnDrag !== !1) && t.stopImmediatePropagation(), !i || Y.pointerEvent && Y.pointerEvent.defaultPrevented || r && l === s ? void((Y.isPressed || n || i) && (o ? l && t.detail && i && !a || (t.preventDefault(), t.preventManipulation && t.preventManipulation()) : t.returnValue = !1)) : (l && r && (c = it), void(U = it))
						},
						_t = function (t) {
							return k ? {
								x: t.x * k[0] + t.y * k[2] + k[4],
								y: t.x * k[1] + t.y * k[3] + k[5]
							} : {
								x: t.x,
								y: t.y
							}
						};
					t = _e.get(this.target), t && t.kill(), this.startDrag = function (t, e) {
						var i, n, r, o;
						pt(t || Y.pointerEvent, !0), e && !Y.hitTest(t || Y.pointerEvent) && (i = be(t || Y.pointerEvent), n = be(p), r = _t({
							x: i.left + i.width / 2,
							y: i.top + i.height / 2
						}), o = _t({
							x: n.left + n.width / 2,
							y: n.top + n.height / 2
						}), f -= r.x - o.x, g -= r.y - o.y), Y.isDragging || (Y.isDragging = !0, oe(Y, "dragstart", "onDragStart"))
					}, this.drag = mt, this.endDrag = function (t) {
						vt(t || Y.pointerEvent, !0)
					}, this.timeSinceDrag = function () {
						return Y.isDragging ? 0 : (Dt() - $) / 1e3
					}, this.timeSinceClick = function () {
						return (Dt() - it) / 1e3
					}, this.hitTest = function (t, e) {
						return _e.hitTest(Y.target, t, e)
					}, this.getDirection = function (t, e) {
						var i, n, r, o, a, s, l = "velocity" === t && St ? t : "object" != typeof t || G ? "start" : "element";
						return "element" === l && (a = be(Y.target), s = be(t)), i = "start" === l ? Y.x - u : "velocity" === l ? St.getVelocity(this.target, H) : a.left + a.width / 2 - (s.left + s.width / 2), G ? 0 > i ? "counter-clockwise" : "clockwise" : (e = e || 2, n = "start" === l ? Y.y - v : "velocity" === l ? St.getVelocity(this.target, j) : a.top + a.height / 2 - (s.top + s.height / 2), r = Math.abs(i / n), o = 1 / e > r ? "" : 0 > i ? "left" : "right", e > r && ("" !== o && (o += "-"), o += 0 > n ? "up" : "down"), o)
					}, this.applyBounds = function (t) {
						var e, i, n, r, o, a;
						if (t && h.bounds !== t) return h.bounds = t, Y.update(!0);
						if (l(!0), rt(), y) {
							if (e = Y.x, i = Y.y, e > _ ? e = _ : b > e && (e = b), i > w ? i = w : T > i && (i = T), (Y.x !== e || Y.y !== i) && (n = !0, Y.x = Y.endX = e, G ? Y.endRotation = e : Y.y = Y.endY = i, A = !0, nt(!0), Y.autoScroll && !Y.isDragging))
								for (te(p.parentNode), r = p, Wt.scrollTop = null != window.pageYOffset ? window.pageYOffset : null != Ot.scrollTop ? Ot.scrollTop : Rt.body.scrollTop, Wt.scrollLeft = null != window.pageXOffset ? window.pageXOffset : null != Ot.scrollLeft ? Ot.scrollLeft : Rt.body.scrollLeft; r && !a;) a = Kt(r.parentNode), o = a ? Wt : r.parentNode, W && o.scrollTop > o._gsMaxScrollY && (o.scrollTop = o._gsMaxScrollY), V && o.scrollLeft > o._gsMaxScrollX && (o.scrollLeft = o._gsMaxScrollX), r = o;
							Y.isThrowing && (n || Y.endX > _ || Y.endX < b || Y.endY > w || Y.endY < T) && st(h.throwProps, n)
						}
						return Y
					}, this.update = function (t, e, i) {
						var n = Y.x,
							r = Y.y;
						return lt(!e), t ? Y.applyBounds() : (A && i && nt(!0), l(!0)), e && (gt(Y.pointerX, Y.pointerY), A && nt(!0)), Y.isPressed && !e && (V && Math.abs(n - Y.x) > .01 || W && Math.abs(r - Y.y) > .01 && !G) && ct(), Y.autoScroll && (te(p.parentNode), Z = Y.isDragging, nt(!0)), Y.autoScroll && (Qt(p, yt), Jt(p, yt)), Y
					}, this.enable = function (t) {
						var e, i, n;
						if ("soft" !== t) {
							for (i = q.length; --i > -1;) n = q[i], de(n, "mousedown", pt), de(n, "touchstart", pt), de(n, "click", xt, !0), G || ne(n, "cursor", h.cursor || "move"), ne(n, "touchCallout", "none"), ne(n, "touchAction", V === W ? "none" : V ? "pan-y" : "pan-x"), se(n) && ne(n.ownerSVGElement || n, "touchAction", V === W ? "none" : V ? "pan-y" : "pan-x"), this.vars.allowContextMenu || de(n, "contextmenu", s);
							ye(q, !1)
						}
						return Jt(p, yt), d = !0, St && "soft" !== t && St.track(m || p, z ? "x,y" : G ? "rotation" : "top,left"), m && m.enable(), p._gsDragID = e = "d" + zt++, Ut[e] = this, m && (m.element._gsDragID = e), wt.set(p, {
							x: "+=0",
							overwrite: !1,
							data: "_draggable"
						}), I = {
							t: p,
							data: Ft ? o : p._gsTransform,
							tween: {},
							setRatio: Ft ? function () {
								wt.set(p, r)
							} : Tt._internals.setTransformRatio || Tt._internals.set3DTransformRatio
						}, ct(), Y.update(!0), Y
					}, this.disable = function (t) {
						var e, i, n = Y.isDragging;
						if (!G)
							for (e = q.length; --e > -1;) ne(q[e], "cursor", null);
						if ("soft" !== t) {
							for (e = q.length; --e > -1;) i = q[e], ne(i, "touchCallout", null), ne(i, "touchAction", null), fe(i, "mousedown", pt), fe(i, "touchstart", pt), fe(i, "click", xt), fe(i, "contextmenu", s);
							ye(q, !0), O && (fe(O, "touchcancel", vt), fe(O, "touchend", vt), fe(O, "touchmove", mt)), fe(Rt, "mouseup", vt), fe(Rt, "mousemove", mt)
						}
						return Qt(p, yt), d = !1, St && "soft" !== t && St.untrack(m || p, z ? "x,y" : G ? "rotation" : "top,left"), m && m.disable(), $t(nt), Y.isDragging = Y.isPressed = R = !1, n && oe(Y, "dragend", "onDragEnd"), Y
					}, this.enabled = function (t, e) {
						return arguments.length ? t ? Y.enable(e) : Y.disable(e) : d
					}, this.kill = function () {
						return Y.isThrowing = !1, wt.killTweensOf(m || p, !0, a), Y.disable(), delete Ut[p._gsDragID], Y
					}, -1 !== n.indexOf("scroll") && (m = this.scrollProxy = new xe(p, Zt({
						onKill: function () {
							Y.isPressed && vt(null)
						}
					}, h)), p.style.overflowY = W && !ue ? "auto" : "hidden", p.style.overflowX = V && !ue ? "auto" : "hidden", p = m.content), h.force3D !== !1 && wt.set(p, {
						force3D: !0
					}), G ? a.rotation = 1 : (V && (a[H] = 1), W && (a[j] = 1)), G ? (r = Pt, o = r.css, r.overwrite = !1) : z && (r = V && W ? Mt : V ? At : Ct, o = r.css, r.overwrite = !1), this.enable()
				},
				W = _e.prototype = new bt;
			W.constructor = _e, W.pointerX = W.pointerY = W.startX = W.startY = W.deltaX = W.deltaY = 0, W.isDragging = W.isPressed = !1, _e.version = "0.16.3", _e.zIndex = 1e3, de(Rt, "touchcancel", function () {}), de(Rt, "contextmenu", function (t) {
				var e;
				for (e in Ut) Ut[e].isPressed && Ut[e].endDrag()
			}), _e.create = function (t, e) {
				"string" == typeof t && (t = wt.selector(t));
				for (var i = t && 0 !== t.length ? G(t) ? H(t) : [t] : [], n = i.length; --n > -1;) i[n] = new _e(i[n], e);
				return i
			}, _e.get = function (t) {
				return Ut[(ie(t) || {})._gsDragID]
			}, _e.timeSinceDrag = function () {
				return (Dt() - jt) / 1e3
			};
			var X = {},
				Y = function (t) {
					var e, i, n = 0,
						r = 0;
					for (t = ie(t), e = t.offsetWidth, i = t.offsetHeight; t;) n += t.offsetTop, r += t.offsetLeft, t = t.offsetParent;
					return {
						top: n,
						left: r,
						width: e,
						height: i
					}
				},
				be = function (t, e) {
					if (t === window) return X.left = X.top = 0, X.width = X.right = Ot.clientWidth || t.innerWidth || Rt.body.clientWidth || 0, X.height = X.bottom = (t.innerHeight || 0) - 20 < Ot.clientHeight ? Ot.clientHeight : t.innerHeight || Rt.body.clientHeight || 0, X;
					var i = t.pageX !== e ? {
						left: t.pageX - C(),
						top: t.pageY - A(),
						right: t.pageX - C() + 1,
						bottom: t.pageY - A() + 1
					} : t.nodeType || t.left === e || t.top === e ? Ft ? Y(t) : ie(t).getBoundingClientRect() : t;
					return i.right === e && i.width !== e ? (i.right = i.left + i.width, i.bottom = i.top + i.height) : i.width === e && (i = {
						width: i.right - i.left,
						height: i.bottom - i.top,
						right: i.right,
						left: i.left,
						bottom: i.bottom,
						top: i.top
					}), i
				};
			return _e.hitTest = function (t, e, i) {
				if (t === e) return !1;
				var n, r, o, a = be(t),
					s = be(e),
					l = s.left > a.right || s.right < a.left || s.top > a.bottom || s.bottom < a.top;
				return l || !i ? !l : (o = -1 !== (i + "").indexOf("%"), i = parseFloat(i) || 0, n = {
					left: Math.max(a.left, s.left),
					top: Math.max(a.top, s.top)
				}, n.width = Math.min(a.right, s.right) - n.left, n.height = Math.min(a.bottom, s.bottom) - n.top, n.width < 0 || n.height < 0 ? !1 : o ? (i *= .01, r = n.width * n.height, r >= a.width * a.height * i || r >= s.width * s.height * i) : n.width > i && n.height > i)
			}, Bt.style.cssText = "visibility:hidden;height:1px;top:-1px;pointer-events:none;position:relative;clear:both;", _e
		}, !0)
	}), _gsScope._gsDefine && _gsScope._gsQueue.pop()(),
	function (t) {
		"use strict";
		var e = function () {
			return (_gsScope.GreenSockGlobals || _gsScope)[t]
		};
		"undefined" != typeof module && module.exports ? (require("../TweenLite.min.js"), require("../plugins/CSSPlugin.min.js"), module.exports = e()) : "function" == typeof define && define.amd && define(["TweenLite", "CSSPlugin"], e)
	}("Draggable");
var _gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window;
(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function () {
		"use strict";
		var s = (_gsScope.document || {}).documentElement,
			l = _gsScope,
			a = function (t, e) {
				var i = "x" === e ? "Width" : "Height",
					n = "scroll" + i,
					r = "client" + i,
					o = document.body;
				return t === l || t === s || t === o ? Math.max(s[n], o[n]) - (l["inner" + i] || s[r] || o[r]) : t[n] - t["offset" + i]
			},
			c = function (t) {
				return "string" == typeof t && (t = TweenLite.selector(t)), t.length && t !== l && t[0] && t[0].style && !t.nodeType && (t = t[0]), t === l || t.nodeType && t.style ? t : null
			},
			u = function (t, e) {
				var i = "scroll" + ("x" === e ? "Left" : "Top");
				return t === l && (null != t.pageXOffset ? i = "page" + e.toUpperCase() + "Offset" : t = null != s[i] ? s : document.body),
					function () {
						return t[i]
					}
			},
			r = function (t, e) {
				var i = c(t).getBoundingClientRect(),
					n = document.body,
					r = !e || e === l || e === n,
					o = r ? {
						top: s.clientTop - (window.pageYOffset || s.scrollTop || n.scrollTop || 0),
						left: s.clientLeft - (window.pageXOffset || s.scrollLeft || n.scrollLeft || 0)
					} : e.getBoundingClientRect(),
					a = {
						x: i.left - o.left,
						y: i.top - o.top
					};
				return !r && e && (a.x += u(e, "x")(), a.y += u(e, "y")()), a
			},
			n = function (t, e, i) {
				var n = typeof t;
				return isNaN(t) ? "number" === n || "string" === n && "=" === t.charAt(1) ? t : "max" === t ? a(e, i) : Math.min(a(e, i), r(t, e)[i]) : parseFloat(t)
			},
			h = _gsScope._gsDefine.plugin({
				propName: "scrollTo",
				API: 2,
				global: !0,
				version: "1.9.1",
				init: function (t, e, i) {
					return this._wdw = t === l, this._target = t, this._tween = i, "object" != typeof e ? (e = {
						y: e
					}, "string" == typeof e.y && "max" !== e.y && "=" !== e.y.charAt(1) && (e.x = e.y)) : e.nodeType && (e = {
						y: e,
						x: e
					}), this.vars = e, this._autoKill = e.autoKill !== !1, this.getX = u(t, "x"), this.getY = u(t, "y"), this.x = this.xPrev = this.getX(), this.y = this.yPrev = this.getY(), null != e.x ? (this._addTween(this, "x", this.x, n(e.x, t, "x") - (e.offsetX || 0), "scrollTo_x", !0), this._overwriteProps.push("scrollTo_x")) : this.skipX = !0, null != e.y ? (this._addTween(this, "y", this.y, n(e.y, t, "y") - (e.offsetY || 0), "scrollTo_y", !0), this._overwriteProps.push("scrollTo_y")) : this.skipY = !0, !0
				},
				set: function (t) {
					this._super.setRatio.call(this, t);
					var e = this._wdw || !this.skipX ? this.getX() : this.xPrev,
						i = this._wdw || !this.skipY ? this.getY() : this.yPrev,
						n = i - this.yPrev,
						r = e - this.xPrev,
						o = h.autoKillThreshold;
					this.x < 0 && (this.x = 0), this.y < 0 && (this.y = 0), this._autoKill && (!this.skipX && (r > o || -o > r) && e < a(this._target, "x") && (this.skipX = !0), !this.skipY && (n > o || -o > n) && i < a(this._target, "y") && (this.skipY = !0), this.skipX && this.skipY && (this._tween.kill(), this.vars.onAutoKill && this.vars.onAutoKill.apply(this.vars.onAutoKillScope || this._tween, this.vars.onAutoKillParams || []))), this._wdw ? l.scrollTo(this.skipX ? e : this.x, this.skipY ? i : this.y) : (this.skipY || (this._target.scrollTop = this.y), this.skipX || (this._target.scrollLeft = this.x)), this.xPrev = this.x, this.yPrev = this.y
				}
			}),
			t = h.prototype;
		h.max = a, h.getOffset = r, h.buildGetter = u, h.autoKillThreshold = 7, t._kill = function (t) {
			return t.scrollTo_x && (this.skipX = !0), t.scrollTo_y && (this.skipY = !0), this._super._kill.call(this, t)
		}
	}), _gsScope._gsDefine && _gsScope._gsQueue.pop()(),
	function (t) {
		"use strict";
		var e = function () {
			return (_gsScope.GreenSockGlobals || _gsScope)[t]
		};
		"undefined" != typeof module && module.exports ? (require("../TweenLite.min.js"), module.exports = e()) : "function" == typeof define && define.amd && define(["TweenLite"], e)
	}("ScrollToPlugin");
var _gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window;
(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function () {
		"use strict";
		var Y = Math.PI / 180,
			q = 180 / Math.PI,
			b = /[achlmqstvz]|(-?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi,
			S = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi,
			a = /(^[#\.]|[a-y][a-z])/gi,
			c = /[achlmqstvz]/gi,
			w = /[\+\-]?\d*\.?\d+e[\+\-]?\d+/gi,
			d = _gsScope._gsDefine.globals.TweenLite,
			T = function (t) {
				_gsScope.console && console.log(t)
			},
			$ = function (t, e) {
				var i, n, r, o, a, s, l = Math.ceil(Math.abs(e) / 90),
					c = 0,
					u = [];
				for (t *= Y, e *= Y, i = e / l, n = 4 / 3 * Math.sin(i / 2) / (1 + Math.cos(i / 2)), s = 0; l > s; s++) r = t + s * i, o = Math.cos(r), a = Math.sin(r), u[c++] = o - n * a, u[c++] = a + n * o, r += i, o = Math.cos(r), a = Math.sin(r), u[c++] = o + n * a, u[c++] = a - n * o, u[c++] = o, u[c++] = a;
				return u
			},
			E = function (t, e, i, n, r, o, a, s, l) {
				if (t !== s || e !== l) {
					i = Math.abs(i), n = Math.abs(n);
					var c = r % 360 * Y,
						u = Math.cos(c),
						h = Math.sin(c),
						d = (t - s) / 2,
						f = (e - l) / 2,
						p = u * d + h * f,
						m = -h * d + u * f,
						g = i * i,
						v = n * n,
						y = p * p,
						x = m * m,
						_ = y / g + x / v;
					_ > 1 && (i = Math.sqrt(_) * i, n = Math.sqrt(_) * n, g = i * i, v = n * n);
					var b = o === a ? -1 : 1,
						w = (g * v - g * x - v * y) / (g * x + v * y);
					0 > w && (w = 0);
					var T = b * Math.sqrt(w),
						E = T * (i * m / n),
						S = T * -(n * p / i),
						M = (t + s) / 2,
						A = (e + l) / 2,
						C = M + (u * E - h * S),
						P = A + (h * E + u * S),
						L = (p - E) / i,
						R = (m - S) / n,
						O = (-p - E) / i,
						k = (-m - S) / n,
						N = Math.sqrt(L * L + R * R),
						I = L;
					b = 0 > R ? -1 : 1;
					var D = b * Math.acos(I / N) * q;
					N = Math.sqrt((L * L + R * R) * (O * O + k * k)), I = L * O + R * k, b = 0 > L * k - R * O ? -1 : 1;
					var F = b * Math.acos(I / N) * q;
					!a && F > 0 ? F -= 360 : a && 0 > F && (F += 360), F %= 360, D %= 360;
					var B, U, z, G = $(D, F),
						H = u * i,
						j = h * i,
						V = h * -n,
						W = u * n,
						X = G.length - 2;
					for (B = 0; X > B; B += 2) U = G[B], z = G[B + 1], G[B] = U * H + z * V + C, G[B + 1] = U * j + z * W + P;
					return G[G.length - 2] = s, G[G.length - 1] = l, G
				}
			},
			f = function (t) {
				var e, i, n, r, o, a, s, l, c, u, h, d, f, p = (t + "").replace(w, function (t) {
						var e = +t;
						return 1e-4 > e && e > -1e-4 ? 0 : e
					}).match(b) || [],
					m = [],
					g = 0,
					v = 0,
					y = p.length,
					x = 2,
					_ = 0;
				if (!t || !isNaN(p[0]) || isNaN(p[1])) return T("ERROR: malformed path data: " + t), m;
				for (e = 0; y > e; e++)
					if (f = o, isNaN(p[e]) ? (o = p[e].toUpperCase(), a = o !== p[e]) : e--, n = +p[e + 1], r = +p[e + 2], a && (n += g, r += v), 0 === e && (l = n, c = r), "M" === o) s && s.length < 8 && (m.length -= 1, x = 0), g = l = n, v = c = r, s = [n, r], _ += x, x = 2, m.push(s), e += 2, o = "L";
					else if ("C" === o) s || (s = [0, 0]), s[x++] = n, s[x++] = r, a || (g = v = 0), s[x++] = g + 1 * p[e + 3], s[x++] = v + 1 * p[e + 4], s[x++] = g += 1 * p[e + 5], s[x++] = v += 1 * p[e + 6], e += 6;
				else if ("S" === o) "C" === f || "S" === f ? (u = g - s[x - 4], h = v - s[x - 3], s[x++] = g + u, s[x++] = v + h) : (s[x++] = g, s[x++] = v), s[x++] = n, s[x++] = r, a || (g = v = 0), s[x++] = g += 1 * p[e + 3], s[x++] = v += 1 * p[e + 4], e += 4;
				else if ("Q" === o) u = n - g, h = r - v, s[x++] = g + 2 * u / 3, s[x++] = v + 2 * h / 3, a || (g = v = 0), g += 1 * p[e + 3], v += 1 * p[e + 4], u = n - g, h = r - v, s[x++] = g + 2 * u / 3, s[x++] = v + 2 * h / 3, s[x++] = g, s[x++] = v, e += 4;
				else if ("T" === o) u = g - s[x - 4], h = v - s[x - 3], s[x++] = g + u, s[x++] = v + h, u = g + 1.5 * u - n, h = v + 1.5 * h - r, s[x++] = n + 2 * u / 3, s[x++] = r + 2 * h / 3, s[x++] = g = n, s[x++] = v = r, e += 2;
				else if ("H" === o) r = v, s[x++] = g + (n - g) / 3, s[x++] = v + (r - v) / 3, s[x++] = g + 2 * (n - g) / 3, s[x++] = v + 2 * (r - v) / 3, s[x++] = g = n, s[x++] = r, e += 1;
				else if ("V" === o) r = n, n = g, a && (r += v - g), s[x++] = n, s[x++] = v + (r - v) / 3, s[x++] = n, s[x++] = v + 2 * (r - v) / 3, s[x++] = n, s[x++] = v = r, e += 1;
				else if ("L" === o || "Z" === o) "Z" === o && (n = l, r = c, s.closed = !0), ("L" === o || Math.abs(g - n) > .5 || Math.abs(v - r) > .5) && (s[x++] = g + (n - g) / 3, s[x++] = v + (r - v) / 3, s[x++] = g + 2 * (n - g) / 3, s[x++] = v + 2 * (r - v) / 3, s[x++] = n, s[x++] = r, "L" === o && (e += 2)), g = n, v = r;
				else if ("A" === o) {
					if (d = E(g, v, 1 * p[e + 1], 1 * p[e + 2], 1 * p[e + 3], 1 * p[e + 4], 1 * p[e + 5], (a ? g : 0) + 1 * p[e + 6], (a ? v : 0) + 1 * p[e + 7]))
						for (i = 0; i < d.length; i++) s[x++] = d[i];
					g = s[x - 2], v = s[x - 1], e += 7
				} else T("Error: malformed path data: " + t);
				return m.totalPoints = _ + x, m
			},
			M = function (t, e) {
				var i, n, r, o, a, s, l, c, u, h, d, f, p, m, g = 0,
					v = .999999,
					y = t.length,
					x = e / ((y - 2) / 6);
				for (p = 2; y > p; p += 6)
					for (g += x; g > v;) i = t[p - 2], n = t[p - 1], r = t[p], o = t[p + 1], a = t[p + 2], s = t[p + 3], l = t[p + 4], c = t[p + 5], m = 1 / (Math.floor(g) + 1), u = i + (r - i) * m, d = r + (a - r) * m, u += (d - u) * m, d += (a + (l - a) * m - d) * m, h = n + (o - n) * m, f = o + (s - o) * m, h += (f - h) * m, f += (s + (c - s) * m - f) * m, t.splice(p, 4, i + (r - i) * m, n + (o - n) * m, u, h, u + (d - u) * m, h + (f - h) * m, d, f, a + (l - a) * m, s + (c - s) * m), p += 6, y += 6, g--;
				return t
			},
			s = function (t) {
				var e, i, n, r, o = "",
					a = t.length,
					s = 100;
				for (i = 0; a > i; i++) {
					for (r = t[i], o += "M" + r[0] + "," + r[1] + " C", e = r.length, n = 2; e > n; n++) o += (r[n++] * s | 0) / s + "," + (r[n++] * s | 0) / s + " " + (r[n++] * s | 0) / s + "," + (r[n++] * s | 0) / s + " " + (r[n++] * s | 0) / s + "," + (r[n] * s | 0) / s + " ";
					r.closed && (o += "z")
				}
				return o
			},
			A = function (t) {
				for (var e = [], i = t.length - 1, n = 0; --i > -1;) e[n++] = t[i], e[n++] = t[i + 1], i--;
				for (i = 0; n > i; i++) t[i] = e[i];
				t.reversed = t.reversed ? !1 : !0
			},
			p = function (t) {
				var e, i = t.length,
					n = 0,
					r = 0;
				for (e = 0; i > e; e++) n += t[e++], r += t[e];
				return [n / (i / 2), r / (i / 2)]
			},
			C = function (t) {
				var e, i, n, r = t.length,
					o = t[0],
					a = o,
					s = t[1],
					l = s;
				for (n = 6; r > n; n += 6) e = t[n], i = t[n + 1], e > o ? o = e : a > e && (a = e), i > s ? s = i : l > i && (l = i);
				return t.centerX = (o + a) / 2, t.centerY = (s + l) / 2, t.size = (o - a) * (s - l)
			},
			P = function (t) {
				for (var e, i, n, r, o, a = t.length, s = t[0][0], l = s, c = t[0][1], u = c; --a > -1;)
					for (o = t[a], e = o.length, r = 6; e > r; r += 6) i = o[r], n = o[r + 1], i > s ? s = i : l > i && (l = i), n > c ? c = n : u > n && (u = n);
				return t.centerX = (s + l) / 2, t.centerY = (c + u) / 2, t.size = (s - l) * (c - u)
			},
			L = function (t, e) {
				return e.length - t.length
			},
			R = function (t, e) {
				var i = t.size || C(t),
					n = e.size || C(e);
				return Math.abs(n - i) < (i + n) / 20 ? e.centerX - t.centerX || e.centerY - t.centerY : n - i
			},
			O = function (t, e) {
				var i, n, r = t.slice(0),
					o = t.length,
					a = o - 2;
				for (e = 0 | e, i = 0; o > i; i++) n = (i + e) % a, t[i++] = r[n], t[i] = r[n + 1]
			},
			m = function (t, e, i, n, r) {
				var o, a, s, l, c = t.length,
					u = 0,
					h = c - 2;
				for (i *= 6, a = 0; c > a; a += 6) o = (a + i) % h, l = t[o] - (e[a] - n), s = t[o + 1] - (e[a + 1] - r), u += Math.sqrt(s * s + l * l);
				return u
			},
			k = function (t, e, i) {
				var n, r, o, a = t.length,
					s = p(t),
					l = p(e),
					c = l[0] - s[0],
					u = l[1] - s[1],
					h = m(t, e, 0, c, u),
					d = 0;
				for (o = 6; a > o; o += 6) r = m(t, e, o / 6, c, u), h > r && (h = r, d = o);
				if (i)
					for (n = t.slice(0), A(n), o = 6; a > o; o += 6) r = m(n, e, o / 6, c, u), h > r && (h = r, d = -o);
				return d / 6
			},
			N = function (t, e, i) {
				for (var n, r, o, a, s, l, c = t.length, u = 99999999999, h = 0, d = 0; --c > -1;)
					for (n = t[c], l = n.length, s = 0; l > s; s += 6) r = n[s] - e, o = n[s + 1] - i, a = Math.sqrt(r * r + o * o), u > a && (u = a, h = n[s], d = n[s + 1]);
				return [h, d]
			},
			I = function (t, e, i, n, r, o) {
				var a, s, l, c, u, h = e.length,
					d = 0,
					f = Math.min(t.size || C(t), e[i].size || C(e[i])) * n,
					p = 999999999999,
					m = t.centerX + r,
					g = t.centerY + o;
				for (s = i; h > s && (a = e[s].size || C(e[s]), !(f > a)); s++) l = e[s].centerX - m, c = e[s].centerY - g, u = Math.sqrt(l * l + c * c), p > u && (d = s, p = u);
				return u = e[d], e.splice(d, 1), u
			},
			l = function (t, e, i, n) {
				var r, o, a, s, l, c, u, h = e.length - t.length,
					d = h > 0 ? e : t,
					f = h > 0 ? t : e,
					p = 0,
					m = "complexity" === n ? L : R,
					g = "position" === n ? 0 : "number" == typeof n ? n : .8,
					v = f.length,
					y = "object" == typeof i && i.push ? i.slice(0) : [i],
					x = "reverse" === y[0] || y[0] < 0,
					_ = "log" === i;
				if (f[0]) {
					if (d.length > 1 && (t.sort(m), e.sort(m), c = d.size || P(d), c = f.size || P(f), c = d.centerX - f.centerX, u = d.centerY - f.centerY, m === R))
						for (v = 0; v < f.length; v++) d.splice(v, 0, I(f[v], d, v, g, c, u));
					if (h)
						for (0 > h && (h = -h), d[0].length > f[0].length && M(f[0], (d[0].length - f[0].length) / 6 | 0), v = f.length; h > p;) s = d[v].size || C(d[v]), a = N(f, d[v].centerX, d[v].centerY), s = a[0], l = a[1], f[v++] = [s, l, s, l, s, l, s, l], f.totalPoints += 8, p++;
					for (v = 0; v < t.length; v++) r = e[v], o = t[v], h = r.length - o.length, 0 > h ? M(r, -h / 6 | 0) : h > 0 && M(o, h / 6 | 0), x && !o.reversed && A(o), i = y[v] || 0 === y[v] ? y[v] : "auto", i && (o.closed || Math.abs(o[0] - o[o.length - 2]) < .5 && Math.abs(o[1] - o[o.length - 1]) < .5 ? "auto" === i || "log" === i ? (y[v] = i = k(o, r, 0 === v), 0 > i && (x = !0, A(o), i = -i), O(o, 6 * i)) : "reverse" !== i && (v && 0 > i && A(o), O(o, 6 * (0 > i ? -i : i))) : !x && ("auto" === i && Math.abs(r[0] - o[0]) + Math.abs(r[1] - o[1]) + Math.abs(r[r.length - 2] - o[o.length - 2]) + Math.abs(r[r.length - 1] - o[o.length - 1]) > Math.abs(r[0] - o[o.length - 2]) + Math.abs(r[1] - o[o.length - 1]) + Math.abs(r[r.length - 2] - o[0]) + Math.abs(r[r.length - 1] - o[1]) || i % 2) ? (A(o), y[v] = -1, x = !0) : "auto" === i ? y[v] = 0 : "reverse" === i && (y[v] = -1), o.closed !== r.closed && (o.closed = r.closed = !1));
					return _ && T("shapeIndex:[" + y.join(",") + "]"), y
				}
			},
			r = function (t, e, i, n) {
				var r = f(t[0]),
					o = f(t[1]);
				l(r, o, e || 0 === e ? e : "auto", i) && (t[0] = s(r), t[1] = s(o), ("log" === n || n === !0) && T('precompile:["' + t[0] + '","' + t[1] + '"]'))
			},
			u = function (e, i, n) {
				return i || n || e || 0 === e ? function (t) {
					r(t, e, i, n)
				} : r
			},
			i = function (t, e) {
				if (!e) return t;
				var i, n, r, o = t.match(S) || [],
					a = o.length,
					s = "";
				for ("reverse" === e ? (n = a - 1, i = -2) : (n = (2 * (parseInt(e, 10) || 0) + 1 + 100 * a) % a, i = 2), r = 0; a > r; r += 2) s += o[n - 1] + "," + o[n] + " ", n = (n + i) % a;
				return s
			},
			o = function (t, e) {
				var i, n, r, o, a, s, l, c = 0,
					u = parseFloat(t[0]),
					h = parseFloat(t[1]),
					d = u + "," + h + " ",
					f = .999999;
				for (r = t.length, i = .5 * e / (.5 * r - 1), n = 0; r - 2 > n; n += 2) {
					if (c += i, s = parseFloat(t[n + 2]), l = parseFloat(t[n + 3]), c > f)
						for (a = 1 / (Math.floor(c) + 1), o = 1; c > f;) d += (u + (s - u) * a * o).toFixed(2) + "," + (h + (l - h) * a * o).toFixed(2) + " ", c--, o++;
					d += s + "," + l + " ", u = s, h = l
				}
				return d
			},
			n = function (t) {
				var e = t[0].match(S) || [],
					i = t[1].match(S) || [],
					n = i.length - e.length;
				n > 0 ? t[0] = o(e, n) : t[1] = o(i, -n)
			},
			h = function (e) {
				return isNaN(e) ? n : function (t) {
					n(t), t[1] = i(t[1], parseInt(e, 10))
				}
			},
			D = function (t, e) {
				var i, n = _gsScope.document.createElementNS("http://www.w3.org/2000/svg", "path"),
					r = Array.prototype.slice.call(t.attributes),
					o = r.length;
				for (e = "," + e + ","; --o > -1;) i = r[o].nodeName.toLowerCase(), -1 === e.indexOf("," + i + ",") && n.setAttributeNS(null, i, r[o].nodeValue);
				return n
			},
			g = function (t, e) {
				var i, n, r, o, a, s, l, c, u, h, d, f, p, m, g, v, y, x, _, b, w, T = t.tagName.toLowerCase(),
					E = .552284749831;
				return "path" !== T && t.getBBox ? (s = D(t, "x,y,width,height,cx,cy,rx,ry,r,x1,x2,y1,y2,points"), "rect" === T ? (o = +t.getAttribute("rx") || 0, a = +t.getAttribute("ry") || 0, n = +t.getAttribute("x") || 0, r = +t.getAttribute("y") || 0, h = (+t.getAttribute("width") || 0) - 2 * o, d = (+t.getAttribute("height") || 0) - 2 * a, o || a ? (f = n + o * (1 - E), p = n + o, m = p + h, g = m + o * E, v = m + o, y = r + a * (1 - E), x = r + a, _ = x + d, b = _ + a * E, w = _ + a, i = "M" + v + "," + x + " V" + _ + " C" + [v, b, g, w, m, w, m - (m - p) / 3, w, p + (m - p) / 3, w, p, w, f, w, n, b, n, _, n, _ - (_ - x) / 3, n, x + (_ - x) / 3, n, x, n, y, f, r, p, r, p + (m - p) / 3, r, m - (m - p) / 3, r, m, r, g, r, v, y, v, x].join(",") + "z") : i = "M" + (n + h) + "," + r + " v" + d + " h" + -h + " v" + -d + " h" + h + "z") : "circle" === T || "ellipse" === T ? ("circle" === T ? (o = a = +t.getAttribute("r") || 0, c = o * E) : (o = +t.getAttribute("rx") || 0, a = +t.getAttribute("ry") || 0, c = a * E), n = +t.getAttribute("cx") || 0, r = +t.getAttribute("cy") || 0, l = o * E, i = "M" + (n + o) + "," + r + " C" + [n + o, r + c, n + l, r + a, n, r + a, n - l, r + a, n - o, r + c, n - o, r, n - o, r - c, n - l, r - a, n, r - a, n + l, r - a, n + o, r - c, n + o, r].join(",") + "z") : "line" === T ? i = "M" + (t.getAttribute("x1") || 0) + "," + (t.getAttribute("y1") || 0) + " L" + (t.getAttribute("x2") || 0) + "," + (t.getAttribute("y2") || 0) : ("polyline" === T || "polygon" === T) && (u = (t.getAttribute("points") + "").match(S) || [], n = u.shift(), r = u.shift(), i = "M" + n + "," + r + " L" + u.join(","), "polygon" === T && (i += "," + n + "," + r + "z")), s.setAttribute("d", i), e && t.parentNode && (t.parentNode.insertBefore(s, t), t.parentNode.removeChild(t)), s) : t
			},
			v = function (t, e, i) {
				var n, r, o = "string" == typeof t;
				return (!o || a.test(t) || (t.match(S) || []).length < 3) && (n = o ? d.selector(t) : t && t[0] ? t : [t], n && n[0] ? (n = n[0], r = n.nodeName.toUpperCase(), e && "PATH" !== r && (n = g(n, !1), r = "PATH"), t = n.getAttribute("PATH" === r ? "d" : "points") || "", n === i && (t = n.getAttributeNS(null, "data-original") || t)) : (T("WARNING: invalid morph to: " + t), t = !1)), t
			},
			y = "Use MorphSVGPlugin.convertToPath(elementOrSelectorText) to convert to a path before morphing.",
			x = _gsScope._gsDefine.plugin({
				propName: "morphSVG",
				API: 2,
				global: !0,
				version: "0.8.11",
				init: function (t, e, i, n) {
					var r, o, a, s, l;
					return "function" != typeof t.setAttribute ? !1 : ("function" == typeof e && (e = e(n, t)), r = t.nodeName.toUpperCase(), l = "POLYLINE" === r || "POLYGON" === r, "PATH" === r || l ? (o = "PATH" === r ? "d" : "points", ("string" == typeof e || e.getBBox || e[0]) && (e = {
						shape: e
					}), s = v(e.shape || e.d || e.points || "", "d" === o, t), l && c.test(s) ? (T("WARNING: a <" + r + "> cannot accept path data. " + y), !1) : (s && (this._target = t, t.getAttributeNS(null, "data-original") || t.setAttributeNS(null, "data-original", t.getAttribute(o)), a = this._addTween(t, "setAttribute", t.getAttribute(o) + "", s + "", "morphSVG", !1, o, "object" == typeof e.precompile ? function (t) {
						t[0] = e.precompile[0], t[1] = e.precompile[1]
					} : "d" === o ? u(e.shapeIndex, e.map || x.defaultMap, e.precompile) : h(e.shapeIndex)), a && (this._overwriteProps.push("morphSVG"), a.end = s, a.endProp = o)), !0)) : (T("WARNING: cannot morph a <" + r + "> SVG element. " + y), !1))
				},
				set: function (t) {
					var e;
					if (this._super.setRatio.call(this, t), 1 === t)
						for (e = this._firstPT; e;) e.end && this._target.setAttribute(e.endProp, e.end), e = e._next
				}
			});
		x.pathFilter = r, x.pointsFilter = n, x.subdivideRawBezier = M, x.defaultMap = "size", x.pathDataToRawBezier = function (t) {
			return f(v(t, !0))
		}, x.equalizeSegmentQuantity = l, x.convertToPath = function (t, e) {
			"string" == typeof t && (t = d.selector(t));
			for (var i = t && 0 !== t.length ? t.length && t[0] && t[0].nodeType ? Array.prototype.slice.call(t, 0) : [t] : [], n = i.length; --n > -1;) i[n] = g(i[n], e !== !1);
			return i
		}, x.pathDataToBezier = function (t, e) {
			var i, n, r, o, a, s, l, c, u = f(v(t, !0))[0] || [],
				h = 0;
			if (e = e || {}, c = e.align || e.relative, o = e.matrix || [1, 0, 0, 1, 0, 0], a = e.offsetX || 0, s = e.offsetY || 0, "relative" === c || c === !0 ? (a -= u[0] * o[0] + u[1] * o[2], s -= u[0] * o[1] + u[1] * o[3], h = "+=") : (a += o[4], s += o[5], c && (c = "string" == typeof c ? d.selector(c) : c && c[0] ? c : [c], c && c[0] && (l = c[0].getBBox() || {
					x: 0,
					y: 0
				}, a -= l.x, s -= l.y))), i = [], r = u.length, o && "1,0,0,1,0,0" !== o.join(","))
				for (n = 0; r > n; n += 2) i.push({
					x: h + (u[n] * o[0] + u[n + 1] * o[2] + a),
					y: h + (u[n] * o[1] + u[n + 1] * o[3] + s)
				});
			else
				for (n = 0; r > n; n += 2) i.push({
					x: h + (u[n] + a),
					y: h + (u[n + 1] + s)
				});
			return i
		}
	}), _gsScope._gsDefine && _gsScope._gsQueue.pop()(),
	function (t) {
		"use strict";
		var e = function () {
			return (_gsScope.GreenSockGlobals || _gsScope)[t]
		};
		"undefined" != typeof module && module.exports ? (require("../TweenLite.min.js"), module.exports = e()) : "function" == typeof define && define.amd && define(["TweenLite"], e)
	}("MorphSVGPlugin");
var _gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window;
! function (i) {
	"use strict";
	var r = i.GreenSockGlobals || i,
		t = function (t) {
			var e, i = t.split("."),
				n = r;
			for (e = 0; e < i.length; e++) n[i[e]] = n = n[i[e]] || {};
			return n
		},
		e = t("com.greensock.utils"),
		T = function (t) {
			var e = t.nodeType,
				i = "";
			if (1 === e || 9 === e || 11 === e) {
				if ("string" == typeof t.textContent) return t.textContent;
				for (t = t.firstChild; t; t = t.nextSibling) i += T(t)
			} else if (3 === e || 4 === e) return t.nodeValue;
			return i
		},
		G = document,
		H = G.defaultView ? G.defaultView.getComputedStyle : function () {},
		o = /([A-Z])/g,
		j = function (t, e, i, n) {
			var r;
			return (i = i || H(t, null)) ? (t = i.getPropertyValue(e.replace(o, "-$1").toLowerCase()), r = t || i.length ? t : i[e]) : t.currentStyle && (i = t.currentStyle, r = i[e]), n ? r : parseInt(r, 10) || 0
		},
		a = function (t) {
			return t.length && t[0] && (t[0].nodeType && t[0].style && !t.nodeType || t[0].length && t[0][0]) ? !0 : !1
		},
		n = function (t) {
			var e, i, n, r = [],
				o = t.length;
			for (e = 0; o > e; e++)
				if (i = t[e], a(i))
					for (n = i.length, n = 0; n < i.length; n++) r.push(i[n]);
				else r.push(i);
			return r
		},
		E = /(?:\r|\n|\t\t)/g,
		S = /(?:\s\s+)/g,
		M = 55296,
		A = 56319,
		s = 56320,
		C = 127462,
		P = 127487,
		L = 127995,
		R = 127999,
		O = function (t) {
			return (t.charCodeAt(0) - M << 10) + (t.charCodeAt(1) - s) + 65536
		},
		l = G.all && !G.addEventListener,
		c = " style='position:relative;display:inline-block;" + (l ? "*display:inline;*zoom:1;'" : "'"),
		u = function (t, e) {
			t = t || "";
			var i = -1 !== t.indexOf("++"),
				n = 1;
			return i && (t = t.split("++").join("")),
				function () {
					return "<" + e + c + (t ? " class='" + t + (i ? n++ : "") + "'>" : ">")
				}
		},
		h = e.SplitText = r.SplitText = function (t, e) {
			if ("string" == typeof t && (t = h.selector(t)), !t) throw "cannot split a null element.";
			this.elements = a(t) ? n(t) : [t], this.chars = [], this.words = [], this.lines = [], this._originals = [], this.vars = e || {}, this.split(e)
		},
		V = function (t, e, i) {
			var n = t.nodeType;
			if (1 === n || 9 === n || 11 === n)
				for (t = t.firstChild; t; t = t.nextSibling) V(t, e, i);
			else(3 === n || 4 === n) && (t.nodeValue = t.nodeValue.split(e).join(i))
		},
		W = function (t, e) {
			for (var i = e.length; --i > -1;) t.push(e[i])
		},
		d = function (t) {
			var e, i = [],
				n = t.length;
			for (e = 0; e !== n; i.push(t[e++]));
			return i
		},
		X = function (t, e, i) {
			for (var n; t && t !== e;) {
				if (n = t._next || t.nextSibling) return n.textContent.charAt(0) === i;
				t = t.parentNode || t._parent
			}
			return !1
		},
		Y = function (t) {
			var e, i, n = d(t.childNodes),
				r = n.length;
			for (e = 0; r > e; e++) i = n[e], i._isSplit ? Y(i) : (e && 3 === i.previousSibling.nodeType ? i.previousSibling.nodeValue += 3 === i.nodeType ? i.nodeValue : i.firstChild.nodeValue : 3 !== i.nodeType && t.insertBefore(i.firstChild, i), t.removeChild(i))
		},
		f = function (t, e, i, n, r, o, a) {
			var s, l, c, u, h, d, f, p, m, g, v, y, x = H(t),
				_ = j(t, "paddingLeft", x),
				b = -999,
				w = j(t, "borderBottomWidth", x) + j(t, "borderTopWidth", x),
				T = j(t, "borderLeftWidth", x) + j(t, "borderRightWidth", x),
				E = j(t, "paddingTop", x) + j(t, "paddingBottom", x),
				S = j(t, "paddingLeft", x) + j(t, "paddingRight", x),
				M = .2 * j(t, "fontSize"),
				A = j(t, "textAlign", x, !0),
				C = [],
				P = [],
				L = [],
				R = e.wordDelimiter || " ",
				O = e.span ? "span" : "div",
				k = e.type || e.split || "chars,words,lines",
				N = r && -1 !== k.indexOf("lines") ? [] : null,
				I = -1 !== k.indexOf("words"),
				D = -1 !== k.indexOf("chars"),
				F = "absolute" === e.position || e.absolute === !0,
				B = e.linesClass,
				U = -1 !== (B || "").indexOf("++"),
				z = [];
			for (N && 1 === t.children.length && t.children[0]._isSplit && (t = t.children[0]), U && (B = B.split("++").join("")), l = t.getElementsByTagName("*"), c = l.length, h = [], s = 0; c > s; s++) h[s] = l[s];
			if (N || F)
				for (s = 0; c > s; s++) u = h[s], d = u.parentNode === t, (d || F || D && !I) && (y = u.offsetTop, N && d && Math.abs(y - b) > M && ("BR" !== u.nodeName || 0 === s) && (f = [], N.push(f), b = y), F && (u._x = u.offsetLeft, u._y = y, u._w = u.offsetWidth, u._h = u.offsetHeight), N && ((u._isSplit && d || !D && d || I && d || !I && u.parentNode.parentNode === t && !u.parentNode._isSplit) && (f.push(u), u._x -= _, X(u, t, R) && (u._wordEnd = !0)), "BR" === u.nodeName && (u.nextSibling && "BR" === u.nextSibling.nodeName || 0 === s) && N.push([])));
			for (s = 0; c > s; s++) u = h[s], d = u.parentNode === t, "BR" !== u.nodeName ? (F && (m = u.style, I || d || (u._x += u.parentNode._x, u._y += u.parentNode._y), m.left = u._x + "px", m.top = u._y + "px", m.position = "absolute", m.display = "block", m.width = u._w + 1 + "px", m.height = u._h + "px"), !I && D ? u._isSplit ? (u._next = u.nextSibling, u.parentNode.appendChild(u)) : u.parentNode._isSplit ? (u._parent = u.parentNode, !u.previousSibling && u.firstChild && (u.firstChild._isFirst = !0), u.nextSibling && " " === u.nextSibling.textContent && !u.nextSibling.nextSibling && z.push(u.nextSibling), u._next = u.nextSibling && u.nextSibling._isFirst ? null : u.nextSibling, u.parentNode.removeChild(u), h.splice(s--, 1), c--) : d || (y = !u.nextSibling && X(u.parentNode, t, R), u.parentNode._parent && u.parentNode._parent.appendChild(u), y && u.parentNode.appendChild(G.createTextNode(" ")), e.span && (u.style.display = "inline"), C.push(u)) : u.parentNode._isSplit && !u._isSplit && "" !== u.innerHTML ? P.push(u) : D && !u._isSplit && (e.span && (u.style.display = "inline"), C.push(u))) : N || F ? (u.parentNode && u.parentNode.removeChild(u), h.splice(s--, 1), c--) : I || t.appendChild(u);
			for (s = z.length; --s > -1;) z[s].parentNode.removeChild(z[s]);
			if (N) {
				for (F && (g = G.createElement(O), t.appendChild(g), v = g.offsetWidth + "px", y = g.offsetParent === t ? 0 : t.offsetLeft, t.removeChild(g)), m = t.style.cssText, t.style.cssText = "display:none;"; t.firstChild;) t.removeChild(t.firstChild);
				for (p = " " === R && (!F || !I && !D), s = 0; s < N.length; s++) {
					for (f = N[s], g = G.createElement(O), g.style.cssText = "display:block;text-align:" + A + ";position:" + (F ? "absolute;" : "relative;"), B && (g.className = B + (U ? s + 1 : "")), L.push(g), c = f.length, l = 0; c > l; l++) "BR" !== f[l].nodeName && (u = f[l], g.appendChild(u), p && u._wordEnd && g.appendChild(G.createTextNode(" ")), F && (0 === l && (g.style.top = u._y + "px", g.style.left = _ + y + "px"), u.style.top = "0px", y && (u.style.left = u._x - y + "px")));
					0 === c ? g.innerHTML = "&nbsp;" : I || D || (Y(g), V(g, String.fromCharCode(160), " ")), F && (g.style.width = v, g.style.height = u._h + "px"), t.appendChild(g)
				}
				t.style.cssText = m
			}
			F && (a > t.clientHeight && (t.style.height = a - E + "px", t.clientHeight < a && (t.style.height = a + w + "px")), o > t.clientWidth && (t.style.width = o - S + "px", t.clientWidth < o && (t.style.width = o + T + "px"))), W(i, C), W(n, P), W(r, L)
		},
		p = function (t, e, i, n) {
			var r, o, a, s, l, c, u, h, d, f = e.span ? "span" : "div",
				p = e.type || e.split || "chars,words,lines",
				m = -1 !== p.indexOf("chars"),
				g = "absolute" === e.position || e.absolute === !0,
				v = e.wordDelimiter || " ",
				y = " " !== v ? "" : g ? "&#173; " : " ",
				x = e.span ? "</span>" : "</div>",
				_ = !0,
				b = G.createElement("div"),
				w = t.parentNode;
			for (w.insertBefore(b, t), b.textContent = t.nodeValue, w.removeChild(t), t = b, r = T(t), u = -1 !== r.indexOf("<"), e.reduceWhiteSpace !== !1 && (r = r.replace(S, " ").replace(E, "")), u && (r = r.split("<").join("{{LT}}")), l = r.length, o = (" " === r.charAt(0) ? y : "") + i(), a = 0; l > a; a++)
				if (c = r.charAt(a), c === v && r.charAt(a - 1) !== v && a) {
					for (o += _ ? x : "", _ = !1; r.charAt(a + 1) === v;) o += y, a++;
					a === l - 1 ? o += y : ")" !== r.charAt(a + 1) && (o += y + i(), _ = !0)
				} else "{" === c && "{{LT}}" === r.substr(a, 6) ? (o += m ? n() + "{{LT}}</" + f + ">" : "{{LT}}", a += 5) : c.charCodeAt(0) >= M && c.charCodeAt(0) <= A || r.charCodeAt(a + 1) >= 65024 && r.charCodeAt(a + 1) <= 65039 ? (h = O(r.substr(a, 2)), d = O(r.substr(a + 2, 2)), s = h >= C && P >= h && d >= C && P >= d || d >= L && R >= d ? 4 : 2, o += m && " " !== c ? n() + r.substr(a, s) + "</" + f + ">" : r.substr(a, s), a += s - 1) : o += m && " " !== c ? n() + c + "</" + f + ">" : c;
			t.outerHTML = o + (_ ? x : ""), u && V(w, "{{LT}}", "<")
		},
		m = function (t, e, i, n) {
			var r, o, a = d(t.childNodes),
				s = a.length,
				l = "absolute" === e.position || e.absolute === !0;
			if (3 !== t.nodeType || s > 1) {
				for (e.absolute = !1, r = 0; s > r; r++) o = a[r], (3 !== o.nodeType || /\S+/.test(o.nodeValue)) && (l && 3 !== o.nodeType && "inline" === j(o, "display", null, !0) && (o.style.display = "inline-block", o.style.position = "relative"), o._isSplit = !0, m(o, e, i, n));
				return e.absolute = l, void(t._isSplit = !0)
			}
			p(t, e, i, n)
		},
		g = h.prototype;
	g.split = function (t) {
		this.isSplit && this.revert(), this.vars = t = t || this.vars, this._originals.length = this.chars.length = this.words.length = this.lines.length = 0;
		for (var e, i, n, r = this.elements.length, o = t.span ? "span" : "div", a = u(t.wordsClass, o), s = u(t.charsClass, o); --r > -1;) n = this.elements[r], this._originals[r] = n.innerHTML, e = n.clientHeight, i = n.clientWidth, m(n, t, a, s), f(n, t, this.chars, this.words, this.lines, i, e);
		return this.chars.reverse(), this.words.reverse(), this.lines.reverse(), this.isSplit = !0, this
	}, g.revert = function () {
		if (!this._originals) throw "revert() call wasn't scoped properly.";
		for (var t = this._originals.length; --t > -1;) this.elements[t].innerHTML = this._originals[t];
		return this.chars = [], this.words = [], this.lines = [], this.isSplit = !1, this
	}, h.selector = i.$ || i.jQuery || function (t) {
		var e = i.$ || i.jQuery;
		return e ? (h.selector = e, e(t)) : "undefined" == typeof document ? t : document.querySelectorAll ? document.querySelectorAll(t) : document.getElementById("#" === t.charAt(0) ? t.substr(1) : t)
	}, h.version = "0.5.8"
}(_gsScope),
function (t) {
	"use strict";
	var e = function () {
		return (_gsScope.GreenSockGlobals || _gsScope)[t]
	};
	"undefined" != typeof module && module.exports ? module.exports = e() : "function" == typeof define && define.amd && define([], e)
}("SplitText");
! function (t, e) {
	"function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", e) : "object" == typeof module && module.exports ? module.exports = e() : t.EvEmitter = e()
}("undefined" != typeof window ? window : this, function () {
	function t() {}
	var e = t.prototype;
	return e.on = function (t, e) {
		if (t && e) {
			var i = this._events = this._events || {},
				n = i[t] = i[t] || [];
			return n.indexOf(e) == -1 && n.push(e), this
		}
	}, e.once = function (t, e) {
		if (t && e) {
			this.on(t, e);
			var i = this._onceEvents = this._onceEvents || {},
				n = i[t] = i[t] || {};
			return n[e] = !0, this
		}
	}, e.off = function (t, e) {
		var i = this._events && this._events[t];
		if (i && i.length) {
			var n = i.indexOf(e);
			return n != -1 && i.splice(n, 1), this
		}
	}, e.emitEvent = function (t, e) {
		var i = this._events && this._events[t];
		if (i && i.length) {
			i = i.slice(0), e = e || [];
			for (var n = this._onceEvents && this._onceEvents[t], r = 0; r < i.length; r++) {
				var o = i[r],
					a = n && n[o];
				a && (this.off(t, o), delete n[o]), o.apply(this, e)
			}
			return this
		}
	}, e.allOff = function () {
		delete this._events, delete this._onceEvents
	}, t
}),
function (e, i) {
	"use strict";
	"function" == typeof define && define.amd ? define(["ev-emitter/ev-emitter"], function (t) {
		return i(e, t)
	}) : "object" == typeof module && module.exports ? module.exports = i(e, require("ev-emitter")) : e.imagesLoaded = i(e, e.EvEmitter)
}("undefined" != typeof window ? window : this, function (e, t) {
	function r(t, e) {
		for (var i in e) t[i] = e[i];
		return t
	}

	function o(t) {
		if (Array.isArray(t)) return t;
		var e = "object" == typeof t && "number" == typeof t.length;
		return e ? c.call(t) : [t]
	}

	function a(t, e, i) {
		if (!(this instanceof a)) return new a(t, e, i);
		var n = t;
		return "string" == typeof t && (n = document.querySelectorAll(t)), n ? (this.elements = o(n), this.options = r({}, this.options), "function" == typeof e ? i = e : r(this.options, e), i && this.on("always", i), this.getImages(), s && (this.jqDeferred = new s.Deferred), void setTimeout(this.check.bind(this))) : void l.error("Bad element for imagesLoaded " + (n || t))
	}

	function i(t) {
		this.img = t
	}

	function n(t, e) {
		this.url = t, this.element = e, this.img = new Image
	}
	var s = e.jQuery,
		l = e.console,
		c = Array.prototype.slice;
	a.prototype = Object.create(t.prototype), a.prototype.options = {}, a.prototype.getImages = function () {
		this.images = [], this.elements.forEach(this.addElementImages, this)
	}, a.prototype.addElementImages = function (t) {
		"IMG" == t.nodeName && this.addImage(t), this.options.background === !0 && this.addElementBackgroundImages(t);
		var e = t.nodeType;
		if (e && u[e]) {
			for (var i = t.querySelectorAll("img"), n = 0; n < i.length; n++) {
				var r = i[n];
				this.addImage(r)
			}
			if ("string" == typeof this.options.background) {
				var o = t.querySelectorAll(this.options.background);
				for (n = 0; n < o.length; n++) {
					var a = o[n];
					this.addElementBackgroundImages(a)
				}
			}
		}
	};
	var u = {
		1: !0,
		9: !0,
		11: !0
	};
	return a.prototype.addElementBackgroundImages = function (t) {
		var e = getComputedStyle(t);
		if (e)
			for (var i = /url\((['"])?(.*?)\1\)/gi, n = i.exec(e.backgroundImage); null !== n;) {
				var r = n && n[2];
				r && this.addBackground(r, t), n = i.exec(e.backgroundImage)
			}
	}, a.prototype.addImage = function (t) {
		var e = new i(t);
		this.images.push(e)
	}, a.prototype.addBackground = function (t, e) {
		var i = new n(t, e);
		this.images.push(i)
	}, a.prototype.check = function () {
		function e(t, e, i) {
			setTimeout(function () {
				n.progress(t, e, i)
			})
		}
		var n = this;
		return this.progressedCount = 0, this.hasAnyBroken = !1, this.images.length ? void this.images.forEach(function (t) {
			t.once("progress", e), t.check()
		}) : void this.complete()
	}, a.prototype.progress = function (t, e, i) {
		this.progressedCount++, this.hasAnyBroken = this.hasAnyBroken || !t.isLoaded, this.emitEvent("progress", [this, t, e]), this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, t), this.progressedCount == this.images.length && this.complete(), this.options.debug && l && l.log("progress: " + i, t, e)
	}, a.prototype.complete = function () {
		var t = this.hasAnyBroken ? "fail" : "done";
		if (this.isComplete = !0, this.emitEvent(t, [this]), this.emitEvent("always", [this]), this.jqDeferred) {
			var e = this.hasAnyBroken ? "reject" : "resolve";
			this.jqDeferred[e](this)
		}
	}, i.prototype = Object.create(t.prototype), i.prototype.check = function () {
		var t = this.getIsImageComplete();
		return t ? void this.confirm(0 !== this.img.naturalWidth, "naturalWidth") : (this.proxyImage = new Image, this.proxyImage.addEventListener("load", this), this.proxyImage.addEventListener("error", this), this.img.addEventListener("load", this), this.img.addEventListener("error", this), void(this.proxyImage.src = this.img.src))
	}, i.prototype.getIsImageComplete = function () {
		return this.img.complete && this.img.naturalWidth
	}, i.prototype.confirm = function (t, e) {
		this.isLoaded = t, this.emitEvent("progress", [this, this.img, e])
	}, i.prototype.handleEvent = function (t) {
		var e = "on" + t.type;
		this[e] && this[e](t)
	}, i.prototype.onload = function () {
		this.confirm(!0, "onload"), this.unbindEvents()
	}, i.prototype.onerror = function () {
		this.confirm(!1, "onerror"), this.unbindEvents()
	}, i.prototype.unbindEvents = function () {
		this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this)
	}, n.prototype = Object.create(i.prototype), n.prototype.check = function () {
		this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.img.src = this.url;
		var t = this.getIsImageComplete();
		t && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), this.unbindEvents())
	}, n.prototype.unbindEvents = function () {
		this.img.removeEventListener("load", this), this.img.removeEventListener("error", this)
	}, n.prototype.confirm = function (t, e) {
		this.isLoaded = t, this.emitEvent("progress", [this, this.element, e])
	}, a.makeJQueryPlugin = function (t) {
		t = t || e.jQuery, t && (s = t, s.fn.imagesLoaded = function (t, e) {
			var i = new a(this, t, e);
			return i.jqDeferred.promise(s(this))
		})
	}, a.makeJQueryPlugin(), a
});
(function () {
	"use strict";

	function l(r, t) {
		var e;
		t = t || {};
		this.trackingClick = false;
		this.trackingClickStart = 0;
		this.targetElement = null;
		this.touchStartX = 0;
		this.touchStartY = 0;
		this.lastTouchIdentifier = 0;
		this.touchBoundary = t.touchBoundary || 10;
		this.layer = r;
		this.tapDelay = t.tapDelay || 200;
		this.tapTimeout = t.tapTimeout || 700;
		if (l.notNeeded(r)) {
			return
		}

		function i(t, e) {
			return function () {
				return t.apply(e, arguments)
			}
		}
		var n = ["onMouse", "onClick", "onTouchStart", "onTouchMove", "onTouchEnd", "onTouchCancel"];
		var o = this;
		for (var a = 0, s = n.length; a < s; a++) {
			o[n[a]] = i(o[n[a]], o)
		}
		if (c) {
			r.addEventListener("mouseover", this.onMouse, true);
			r.addEventListener("mousedown", this.onMouse, true);
			r.addEventListener("mouseup", this.onMouse, true)
		}
		r.addEventListener("click", this.onClick, true);
		r.addEventListener("touchstart", this.onTouchStart, false);
		r.addEventListener("touchmove", this.onTouchMove, false);
		r.addEventListener("touchend", this.onTouchEnd, false);
		r.addEventListener("touchcancel", this.onTouchCancel, false);
		if (!Event.prototype.stopImmediatePropagation) {
			r.removeEventListener = function (t, e, i) {
				var n = Node.prototype.removeEventListener;
				if (t === "click") {
					n.call(r, t, e.hijacked || e, i)
				} else {
					n.call(r, t, e, i)
				}
			};
			r.addEventListener = function (t, e, i) {
				var n = Node.prototype.addEventListener;
				if (t === "click") {
					n.call(r, t, e.hijacked || (e.hijacked = function (t) {
						if (!t.propagationStopped) {
							e(t)
						}
					}), i)
				} else {
					n.call(r, t, e, i)
				}
			}
		}
		if (typeof r.onclick === "function") {
			e = r.onclick;
			r.addEventListener("click", function (t) {
				e(t)
			}, false);
			r.onclick = null
		}
	}
	var t = navigator.userAgent.indexOf("Windows Phone") >= 0;
	var c = navigator.userAgent.indexOf("Android") > 0 && !t;
	var s = /iP(ad|hone|od)/.test(navigator.userAgent) && !t;
	var u = s && /OS 4_\d(_\d)?/.test(navigator.userAgent);
	var h = s && /OS [6-7]_\d/.test(navigator.userAgent);
	var o = navigator.userAgent.indexOf("BB10") > 0;
	l.prototype.needsClick = function (t) {
		switch (t.nodeName.toLowerCase()) {
			case "button":
			case "select":
			case "textarea":
				if (t.disabled) {
					return true
				}
				break;
			case "input":
				if (s && t.type === "file" || t.disabled) {
					return true
				}
				break;
			case "label":
			case "iframe":
			case "video":
				return true
		}
		return /\bneedsclick\b/.test(t.className)
	};
	l.prototype.needsFocus = function (t) {
		switch (t.nodeName.toLowerCase()) {
			case "textarea":
				return true;
			case "select":
				return !c;
			case "input":
				switch (t.type) {
					case "button":
					case "checkbox":
					case "file":
					case "image":
					case "radio":
					case "submit":
						return false
				}
				return !t.disabled && !t.readOnly;
			default:
				return /\bneedsfocus\b/.test(t.className)
		}
	};
	l.prototype.sendClick = function (t, e) {
		var i, n;
		if (document.activeElement && document.activeElement !== t) {
			document.activeElement.blur()
		}
		n = e.changedTouches[0];
		i = document.createEvent("MouseEvents");
		i.initMouseEvent(this.determineEventType(t), true, true, window, 1, n.screenX, n.screenY, n.clientX, n.clientY, false, false, false, false, 0, null);
		i.forwardedTouchEvent = true;
		t.dispatchEvent(i)
	};
	l.prototype.determineEventType = function (t) {
		if (c && t.tagName.toLowerCase() === "select") {
			return "mousedown"
		}
		return "click"
	};
	l.prototype.focus = function (t) {
		var e;
		if (s && t.setSelectionRange && t.type.indexOf("date") !== 0 && t.type !== "time" && t.type !== "month") {
			e = t.value.length;
			t.setSelectionRange(e, e)
		} else {
			t.focus()
		}
	};
	l.prototype.updateScrollParent = function (t) {
		var e, i;
		e = t.fastClickScrollParent;
		if (!e || !e.contains(t)) {
			i = t;
			do {
				if (i.scrollHeight > i.offsetHeight) {
					e = i;
					t.fastClickScrollParent = i;
					break
				}
				i = i.parentElement
			} while (i)
		}
		if (e) {
			e.fastClickLastScrollTop = e.scrollTop
		}
	};
	l.prototype.getTargetElementFromEventTarget = function (t) {
		if (t.nodeType === Node.TEXT_NODE) {
			return t.parentNode
		}
		return t
	};
	l.prototype.onTouchStart = function (t) {
		var e, i, n;
		if (t.targetTouches.length > 1) {
			return true
		}
		e = this.getTargetElementFromEventTarget(t.target);
		i = t.targetTouches[0];
		if (s) {
			n = window.getSelection();
			if (n.rangeCount && !n.isCollapsed) {
				return true
			}
			if (!u) {
				if (i.identifier && i.identifier === this.lastTouchIdentifier) {
					t.preventDefault();
					return false
				}
				this.lastTouchIdentifier = i.identifier;
				this.updateScrollParent(e)
			}
		}
		this.trackingClick = true;
		this.trackingClickStart = t.timeStamp;
		this.targetElement = e;
		this.touchStartX = i.pageX;
		this.touchStartY = i.pageY;
		if (t.timeStamp - this.lastClickTime < this.tapDelay) {
			t.preventDefault()
		}
		return true
	};
	l.prototype.touchHasMoved = function (t) {
		var e = t.changedTouches[0],
			i = this.touchBoundary;
		if (Math.abs(e.pageX - this.touchStartX) > i || Math.abs(e.pageY - this.touchStartY) > i) {
			return true
		}
		return false
	};
	l.prototype.onTouchMove = function (t) {
		if (!this.trackingClick) {
			return true
		}
		if (this.targetElement !== this.getTargetElementFromEventTarget(t.target) || this.touchHasMoved(t)) {
			this.trackingClick = false;
			this.targetElement = null
		}
		return true
	};
	l.prototype.findControl = function (t) {
		if (t.control !== undefined) {
			return t.control
		}
		if (t.htmlFor) {
			return document.getElementById(t.htmlFor)
		}
		return t.querySelector("button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea")
	};
	l.prototype.onTouchEnd = function (t) {
		var e, i, n, r, o, a = this.targetElement;
		if (!this.trackingClick) {
			return true
		}
		if (t.timeStamp - this.lastClickTime < this.tapDelay) {
			this.cancelNextClick = true;
			return true
		}
		if (t.timeStamp - this.trackingClickStart > this.tapTimeout) {
			return true
		}
		this.cancelNextClick = false;
		this.lastClickTime = t.timeStamp;
		i = this.trackingClickStart;
		this.trackingClick = false;
		this.trackingClickStart = 0;
		if (h) {
			o = t.changedTouches[0];
			a = document.elementFromPoint(o.pageX - window.pageXOffset, o.pageY - window.pageYOffset) || a;
			a.fastClickScrollParent = this.targetElement.fastClickScrollParent
		}
		n = a.tagName.toLowerCase();
		if (n === "label") {
			e = this.findControl(a);
			if (e) {
				this.focus(a);
				if (c) {
					return false
				}
				a = e
			}
		} else if (this.needsFocus(a)) {
			if (t.timeStamp - i > 100 || s && window.top !== window && n === "input") {
				this.targetElement = null;
				return false
			}
			this.focus(a);
			this.sendClick(a, t);
			if (!s || n !== "select") {
				this.targetElement = null;
				t.preventDefault()
			}
			return false
		}
		if (s && !u) {
			r = a.fastClickScrollParent;
			if (r && r.fastClickLastScrollTop !== r.scrollTop) {
				return true
			}
		}
		if (!this.needsClick(a)) {
			t.preventDefault();
			this.sendClick(a, t)
		}
		return false
	};
	l.prototype.onTouchCancel = function () {
		this.trackingClick = false;
		this.targetElement = null
	};
	l.prototype.onMouse = function (t) {
		if (!this.targetElement) {
			return true
		}
		if (t.forwardedTouchEvent) {
			return true
		}
		if (!t.cancelable) {
			return true
		}
		if (!this.needsClick(this.targetElement) || this.cancelNextClick) {
			if (t.stopImmediatePropagation) {
				t.stopImmediatePropagation()
			} else {
				t.propagationStopped = true
			}
			t.stopPropagation();
			t.preventDefault();
			return false
		}
		return true
	};
	l.prototype.onClick = function (t) {
		var e;
		if (this.trackingClick) {
			this.targetElement = null;
			this.trackingClick = false;
			return true
		}
		if (t.target.type === "submit" && t.detail === 0) {
			return true
		}
		e = this.onMouse(t);
		if (!e) {
			this.targetElement = null
		}
		return e
	};
	l.prototype.destroy = function () {
		var t = this.layer;
		if (c) {
			t.removeEventListener("mouseover", this.onMouse, true);
			t.removeEventListener("mousedown", this.onMouse, true);
			t.removeEventListener("mouseup", this.onMouse, true)
		}
		t.removeEventListener("click", this.onClick, true);
		t.removeEventListener("touchstart", this.onTouchStart, false);
		t.removeEventListener("touchmove", this.onTouchMove, false);
		t.removeEventListener("touchend", this.onTouchEnd, false);
		t.removeEventListener("touchcancel", this.onTouchCancel, false)
	};
	l.notNeeded = function (t) {
		var e;
		var i;
		var n;
		var r;
		if (typeof window.ontouchstart === "undefined") {
			return true
		}
		i = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1];
		if (i) {
			if (c) {
				e = document.querySelector("meta[name=viewport]");
				if (e) {
					if (e.content.indexOf("user-scalable=no") !== -1) {
						return true
					}
					if (i > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
						return true
					}
				}
			} else {
				return true
			}
		}
		if (o) {
			n = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);
			if (n[1] >= 10 && n[2] >= 3) {
				e = document.querySelector("meta[name=viewport]");
				if (e) {
					if (e.content.indexOf("user-scalable=no") !== -1) {
						return true
					}
					if (document.documentElement.scrollWidth <= window.outerWidth) {
						return true
					}
				}
			}
		}
		if (t.style.msTouchAction === "none" || t.style.touchAction === "manipulation") {
			return true
		}
		r = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1];
		if (r >= 27) {
			e = document.querySelector("meta[name=viewport]");
			if (e && (e.content.indexOf("user-scalable=no") !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) {
				return true
			}
		}
		if (t.style.touchAction === "none" || t.style.touchAction === "manipulation") {
			return true
		}
		return false
	};
	l.attach = function (t, e) {
		return new l(t, e)
	};
	if (typeof define === "function" && typeof define.amd === "object" && define.amd) {
		define(function () {
			return l
		})
	} else if (typeof module !== "undefined" && module.exports) {
		module.exports = l.attach;
		module.exports.FastClick = l
	} else {
		window.FastClick = l
	}
})();
(function (t, e) {
	"object" === typeof exports && "undefined" !== typeof module ? e(exports) : "function" === typeof define && define.amd ? define(["exports"], e) : e(t.THREE = {})
})(this, function (t) {
	function e() {}

	function W(t, e) {
		this.x = t || 0;
		this.y = e || 0
	}

	function xt() {
		this.elements = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
		0 < arguments.length && console.error("THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.")
	}

	function j(t, e, i, n) {
		this._x = t || 0;
		this._y = e || 0;
		this._z = i || 0;
		this._w = void 0 !== n ? n : 1
	}

	function _t(t, e, i) {
		this.x = t || 0;
		this.y = e || 0;
		this.z = i || 0
	}

	function g() {
		this.elements = [1, 0, 0, 0, 1, 0, 0, 0, 1];
		0 < arguments.length && console.error("THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.")
	}

	function d(t, e, i, n, r, o, a, s, l, c) {
		Object.defineProperty(this, "id", {
			value: to++
		});
		this.uuid = Kr.generateUUID();
		this.name = "";
		this.image = void 0 !== t ? t : d.DEFAULT_IMAGE;
		this.mipmaps = [];
		this.mapping = void 0 !== e ? e : d.DEFAULT_MAPPING;
		this.wrapS = void 0 !== i ? i : 1001;
		this.wrapT = void 0 !== n ? n : 1001;
		this.magFilter = void 0 !== r ? r : 1006;
		this.minFilter = void 0 !== o ? o : 1008;
		this.anisotropy = void 0 !== l ? l : 1;
		this.format = void 0 !== a ? a : 1023;
		this.type = void 0 !== s ? s : 1009;
		this.offset = new W(0, 0);
		this.repeat = new W(1, 1);
		this.center = new W(0, 0);
		this.rotation = 0;
		this.matrixAutoUpdate = !0;
		this.matrix = new g;
		this.generateMipmaps = !0;
		this.premultiplyAlpha = !1;
		this.flipY = !0;
		this.unpackAlignment = 4;
		this.encoding = void 0 !== c ? c : 3e3;
		this.version = 0;
		this.onUpdate = null
	}

	function bt(t, e, i, n) {
		this.x = t || 0;
		this.y = e || 0;
		this.z = i || 0;
		this.w = void 0 !== n ? n : 1
	}

	function A(t, e, i) {
		this.width = t;
		this.height = e;
		this.scissor = new bt(0, 0, t, e);
		this.scissorTest = !1;
		this.viewport = new bt(0, 0, t, e);
		i = i || {};
		void 0 === i.minFilter && (i.minFilter = 1006);
		this.texture = new d(void 0, void 0, i.wrapS, i.wrapT, i.magFilter, i.minFilter, i.format, i.type, i.anisotropy, i.encoding);
		this.texture.generateMipmaps = void 0 !== i.generateMipmaps ? i.generateMipmaps : !0;
		this.depthBuffer = void 0 !== i.depthBuffer ? i.depthBuffer : !0;
		this.stencilBuffer = void 0 !== i.stencilBuffer ? i.stencilBuffer : !0;
		this.depthTexture = void 0 !== i.depthTexture ? i.depthTexture : null
	}

	function n(t, e, i) {
		A.call(this, t, e, i);
		this.activeMipMapLevel = this.activeCubeFace = 0
	}

	function wt(t, e, i, n, r, o, a, s, l, c, u, h) {
		d.call(this, null, o, a, s, l, c, n, r, u, h);
		this.image = {
			data: t,
			width: e,
			height: i
		};
		this.magFilter = void 0 !== l ? l : 1003;
		this.minFilter = void 0 !== c ? c : 1003;
		this.flipY = this.generateMipmaps = !1;
		this.unpackAlignment = 1
	}

	function i(t, e) {
		this.min = void 0 !== t ? t : new _t(Infinity, Infinity, Infinity);
		this.max = void 0 !== e ? e : new _t(-Infinity, -Infinity, -Infinity)
	}

	function c(t, e) {
		this.center = void 0 !== t ? t : new _t;
		this.radius = void 0 !== e ? e : 0
	}

	function v(t, e) {
		this.normal = void 0 !== t ? t : new _t(1, 0, 0);
		this.constant = void 0 !== e ? e : 0
	}

	function Tt(t, e, i, n, r, o) {
		this.planes = [void 0 !== t ? t : new v, void 0 !== e ? e : new v, void 0 !== i ? i : new v, void 0 !== n ? n : new v, void 0 !== r ? r : new v, void 0 !== o ? o : new v]
	}

	function w(t, e, i) {
		return void 0 === e && void 0 === i ? this.set(t) : this.setRGB(t, e, i)
	}

	function Et() {
		function i(t, e) {
			!1 !== r && (o(t, e), n.requestAnimationFrame(i))
		}
		var n = null,
			r = !1,
			o = null;
		return {
			start: function () {
				!0 !== r && null !== o && (n.requestAnimationFrame(i), r = !0)
			},
			stop: function () {
				r = !1
			},
			setAnimationLoop: function (t) {
				o = t
			},
			setContext: function (t) {
				n = t
			}
		}
	}

	function St(a) {
		function s(t, e) {
			var i = t.array,
				n = t.dynamic ? a.DYNAMIC_DRAW : a.STATIC_DRAW,
				r = a.createBuffer();
			a.bindBuffer(e, r);
			a.bufferData(e, i, n);
			t.onUploadCallback();
			e = a.FLOAT;
			i instanceof Float32Array ? e = a.FLOAT : i instanceof Float64Array ? console.warn("THREE.WebGLAttributes: Unsupported data buffer format: Float64Array.") : i instanceof Uint16Array ? e = a.UNSIGNED_SHORT : i instanceof Int16Array ? e = a.SHORT : i instanceof Uint32Array ? e = a.UNSIGNED_INT : i instanceof Int32Array ? e = a.INT : i instanceof Int8Array ? e = a.BYTE : i instanceof Uint8Array && (e = a.UNSIGNED_BYTE);
			return {
				buffer: r,
				type: e,
				bytesPerElement: i.BYTES_PER_ELEMENT,
				version: t.version
			}
		}
		var l = new WeakMap;
		return {
			get: function (t) {
				t.isInterleavedBufferAttribute && (t = t.data);
				return l.get(t)
			},
			remove: function (t) {
				t.isInterleavedBufferAttribute && (t = t.data);
				var e = l.get(t);
				e && (a.deleteBuffer(e.buffer), l.delete(t))
			},
			update: function (t, e) {
				t.isInterleavedBufferAttribute && (t = t.data);
				var i = l.get(t);
				if (void 0 === i) l.set(t, s(t, e));
				else if (i.version < t.version) {
					var n = t,
						r = n.array,
						o = n.updateRange;
					a.bindBuffer(e, i.buffer);
					!1 === n.dynamic ? a.bufferData(e, r, a.STATIC_DRAW) : -1 === o.count ? a.bufferSubData(e, 0, r) : 0 === o.count ? console.error("THREE.WebGLObjects.updateBuffer: dynamic THREE.BufferAttribute marked as needsUpdate but updateRange.count is 0, ensure you are using set methods or updating manually.") : (a.bufferSubData(e, o.offset * r.BYTES_PER_ELEMENT, r.subarray(o.offset, o.offset + o.count)), o.count = -1);
					i.version = t.version
				}
			}
		}
	}

	function r(t, e, i, n) {
		this._x = t || 0;
		this._y = e || 0;
		this._z = i || 0;
		this._order = n || r.DefaultOrder
	}

	function o() {
		this.mask = 1
	}

	function u() {
		Object.defineProperty(this, "id", {
			value: ao++
		});
		this.uuid = Kr.generateUUID();
		this.name = "";
		this.type = "Object3D";
		this.parent = null;
		this.children = [];
		this.up = u.DefaultUp.clone();
		var t = new _t,
			e = new r,
			i = new j,
			n = new _t(1, 1, 1);
		e.onChange(function () {
			i.setFromEuler(e, !1)
		});
		i.onChange(function () {
			e.setFromQuaternion(i, void 0, !1)
		});
		Object.defineProperties(this, {
			position: {
				enumerable: !0,
				value: t
			},
			rotation: {
				enumerable: !0,
				value: e
			},
			quaternion: {
				enumerable: !0,
				value: i
			},
			scale: {
				enumerable: !0,
				value: n
			},
			modelViewMatrix: {
				value: new xt
			},
			normalMatrix: {
				value: new g
			}
		});
		this.matrix = new xt;
		this.matrixWorld = new xt;
		this.matrixAutoUpdate = u.DefaultMatrixAutoUpdate;
		this.matrixWorldNeedsUpdate = !1;
		this.layers = new o;
		this.visible = !0;
		this.receiveShadow = this.castShadow = !1;
		this.frustumCulled = !0;
		this.renderOrder = 0;
		this.userData = {}
	}

	function l() {
		u.call(this);
		this.type = "Camera";
		this.matrixWorldInverse = new xt;
		this.projectionMatrix = new xt
	}

	function f(t, e, i, n, r, o) {
		l.call(this);
		this.type = "OrthographicCamera";
		this.zoom = 1;
		this.view = null;
		this.left = t;
		this.right = e;
		this.top = i;
		this.bottom = n;
		this.near = void 0 !== r ? r : .1;
		this.far = void 0 !== o ? o : 2e3;
		this.updateProjectionMatrix()
	}

	function F(t, e, i, n, r, o) {
		this.a = t;
		this.b = e;
		this.c = i;
		this.normal = n && n.isVector3 ? n : new _t;
		this.vertexNormals = Array.isArray(n) ? n : [];
		this.color = r && r.isColor ? r : new w;
		this.vertexColors = Array.isArray(r) ? r : [];
		this.materialIndex = void 0 !== o ? o : 0
	}

	function T() {
		Object.defineProperty(this, "id", {
			value: so += 2
		});
		this.uuid = Kr.generateUUID();
		this.name = "";
		this.type = "Geometry";
		this.vertices = [];
		this.colors = [];
		this.faces = [];
		this.faceVertexUvs = [
			[]
		];
		this.morphTargets = [];
		this.morphNormals = [];
		this.skinWeights = [];
		this.skinIndices = [];
		this.lineDistances = [];
		this.boundingSphere = this.boundingBox = null;
		this.groupsNeedUpdate = this.lineDistancesNeedUpdate = this.colorsNeedUpdate = this.normalsNeedUpdate = this.uvsNeedUpdate = this.verticesNeedUpdate = this.elementsNeedUpdate = !1
	}

	function y(t, e, i) {
		if (Array.isArray(t)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
		this.name = "";
		this.array = t;
		this.itemSize = e;
		this.count = void 0 !== t ? t.length / e : 0;
		this.normalized = !0 === i;
		this.dynamic = !1;
		this.updateRange = {
			offset: 0,
			count: -1
		};
		this.version = 0
	}

	function a(t, e, i) {
		y.call(this, new Int8Array(t), e, i)
	}

	function s(t, e, i) {
		y.call(this, new Uint8Array(t), e, i)
	}

	function h(t, e, i) {
		y.call(this, new Uint8ClampedArray(t), e, i)
	}

	function p(t, e, i) {
		y.call(this, new Int16Array(t), e, i)
	}

	function m(t, e, i) {
		y.call(this, new Uint16Array(t), e, i)
	}

	function x(t, e, i) {
		y.call(this, new Int32Array(t), e, i)
	}

	function _(t, e, i) {
		y.call(this, new Uint32Array(t), e, i)
	}

	function P(t, e, i) {
		y.call(this, new Float32Array(t), e, i)
	}

	function b(t, e, i) {
		y.call(this, new Float64Array(t), e, i)
	}

	function E() {
		this.vertices = [];
		this.normals = [];
		this.colors = [];
		this.uvs = [];
		this.uvs2 = [];
		this.groups = [];
		this.morphTargets = {};
		this.skinWeights = [];
		this.skinIndices = [];
		this.boundingSphere = this.boundingBox = null;
		this.groupsNeedUpdate = this.uvsNeedUpdate = this.colorsNeedUpdate = this.normalsNeedUpdate = this.verticesNeedUpdate = !1
	}

	function S(t) {
		if (0 === t.length) return -Infinity;
		for (var e = t[0], i = 1, n = t.length; i < n; ++i) t[i] > e && (e = t[i]);
		return e
	}

	function L() {
		Object.defineProperty(this, "id", {
			value: lo += 2
		});
		this.uuid = Kr.generateUUID();
		this.name = "";
		this.type = "BufferGeometry";
		this.index = null;
		this.attributes = {};
		this.morphAttributes = {};
		this.groups = [];
		this.boundingSphere = this.boundingBox = null;
		this.drawRange = {
			start: 0,
			count: Infinity
		};
		this.userData = {}
	}

	function M(t, e, i, n, r, o) {
		T.call(this);
		this.type = "BoxGeometry";
		this.parameters = {
			width: t,
			height: e,
			depth: i,
			widthSegments: n,
			heightSegments: r,
			depthSegments: o
		};
		this.fromBufferGeometry(new C(t, e, i, n, r, o));
		this.mergeVertices()
	}

	function C(t, e, i, n, r, o) {
		function a(t, e, i, n, r, o, a, s, l, c, u) {
			var h = o / l,
				d = a / c,
				f = o / 2,
				p = a / 2,
				m = s / 2;
			a = l + 1;
			var g = c + 1,
				v = o = 0,
				y, x, _ = new _t;
			for (x = 0; x < g; x++) {
				var b = x * d - p;
				for (y = 0; y < a; y++) _[t] = (y * h - f) * n, _[e] = b * r, _[i] = m, E.push(_.x, _.y, _.z), _[t] = 0, _[e] = 0, _[i] = 0 < s ? 1 : -1, S.push(_.x, _.y, _.z), M.push(y / l), M.push(1 - x / c), o += 1
			}
			for (x = 0; x < c; x++)
				for (y = 0; y < l; y++) t = A + y + a * (x + 1), e = A + (y + 1) + a * (x + 1), i = A + (y + 1) + a * x, T.push(A + y + a * x, t, i), T.push(t, e, i), v += 6;
			w.addGroup(C, v, u);
			C += v;
			A += o
		}
		L.call(this);
		this.type = "BoxBufferGeometry";
		this.parameters = {
			width: t,
			height: e,
			depth: i,
			widthSegments: n,
			heightSegments: r,
			depthSegments: o
		};
		var w = this;
		t = t || 1;
		e = e || 1;
		i = i || 1;
		n = Math.floor(n) || 1;
		r = Math.floor(r) || 1;
		o = Math.floor(o) || 1;
		var T = [],
			E = [],
			S = [],
			M = [],
			A = 0,
			C = 0;
		a("z", "y", "x", -1, -1, i, e, t, o, r, 0);
		a("z", "y", "x", 1, -1, i, e, -t, o, r, 1);
		a("x", "z", "y", 1, 1, t, i, e, n, o, 2);
		a("x", "z", "y", 1, -1, t, i, -e, n, o, 3);
		a("x", "y", "z", 1, -1, t, e, i, n, r, 4);
		a("x", "y", "z", -1, -1, t, e, -i, n, r, 5);
		this.setIndex(T);
		this.addAttribute("position", new P(E, 3));
		this.addAttribute("normal", new P(S, 3));
		this.addAttribute("uv", new P(M, 2))
	}

	function R(t, e, i, n) {
		T.call(this);
		this.type = "PlaneGeometry";
		this.parameters = {
			width: t,
			height: e,
			widthSegments: i,
			heightSegments: n
		};
		this.fromBufferGeometry(new O(t, e, i, n));
		this.mergeVertices()
	}

	function O(t, e, i, n) {
		L.call(this);
		this.type = "PlaneBufferGeometry";
		this.parameters = {
			width: t,
			height: e,
			widthSegments: i,
			heightSegments: n
		};
		t = t || 1;
		e = e || 1;
		var r = t / 2,
			o = e / 2;
		i = Math.floor(i) || 1;
		n = Math.floor(n) || 1;
		var a = i + 1,
			s = n + 1,
			l = t / i,
			c = e / n,
			u = [],
			h = [],
			d = [],
			f = [];
		for (t = 0; t < s; t++) {
			var p = t * c - o;
			for (e = 0; e < a; e++) h.push(e * l - r, -p, 0), d.push(0, 0, 1), f.push(e / i), f.push(1 - t / n)
		}
		for (t = 0; t < n; t++)
			for (e = 0; e < i; e++) r = e + a * (t + 1), o = e + 1 + a * (t + 1), s = e + 1 + a * t, u.push(e + a * t, r, s), u.push(r, o, s);
		this.setIndex(u);
		this.addAttribute("position", new P(h, 3));
		this.addAttribute("normal", new P(d, 3));
		this.addAttribute("uv", new P(f, 2))
	}

	function k() {
		Object.defineProperty(this, "id", {
			value: co++
		});
		this.uuid = Kr.generateUUID();
		this.name = "";
		this.type = "Material";
		this.lights = this.fog = !0;
		this.blending = 1;
		this.side = 0;
		this.flatShading = !1;
		this.vertexColors = 0;
		this.opacity = 1;
		this.transparent = !1;
		this.blendSrc = 204;
		this.blendDst = 205;
		this.blendEquation = 100;
		this.blendEquationAlpha = this.blendDstAlpha = this.blendSrcAlpha = null;
		this.depthFunc = 3;
		this.depthWrite = this.depthTest = !0;
		this.clippingPlanes = null;
		this.clipShadows = this.clipIntersection = !1;
		this.shadowSide = null;
		this.colorWrite = !0;
		this.precision = null;
		this.polygonOffset = !1;
		this.polygonOffsetUnits = this.polygonOffsetFactor = 0;
		this.dithering = !1;
		this.alphaTest = 0;
		this.premultipliedAlpha = !1;
		this.overdraw = 0;
		this.visible = !0;
		this.userData = {};
		this.needsUpdate = !0
	}

	function N(t) {
		k.call(this);
		this.type = "MeshBasicMaterial";
		this.color = new w(16777215);
		this.lightMap = this.map = null;
		this.lightMapIntensity = 1;
		this.aoMap = null;
		this.aoMapIntensity = 1;
		this.envMap = this.alphaMap = this.specularMap = null;
		this.combine = 0;
		this.reflectivity = 1;
		this.refractionRatio = .98;
		this.wireframe = !1;
		this.wireframeLinewidth = 1;
		this.wireframeLinejoin = this.wireframeLinecap = "round";
		this.lights = this.morphTargets = this.skinning = !1;
		this.setValues(t)
	}

	function I(t) {
		k.call(this);
		this.type = "ShaderMaterial";
		this.defines = {};
		this.uniforms = {};
		this.vertexShader = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
		this.fragmentShader = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
		this.linewidth = 1;
		this.wireframe = !1;
		this.wireframeLinewidth = 1;
		this.morphNormals = this.morphTargets = this.skinning = this.clipping = this.lights = this.fog = !1;
		this.extensions = {
			derivatives: !1,
			fragDepth: !1,
			drawBuffers: !1,
			shaderTextureLOD: !1
		};
		this.defaultAttributeValues = {
			color: [1, 1, 1],
			uv: [0, 0],
			uv2: [0, 0]
		};
		this.index0AttributeName = void 0;
		this.uniformsNeedUpdate = !1;
		void 0 !== t && (void 0 !== t.attributes && console.error("THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead."), this.setValues(t))
	}

	function B(t, e) {
		this.origin = void 0 !== t ? t : new _t;
		this.direction = void 0 !== e ? e : new _t
	}

	function D(t, e) {
		this.start = void 0 !== t ? t : new _t;
		this.end = void 0 !== e ? e : new _t
	}

	function U(t, e, i) {
		this.a = void 0 !== t ? t : new _t;
		this.b = void 0 !== e ? e : new _t;
		this.c = void 0 !== i ? i : new _t
	}

	function z(t, e) {
		u.call(this);
		this.type = "Mesh";
		this.geometry = void 0 !== t ? t : new L;
		this.material = void 0 !== e ? e : new N({
			color: 16777215 * Math.random()
		});
		this.drawMode = 0;
		this.updateMorphTargets()
	}

	function Mt(r, i, o, n) {
		function a(t, e) {
			i.buffers.color.setClear(t.r, t.g, t.b, e, n)
		}
		var s = new w(0),
			l = 0,
			c, u, h;
		return {
			getClearColor: function () {
				return s
			},
			setClearColor: function (t, e) {
				s.set(t);
				l = void 0 !== e ? e : 1;
				a(s, l)
			},
			getClearAlpha: function () {
				return l
			},
			setClearAlpha: function (t) {
				l = t;
				a(s, l)
			},
			render: function (t, e, i, n) {
				e = e.background;
				null === e ? a(s, l) : e && e.isColor && (a(e, 1), n = !0);
				(r.autoClear || n) && r.clear(r.autoClearColor, r.autoClearDepth, r.autoClearStencil);
				e && e.isCubeTexture ? (void 0 === h && (h = new z(new C(1, 1, 1), new I({
					uniforms: oo.cube.uniforms,
					vertexShader: oo.cube.vertexShader,
					fragmentShader: oo.cube.fragmentShader,
					side: 1,
					depthTest: !0,
					depthWrite: !1,
					fog: !1
				})), h.geometry.removeAttribute("normal"), h.geometry.removeAttribute("uv"), h.onBeforeRender = function (t, e, i) {
					this.matrixWorld.copyPosition(i.matrixWorld)
				}, o.update(h)), h.material.uniforms.tCube.value = e, t.push(h, h.geometry, h.material, 0, null)) : e && e.isTexture && (void 0 === c && (c = new f(-1, 1, 1, -1, 0, 1), u = new z(new O(2, 2), new N({
					depthTest: !1,
					depthWrite: !1,
					fog: !1
				})), o.update(u)), u.material.map = e, r.renderBufferDirect(c, null, u.geometry, u.material, u, null))
			}
		}
	}

	function At(i, r, o) {
		var a;
		this.setMode = function (t) {
			a = t
		};
		this.render = function (t, e) {
			i.drawArrays(a, t, e);
			o.update(e, a)
		};
		this.renderInstances = function (t, e, i) {
			var n = r.get("ANGLE_instanced_arrays");
			null === n ? console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.") : (n.drawArraysInstancedANGLE(a, e, i, t.maxInstancedCount), o.update(i, a, t.maxInstancedCount))
		}
	}

	function Ct(e, i, t) {
		function n(t) {
			if ("highp" === t) {
				if (0 < e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.HIGH_FLOAT).precision && 0 < e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.HIGH_FLOAT).precision) return "highp";
				t = "mediump"
			}
			return "mediump" === t && 0 < e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.MEDIUM_FLOAT).precision && 0 < e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.MEDIUM_FLOAT).precision ? "mediump" : "lowp"
		}
		var r, o = void 0 !== t.precision ? t.precision : "highp",
			a = n(o);
		a !== o && (console.warn("THREE.WebGLRenderer:", o, "not supported, using", a, "instead."), o = a);
		t = !0 === t.logarithmicDepthBuffer;
		a = e.getParameter(e.MAX_TEXTURE_IMAGE_UNITS);
		var s = e.getParameter(e.MAX_VERTEX_TEXTURE_IMAGE_UNITS),
			l = e.getParameter(e.MAX_TEXTURE_SIZE),
			c = e.getParameter(e.MAX_CUBE_MAP_TEXTURE_SIZE),
			u = e.getParameter(e.MAX_VERTEX_ATTRIBS),
			h = e.getParameter(e.MAX_VERTEX_UNIFORM_VECTORS),
			d = e.getParameter(e.MAX_VARYING_VECTORS),
			f = e.getParameter(e.MAX_FRAGMENT_UNIFORM_VECTORS),
			p = 0 < s,
			m = !!i.get("OES_texture_float");
		return {
			getMaxAnisotropy: function () {
				if (void 0 !== r) return r;
				var t = i.get("EXT_texture_filter_anisotropic");
				return r = null !== t ? e.getParameter(t.MAX_TEXTURE_MAX_ANISOTROPY_EXT) : 0
			},
			getMaxPrecision: n,
			precision: o,
			logarithmicDepthBuffer: t,
			maxTextures: a,
			maxVertexTextures: s,
			maxTextureSize: l,
			maxCubemapSize: c,
			maxAttributes: u,
			maxVertexUniforms: h,
			maxVaryings: d,
			maxFragmentUniforms: f,
			vertexTextures: p,
			floatFragmentTextures: m,
			floatVertexTextures: p && m
		}
	}

	function Pt() {
		function l() {
			m.value !== u && (m.value = u, m.needsUpdate = 0 < h);
			a.numPlanes = h;
			a.numIntersection = 0
		}

		function c(t, e, i, n) {
			var r = null !== t ? t.length : 0,
				o = null;
			if (0 !== r) {
				o = m.value;
				if (!0 !== n || null === o) {
					n = i + 4 * r;
					e = e.matrixWorldInverse;
					p.getNormalMatrix(e);
					if (null === o || o.length < n) o = new Float32Array(n);
					for (n = 0; n !== r; ++n, i += 4) s.copy(t[n]).applyMatrix4(e, p), s.normal.toArray(o, i), o[i + 3] = s.constant
				}
				m.value = o;
				m.needsUpdate = !0
			}
			a.numPlanes = r;
			return o
		}
		var a = this,
			u = null,
			h = 0,
			d = !1,
			f = !1,
			s = new v,
			p = new g,
			m = {
				value: null,
				needsUpdate: !1
			};
		this.uniform = m;
		this.numIntersection = this.numPlanes = 0;
		this.init = function (t, e, i) {
			var n = 0 !== t.length || e || 0 !== h || d;
			d = e;
			u = c(t, i, 0);
			h = t.length;
			return n
		};
		this.beginShadows = function () {
			f = !0;
			c(null)
		};
		this.endShadows = function () {
			f = !1;
			l()
		};
		this.setState = function (t, e, i, n, r, o) {
			if (!d || null === t || 0 === t.length || f && !i) f ? c(null) : l();
			else {
				i = f ? 0 : h;
				var a = 4 * i,
					s = r.clippingState || null;
				m.value = s;
				s = c(t, n, a, o);
				for (t = 0; t !== a; ++t) s[t] = u[t];
				r.clippingState = s;
				this.numIntersection = e ? this.numPlanes : 0;
				this.numPlanes += i
			}
		}
	}

	function Lt(i) {
		var n = {};
		return {
			get: function (t) {
				if (void 0 !== n[t]) return n[t];
				switch (t) {
					case "WEBGL_depth_texture":
						var e = i.getExtension("WEBGL_depth_texture") || i.getExtension("MOZ_WEBGL_depth_texture") || i.getExtension("WEBKIT_WEBGL_depth_texture");
						break;
					case "EXT_texture_filter_anisotropic":
						e = i.getExtension("EXT_texture_filter_anisotropic") || i.getExtension("MOZ_EXT_texture_filter_anisotropic") || i.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
						break;
					case "WEBGL_compressed_texture_s3tc":
						e = i.getExtension("WEBGL_compressed_texture_s3tc") || i.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || i.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
						break;
					case "WEBGL_compressed_texture_pvrtc":
						e = i.getExtension("WEBGL_compressed_texture_pvrtc") || i.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
						break;
					default:
						e = i.getExtension(t)
				}
				null === e && console.warn("THREE.WebGLRenderer: " + t + " extension not supported.");
				return n[t] = e
			}
		}
	}

	function Rt(l, c, n) {
		function r(t) {
			t = t.target;
			var e = o[t.id];
			null !== e.index && c.remove(e.index);
			for (var i in e.attributes) c.remove(e.attributes[i]);
			t.removeEventListener("dispose", r);
			delete o[t.id];
			if (i = u[t.id]) c.remove(i), delete u[t.id];
			if (i = u[e.id]) c.remove(i), delete u[e.id];
			n.memory.geometries--
		}
		var o = {},
			u = {};
		return {
			get: function (t, e) {
				var i = o[e.id];
				if (i) return i;
				e.addEventListener("dispose", r);
				e.isBufferGeometry ? i = e : e.isGeometry && (void 0 === e._bufferGeometry && (e._bufferGeometry = (new L).setFromObject(t)), i = e._bufferGeometry);
				o[e.id] = i;
				n.memory.geometries++;
				return i
			},
			update: function (t) {
				var e = t.index,
					i = t.attributes;
				null !== e && c.update(e, l.ELEMENT_ARRAY_BUFFER);
				for (var n in i) c.update(i[n], l.ARRAY_BUFFER);
				t = t.morphAttributes;
				for (n in t) {
					e = t[n];
					i = 0;
					for (var r = e.length; i < r; i++) c.update(e[i], l.ARRAY_BUFFER)
				}
			},
			getWireframeAttribute: function (t) {
				var e = u[t.id];
				if (e) return e;
				e = [];
				var i = t.index,
					n = t.attributes;
				if (null !== i) {
					i = i.array;
					n = 0;
					for (var r = i.length; n < r; n += 3) {
						var o = i[n + 0],
							a = i[n + 1],
							s = i[n + 2];
						e.push(o, a, a, s, s, o)
					}
				} else
					for (i = n.position.array, n = 0, r = i.length / 3 - 1; n < r; n += 3) o = n + 0, a = n + 1, s = n + 2, e.push(o, a, a, s, s, o);
				e = new(65535 < S(e) ? _ : m)(e, 1);
				c.update(e, l.ELEMENT_ARRAY_BUFFER);
				return u[t.id] = e
			}
		}
	}

	function Ot(i, r, o) {
		var a, s, l;
		this.setMode = function (t) {
			a = t
		};
		this.setIndex = function (t) {
			s = t.type;
			l = t.bytesPerElement
		};
		this.render = function (t, e) {
			i.drawElements(a, e, s, t * l);
			o.update(e, a)
		};
		this.renderInstances = function (t, e, i) {
			var n = r.get("ANGLE_instanced_arrays");
			null === n ? console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.") : (n.drawElementsInstancedANGLE(a, i, s, e * l, t.maxInstancedCount), o.update(i, a, t.maxInstancedCount))
		}
	}

	function kt(n) {
		var r = {
			frame: 0,
			calls: 0,
			triangles: 0,
			points: 0,
			lines: 0
		};
		return {
			memory: {
				geometries: 0,
				textures: 0
			},
			render: r,
			programs: null,
			autoReset: !0,
			reset: function () {
				r.frame++;
				r.calls = 0;
				r.triangles = 0;
				r.points = 0;
				r.lines = 0
			},
			update: function (t, e, i) {
				i = i || 1;
				r.calls++;
				switch (e) {
					case n.TRIANGLES:
						r.triangles += t / 3 * i;
						break;
					case n.TRIANGLE_STRIP:
					case n.TRIANGLE_FAN:
						r.triangles += i * (t - 2);
						break;
					case n.LINES:
						r.lines += t / 2 * i;
						break;
					case n.LINE_STRIP:
						r.lines += i * (t - 1);
						break;
					case n.LINE_LOOP:
						r.lines += i * t;
						break;
					case n.POINTS:
						r.points += i * t;
						break;
					default:
						console.error("THREE.WebGLInfo: Unknown draw mode:", e)
				}
			}
		}
	}

	function G(t, e) {
		return Math.abs(e[1]) - Math.abs(t[1])
	}

	function Nt(c) {
		var u = {},
			h = new Float32Array(8);
		return {
			update: function (t, e, i, n) {
				var r = t.morphTargetInfluences,
					o = r.length;
				t = u[e.id];
				if (void 0 === t) {
					t = [];
					for (var a = 0; a < o; a++) t[a] = [a, 0];
					u[e.id] = t
				}
				var s = i.morphTargets && e.morphAttributes.position;
				i = i.morphNormals && e.morphAttributes.normal;
				for (a = 0; a < o; a++) {
					var l = t[a];
					0 !== l[1] && (s && e.removeAttribute("morphTarget" + a), i && e.removeAttribute("morphNormal" + a))
				}
				for (a = 0; a < o; a++) l = t[a], l[0] = a, l[1] = r[a];
				t.sort(G);
				for (a = 0; 8 > a; a++) {
					if (l = t[a])
						if (r = l[0], o = l[1]) {
							s && e.addAttribute("morphTarget" + a, s[r]);
							i && e.addAttribute("morphNormal" + a, i[r]);
							h[a] = o;
							continue
						}
					h[a] = 0
				}
				n.getUniforms().setValue(c, "morphTargetInfluences", h)
			}
		}
	}

	function It(r, o) {
		var a = {};
		return {
			update: function (t) {
				var e = o.render.frame,
					i = t.geometry,
					n = r.get(t, i);
				a[n.id] !== e && (i.isGeometry && n.updateFromObject(t), r.update(n), a[n.id] = e);
				return n
			},
			dispose: function () {
				a = {}
			}
		}
	}

	function H(t, e, i, n, r, o, a, s, l, c) {
		t = void 0 !== t ? t : [];
		d.call(this, t, void 0 !== e ? e : 301, i, n, r, o, a, s, l, c);
		this.flipY = !1
	}

	function V(t, e, i) {
		var n = t[0];
		if (0 >= n || 0 < n) return t;
		var r = e * i,
			o = fo[r];
		void 0 === o && (o = new Float32Array(r), fo[r] = o);
		if (0 !== e)
			for (n.toArray(o, 0), n = 1, r = 0; n !== e; ++n) r += i, t[n].toArray(o, r);
		return o
	}

	function X(t, e) {
		if (t.length !== e.length) return !1;
		for (var i = 0, n = t.length; i < n; i++)
			if (t[i] !== e[i]) return !1;
		return !0
	}

	function Y(t, e) {
		for (var i = 0, n = e.length; i < n; i++) t[i] = e[i]
	}

	function q(t, e) {
		var i = po[e];
		void 0 === i && (i = new Int32Array(e), po[e] = i);
		for (var n = 0; n !== e; ++n) i[n] = t.allocTextureUnit();
		return i
	}

	function $(t, e) {
		var i = this.cache;
		i[0] !== e && (t.uniform1f(this.addr, e), i[0] = e)
	}

	function Z(t, e) {
		var i = this.cache;
		i[0] !== e && (t.uniform1i(this.addr, e), i[0] = e)
	}

	function J(t, e) {
		var i = this.cache;
		if (void 0 !== e.x) {
			if (i[0] !== e.x || i[1] !== e.y) t.uniform2f(this.addr, e.x, e.y), i[0] = e.x, i[1] = e.y
		} else X(i, e) || (t.uniform2fv(this.addr, e), Y(i, e))
	}

	function Q(t, e) {
		var i = this.cache;
		if (void 0 !== e.x) {
			if (i[0] !== e.x || i[1] !== e.y || i[2] !== e.z) t.uniform3f(this.addr, e.x, e.y, e.z), i[0] = e.x, i[1] = e.y, i[2] = e.z
		} else if (void 0 !== e.r) {
			if (i[0] !== e.r || i[1] !== e.g || i[2] !== e.b) t.uniform3f(this.addr, e.r, e.g, e.b), i[0] = e.r, i[1] = e.g, i[2] = e.b
		} else X(i, e) || (t.uniform3fv(this.addr, e), Y(i, e))
	}

	function K(t, e) {
		var i = this.cache;
		if (void 0 !== e.x) {
			if (i[0] !== e.x || i[1] !== e.y || i[2] !== e.z || i[3] !== e.w) t.uniform4f(this.addr, e.x, e.y, e.z, e.w), i[0] = e.x, i[1] = e.y, i[2] = e.z, i[3] = e.w
		} else X(i, e) || (t.uniform4fv(this.addr, e), Y(i, e))
	}

	function tt(t, e) {
		var i = this.cache,
			n = e.elements;
		void 0 === n ? X(i, e) || (t.uniformMatrix2fv(this.addr, !1, e), Y(i, e)) : X(i, n) || (vo.set(n), t.uniformMatrix2fv(this.addr, !1, vo), Y(i, n))
	}

	function et(t, e) {
		var i = this.cache,
			n = e.elements;
		void 0 === n ? X(i, e) || (t.uniformMatrix3fv(this.addr, !1, e), Y(i, e)) : X(i, n) || (go.set(n), t.uniformMatrix3fv(this.addr, !1, go), Y(i, n))
	}

	function it(t, e) {
		var i = this.cache,
			n = e.elements;
		void 0 === n ? X(i, e) || (t.uniformMatrix4fv(this.addr, !1, e), Y(i, e)) : X(i, n) || (mo.set(n), t.uniformMatrix4fv(this.addr, !1, mo), Y(i, n))
	}

	function nt(t, e, i) {
		var n = this.cache,
			r = i.allocTextureUnit();
		n[0] !== r && (t.uniform1i(this.addr, r), n[0] = r);
		i.setTexture2D(e || uo, r)
	}

	function rt(t, e, i) {
		var n = this.cache,
			r = i.allocTextureUnit();
		n[0] !== r && (t.uniform1i(this.addr, r), n[0] = r);
		i.setTextureCube(e || ho, r)
	}

	function ot(t, e) {
		var i = this.cache;
		X(i, e) || (t.uniform2iv(this.addr, e), Y(i, e))
	}

	function at(t, e) {
		var i = this.cache;
		X(i, e) || (t.uniform3iv(this.addr, e), Y(i, e))
	}

	function st(t, e) {
		var i = this.cache;
		X(i, e) || (t.uniform4iv(this.addr, e), Y(i, e))
	}

	function lt(t) {
		switch (t) {
			case 5126:
				return $;
			case 35664:
				return J;
			case 35665:
				return Q;
			case 35666:
				return K;
			case 35674:
				return tt;
			case 35675:
				return et;
			case 35676:
				return it;
			case 35678:
			case 36198:
				return nt;
			case 35680:
				return rt;
			case 5124:
			case 35670:
				return Z;
			case 35667:
			case 35671:
				return ot;
			case 35668:
			case 35672:
				return at;
			case 35669:
			case 35673:
				return st
		}
	}

	function ct(t, e) {
		var i = this.cache;
		X(i, e) || (t.uniform1fv(this.addr, e), Y(i, e))
	}

	function ut(t, e) {
		var i = this.cache;
		X(i, e) || (t.uniform1iv(this.addr, e), Y(i, e))
	}

	function ht(t, e) {
		var i = this.cache;
		e = V(e, this.size, 2);
		X(i, e) || (t.uniform2fv(this.addr, e), this.updateCache(e))
	}

	function dt(t, e) {
		var i = this.cache;
		e = V(e, this.size, 3);
		X(i, e) || (t.uniform3fv(this.addr, e), this.updateCache(e))
	}

	function ft(t, e) {
		var i = this.cache;
		e = V(e, this.size, 4);
		X(i, e) || (t.uniform4fv(this.addr, e), this.updateCache(e))
	}

	function pt(t, e) {
		var i = this.cache;
		e = V(e, this.size, 4);
		X(i, e) || (t.uniformMatrix2fv(this.addr, !1, e), this.updateCache(e))
	}

	function mt(t, e) {
		var i = this.cache;
		e = V(e, this.size, 9);
		X(i, e) || (t.uniformMatrix3fv(this.addr, !1, e), this.updateCache(e))
	}

	function gt(t, e) {
		var i = this.cache;
		e = V(e, this.size, 16);
		X(i, e) || (t.uniformMatrix4fv(this.addr, !1, e), this.updateCache(e))
	}

	function vt(t, e, i) {
		var n = this.cache,
			r = e.length,
			o = q(i, r);
		!1 === X(n, o) && (t.uniform1iv(this.addr, o), Y(n, o));
		for (t = 0; t !== r; ++t) i.setTexture2D(e[t] || uo, o[t])
	}

	function yt(t, e, i) {
		var n = this.cache,
			r = e.length,
			o = q(i, r);
		!1 === X(n, o) && (t.uniform1iv(this.addr, o), Y(n, o));
		for (t = 0; t !== r; ++t) i.setTextureCube(e[t] || ho, o[t])
	}

	function Dt(t) {
		switch (t) {
			case 5126:
				return ct;
			case 35664:
				return ht;
			case 35665:
				return dt;
			case 35666:
				return ft;
			case 35674:
				return pt;
			case 35675:
				return mt;
			case 35676:
				return gt;
			case 35678:
				return vt;
			case 35680:
				return yt;
			case 5124:
			case 35670:
				return ut;
			case 35667:
			case 35671:
				return ot;
			case 35668:
			case 35672:
				return at;
			case 35669:
			case 35673:
				return st
		}
	}

	function Ft(t, e, i) {
		this.id = t;
		this.addr = i;
		this.cache = [];
		this.setValue = lt(e.type)
	}

	function Bt(t, e, i) {
		this.id = t;
		this.addr = i;
		this.cache = [];
		this.size = e.size;
		this.setValue = Dt(e.type)
	}

	function Ut(t) {
		this.id = t;
		this.seq = [];
		this.map = {}
	}

	function zt(t, e, i) {
		this.seq = [];
		this.map = {};
		this.renderer = i;
		i = t.getProgramParameter(e, t.ACTIVE_UNIFORMS);
		for (var n = 0; n < i; ++n) {
			var r = t.getActiveUniform(e, n),
				o = t.getUniformLocation(e, r.name),
				a = this,
				s = r.name,
				l = s.length;
			for (yo.lastIndex = 0;;) {
				var c = yo.exec(s),
					u = yo.lastIndex,
					h = c[1],
					d = c[3];
				"]" === c[2] && (h |= 0);
				if (void 0 === d || "[" === d && u + 2 === l) {
					s = a;
					r = void 0 === d ? new Ft(h, r, o) : new Bt(h, r, o);
					s.seq.push(r);
					s.map[r.id] = r;
					break
				} else d = a.map[h], void 0 === d && (d = new Ut(h), h = a, a = d, h.seq.push(a), h.map[a.id] = a), a = d
			}
		}
	}

	function Gt(t) {
		t = t.split("\n");
		for (var e = 0; e < t.length; e++) t[e] = e + 1 + ": " + t[e];
		return t.join("\n")
	}

	function Ht(t, e, i) {
		var n = t.createShader(e);
		t.shaderSource(n, i);
		t.compileShader(n);
		!1 === t.getShaderParameter(n, t.COMPILE_STATUS) && console.error("THREE.WebGLShader: Shader couldn't compile.");
		"" !== t.getShaderInfoLog(n) && console.warn("THREE.WebGLShader: gl.getShaderInfoLog()", e === t.VERTEX_SHADER ? "vertex" : "fragment", t.getShaderInfoLog(n), Gt(i));
		return n
	}

	function jt(t) {
		switch (t) {
			case 3e3:
				return ["Linear", "( value )"];
			case 3001:
				return ["sRGB", "( value )"];
			case 3002:
				return ["RGBE", "( value )"];
			case 3004:
				return ["RGBM", "( value, 7.0 )"];
			case 3005:
				return ["RGBM", "( value, 16.0 )"];
			case 3006:
				return ["RGBD", "( value, 256.0 )"];
			case 3007:
				return ["Gamma", "( value, float( GAMMA_FACTOR ) )"];
			default:
				throw Error("unsupported encoding: " + t)
		}
	}

	function Vt(t, e) {
		e = jt(e);
		return "vec4 " + t + "( vec4 value ) { return " + e[0] + "ToLinear" + e[1] + "; }"
	}

	function Wt(t, e) {
		e = jt(e);
		return "vec4 " + t + "( vec4 value ) { return LinearTo" + e[0] + e[1] + "; }"
	}

	function Xt(t, e) {
		switch (e) {
			case 1:
				e = "Linear";
				break;
			case 2:
				e = "Reinhard";
				break;
			case 3:
				e = "Uncharted2";
				break;
			case 4:
				e = "OptimizedCineon";
				break;
			default:
				throw Error("unsupported toneMapping: " + e)
		}
		return "vec3 " + t + "( vec3 color ) { return " + e + "ToneMapping( color ); }"
	}

	function Yt(t, e, i) {
		t = t || {};
		return [t.derivatives || e.envMapCubeUV || e.bumpMap || e.normalMap || e.flatShading ? "#extension GL_OES_standard_derivatives : enable" : "", (t.fragDepth || e.logarithmicDepthBuffer) && i.get("EXT_frag_depth") ? "#extension GL_EXT_frag_depth : enable" : "", t.drawBuffers && i.get("WEBGL_draw_buffers") ? "#extension GL_EXT_draw_buffers : require" : "", (t.shaderTextureLOD || e.envMap) && i.get("EXT_shader_texture_lod") ? "#extension GL_EXT_shader_texture_lod : enable" : ""].filter($t).join("\n")
	}

	function qt(t) {
		var e = [],
			i;
		for (i in t) {
			var n = t[i];
			!1 !== n && e.push("#define " + i + " " + n)
		}
		return e.join("\n")
	}

	function $t(t) {
		return "" !== t
	}

	function Zt(t, e) {
		return t.replace(/NUM_DIR_LIGHTS/g, e.numDirLights).replace(/NUM_SPOT_LIGHTS/g, e.numSpotLights).replace(/NUM_RECT_AREA_LIGHTS/g, e.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, e.numPointLights).replace(/NUM_HEMI_LIGHTS/g, e.numHemiLights)
	}

	function Jt(t, e) {
		return t.replace(/NUM_CLIPPING_PLANES/g, e.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, e.numClippingPlanes - e.numClipIntersection)
	}

	function Qt(t) {
		return t.replace(/^[ \t]*#include +<([\w\d.]+)>/gm, function (t, e) {
			t = eo[e];
			if (void 0 === t) throw Error("Can not resolve #include <" + e + ">");
			return Qt(t)
		})
	}

	function Kt(t) {
		return t.replace(/#pragma unroll_loop[\s]+?for \( int i = (\d+); i < (\d+); i \+\+ \) \{([\s\S]+?)(?=\})\}/g, function (t, e, i, n) {
			t = "";
			for (e = parseInt(e); e < parseInt(i); e++) t += n.replace(/\[ i \]/g, "[ " + e + " ]");
			return t
		})
	}

	function te(t, e, i, n, r, o) {
		var a = t.context,
			s = n.defines,
			l = r.vertexShader,
			c = r.fragmentShader,
			u = "SHADOWMAP_TYPE_BASIC";
		1 === o.shadowMapType ? u = "SHADOWMAP_TYPE_PCF" : 2 === o.shadowMapType && (u = "SHADOWMAP_TYPE_PCF_SOFT");
		var h = "ENVMAP_TYPE_CUBE",
			d = "ENVMAP_MODE_REFLECTION",
			f = "ENVMAP_BLENDING_MULTIPLY";
		if (o.envMap) {
			switch (n.envMap.mapping) {
				case 301:
				case 302:
					h = "ENVMAP_TYPE_CUBE";
					break;
				case 306:
				case 307:
					h = "ENVMAP_TYPE_CUBE_UV";
					break;
				case 303:
				case 304:
					h = "ENVMAP_TYPE_EQUIREC";
					break;
				case 305:
					h = "ENVMAP_TYPE_SPHERE"
			}
			switch (n.envMap.mapping) {
				case 302:
				case 304:
					d = "ENVMAP_MODE_REFRACTION"
			}
			switch (n.combine) {
				case 0:
					f = "ENVMAP_BLENDING_MULTIPLY";
					break;
				case 1:
					f = "ENVMAP_BLENDING_MIX";
					break;
				case 2:
					f = "ENVMAP_BLENDING_ADD"
			}
		}
		var p = 0 < t.gammaFactor ? t.gammaFactor : 1,
			m = Yt(n.extensions, o, e),
			g = qt(s),
			v = a.createProgram();
		n.isRawShaderMaterial ? (s = [g].filter($t).join("\n"), 0 < s.length && (s += "\n"), e = [m, g].filter($t).join("\n"), 0 < e.length && (e += "\n")) : (s = ["precision " + o.precision + " float;", "precision " + o.precision + " int;", "#define SHADER_NAME " + r.name, g, o.supportsVertexTextures ? "#define VERTEX_TEXTURES" : "", "#define GAMMA_FACTOR " + p, "#define MAX_BONES " + o.maxBones, o.useFog && o.fog ? "#define USE_FOG" : "", o.useFog && o.fogExp ? "#define FOG_EXP2" : "", o.map ? "#define USE_MAP" : "", o.envMap ? "#define USE_ENVMAP" : "", o.envMap ? "#define " + d : "", o.lightMap ? "#define USE_LIGHTMAP" : "", o.aoMap ? "#define USE_AOMAP" : "", o.emissiveMap ? "#define USE_EMISSIVEMAP" : "", o.bumpMap ? "#define USE_BUMPMAP" : "", o.normalMap ? "#define USE_NORMALMAP" : "", o.displacementMap && o.supportsVertexTextures ? "#define USE_DISPLACEMENTMAP" : "", o.specularMap ? "#define USE_SPECULARMAP" : "", o.roughnessMap ? "#define USE_ROUGHNESSMAP" : "", o.metalnessMap ? "#define USE_METALNESSMAP" : "", o.alphaMap ? "#define USE_ALPHAMAP" : "", o.vertexColors ? "#define USE_COLOR" : "", o.flatShading ? "#define FLAT_SHADED" : "", o.skinning ? "#define USE_SKINNING" : "", o.useVertexTexture ? "#define BONE_TEXTURE" : "", o.morphTargets ? "#define USE_MORPHTARGETS" : "", o.morphNormals && !1 === o.flatShading ? "#define USE_MORPHNORMALS" : "", o.doubleSided ? "#define DOUBLE_SIDED" : "", o.flipSided ? "#define FLIP_SIDED" : "", o.shadowMapEnabled ? "#define USE_SHADOWMAP" : "", o.shadowMapEnabled ? "#define " + u : "", o.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "", o.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "", o.logarithmicDepthBuffer && e.get("EXT_frag_depth") ? "#define USE_LOGDEPTHBUF_EXT" : "", "uniform mat4 modelMatrix;", "uniform mat4 modelViewMatrix;", "uniform mat4 projectionMatrix;", "uniform mat4 viewMatrix;", "uniform mat3 normalMatrix;", "uniform vec3 cameraPosition;", "attribute vec3 position;", "attribute vec3 normal;", "attribute vec2 uv;", "#ifdef USE_COLOR", "\tattribute vec3 color;", "#endif", "#ifdef USE_MORPHTARGETS", "\tattribute vec3 morphTarget0;", "\tattribute vec3 morphTarget1;", "\tattribute vec3 morphTarget2;", "\tattribute vec3 morphTarget3;", "\t#ifdef USE_MORPHNORMALS", "\t\tattribute vec3 morphNormal0;", "\t\tattribute vec3 morphNormal1;", "\t\tattribute vec3 morphNormal2;", "\t\tattribute vec3 morphNormal3;", "\t#else", "\t\tattribute vec3 morphTarget4;", "\t\tattribute vec3 morphTarget5;", "\t\tattribute vec3 morphTarget6;", "\t\tattribute vec3 morphTarget7;", "\t#endif", "#endif", "#ifdef USE_SKINNING", "\tattribute vec4 skinIndex;", "\tattribute vec4 skinWeight;", "#endif", "\n"].filter($t).join("\n"), e = [m, "precision " + o.precision + " float;", "precision " + o.precision + " int;", "#define SHADER_NAME " + r.name, g, o.alphaTest ? "#define ALPHATEST " + o.alphaTest + (o.alphaTest % 1 ? "" : ".0") : "", "#define GAMMA_FACTOR " + p, o.useFog && o.fog ? "#define USE_FOG" : "", o.useFog && o.fogExp ? "#define FOG_EXP2" : "", o.map ? "#define USE_MAP" : "", o.envMap ? "#define USE_ENVMAP" : "", o.envMap ? "#define " + h : "", o.envMap ? "#define " + d : "", o.envMap ? "#define " + f : "", o.lightMap ? "#define USE_LIGHTMAP" : "", o.aoMap ? "#define USE_AOMAP" : "", o.emissiveMap ? "#define USE_EMISSIVEMAP" : "", o.bumpMap ? "#define USE_BUMPMAP" : "", o.normalMap ? "#define USE_NORMALMAP" : "", o.specularMap ? "#define USE_SPECULARMAP" : "", o.roughnessMap ? "#define USE_ROUGHNESSMAP" : "", o.metalnessMap ? "#define USE_METALNESSMAP" : "", o.alphaMap ? "#define USE_ALPHAMAP" : "", o.vertexColors ? "#define USE_COLOR" : "", o.gradientMap ? "#define USE_GRADIENTMAP" : "", o.flatShading ? "#define FLAT_SHADED" : "", o.doubleSided ? "#define DOUBLE_SIDED" : "", o.flipSided ? "#define FLIP_SIDED" : "", o.shadowMapEnabled ? "#define USE_SHADOWMAP" : "", o.shadowMapEnabled ? "#define " + u : "", o.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "", o.physicallyCorrectLights ? "#define PHYSICALLY_CORRECT_LIGHTS" : "", o.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "", o.logarithmicDepthBuffer && e.get("EXT_frag_depth") ? "#define USE_LOGDEPTHBUF_EXT" : "", o.envMap && e.get("EXT_shader_texture_lod") ? "#define TEXTURE_LOD_EXT" : "", "uniform mat4 viewMatrix;", "uniform vec3 cameraPosition;", 0 !== o.toneMapping ? "#define TONE_MAPPING" : "", 0 !== o.toneMapping ? eo.tonemapping_pars_fragment : "", 0 !== o.toneMapping ? Xt("toneMapping", o.toneMapping) : "", o.dithering ? "#define DITHERING" : "", o.outputEncoding || o.mapEncoding || o.envMapEncoding || o.emissiveMapEncoding ? eo.encodings_pars_fragment : "", o.mapEncoding ? Vt("mapTexelToLinear", o.mapEncoding) : "", o.envMapEncoding ? Vt("envMapTexelToLinear", o.envMapEncoding) : "", o.emissiveMapEncoding ? Vt("emissiveMapTexelToLinear", o.emissiveMapEncoding) : "", o.outputEncoding ? Wt("linearToOutputTexel", o.outputEncoding) : "", o.depthPacking ? "#define DEPTH_PACKING " + n.depthPacking : "", "\n"].filter($t).join("\n"));
		l = Qt(l);
		l = Zt(l, o);
		l = Jt(l, o);
		c = Qt(c);
		c = Zt(c, o);
		c = Jt(c, o);
		l = Kt(l);
		c = Kt(c);
		c = e + c;
		l = Ht(a, a.VERTEX_SHADER, s + l);
		c = Ht(a, a.FRAGMENT_SHADER, c);
		a.attachShader(v, l);
		a.attachShader(v, c);
		void 0 !== n.index0AttributeName ? a.bindAttribLocation(v, 0, n.index0AttributeName) : !0 === o.morphTargets && a.bindAttribLocation(v, 0, "position");
		a.linkProgram(v);
		o = a.getProgramInfoLog(v).trim();
		u = a.getShaderInfoLog(l).trim();
		h = a.getShaderInfoLog(c).trim();
		f = d = !0;
		if (!1 === a.getProgramParameter(v, a.LINK_STATUS)) d = !1, console.error("THREE.WebGLProgram: shader error: ", a.getError(), "gl.VALIDATE_STATUS", a.getProgramParameter(v, a.VALIDATE_STATUS), "gl.getProgramInfoLog", o, u, h);
		else if ("" !== o) console.warn("THREE.WebGLProgram: gl.getProgramInfoLog()", o);
		else if ("" === u || "" === h) f = !1;
		f && (this.diagnostics = {
			runnable: d,
			material: n,
			programLog: o,
			vertexShader: {
				log: u,
				prefix: s
			},
			fragmentShader: {
				log: h,
				prefix: e
			}
		});
		a.deleteShader(l);
		a.deleteShader(c);
		var y;
		this.getUniforms = function () {
			void 0 === y && (y = new zt(a, v, t));
			return y
		};
		var x;
		this.getAttributes = function () {
			if (void 0 === x) {
				for (var t = {}, e = a.getProgramParameter(v, a.ACTIVE_ATTRIBUTES), i = 0; i < e; i++) {
					var n = a.getActiveAttrib(v, i).name;
					t[n] = a.getAttribLocation(v, n)
				}
				x = t
			}
			return x
		};
		this.destroy = function () {
			a.deleteProgram(v);
			this.program = void 0
		};
		Object.defineProperties(this, {
			uniforms: {
				get: function () {
					console.warn("THREE.WebGLProgram: .uniforms is now .getUniforms().");
					return this.getUniforms()
				}
			},
			attributes: {
				get: function () {
					console.warn("THREE.WebGLProgram: .attributes is now .getAttributes().");
					return this.getAttributes()
				}
			}
		});
		this.name = r.name;
		this.id = xo++;
		this.code = i;
		this.usedTimes = 1;
		this.program = v;
		this.vertexShader = l;
		this.fragmentShader = c;
		return this
	}

	function ee(h, l, d) {
		function f(t, e) {
			if (t) t.isTexture ? i = t.encoding : t.isWebGLRenderTarget && (console.warn("THREE.WebGLPrograms.getTextureEncodingFromMap: don't use render targets as textures. Use their .texture property instead."), i = t.texture.encoding);
			else var i = 3e3;
			3e3 === i && e && (i = 3007);
			return i
		}
		var c = [],
			p = {
				MeshDepthMaterial: "depth",
				MeshDistanceMaterial: "distanceRGBA",
				MeshNormalMaterial: "normal",
				MeshBasicMaterial: "basic",
				MeshLambertMaterial: "lambert",
				MeshPhongMaterial: "phong",
				MeshToonMaterial: "phong",
				MeshStandardMaterial: "physical",
				MeshPhysicalMaterial: "physical",
				LineBasicMaterial: "basic",
				LineDashedMaterial: "dashed",
				PointsMaterial: "points",
				ShadowMaterial: "shadow"
			},
			r = "precision supportsVertexTextures map mapEncoding envMap envMapMode envMapEncoding lightMap aoMap emissiveMap emissiveMapEncoding bumpMap normalMap displacementMap specularMap roughnessMap metalnessMap gradientMap alphaMap combine vertexColors fog useFog fogExp flatShading sizeAttenuation logarithmicDepthBuffer skinning maxBones useVertexTexture morphTargets morphNormals maxMorphTargets maxMorphNormals premultipliedAlpha numDirLights numPointLights numSpotLights numHemiLights numRectAreaLights shadowMapEnabled shadowMapType toneMapping physicallyCorrectLights alphaTest doubleSided flipSided numClippingPlanes numClipIntersection depthPacking dithering".split(" ");
		this.getParameters = function (t, e, i, n, r, o, a) {
			var s = p[t.type];
			if (a.isSkinnedMesh) {
				var l = a.skeleton.bones;
				if (d.floatVertexTextures) l = 1024;
				else {
					var c = Math.min(Math.floor((d.maxVertexUniforms - 20) / 4), l.length);
					c < l.length ? (console.warn("THREE.WebGLRenderer: Skeleton has " + l.length + " bones. This GPU supports " + c + "."), l = 0) : l = c
				}
			} else l = 0;
			c = d.precision;
			null !== t.precision && (c = d.getMaxPrecision(t.precision), c !== t.precision && console.warn("THREE.WebGLProgram.getParameters:", t.precision, "not supported, using", c, "instead."));
			var u = h.getRenderTarget();
			return {
				shaderID: s,
				precision: c,
				supportsVertexTextures: d.vertexTextures,
				outputEncoding: f(u ? u.texture : null, h.gammaOutput),
				map: !!t.map,
				mapEncoding: f(t.map, h.gammaInput),
				envMap: !!t.envMap,
				envMapMode: t.envMap && t.envMap.mapping,
				envMapEncoding: f(t.envMap, h.gammaInput),
				envMapCubeUV: !!t.envMap && (306 === t.envMap.mapping || 307 === t.envMap.mapping),
				lightMap: !!t.lightMap,
				aoMap: !!t.aoMap,
				emissiveMap: !!t.emissiveMap,
				emissiveMapEncoding: f(t.emissiveMap, h.gammaInput),
				bumpMap: !!t.bumpMap,
				normalMap: !!t.normalMap,
				displacementMap: !!t.displacementMap,
				roughnessMap: !!t.roughnessMap,
				metalnessMap: !!t.metalnessMap,
				specularMap: !!t.specularMap,
				alphaMap: !!t.alphaMap,
				gradientMap: !!t.gradientMap,
				combine: t.combine,
				vertexColors: t.vertexColors,
				fog: !!n,
				useFog: t.fog,
				fogExp: n && n.isFogExp2,
				flatShading: t.flatShading,
				sizeAttenuation: t.sizeAttenuation,
				logarithmicDepthBuffer: d.logarithmicDepthBuffer,
				skinning: t.skinning && 0 < l,
				maxBones: l,
				useVertexTexture: d.floatVertexTextures,
				morphTargets: t.morphTargets,
				morphNormals: t.morphNormals,
				maxMorphTargets: h.maxMorphTargets,
				maxMorphNormals: h.maxMorphNormals,
				numDirLights: e.directional.length,
				numPointLights: e.point.length,
				numSpotLights: e.spot.length,
				numRectAreaLights: e.rectArea.length,
				numHemiLights: e.hemi.length,
				numClippingPlanes: r,
				numClipIntersection: o,
				dithering: t.dithering,
				shadowMapEnabled: h.shadowMap.enabled && a.receiveShadow && 0 < i.length,
				shadowMapType: h.shadowMap.type,
				toneMapping: h.toneMapping,
				physicallyCorrectLights: h.physicallyCorrectLights,
				premultipliedAlpha: t.premultipliedAlpha,
				alphaTest: t.alphaTest,
				doubleSided: 2 === t.side,
				flipSided: 1 === t.side,
				depthPacking: void 0 !== t.depthPacking ? t.depthPacking : !1
			}
		};
		this.getProgramCode = function (t, e) {
			var i = [];
			e.shaderID ? i.push(e.shaderID) : (i.push(t.fragmentShader), i.push(t.vertexShader));
			if (void 0 !== t.defines)
				for (var n in t.defines) i.push(n), i.push(t.defines[n]);
			for (n = 0; n < r.length; n++) i.push(e[r[n]]);
			i.push(t.onBeforeCompile.toString());
			i.push(h.gammaOutput);
			return i.join()
		};
		this.acquireProgram = function (t, e, i, n) {
			for (var r, o = 0, a = c.length; o < a; o++) {
				var s = c[o];
				if (s.code === n) {
					r = s;
					++r.usedTimes;
					break
				}
			}
			void 0 === r && (r = new te(h, l, n, t, e, i), c.push(r));
			return r
		};
		this.releaseProgram = function (t) {
			if (0 === --t.usedTimes) {
				var e = c.indexOf(t);
				c[e] = c[c.length - 1];
				c.pop();
				t.destroy()
			}
		};
		this.programs = c
	}

	function ie() {
		var n = new WeakMap;
		return {
			get: function (t) {
				var e = n.get(t);
				void 0 === e && (e = {}, n.set(t, e));
				return e
			},
			remove: function (t) {
				n.delete(t)
			},
			update: function (t, e, i) {
				n.get(t)[e] = i
			},
			dispose: function () {
				n = new WeakMap
			}
		}
	}

	function ne(t, e) {
		return t.renderOrder !== e.renderOrder ? t.renderOrder - e.renderOrder : t.program && e.program && t.program !== e.program ? t.program.id - e.program.id : t.material.id !== e.material.id ? t.material.id - e.material.id : t.z !== e.z ? t.z - e.z : t.id - e.id
	}

	function re(t, e) {
		return t.renderOrder !== e.renderOrder ? t.renderOrder - e.renderOrder : t.z !== e.z ? e.z - t.z : t.id - e.id
	}

	function oe() {
		var a = [],
			s = 0,
			l = [],
			c = [];
		return {
			opaque: l,
			transparent: c,
			init: function () {
				s = 0;
				l.length = 0;
				c.length = 0
			},
			push: function (t, e, i, n, r) {
				var o = a[s];
				void 0 === o ? (o = {
					id: t.id,
					object: t,
					geometry: e,
					material: i,
					program: i.program,
					renderOrder: t.renderOrder,
					z: n,
					group: r
				}, a[s] = o) : (o.id = t.id, o.object = t, o.geometry = e, o.material = i, o.program = i.program, o.renderOrder = t.renderOrder, o.z = n, o.group = r);
				(!0 === i.transparent ? c : l).push(o);
				s++
			},
			sort: function () {
				1 < l.length && l.sort(ne);
				1 < c.length && c.sort(re)
			}
		}
	}

	function ae() {
		var i = {};
		return {
			get: function (t, e) {
				t = t.id + "," + e.id;
				e = i[t];
				void 0 === e && (e = new oe, i[t] = e);
				return e
			},
			dispose: function () {
				i = {}
			}
		}
	}

	function se() {
		var i = {};
		return {
			get: function (t) {
				if (void 0 !== i[t.id]) return i[t.id];
				switch (t.type) {
					case "DirectionalLight":
						var e = {
							direction: new _t,
							color: new w,
							shadow: !1,
							shadowBias: 0,
							shadowRadius: 1,
							shadowMapSize: new W
						};
						break;
					case "SpotLight":
						e = {
							position: new _t,
							direction: new _t,
							color: new w,
							distance: 0,
							coneCos: 0,
							penumbraCos: 0,
							decay: 0,
							shadow: !1,
							shadowBias: 0,
							shadowRadius: 1,
							shadowMapSize: new W
						};
						break;
					case "PointLight":
						e = {
							position: new _t,
							color: new w,
							distance: 0,
							decay: 0,
							shadow: !1,
							shadowBias: 0,
							shadowRadius: 1,
							shadowMapSize: new W,
							shadowCameraNear: 1,
							shadowCameraFar: 1e3
						};
						break;
					case "HemisphereLight":
						e = {
							direction: new _t,
							skyColor: new w,
							groundColor: new w
						};
						break;
					case "RectAreaLight":
						e = {
							color: new w,
							position: new _t,
							halfWidth: new _t,
							halfHeight: new _t
						}
				}
				return i[t.id] = e
			}
		}
	}

	function le() {
		var x = new se,
			_ = {
				id: _o++,
				hash: "",
				ambient: [0, 0, 0],
				directional: [],
				directionalShadowMap: [],
				directionalShadowMatrix: [],
				spot: [],
				spotShadowMap: [],
				spotShadowMatrix: [],
				rectArea: [],
				point: [],
				pointShadowMap: [],
				pointShadowMatrix: [],
				hemi: []
			},
			b = new _t,
			w = new xt,
			T = new xt;
		return {
			setup: function (t, e, i) {
				var n = 0,
					r = 0,
					o = 0,
					a = 0,
					s = 0,
					l = 0,
					c = 0,
					u = 0;
				i = i.matrixWorldInverse;
				for (var h = 0, d = t.length; h < d; h++) {
					var f = t[h],
						p = f.color,
						m = f.intensity,
						g = f.distance,
						v = f.shadow && f.shadow.map ? f.shadow.map.texture : null;
					if (f.isAmbientLight) n += p.r * m, r += p.g * m, o += p.b * m;
					else if (f.isDirectionalLight) {
						var y = x.get(f);
						y.color.copy(f.color).multiplyScalar(f.intensity);
						y.direction.setFromMatrixPosition(f.matrixWorld);
						b.setFromMatrixPosition(f.target.matrixWorld);
						y.direction.sub(b);
						y.direction.transformDirection(i);
						if (y.shadow = f.castShadow) p = f.shadow, y.shadowBias = p.bias, y.shadowRadius = p.radius, y.shadowMapSize = p.mapSize;
						_.directionalShadowMap[a] = v;
						_.directionalShadowMatrix[a] = f.shadow.matrix;
						_.directional[a] = y;
						a++
					} else if (f.isSpotLight) {
						y = x.get(f);
						y.position.setFromMatrixPosition(f.matrixWorld);
						y.position.applyMatrix4(i);
						y.color.copy(p).multiplyScalar(m);
						y.distance = g;
						y.direction.setFromMatrixPosition(f.matrixWorld);
						b.setFromMatrixPosition(f.target.matrixWorld);
						y.direction.sub(b);
						y.direction.transformDirection(i);
						y.coneCos = Math.cos(f.angle);
						y.penumbraCos = Math.cos(f.angle * (1 - f.penumbra));
						y.decay = 0 === f.distance ? 0 : f.decay;
						if (y.shadow = f.castShadow) p = f.shadow, y.shadowBias = p.bias, y.shadowRadius = p.radius, y.shadowMapSize = p.mapSize;
						_.spotShadowMap[l] = v;
						_.spotShadowMatrix[l] = f.shadow.matrix;
						_.spot[l] = y;
						l++
					} else if (f.isRectAreaLight) y = x.get(f), y.color.copy(p).multiplyScalar(m), y.position.setFromMatrixPosition(f.matrixWorld), y.position.applyMatrix4(i), T.identity(), w.copy(f.matrixWorld), w.premultiply(i), T.extractRotation(w), y.halfWidth.set(.5 * f.width, 0, 0), y.halfHeight.set(0, .5 * f.height, 0), y.halfWidth.applyMatrix4(T), y.halfHeight.applyMatrix4(T), _.rectArea[c] = y, c++;
					else if (f.isPointLight) {
						y = x.get(f);
						y.position.setFromMatrixPosition(f.matrixWorld);
						y.position.applyMatrix4(i);
						y.color.copy(f.color).multiplyScalar(f.intensity);
						y.distance = f.distance;
						y.decay = 0 === f.distance ? 0 : f.decay;
						if (y.shadow = f.castShadow) p = f.shadow, y.shadowBias = p.bias, y.shadowRadius = p.radius, y.shadowMapSize = p.mapSize, y.shadowCameraNear = p.camera.near, y.shadowCameraFar = p.camera.far;
						_.pointShadowMap[s] = v;
						_.pointShadowMatrix[s] = f.shadow.matrix;
						_.point[s] = y;
						s++
					} else f.isHemisphereLight && (y = x.get(f), y.direction.setFromMatrixPosition(f.matrixWorld), y.direction.transformDirection(i), y.direction.normalize(), y.skyColor.copy(f.color).multiplyScalar(m), y.groundColor.copy(f.groundColor).multiplyScalar(m), _.hemi[u] = y, u++)
				}
				_.ambient[0] = n;
				_.ambient[1] = r;
				_.ambient[2] = o;
				_.directional.length = a;
				_.spot.length = l;
				_.rectArea.length = c;
				_.point.length = s;
				_.hemi.length = u;
				_.hash = _.id + "," + a + "," + s + "," + l + "," + c + "," + u + "," + e.length
			},
			state: _
		}
	}

	function ce() {
		var e = new le,
			i = [],
			n = [],
			r = [];
		return {
			init: function () {
				i.length = 0;
				n.length = 0;
				r.length = 0
			},
			state: {
				lightsArray: i,
				shadowsArray: n,
				spritesArray: r,
				lights: e
			},
			setupLights: function (t) {
				e.setup(i, n, t)
			},
			pushLight: function (t) {
				i.push(t)
			},
			pushShadow: function (t) {
				n.push(t)
			},
			pushSprite: function (t) {
				r.push(t)
			}
		}
	}

	function ue() {
		var i = {};
		return {
			get: function (t, e) {
				t = t.id + "," + e.id;
				e = i[t];
				void 0 === e && (e = new ce, i[t] = e);
				return e
			},
			dispose: function () {
				i = {}
			}
		}
	}

	function he(t) {
		k.call(this);
		this.type = "MeshDepthMaterial";
		this.depthPacking = 3200;
		this.morphTargets = this.skinning = !1;
		this.displacementMap = this.alphaMap = this.map = null;
		this.displacementScale = 1;
		this.displacementBias = 0;
		this.wireframe = !1;
		this.wireframeLinewidth = 1;
		this.lights = this.fog = !1;
		this.setValues(t)
	}

	function de(t) {
		k.call(this);
		this.type = "MeshDistanceMaterial";
		this.referencePosition = new _t;
		this.nearDistance = 1;
		this.farDistance = 1e3;
		this.morphTargets = this.skinning = !1;
		this.displacementMap = this.alphaMap = this.map = null;
		this.displacementScale = 1;
		this.displacementBias = 0;
		this.lights = this.fog = !1;
		this.setValues(t)
	}

	function fe(d, h, t) {
		function f(t, e, i, n, r, o) {
			var a = t.geometry;
			var s = c;
			var l = t.customDepthMaterial;
			i && (s = u, l = t.customDistanceMaterial);
			l ? s = l : (l = !1, e.morphTargets && (a && a.isBufferGeometry ? l = a.morphAttributes && a.morphAttributes.position && 0 < a.morphAttributes.position.length : a && a.isGeometry && (l = a.morphTargets && 0 < a.morphTargets.length)), t.isSkinnedMesh && !1 === e.skinning && console.warn("THREE.WebGLShadowMap: THREE.SkinnedMesh with material.skinning set to false:", t), t = t.isSkinnedMesh && e.skinning, a = 0, l && (a |= 1), t && (a |= 2), s = s[a]);
			d.localClippingEnabled && !0 === e.clipShadows && 0 !== e.clippingPlanes.length && (a = s.uuid, l = e.uuid, t = b[a], void 0 === t && (t = {}, b[a] = t), a = t[l], void 0 === a && (a = s.clone(), t[l] = a), s = a);
			s.visible = e.visible;
			s.wireframe = e.wireframe;
			s.side = null != e.shadowSide ? e.shadowSide : w[e.side];
			s.clipShadows = e.clipShadows;
			s.clippingPlanes = e.clippingPlanes;
			s.clipIntersection = e.clipIntersection;
			s.wireframeLinewidth = e.wireframeLinewidth;
			s.linewidth = e.linewidth;
			i && s.isMeshDistanceMaterial && (s.referencePosition.copy(n), s.nearDistance = r, s.farDistance = o);
			return s
		}

		function p(t, e, i, n) {
			if (!1 !== t.visible) {
				if (t.layers.test(e.layers) && (t.isMesh || t.isLine || t.isPoints) && t.castShadow && (!t.frustumCulled || m.intersectsObject(t))) {
					t.modelViewMatrix.multiplyMatrices(i.matrixWorldInverse, t.matrixWorld);
					var r = h.update(t),
						o = t.material;
					if (Array.isArray(o))
						for (var a = r.groups, s = 0, l = a.length; s < l; s++) {
							var c = a[s],
								u = o[c.materialIndex];
							u && u.visible && (u = f(t, u, n, _, i.near, i.far), d.renderBufferDirect(i, null, r, u, t, c))
						} else o.visible && (u = f(t, o, n, _, i.near, i.far), d.renderBufferDirect(i, null, r, u, t, null))
				}
				t = t.children;
				r = 0;
				for (o = t.length; r < o; r++) p(t[r], e, i, n)
			}
		}
		var m = new Tt,
			g = new xt,
			v = new W,
			y = new W(t, t),
			x = new _t,
			_ = new _t,
			c = Array(4),
			u = Array(4),
			b = {},
			w = {
				0: 1,
				1: 0,
				2: 2
			},
			T = [new _t(1, 0, 0), new _t(-1, 0, 0), new _t(0, 0, 1), new _t(0, 0, -1), new _t(0, 1, 0), new _t(0, -1, 0)],
			E = [new _t(0, 1, 0), new _t(0, 1, 0), new _t(0, 1, 0), new _t(0, 1, 0), new _t(0, 0, 1), new _t(0, 0, -1)],
			S = [new bt, new bt, new bt, new bt, new bt, new bt];
		for (t = 0; 4 !== t; ++t) {
			var e = 0 !== (t & 1),
				i = 0 !== (t & 2),
				n = new he({
					depthPacking: 3201,
					morphTargets: e,
					skinning: i
				});
			c[t] = n;
			e = new de({
				morphTargets: e,
				skinning: i
			});
			u[t] = e
		}
		var M = this;
		this.enabled = !1;
		this.autoUpdate = !0;
		this.needsUpdate = !1;
		this.type = 1;
		this.render = function (t, e, i) {
			if (!1 !== M.enabled && (!1 !== M.autoUpdate || !1 !== M.needsUpdate) && 0 !== t.length) {
				var n = d.state;
				n.disable(d.context.BLEND);
				n.buffers.color.setClear(1, 1, 1, 1);
				n.buffers.depth.setTest(!0);
				n.setScissorTest(!1);
				for (var r, o = 0, a = t.length; o < a; o++) {
					var s = t[o];
					r = s.shadow;
					var l = s && s.isPointLight;
					if (void 0 === r) console.warn("THREE.WebGLShadowMap:", s, "has no shadow.");
					else {
						var c = r.camera;
						v.copy(r.mapSize);
						v.min(y);
						if (l) {
							var u = v.x,
								h = v.y;
							S[0].set(2 * u, h, u, h);
							S[1].set(0, h, u, h);
							S[2].set(3 * u, h, u, h);
							S[3].set(u, h, u, h);
							S[4].set(3 * u, 0, u, h);
							S[5].set(u, 0, u, h);
							v.x *= 4;
							v.y *= 2
						}
						null === r.map && (r.map = new A(v.x, v.y, {
							minFilter: 1003,
							magFilter: 1003,
							format: 1023
						}), r.map.texture.name = s.name + ".shadowMap", c.updateProjectionMatrix());
						r.isSpotLightShadow && r.update(s);
						u = r.map;
						h = r.matrix;
						_.setFromMatrixPosition(s.matrixWorld);
						c.position.copy(_);
						l ? (r = 6, h.makeTranslation(-_.x, -_.y, -_.z)) : (r = 1, x.setFromMatrixPosition(s.target.matrixWorld), c.lookAt(x), c.updateMatrixWorld(), h.set(.5, 0, 0, .5, 0, .5, 0, .5, 0, 0, .5, .5, 0, 0, 0, 1), h.multiply(c.projectionMatrix), h.multiply(c.matrixWorldInverse));
						d.setRenderTarget(u);
						d.clear();
						for (s = 0; s < r; s++) l && (x.copy(c.position), x.add(T[s]), c.up.copy(E[s]), c.lookAt(x), c.updateMatrixWorld(), n.viewport(S[s])), g.multiplyMatrices(c.projectionMatrix, c.matrixWorldInverse), m.setFromMatrix(g), p(e, i, c, l)
					}
				}
				M.needsUpdate = !1
			}
		}
	}

	function pe(t, e, i, n, r, o, a, s, l) {
		d.call(this, t, e, i, n, r, o, a, s, l);
		this.needsUpdate = !0
	}

	function me(d, f, p, m, g) {
		var v, y, x, _, b, w, T, E, S, M, A, C, P, L, R, O, k, N;

		function I(t, e) {
			return t.renderOrder !== e.renderOrder ? t.renderOrder - e.renderOrder : t.z !== e.z ? e.z - t.z : e.id - t.id
		}
		var D, F, B, U, z = new _t,
			G = new j,
			H = new _t;
		this.render = function (t, e, i) {
			if (0 !== t.length) {
				if (void 0 === B) {
					var n = new Float32Array([-.5, -.5, 0, 0, .5, -.5, 1, 0, .5, .5, 1, 1, -.5, .5, 0, 1]),
						r = new Uint16Array([0, 1, 2, 0, 2, 3]);
					D = f.createBuffer();
					F = f.createBuffer();
					f.bindBuffer(f.ARRAY_BUFFER, D);
					f.bufferData(f.ARRAY_BUFFER, n, f.STATIC_DRAW);
					f.bindBuffer(f.ELEMENT_ARRAY_BUFFER, F);
					f.bufferData(f.ELEMENT_ARRAY_BUFFER, r, f.STATIC_DRAW);
					n = f.createProgram();
					r = f.createShader(f.VERTEX_SHADER);
					var o = f.createShader(f.FRAGMENT_SHADER);
					f.shaderSource(r, ["precision " + g.precision + " float;", "#define SHADER_NAME SpriteMaterial\nuniform mat4 modelViewMatrix;\nuniform mat4 projectionMatrix;\nuniform float rotation;\nuniform vec2 center;\nuniform vec2 scale;\nuniform vec2 uvOffset;\nuniform vec2 uvScale;\nattribute vec2 position;\nattribute vec2 uv;\nvarying vec2 vUV;\nvarying float fogDepth;\nvoid main() {\n\tvUV = uvOffset + uv * uvScale;\n\tvec2 alignedPosition = ( position - center ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tvec4 mvPosition;\n\tmvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\tfogDepth = - mvPosition.z;\n}"].join("\n"));
					f.shaderSource(o, ["precision " + g.precision + " float;", "#define SHADER_NAME SpriteMaterial\nuniform vec3 color;\nuniform sampler2D map;\nuniform float opacity;\nuniform int fogType;\nuniform vec3 fogColor;\nuniform float fogDensity;\nuniform float fogNear;\nuniform float fogFar;\nuniform float alphaTest;\nvarying vec2 vUV;\nvarying float fogDepth;\nvoid main() {\n\tvec4 texture = texture2D( map, vUV );\n\tgl_FragColor = vec4( color * texture.xyz, texture.a * opacity );\n\tif ( gl_FragColor.a < alphaTest ) discard;\n\tif ( fogType > 0 ) {\n\t\tfloat fogFactor = 0.0;\n\t\tif ( fogType == 1 ) {\n\t\t\tfogFactor = smoothstep( fogNear, fogFar, fogDepth );\n\t\t} else {\n\t\t\tconst float LOG2 = 1.442695;\n\t\t\tfogFactor = exp2( - fogDensity * fogDensity * fogDepth * fogDepth * LOG2 );\n\t\t\tfogFactor = 1.0 - clamp( fogFactor, 0.0, 1.0 );\n\t\t}\n\t\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n\t}\n}"].join("\n"));
					f.compileShader(r);
					f.compileShader(o);
					f.attachShader(n, r);
					f.attachShader(n, o);
					f.linkProgram(n);
					B = n;
					k = f.getAttribLocation(B, "position");
					N = f.getAttribLocation(B, "uv");
					v = f.getUniformLocation(B, "uvOffset");
					y = f.getUniformLocation(B, "uvScale");
					x = f.getUniformLocation(B, "rotation");
					_ = f.getUniformLocation(B, "center");
					b = f.getUniformLocation(B, "scale");
					w = f.getUniformLocation(B, "color");
					T = f.getUniformLocation(B, "map");
					E = f.getUniformLocation(B, "opacity");
					S = f.getUniformLocation(B, "modelViewMatrix");
					M = f.getUniformLocation(B, "projectionMatrix");
					A = f.getUniformLocation(B, "fogType");
					C = f.getUniformLocation(B, "fogDensity");
					P = f.getUniformLocation(B, "fogNear");
					L = f.getUniformLocation(B, "fogFar");
					R = f.getUniformLocation(B, "fogColor");
					f.getUniformLocation(B, "fogDepth");
					O = f.getUniformLocation(B, "alphaTest");
					n = document.createElementNS("http://www.w3.org/1999/xhtml", "canvas");
					n.width = 8;
					n.height = 8;
					r = n.getContext("2d");
					r.fillStyle = "white";
					r.fillRect(0, 0, 8, 8);
					U = new pe(n)
				}
				p.useProgram(B);
				p.initAttributes();
				p.enableAttribute(k);
				p.enableAttribute(N);
				p.disableUnusedAttributes();
				p.disable(f.CULL_FACE);
				p.enable(f.BLEND);
				f.bindBuffer(f.ARRAY_BUFFER, D);
				f.vertexAttribPointer(k, 2, f.FLOAT, !1, 16, 0);
				f.vertexAttribPointer(N, 2, f.FLOAT, !1, 16, 8);
				f.bindBuffer(f.ELEMENT_ARRAY_BUFFER, F);
				f.uniformMatrix4fv(M, !1, i.projectionMatrix.elements);
				p.activeTexture(f.TEXTURE0);
				f.uniform1i(T, 0);
				r = n = 0;
				(o = e.fog) ? (f.uniform3f(R, o.color.r, o.color.g, o.color.b), o.isFog ? (f.uniform1f(P, o.near), f.uniform1f(L, o.far), f.uniform1i(A, 1), r = n = 1) : o.isFogExp2 && (f.uniform1f(C, o.density), f.uniform1i(A, 2), r = n = 2)) : (f.uniform1i(A, 0), r = n = 0);
				o = 0;
				for (var a = t.length; o < a; o++) {
					var s = t[o];
					s.modelViewMatrix.multiplyMatrices(i.matrixWorldInverse, s.matrixWorld);
					s.z = -s.modelViewMatrix.elements[14]
				}
				t.sort(I);
				var l = [],
					c = [];
				o = 0;
				for (a = t.length; o < a; o++) {
					s = t[o];
					var u = s.material;
					if (!1 !== u.visible) {
						s.onBeforeRender(d, e, i, void 0, u, void 0);
						f.uniform1f(O, u.alphaTest);
						f.uniformMatrix4fv(S, !1, s.modelViewMatrix.elements);
						s.matrixWorld.decompose(z, G, H);
						l[0] = H.x;
						l[1] = H.y;
						c[0] = s.center.x - .5;
						c[1] = s.center.y - .5;
						var h = 0;
						e.fog && u.fog && (h = r);
						n !== h && (f.uniform1i(A, h), n = h);
						null !== u.map ? (f.uniform2f(v, u.map.offset.x, u.map.offset.y), f.uniform2f(y, u.map.repeat.x, u.map.repeat.y)) : (f.uniform2f(v, 0, 0), f.uniform2f(y, 1, 1));
						f.uniform1f(E, u.opacity);
						f.uniform3f(w, u.color.r, u.color.g, u.color.b);
						f.uniform1f(x, u.rotation);
						f.uniform2fv(_, c);
						f.uniform2fv(b, l);
						p.setBlending(u.blending, u.blendEquation, u.blendSrc, u.blendDst, u.blendEquationAlpha, u.blendSrcAlpha, u.blendDstAlpha, u.premultipliedAlpha);
						p.buffers.depth.setTest(u.depthTest);
						p.buffers.depth.setMask(u.depthWrite);
						p.buffers.color.setMask(u.colorWrite);
						m.setTexture2D(u.map || U, 0);
						f.drawElements(f.TRIANGLES, 6, f.UNSIGNED_SHORT, 0);
						s.onAfterRender(d, e, i, void 0, u, void 0)
					}
				}
				p.enable(f.CULL_FACE);
				p.reset()
			}
		}
	}

	function ge(u, i, l) {
		function t(t, e, i) {
			var n = new Uint8Array(4),
				r = u.createTexture();
			u.bindTexture(t, r);
			u.texParameteri(t, u.TEXTURE_MIN_FILTER, u.NEAREST);
			u.texParameteri(t, u.TEXTURE_MAG_FILTER, u.NEAREST);
			for (t = 0; t < i; t++) u.texImage2D(e + t, 0, u.RGBA, 1, 1, 0, u.RGBA, u.UNSIGNED_BYTE, n);
			return r
		}

		function e(t, e) {
			g[t] = 1;
			0 === v[t] && (u.enableVertexAttribArray(t), v[t] = 1);
			y[t] !== e && (i.get("ANGLE_instanced_arrays").vertexAttribDivisorANGLE(t, e), y[t] = e)
		}

		function h(t) {
			!0 !== x[t] && (u.enable(t), x[t] = !0)
		}

		function d(t) {
			!1 !== x[t] && (u.disable(t), x[t] = !1)
		}

		function n(t, e, i, n, r, o, a, s) {
			0 !== t ? h(u.BLEND) : d(u.BLEND);
			if (5 !== t) {
				if (t !== w || s !== P) switch (t) {
					case 2:
						s ? (u.blendEquationSeparate(u.FUNC_ADD, u.FUNC_ADD), u.blendFuncSeparate(u.ONE, u.ONE, u.ONE, u.ONE)) : (u.blendEquation(u.FUNC_ADD), u.blendFunc(u.SRC_ALPHA, u.ONE));
						break;
					case 3:
						s ? (u.blendEquationSeparate(u.FUNC_ADD, u.FUNC_ADD), u.blendFuncSeparate(u.ZERO, u.ZERO, u.ONE_MINUS_SRC_COLOR, u.ONE_MINUS_SRC_ALPHA)) : (u.blendEquation(u.FUNC_ADD), u.blendFunc(u.ZERO, u.ONE_MINUS_SRC_COLOR));
						break;
					case 4:
						s ? (u.blendEquationSeparate(u.FUNC_ADD, u.FUNC_ADD), u.blendFuncSeparate(u.ZERO, u.SRC_COLOR, u.ZERO, u.SRC_ALPHA)) : (u.blendEquation(u.FUNC_ADD), u.blendFunc(u.ZERO, u.SRC_COLOR));
						break;
					default:
						s ? (u.blendEquationSeparate(u.FUNC_ADD, u.FUNC_ADD), u.blendFuncSeparate(u.ONE, u.ONE_MINUS_SRC_ALPHA, u.ONE, u.ONE_MINUS_SRC_ALPHA)) : (u.blendEquationSeparate(u.FUNC_ADD, u.FUNC_ADD), u.blendFuncSeparate(u.SRC_ALPHA, u.ONE_MINUS_SRC_ALPHA, u.ONE, u.ONE_MINUS_SRC_ALPHA))
				}
				C = A = M = S = E = T = null
			} else {
				r = r || e;
				o = o || i;
				a = a || n;
				if (e !== T || r !== M) u.blendEquationSeparate(l.convert(e), l.convert(r)), T = e, M = r;
				if (i !== E || n !== S || o !== A || a !== C) u.blendFuncSeparate(l.convert(i), l.convert(n), l.convert(o), l.convert(a)), E = i, S = n, A = o, C = a
			}
			w = t;
			P = s
		}

		function r(t) {
			L !== t && (t ? u.frontFace(u.CW) : u.frontFace(u.CCW), L = t)
		}

		function o(t) {
			0 !== t ? (h(u.CULL_FACE), t !== R && (1 === t ? u.cullFace(u.BACK) : 2 === t ? u.cullFace(u.FRONT) : u.cullFace(u.FRONT_AND_BACK))) : d(u.CULL_FACE);
			R = t
		}

		function a(t, e, i) {
			if (t) {
				if (h(u.POLYGON_OFFSET_FILL), k !== e || N !== i) u.polygonOffset(e, i), k = e, N = i
			} else d(u.POLYGON_OFFSET_FILL)
		}

		function s(t) {
			void 0 === t && (t = u.TEXTURE0 + I - 1);
			F !== t && (u.activeTexture(t), F = t)
		}
		var c = new function () {
				var e = !1,
					o = new bt,
					i = null,
					a = new bt(0, 0, 0, 0);
				return {
					setMask: function (t) {
						i === t || e || (u.colorMask(t, t, t, t), i = t)
					},
					setLocked: function (t) {
						e = t
					},
					setClear: function (t, e, i, n, r) {
						!0 === r && (t *= n, e *= n, i *= n);
						o.set(t, e, i, n);
						!1 === a.equals(o) && (u.clearColor(t, e, i, n), a.copy(o))
					},
					reset: function () {
						e = !1;
						i = null;
						a.set(-1, 0, 0, 0)
					}
				}
			},
			f = new function () {
				var e = !1,
					i = null,
					n = null,
					r = null;
				return {
					setTest: function (t) {
						t ? h(u.DEPTH_TEST) : d(u.DEPTH_TEST)
					},
					setMask: function (t) {
						i === t || e || (u.depthMask(t), i = t)
					},
					setFunc: function (t) {
						if (n !== t) {
							if (t) switch (t) {
								case 0:
									u.depthFunc(u.NEVER);
									break;
								case 1:
									u.depthFunc(u.ALWAYS);
									break;
								case 2:
									u.depthFunc(u.LESS);
									break;
								case 3:
									u.depthFunc(u.LEQUAL);
									break;
								case 4:
									u.depthFunc(u.EQUAL);
									break;
								case 5:
									u.depthFunc(u.GEQUAL);
									break;
								case 6:
									u.depthFunc(u.GREATER);
									break;
								case 7:
									u.depthFunc(u.NOTEQUAL);
									break;
								default:
									u.depthFunc(u.LEQUAL)
							} else u.depthFunc(u.LEQUAL);
							n = t
						}
					},
					setLocked: function (t) {
						e = t
					},
					setClear: function (t) {
						r !== t && (u.clearDepth(t), r = t)
					},
					reset: function () {
						e = !1;
						r = n = i = null
					}
				}
			},
			p = new function () {
				var e = !1,
					i = null,
					n = null,
					r = null,
					o = null,
					a = null,
					s = null,
					l = null,
					c = null;
				return {
					setTest: function (t) {
						t ? h(u.STENCIL_TEST) : d(u.STENCIL_TEST)
					},
					setMask: function (t) {
						i === t || e || (u.stencilMask(t), i = t)
					},
					setFunc: function (t, e, i) {
						if (n !== t || r !== e || o !== i) u.stencilFunc(t, e, i), n = t, r = e, o = i
					},
					setOp: function (t, e, i) {
						if (a !== t || s !== e || l !== i) u.stencilOp(t, e, i), a = t, s = e, l = i
					},
					setLocked: function (t) {
						e = t
					},
					setClear: function (t) {
						c !== t && (u.clearStencil(t), c = t)
					},
					reset: function () {
						e = !1;
						c = l = s = a = o = r = n = i = null
					}
				}
			},
			m = u.getParameter(u.MAX_VERTEX_ATTRIBS),
			g = new Uint8Array(m),
			v = new Uint8Array(m),
			y = new Uint8Array(m),
			x = {},
			_ = null,
			b = null,
			w = null,
			T = null,
			E = null,
			S = null,
			M = null,
			A = null,
			C = null,
			P = !1,
			L = null,
			R = null,
			O = null,
			k = null,
			N = null,
			I = u.getParameter(u.MAX_COMBINED_TEXTURE_IMAGE_UNITS),
			D = !1;
		m = 0;
		m = u.getParameter(u.VERSION); - 1 !== m.indexOf("WebGL") ? (m = parseFloat(/^WebGL ([0-9])/.exec(m)[1]), D = 1 <= m) : -1 !== m.indexOf("OpenGL ES") && (m = parseFloat(/^OpenGL ES ([0-9])/.exec(m)[1]), D = 2 <= m);
		var F = null,
			B = {},
			U = new bt,
			z = new bt,
			G = {};
		G[u.TEXTURE_2D] = t(u.TEXTURE_2D, u.TEXTURE_2D, 1);
		G[u.TEXTURE_CUBE_MAP] = t(u.TEXTURE_CUBE_MAP, u.TEXTURE_CUBE_MAP_POSITIVE_X, 6);
		c.setClear(0, 0, 0, 1);
		f.setClear(1);
		p.setClear(0);
		h(u.DEPTH_TEST);
		f.setFunc(3);
		r(!1);
		o(1);
		h(u.CULL_FACE);
		h(u.BLEND);
		n(1);
		return {
			buffers: {
				color: c,
				depth: f,
				stencil: p
			},
			initAttributes: function () {
				for (var t = 0, e = g.length; t < e; t++) g[t] = 0
			},
			enableAttribute: function (t) {
				e(t, 0)
			},
			enableAttributeAndDivisor: e,
			disableUnusedAttributes: function () {
				for (var t = 0, e = v.length; t !== e; ++t) v[t] !== g[t] && (u.disableVertexAttribArray(t), v[t] = 0)
			},
			enable: h,
			disable: d,
			getCompressedTextureFormats: function () {
				if (null === _ && (_ = [], i.get("WEBGL_compressed_texture_pvrtc") || i.get("WEBGL_compressed_texture_s3tc") || i.get("WEBGL_compressed_texture_etc1") || i.get("WEBGL_compressed_texture_astc")))
					for (var t = u.getParameter(u.COMPRESSED_TEXTURE_FORMATS), e = 0; e < t.length; e++) _.push(t[e]);
				return _
			},
			useProgram: function (t) {
				return b !== t ? (u.useProgram(t), b = t, !0) : !1
			},
			setBlending: n,
			setMaterial: function (t, e) {
				2 === t.side ? d(u.CULL_FACE) : h(u.CULL_FACE);
				var i = 1 === t.side;
				e && (i = !i);
				r(i);
				!0 === t.transparent ? n(t.blending, t.blendEquation, t.blendSrc, t.blendDst, t.blendEquationAlpha, t.blendSrcAlpha, t.blendDstAlpha, t.premultipliedAlpha) : n(0);
				f.setFunc(t.depthFunc);
				f.setTest(t.depthTest);
				f.setMask(t.depthWrite);
				c.setMask(t.colorWrite);
				a(t.polygonOffset, t.polygonOffsetFactor, t.polygonOffsetUnits)
			},
			setFlipSided: r,
			setCullFace: o,
			setLineWidth: function (t) {
				t !== O && (D && u.lineWidth(t), O = t)
			},
			setPolygonOffset: a,
			setScissorTest: function (t) {
				t ? h(u.SCISSOR_TEST) : d(u.SCISSOR_TEST)
			},
			activeTexture: s,
			bindTexture: function (t, e) {
				null === F && s();
				var i = B[F];
				void 0 === i && (i = {
					type: void 0,
					texture: void 0
				}, B[F] = i);
				if (i.type !== t || i.texture !== e) u.bindTexture(t, e || G[t]), i.type = t, i.texture = e
			},
			compressedTexImage2D: function () {
				try {
					u.compressedTexImage2D.apply(u, arguments)
				} catch (t) {
					console.error("THREE.WebGLState:", t)
				}
			},
			texImage2D: function () {
				try {
					u.texImage2D.apply(u, arguments)
				} catch (t) {
					console.error("THREE.WebGLState:", t)
				}
			},
			scissor: function (t) {
				!1 === U.equals(t) && (u.scissor(t.x, t.y, t.z, t.w), U.copy(t))
			},
			viewport: function (t) {
				!1 === z.equals(t) && (u.viewport(t.x, t.y, t.z, t.w), z.copy(t))
			},
			reset: function () {
				for (var t = 0; t < v.length; t++) 1 === v[t] && (u.disableVertexAttribArray(t), v[t] = 0);
				x = {};
				F = _ = null;
				B = {};
				R = L = w = b = null;
				c.reset();
				f.reset();
				p.reset()
			}
		}
	}

	function ve(p, n, m, g, v, y, x) {
		function _(t, e) {
			if (t.width > e || t.height > e) {
				if ("data" in t) {
					console.warn("THREE.WebGLRenderer: image in DataTexture is too big (" + t.width + "x" + t.height + ").");
					return
				}
				e /= Math.max(t.width, t.height);
				var i = document.createElementNS("http://www.w3.org/1999/xhtml", "canvas");
				i.width = Math.floor(t.width * e);
				i.height = Math.floor(t.height * e);
				i.getContext("2d").drawImage(t, 0, 0, t.width, t.height, 0, 0, i.width, i.height);
				console.warn("THREE.WebGLRenderer: image is too big (" + t.width + "x" + t.height + "). Resized to " + i.width + "x" + i.height, t);
				return i
			}
			return t
		}

		function b(t) {
			return Kr.isPowerOfTwo(t.width) && Kr.isPowerOfTwo(t.height)
		}

		function w(t, e) {
			return t.generateMipmaps && e && 1003 !== t.minFilter && 1006 !== t.minFilter
		}

		function T(t, e, i, n) {
			p.generateMipmap(t);
			g.get(e).__maxMipLevel = Math.log(Math.max(i, n)) * Math.LOG2E
		}

		function r(t) {
			return 1003 === t || 1004 === t || 1005 === t ? p.NEAREST : p.LINEAR
		}

		function E(t) {
			t = t.target;
			t.removeEventListener("dispose", E);
			t: {
				var e = g.get(t);
				if (t.image && e.__image__webglTextureCube) p.deleteTexture(e.__image__webglTextureCube);
				else {
					if (void 0 === e.__webglInit) break t;
					p.deleteTexture(e.__webglTexture)
				}
				g.remove(t)
			}
			t.isVideoTexture && delete h[t.id];
			x.memory.textures--
		}

		function a(t) {
			t = t.target;
			t.removeEventListener("dispose", a);
			var e = g.get(t),
				i = g.get(t.texture);
			if (t) {
				void 0 !== i.__webglTexture && p.deleteTexture(i.__webglTexture);
				t.depthTexture && t.depthTexture.dispose();
				if (t.isWebGLRenderTargetCube)
					for (i = 0; 6 > i; i++) p.deleteFramebuffer(e.__webglFramebuffer[i]), e.__webglDepthbuffer && p.deleteRenderbuffer(e.__webglDepthbuffer[i]);
				else p.deleteFramebuffer(e.__webglFramebuffer), e.__webglDepthbuffer && p.deleteRenderbuffer(e.__webglDepthbuffer);
				g.remove(t.texture);
				g.remove(t)
			}
			x.memory.textures--
		}

		function s(t, e) {
			var i = g.get(t);
			if (t.isVideoTexture) {
				var n = t.id,
					r = x.render.frame;
				h[n] !== r && (h[n] = r, t.update())
			}
			if (0 < t.version && i.__version !== t.version)
				if (n = t.image, void 0 === n) console.warn("THREE.WebGLRenderer: Texture marked for update but image is undefined", t);
				else if (!1 === n.complete) console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete", t);
			else {
				void 0 === i.__webglInit && (i.__webglInit = !0, t.addEventListener("dispose", E), i.__webglTexture = p.createTexture(), x.memory.textures++);
				m.activeTexture(p.TEXTURE0 + e);
				m.bindTexture(p.TEXTURE_2D, i.__webglTexture);
				p.pixelStorei(p.UNPACK_FLIP_Y_WEBGL, t.flipY);
				p.pixelStorei(p.UNPACK_PREMULTIPLY_ALPHA_WEBGL, t.premultiplyAlpha);
				p.pixelStorei(p.UNPACK_ALIGNMENT, t.unpackAlignment);
				e = _(t.image, v.maxTextureSize);
				(1001 !== t.wrapS || 1001 !== t.wrapT || 1003 !== t.minFilter && 1006 !== t.minFilter) && !1 === b(e) && (e instanceof HTMLImageElement || e instanceof HTMLCanvasElement || e instanceof ImageBitmap) && (void 0 === d && (d = document.createElementNS("http://www.w3.org/1999/xhtml", "canvas")), d.width = Kr.floorPowerOfTwo(e.width), d.height = Kr.floorPowerOfTwo(e.height), d.getContext("2d").drawImage(e, 0, 0, d.width, d.height), console.warn("THREE.WebGLRenderer: image is not power of two (" + e.width + "x" + e.height + "). Resized to " + d.width + "x" + d.height, e), e = d);
				n = b(e);
				r = y.convert(t.format);
				var o = y.convert(t.type);
				S(p.TEXTURE_2D, t, n);
				var a = t.mipmaps;
				if (t.isDepthTexture) {
					var s = p.DEPTH_COMPONENT;
					if (1015 === t.type) {
						if (!u) throw Error("Float Depth Texture only supported in WebGL2.0");
						s = p.DEPTH_COMPONENT32F
					} else u && (s = p.DEPTH_COMPONENT16);
					1026 === t.format && s === p.DEPTH_COMPONENT && 1012 !== t.type && 1014 !== t.type && (console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture."), t.type = 1012, o = y.convert(t.type));
					1027 === t.format && (s = p.DEPTH_STENCIL, 1020 !== t.type && (console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture."), t.type = 1020, o = y.convert(t.type)));
					m.texImage2D(p.TEXTURE_2D, 0, s, e.width, e.height, 0, r, o, null)
				} else if (t.isDataTexture)
					if (0 < a.length && n) {
						for (var l = 0, c = a.length; l < c; l++) s = a[l], m.texImage2D(p.TEXTURE_2D, l, r, s.width, s.height, 0, r, o, s.data);
						t.generateMipmaps = !1;
						i.__maxMipLevel = a.length - 1
					} else m.texImage2D(p.TEXTURE_2D, 0, r, e.width, e.height, 0, r, o, e.data), i.__maxMipLevel = 0;
				else if (t.isCompressedTexture) {
					l = 0;
					for (c = a.length; l < c; l++) s = a[l], 1023 !== t.format && 1022 !== t.format ? -1 < m.getCompressedTextureFormats().indexOf(r) ? m.compressedTexImage2D(p.TEXTURE_2D, l, r, s.width, s.height, 0, s.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : m.texImage2D(p.TEXTURE_2D, l, r, s.width, s.height, 0, r, o, s.data);
					i.__maxMipLevel = a.length - 1
				} else if (0 < a.length && n) {
					l = 0;
					for (c = a.length; l < c; l++) s = a[l], m.texImage2D(p.TEXTURE_2D, l, r, r, o, s);
					t.generateMipmaps = !1;
					i.__maxMipLevel = a.length - 1
				} else m.texImage2D(p.TEXTURE_2D, 0, r, r, o, e), i.__maxMipLevel = 0;
				w(t, n) && T(p.TEXTURE_2D, t, e.width, e.height);
				i.__version = t.version;
				if (t.onUpdate) t.onUpdate(t);
				return
			}
			m.activeTexture(p.TEXTURE0 + e);
			m.bindTexture(p.TEXTURE_2D, i.__webglTexture)
		}

		function S(t, e, i) {
			i ? (p.texParameteri(t, p.TEXTURE_WRAP_S, y.convert(e.wrapS)), p.texParameteri(t, p.TEXTURE_WRAP_T, y.convert(e.wrapT)), p.texParameteri(t, p.TEXTURE_MAG_FILTER, y.convert(e.magFilter)), p.texParameteri(t, p.TEXTURE_MIN_FILTER, y.convert(e.minFilter))) : (p.texParameteri(t, p.TEXTURE_WRAP_S, p.CLAMP_TO_EDGE), p.texParameteri(t, p.TEXTURE_WRAP_T, p.CLAMP_TO_EDGE), 1001 === e.wrapS && 1001 === e.wrapT || console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.", e), p.texParameteri(t, p.TEXTURE_MAG_FILTER, r(e.magFilter)), p.texParameteri(t, p.TEXTURE_MIN_FILTER, r(e.minFilter)), 1003 !== e.minFilter && 1006 !== e.minFilter && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.", e));
			!(i = n.get("EXT_texture_filter_anisotropic")) || 1015 === e.type && null === n.get("OES_texture_float_linear") || 1016 === e.type && null === n.get("OES_texture_half_float_linear") || !(1 < e.anisotropy || g.get(e).__currentAnisotropy) || (p.texParameterf(t, i.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(e.anisotropy, v.getMaxAnisotropy())), g.get(e).__currentAnisotropy = e.anisotropy)
		}

		function l(t, e, i, n) {
			var r = y.convert(e.texture.format),
				o = y.convert(e.texture.type);
			m.texImage2D(n, 0, r, e.width, e.height, 0, r, o, null);
			p.bindFramebuffer(p.FRAMEBUFFER, t);
			p.framebufferTexture2D(p.FRAMEBUFFER, i, n, g.get(e.texture).__webglTexture, 0);
			p.bindFramebuffer(p.FRAMEBUFFER, null)
		}

		function c(t, e) {
			p.bindRenderbuffer(p.RENDERBUFFER, t);
			e.depthBuffer && !e.stencilBuffer ? (p.renderbufferStorage(p.RENDERBUFFER, p.DEPTH_COMPONENT16, e.width, e.height), p.framebufferRenderbuffer(p.FRAMEBUFFER, p.DEPTH_ATTACHMENT, p.RENDERBUFFER, t)) : e.depthBuffer && e.stencilBuffer ? (p.renderbufferStorage(p.RENDERBUFFER, p.DEPTH_STENCIL, e.width, e.height), p.framebufferRenderbuffer(p.FRAMEBUFFER, p.DEPTH_STENCIL_ATTACHMENT, p.RENDERBUFFER, t)) : p.renderbufferStorage(p.RENDERBUFFER, p.RGBA4, e.width, e.height);
			p.bindRenderbuffer(p.RENDERBUFFER, null)
		}
		var u = "undefined" !== typeof WebGL2RenderingContext && p instanceof WebGL2RenderingContext,
			h = {},
			d;
		this.setTexture2D = s;
		this.setTextureCube = function (t, e) {
			var i = g.get(t);
			if (6 === t.image.length)
				if (0 < t.version && i.__version !== t.version) {
					i.__image__webglTextureCube || (t.addEventListener("dispose", E), i.__image__webglTextureCube = p.createTexture(), x.memory.textures++);
					m.activeTexture(p.TEXTURE0 + e);
					m.bindTexture(p.TEXTURE_CUBE_MAP, i.__image__webglTextureCube);
					p.pixelStorei(p.UNPACK_FLIP_Y_WEBGL, t.flipY);
					e = t && t.isCompressedTexture;
					for (var n = t.image[0] && t.image[0].isDataTexture, r = [], o = 0; 6 > o; o++) r[o] = e || n ? n ? t.image[o].image : t.image[o] : _(t.image[o], v.maxCubemapSize);
					var a = r[0],
						s = b(a),
						l = y.convert(t.format),
						c = y.convert(t.type);
					S(p.TEXTURE_CUBE_MAP, t, s);
					for (o = 0; 6 > o; o++)
						if (e)
							for (var u, h = r[o].mipmaps, d = 0, f = h.length; d < f; d++) u = h[d], 1023 !== t.format && 1022 !== t.format ? -1 < m.getCompressedTextureFormats().indexOf(l) ? m.compressedTexImage2D(p.TEXTURE_CUBE_MAP_POSITIVE_X + o, d, l, u.width, u.height, 0, u.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : m.texImage2D(p.TEXTURE_CUBE_MAP_POSITIVE_X + o, d, l, u.width, u.height, 0, l, c, u.data);
						else n ? m.texImage2D(p.TEXTURE_CUBE_MAP_POSITIVE_X + o, 0, l, r[o].width, r[o].height, 0, l, c, r[o].data) : m.texImage2D(p.TEXTURE_CUBE_MAP_POSITIVE_X + o, 0, l, l, c, r[o]);
					i.__maxMipLevel = e ? h.length - 1 : 0;
					w(t, s) && T(p.TEXTURE_CUBE_MAP, t, a.width, a.height);
					i.__version = t.version;
					if (t.onUpdate) t.onUpdate(t)
				} else m.activeTexture(p.TEXTURE0 + e), m.bindTexture(p.TEXTURE_CUBE_MAP, i.__image__webglTextureCube)
		};
		this.setTextureCubeDynamic = function (t, e) {
			m.activeTexture(p.TEXTURE0 + e);
			m.bindTexture(p.TEXTURE_CUBE_MAP, g.get(t).__webglTexture)
		};
		this.setupRenderTarget = function (t) {
			var e = g.get(t),
				i = g.get(t.texture);
			t.addEventListener("dispose", a);
			i.__webglTexture = p.createTexture();
			x.memory.textures++;
			var n = !0 === t.isWebGLRenderTargetCube,
				r = b(t);
			if (n) {
				e.__webglFramebuffer = [];
				for (var o = 0; 6 > o; o++) e.__webglFramebuffer[o] = p.createFramebuffer()
			} else e.__webglFramebuffer = p.createFramebuffer();
			if (n) {
				m.bindTexture(p.TEXTURE_CUBE_MAP, i.__webglTexture);
				S(p.TEXTURE_CUBE_MAP, t.texture, r);
				for (o = 0; 6 > o; o++) l(e.__webglFramebuffer[o], t, p.COLOR_ATTACHMENT0, p.TEXTURE_CUBE_MAP_POSITIVE_X + o);
				w(t.texture, r) && T(p.TEXTURE_CUBE_MAP, t.texture, t.width, t.height);
				m.bindTexture(p.TEXTURE_CUBE_MAP, null)
			} else m.bindTexture(p.TEXTURE_2D, i.__webglTexture), S(p.TEXTURE_2D, t.texture, r), l(e.__webglFramebuffer, t, p.COLOR_ATTACHMENT0, p.TEXTURE_2D), w(t.texture, r) && T(p.TEXTURE_2D, t.texture, t.width, t.height), m.bindTexture(p.TEXTURE_2D, null);
			if (t.depthBuffer) {
				e = g.get(t);
				i = !0 === t.isWebGLRenderTargetCube;
				if (t.depthTexture) {
					if (i) throw Error("target.depthTexture not supported in Cube render targets");
					if (t && t.isWebGLRenderTargetCube) throw Error("Depth Texture with cube render targets is not supported");
					p.bindFramebuffer(p.FRAMEBUFFER, e.__webglFramebuffer);
					if (!t.depthTexture || !t.depthTexture.isDepthTexture) throw Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
					g.get(t.depthTexture).__webglTexture && t.depthTexture.image.width === t.width && t.depthTexture.image.height === t.height || (t.depthTexture.image.width = t.width, t.depthTexture.image.height = t.height, t.depthTexture.needsUpdate = !0);
					s(t.depthTexture, 0);
					e = g.get(t.depthTexture).__webglTexture;
					if (1026 === t.depthTexture.format) p.framebufferTexture2D(p.FRAMEBUFFER, p.DEPTH_ATTACHMENT, p.TEXTURE_2D, e, 0);
					else if (1027 === t.depthTexture.format) p.framebufferTexture2D(p.FRAMEBUFFER, p.DEPTH_STENCIL_ATTACHMENT, p.TEXTURE_2D, e, 0);
					else throw Error("Unknown depthTexture format")
				} else if (i)
					for (e.__webglDepthbuffer = [], i = 0; 6 > i; i++) p.bindFramebuffer(p.FRAMEBUFFER, e.__webglFramebuffer[i]), e.__webglDepthbuffer[i] = p.createRenderbuffer(), c(e.__webglDepthbuffer[i], t);
				else p.bindFramebuffer(p.FRAMEBUFFER, e.__webglFramebuffer), e.__webglDepthbuffer = p.createRenderbuffer(), c(e.__webglDepthbuffer, t);
				p.bindFramebuffer(p.FRAMEBUFFER, null)
			}
		};
		this.updateRenderTargetMipmap = function (t) {
			var e = t.texture,
				i = b(t);
			if (w(e, i)) {
				i = t.isWebGLRenderTargetCube ? p.TEXTURE_CUBE_MAP : p.TEXTURE_2D;
				var n = g.get(e).__webglTexture;
				m.bindTexture(i, n);
				T(i, e, t.width, t.height);
				m.bindTexture(i, null)
			}
		}
	}

	function ye(i, n) {
		return {
			convert: function (t) {
				if (1e3 === t) return i.REPEAT;
				if (1001 === t) return i.CLAMP_TO_EDGE;
				if (1002 === t) return i.MIRRORED_REPEAT;
				if (1003 === t) return i.NEAREST;
				if (1004 === t) return i.NEAREST_MIPMAP_NEAREST;
				if (1005 === t) return i.NEAREST_MIPMAP_LINEAR;
				if (1006 === t) return i.LINEAR;
				if (1007 === t) return i.LINEAR_MIPMAP_NEAREST;
				if (1008 === t) return i.LINEAR_MIPMAP_LINEAR;
				if (1009 === t) return i.UNSIGNED_BYTE;
				if (1017 === t) return i.UNSIGNED_SHORT_4_4_4_4;
				if (1018 === t) return i.UNSIGNED_SHORT_5_5_5_1;
				if (1019 === t) return i.UNSIGNED_SHORT_5_6_5;
				if (1010 === t) return i.BYTE;
				if (1011 === t) return i.SHORT;
				if (1012 === t) return i.UNSIGNED_SHORT;
				if (1013 === t) return i.INT;
				if (1014 === t) return i.UNSIGNED_INT;
				if (1015 === t) return i.FLOAT;
				if (1016 === t) {
					var e = n.get("OES_texture_half_float");
					if (null !== e) return e.HALF_FLOAT_OES
				}
				if (1021 === t) return i.ALPHA;
				if (1022 === t) return i.RGB;
				if (1023 === t) return i.RGBA;
				if (1024 === t) return i.LUMINANCE;
				if (1025 === t) return i.LUMINANCE_ALPHA;
				if (1026 === t) return i.DEPTH_COMPONENT;
				if (1027 === t) return i.DEPTH_STENCIL;
				if (100 === t) return i.FUNC_ADD;
				if (101 === t) return i.FUNC_SUBTRACT;
				if (102 === t) return i.FUNC_REVERSE_SUBTRACT;
				if (200 === t) return i.ZERO;
				if (201 === t) return i.ONE;
				if (202 === t) return i.SRC_COLOR;
				if (203 === t) return i.ONE_MINUS_SRC_COLOR;
				if (204 === t) return i.SRC_ALPHA;
				if (205 === t) return i.ONE_MINUS_SRC_ALPHA;
				if (206 === t) return i.DST_ALPHA;
				if (207 === t) return i.ONE_MINUS_DST_ALPHA;
				if (208 === t) return i.DST_COLOR;
				if (209 === t) return i.ONE_MINUS_DST_COLOR;
				if (210 === t) return i.SRC_ALPHA_SATURATE;
				if (33776 === t || 33777 === t || 33778 === t || 33779 === t)
					if (e = n.get("WEBGL_compressed_texture_s3tc"), null !== e) {
						if (33776 === t) return e.COMPRESSED_RGB_S3TC_DXT1_EXT;
						if (33777 === t) return e.COMPRESSED_RGBA_S3TC_DXT1_EXT;
						if (33778 === t) return e.COMPRESSED_RGBA_S3TC_DXT3_EXT;
						if (33779 === t) return e.COMPRESSED_RGBA_S3TC_DXT5_EXT
					}
				if (35840 === t || 35841 === t || 35842 === t || 35843 === t)
					if (e = n.get("WEBGL_compressed_texture_pvrtc"), null !== e) {
						if (35840 === t) return e.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
						if (35841 === t) return e.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
						if (35842 === t) return e.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
						if (35843 === t) return e.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG
					}
				if (36196 === t && (e = n.get("WEBGL_compressed_texture_etc1"), null !== e)) return e.COMPRESSED_RGB_ETC1_WEBGL;
				if (37808 === t || 37809 === t || 37810 === t || 37811 === t || 37812 === t || 37813 === t || 37814 === t || 37815 === t || 37816 === t || 37817 === t || 37818 === t || 37819 === t || 37820 === t || 37821 === t)
					if (e = n.get("WEBGL_compressed_texture_astc"), null !== e) return t;
				if (103 === t || 104 === t)
					if (e = n.get("EXT_blend_minmax"), null !== e) {
						if (103 === t) return e.MIN_EXT;
						if (104 === t) return e.MAX_EXT
					}
				return 1020 === t && (e = n.get("WEBGL_depth_texture"), null !== e) ? e.UNSIGNED_INT_24_8_WEBGL : 0
			}
		}
	}

	function xe(t, e, i, n) {
		l.call(this);
		this.type = "PerspectiveCamera";
		this.fov = void 0 !== t ? t : 50;
		this.zoom = 1;
		this.near = void 0 !== i ? i : .1;
		this.far = void 0 !== n ? n : 2e3;
		this.focus = 10;
		this.aspect = void 0 !== e ? e : 1;
		this.view = null;
		this.filmGauge = 35;
		this.filmOffset = 0;
		this.updateProjectionMatrix()
	}

	function _e(t) {
		xe.call(this);
		this.cameras = t || []
	}

	function be(i) {
		function n() {
			return null !== o && !0 === o.isPresenting
		}

		function t() {
			if (n()) {
				var t = o.getEyeParameters("left"),
					e = t.renderWidth;
				t = t.renderHeight;
				v = i.getPixelRatio();
				g = i.getSize();
				i.setDrawingBufferSize(2 * e, t, 1);
				y.start()
			} else r.enabled && (i.setDrawingBufferSize(g.width, g.height, v), y.stop())
		}
		var r = this,
			o = null,
			a = null,
			s = null,
			l = new xt,
			c = new xt;
		"undefined" !== typeof window && "VRFrameData" in window && (a = new window.VRFrameData, window.addEventListener("vrdisplaypresentchange", t, !1));
		var u = new xt,
			h = new j,
			d = new _t,
			f = new xe;
		f.bounds = new bt(0, 0, .5, 1);
		f.layers.enable(1);
		var p = new xe;
		p.bounds = new bt(.5, 0, .5, 1);
		p.layers.enable(2);
		var m = new _e([f, p]);
		m.layers.enable(1);
		m.layers.enable(2);
		var g, v;
		this.enabled = !1;
		this.userHeight = 1.6;
		this.getDevice = function () {
			return o
		};
		this.setDevice = function (t) {
			void 0 !== t && (o = t);
			y.setContext(t)
		};
		this.setPoseTarget = function (t) {
			void 0 !== t && (s = t)
		};
		this.getCamera = function (t) {
			if (null === o) return t;
			o.depthNear = t.near;
			o.depthFar = t.far;
			o.getFrameData(a);
			var e = o.stageParameters;
			e ? l.fromArray(e.sittingToStandingTransform) : l.makeTranslation(0, r.userHeight, 0);
			e = a.pose;
			var i = null !== s ? s : t;
			i.matrix.copy(l);
			i.matrix.decompose(i.position, i.quaternion, i.scale);
			null !== e.orientation && (h.fromArray(e.orientation), i.quaternion.multiply(h));
			null !== e.position && (h.setFromRotationMatrix(l), d.fromArray(e.position), d.applyQuaternion(h), i.position.add(d));
			i.updateMatrixWorld();
			if (!1 === o.isPresenting) return t;
			f.near = t.near;
			p.near = t.near;
			f.far = t.far;
			p.far = t.far;
			m.matrixWorld.copy(t.matrixWorld);
			m.matrixWorldInverse.copy(t.matrixWorldInverse);
			f.matrixWorldInverse.fromArray(a.leftViewMatrix);
			p.matrixWorldInverse.fromArray(a.rightViewMatrix);
			c.getInverse(l);
			f.matrixWorldInverse.multiply(c);
			p.matrixWorldInverse.multiply(c);
			t = i.parent;
			null !== t && (u.getInverse(t.matrixWorld), f.matrixWorldInverse.multiply(u), p.matrixWorldInverse.multiply(u));
			f.matrixWorld.getInverse(f.matrixWorldInverse);
			p.matrixWorld.getInverse(p.matrixWorldInverse);
			f.projectionMatrix.fromArray(a.leftProjectionMatrix);
			p.projectionMatrix.fromArray(a.rightProjectionMatrix);
			m.projectionMatrix.copy(f.projectionMatrix);
			t = o.getLayers();
			t.length && (t = t[0], null !== t.leftBounds && 4 === t.leftBounds.length && f.bounds.fromArray(t.leftBounds), null !== t.rightBounds && 4 === t.rightBounds.length && p.bounds.fromArray(t.rightBounds));
			return m
		};
		this.getStandingMatrix = function () {
			return l
		};
		this.isPresenting = n;
		var y = new Et;
		this.setAnimationLoop = function (t) {
			y.setAnimationLoop(t)
		};
		this.submitFrame = function () {
			n() && o.submitFrame()
		};
		this.dispose = function () {
			"undefined" !== typeof window && window.removeEventListener("vrdisplaypresentchange", t)
		}
	}

	function we(i) {
		function r() {
			return null !== s && null !== l
		}

		function o(t, e) {
			null === e ? t.matrixWorld.copy(t.matrix) : t.matrixWorld.multiplyMatrices(e.matrixWorld, t.matrix);
			t.matrixWorldInverse.getInverse(t.matrixWorld)
		}
		var n = i.context,
			e = null,
			s = null,
			l = null,
			c = null,
			t = new xe;
		t.layers.enable(1);
		t.viewport = new bt;
		var a = new xe;
		a.layers.enable(2);
		a.viewport = new bt;
		var u = new _e([t, a]);
		u.layers.enable(1);
		u.layers.enable(2);
		this.enabled = !1;
		this.getDevice = function () {
			return e
		};
		this.setDevice = function (t) {
			void 0 !== t && (e = t);
			n.setCompatibleXRDevice(t)
		};
		this.setSession = function (t, e) {
			s = t;
			null !== s && (s.addEventListener("end", function () {
				i.setFramebuffer(null);
				d.stop()
			}), s.baseLayer = new XRWebGLLayer(s, n), s.requestFrameOfReference(e.frameOfReferenceType).then(function (t) {
				l = t;
				i.setFramebuffer(s.baseLayer.framebuffer);
				d.setContext(s);
				d.start()
			}))
		};
		this.getCamera = function (t) {
			if (r()) {
				var e = t.parent,
					i = u.cameras;
				o(u, e);
				for (var n = 0; n < i.length; n++) o(i[n], e);
				t.matrixWorld.copy(u.matrixWorld);
				t = t.children;
				n = 0;
				for (e = t.length; n < e; n++) t[n].updateMatrixWorld(!0);
				return u
			}
			return t
		};
		this.isPresenting = r;
		var h = null,
			d = new Et;
		d.setAnimationLoop(function (t, e) {
			c = e.getDevicePose(l);
			t = s.baseLayer;
			e = e.views;
			for (var i = 0; i < e.length; i++) {
				var n = e[i],
					r = t.getViewport(n),
					o = c.getViewMatrix(n),
					a = u.cameras[i];
				a.matrix.fromArray(o).getInverse(a.matrix);
				a.projectionMatrix.fromArray(n.projectionMatrix);
				a.viewport.set(r.x, r.y, r.width, r.height);
				0 === i && (u.matrix.copy(a.matrix), u.projectionMatrix.copy(a.projectionMatrix))
			}
			h && h()
		});
		this.setAnimationLoop = function (t) {
			h = t
		};
		this.getStandingMatrix = function () {
			console.warn("THREE.WebXRManager: getStandingMatrix() is no longer needed.");
			return new THREE.Matrix4
		};
		this.submitFrame = function () {}
	}

	function Te(t) {
		function e() {
			J = new Lt(Z);
			J.get("WEBGL_depth_texture");
			J.get("OES_texture_float");
			J.get("OES_texture_float_linear");
			J.get("OES_texture_half_float");
			J.get("OES_texture_half_float_linear");
			J.get("OES_standard_derivatives");
			J.get("OES_element_index_uint");
			J.get("ANGLE_instanced_arrays");
			pt = new ye(Z, J);
			Q = new Ct(Z, J, t);
			K = new ge(Z, J, pt);
			K.scissor(I.copy(H).multiplyScalar(z));
			K.viewport(N.copy(G).multiplyScalar(z));
			tt = new kt(Z);
			et = new ie;
			it = new ve(Z, J, K, et, Q, pt, tt);
			nt = new St(Z);
			rt = new Rt(Z, nt, tt);
			ot = new It(rt, tt);
			ut = new Nt(Z);
			at = new ee(S, J, Q);
			st = new ae;
			lt = new ue;
			ct = new Mt(S, K, ot, x);
			ht = new At(Z, J, tt);
			dt = new Ot(Z, J, tt);
			ft = new me(S, Z, K, it, Q);
			tt.programs = at.programs;
			S.context = Z;
			S.capabilities = Q;
			S.extensions = J;
			S.properties = et;
			S.renderLists = st;
			S.state = K;
			S.info = tt
		}

		function i(t) {
			t.preventDefault();
			console.log("THREE.WebGLRenderer: Context Lost.");
			M = !0
		}

		function n() {
			console.log("THREE.WebGLRenderer: Context Restored.");
			M = !1;
			e()
		}

		function l(t) {
			t = t.target;
			t.removeEventListener("dispose", l);
			c(t);
			et.remove(t)
		}

		function c(t) {
			var e = et.get(t).program;
			t.program = void 0;
			void 0 !== e && at.releaseProgram(e)
		}

		function s(t, e, i) {
			t.render(function (t) {
				S.renderBufferImmediate(t, e, i)
			})
		}

		function u(t, e, i) {
			if (!1 !== t.visible) {
				if (t.layers.test(e.layers))
					if (t.isLight) E.pushLight(t), t.castShadow && E.pushShadow(t);
					else if (t.isSprite) t.frustumCulled && !V.intersectsSprite(t) || E.pushSprite(t);
				else if (t.isImmediateRenderObject) i && $.setFromMatrixPosition(t.matrixWorld).applyMatrix4(q), T.push(t, null, t.material, $.z, null);
				else if (t.isMesh || t.isLine || t.isPoints)
					if (t.isSkinnedMesh && t.skeleton.update(), !t.frustumCulled || V.intersectsObject(t)) {
						i && $.setFromMatrixPosition(t.matrixWorld).applyMatrix4(q);
						var n = ot.update(t),
							r = t.material;
						if (Array.isArray(r))
							for (var o = n.groups, a = 0, s = o.length; a < s; a++) {
								var l = o[a],
									c = r[l.materialIndex];
								c && c.visible && T.push(t, n, c, $.z, l)
							} else r.visible && T.push(t, n, r, $.z, null)
					}
				t = t.children;
				a = 0;
				for (s = t.length; a < s; a++) u(t[a], e, i)
			}
		}

		function a(t, e, i, n) {
			for (var r = 0, o = t.length; r < o; r++) {
				var a = t[r],
					s = a.object,
					l = a.geometry,
					c = void 0 === n ? a.material : n;
				a = a.group;
				if (i.isArrayCamera) {
					k = i;
					for (var u = i.cameras, h = 0, d = u.length; h < d; h++) {
						var f = u[h];
						if (s.layers.test(f.layers)) {
							if ("viewport" in f) K.viewport(N.copy(f.viewport));
							else {
								var p = f.bounds;
								K.viewport(N.set(p.x * B, p.y * U, p.z * B, p.w * U).multiplyScalar(z))
							}
							m(s, e, f, l, c, a)
						}
					}
				} else k = null, m(s, e, i, l, c, a)
			}
		}

		function m(t, e, i, n, r, o) {
			t.onBeforeRender(S, e, i, n, r, o);
			E = lt.get(e, k || i);
			t.modelViewMatrix.multiplyMatrices(i.matrixWorldInverse, t.matrixWorld);
			t.normalMatrix.getNormalMatrix(t.modelViewMatrix);
			if (t.isImmediateRenderObject) {
				var a = t.isMesh && 0 > t.matrixWorld.determinant();
				K.setMaterial(r, a);
				a = w(i, e.fog, r, t);
				R = "";
				s(t, a, r)
			} else S.renderBufferDirect(i, e.fog, n, r, t, o);
			t.onAfterRender(S, e, i, n, r, o);
			E = lt.get(e, k || i)
		}

		function f(t, e, i) {
			var n = et.get(t),
				r = E.state.lights;
			i = at.getParameters(t, r.state, E.state.shadowsArray, e, W.numPlanes, W.numIntersection, i);
			var o = at.getProgramCode(t, i),
				a = n.program,
				s = !0;
			if (void 0 === a) t.addEventListener("dispose", l);
			else if (a.code !== o) c(t);
			else {
				if (n.lightsHash !== r.state.hash) et.update(t, "lightsHash", r.state.hash);
				else if (void 0 !== i.shaderID) return;
				s = !1
			}
			s && (i.shaderID ? (a = oo[i.shaderID], n.shader = {
				name: t.type,
				uniforms: io.clone(a.uniforms),
				vertexShader: a.vertexShader,
				fragmentShader: a.fragmentShader
			}) : n.shader = {
				name: t.type,
				uniforms: t.uniforms,
				vertexShader: t.vertexShader,
				fragmentShader: t.fragmentShader
			}, t.onBeforeCompile(n.shader, S), a = at.acquireProgram(t, n.shader, i, o), n.program = a, t.program = a);
			i = a.getAttributes();
			if (t.morphTargets)
				for (o = t.numSupportedMorphTargets = 0; o < S.maxMorphTargets; o++) 0 <= i["morphTarget" + o] && t.numSupportedMorphTargets++;
			if (t.morphNormals)
				for (o = t.numSupportedMorphNormals = 0; o < S.maxMorphNormals; o++) 0 <= i["morphNormal" + o] && t.numSupportedMorphNormals++;
			i = n.shader.uniforms;
			if (!t.isShaderMaterial && !t.isRawShaderMaterial || !0 === t.clipping) n.numClippingPlanes = W.numPlanes, n.numIntersection = W.numIntersection, i.clippingPlanes = W.uniform;
			n.fog = e;
			n.lightsHash = r.state.hash;
			t.lights && (i.ambientLightColor.value = r.state.ambient, i.directionalLights.value = r.state.directional, i.spotLights.value = r.state.spot, i.rectAreaLights.value = r.state.rectArea, i.pointLights.value = r.state.point, i.hemisphereLights.value = r.state.hemi, i.directionalShadowMap.value = r.state.directionalShadowMap, i.directionalShadowMatrix.value = r.state.directionalShadowMatrix, i.spotShadowMap.value = r.state.spotShadowMap, i.spotShadowMatrix.value = r.state.spotShadowMatrix, i.pointShadowMap.value = r.state.pointShadowMap, i.pointShadowMatrix.value = r.state.pointShadowMatrix);
			t = n.program.getUniforms();
			t = zt.seqWithValue(t.seq, i);
			n.uniformsList = t
		}

		function w(t, e, i, n) {
			F = 0;
			var r = et.get(i),
				o = E.state.lights;
			X && (Y || t !== O) && W.setState(i.clippingPlanes, i.clipIntersection, i.clipShadows, t, r, t === O && i.id === L);
			!1 === i.needsUpdate && (void 0 === r.program ? i.needsUpdate = !0 : i.fog && r.fog !== e ? i.needsUpdate = !0 : i.lights && r.lightsHash !== o.state.hash ? i.needsUpdate = !0 : void 0 === r.numClippingPlanes || r.numClippingPlanes === W.numPlanes && r.numIntersection === W.numIntersection || (i.needsUpdate = !0));
			i.needsUpdate && (f(i, e, n), i.needsUpdate = !1);
			var a = !1,
				s = !1,
				l = !1;
			o = r.program;
			var c = o.getUniforms(),
				u = r.shader.uniforms;
			K.useProgram(o.program) && (l = s = a = !0);
			i.id !== L && (L = i.id, s = !0);
			if (a || t !== O) {
				c.setValue(Z, "projectionMatrix", t.projectionMatrix);
				Q.logarithmicDepthBuffer && c.setValue(Z, "logDepthBufFC", 2 / (Math.log(t.far + 1) / Math.LN2));
				O !== (k || t) && (O = k || t, l = s = !0);
				if (i.isShaderMaterial || i.isMeshPhongMaterial || i.isMeshStandardMaterial || i.envMap) a = c.map.cameraPosition, void 0 !== a && a.setValue(Z, $.setFromMatrixPosition(t.matrixWorld));
				(i.isMeshPhongMaterial || i.isMeshLambertMaterial || i.isMeshBasicMaterial || i.isMeshStandardMaterial || i.isShaderMaterial || i.skinning) && c.setValue(Z, "viewMatrix", t.matrixWorldInverse)
			}
			if (i.skinning && (c.setOptional(Z, n, "bindMatrix"), c.setOptional(Z, n, "bindMatrixInverse"), t = n.skeleton))
				if (a = t.bones, Q.floatVertexTextures) {
					if (void 0 === t.boneTexture) {
						a = Math.sqrt(4 * a.length);
						a = Kr.ceilPowerOfTwo(a);
						a = Math.max(a, 4);
						var h = new Float32Array(a * a * 4);
						h.set(t.boneMatrices);
						var d = new wt(h, a, a, 1023, 1015);
						d.needsUpdate = !0;
						t.boneMatrices = h;
						t.boneTexture = d;
						t.boneTextureSize = a
					}
					c.setValue(Z, "boneTexture", t.boneTexture);
					c.setValue(Z, "boneTextureSize", t.boneTextureSize)
				} else c.setOptional(Z, t, "boneMatrices");
			s && (c.setValue(Z, "toneMappingExposure", S.toneMappingExposure), c.setValue(Z, "toneMappingWhitePoint", S.toneMappingWhitePoint), i.lights && (s = l, u.ambientLightColor.needsUpdate = s, u.directionalLights.needsUpdate = s, u.pointLights.needsUpdate = s, u.spotLights.needsUpdate = s, u.rectAreaLights.needsUpdate = s, u.hemisphereLights.needsUpdate = s), e && i.fog && (u.fogColor.value = e.color, e.isFog ? (u.fogNear.value = e.near, u.fogFar.value = e.far) : e.isFogExp2 && (u.fogDensity.value = e.density)), i.isMeshBasicMaterial ? p(u, i) : i.isMeshLambertMaterial ? (p(u, i), i.emissiveMap && (u.emissiveMap.value = i.emissiveMap)) : i.isMeshPhongMaterial ? (p(u, i), i.isMeshToonMaterial ? (g(u, i), i.gradientMap && (u.gradientMap.value = i.gradientMap)) : g(u, i)) : i.isMeshStandardMaterial ? (p(u, i), i.isMeshPhysicalMaterial && (u.clearCoat.value = i.clearCoat, u.clearCoatRoughness.value = i.clearCoatRoughness), u.roughness.value = i.roughness, u.metalness.value = i.metalness, i.roughnessMap && (u.roughnessMap.value = i.roughnessMap), i.metalnessMap && (u.metalnessMap.value = i.metalnessMap), i.emissiveMap && (u.emissiveMap.value = i.emissiveMap), i.bumpMap && (u.bumpMap.value = i.bumpMap, u.bumpScale.value = i.bumpScale, 1 === i.side && (u.bumpScale.value *= -1)), i.normalMap && (u.normalMap.value = i.normalMap, u.normalScale.value.copy(i.normalScale), 1 === i.side && u.normalScale.value.negate()), i.displacementMap && (u.displacementMap.value = i.displacementMap, u.displacementScale.value = i.displacementScale, u.displacementBias.value = i.displacementBias), i.envMap && (u.envMapIntensity.value = i.envMapIntensity)) : i.isMeshDepthMaterial ? (p(u, i), i.displacementMap && (u.displacementMap.value = i.displacementMap, u.displacementScale.value = i.displacementScale, u.displacementBias.value = i.displacementBias)) : i.isMeshDistanceMaterial ? (p(u, i), i.displacementMap && (u.displacementMap.value = i.displacementMap, u.displacementScale.value = i.displacementScale, u.displacementBias.value = i.displacementBias), u.referencePosition.value.copy(i.referencePosition), u.nearDistance.value = i.nearDistance, u.farDistance.value = i.farDistance) : i.isMeshNormalMaterial ? (p(u, i), i.bumpMap && (u.bumpMap.value = i.bumpMap, u.bumpScale.value = i.bumpScale, 1 === i.side && (u.bumpScale.value *= -1)), i.normalMap && (u.normalMap.value = i.normalMap, u.normalScale.value.copy(i.normalScale), 1 === i.side && u.normalScale.value.negate()), i.displacementMap && (u.displacementMap.value = i.displacementMap, u.displacementScale.value = i.displacementScale, u.displacementBias.value = i.displacementBias)) : i.isLineBasicMaterial ? (u.diffuse.value = i.color, u.opacity.value = i.opacity, i.isLineDashedMaterial && (u.dashSize.value = i.dashSize, u.totalSize.value = i.dashSize + i.gapSize, u.scale.value = i.scale)) : i.isPointsMaterial ? (u.diffuse.value = i.color, u.opacity.value = i.opacity, u.size.value = i.size * z, u.scale.value = .5 * U, u.map.value = i.map, null !== i.map && (!0 === i.map.matrixAutoUpdate && i.map.updateMatrix(), u.uvTransform.value.copy(i.map.matrix))) : i.isShadowMaterial && (u.color.value = i.color, u.opacity.value = i.opacity), void 0 !== u.ltc_1 && (u.ltc_1.value = ro.LTC_1), void 0 !== u.ltc_2 && (u.ltc_2.value = ro.LTC_2), zt.upload(Z, r.uniformsList, u, S));
			i.isShaderMaterial && !0 === i.uniformsNeedUpdate && (zt.upload(Z, r.uniformsList, u, S), i.uniformsNeedUpdate = !1);
			c.setValue(Z, "modelViewMatrix", n.modelViewMatrix);
			c.setValue(Z, "normalMatrix", n.normalMatrix);
			c.setValue(Z, "modelMatrix", n.matrixWorld);
			return o
		}

		function p(t, e) {
			t.opacity.value = e.opacity;
			e.color && (t.diffuse.value = e.color);
			e.emissive && t.emissive.value.copy(e.emissive).multiplyScalar(e.emissiveIntensity);
			e.map && (t.map.value = e.map);
			e.alphaMap && (t.alphaMap.value = e.alphaMap);
			e.specularMap && (t.specularMap.value = e.specularMap);
			e.envMap && (t.envMap.value = e.envMap, t.flipEnvMap.value = e.envMap && e.envMap.isCubeTexture ? -1 : 1, t.reflectivity.value = e.reflectivity, t.refractionRatio.value = e.refractionRatio, t.maxMipLevel.value = et.get(e.envMap).__maxMipLevel);
			e.lightMap && (t.lightMap.value = e.lightMap, t.lightMapIntensity.value = e.lightMapIntensity);
			e.aoMap && (t.aoMap.value = e.aoMap, t.aoMapIntensity.value = e.aoMapIntensity);
			if (e.map) var i = e.map;
			else e.specularMap ? i = e.specularMap : e.displacementMap ? i = e.displacementMap : e.normalMap ? i = e.normalMap : e.bumpMap ? i = e.bumpMap : e.roughnessMap ? i = e.roughnessMap : e.metalnessMap ? i = e.metalnessMap : e.alphaMap ? i = e.alphaMap : e.emissiveMap && (i = e.emissiveMap);
			void 0 !== i && (i.isWebGLRenderTarget && (i = i.texture), !0 === i.matrixAutoUpdate && i.updateMatrix(), t.uvTransform.value.copy(i.matrix))
		}

		function g(t, e) {
			t.specular.value = e.specular;
			t.shininess.value = Math.max(e.shininess, 1e-4);
			e.emissiveMap && (t.emissiveMap.value = e.emissiveMap);
			e.bumpMap && (t.bumpMap.value = e.bumpMap, t.bumpScale.value = e.bumpScale, 1 === e.side && (t.bumpScale.value *= -1));
			e.normalMap && (t.normalMap.value = e.normalMap, t.normalScale.value.copy(e.normalScale), 1 === e.side && t.normalScale.value.negate());
			e.displacementMap && (t.displacementMap.value = e.displacementMap, t.displacementScale.value = e.displacementScale, t.displacementBias.value = e.displacementBias)
		}
		console.log("THREE.WebGLRenderer", "93");
		t = t || {};
		var r = void 0 !== t.canvas ? t.canvas : document.createElementNS("http://www.w3.org/1999/xhtml", "canvas"),
			o = void 0 !== t.context ? t.context : null,
			h = void 0 !== t.alpha ? t.alpha : !1,
			d = void 0 !== t.depth ? t.depth : !0,
			v = void 0 !== t.stencil ? t.stencil : !0,
			y = void 0 !== t.antialias ? t.antialias : !1,
			x = void 0 !== t.premultipliedAlpha ? t.premultipliedAlpha : !0,
			_ = void 0 !== t.preserveDrawingBuffer ? t.preserveDrawingBuffer : !1,
			b = void 0 !== t.powerPreference ? t.powerPreference : "default",
			T = null,
			E = null;
		this.domElement = r;
		this.context = null;
		this.sortObjects = this.autoClearStencil = this.autoClearDepth = this.autoClearColor = this.autoClear = !0;
		this.clippingPlanes = [];
		this.localClippingEnabled = !1;
		this.gammaFactor = 2;
		this.physicallyCorrectLights = this.gammaOutput = this.gammaInput = !1;
		this.toneMappingWhitePoint = this.toneMappingExposure = this.toneMapping = 1;
		this.maxMorphTargets = 8;
		this.maxMorphNormals = 4;
		var S = this,
			M = !1,
			A = null,
			C = null,
			P = null,
			L = -1,
			R = "",
			O = null,
			k = null,
			N = new bt,
			I = new bt,
			D = null,
			F = 0,
			B = r.width,
			U = r.height,
			z = 1,
			G = new bt(0, 0, B, U),
			H = new bt(0, 0, B, U),
			j = !1,
			V = new Tt,
			W = new Pt,
			X = !1,
			Y = !1,
			q = new xt,
			$ = new _t;
		try {
			h = {
				alpha: h,
				depth: d,
				stencil: v,
				antialias: y,
				premultipliedAlpha: x,
				preserveDrawingBuffer: _,
				powerPreference: b
			};
			r.addEventListener("webglcontextlost", i, !1);
			r.addEventListener("webglcontextrestored", n, !1);
			var Z = o || r.getContext("webgl", h) || r.getContext("experimental-webgl", h);
			if (null === Z) {
				if (null !== r.getContext("webgl")) throw Error("Error creating WebGL context with your selected attributes.");
				throw Error("Error creating WebGL context.")
			}
			void 0 === Z.getShaderPrecisionFormat && (Z.getShaderPrecisionFormat = function () {
				return {
					rangeMin: 1,
					rangeMax: 1,
					precision: 1
				}
			})
		} catch (t) {
			console.error("THREE.WebGLRenderer: " + t.message)
		}
		var J, Q, K, tt, et, it, nt, rt, ot, at, st, lt, ct, ut, ht, dt, ft, pt;
		e();
		var mt = "xr" in navigator ? new we(S) : new be(S);
		this.vr = mt;
		var gt = new fe(S, ot, Q.maxTextureSize);
		this.shadowMap = gt;
		this.getContext = function () {
			return Z
		};
		this.getContextAttributes = function () {
			return Z.getContextAttributes()
		};
		this.forceContextLoss = function () {
			var t = J.get("WEBGL_lose_context");
			t && t.loseContext()
		};
		this.forceContextRestore = function () {
			var t = J.get("WEBGL_lose_context");
			t && t.restoreContext()
		};
		this.getPixelRatio = function () {
			return z
		};
		this.setPixelRatio = function (t) {
			void 0 !== t && (z = t, this.setSize(B, U, !1))
		};
		this.getSize = function () {
			return {
				width: B,
				height: U
			}
		};
		this.setSize = function (t, e, i) {
			mt.isPresenting() ? console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.") : (B = t, U = e, r.width = t * z, r.height = e * z, !1 !== i && (r.style.width = t + "px", r.style.height = e + "px"), this.setViewport(0, 0, t, e))
		};
		this.getDrawingBufferSize = function () {
			return {
				width: B * z,
				height: U * z
			}
		};
		this.setDrawingBufferSize = function (t, e, i) {
			B = t;
			U = e;
			z = i;
			r.width = t * i;
			r.height = e * i;
			this.setViewport(0, 0, t, e)
		};
		this.getCurrentViewport = function () {
			return N
		};
		this.setViewport = function (t, e, i, n) {
			G.set(t, U - e - n, i, n);
			K.viewport(N.copy(G).multiplyScalar(z))
		};
		this.setScissor = function (t, e, i, n) {
			H.set(t, U - e - n, i, n);
			K.scissor(I.copy(H).multiplyScalar(z))
		};
		this.setScissorTest = function (t) {
			K.setScissorTest(j = t)
		};
		this.getClearColor = function () {
			return ct.getClearColor()
		};
		this.setClearColor = function () {
			ct.setClearColor.apply(ct, arguments)
		};
		this.getClearAlpha = function () {
			return ct.getClearAlpha()
		};
		this.setClearAlpha = function () {
			ct.setClearAlpha.apply(ct, arguments)
		};
		this.clear = function (t, e, i) {
			var n = 0;
			if (void 0 === t || t) n |= Z.COLOR_BUFFER_BIT;
			if (void 0 === e || e) n |= Z.DEPTH_BUFFER_BIT;
			if (void 0 === i || i) n |= Z.STENCIL_BUFFER_BIT;
			Z.clear(n)
		};
		this.clearColor = function () {
			this.clear(!0, !1, !1)
		};
		this.clearDepth = function () {
			this.clear(!1, !0, !1)
		};
		this.clearStencil = function () {
			this.clear(!1, !1, !0)
		};
		this.clearTarget = function (t, e, i, n) {
			this.setRenderTarget(t);
			this.clear(e, i, n)
		};
		this.dispose = function () {
			r.removeEventListener("webglcontextlost", i, !1);
			r.removeEventListener("webglcontextrestored", n, !1);
			st.dispose();
			lt.dispose();
			et.dispose();
			ot.dispose();
			mt.dispose();
			yt.stop()
		};
		this.renderBufferImmediate = function (t, e, i) {
			K.initAttributes();
			var n = et.get(t);
			t.hasPositions && !n.position && (n.position = Z.createBuffer());
			t.hasNormals && !n.normal && (n.normal = Z.createBuffer());
			t.hasUvs && !n.uv && (n.uv = Z.createBuffer());
			t.hasColors && !n.color && (n.color = Z.createBuffer());
			e = e.getAttributes();
			t.hasPositions && (Z.bindBuffer(Z.ARRAY_BUFFER, n.position), Z.bufferData(Z.ARRAY_BUFFER, t.positionArray, Z.DYNAMIC_DRAW), K.enableAttribute(e.position), Z.vertexAttribPointer(e.position, 3, Z.FLOAT, !1, 0, 0));
			if (t.hasNormals) {
				Z.bindBuffer(Z.ARRAY_BUFFER, n.normal);
				if (!i.isMeshPhongMaterial && !i.isMeshStandardMaterial && !i.isMeshNormalMaterial && !0 === i.flatShading)
					for (var r = 0, o = 3 * t.count; r < o; r += 9) {
						var a = t.normalArray,
							s = (a[r + 0] + a[r + 3] + a[r + 6]) / 3,
							l = (a[r + 1] + a[r + 4] + a[r + 7]) / 3,
							c = (a[r + 2] + a[r + 5] + a[r + 8]) / 3;
						a[r + 0] = s;
						a[r + 1] = l;
						a[r + 2] = c;
						a[r + 3] = s;
						a[r + 4] = l;
						a[r + 5] = c;
						a[r + 6] = s;
						a[r + 7] = l;
						a[r + 8] = c
					}
				Z.bufferData(Z.ARRAY_BUFFER, t.normalArray, Z.DYNAMIC_DRAW);
				K.enableAttribute(e.normal);
				Z.vertexAttribPointer(e.normal, 3, Z.FLOAT, !1, 0, 0)
			}
			t.hasUvs && i.map && (Z.bindBuffer(Z.ARRAY_BUFFER, n.uv), Z.bufferData(Z.ARRAY_BUFFER, t.uvArray, Z.DYNAMIC_DRAW), K.enableAttribute(e.uv), Z.vertexAttribPointer(e.uv, 2, Z.FLOAT, !1, 0, 0));
			t.hasColors && 0 !== i.vertexColors && (Z.bindBuffer(Z.ARRAY_BUFFER, n.color), Z.bufferData(Z.ARRAY_BUFFER, t.colorArray, Z.DYNAMIC_DRAW), K.enableAttribute(e.color), Z.vertexAttribPointer(e.color, 3, Z.FLOAT, !1, 0, 0));
			K.disableUnusedAttributes();
			Z.drawArrays(Z.TRIANGLES, 0, t.count);
			t.count = 0
		};
		this.renderBufferDirect = function (t, e, i, n, r, o) {
			var a = r.isMesh && 0 > r.matrixWorld.determinant();
			K.setMaterial(n, a);
			var s = w(t, e, n, r);
			t = i.id + "_" + s.id + "_" + (!0 === n.wireframe);
			var l = !1;
			t !== R && (R = t, l = !0);
			r.morphTargetInfluences && (ut.update(r, i, n, s), l = !0);
			a = i.index;
			var c = i.attributes.position;
			e = 1;
			!0 === n.wireframe && (a = rt.getWireframeAttribute(i), e = 2);
			t = ht;
			if (null !== a) {
				var u = nt.get(a);
				t = dt;
				t.setIndex(u)
			}
			if (l) {
				if (i && i.isInstancedBufferGeometry && null === J.get("ANGLE_instanced_arrays")) console.error("THREE.WebGLRenderer.setupVertexAttributes: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
				else {
					K.initAttributes();
					l = i.attributes;
					s = s.getAttributes();
					var h = n.defaultAttributeValues;
					for (b in s) {
						var d = s[b];
						if (0 <= d) {
							var f = l[b];
							if (void 0 !== f) {
								var p = f.normalized,
									m = f.itemSize,
									g = nt.get(f);
								if (void 0 !== g) {
									var v = g.buffer,
										y = g.type;
									g = g.bytesPerElement;
									if (f.isInterleavedBufferAttribute) {
										var x = f.data,
											_ = x.stride;
										f = f.offset;
										x && x.isInstancedInterleavedBuffer ? (K.enableAttributeAndDivisor(d, x.meshPerAttribute), void 0 === i.maxInstancedCount && (i.maxInstancedCount = x.meshPerAttribute * x.count)) : K.enableAttribute(d);
										Z.bindBuffer(Z.ARRAY_BUFFER, v);
										Z.vertexAttribPointer(d, m, y, p, _ * g, f * g)
									} else f.isInstancedBufferAttribute ? (K.enableAttributeAndDivisor(d, f.meshPerAttribute), void 0 === i.maxInstancedCount && (i.maxInstancedCount = f.meshPerAttribute * f.count)) : K.enableAttribute(d), Z.bindBuffer(Z.ARRAY_BUFFER, v), Z.vertexAttribPointer(d, m, y, p, 0, 0)
								}
							} else if (void 0 !== h && (p = h[b], void 0 !== p)) switch (p.length) {
								case 2:
									Z.vertexAttrib2fv(d, p);
									break;
								case 3:
									Z.vertexAttrib3fv(d, p);
									break;
								case 4:
									Z.vertexAttrib4fv(d, p);
									break;
								default:
									Z.vertexAttrib1fv(d, p)
							}
						}
					}
					K.disableUnusedAttributes()
				}
				null !== a && Z.bindBuffer(Z.ELEMENT_ARRAY_BUFFER, u.buffer)
			}
			u = Infinity;
			null !== a ? u = a.count : void 0 !== c && (u = c.count);
			a = i.drawRange.start * e;
			c = null !== o ? o.start * e : 0;
			var b = Math.max(a, c);
			o = Math.max(0, Math.min(u, a + i.drawRange.count * e, c + (null !== o ? o.count * e : Infinity)) - 1 - b + 1);
			if (0 !== o) {
				if (r.isMesh)
					if (!0 === n.wireframe) K.setLineWidth(n.wireframeLinewidth * (null === C ? z : 1)), t.setMode(Z.LINES);
					else switch (r.drawMode) {
						case 0:
							t.setMode(Z.TRIANGLES);
							break;
						case 1:
							t.setMode(Z.TRIANGLE_STRIP);
							break;
						case 2:
							t.setMode(Z.TRIANGLE_FAN)
					} else r.isLine ? (n = n.linewidth, void 0 === n && (n = 1), K.setLineWidth(n * (null === C ? z : 1)), r.isLineSegments ? t.setMode(Z.LINES) : r.isLineLoop ? t.setMode(Z.LINE_LOOP) : t.setMode(Z.LINE_STRIP)) : r.isPoints && t.setMode(Z.POINTS);
				i && i.isInstancedBufferGeometry ? 0 < i.maxInstancedCount && t.renderInstances(i, b, o) : t.render(b, o)
			}
		};
		this.compile = function (i, t) {
			E = lt.get(i, t);
			E.init();
			i.traverse(function (t) {
				t.isLight && (E.pushLight(t), t.castShadow && E.pushShadow(t))
			});
			E.setupLights(t);
			i.traverse(function (t) {
				if (t.material)
					if (Array.isArray(t.material))
						for (var e = 0; e < t.material.length; e++) f(t.material[e], i.fog, t);
					else f(t.material, i.fog, t)
			})
		};
		var vt = null,
			yt = new Et;
		yt.setAnimationLoop(function () {
			mt.isPresenting() || vt && vt()
		});
		yt.setContext(window);
		this.setAnimationLoop = function (t) {
			vt = t;
			mt.setAnimationLoop(t);
			yt.start()
		};
		this.render = function (t, e, i, n) {
			if (!e || !e.isCamera) console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
			else if (!M) {
				R = "";
				L = -1;
				O = null;
				!0 === t.autoUpdate && t.updateMatrixWorld();
				null === e.parent && e.updateMatrixWorld();
				mt.enabled && (e = mt.getCamera(e));
				E = lt.get(t, e);
				E.init();
				t.onBeforeRender(S, t, e, i);
				q.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse);
				V.setFromMatrix(q);
				Y = this.localClippingEnabled;
				X = W.init(this.clippingPlanes, Y, e);
				T = st.get(t, e);
				T.init();
				u(t, e, S.sortObjects);
				!0 === S.sortObjects && T.sort();
				X && W.beginShadows();
				gt.render(E.state.shadowsArray, t, e);
				E.setupLights(e);
				X && W.endShadows();
				this.info.autoReset && this.info.reset();
				void 0 === i && (i = null);
				this.setRenderTarget(i);
				ct.render(T, t, e, n);
				n = T.opaque;
				var r = T.transparent;
				if (t.overrideMaterial) {
					var o = t.overrideMaterial;
					n.length && a(n, t, e, o);
					r.length && a(r, t, e, o)
				} else n.length && a(n, t, e), r.length && a(r, t, e);
				ft.render(E.state.spritesArray, t, e);
				i && it.updateRenderTargetMipmap(i);
				K.buffers.depth.setTest(!0);
				K.buffers.depth.setMask(!0);
				K.buffers.color.setMask(!0);
				K.setPolygonOffset(!1);
				t.onAfterRender(S, t, e);
				mt.enabled && mt.submitFrame();
				E = T = null
			}
		};
		this.allocTextureUnit = function () {
			var t = F;
			t >= Q.maxTextures && console.warn("THREE.WebGLRenderer: Trying to use " + t + " texture units while this GPU supports only " + Q.maxTextures);
			F += 1;
			return t
		};
		this.setTexture2D = function () {
			var i = !1;
			return function (t, e) {
				t && t.isWebGLRenderTarget && (i || (console.warn("THREE.WebGLRenderer.setTexture2D: don't use render targets as textures. Use their .texture property instead."), i = !0), t = t.texture);
				it.setTexture2D(t, e)
			}
		}();
		this.setTexture = function () {
			var i = !1;
			return function (t, e) {
				i || (console.warn("THREE.WebGLRenderer: .setTexture is deprecated, use setTexture2D instead."), i = !0);
				it.setTexture2D(t, e)
			}
		}();
		this.setTextureCube = function () {
			var i = !1;
			return function (t, e) {
				t && t.isWebGLRenderTargetCube && (i || (console.warn("THREE.WebGLRenderer.setTextureCube: don't use cube render targets as textures. Use their .texture property instead."), i = !0), t = t.texture);
				t && t.isCubeTexture || Array.isArray(t.image) && 6 === t.image.length ? it.setTextureCube(t, e) : it.setTextureCubeDynamic(t, e)
			}
		}();
		this.setFramebuffer = function (t) {
			A = t
		};
		this.getRenderTarget = function () {
			return C
		};
		this.setRenderTarget = function (t) {
			(C = t) && void 0 === et.get(t).__webglFramebuffer && it.setupRenderTarget(t);
			var e = A,
				i = !1;
			t ? (e = et.get(t).__webglFramebuffer, t.isWebGLRenderTargetCube && (e = e[t.activeCubeFace], i = !0), N.copy(t.viewport), I.copy(t.scissor), D = t.scissorTest) : (N.copy(G).multiplyScalar(z), I.copy(H).multiplyScalar(z), D = j);
			P !== e && (Z.bindFramebuffer(Z.FRAMEBUFFER, e), P = e);
			K.viewport(N);
			K.scissor(I);
			K.setScissorTest(D);
			i && (i = et.get(t.texture), Z.framebufferTexture2D(Z.FRAMEBUFFER, Z.COLOR_ATTACHMENT0, Z.TEXTURE_CUBE_MAP_POSITIVE_X + t.activeCubeFace, i.__webglTexture, t.activeMipMapLevel))
		};
		this.readRenderTargetPixels = function (t, e, i, n, r, o) {
			if (t && t.isWebGLRenderTarget) {
				var a = et.get(t).__webglFramebuffer;
				if (a) {
					var s = !1;
					a !== P && (Z.bindFramebuffer(Z.FRAMEBUFFER, a), s = !0);
					try {
						var l = t.texture,
							c = l.format,
							u = l.type;
						1023 !== c && pt.convert(c) !== Z.getParameter(Z.IMPLEMENTATION_COLOR_READ_FORMAT) ? console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.") : 1009 === u || pt.convert(u) === Z.getParameter(Z.IMPLEMENTATION_COLOR_READ_TYPE) || 1015 === u && (J.get("OES_texture_float") || J.get("WEBGL_color_buffer_float")) || 1016 === u && J.get("EXT_color_buffer_half_float") ? Z.checkFramebufferStatus(Z.FRAMEBUFFER) === Z.FRAMEBUFFER_COMPLETE ? 0 <= e && e <= t.width - n && 0 <= i && i <= t.height - r && Z.readPixels(e, i, n, r, pt.convert(c), pt.convert(u), o) : console.error("THREE.WebGLRenderer.readRenderTargetPixels: readPixels from renderTarget failed. Framebuffer not complete.") : console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.")
					} finally {
						s && Z.bindFramebuffer(Z.FRAMEBUFFER, P)
					}
				}
			} else console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.")
		};
		this.copyFramebufferToTexture = function (t, e, i) {
			var n = e.image.width,
				r = e.image.height,
				o = pt.convert(e.format);
			this.setTexture2D(e, 0);
			Z.copyTexImage2D(Z.TEXTURE_2D, i || 0, o, t.x, t.y, n, r, 0)
		};
		this.copyTextureToTexture = function (t, e, i, n) {
			var r = e.image.width,
				o = e.image.height,
				a = pt.convert(i.format),
				s = pt.convert(i.type);
			this.setTexture2D(i, 0);
			e.isDataTexture ? Z.texSubImage2D(Z.TEXTURE_2D, n || 0, t.x, t.y, r, o, a, s, e.image.data) : Z.texSubImage2D(Z.TEXTURE_2D, n || 0, t.x, t.y, a, s, e.image)
		}
	}

	function Ee(t, e) {
		this.name = "";
		this.color = new w(t);
		this.density = void 0 !== e ? e : 25e-5
	}

	function Se(t, e, i) {
		this.name = "";
		this.color = new w(t);
		this.near = void 0 !== e ? e : 1;
		this.far = void 0 !== i ? i : 1e3
	}

	function Me() {
		u.call(this);
		this.type = "Scene";
		this.overrideMaterial = this.fog = this.background = null;
		this.autoUpdate = !0
	}

	function Ae(t) {
		k.call(this);
		this.type = "SpriteMaterial";
		this.color = new w(16777215);
		this.map = null;
		this.rotation = 0;
		this.lights = this.fog = !1;
		this.setValues(t)
	}

	function Ce(t) {
		u.call(this);
		this.type = "Sprite";
		this.material = void 0 !== t ? t : new Ae;
		this.center = new W(.5, .5)
	}

	function Pe() {
		u.call(this);
		this.type = "LOD";
		Object.defineProperties(this, {
			levels: {
				enumerable: !0,
				value: []
			}
		})
	}

	function Le(t, e) {
		t = t || [];
		this.bones = t.slice(0);
		this.boneMatrices = new Float32Array(16 * this.bones.length);
		if (void 0 === e) this.calculateInverses();
		else if (this.bones.length === e.length) this.boneInverses = e.slice(0);
		else
			for (console.warn("THREE.Skeleton boneInverses is the wrong length."), this.boneInverses = [], t = 0, e = this.bones.length; t < e; t++) this.boneInverses.push(new xt)
	}

	function Re() {
		u.call(this);
		this.type = "Bone"
	}

	function Oe(t, e) {
		z.call(this, t, e);
		this.type = "SkinnedMesh";
		this.bindMode = "attached";
		this.bindMatrix = new xt;
		this.bindMatrixInverse = new xt;
		t = this.initBones();
		t = new Le(t);
		this.bind(t, this.matrixWorld);
		this.normalizeSkinWeights()
	}

	function ke(t) {
		k.call(this);
		this.type = "LineBasicMaterial";
		this.color = new w(16777215);
		this.linewidth = 1;
		this.linejoin = this.linecap = "round";
		this.lights = !1;
		this.setValues(t)
	}

	function Ne(t, e, i) {
		if (1 === i) return console.warn("THREE.Line: parameter THREE.LinePieces no longer supported. Created THREE.LineSegments instead."), new Ie(t, e);
		u.call(this);
		this.type = "Line";
		this.geometry = void 0 !== t ? t : new L;
		this.material = void 0 !== e ? e : new ke({
			color: 16777215 * Math.random()
		})
	}

	function Ie(t, e) {
		Ne.call(this, t, e);
		this.type = "LineSegments"
	}

	function De(t, e) {
		Ne.call(this, t, e);
		this.type = "LineLoop"
	}

	function Fe(t) {
		k.call(this);
		this.type = "PointsMaterial";
		this.color = new w(16777215);
		this.map = null;
		this.size = 1;
		this.sizeAttenuation = !0;
		this.lights = this.morphTargets = !1;
		this.setValues(t)
	}

	function Be(t, e) {
		u.call(this);
		this.type = "Points";
		this.geometry = void 0 !== t ? t : new L;
		this.material = void 0 !== e ? e : new Fe({
			color: 16777215 * Math.random()
		})
	}

	function Ue() {
		u.call(this);
		this.type = "Group"
	}

	function ze(t, e, i, n, r, o, a, s, l) {
		d.call(this, t, e, i, n, r, o, a, s, l);
		this.generateMipmaps = !1
	}

	function Ge(t, e, i, n, r, o, a, s, l, c, u, h) {
		d.call(this, null, o, a, s, l, c, n, r, u, h);
		this.image = {
			width: e,
			height: i
		};
		this.mipmaps = t;
		this.generateMipmaps = this.flipY = !1
	}

	function He(t, e, i, n, r, o, a, s, l, c) {
		c = void 0 !== c ? c : 1026;
		if (1026 !== c && 1027 !== c) throw Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
		void 0 === i && 1026 === c && (i = 1012);
		void 0 === i && 1027 === c && (i = 1020);
		d.call(this, null, n, r, o, a, s, c, i, l);
		this.image = {
			width: t,
			height: e
		};
		this.magFilter = void 0 !== a ? a : 1003;
		this.minFilter = void 0 !== s ? s : 1003;
		this.generateMipmaps = this.flipY = !1
	}

	function je(t) {
		L.call(this);
		this.type = "WireframeGeometry";
		var e = [],
			i, n, r, o = [0, 0],
			a = {},
			s = ["a", "b", "c"];
		if (t && t.isGeometry) {
			var l = t.faces;
			var c = 0;
			for (n = l.length; c < n; c++) {
				var u = l[c];
				for (i = 0; 3 > i; i++) {
					var h = u[s[i]];
					var d = u[s[(i + 1) % 3]];
					o[0] = Math.min(h, d);
					o[1] = Math.max(h, d);
					h = o[0] + "," + o[1];
					void 0 === a[h] && (a[h] = {
						index1: o[0],
						index2: o[1]
					})
				}
			}
			for (h in a) c = a[h], s = t.vertices[c.index1], e.push(s.x, s.y, s.z), s = t.vertices[c.index2], e.push(s.x, s.y, s.z)
		} else if (t && t.isBufferGeometry)
			if (s = new _t, null !== t.index) {
				l = t.attributes.position;
				u = t.index;
				var f = t.groups;
				0 === f.length && (f = [{
					start: 0,
					count: u.count,
					materialIndex: 0
				}]);
				t = 0;
				for (r = f.length; t < r; ++t)
					for (c = f[t], i = c.start, n = c.count, c = i, n = i + n; c < n; c += 3)
						for (i = 0; 3 > i; i++) h = u.getX(c + i), d = u.getX(c + (i + 1) % 3), o[0] = Math.min(h, d), o[1] = Math.max(h, d), h = o[0] + "," + o[1], void 0 === a[h] && (a[h] = {
							index1: o[0],
							index2: o[1]
						});
				for (h in a) c = a[h], s.fromBufferAttribute(l, c.index1), e.push(s.x, s.y, s.z), s.fromBufferAttribute(l, c.index2), e.push(s.x, s.y, s.z)
			} else
				for (l = t.attributes.position, c = 0, n = l.count / 3; c < n; c++)
					for (i = 0; 3 > i; i++) a = 3 * c + i, s.fromBufferAttribute(l, a), e.push(s.x, s.y, s.z), a = 3 * c + (i + 1) % 3, s.fromBufferAttribute(l, a), e.push(s.x, s.y, s.z);
		this.addAttribute("position", new P(e, 3))
	}

	function Ve(t, e, i) {
		T.call(this);
		this.type = "ParametricGeometry";
		this.parameters = {
			func: t,
			slices: e,
			stacks: i
		};
		this.fromBufferGeometry(new We(t, e, i));
		this.mergeVertices()
	}

	function We(t, e, i) {
		L.call(this);
		this.type = "ParametricBufferGeometry";
		this.parameters = {
			func: t,
			slices: e,
			stacks: i
		};
		var n = [],
			r = [],
			o = [],
			a = [],
			s = new _t,
			l = new _t,
			c = new _t,
			u = new _t,
			h = new _t,
			d, f;
		3 > t.length && console.error("THREE.ParametricGeometry: Function must now modify a Vector3 as third parameter.");
		var p = e + 1;
		for (d = 0; d <= i; d++) {
			var m = d / i;
			for (f = 0; f <= e; f++) {
				var g = f / e;
				t(g, m, l);
				r.push(l.x, l.y, l.z);
				0 <= g - 1e-5 ? (t(g - 1e-5, m, c), u.subVectors(l, c)) : (t(g + 1e-5, m, c), u.subVectors(c, l));
				0 <= m - 1e-5 ? (t(g, m - 1e-5, c), h.subVectors(l, c)) : (t(g, m + 1e-5, c), h.subVectors(c, l));
				s.crossVectors(u, h).normalize();
				o.push(s.x, s.y, s.z);
				a.push(g, m)
			}
		}
		for (d = 0; d < i; d++)
			for (f = 0; f < e; f++) t = d * p + f + 1, s = (d + 1) * p + f + 1, l = (d + 1) * p + f, n.push(d * p + f, t, l), n.push(t, s, l);
		this.setIndex(n);
		this.addAttribute("position", new P(r, 3));
		this.addAttribute("normal", new P(o, 3));
		this.addAttribute("uv", new P(a, 2))
	}

	function Xe(t, e, i, n) {
		T.call(this);
		this.type = "PolyhedronGeometry";
		this.parameters = {
			vertices: t,
			indices: e,
			radius: i,
			detail: n
		};
		this.fromBufferGeometry(new Ye(t, e, i, n));
		this.mergeVertices()
	}

	function Ye(i, m, t, e) {
		function g(t) {
			h.push(t.x, t.y, t.z)
		}

		function v(t, e) {
			t *= 3;
			e.x = i[t + 0];
			e.y = i[t + 1];
			e.z = i[t + 2]
		}

		function u(t, e, i, n) {
			0 > n && 1 === t.x && (d[e] = t.x - 1);
			0 === i.x && 0 === i.z && (d[e] = n / 2 / Math.PI + .5)
		}
		L.call(this);
		this.type = "PolyhedronBufferGeometry";
		this.parameters = {
			vertices: i,
			indices: m,
			radius: t,
			detail: e
		};
		t = t || 1;
		e = e || 0;
		var h = [],
			d = [];
		(function (t) {
			for (var e = new _t, i = new _t, n = new _t, r = 0; r < m.length; r += 3) {
				v(m[r + 0], e);
				v(m[r + 1], i);
				v(m[r + 2], n);
				var o, a, s = e,
					l = i,
					c = n,
					u = Math.pow(2, t),
					h = [];
				for (a = 0; a <= u; a++) {
					h[a] = [];
					var d = s.clone().lerp(c, a / u),
						f = l.clone().lerp(c, a / u),
						p = u - a;
					for (o = 0; o <= p; o++) h[a][o] = 0 === o && a === u ? d : d.clone().lerp(f, o / p)
				}
				for (a = 0; a < u; a++)
					for (o = 0; o < 2 * (u - a) - 1; o++) s = Math.floor(o / 2), 0 === o % 2 ? (g(h[a][s + 1]), g(h[a + 1][s]), g(h[a][s])) : (g(h[a][s + 1]), g(h[a + 1][s + 1]), g(h[a + 1][s]))
			}
		})(e);
		(function (t) {
			for (var e = new _t, i = 0; i < h.length; i += 3) e.x = h[i + 0], e.y = h[i + 1], e.z = h[i + 2], e.normalize().multiplyScalar(t), h[i + 0] = e.x, h[i + 1] = e.y, h[i + 2] = e.z
		})(t);
		(function () {
			for (var t = new _t, e = 0; e < h.length; e += 3) t.x = h[e + 0], t.y = h[e + 1], t.z = h[e + 2], d.push(Math.atan2(t.z, -t.x) / 2 / Math.PI + .5, 1 - (Math.atan2(-t.y, Math.sqrt(t.x * t.x + t.z * t.z)) / Math.PI + .5));
			t = new _t;
			e = new _t;
			for (var i = new _t, n = new _t, r = new W, o = new W, a = new W, s = 0, l = 0; s < h.length; s += 9, l += 6) {
				t.set(h[s + 0], h[s + 1], h[s + 2]);
				e.set(h[s + 3], h[s + 4], h[s + 5]);
				i.set(h[s + 6], h[s + 7], h[s + 8]);
				r.set(d[l + 0], d[l + 1]);
				o.set(d[l + 2], d[l + 3]);
				a.set(d[l + 4], d[l + 5]);
				n.copy(t).add(e).add(i).divideScalar(3);
				var c = Math.atan2(n.z, -n.x);
				u(r, l + 0, t, c);
				u(o, l + 2, e, c);
				u(a, l + 4, i, c)
			}
			for (t = 0; t < d.length; t += 6) e = d[t + 0], i = d[t + 2], n = d[t + 4], r = Math.min(e, i, n), .9 < Math.max(e, i, n) && .1 > r && (.2 > e && (d[t + 0] += 1), .2 > i && (d[t + 2] += 1), .2 > n && (d[t + 4] += 1))
		})();
		this.addAttribute("position", new P(h, 3));
		this.addAttribute("normal", new P(h.slice(), 3));
		this.addAttribute("uv", new P(d, 2));
		0 === e ? this.computeVertexNormals() : this.normalizeNormals()
	}

	function qe(t, e) {
		T.call(this);
		this.type = "TetrahedronGeometry";
		this.parameters = {
			radius: t,
			detail: e
		};
		this.fromBufferGeometry(new $e(t, e));
		this.mergeVertices()
	}

	function $e(t, e) {
		Ye.call(this, [1, 1, 1, -1, -1, 1, -1, 1, -1, 1, -1, -1], [2, 1, 0, 0, 3, 2, 1, 3, 0, 2, 3, 1], t, e);
		this.type = "TetrahedronBufferGeometry";
		this.parameters = {
			radius: t,
			detail: e
		}
	}

	function Ze(t, e) {
		T.call(this);
		this.type = "OctahedronGeometry";
		this.parameters = {
			radius: t,
			detail: e
		};
		this.fromBufferGeometry(new Je(t, e));
		this.mergeVertices()
	}

	function Je(t, e) {
		Ye.call(this, [1, 0, 0, -1, 0, 0, 0, 1, 0, 0, -1, 0, 0, 0, 1, 0, 0, -1], [0, 2, 4, 0, 4, 3, 0, 3, 5, 0, 5, 2, 1, 2, 5, 1, 5, 3, 1, 3, 4, 1, 4, 2], t, e);
		this.type = "OctahedronBufferGeometry";
		this.parameters = {
			radius: t,
			detail: e
		}
	}

	function Qe(t, e) {
		T.call(this);
		this.type = "IcosahedronGeometry";
		this.parameters = {
			radius: t,
			detail: e
		};
		this.fromBufferGeometry(new Ke(t, e));
		this.mergeVertices()
	}

	function Ke(t, e) {
		var i = (1 + Math.sqrt(5)) / 2;
		Ye.call(this, [-1, i, 0, 1, i, 0, -1, -i, 0, 1, -i, 0, 0, -1, i, 0, 1, i, 0, -1, -i, 0, 1, -i, i, 0, -1, i, 0, 1, -i, 0, -1, -i, 0, 1], [0, 11, 5, 0, 5, 1, 0, 1, 7, 0, 7, 10, 0, 10, 11, 1, 5, 9, 5, 11, 4, 11, 10, 2, 10, 7, 6, 7, 1, 8, 3, 9, 4, 3, 4, 2, 3, 2, 6, 3, 6, 8, 3, 8, 9, 4, 9, 5, 2, 4, 11, 6, 2, 10, 8, 6, 7, 9, 8, 1], t, e);
		this.type = "IcosahedronBufferGeometry";
		this.parameters = {
			radius: t,
			detail: e
		}
	}

	function ti(t, e) {
		T.call(this);
		this.type = "DodecahedronGeometry";
		this.parameters = {
			radius: t,
			detail: e
		};
		this.fromBufferGeometry(new ei(t, e));
		this.mergeVertices()
	}

	function ei(t, e) {
		var i = (1 + Math.sqrt(5)) / 2,
			n = 1 / i;
		Ye.call(this, [-1, -1, -1, -1, -1, 1, -1, 1, -1, -1, 1, 1, 1, -1, -1, 1, -1, 1, 1, 1, -1, 1, 1, 1, 0, -n, -i, 0, -n, i, 0, n, -i, 0, n, i, -n, -i, 0, -n, i, 0, n, -i, 0, n, i, 0, -i, 0, -n, i, 0, -n, -i, 0, n, i, 0, n], [3, 11, 7, 3, 7, 15, 3, 15, 13, 7, 19, 17, 7, 17, 6, 7, 6, 15, 17, 4, 8, 17, 8, 10, 17, 10, 6, 8, 0, 16, 8, 16, 2, 8, 2, 10, 0, 12, 1, 0, 1, 18, 0, 18, 16, 6, 10, 2, 6, 2, 13, 6, 13, 15, 2, 16, 18, 2, 18, 3, 2, 3, 13, 18, 1, 9, 18, 9, 11, 18, 11, 3, 4, 14, 12, 4, 12, 0, 4, 0, 8, 11, 9, 5, 11, 5, 19, 11, 19, 7, 19, 5, 14, 19, 14, 4, 19, 4, 17, 1, 12, 14, 1, 14, 5, 1, 5, 9], t, e);
		this.type = "DodecahedronBufferGeometry";
		this.parameters = {
			radius: t,
			detail: e
		}
	}

	function ii(t, e, i, n, r, o) {
		T.call(this);
		this.type = "TubeGeometry";
		this.parameters = {
			path: t,
			tubularSegments: e,
			radius: i,
			radialSegments: n,
			closed: r
		};
		void 0 !== o && console.warn("THREE.TubeGeometry: taper has been removed.");
		t = new ni(t, e, i, n, r);
		this.tangents = t.tangents;
		this.normals = t.normals;
		this.binormals = t.binormals;
		this.fromBufferGeometry(t);
		this.mergeVertices()
	}

	function ni(r, o, a, s, t) {
		function e(t) {
			h = r.getPointAt(t / o, h);
			var e = l.normals[t];
			t = l.binormals[t];
			for (d = 0; d <= s; d++) {
				var i = d / s * Math.PI * 2,
					n = Math.sin(i);
				i = -Math.cos(i);
				u.x = i * e.x + n * t.x;
				u.y = i * e.y + n * t.y;
				u.z = i * e.z + n * t.z;
				u.normalize();
				p.push(u.x, u.y, u.z);
				c.x = h.x + a * u.x;
				c.y = h.y + a * u.y;
				c.z = h.z + a * u.z;
				f.push(c.x, c.y, c.z)
			}
		}
		L.call(this);
		this.type = "TubeBufferGeometry";
		this.parameters = {
			path: r,
			tubularSegments: o,
			radius: a,
			radialSegments: s,
			closed: t
		};
		o = o || 64;
		a = a || 1;
		s = s || 8;
		t = t || !1;
		var l = r.computeFrenetFrames(o, t);
		this.tangents = l.tangents;
		this.normals = l.normals;
		this.binormals = l.binormals;
		var c = new _t,
			u = new _t,
			i = new W,
			h = new _t,
			n, d, f = [],
			p = [],
			m = [],
			g = [];
		for (n = 0; n < o; n++) e(n);
		e(!1 === t ? o : 0);
		for (n = 0; n <= o; n++)
			for (d = 0; d <= s; d++) i.x = n / o, i.y = d / s, m.push(i.x, i.y);
		(function () {
			for (d = 1; d <= o; d++)
				for (n = 1; n <= s; n++) {
					var t = (s + 1) * d + (n - 1),
						e = (s + 1) * d + n,
						i = (s + 1) * (d - 1) + n;
					g.push((s + 1) * (d - 1) + (n - 1), t, i);
					g.push(t, e, i)
				}
		})();
		this.setIndex(g);
		this.addAttribute("position", new P(f, 3));
		this.addAttribute("normal", new P(p, 3));
		this.addAttribute("uv", new P(m, 2))
	}

	function ri(t, e, i, n, r, o, a) {
		T.call(this);
		this.type = "TorusKnotGeometry";
		this.parameters = {
			radius: t,
			tube: e,
			tubularSegments: i,
			radialSegments: n,
			p: r,
			q: o
		};
		void 0 !== a && console.warn("THREE.TorusKnotGeometry: heightScale has been deprecated. Use .scale( x, y, z ) instead.");
		this.fromBufferGeometry(new oi(t, e, i, n, r, o));
		this.mergeVertices()
	}

	function oi(t, e, i, n, r, o) {
		function a(t, e, i, n, r) {
			var o = Math.sin(t);
			e = i / e * t;
			i = Math.cos(e);
			r.x = n * (2 + i) * .5 * Math.cos(t);
			r.y = n * (2 + i) * o * .5;
			r.z = n * Math.sin(e) * .5
		}
		L.call(this);
		this.type = "TorusKnotBufferGeometry";
		this.parameters = {
			radius: t,
			tube: e,
			tubularSegments: i,
			radialSegments: n,
			p: r,
			q: o
		};
		t = t || 1;
		e = e || .4;
		i = Math.floor(i) || 64;
		n = Math.floor(n) || 8;
		r = r || 2;
		o = o || 3;
		var s = [],
			l = [],
			c = [],
			u = [],
			h, d = new _t,
			f = new _t,
			p = new _t,
			m = new _t,
			g = new _t,
			v = new _t,
			y = new _t;
		for (h = 0; h <= i; ++h) {
			var x = h / i * r * Math.PI * 2;
			a(x, r, o, t, p);
			a(x + .01, r, o, t, m);
			v.subVectors(m, p);
			y.addVectors(m, p);
			g.crossVectors(v, y);
			y.crossVectors(g, v);
			g.normalize();
			y.normalize();
			for (x = 0; x <= n; ++x) {
				var _ = x / n * Math.PI * 2,
					b = -e * Math.cos(_);
				_ = e * Math.sin(_);
				d.x = p.x + (b * y.x + _ * g.x);
				d.y = p.y + (b * y.y + _ * g.y);
				d.z = p.z + (b * y.z + _ * g.z);
				l.push(d.x, d.y, d.z);
				f.subVectors(d, p).normalize();
				c.push(f.x, f.y, f.z);
				u.push(h / i);
				u.push(x / n)
			}
		}
		for (x = 1; x <= i; x++)
			for (h = 1; h <= n; h++) t = (n + 1) * x + (h - 1), e = (n + 1) * x + h, r = (n + 1) * (x - 1) + h, s.push((n + 1) * (x - 1) + (h - 1), t, r), s.push(t, e, r);
		this.setIndex(s);
		this.addAttribute("position", new P(l, 3));
		this.addAttribute("normal", new P(c, 3));
		this.addAttribute("uv", new P(u, 2))
	}

	function ai(t, e, i, n, r) {
		T.call(this);
		this.type = "TorusGeometry";
		this.parameters = {
			radius: t,
			tube: e,
			radialSegments: i,
			tubularSegments: n,
			arc: r
		};
		this.fromBufferGeometry(new si(t, e, i, n, r));
		this.mergeVertices()
	}

	function si(t, e, i, n, r) {
		L.call(this);
		this.type = "TorusBufferGeometry";
		this.parameters = {
			radius: t,
			tube: e,
			radialSegments: i,
			tubularSegments: n,
			arc: r
		};
		t = t || 1;
		e = e || .4;
		i = Math.floor(i) || 8;
		n = Math.floor(n) || 6;
		r = r || 2 * Math.PI;
		var o = [],
			a = [],
			s = [],
			l = [],
			c = new _t,
			u = new _t,
			h = new _t,
			d, f;
		for (d = 0; d <= i; d++)
			for (f = 0; f <= n; f++) {
				var p = f / n * r,
					m = d / i * Math.PI * 2;
				u.x = (t + e * Math.cos(m)) * Math.cos(p);
				u.y = (t + e * Math.cos(m)) * Math.sin(p);
				u.z = e * Math.sin(m);
				a.push(u.x, u.y, u.z);
				c.x = t * Math.cos(p);
				c.y = t * Math.sin(p);
				h.subVectors(u, c).normalize();
				s.push(h.x, h.y, h.z);
				l.push(f / n);
				l.push(d / i)
			}
		for (d = 1; d <= i; d++)
			for (f = 1; f <= n; f++) t = (n + 1) * (d - 1) + f - 1, e = (n + 1) * (d - 1) + f, r = (n + 1) * d + f, o.push((n + 1) * d + f - 1, t, r), o.push(t, e, r);
		this.setIndex(o);
		this.addAttribute("position", new P(a, 3));
		this.addAttribute("normal", new P(s, 3));
		this.addAttribute("uv", new P(l, 2))
	}

	function li(t, e, i, n, r) {
		for (var o, a = 0, s = e, l = i - n; s < i; s += n) a += (t[l] - t[s]) * (t[s + 1] + t[l + 1]), l = s;
		if (r === 0 < a)
			for (r = e; r < i; r += n) o = bi(r, t[r], t[r + 1], o);
		else
			for (r = i - n; r >= e; r -= n) o = bi(r, t[r], t[r + 1], o);
		o && vi(o, o.next) && (wi(o), o = o.next);
		return o
	}

	function ci(t, e) {
		if (!t) return t;
		e || (e = t);
		do {
			var i = !1;
			if (t.steiner || !vi(t, t.next) && 0 !== gi(t.prev, t, t.next)) t = t.next;
			else {
				wi(t);
				t = e = t.prev;
				if (t === t.next) break;
				i = !0
			}
		} while (i || t !== e);
		return e
	}

	function ui(t, e, i, n, r, o, a) {
		if (t) {
			if (!a && o) {
				var s = t,
					l = s;
				do {
					null === l.z && (l.z = fi(l.x, l.y, n, r, o)), l.prevZ = l.prev, l = l.nextZ = l.next
				} while (l !== s);
				l.prevZ.nextZ = null;
				l.prevZ = null;
				s = l;
				var c, u, h, d, f = 1;
				do {
					l = s;
					var p = s = null;
					for (u = 0; l;) {
						u++;
						var m = l;
						for (c = h = 0; c < f && (h++, m = m.nextZ, m); c++);
						for (d = f; 0 < h || 0 < d && m;) 0 !== h && (0 === d || !m || l.z <= m.z) ? (c = l, l = l.nextZ, h--) : (c = m, m = m.nextZ, d--), p ? p.nextZ = c : s = c, c.prevZ = p, p = c;
						l = m
					}
					p.nextZ = null;
					f *= 2
				} while (1 < u)
			}
			for (s = t; t.prev !== t.next;) {
				l = t.prev;
				m = t.next;
				if (o) t: {
					p = t;d = n;
					var g = r,
						v = o;u = p.prev;h = p;f = p.next;
					if (0 <= gi(u, h, f)) p = !1;
					else {
						var y = u.x > h.x ? u.x > f.x ? u.x : f.x : h.x > f.x ? h.x : f.x,
							x = u.y > h.y ? u.y > f.y ? u.y : f.y : h.y > f.y ? h.y : f.y;
						c = fi(u.x < h.x ? u.x < f.x ? u.x : f.x : h.x < f.x ? h.x : f.x, u.y < h.y ? u.y < f.y ? u.y : f.y : h.y < f.y ? h.y : f.y, d, g, v);
						d = fi(y, x, d, g, v);
						for (g = p.nextZ; g && g.z <= d;) {
							if (g !== p.prev && g !== p.next && mi(u.x, u.y, h.x, h.y, f.x, f.y, g.x, g.y) && 0 <= gi(g.prev, g, g.next)) {
								p = !1;
								break t
							}
							g = g.nextZ
						}
						for (g = p.prevZ; g && g.z >= c;) {
							if (g !== p.prev && g !== p.next && mi(u.x, u.y, h.x, h.y, f.x, f.y, g.x, g.y) && 0 <= gi(g.prev, g, g.next)) {
								p = !1;
								break t
							}
							g = g.prevZ
						}
						p = !0
					}
				}
				else t: if (p = t, u = p.prev, h = p, f = p.next, 0 <= gi(u, h, f)) p = !1;
					else {
						for (c = p.next.next; c !== p.prev;) {
							if (mi(u.x, u.y, h.x, h.y, f.x, f.y, c.x, c.y) && 0 <= gi(c.prev, c, c.next)) {
								p = !1;
								break t
							}
							c = c.next
						}
						p = !0
					} if (p) e.push(l.i / i), e.push(t.i / i), e.push(m.i / i), wi(t), s = t = m.next;
				else if (t = m, t === s) {
					if (!a) ui(ci(t), e, i, n, r, o, 1);
					else if (1 === a) {
						a = e;
						s = i;
						l = t;
						do {
							m = l.prev, p = l.next.next, !vi(m, p) && yi(m, l, l.next, p) && xi(m, p) && xi(p, m) && (a.push(m.i / s), a.push(l.i / s), a.push(p.i / s), wi(l), wi(l.next), l = t = p), l = l.next
						} while (l !== t);
						t = l;
						ui(t, e, i, n, r, o, 2)
					} else if (2 === a) t: {
						a = t;do {
							for (s = a.next.next; s !== a.prev;) {
								if (l = a.i !== s.i) {
									l = a;
									m = s;
									if (p = l.next.i !== m.i && l.prev.i !== m.i) {
										e: {
											p = l;do {
												if (p.i !== l.i && p.next.i !== l.i && p.i !== m.i && p.next.i !== m.i && yi(p, p.next, l, m)) {
													p = !0;
													break e
												}
												p = p.next
											} while (p !== l);p = !1
										}
										p = !p
									}
									if (p = p && xi(l, m) && xi(m, l)) {
										p = l;
										u = !1;
										h = (l.x + m.x) / 2;
										m = (l.y + m.y) / 2;
										do {
											p.y > m !== p.next.y > m && p.next.y !== p.y && h < (p.next.x - p.x) * (m - p.y) / (p.next.y - p.y) + p.x && (u = !u), p = p.next
										} while (p !== l);
										p = u
									}
									l = p
								}
								if (l) {
									t = _i(a, s);
									a = ci(a, a.next);
									t = ci(t, t.next);
									ui(a, e, i, n, r, o);
									ui(t, e, i, n, r, o);
									break t
								}
								s = s.next
							}
							a = a.next
						} while (a !== t)
					}
					break
				}
			}
		}
	}

	function hi(t, e) {
		return t.x - e.x
	}

	function di(t, e) {
		var i = e,
			n = t.x,
			r = t.y,
			o = -Infinity;
		do {
			if (r <= i.y && r >= i.next.y && i.next.y !== i.y) {
				var a = i.x + (r - i.y) * (i.next.x - i.x) / (i.next.y - i.y);
				if (a <= n && a > o) {
					o = a;
					if (a === n) {
						if (r === i.y) return i;
						if (r === i.next.y) return i.next
					}
					var s = i.x < i.next.x ? i : i.next
				}
			}
			i = i.next
		} while (i !== e);
		if (!s) return null;
		if (n === o) return s.prev;
		e = s;
		a = s.x;
		var l = s.y,
			c = Infinity;
		for (i = s.next; i !== e;) {
			if (n >= i.x && i.x >= a && n !== i.x && mi(r < l ? n : o, r, a, l, r < l ? o : n, r, i.x, i.y)) {
				var u = Math.abs(r - i.y) / (n - i.x);
				(u < c || u === c && i.x > s.x) && xi(i, t) && (s = i, c = u)
			}
			i = i.next
		}
		return s
	}

	function fi(t, e, i, n, r) {
		t = 32767 * (t - i) * r;
		e = 32767 * (e - n) * r;
		t = (t | t << 8) & 16711935;
		t = (t | t << 4) & 252645135;
		t = (t | t << 2) & 858993459;
		e = (e | e << 8) & 16711935;
		e = (e | e << 4) & 252645135;
		e = (e | e << 2) & 858993459;
		return (t | t << 1) & 1431655765 | ((e | e << 1) & 1431655765) << 1
	}

	function pi(t) {
		var e = t,
			i = t;
		do {
			e.x < i.x && (i = e), e = e.next
		} while (e !== t);
		return i
	}

	function mi(t, e, i, n, r, o, a, s) {
		return 0 <= (r - a) * (e - s) - (t - a) * (o - s) && 0 <= (t - a) * (n - s) - (i - a) * (e - s) && 0 <= (i - a) * (o - s) - (r - a) * (n - s)
	}

	function gi(t, e, i) {
		return (e.y - t.y) * (i.x - e.x) - (e.x - t.x) * (i.y - e.y)
	}

	function vi(t, e) {
		return t.x === e.x && t.y === e.y
	}

	function yi(t, e, i, n) {
		return vi(t, e) && vi(i, n) || vi(t, n) && vi(i, e) ? !0 : 0 < gi(t, e, i) !== 0 < gi(t, e, n) && 0 < gi(i, n, t) !== 0 < gi(i, n, e)
	}

	function xi(t, e) {
		return 0 > gi(t.prev, t, t.next) ? 0 <= gi(t, e, t.next) && 0 <= gi(t, t.prev, e) : 0 > gi(t, e, t.prev) || 0 > gi(t, t.next, e)
	}

	function _i(t, e) {
		var i = new Ti(t.i, t.x, t.y),
			n = new Ti(e.i, e.x, e.y),
			r = t.next,
			o = e.prev;
		t.next = e;
		e.prev = t;
		i.next = r;
		r.prev = i;
		n.next = i;
		i.prev = n;
		o.next = n;
		n.prev = o;
		return n
	}

	function bi(t, e, i, n) {
		t = new Ti(t, e, i);
		n ? (t.next = n.next, t.prev = n, n.next.prev = t, n.next = t) : (t.prev = t, t.next = t);
		return t
	}

	function wi(t) {
		t.next.prev = t.prev;
		t.prev.next = t.next;
		t.prevZ && (t.prevZ.nextZ = t.nextZ);
		t.nextZ && (t.nextZ.prevZ = t.prevZ)
	}

	function Ti(t, e, i) {
		this.i = t;
		this.x = e;
		this.y = i;
		this.nextZ = this.prevZ = this.z = this.next = this.prev = null;
		this.steiner = !1
	}

	function Ei(t) {
		var e = t.length;
		2 < e && t[e - 1].equals(t[0]) && t.pop()
	}

	function Si(t, e) {
		for (var i = 0; i < e.length; i++) t.push(e[i].x), t.push(e[i].y)
	}

	function Mi(t, e) {
		T.call(this);
		this.type = "ExtrudeGeometry";
		this.parameters = {
			shapes: t,
			options: e
		};
		this.fromBufferGeometry(new Ai(t, e));
		this.mergeVertices()
	}

	function Ai(t, G) {
		function e(t) {
			function e(t, e, i) {
				e || console.error("THREE.ExtrudeGeometry: vec does not exist");
				return e.clone().multiplyScalar(i).add(t)
			}

			function i(t, e, i) {
				var n = t.x - e.x;
				var r = t.y - e.y;
				var o = i.x - t.x;
				var a = i.y - t.y,
					s = n * n + r * r;
				if (Math.abs(n * a - r * o) > Number.EPSILON) {
					var l = Math.sqrt(s),
						c = Math.sqrt(o * o + a * a);
					s = e.x - r / l;
					e = e.y + n / l;
					a = ((i.x - a / c - s) * a - (i.y + o / c - e) * o) / (n * a - r * o);
					o = s + n * a - t.x;
					n = e + r * a - t.y;
					r = o * o + n * n;
					if (2 >= r) return new W(o, n);
					r = Math.sqrt(r / 2)
				} else t = !1, n > Number.EPSILON ? o > Number.EPSILON && (t = !0) : n < -Number.EPSILON ? o < -Number.EPSILON && (t = !0) : Math.sign(r) === Math.sign(a) && (t = !0), t ? (o = -r, r = Math.sqrt(s)) : (o = n, n = r, r = Math.sqrt(s / 2));
				return new W(o / r, n / r)
			}

			function n(t, e) {
				for (N = t.length; 0 <= --N;) {
					var i = N;
					var n = N - 1;
					0 > n && (n = t.length - 1);
					var r, o = d + 2 * m;
					for (r = 0; r < o; r++) {
						var a = R * r,
							s = R * (r + 1),
							l = e + n + a,
							c = e + n + s;
						s = e + i + s;
						u(e + i + a);
						u(l);
						u(s);
						u(l);
						u(c);
						u(s);
						a = j.length / 3;
						a = v.generateSideWallUV(H, j, a - 6, a - 3, a - 2, a - 1);
						h(a[0]);
						h(a[1]);
						h(a[3]);
						h(a[1]);
						h(a[2]);
						h(a[3])
					}
				}
			}

			function r(t, e, i) {
				a.push(t);
				a.push(e);
				a.push(i)
			}

			function o(t, e, i) {
				u(t);
				u(e);
				u(i);
				t = j.length / 3;
				t = v.generateTopUV(H, j, t - 3, t - 2, t - 1);
				h(t[0]);
				h(t[1]);
				h(t[2])
			}

			function u(t) {
				j.push(a[3 * t]);
				j.push(a[3 * t + 1]);
				j.push(a[3 * t + 2])
			}

			function h(t) {
				V.push(t.x);
				V.push(t.y)
			}
			var a = [],
				s = void 0 !== G.curveSegments ? G.curveSegments : 12,
				d = void 0 !== G.steps ? G.steps : 1,
				l = void 0 !== G.depth ? G.depth : 100,
				c = void 0 !== G.bevelEnabled ? G.bevelEnabled : !0,
				f = void 0 !== G.bevelThickness ? G.bevelThickness : 6,
				p = void 0 !== G.bevelSize ? G.bevelSize : f - 2,
				m = void 0 !== G.bevelSegments ? G.bevelSegments : 3,
				g = G.extrudePath,
				v = void 0 !== G.UVGenerator ? G.UVGenerator : To;
			void 0 !== G.amount && (console.warn("THREE.ExtrudeBufferGeometry: amount has been renamed to depth."), l = G.amount);
			var y = !1;
			if (g) {
				var x = g.getSpacedPoints(d);
				y = !0;
				c = !1;
				var _ = g.computeFrenetFrames(d, !1);
				var b = new _t;
				var w = new _t;
				var T = new _t
			}
			c || (p = f = m = 0);
			var E;
			s = t.extractPoints(s);
			t = s.shape;
			var S = s.holes;
			if (!wo.isClockWise(t)) {
				t = t.reverse();
				var M = 0;
				for (E = S.length; M < E; M++) {
					var A = S[M];
					wo.isClockWise(A) && (S[M] = A.reverse())
				}
			}
			var C = wo.triangulateShape(t, S),
				P = t;
			M = 0;
			for (E = S.length; M < E; M++) A = S[M], t = t.concat(A);
			var L, R = t.length,
				O, k = C.length;
			s = [];
			var N = 0;
			var I = P.length;
			var D = I - 1;
			for (L = N + 1; N < I; N++, D++, L++) D === I && (D = 0), L === I && (L = 0), s[N] = i(P[N], P[D], P[L]);
			g = [];
			var F = s.concat();
			M = 0;
			for (E = S.length; M < E; M++) {
				A = S[M];
				var B = [];
				N = 0;
				I = A.length;
				D = I - 1;
				for (L = N + 1; N < I; N++, D++, L++) D === I && (D = 0), L === I && (L = 0), B[N] = i(A[N], A[D], A[L]);
				g.push(B);
				F = F.concat(B)
			}
			for (D = 0; D < m; D++) {
				I = D / m;
				var U = f * Math.cos(I * Math.PI / 2);
				L = p * Math.sin(I * Math.PI / 2);
				N = 0;
				for (I = P.length; N < I; N++) {
					var z = e(P[N], s[N], L);
					r(z.x, z.y, -U)
				}
				M = 0;
				for (E = S.length; M < E; M++)
					for (A = S[M], B = g[M], N = 0, I = A.length; N < I; N++) z = e(A[N], B[N], L), r(z.x, z.y, -U)
			}
			L = p;
			for (N = 0; N < R; N++) z = c ? e(t[N], F[N], L) : t[N], y ? (w.copy(_.normals[0]).multiplyScalar(z.x), b.copy(_.binormals[0]).multiplyScalar(z.y), T.copy(x[0]).add(w).add(b), r(T.x, T.y, T.z)) : r(z.x, z.y, 0);
			for (I = 1; I <= d; I++)
				for (N = 0; N < R; N++) z = c ? e(t[N], F[N], L) : t[N], y ? (w.copy(_.normals[I]).multiplyScalar(z.x), b.copy(_.binormals[I]).multiplyScalar(z.y), T.copy(x[I]).add(w).add(b), r(T.x, T.y, T.z)) : r(z.x, z.y, l / d * I);
			for (D = m - 1; 0 <= D; D--) {
				I = D / m;
				U = f * Math.cos(I * Math.PI / 2);
				L = p * Math.sin(I * Math.PI / 2);
				N = 0;
				for (I = P.length; N < I; N++) z = e(P[N], s[N], L), r(z.x, z.y, l + U);
				M = 0;
				for (E = S.length; M < E; M++)
					for (A = S[M], B = g[M], N = 0, I = A.length; N < I; N++) z = e(A[N], B[N], L), y ? r(z.x, z.y + x[d - 1].y, x[d - 1].x + U) : r(z.x, z.y, l + U)
			}(function () {
				var t = j.length / 3;
				if (c) {
					var e = 0 * R;
					for (N = 0; N < k; N++) O = C[N], o(O[2] + e, O[1] + e, O[0] + e);
					e = R * (d + 2 * m);
					for (N = 0; N < k; N++) O = C[N], o(O[0] + e, O[1] + e, O[2] + e)
				} else {
					for (N = 0; N < k; N++) O = C[N], o(O[2], O[1], O[0]);
					for (N = 0; N < k; N++) O = C[N], o(O[0] + R * d, O[1] + R * d, O[2] + R * d)
				}
				H.addGroup(t, j.length / 3 - t, 0)
			})();
			(function () {
				var t = j.length / 3,
					e = 0;
				n(P, e);
				e += P.length;
				M = 0;
				for (E = S.length; M < E; M++) A = S[M], n(A, e), e += A.length;
				H.addGroup(t, j.length / 3 - t, 1)
			})()
		}
		L.call(this);
		this.type = "ExtrudeBufferGeometry";
		this.parameters = {
			shapes: t,
			options: G
		};
		t = Array.isArray(t) ? t : [t];
		for (var H = this, j = [], V = [], i = 0, n = t.length; i < n; i++) e(t[i]);
		this.addAttribute("position", new P(j, 3));
		this.addAttribute("uv", new P(V, 2));
		this.computeVertexNormals()
	}

	function Ci(t, e, i) {
		i.shapes = [];
		if (Array.isArray(t))
			for (var n = 0, r = t.length; n < r; n++) i.shapes.push(t[n].uuid);
		else i.shapes.push(t.uuid);
		void 0 !== e.extrudePath && (i.options.extrudePath = e.extrudePath.toJSON());
		return i
	}

	function Pi(t, e) {
		T.call(this);
		this.type = "TextGeometry";
		this.parameters = {
			text: t,
			parameters: e
		};
		this.fromBufferGeometry(new Li(t, e));
		this.mergeVertices()
	}

	function Li(t, e) {
		e = e || {};
		var i = e.font;
		if (!i || !i.isFont) return console.error("THREE.TextGeometry: font parameter is not an instance of THREE.Font."), new T;
		t = i.generateShapes(t, e.size, e.curveSegments);
		e.depth = void 0 !== e.height ? e.height : 50;
		void 0 === e.bevelThickness && (e.bevelThickness = 10);
		void 0 === e.bevelSize && (e.bevelSize = 8);
		void 0 === e.bevelEnabled && (e.bevelEnabled = !1);
		Ai.call(this, t, e);
		this.type = "TextBufferGeometry"
	}

	function Ri(t, e, i, n, r, o, a) {
		T.call(this);
		this.type = "SphereGeometry";
		this.parameters = {
			radius: t,
			widthSegments: e,
			heightSegments: i,
			phiStart: n,
			phiLength: r,
			thetaStart: o,
			thetaLength: a
		};
		this.fromBufferGeometry(new Oi(t, e, i, n, r, o, a));
		this.mergeVertices()
	}

	function Oi(t, e, i, n, r, o, a) {
		L.call(this);
		this.type = "SphereBufferGeometry";
		this.parameters = {
			radius: t,
			widthSegments: e,
			heightSegments: i,
			phiStart: n,
			phiLength: r,
			thetaStart: o,
			thetaLength: a
		};
		t = t || 1;
		e = Math.max(3, Math.floor(e) || 8);
		i = Math.max(2, Math.floor(i) || 6);
		n = void 0 !== n ? n : 0;
		r = void 0 !== r ? r : 2 * Math.PI;
		o = void 0 !== o ? o : 0;
		a = void 0 !== a ? a : Math.PI;
		var s = o + a,
			l, c, u = 0,
			h = [],
			d = new _t,
			f = new _t,
			p = [],
			m = [],
			g = [],
			v = [];
		for (c = 0; c <= i; c++) {
			var y = [],
				x = c / i;
			for (l = 0; l <= e; l++) {
				var _ = l / e;
				d.x = -t * Math.cos(n + _ * r) * Math.sin(o + x * a);
				d.y = t * Math.cos(o + x * a);
				d.z = t * Math.sin(n + _ * r) * Math.sin(o + x * a);
				m.push(d.x, d.y, d.z);
				f.set(d.x, d.y, d.z).normalize();
				g.push(f.x, f.y, f.z);
				v.push(_, 1 - x);
				y.push(u++)
			}
			h.push(y)
		}
		for (c = 0; c < i; c++)
			for (l = 0; l < e; l++) t = h[c][l + 1], n = h[c][l], r = h[c + 1][l], a = h[c + 1][l + 1], (0 !== c || 0 < o) && p.push(t, n, a), (c !== i - 1 || s < Math.PI) && p.push(n, r, a);
		this.setIndex(p);
		this.addAttribute("position", new P(m, 3));
		this.addAttribute("normal", new P(g, 3));
		this.addAttribute("uv", new P(v, 2))
	}

	function ki(t, e, i, n, r, o) {
		T.call(this);
		this.type = "RingGeometry";
		this.parameters = {
			innerRadius: t,
			outerRadius: e,
			thetaSegments: i,
			phiSegments: n,
			thetaStart: r,
			thetaLength: o
		};
		this.fromBufferGeometry(new Ni(t, e, i, n, r, o));
		this.mergeVertices()
	}

	function Ni(t, e, i, n, r, o) {
		L.call(this);
		this.type = "RingBufferGeometry";
		this.parameters = {
			innerRadius: t,
			outerRadius: e,
			thetaSegments: i,
			phiSegments: n,
			thetaStart: r,
			thetaLength: o
		};
		t = t || .5;
		e = e || 1;
		r = void 0 !== r ? r : 0;
		o = void 0 !== o ? o : 2 * Math.PI;
		i = void 0 !== i ? Math.max(3, i) : 8;
		n = void 0 !== n ? Math.max(1, n) : 1;
		var a = [],
			s = [],
			l = [],
			c = [],
			u = t,
			h = (e - t) / n,
			d = new _t,
			f = new W,
			p, m;
		for (p = 0; p <= n; p++) {
			for (m = 0; m <= i; m++) t = r + m / i * o, d.x = u * Math.cos(t), d.y = u * Math.sin(t), s.push(d.x, d.y, d.z), l.push(0, 0, 1), f.x = (d.x / e + 1) / 2, f.y = (d.y / e + 1) / 2, c.push(f.x, f.y);
			u += h
		}
		for (p = 0; p < n; p++)
			for (e = p * (i + 1), m = 0; m < i; m++) t = m + e, r = t + i + 1, o = t + i + 2, u = t + 1, a.push(t, r, u), a.push(r, o, u);
		this.setIndex(a);
		this.addAttribute("position", new P(s, 3));
		this.addAttribute("normal", new P(l, 3));
		this.addAttribute("uv", new P(c, 2))
	}

	function Ii(t, e, i, n) {
		T.call(this);
		this.type = "LatheGeometry";
		this.parameters = {
			points: t,
			segments: e,
			phiStart: i,
			phiLength: n
		};
		this.fromBufferGeometry(new Di(t, e, i, n));
		this.mergeVertices()
	}

	function Di(t, e, i, n) {
		L.call(this);
		this.type = "LatheBufferGeometry";
		this.parameters = {
			points: t,
			segments: e,
			phiStart: i,
			phiLength: n
		};
		e = Math.floor(e) || 12;
		i = i || 0;
		n = n || 2 * Math.PI;
		n = Kr.clamp(n, 0, 2 * Math.PI);
		var r = [],
			o = [],
			a = [],
			s = 1 / e,
			l = new _t,
			c = new W,
			u;
		for (u = 0; u <= e; u++) {
			var h = i + u * s * n;
			var d = Math.sin(h),
				f = Math.cos(h);
			for (h = 0; h <= t.length - 1; h++) l.x = t[h].x * d, l.y = t[h].y, l.z = t[h].x * f, o.push(l.x, l.y, l.z), c.x = u / e, c.y = h / (t.length - 1), a.push(c.x, c.y)
		}
		for (u = 0; u < e; u++)
			for (h = 0; h < t.length - 1; h++) i = h + u * t.length, s = i + t.length, l = i + t.length + 1, c = i + 1, r.push(i, s, c), r.push(s, l, c);
		this.setIndex(r);
		this.addAttribute("position", new P(o, 3));
		this.addAttribute("uv", new P(a, 2));
		this.computeVertexNormals();
		if (n === 2 * Math.PI)
			for (n = this.attributes.normal.array, r = new _t, o = new _t, a = new _t, i = e * t.length * 3, h = u = 0; u < t.length; u++, h += 3) r.x = n[h + 0], r.y = n[h + 1], r.z = n[h + 2], o.x = n[i + h + 0], o.y = n[i + h + 1], o.z = n[i + h + 2], a.addVectors(r, o).normalize(), n[h + 0] = n[i + h + 0] = a.x, n[h + 1] = n[i + h + 1] = a.y, n[h + 2] = n[i + h + 2] = a.z
	}

	function Fi(t, e) {
		T.call(this);
		this.type = "ShapeGeometry";
		"object" === typeof e && (console.warn("THREE.ShapeGeometry: Options parameter has been removed."), e = e.curveSegments);
		this.parameters = {
			shapes: t,
			curveSegments: e
		};
		this.fromBufferGeometry(new Bi(t, e));
		this.mergeVertices()
	}

	function Bi(t, s) {
		function e(t) {
			var e, i = c.length / 3;
			t = t.extractPoints(s);
			var n = t.shape,
				r = t.holes;
			if (!1 === wo.isClockWise(n))
				for (n = n.reverse(), t = 0, e = r.length; t < e; t++) {
					var o = r[t];
					!0 === wo.isClockWise(o) && (r[t] = o.reverse())
				}
			var a = wo.triangulateShape(n, r);
			t = 0;
			for (e = r.length; t < e; t++) o = r[t], n = n.concat(o);
			t = 0;
			for (e = n.length; t < e; t++) o = n[t], c.push(o.x, o.y, 0), u.push(0, 0, 1), h.push(o.x, o.y);
			t = 0;
			for (e = a.length; t < e; t++) n = a[t], l.push(n[0] + i, n[1] + i, n[2] + i), d += 3
		}
		L.call(this);
		this.type = "ShapeBufferGeometry";
		this.parameters = {
			shapes: t,
			curveSegments: s
		};
		s = s || 12;
		var l = [],
			c = [],
			u = [],
			h = [],
			i = 0,
			d = 0;
		if (!1 === Array.isArray(t)) e(t);
		else
			for (var n = 0; n < t.length; n++) e(t[n]), this.addGroup(i, d, n), i += d, d = 0;
		this.setIndex(l);
		this.addAttribute("position", new P(c, 3));
		this.addAttribute("normal", new P(u, 3));
		this.addAttribute("uv", new P(h, 2))
	}

	function Ui(t, e) {
		e.shapes = [];
		if (Array.isArray(t))
			for (var i = 0, n = t.length; i < n; i++) e.shapes.push(t[i].uuid);
		else e.shapes.push(t.uuid);
		return e
	}

	function zi(t, e) {
		L.call(this);
		this.type = "EdgesGeometry";
		this.parameters = {
			thresholdAngle: e
		};
		var i = [];
		e = Math.cos(Kr.DEG2RAD * (void 0 !== e ? e : 1));
		var n = [0, 0],
			r = {},
			o = ["a", "b", "c"];
		if (t.isBufferGeometry) {
			var a = new T;
			a.fromBufferGeometry(t)
		} else a = t.clone();
		a.mergeVertices();
		a.computeFaceNormals();
		t = a.vertices;
		a = a.faces;
		for (var s = 0, l = a.length; s < l; s++)
			for (var c = a[s], u = 0; 3 > u; u++) {
				var h = c[o[u]];
				var d = c[o[(u + 1) % 3]];
				n[0] = Math.min(h, d);
				n[1] = Math.max(h, d);
				h = n[0] + "," + n[1];
				void 0 === r[h] ? r[h] = {
					index1: n[0],
					index2: n[1],
					face1: s,
					face2: void 0
				} : r[h].face2 = s
			}
		for (h in r)
			if (n = r[h], void 0 === n.face2 || a[n.face1].normal.dot(a[n.face2].normal) <= e) o = t[n.index1], i.push(o.x, o.y, o.z), o = t[n.index2], i.push(o.x, o.y, o.z);
		this.addAttribute("position", new P(i, 3))
	}

	function Gi(t, e, i, n, r, o, a, s) {
		T.call(this);
		this.type = "CylinderGeometry";
		this.parameters = {
			radiusTop: t,
			radiusBottom: e,
			height: i,
			radialSegments: n,
			heightSegments: r,
			openEnded: o,
			thetaStart: a,
			thetaLength: s
		};
		this.fromBufferGeometry(new Hi(t, e, i, n, r, o, a, s));
		this.mergeVertices()
	}

	function Hi(d, f, p, m, g, t, v, y) {
		function e(t) {
			var e, i = new W,
				n = new _t,
				r = 0,
				o = !0 === t ? d : f,
				a = !0 === t ? 1 : -1;
			var s = E;
			for (e = 1; e <= m; e++) b.push(0, M * a, 0), w.push(0, a, 0), T.push(.5, .5), E++;
			var l = E;
			for (e = 0; e <= m; e++) {
				var c = e / m * y + v,
					u = Math.cos(c);
				c = Math.sin(c);
				n.x = o * c;
				n.y = M * a;
				n.z = o * u;
				b.push(n.x, n.y, n.z);
				w.push(0, a, 0);
				i.x = .5 * u + .5;
				i.y = .5 * c * a + .5;
				T.push(i.x, i.y);
				E++
			}
			for (e = 0; e < m; e++) i = s + e, n = l + e, !0 === t ? _.push(n, n + 1, i) : _.push(n + 1, n, i), r += 3;
			x.addGroup(A, r, !0 === t ? 1 : 2);
			A += r
		}
		L.call(this);
		this.type = "CylinderBufferGeometry";
		this.parameters = {
			radiusTop: d,
			radiusBottom: f,
			height: p,
			radialSegments: m,
			heightSegments: g,
			openEnded: t,
			thetaStart: v,
			thetaLength: y
		};
		var x = this;
		d = void 0 !== d ? d : 1;
		f = void 0 !== f ? f : 1;
		p = p || 1;
		m = Math.floor(m) || 8;
		g = Math.floor(g) || 1;
		t = void 0 !== t ? t : !1;
		v = void 0 !== v ? v : 0;
		y = void 0 !== y ? y : 2 * Math.PI;
		var _ = [],
			b = [],
			w = [],
			T = [],
			E = 0,
			S = [],
			M = p / 2,
			A = 0;
		(function () {
			var t, e, i = new _t,
				n = new _t,
				r = 0,
				o = (f - d) / p;
			for (e = 0; e <= g; e++) {
				var a = [],
					s = e / g,
					l = s * (f - d) + d;
				for (t = 0; t <= m; t++) {
					var c = t / m,
						u = c * y + v,
						h = Math.sin(u);
					u = Math.cos(u);
					n.x = l * h;
					n.y = -s * p + M;
					n.z = l * u;
					b.push(n.x, n.y, n.z);
					i.set(h, o, u).normalize();
					w.push(i.x, i.y, i.z);
					T.push(c, 1 - s);
					a.push(E++)
				}
				S.push(a)
			}
			for (t = 0; t < m; t++)
				for (e = 0; e < g; e++) i = S[e + 1][t], n = S[e + 1][t + 1], o = S[e][t + 1], _.push(S[e][t], i, o), _.push(i, n, o), r += 6;
			x.addGroup(A, r, 0);
			A += r
		})();
		!1 === t && (0 < d && e(!0), 0 < f && e(!1));
		this.setIndex(_);
		this.addAttribute("position", new P(b, 3));
		this.addAttribute("normal", new P(w, 3));
		this.addAttribute("uv", new P(T, 2))
	}

	function ji(t, e, i, n, r, o, a) {
		Gi.call(this, 0, t, e, i, n, r, o, a);
		this.type = "ConeGeometry";
		this.parameters = {
			radius: t,
			height: e,
			radialSegments: i,
			heightSegments: n,
			openEnded: r,
			thetaStart: o,
			thetaLength: a
		}
	}

	function Vi(t, e, i, n, r, o, a) {
		Hi.call(this, 0, t, e, i, n, r, o, a);
		this.type = "ConeBufferGeometry";
		this.parameters = {
			radius: t,
			height: e,
			radialSegments: i,
			heightSegments: n,
			openEnded: r,
			thetaStart: o,
			thetaLength: a
		}
	}

	function Wi(t, e, i, n) {
		T.call(this);
		this.type = "CircleGeometry";
		this.parameters = {
			radius: t,
			segments: e,
			thetaStart: i,
			thetaLength: n
		};
		this.fromBufferGeometry(new Xi(t, e, i, n));
		this.mergeVertices()
	}

	function Xi(t, e, i, n) {
		L.call(this);
		this.type = "CircleBufferGeometry";
		this.parameters = {
			radius: t,
			segments: e,
			thetaStart: i,
			thetaLength: n
		};
		t = t || 1;
		e = void 0 !== e ? Math.max(3, e) : 8;
		i = void 0 !== i ? i : 0;
		n = void 0 !== n ? n : 2 * Math.PI;
		var r = [],
			o = [],
			a = [],
			s = [],
			l, c = new _t,
			u = new W;
		o.push(0, 0, 0);
		a.push(0, 0, 1);
		s.push(.5, .5);
		var h = 0;
		for (l = 3; h <= e; h++, l += 3) {
			var d = i + h / e * n;
			c.x = t * Math.cos(d);
			c.y = t * Math.sin(d);
			o.push(c.x, c.y, c.z);
			a.push(0, 0, 1);
			u.x = (o[l] / t + 1) / 2;
			u.y = (o[l + 1] / t + 1) / 2;
			s.push(u.x, u.y)
		}
		for (l = 1; l <= e; l++) r.push(l, l + 1, 0);
		this.setIndex(r);
		this.addAttribute("position", new P(o, 3));
		this.addAttribute("normal", new P(a, 3));
		this.addAttribute("uv", new P(s, 2))
	}

	function Yi(t) {
		k.call(this);
		this.type = "ShadowMaterial";
		this.color = new w(0);
		this.transparent = !0;
		this.setValues(t)
	}

	function qi(t) {
		I.call(this, t);
		this.type = "RawShaderMaterial"
	}

	function $i(t) {
		k.call(this);
		this.defines = {
			STANDARD: ""
		};
		this.type = "MeshStandardMaterial";
		this.color = new w(16777215);
		this.metalness = this.roughness = .5;
		this.lightMap = this.map = null;
		this.lightMapIntensity = 1;
		this.aoMap = null;
		this.aoMapIntensity = 1;
		this.emissive = new w(0);
		this.emissiveIntensity = 1;
		this.bumpMap = this.emissiveMap = null;
		this.bumpScale = 1;
		this.normalMap = null;
		this.normalScale = new W(1, 1);
		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;
		this.envMap = this.alphaMap = this.metalnessMap = this.roughnessMap = null;
		this.envMapIntensity = 1;
		this.refractionRatio = .98;
		this.wireframe = !1;
		this.wireframeLinewidth = 1;
		this.wireframeLinejoin = this.wireframeLinecap = "round";
		this.morphNormals = this.morphTargets = this.skinning = !1;
		this.setValues(t)
	}

	function Zi(t) {
		$i.call(this);
		this.defines = {
			PHYSICAL: ""
		};
		this.type = "MeshPhysicalMaterial";
		this.reflectivity = .5;
		this.clearCoatRoughness = this.clearCoat = 0;
		this.setValues(t)
	}

	function Ji(t) {
		k.call(this);
		this.type = "MeshPhongMaterial";
		this.color = new w(16777215);
		this.specular = new w(1118481);
		this.shininess = 30;
		this.lightMap = this.map = null;
		this.lightMapIntensity = 1;
		this.aoMap = null;
		this.aoMapIntensity = 1;
		this.emissive = new w(0);
		this.emissiveIntensity = 1;
		this.bumpMap = this.emissiveMap = null;
		this.bumpScale = 1;
		this.normalMap = null;
		this.normalScale = new W(1, 1);
		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;
		this.envMap = this.alphaMap = this.specularMap = null;
		this.combine = 0;
		this.reflectivity = 1;
		this.refractionRatio = .98;
		this.wireframe = !1;
		this.wireframeLinewidth = 1;
		this.wireframeLinejoin = this.wireframeLinecap = "round";
		this.morphNormals = this.morphTargets = this.skinning = !1;
		this.setValues(t)
	}

	function Qi(t) {
		Ji.call(this);
		this.defines = {
			TOON: ""
		};
		this.type = "MeshToonMaterial";
		this.gradientMap = null;
		this.setValues(t)
	}

	function Ki(t) {
		k.call(this);
		this.type = "MeshNormalMaterial";
		this.bumpMap = null;
		this.bumpScale = 1;
		this.normalMap = null;
		this.normalScale = new W(1, 1);
		this.displacementMap = null;
		this.displacementScale = 1;
		this.displacementBias = 0;
		this.wireframe = !1;
		this.wireframeLinewidth = 1;
		this.morphNormals = this.morphTargets = this.skinning = this.lights = this.fog = !1;
		this.setValues(t)
	}

	function tn(t) {
		k.call(this);
		this.type = "MeshLambertMaterial";
		this.color = new w(16777215);
		this.lightMap = this.map = null;
		this.lightMapIntensity = 1;
		this.aoMap = null;
		this.aoMapIntensity = 1;
		this.emissive = new w(0);
		this.emissiveIntensity = 1;
		this.envMap = this.alphaMap = this.specularMap = this.emissiveMap = null;
		this.combine = 0;
		this.reflectivity = 1;
		this.refractionRatio = .98;
		this.wireframe = !1;
		this.wireframeLinewidth = 1;
		this.wireframeLinejoin = this.wireframeLinecap = "round";
		this.morphNormals = this.morphTargets = this.skinning = !1;
		this.setValues(t)
	}

	function en(t) {
		ke.call(this);
		this.type = "LineDashedMaterial";
		this.scale = 1;
		this.dashSize = 3;
		this.gapSize = 1;
		this.setValues(t)
	}

	function nn(t, e, i) {
		var n = this,
			r = !1,
			o = 0,
			a = 0,
			s = void 0;
		this.onStart = void 0;
		this.onLoad = t;
		this.onProgress = e;
		this.onError = i;
		this.itemStart = function (t) {
			a++;
			if (!1 === r && void 0 !== n.onStart) n.onStart(t, o, a);
			r = !0
		};
		this.itemEnd = function (t) {
			o++;
			if (void 0 !== n.onProgress) n.onProgress(t, o, a);
			if (o === a && (r = !1, void 0 !== n.onLoad)) n.onLoad()
		};
		this.itemError = function (t) {
			if (void 0 !== n.onError) n.onError(t)
		};
		this.resolveURL = function (t) {
			return s ? s(t) : t
		};
		this.setURLModifier = function (t) {
			s = t;
			return this
		}
	}

	function rn(t) {
		this.manager = void 0 !== t ? t : Ao
	}

	function on(t) {
		this.manager = void 0 !== t ? t : Ao;
		this._parser = null
	}

	function an(t) {
		this.manager = void 0 !== t ? t : Ao;
		this._parser = null
	}

	function sn(t) {
		this.manager = void 0 !== t ? t : Ao
	}

	function ln(t) {
		this.manager = void 0 !== t ? t : Ao
	}

	function cn(t) {
		this.manager = void 0 !== t ? t : Ao
	}

	function un() {
		this.type = "Curve";
		this.arcLengthDivisions = 200
	}

	function hn(t, e, i, n, r, o, a, s) {
		un.call(this);
		this.type = "EllipseCurve";
		this.aX = t || 0;
		this.aY = e || 0;
		this.xRadius = i || 1;
		this.yRadius = n || 1;
		this.aStartAngle = r || 0;
		this.aEndAngle = o || 2 * Math.PI;
		this.aClockwise = a || !1;
		this.aRotation = s || 0
	}

	function dn(t, e, i, n, r, o) {
		hn.call(this, t, e, i, i, n, r, o);
		this.type = "ArcCurve"
	}

	function fn() {
		var s = 0,
			l = 0,
			c = 0,
			u = 0;
		return {
			initCatmullRom: function (t, e, i, n, r) {
				t = r * (i - t);
				n = r * (n - e);
				s = e;
				l = t;
				c = -3 * e + 3 * i - 2 * t - n;
				u = 2 * e - 2 * i + t + n
			},
			initNonuniformCatmullRom: function (t, e, i, n, r, o, a) {
				t = ((e - t) / r - (i - t) / (r + o) + (i - e) / o) * o;
				n = ((i - e) / o - (n - e) / (o + a) + (n - i) / a) * o;
				s = e;
				l = t;
				c = -3 * e + 3 * i - 2 * t - n;
				u = 2 * e - 2 * i + t + n
			},
			calc: function (t) {
				var e = t * t;
				return s + l * t + c * e + u * e * t
			}
		}
	}

	function pn(t, e, i, n) {
		un.call(this);
		this.type = "CatmullRomCurve3";
		this.points = t || [];
		this.closed = e || !1;
		this.curveType = i || "centripetal";
		this.tension = n || .5
	}

	function mn(t, e, i, n, r) {
		e = .5 * (n - e);
		r = .5 * (r - i);
		var o = t * t;
		return (2 * i - 2 * n + e + r) * t * o + (-3 * i + 3 * n - 2 * e - r) * o + e * t + i
	}

	function gn(t, e, i, n) {
		var r = 1 - t;
		return r * r * e + 2 * (1 - t) * t * i + t * t * n
	}

	function vn(t, e, i, n, r) {
		var o = 1 - t,
			a = 1 - t;
		return o * o * o * e + 3 * a * a * t * i + 3 * (1 - t) * t * t * n + t * t * t * r
	}

	function yn(t, e, i, n) {
		un.call(this);
		this.type = "CubicBezierCurve";
		this.v0 = t || new W;
		this.v1 = e || new W;
		this.v2 = i || new W;
		this.v3 = n || new W
	}

	function xn(t, e, i, n) {
		un.call(this);
		this.type = "CubicBezierCurve3";
		this.v0 = t || new _t;
		this.v1 = e || new _t;
		this.v2 = i || new _t;
		this.v3 = n || new _t
	}

	function _n(t, e) {
		un.call(this);
		this.type = "LineCurve";
		this.v1 = t || new W;
		this.v2 = e || new W
	}

	function bn(t, e) {
		un.call(this);
		this.type = "LineCurve3";
		this.v1 = t || new _t;
		this.v2 = e || new _t
	}

	function wn(t, e, i) {
		un.call(this);
		this.type = "QuadraticBezierCurve";
		this.v0 = t || new W;
		this.v1 = e || new W;
		this.v2 = i || new W
	}

	function Tn(t, e, i) {
		un.call(this);
		this.type = "QuadraticBezierCurve3";
		this.v0 = t || new _t;
		this.v1 = e || new _t;
		this.v2 = i || new _t
	}

	function En(t) {
		un.call(this);
		this.type = "SplineCurve";
		this.points = t || []
	}

	function Sn() {
		un.call(this);
		this.type = "CurvePath";
		this.curves = [];
		this.autoClose = !1
	}

	function Mn(t) {
		Sn.call(this);
		this.type = "Path";
		this.currentPoint = new W;
		t && this.setFromPoints(t)
	}

	function An(t) {
		Mn.call(this, t);
		this.uuid = Kr.generateUUID();
		this.type = "Shape";
		this.holes = []
	}

	function Cn(t, e) {
		u.call(this);
		this.type = "Light";
		this.color = new w(t);
		this.intensity = void 0 !== e ? e : 1;
		this.receiveShadow = void 0
	}

	function Pn(t, e, i) {
		Cn.call(this, t, i);
		this.type = "HemisphereLight";
		this.castShadow = void 0;
		this.position.copy(u.DefaultUp);
		this.updateMatrix();
		this.groundColor = new w(e)
	}

	function Ln(t) {
		this.camera = t;
		this.bias = 0;
		this.radius = 1;
		this.mapSize = new W(512, 512);
		this.map = null;
		this.matrix = new xt
	}

	function Rn() {
		Ln.call(this, new xe(50, 1, .5, 500))
	}

	function On(t, e, i, n, r, o) {
		Cn.call(this, t, e);
		this.type = "SpotLight";
		this.position.copy(u.DefaultUp);
		this.updateMatrix();
		this.target = new u;
		Object.defineProperty(this, "power", {
			get: function () {
				return this.intensity * Math.PI
			},
			set: function (t) {
				this.intensity = t / Math.PI
			}
		});
		this.distance = void 0 !== i ? i : 0;
		this.angle = void 0 !== n ? n : Math.PI / 3;
		this.penumbra = void 0 !== r ? r : 0;
		this.decay = void 0 !== o ? o : 1;
		this.shadow = new Rn
	}

	function kn(t, e, i, n) {
		Cn.call(this, t, e);
		this.type = "PointLight";
		Object.defineProperty(this, "power", {
			get: function () {
				return 4 * this.intensity * Math.PI
			},
			set: function (t) {
				this.intensity = t / (4 * Math.PI)
			}
		});
		this.distance = void 0 !== i ? i : 0;
		this.decay = void 0 !== n ? n : 1;
		this.shadow = new Ln(new xe(90, 1, .5, 500))
	}

	function Nn() {
		Ln.call(this, new f(-5, 5, 5, -5, .5, 500))
	}

	function In(t, e) {
		Cn.call(this, t, e);
		this.type = "DirectionalLight";
		this.position.copy(u.DefaultUp);
		this.updateMatrix();
		this.target = new u;
		this.shadow = new Nn
	}

	function Dn(t, e) {
		Cn.call(this, t, e);
		this.type = "AmbientLight";
		this.castShadow = void 0
	}

	function Fn(t, e, i, n) {
		Cn.call(this, t, e);
		this.type = "RectAreaLight";
		this.width = void 0 !== i ? i : 10;
		this.height = void 0 !== n ? n : 10
	}

	function Bn(t, e, i, n) {
		qn.call(this, t, e, i, n)
	}

	function Un(t, e, i) {
		qn.call(this, t, e, i)
	}

	function zn(t, e, i, n) {
		this.parameterPositions = t;
		this._cachedIndex = 0;
		this.resultBuffer = void 0 !== n ? n : new e.constructor(i);
		this.sampleValues = e;
		this.valueSize = i
	}

	function Gn(t, e, i, n) {
		zn.call(this, t, e, i, n)
	}

	function Hn(t, e, i, n) {
		qn.call(this, t, e, i, n)
	}

	function jn(t, e, i, n) {
		qn.call(this, t, e, i, n)
	}

	function Vn(t, e, i, n) {
		qn.call(this, t, e, i, n)
	}

	function Wn(t, e, i, n) {
		zn.call(this, t, e, i, n);
		this._offsetNext = this._weightNext = this._offsetPrev = this._weightPrev = -0
	}

	function Xn(t, e, i, n) {
		zn.call(this, t, e, i, n)
	}

	function Yn(t, e, i, n) {
		zn.call(this, t, e, i, n)
	}

	function qn(t, e, i, n) {
		if (void 0 === t) throw Error("THREE.KeyframeTrack: track name is undefined");
		if (void 0 === e || 0 === e.length) throw Error("THREE.KeyframeTrack: no keyframes in track named " + t);
		this.name = t;
		this.times = No.convertArray(e, this.TimeBufferType);
		this.values = No.convertArray(i, this.ValueBufferType);
		this.setInterpolation(n || this.DefaultInterpolation);
		this.validate();
		this.optimize()
	}

	function $n(t, e, i, n) {
		qn.call(this, t, e, i, n)
	}

	function Zn(t, e, i) {
		this.name = t;
		this.tracks = i;
		this.duration = void 0 !== e ? e : -1;
		this.uuid = Kr.generateUUID();
		0 > this.duration && this.resetDuration();
		this.optimize()
	}

	function Jn(t) {
		this.manager = void 0 !== t ? t : Ao;
		this.textures = {}
	}

	function Qn(t) {
		this.manager = void 0 !== t ? t : Ao
	}

	function Kn() {}

	function tr(t) {
		"boolean" === typeof t && (console.warn("THREE.JSONLoader: showStatus parameter has been removed from constructor."), t = void 0);
		this.manager = void 0 !== t ? t : Ao;
		this.withCredentials = !1
	}

	function er(t) {
		this.manager = void 0 !== t ? t : Ao;
		this.texturePath = ""
	}

	function ir(t) {
		"undefined" === typeof createImageBitmap && console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported.");
		"undefined" === typeof fetch && console.warn("THREE.ImageBitmapLoader: fetch() not supported.");
		this.manager = void 0 !== t ? t : Ao;
		this.options = void 0
	}

	function nr() {
		this.type = "ShapePath";
		this.color = new w;
		this.subPaths = [];
		this.currentPath = null
	}

	function rr(t) {
		this.type = "Font";
		this.data = t
	}

	function or(t) {
		this.manager = void 0 !== t ? t : Ao
	}

	function ar(t) {
		this.manager = void 0 !== t ? t : Ao
	}

	function sr() {
		this.type = "StereoCamera";
		this.aspect = 1;
		this.eyeSep = .064;
		this.cameraL = new xe;
		this.cameraL.layers.enable(1);
		this.cameraL.matrixAutoUpdate = !1;
		this.cameraR = new xe;
		this.cameraR.layers.enable(2);
		this.cameraR.matrixAutoUpdate = !1
	}

	function lr(t, e, i) {
		u.call(this);
		this.type = "CubeCamera";
		var r = new xe(90, 1, t, e);
		r.up.set(0, -1, 0);
		r.lookAt(new _t(1, 0, 0));
		this.add(r);
		var o = new xe(90, 1, t, e);
		o.up.set(0, -1, 0);
		o.lookAt(new _t(-1, 0, 0));
		this.add(o);
		var a = new xe(90, 1, t, e);
		a.up.set(0, 0, 1);
		a.lookAt(new _t(0, 1, 0));
		this.add(a);
		var s = new xe(90, 1, t, e);
		s.up.set(0, 0, -1);
		s.lookAt(new _t(0, -1, 0));
		this.add(s);
		var l = new xe(90, 1, t, e);
		l.up.set(0, -1, 0);
		l.lookAt(new _t(0, 0, 1));
		this.add(l);
		var c = new xe(90, 1, t, e);
		c.up.set(0, -1, 0);
		c.lookAt(new _t(0, 0, -1));
		this.add(c);
		this.renderTarget = new n(i, i, {
			format: 1022,
			magFilter: 1006,
			minFilter: 1006
		});
		this.renderTarget.texture.name = "CubeCamera";
		this.update = function (t, e) {
			null === this.parent && this.updateMatrixWorld();
			var i = this.renderTarget,
				n = i.texture.generateMipmaps;
			i.texture.generateMipmaps = !1;
			i.activeCubeFace = 0;
			t.render(e, r, i);
			i.activeCubeFace = 1;
			t.render(e, o, i);
			i.activeCubeFace = 2;
			t.render(e, a, i);
			i.activeCubeFace = 3;
			t.render(e, s, i);
			i.activeCubeFace = 4;
			t.render(e, l, i);
			i.texture.generateMipmaps = n;
			i.activeCubeFace = 5;
			t.render(e, c, i);
			t.setRenderTarget(null)
		};
		this.clear = function (t, e, i, n) {
			for (var r = this.renderTarget, o = 0; 6 > o; o++) r.activeCubeFace = o, t.setRenderTarget(r), t.clear(e, i, n);
			t.setRenderTarget(null)
		}
	}

	function cr() {
		u.call(this);
		this.type = "AudioListener";
		this.context = Go.getContext();
		this.gain = this.context.createGain();
		this.gain.connect(this.context.destination);
		this.filter = null
	}

	function ur(t) {
		u.call(this);
		this.type = "Audio";
		this.context = t.context;
		this.gain = this.context.createGain();
		this.gain.connect(t.getInput());
		this.autoplay = !1;
		this.buffer = null;
		this.loop = !1;
		this.offset = this.startTime = 0;
		this.playbackRate = 1;
		this.isPlaying = !1;
		this.hasPlaybackControl = !0;
		this.sourceType = "empty";
		this.filters = []
	}

	function hr(t) {
		ur.call(this, t);
		this.panner = this.context.createPanner();
		this.panner.connect(this.gain)
	}

	function dr(t, e) {
		this.analyser = t.context.createAnalyser();
		this.analyser.fftSize = void 0 !== e ? e : 2048;
		this.data = new Uint8Array(this.analyser.frequencyBinCount);
		t.getOutput().connect(this.analyser)
	}

	function fr(t, e, i) {
		this.binding = t;
		this.valueSize = i;
		t = Float64Array;
		switch (e) {
			case "quaternion":
				e = this._slerp;
				break;
			case "string":
			case "bool":
				t = Array;
				e = this._select;
				break;
			default:
				e = this._lerp
		}
		this.buffer = new t(4 * i);
		this._mixBufferRegion = e;
		this.referenceCount = this.useCount = this.cumulativeWeight = 0
	}

	function pr(t, e, i) {
		i = i || mr.parseTrackName(e);
		this._targetGroup = t;
		this._bindings = t.subscribe_(e, i)
	}

	function mr(t, e, i) {
		this.path = e;
		this.parsedPath = i || mr.parseTrackName(e);
		this.node = mr.findNode(t, this.parsedPath.nodeName) || t;
		this.rootNode = t
	}

	function gr() {
		this.uuid = Kr.generateUUID();
		this._objects = Array.prototype.slice.call(arguments);
		this.nCachedObjects_ = 0;
		var t = {};
		this._indicesByUUID = t;
		for (var e = 0, i = arguments.length; e !== i; ++e) t[arguments[e].uuid] = e;
		this._paths = [];
		this._parsedPaths = [];
		this._bindings = [];
		this._bindingsIndicesByPath = {};
		var n = this;
		this.stats = {
			objects: {get total() {
					return n._objects.length
				},
				get inUse() {
					return this.total - n.nCachedObjects_
				}
			},
			get bindingsPerObject() {
				return n._bindings.length
			}
		}
	}

	function vr(t, e, i) {
		this._mixer = t;
		this._clip = e;
		this._localRoot = i || null;
		t = e.tracks;
		e = t.length;
		i = Array(e);
		for (var n = {
				endingStart: 2400,
				endingEnd: 2400
			}, r = 0; r !== e; ++r) {
			var o = t[r].createInterpolant(null);
			i[r] = o;
			o.settings = n
		}
		this._interpolantSettings = n;
		this._interpolants = i;
		this._propertyBindings = Array(e);
		this._weightInterpolant = this._timeScaleInterpolant = this._byClipCacheIndex = this._cacheIndex = null;
		this.loop = 2201;
		this._loopCount = -1;
		this._startTime = null;
		this.time = 0;
		this._effectiveWeight = this.weight = this._effectiveTimeScale = this.timeScale = 1;
		this.repetitions = Infinity;
		this.paused = !1;
		this.enabled = !0;
		this.clampWhenFinished = !1;
		this.zeroSlopeAtEnd = this.zeroSlopeAtStart = !0
	}

	function yr(t) {
		this._root = t;
		this._initMemoryManager();
		this.time = this._accuIndex = 0;
		this.timeScale = 1
	}

	function xr(t, e) {
		"string" === typeof t && (console.warn("THREE.Uniform: Type parameter is no longer needed."), t = e);
		this.value = t
	}

	function _r() {
		L.call(this);
		this.type = "InstancedBufferGeometry";
		this.maxInstancedCount = void 0
	}

	function br(t, e, i, n) {
		this.data = t;
		this.itemSize = e;
		this.offset = i;
		this.normalized = !0 === n
	}

	function wr(t, e) {
		this.array = t;
		this.stride = e;
		this.count = void 0 !== t ? t.length / e : 0;
		this.dynamic = !1;
		this.updateRange = {
			offset: 0,
			count: -1
		};
		this.version = 0
	}

	function Tr(t, e, i) {
		wr.call(this, t, e);
		this.meshPerAttribute = i || 1
	}

	function Er(t, e, i) {
		y.call(this, t, e);
		this.meshPerAttribute = i || 1
	}

	function Sr(t, e, i, n) {
		this.ray = new B(t, e);
		this.near = i || 0;
		this.far = n || Infinity;
		this.params = {
			Mesh: {},
			Line: {},
			LOD: {},
			Points: {
				threshold: 1
			},
			Sprite: {}
		};
		Object.defineProperties(this.params, {
			PointCloud: {
				get: function () {
					console.warn("THREE.Raycaster: params.PointCloud has been renamed to params.Points.");
					return this.Points
				}
			}
		})
	}

	function Mr(t, e) {
		return t.distance - e.distance
	}

	function Ar(t, e, i, n) {
		if (!1 !== t.visible && (t.raycast(e, i), !0 === n)) {
			t = t.children;
			n = 0;
			for (var r = t.length; n < r; n++) Ar(t[n], e, i, !0)
		}
	}

	function Cr(t) {
		this.autoStart = void 0 !== t ? t : !0;
		this.elapsedTime = this.oldTime = this.startTime = 0;
		this.running = !1
	}

	function Pr(t, e, i) {
		this.radius = void 0 !== t ? t : 1;
		this.phi = void 0 !== e ? e : 0;
		this.theta = void 0 !== i ? i : 0;
		return this
	}

	function Lr(t, e, i) {
		this.radius = void 0 !== t ? t : 1;
		this.theta = void 0 !== e ? e : 0;
		this.y = void 0 !== i ? i : 0;
		return this
	}

	function Rr(t, e) {
		this.min = void 0 !== t ? t : new W(Infinity, Infinity);
		this.max = void 0 !== e ? e : new W(-Infinity, -Infinity)
	}

	function Or(t) {
		u.call(this);
		this.material = t;
		this.render = function () {}
	}

	function kr(t, e, i, n) {
		this.object = t;
		this.size = void 0 !== e ? e : 1;
		t = void 0 !== i ? i : 16711680;
		n = void 0 !== n ? n : 1;
		e = 0;
		(i = this.object.geometry) && i.isGeometry ? e = 3 * i.faces.length : i && i.isBufferGeometry && (e = i.attributes.normal.count);
		i = new L;
		e = new P(6 * e, 3);
		i.addAttribute("position", e);
		Ie.call(this, i, new ke({
			color: t,
			linewidth: n
		}));
		this.matrixAutoUpdate = !1;
		this.update()
	}

	function Nr(t, e) {
		u.call(this);
		this.light = t;
		this.light.updateMatrixWorld();
		this.matrix = t.matrixWorld;
		this.matrixAutoUpdate = !1;
		this.color = e;
		t = new L;
		e = [0, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 1, 0, 0, 0, -1, 0, 1, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, -1, 1];
		for (var i = 0, n = 1; 32 > i; i++, n++) {
			var r = i / 32 * Math.PI * 2,
				o = n / 32 * Math.PI * 2;
			e.push(Math.cos(r), Math.sin(r), 1, Math.cos(o), Math.sin(o), 1)
		}
		t.addAttribute("position", new P(e, 3));
		e = new ke({
			fog: !1
		});
		this.cone = new Ie(t, e);
		this.add(this.cone);
		this.update()
	}

	function Ir(t) {
		var e = [];
		t && t.isBone && e.push(t);
		for (var i = 0; i < t.children.length; i++) e.push.apply(e, Ir(t.children[i]));
		return e
	}

	function Dr(t) {
		for (var e = Ir(t), i = new L, n = [], r = [], o = new w(0, 0, 1), a = new w(0, 1, 0), s = 0; s < e.length; s++) {
			var l = e[s];
			l.parent && l.parent.isBone && (n.push(0, 0, 0), n.push(0, 0, 0), r.push(o.r, o.g, o.b), r.push(a.r, a.g, a.b))
		}
		i.addAttribute("position", new P(n, 3));
		i.addAttribute("color", new P(r, 3));
		n = new ke({
			vertexColors: 2,
			depthTest: !1,
			depthWrite: !1,
			transparent: !0
		});
		Ie.call(this, i, n);
		this.root = t;
		this.bones = e;
		this.matrix = t.matrixWorld;
		this.matrixAutoUpdate = !1
	}

	function Fr(t, e, i) {
		this.light = t;
		this.light.updateMatrixWorld();
		this.color = i;
		t = new Oi(e, 4, 2);
		e = new N({
			wireframe: !0,
			fog: !1
		});
		z.call(this, t, e);
		this.matrix = this.light.matrixWorld;
		this.matrixAutoUpdate = !1;
		this.update()
	}

	function Br(t, e) {
		u.call(this);
		this.light = t;
		this.light.updateMatrixWorld();
		this.matrix = t.matrixWorld;
		this.matrixAutoUpdate = !1;
		this.color = e;
		t = new ke({
			fog: !1
		});
		e = new L;
		e.addAttribute("position", new y(new Float32Array(15), 3));
		this.line = new Ne(e, t);
		this.add(this.line);
		this.update()
	}

	function Ur(t, e, i) {
		u.call(this);
		this.light = t;
		this.light.updateMatrixWorld();
		this.matrix = t.matrixWorld;
		this.matrixAutoUpdate = !1;
		this.color = i;
		t = new Je(e);
		t.rotateY(.5 * Math.PI);
		this.material = new N({
			wireframe: !0,
			fog: !1
		});
		void 0 === this.color && (this.material.vertexColors = 2);
		e = t.getAttribute("position");
		e = new Float32Array(3 * e.count);
		t.addAttribute("color", new y(e, 3));
		this.add(new z(t, this.material));
		this.update()
	}

	function zr(t, e, i, n) {
		t = t || 10;
		e = e || 10;
		i = new w(void 0 !== i ? i : 4473924);
		n = new w(void 0 !== n ? n : 8947848);
		var r = e / 2,
			o = t / e,
			a = t / 2;
		t = [];
		for (var s = [], l = 0, c = 0, u = -a; l <= e; l++, u += o) {
			t.push(-a, 0, u, a, 0, u);
			t.push(u, 0, -a, u, 0, a);
			var h = l === r ? i : n;
			h.toArray(s, c);
			c += 3;
			h.toArray(s, c);
			c += 3;
			h.toArray(s, c);
			c += 3;
			h.toArray(s, c);
			c += 3
		}
		e = new L;
		e.addAttribute("position", new P(t, 3));
		e.addAttribute("color", new P(s, 3));
		i = new ke({
			vertexColors: 2
		});
		Ie.call(this, e, i)
	}

	function Gr(t, e, i, n, r, o) {
		t = t || 10;
		e = e || 16;
		i = i || 8;
		n = n || 64;
		r = new w(void 0 !== r ? r : 4473924);
		o = new w(void 0 !== o ? o : 8947848);
		var a = [],
			s = [],
			l;
		for (l = 0; l <= e; l++) {
			var c = l / e * 2 * Math.PI;
			var u = Math.sin(c) * t;
			c = Math.cos(c) * t;
			a.push(0, 0, 0);
			a.push(u, 0, c);
			var h = l & 1 ? r : o;
			s.push(h.r, h.g, h.b);
			s.push(h.r, h.g, h.b)
		}
		for (l = 0; l <= i; l++) {
			h = l & 1 ? r : o;
			var d = t - t / i * l;
			for (e = 0; e < n; e++) c = e / n * 2 * Math.PI, u = Math.sin(c) * d, c = Math.cos(c) * d, a.push(u, 0, c), s.push(h.r, h.g, h.b), c = (e + 1) / n * 2 * Math.PI, u = Math.sin(c) * d, c = Math.cos(c) * d, a.push(u, 0, c), s.push(h.r, h.g, h.b)
		}
		t = new L;
		t.addAttribute("position", new P(a, 3));
		t.addAttribute("color", new P(s, 3));
		a = new ke({
			vertexColors: 2
		});
		Ie.call(this, t, a)
	}

	function Hr(t, e, i, n) {
		this.object = t;
		this.size = void 0 !== e ? e : 1;
		t = void 0 !== i ? i : 16776960;
		n = void 0 !== n ? n : 1;
		e = 0;
		(i = this.object.geometry) && i.isGeometry ? e = i.faces.length : console.warn("THREE.FaceNormalsHelper: only THREE.Geometry is supported. Use THREE.VertexNormalsHelper, instead.");
		i = new L;
		e = new P(6 * e, 3);
		i.addAttribute("position", e);
		Ie.call(this, i, new ke({
			color: t,
			linewidth: n
		}));
		this.matrixAutoUpdate = !1;
		this.update()
	}

	function jr(t, e, i) {
		u.call(this);
		this.light = t;
		this.light.updateMatrixWorld();
		this.matrix = t.matrixWorld;
		this.matrixAutoUpdate = !1;
		this.color = i;
		void 0 === e && (e = 1);
		t = new L;
		t.addAttribute("position", new P([-e, e, 0, e, e, 0, e, -e, 0, -e, -e, 0, -e, e, 0], 3));
		e = new ke({
			fog: !1
		});
		this.lightPlane = new Ne(t, e);
		this.add(this.lightPlane);
		t = new L;
		t.addAttribute("position", new P([0, 0, 0, 0, 0, 1], 3));
		this.targetLine = new Ne(t, e);
		this.add(this.targetLine);
		this.update()
	}

	function Vr(t) {
		function e(t, e, i) {
			n(t, i);
			n(e, i)
		}

		function n(t, e) {
			o.push(0, 0, 0);
			a.push(e.r, e.g, e.b);
			void 0 === s[t] && (s[t] = []);
			s[t].push(o.length / 3 - 1)
		}
		var i = new L,
			r = new ke({
				color: 16777215,
				vertexColors: 1
			}),
			o = [],
			a = [],
			s = {},
			l = new w(16755200),
			c = new w(16711680),
			u = new w(43775),
			h = new w(16777215),
			d = new w(3355443);
		e("n1", "n2", l);
		e("n2", "n4", l);
		e("n4", "n3", l);
		e("n3", "n1", l);
		e("f1", "f2", l);
		e("f2", "f4", l);
		e("f4", "f3", l);
		e("f3", "f1", l);
		e("n1", "f1", l);
		e("n2", "f2", l);
		e("n3", "f3", l);
		e("n4", "f4", l);
		e("p", "n1", c);
		e("p", "n2", c);
		e("p", "n3", c);
		e("p", "n4", c);
		e("u1", "u2", u);
		e("u2", "u3", u);
		e("u3", "u1", u);
		e("c", "t", h);
		e("p", "c", d);
		e("cn1", "cn2", d);
		e("cn3", "cn4", d);
		e("cf1", "cf2", d);
		e("cf3", "cf4", d);
		i.addAttribute("position", new P(o, 3));
		i.addAttribute("color", new P(a, 3));
		Ie.call(this, i, r);
		this.camera = t;
		this.camera.updateProjectionMatrix && this.camera.updateProjectionMatrix();
		this.matrix = t.matrixWorld;
		this.matrixAutoUpdate = !1;
		this.pointMap = s;
		this.update()
	}

	function Wr(t, e) {
		this.object = t;
		void 0 === e && (e = 16776960);
		t = new Uint16Array([0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7]);
		var i = new Float32Array(24),
			n = new L;
		n.setIndex(new y(t, 1));
		n.addAttribute("position", new y(i, 3));
		Ie.call(this, n, new ke({
			color: e
		}));
		this.matrixAutoUpdate = !1;
		this.update()
	}

	function Xr(t, e) {
		this.type = "Box3Helper";
		this.box = t;
		t = void 0 !== e ? e : 16776960;
		e = new Uint16Array([0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7]);
		var i = new L;
		i.setIndex(new y(e, 1));
		i.addAttribute("position", new P([1, 1, 1, -1, 1, 1, -1, -1, 1, 1, -1, 1, 1, 1, -1, -1, 1, -1, -1, -1, -1, 1, -1, -1], 3));
		Ie.call(this, i, new ke({
			color: t
		}));
		this.geometry.computeBoundingSphere()
	}

	function Yr(t, e, i) {
		this.type = "PlaneHelper";
		this.plane = t;
		this.size = void 0 === e ? 1 : e;
		t = void 0 !== i ? i : 16776960;
		e = new L;
		e.addAttribute("position", new P([1, -1, 1, -1, 1, 1, -1, -1, 1, 1, 1, 1, -1, 1, 1, -1, -1, 1, 1, -1, 1, 1, 1, 1, 0, 0, 1, 0, 0, 0], 3));
		e.computeBoundingSphere();
		Ne.call(this, e, new ke({
			color: t
		}));
		e = new L;
		e.addAttribute("position", new P([1, 1, 1, -1, 1, 1, -1, -1, 1, 1, 1, 1, -1, -1, 1, 1, -1, 1], 3));
		e.computeBoundingSphere();
		this.add(new z(e, new N({
			color: t,
			opacity: .2,
			transparent: !0,
			depthWrite: !1
		})))
	}

	function qr(t, e, i, n, r, o) {
		u.call(this);
		void 0 === n && (n = 16776960);
		void 0 === i && (i = 1);
		void 0 === r && (r = .2 * i);
		void 0 === o && (o = .2 * r);
		void 0 === Ho && (Ho = new L, Ho.addAttribute("position", new P([0, 0, 0, 0, 1, 0], 3)), jo = new Hi(0, .5, 1, 5, 1), jo.translate(0, -.5, 0));
		this.position.copy(e);
		this.line = new Ne(Ho, new ke({
			color: n
		}));
		this.line.matrixAutoUpdate = !1;
		this.add(this.line);
		this.cone = new z(jo, new N({
			color: n
		}));
		this.cone.matrixAutoUpdate = !1;
		this.add(this.cone);
		this.setDirection(t);
		this.setLength(i, r, o)
	}

	function $r(t) {
		t = t || 1;
		var e = [0, 0, 0, t, 0, 0, 0, 0, 0, 0, t, 0, 0, 0, 0, 0, 0, t];
		t = new L;
		t.addAttribute("position", new P(e, 3));
		t.addAttribute("color", new P([1, 0, 0, 1, .6, 0, 0, 1, 0, .6, 1, 0, 0, 0, 1, 0, .6, 1], 3));
		e = new ke({
			vertexColors: 2
		});
		Ie.call(this, t, e)
	}

	function Zr(t) {
		console.warn("THREE.ClosedSplineCurve3 has been deprecated. Use THREE.CatmullRomCurve3 instead.");
		pn.call(this, t);
		this.type = "catmullrom";
		this.closed = !0
	}

	function Jr(t) {
		console.warn("THREE.SplineCurve3 has been deprecated. Use THREE.CatmullRomCurve3 instead.");
		pn.call(this, t);
		this.type = "catmullrom"
	}

	function Qr(t) {
		console.warn("THREE.Spline has been removed. Use THREE.CatmullRomCurve3 instead.");
		pn.call(this, t);
		this.type = "catmullrom"
	}
	void 0 === Number.EPSILON && (Number.EPSILON = Math.pow(2, -52));
	void 0 === Number.isInteger && (Number.isInteger = function (t) {
		return "number" === typeof t && isFinite(t) && Math.floor(t) === t
	});
	void 0 === Math.sign && (Math.sign = function (t) {
		return 0 > t ? -1 : 0 < t ? 1 : +t
	});
	!1 === "name" in Function.prototype && Object.defineProperty(Function.prototype, "name", {
		get: function () {
			return this.toString().match(/^\s*function\s*([^\(\s]*)/)[1]
		}
	});
	void 0 === Object.assign && function () {
		Object.assign = function (t) {
			if (void 0 === t || null === t) throw new TypeError("Cannot convert undefined or null to object");
			for (var e = Object(t), i = 1; i < arguments.length; i++) {
				var n = arguments[i];
				if (void 0 !== n && null !== n)
					for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
			}
			return e
		}
	}();
	Object.assign(e.prototype, {
		addEventListener: function (t, e) {
			void 0 === this._listeners && (this._listeners = {});
			var i = this._listeners;
			void 0 === i[t] && (i[t] = []); - 1 === i[t].indexOf(e) && i[t].push(e)
		},
		hasEventListener: function (t, e) {
			if (void 0 === this._listeners) return !1;
			var i = this._listeners;
			return void 0 !== i[t] && -1 !== i[t].indexOf(e)
		},
		removeEventListener: function (t, e) {
			void 0 !== this._listeners && (t = this._listeners[t], void 0 !== t && (e = t.indexOf(e), -1 !== e && t.splice(e, 1)))
		},
		dispatchEvent: function (t) {
			if (void 0 !== this._listeners) {
				var e = this._listeners[t.type];
				if (void 0 !== e) {
					t.target = this;
					e = e.slice(0);
					for (var i = 0, n = e.length; i < n; i++) e[i].call(this, t)
				}
			}
		}
	});
	var Kr = {
		DEG2RAD: Math.PI / 180,
		RAD2DEG: 180 / Math.PI,
		generateUUID: function () {
			for (var r = [], t = 0; 256 > t; t++) r[t] = (16 > t ? "0" : "") + t.toString(16);
			return function () {
				var t = 4294967295 * Math.random() | 0,
					e = 4294967295 * Math.random() | 0,
					i = 4294967295 * Math.random() | 0,
					n = 4294967295 * Math.random() | 0;
				return (r[t & 255] + r[t >> 8 & 255] + r[t >> 16 & 255] + r[t >> 24 & 255] + "-" + r[e & 255] + r[e >> 8 & 255] + "-" + r[e >> 16 & 15 | 64] + r[e >> 24 & 255] + "-" + r[i & 63 | 128] + r[i >> 8 & 255] + "-" + r[i >> 16 & 255] + r[i >> 24 & 255] + r[n & 255] + r[n >> 8 & 255] + r[n >> 16 & 255] + r[n >> 24 & 255]).toUpperCase()
			}
		}(),
		clamp: function (t, e, i) {
			return Math.max(e, Math.min(i, t))
		},
		euclideanModulo: function (t, e) {
			return (t % e + e) % e
		},
		mapLinear: function (t, e, i, n, r) {
			return n + (t - e) * (r - n) / (i - e)
		},
		lerp: function (t, e, i) {
			return (1 - i) * t + i * e
		},
		smoothstep: function (t, e, i) {
			if (t <= e) return 0;
			if (t >= i) return 1;
			t = (t - e) / (i - e);
			return t * t * (3 - 2 * t)
		},
		smootherstep: function (t, e, i) {
			if (t <= e) return 0;
			if (t >= i) return 1;
			t = (t - e) / (i - e);
			return t * t * t * (t * (6 * t - 15) + 10)
		},
		randInt: function (t, e) {
			return t + Math.floor(Math.random() * (e - t + 1))
		},
		randFloat: function (t, e) {
			return t + Math.random() * (e - t)
		},
		randFloatSpread: function (t) {
			return t * (.5 - Math.random())
		},
		degToRad: function (t) {
			return t * Kr.DEG2RAD
		},
		radToDeg: function (t) {
			return t * Kr.RAD2DEG
		},
		isPowerOfTwo: function (t) {
			return 0 === (t & t - 1) && 0 !== t
		},
		ceilPowerOfTwo: function (t) {
			return Math.pow(2, Math.ceil(Math.log(t) / Math.LN2))
		},
		floorPowerOfTwo: function (t) {
			return Math.pow(2, Math.floor(Math.log(t) / Math.LN2))
		}
	};
	Object.defineProperties(W.prototype, {
		width: {
			get: function () {
				return this.x
			},
			set: function (t) {
				this.x = t
			}
		},
		height: {
			get: function () {
				return this.y
			},
			set: function (t) {
				this.y = t
			}
		}
	});
	Object.assign(W.prototype, {
		isVector2: !0,
		set: function (t, e) {
			this.x = t;
			this.y = e;
			return this
		},
		setScalar: function (t) {
			this.y = this.x = t;
			return this
		},
		setX: function (t) {
			this.x = t;
			return this
		},
		setY: function (t) {
			this.y = t;
			return this
		},
		setComponent: function (t, e) {
			switch (t) {
				case 0:
					this.x = e;
					break;
				case 1:
					this.y = e;
					break;
				default:
					throw Error("index is out of range: " + t)
			}
			return this
		},
		getComponent: function (t) {
			switch (t) {
				case 0:
					return this.x;
				case 1:
					return this.y;
				default:
					throw Error("index is out of range: " + t)
			}
		},
		clone: function () {
			return new this.constructor(this.x, this.y)
		},
		copy: function (t) {
			this.x = t.x;
			this.y = t.y;
			return this
		},
		add: function (t, e) {
			if (void 0 !== e) return console.warn("THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead."), this.addVectors(t, e);
			this.x += t.x;
			this.y += t.y;
			return this
		},
		addScalar: function (t) {
			this.x += t;
			this.y += t;
			return this
		},
		addVectors: function (t, e) {
			this.x = t.x + e.x;
			this.y = t.y + e.y;
			return this
		},
		addScaledVector: function (t, e) {
			this.x += t.x * e;
			this.y += t.y * e;
			return this
		},
		sub: function (t, e) {
			if (void 0 !== e) return console.warn("THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."), this.subVectors(t, e);
			this.x -= t.x;
			this.y -= t.y;
			return this
		},
		subScalar: function (t) {
			this.x -= t;
			this.y -= t;
			return this
		},
		subVectors: function (t, e) {
			this.x = t.x - e.x;
			this.y = t.y - e.y;
			return this
		},
		multiply: function (t) {
			this.x *= t.x;
			this.y *= t.y;
			return this
		},
		multiplyScalar: function (t) {
			this.x *= t;
			this.y *= t;
			return this
		},
		divide: function (t) {
			this.x /= t.x;
			this.y /= t.y;
			return this
		},
		divideScalar: function (t) {
			return this.multiplyScalar(1 / t)
		},
		applyMatrix3: function (t) {
			var e = this.x,
				i = this.y;
			t = t.elements;
			this.x = t[0] * e + t[3] * i + t[6];
			this.y = t[1] * e + t[4] * i + t[7];
			return this
		},
		min: function (t) {
			this.x = Math.min(this.x, t.x);
			this.y = Math.min(this.y, t.y);
			return this
		},
		max: function (t) {
			this.x = Math.max(this.x, t.x);
			this.y = Math.max(this.y, t.y);
			return this
		},
		clamp: function (t, e) {
			this.x = Math.max(t.x, Math.min(e.x, this.x));
			this.y = Math.max(t.y, Math.min(e.y, this.y));
			return this
		},
		clampScalar: function () {
			var i = new W,
				n = new W;
			return function (t, e) {
				i.set(t, t);
				n.set(e, e);
				return this.clamp(i, n)
			}
		}(),
		clampLength: function (t, e) {
			var i = this.length();
			return this.divideScalar(i || 1).multiplyScalar(Math.max(t, Math.min(e, i)))
		},
		floor: function () {
			this.x = Math.floor(this.x);
			this.y = Math.floor(this.y);
			return this
		},
		ceil: function () {
			this.x = Math.ceil(this.x);
			this.y = Math.ceil(this.y);
			return this
		},
		round: function () {
			this.x = Math.round(this.x);
			this.y = Math.round(this.y);
			return this
		},
		roundToZero: function () {
			this.x = 0 > this.x ? Math.ceil(this.x) : Math.floor(this.x);
			this.y = 0 > this.y ? Math.ceil(this.y) : Math.floor(this.y);
			return this
		},
		negate: function () {
			this.x = -this.x;
			this.y = -this.y;
			return this
		},
		dot: function (t) {
			return this.x * t.x + this.y * t.y
		},
		lengthSq: function () {
			return this.x * this.x + this.y * this.y
		},
		length: function () {
			return Math.sqrt(this.x * this.x + this.y * this.y)
		},
		manhattanLength: function () {
			return Math.abs(this.x) + Math.abs(this.y)
		},
		normalize: function () {
			return this.divideScalar(this.length() || 1)
		},
		angle: function () {
			var t = Math.atan2(this.y, this.x);
			0 > t && (t += 2 * Math.PI);
			return t
		},
		distanceTo: function (t) {
			return Math.sqrt(this.distanceToSquared(t))
		},
		distanceToSquared: function (t) {
			var e = this.x - t.x;
			t = this.y - t.y;
			return e * e + t * t
		},
		manhattanDistanceTo: function (t) {
			return Math.abs(this.x - t.x) + Math.abs(this.y - t.y)
		},
		setLength: function (t) {
			return this.normalize().multiplyScalar(t)
		},
		lerp: function (t, e) {
			this.x += (t.x - this.x) * e;
			this.y += (t.y - this.y) * e;
			return this
		},
		lerpVectors: function (t, e, i) {
			return this.subVectors(e, t).multiplyScalar(i).add(t)
		},
		equals: function (t) {
			return t.x === this.x && t.y === this.y
		},
		fromArray: function (t, e) {
			void 0 === e && (e = 0);
			this.x = t[e];
			this.y = t[e + 1];
			return this
		},
		toArray: function (t, e) {
			void 0 === t && (t = []);
			void 0 === e && (e = 0);
			t[e] = this.x;
			t[e + 1] = this.y;
			return t
		},
		fromBufferAttribute: function (t, e, i) {
			void 0 !== i && console.warn("THREE.Vector2: offset has been removed from .fromBufferAttribute().");
			this.x = t.getX(e);
			this.y = t.getY(e);
			return this
		},
		rotateAround: function (t, e) {
			var i = Math.cos(e);
			e = Math.sin(e);
			var n = this.x - t.x,
				r = this.y - t.y;
			this.x = n * i - r * e + t.x;
			this.y = n * e + r * i + t.y;
			return this
		}
	});
	Object.assign(xt.prototype, {
		isMatrix4: !0,
		set: function (t, e, i, n, r, o, a, s, l, c, u, h, d, f, p, m) {
			var g = this.elements;
			g[0] = t;
			g[4] = e;
			g[8] = i;
			g[12] = n;
			g[1] = r;
			g[5] = o;
			g[9] = a;
			g[13] = s;
			g[2] = l;
			g[6] = c;
			g[10] = u;
			g[14] = h;
			g[3] = d;
			g[7] = f;
			g[11] = p;
			g[15] = m;
			return this
		},
		identity: function () {
			this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
			return this
		},
		clone: function () {
			return (new xt).fromArray(this.elements)
		},
		copy: function (t) {
			var e = this.elements;
			t = t.elements;
			e[0] = t[0];
			e[1] = t[1];
			e[2] = t[2];
			e[3] = t[3];
			e[4] = t[4];
			e[5] = t[5];
			e[6] = t[6];
			e[7] = t[7];
			e[8] = t[8];
			e[9] = t[9];
			e[10] = t[10];
			e[11] = t[11];
			e[12] = t[12];
			e[13] = t[13];
			e[14] = t[14];
			e[15] = t[15];
			return this
		},
		copyPosition: function (t) {
			var e = this.elements;
			t = t.elements;
			e[12] = t[12];
			e[13] = t[13];
			e[14] = t[14];
			return this
		},
		extractBasis: function (t, e, i) {
			t.setFromMatrixColumn(this, 0);
			e.setFromMatrixColumn(this, 1);
			i.setFromMatrixColumn(this, 2);
			return this
		},
		makeBasis: function (t, e, i) {
			this.set(t.x, e.x, i.x, 0, t.y, e.y, i.y, 0, t.z, e.z, i.z, 0, 0, 0, 0, 1);
			return this
		},
		extractRotation: function () {
			var o = new _t;
			return function (t) {
				var e = this.elements,
					i = t.elements,
					n = 1 / o.setFromMatrixColumn(t, 0).length(),
					r = 1 / o.setFromMatrixColumn(t, 1).length();
				t = 1 / o.setFromMatrixColumn(t, 2).length();
				e[0] = i[0] * n;
				e[1] = i[1] * n;
				e[2] = i[2] * n;
				e[3] = 0;
				e[4] = i[4] * r;
				e[5] = i[5] * r;
				e[6] = i[6] * r;
				e[7] = 0;
				e[8] = i[8] * t;
				e[9] = i[9] * t;
				e[10] = i[10] * t;
				e[11] = 0;
				e[12] = 0;
				e[13] = 0;
				e[14] = 0;
				e[15] = 1;
				return this
			}
		}(),
		makeRotationFromEuler: function (t) {
			t && t.isEuler || console.error("THREE.Matrix4: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.");
			var e = this.elements,
				i = t.x,
				n = t.y,
				r = t.z,
				o = Math.cos(i);
			i = Math.sin(i);
			var a = Math.cos(n);
			n = Math.sin(n);
			var s = Math.cos(r);
			r = Math.sin(r);
			if ("XYZ" === t.order) {
				t = o * s;
				var l = o * r,
					c = i * s,
					u = i * r;
				e[0] = a * s;
				e[4] = -a * r;
				e[8] = n;
				e[1] = l + c * n;
				e[5] = t - u * n;
				e[9] = -i * a;
				e[2] = u - t * n;
				e[6] = c + l * n;
				e[10] = o * a
			} else "YXZ" === t.order ? (t = a * s, l = a * r, c = n * s, u = n * r, e[0] = t + u * i, e[4] = c * i - l, e[8] = o * n, e[1] = o * r, e[5] = o * s, e[9] = -i, e[2] = l * i - c, e[6] = u + t * i, e[10] = o * a) : "ZXY" === t.order ? (t = a * s, l = a * r, c = n * s, u = n * r, e[0] = t - u * i, e[4] = -o * r, e[8] = c + l * i, e[1] = l + c * i, e[5] = o * s, e[9] = u - t * i, e[2] = -o * n, e[6] = i, e[10] = o * a) : "ZYX" === t.order ? (t = o * s, l = o * r, c = i * s, u = i * r, e[0] = a * s, e[4] = c * n - l, e[8] = t * n + u, e[1] = a * r, e[5] = u * n + t, e[9] = l * n - c, e[2] = -n, e[6] = i * a, e[10] = o * a) : "YZX" === t.order ? (t = o * a, l = o * n, c = i * a, u = i * n, e[0] = a * s, e[4] = u - t * r, e[8] = c * r + l, e[1] = r, e[5] = o * s, e[9] = -i * s, e[2] = -n * s, e[6] = l * r + c, e[10] = t - u * r) : "XZY" === t.order && (t = o * a, l = o * n, c = i * a, u = i * n, e[0] = a * s, e[4] = -r, e[8] = n * s, e[1] = t * r + u, e[5] = o * s, e[9] = l * r - c, e[2] = c * r - l, e[6] = i * s, e[10] = u * r + t);
			e[3] = 0;
			e[7] = 0;
			e[11] = 0;
			e[12] = 0;
			e[13] = 0;
			e[14] = 0;
			e[15] = 1;
			return this
		},
		makeRotationFromQuaternion: function () {
			var e = new _t(0, 0, 0),
				i = new _t(1, 1, 1);
			return function (t) {
				return this.compose(e, t, i)
			}
		}(),
		lookAt: function () {
			var r = new _t,
				o = new _t,
				a = new _t;
			return function (t, e, i) {
				var n = this.elements;
				a.subVectors(t, e);
				0 === a.lengthSq() && (a.z = 1);
				a.normalize();
				r.crossVectors(i, a);
				0 === r.lengthSq() && (1 === Math.abs(i.z) ? a.x += 1e-4 : a.z += 1e-4, a.normalize(), r.crossVectors(i, a));
				r.normalize();
				o.crossVectors(a, r);
				n[0] = r.x;
				n[4] = o.x;
				n[8] = a.x;
				n[1] = r.y;
				n[5] = o.y;
				n[9] = a.y;
				n[2] = r.z;
				n[6] = o.z;
				n[10] = a.z;
				return this
			}
		}(),
		multiply: function (t, e) {
			return void 0 !== e ? (console.warn("THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead."), this.multiplyMatrices(t, e)) : this.multiplyMatrices(this, t)
		},
		premultiply: function (t) {
			return this.multiplyMatrices(t, this)
		},
		multiplyMatrices: function (t, e) {
			var i = t.elements,
				n = e.elements;
			e = this.elements;
			t = i[0];
			var r = i[4],
				o = i[8],
				a = i[12],
				s = i[1],
				l = i[5],
				c = i[9],
				u = i[13],
				h = i[2],
				d = i[6],
				f = i[10],
				p = i[14],
				m = i[3],
				g = i[7],
				v = i[11];
			i = i[15];
			var y = n[0],
				x = n[4],
				_ = n[8],
				b = n[12],
				w = n[1],
				T = n[5],
				E = n[9],
				S = n[13],
				M = n[2],
				A = n[6],
				C = n[10],
				P = n[14],
				L = n[3],
				R = n[7],
				O = n[11];
			n = n[15];
			e[0] = t * y + r * w + o * M + a * L;
			e[4] = t * x + r * T + o * A + a * R;
			e[8] = t * _ + r * E + o * C + a * O;
			e[12] = t * b + r * S + o * P + a * n;
			e[1] = s * y + l * w + c * M + u * L;
			e[5] = s * x + l * T + c * A + u * R;
			e[9] = s * _ + l * E + c * C + u * O;
			e[13] = s * b + l * S + c * P + u * n;
			e[2] = h * y + d * w + f * M + p * L;
			e[6] = h * x + d * T + f * A + p * R;
			e[10] = h * _ + d * E + f * C + p * O;
			e[14] = h * b + d * S + f * P + p * n;
			e[3] = m * y + g * w + v * M + i * L;
			e[7] = m * x + g * T + v * A + i * R;
			e[11] = m * _ + g * E + v * C + i * O;
			e[15] = m * b + g * S + v * P + i * n;
			return this
		},
		multiplyScalar: function (t) {
			var e = this.elements;
			e[0] *= t;
			e[4] *= t;
			e[8] *= t;
			e[12] *= t;
			e[1] *= t;
			e[5] *= t;
			e[9] *= t;
			e[13] *= t;
			e[2] *= t;
			e[6] *= t;
			e[10] *= t;
			e[14] *= t;
			e[3] *= t;
			e[7] *= t;
			e[11] *= t;
			e[15] *= t;
			return this
		},
		applyToBufferAttribute: function () {
			var n = new _t;
			return function (t) {
				for (var e = 0, i = t.count; e < i; e++) n.x = t.getX(e), n.y = t.getY(e), n.z = t.getZ(e), n.applyMatrix4(this), t.setXYZ(e, n.x, n.y, n.z);
				return t
			}
		}(),
		determinant: function () {
			var t = this.elements,
				e = t[0],
				i = t[4],
				n = t[8],
				r = t[12],
				o = t[1],
				a = t[5],
				s = t[9],
				l = t[13],
				c = t[2],
				u = t[6],
				h = t[10],
				d = t[14];
			return t[3] * (+r * s * u - n * l * u - r * a * h + i * l * h + n * a * d - i * s * d) + t[7] * (+e * s * d - e * l * h + r * o * h - n * o * d + n * l * c - r * s * c) + t[11] * (+e * l * u - e * a * d - r * o * u + i * o * d + r * a * c - i * l * c) + t[15] * (-n * a * c - e * s * u + e * a * h + n * o * u - i * o * h + i * s * c)
		},
		transpose: function () {
			var t = this.elements;
			var e = t[1];
			t[1] = t[4];
			t[4] = e;
			e = t[2];
			t[2] = t[8];
			t[8] = e;
			e = t[6];
			t[6] = t[9];
			t[9] = e;
			e = t[3];
			t[3] = t[12];
			t[12] = e;
			e = t[7];
			t[7] = t[13];
			t[13] = e;
			e = t[11];
			t[11] = t[14];
			t[14] = e;
			return this
		},
		setPosition: function (t) {
			var e = this.elements;
			e[12] = t.x;
			e[13] = t.y;
			e[14] = t.z;
			return this
		},
		getInverse: function (t, e) {
			var i = this.elements,
				n = t.elements;
			t = n[0];
			var r = n[1],
				o = n[2],
				a = n[3],
				s = n[4],
				l = n[5],
				c = n[6],
				u = n[7],
				h = n[8],
				d = n[9],
				f = n[10],
				p = n[11],
				m = n[12],
				g = n[13],
				v = n[14];
			n = n[15];
			var y = d * v * u - g * f * u + g * c * p - l * v * p - d * c * n + l * f * n,
				x = m * f * u - h * v * u - m * c * p + s * v * p + h * c * n - s * f * n,
				_ = h * g * u - m * d * u + m * l * p - s * g * p - h * l * n + s * d * n,
				b = m * d * c - h * g * c - m * l * f + s * g * f + h * l * v - s * d * v,
				w = t * y + r * x + o * _ + a * b;
			if (0 === w) {
				if (!0 === e) throw Error("THREE.Matrix4: .getInverse() can't invert matrix, determinant is 0");
				console.warn("THREE.Matrix4: .getInverse() can't invert matrix, determinant is 0");
				return this.identity()
			}
			e = 1 / w;
			i[0] = y * e;
			i[1] = (g * f * a - d * v * a - g * o * p + r * v * p + d * o * n - r * f * n) * e;
			i[2] = (l * v * a - g * c * a + g * o * u - r * v * u - l * o * n + r * c * n) * e;
			i[3] = (d * c * a - l * f * a - d * o * u + r * f * u + l * o * p - r * c * p) * e;
			i[4] = x * e;
			i[5] = (h * v * a - m * f * a + m * o * p - t * v * p - h * o * n + t * f * n) * e;
			i[6] = (m * c * a - s * v * a - m * o * u + t * v * u + s * o * n - t * c * n) * e;
			i[7] = (s * f * a - h * c * a + h * o * u - t * f * u - s * o * p + t * c * p) * e;
			i[8] = _ * e;
			i[9] = (m * d * a - h * g * a - m * r * p + t * g * p + h * r * n - t * d * n) * e;
			i[10] = (s * g * a - m * l * a + m * r * u - t * g * u - s * r * n + t * l * n) * e;
			i[11] = (h * l * a - s * d * a - h * r * u + t * d * u + s * r * p - t * l * p) * e;
			i[12] = b * e;
			i[13] = (h * g * o - m * d * o + m * r * f - t * g * f - h * r * v + t * d * v) * e;
			i[14] = (m * l * o - s * g * o - m * r * c + t * g * c + s * r * v - t * l * v) * e;
			i[15] = (s * d * o - h * l * o + h * r * c - t * d * c - s * r * f + t * l * f) * e;
			return this
		},
		scale: function (t) {
			var e = this.elements,
				i = t.x,
				n = t.y;
			t = t.z;
			e[0] *= i;
			e[4] *= n;
			e[8] *= t;
			e[1] *= i;
			e[5] *= n;
			e[9] *= t;
			e[2] *= i;
			e[6] *= n;
			e[10] *= t;
			e[3] *= i;
			e[7] *= n;
			e[11] *= t;
			return this
		},
		getMaxScaleOnAxis: function () {
			var t = this.elements;
			return Math.sqrt(Math.max(t[0] * t[0] + t[1] * t[1] + t[2] * t[2], t[4] * t[4] + t[5] * t[5] + t[6] * t[6], t[8] * t[8] + t[9] * t[9] + t[10] * t[10]))
		},
		makeTranslation: function (t, e, i) {
			this.set(1, 0, 0, t, 0, 1, 0, e, 0, 0, 1, i, 0, 0, 0, 1);
			return this
		},
		makeRotationX: function (t) {
			var e = Math.cos(t);
			t = Math.sin(t);
			this.set(1, 0, 0, 0, 0, e, -t, 0, 0, t, e, 0, 0, 0, 0, 1);
			return this
		},
		makeRotationY: function (t) {
			var e = Math.cos(t);
			t = Math.sin(t);
			this.set(e, 0, t, 0, 0, 1, 0, 0, -t, 0, e, 0, 0, 0, 0, 1);
			return this
		},
		makeRotationZ: function (t) {
			var e = Math.cos(t);
			t = Math.sin(t);
			this.set(e, -t, 0, 0, t, e, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
			return this
		},
		makeRotationAxis: function (t, e) {
			var i = Math.cos(e);
			e = Math.sin(e);
			var n = 1 - i,
				r = t.x,
				o = t.y;
			t = t.z;
			var a = n * r,
				s = n * o;
			this.set(a * r + i, a * o - e * t, a * t + e * o, 0, a * o + e * t, s * o + i, s * t - e * r, 0, a * t - e * o, s * t + e * r, n * t * t + i, 0, 0, 0, 0, 1);
			return this
		},
		makeScale: function (t, e, i) {
			this.set(t, 0, 0, 0, 0, e, 0, 0, 0, 0, i, 0, 0, 0, 0, 1);
			return this
		},
		makeShear: function (t, e, i) {
			this.set(1, e, i, 0, t, 1, i, 0, t, e, 1, 0, 0, 0, 0, 1);
			return this
		},
		compose: function (t, e, i) {
			var n = this.elements,
				r = e._x,
				o = e._y,
				a = e._z,
				s = e._w,
				l = r + r,
				c = o + o,
				u = a + a;
			e = r * l;
			var h = r * c;
			r *= u;
			var d = o * c;
			o *= u;
			a *= u;
			l *= s;
			c *= s;
			s *= u;
			u = i.x;
			var f = i.y;
			i = i.z;
			n[0] = (1 - (d + a)) * u;
			n[1] = (h + s) * u;
			n[2] = (r - c) * u;
			n[3] = 0;
			n[4] = (h - s) * f;
			n[5] = (1 - (e + a)) * f;
			n[6] = (o + l) * f;
			n[7] = 0;
			n[8] = (r + c) * i;
			n[9] = (o - l) * i;
			n[10] = (1 - (e + d)) * i;
			n[11] = 0;
			n[12] = t.x;
			n[13] = t.y;
			n[14] = t.z;
			n[15] = 1;
			return this
		},
		decompose: function () {
			var l = new _t,
				c = new xt;
			return function (t, e, i) {
				var n = this.elements,
					r = l.set(n[0], n[1], n[2]).length(),
					o = l.set(n[4], n[5], n[6]).length(),
					a = l.set(n[8], n[9], n[10]).length();
				0 > this.determinant() && (r = -r);
				t.x = n[12];
				t.y = n[13];
				t.z = n[14];
				c.copy(this);
				t = 1 / r;
				n = 1 / o;
				var s = 1 / a;
				c.elements[0] *= t;
				c.elements[1] *= t;
				c.elements[2] *= t;
				c.elements[4] *= n;
				c.elements[5] *= n;
				c.elements[6] *= n;
				c.elements[8] *= s;
				c.elements[9] *= s;
				c.elements[10] *= s;
				e.setFromRotationMatrix(c);
				i.x = r;
				i.y = o;
				i.z = a;
				return this
			}
		}(),
		makePerspective: function (t, e, i, n, r, o) {
			void 0 === o && console.warn("THREE.Matrix4: .makePerspective() has been redefined and has a new signature. Please check the docs.");
			var a = this.elements;
			a[0] = 2 * r / (e - t);
			a[4] = 0;
			a[8] = (e + t) / (e - t);
			a[12] = 0;
			a[1] = 0;
			a[5] = 2 * r / (i - n);
			a[9] = (i + n) / (i - n);
			a[13] = 0;
			a[2] = 0;
			a[6] = 0;
			a[10] = -(o + r) / (o - r);
			a[14] = -2 * o * r / (o - r);
			a[3] = 0;
			a[7] = 0;
			a[11] = -1;
			a[15] = 0;
			return this
		},
		makeOrthographic: function (t, e, i, n, r, o) {
			var a = this.elements,
				s = 1 / (e - t),
				l = 1 / (i - n),
				c = 1 / (o - r);
			a[0] = 2 * s;
			a[4] = 0;
			a[8] = 0;
			a[12] = -((e + t) * s);
			a[1] = 0;
			a[5] = 2 * l;
			a[9] = 0;
			a[13] = -((i + n) * l);
			a[2] = 0;
			a[6] = 0;
			a[10] = -2 * c;
			a[14] = -((o + r) * c);
			a[3] = 0;
			a[7] = 0;
			a[11] = 0;
			a[15] = 1;
			return this
		},
		equals: function (t) {
			var e = this.elements;
			t = t.elements;
			for (var i = 0; 16 > i; i++)
				if (e[i] !== t[i]) return !1;
			return !0
		},
		fromArray: function (t, e) {
			void 0 === e && (e = 0);
			for (var i = 0; 16 > i; i++) this.elements[i] = t[i + e];
			return this
		},
		toArray: function (t, e) {
			void 0 === t && (t = []);
			void 0 === e && (e = 0);
			var i = this.elements;
			t[e] = i[0];
			t[e + 1] = i[1];
			t[e + 2] = i[2];
			t[e + 3] = i[3];
			t[e + 4] = i[4];
			t[e + 5] = i[5];
			t[e + 6] = i[6];
			t[e + 7] = i[7];
			t[e + 8] = i[8];
			t[e + 9] = i[9];
			t[e + 10] = i[10];
			t[e + 11] = i[11];
			t[e + 12] = i[12];
			t[e + 13] = i[13];
			t[e + 14] = i[14];
			t[e + 15] = i[15];
			return t
		}
	});
	Object.assign(j, {
		slerp: function (t, e, i, n) {
			return i.copy(t).slerp(e, n)
		},
		slerpFlat: function (t, e, i, n, r, o, a) {
			var s = i[n + 0],
				l = i[n + 1],
				c = i[n + 2];
			i = i[n + 3];
			n = r[o + 0];
			var u = r[o + 1],
				h = r[o + 2];
			r = r[o + 3];
			if (i !== r || s !== n || l !== u || c !== h) {
				o = 1 - a;
				var d = s * n + l * u + c * h + i * r,
					f = 0 <= d ? 1 : -1,
					p = 1 - d * d;
				p > Number.EPSILON && (p = Math.sqrt(p), d = Math.atan2(p, d * f), o = Math.sin(o * d) / p, a = Math.sin(a * d) / p);
				f *= a;
				s = s * o + n * f;
				l = l * o + u * f;
				c = c * o + h * f;
				i = i * o + r * f;
				o === 1 - a && (a = 1 / Math.sqrt(s * s + l * l + c * c + i * i), s *= a, l *= a, c *= a, i *= a)
			}
			t[e] = s;
			t[e + 1] = l;
			t[e + 2] = c;
			t[e + 3] = i
		}
	});
	Object.defineProperties(j.prototype, {
		x: {
			get: function () {
				return this._x
			},
			set: function (t) {
				this._x = t;
				this.onChangeCallback()
			}
		},
		y: {
			get: function () {
				return this._y
			},
			set: function (t) {
				this._y = t;
				this.onChangeCallback()
			}
		},
		z: {
			get: function () {
				return this._z
			},
			set: function (t) {
				this._z = t;
				this.onChangeCallback()
			}
		},
		w: {
			get: function () {
				return this._w
			},
			set: function (t) {
				this._w = t;
				this.onChangeCallback()
			}
		}
	});
	Object.assign(j.prototype, {
		set: function (t, e, i, n) {
			this._x = t;
			this._y = e;
			this._z = i;
			this._w = n;
			this.onChangeCallback();
			return this
		},
		clone: function () {
			return new this.constructor(this._x, this._y, this._z, this._w)
		},
		copy: function (t) {
			this._x = t.x;
			this._y = t.y;
			this._z = t.z;
			this._w = t.w;
			this.onChangeCallback();
			return this
		},
		setFromEuler: function (t, e) {
			if (!t || !t.isEuler) throw Error("THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.");
			var i = t._x,
				n = t._y,
				r = t._z;
			t = t.order;
			var o = Math.cos,
				a = Math.sin,
				s = o(i / 2),
				l = o(n / 2);
			o = o(r / 2);
			i = a(i / 2);
			n = a(n / 2);
			r = a(r / 2);
			"XYZ" === t ? (this._x = i * l * o + s * n * r, this._y = s * n * o - i * l * r, this._z = s * l * r + i * n * o, this._w = s * l * o - i * n * r) : "YXZ" === t ? (this._x = i * l * o + s * n * r, this._y = s * n * o - i * l * r, this._z = s * l * r - i * n * o, this._w = s * l * o + i * n * r) : "ZXY" === t ? (this._x = i * l * o - s * n * r, this._y = s * n * o + i * l * r, this._z = s * l * r + i * n * o, this._w = s * l * o - i * n * r) : "ZYX" === t ? (this._x = i * l * o - s * n * r, this._y = s * n * o + i * l * r, this._z = s * l * r - i * n * o, this._w = s * l * o + i * n * r) : "YZX" === t ? (this._x = i * l * o + s * n * r, this._y = s * n * o + i * l * r, this._z = s * l * r - i * n * o, this._w = s * l * o - i * n * r) : "XZY" === t && (this._x = i * l * o - s * n * r, this._y = s * n * o - i * l * r, this._z = s * l * r + i * n * o, this._w = s * l * o + i * n * r);
			if (!1 !== e) this.onChangeCallback();
			return this
		},
		setFromAxisAngle: function (t, e) {
			e /= 2;
			var i = Math.sin(e);
			this._x = t.x * i;
			this._y = t.y * i;
			this._z = t.z * i;
			this._w = Math.cos(e);
			this.onChangeCallback();
			return this
		},
		setFromRotationMatrix: function (t) {
			var e = t.elements,
				i = e[0];
			t = e[4];
			var n = e[8],
				r = e[1],
				o = e[5],
				a = e[9],
				s = e[2],
				l = e[6];
			e = e[10];
			var c = i + o + e;
			0 < c ? (i = .5 / Math.sqrt(c + 1), this._w = .25 / i, this._x = (l - a) * i, this._y = (n - s) * i, this._z = (r - t) * i) : i > o && i > e ? (i = 2 * Math.sqrt(1 + i - o - e), this._w = (l - a) / i, this._x = .25 * i, this._y = (t + r) / i, this._z = (n + s) / i) : o > e ? (i = 2 * Math.sqrt(1 + o - i - e), this._w = (n - s) / i, this._x = (t + r) / i, this._y = .25 * i, this._z = (a + l) / i) : (i = 2 * Math.sqrt(1 + e - i - o), this._w = (r - t) / i, this._x = (n + s) / i, this._y = (a + l) / i, this._z = .25 * i);
			this.onChangeCallback();
			return this
		},
		setFromUnitVectors: function () {
			var i = new _t,
				n;
			return function (t, e) {
				void 0 === i && (i = new _t);
				n = t.dot(e) + 1;
				1e-6 > n ? (n = 0, Math.abs(t.x) > Math.abs(t.z) ? i.set(-t.y, t.x, 0) : i.set(0, -t.z, t.y)) : i.crossVectors(t, e);
				this._x = i.x;
				this._y = i.y;
				this._z = i.z;
				this._w = n;
				return this.normalize()
			}
		}(),
		inverse: function () {
			return this.conjugate()
		},
		conjugate: function () {
			this._x *= -1;
			this._y *= -1;
			this._z *= -1;
			this.onChangeCallback();
			return this
		},
		dot: function (t) {
			return this._x * t._x + this._y * t._y + this._z * t._z + this._w * t._w
		},
		lengthSq: function () {
			return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w
		},
		length: function () {
			return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w)
		},
		normalize: function () {
			var t = this.length();
			0 === t ? (this._z = this._y = this._x = 0, this._w = 1) : (t = 1 / t, this._x *= t, this._y *= t, this._z *= t, this._w *= t);
			this.onChangeCallback();
			return this
		},
		multiply: function (t, e) {
			return void 0 !== e ? (console.warn("THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead."), this.multiplyQuaternions(t, e)) : this.multiplyQuaternions(this, t)
		},
		premultiply: function (t) {
			return this.multiplyQuaternions(t, this)
		},
		multiplyQuaternions: function (t, e) {
			var i = t._x,
				n = t._y,
				r = t._z;
			t = t._w;
			var o = e._x,
				a = e._y,
				s = e._z;
			e = e._w;
			this._x = i * e + t * o + n * s - r * a;
			this._y = n * e + t * a + r * o - i * s;
			this._z = r * e + t * s + i * a - n * o;
			this._w = t * e - i * o - n * a - r * s;
			this.onChangeCallback();
			return this
		},
		slerp: function (t, e) {
			if (0 === e) return this;
			if (1 === e) return this.copy(t);
			var i = this._x,
				n = this._y,
				r = this._z,
				o = this._w,
				a = o * t._w + i * t._x + n * t._y + r * t._z;
			0 > a ? (this._w = -t._w, this._x = -t._x, this._y = -t._y, this._z = -t._z, a = -a) : this.copy(t);
			if (1 <= a) return this._w = o, this._x = i, this._y = n, this._z = r, this;
			t = Math.sqrt(1 - a * a);
			if (.001 > Math.abs(t)) return this._w = .5 * (o + this._w), this._x = .5 * (i + this._x), this._y = .5 * (n + this._y), this._z = .5 * (r + this._z), this;
			var s = Math.atan2(t, a);
			a = Math.sin((1 - e) * s) / t;
			e = Math.sin(e * s) / t;
			this._w = o * a + this._w * e;
			this._x = i * a + this._x * e;
			this._y = n * a + this._y * e;
			this._z = r * a + this._z * e;
			this.onChangeCallback();
			return this
		},
		equals: function (t) {
			return t._x === this._x && t._y === this._y && t._z === this._z && t._w === this._w
		},
		fromArray: function (t, e) {
			void 0 === e && (e = 0);
			this._x = t[e];
			this._y = t[e + 1];
			this._z = t[e + 2];
			this._w = t[e + 3];
			this.onChangeCallback();
			return this
		},
		toArray: function (t, e) {
			void 0 === t && (t = []);
			void 0 === e && (e = 0);
			t[e] = this._x;
			t[e + 1] = this._y;
			t[e + 2] = this._z;
			t[e + 3] = this._w;
			return t
		},
		onChange: function (t) {
			this.onChangeCallback = t;
			return this
		},
		onChangeCallback: function () {}
	});
	Object.assign(_t.prototype, {
		isVector3: !0,
		set: function (t, e, i) {
			this.x = t;
			this.y = e;
			this.z = i;
			return this
		},
		setScalar: function (t) {
			this.z = this.y = this.x = t;
			return this
		},
		setX: function (t) {
			this.x = t;
			return this
		},
		setY: function (t) {
			this.y = t;
			return this
		},
		setZ: function (t) {
			this.z = t;
			return this
		},
		setComponent: function (t, e) {
			switch (t) {
				case 0:
					this.x = e;
					break;
				case 1:
					this.y = e;
					break;
				case 2:
					this.z = e;
					break;
				default:
					throw Error("index is out of range: " + t)
			}
			return this
		},
		getComponent: function (t) {
			switch (t) {
				case 0:
					return this.x;
				case 1:
					return this.y;
				case 2:
					return this.z;
				default:
					throw Error("index is out of range: " + t)
			}
		},
		clone: function () {
			return new this.constructor(this.x, this.y, this.z)
		},
		copy: function (t) {
			this.x = t.x;
			this.y = t.y;
			this.z = t.z;
			return this
		},
		add: function (t, e) {
			if (void 0 !== e) return console.warn("THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead."), this.addVectors(t, e);
			this.x += t.x;
			this.y += t.y;
			this.z += t.z;
			return this
		},
		addScalar: function (t) {
			this.x += t;
			this.y += t;
			this.z += t;
			return this
		},
		addVectors: function (t, e) {
			this.x = t.x + e.x;
			this.y = t.y + e.y;
			this.z = t.z + e.z;
			return this
		},
		addScaledVector: function (t, e) {
			this.x += t.x * e;
			this.y += t.y * e;
			this.z += t.z * e;
			return this
		},
		sub: function (t, e) {
			if (void 0 !== e) return console.warn("THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."), this.subVectors(t, e);
			this.x -= t.x;
			this.y -= t.y;
			this.z -= t.z;
			return this
		},
		subScalar: function (t) {
			this.x -= t;
			this.y -= t;
			this.z -= t;
			return this
		},
		subVectors: function (t, e) {
			this.x = t.x - e.x;
			this.y = t.y - e.y;
			this.z = t.z - e.z;
			return this
		},
		multiply: function (t, e) {
			if (void 0 !== e) return console.warn("THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead."), this.multiplyVectors(t, e);
			this.x *= t.x;
			this.y *= t.y;
			this.z *= t.z;
			return this
		},
		multiplyScalar: function (t) {
			this.x *= t;
			this.y *= t;
			this.z *= t;
			return this
		},
		multiplyVectors: function (t, e) {
			this.x = t.x * e.x;
			this.y = t.y * e.y;
			this.z = t.z * e.z;
			return this
		},
		applyEuler: function () {
			var e = new j;
			return function (t) {
				t && t.isEuler || console.error("THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order.");
				return this.applyQuaternion(e.setFromEuler(t))
			}
		}(),
		applyAxisAngle: function () {
			var i = new j;
			return function (t, e) {
				return this.applyQuaternion(i.setFromAxisAngle(t, e))
			}
		}(),
		applyMatrix3: function (t) {
			var e = this.x,
				i = this.y,
				n = this.z;
			t = t.elements;
			this.x = t[0] * e + t[3] * i + t[6] * n;
			this.y = t[1] * e + t[4] * i + t[7] * n;
			this.z = t[2] * e + t[5] * i + t[8] * n;
			return this
		},
		applyMatrix4: function (t) {
			var e = this.x,
				i = this.y,
				n = this.z;
			t = t.elements;
			var r = 1 / (t[3] * e + t[7] * i + t[11] * n + t[15]);
			this.x = (t[0] * e + t[4] * i + t[8] * n + t[12]) * r;
			this.y = (t[1] * e + t[5] * i + t[9] * n + t[13]) * r;
			this.z = (t[2] * e + t[6] * i + t[10] * n + t[14]) * r;
			return this
		},
		applyQuaternion: function (t) {
			var e = this.x,
				i = this.y,
				n = this.z,
				r = t.x,
				o = t.y,
				a = t.z;
			t = t.w;
			var s = t * e + o * n - a * i,
				l = t * i + a * e - r * n,
				c = t * n + r * i - o * e;
			e = -r * e - o * i - a * n;
			this.x = s * t + e * -r + l * -a - c * -o;
			this.y = l * t + e * -o + c * -r - s * -a;
			this.z = c * t + e * -a + s * -o - l * -r;
			return this
		},
		project: function () {
			var e = new xt;
			return function (t) {
				e.multiplyMatrices(t.projectionMatrix, e.getInverse(t.matrixWorld));
				return this.applyMatrix4(e)
			}
		}(),
		unproject: function () {
			var e = new xt;
			return function (t) {
				e.multiplyMatrices(t.matrixWorld, e.getInverse(t.projectionMatrix));
				return this.applyMatrix4(e)
			}
		}(),
		transformDirection: function (t) {
			var e = this.x,
				i = this.y,
				n = this.z;
			t = t.elements;
			this.x = t[0] * e + t[4] * i + t[8] * n;
			this.y = t[1] * e + t[5] * i + t[9] * n;
			this.z = t[2] * e + t[6] * i + t[10] * n;
			return this.normalize()
		},
		divide: function (t) {
			this.x /= t.x;
			this.y /= t.y;
			this.z /= t.z;
			return this
		},
		divideScalar: function (t) {
			return this.multiplyScalar(1 / t)
		},
		min: function (t) {
			this.x = Math.min(this.x, t.x);
			this.y = Math.min(this.y, t.y);
			this.z = Math.min(this.z, t.z);
			return this
		},
		max: function (t) {
			this.x = Math.max(this.x, t.x);
			this.y = Math.max(this.y, t.y);
			this.z = Math.max(this.z, t.z);
			return this
		},
		clamp: function (t, e) {
			this.x = Math.max(t.x, Math.min(e.x, this.x));
			this.y = Math.max(t.y, Math.min(e.y, this.y));
			this.z = Math.max(t.z, Math.min(e.z, this.z));
			return this
		},
		clampScalar: function () {
			var i = new _t,
				n = new _t;
			return function (t, e) {
				i.set(t, t, t);
				n.set(e, e, e);
				return this.clamp(i, n)
			}
		}(),
		clampLength: function (t, e) {
			var i = this.length();
			return this.divideScalar(i || 1).multiplyScalar(Math.max(t, Math.min(e, i)))
		},
		floor: function () {
			this.x = Math.floor(this.x);
			this.y = Math.floor(this.y);
			this.z = Math.floor(this.z);
			return this
		},
		ceil: function () {
			this.x = Math.ceil(this.x);
			this.y = Math.ceil(this.y);
			this.z = Math.ceil(this.z);
			return this
		},
		round: function () {
			this.x = Math.round(this.x);
			this.y = Math.round(this.y);
			this.z = Math.round(this.z);
			return this
		},
		roundToZero: function () {
			this.x = 0 > this.x ? Math.ceil(this.x) : Math.floor(this.x);
			this.y = 0 > this.y ? Math.ceil(this.y) : Math.floor(this.y);
			this.z = 0 > this.z ? Math.ceil(this.z) : Math.floor(this.z);
			return this
		},
		negate: function () {
			this.x = -this.x;
			this.y = -this.y;
			this.z = -this.z;
			return this
		},
		dot: function (t) {
			return this.x * t.x + this.y * t.y + this.z * t.z
		},
		lengthSq: function () {
			return this.x * this.x + this.y * this.y + this.z * this.z
		},
		length: function () {
			return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z)
		},
		manhattanLength: function () {
			return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z)
		},
		normalize: function () {
			return this.divideScalar(this.length() || 1)
		},
		setLength: function (t) {
			return this.normalize().multiplyScalar(t)
		},
		lerp: function (t, e) {
			this.x += (t.x - this.x) * e;
			this.y += (t.y - this.y) * e;
			this.z += (t.z - this.z) * e;
			return this
		},
		lerpVectors: function (t, e, i) {
			return this.subVectors(e, t).multiplyScalar(i).add(t)
		},
		cross: function (t, e) {
			return void 0 !== e ? (console.warn("THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead."), this.crossVectors(t, e)) : this.crossVectors(this, t)
		},
		crossVectors: function (t, e) {
			var i = t.x,
				n = t.y;
			t = t.z;
			var r = e.x,
				o = e.y;
			e = e.z;
			this.x = n * e - t * o;
			this.y = t * r - i * e;
			this.z = i * o - n * r;
			return this
		},
		projectOnVector: function (t) {
			var e = t.dot(this) / t.lengthSq();
			return this.copy(t).multiplyScalar(e)
		},
		projectOnPlane: function () {
			var e = new _t;
			return function (t) {
				e.copy(this).projectOnVector(t);
				return this.sub(e)
			}
		}(),
		reflect: function () {
			var e = new _t;
			return function (t) {
				return this.sub(e.copy(t).multiplyScalar(2 * this.dot(t)))
			}
		}(),
		angleTo: function (t) {
			t = this.dot(t) / Math.sqrt(this.lengthSq() * t.lengthSq());
			return Math.acos(Kr.clamp(t, -1, 1))
		},
		distanceTo: function (t) {
			return Math.sqrt(this.distanceToSquared(t))
		},
		distanceToSquared: function (t) {
			var e = this.x - t.x,
				i = this.y - t.y;
			t = this.z - t.z;
			return e * e + i * i + t * t
		},
		manhattanDistanceTo: function (t) {
			return Math.abs(this.x - t.x) + Math.abs(this.y - t.y) + Math.abs(this.z - t.z)
		},
		setFromSpherical: function (t) {
			var e = Math.sin(t.phi) * t.radius;
			this.x = e * Math.sin(t.theta);
			this.y = Math.cos(t.phi) * t.radius;
			this.z = e * Math.cos(t.theta);
			return this
		},
		setFromCylindrical: function (t) {
			this.x = t.radius * Math.sin(t.theta);
			this.y = t.y;
			this.z = t.radius * Math.cos(t.theta);
			return this
		},
		setFromMatrixPosition: function (t) {
			t = t.elements;
			this.x = t[12];
			this.y = t[13];
			this.z = t[14];
			return this
		},
		setFromMatrixScale: function (t) {
			var e = this.setFromMatrixColumn(t, 0).length(),
				i = this.setFromMatrixColumn(t, 1).length();
			t = this.setFromMatrixColumn(t, 2).length();
			this.x = e;
			this.y = i;
			this.z = t;
			return this
		},
		setFromMatrixColumn: function (t, e) {
			return this.fromArray(t.elements, 4 * e)
		},
		equals: function (t) {
			return t.x === this.x && t.y === this.y && t.z === this.z
		},
		fromArray: function (t, e) {
			void 0 === e && (e = 0);
			this.x = t[e];
			this.y = t[e + 1];
			this.z = t[e + 2];
			return this
		},
		toArray: function (t, e) {
			void 0 === t && (t = []);
			void 0 === e && (e = 0);
			t[e] = this.x;
			t[e + 1] = this.y;
			t[e + 2] = this.z;
			return t
		},
		fromBufferAttribute: function (t, e, i) {
			void 0 !== i && console.warn("THREE.Vector3: offset has been removed from .fromBufferAttribute().");
			this.x = t.getX(e);
			this.y = t.getY(e);
			this.z = t.getZ(e);
			return this
		}
	});
	Object.assign(g.prototype, {
		isMatrix3: !0,
		set: function (t, e, i, n, r, o, a, s, l) {
			var c = this.elements;
			c[0] = t;
			c[1] = n;
			c[2] = a;
			c[3] = e;
			c[4] = r;
			c[5] = s;
			c[6] = i;
			c[7] = o;
			c[8] = l;
			return this
		},
		identity: function () {
			this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
			return this
		},
		clone: function () {
			return (new this.constructor).fromArray(this.elements)
		},
		copy: function (t) {
			var e = this.elements;
			t = t.elements;
			e[0] = t[0];
			e[1] = t[1];
			e[2] = t[2];
			e[3] = t[3];
			e[4] = t[4];
			e[5] = t[5];
			e[6] = t[6];
			e[7] = t[7];
			e[8] = t[8];
			return this
		},
		setFromMatrix4: function (t) {
			t = t.elements;
			this.set(t[0], t[4], t[8], t[1], t[5], t[9], t[2], t[6], t[10]);
			return this
		},
		applyToBufferAttribute: function () {
			var n = new _t;
			return function (t) {
				for (var e = 0, i = t.count; e < i; e++) n.x = t.getX(e), n.y = t.getY(e), n.z = t.getZ(e), n.applyMatrix3(this), t.setXYZ(e, n.x, n.y, n.z);
				return t
			}
		}(),
		multiply: function (t) {
			return this.multiplyMatrices(this, t)
		},
		premultiply: function (t) {
			return this.multiplyMatrices(t, this)
		},
		multiplyMatrices: function (t, e) {
			var i = t.elements,
				n = e.elements;
			e = this.elements;
			t = i[0];
			var r = i[3],
				o = i[6],
				a = i[1],
				s = i[4],
				l = i[7],
				c = i[2],
				u = i[5];
			i = i[8];
			var h = n[0],
				d = n[3],
				f = n[6],
				p = n[1],
				m = n[4],
				g = n[7],
				v = n[2],
				y = n[5];
			n = n[8];
			e[0] = t * h + r * p + o * v;
			e[3] = t * d + r * m + o * y;
			e[6] = t * f + r * g + o * n;
			e[1] = a * h + s * p + l * v;
			e[4] = a * d + s * m + l * y;
			e[7] = a * f + s * g + l * n;
			e[2] = c * h + u * p + i * v;
			e[5] = c * d + u * m + i * y;
			e[8] = c * f + u * g + i * n;
			return this
		},
		multiplyScalar: function (t) {
			var e = this.elements;
			e[0] *= t;
			e[3] *= t;
			e[6] *= t;
			e[1] *= t;
			e[4] *= t;
			e[7] *= t;
			e[2] *= t;
			e[5] *= t;
			e[8] *= t;
			return this
		},
		determinant: function () {
			var t = this.elements,
				e = t[0],
				i = t[1],
				n = t[2],
				r = t[3],
				o = t[4],
				a = t[5],
				s = t[6],
				l = t[7];
			t = t[8];
			return e * o * t - e * a * l - i * r * t + i * a * s + n * r * l - n * o * s
		},
		getInverse: function (t, e) {
			t && t.isMatrix4 && console.error("THREE.Matrix3: .getInverse() no longer takes a Matrix4 argument.");
			var i = t.elements;
			t = this.elements;
			var n = i[0],
				r = i[1],
				o = i[2],
				a = i[3],
				s = i[4],
				l = i[5],
				c = i[6],
				u = i[7];
			i = i[8];
			var h = i * s - l * u,
				d = l * c - i * a,
				f = u * a - s * c,
				p = n * h + r * d + o * f;
			if (0 === p) {
				if (!0 === e) throw Error("THREE.Matrix3: .getInverse() can't invert matrix, determinant is 0");
				console.warn("THREE.Matrix3: .getInverse() can't invert matrix, determinant is 0");
				return this.identity()
			}
			e = 1 / p;
			t[0] = h * e;
			t[1] = (o * u - i * r) * e;
			t[2] = (l * r - o * s) * e;
			t[3] = d * e;
			t[4] = (i * n - o * c) * e;
			t[5] = (o * a - l * n) * e;
			t[6] = f * e;
			t[7] = (r * c - u * n) * e;
			t[8] = (s * n - r * a) * e;
			return this
		},
		transpose: function () {
			var t = this.elements;
			var e = t[1];
			t[1] = t[3];
			t[3] = e;
			e = t[2];
			t[2] = t[6];
			t[6] = e;
			e = t[5];
			t[5] = t[7];
			t[7] = e;
			return this
		},
		getNormalMatrix: function (t) {
			return this.setFromMatrix4(t).getInverse(this).transpose()
		},
		transposeIntoArray: function (t) {
			var e = this.elements;
			t[0] = e[0];
			t[1] = e[3];
			t[2] = e[6];
			t[3] = e[1];
			t[4] = e[4];
			t[5] = e[7];
			t[6] = e[2];
			t[7] = e[5];
			t[8] = e[8];
			return this
		},
		setUvTransform: function (t, e, i, n, r, o, a) {
			var s = Math.cos(r);
			r = Math.sin(r);
			this.set(i * s, i * r, -i * (s * o + r * a) + o + t, -n * r, n * s, -n * (-r * o + s * a) + a + e, 0, 0, 1)
		},
		scale: function (t, e) {
			var i = this.elements;
			i[0] *= t;
			i[3] *= t;
			i[6] *= t;
			i[1] *= e;
			i[4] *= e;
			i[7] *= e;
			return this
		},
		rotate: function (t) {
			var e = Math.cos(t);
			t = Math.sin(t);
			var i = this.elements,
				n = i[0],
				r = i[3],
				o = i[6],
				a = i[1],
				s = i[4],
				l = i[7];
			i[0] = e * n + t * a;
			i[3] = e * r + t * s;
			i[6] = e * o + t * l;
			i[1] = -t * n + e * a;
			i[4] = -t * r + e * s;
			i[7] = -t * o + e * l;
			return this
		},
		translate: function (t, e) {
			var i = this.elements;
			i[0] += t * i[2];
			i[3] += t * i[5];
			i[6] += t * i[8];
			i[1] += e * i[2];
			i[4] += e * i[5];
			i[7] += e * i[8];
			return this
		},
		equals: function (t) {
			var e = this.elements;
			t = t.elements;
			for (var i = 0; 9 > i; i++)
				if (e[i] !== t[i]) return !1;
			return !0
		},
		fromArray: function (t, e) {
			void 0 === e && (e = 0);
			for (var i = 0; 9 > i; i++) this.elements[i] = t[i + e];
			return this
		},
		toArray: function (t, e) {
			void 0 === t && (t = []);
			void 0 === e && (e = 0);
			var i = this.elements;
			t[e] = i[0];
			t[e + 1] = i[1];
			t[e + 2] = i[2];
			t[e + 3] = i[3];
			t[e + 4] = i[4];
			t[e + 5] = i[5];
			t[e + 6] = i[6];
			t[e + 7] = i[7];
			t[e + 8] = i[8];
			return t
		}
	});
	var to = 0;
	d.DEFAULT_IMAGE = void 0;
	d.DEFAULT_MAPPING = 300;
	d.prototype = Object.assign(Object.create(e.prototype), {
		constructor: d,
		isTexture: !0,
		updateMatrix: function () {
			this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y)
		},
		clone: function () {
			return (new this.constructor).copy(this)
		},
		copy: function (t) {
			this.name = t.name;
			this.image = t.image;
			this.mipmaps = t.mipmaps.slice(0);
			this.mapping = t.mapping;
			this.wrapS = t.wrapS;
			this.wrapT = t.wrapT;
			this.magFilter = t.magFilter;
			this.minFilter = t.minFilter;
			this.anisotropy = t.anisotropy;
			this.format = t.format;
			this.type = t.type;
			this.offset.copy(t.offset);
			this.repeat.copy(t.repeat);
			this.center.copy(t.center);
			this.rotation = t.rotation;
			this.matrixAutoUpdate = t.matrixAutoUpdate;
			this.matrix.copy(t.matrix);
			this.generateMipmaps = t.generateMipmaps;
			this.premultiplyAlpha = t.premultiplyAlpha;
			this.flipY = t.flipY;
			this.unpackAlignment = t.unpackAlignment;
			this.encoding = t.encoding;
			return this
		},
		toJSON: function (t) {
			var e = void 0 === t || "string" === typeof t;
			if (!e && void 0 !== t.textures[this.uuid]) return t.textures[this.uuid];
			var i = {
				metadata: {
					version: 4.5,
					type: "Texture",
					generator: "Texture.toJSON"
				},
				uuid: this.uuid,
				name: this.name,
				mapping: this.mapping,
				repeat: [this.repeat.x, this.repeat.y],
				offset: [this.offset.x, this.offset.y],
				center: [this.center.x, this.center.y],
				rotation: this.rotation,
				wrap: [this.wrapS, this.wrapT],
				format: this.format,
				minFilter: this.minFilter,
				magFilter: this.magFilter,
				anisotropy: this.anisotropy,
				flipY: this.flipY
			};
			if (void 0 !== this.image) {
				var n = this.image;
				void 0 === n.uuid && (n.uuid = Kr.generateUUID());
				if (!e && void 0 === t.images[n.uuid]) {
					var r = t.images,
						o = n.uuid,
						a = n.uuid;
					if (n instanceof HTMLCanvasElement) var s = n;
					else {
						s = document.createElementNS("http://www.w3.org/1999/xhtml", "canvas");
						s.width = n.width;
						s.height = n.height;
						var l = s.getContext("2d");
						n instanceof ImageData ? l.putImageData(n, 0, 0) : l.drawImage(n, 0, 0, n.width, n.height)
					}
					s = 2048 < s.width || 2048 < s.height ? s.toDataURL("image/jpeg", .6) : s.toDataURL("image/png");
					r[o] = {
						uuid: a,
						url: s
					}
				}
				i.image = n.uuid
			}
			e || (t.textures[this.uuid] = i);
			return i
		},
		dispose: function () {
			this.dispatchEvent({
				type: "dispose"
			})
		},
		transformUv: function (t) {
			if (300 === this.mapping) {
				t.applyMatrix3(this.matrix);
				if (0 > t.x || 1 < t.x) switch (this.wrapS) {
					case 1e3:
						t.x -= Math.floor(t.x);
						break;
					case 1001:
						t.x = 0 > t.x ? 0 : 1;
						break;
					case 1002:
						t.x = 1 === Math.abs(Math.floor(t.x) % 2) ? Math.ceil(t.x) - t.x : t.x - Math.floor(t.x)
				}
				if (0 > t.y || 1 < t.y) switch (this.wrapT) {
					case 1e3:
						t.y -= Math.floor(t.y);
						break;
					case 1001:
						t.y = 0 > t.y ? 0 : 1;
						break;
					case 1002:
						t.y = 1 === Math.abs(Math.floor(t.y) % 2) ? Math.ceil(t.y) - t.y : t.y - Math.floor(t.y)
				}
				this.flipY && (t.y = 1 - t.y)
			}
		}
	});
	Object.defineProperty(d.prototype, "needsUpdate", {
		set: function (t) {
			!0 === t && this.version++
		}
	});
	Object.assign(bt.prototype, {
		isVector4: !0,
		set: function (t, e, i, n) {
			this.x = t;
			this.y = e;
			this.z = i;
			this.w = n;
			return this
		},
		setScalar: function (t) {
			this.w = this.z = this.y = this.x = t;
			return this
		},
		setX: function (t) {
			this.x = t;
			return this
		},
		setY: function (t) {
			this.y = t;
			return this
		},
		setZ: function (t) {
			this.z = t;
			return this
		},
		setW: function (t) {
			this.w = t;
			return this
		},
		setComponent: function (t, e) {
			switch (t) {
				case 0:
					this.x = e;
					break;
				case 1:
					this.y = e;
					break;
				case 2:
					this.z = e;
					break;
				case 3:
					this.w = e;
					break;
				default:
					throw Error("index is out of range: " + t)
			}
			return this
		},
		getComponent: function (t) {
			switch (t) {
				case 0:
					return this.x;
				case 1:
					return this.y;
				case 2:
					return this.z;
				case 3:
					return this.w;
				default:
					throw Error("index is out of range: " + t)
			}
		},
		clone: function () {
			return new this.constructor(this.x, this.y, this.z, this.w)
		},
		copy: function (t) {
			this.x = t.x;
			this.y = t.y;
			this.z = t.z;
			this.w = void 0 !== t.w ? t.w : 1;
			return this
		},
		add: function (t, e) {
			if (void 0 !== e) return console.warn("THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead."), this.addVectors(t, e);
			this.x += t.x;
			this.y += t.y;
			this.z += t.z;
			this.w += t.w;
			return this
		},
		addScalar: function (t) {
			this.x += t;
			this.y += t;
			this.z += t;
			this.w += t;
			return this
		},
		addVectors: function (t, e) {
			this.x = t.x + e.x;
			this.y = t.y + e.y;
			this.z = t.z + e.z;
			this.w = t.w + e.w;
			return this
		},
		addScaledVector: function (t, e) {
			this.x += t.x * e;
			this.y += t.y * e;
			this.z += t.z * e;
			this.w += t.w * e;
			return this
		},
		sub: function (t, e) {
			if (void 0 !== e) return console.warn("THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."), this.subVectors(t, e);
			this.x -= t.x;
			this.y -= t.y;
			this.z -= t.z;
			this.w -= t.w;
			return this
		},
		subScalar: function (t) {
			this.x -= t;
			this.y -= t;
			this.z -= t;
			this.w -= t;
			return this
		},
		subVectors: function (t, e) {
			this.x = t.x - e.x;
			this.y = t.y - e.y;
			this.z = t.z - e.z;
			this.w = t.w - e.w;
			return this
		},
		multiplyScalar: function (t) {
			this.x *= t;
			this.y *= t;
			this.z *= t;
			this.w *= t;
			return this
		},
		applyMatrix4: function (t) {
			var e = this.x,
				i = this.y,
				n = this.z,
				r = this.w;
			t = t.elements;
			this.x = t[0] * e + t[4] * i + t[8] * n + t[12] * r;
			this.y = t[1] * e + t[5] * i + t[9] * n + t[13] * r;
			this.z = t[2] * e + t[6] * i + t[10] * n + t[14] * r;
			this.w = t[3] * e + t[7] * i + t[11] * n + t[15] * r;
			return this
		},
		divideScalar: function (t) {
			return this.multiplyScalar(1 / t)
		},
		setAxisAngleFromQuaternion: function (t) {
			this.w = 2 * Math.acos(t.w);
			var e = Math.sqrt(1 - t.w * t.w);
			1e-4 > e ? (this.x = 1, this.z = this.y = 0) : (this.x = t.x / e, this.y = t.y / e, this.z = t.z / e);
			return this
		},
		setAxisAngleFromRotationMatrix: function (t) {
			t = t.elements;
			var e = t[0];
			var i = t[4];
			var n = t[8],
				r = t[1],
				o = t[5],
				a = t[9];
			var s = t[2];
			var l = t[6];
			var c = t[10];
			if (.01 > Math.abs(i - r) && .01 > Math.abs(n - s) && .01 > Math.abs(a - l)) {
				if (.1 > Math.abs(i + r) && .1 > Math.abs(n + s) && .1 > Math.abs(a + l) && .1 > Math.abs(e + o + c - 3)) return this.set(1, 0, 0, 0), this;
				t = Math.PI;
				e = (e + 1) / 2;
				o = (o + 1) / 2;
				c = (c + 1) / 2;
				i = (i + r) / 4;
				n = (n + s) / 4;
				a = (a + l) / 4;
				e > o && e > c ? .01 > e ? (l = 0, i = s = .707106781) : (l = Math.sqrt(e), s = i / l, i = n / l) : o > c ? .01 > o ? (l = .707106781, s = 0, i = .707106781) : (s = Math.sqrt(o), l = i / s, i = a / s) : .01 > c ? (s = l = .707106781, i = 0) : (i = Math.sqrt(c), l = n / i, s = a / i);
				this.set(l, s, i, t);
				return this
			}
			t = Math.sqrt((l - a) * (l - a) + (n - s) * (n - s) + (r - i) * (r - i));
			.001 > Math.abs(t) && (t = 1);
			this.x = (l - a) / t;
			this.y = (n - s) / t;
			this.z = (r - i) / t;
			this.w = Math.acos((e + o + c - 1) / 2);
			return this
		},
		min: function (t) {
			this.x = Math.min(this.x, t.x);
			this.y = Math.min(this.y, t.y);
			this.z = Math.min(this.z, t.z);
			this.w = Math.min(this.w, t.w);
			return this
		},
		max: function (t) {
			this.x = Math.max(this.x, t.x);
			this.y = Math.max(this.y, t.y);
			this.z = Math.max(this.z, t.z);
			this.w = Math.max(this.w, t.w);
			return this
		},
		clamp: function (t, e) {
			this.x = Math.max(t.x, Math.min(e.x, this.x));
			this.y = Math.max(t.y, Math.min(e.y, this.y));
			this.z = Math.max(t.z, Math.min(e.z, this.z));
			this.w = Math.max(t.w, Math.min(e.w, this.w));
			return this
		},
		clampScalar: function () {
			var i, n;
			return function (t, e) {
				void 0 === i && (i = new bt, n = new bt);
				i.set(t, t, t, t);
				n.set(e, e, e, e);
				return this.clamp(i, n)
			}
		}(),
		clampLength: function (t, e) {
			var i = this.length();
			return this.divideScalar(i || 1).multiplyScalar(Math.max(t, Math.min(e, i)))
		},
		floor: function () {
			this.x = Math.floor(this.x);
			this.y = Math.floor(this.y);
			this.z = Math.floor(this.z);
			this.w = Math.floor(this.w);
			return this
		},
		ceil: function () {
			this.x = Math.ceil(this.x);
			this.y = Math.ceil(this.y);
			this.z = Math.ceil(this.z);
			this.w = Math.ceil(this.w);
			return this
		},
		round: function () {
			this.x = Math.round(this.x);
			this.y = Math.round(this.y);
			this.z = Math.round(this.z);
			this.w = Math.round(this.w);
			return this
		},
		roundToZero: function () {
			this.x = 0 > this.x ? Math.ceil(this.x) : Math.floor(this.x);
			this.y = 0 > this.y ? Math.ceil(this.y) : Math.floor(this.y);
			this.z = 0 > this.z ? Math.ceil(this.z) : Math.floor(this.z);
			this.w = 0 > this.w ? Math.ceil(this.w) : Math.floor(this.w);
			return this
		},
		negate: function () {
			this.x = -this.x;
			this.y = -this.y;
			this.z = -this.z;
			this.w = -this.w;
			return this
		},
		dot: function (t) {
			return this.x * t.x + this.y * t.y + this.z * t.z + this.w * t.w
		},
		lengthSq: function () {
			return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w
		},
		length: function () {
			return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w)
		},
		manhattanLength: function () {
			return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w)
		},
		normalize: function () {
			return this.divideScalar(this.length() || 1)
		},
		setLength: function (t) {
			return this.normalize().multiplyScalar(t)
		},
		lerp: function (t, e) {
			this.x += (t.x - this.x) * e;
			this.y += (t.y - this.y) * e;
			this.z += (t.z - this.z) * e;
			this.w += (t.w - this.w) * e;
			return this
		},
		lerpVectors: function (t, e, i) {
			return this.subVectors(e, t).multiplyScalar(i).add(t)
		},
		equals: function (t) {
			return t.x === this.x && t.y === this.y && t.z === this.z && t.w === this.w
		},
		fromArray: function (t, e) {
			void 0 === e && (e = 0);
			this.x = t[e];
			this.y = t[e + 1];
			this.z = t[e + 2];
			this.w = t[e + 3];
			return this
		},
		toArray: function (t, e) {
			void 0 === t && (t = []);
			void 0 === e && (e = 0);
			t[e] = this.x;
			t[e + 1] = this.y;
			t[e + 2] = this.z;
			t[e + 3] = this.w;
			return t
		},
		fromBufferAttribute: function (t, e, i) {
			void 0 !== i && console.warn("THREE.Vector4: offset has been removed from .fromBufferAttribute().");
			this.x = t.getX(e);
			this.y = t.getY(e);
			this.z = t.getZ(e);
			this.w = t.getW(e);
			return this
		}
	});
	A.prototype = Object.assign(Object.create(e.prototype), {
		constructor: A,
		isWebGLRenderTarget: !0,
		setSize: function (t, e) {
			if (this.width !== t || this.height !== e) this.width = t, this.height = e, this.dispose();
			this.viewport.set(0, 0, t, e);
			this.scissor.set(0, 0, t, e)
		},
		clone: function () {
			return (new this.constructor).copy(this)
		},
		copy: function (t) {
			this.width = t.width;
			this.height = t.height;
			this.viewport.copy(t.viewport);
			this.texture = t.texture.clone();
			this.depthBuffer = t.depthBuffer;
			this.stencilBuffer = t.stencilBuffer;
			this.depthTexture = t.depthTexture;
			return this
		},
		dispose: function () {
			this.dispatchEvent({
				type: "dispose"
			})
		}
	});
	n.prototype = Object.create(A.prototype);
	n.prototype.constructor = n;
	n.prototype.isWebGLRenderTargetCube = !0;
	wt.prototype = Object.create(d.prototype);
	wt.prototype.constructor = wt;
	wt.prototype.isDataTexture = !0;
	Object.assign(i.prototype, {
		isBox3: !0,
		set: function (t, e) {
			this.min.copy(t);
			this.max.copy(e);
			return this
		},
		setFromArray: function (t) {
			for (var e = Infinity, i = Infinity, n = Infinity, r = -Infinity, o = -Infinity, a = -Infinity, s = 0, l = t.length; s < l; s += 3) {
				var c = t[s],
					u = t[s + 1],
					h = t[s + 2];
				c < e && (e = c);
				u < i && (i = u);
				h < n && (n = h);
				c > r && (r = c);
				u > o && (o = u);
				h > a && (a = h)
			}
			this.min.set(e, i, n);
			this.max.set(r, o, a);
			return this
		},
		setFromBufferAttribute: function (t) {
			for (var e = Infinity, i = Infinity, n = Infinity, r = -Infinity, o = -Infinity, a = -Infinity, s = 0, l = t.count; s < l; s++) {
				var c = t.getX(s),
					u = t.getY(s),
					h = t.getZ(s);
				c < e && (e = c);
				u < i && (i = u);
				h < n && (n = h);
				c > r && (r = c);
				u > o && (o = u);
				h > a && (a = h)
			}
			this.min.set(e, i, n);
			this.max.set(r, o, a);
			return this
		},
		setFromPoints: function (t) {
			this.makeEmpty();
			for (var e = 0, i = t.length; e < i; e++) this.expandByPoint(t[e]);
			return this
		},
		setFromCenterAndSize: function () {
			var i = new _t;
			return function (t, e) {
				e = i.copy(e).multiplyScalar(.5);
				this.min.copy(t).sub(e);
				this.max.copy(t).add(e);
				return this
			}
		}(),
		setFromObject: function (t) {
			this.makeEmpty();
			return this.expandByObject(t)
		},
		clone: function () {
			return (new this.constructor).copy(this)
		},
		copy: function (t) {
			this.min.copy(t.min);
			this.max.copy(t.max);
			return this
		},
		makeEmpty: function () {
			this.min.x = this.min.y = this.min.z = Infinity;
			this.max.x = this.max.y = this.max.z = -Infinity;
			return this
		},
		isEmpty: function () {
			return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z
		},
		getCenter: function (t) {
			void 0 === t && (console.warn("THREE.Box3: .getCenter() target is now required"), t = new _t);
			return this.isEmpty() ? t.set(0, 0, 0) : t.addVectors(this.min, this.max).multiplyScalar(.5)
		},
		getSize: function (t) {
			void 0 === t && (console.warn("THREE.Box3: .getSize() target is now required"), t = new _t);
			return this.isEmpty() ? t.set(0, 0, 0) : t.subVectors(this.max, this.min)
		},
		expandByPoint: function (t) {
			this.min.min(t);
			this.max.max(t);
			return this
		},
		expandByVector: function (t) {
			this.min.sub(t);
			this.max.add(t);
			return this
		},
		expandByScalar: function (t) {
			this.min.addScalar(-t);
			this.max.addScalar(t);
			return this
		},
		expandByObject: function () {
			function e(t) {
				var e = t.geometry;
				if (void 0 !== e)
					if (e.isGeometry)
						for (e = e.vertices, n = 0, r = e.length; n < r; n++) o.copy(e[n]), o.applyMatrix4(t.matrixWorld), i.expandByPoint(o);
					else if (e.isBufferGeometry && (e = e.attributes.position, void 0 !== e))
					for (n = 0, r = e.count; n < r; n++) o.fromBufferAttribute(e, n).applyMatrix4(t.matrixWorld), i.expandByPoint(o)
			}
			var i, n, r, o = new _t;
			return function (t) {
				i = this;
				t.updateMatrixWorld(!0);
				t.traverse(e);
				return this
			}
		}(),
		containsPoint: function (t) {
			return t.x < this.min.x || t.x > this.max.x || t.y < this.min.y || t.y > this.max.y || t.z < this.min.z || t.z > this.max.z ? !1 : !0
		},
		containsBox: function (t) {
			return this.min.x <= t.min.x && t.max.x <= this.max.x && this.min.y <= t.min.y && t.max.y <= this.max.y && this.min.z <= t.min.z && t.max.z <= this.max.z
		},
		getParameter: function (t, e) {
			void 0 === e && (console.warn("THREE.Box3: .getParameter() target is now required"), e = new _t);
			return e.set((t.x - this.min.x) / (this.max.x - this.min.x), (t.y - this.min.y) / (this.max.y - this.min.y), (t.z - this.min.z) / (this.max.z - this.min.z))
		},
		intersectsBox: function (t) {
			return t.max.x < this.min.x || t.min.x > this.max.x || t.max.y < this.min.y || t.min.y > this.max.y || t.max.z < this.min.z || t.min.z > this.max.z ? !1 : !0
		},
		intersectsSphere: function () {
			var e = new _t;
			return function (t) {
				this.clampPoint(t.center, e);
				return e.distanceToSquared(t.center) <= t.radius * t.radius
			}
		}(),
		intersectsPlane: function (t) {
			if (0 < t.normal.x) {
				var e = t.normal.x * this.min.x;
				var i = t.normal.x * this.max.x
			} else e = t.normal.x * this.max.x, i = t.normal.x * this.min.x;
			0 < t.normal.y ? (e += t.normal.y * this.min.y, i += t.normal.y * this.max.y) : (e += t.normal.y * this.max.y, i += t.normal.y * this.min.y);
			0 < t.normal.z ? (e += t.normal.z * this.min.z, i += t.normal.z * this.max.z) : (e += t.normal.z * this.max.z, i += t.normal.z * this.min.z);
			return e <= t.constant && i >= t.constant
		},
		intersectsTriangle: function () {
			function e(t) {
				var e;
				var i = 0;
				for (e = t.length - 3; i <= e; i += 3) {
					u.fromArray(t, i);
					var n = h.x * Math.abs(u.x) + h.y * Math.abs(u.y) + h.z * Math.abs(u.z),
						r = s.dot(u),
						o = l.dot(u),
						a = c.dot(u);
					if (Math.max(-Math.max(r, o, a), Math.min(r, o, a)) > n) return !1
				}
				return !0
			}
			var s = new _t,
				l = new _t,
				c = new _t,
				i = new _t,
				n = new _t,
				r = new _t,
				u = new _t,
				o = new _t,
				h = new _t,
				a = new _t;
			return function (t) {
				if (this.isEmpty()) return !1;
				this.getCenter(o);
				h.subVectors(this.max, o);
				s.subVectors(t.a, o);
				l.subVectors(t.b, o);
				c.subVectors(t.c, o);
				i.subVectors(l, s);
				n.subVectors(c, l);
				r.subVectors(s, c);
				t = [0, -i.z, i.y, 0, -n.z, n.y, 0, -r.z, r.y, i.z, 0, -i.x, n.z, 0, -n.x, r.z, 0, -r.x, -i.y, i.x, 0, -n.y, n.x, 0, -r.y, r.x, 0];
				if (!e(t)) return !1;
				t = [1, 0, 0, 0, 1, 0, 0, 0, 1];
				if (!e(t)) return !1;
				a.crossVectors(i, n);
				t = [a.x, a.y, a.z];
				return e(t)
			}
		}(),
		clampPoint: function (t, e) {
			void 0 === e && (console.warn("THREE.Box3: .clampPoint() target is now required"), e = new _t);
			return e.copy(t).clamp(this.min, this.max)
		},
		distanceToPoint: function () {
			var e = new _t;
			return function (t) {
				return e.copy(t).clamp(this.min, this.max).sub(t).length()
			}
		}(),
		getBoundingSphere: function () {
			var e = new _t;
			return function (t) {
				void 0 === t && (console.warn("THREE.Box3: .getBoundingSphere() target is now required"), t = new c);
				this.getCenter(t.center);
				t.radius = .5 * this.getSize(e).length();
				return t
			}
		}(),
		intersect: function (t) {
			this.min.max(t.min);
			this.max.min(t.max);
			this.isEmpty() && this.makeEmpty();
			return this
		},
		union: function (t) {
			this.min.min(t.min);
			this.max.max(t.max);
			return this
		},
		applyMatrix4: function (t) {
			if (this.isEmpty()) return this;
			t = t.elements;
			var e = t[0] * this.min.x,
				i = t[1] * this.min.x,
				n = t[2] * this.min.x,
				r = t[0] * this.max.x,
				o = t[1] * this.max.x,
				a = t[2] * this.max.x,
				s = t[4] * this.min.y,
				l = t[5] * this.min.y,
				c = t[6] * this.min.y,
				u = t[4] * this.max.y,
				h = t[5] * this.max.y,
				d = t[6] * this.max.y,
				f = t[8] * this.min.z,
				p = t[9] * this.min.z,
				m = t[10] * this.min.z,
				g = t[8] * this.max.z,
				v = t[9] * this.max.z,
				y = t[10] * this.max.z;
			this.min.x = Math.min(e, r) + Math.min(s, u) + Math.min(f, g) + t[12];
			this.min.y = Math.min(i, o) + Math.min(l, h) + Math.min(p, v) + t[13];
			this.min.z = Math.min(n, a) + Math.min(c, d) + Math.min(m, y) + t[14];
			this.max.x = Math.max(e, r) + Math.max(s, u) + Math.max(f, g) + t[12];
			this.max.y = Math.max(i, o) + Math.max(l, h) + Math.max(p, v) + t[13];
			this.max.z = Math.max(n, a) + Math.max(c, d) + Math.max(m, y) + t[14];
			return this
		},
		translate: function (t) {
			this.min.add(t);
			this.max.add(t);
			return this
		},
		equals: function (t) {
			return t.min.equals(this.min) && t.max.equals(this.max)
		}
	});
	Object.assign(c.prototype, {
		set: function (t, e) {
			this.center.copy(t);
			this.radius = e;
			return this
		},
		setFromPoints: function () {
			var o = new i;
			return function (t, e) {
				var i = this.center;
				void 0 !== e ? i.copy(e) : o.setFromPoints(t).getCenter(i);
				for (var n = e = 0, r = t.length; n < r; n++) e = Math.max(e, i.distanceToSquared(t[n]));
				this.radius = Math.sqrt(e);
				return this
			}
		}(),
		clone: function () {
			return (new this.constructor).copy(this)
		},
		copy: function (t) {
			this.center.copy(t.center);
			this.radius = t.radius;
			return this
		},
		empty: function () {
			return 0 >= this.radius
		},
		containsPoint: function (t) {
			return t.distanceToSquared(this.center) <= this.radius * this.radius
		},
		distanceToPoint: function (t) {
			return t.distanceTo(this.center) - this.radius
		},
		intersectsSphere: function (t) {
			var e = this.radius + t.radius;
			return t.center.distanceToSquared(this.center) <= e * e
		},
		intersectsBox: function (t) {
			return t.intersectsSphere(this)
		},
		intersectsPlane: function (t) {
			return Math.abs(t.distanceToPoint(this.center)) <= this.radius
		},
		clampPoint: function (t, e) {
			var i = this.center.distanceToSquared(t);
			void 0 === e && (console.warn("THREE.Sphere: .clampPoint() target is now required"), e = new _t);
			e.copy(t);
			i > this.radius * this.radius && (e.sub(this.center).normalize(), e.multiplyScalar(this.radius).add(this.center));
			return e
		},
		getBoundingBox: function (t) {
			void 0 === t && (console.warn("THREE.Sphere: .getBoundingBox() target is now required"), t = new i);
			t.set(this.center, this.center);
			t.expandByScalar(this.radius);
			return t
		},
		applyMatrix4: function (t) {
			this.center.applyMatrix4(t);
			this.radius *= t.getMaxScaleOnAxis();
			return this
		},
		translate: function (t) {
			this.center.add(t);
			return this
		},
		equals: function (t) {
			return t.center.equals(this.center) && t.radius === this.radius
		}
	});
	Object.assign(v.prototype, {
		set: function (t, e) {
			this.normal.copy(t);
			this.constant = e;
			return this
		},
		setComponents: function (t, e, i, n) {
			this.normal.set(t, e, i);
			this.constant = n;
			return this
		},
		setFromNormalAndCoplanarPoint: function (t, e) {
			this.normal.copy(t);
			this.constant = -e.dot(this.normal);
			return this
		},
		setFromCoplanarPoints: function () {
			var n = new _t,
				r = new _t;
			return function (t, e, i) {
				e = n.subVectors(i, e).cross(r.subVectors(t, e)).normalize();
				this.setFromNormalAndCoplanarPoint(e, t);
				return this
			}
		}(),
		clone: function () {
			return (new this.constructor).copy(this)
		},
		copy: function (t) {
			this.normal.copy(t.normal);
			this.constant = t.constant;
			return this
		},
		normalize: function () {
			var t = 1 / this.normal.length();
			this.normal.multiplyScalar(t);
			this.constant *= t;
			return this
		},
		negate: function () {
			this.constant *= -1;
			this.normal.negate();
			return this
		},
		distanceToPoint: function (t) {
			return this.normal.dot(t) + this.constant
		},
		distanceToSphere: function (t) {
			return this.distanceToPoint(t.center) - t.radius
		},
		projectPoint: function (t, e) {
			void 0 === e && (console.warn("THREE.Plane: .projectPoint() target is now required"), e = new _t);
			return e.copy(this.normal).multiplyScalar(-this.distanceToPoint(t)).add(t)
		},
		intersectLine: function () {
			var r = new _t;
			return function (t, e) {
				void 0 === e && (console.warn("THREE.Plane: .intersectLine() target is now required"), e = new _t);
				var i = t.delta(r),
					n = this.normal.dot(i);
				if (0 === n) {
					if (0 === this.distanceToPoint(t.start)) return e.copy(t.start)
				} else if (n = -(t.start.dot(this.normal) + this.constant) / n, !(0 > n || 1 < n)) return e.copy(i).multiplyScalar(n).add(t.start)
			}
		}(),
		intersectsLine: function (t) {
			var e = this.distanceToPoint(t.start);
			t = this.distanceToPoint(t.end);
			return 0 > e && 0 < t || 0 > t && 0 < e
		},
		intersectsBox: function (t) {
			return t.intersectsPlane(this)
		},
		intersectsSphere: function (t) {
			return t.intersectsPlane(this)
		},
		coplanarPoint: function (t) {
			void 0 === t && (console.warn("THREE.Plane: .coplanarPoint() target is now required"), t = new _t);
			return t.copy(this.normal).multiplyScalar(-this.constant)
		},
		applyMatrix4: function () {
			var i = new _t,
				n = new g;
			return function (t, e) {
				e = e || n.getNormalMatrix(t);
				t = this.coplanarPoint(i).applyMatrix4(t);
				e = this.normal.applyMatrix3(e).normalize();
				this.constant = -t.dot(e);
				return this
			}
		}(),
		translate: function (t) {
			this.constant -= t.dot(this.normal);
			return this
		},
		equals: function (t) {
			return t.normal.equals(this.normal) && t.constant === this.constant
		}
	});
	Object.assign(Tt.prototype, {
		set: function (t, e, i, n, r, o) {
			var a = this.planes;
			a[0].copy(t);
			a[1].copy(e);
			a[2].copy(i);
			a[3].copy(n);
			a[4].copy(r);
			a[5].copy(o);
			return this
		},
		clone: function () {
			return (new this.constructor).copy(this)
		},
		copy: function (t) {
			for (var e = this.planes, i = 0; 6 > i; i++) e[i].copy(t.planes[i]);
			return this
		},
		setFromMatrix: function (t) {
			var e = this.planes,
				i = t.elements;
			t = i[0];
			var n = i[1],
				r = i[2],
				o = i[3],
				a = i[4],
				s = i[5],
				l = i[6],
				c = i[7],
				u = i[8],
				h = i[9],
				d = i[10],
				f = i[11],
				p = i[12],
				m = i[13],
				g = i[14];
			i = i[15];
			e[0].setComponents(o - t, c - a, f - u, i - p).normalize();
			e[1].setComponents(o + t, c + a, f + u, i + p).normalize();
			e[2].setComponents(o + n, c + s, f + h, i + m).normalize();
			e[3].setComponents(o - n, c - s, f - h, i - m).normalize();
			e[4].setComponents(o - r, c - l, f - d, i - g).normalize();
			e[5].setComponents(o + r, c + l, f + d, i + g).normalize();
			return this
		},
		intersectsObject: function () {
			var i = new c;
			return function (t) {
				var e = t.geometry;
				null === e.boundingSphere && e.computeBoundingSphere();
				i.copy(e.boundingSphere).applyMatrix4(t.matrixWorld);
				return this.intersectsSphere(i)
			}
		}(),
		intersectsSprite: function () {
			var e = new c;
			return function (t) {
				e.center.set(0, 0, 0);
				e.radius = .7071067811865476;
				e.applyMatrix4(t.matrixWorld);
				return this.intersectsSphere(e)
			}
		}(),
		intersectsSphere: function (t) {
			var e = this.planes,
				i = t.center;
			t = -t.radius;
			for (var n = 0; 6 > n; n++)
				if (e[n].distanceToPoint(i) < t) return !1;
			return !0
		},
		intersectsBox: function () {
			var o = new _t,
				a = new _t;
			return function (t) {
				for (var e = this.planes, i = 0; 6 > i; i++) {
					var n = e[i];
					o.x = 0 < n.normal.x ? t.min.x : t.max.x;
					a.x = 0 < n.normal.x ? t.max.x : t.min.x;
					o.y = 0 < n.normal.y ? t.min.y : t.max.y;
					a.y = 0 < n.normal.y ? t.max.y : t.min.y;
					o.z = 0 < n.normal.z ? t.min.z : t.max.z;
					a.z = 0 < n.normal.z ? t.max.z : t.min.z;
					var r = n.distanceToPoint(o);
					n = n.distanceToPoint(a);
					if (0 > r && 0 > n) return !1
				}
				return !0
			}
		}(),
		containsPoint: function (t) {
			for (var e = this.planes, i = 0; 6 > i; i++)
				if (0 > e[i].distanceToPoint(t)) return !1;
			return !0
		}
	});
	var eo = {
			alphamap_fragment: "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif\n",
			alphamap_pars_fragment: "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif\n",
			alphatest_fragment: "#ifdef ALPHATEST\n\tif ( diffuseColor.a < ALPHATEST ) discard;\n#endif\n",
			aomap_fragment: "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_ENVMAP ) && defined( PHYSICAL )\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.specularRoughness );\n\t#endif\n#endif\n",
			aomap_pars_fragment: "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif",
			begin_vertex: "\nvec3 transformed = vec3( position );\n",
			beginnormal_vertex: "\nvec3 objectNormal = vec3( normal );\n",
			bsdfs: "float punctualLightIntensityToIrradianceFactor( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\tif( decayExponent > 0.0 ) {\n#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n\t\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\t\tfloat maxDistanceCutoffFactor = pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t\treturn distanceFalloff * maxDistanceCutoffFactor;\n#else\n\t\treturn pow( saturate( -lightDistance / cutoffDistance + 1.0 ), decayExponent );\n#endif\n\t}\n\treturn 1.0;\n}\nvec3 BRDF_Diffuse_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 specularColor, const in float dotLH ) {\n\tfloat fresnel = exp2( ( -5.55473 * dotLH - 6.98316 ) * dotLH );\n\treturn ( 1.0 - specularColor ) * fresnel + specularColor;\n}\nfloat G_GGX_Smith( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gl = dotNL + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\tfloat gv = dotNV + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\treturn 1.0 / ( gl * gv );\n}\nfloat G_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_Specular_GGX( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float roughness ) {\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n\tfloat dotNL = saturate( dot( geometry.normal, incidentLight.direction ) );\n\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\tfloat dotNH = saturate( dot( geometry.normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\tfloat D = D_GGX( alpha, dotNH );\n\treturn F * ( G * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE  = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS  = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\nvec3 BRDF_Specular_GGX_Environment( const in GeometricContext geometry, const in vec3 specularColor, const in float roughness ) {\n\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 AB = vec2( -1.04, 1.04 ) * a004 + r.zw;\n\treturn specularColor * AB.x + AB.y;\n}\nfloat G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_Specular_BlinnPhong( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n\tfloat dotNH = saturate( dot( geometry.normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n}\nfloat GGXRoughnessToBlinnExponent( const in float ggxRoughness ) {\n\treturn ( 2.0 / pow2( ggxRoughness + 0.0001 ) - 2.0 );\n}\nfloat BlinnExponentToGGXRoughness( const in float blinnExponent ) {\n\treturn sqrt( 2.0 / ( blinnExponent + 2.0 ) );\n}\n",
			bumpmap_pars_fragment: "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vUv );\n\t\tvec2 dSTdy = dFdy( vUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy ) {\n\t\tvec3 vSigmaX = vec3( dFdx( surf_pos.x ), dFdx( surf_pos.y ), dFdx( surf_pos.z ) );\n\t\tvec3 vSigmaY = vec3( dFdy( surf_pos.x ), dFdy( surf_pos.y ), dFdy( surf_pos.z ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 );\n\t\tfDet *= ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif\n",
			clipping_planes_fragment: "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#pragma unroll_loop\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\tplane = clippingPlanes[ i ];\n\t\tif ( dot( vViewPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\t#pragma unroll_loop\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vViewPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\tif ( clipped ) discard;\n\t#endif\n#endif\n",
			clipping_planes_pars_fragment: "#if NUM_CLIPPING_PLANES > 0\n\t#if ! defined( PHYSICAL ) && ! defined( PHONG )\n\t\tvarying vec3 vViewPosition;\n\t#endif\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif\n",
			clipping_planes_pars_vertex: "#if NUM_CLIPPING_PLANES > 0 && ! defined( PHYSICAL ) && ! defined( PHONG )\n\tvarying vec3 vViewPosition;\n#endif\n",
			clipping_planes_vertex: "#if NUM_CLIPPING_PLANES > 0 && ! defined( PHYSICAL ) && ! defined( PHONG )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n",
			color_fragment: "#ifdef USE_COLOR\n\tdiffuseColor.rgb *= vColor;\n#endif",
			color_pars_fragment: "#ifdef USE_COLOR\n\tvarying vec3 vColor;\n#endif\n",
			color_pars_vertex: "#ifdef USE_COLOR\n\tvarying vec3 vColor;\n#endif",
			color_vertex: "#ifdef USE_COLOR\n\tvColor.xyz = color.xyz;\n#endif",
			common: "#define PI 3.14159265359\n#define PI2 6.28318530718\n#define PI_HALF 1.5707963267949\n#define RECIPROCAL_PI 0.31830988618\n#define RECIPROCAL_PI2 0.15915494\n#define LOG2 1.442695\n#define EPSILON 1e-6\n#define saturate(a) clamp( a, 0.0, 1.0 )\n#define whiteCompliment(a) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat average( const in vec3 color ) { return dot( color, vec3( 0.3333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract(sin(sn) * c);\n}\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\nstruct GeometricContext {\n\tvec3 position;\n\tvec3 normal;\n\tvec3 viewDir;\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nvec3 projectOnPlane(in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\tfloat distance = dot( planeNormal, point - pointOnPlane );\n\treturn - distance * planeNormal + point;\n}\nfloat sideOfPlane( in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn sign( dot( point - pointOnPlane, planeNormal ) );\n}\nvec3 linePlaneIntersect( in vec3 pointOnLine, in vec3 lineDirection, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn lineDirection * ( dot( planeNormal, pointOnPlane - pointOnLine ) / dot( planeNormal, lineDirection ) ) + pointOnLine;\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nfloat linearToRelativeLuminance( const in vec3 color ) {\n\tvec3 weights = vec3( 0.2126, 0.7152, 0.0722 );\n\treturn dot( weights, color.rgb );\n}\n",
			cube_uv_reflection_fragment: "#ifdef ENVMAP_TYPE_CUBE_UV\n#define cubeUV_textureSize (1024.0)\nint getFaceFromDirection(vec3 direction) {\n\tvec3 absDirection = abs(direction);\n\tint face = -1;\n\tif( absDirection.x > absDirection.z ) {\n\t\tif(absDirection.x > absDirection.y )\n\t\t\tface = direction.x > 0.0 ? 0 : 3;\n\t\telse\n\t\t\tface = direction.y > 0.0 ? 1 : 4;\n\t}\n\telse {\n\t\tif(absDirection.z > absDirection.y )\n\t\t\tface = direction.z > 0.0 ? 2 : 5;\n\t\telse\n\t\t\tface = direction.y > 0.0 ? 1 : 4;\n\t}\n\treturn face;\n}\n#define cubeUV_maxLods1  (log2(cubeUV_textureSize*0.25) - 1.0)\n#define cubeUV_rangeClamp (exp2((6.0 - 1.0) * 2.0))\nvec2 MipLevelInfo( vec3 vec, float roughnessLevel, float roughness ) {\n\tfloat scale = exp2(cubeUV_maxLods1 - roughnessLevel);\n\tfloat dxRoughness = dFdx(roughness);\n\tfloat dyRoughness = dFdy(roughness);\n\tvec3 dx = dFdx( vec * scale * dxRoughness );\n\tvec3 dy = dFdy( vec * scale * dyRoughness );\n\tfloat d = max( dot( dx, dx ), dot( dy, dy ) );\n\td = clamp(d, 1.0, cubeUV_rangeClamp);\n\tfloat mipLevel = 0.5 * log2(d);\n\treturn vec2(floor(mipLevel), fract(mipLevel));\n}\n#define cubeUV_maxLods2 (log2(cubeUV_textureSize*0.25) - 2.0)\n#define cubeUV_rcpTextureSize (1.0 / cubeUV_textureSize)\nvec2 getCubeUV(vec3 direction, float roughnessLevel, float mipLevel) {\n\tmipLevel = roughnessLevel > cubeUV_maxLods2 - 3.0 ? 0.0 : mipLevel;\n\tfloat a = 16.0 * cubeUV_rcpTextureSize;\n\tvec2 exp2_packed = exp2( vec2( roughnessLevel, mipLevel ) );\n\tvec2 rcp_exp2_packed = vec2( 1.0 ) / exp2_packed;\n\tfloat powScale = exp2_packed.x * exp2_packed.y;\n\tfloat scale = rcp_exp2_packed.x * rcp_exp2_packed.y * 0.25;\n\tfloat mipOffset = 0.75*(1.0 - rcp_exp2_packed.y) * rcp_exp2_packed.x;\n\tbool bRes = mipLevel == 0.0;\n\tscale =  bRes && (scale < a) ? a : scale;\n\tvec3 r;\n\tvec2 offset;\n\tint face = getFaceFromDirection(direction);\n\tfloat rcpPowScale = 1.0 / powScale;\n\tif( face == 0) {\n\t\tr = vec3(direction.x, -direction.z, direction.y);\n\t\toffset = vec2(0.0+mipOffset,0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? a : offset.y;\n\t}\n\telse if( face == 1) {\n\t\tr = vec3(direction.y, direction.x, direction.z);\n\t\toffset = vec2(scale+mipOffset, 0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? a : offset.y;\n\t}\n\telse if( face == 2) {\n\t\tr = vec3(direction.z, direction.x, direction.y);\n\t\toffset = vec2(2.0*scale+mipOffset, 0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? a : offset.y;\n\t}\n\telse if( face == 3) {\n\t\tr = vec3(direction.x, direction.z, direction.y);\n\t\toffset = vec2(0.0+mipOffset,0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? 0.0 : offset.y;\n\t}\n\telse if( face == 4) {\n\t\tr = vec3(direction.y, direction.x, -direction.z);\n\t\toffset = vec2(scale+mipOffset, 0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? 0.0 : offset.y;\n\t}\n\telse {\n\t\tr = vec3(direction.z, -direction.x, direction.y);\n\t\toffset = vec2(2.0*scale+mipOffset, 0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? 0.0 : offset.y;\n\t}\n\tr = normalize(r);\n\tfloat texelOffset = 0.5 * cubeUV_rcpTextureSize;\n\tvec2 s = ( r.yz / abs( r.x ) + vec2( 1.0 ) ) * 0.5;\n\tvec2 base = offset + vec2( texelOffset );\n\treturn base + s * ( scale - 2.0 * texelOffset );\n}\n#define cubeUV_maxLods3 (log2(cubeUV_textureSize*0.25) - 3.0)\nvec4 textureCubeUV(vec3 reflectedDirection, float roughness ) {\n\tfloat roughnessVal = roughness* cubeUV_maxLods3;\n\tfloat r1 = floor(roughnessVal);\n\tfloat r2 = r1 + 1.0;\n\tfloat t = fract(roughnessVal);\n\tvec2 mipInfo = MipLevelInfo(reflectedDirection, r1, roughness);\n\tfloat s = mipInfo.y;\n\tfloat level0 = mipInfo.x;\n\tfloat level1 = level0 + 1.0;\n\tlevel1 = level1 > 5.0 ? 5.0 : level1;\n\tlevel0 += min( floor( s + 0.5 ), 5.0 );\n\tvec2 uv_10 = getCubeUV(reflectedDirection, r1, level0);\n\tvec4 color10 = envMapTexelToLinear(texture2D(envMap, uv_10));\n\tvec2 uv_20 = getCubeUV(reflectedDirection, r2, level0);\n\tvec4 color20 = envMapTexelToLinear(texture2D(envMap, uv_20));\n\tvec4 result = mix(color10, color20, t);\n\treturn vec4(result.rgb, 1.0);\n}\n#endif\n",
			defaultnormal_vertex: "vec3 transformedNormal = normalMatrix * objectNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n",
			displacementmap_pars_vertex: "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif\n",
			displacementmap_vertex: "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, uv ).x * displacementScale + displacementBias );\n#endif\n",
			emissivemap_fragment: "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vUv );\n\temissiveColor.rgb = emissiveMapTexelToLinear( emissiveColor ).rgb;\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif\n",
			emissivemap_pars_fragment: "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif\n",
			encodings_fragment: "  gl_FragColor = linearToOutputTexel( gl_FragColor );\n",
			encodings_pars_fragment: "\nvec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 GammaToLinear( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.xyz, vec3( gammaFactor ) ), value.w );\n}\nvec4 LinearToGamma( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.xyz, vec3( 1.0 / gammaFactor ) ), value.w );\n}\nvec4 sRGBToLinear( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.w );\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.w );\n}\nvec4 RGBEToLinear( in vec4 value ) {\n\treturn vec4( value.rgb * exp2( value.a * 255.0 - 128.0 ), 1.0 );\n}\nvec4 LinearToRGBE( in vec4 value ) {\n\tfloat maxComponent = max( max( value.r, value.g ), value.b );\n\tfloat fExp = clamp( ceil( log2( maxComponent ) ), -128.0, 127.0 );\n\treturn vec4( value.rgb / exp2( fExp ), ( fExp + 128.0 ) / 255.0 );\n}\nvec4 RGBMToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.xyz * value.w * maxRange, 1.0 );\n}\nvec4 LinearToRGBM( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.x, max( value.g, value.b ) );\n\tfloat M      = clamp( maxRGB / maxRange, 0.0, 1.0 );\n\tM            = ceil( M * 255.0 ) / 255.0;\n\treturn vec4( value.rgb / ( M * maxRange ), M );\n}\nvec4 RGBDToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.rgb * ( ( maxRange / 255.0 ) / value.a ), 1.0 );\n}\nvec4 LinearToRGBD( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.x, max( value.g, value.b ) );\n\tfloat D      = max( maxRange / maxRGB, 1.0 );\n\tD            = min( floor( D ) / 255.0, 1.0 );\n\treturn vec4( value.rgb * ( D * ( 255.0 / maxRange ) ), D );\n}\nconst mat3 cLogLuvM = mat3( 0.2209, 0.3390, 0.4184, 0.1138, 0.6780, 0.7319, 0.0102, 0.1130, 0.2969 );\nvec4 LinearToLogLuv( in vec4 value )  {\n\tvec3 Xp_Y_XYZp = value.rgb * cLogLuvM;\n\tXp_Y_XYZp = max(Xp_Y_XYZp, vec3(1e-6, 1e-6, 1e-6));\n\tvec4 vResult;\n\tvResult.xy = Xp_Y_XYZp.xy / Xp_Y_XYZp.z;\n\tfloat Le = 2.0 * log2(Xp_Y_XYZp.y) + 127.0;\n\tvResult.w = fract(Le);\n\tvResult.z = (Le - (floor(vResult.w*255.0))/255.0)/255.0;\n\treturn vResult;\n}\nconst mat3 cLogLuvInverseM = mat3( 6.0014, -2.7008, -1.7996, -1.3320, 3.1029, -5.7721, 0.3008, -1.0882, 5.6268 );\nvec4 LogLuvToLinear( in vec4 value ) {\n\tfloat Le = value.z * 255.0 + value.w;\n\tvec3 Xp_Y_XYZp;\n\tXp_Y_XYZp.y = exp2((Le - 127.0) / 2.0);\n\tXp_Y_XYZp.z = Xp_Y_XYZp.y / value.y;\n\tXp_Y_XYZp.x = value.x * Xp_Y_XYZp.z;\n\tvec3 vRGB = Xp_Y_XYZp.rgb * cLogLuvInverseM;\n\treturn vec4( max(vRGB, 0.0), 1.0 );\n}\n",
			envmap_fragment: "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvec3 cameraToVertex = normalize( vWorldPosition - cameraPosition );\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#elif defined( ENVMAP_TYPE_EQUIREC )\n\t\tvec2 sampleUV;\n\t\treflectVec = normalize( reflectVec );\n\t\tsampleUV.y = asin( clamp( reflectVec.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\t\tsampleUV.x = atan( reflectVec.z, reflectVec.x ) * RECIPROCAL_PI2 + 0.5;\n\t\tvec4 envColor = texture2D( envMap, sampleUV );\n\t#elif defined( ENVMAP_TYPE_SPHERE )\n\t\treflectVec = normalize( reflectVec );\n\t\tvec3 reflectView = normalize( ( viewMatrix * vec4( reflectVec, 0.0 ) ).xyz + vec3( 0.0, 0.0, 1.0 ) );\n\t\tvec4 envColor = texture2D( envMap, reflectView.xy * 0.5 + 0.5 );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\tenvColor = envMapTexelToLinear( envColor );\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif\n",
			envmap_pars_fragment: "#if defined( USE_ENVMAP ) || defined( PHYSICAL )\n\tuniform float reflectivity;\n\tuniform float envMapIntensity;\n#endif\n#ifdef USE_ENVMAP\n\t#if ! defined( PHYSICAL ) && ( defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) )\n\t\tvarying vec3 vWorldPosition;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\tuniform float flipEnvMap;\n\tuniform int maxMipLevel;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( PHYSICAL )\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif\n",
			envmap_pars_vertex: "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif\n",
			envmap_vertex: "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif\n",
			fog_vertex: "\n#ifdef USE_FOG\nfogDepth = -mvPosition.z;\n#endif",
			fog_pars_vertex: "#ifdef USE_FOG\n  varying float fogDepth;\n#endif\n",
			fog_fragment: "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = whiteCompliment( exp2( - fogDensity * fogDensity * fogDepth * fogDepth * LOG2 ) );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, fogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif\n",
			fog_pars_fragment: "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float fogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif\n",
			gradientmap_pars_fragment: "#ifdef TOON\n\tuniform sampler2D gradientMap;\n\tvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\t\tfloat dotNL = dot( normal, lightDirection );\n\t\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t\t#ifdef USE_GRADIENTMAP\n\t\t\treturn texture2D( gradientMap, coord ).rgb;\n\t\t#else\n\t\t\treturn ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );\n\t\t#endif\n\t}\n#endif\n",
			lightmap_fragment: "#ifdef USE_LIGHTMAP\n\treflectedLight.indirectDiffuse += PI * texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n#endif\n",
			lightmap_pars_fragment: "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif",
			lights_lambert_vertex: "vec3 diffuse = vec3( 1.0 );\nGeometricContext geometry;\ngeometry.position = mvPosition.xyz;\ngeometry.normal = normalize( transformedNormal );\ngeometry.viewDir = normalize( -mvPosition.xyz );\nGeometricContext backGeometry;\nbackGeometry.position = geometry.position;\nbackGeometry.normal = -geometry.normal;\nbackGeometry.viewDir = geometry.viewDir;\nvLightFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\n\tvLightBack = vec3( 0.0 );\n#endif\nIncidentLight directLight;\nfloat dotNL;\nvec3 directLightColor_Diffuse;\n#if NUM_POINT_LIGHTS > 0\n\t#pragma unroll_loop\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tgetPointDirectLightIrradiance( pointLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\t#pragma unroll_loop\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tgetSpotDirectLightIrradiance( spotLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_DIR_LIGHTS > 0\n\t#pragma unroll_loop\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tgetDirectionalDirectLightIrradiance( directionalLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\t#pragma unroll_loop\n\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\tvLightFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry );\n\t\t#endif\n\t}\n#endif\n",
			lights_pars_begin: "uniform vec3 ambientLightColor;\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treturn irradiance;\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalDirectLightIrradiance( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tdirectLight.color = directionalLight.color;\n\t\tdirectLight.direction = directionalLight.direction;\n\t\tdirectLight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t\tfloat shadowCameraNear;\n\t\tfloat shadowCameraFar;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointDirectLightIrradiance( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tvec3 lVector = pointLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tdirectLight.color = pointLight.color;\n\t\tdirectLight.color *= punctualLightIntensityToIrradianceFactor( lightDistance, pointLight.distance, pointLight.decay );\n\t\tdirectLight.visible = ( directLight.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotDirectLightIrradiance( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight directLight  ) {\n\t\tvec3 lVector = spotLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tfloat angleCos = dot( directLight.direction, spotLight.direction );\n\t\tif ( angleCos > spotLight.coneCos ) {\n\t\t\tfloat spotEffect = smoothstep( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\t\tdirectLight.color = spotLight.color;\n\t\t\tdirectLight.color *= spotEffect * punctualLightIntensityToIrradianceFactor( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tdirectLight.visible = true;\n\t\t} else {\n\t\t\tdirectLight.color = vec3( 0.0 );\n\t\t\tdirectLight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in GeometricContext geometry ) {\n\t\tfloat dotNL = dot( geometry.normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tirradiance *= PI;\n\t\t#endif\n\t\treturn irradiance;\n\t}\n#endif\n",
			lights_pars_maps: "#if defined( USE_ENVMAP ) && defined( PHYSICAL )\n\tvec3 getLightProbeIndirectIrradiance( const in GeometricContext geometry, const in int maxMIPLevel ) {\n\t\tvec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryVec = vec3( flipEnvMap * worldNormal.x, worldNormal.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 queryVec = vec3( flipEnvMap * worldNormal.x, worldNormal.yz );\n\t\t\tvec4 envMapColor = textureCubeUV( queryVec, 1.0 );\n\t\t#else\n\t\t\tvec4 envMapColor = vec4( 0.0 );\n\t\t#endif\n\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t}\n\tfloat getSpecularMIPLevel( const in float blinnShininessExponent, const in int maxMIPLevel ) {\n\t\tfloat maxMIPLevelScalar = float( maxMIPLevel );\n\t\tfloat desiredMIPLevel = maxMIPLevelScalar + 0.79248 - 0.5 * log2( pow2( blinnShininessExponent ) + 1.0 );\n\t\treturn clamp( desiredMIPLevel, 0.0, maxMIPLevelScalar );\n\t}\n\tvec3 getLightProbeIndirectRadiance( const in GeometricContext geometry, const in float blinnShininessExponent, const in int maxMIPLevel ) {\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( -geometry.viewDir, geometry.normal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( -geometry.viewDir, geometry.normal, refractionRatio );\n\t\t#endif\n\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\tfloat specularMIPLevel = getSpecularMIPLevel( blinnShininessExponent, maxMIPLevel );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryReflectVec = vec3( flipEnvMap * reflectVec.x, reflectVec.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 queryReflectVec = vec3( flipEnvMap * reflectVec.x, reflectVec.yz );\n\t\t\tvec4 envMapColor = textureCubeUV(queryReflectVec, BlinnExponentToGGXRoughness(blinnShininessExponent));\n\t\t#elif defined( ENVMAP_TYPE_EQUIREC )\n\t\t\tvec2 sampleUV;\n\t\t\tsampleUV.y = asin( clamp( reflectVec.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\t\t\tsampleUV.x = atan( reflectVec.z, reflectVec.x ) * RECIPROCAL_PI2 + 0.5;\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = texture2DLodEXT( envMap, sampleUV, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = texture2D( envMap, sampleUV, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_SPHERE )\n\t\t\tvec3 reflectView = normalize( ( viewMatrix * vec4( reflectVec, 0.0 ) ).xyz + vec3( 0.0,0.0,1.0 ) );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = texture2DLodEXT( envMap, reflectView.xy * 0.5 + 0.5, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = texture2D( envMap, reflectView.xy * 0.5 + 0.5, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#endif\n\t\treturn envMapColor.rgb * envMapIntensity;\n\t}\n#endif\n",
			lights_phong_fragment: "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;\n",
			lights_phong_pars_fragment: "varying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\nstruct BlinnPhongMaterial {\n\tvec3\tdiffuseColor;\n\tvec3\tspecularColor;\n\tfloat\tspecularShininess;\n\tfloat\tspecularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\t#ifdef TOON\n\t\tvec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n\t#else\n\t\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\t\tvec3 irradiance = dotNL * directLight.color;\n\t#endif\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treflectedLight.directDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_Specular_BlinnPhong( directLight, geometry, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )\t(0)\n",
			lights_physical_fragment: "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nmaterial.specularRoughness = clamp( roughnessFactor, 0.04, 1.0 );\n#ifdef STANDARD\n\tmaterial.specularColor = mix( vec3( DEFAULT_SPECULAR_COEFFICIENT ), diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( MAXIMUM_SPECULAR_COEFFICIENT * pow2( reflectivity ) ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.clearCoat = saturate( clearCoat );\tmaterial.clearCoatRoughness = clamp( clearCoatRoughness, 0.04, 1.0 );\n#endif\n",
			lights_physical_pars_fragment: "struct PhysicalMaterial {\n\tvec3\tdiffuseColor;\n\tfloat\tspecularRoughness;\n\tvec3\tspecularColor;\n\t#ifndef STANDARD\n\t\tfloat clearCoat;\n\t\tfloat clearCoatRoughness;\n\t#endif\n};\n#define MAXIMUM_SPECULAR_COEFFICIENT 0.16\n#define DEFAULT_SPECULAR_COEFFICIENT 0.04\nfloat clearCoatDHRApprox( const in float roughness, const in float dotNL ) {\n\treturn DEFAULT_SPECULAR_COEFFICIENT + ( 1.0 - DEFAULT_SPECULAR_COEFFICIENT ) * ( pow( 1.0 - dotNL, 5.0 ) * pow( 1.0 - roughness, 2.0 ) );\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometry.normal;\n\t\tvec3 viewDir = geometry.viewDir;\n\t\tvec3 position = geometry.position;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.specularRoughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos - halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos + halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos + halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos - halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\t#ifndef STANDARD\n\t\tfloat clearCoatDHR = material.clearCoat * clearCoatDHRApprox( material.clearCoatRoughness, dotNL );\n\t#else\n\t\tfloat clearCoatDHR = 0.0;\n\t#endif\n\treflectedLight.directSpecular += ( 1.0 - clearCoatDHR ) * irradiance * BRDF_Specular_GGX( directLight, geometry, material.specularColor, material.specularRoughness );\n\treflectedLight.directDiffuse += ( 1.0 - clearCoatDHR ) * irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n\t#ifndef STANDARD\n\t\treflectedLight.directSpecular += irradiance * material.clearCoat * BRDF_Specular_GGX( directLight, geometry, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearCoatRoughness );\n\t#endif\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 clearCoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t#ifndef STANDARD\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\tfloat dotNL = dotNV;\n\t\tfloat clearCoatDHR = material.clearCoat * clearCoatDHRApprox( material.clearCoatRoughness, dotNL );\n\t#else\n\t\tfloat clearCoatDHR = 0.0;\n\t#endif\n\treflectedLight.indirectSpecular += ( 1.0 - clearCoatDHR ) * radiance * BRDF_Specular_GGX_Environment( geometry, material.specularColor, material.specularRoughness );\n\t#ifndef STANDARD\n\t\treflectedLight.indirectSpecular += clearCoatRadiance * material.clearCoat * BRDF_Specular_GGX_Environment( geometry, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearCoatRoughness );\n\t#endif\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\n#define Material_BlinnShininessExponent( material )   GGXRoughnessToBlinnExponent( material.specularRoughness )\n#define Material_ClearCoat_BlinnShininessExponent( material )   GGXRoughnessToBlinnExponent( material.clearCoatRoughness )\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}\n",
			lights_fragment_begin: "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = normalize( vViewPosition );\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#pragma unroll_loop\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointDirectLightIrradiance( pointLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( pointLight.shadow, directLight.visible ) ) ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\t#pragma unroll_loop\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotDirectLightIrradiance( spotLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( spotLight.shadow, directLight.visible ) ) ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#pragma unroll_loop\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalDirectLightIrradiance( directionalLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( directionalLight.shadow, directLight.visible ) ) ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t}\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearCoatRadiance = vec3( 0.0 );\n#endif\n",
			lights_fragment_maps: "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec3 lightMapIrradiance = texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tlightMapIrradiance *= PI;\n\t\t#endif\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( PHYSICAL ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tirradiance += getLightProbeIndirectIrradiance( geometry, maxMipLevel );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\tradiance += getLightProbeIndirectRadiance( geometry, Material_BlinnShininessExponent( material ), maxMipLevel );\n\t#ifndef STANDARD\n\t\tclearCoatRadiance += getLightProbeIndirectRadiance( geometry, Material_ClearCoat_BlinnShininessExponent( material ), maxMipLevel );\n\t#endif\n#endif\n",
			lights_fragment_end: "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, clearCoatRadiance, geometry, material, reflectedLight );\n#endif\n",
			logdepthbuf_fragment: "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tgl_FragDepthEXT = log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif",
			logdepthbuf_pars_fragment: "#ifdef USE_LOGDEPTHBUF\n\tuniform float logDepthBufFC;\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t#endif\n#endif\n",
			logdepthbuf_pars_vertex: "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t#endif\n\tuniform float logDepthBufFC;\n#endif",
			logdepthbuf_vertex: "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t#else\n\t\tgl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n\t\tgl_Position.z *= gl_Position.w;\n\t#endif\n#endif\n",
			map_fragment: "#ifdef USE_MAP\n\tvec4 texelColor = texture2D( map, vUv );\n\ttexelColor = mapTexelToLinear( texelColor );\n\tdiffuseColor *= texelColor;\n#endif\n",
			map_pars_fragment: "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n",
			map_particle_fragment: "#ifdef USE_MAP\n\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\tvec4 mapTexel = texture2D( map, uv );\n\tdiffuseColor *= mapTexelToLinear( mapTexel );\n#endif\n",
			map_particle_pars_fragment: "#ifdef USE_MAP\n\tuniform mat3 uvTransform;\n\tuniform sampler2D map;\n#endif\n",
			metalnessmap_fragment: "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif\n",
			metalnessmap_pars_fragment: "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif",
			morphnormal_vertex: "#ifdef USE_MORPHNORMALS\n\tobjectNormal += ( morphNormal0 - normal ) * morphTargetInfluences[ 0 ];\n\tobjectNormal += ( morphNormal1 - normal ) * morphTargetInfluences[ 1 ];\n\tobjectNormal += ( morphNormal2 - normal ) * morphTargetInfluences[ 2 ];\n\tobjectNormal += ( morphNormal3 - normal ) * morphTargetInfluences[ 3 ];\n#endif\n",
			morphtarget_pars_vertex: "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_MORPHNORMALS\n\tuniform float morphTargetInfluences[ 8 ];\n\t#else\n\tuniform float morphTargetInfluences[ 4 ];\n\t#endif\n#endif",
			morphtarget_vertex: "#ifdef USE_MORPHTARGETS\n\ttransformed += ( morphTarget0 - position ) * morphTargetInfluences[ 0 ];\n\ttransformed += ( morphTarget1 - position ) * morphTargetInfluences[ 1 ];\n\ttransformed += ( morphTarget2 - position ) * morphTargetInfluences[ 2 ];\n\ttransformed += ( morphTarget3 - position ) * morphTargetInfluences[ 3 ];\n\t#ifndef USE_MORPHNORMALS\n\ttransformed += ( morphTarget4 - position ) * morphTargetInfluences[ 4 ];\n\ttransformed += ( morphTarget5 - position ) * morphTargetInfluences[ 5 ];\n\ttransformed += ( morphTarget6 - position ) * morphTargetInfluences[ 6 ];\n\ttransformed += ( morphTarget7 - position ) * morphTargetInfluences[ 7 ];\n\t#endif\n#endif\n",
			normal_fragment_begin: "#ifdef FLAT_SHADED\n\tvec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n\tvec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n\t#endif\n#endif\n",
			normal_fragment_maps: "#ifdef USE_NORMALMAP\n\tnormal = perturbNormal2Arb( -vViewPosition, normal );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( -vViewPosition, normal, dHdxy_fwd() );\n#endif\n",
			normalmap_pars_fragment: "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n\tvec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm ) {\n\t\tvec3 q0 = vec3( dFdx( eye_pos.x ), dFdx( eye_pos.y ), dFdx( eye_pos.z ) );\n\t\tvec3 q1 = vec3( dFdy( eye_pos.x ), dFdy( eye_pos.y ), dFdy( eye_pos.z ) );\n\t\tvec2 st0 = dFdx( vUv.st );\n\t\tvec2 st1 = dFdy( vUv.st );\n\t\tfloat scale = sign( st1.t * st0.s - st0.t * st1.s );\n\t\tvec3 S = normalize( ( q0 * st1.t - q1 * st0.t ) * scale );\n\t\tvec3 T = normalize( ( - q0 * st1.s + q1 * st0.s ) * scale );\n\t\tvec3 N = normalize( surf_norm );\n\t\tmat3 tsn = mat3( S, T, N );\n\t\tvec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\t\tmapN.xy *= normalScale;\n\t\tmapN.xy *= ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n\t\treturn normalize( tsn * mapN );\n\t}\n#endif\n",
			packing: "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256.,  256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n\treturn linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn (( near + viewZ ) * far ) / (( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * invClipZ - far );\n}\n",
			premultiplied_alpha_fragment: "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif\n",
			project_vertex: "vec4 mvPosition = modelViewMatrix * vec4( transformed, 1.0 );\ngl_Position = projectionMatrix * mvPosition;\n",
			dithering_fragment: "#if defined( DITHERING )\n  gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif\n",
			dithering_pars_fragment: "#if defined( DITHERING )\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif\n",
			roughnessmap_fragment: "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vUv );\n\troughnessFactor *= texelRoughness.g;\n#endif\n",
			roughnessmap_pars_fragment: "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif",
			shadowmap_pars_fragment: "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHTS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHTS ];\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHTS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHTS ];\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHTS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHTS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tfloat texture2DShadowLerp( sampler2D depths, vec2 size, vec2 uv, float compare ) {\n\t\tconst vec2 offset = vec2( 0.0, 1.0 );\n\t\tvec2 texelSize = vec2( 1.0 ) / size;\n\t\tvec2 centroidUV = floor( uv * size + 0.5 ) / size;\n\t\tfloat lb = texture2DCompare( depths, centroidUV + texelSize * offset.xx, compare );\n\t\tfloat lt = texture2DCompare( depths, centroidUV + texelSize * offset.xy, compare );\n\t\tfloat rb = texture2DCompare( depths, centroidUV + texelSize * offset.yx, compare );\n\t\tfloat rt = texture2DCompare( depths, centroidUV + texelSize * offset.yy, compare );\n\t\tvec2 f = fract( uv * size + 0.5 );\n\t\tfloat a = mix( lb, lt, f.y );\n\t\tfloat b = mix( rb, rt, f.y );\n\t\tfloat c = mix( a, b, f.x );\n\t\treturn c;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n\t\tbool inFrustum = all( inFrustumVec );\n\t\tbvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n\t\tbool frustumTest = all( frustumTestVec );\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tshadow = (\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tfloat dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\tdp += shadowBias;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif\n",
			shadowmap_pars_vertex: "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHTS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHTS ];\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\t\tuniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHTS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHTS ];\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHTS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHTS ];\n\t#endif\n#endif\n",
			shadowmap_vertex: "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\t#pragma unroll_loop\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\t#pragma unroll_loop\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tvSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\t#pragma unroll_loop\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n#endif\n",
			shadowmask_pars_fragment: "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\tDirectionalLight directionalLight;\n\t#pragma unroll_loop\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tshadow *= bool( directionalLight.shadow ) ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\tSpotLight spotLight;\n\t#pragma unroll_loop\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tshadow *= bool( spotLight.shadow ) ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t}\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\tPointLight pointLight;\n\t#pragma unroll_loop\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tshadow *= bool( pointLight.shadow ) ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#endif\n\t#endif\n\treturn shadow;\n}\n",
			skinbase_vertex: "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif",
			skinning_pars_vertex: "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\t#ifdef BONE_TEXTURE\n\t\tuniform sampler2D boneTexture;\n\t\tuniform int boneTextureSize;\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tfloat j = i * 4.0;\n\t\t\tfloat x = mod( j, float( boneTextureSize ) );\n\t\t\tfloat y = floor( j / float( boneTextureSize ) );\n\t\t\tfloat dx = 1.0 / float( boneTextureSize );\n\t\t\tfloat dy = 1.0 / float( boneTextureSize );\n\t\t\ty = dy * ( y + 0.5 );\n\t\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\t\treturn bone;\n\t\t}\n\t#else\n\t\tuniform mat4 boneMatrices[ MAX_BONES ];\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tmat4 bone = boneMatrices[ int(i) ];\n\t\t\treturn bone;\n\t\t}\n\t#endif\n#endif\n",
			skinning_vertex: "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif\n",
			skinnormal_vertex: "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix  = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n#endif\n",
			specularmap_fragment: "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif",
			specularmap_pars_fragment: "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif",
			tonemapping_fragment: "#if defined( TONE_MAPPING )\n  gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif\n",
			tonemapping_pars_fragment: "#ifndef saturate\n\t#define saturate(a) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nuniform float toneMappingWhitePoint;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\n#define Uncharted2Helper( x ) max( ( ( x * ( 0.15 * x + 0.10 * 0.50 ) + 0.20 * 0.02 ) / ( x * ( 0.15 * x + 0.50 ) + 0.20 * 0.30 ) ) - 0.02 / 0.30, vec3( 0.0 ) )\nvec3 Uncharted2ToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( Uncharted2Helper( color ) / Uncharted2Helper( vec3( toneMappingWhitePoint ) ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\n",
			uv_pars_fragment: "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvarying vec2 vUv;\n#endif",
			uv_pars_vertex: "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\n",
			uv_vertex: "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n#endif",
			uv2_pars_fragment: "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvarying vec2 vUv2;\n#endif",
			uv2_pars_vertex: "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tattribute vec2 uv2;\n\tvarying vec2 vUv2;\n#endif",
			uv2_vertex: "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvUv2 = uv2;\n#endif",
			worldpos_vertex: "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP )\n\tvec4 worldPosition = modelMatrix * vec4( transformed, 1.0 );\n#endif\n",
			cube_frag: "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldPosition;\nvoid main() {\n\tgl_FragColor = textureCube( tCube, vec3( tFlip * vWorldPosition.x, vWorldPosition.yz ) );\n\tgl_FragColor.a *= opacity;\n}\n",
			cube_vert: "varying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvWorldPosition = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}\n",
			depth_frag: "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <logdepthbuf_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - gl_FragCoord.z ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( gl_FragCoord.z );\n\t#endif\n}\n",
			depth_vert: "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n}\n",
			distanceRGBA_frag: "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}\n",
			distanceRGBA_vert: "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}\n",
			equirect_frag: "uniform sampler2D tEquirect;\nvarying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldPosition );\n\tvec2 sampleUV;\n\tsampleUV.y = asin( clamp( direction.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\tsampleUV.x = atan( direction.z, direction.x ) * RECIPROCAL_PI2 + 0.5;\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n}\n",
			equirect_vert: "varying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvWorldPosition = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}\n",
			linedashed_frag: "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n",
			linedashed_vert: "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\tvLineDistance = scale * lineDistance;\n\tvec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}\n",
			meshbasic_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\treflectedLight.indirectDiffuse += texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n",
			meshbasic_vert: "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_ENVMAP\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}\n",
			meshlambert_frag: "uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <lights_pars_maps>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <emissivemap_fragment>\n\treflectedLight.indirectDiffuse = getAmbientLightIrradiance( ambientLightColor );\n\t#include <lightmap_fragment>\n\treflectedLight.indirectDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb );\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n\t#else\n\t\treflectedLight.directDiffuse = vLightFront;\n\t#endif\n\treflectedLight.directDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb ) * getShadowMask();\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}\n",
			meshlambert_vert: "#define LAMBERT\nvarying vec3 vLightFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <lights_pars_maps>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <lights_lambert_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n",
			meshphong_frag: "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <lights_pars_maps>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}\n",
			meshphong_vert: "#define PHONG\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n",
			meshphysical_frag: "#define PHYSICAL\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifndef STANDARD\n\tuniform float clearCoat;\n\tuniform float clearCoatRoughness;\n#endif\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <cube_uv_reflection_fragment>\n#include <lights_pars_begin>\n#include <lights_pars_maps>\n#include <lights_physical_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}\n",
			meshphysical_vert: "#define PHYSICAL\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n",
			normal_frag: "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n}\n",
			normal_vert: "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}\n",
			points_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n",
			points_vert: "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#ifdef USE_SIZEATTENUATION\n\t\tgl_PointSize = size * ( scale / - mvPosition.z );\n\t#else\n\t\tgl_PointSize = size;\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}\n",
			shadow_frag: "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <fog_fragment>\n}\n",
			shadow_vert: "#include <fog_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n"
		},
		io = {
			merge: function (t) {
				for (var e = {}, i = 0; i < t.length; i++) {
					var n = this.clone(t[i]),
						r;
					for (r in n) e[r] = n[r]
				}
				return e
			},
			clone: function (t) {
				var e = {},
					i;
				for (i in t) {
					e[i] = {};
					for (var n in t[i]) {
						var r = t[i][n];
						r && (r.isColor || r.isMatrix3 || r.isMatrix4 || r.isVector2 || r.isVector3 || r.isVector4 || r.isTexture) ? e[i][n] = r.clone() : Array.isArray(r) ? e[i][n] = r.slice() : e[i][n] = r
					}
				}
				return e
			}
		},
		no = {
			aliceblue: 15792383,
			antiquewhite: 16444375,
			aqua: 65535,
			aquamarine: 8388564,
			azure: 15794175,
			beige: 16119260,
			bisque: 16770244,
			black: 0,
			blanchedalmond: 16772045,
			blue: 255,
			blueviolet: 9055202,
			brown: 10824234,
			burlywood: 14596231,
			cadetblue: 6266528,
			chartreuse: 8388352,
			chocolate: 13789470,
			coral: 16744272,
			cornflowerblue: 6591981,
			cornsilk: 16775388,
			crimson: 14423100,
			cyan: 65535,
			darkblue: 139,
			darkcyan: 35723,
			darkgoldenrod: 12092939,
			darkgray: 11119017,
			darkgreen: 25600,
			darkgrey: 11119017,
			darkkhaki: 12433259,
			darkmagenta: 9109643,
			darkolivegreen: 5597999,
			darkorange: 16747520,
			darkorchid: 10040012,
			darkred: 9109504,
			darksalmon: 15308410,
			darkseagreen: 9419919,
			darkslateblue: 4734347,
			darkslategray: 3100495,
			darkslategrey: 3100495,
			darkturquoise: 52945,
			darkviolet: 9699539,
			deeppink: 16716947,
			deepskyblue: 49151,
			dimgray: 6908265,
			dimgrey: 6908265,
			dodgerblue: 2003199,
			firebrick: 11674146,
			floralwhite: 16775920,
			forestgreen: 2263842,
			fuchsia: 16711935,
			gainsboro: 14474460,
			ghostwhite: 16316671,
			gold: 16766720,
			goldenrod: 14329120,
			gray: 8421504,
			green: 32768,
			greenyellow: 11403055,
			grey: 8421504,
			honeydew: 15794160,
			hotpink: 16738740,
			indianred: 13458524,
			indigo: 4915330,
			ivory: 16777200,
			khaki: 15787660,
			lavender: 15132410,
			lavenderblush: 16773365,
			lawngreen: 8190976,
			lemonchiffon: 16775885,
			lightblue: 11393254,
			lightcoral: 15761536,
			lightcyan: 14745599,
			lightgoldenrodyellow: 16448210,
			lightgray: 13882323,
			lightgreen: 9498256,
			lightgrey: 13882323,
			lightpink: 16758465,
			lightsalmon: 16752762,
			lightseagreen: 2142890,
			lightskyblue: 8900346,
			lightslategray: 7833753,
			lightslategrey: 7833753,
			lightsteelblue: 11584734,
			lightyellow: 16777184,
			lime: 65280,
			limegreen: 3329330,
			linen: 16445670,
			magenta: 16711935,
			maroon: 8388608,
			mediumaquamarine: 6737322,
			mediumblue: 205,
			mediumorchid: 12211667,
			mediumpurple: 9662683,
			mediumseagreen: 3978097,
			mediumslateblue: 8087790,
			mediumspringgreen: 64154,
			mediumturquoise: 4772300,
			mediumvioletred: 13047173,
			midnightblue: 1644912,
			mintcream: 16121850,
			mistyrose: 16770273,
			moccasin: 16770229,
			navajowhite: 16768685,
			navy: 128,
			oldlace: 16643558,
			olive: 8421376,
			olivedrab: 7048739,
			orange: 16753920,
			orangered: 16729344,
			orchid: 14315734,
			palegoldenrod: 15657130,
			palegreen: 10025880,
			paleturquoise: 11529966,
			palevioletred: 14381203,
			papayawhip: 16773077,
			peachpuff: 16767673,
			peru: 13468991,
			pink: 16761035,
			plum: 14524637,
			powderblue: 11591910,
			purple: 8388736,
			rebeccapurple: 6697881,
			red: 16711680,
			rosybrown: 12357519,
			royalblue: 4286945,
			saddlebrown: 9127187,
			salmon: 16416882,
			sandybrown: 16032864,
			seagreen: 3050327,
			seashell: 16774638,
			sienna: 10506797,
			silver: 12632256,
			skyblue: 8900331,
			slateblue: 6970061,
			slategray: 7372944,
			slategrey: 7372944,
			snow: 16775930,
			springgreen: 65407,
			steelblue: 4620980,
			tan: 13808780,
			teal: 32896,
			thistle: 14204888,
			tomato: 16737095,
			turquoise: 4251856,
			violet: 15631086,
			wheat: 16113331,
			white: 16777215,
			whitesmoke: 16119285,
			yellow: 16776960,
			yellowgreen: 10145074
		};
	Object.assign(w.prototype, {
		isColor: !0,
		r: 1,
		g: 1,
		b: 1,
		set: function (t) {
			t && t.isColor ? this.copy(t) : "number" === typeof t ? this.setHex(t) : "string" === typeof t && this.setStyle(t);
			return this
		},
		setScalar: function (t) {
			this.b = this.g = this.r = t;
			return this
		},
		setHex: function (t) {
			t = Math.floor(t);
			this.r = (t >> 16 & 255) / 255;
			this.g = (t >> 8 & 255) / 255;
			this.b = (t & 255) / 255;
			return this
		},
		setRGB: function (t, e, i) {
			this.r = t;
			this.g = e;
			this.b = i;
			return this
		},
		setHSL: function () {
			function n(t, e, i) {
				0 > i && (i += 1);
				1 < i && --i;
				return i < 1 / 6 ? t + 6 * (e - t) * i : .5 > i ? e : i < 2 / 3 ? t + 6 * (e - t) * (2 / 3 - i) : t
			}
			return function (t, e, i) {
				t = Kr.euclideanModulo(t, 1);
				e = Kr.clamp(e, 0, 1);
				i = Kr.clamp(i, 0, 1);
				0 === e ? this.r = this.g = this.b = i : (e = .5 >= i ? i * (1 + e) : i + e - i * e, i = 2 * i - e, this.r = n(i, e, t + 1 / 3), this.g = n(i, e, t), this.b = n(i, e, t - 1 / 3));
				return this
			}
		}(),
		setStyle: function (e) {
			function t(t) {
				void 0 !== t && 1 > parseFloat(t) && console.warn("THREE.Color: Alpha component of " + e + " will be ignored.")
			}
			var i;
			if (i = /^((?:rgb|hsl)a?)\(\s*([^\)]*)\)/.exec(e)) {
				var n = i[2];
				switch (i[1]) {
					case "rgb":
					case "rgba":
						if (i = /^(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec(n)) return this.r = Math.min(255, parseInt(i[1], 10)) / 255, this.g = Math.min(255, parseInt(i[2], 10)) / 255, this.b = Math.min(255, parseInt(i[3], 10)) / 255, t(i[5]), this;
						if (i = /^(\d+)%\s*,\s*(\d+)%\s*,\s*(\d+)%\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec(n)) return this.r = Math.min(100, parseInt(i[1], 10)) / 100, this.g = Math.min(100, parseInt(i[2], 10)) / 100, this.b = Math.min(100, parseInt(i[3], 10)) / 100, t(i[5]), this;
						break;
					case "hsl":
					case "hsla":
						if (i = /^([0-9]*\.?[0-9]+)\s*,\s*(\d+)%\s*,\s*(\d+)%\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec(n)) {
							n = parseFloat(i[1]) / 360;
							var r = parseInt(i[2], 10) / 100,
								o = parseInt(i[3], 10) / 100;
							t(i[5]);
							return this.setHSL(n, r, o)
						}
				}
			} else if (i = /^#([A-Fa-f0-9]+)$/.exec(e)) {
				i = i[1];
				n = i.length;
				if (3 === n) return this.r = parseInt(i.charAt(0) + i.charAt(0), 16) / 255, this.g = parseInt(i.charAt(1) + i.charAt(1), 16) / 255, this.b = parseInt(i.charAt(2) + i.charAt(2), 16) / 255, this;
				if (6 === n) return this.r = parseInt(i.charAt(0) + i.charAt(1), 16) / 255, this.g = parseInt(i.charAt(2) + i.charAt(3), 16) / 255, this.b = parseInt(i.charAt(4) + i.charAt(5), 16) / 255, this
			}
			e && 0 < e.length && (i = no[e], void 0 !== i ? this.setHex(i) : console.warn("THREE.Color: Unknown color " + e));
			return this
		},
		clone: function () {
			return new this.constructor(this.r, this.g, this.b)
		},
		copy: function (t) {
			this.r = t.r;
			this.g = t.g;
			this.b = t.b;
			return this
		},
		copyGammaToLinear: function (t, e) {
			void 0 === e && (e = 2);
			this.r = Math.pow(t.r, e);
			this.g = Math.pow(t.g, e);
			this.b = Math.pow(t.b, e);
			return this
		},
		copyLinearToGamma: function (t, e) {
			void 0 === e && (e = 2);
			e = 0 < e ? 1 / e : 1;
			this.r = Math.pow(t.r, e);
			this.g = Math.pow(t.g, e);
			this.b = Math.pow(t.b, e);
			return this
		},
		convertGammaToLinear: function (t) {
			this.copyGammaToLinear(this, t);
			return this
		},
		convertLinearToGamma: function (t) {
			this.copyLinearToGamma(this, t);
			return this
		},
		getHex: function () {
			return 255 * this.r << 16 ^ 255 * this.g << 8 ^ 255 * this.b << 0
		},
		getHexString: function () {
			return ("000000" + this.getHex().toString(16)).slice(-6)
		},
		getHSL: function (t) {
			void 0 === t && (console.warn("THREE.Color: .getHSL() target is now required"), t = {
				h: 0,
				s: 0,
				l: 0
			});
			var e = this.r,
				i = this.g,
				n = this.b,
				r = Math.max(e, i, n),
				o = Math.min(e, i, n),
				a, s = (o + r) / 2;
			if (o === r) o = a = 0;
			else {
				var l = r - o;
				o = .5 >= s ? l / (r + o) : l / (2 - r - o);
				switch (r) {
					case e:
						a = (i - n) / l + (i < n ? 6 : 0);
						break;
					case i:
						a = (n - e) / l + 2;
						break;
					case n:
						a = (e - i) / l + 4
				}
				a /= 6
			}
			t.h = a;
			t.s = o;
			t.l = s;
			return t
		},
		getStyle: function () {
			return "rgb(" + (255 * this.r | 0) + "," + (255 * this.g | 0) + "," + (255 * this.b | 0) + ")"
		},
		offsetHSL: function () {
			var n = {};
			return function (t, e, i) {
				this.getHSL(n);
				n.h += t;
				n.s += e;
				n.l += i;
				this.setHSL(n.h, n.s, n.l);
				return this
			}
		}(),
		add: function (t) {
			this.r += t.r;
			this.g += t.g;
			this.b += t.b;
			return this
		},
		addColors: function (t, e) {
			this.r = t.r + e.r;
			this.g = t.g + e.g;
			this.b = t.b + e.b;
			return this
		},
		addScalar: function (t) {
			this.r += t;
			this.g += t;
			this.b += t;
			return this
		},
		sub: function (t) {
			this.r = Math.max(0, this.r - t.r);
			this.g = Math.max(0, this.g - t.g);
			this.b = Math.max(0, this.b - t.b);
			return this
		},
		multiply: function (t) {
			this.r *= t.r;
			this.g *= t.g;
			this.b *= t.b;
			return this
		},
		multiplyScalar: function (t) {
			this.r *= t;
			this.g *= t;
			this.b *= t;
			return this
		},
		lerp: function (t, e) {
			this.r += (t.r - this.r) * e;
			this.g += (t.g - this.g) * e;
			this.b += (t.b - this.b) * e;
			return this
		},
		equals: function (t) {
			return t.r === this.r && t.g === this.g && t.b === this.b
		},
		fromArray: function (t, e) {
			void 0 === e && (e = 0);
			this.r = t[e];
			this.g = t[e + 1];
			this.b = t[e + 2];
			return this
		},
		toArray: function (t, e) {
			void 0 === t && (t = []);
			void 0 === e && (e = 0);
			t[e] = this.r;
			t[e + 1] = this.g;
			t[e + 2] = this.b;
			return t
		},
		toJSON: function () {
			return this.getHex()
		}
	});
	var ro = {
			common: {
				diffuse: {
					value: new w(15658734)
				},
				opacity: {
					value: 1
				},
				map: {
					value: null
				},
				uvTransform: {
					value: new g
				},
				alphaMap: {
					value: null
				}
			},
			specularmap: {
				specularMap: {
					value: null
				}
			},
			envmap: {
				envMap: {
					value: null
				},
				flipEnvMap: {
					value: -1
				},
				reflectivity: {
					value: 1
				},
				refractionRatio: {
					value: .98
				},
				maxMipLevel: {
					value: 0
				}
			},
			aomap: {
				aoMap: {
					value: null
				},
				aoMapIntensity: {
					value: 1
				}
			},
			lightmap: {
				lightMap: {
					value: null
				},
				lightMapIntensity: {
					value: 1
				}
			},
			emissivemap: {
				emissiveMap: {
					value: null
				}
			},
			bumpmap: {
				bumpMap: {
					value: null
				},
				bumpScale: {
					value: 1
				}
			},
			normalmap: {
				normalMap: {
					value: null
				},
				normalScale: {
					value: new W(1, 1)
				}
			},
			displacementmap: {
				displacementMap: {
					value: null
				},
				displacementScale: {
					value: 1
				},
				displacementBias: {
					value: 0
				}
			},
			roughnessmap: {
				roughnessMap: {
					value: null
				}
			},
			metalnessmap: {
				metalnessMap: {
					value: null
				}
			},
			gradientmap: {
				gradientMap: {
					value: null
				}
			},
			fog: {
				fogDensity: {
					value: 25e-5
				},
				fogNear: {
					value: 1
				},
				fogFar: {
					value: 2e3
				},
				fogColor: {
					value: new w(16777215)
				}
			},
			lights: {
				ambientLightColor: {
					value: []
				},
				directionalLights: {
					value: [],
					properties: {
						direction: {},
						color: {},
						shadow: {},
						shadowBias: {},
						shadowRadius: {},
						shadowMapSize: {}
					}
				},
				directionalShadowMap: {
					value: []
				},
				directionalShadowMatrix: {
					value: []
				},
				spotLights: {
					value: [],
					properties: {
						color: {},
						position: {},
						direction: {},
						distance: {},
						coneCos: {},
						penumbraCos: {},
						decay: {},
						shadow: {},
						shadowBias: {},
						shadowRadius: {},
						shadowMapSize: {}
					}
				},
				spotShadowMap: {
					value: []
				},
				spotShadowMatrix: {
					value: []
				},
				pointLights: {
					value: [],
					properties: {
						color: {},
						position: {},
						decay: {},
						distance: {},
						shadow: {},
						shadowBias: {},
						shadowRadius: {},
						shadowMapSize: {},
						shadowCameraNear: {},
						shadowCameraFar: {}
					}
				},
				pointShadowMap: {
					value: []
				},
				pointShadowMatrix: {
					value: []
				},
				hemisphereLights: {
					value: [],
					properties: {
						direction: {},
						skyColor: {},
						groundColor: {}
					}
				},
				rectAreaLights: {
					value: [],
					properties: {
						color: {},
						position: {},
						width: {},
						height: {}
					}
				}
			},
			points: {
				diffuse: {
					value: new w(15658734)
				},
				opacity: {
					value: 1
				},
				size: {
					value: 1
				},
				scale: {
					value: 1
				},
				map: {
					value: null
				},
				uvTransform: {
					value: new g
				}
			}
		},
		oo = {
			basic: {
				uniforms: io.merge([ro.common, ro.specularmap, ro.envmap, ro.aomap, ro.lightmap, ro.fog]),
				vertexShader: eo.meshbasic_vert,
				fragmentShader: eo.meshbasic_frag
			},
			lambert: {
				uniforms: io.merge([ro.common, ro.specularmap, ro.envmap, ro.aomap, ro.lightmap, ro.emissivemap, ro.fog, ro.lights, {
					emissive: {
						value: new w(0)
					}
				}]),
				vertexShader: eo.meshlambert_vert,
				fragmentShader: eo.meshlambert_frag
			},
			phong: {
				uniforms: io.merge([ro.common, ro.specularmap, ro.envmap, ro.aomap, ro.lightmap, ro.emissivemap, ro.bumpmap, ro.normalmap, ro.displacementmap, ro.gradientmap, ro.fog, ro.lights, {
					emissive: {
						value: new w(0)
					},
					specular: {
						value: new w(1118481)
					},
					shininess: {
						value: 30
					}
				}]),
				vertexShader: eo.meshphong_vert,
				fragmentShader: eo.meshphong_frag
			},
			standard: {
				uniforms: io.merge([ro.common, ro.envmap, ro.aomap, ro.lightmap, ro.emissivemap, ro.bumpmap, ro.normalmap, ro.displacementmap, ro.roughnessmap, ro.metalnessmap, ro.fog, ro.lights, {
					emissive: {
						value: new w(0)
					},
					roughness: {
						value: .5
					},
					metalness: {
						value: .5
					},
					envMapIntensity: {
						value: 1
					}
				}]),
				vertexShader: eo.meshphysical_vert,
				fragmentShader: eo.meshphysical_frag
			},
			points: {
				uniforms: io.merge([ro.points, ro.fog]),
				vertexShader: eo.points_vert,
				fragmentShader: eo.points_frag
			},
			dashed: {
				uniforms: io.merge([ro.common, ro.fog, {
					scale: {
						value: 1
					},
					dashSize: {
						value: 1
					},
					totalSize: {
						value: 2
					}
				}]),
				vertexShader: eo.linedashed_vert,
				fragmentShader: eo.linedashed_frag
			},
			depth: {
				uniforms: io.merge([ro.common, ro.displacementmap]),
				vertexShader: eo.depth_vert,
				fragmentShader: eo.depth_frag
			},
			normal: {
				uniforms: io.merge([ro.common, ro.bumpmap, ro.normalmap, ro.displacementmap, {
					opacity: {
						value: 1
					}
				}]),
				vertexShader: eo.normal_vert,
				fragmentShader: eo.normal_frag
			},
			cube: {
				uniforms: {
					tCube: {
						value: null
					},
					tFlip: {
						value: -1
					},
					opacity: {
						value: 1
					}
				},
				vertexShader: eo.cube_vert,
				fragmentShader: eo.cube_frag
			},
			equirect: {
				uniforms: {
					tEquirect: {
						value: null
					}
				},
				vertexShader: eo.equirect_vert,
				fragmentShader: eo.equirect_frag
			},
			distanceRGBA: {
				uniforms: io.merge([ro.common, ro.displacementmap, {
					referencePosition: {
						value: new _t
					},
					nearDistance: {
						value: 1
					},
					farDistance: {
						value: 1e3
					}
				}]),
				vertexShader: eo.distanceRGBA_vert,
				fragmentShader: eo.distanceRGBA_frag
			},
			shadow: {
				uniforms: io.merge([ro.lights, ro.fog, {
					color: {
						value: new w(0)
					},
					opacity: {
						value: 1
					}
				}]),
				vertexShader: eo.shadow_vert,
				fragmentShader: eo.shadow_frag
			}
		};
	oo.physical = {
		uniforms: io.merge([oo.standard.uniforms, {
			clearCoat: {
				value: 0
			},
			clearCoatRoughness: {
				value: 0
			}
		}]),
		vertexShader: eo.meshphysical_vert,
		fragmentShader: eo.meshphysical_frag
	};
	r.RotationOrders = "XYZ YZX ZXY XZY YXZ ZYX".split(" ");
	r.DefaultOrder = "XYZ";
	Object.defineProperties(r.prototype, {
		x: {
			get: function () {
				return this._x
			},
			set: function (t) {
				this._x = t;
				this.onChangeCallback()
			}
		},
		y: {
			get: function () {
				return this._y
			},
			set: function (t) {
				this._y = t;
				this.onChangeCallback()
			}
		},
		z: {
			get: function () {
				return this._z
			},
			set: function (t) {
				this._z = t;
				this.onChangeCallback()
			}
		},
		order: {
			get: function () {
				return this._order
			},
			set: function (t) {
				this._order = t;
				this.onChangeCallback()
			}
		}
	});
	Object.assign(r.prototype, {
		isEuler: !0,
		set: function (t, e, i, n) {
			this._x = t;
			this._y = e;
			this._z = i;
			this._order = n || this._order;
			this.onChangeCallback();
			return this
		},
		clone: function () {
			return new this.constructor(this._x, this._y, this._z, this._order)
		},
		copy: function (t) {
			this._x = t._x;
			this._y = t._y;
			this._z = t._z;
			this._order = t._order;
			this.onChangeCallback();
			return this
		},
		setFromRotationMatrix: function (t, e, i) {
			var n = Kr.clamp,
				r = t.elements;
			t = r[0];
			var o = r[4],
				a = r[8],
				s = r[1],
				l = r[5],
				c = r[9],
				u = r[2],
				h = r[6];
			r = r[10];
			e = e || this._order;
			"XYZ" === e ? (this._y = Math.asin(n(a, -1, 1)), .99999 > Math.abs(a) ? (this._x = Math.atan2(-c, r), this._z = Math.atan2(-o, t)) : (this._x = Math.atan2(h, l), this._z = 0)) : "YXZ" === e ? (this._x = Math.asin(-n(c, -1, 1)), .99999 > Math.abs(c) ? (this._y = Math.atan2(a, r), this._z = Math.atan2(s, l)) : (this._y = Math.atan2(-u, t), this._z = 0)) : "ZXY" === e ? (this._x = Math.asin(n(h, -1, 1)), .99999 > Math.abs(h) ? (this._y = Math.atan2(-u, r), this._z = Math.atan2(-o, l)) : (this._y = 0, this._z = Math.atan2(s, t))) : "ZYX" === e ? (this._y = Math.asin(-n(u, -1, 1)), .99999 > Math.abs(u) ? (this._x = Math.atan2(h, r), this._z = Math.atan2(s, t)) : (this._x = 0, this._z = Math.atan2(-o, l))) : "YZX" === e ? (this._z = Math.asin(n(s, -1, 1)), .99999 > Math.abs(s) ? (this._x = Math.atan2(-c, l), this._y = Math.atan2(-u, t)) : (this._x = 0, this._y = Math.atan2(a, r))) : "XZY" === e ? (this._z = Math.asin(-n(o, -1, 1)), .99999 > Math.abs(o) ? (this._x = Math.atan2(h, l), this._y = Math.atan2(a, t)) : (this._x = Math.atan2(-c, r), this._y = 0)) : console.warn("THREE.Euler: .setFromRotationMatrix() given unsupported order: " + e);
			this._order = e;
			if (!1 !== i) this.onChangeCallback();
			return this
		},
		setFromQuaternion: function () {
			var n = new xt;
			return function (t, e, i) {
				n.makeRotationFromQuaternion(t);
				return this.setFromRotationMatrix(n, e, i)
			}
		}(),
		setFromVector3: function (t, e) {
			return this.set(t.x, t.y, t.z, e || this._order)
		},
		reorder: function () {
			var e = new j;
			return function (t) {
				e.setFromEuler(this);
				return this.setFromQuaternion(e, t)
			}
		}(),
		equals: function (t) {
			return t._x === this._x && t._y === this._y && t._z === this._z && t._order === this._order
		},
		fromArray: function (t) {
			this._x = t[0];
			this._y = t[1];
			this._z = t[2];
			void 0 !== t[3] && (this._order = t[3]);
			this.onChangeCallback();
			return this
		},
		toArray: function (t, e) {
			void 0 === t && (t = []);
			void 0 === e && (e = 0);
			t[e] = this._x;
			t[e + 1] = this._y;
			t[e + 2] = this._z;
			t[e + 3] = this._order;
			return t
		},
		toVector3: function (t) {
			return t ? t.set(this._x, this._y, this._z) : new _t(this._x, this._y, this._z)
		},
		onChange: function (t) {
			this.onChangeCallback = t;
			return this
		},
		onChangeCallback: function () {}
	});
	Object.assign(o.prototype, {
		set: function (t) {
			this.mask = 1 << t | 0
		},
		enable: function (t) {
			this.mask = this.mask | 1 << t | 0
		},
		toggle: function (t) {
			this.mask ^= 1 << t | 0
		},
		disable: function (t) {
			this.mask &= ~(1 << t | 0)
		},
		test: function (t) {
			return 0 !== (this.mask & t.mask)
		}
	});
	var ao = 0;
	u.DefaultUp = new _t(0, 1, 0);
	u.DefaultMatrixAutoUpdate = !0;
	u.prototype = Object.assign(Object.create(e.prototype), {
		constructor: u,
		isObject3D: !0,
		onBeforeRender: function () {},
		onAfterRender: function () {},
		applyMatrix: function (t) {
			this.matrix.multiplyMatrices(t, this.matrix);
			this.matrix.decompose(this.position, this.quaternion, this.scale)
		},
		applyQuaternion: function (t) {
			this.quaternion.premultiply(t);
			return this
		},
		setRotationFromAxisAngle: function (t, e) {
			this.quaternion.setFromAxisAngle(t, e)
		},
		setRotationFromEuler: function (t) {
			this.quaternion.setFromEuler(t, !0)
		},
		setRotationFromMatrix: function (t) {
			this.quaternion.setFromRotationMatrix(t)
		},
		setRotationFromQuaternion: function (t) {
			this.quaternion.copy(t)
		},
		rotateOnAxis: function () {
			var i = new j;
			return function (t, e) {
				i.setFromAxisAngle(t, e);
				this.quaternion.multiply(i);
				return this
			}
		}(),
		rotateOnWorldAxis: function () {
			var i = new j;
			return function (t, e) {
				i.setFromAxisAngle(t, e);
				this.quaternion.premultiply(i);
				return this
			}
		}(),
		rotateX: function () {
			var e = new _t(1, 0, 0);
			return function (t) {
				return this.rotateOnAxis(e, t)
			}
		}(),
		rotateY: function () {
			var e = new _t(0, 1, 0);
			return function (t) {
				return this.rotateOnAxis(e, t)
			}
		}(),
		rotateZ: function () {
			var e = new _t(0, 0, 1);
			return function (t) {
				return this.rotateOnAxis(e, t)
			}
		}(),
		translateOnAxis: function () {
			var i = new _t;
			return function (t, e) {
				i.copy(t).applyQuaternion(this.quaternion);
				this.position.add(i.multiplyScalar(e));
				return this
			}
		}(),
		translateX: function () {
			var e = new _t(1, 0, 0);
			return function (t) {
				return this.translateOnAxis(e, t)
			}
		}(),
		translateY: function () {
			var e = new _t(0, 1, 0);
			return function (t) {
				return this.translateOnAxis(e, t)
			}
		}(),
		translateZ: function () {
			var e = new _t(0, 0, 1);
			return function (t) {
				return this.translateOnAxis(e, t)
			}
		}(),
		localToWorld: function (t) {
			return t.applyMatrix4(this.matrixWorld)
		},
		worldToLocal: function () {
			var e = new xt;
			return function (t) {
				return t.applyMatrix4(e.getInverse(this.matrixWorld))
			}
		}(),
		lookAt: function () {
			var n = new xt,
				r = new _t;
			return function (t, e, i) {
				t.isVector3 ? r.copy(t) : r.set(t, e, i);
				this.isCamera ? n.lookAt(this.position, r, this.up) : n.lookAt(r, this.position, this.up);
				this.quaternion.setFromRotationMatrix(n)
			}
		}(),
		add: function (t) {
			if (1 < arguments.length) {
				for (var e = 0; e < arguments.length; e++) this.add(arguments[e]);
				return this
			}
			if (t === this) return console.error("THREE.Object3D.add: object can't be added as a child of itself.", t), this;
			t && t.isObject3D ? (null !== t.parent && t.parent.remove(t), t.parent = this, t.dispatchEvent({
				type: "added"
			}), this.children.push(t)) : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", t);
			return this
		},
		remove: function (t) {
			if (1 < arguments.length) {
				for (var e = 0; e < arguments.length; e++) this.remove(arguments[e]);
				return this
			}
			e = this.children.indexOf(t); - 1 !== e && (t.parent = null, t.dispatchEvent({
				type: "removed"
			}), this.children.splice(e, 1));
			return this
		},
		getObjectById: function (t) {
			return this.getObjectByProperty("id", t)
		},
		getObjectByName: function (t) {
			return this.getObjectByProperty("name", t)
		},
		getObjectByProperty: function (t, e) {
			if (this[t] === e) return this;
			for (var i = 0, n = this.children.length; i < n; i++) {
				var r = this.children[i].getObjectByProperty(t, e);
				if (void 0 !== r) return r
			}
		},
		getWorldPosition: function (t) {
			void 0 === t && (console.warn("THREE.Object3D: .getWorldPosition() target is now required"), t = new _t);
			this.updateMatrixWorld(!0);
			return t.setFromMatrixPosition(this.matrixWorld)
		},
		getWorldQuaternion: function () {
			var e = new _t,
				i = new _t;
			return function (t) {
				void 0 === t && (console.warn("THREE.Object3D: .getWorldQuaternion() target is now required"), t = new j);
				this.updateMatrixWorld(!0);
				this.matrixWorld.decompose(e, t, i);
				return t
			}
		}(),
		getWorldScale: function () {
			var e = new _t,
				i = new j;
			return function (t) {
				void 0 === t && (console.warn("THREE.Object3D: .getWorldScale() target is now required"), t = new _t);
				this.updateMatrixWorld(!0);
				this.matrixWorld.decompose(e, i, t);
				return t
			}
		}(),
		getWorldDirection: function () {
			var e = new j;
			return function (t) {
				void 0 === t && (console.warn("THREE.Object3D: .getWorldDirection() target is now required"), t = new _t);
				this.getWorldQuaternion(e);
				return t.set(0, 0, 1).applyQuaternion(e)
			}
		}(),
		raycast: function () {},
		traverse: function (t) {
			t(this);
			for (var e = this.children, i = 0, n = e.length; i < n; i++) e[i].traverse(t)
		},
		traverseVisible: function (t) {
			if (!1 !== this.visible) {
				t(this);
				for (var e = this.children, i = 0, n = e.length; i < n; i++) e[i].traverseVisible(t)
			}
		},
		traverseAncestors: function (t) {
			var e = this.parent;
			null !== e && (t(e), e.traverseAncestors(t))
		},
		updateMatrix: function () {
			this.matrix.compose(this.position, this.quaternion, this.scale);
			this.matrixWorldNeedsUpdate = !0
		},
		updateMatrixWorld: function (t) {
			this.matrixAutoUpdate && this.updateMatrix();
			if (this.matrixWorldNeedsUpdate || t) null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), this.matrixWorldNeedsUpdate = !1, t = !0;
			for (var e = this.children, i = 0, n = e.length; i < n; i++) e[i].updateMatrixWorld(t)
		},
		toJSON: function (i) {
			function t(t, e) {
				void 0 === t[e.uuid] && (t[e.uuid] = e.toJSON(i));
				return e.uuid
			}

			function e(t) {
				var e = [],
					i;
				for (i in t) {
					var n = t[i];
					delete n.metadata;
					e.push(n)
				}
				return e
			}
			var n = void 0 === i || "string" === typeof i,
				r = {};
			n && (i = {
				geometries: {},
				materials: {},
				textures: {},
				images: {},
				shapes: {}
			}, r.metadata = {
				version: 4.5,
				type: "Object",
				generator: "Object3D.toJSON"
			});
			var o = {};
			o.uuid = this.uuid;
			o.type = this.type;
			"" !== this.name && (o.name = this.name);
			!0 === this.castShadow && (o.castShadow = !0);
			!0 === this.receiveShadow && (o.receiveShadow = !0);
			!1 === this.visible && (o.visible = !1);
			!1 === this.frustumCulled && (o.frustumCulled = !1);
			0 !== this.renderOrder && (o.renderOrder = this.renderOrder);
			"{}" !== JSON.stringify(this.userData) && (o.userData = this.userData);
			o.matrix = this.matrix.toArray();
			!1 === this.matrixAutoUpdate && (o.matrixAutoUpdate = !1);
			if (void 0 !== this.geometry) {
				o.geometry = t(i.geometries, this.geometry);
				var a = this.geometry.parameters;
				if (void 0 !== a && void 0 !== a.shapes)
					if (a = a.shapes, Array.isArray(a))
						for (var s = 0, l = a.length; s < l; s++) t(i.shapes, a[s]);
					else t(i.shapes, a)
			}
			if (void 0 !== this.material)
				if (Array.isArray(this.material)) {
					a = [];
					s = 0;
					for (l = this.material.length; s < l; s++) a.push(t(i.materials, this.material[s]));
					o.material = a
				} else o.material = t(i.materials, this.material);
			if (0 < this.children.length)
				for (o.children = [], s = 0; s < this.children.length; s++) o.children.push(this.children[s].toJSON(i).object);
			if (n) {
				n = e(i.geometries);
				s = e(i.materials);
				l = e(i.textures);
				var c = e(i.images);
				a = e(i.shapes);
				0 < n.length && (r.geometries = n);
				0 < s.length && (r.materials = s);
				0 < l.length && (r.textures = l);
				0 < c.length && (r.images = c);
				0 < a.length && (r.shapes = a)
			}
			r.object = o;
			return r
		},
		clone: function (t) {
			return (new this.constructor).copy(this, t)
		},
		copy: function (t, e) {
			void 0 === e && (e = !0);
			this.name = t.name;
			this.up.copy(t.up);
			this.position.copy(t.position);
			this.quaternion.copy(t.quaternion);
			this.scale.copy(t.scale);
			this.matrix.copy(t.matrix);
			this.matrixWorld.copy(t.matrixWorld);
			this.matrixAutoUpdate = t.matrixAutoUpdate;
			this.matrixWorldNeedsUpdate = t.matrixWorldNeedsUpdate;
			this.layers.mask = t.layers.mask;
			this.visible = t.visible;
			this.castShadow = t.castShadow;
			this.receiveShadow = t.receiveShadow;
			this.frustumCulled = t.frustumCulled;
			this.renderOrder = t.renderOrder;
			this.userData = JSON.parse(JSON.stringify(t.userData));
			if (!0 === e)
				for (e = 0; e < t.children.length; e++) this.add(t.children[e].clone());
			return this
		}
	});
	l.prototype = Object.assign(Object.create(u.prototype), {
		constructor: l,
		isCamera: !0,
		copy: function (t, e) {
			u.prototype.copy.call(this, t, e);
			this.matrixWorldInverse.copy(t.matrixWorldInverse);
			this.projectionMatrix.copy(t.projectionMatrix);
			return this
		},
		getWorldDirection: function () {
			var e = new j;
			return function (t) {
				void 0 === t && (console.warn("THREE.Camera: .getWorldDirection() target is now required"), t = new _t);
				this.getWorldQuaternion(e);
				return t.set(0, 0, -1).applyQuaternion(e)
			}
		}(),
		updateMatrixWorld: function (t) {
			u.prototype.updateMatrixWorld.call(this, t);
			this.matrixWorldInverse.getInverse(this.matrixWorld)
		},
		clone: function () {
			return (new this.constructor).copy(this)
		}
	});
	f.prototype = Object.assign(Object.create(l.prototype), {
		constructor: f,
		isOrthographicCamera: !0,
		copy: function (t, e) {
			l.prototype.copy.call(this, t, e);
			this.left = t.left;
			this.right = t.right;
			this.top = t.top;
			this.bottom = t.bottom;
			this.near = t.near;
			this.far = t.far;
			this.zoom = t.zoom;
			this.view = null === t.view ? null : Object.assign({}, t.view);
			return this
		},
		setViewOffset: function (t, e, i, n, r, o) {
			null === this.view && (this.view = {
				enabled: !0,
				fullWidth: 1,
				fullHeight: 1,
				offsetX: 0,
				offsetY: 0,
				width: 1,
				height: 1
			});
			this.view.enabled = !0;
			this.view.fullWidth = t;
			this.view.fullHeight = e;
			this.view.offsetX = i;
			this.view.offsetY = n;
			this.view.width = r;
			this.view.height = o;
			this.updateProjectionMatrix()
		},
		clearViewOffset: function () {
			null !== this.view && (this.view.enabled = !1);
			this.updateProjectionMatrix()
		},
		updateProjectionMatrix: function () {
			var t = (this.right - this.left) / (2 * this.zoom),
				e = (this.top - this.bottom) / (2 * this.zoom),
				i = (this.right + this.left) / 2,
				n = (this.top + this.bottom) / 2,
				r = i - t;
			i += t;
			t = n + e;
			e = n - e;
			if (null !== this.view && this.view.enabled) {
				i = this.zoom / (this.view.width / this.view.fullWidth);
				e = this.zoom / (this.view.height / this.view.fullHeight);
				var o = (this.right - this.left) / this.view.width;
				n = (this.top - this.bottom) / this.view.height;
				r += this.view.offsetX / i * o;
				i = r + this.view.width / i * o;
				t -= this.view.offsetY / e * n;
				e = t - this.view.height / e * n
			}
			this.projectionMatrix.makeOrthographic(r, i, t, e, this.near, this.far)
		},
		toJSON: function (t) {
			t = u.prototype.toJSON.call(this, t);
			t.object.zoom = this.zoom;
			t.object.left = this.left;
			t.object.right = this.right;
			t.object.top = this.top;
			t.object.bottom = this.bottom;
			t.object.near = this.near;
			t.object.far = this.far;
			null !== this.view && (t.object.view = Object.assign({}, this.view));
			return t
		}
	});
	Object.assign(F.prototype, {
		clone: function () {
			return (new this.constructor).copy(this)
		},
		copy: function (t) {
			this.a = t.a;
			this.b = t.b;
			this.c = t.c;
			this.normal.copy(t.normal);
			this.color.copy(t.color);
			this.materialIndex = t.materialIndex;
			for (var e = 0, i = t.vertexNormals.length; e < i; e++) this.vertexNormals[e] = t.vertexNormals[e].clone();
			e = 0;
			for (i = t.vertexColors.length; e < i; e++) this.vertexColors[e] = t.vertexColors[e].clone();
			return this
		}
	});
	var so = 0;
	T.prototype = Object.assign(Object.create(e.prototype), {
		constructor: T,
		isGeometry: !0,
		applyMatrix: function (t) {
			for (var e = (new g).getNormalMatrix(t), i = 0, n = this.vertices.length; i < n; i++) this.vertices[i].applyMatrix4(t);
			i = 0;
			for (n = this.faces.length; i < n; i++) {
				t = this.faces[i];
				t.normal.applyMatrix3(e).normalize();
				for (var r = 0, o = t.vertexNormals.length; r < o; r++) t.vertexNormals[r].applyMatrix3(e).normalize()
			}
			null !== this.boundingBox && this.computeBoundingBox();
			null !== this.boundingSphere && this.computeBoundingSphere();
			this.normalsNeedUpdate = this.verticesNeedUpdate = !0;
			return this
		},
		rotateX: function () {
			var e = new xt;
			return function (t) {
				e.makeRotationX(t);
				this.applyMatrix(e);
				return this
			}
		}(),
		rotateY: function () {
			var e = new xt;
			return function (t) {
				e.makeRotationY(t);
				this.applyMatrix(e);
				return this
			}
		}(),
		rotateZ: function () {
			var e = new xt;
			return function (t) {
				e.makeRotationZ(t);
				this.applyMatrix(e);
				return this
			}
		}(),
		translate: function () {
			var n = new xt;
			return function (t, e, i) {
				n.makeTranslation(t, e, i);
				this.applyMatrix(n);
				return this
			}
		}(),
		scale: function () {
			var n = new xt;
			return function (t, e, i) {
				n.makeScale(t, e, i);
				this.applyMatrix(n);
				return this
			}
		}(),
		lookAt: function () {
			var e = new u;
			return function (t) {
				e.lookAt(t);
				e.updateMatrix();
				this.applyMatrix(e.matrix)
			}
		}(),
		fromBufferGeometry: function (t) {
			function e(t, e, i, n) {
				var r = void 0 !== s ? [h[t].clone(), h[e].clone(), h[i].clone()] : [],
					o = void 0 !== l ? [a.colors[t].clone(), a.colors[e].clone(), a.colors[i].clone()] : [];
				n = new F(t, e, i, r, o, n);
				a.faces.push(n);
				void 0 !== c && a.faceVertexUvs[0].push([d[t].clone(), d[e].clone(), d[i].clone()]);
				void 0 !== u && a.faceVertexUvs[1].push([f[t].clone(), f[e].clone(), f[i].clone()])
			}
			var a = this,
				i = null !== t.index ? t.index.array : void 0,
				n = t.attributes,
				r = n.position.array,
				s = void 0 !== n.normal ? n.normal.array : void 0,
				l = void 0 !== n.color ? n.color.array : void 0,
				c = void 0 !== n.uv ? n.uv.array : void 0,
				u = void 0 !== n.uv2 ? n.uv2.array : void 0;
			void 0 !== u && (this.faceVertexUvs[1] = []);
			for (var h = [], d = [], f = [], o = n = 0; n < r.length; n += 3, o += 2) a.vertices.push(new _t(r[n], r[n + 1], r[n + 2])), void 0 !== s && h.push(new _t(s[n], s[n + 1], s[n + 2])), void 0 !== l && a.colors.push(new w(l[n], l[n + 1], l[n + 2])), void 0 !== c && d.push(new W(c[o], c[o + 1])), void 0 !== u && f.push(new W(u[o], u[o + 1]));
			var p = t.groups;
			if (0 < p.length)
				for (n = 0; n < p.length; n++) {
					r = p[n];
					var m = r.start,
						g = r.count;
					o = m;
					for (m += g; o < m; o += 3) void 0 !== i ? e(i[o], i[o + 1], i[o + 2], r.materialIndex) : e(o, o + 1, o + 2, r.materialIndex)
				} else if (void 0 !== i)
					for (n = 0; n < i.length; n += 3) e(i[n], i[n + 1], i[n + 2]);
				else
					for (n = 0; n < r.length / 3; n += 3) e(n, n + 1, n + 2);
			this.computeFaceNormals();
			null !== t.boundingBox && (this.boundingBox = t.boundingBox.clone());
			null !== t.boundingSphere && (this.boundingSphere = t.boundingSphere.clone());
			return this
		},
		center: function () {
			var t = new _t;
			return function () {
				this.computeBoundingBox();
				this.boundingBox.getCenter(t).negate();
				this.translate(t.x, t.y, t.z);
				return this
			}
		}(),
		normalize: function () {
			this.computeBoundingSphere();
			var t = this.boundingSphere.center,
				e = this.boundingSphere.radius;
			e = 0 === e ? 1 : 1 / e;
			var i = new xt;
			i.set(e, 0, 0, -e * t.x, 0, e, 0, -e * t.y, 0, 0, e, -e * t.z, 0, 0, 0, 1);
			this.applyMatrix(i);
			return this
		},
		computeFaceNormals: function () {
			for (var t = new _t, e = new _t, i = 0, n = this.faces.length; i < n; i++) {
				var r = this.faces[i],
					o = this.vertices[r.a],
					a = this.vertices[r.b];
				t.subVectors(this.vertices[r.c], a);
				e.subVectors(o, a);
				t.cross(e);
				t.normalize();
				r.normal.copy(t)
			}
		},
		computeVertexNormals: function (t) {
			void 0 === t && (t = !0);
			var e;
			var i = Array(this.vertices.length);
			var n = 0;
			for (e = this.vertices.length; n < e; n++) i[n] = new _t;
			if (t) {
				var r = new _t,
					o = new _t;
				t = 0;
				for (n = this.faces.length; t < n; t++) {
					e = this.faces[t];
					var a = this.vertices[e.a];
					var s = this.vertices[e.b];
					var l = this.vertices[e.c];
					r.subVectors(l, s);
					o.subVectors(a, s);
					r.cross(o);
					i[e.a].add(r);
					i[e.b].add(r);
					i[e.c].add(r)
				}
			} else
				for (this.computeFaceNormals(), t = 0, n = this.faces.length; t < n; t++) e = this.faces[t], i[e.a].add(e.normal), i[e.b].add(e.normal), i[e.c].add(e.normal);
			n = 0;
			for (e = this.vertices.length; n < e; n++) i[n].normalize();
			t = 0;
			for (n = this.faces.length; t < n; t++) e = this.faces[t], a = e.vertexNormals, 3 === a.length ? (a[0].copy(i[e.a]), a[1].copy(i[e.b]), a[2].copy(i[e.c])) : (a[0] = i[e.a].clone(), a[1] = i[e.b].clone(), a[2] = i[e.c].clone());
			0 < this.faces.length && (this.normalsNeedUpdate = !0)
		},
		computeFlatVertexNormals: function () {
			var t;
			this.computeFaceNormals();
			var e = 0;
			for (t = this.faces.length; e < t; e++) {
				var i = this.faces[e];
				var n = i.vertexNormals;
				3 === n.length ? (n[0].copy(i.normal), n[1].copy(i.normal), n[2].copy(i.normal)) : (n[0] = i.normal.clone(), n[1] = i.normal.clone(), n[2] = i.normal.clone())
			}
			0 < this.faces.length && (this.normalsNeedUpdate = !0)
		},
		computeMorphNormals: function () {
			var t, e;
			var i = 0;
			for (e = this.faces.length; i < e; i++) {
				var n = this.faces[i];
				n.__originalFaceNormal ? n.__originalFaceNormal.copy(n.normal) : n.__originalFaceNormal = n.normal.clone();
				n.__originalVertexNormals || (n.__originalVertexNormals = []);
				var r = 0;
				for (t = n.vertexNormals.length; r < t; r++) n.__originalVertexNormals[r] ? n.__originalVertexNormals[r].copy(n.vertexNormals[r]) : n.__originalVertexNormals[r] = n.vertexNormals[r].clone()
			}
			var o = new T;
			o.faces = this.faces;
			r = 0;
			for (t = this.morphTargets.length; r < t; r++) {
				if (!this.morphNormals[r]) {
					this.morphNormals[r] = {};
					this.morphNormals[r].faceNormals = [];
					this.morphNormals[r].vertexNormals = [];
					n = this.morphNormals[r].faceNormals;
					var a = this.morphNormals[r].vertexNormals;
					i = 0;
					for (e = this.faces.length; i < e; i++) {
						var s = new _t;
						var l = {
							a: new _t,
							b: new _t,
							c: new _t
						};
						n.push(s);
						a.push(l)
					}
				}
				a = this.morphNormals[r];
				o.vertices = this.morphTargets[r].vertices;
				o.computeFaceNormals();
				o.computeVertexNormals();
				i = 0;
				for (e = this.faces.length; i < e; i++) n = this.faces[i], s = a.faceNormals[i], l = a.vertexNormals[i], s.copy(n.normal), l.a.copy(n.vertexNormals[0]), l.b.copy(n.vertexNormals[1]), l.c.copy(n.vertexNormals[2])
			}
			i = 0;
			for (e = this.faces.length; i < e; i++) n = this.faces[i], n.normal = n.__originalFaceNormal, n.vertexNormals = n.__originalVertexNormals
		},
		computeBoundingBox: function () {
			null === this.boundingBox && (this.boundingBox = new i);
			this.boundingBox.setFromPoints(this.vertices)
		},
		computeBoundingSphere: function () {
			null === this.boundingSphere && (this.boundingSphere = new c);
			this.boundingSphere.setFromPoints(this.vertices)
		},
		merge: function (t, e, i) {
			if (t && t.isGeometry) {
				var n, r = this.vertices.length,
					o = this.vertices,
					a = t.vertices,
					s = this.faces,
					l = t.faces,
					c = this.faceVertexUvs[0],
					u = t.faceVertexUvs[0],
					h = this.colors,
					d = t.colors;
				void 0 === i && (i = 0);
				void 0 !== e && (n = (new g).getNormalMatrix(e));
				t = 0;
				for (var f = a.length; t < f; t++) {
					var p = a[t].clone();
					void 0 !== e && p.applyMatrix4(e);
					o.push(p)
				}
				t = 0;
				for (f = d.length; t < f; t++) h.push(d[t].clone());
				t = 0;
				for (f = l.length; t < f; t++) {
					a = l[t];
					var m = a.vertexNormals;
					d = a.vertexColors;
					h = new F(a.a + r, a.b + r, a.c + r);
					h.normal.copy(a.normal);
					void 0 !== n && h.normal.applyMatrix3(n).normalize();
					e = 0;
					for (o = m.length; e < o; e++) p = m[e].clone(), void 0 !== n && p.applyMatrix3(n).normalize(), h.vertexNormals.push(p);
					h.color.copy(a.color);
					e = 0;
					for (o = d.length; e < o; e++) p = d[e], h.vertexColors.push(p.clone());
					h.materialIndex = a.materialIndex + i;
					s.push(h)
				}
				t = 0;
				for (f = u.length; t < f; t++)
					if (i = u[t], n = [], void 0 !== i) {
						e = 0;
						for (o = i.length; e < o; e++) n.push(i[e].clone());
						c.push(n)
					}
			} else console.error("THREE.Geometry.merge(): geometry not an instance of THREE.Geometry.", t)
		},
		mergeMesh: function (t) {
			t && t.isMesh ? (t.matrixAutoUpdate && t.updateMatrix(), this.merge(t.geometry, t.matrix)) : console.error("THREE.Geometry.mergeMesh(): mesh not an instance of THREE.Mesh.", t)
		},
		mergeVertices: function () {
			var t = {},
				e = [],
				i = [],
				n = Math.pow(10, 4),
				r;
			var o = 0;
			for (r = this.vertices.length; o < r; o++) {
				var a = this.vertices[o];
				a = Math.round(a.x * n) + "_" + Math.round(a.y * n) + "_" + Math.round(a.z * n);
				void 0 === t[a] ? (t[a] = o, e.push(this.vertices[o]), i[o] = e.length - 1) : i[o] = i[t[a]]
			}
			t = [];
			o = 0;
			for (r = this.faces.length; o < r; o++)
				for (n = this.faces[o], n.a = i[n.a], n.b = i[n.b], n.c = i[n.c], n = [n.a, n.b, n.c], a = 0; 3 > a; a++)
					if (n[a] === n[(a + 1) % 3]) {
						t.push(o);
						break
					}
			for (o = t.length - 1; 0 <= o; o--)
				for (n = t[o], this.faces.splice(n, 1), i = 0, r = this.faceVertexUvs.length; i < r; i++) this.faceVertexUvs[i].splice(n, 1);
			o = this.vertices.length - e.length;
			this.vertices = e;
			return o
		},
		setFromPoints: function (t) {
			this.vertices = [];
			for (var e = 0, i = t.length; e < i; e++) {
				var n = t[e];
				this.vertices.push(new _t(n.x, n.y, n.z || 0))
			}
			return this
		},
		sortFacesByMaterialIndex: function () {
			for (var t = this.faces, e = t.length, i = 0; i < e; i++) t[i]._id = i;
			t.sort(function (t, e) {
				return t.materialIndex - e.materialIndex
			});
			var n = this.faceVertexUvs[0],
				r = this.faceVertexUvs[1],
				o, a;
			n && n.length === e && (o = []);
			r && r.length === e && (a = []);
			for (i = 0; i < e; i++) {
				var s = t[i]._id;
				o && o.push(n[s]);
				a && a.push(r[s])
			}
			o && (this.faceVertexUvs[0] = o);
			a && (this.faceVertexUvs[1] = a)
		},
		toJSON: function () {
			function t(t, e, i) {
				return i ? t | 1 << e : t & ~(1 << e)
			}

			function e(t) {
				var e = t.x.toString() + t.y.toString() + t.z.toString();
				if (void 0 !== c[e]) return c[e];
				c[e] = l.length / 3;
				l.push(t.x, t.y, t.z);
				return c[e]
			}

			function i(t) {
				var e = t.r.toString() + t.g.toString() + t.b.toString();
				if (void 0 !== h[e]) return h[e];
				h[e] = u.length;
				u.push(t.getHex());
				return h[e]
			}

			function n(t) {
				var e = t.x.toString() + t.y.toString();
				if (void 0 !== f[e]) return f[e];
				f[e] = d.length / 2;
				d.push(t.x, t.y);
				return f[e]
			}
			var r = {
				metadata: {
					version: 4.5,
					type: "Geometry",
					generator: "Geometry.toJSON"
				}
			};
			r.uuid = this.uuid;
			r.type = this.type;
			"" !== this.name && (r.name = this.name);
			if (void 0 !== this.parameters) {
				var o = this.parameters,
					a;
				for (a in o) void 0 !== o[a] && (r[a] = o[a]);
				return r
			}
			o = [];
			for (a = 0; a < this.vertices.length; a++) {
				var s = this.vertices[a];
				o.push(s.x, s.y, s.z)
			}
			s = [];
			var l = [],
				c = {},
				u = [],
				h = {},
				d = [],
				f = {};
			for (a = 0; a < this.faces.length; a++) {
				var p = this.faces[a],
					m = void 0 !== this.faceVertexUvs[0][a],
					g = 0 < p.normal.length(),
					v = 0 < p.vertexNormals.length,
					y = 1 !== p.color.r || 1 !== p.color.g || 1 !== p.color.b,
					x = 0 < p.vertexColors.length,
					_ = 0;
				_ = t(_, 0, 0);
				_ = t(_, 1, !0);
				_ = t(_, 2, !1);
				_ = t(_, 3, m);
				_ = t(_, 4, g);
				_ = t(_, 5, v);
				_ = t(_, 6, y);
				_ = t(_, 7, x);
				s.push(_);
				s.push(p.a, p.b, p.c);
				s.push(p.materialIndex);
				m && (m = this.faceVertexUvs[0][a], s.push(n(m[0]), n(m[1]), n(m[2])));
				g && s.push(e(p.normal));
				v && (g = p.vertexNormals, s.push(e(g[0]), e(g[1]), e(g[2])));
				y && s.push(i(p.color));
				x && (p = p.vertexColors, s.push(i(p[0]), i(p[1]), i(p[2])))
			}
			r.data = {};
			r.data.vertices = o;
			r.data.normals = l;
			0 < u.length && (r.data.colors = u);
			0 < d.length && (r.data.uvs = [d]);
			r.data.faces = s;
			return r
		},
		clone: function () {
			return (new T).copy(this)
		},
		copy: function (t) {
			var e, i, n;
			this.vertices = [];
			this.colors = [];
			this.faces = [];
			this.faceVertexUvs = [
				[]
			];
			this.morphTargets = [];
			this.morphNormals = [];
			this.skinWeights = [];
			this.skinIndices = [];
			this.lineDistances = [];
			this.boundingSphere = this.boundingBox = null;
			this.name = t.name;
			var r = t.vertices;
			var o = 0;
			for (e = r.length; o < e; o++) this.vertices.push(r[o].clone());
			r = t.colors;
			o = 0;
			for (e = r.length; o < e; o++) this.colors.push(r[o].clone());
			r = t.faces;
			o = 0;
			for (e = r.length; o < e; o++) this.faces.push(r[o].clone());
			o = 0;
			for (e = t.faceVertexUvs.length; o < e; o++) {
				var a = t.faceVertexUvs[o];
				void 0 === this.faceVertexUvs[o] && (this.faceVertexUvs[o] = []);
				r = 0;
				for (i = a.length; r < i; r++) {
					var s = a[r],
						l = [];
					var c = 0;
					for (n = s.length; c < n; c++) l.push(s[c].clone());
					this.faceVertexUvs[o].push(l)
				}
			}
			c = t.morphTargets;
			o = 0;
			for (e = c.length; o < e; o++) {
				n = {};
				n.name = c[o].name;
				if (void 0 !== c[o].vertices)
					for (n.vertices = [], r = 0, i = c[o].vertices.length; r < i; r++) n.vertices.push(c[o].vertices[r].clone());
				if (void 0 !== c[o].normals)
					for (n.normals = [], r = 0, i = c[o].normals.length; r < i; r++) n.normals.push(c[o].normals[r].clone());
				this.morphTargets.push(n)
			}
			c = t.morphNormals;
			o = 0;
			for (e = c.length; o < e; o++) {
				n = {};
				if (void 0 !== c[o].vertexNormals)
					for (n.vertexNormals = [], r = 0, i = c[o].vertexNormals.length; r < i; r++) a = c[o].vertexNormals[r], s = {}, s.a = a.a.clone(), s.b = a.b.clone(), s.c = a.c.clone(), n.vertexNormals.push(s);
				if (void 0 !== c[o].faceNormals)
					for (n.faceNormals = [], r = 0, i = c[o].faceNormals.length; r < i; r++) n.faceNormals.push(c[o].faceNormals[r].clone());
				this.morphNormals.push(n)
			}
			r = t.skinWeights;
			o = 0;
			for (e = r.length; o < e; o++) this.skinWeights.push(r[o].clone());
			r = t.skinIndices;
			o = 0;
			for (e = r.length; o < e; o++) this.skinIndices.push(r[o].clone());
			r = t.lineDistances;
			o = 0;
			for (e = r.length; o < e; o++) this.lineDistances.push(r[o]);
			o = t.boundingBox;
			null !== o && (this.boundingBox = o.clone());
			o = t.boundingSphere;
			null !== o && (this.boundingSphere = o.clone());
			this.elementsNeedUpdate = t.elementsNeedUpdate;
			this.verticesNeedUpdate = t.verticesNeedUpdate;
			this.uvsNeedUpdate = t.uvsNeedUpdate;
			this.normalsNeedUpdate = t.normalsNeedUpdate;
			this.colorsNeedUpdate = t.colorsNeedUpdate;
			this.lineDistancesNeedUpdate = t.lineDistancesNeedUpdate;
			this.groupsNeedUpdate = t.groupsNeedUpdate;
			return this
		},
		dispose: function () {
			this.dispatchEvent({
				type: "dispose"
			})
		}
	});
	Object.defineProperty(y.prototype, "needsUpdate", {
		set: function (t) {
			!0 === t && this.version++
		}
	});
	Object.assign(y.prototype, {
		isBufferAttribute: !0,
		onUploadCallback: function () {},
		setArray: function (t) {
			if (Array.isArray(t)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
			this.count = void 0 !== t ? t.length / this.itemSize : 0;
			this.array = t;
			return this
		},
		setDynamic: function (t) {
			this.dynamic = t;
			return this
		},
		copy: function (t) {
			this.name = t.name;
			this.array = new t.array.constructor(t.array);
			this.itemSize = t.itemSize;
			this.count = t.count;
			this.normalized = t.normalized;
			this.dynamic = t.dynamic;
			return this
		},
		copyAt: function (t, e, i) {
			t *= this.itemSize;
			i *= e.itemSize;
			for (var n = 0, r = this.itemSize; n < r; n++) this.array[t + n] = e.array[i + n];
			return this
		},
		copyArray: function (t) {
			this.array.set(t);
			return this
		},
		copyColorsArray: function (t) {
			for (var e = this.array, i = 0, n = 0, r = t.length; n < r; n++) {
				var o = t[n];
				void 0 === o && (console.warn("THREE.BufferAttribute.copyColorsArray(): color is undefined", n), o = new w);
				e[i++] = o.r;
				e[i++] = o.g;
				e[i++] = o.b
			}
			return this
		},
		copyVector2sArray: function (t) {
			for (var e = this.array, i = 0, n = 0, r = t.length; n < r; n++) {
				var o = t[n];
				void 0 === o && (console.warn("THREE.BufferAttribute.copyVector2sArray(): vector is undefined", n), o = new W);
				e[i++] = o.x;
				e[i++] = o.y
			}
			return this
		},
		copyVector3sArray: function (t) {
			for (var e = this.array, i = 0, n = 0, r = t.length; n < r; n++) {
				var o = t[n];
				void 0 === o && (console.warn("THREE.BufferAttribute.copyVector3sArray(): vector is undefined", n), o = new _t);
				e[i++] = o.x;
				e[i++] = o.y;
				e[i++] = o.z
			}
			return this
		},
		copyVector4sArray: function (t) {
			for (var e = this.array, i = 0, n = 0, r = t.length; n < r; n++) {
				var o = t[n];
				void 0 === o && (console.warn("THREE.BufferAttribute.copyVector4sArray(): vector is undefined", n), o = new bt);
				e[i++] = o.x;
				e[i++] = o.y;
				e[i++] = o.z;
				e[i++] = o.w
			}
			return this
		},
		set: function (t, e) {
			void 0 === e && (e = 0);
			this.array.set(t, e);
			return this
		},
		getX: function (t) {
			return this.array[t * this.itemSize]
		},
		setX: function (t, e) {
			this.array[t * this.itemSize] = e;
			return this
		},
		getY: function (t) {
			return this.array[t * this.itemSize + 1]
		},
		setY: function (t, e) {
			this.array[t * this.itemSize + 1] = e;
			return this
		},
		getZ: function (t) {
			return this.array[t * this.itemSize + 2]
		},
		setZ: function (t, e) {
			this.array[t * this.itemSize + 2] = e;
			return this
		},
		getW: function (t) {
			return this.array[t * this.itemSize + 3]
		},
		setW: function (t, e) {
			this.array[t * this.itemSize + 3] = e;
			return this
		},
		setXY: function (t, e, i) {
			t *= this.itemSize;
			this.array[t + 0] = e;
			this.array[t + 1] = i;
			return this
		},
		setXYZ: function (t, e, i, n) {
			t *= this.itemSize;
			this.array[t + 0] = e;
			this.array[t + 1] = i;
			this.array[t + 2] = n;
			return this
		},
		setXYZW: function (t, e, i, n, r) {
			t *= this.itemSize;
			this.array[t + 0] = e;
			this.array[t + 1] = i;
			this.array[t + 2] = n;
			this.array[t + 3] = r;
			return this
		},
		onUpload: function (t) {
			this.onUploadCallback = t;
			return this
		},
		clone: function () {
			return new this.constructor(this.array, this.itemSize).copy(this)
		}
	});
	a.prototype = Object.create(y.prototype);
	a.prototype.constructor = a;
	s.prototype = Object.create(y.prototype);
	s.prototype.constructor = s;
	h.prototype = Object.create(y.prototype);
	h.prototype.constructor = h;
	p.prototype = Object.create(y.prototype);
	p.prototype.constructor = p;
	m.prototype = Object.create(y.prototype);
	m.prototype.constructor = m;
	x.prototype = Object.create(y.prototype);
	x.prototype.constructor = x;
	_.prototype = Object.create(y.prototype);
	_.prototype.constructor = _;
	P.prototype = Object.create(y.prototype);
	P.prototype.constructor = P;
	b.prototype = Object.create(y.prototype);
	b.prototype.constructor = b;
	Object.assign(E.prototype, {
		computeGroups: function (t) {
			var e = [],
				i = void 0;
			t = t.faces;
			for (var n = 0; n < t.length; n++) {
				var r = t[n];
				if (r.materialIndex !== i) {
					i = r.materialIndex;
					void 0 !== o && (o.count = 3 * n - o.start, e.push(o));
					var o = {
						start: 3 * n,
						materialIndex: i
					}
				}
			}
			void 0 !== o && (o.count = 3 * n - o.start, e.push(o));
			this.groups = e
		},
		fromGeometry: function (t) {
			var e = t.faces,
				i = t.vertices,
				n = t.faceVertexUvs,
				r = n[0] && 0 < n[0].length,
				o = n[1] && 0 < n[1].length,
				a = t.morphTargets,
				s = a.length;
			if (0 < s) {
				var l = [];
				for (var c = 0; c < s; c++) l[c] = [];
				this.morphTargets.position = l
			}
			var u = t.morphNormals,
				h = u.length;
			if (0 < h) {
				var d = [];
				for (c = 0; c < h; c++) d[c] = [];
				this.morphTargets.normal = d
			}
			var f = t.skinIndices,
				p = t.skinWeights,
				m = f.length === i.length,
				g = p.length === i.length;
			0 === e.length && console.error("THREE.DirectGeometry: Faceless geometries are not supported.");
			for (c = 0; c < e.length; c++) {
				var v = e[c];
				this.vertices.push(i[v.a], i[v.b], i[v.c]);
				var y = v.vertexNormals;
				3 === y.length ? this.normals.push(y[0], y[1], y[2]) : (y = v.normal, this.normals.push(y, y, y));
				y = v.vertexColors;
				3 === y.length ? this.colors.push(y[0], y[1], y[2]) : (y = v.color, this.colors.push(y, y, y));
				!0 === r && (y = n[0][c], void 0 !== y ? this.uvs.push(y[0], y[1], y[2]) : (console.warn("THREE.DirectGeometry.fromGeometry(): Undefined vertexUv ", c), this.uvs.push(new W, new W, new W)));
				!0 === o && (y = n[1][c], void 0 !== y ? this.uvs2.push(y[0], y[1], y[2]) : (console.warn("THREE.DirectGeometry.fromGeometry(): Undefined vertexUv2 ", c), this.uvs2.push(new W, new W, new W)));
				for (y = 0; y < s; y++) {
					var x = a[y].vertices;
					l[y].push(x[v.a], x[v.b], x[v.c])
				}
				for (y = 0; y < h; y++) x = u[y].vertexNormals[c], d[y].push(x.a, x.b, x.c);
				m && this.skinIndices.push(f[v.a], f[v.b], f[v.c]);
				g && this.skinWeights.push(p[v.a], p[v.b], p[v.c])
			}
			this.computeGroups(t);
			this.verticesNeedUpdate = t.verticesNeedUpdate;
			this.normalsNeedUpdate = t.normalsNeedUpdate;
			this.colorsNeedUpdate = t.colorsNeedUpdate;
			this.uvsNeedUpdate = t.uvsNeedUpdate;
			this.groupsNeedUpdate = t.groupsNeedUpdate;
			return this
		}
	});
	var lo = 1;
	L.prototype = Object.assign(Object.create(e.prototype), {
		constructor: L,
		isBufferGeometry: !0,
		getIndex: function () {
			return this.index
		},
		setIndex: function (t) {
			Array.isArray(t) ? this.index = new(65535 < S(t) ? _ : m)(t, 1) : this.index = t
		},
		addAttribute: function (t, e, i) {
			if (!(e && e.isBufferAttribute || e && e.isInterleavedBufferAttribute)) return console.warn("THREE.BufferGeometry: .addAttribute() now expects ( name, attribute )."), this.addAttribute(t, new y(e, i));
			if ("index" === t) return console.warn("THREE.BufferGeometry.addAttribute: Use .setIndex() for index attribute."), this.setIndex(e), this;
			this.attributes[t] = e;
			return this
		},
		getAttribute: function (t) {
			return this.attributes[t]
		},
		removeAttribute: function (t) {
			delete this.attributes[t];
			return this
		},
		addGroup: function (t, e, i) {
			this.groups.push({
				start: t,
				count: e,
				materialIndex: void 0 !== i ? i : 0
			})
		},
		clearGroups: function () {
			this.groups = []
		},
		setDrawRange: function (t, e) {
			this.drawRange.start = t;
			this.drawRange.count = e
		},
		applyMatrix: function (t) {
			var e = this.attributes.position;
			void 0 !== e && (t.applyToBufferAttribute(e), e.needsUpdate = !0);
			e = this.attributes.normal;
			void 0 !== e && ((new g).getNormalMatrix(t).applyToBufferAttribute(e), e.needsUpdate = !0);
			null !== this.boundingBox && this.computeBoundingBox();
			null !== this.boundingSphere && this.computeBoundingSphere();
			return this
		},
		rotateX: function () {
			var e = new xt;
			return function (t) {
				e.makeRotationX(t);
				this.applyMatrix(e);
				return this
			}
		}(),
		rotateY: function () {
			var e = new xt;
			return function (t) {
				e.makeRotationY(t);
				this.applyMatrix(e);
				return this
			}
		}(),
		rotateZ: function () {
			var e = new xt;
			return function (t) {
				e.makeRotationZ(t);
				this.applyMatrix(e);
				return this
			}
		}(),
		translate: function () {
			var n = new xt;
			return function (t, e, i) {
				n.makeTranslation(t, e, i);
				this.applyMatrix(n);
				return this
			}
		}(),
		scale: function () {
			var n = new xt;
			return function (t, e, i) {
				n.makeScale(t, e, i);
				this.applyMatrix(n);
				return this
			}
		}(),
		lookAt: function () {
			var e = new u;
			return function (t) {
				e.lookAt(t);
				e.updateMatrix();
				this.applyMatrix(e.matrix)
			}
		}(),
		center: function () {
			var t = new _t;
			return function () {
				this.computeBoundingBox();
				this.boundingBox.getCenter(t).negate();
				this.translate(t.x, t.y, t.z);
				return this
			}
		}(),
		setFromObject: function (t) {
			var e = t.geometry;
			if (t.isPoints || t.isLine) {
				t = new P(3 * e.vertices.length, 3);
				var i = new P(3 * e.colors.length, 3);
				this.addAttribute("position", t.copyVector3sArray(e.vertices));
				this.addAttribute("color", i.copyColorsArray(e.colors));
				e.lineDistances && e.lineDistances.length === e.vertices.length && (t = new P(e.lineDistances.length, 1), this.addAttribute("lineDistance", t.copyArray(e.lineDistances)));
				null !== e.boundingSphere && (this.boundingSphere = e.boundingSphere.clone());
				null !== e.boundingBox && (this.boundingBox = e.boundingBox.clone())
			} else t.isMesh && e && e.isGeometry && this.fromGeometry(e);
			return this
		},
		setFromPoints: function (t) {
			for (var e = [], i = 0, n = t.length; i < n; i++) {
				var r = t[i];
				e.push(r.x, r.y, r.z || 0)
			}
			this.addAttribute("position", new P(e, 3));
			return this
		},
		updateFromObject: function (t) {
			var e = t.geometry;
			if (t.isMesh) {
				var i = e.__directGeometry;
				!0 === e.elementsNeedUpdate && (i = void 0, e.elementsNeedUpdate = !1);
				if (void 0 === i) return this.fromGeometry(e);
				i.verticesNeedUpdate = e.verticesNeedUpdate;
				i.normalsNeedUpdate = e.normalsNeedUpdate;
				i.colorsNeedUpdate = e.colorsNeedUpdate;
				i.uvsNeedUpdate = e.uvsNeedUpdate;
				i.groupsNeedUpdate = e.groupsNeedUpdate;
				e.verticesNeedUpdate = !1;
				e.normalsNeedUpdate = !1;
				e.colorsNeedUpdate = !1;
				e.uvsNeedUpdate = !1;
				e.groupsNeedUpdate = !1;
				e = i
			}!0 === e.verticesNeedUpdate && (i = this.attributes.position, void 0 !== i && (i.copyVector3sArray(e.vertices), i.needsUpdate = !0), e.verticesNeedUpdate = !1);
			!0 === e.normalsNeedUpdate && (i = this.attributes.normal, void 0 !== i && (i.copyVector3sArray(e.normals), i.needsUpdate = !0), e.normalsNeedUpdate = !1);
			!0 === e.colorsNeedUpdate && (i = this.attributes.color, void 0 !== i && (i.copyColorsArray(e.colors), i.needsUpdate = !0), e.colorsNeedUpdate = !1);
			e.uvsNeedUpdate && (i = this.attributes.uv, void 0 !== i && (i.copyVector2sArray(e.uvs), i.needsUpdate = !0), e.uvsNeedUpdate = !1);
			e.lineDistancesNeedUpdate && (i = this.attributes.lineDistance, void 0 !== i && (i.copyArray(e.lineDistances), i.needsUpdate = !0), e.lineDistancesNeedUpdate = !1);
			e.groupsNeedUpdate && (e.computeGroups(t.geometry), this.groups = e.groups, e.groupsNeedUpdate = !1);
			return this
		},
		fromGeometry: function (t) {
			t.__directGeometry = (new E).fromGeometry(t);
			return this.fromDirectGeometry(t.__directGeometry)
		},
		fromDirectGeometry: function (t) {
			var e = new Float32Array(3 * t.vertices.length);
			this.addAttribute("position", new y(e, 3).copyVector3sArray(t.vertices));
			0 < t.normals.length && (e = new Float32Array(3 * t.normals.length), this.addAttribute("normal", new y(e, 3).copyVector3sArray(t.normals)));
			0 < t.colors.length && (e = new Float32Array(3 * t.colors.length), this.addAttribute("color", new y(e, 3).copyColorsArray(t.colors)));
			0 < t.uvs.length && (e = new Float32Array(2 * t.uvs.length), this.addAttribute("uv", new y(e, 2).copyVector2sArray(t.uvs)));
			0 < t.uvs2.length && (e = new Float32Array(2 * t.uvs2.length), this.addAttribute("uv2", new y(e, 2).copyVector2sArray(t.uvs2)));
			this.groups = t.groups;
			for (var i in t.morphTargets) {
				e = [];
				for (var n = t.morphTargets[i], r = 0, o = n.length; r < o; r++) {
					var a = n[r],
						s = new P(3 * a.length, 3);
					e.push(s.copyVector3sArray(a))
				}
				this.morphAttributes[i] = e
			}
			0 < t.skinIndices.length && (i = new P(4 * t.skinIndices.length, 4), this.addAttribute("skinIndex", i.copyVector4sArray(t.skinIndices)));
			0 < t.skinWeights.length && (i = new P(4 * t.skinWeights.length, 4), this.addAttribute("skinWeight", i.copyVector4sArray(t.skinWeights)));
			null !== t.boundingSphere && (this.boundingSphere = t.boundingSphere.clone());
			null !== t.boundingBox && (this.boundingBox = t.boundingBox.clone());
			return this
		},
		computeBoundingBox: function () {
			null === this.boundingBox && (this.boundingBox = new i);
			var t = this.attributes.position;
			void 0 !== t ? this.boundingBox.setFromBufferAttribute(t) : this.boundingBox.makeEmpty();
			(isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && console.error('THREE.BufferGeometry.computeBoundingBox: Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this)
		},
		computeBoundingSphere: function () {
			var o = new i,
				a = new _t;
			return function () {
				null === this.boundingSphere && (this.boundingSphere = new c);
				var t = this.attributes.position;
				if (t) {
					var e = this.boundingSphere.center;
					o.setFromBufferAttribute(t);
					o.getCenter(e);
					for (var i = 0, n = 0, r = t.count; n < r; n++) a.x = t.getX(n), a.y = t.getY(n), a.z = t.getZ(n), i = Math.max(i, e.distanceToSquared(a));
					this.boundingSphere.radius = Math.sqrt(i);
					isNaN(this.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this)
				}
			}
		}(),
		computeFaceNormals: function () {},
		computeVertexNormals: function () {
			var t = this.index,
				e = this.attributes,
				i = this.groups;
			if (e.position) {
				var n = e.position.array;
				if (void 0 === e.normal) this.addAttribute("normal", new y(new Float32Array(n.length), 3));
				else
					for (var r = e.normal.array, o = 0, a = r.length; o < a; o++) r[o] = 0;
				r = e.normal.array;
				var s = new _t,
					l = new _t,
					c = new _t,
					u = new _t,
					h = new _t;
				if (t) {
					t = t.array;
					0 === i.length && this.addGroup(0, t.length);
					for (var d = 0, f = i.length; d < f; ++d) {
						o = i[d];
						a = o.start;
						var p = o.count;
						o = a;
						for (a += p; o < a; o += 3) {
							p = 3 * t[o + 0];
							var m = 3 * t[o + 1];
							var g = 3 * t[o + 2];
							s.fromArray(n, p);
							l.fromArray(n, m);
							c.fromArray(n, g);
							u.subVectors(c, l);
							h.subVectors(s, l);
							u.cross(h);
							r[p] += u.x;
							r[p + 1] += u.y;
							r[p + 2] += u.z;
							r[m] += u.x;
							r[m + 1] += u.y;
							r[m + 2] += u.z;
							r[g] += u.x;
							r[g + 1] += u.y;
							r[g + 2] += u.z
						}
					}
				} else
					for (o = 0, a = n.length; o < a; o += 9) s.fromArray(n, o), l.fromArray(n, o + 3), c.fromArray(n, o + 6), u.subVectors(c, l), h.subVectors(s, l), u.cross(h), r[o] = u.x, r[o + 1] = u.y, r[o + 2] = u.z, r[o + 3] = u.x, r[o + 4] = u.y, r[o + 5] = u.z, r[o + 6] = u.x, r[o + 7] = u.y, r[o + 8] = u.z;
				this.normalizeNormals();
				e.normal.needsUpdate = !0
			}
		},
		merge: function (t, e) {
			if (t && t.isBufferGeometry) {
				void 0 === e && (e = 0, console.warn("THREE.BufferGeometry.merge(): Overwriting original geometry, starting at offset=0. Use BufferGeometryUtils.mergeBufferGeometries() for lossless merge."));
				var i = this.attributes,
					n;
				for (n in i)
					if (void 0 !== t.attributes[n]) {
						var r = i[n].array,
							o = t.attributes[n],
							a = o.array,
							s = 0;
						for (o = o.itemSize * e; s < a.length; s++, o++) r[o] = a[s]
					}
				return this
			}
			console.error("THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.", t)
		},
		normalizeNormals: function () {
			var n = new _t;
			return function () {
				for (var t = this.attributes.normal, e = 0, i = t.count; e < i; e++) n.x = t.getX(e), n.y = t.getY(e), n.z = t.getZ(e), n.normalize(), t.setXYZ(e, n.x, n.y, n.z)
			}
		}(),
		toNonIndexed: function () {
			if (null === this.index) return console.warn("THREE.BufferGeometry.toNonIndexed(): Geometry is already non-indexed."), this;
			var t = new L,
				e = this.index.array,
				i = this.attributes,
				n;
			for (n in i) {
				var r = i[n],
					o = r.array,
					a = r.itemSize,
					s = new o.constructor(e.length * a),
					l = 0;
				r = 0;
				for (var c = e.length; r < c; r++) {
					var u = e[r] * a;
					for (var h = 0; h < a; h++) s[l++] = o[u++]
				}
				t.addAttribute(n, new y(s, a))
			}
			e = this.groups;
			r = 0;
			for (c = e.length; r < c; r++) i = e[r], t.addGroup(i.start, i.count, i.materialIndex);
			return t
		},
		toJSON: function () {
			var t = {
				metadata: {
					version: 4.5,
					type: "BufferGeometry",
					generator: "BufferGeometry.toJSON"
				}
			};
			t.uuid = this.uuid;
			t.type = this.type;
			"" !== this.name && (t.name = this.name);
			0 < Object.keys(this.userData).length && (t.userData = this.userData);
			if (void 0 !== this.parameters) {
				var e = this.parameters;
				for (r in e) void 0 !== e[r] && (t[r] = e[r]);
				return t
			}
			t.data = {
				attributes: {}
			};
			var i = this.index;
			null !== i && (e = Array.prototype.slice.call(i.array), t.data.index = {
				type: i.array.constructor.name,
				array: e
			});
			i = this.attributes;
			for (r in i) {
				var n = i[r];
				e = Array.prototype.slice.call(n.array);
				t.data.attributes[r] = {
					itemSize: n.itemSize,
					type: n.array.constructor.name,
					array: e,
					normalized: n.normalized
				}
			}
			var r = this.groups;
			0 < r.length && (t.data.groups = JSON.parse(JSON.stringify(r)));
			r = this.boundingSphere;
			null !== r && (t.data.boundingSphere = {
				center: r.center.toArray(),
				radius: r.radius
			});
			return t
		},
		clone: function () {
			return (new L).copy(this)
		},
		copy: function (t) {
			var e;
			this.index = null;
			this.attributes = {};
			this.morphAttributes = {};
			this.groups = [];
			this.boundingSphere = this.boundingBox = null;
			this.name = t.name;
			var i = t.index;
			null !== i && this.setIndex(i.clone());
			i = t.attributes;
			for (a in i) this.addAttribute(a, i[a].clone());
			var n = t.morphAttributes;
			for (a in n) {
				var r = [],
					o = n[a];
				i = 0;
				for (e = o.length; i < e; i++) r.push(o[i].clone());
				this.morphAttributes[a] = r
			}
			var a = t.groups;
			i = 0;
			for (e = a.length; i < e; i++) n = a[i], this.addGroup(n.start, n.count, n.materialIndex);
			a = t.boundingBox;
			null !== a && (this.boundingBox = a.clone());
			a = t.boundingSphere;
			null !== a && (this.boundingSphere = a.clone());
			this.drawRange.start = t.drawRange.start;
			this.drawRange.count = t.drawRange.count;
			this.userData = t.userData;
			return this
		},
		dispose: function () {
			this.dispatchEvent({
				type: "dispose"
			})
		}
	});
	M.prototype = Object.create(T.prototype);
	M.prototype.constructor = M;
	C.prototype = Object.create(L.prototype);
	C.prototype.constructor = C;
	R.prototype = Object.create(T.prototype);
	R.prototype.constructor = R;
	O.prototype = Object.create(L.prototype);
	O.prototype.constructor = O;
	var co = 0;
	k.prototype = Object.assign(Object.create(e.prototype), {
		constructor: k,
		isMaterial: !0,
		onBeforeCompile: function () {},
		setValues: function (t) {
			if (void 0 !== t)
				for (var e in t) {
					var i = t[e];
					if (void 0 === i) console.warn("THREE.Material: '" + e + "' parameter is undefined.");
					else if ("shading" === e) console.warn("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead."), this.flatShading = 1 === i ? !0 : !1;
					else {
						var n = this[e];
						void 0 === n ? console.warn("THREE." + this.type + ": '" + e + "' is not a property of this material.") : n && n.isColor ? n.set(i) : n && n.isVector3 && i && i.isVector3 ? n.copy(i) : this[e] = "overdraw" === e ? Number(i) : i
					}
				}
		},
		toJSON: function (t) {
			function e(t) {
				var e = [],
					i;
				for (i in t) {
					var n = t[i];
					delete n.metadata;
					e.push(n)
				}
				return e
			}
			var i = void 0 === t || "string" === typeof t;
			i && (t = {
				textures: {},
				images: {}
			});
			var n = {
				metadata: {
					version: 4.5,
					type: "Material",
					generator: "Material.toJSON"
				}
			};
			n.uuid = this.uuid;
			n.type = this.type;
			"" !== this.name && (n.name = this.name);
			this.color && this.color.isColor && (n.color = this.color.getHex());
			void 0 !== this.roughness && (n.roughness = this.roughness);
			void 0 !== this.metalness && (n.metalness = this.metalness);
			this.emissive && this.emissive.isColor && (n.emissive = this.emissive.getHex());
			1 !== this.emissiveIntensity && (n.emissiveIntensity = this.emissiveIntensity);
			this.specular && this.specular.isColor && (n.specular = this.specular.getHex());
			void 0 !== this.shininess && (n.shininess = this.shininess);
			void 0 !== this.clearCoat && (n.clearCoat = this.clearCoat);
			void 0 !== this.clearCoatRoughness && (n.clearCoatRoughness = this.clearCoatRoughness);
			this.map && this.map.isTexture && (n.map = this.map.toJSON(t).uuid);
			this.alphaMap && this.alphaMap.isTexture && (n.alphaMap = this.alphaMap.toJSON(t).uuid);
			this.lightMap && this.lightMap.isTexture && (n.lightMap = this.lightMap.toJSON(t).uuid);
			this.aoMap && this.aoMap.isTexture && (n.aoMap = this.aoMap.toJSON(t).uuid, n.aoMapIntensity = this.aoMapIntensity);
			this.bumpMap && this.bumpMap.isTexture && (n.bumpMap = this.bumpMap.toJSON(t).uuid, n.bumpScale = this.bumpScale);
			this.normalMap && this.normalMap.isTexture && (n.normalMap = this.normalMap.toJSON(t).uuid, n.normalScale = this.normalScale.toArray());
			this.displacementMap && this.displacementMap.isTexture && (n.displacementMap = this.displacementMap.toJSON(t).uuid, n.displacementScale = this.displacementScale, n.displacementBias = this.displacementBias);
			this.roughnessMap && this.roughnessMap.isTexture && (n.roughnessMap = this.roughnessMap.toJSON(t).uuid);
			this.metalnessMap && this.metalnessMap.isTexture && (n.metalnessMap = this.metalnessMap.toJSON(t).uuid);
			this.emissiveMap && this.emissiveMap.isTexture && (n.emissiveMap = this.emissiveMap.toJSON(t).uuid);
			this.specularMap && this.specularMap.isTexture && (n.specularMap = this.specularMap.toJSON(t).uuid);
			this.envMap && this.envMap.isTexture && (n.envMap = this.envMap.toJSON(t).uuid, n.reflectivity = this.reflectivity);
			this.gradientMap && this.gradientMap.isTexture && (n.gradientMap = this.gradientMap.toJSON(t).uuid);
			void 0 !== this.size && (n.size = this.size);
			void 0 !== this.sizeAttenuation && (n.sizeAttenuation = this.sizeAttenuation);
			1 !== this.blending && (n.blending = this.blending);
			!0 === this.flatShading && (n.flatShading = this.flatShading);
			0 !== this.side && (n.side = this.side);
			0 !== this.vertexColors && (n.vertexColors = this.vertexColors);
			1 > this.opacity && (n.opacity = this.opacity);
			!0 === this.transparent && (n.transparent = this.transparent);
			n.depthFunc = this.depthFunc;
			n.depthTest = this.depthTest;
			n.depthWrite = this.depthWrite;
			0 !== this.rotation && (n.rotation = this.rotation);
			1 !== this.linewidth && (n.linewidth = this.linewidth);
			void 0 !== this.dashSize && (n.dashSize = this.dashSize);
			void 0 !== this.gapSize && (n.gapSize = this.gapSize);
			void 0 !== this.scale && (n.scale = this.scale);
			!0 === this.dithering && (n.dithering = !0);
			0 < this.alphaTest && (n.alphaTest = this.alphaTest);
			!0 === this.premultipliedAlpha && (n.premultipliedAlpha = this.premultipliedAlpha);
			!0 === this.wireframe && (n.wireframe = this.wireframe);
			1 < this.wireframeLinewidth && (n.wireframeLinewidth = this.wireframeLinewidth);
			"round" !== this.wireframeLinecap && (n.wireframeLinecap = this.wireframeLinecap);
			"round" !== this.wireframeLinejoin && (n.wireframeLinejoin = this.wireframeLinejoin);
			!0 === this.morphTargets && (n.morphTargets = !0);
			!0 === this.skinning && (n.skinning = !0);
			!1 === this.visible && (n.visible = !1);
			"{}" !== JSON.stringify(this.userData) && (n.userData = this.userData);
			i && (i = e(t.textures), t = e(t.images), 0 < i.length && (n.textures = i), 0 < t.length && (n.images = t));
			return n
		},
		clone: function () {
			return (new this.constructor).copy(this)
		},
		copy: function (t) {
			this.name = t.name;
			this.fog = t.fog;
			this.lights = t.lights;
			this.blending = t.blending;
			this.side = t.side;
			this.flatShading = t.flatShading;
			this.vertexColors = t.vertexColors;
			this.opacity = t.opacity;
			this.transparent = t.transparent;
			this.blendSrc = t.blendSrc;
			this.blendDst = t.blendDst;
			this.blendEquation = t.blendEquation;
			this.blendSrcAlpha = t.blendSrcAlpha;
			this.blendDstAlpha = t.blendDstAlpha;
			this.blendEquationAlpha = t.blendEquationAlpha;
			this.depthFunc = t.depthFunc;
			this.depthTest = t.depthTest;
			this.depthWrite = t.depthWrite;
			this.colorWrite = t.colorWrite;
			this.precision = t.precision;
			this.polygonOffset = t.polygonOffset;
			this.polygonOffsetFactor = t.polygonOffsetFactor;
			this.polygonOffsetUnits = t.polygonOffsetUnits;
			this.dithering = t.dithering;
			this.alphaTest = t.alphaTest;
			this.premultipliedAlpha = t.premultipliedAlpha;
			this.overdraw = t.overdraw;
			this.visible = t.visible;
			this.userData = JSON.parse(JSON.stringify(t.userData));
			this.clipShadows = t.clipShadows;
			this.clipIntersection = t.clipIntersection;
			var e = t.clippingPlanes,
				i = null;
			if (null !== e) {
				var n = e.length;
				i = Array(n);
				for (var r = 0; r !== n; ++r) i[r] = e[r].clone()
			}
			this.clippingPlanes = i;
			this.shadowSide = t.shadowSide;
			return this
		},
		dispose: function () {
			this.dispatchEvent({
				type: "dispose"
			})
		}
	});
	N.prototype = Object.create(k.prototype);
	N.prototype.constructor = N;
	N.prototype.isMeshBasicMaterial = !0;
	N.prototype.copy = function (t) {
		k.prototype.copy.call(this, t);
		this.color.copy(t.color);
		this.map = t.map;
		this.lightMap = t.lightMap;
		this.lightMapIntensity = t.lightMapIntensity;
		this.aoMap = t.aoMap;
		this.aoMapIntensity = t.aoMapIntensity;
		this.specularMap = t.specularMap;
		this.alphaMap = t.alphaMap;
		this.envMap = t.envMap;
		this.combine = t.combine;
		this.reflectivity = t.reflectivity;
		this.refractionRatio = t.refractionRatio;
		this.wireframe = t.wireframe;
		this.wireframeLinewidth = t.wireframeLinewidth;
		this.wireframeLinecap = t.wireframeLinecap;
		this.wireframeLinejoin = t.wireframeLinejoin;
		this.skinning = t.skinning;
		this.morphTargets = t.morphTargets;
		return this
	};
	I.prototype = Object.create(k.prototype);
	I.prototype.constructor = I;
	I.prototype.isShaderMaterial = !0;
	I.prototype.copy = function (t) {
		k.prototype.copy.call(this, t);
		this.fragmentShader = t.fragmentShader;
		this.vertexShader = t.vertexShader;
		this.uniforms = io.clone(t.uniforms);
		this.defines = Object.assign({}, t.defines);
		this.wireframe = t.wireframe;
		this.wireframeLinewidth = t.wireframeLinewidth;
		this.lights = t.lights;
		this.clipping = t.clipping;
		this.skinning = t.skinning;
		this.morphTargets = t.morphTargets;
		this.morphNormals = t.morphNormals;
		this.extensions = t.extensions;
		return this
	};
	I.prototype.toJSON = function (t) {
		t = k.prototype.toJSON.call(this, t);
		t.uniforms = this.uniforms;
		t.vertexShader = this.vertexShader;
		t.fragmentShader = this.fragmentShader;
		return t
	};
	Object.assign(B.prototype, {
		set: function (t, e) {
			this.origin.copy(t);
			this.direction.copy(e);
			return this
		},
		clone: function () {
			return (new this.constructor).copy(this)
		},
		copy: function (t) {
			this.origin.copy(t.origin);
			this.direction.copy(t.direction);
			return this
		},
		at: function (t, e) {
			void 0 === e && (console.warn("THREE.Ray: .at() target is now required"), e = new _t);
			return e.copy(this.direction).multiplyScalar(t).add(this.origin)
		},
		lookAt: function (t) {
			this.direction.copy(t).sub(this.origin).normalize();
			return this
		},
		recast: function () {
			var e = new _t;
			return function (t) {
				this.origin.copy(this.at(t, e));
				return this
			}
		}(),
		closestPointToPoint: function (t, e) {
			void 0 === e && (console.warn("THREE.Ray: .closestPointToPoint() target is now required"), e = new _t);
			e.subVectors(t, this.origin);
			t = e.dot(this.direction);
			return 0 > t ? e.copy(this.origin) : e.copy(this.direction).multiplyScalar(t).add(this.origin)
		},
		distanceToPoint: function (t) {
			return Math.sqrt(this.distanceSqToPoint(t))
		},
		distanceSqToPoint: function () {
			var i = new _t;
			return function (t) {
				var e = i.subVectors(t, this.origin).dot(this.direction);
				if (0 > e) return this.origin.distanceToSquared(t);
				i.copy(this.direction).multiplyScalar(e).add(this.origin);
				return i.distanceToSquared(t)
			}
		}(),
		distanceSqToSegment: function () {
			var h = new _t,
				d = new _t,
				f = new _t;
			return function (t, e, i, n) {
				h.copy(t).add(e).multiplyScalar(.5);
				d.copy(e).sub(t).normalize();
				f.copy(this.origin).sub(h);
				var r = .5 * t.distanceTo(e),
					o = -this.direction.dot(d),
					a = f.dot(this.direction),
					s = -f.dot(d),
					l = f.lengthSq(),
					c = Math.abs(1 - o * o);
				if (0 < c) {
					t = o * s - a;
					e = o * a - s;
					var u = r * c;
					0 <= t ? e >= -u ? e <= u ? (r = 1 / c, t *= r, e *= r, o = t * (t + o * e + 2 * a) + e * (o * t + e + 2 * s) + l) : (e = r, t = Math.max(0, -(o * e + a)), o = -t * t + e * (e + 2 * s) + l) : (e = -r, t = Math.max(0, -(o * e + a)), o = -t * t + e * (e + 2 * s) + l) : e <= -u ? (t = Math.max(0, -(-o * r + a)), e = 0 < t ? -r : Math.min(Math.max(-r, -s), r), o = -t * t + e * (e + 2 * s) + l) : e <= u ? (t = 0, e = Math.min(Math.max(-r, -s), r), o = e * (e + 2 * s) + l) : (t = Math.max(0, -(o * r + a)), e = 0 < t ? r : Math.min(Math.max(-r, -s), r), o = -t * t + e * (e + 2 * s) + l)
				} else e = 0 < o ? -r : r, t = Math.max(0, -(o * e + a)), o = -t * t + e * (e + 2 * s) + l;
				i && i.copy(this.direction).multiplyScalar(t).add(this.origin);
				n && n.copy(d).multiplyScalar(e).add(h);
				return o
			}
		}(),
		intersectSphere: function () {
			var r = new _t;
			return function (t, e) {
				r.subVectors(t.center, this.origin);
				var i = r.dot(this.direction),
					n = r.dot(r) - i * i;
				t = t.radius * t.radius;
				if (n > t) return null;
				t = Math.sqrt(t - n);
				n = i - t;
				i += t;
				return 0 > n && 0 > i ? null : 0 > n ? this.at(i, e) : this.at(n, e)
			}
		}(),
		intersectsSphere: function (t) {
			return this.distanceToPoint(t.center) <= t.radius
		},
		distanceToPlane: function (t) {
			var e = t.normal.dot(this.direction);
			if (0 === e) return 0 === t.distanceToPoint(this.origin) ? 0 : null;
			t = -(this.origin.dot(t.normal) + t.constant) / e;
			return 0 <= t ? t : null
		},
		intersectPlane: function (t, e) {
			t = this.distanceToPlane(t);
			return null === t ? null : this.at(t, e)
		},
		intersectsPlane: function (t) {
			var e = t.distanceToPoint(this.origin);
			return 0 === e || 0 > t.normal.dot(this.direction) * e ? !0 : !1
		},
		intersectBox: function (t, e) {
			var i = 1 / this.direction.x;
			var n = 1 / this.direction.y;
			var r = 1 / this.direction.z,
				o = this.origin;
			if (0 <= i) {
				var a = (t.min.x - o.x) * i;
				i *= t.max.x - o.x
			} else a = (t.max.x - o.x) * i, i *= t.min.x - o.x;
			if (0 <= n) {
				var s = (t.min.y - o.y) * n;
				n *= t.max.y - o.y
			} else s = (t.max.y - o.y) * n, n *= t.min.y - o.y;
			if (a > n || s > i) return null;
			if (s > a || a !== a) a = s;
			if (n < i || i !== i) i = n;
			0 <= r ? (s = (t.min.z - o.z) * r, t = (t.max.z - o.z) * r) : (s = (t.max.z - o.z) * r, t = (t.min.z - o.z) * r);
			if (a > t || s > i) return null;
			if (s > a || a !== a) a = s;
			if (t < i || i !== i) i = t;
			return 0 > i ? null : this.at(0 <= a ? a : i, e)
		},
		intersectsBox: function () {
			var e = new _t;
			return function (t) {
				return null !== this.intersectBox(t, e)
			}
		}(),
		intersectTriangle: function () {
			var o = new _t,
				a = new _t,
				s = new _t,
				l = new _t;
			return function (t, e, i, n, r) {
				a.subVectors(e, t);
				s.subVectors(i, t);
				l.crossVectors(a, s);
				e = this.direction.dot(l);
				if (0 < e) {
					if (n) return null;
					n = 1
				} else if (0 > e) n = -1, e = -e;
				else return null;
				o.subVectors(this.origin, t);
				t = n * this.direction.dot(s.crossVectors(o, s));
				if (0 > t) return null;
				i = n * this.direction.dot(a.cross(o));
				if (0 > i || t + i > e) return null;
				t = -n * o.dot(l);
				return 0 > t ? null : this.at(t / e, r)
			}
		}(),
		applyMatrix4: function (t) {
			this.origin.applyMatrix4(t);
			this.direction.transformDirection(t);
			return this
		},
		equals: function (t) {
			return t.origin.equals(this.origin) && t.direction.equals(this.direction)
		}
	});
	Object.assign(D.prototype, {
		set: function (t, e) {
			this.start.copy(t);
			this.end.copy(e);
			return this
		},
		clone: function () {
			return (new this.constructor).copy(this)
		},
		copy: function (t) {
			this.start.copy(t.start);
			this.end.copy(t.end);
			return this
		},
		getCenter: function (t) {
			void 0 === t && (console.warn("THREE.Line3: .getCenter() target is now required"), t = new _t);
			return t.addVectors(this.start, this.end).multiplyScalar(.5)
		},
		delta: function (t) {
			void 0 === t && (console.warn("THREE.Line3: .delta() target is now required"), t = new _t);
			return t.subVectors(this.end, this.start)
		},
		distanceSq: function () {
			return this.start.distanceToSquared(this.end)
		},
		distance: function () {
			return this.start.distanceTo(this.end)
		},
		at: function (t, e) {
			void 0 === e && (console.warn("THREE.Line3: .at() target is now required"), e = new _t);
			return this.delta(e).multiplyScalar(t).add(this.start)
		},
		closestPointToPointParameter: function () {
			var i = new _t,
				n = new _t;
			return function (t, e) {
				i.subVectors(t, this.start);
				n.subVectors(this.end, this.start);
				t = n.dot(n);
				t = n.dot(i) / t;
				e && (t = Kr.clamp(t, 0, 1));
				return t
			}
		}(),
		closestPointToPoint: function (t, e, i) {
			t = this.closestPointToPointParameter(t, e);
			void 0 === i && (console.warn("THREE.Line3: .closestPointToPoint() target is now required"), i = new _t);
			return this.delta(i).multiplyScalar(t).add(this.start)
		},
		applyMatrix4: function (t) {
			this.start.applyMatrix4(t);
			this.end.applyMatrix4(t);
			return this
		},
		equals: function (t) {
			return t.start.equals(this.start) && t.end.equals(this.end)
		}
	});
	Object.assign(U, {
		getNormal: function () {
			var r = new _t;
			return function (t, e, i, n) {
				void 0 === n && (console.warn("THREE.Triangle: .getNormal() target is now required"), n = new _t);
				n.subVectors(i, e);
				r.subVectors(t, e);
				n.cross(r);
				t = n.lengthSq();
				return 0 < t ? n.multiplyScalar(1 / Math.sqrt(t)) : n.set(0, 0, 0)
			}
		}(),
		getBarycoord: function () {
			var s = new _t,
				l = new _t,
				c = new _t;
			return function (t, e, i, n, r) {
				s.subVectors(n, e);
				l.subVectors(i, e);
				c.subVectors(t, e);
				t = s.dot(s);
				e = s.dot(l);
				i = s.dot(c);
				var o = l.dot(l);
				n = l.dot(c);
				var a = t * o - e * e;
				void 0 === r && (console.warn("THREE.Triangle: .getBarycoord() target is now required"), r = new _t);
				if (0 === a) return r.set(-2, -1, -1);
				a = 1 / a;
				o = (o * i - e * n) * a;
				t = (t * n - e * i) * a;
				return r.set(1 - o - t, t, o)
			}
		}(),
		containsPoint: function () {
			var r = new _t;
			return function (t, e, i, n) {
				U.getBarycoord(t, e, i, n, r);
				return 0 <= r.x && 0 <= r.y && 1 >= r.x + r.y
			}
		}()
	});
	Object.assign(U.prototype, {
		set: function (t, e, i) {
			this.a.copy(t);
			this.b.copy(e);
			this.c.copy(i);
			return this
		},
		setFromPointsAndIndices: function (t, e, i, n) {
			this.a.copy(t[e]);
			this.b.copy(t[i]);
			this.c.copy(t[n]);
			return this
		},
		clone: function () {
			return (new this.constructor).copy(this)
		},
		copy: function (t) {
			this.a.copy(t.a);
			this.b.copy(t.b);
			this.c.copy(t.c);
			return this
		},
		getArea: function () {
			var t = new _t,
				e = new _t;
			return function () {
				t.subVectors(this.c, this.b);
				e.subVectors(this.a, this.b);
				return .5 * t.cross(e).length()
			}
		}(),
		getMidpoint: function (t) {
			void 0 === t && (console.warn("THREE.Triangle: .getMidpoint() target is now required"), t = new _t);
			return t.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3)
		},
		getNormal: function (t) {
			return U.getNormal(this.a, this.b, this.c, t)
		},
		getPlane: function (t) {
			void 0 === t && (console.warn("THREE.Triangle: .getPlane() target is now required"), t = new _t);
			return t.setFromCoplanarPoints(this.a, this.b, this.c)
		},
		getBarycoord: function (t, e) {
			return U.getBarycoord(t, this.a, this.b, this.c, e)
		},
		containsPoint: function (t) {
			return U.containsPoint(t, this.a, this.b, this.c)
		},
		intersectsBox: function (t) {
			return t.intersectsTriangle(this)
		},
		closestPointToPoint: function () {
			var r = new v,
				o = [new D, new D, new D],
				a = new _t,
				s = new _t;
			return function (t, e) {
				void 0 === e && (console.warn("THREE.Triangle: .closestPointToPoint() target is now required"), e = new _t);
				var i = Infinity;
				r.setFromCoplanarPoints(this.a, this.b, this.c);
				r.projectPoint(t, a);
				if (!0 === this.containsPoint(a)) e.copy(a);
				else
					for (o[0].set(this.a, this.b), o[1].set(this.b, this.c), o[2].set(this.c, this.a), t = 0; t < o.length; t++) {
						o[t].closestPointToPoint(a, !0, s);
						var n = a.distanceToSquared(s);
						n < i && (i = n, e.copy(s))
					}
				return e
			}
		}(),
		equals: function (t) {
			return t.a.equals(this.a) && t.b.equals(this.b) && t.c.equals(this.c)
		}
	});
	z.prototype = Object.assign(Object.create(u.prototype), {
		constructor: z,
		isMesh: !0,
		setDrawMode: function (t) {
			this.drawMode = t
		},
		copy: function (t) {
			u.prototype.copy.call(this, t);
			this.drawMode = t.drawMode;
			void 0 !== t.morphTargetInfluences && (this.morphTargetInfluences = t.morphTargetInfluences.slice());
			void 0 !== t.morphTargetDictionary && (this.morphTargetDictionary = Object.assign({}, t.morphTargetDictionary));
			return this
		},
		updateMorphTargets: function () {
			var t = this.geometry;
			if (t.isBufferGeometry) {
				t = t.morphAttributes;
				var e = Object.keys(t);
				if (0 < e.length) {
					var i = t[e[0]];
					if (void 0 !== i)
						for (this.morphTargetInfluences = [], this.morphTargetDictionary = {}, t = 0, e = i.length; t < e; t++) {
							var n = i[t].name || String(t);
							this.morphTargetInfluences.push(0);
							this.morphTargetDictionary[n] = t
						}
				}
			} else if (i = t.morphTargets, void 0 !== i && 0 < i.length)
				for (this.morphTargetInfluences = [], this.morphTargetDictionary = {}, t = 0, e = i.length; t < e; t++) n = i[t].name || String(t), this.morphTargetInfluences.push(0), this.morphTargetDictionary[n] = t
		},
		raycast: function () {
			function b(t, e, i, n, r, o, a) {
				U.getBarycoord(t, e, i, n, s);
				r.multiplyScalar(s.x);
				o.multiplyScalar(s.y);
				a.multiplyScalar(s.z);
				r.add(o).add(a);
				return r.clone()
			}

			function w(t, e, i, n, r, o, a, s) {
				if (null === (1 === e.side ? n.intersectTriangle(a, o, r, !0, s) : n.intersectTriangle(r, o, a, 2 !== e.side, s))) return null;
				l.copy(s);
				l.applyMatrix4(t.matrixWorld);
				e = i.ray.origin.distanceTo(l);
				return e < i.near || e > i.far ? null : {
					distance: e,
					point: l.clone(),
					object: t
				}
			}

			function T(t, e, i, n, r, o, a, s) {
				A.fromBufferAttribute(n, o);
				C.fromBufferAttribute(n, a);
				P.fromBufferAttribute(n, s);
				if (t = w(t, t.material, e, i, A, C, P, D)) r && (k.fromBufferAttribute(r, o), N.fromBufferAttribute(r, a), I.fromBufferAttribute(r, s), t.uv = b(D, A, C, P, k, N, I)), r = new F(o, a, s), U.getNormal(A, C, P, r.normal), t.face = r;
				return t
			}
			var E = new xt,
				S = new B,
				M = new c,
				A = new _t,
				C = new _t,
				P = new _t,
				L = new _t,
				R = new _t,
				O = new _t,
				k = new W,
				N = new W,
				I = new W,
				s = new _t,
				D = new _t,
				l = new _t;
			return function (t, e) {
				var i = this.geometry,
					n = this.material,
					r = this.matrixWorld;
				if (void 0 !== n && (null === i.boundingSphere && i.computeBoundingSphere(), M.copy(i.boundingSphere), M.applyMatrix4(r), !1 !== t.ray.intersectsSphere(M) && (E.getInverse(r), S.copy(t.ray).applyMatrix4(E), null === i.boundingBox || !1 !== S.intersectsBox(i.boundingBox)))) {
					var o;
					if (i.isBufferGeometry) {
						n = i.index;
						var a = i.attributes.position;
						i = i.attributes.uv;
						var s;
						if (null !== n)
							for (r = 0, s = n.count; r < s; r += 3) {
								var l = n.getX(r);
								var c = n.getX(r + 1);
								var u = n.getX(r + 2);
								if (o = T(this, t, S, a, i, l, c, u)) o.faceIndex = Math.floor(r / 3), e.push(o)
							} else if (void 0 !== a)
								for (r = 0, s = a.count; r < s; r += 3)
									if (l = r, c = r + 1, u = r + 2, o = T(this, t, S, a, i, l, c, u)) o.faceIndex = Math.floor(r / 3), e.push(o)
					} else if (i.isGeometry) {
						r = Array.isArray(n);
						s = i.vertices;
						l = i.faces;
						c = i.faceVertexUvs[0];
						0 < c.length && (a = c);
						for (var h = 0, d = l.length; h < d; h++) {
							var f = l[h];
							o = r ? n[f.materialIndex] : n;
							if (void 0 !== o) {
								c = s[f.a];
								u = s[f.b];
								var p = s[f.c];
								if (!0 === o.morphTargets) {
									var m = i.morphTargets,
										g = this.morphTargetInfluences;
									A.set(0, 0, 0);
									C.set(0, 0, 0);
									P.set(0, 0, 0);
									for (var v = 0, y = m.length; v < y; v++) {
										var x = g[v];
										if (0 !== x) {
											var _ = m[v].vertices;
											A.addScaledVector(L.subVectors(_[f.a], c), x);
											C.addScaledVector(R.subVectors(_[f.b], u), x);
											P.addScaledVector(O.subVectors(_[f.c], p), x)
										}
									}
									A.add(c);
									C.add(u);
									P.add(p);
									c = A;
									u = C;
									p = P
								}
								if (o = w(this, o, t, S, c, u, p, D)) a && a[h] && (m = a[h], k.copy(m[0]), N.copy(m[1]), I.copy(m[2]), o.uv = b(D, c, u, p, k, N, I)), o.face = f, o.faceIndex = h, e.push(o)
							}
						}
					}
				}
			}
		}(),
		clone: function () {
			return new this.constructor(this.geometry, this.material).copy(this)
		}
	});
	H.prototype = Object.create(d.prototype);
	H.prototype.constructor = H;
	H.prototype.isCubeTexture = !0;
	Object.defineProperty(H.prototype, "images", {
		get: function () {
			return this.image
		},
		set: function (t) {
			this.image = t
		}
	});
	var uo = new d,
		ho = new H,
		fo = [],
		po = [],
		mo = new Float32Array(16),
		go = new Float32Array(9),
		vo = new Float32Array(4);
	Bt.prototype.updateCache = function (t) {
		var e = this.cache;
		t instanceof Float32Array && e.length !== t.length && (this.cache = new Float32Array(t.length));
		Y(e, t)
	};
	Ut.prototype.setValue = function (t, e) {
		for (var i = this.seq, n = 0, r = i.length; n !== r; ++n) {
			var o = i[n];
			o.setValue(t, e[o.id])
		}
	};
	var yo = /([\w\d_]+)(\])?(\[|\.)?/g;
	zt.prototype.setValue = function (t, e, i) {
		e = this.map[e];
		void 0 !== e && e.setValue(t, i, this.renderer)
	};
	zt.prototype.setOptional = function (t, e, i) {
		e = e[i];
		void 0 !== e && this.setValue(t, i, e)
	};
	zt.upload = function (t, e, i, n) {
		for (var r = 0, o = e.length; r !== o; ++r) {
			var a = e[r],
				s = i[a.id];
			!1 !== s.needsUpdate && a.setValue(t, s.value, n)
		}
	};
	zt.seqWithValue = function (t, e) {
		for (var i = [], n = 0, r = t.length; n !== r; ++n) {
			var o = t[n];
			o.id in e && i.push(o)
		}
		return i
	};
	var xo = 0,
		_o = 0;
	he.prototype = Object.create(k.prototype);
	he.prototype.constructor = he;
	he.prototype.isMeshDepthMaterial = !0;
	he.prototype.copy = function (t) {
		k.prototype.copy.call(this, t);
		this.depthPacking = t.depthPacking;
		this.skinning = t.skinning;
		this.morphTargets = t.morphTargets;
		this.map = t.map;
		this.alphaMap = t.alphaMap;
		this.displacementMap = t.displacementMap;
		this.displacementScale = t.displacementScale;
		this.displacementBias = t.displacementBias;
		this.wireframe = t.wireframe;
		this.wireframeLinewidth = t.wireframeLinewidth;
		return this
	};
	de.prototype = Object.create(k.prototype);
	de.prototype.constructor = de;
	de.prototype.isMeshDistanceMaterial = !0;
	de.prototype.copy = function (t) {
		k.prototype.copy.call(this, t);
		this.referencePosition.copy(t.referencePosition);
		this.nearDistance = t.nearDistance;
		this.farDistance = t.farDistance;
		this.skinning = t.skinning;
		this.morphTargets = t.morphTargets;
		this.map = t.map;
		this.alphaMap = t.alphaMap;
		this.displacementMap = t.displacementMap;
		this.displacementScale = t.displacementScale;
		this.displacementBias = t.displacementBias;
		return this
	};
	pe.prototype = Object.create(d.prototype);
	pe.prototype.constructor = pe;
	pe.prototype.isCanvasTexture = !0;
	xe.prototype = Object.assign(Object.create(l.prototype), {
		constructor: xe,
		isPerspectiveCamera: !0,
		copy: function (t, e) {
			l.prototype.copy.call(this, t, e);
			this.fov = t.fov;
			this.zoom = t.zoom;
			this.near = t.near;
			this.far = t.far;
			this.focus = t.focus;
			this.aspect = t.aspect;
			this.view = null === t.view ? null : Object.assign({}, t.view);
			this.filmGauge = t.filmGauge;
			this.filmOffset = t.filmOffset;
			return this
		},
		setFocalLength: function (t) {
			t = .5 * this.getFilmHeight() / t;
			this.fov = 2 * Kr.RAD2DEG * Math.atan(t);
			this.updateProjectionMatrix()
		},
		getFocalLength: function () {
			var t = Math.tan(.5 * Kr.DEG2RAD * this.fov);
			return .5 * this.getFilmHeight() / t
		},
		getEffectiveFOV: function () {
			return 2 * Kr.RAD2DEG * Math.atan(Math.tan(.5 * Kr.DEG2RAD * this.fov) / this.zoom)
		},
		getFilmWidth: function () {
			return this.filmGauge * Math.min(this.aspect, 1)
		},
		getFilmHeight: function () {
			return this.filmGauge / Math.max(this.aspect, 1)
		},
		setViewOffset: function (t, e, i, n, r, o) {
			this.aspect = t / e;
			null === this.view && (this.view = {
				enabled: !0,
				fullWidth: 1,
				fullHeight: 1,
				offsetX: 0,
				offsetY: 0,
				width: 1,
				height: 1
			});
			this.view.enabled = !0;
			this.view.fullWidth = t;
			this.view.fullHeight = e;
			this.view.offsetX = i;
			this.view.offsetY = n;
			this.view.width = r;
			this.view.height = o;
			this.updateProjectionMatrix()
		},
		clearViewOffset: function () {
			null !== this.view && (this.view.enabled = !1);
			this.updateProjectionMatrix()
		},
		updateProjectionMatrix: function () {
			var t = this.near,
				e = t * Math.tan(.5 * Kr.DEG2RAD * this.fov) / this.zoom,
				i = 2 * e,
				n = this.aspect * i,
				r = -.5 * n,
				o = this.view;
			if (null !== this.view && this.view.enabled) {
				var a = o.fullWidth,
					s = o.fullHeight;
				r += o.offsetX * n / a;
				e -= o.offsetY * i / s;
				n *= o.width / a;
				i *= o.height / s
			}
			o = this.filmOffset;
			0 !== o && (r += t * o / this.getFilmWidth());
			this.projectionMatrix.makePerspective(r, r + n, e, e - i, t, this.far)
		},
		toJSON: function (t) {
			t = u.prototype.toJSON.call(this, t);
			t.object.fov = this.fov;
			t.object.zoom = this.zoom;
			t.object.near = this.near;
			t.object.far = this.far;
			t.object.focus = this.focus;
			t.object.aspect = this.aspect;
			null !== this.view && (t.object.view = Object.assign({}, this.view));
			t.object.filmGauge = this.filmGauge;
			t.object.filmOffset = this.filmOffset;
			return t
		}
	});
	_e.prototype = Object.assign(Object.create(xe.prototype), {
		constructor: _e,
		isArrayCamera: !0
	});
	Ee.prototype.isFogExp2 = !0;
	Ee.prototype.clone = function () {
		return new Ee(this.color, this.density)
	};
	Ee.prototype.toJSON = function () {
		return {
			type: "FogExp2",
			color: this.color.getHex(),
			density: this.density
		}
	};
	Se.prototype.isFog = !0;
	Se.prototype.clone = function () {
		return new Se(this.color, this.near, this.far)
	};
	Se.prototype.toJSON = function () {
		return {
			type: "Fog",
			color: this.color.getHex(),
			near: this.near,
			far: this.far
		}
	};
	Me.prototype = Object.assign(Object.create(u.prototype), {
		constructor: Me,
		copy: function (t, e) {
			u.prototype.copy.call(this, t, e);
			null !== t.background && (this.background = t.background.clone());
			null !== t.fog && (this.fog = t.fog.clone());
			null !== t.overrideMaterial && (this.overrideMaterial = t.overrideMaterial.clone());
			this.autoUpdate = t.autoUpdate;
			this.matrixAutoUpdate = t.matrixAutoUpdate;
			return this
		},
		toJSON: function (t) {
			var e = u.prototype.toJSON.call(this, t);
			null !== this.background && (e.object.background = this.background.toJSON(t));
			null !== this.fog && (e.object.fog = this.fog.toJSON());
			return e
		}
	});
	Ae.prototype = Object.create(k.prototype);
	Ae.prototype.constructor = Ae;
	Ae.prototype.isSpriteMaterial = !0;
	Ae.prototype.copy = function (t) {
		k.prototype.copy.call(this, t);
		this.color.copy(t.color);
		this.map = t.map;
		this.rotation = t.rotation;
		return this
	};
	Ce.prototype = Object.assign(Object.create(u.prototype), {
		constructor: Ce,
		isSprite: !0,
		raycast: function () {
			var n = new _t,
				r = new _t,
				o = new _t;
			return function (t, e) {
				r.setFromMatrixPosition(this.matrixWorld);
				t.ray.closestPointToPoint(r, n);
				o.setFromMatrixScale(this.matrixWorld);
				var i = o.x * o.y / 4;
				r.distanceToSquared(n) > i || (i = t.ray.origin.distanceTo(n), i < t.near || i > t.far || e.push({
					distance: i,
					point: n.clone(),
					face: null,
					object: this
				}))
			}
		}(),
		clone: function () {
			return new this.constructor(this.material).copy(this)
		},
		copy: function (t) {
			u.prototype.copy.call(this, t);
			void 0 !== t.center && this.center.copy(t.center);
			return this
		}
	});
	Pe.prototype = Object.assign(Object.create(u.prototype), {
		constructor: Pe,
		copy: function (t) {
			u.prototype.copy.call(this, t, !1);
			t = t.levels;
			for (var e = 0, i = t.length; e < i; e++) {
				var n = t[e];
				this.addLevel(n.object.clone(), n.distance)
			}
			return this
		},
		addLevel: function (t, e) {
			void 0 === e && (e = 0);
			e = Math.abs(e);
			for (var i = this.levels, n = 0; n < i.length && !(e < i[n].distance); n++);
			i.splice(n, 0, {
				distance: e,
				object: t
			});
			this.add(t)
		},
		getObjectForDistance: function (t) {
			for (var e = this.levels, i = 1, n = e.length; i < n && !(t < e[i].distance); i++);
			return e[i - 1].object
		},
		raycast: function () {
			var n = new _t;
			return function (t, e) {
				n.setFromMatrixPosition(this.matrixWorld);
				var i = t.ray.origin.distanceTo(n);
				this.getObjectForDistance(i).raycast(t, e)
			}
		}(),
		update: function () {
			var r = new _t,
				o = new _t;
			return function (t) {
				var e = this.levels;
				if (1 < e.length) {
					r.setFromMatrixPosition(t.matrixWorld);
					o.setFromMatrixPosition(this.matrixWorld);
					t = r.distanceTo(o);
					e[0].object.visible = !0;
					for (var i = 1, n = e.length; i < n; i++)
						if (t >= e[i].distance) e[i - 1].object.visible = !1, e[i].object.visible = !0;
						else break;
					for (; i < n; i++) e[i].object.visible = !1
				}
			}
		}(),
		toJSON: function (t) {
			t = u.prototype.toJSON.call(this, t);
			t.object.levels = [];
			for (var e = this.levels, i = 0, n = e.length; i < n; i++) {
				var r = e[i];
				t.object.levels.push({
					object: r.object.uuid,
					distance: r.distance
				})
			}
			return t
		}
	});
	Object.assign(Le.prototype, {
		calculateInverses: function () {
			this.boneInverses = [];
			for (var t = 0, e = this.bones.length; t < e; t++) {
				var i = new xt;
				this.bones[t] && i.getInverse(this.bones[t].matrixWorld);
				this.boneInverses.push(i)
			}
		},
		pose: function () {
			var t, e;
			var i = 0;
			for (e = this.bones.length; i < e; i++)(t = this.bones[i]) && t.matrixWorld.getInverse(this.boneInverses[i]);
			i = 0;
			for (e = this.bones.length; i < e; i++)
				if (t = this.bones[i]) t.parent && t.parent.isBone ? (t.matrix.getInverse(t.parent.matrixWorld), t.matrix.multiply(t.matrixWorld)) : t.matrix.copy(t.matrixWorld), t.matrix.decompose(t.position, t.quaternion, t.scale)
		},
		update: function () {
			var a = new xt,
				s = new xt;
			return function () {
				for (var t = this.bones, e = this.boneInverses, i = this.boneMatrices, n = this.boneTexture, r = 0, o = t.length; r < o; r++) a.multiplyMatrices(t[r] ? t[r].matrixWorld : s, e[r]), a.toArray(i, 16 * r);
				void 0 !== n && (n.needsUpdate = !0)
			}
		}(),
		clone: function () {
			return new Le(this.bones, this.boneInverses)
		},
		getBoneByName: function (t) {
			for (var e = 0, i = this.bones.length; e < i; e++) {
				var n = this.bones[e];
				if (n.name === t) return n
			}
		}
	});
	Re.prototype = Object.assign(Object.create(u.prototype), {
		constructor: Re,
		isBone: !0
	});
	Oe.prototype = Object.assign(Object.create(z.prototype), {
		constructor: Oe,
		isSkinnedMesh: !0,
		initBones: function () {
			var t = [],
				e;
			if (this.geometry && void 0 !== this.geometry.bones) {
				var i = 0;
				for (e = this.geometry.bones.length; i < e; i++) {
					var n = this.geometry.bones[i];
					var r = new Re;
					t.push(r);
					r.name = n.name;
					r.position.fromArray(n.pos);
					r.quaternion.fromArray(n.rotq);
					void 0 !== n.scl && r.scale.fromArray(n.scl)
				}
				i = 0;
				for (e = this.geometry.bones.length; i < e; i++) n = this.geometry.bones[i], -1 !== n.parent && null !== n.parent && void 0 !== t[n.parent] ? t[n.parent].add(t[i]) : this.add(t[i])
			}
			this.updateMatrixWorld(!0);
			return t
		},
		bind: function (t, e) {
			this.skeleton = t;
			void 0 === e && (this.updateMatrixWorld(!0), this.skeleton.calculateInverses(), e = this.matrixWorld);
			this.bindMatrix.copy(e);
			this.bindMatrixInverse.getInverse(e)
		},
		pose: function () {
			this.skeleton.pose()
		},
		normalizeSkinWeights: function () {
			var t;
			if (this.geometry && this.geometry.isGeometry)
				for (t = 0; t < this.geometry.skinWeights.length; t++) {
					var e = this.geometry.skinWeights[t];
					var i = 1 / e.manhattanLength();
					Infinity !== i ? e.multiplyScalar(i) : e.set(1, 0, 0, 0)
				} else if (this.geometry && this.geometry.isBufferGeometry) {
					e = new bt;
					var n = this.geometry.attributes.skinWeight;
					for (t = 0; t < n.count; t++) e.x = n.getX(t), e.y = n.getY(t), e.z = n.getZ(t), e.w = n.getW(t), i = 1 / e.manhattanLength(), Infinity !== i ? e.multiplyScalar(i) : e.set(1, 0, 0, 0), n.setXYZW(t, e.x, e.y, e.z, e.w)
				}
		},
		updateMatrixWorld: function (t) {
			z.prototype.updateMatrixWorld.call(this, t);
			"attached" === this.bindMode ? this.bindMatrixInverse.getInverse(this.matrixWorld) : "detached" === this.bindMode ? this.bindMatrixInverse.getInverse(this.bindMatrix) : console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode)
		},
		clone: function () {
			return new this.constructor(this.geometry, this.material).copy(this)
		}
	});
	ke.prototype = Object.create(k.prototype);
	ke.prototype.constructor = ke;
	ke.prototype.isLineBasicMaterial = !0;
	ke.prototype.copy = function (t) {
		k.prototype.copy.call(this, t);
		this.color.copy(t.color);
		this.linewidth = t.linewidth;
		this.linecap = t.linecap;
		this.linejoin = t.linejoin;
		return this
	};
	Ne.prototype = Object.assign(Object.create(u.prototype), {
		constructor: Ne,
		isLine: !0,
		computeLineDistances: function () {
			var o = new _t,
				a = new _t;
			return function () {
				var t = this.geometry;
				if (t.isBufferGeometry)
					if (null === t.index) {
						for (var e = t.attributes.position, i = [0], n = 1, r = e.count; n < r; n++) o.fromBufferAttribute(e, n - 1), a.fromBufferAttribute(e, n), i[n] = i[n - 1], i[n] += o.distanceTo(a);
						t.addAttribute("lineDistance", new P(i, 1))
					} else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
				else if (t.isGeometry)
					for (e = t.vertices, i = t.lineDistances, i[0] = 0, n = 1, r = e.length; n < r; n++) i[n] = i[n - 1], i[n] += e[n - 1].distanceTo(e[n]);
				return this
			}
		}(),
		raycast: function () {
			var f = new xt,
				p = new B,
				m = new c;
			return function (t, e) {
				var i = t.linePrecision;
				i *= i;
				var n = this.geometry,
					r = this.matrixWorld;
				null === n.boundingSphere && n.computeBoundingSphere();
				m.copy(n.boundingSphere);
				m.applyMatrix4(r);
				if (!1 !== t.ray.intersectsSphere(m)) {
					f.getInverse(r);
					p.copy(t.ray).applyMatrix4(f);
					var o = new _t,
						a = new _t;
					r = new _t;
					var s = new _t,
						l = this && this.isLineSegments ? 2 : 1;
					if (n.isBufferGeometry) {
						var c = n.index,
							u = n.attributes.position.array;
						if (null !== c) {
							c = c.array;
							n = 0;
							for (var h = c.length - 1; n < h; n += l) {
								var d = c[n + 1];
								o.fromArray(u, 3 * c[n]);
								a.fromArray(u, 3 * d);
								d = p.distanceSqToSegment(o, a, s, r);
								d > i || (s.applyMatrix4(this.matrixWorld), d = t.ray.origin.distanceTo(s), d < t.near || d > t.far || e.push({
									distance: d,
									point: r.clone().applyMatrix4(this.matrixWorld),
									index: n,
									face: null,
									faceIndex: null,
									object: this
								}))
							}
						} else
							for (n = 0, h = u.length / 3 - 1; n < h; n += l) o.fromArray(u, 3 * n), a.fromArray(u, 3 * n + 3), d = p.distanceSqToSegment(o, a, s, r), d > i || (s.applyMatrix4(this.matrixWorld), d = t.ray.origin.distanceTo(s), d < t.near || d > t.far || e.push({
								distance: d,
								point: r.clone().applyMatrix4(this.matrixWorld),
								index: n,
								face: null,
								faceIndex: null,
								object: this
							}))
					} else if (n.isGeometry)
						for (o = n.vertices, a = o.length, n = 0; n < a - 1; n += l) d = p.distanceSqToSegment(o[n], o[n + 1], s, r), d > i || (s.applyMatrix4(this.matrixWorld), d = t.ray.origin.distanceTo(s), d < t.near || d > t.far || e.push({
							distance: d,
							point: r.clone().applyMatrix4(this.matrixWorld),
							index: n,
							face: null,
							faceIndex: null,
							object: this
						}))
				}
			}
		}(),
		clone: function () {
			return new this.constructor(this.geometry, this.material).copy(this)
		}
	});
	Ie.prototype = Object.assign(Object.create(Ne.prototype), {
		constructor: Ie,
		isLineSegments: !0,
		computeLineDistances: function () {
			var o = new _t,
				a = new _t;
			return function () {
				var t = this.geometry;
				if (t.isBufferGeometry)
					if (null === t.index) {
						for (var e = t.attributes.position, i = [], n = 0, r = e.count; n < r; n += 2) o.fromBufferAttribute(e, n), a.fromBufferAttribute(e, n + 1), i[n] = 0 === n ? 0 : i[n - 1], i[n + 1] = i[n] + o.distanceTo(a);
						t.addAttribute("lineDistance", new P(i, 1))
					} else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
				else if (t.isGeometry)
					for (e = t.vertices, i = t.lineDistances, n = 0, r = e.length; n < r; n += 2) o.copy(e[n]), a.copy(e[n + 1]), i[n] = 0 === n ? 0 : i[n - 1], i[n + 1] = i[n] + o.distanceTo(a);
				return this
			}
		}()
	});
	De.prototype = Object.assign(Object.create(Ne.prototype), {
		constructor: De,
		isLineLoop: !0
	});
	Fe.prototype = Object.create(k.prototype);
	Fe.prototype.constructor = Fe;
	Fe.prototype.isPointsMaterial = !0;
	Fe.prototype.copy = function (t) {
		k.prototype.copy.call(this, t);
		this.color.copy(t.color);
		this.map = t.map;
		this.size = t.size;
		this.sizeAttenuation = t.sizeAttenuation;
		this.morphTargets = t.morphTargets;
		return this
	};
	Be.prototype = Object.assign(Object.create(u.prototype), {
		constructor: Be,
		isPoints: !0,
		raycast: function () {
			var f = new xt,
				p = new B,
				m = new c;
			return function (n, r) {
				function t(t, e) {
					var i = p.distanceSqToPoint(t);
					i < s && (p.closestPointToPoint(t, l), l.applyMatrix4(a), t = n.ray.origin.distanceTo(l), t < n.near || t > n.far || r.push({
						distance: t,
						distanceToRay: Math.sqrt(i),
						point: l.clone(),
						index: e,
						face: null,
						object: o
					}))
				}
				var o = this,
					e = this.geometry,
					a = this.matrixWorld,
					i = n.params.Points.threshold;
				null === e.boundingSphere && e.computeBoundingSphere();
				m.copy(e.boundingSphere);
				m.applyMatrix4(a);
				m.radius += i;
				if (!1 !== n.ray.intersectsSphere(m)) {
					f.getInverse(a);
					p.copy(n.ray).applyMatrix4(f);
					i /= (this.scale.x + this.scale.y + this.scale.z) / 3;
					var s = i * i;
					i = new _t;
					var l = new _t;
					if (e.isBufferGeometry) {
						var c = e.index;
						e = e.attributes.position.array;
						if (null !== c) {
							var u = c.array;
							c = 0;
							for (var h = u.length; c < h; c++) {
								var d = u[c];
								i.fromArray(e, 3 * d);
								t(i, d)
							}
						} else
							for (c = 0, u = e.length / 3; c < u; c++) i.fromArray(e, 3 * c), t(i, c)
					} else
						for (i = e.vertices, c = 0, u = i.length; c < u; c++) t(i[c], c)
				}
			}
		}(),
		clone: function () {
			return new this.constructor(this.geometry, this.material).copy(this)
		}
	});
	Ue.prototype = Object.assign(Object.create(u.prototype), {
		constructor: Ue,
		isGroup: !0
	});
	ze.prototype = Object.assign(Object.create(d.prototype), {
		constructor: ze,
		isVideoTexture: !0,
		update: function () {
			var t = this.image;
			t.readyState >= t.HAVE_CURRENT_DATA && (this.needsUpdate = !0)
		}
	});
	Ge.prototype = Object.create(d.prototype);
	Ge.prototype.constructor = Ge;
	Ge.prototype.isCompressedTexture = !0;
	He.prototype = Object.create(d.prototype);
	He.prototype.constructor = He;
	He.prototype.isDepthTexture = !0;
	je.prototype = Object.create(L.prototype);
	je.prototype.constructor = je;
	Ve.prototype = Object.create(T.prototype);
	Ve.prototype.constructor = Ve;
	We.prototype = Object.create(L.prototype);
	We.prototype.constructor = We;
	Xe.prototype = Object.create(T.prototype);
	Xe.prototype.constructor = Xe;
	Ye.prototype = Object.create(L.prototype);
	Ye.prototype.constructor = Ye;
	qe.prototype = Object.create(T.prototype);
	qe.prototype.constructor = qe;
	$e.prototype = Object.create(Ye.prototype);
	$e.prototype.constructor = $e;
	Ze.prototype = Object.create(T.prototype);
	Ze.prototype.constructor = Ze;
	Je.prototype = Object.create(Ye.prototype);
	Je.prototype.constructor = Je;
	Qe.prototype = Object.create(T.prototype);
	Qe.prototype.constructor = Qe;
	Ke.prototype = Object.create(Ye.prototype);
	Ke.prototype.constructor = Ke;
	ti.prototype = Object.create(T.prototype);
	ti.prototype.constructor = ti;
	ei.prototype = Object.create(Ye.prototype);
	ei.prototype.constructor = ei;
	ii.prototype = Object.create(T.prototype);
	ii.prototype.constructor = ii;
	ni.prototype = Object.create(L.prototype);
	ni.prototype.constructor = ni;
	ri.prototype = Object.create(T.prototype);
	ri.prototype.constructor = ri;
	oi.prototype = Object.create(L.prototype);
	oi.prototype.constructor = oi;
	ai.prototype = Object.create(T.prototype);
	ai.prototype.constructor = ai;
	si.prototype = Object.create(L.prototype);
	si.prototype.constructor = si;
	var bo = {
			triangulate: function (t, e, i) {
				i = i || 2;
				var n = e && e.length,
					r = n ? e[0] * i : t.length,
					o = li(t, 0, r, i, !0),
					a = [];
				if (!o) return a;
				var s;
				if (n) {
					var l = i;
					n = [];
					var c;
					var u = 0;
					for (c = e.length; u < c; u++) {
						var h = e[u] * l;
						var d = u < c - 1 ? e[u + 1] * l : t.length;
						h = li(t, h, d, l, !1);
						h === h.next && (h.steiner = !0);
						n.push(pi(h))
					}
					n.sort(hi);
					for (u = 0; u < n.length; u++) {
						e = n[u];
						l = o;
						if (l = di(e, l)) e = _i(l, e), ci(e, e.next);
						o = ci(o, o.next)
					}
				}
				if (t.length > 80 * i) {
					var f = s = t[0];
					var p = n = t[1];
					for (l = i; l < r; l += i) u = t[l], e = t[l + 1], u < f && (f = u), e < p && (p = e), u > s && (s = u), e > n && (n = e);
					s = Math.max(s - f, n - p);
					s = 0 !== s ? 1 / s : 0
				}
				ui(o, a, i, f, p, s);
				return a
			}
		},
		wo = {
			area: function (t) {
				for (var e = t.length, i = 0, n = e - 1, r = 0; r < e; n = r++) i += t[n].x * t[r].y - t[r].x * t[n].y;
				return .5 * i
			},
			isClockWise: function (t) {
				return 0 > wo.area(t)
			},
			triangulateShape: function (t, e) {
				var i = [],
					n = [],
					r = [];
				Ei(t);
				Si(i, t);
				var o = t.length;
				e.forEach(Ei);
				for (t = 0; t < e.length; t++) n.push(o), o += e[t].length, Si(i, e[t]);
				e = bo.triangulate(i, n);
				for (t = 0; t < e.length; t += 3) r.push(e.slice(t, t + 3));
				return r
			}
		};
	Mi.prototype = Object.create(T.prototype);
	Mi.prototype.constructor = Mi;
	Mi.prototype.toJSON = function () {
		var t = T.prototype.toJSON.call(this);
		return Ci(this.parameters.shapes, this.parameters.options, t)
	};
	Ai.prototype = Object.create(L.prototype);
	Ai.prototype.constructor = Ai;
	Ai.prototype.toJSON = function () {
		var t = L.prototype.toJSON.call(this);
		return Ci(this.parameters.shapes, this.parameters.options, t)
	};
	var To = {
		generateTopUV: function (t, e, i, n, r) {
			t = e[3 * n];
			n = e[3 * n + 1];
			var o = e[3 * r];
			r = e[3 * r + 1];
			return [new W(e[3 * i], e[3 * i + 1]), new W(t, n), new W(o, r)]
		},
		generateSideWallUV: function (t, e, i, n, r, o) {
			t = e[3 * i];
			var a = e[3 * i + 1];
			i = e[3 * i + 2];
			var s = e[3 * n],
				l = e[3 * n + 1];
			n = e[3 * n + 2];
			var c = e[3 * r],
				u = e[3 * r + 1];
			r = e[3 * r + 2];
			var h = e[3 * o],
				d = e[3 * o + 1];
			e = e[3 * o + 2];
			return .01 > Math.abs(a - l) ? [new W(t, 1 - i), new W(s, 1 - n), new W(c, 1 - r), new W(h, 1 - e)] : [new W(a, 1 - i), new W(l, 1 - n), new W(u, 1 - r), new W(d, 1 - e)]
		}
	};
	Pi.prototype = Object.create(T.prototype);
	Pi.prototype.constructor = Pi;
	Li.prototype = Object.create(Ai.prototype);
	Li.prototype.constructor = Li;
	Ri.prototype = Object.create(T.prototype);
	Ri.prototype.constructor = Ri;
	Oi.prototype = Object.create(L.prototype);
	Oi.prototype.constructor = Oi;
	ki.prototype = Object.create(T.prototype);
	ki.prototype.constructor = ki;
	Ni.prototype = Object.create(L.prototype);
	Ni.prototype.constructor = Ni;
	Ii.prototype = Object.create(T.prototype);
	Ii.prototype.constructor = Ii;
	Di.prototype = Object.create(L.prototype);
	Di.prototype.constructor = Di;
	Fi.prototype = Object.create(T.prototype);
	Fi.prototype.constructor = Fi;
	Fi.prototype.toJSON = function () {
		var t = T.prototype.toJSON.call(this);
		return Ui(this.parameters.shapes, t)
	};
	Bi.prototype = Object.create(L.prototype);
	Bi.prototype.constructor = Bi;
	Bi.prototype.toJSON = function () {
		var t = L.prototype.toJSON.call(this);
		return Ui(this.parameters.shapes, t)
	};
	zi.prototype = Object.create(L.prototype);
	zi.prototype.constructor = zi;
	Gi.prototype = Object.create(T.prototype);
	Gi.prototype.constructor = Gi;
	Hi.prototype = Object.create(L.prototype);
	Hi.prototype.constructor = Hi;
	ji.prototype = Object.create(Gi.prototype);
	ji.prototype.constructor = ji;
	Vi.prototype = Object.create(Hi.prototype);
	Vi.prototype.constructor = Vi;
	Wi.prototype = Object.create(T.prototype);
	Wi.prototype.constructor = Wi;
	Xi.prototype = Object.create(L.prototype);
	Xi.prototype.constructor = Xi;
	var Eo = Object.freeze({
		WireframeGeometry: je,
		ParametricGeometry: Ve,
		ParametricBufferGeometry: We,
		TetrahedronGeometry: qe,
		TetrahedronBufferGeometry: $e,
		OctahedronGeometry: Ze,
		OctahedronBufferGeometry: Je,
		IcosahedronGeometry: Qe,
		IcosahedronBufferGeometry: Ke,
		DodecahedronGeometry: ti,
		DodecahedronBufferGeometry: ei,
		PolyhedronGeometry: Xe,
		PolyhedronBufferGeometry: Ye,
		TubeGeometry: ii,
		TubeBufferGeometry: ni,
		TorusKnotGeometry: ri,
		TorusKnotBufferGeometry: oi,
		TorusGeometry: ai,
		TorusBufferGeometry: si,
		TextGeometry: Pi,
		TextBufferGeometry: Li,
		SphereGeometry: Ri,
		SphereBufferGeometry: Oi,
		RingGeometry: ki,
		RingBufferGeometry: Ni,
		PlaneGeometry: R,
		PlaneBufferGeometry: O,
		LatheGeometry: Ii,
		LatheBufferGeometry: Di,
		ShapeGeometry: Fi,
		ShapeBufferGeometry: Bi,
		ExtrudeGeometry: Mi,
		ExtrudeBufferGeometry: Ai,
		EdgesGeometry: zi,
		ConeGeometry: ji,
		ConeBufferGeometry: Vi,
		CylinderGeometry: Gi,
		CylinderBufferGeometry: Hi,
		CircleGeometry: Wi,
		CircleBufferGeometry: Xi,
		BoxGeometry: M,
		BoxBufferGeometry: C
	});
	Yi.prototype = Object.create(k.prototype);
	Yi.prototype.constructor = Yi;
	Yi.prototype.isShadowMaterial = !0;
	Yi.prototype.copy = function (t) {
		k.prototype.copy.call(this, t);
		this.color.copy(t.color);
		return this
	};
	qi.prototype = Object.create(I.prototype);
	qi.prototype.constructor = qi;
	qi.prototype.isRawShaderMaterial = !0;
	$i.prototype = Object.create(k.prototype);
	$i.prototype.constructor = $i;
	$i.prototype.isMeshStandardMaterial = !0;
	$i.prototype.copy = function (t) {
		k.prototype.copy.call(this, t);
		this.defines = {
			STANDARD: ""
		};
		this.color.copy(t.color);
		this.roughness = t.roughness;
		this.metalness = t.metalness;
		this.map = t.map;
		this.lightMap = t.lightMap;
		this.lightMapIntensity = t.lightMapIntensity;
		this.aoMap = t.aoMap;
		this.aoMapIntensity = t.aoMapIntensity;
		this.emissive.copy(t.emissive);
		this.emissiveMap = t.emissiveMap;
		this.emissiveIntensity = t.emissiveIntensity;
		this.bumpMap = t.bumpMap;
		this.bumpScale = t.bumpScale;
		this.normalMap = t.normalMap;
		this.normalScale.copy(t.normalScale);
		this.displacementMap = t.displacementMap;
		this.displacementScale = t.displacementScale;
		this.displacementBias = t.displacementBias;
		this.roughnessMap = t.roughnessMap;
		this.metalnessMap = t.metalnessMap;
		this.alphaMap = t.alphaMap;
		this.envMap = t.envMap;
		this.envMapIntensity = t.envMapIntensity;
		this.refractionRatio = t.refractionRatio;
		this.wireframe = t.wireframe;
		this.wireframeLinewidth = t.wireframeLinewidth;
		this.wireframeLinecap = t.wireframeLinecap;
		this.wireframeLinejoin = t.wireframeLinejoin;
		this.skinning = t.skinning;
		this.morphTargets = t.morphTargets;
		this.morphNormals = t.morphNormals;
		return this
	};
	Zi.prototype = Object.create($i.prototype);
	Zi.prototype.constructor = Zi;
	Zi.prototype.isMeshPhysicalMaterial = !0;
	Zi.prototype.copy = function (t) {
		$i.prototype.copy.call(this, t);
		this.defines = {
			PHYSICAL: ""
		};
		this.reflectivity = t.reflectivity;
		this.clearCoat = t.clearCoat;
		this.clearCoatRoughness = t.clearCoatRoughness;
		return this
	};
	Ji.prototype = Object.create(k.prototype);
	Ji.prototype.constructor = Ji;
	Ji.prototype.isMeshPhongMaterial = !0;
	Ji.prototype.copy = function (t) {
		k.prototype.copy.call(this, t);
		this.color.copy(t.color);
		this.specular.copy(t.specular);
		this.shininess = t.shininess;
		this.map = t.map;
		this.lightMap = t.lightMap;
		this.lightMapIntensity = t.lightMapIntensity;
		this.aoMap = t.aoMap;
		this.aoMapIntensity = t.aoMapIntensity;
		this.emissive.copy(t.emissive);
		this.emissiveMap = t.emissiveMap;
		this.emissiveIntensity = t.emissiveIntensity;
		this.bumpMap = t.bumpMap;
		this.bumpScale = t.bumpScale;
		this.normalMap = t.normalMap;
		this.normalScale.copy(t.normalScale);
		this.displacementMap = t.displacementMap;
		this.displacementScale = t.displacementScale;
		this.displacementBias = t.displacementBias;
		this.specularMap = t.specularMap;
		this.alphaMap = t.alphaMap;
		this.envMap = t.envMap;
		this.combine = t.combine;
		this.reflectivity = t.reflectivity;
		this.refractionRatio = t.refractionRatio;
		this.wireframe = t.wireframe;
		this.wireframeLinewidth = t.wireframeLinewidth;
		this.wireframeLinecap = t.wireframeLinecap;
		this.wireframeLinejoin = t.wireframeLinejoin;
		this.skinning = t.skinning;
		this.morphTargets = t.morphTargets;
		this.morphNormals = t.morphNormals;
		return this
	};
	Qi.prototype = Object.create(Ji.prototype);
	Qi.prototype.constructor = Qi;
	Qi.prototype.isMeshToonMaterial = !0;
	Qi.prototype.copy = function (t) {
		Ji.prototype.copy.call(this, t);
		this.gradientMap = t.gradientMap;
		return this
	};
	Ki.prototype = Object.create(k.prototype);
	Ki.prototype.constructor = Ki;
	Ki.prototype.isMeshNormalMaterial = !0;
	Ki.prototype.copy = function (t) {
		k.prototype.copy.call(this, t);
		this.bumpMap = t.bumpMap;
		this.bumpScale = t.bumpScale;
		this.normalMap = t.normalMap;
		this.normalScale.copy(t.normalScale);
		this.displacementMap = t.displacementMap;
		this.displacementScale = t.displacementScale;
		this.displacementBias = t.displacementBias;
		this.wireframe = t.wireframe;
		this.wireframeLinewidth = t.wireframeLinewidth;
		this.skinning = t.skinning;
		this.morphTargets = t.morphTargets;
		this.morphNormals = t.morphNormals;
		return this
	};
	tn.prototype = Object.create(k.prototype);
	tn.prototype.constructor = tn;
	tn.prototype.isMeshLambertMaterial = !0;
	tn.prototype.copy = function (t) {
		k.prototype.copy.call(this, t);
		this.color.copy(t.color);
		this.map = t.map;
		this.lightMap = t.lightMap;
		this.lightMapIntensity = t.lightMapIntensity;
		this.aoMap = t.aoMap;
		this.aoMapIntensity = t.aoMapIntensity;
		this.emissive.copy(t.emissive);
		this.emissiveMap = t.emissiveMap;
		this.emissiveIntensity = t.emissiveIntensity;
		this.specularMap = t.specularMap;
		this.alphaMap = t.alphaMap;
		this.envMap = t.envMap;
		this.combine = t.combine;
		this.reflectivity = t.reflectivity;
		this.refractionRatio = t.refractionRatio;
		this.wireframe = t.wireframe;
		this.wireframeLinewidth = t.wireframeLinewidth;
		this.wireframeLinecap = t.wireframeLinecap;
		this.wireframeLinejoin = t.wireframeLinejoin;
		this.skinning = t.skinning;
		this.morphTargets = t.morphTargets;
		this.morphNormals = t.morphNormals;
		return this
	};
	en.prototype = Object.create(ke.prototype);
	en.prototype.constructor = en;
	en.prototype.isLineDashedMaterial = !0;
	en.prototype.copy = function (t) {
		ke.prototype.copy.call(this, t);
		this.scale = t.scale;
		this.dashSize = t.dashSize;
		this.gapSize = t.gapSize;
		return this
	};
	var So = Object.freeze({
			ShadowMaterial: Yi,
			SpriteMaterial: Ae,
			RawShaderMaterial: qi,
			ShaderMaterial: I,
			PointsMaterial: Fe,
			MeshPhysicalMaterial: Zi,
			MeshStandardMaterial: $i,
			MeshPhongMaterial: Ji,
			MeshToonMaterial: Qi,
			MeshNormalMaterial: Ki,
			MeshLambertMaterial: tn,
			MeshDepthMaterial: he,
			MeshDistanceMaterial: de,
			MeshBasicMaterial: N,
			LineDashedMaterial: en,
			LineBasicMaterial: ke,
			Material: k
		}),
		Mo = {
			enabled: !1,
			files: {},
			add: function (t, e) {
				!1 !== this.enabled && (this.files[t] = e)
			},
			get: function (t) {
				if (!1 !== this.enabled) return this.files[t]
			},
			remove: function (t) {
				delete this.files[t]
			},
			clear: function () {
				this.files = {}
			}
		},
		Ao = new nn,
		Co = {};
	Object.assign(rn.prototype, {
		load: function (a, t, e, i) {
			void 0 === a && (a = "");
			void 0 !== this.path && (a = this.path + a);
			a = this.manager.resolveURL(a);
			var s = this,
				n = Mo.get(a);
			if (void 0 !== n) return s.manager.itemStart(a), setTimeout(function () {
				t && t(n);
				s.manager.itemEnd(a)
			}, 0), n;
			if (void 0 !== Co[a]) Co[a].push({
				onLoad: t,
				onProgress: e,
				onError: i
			});
			else {
				var r = a.match(/^data:(.*?)(;base64)?,(.*)$/);
				if (r) {
					e = r[1];
					var o = !!r[2];
					r = r[3];
					r = window.decodeURIComponent(r);
					o && (r = window.atob(r));
					try {
						var l = (this.responseType || "").toLowerCase();
						switch (l) {
							case "arraybuffer":
							case "blob":
								var c = new Uint8Array(r.length);
								for (o = 0; o < r.length; o++) c[o] = r.charCodeAt(o);
								var u = "blob" === l ? new Blob([c.buffer], {
									type: e
								}) : c.buffer;
								break;
							case "document":
								u = (new DOMParser).parseFromString(r, e);
								break;
							case "json":
								u = JSON.parse(r);
								break;
							default:
								u = r
						}
						window.setTimeout(function () {
							t && t(u);
							s.manager.itemEnd(a)
						}, 0)
					} catch (t) {
						window.setTimeout(function () {
							i && i(t);
							s.manager.itemEnd(a);
							s.manager.itemError(a)
						}, 0)
					}
				} else {
					Co[a] = [];
					Co[a].push({
						onLoad: t,
						onProgress: e,
						onError: i
					});
					var h = new XMLHttpRequest;
					h.open("GET", a, !0);
					h.addEventListener("load", function (t) {
						var e = this.response;
						Mo.add(a, e);
						var i = Co[a];
						delete Co[a];
						if (200 === this.status || 0 === this.status) {
							0 === this.status && console.warn("THREE.FileLoader: HTTP Status 0 received.");
							for (var n = 0, r = i.length; n < r; n++) {
								var o = i[n];
								if (o.onLoad) o.onLoad(e)
							}
							s.manager.itemEnd(a)
						} else {
							n = 0;
							for (r = i.length; n < r; n++)
								if (o = i[n], o.onError) o.onError(t);
							s.manager.itemEnd(a);
							s.manager.itemError(a)
						}
					}, !1);
					h.addEventListener("progress", function (t) {
						for (var e = Co[a], i = 0, n = e.length; i < n; i++) {
							var r = e[i];
							if (r.onProgress) r.onProgress(t)
						}
					}, !1);
					h.addEventListener("error", function (t) {
						var e = Co[a];
						delete Co[a];
						for (var i = 0, n = e.length; i < n; i++) {
							var r = e[i];
							if (r.onError) r.onError(t)
						}
						s.manager.itemEnd(a);
						s.manager.itemError(a)
					}, !1);
					void 0 !== this.responseType && (h.responseType = this.responseType);
					void 0 !== this.withCredentials && (h.withCredentials = this.withCredentials);
					h.overrideMimeType && h.overrideMimeType(void 0 !== this.mimeType ? this.mimeType : "text/plain");
					for (o in this.requestHeader) h.setRequestHeader(o, this.requestHeader[o]);
					h.send(null)
				}
				s.manager.itemStart(a);
				return h
			}
		},
		setPath: function (t) {
			this.path = t;
			return this
		},
		setResponseType: function (t) {
			this.responseType = t;
			return this
		},
		setWithCredentials: function (t) {
			this.withCredentials = t;
			return this
		},
		setMimeType: function (t) {
			this.mimeType = t;
			return this
		},
		setRequestHeader: function (t) {
			this.requestHeader = t;
			return this
		}
	});
	Object.assign(on.prototype, {
		load: function (t, r, i, n) {
			function e(e) {
				l.load(t[e], function (t) {
					t = o._parser(t, !0);
					a[e] = {
						width: t.width,
						height: t.height,
						format: t.format,
						mipmaps: t.mipmaps
					};
					c += 1;
					6 === c && (1 === t.mipmapCount && (s.minFilter = 1006), s.format = t.format, s.needsUpdate = !0, r && r(s))
				}, i, n)
			}
			var o = this,
				a = [],
				s = new Ge;
			s.image = a;
			var l = new rn(this.manager);
			l.setPath(this.path);
			l.setResponseType("arraybuffer");
			if (Array.isArray(t))
				for (var c = 0, u = 0, h = t.length; u < h; ++u) e(u);
			else l.load(t, function (t) {
				t = o._parser(t, !0);
				if (t.isCubemap)
					for (var e = t.mipmaps.length / t.mipmapCount, i = 0; i < e; i++) {
						a[i] = {
							mipmaps: []
						};
						for (var n = 0; n < t.mipmapCount; n++) a[i].mipmaps.push(t.mipmaps[i * t.mipmapCount + n]), a[i].format = t.format, a[i].width = t.width, a[i].height = t.height
					} else s.image.width = t.width, s.image.height = t.height, s.mipmaps = t.mipmaps;
				1 === t.mipmapCount && (s.minFilter = 1006);
				s.format = t.format;
				s.needsUpdate = !0;
				r && r(s)
			}, i, n);
			return s
		},
		setPath: function (t) {
			this.path = t;
			return this
		}
	});
	Object.assign(an.prototype, {
		load: function (t, e, i, n) {
			var r = this,
				o = new wt,
				a = new rn(this.manager);
			a.setResponseType("arraybuffer");
			a.load(t, function (t) {
				if (t = r._parser(t)) void 0 !== t.image ? o.image = t.image : void 0 !== t.data && (o.image.width = t.width, o.image.height = t.height, o.image.data = t.data), o.wrapS = void 0 !== t.wrapS ? t.wrapS : 1001, o.wrapT = void 0 !== t.wrapT ? t.wrapT : 1001, o.magFilter = void 0 !== t.magFilter ? t.magFilter : 1006, o.minFilter = void 0 !== t.minFilter ? t.minFilter : 1008, o.anisotropy = void 0 !== t.anisotropy ? t.anisotropy : 1, void 0 !== t.format && (o.format = t.format), void 0 !== t.type && (o.type = t.type), void 0 !== t.mipmaps && (o.mipmaps = t.mipmaps), 1 === t.mipmapCount && (o.minFilter = 1006), o.needsUpdate = !0, e && e(o, t)
			}, i, n);
			return o
		}
	});
	Object.assign(sn.prototype, {
		crossOrigin: "Anonymous",
		load: function (e, t, i, n) {
			function r() {
				l.removeEventListener("load", r, !1);
				l.removeEventListener("error", o, !1);
				Mo.add(e, this);
				t && t(this);
				a.manager.itemEnd(e)
			}

			function o(t) {
				l.removeEventListener("load", r, !1);
				l.removeEventListener("error", o, !1);
				n && n(t);
				a.manager.itemEnd(e);
				a.manager.itemError(e)
			}
			void 0 === e && (e = "");
			void 0 !== this.path && (e = this.path + e);
			e = this.manager.resolveURL(e);
			var a = this,
				s = Mo.get(e);
			if (void 0 !== s) return a.manager.itemStart(e), setTimeout(function () {
				t && t(s);
				a.manager.itemEnd(e)
			}, 0), s;
			var l = document.createElementNS("http://www.w3.org/1999/xhtml", "img");
			l.addEventListener("load", r, !1);
			l.addEventListener("error", o, !1);
			"data:" !== e.substr(0, 5) && void 0 !== this.crossOrigin && (l.crossOrigin = this.crossOrigin);
			a.manager.itemStart(e);
			l.src = e;
			return l
		},
		setCrossOrigin: function (t) {
			this.crossOrigin = t;
			return this
		},
		setPath: function (t) {
			this.path = t;
			return this
		}
	});
	Object.assign(ln.prototype, {
		crossOrigin: "Anonymous",
		load: function (t, i, e, n) {
			function r(e) {
				a.load(t[e], function (t) {
					o.images[e] = t;
					s++;
					6 === s && (o.needsUpdate = !0, i && i(o))
				}, void 0, n)
			}
			var o = new H,
				a = new sn(this.manager);
			a.setCrossOrigin(this.crossOrigin);
			a.setPath(this.path);
			var s = 0;
			for (e = 0; e < t.length; ++e) r(e);
			return o
		},
		setCrossOrigin: function (t) {
			this.crossOrigin = t;
			return this
		},
		setPath: function (t) {
			this.path = t;
			return this
		}
	});
	Object.assign(cn.prototype, {
		crossOrigin: "Anonymous",
		load: function (e, i, t, n) {
			var r = new d,
				o = new sn(this.manager);
			o.setCrossOrigin(this.crossOrigin);
			o.setPath(this.path);
			o.load(e, function (t) {
				r.image = t;
				t = 0 < e.search(/\.(jpg|jpeg)$/) || 0 === e.search(/^data:image\/jpeg/);
				r.format = t ? 1022 : 1023;
				r.needsUpdate = !0;
				void 0 !== i && i(r)
			}, t, n);
			return r
		},
		setCrossOrigin: function (t) {
			this.crossOrigin = t;
			return this
		},
		setPath: function (t) {
			this.path = t;
			return this
		}
	});
	Object.assign(un.prototype, {
		getPoint: function () {
			console.warn("THREE.Curve: .getPoint() not implemented.");
			return null
		},
		getPointAt: function (t, e) {
			t = this.getUtoTmapping(t);
			return this.getPoint(t, e)
		},
		getPoints: function (t) {
			void 0 === t && (t = 5);
			for (var e = [], i = 0; i <= t; i++) e.push(this.getPoint(i / t));
			return e
		},
		getSpacedPoints: function (t) {
			void 0 === t && (t = 5);
			for (var e = [], i = 0; i <= t; i++) e.push(this.getPointAt(i / t));
			return e
		},
		getLength: function () {
			var t = this.getLengths();
			return t[t.length - 1]
		},
		getLengths: function (t) {
			void 0 === t && (t = this.arcLengthDivisions);
			if (this.cacheArcLengths && this.cacheArcLengths.length === t + 1 && !this.needsUpdate) return this.cacheArcLengths;
			this.needsUpdate = !1;
			var e = [],
				i = this.getPoint(0),
				n, r = 0;
			e.push(0);
			for (n = 1; n <= t; n++) {
				var o = this.getPoint(n / t);
				r += o.distanceTo(i);
				e.push(r);
				i = o
			}
			return this.cacheArcLengths = e
		},
		updateArcLengths: function () {
			this.needsUpdate = !0;
			this.getLengths()
		},
		getUtoTmapping: function (t, e) {
			var i = this.getLengths(),
				n = i.length;
			e = e ? e : t * i[n - 1];
			for (var r = 0, o = n - 1, a; r <= o;)
				if (t = Math.floor(r + (o - r) / 2), a = i[t] - e, 0 > a) r = t + 1;
				else if (0 < a) o = t - 1;
			else {
				o = t;
				break
			}
			t = o;
			if (i[t] === e) return t / (n - 1);
			r = i[t];
			return (t + (e - r) / (i[t + 1] - r)) / (n - 1)
		},
		getTangent: function (t) {
			var e = t - 1e-4;
			t += 1e-4;
			0 > e && (e = 0);
			1 < t && (t = 1);
			e = this.getPoint(e);
			return this.getPoint(t).clone().sub(e).normalize()
		},
		getTangentAt: function (t) {
			t = this.getUtoTmapping(t);
			return this.getTangent(t)
		},
		computeFrenetFrames: function (t, e) {
			var i = new _t,
				n = [],
				r = [],
				o = [],
				a = new _t,
				s = new xt,
				l;
			for (l = 0; l <= t; l++) {
				var c = l / t;
				n[l] = this.getTangentAt(c);
				n[l].normalize()
			}
			r[0] = new _t;
			o[0] = new _t;
			l = Number.MAX_VALUE;
			c = Math.abs(n[0].x);
			var u = Math.abs(n[0].y),
				h = Math.abs(n[0].z);
			c <= l && (l = c, i.set(1, 0, 0));
			u <= l && (l = u, i.set(0, 1, 0));
			h <= l && i.set(0, 0, 1);
			a.crossVectors(n[0], i).normalize();
			r[0].crossVectors(n[0], a);
			o[0].crossVectors(n[0], r[0]);
			for (l = 1; l <= t; l++) r[l] = r[l - 1].clone(), o[l] = o[l - 1].clone(), a.crossVectors(n[l - 1], n[l]), a.length() > Number.EPSILON && (a.normalize(), i = Math.acos(Kr.clamp(n[l - 1].dot(n[l]), -1, 1)), r[l].applyMatrix4(s.makeRotationAxis(a, i))), o[l].crossVectors(n[l], r[l]);
			if (!0 === e)
				for (i = Math.acos(Kr.clamp(r[0].dot(r[t]), -1, 1)), i /= t, 0 < n[0].dot(a.crossVectors(r[0], r[t])) && (i = -i), l = 1; l <= t; l++) r[l].applyMatrix4(s.makeRotationAxis(n[l], i * l)), o[l].crossVectors(n[l], r[l]);
			return {
				tangents: n,
				normals: r,
				binormals: o
			}
		},
		clone: function () {
			return (new this.constructor).copy(this)
		},
		copy: function (t) {
			this.arcLengthDivisions = t.arcLengthDivisions;
			return this
		},
		toJSON: function () {
			var t = {
				metadata: {
					version: 4.5,
					type: "Curve",
					generator: "Curve.toJSON"
				}
			};
			t.arcLengthDivisions = this.arcLengthDivisions;
			t.type = this.type;
			return t
		},
		fromJSON: function (t) {
			this.arcLengthDivisions = t.arcLengthDivisions;
			return this
		}
	});
	hn.prototype = Object.create(un.prototype);
	hn.prototype.constructor = hn;
	hn.prototype.isEllipseCurve = !0;
	hn.prototype.getPoint = function (t, e) {
		e = e || new W;
		for (var i = 2 * Math.PI, n = this.aEndAngle - this.aStartAngle, r = Math.abs(n) < Number.EPSILON; 0 > n;) n += i;
		for (; n > i;) n -= i;
		n < Number.EPSILON && (n = r ? 0 : i);
		!0 !== this.aClockwise || r || (n = n === i ? -i : n - i);
		i = this.aStartAngle + t * n;
		t = this.aX + this.xRadius * Math.cos(i);
		var o = this.aY + this.yRadius * Math.sin(i);
		0 !== this.aRotation && (i = Math.cos(this.aRotation), n = Math.sin(this.aRotation), r = t - this.aX, o -= this.aY, t = r * i - o * n + this.aX, o = r * n + o * i + this.aY);
		return e.set(t, o)
	};
	hn.prototype.copy = function (t) {
		un.prototype.copy.call(this, t);
		this.aX = t.aX;
		this.aY = t.aY;
		this.xRadius = t.xRadius;
		this.yRadius = t.yRadius;
		this.aStartAngle = t.aStartAngle;
		this.aEndAngle = t.aEndAngle;
		this.aClockwise = t.aClockwise;
		this.aRotation = t.aRotation;
		return this
	};
	hn.prototype.toJSON = function () {
		var t = un.prototype.toJSON.call(this);
		t.aX = this.aX;
		t.aY = this.aY;
		t.xRadius = this.xRadius;
		t.yRadius = this.yRadius;
		t.aStartAngle = this.aStartAngle;
		t.aEndAngle = this.aEndAngle;
		t.aClockwise = this.aClockwise;
		t.aRotation = this.aRotation;
		return t
	};
	hn.prototype.fromJSON = function (t) {
		un.prototype.fromJSON.call(this, t);
		this.aX = t.aX;
		this.aY = t.aY;
		this.xRadius = t.xRadius;
		this.yRadius = t.yRadius;
		this.aStartAngle = t.aStartAngle;
		this.aEndAngle = t.aEndAngle;
		this.aClockwise = t.aClockwise;
		this.aRotation = t.aRotation;
		return this
	};
	dn.prototype = Object.create(hn.prototype);
	dn.prototype.constructor = dn;
	dn.prototype.isArcCurve = !0;
	var Po = new _t,
		Lo = new fn,
		Ro = new fn,
		Oo = new fn;
	pn.prototype = Object.create(un.prototype);
	pn.prototype.constructor = pn;
	pn.prototype.isCatmullRomCurve3 = !0;
	pn.prototype.getPoint = function (t, e) {
		e = e || new _t;
		var i = this.points,
			n = i.length;
		t *= n - (this.closed ? 0 : 1);
		var r = Math.floor(t);
		t -= r;
		this.closed ? r += 0 < r ? 0 : (Math.floor(Math.abs(r) / n) + 1) * n : 0 === t && r === n - 1 && (r = n - 2, t = 1);
		if (this.closed || 0 < r) var o = i[(r - 1) % n];
		else Po.subVectors(i[0], i[1]).add(i[0]), o = Po;
		var a = i[r % n];
		var s = i[(r + 1) % n];
		this.closed || r + 2 < n ? i = i[(r + 2) % n] : (Po.subVectors(i[n - 1], i[n - 2]).add(i[n - 1]), i = Po);
		if ("centripetal" === this.curveType || "chordal" === this.curveType) {
			var l = "chordal" === this.curveType ? .5 : .25;
			n = Math.pow(o.distanceToSquared(a), l);
			r = Math.pow(a.distanceToSquared(s), l);
			l = Math.pow(s.distanceToSquared(i), l);
			1e-4 > r && (r = 1);
			1e-4 > n && (n = r);
			1e-4 > l && (l = r);
			Lo.initNonuniformCatmullRom(o.x, a.x, s.x, i.x, n, r, l);
			Ro.initNonuniformCatmullRom(o.y, a.y, s.y, i.y, n, r, l);
			Oo.initNonuniformCatmullRom(o.z, a.z, s.z, i.z, n, r, l)
		} else "catmullrom" === this.curveType && (Lo.initCatmullRom(o.x, a.x, s.x, i.x, this.tension), Ro.initCatmullRom(o.y, a.y, s.y, i.y, this.tension), Oo.initCatmullRom(o.z, a.z, s.z, i.z, this.tension));
		e.set(Lo.calc(t), Ro.calc(t), Oo.calc(t));
		return e
	};
	pn.prototype.copy = function (t) {
		un.prototype.copy.call(this, t);
		this.points = [];
		for (var e = 0, i = t.points.length; e < i; e++) this.points.push(t.points[e].clone());
		this.closed = t.closed;
		this.curveType = t.curveType;
		this.tension = t.tension;
		return this
	};
	pn.prototype.toJSON = function () {
		var t = un.prototype.toJSON.call(this);
		t.points = [];
		for (var e = 0, i = this.points.length; e < i; e++) t.points.push(this.points[e].toArray());
		t.closed = this.closed;
		t.curveType = this.curveType;
		t.tension = this.tension;
		return t
	};
	pn.prototype.fromJSON = function (t) {
		un.prototype.fromJSON.call(this, t);
		this.points = [];
		for (var e = 0, i = t.points.length; e < i; e++) {
			var n = t.points[e];
			this.points.push((new _t).fromArray(n))
		}
		this.closed = t.closed;
		this.curveType = t.curveType;
		this.tension = t.tension;
		return this
	};
	yn.prototype = Object.create(un.prototype);
	yn.prototype.constructor = yn;
	yn.prototype.isCubicBezierCurve = !0;
	yn.prototype.getPoint = function (t, e) {
		e = e || new W;
		var i = this.v0,
			n = this.v1,
			r = this.v2,
			o = this.v3;
		e.set(vn(t, i.x, n.x, r.x, o.x), vn(t, i.y, n.y, r.y, o.y));
		return e
	};
	yn.prototype.copy = function (t) {
		un.prototype.copy.call(this, t);
		this.v0.copy(t.v0);
		this.v1.copy(t.v1);
		this.v2.copy(t.v2);
		this.v3.copy(t.v3);
		return this
	};
	yn.prototype.toJSON = function () {
		var t = un.prototype.toJSON.call(this);
		t.v0 = this.v0.toArray();
		t.v1 = this.v1.toArray();
		t.v2 = this.v2.toArray();
		t.v3 = this.v3.toArray();
		return t
	};
	yn.prototype.fromJSON = function (t) {
		un.prototype.fromJSON.call(this, t);
		this.v0.fromArray(t.v0);
		this.v1.fromArray(t.v1);
		this.v2.fromArray(t.v2);
		this.v3.fromArray(t.v3);
		return this
	};
	xn.prototype = Object.create(un.prototype);
	xn.prototype.constructor = xn;
	xn.prototype.isCubicBezierCurve3 = !0;
	xn.prototype.getPoint = function (t, e) {
		e = e || new _t;
		var i = this.v0,
			n = this.v1,
			r = this.v2,
			o = this.v3;
		e.set(vn(t, i.x, n.x, r.x, o.x), vn(t, i.y, n.y, r.y, o.y), vn(t, i.z, n.z, r.z, o.z));
		return e
	};
	xn.prototype.copy = function (t) {
		un.prototype.copy.call(this, t);
		this.v0.copy(t.v0);
		this.v1.copy(t.v1);
		this.v2.copy(t.v2);
		this.v3.copy(t.v3);
		return this
	};
	xn.prototype.toJSON = function () {
		var t = un.prototype.toJSON.call(this);
		t.v0 = this.v0.toArray();
		t.v1 = this.v1.toArray();
		t.v2 = this.v2.toArray();
		t.v3 = this.v3.toArray();
		return t
	};
	xn.prototype.fromJSON = function (t) {
		un.prototype.fromJSON.call(this, t);
		this.v0.fromArray(t.v0);
		this.v1.fromArray(t.v1);
		this.v2.fromArray(t.v2);
		this.v3.fromArray(t.v3);
		return this
	};
	_n.prototype = Object.create(un.prototype);
	_n.prototype.constructor = _n;
	_n.prototype.isLineCurve = !0;
	_n.prototype.getPoint = function (t, e) {
		e = e || new W;
		1 === t ? e.copy(this.v2) : (e.copy(this.v2).sub(this.v1), e.multiplyScalar(t).add(this.v1));
		return e
	};
	_n.prototype.getPointAt = function (t, e) {
		return this.getPoint(t, e)
	};
	_n.prototype.getTangent = function () {
		return this.v2.clone().sub(this.v1).normalize()
	};
	_n.prototype.copy = function (t) {
		un.prototype.copy.call(this, t);
		this.v1.copy(t.v1);
		this.v2.copy(t.v2);
		return this
	};
	_n.prototype.toJSON = function () {
		var t = un.prototype.toJSON.call(this);
		t.v1 = this.v1.toArray();
		t.v2 = this.v2.toArray();
		return t
	};
	_n.prototype.fromJSON = function (t) {
		un.prototype.fromJSON.call(this, t);
		this.v1.fromArray(t.v1);
		this.v2.fromArray(t.v2);
		return this
	};
	bn.prototype = Object.create(un.prototype);
	bn.prototype.constructor = bn;
	bn.prototype.isLineCurve3 = !0;
	bn.prototype.getPoint = function (t, e) {
		e = e || new _t;
		1 === t ? e.copy(this.v2) : (e.copy(this.v2).sub(this.v1), e.multiplyScalar(t).add(this.v1));
		return e
	};
	bn.prototype.getPointAt = function (t, e) {
		return this.getPoint(t, e)
	};
	bn.prototype.copy = function (t) {
		un.prototype.copy.call(this, t);
		this.v1.copy(t.v1);
		this.v2.copy(t.v2);
		return this
	};
	bn.prototype.toJSON = function () {
		var t = un.prototype.toJSON.call(this);
		t.v1 = this.v1.toArray();
		t.v2 = this.v2.toArray();
		return t
	};
	bn.prototype.fromJSON = function (t) {
		un.prototype.fromJSON.call(this, t);
		this.v1.fromArray(t.v1);
		this.v2.fromArray(t.v2);
		return this
	};
	wn.prototype = Object.create(un.prototype);
	wn.prototype.constructor = wn;
	wn.prototype.isQuadraticBezierCurve = !0;
	wn.prototype.getPoint = function (t, e) {
		e = e || new W;
		var i = this.v0,
			n = this.v1,
			r = this.v2;
		e.set(gn(t, i.x, n.x, r.x), gn(t, i.y, n.y, r.y));
		return e
	};
	wn.prototype.copy = function (t) {
		un.prototype.copy.call(this, t);
		this.v0.copy(t.v0);
		this.v1.copy(t.v1);
		this.v2.copy(t.v2);
		return this
	};
	wn.prototype.toJSON = function () {
		var t = un.prototype.toJSON.call(this);
		t.v0 = this.v0.toArray();
		t.v1 = this.v1.toArray();
		t.v2 = this.v2.toArray();
		return t
	};
	wn.prototype.fromJSON = function (t) {
		un.prototype.fromJSON.call(this, t);
		this.v0.fromArray(t.v0);
		this.v1.fromArray(t.v1);
		this.v2.fromArray(t.v2);
		return this
	};
	Tn.prototype = Object.create(un.prototype);
	Tn.prototype.constructor = Tn;
	Tn.prototype.isQuadraticBezierCurve3 = !0;
	Tn.prototype.getPoint = function (t, e) {
		e = e || new _t;
		var i = this.v0,
			n = this.v1,
			r = this.v2;
		e.set(gn(t, i.x, n.x, r.x), gn(t, i.y, n.y, r.y), gn(t, i.z, n.z, r.z));
		return e
	};
	Tn.prototype.copy = function (t) {
		un.prototype.copy.call(this, t);
		this.v0.copy(t.v0);
		this.v1.copy(t.v1);
		this.v2.copy(t.v2);
		return this
	};
	Tn.prototype.toJSON = function () {
		var t = un.prototype.toJSON.call(this);
		t.v0 = this.v0.toArray();
		t.v1 = this.v1.toArray();
		t.v2 = this.v2.toArray();
		return t
	};
	Tn.prototype.fromJSON = function (t) {
		un.prototype.fromJSON.call(this, t);
		this.v0.fromArray(t.v0);
		this.v1.fromArray(t.v1);
		this.v2.fromArray(t.v2);
		return this
	};
	En.prototype = Object.create(un.prototype);
	En.prototype.constructor = En;
	En.prototype.isSplineCurve = !0;
	En.prototype.getPoint = function (t, e) {
		e = e || new W;
		var i = this.points,
			n = (i.length - 1) * t;
		t = Math.floor(n);
		n -= t;
		var r = i[0 === t ? t : t - 1],
			o = i[t],
			a = i[t > i.length - 2 ? i.length - 1 : t + 1];
		i = i[t > i.length - 3 ? i.length - 1 : t + 2];
		e.set(mn(n, r.x, o.x, a.x, i.x), mn(n, r.y, o.y, a.y, i.y));
		return e
	};
	En.prototype.copy = function (t) {
		un.prototype.copy.call(this, t);
		this.points = [];
		for (var e = 0, i = t.points.length; e < i; e++) this.points.push(t.points[e].clone());
		return this
	};
	En.prototype.toJSON = function () {
		var t = un.prototype.toJSON.call(this);
		t.points = [];
		for (var e = 0, i = this.points.length; e < i; e++) t.points.push(this.points[e].toArray());
		return t
	};
	En.prototype.fromJSON = function (t) {
		un.prototype.fromJSON.call(this, t);
		this.points = [];
		for (var e = 0, i = t.points.length; e < i; e++) {
			var n = t.points[e];
			this.points.push((new W).fromArray(n))
		}
		return this
	};
	var ko = Object.freeze({
		ArcCurve: dn,
		CatmullRomCurve3: pn,
		CubicBezierCurve: yn,
		CubicBezierCurve3: xn,
		EllipseCurve: hn,
		LineCurve: _n,
		LineCurve3: bn,
		QuadraticBezierCurve: wn,
		QuadraticBezierCurve3: Tn,
		SplineCurve: En
	});
	Sn.prototype = Object.assign(Object.create(un.prototype), {
		constructor: Sn,
		add: function (t) {
			this.curves.push(t)
		},
		closePath: function () {
			var t = this.curves[0].getPoint(0),
				e = this.curves[this.curves.length - 1].getPoint(1);
			t.equals(e) || this.curves.push(new _n(e, t))
		},
		getPoint: function (t) {
			var e = t * this.getLength(),
				i = this.getCurveLengths();
			for (t = 0; t < i.length;) {
				if (i[t] >= e) return e = i[t] - e, t = this.curves[t], i = t.getLength(), t.getPointAt(0 === i ? 0 : 1 - e / i);
				t++
			}
			return null
		},
		getLength: function () {
			var t = this.getCurveLengths();
			return t[t.length - 1]
		},
		updateArcLengths: function () {
			this.needsUpdate = !0;
			this.cacheLengths = null;
			this.getCurveLengths()
		},
		getCurveLengths: function () {
			if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
			for (var t = [], e = 0, i = 0, n = this.curves.length; i < n; i++) e += this.curves[i].getLength(), t.push(e);
			return this.cacheLengths = t
		},
		getSpacedPoints: function (t) {
			void 0 === t && (t = 40);
			for (var e = [], i = 0; i <= t; i++) e.push(this.getPoint(i / t));
			this.autoClose && e.push(e[0]);
			return e
		},
		getPoints: function (t) {
			t = t || 12;
			for (var e = [], i, n = 0, r = this.curves; n < r.length; n++) {
				var o = r[n];
				o = o.getPoints(o && o.isEllipseCurve ? 2 * t : o && o.isLineCurve ? 1 : o && o.isSplineCurve ? t * o.points.length : t);
				for (var a = 0; a < o.length; a++) {
					var s = o[a];
					i && i.equals(s) || (e.push(s), i = s)
				}
			}
			this.autoClose && 1 < e.length && !e[e.length - 1].equals(e[0]) && e.push(e[0]);
			return e
		},
		copy: function (t) {
			un.prototype.copy.call(this, t);
			this.curves = [];
			for (var e = 0, i = t.curves.length; e < i; e++) this.curves.push(t.curves[e].clone());
			this.autoClose = t.autoClose;
			return this
		},
		toJSON: function () {
			var t = un.prototype.toJSON.call(this);
			t.autoClose = this.autoClose;
			t.curves = [];
			for (var e = 0, i = this.curves.length; e < i; e++) t.curves.push(this.curves[e].toJSON());
			return t
		},
		fromJSON: function (t) {
			un.prototype.fromJSON.call(this, t);
			this.autoClose = t.autoClose;
			this.curves = [];
			for (var e = 0, i = t.curves.length; e < i; e++) {
				var n = t.curves[e];
				this.curves.push((new ko[n.type]).fromJSON(n))
			}
			return this
		}
	});
	Mn.prototype = Object.assign(Object.create(Sn.prototype), {
		constructor: Mn,
		setFromPoints: function (t) {
			this.moveTo(t[0].x, t[0].y);
			for (var e = 1, i = t.length; e < i; e++) this.lineTo(t[e].x, t[e].y)
		},
		moveTo: function (t, e) {
			this.currentPoint.set(t, e)
		},
		lineTo: function (t, e) {
			var i = new _n(this.currentPoint.clone(), new W(t, e));
			this.curves.push(i);
			this.currentPoint.set(t, e)
		},
		quadraticCurveTo: function (t, e, i, n) {
			t = new wn(this.currentPoint.clone(), new W(t, e), new W(i, n));
			this.curves.push(t);
			this.currentPoint.set(i, n)
		},
		bezierCurveTo: function (t, e, i, n, r, o) {
			t = new yn(this.currentPoint.clone(), new W(t, e), new W(i, n), new W(r, o));
			this.curves.push(t);
			this.currentPoint.set(r, o)
		},
		splineThru: function (t) {
			var e = [this.currentPoint.clone()].concat(t);
			e = new En(e);
			this.curves.push(e);
			this.currentPoint.copy(t[t.length - 1])
		},
		arc: function (t, e, i, n, r, o) {
			this.absarc(t + this.currentPoint.x, e + this.currentPoint.y, i, n, r, o)
		},
		absarc: function (t, e, i, n, r, o) {
			this.absellipse(t, e, i, i, n, r, o)
		},
		ellipse: function (t, e, i, n, r, o, a, s) {
			this.absellipse(t + this.currentPoint.x, e + this.currentPoint.y, i, n, r, o, a, s)
		},
		absellipse: function (t, e, i, n, r, o, a, s) {
			t = new hn(t, e, i, n, r, o, a, s);
			0 < this.curves.length && (e = t.getPoint(0), e.equals(this.currentPoint) || this.lineTo(e.x, e.y));
			this.curves.push(t);
			t = t.getPoint(1);
			this.currentPoint.copy(t)
		},
		copy: function (t) {
			Sn.prototype.copy.call(this, t);
			this.currentPoint.copy(t.currentPoint);
			return this
		},
		toJSON: function () {
			var t = Sn.prototype.toJSON.call(this);
			t.currentPoint = this.currentPoint.toArray();
			return t
		},
		fromJSON: function (t) {
			Sn.prototype.fromJSON.call(this, t);
			this.currentPoint.fromArray(t.currentPoint);
			return this
		}
	});
	An.prototype = Object.assign(Object.create(Mn.prototype), {
		constructor: An,
		getPointsHoles: function (t) {
			for (var e = [], i = 0, n = this.holes.length; i < n; i++) e[i] = this.holes[i].getPoints(t);
			return e
		},
		extractPoints: function (t) {
			return {
				shape: this.getPoints(t),
				holes: this.getPointsHoles(t)
			}
		},
		copy: function (t) {
			Mn.prototype.copy.call(this, t);
			this.holes = [];
			for (var e = 0, i = t.holes.length; e < i; e++) this.holes.push(t.holes[e].clone());
			return this
		},
		toJSON: function () {
			var t = Mn.prototype.toJSON.call(this);
			t.uuid = this.uuid;
			t.holes = [];
			for (var e = 0, i = this.holes.length; e < i; e++) t.holes.push(this.holes[e].toJSON());
			return t
		},
		fromJSON: function (t) {
			Mn.prototype.fromJSON.call(this, t);
			this.uuid = t.uuid;
			this.holes = [];
			for (var e = 0, i = t.holes.length; e < i; e++) {
				var n = t.holes[e];
				this.holes.push((new Mn).fromJSON(n))
			}
			return this
		}
	});
	Cn.prototype = Object.assign(Object.create(u.prototype), {
		constructor: Cn,
		isLight: !0,
		copy: function (t) {
			u.prototype.copy.call(this, t);
			this.color.copy(t.color);
			this.intensity = t.intensity;
			return this
		},
		toJSON: function (t) {
			t = u.prototype.toJSON.call(this, t);
			t.object.color = this.color.getHex();
			t.object.intensity = this.intensity;
			void 0 !== this.groundColor && (t.object.groundColor = this.groundColor.getHex());
			void 0 !== this.distance && (t.object.distance = this.distance);
			void 0 !== this.angle && (t.object.angle = this.angle);
			void 0 !== this.decay && (t.object.decay = this.decay);
			void 0 !== this.penumbra && (t.object.penumbra = this.penumbra);
			void 0 !== this.shadow && (t.object.shadow = this.shadow.toJSON());
			return t
		}
	});
	Pn.prototype = Object.assign(Object.create(Cn.prototype), {
		constructor: Pn,
		isHemisphereLight: !0,
		copy: function (t) {
			Cn.prototype.copy.call(this, t);
			this.groundColor.copy(t.groundColor);
			return this
		}
	});
	Object.assign(Ln.prototype, {
		copy: function (t) {
			this.camera = t.camera.clone();
			this.bias = t.bias;
			this.radius = t.radius;
			this.mapSize.copy(t.mapSize);
			return this
		},
		clone: function () {
			return (new this.constructor).copy(this)
		},
		toJSON: function () {
			var t = {};
			0 !== this.bias && (t.bias = this.bias);
			1 !== this.radius && (t.radius = this.radius);
			if (512 !== this.mapSize.x || 512 !== this.mapSize.y) t.mapSize = this.mapSize.toArray();
			t.camera = this.camera.toJSON(!1).object;
			delete t.camera.matrix;
			return t
		}
	});
	Rn.prototype = Object.assign(Object.create(Ln.prototype), {
		constructor: Rn,
		isSpotLightShadow: !0,
		update: function (t) {
			var e = this.camera,
				i = 2 * Kr.RAD2DEG * t.angle,
				n = this.mapSize.width / this.mapSize.height;
			t = t.distance || e.far;
			if (i !== e.fov || n !== e.aspect || t !== e.far) e.fov = i, e.aspect = n, e.far = t, e.updateProjectionMatrix()
		}
	});
	On.prototype = Object.assign(Object.create(Cn.prototype), {
		constructor: On,
		isSpotLight: !0,
		copy: function (t) {
			Cn.prototype.copy.call(this, t);
			this.distance = t.distance;
			this.angle = t.angle;
			this.penumbra = t.penumbra;
			this.decay = t.decay;
			this.target = t.target.clone();
			this.shadow = t.shadow.clone();
			return this
		}
	});
	kn.prototype = Object.assign(Object.create(Cn.prototype), {
		constructor: kn,
		isPointLight: !0,
		copy: function (t) {
			Cn.prototype.copy.call(this, t);
			this.distance = t.distance;
			this.decay = t.decay;
			this.shadow = t.shadow.clone();
			return this
		}
	});
	Nn.prototype = Object.assign(Object.create(Ln.prototype), {
		constructor: Nn
	});
	In.prototype = Object.assign(Object.create(Cn.prototype), {
		constructor: In,
		isDirectionalLight: !0,
		copy: function (t) {
			Cn.prototype.copy.call(this, t);
			this.target = t.target.clone();
			this.shadow = t.shadow.clone();
			return this
		}
	});
	Dn.prototype = Object.assign(Object.create(Cn.prototype), {
		constructor: Dn,
		isAmbientLight: !0
	});
	Fn.prototype = Object.assign(Object.create(Cn.prototype), {
		constructor: Fn,
		isRectAreaLight: !0,
		copy: function (t) {
			Cn.prototype.copy.call(this, t);
			this.width = t.width;
			this.height = t.height;
			return this
		},
		toJSON: function (t) {
			t = Cn.prototype.toJSON.call(this, t);
			t.object.width = this.width;
			t.object.height = this.height;
			return t
		}
	});
	Bn.prototype = Object.assign(Object.create(qn.prototype), {
		constructor: Bn,
		ValueTypeName: "string",
		ValueBufferType: Array,
		DefaultInterpolation: 2300,
		InterpolantFactoryMethodLinear: void 0,
		InterpolantFactoryMethodSmooth: void 0
	});
	Un.prototype = Object.assign(Object.create(qn.prototype), {
		constructor: Un,
		ValueTypeName: "bool",
		ValueBufferType: Array,
		DefaultInterpolation: 2300,
		InterpolantFactoryMethodLinear: void 0,
		InterpolantFactoryMethodSmooth: void 0
	});
	Object.assign(zn.prototype, {
		evaluate: function (t) {
			var e = this.parameterPositions,
				i = this._cachedIndex,
				n = e[i],
				r = e[i - 1];
			t: {
				e: {
					i: {
						n: if (!(t < n)) {
							for (var o = i + 2;;) {
								if (void 0 === n) {
									if (t < r) break n;
									this._cachedIndex = i = e.length;
									return this.afterEnd_(i - 1, t, r)
								}
								if (i === o) break;
								r = n;
								n = e[++i];
								if (t < n) break e
							}
							n = e.length;
							break i
						}if (t >= r) break t;
						else {
							o = e[1];
							t < o && (i = 2, r = o);
							for (o = i - 2;;) {
								if (void 0 === r) return this._cachedIndex = 0, this.beforeStart_(0, t, n);
								if (i === o) break;
								n = r;
								r = e[--i - 1];
								if (t >= r) break e
							}
							n = i;
							i = 0
						}
					}
					for (; i < n;) r = i + n >>> 1,
					t < e[r] ? n = r : i = r + 1;n = e[i];r = e[i - 1];
					if (void 0 === r) return this._cachedIndex = 0, this.beforeStart_(0, t, n);
					if (void 0 === n) return this._cachedIndex = i = e.length, this.afterEnd_(i - 1, r, t)
				}
				this._cachedIndex = i;this.intervalChanged_(i, r, n)
			}
			return this.interpolate_(i, r, t, n)
		},
		settings: null,
		DefaultSettings_: {},
		getSettings_: function () {
			return this.settings || this.DefaultSettings_
		},
		copySampleValue_: function (t) {
			var e = this.resultBuffer,
				i = this.sampleValues,
				n = this.valueSize;
			t *= n;
			for (var r = 0; r !== n; ++r) e[r] = i[t + r];
			return e
		},
		interpolate_: function () {
			throw Error("call to abstract method")
		},
		intervalChanged_: function () {}
	});
	Object.assign(zn.prototype, {
		beforeStart_: zn.prototype.copySampleValue_,
		afterEnd_: zn.prototype.copySampleValue_
	});
	Gn.prototype = Object.assign(Object.create(zn.prototype), {
		constructor: Gn,
		interpolate_: function (t, e, i, n) {
			var r = this.resultBuffer,
				o = this.sampleValues,
				a = this.valueSize;
			t *= a;
			e = (i - e) / (n - e);
			for (i = t + a; t !== i; t += 4) j.slerpFlat(r, 0, o, t - a, o, t, e);
			return r
		}
	});
	Hn.prototype = Object.assign(Object.create(qn.prototype), {
		constructor: Hn,
		ValueTypeName: "quaternion",
		DefaultInterpolation: 2301,
		InterpolantFactoryMethodLinear: function (t) {
			return new Gn(this.times, this.values, this.getValueSize(), t)
		},
		InterpolantFactoryMethodSmooth: void 0
	});
	jn.prototype = Object.assign(Object.create(qn.prototype), {
		constructor: jn,
		ValueTypeName: "color"
	});
	Vn.prototype = Object.assign(Object.create(qn.prototype), {
		constructor: Vn,
		ValueTypeName: "number"
	});
	Wn.prototype = Object.assign(Object.create(zn.prototype), {
		constructor: Wn,
		DefaultSettings_: {
			endingStart: 2400,
			endingEnd: 2400
		},
		intervalChanged_: function (t, e, i) {
			var n = this.parameterPositions,
				r = t - 2,
				o = t + 1,
				a = n[r],
				s = n[o];
			if (void 0 === a) switch (this.getSettings_().endingStart) {
				case 2401:
					r = t;
					a = 2 * e - i;
					break;
				case 2402:
					r = n.length - 2;
					a = e + n[r] - n[r + 1];
					break;
				default:
					r = t, a = i
			}
			if (void 0 === s) switch (this.getSettings_().endingEnd) {
				case 2401:
					o = t;
					s = 2 * i - e;
					break;
				case 2402:
					o = 1;
					s = i + n[1] - n[0];
					break;
				default:
					o = t - 1, s = e
			}
			t = .5 * (i - e);
			n = this.valueSize;
			this._weightPrev = t / (e - a);
			this._weightNext = t / (s - i);
			this._offsetPrev = r * n;
			this._offsetNext = o * n
		},
		interpolate_: function (t, e, i, n) {
			var r = this.resultBuffer,
				o = this.sampleValues,
				a = this.valueSize;
			t *= a;
			var s = t - a,
				l = this._offsetPrev,
				c = this._offsetNext,
				u = this._weightPrev,
				h = this._weightNext,
				d = (i - e) / (n - e);
			i = d * d;
			n = i * d;
			e = -u * n + 2 * u * i - u * d;
			u = (1 + u) * n + (-1.5 - 2 * u) * i + (-.5 + u) * d + 1;
			d = (-1 - h) * n + (1.5 + h) * i + .5 * d;
			h = h * n - h * i;
			for (i = 0; i !== a; ++i) r[i] = e * o[l + i] + u * o[s + i] + d * o[t + i] + h * o[c + i];
			return r
		}
	});
	Xn.prototype = Object.assign(Object.create(zn.prototype), {
		constructor: Xn,
		interpolate_: function (t, e, i, n) {
			var r = this.resultBuffer,
				o = this.sampleValues,
				a = this.valueSize;
			t *= a;
			var s = t - a;
			e = (i - e) / (n - e);
			i = 1 - e;
			for (n = 0; n !== a; ++n) r[n] = o[s + n] * i + o[t + n] * e;
			return r
		}
	});
	Yn.prototype = Object.assign(Object.create(zn.prototype), {
		constructor: Yn,
		interpolate_: function (t) {
			return this.copySampleValue_(t - 1)
		}
	});
	var No = {
		arraySlice: function (t, e, i) {
			return No.isTypedArray(t) ? new t.constructor(t.subarray(e, void 0 !== i ? i : t.length)) : t.slice(e, i)
		},
		convertArray: function (t, e, i) {
			return !t || !i && t.constructor === e ? t : "number" === typeof e.BYTES_PER_ELEMENT ? new e(t) : Array.prototype.slice.call(t)
		},
		isTypedArray: function (t) {
			return ArrayBuffer.isView(t) && !(t instanceof DataView)
		},
		getKeyframeOrder: function (i) {
			for (var t = i.length, e = Array(t), n = 0; n !== t; ++n) e[n] = n;
			e.sort(function (t, e) {
				return i[t] - i[e]
			});
			return e
		},
		sortedArray: function (t, e, i) {
			for (var n = t.length, r = new t.constructor(n), o = 0, a = 0; a !== n; ++o)
				for (var s = i[o] * e, l = 0; l !== e; ++l) r[a++] = t[s + l];
			return r
		},
		flattenJSON: function (t, e, i, n) {
			for (var r = 1, o = t[0]; void 0 !== o && void 0 === o[n];) o = t[r++];
			if (void 0 !== o) {
				var a = o[n];
				if (void 0 !== a)
					if (Array.isArray(a)) {
						do {
							a = o[n], void 0 !== a && (e.push(o.time), i.push.apply(i, a)), o = t[r++]
						} while (void 0 !== o)
					} else if (void 0 !== a.toArray) {
					do {
						a = o[n], void 0 !== a && (e.push(o.time), a.toArray(i, i.length)), o = t[r++]
					} while (void 0 !== o)
				} else {
					do {
						a = o[n], void 0 !== a && (e.push(o.time), i.push(a)), o = t[r++]
					} while (void 0 !== o)
				}
			}
		}
	};
	Object.assign(qn, {
		parse: function (t) {
			if (void 0 === t.type) throw Error("THREE.KeyframeTrack: track type undefined, can not parse");
			var e = qn._getTrackTypeForValueTypeName(t.type);
			if (void 0 === t.times) {
				var i = [],
					n = [];
				No.flattenJSON(t.keys, i, n, "value");
				t.times = i;
				t.values = n
			}
			return void 0 !== e.parse ? e.parse(t) : new e(t.name, t.times, t.values, t.interpolation)
		},
		toJSON: function (t) {
			var e = t.constructor;
			if (void 0 !== e.toJSON) e = e.toJSON(t);
			else {
				e = {
					name: t.name,
					times: No.convertArray(t.times, Array),
					values: No.convertArray(t.values, Array)
				};
				var i = t.getInterpolation();
				i !== t.DefaultInterpolation && (e.interpolation = i)
			}
			e.type = t.ValueTypeName;
			return e
		},
		_getTrackTypeForValueTypeName: function (t) {
			switch (t.toLowerCase()) {
				case "scalar":
				case "double":
				case "float":
				case "number":
				case "integer":
					return Vn;
				case "vector":
				case "vector2":
				case "vector3":
				case "vector4":
					return $n;
				case "color":
					return jn;
				case "quaternion":
					return Hn;
				case "bool":
				case "boolean":
					return Un;
				case "string":
					return Bn
			}
			throw Error("THREE.KeyframeTrack: Unsupported typeName: " + t)
		}
	});
	Object.assign(qn.prototype, {
		constructor: qn,
		TimeBufferType: Float32Array,
		ValueBufferType: Float32Array,
		DefaultInterpolation: 2301,
		InterpolantFactoryMethodDiscrete: function (t) {
			return new Yn(this.times, this.values, this.getValueSize(), t)
		},
		InterpolantFactoryMethodLinear: function (t) {
			return new Xn(this.times, this.values, this.getValueSize(), t)
		},
		InterpolantFactoryMethodSmooth: function (t) {
			return new Wn(this.times, this.values, this.getValueSize(), t)
		},
		setInterpolation: function (t) {
			switch (t) {
				case 2300:
					var e = this.InterpolantFactoryMethodDiscrete;
					break;
				case 2301:
					e = this.InterpolantFactoryMethodLinear;
					break;
				case 2302:
					e = this.InterpolantFactoryMethodSmooth
			}
			if (void 0 === e) {
				e = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
				if (void 0 === this.createInterpolant)
					if (t !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
					else throw Error(e);
				console.warn("THREE.KeyframeTrack:", e)
			} else this.createInterpolant = e
		},
		getInterpolation: function () {
			switch (this.createInterpolant) {
				case this.InterpolantFactoryMethodDiscrete:
					return 2300;
				case this.InterpolantFactoryMethodLinear:
					return 2301;
				case this.InterpolantFactoryMethodSmooth:
					return 2302
			}
		},
		getValueSize: function () {
			return this.values.length / this.times.length
		},
		shift: function (t) {
			if (0 !== t)
				for (var e = this.times, i = 0, n = e.length; i !== n; ++i) e[i] += t;
			return this
		},
		scale: function (t) {
			if (1 !== t)
				for (var e = this.times, i = 0, n = e.length; i !== n; ++i) e[i] *= t;
			return this
		},
		trim: function (t, e) {
			for (var i = this.times, n = i.length, r = 0, o = n - 1; r !== n && i[r] < t;) ++r;
			for (; - 1 !== o && i[o] > e;) --o;
			++o;
			if (0 !== r || o !== n) r >= o && (o = Math.max(o, 1), r = o - 1), t = this.getValueSize(), this.times = No.arraySlice(i, r, o), this.values = No.arraySlice(this.values, r * t, o * t);
			return this
		},
		validate: function () {
			var t = !0,
				e = this.getValueSize();
			0 !== e - Math.floor(e) && (console.error("THREE.KeyframeTrack: Invalid value size in track.", this), t = !1);
			var i = this.times;
			e = this.values;
			var n = i.length;
			0 === n && (console.error("THREE.KeyframeTrack: Track is empty.", this), t = !1);
			for (var r = null, o = 0; o !== n; o++) {
				var a = i[o];
				if ("number" === typeof a && isNaN(a)) {
					console.error("THREE.KeyframeTrack: Time is not a valid number.", this, o, a);
					t = !1;
					break
				}
				if (null !== r && r > a) {
					console.error("THREE.KeyframeTrack: Out of order keys.", this, o, a, r);
					t = !1;
					break
				}
				r = a
			}
			if (void 0 !== e && No.isTypedArray(e))
				for (o = 0, i = e.length; o !== i; ++o)
					if (n = e[o], isNaN(n)) {
						console.error("THREE.KeyframeTrack: Value is not a valid number.", this, o, n);
						t = !1;
						break
					}
			return t
		},
		optimize: function () {
			for (var t = this.times, e = this.values, i = this.getValueSize(), n = 2302 === this.getInterpolation(), r = 1, o = t.length - 1, a = 1; a < o; ++a) {
				var s = !1,
					l = t[a];
				if (l !== t[a + 1] && (1 !== a || l !== l[0]))
					if (n) s = !0;
					else {
						var c = a * i,
							u = c - i,
							h = c + i;
						for (l = 0; l !== i; ++l) {
							var d = e[c + l];
							if (d !== e[u + l] || d !== e[h + l]) {
								s = !0;
								break
							}
						}
					}
				if (s) {
					if (a !== r)
						for (t[r] = t[a], s = a * i, c = r * i, l = 0; l !== i; ++l) e[c + l] = e[s + l];
					++r
				}
			}
			if (0 < o) {
				t[r] = t[o];
				s = o * i;
				c = r * i;
				for (l = 0; l !== i; ++l) e[c + l] = e[s + l];
				++r
			}
			r !== t.length && (this.times = No.arraySlice(t, 0, r), this.values = No.arraySlice(e, 0, r * i));
			return this
		}
	});
	$n.prototype = Object.assign(Object.create(qn.prototype), {
		constructor: $n,
		ValueTypeName: "vector"
	});
	Object.assign(Zn, {
		parse: function (t) {
			for (var e = [], i = t.tracks, n = 1 / (t.fps || 1), r = 0, o = i.length; r !== o; ++r) e.push(qn.parse(i[r]).scale(n));
			return new Zn(t.name, t.duration, e)
		},
		toJSON: function (t) {
			var e = [],
				i = t.tracks;
			t = {
				name: t.name,
				duration: t.duration,
				tracks: e,
				uuid: t.uuid
			};
			for (var n = 0, r = i.length; n !== r; ++n) e.push(qn.toJSON(i[n]));
			return t
		},
		CreateFromMorphTargetSequence: function (t, e, i, n) {
			for (var r = e.length, o = [], a = 0; a < r; a++) {
				var s = [],
					l = [];
				s.push((a + r - 1) % r, a, (a + 1) % r);
				l.push(0, 1, 0);
				var c = No.getKeyframeOrder(s);
				s = No.sortedArray(s, 1, c);
				l = No.sortedArray(l, 1, c);
				n || 0 !== s[0] || (s.push(r), l.push(l[0]));
				o.push(new Vn(".morphTargetInfluences[" + e[a].name + "]", s, l).scale(1 / i))
			}
			return new Zn(t, -1, o)
		},
		findByName: function (t, e) {
			var i = t;
			Array.isArray(t) || (i = t.geometry && t.geometry.animations || t.animations);
			for (t = 0; t < i.length; t++)
				if (i[t].name === e) return i[t];
			return null
		},
		CreateClipsFromMorphTargetSequences: function (t, e, i) {
			for (var n = {}, r = /^([\w-]*?)([\d]+)$/, o = 0, a = t.length; o < a; o++) {
				var s = t[o],
					l = s.name.match(r);
				if (l && 1 < l.length) {
					var c = l[1];
					(l = n[c]) || (n[c] = l = []);
					l.push(s)
				}
			}
			t = [];
			for (c in n) t.push(Zn.CreateFromMorphTargetSequence(c, n[c], e, i));
			return t
		},
		parseAnimation: function (t, e) {
			if (!t) return console.error("THREE.AnimationClip: No animation in JSONLoader data."), null;
			var i = function (t, e, i, n, r) {
					if (0 !== i.length) {
						var o = [],
							a = [];
						No.flattenJSON(i, o, a, n);
						0 !== o.length && r.push(new t(e, o, a))
					}
				},
				n = [],
				r = t.name || "default",
				o = t.length || -1,
				a = t.fps || 30;
			t = t.hierarchy || [];
			for (var s = 0; s < t.length; s++) {
				var l = t[s].keys;
				if (l && 0 !== l.length)
					if (l[0].morphTargets) {
						o = {};
						for (var c = 0; c < l.length; c++)
							if (l[c].morphTargets)
								for (var u = 0; u < l[c].morphTargets.length; u++) o[l[c].morphTargets[u]] = -1;
						for (var h in o) {
							var d = [],
								f = [];
							for (u = 0; u !== l[c].morphTargets.length; ++u) {
								var p = l[c];
								d.push(p.time);
								f.push(p.morphTarget === h ? 1 : 0)
							}
							n.push(new Vn(".morphTargetInfluence[" + h + "]", d, f))
						}
						o = o.length * (a || 1)
					} else c = ".bones[" + e[s].name + "]", i($n, c + ".position", l, "pos", n), i(Hn, c + ".quaternion", l, "rot", n), i($n, c + ".scale", l, "scl", n)
			}
			return 0 === n.length ? null : new Zn(r, o, n)
		}
	});
	Object.assign(Zn.prototype, {
		resetDuration: function () {
			for (var t = 0, e = 0, i = this.tracks.length; e !== i; ++e) {
				var n = this.tracks[e];
				t = Math.max(t, n.times[n.times.length - 1])
			}
			this.duration = t
		},
		trim: function () {
			for (var t = 0; t < this.tracks.length; t++) this.tracks[t].trim(0, this.duration);
			return this
		},
		optimize: function () {
			for (var t = 0; t < this.tracks.length; t++) this.tracks[t].optimize();
			return this
		}
	});
	Object.assign(Jn.prototype, {
		load: function (t, e, i, n) {
			var r = this;
			new rn(r.manager).load(t, function (t) {
				e(r.parse(JSON.parse(t)))
			}, i, n)
		},
		setTextures: function (t) {
			this.textures = t
		},
		parse: function (t) {
			function e(t) {
				void 0 === i[t] && console.warn("THREE.MaterialLoader: Undefined texture", t);
				return i[t]
			}
			var i = this.textures,
				n = new So[t.type];
			void 0 !== t.uuid && (n.uuid = t.uuid);
			void 0 !== t.name && (n.name = t.name);
			void 0 !== t.color && n.color.setHex(t.color);
			void 0 !== t.roughness && (n.roughness = t.roughness);
			void 0 !== t.metalness && (n.metalness = t.metalness);
			void 0 !== t.emissive && n.emissive.setHex(t.emissive);
			void 0 !== t.specular && n.specular.setHex(t.specular);
			void 0 !== t.shininess && (n.shininess = t.shininess);
			void 0 !== t.clearCoat && (n.clearCoat = t.clearCoat);
			void 0 !== t.clearCoatRoughness && (n.clearCoatRoughness = t.clearCoatRoughness);
			void 0 !== t.uniforms && (n.uniforms = t.uniforms);
			void 0 !== t.vertexShader && (n.vertexShader = t.vertexShader);
			void 0 !== t.fragmentShader && (n.fragmentShader = t.fragmentShader);
			void 0 !== t.vertexColors && (n.vertexColors = t.vertexColors);
			void 0 !== t.fog && (n.fog = t.fog);
			void 0 !== t.flatShading && (n.flatShading = t.flatShading);
			void 0 !== t.blending && (n.blending = t.blending);
			void 0 !== t.side && (n.side = t.side);
			void 0 !== t.opacity && (n.opacity = t.opacity);
			void 0 !== t.transparent && (n.transparent = t.transparent);
			void 0 !== t.alphaTest && (n.alphaTest = t.alphaTest);
			void 0 !== t.depthTest && (n.depthTest = t.depthTest);
			void 0 !== t.depthWrite && (n.depthWrite = t.depthWrite);
			void 0 !== t.colorWrite && (n.colorWrite = t.colorWrite);
			void 0 !== t.wireframe && (n.wireframe = t.wireframe);
			void 0 !== t.wireframeLinewidth && (n.wireframeLinewidth = t.wireframeLinewidth);
			void 0 !== t.wireframeLinecap && (n.wireframeLinecap = t.wireframeLinecap);
			void 0 !== t.wireframeLinejoin && (n.wireframeLinejoin = t.wireframeLinejoin);
			void 0 !== t.rotation && (n.rotation = t.rotation);
			1 !== t.linewidth && (n.linewidth = t.linewidth);
			void 0 !== t.dashSize && (n.dashSize = t.dashSize);
			void 0 !== t.gapSize && (n.gapSize = t.gapSize);
			void 0 !== t.scale && (n.scale = t.scale);
			void 0 !== t.polygonOffset && (n.polygonOffset = t.polygonOffset);
			void 0 !== t.polygonOffsetFactor && (n.polygonOffsetFactor = t.polygonOffsetFactor);
			void 0 !== t.polygonOffsetUnits && (n.polygonOffsetUnits = t.polygonOffsetUnits);
			void 0 !== t.skinning && (n.skinning = t.skinning);
			void 0 !== t.morphTargets && (n.morphTargets = t.morphTargets);
			void 0 !== t.dithering && (n.dithering = t.dithering);
			void 0 !== t.visible && (n.visible = t.visible);
			void 0 !== t.userData && (n.userData = t.userData);
			void 0 !== t.shading && (n.flatShading = 1 === t.shading);
			void 0 !== t.size && (n.size = t.size);
			void 0 !== t.sizeAttenuation && (n.sizeAttenuation = t.sizeAttenuation);
			void 0 !== t.map && (n.map = e(t.map));
			void 0 !== t.alphaMap && (n.alphaMap = e(t.alphaMap), n.transparent = !0);
			void 0 !== t.bumpMap && (n.bumpMap = e(t.bumpMap));
			void 0 !== t.bumpScale && (n.bumpScale = t.bumpScale);
			void 0 !== t.normalMap && (n.normalMap = e(t.normalMap));
			if (void 0 !== t.normalScale) {
				var r = t.normalScale;
				!1 === Array.isArray(r) && (r = [r, r]);
				n.normalScale = (new W).fromArray(r)
			}
			void 0 !== t.displacementMap && (n.displacementMap = e(t.displacementMap));
			void 0 !== t.displacementScale && (n.displacementScale = t.displacementScale);
			void 0 !== t.displacementBias && (n.displacementBias = t.displacementBias);
			void 0 !== t.roughnessMap && (n.roughnessMap = e(t.roughnessMap));
			void 0 !== t.metalnessMap && (n.metalnessMap = e(t.metalnessMap));
			void 0 !== t.emissiveMap && (n.emissiveMap = e(t.emissiveMap));
			void 0 !== t.emissiveIntensity && (n.emissiveIntensity = t.emissiveIntensity);
			void 0 !== t.specularMap && (n.specularMap = e(t.specularMap));
			void 0 !== t.envMap && (n.envMap = e(t.envMap));
			void 0 !== t.reflectivity && (n.reflectivity = t.reflectivity);
			void 0 !== t.lightMap && (n.lightMap = e(t.lightMap));
			void 0 !== t.lightMapIntensity && (n.lightMapIntensity = t.lightMapIntensity);
			void 0 !== t.aoMap && (n.aoMap = e(t.aoMap));
			void 0 !== t.aoMapIntensity && (n.aoMapIntensity = t.aoMapIntensity);
			void 0 !== t.gradientMap && (n.gradientMap = e(t.gradientMap));
			return n
		}
	});
	Object.assign(Qn.prototype, {
		load: function (t, e, i, n) {
			var r = this;
			new rn(r.manager).load(t, function (t) {
				e(r.parse(JSON.parse(t)))
			}, i, n)
		},
		parse: function (t) {
			var e = new L,
				i = t.data.index;
			void 0 !== i && (i = new Io[i.type](i.array), e.setIndex(new y(i, 1)));
			var n = t.data.attributes;
			for (o in n) {
				var r = n[o];
				i = new Io[r.type](r.array);
				e.addAttribute(o, new y(i, r.itemSize, r.normalized))
			}
			var o = t.data.groups || t.data.drawcalls || t.data.offsets;
			if (void 0 !== o)
				for (i = 0, n = o.length; i !== n; ++i) r = o[i], e.addGroup(r.start, r.count, r.materialIndex);
			t = t.data.boundingSphere;
			void 0 !== t && (o = new _t, void 0 !== t.center && o.fromArray(t.center), e.boundingSphere = new c(o, t.radius));
			return e
		}
	});
	var Io = {
		Int8Array: Int8Array,
		Uint8Array: Uint8Array,
		Uint8ClampedArray: "undefined" !== typeof Uint8ClampedArray ? Uint8ClampedArray : Uint8Array,
		Int16Array: Int16Array,
		Uint16Array: Uint16Array,
		Int32Array: Int32Array,
		Uint32Array: Uint32Array,
		Float32Array: Float32Array,
		Float64Array: Float64Array
	};
	Kn.Handlers = {
		handlers: [],
		add: function (t, e) {
			this.handlers.push(t, e)
		},
		get: function (t) {
			for (var e = this.handlers, i = 0, n = e.length; i < n; i += 2) {
				var r = e[i + 1];
				if (e[i].test(t)) return r
			}
			return null
		}
	};
	Object.assign(Kn.prototype, {
		crossOrigin: void 0,
		onLoadStart: function () {},
		onLoadProgress: function () {},
		onLoadComplete: function () {},
		initMaterials: function (t, e, i) {
			for (var n = [], r = 0; r < t.length; ++r) n[r] = this.createMaterial(t[r], e, i);
			return n
		},
		createMaterial: function () {
			var o = {
					NoBlending: 0,
					NormalBlending: 1,
					AdditiveBlending: 2,
					SubtractiveBlending: 3,
					MultiplyBlending: 4,
					CustomBlending: 5
				},
				c = new w,
				u = new cn,
				h = new Jn;
			return function (t, a, s) {
				function e(t, e, i, n, r) {
					t = a + t;
					var o = Kn.Handlers.get(t);
					null !== o ? t = o.load(t) : (u.setCrossOrigin(s), t = u.load(t));
					void 0 !== e && (t.repeat.fromArray(e), 1 !== e[0] && (t.wrapS = 1e3), 1 !== e[1] && (t.wrapT = 1e3));
					void 0 !== i && t.offset.fromArray(i);
					void 0 !== n && ("repeat" === n[0] && (t.wrapS = 1e3), "mirror" === n[0] && (t.wrapS = 1002), "repeat" === n[1] && (t.wrapT = 1e3), "mirror" === n[1] && (t.wrapT = 1002));
					void 0 !== r && (t.anisotropy = r);
					e = Kr.generateUUID();
					l[e] = t;
					return e
				}
				var l = {},
					i = {
						uuid: Kr.generateUUID(),
						type: "MeshLambertMaterial"
					},
					n;
				for (n in t) {
					var r = t[n];
					switch (n) {
						case "DbgColor":
						case "DbgIndex":
						case "opticalDensity":
						case "illumination":
							break;
						case "DbgName":
							i.name = r;
							break;
						case "blending":
							i.blending = o[r];
							break;
						case "colorAmbient":
						case "mapAmbient":
							console.warn("THREE.Loader.createMaterial:", n, "is no longer supported.");
							break;
						case "colorDiffuse":
							i.color = c.fromArray(r).getHex();
							break;
						case "colorSpecular":
							i.specular = c.fromArray(r).getHex();
							break;
						case "colorEmissive":
							i.emissive = c.fromArray(r).getHex();
							break;
						case "specularCoef":
							i.shininess = r;
							break;
						case "shading":
							"basic" === r.toLowerCase() && (i.type = "MeshBasicMaterial");
							"phong" === r.toLowerCase() && (i.type = "MeshPhongMaterial");
							"standard" === r.toLowerCase() && (i.type = "MeshStandardMaterial");
							break;
						case "mapDiffuse":
							i.map = e(r, t.mapDiffuseRepeat, t.mapDiffuseOffset, t.mapDiffuseWrap, t.mapDiffuseAnisotropy);
							break;
						case "mapDiffuseRepeat":
						case "mapDiffuseOffset":
						case "mapDiffuseWrap":
						case "mapDiffuseAnisotropy":
							break;
						case "mapEmissive":
							i.emissiveMap = e(r, t.mapEmissiveRepeat, t.mapEmissiveOffset, t.mapEmissiveWrap, t.mapEmissiveAnisotropy);
							break;
						case "mapEmissiveRepeat":
						case "mapEmissiveOffset":
						case "mapEmissiveWrap":
						case "mapEmissiveAnisotropy":
							break;
						case "mapLight":
							i.lightMap = e(r, t.mapLightRepeat, t.mapLightOffset, t.mapLightWrap, t.mapLightAnisotropy);
							break;
						case "mapLightRepeat":
						case "mapLightOffset":
						case "mapLightWrap":
						case "mapLightAnisotropy":
							break;
						case "mapAO":
							i.aoMap = e(r, t.mapAORepeat, t.mapAOOffset, t.mapAOWrap, t.mapAOAnisotropy);
							break;
						case "mapAORepeat":
						case "mapAOOffset":
						case "mapAOWrap":
						case "mapAOAnisotropy":
							break;
						case "mapBump":
							i.bumpMap = e(r, t.mapBumpRepeat, t.mapBumpOffset, t.mapBumpWrap, t.mapBumpAnisotropy);
							break;
						case "mapBumpScale":
							i.bumpScale = r;
							break;
						case "mapBumpRepeat":
						case "mapBumpOffset":
						case "mapBumpWrap":
						case "mapBumpAnisotropy":
							break;
						case "mapNormal":
							i.normalMap = e(r, t.mapNormalRepeat, t.mapNormalOffset, t.mapNormalWrap, t.mapNormalAnisotropy);
							break;
						case "mapNormalFactor":
							i.normalScale = r;
							break;
						case "mapNormalRepeat":
						case "mapNormalOffset":
						case "mapNormalWrap":
						case "mapNormalAnisotropy":
							break;
						case "mapSpecular":
							i.specularMap = e(r, t.mapSpecularRepeat, t.mapSpecularOffset, t.mapSpecularWrap, t.mapSpecularAnisotropy);
							break;
						case "mapSpecularRepeat":
						case "mapSpecularOffset":
						case "mapSpecularWrap":
						case "mapSpecularAnisotropy":
							break;
						case "mapMetalness":
							i.metalnessMap = e(r, t.mapMetalnessRepeat, t.mapMetalnessOffset, t.mapMetalnessWrap, t.mapMetalnessAnisotropy);
							break;
						case "mapMetalnessRepeat":
						case "mapMetalnessOffset":
						case "mapMetalnessWrap":
						case "mapMetalnessAnisotropy":
							break;
						case "mapRoughness":
							i.roughnessMap = e(r, t.mapRoughnessRepeat, t.mapRoughnessOffset, t.mapRoughnessWrap, t.mapRoughnessAnisotropy);
							break;
						case "mapRoughnessRepeat":
						case "mapRoughnessOffset":
						case "mapRoughnessWrap":
						case "mapRoughnessAnisotropy":
							break;
						case "mapAlpha":
							i.alphaMap = e(r, t.mapAlphaRepeat, t.mapAlphaOffset, t.mapAlphaWrap, t.mapAlphaAnisotropy);
							break;
						case "mapAlphaRepeat":
						case "mapAlphaOffset":
						case "mapAlphaWrap":
						case "mapAlphaAnisotropy":
							break;
						case "flipSided":
							i.side = 1;
							break;
						case "doubleSided":
							i.side = 2;
							break;
						case "transparency":
							console.warn("THREE.Loader.createMaterial: transparency has been renamed to opacity");
							i.opacity = r;
							break;
						case "depthTest":
						case "depthWrite":
						case "colorWrite":
						case "opacity":
						case "reflectivity":
						case "transparent":
						case "visible":
						case "wireframe":
							i[n] = r;
							break;
						case "vertexColors":
							!0 === r && (i.vertexColors = 2);
							"face" === r && (i.vertexColors = 1);
							break;
						default:
							console.error("THREE.Loader.createMaterial: Unsupported", n, r)
					}
				}
				"MeshBasicMaterial" === i.type && delete i.emissive;
				"MeshPhongMaterial" !== i.type && delete i.specular;
				1 > i.opacity && (i.transparent = !0);
				h.setTextures(l);
				return h.parse(i)
			}
		}()
	});
	var Do = {
		decodeText: function (t) {
			if ("undefined" !== typeof TextDecoder) return (new TextDecoder).decode(t);
			for (var e = "", i = 0, n = t.length; i < n; i++) e += String.fromCharCode(t[i]);
			return decodeURIComponent(escape(e))
		},
		extractUrlBase: function (t) {
			var e = t.lastIndexOf("/");
			return -1 === e ? "./" : t.substr(0, e + 1)
		}
	};
	Object.assign(tr.prototype, {
		load: function (i, n, t, e) {
			var r = this,
				o = this.texturePath && "string" === typeof this.texturePath ? this.texturePath : Do.extractUrlBase(i),
				a = new rn(this.manager);
			a.setWithCredentials(this.withCredentials);
			a.load(i, function (t) {
				t = JSON.parse(t);
				var e = t.metadata;
				if (void 0 !== e && (e = e.type, void 0 !== e && "object" === e.toLowerCase())) {
					console.error("THREE.JSONLoader: " + i + " should be loaded with THREE.ObjectLoader instead.");
					return
				}
				t = r.parse(t, o);
				n(t.geometry, t.materials)
			}, t, e)
		},
		setTexturePath: function (t) {
			this.texturePath = t
		},
		parse: function () {
			return function (t, e) {
				void 0 !== t.data && (t = t.data);
				t.scale = void 0 !== t.scale ? 1 / t.scale : 1;
				var i = new T,
					n = t,
					r, o, a, s = n.faces;
				var l = n.vertices;
				var c = n.normals,
					u = n.colors;
				var h = n.scale;
				var d = 0;
				if (void 0 !== n.uvs) {
					for (r = 0; r < n.uvs.length; r++) n.uvs[r].length && d++;
					for (r = 0; r < d; r++) i.faceVertexUvs[r] = []
				}
				var f = 0;
				for (a = l.length; f < a;) r = new _t, r.x = l[f++] * h, r.y = l[f++] * h, r.z = l[f++] * h, i.vertices.push(r);
				f = 0;
				for (a = s.length; f < a;) {
					l = s[f++];
					var p = l & 1;
					var m = l & 2;
					r = l & 8;
					var g = l & 16;
					var v = l & 32;
					h = l & 64;
					l &= 128;
					if (p) {
						p = new F;
						p.a = s[f];
						p.b = s[f + 1];
						p.c = s[f + 3];
						var y = new F;
						y.a = s[f + 1];
						y.b = s[f + 2];
						y.c = s[f + 3];
						f += 4;
						m && (m = s[f++], p.materialIndex = m, y.materialIndex = m);
						m = i.faces.length;
						if (r)
							for (r = 0; r < d; r++) {
								var x = n.uvs[r];
								i.faceVertexUvs[r][m] = [];
								i.faceVertexUvs[r][m + 1] = [];
								for (o = 0; 4 > o; o++) {
									var _ = s[f++];
									var b = x[2 * _];
									_ = x[2 * _ + 1];
									b = new W(b, _);
									2 !== o && i.faceVertexUvs[r][m].push(b);
									0 !== o && i.faceVertexUvs[r][m + 1].push(b)
								}
							}
						g && (g = 3 * s[f++], p.normal.set(c[g++], c[g++], c[g]), y.normal.copy(p.normal));
						if (v)
							for (r = 0; 4 > r; r++) g = 3 * s[f++], v = new _t(c[g++], c[g++], c[g]), 2 !== r && p.vertexNormals.push(v), 0 !== r && y.vertexNormals.push(v);
						h && (h = s[f++], h = u[h], p.color.setHex(h), y.color.setHex(h));
						if (l)
							for (r = 0; 4 > r; r++) h = s[f++], h = u[h], 2 !== r && p.vertexColors.push(new w(h)), 0 !== r && y.vertexColors.push(new w(h));
						i.faces.push(p);
						i.faces.push(y)
					} else {
						p = new F;
						p.a = s[f++];
						p.b = s[f++];
						p.c = s[f++];
						m && (m = s[f++], p.materialIndex = m);
						m = i.faces.length;
						if (r)
							for (r = 0; r < d; r++)
								for (x = n.uvs[r], i.faceVertexUvs[r][m] = [], o = 0; 3 > o; o++) _ = s[f++], b = x[2 * _], _ = x[2 * _ + 1], b = new W(b, _), i.faceVertexUvs[r][m].push(b);
						g && (g = 3 * s[f++], p.normal.set(c[g++], c[g++], c[g]));
						if (v)
							for (r = 0; 3 > r; r++) g = 3 * s[f++], v = new _t(c[g++], c[g++], c[g]), p.vertexNormals.push(v);
						h && (h = s[f++], p.color.setHex(u[h]));
						if (l)
							for (r = 0; 3 > r; r++) h = s[f++], p.vertexColors.push(new w(u[h]));
						i.faces.push(p)
					}
				}
				n = t;
				f = void 0 !== n.influencesPerVertex ? n.influencesPerVertex : 2;
				if (n.skinWeights)
					for (a = 0, s = n.skinWeights.length; a < s; a += f) i.skinWeights.push(new bt(n.skinWeights[a], 1 < f ? n.skinWeights[a + 1] : 0, 2 < f ? n.skinWeights[a + 2] : 0, 3 < f ? n.skinWeights[a + 3] : 0));
				if (n.skinIndices)
					for (a = 0, s = n.skinIndices.length; a < s; a += f) i.skinIndices.push(new bt(n.skinIndices[a], 1 < f ? n.skinIndices[a + 1] : 0, 2 < f ? n.skinIndices[a + 2] : 0, 3 < f ? n.skinIndices[a + 3] : 0));
				i.bones = n.bones;
				i.bones && 0 < i.bones.length && (i.skinWeights.length !== i.skinIndices.length || i.skinIndices.length !== i.vertices.length) && console.warn("When skinning, number of vertices (" + i.vertices.length + "), skinIndices (" + i.skinIndices.length + "), and skinWeights (" + i.skinWeights.length + ") should match.");
				a = t;
				s = a.scale;
				if (void 0 !== a.morphTargets)
					for (n = 0, f = a.morphTargets.length; n < f; n++)
						for (i.morphTargets[n] = {}, i.morphTargets[n].name = a.morphTargets[n].name, i.morphTargets[n].vertices = [], c = i.morphTargets[n].vertices, u = a.morphTargets[n].vertices, d = 0, l = u.length; d < l; d += 3) h = new _t, h.x = u[d] * s, h.y = u[d + 1] * s, h.z = u[d + 2] * s, c.push(h);
				if (void 0 !== a.morphColors && 0 < a.morphColors.length)
					for (console.warn('THREE.JSONLoader: "morphColors" no longer supported. Using them as face colors.'), s = i.faces, a = a.morphColors[0].colors, n = 0, f = s.length; n < f; n++) s[n].color.fromArray(a, 3 * n);
				a = t;
				n = [];
				f = [];
				void 0 !== a.animation && f.push(a.animation);
				void 0 !== a.animations && (a.animations.length ? f = f.concat(a.animations) : f.push(a.animations));
				for (a = 0; a < f.length; a++)(s = Zn.parseAnimation(f[a], i.bones)) && n.push(s);
				i.morphTargets && (f = Zn.CreateClipsFromMorphTargetSequences(i.morphTargets, 10), n = n.concat(f));
				0 < n.length && (i.animations = n);
				i.computeFaceNormals();
				i.computeBoundingSphere();
				if (void 0 === t.materials || 0 === t.materials.length) return {
					geometry: i
				};
				t = Kn.prototype.initMaterials(t.materials, e, this.crossOrigin);
				return {
					geometry: i,
					materials: t
				}
			}
		}()
	});
	Object.assign(er.prototype, {
		load: function (i, n, t, r) {
			"" === this.texturePath && (this.texturePath = i.substring(0, i.lastIndexOf("/") + 1));
			var o = this;
			new rn(o.manager).load(i, function (t) {
				var e = null;
				try {
					e = JSON.parse(t)
				} catch (t) {
					void 0 !== r && r(t);
					console.error("THREE:ObjectLoader: Can't parse " + i + ".", t.message);
					return
				}
				t = e.metadata;
				void 0 === t || void 0 === t.type || "geometry" === t.type.toLowerCase() ? console.error("THREE.ObjectLoader: Can't load " + i + ". Use THREE.JSONLoader instead.") : o.parse(e, n)
			}, t, r)
		},
		setTexturePath: function (t) {
			this.texturePath = t;
			return this
		},
		setCrossOrigin: function (t) {
			this.crossOrigin = t;
			return this
		},
		parse: function (t, e) {
			var i = this.parseShape(t.shapes);
			i = this.parseGeometries(t.geometries, i);
			var n = this.parseImages(t.images, function () {
				void 0 !== e && e(r)
			});
			n = this.parseTextures(t.textures, n);
			n = this.parseMaterials(t.materials, n);
			var r = this.parseObject(t.object, i, n);
			t.animations && (r.animations = this.parseAnimations(t.animations));
			void 0 !== t.images && 0 !== t.images.length || void 0 === e || e(r);
			return r
		},
		parseShape: function (t) {
			var e = {};
			if (void 0 !== t)
				for (var i = 0, n = t.length; i < n; i++) {
					var r = (new An).fromJSON(t[i]);
					e[r.uuid] = r
				}
			return e
		},
		parseGeometries: function (t, e) {
			var i = {};
			if (void 0 !== t)
				for (var n = new tr, r = new Qn, o = 0, a = t.length; o < a; o++) {
					var s = t[o];
					switch (s.type) {
						case "PlaneGeometry":
						case "PlaneBufferGeometry":
							var l = new Eo[s.type](s.width, s.height, s.widthSegments, s.heightSegments);
							break;
						case "BoxGeometry":
						case "BoxBufferGeometry":
						case "CubeGeometry":
							l = new Eo[s.type](s.width, s.height, s.depth, s.widthSegments, s.heightSegments, s.depthSegments);
							break;
						case "CircleGeometry":
						case "CircleBufferGeometry":
							l = new Eo[s.type](s.radius, s.segments, s.thetaStart, s.thetaLength);
							break;
						case "CylinderGeometry":
						case "CylinderBufferGeometry":
							l = new Eo[s.type](s.radiusTop, s.radiusBottom, s.height, s.radialSegments, s.heightSegments, s.openEnded, s.thetaStart, s.thetaLength);
							break;
						case "ConeGeometry":
						case "ConeBufferGeometry":
							l = new Eo[s.type](s.radius, s.height, s.radialSegments, s.heightSegments, s.openEnded, s.thetaStart, s.thetaLength);
							break;
						case "SphereGeometry":
						case "SphereBufferGeometry":
							l = new Eo[s.type](s.radius, s.widthSegments, s.heightSegments, s.phiStart, s.phiLength, s.thetaStart, s.thetaLength);
							break;
						case "DodecahedronGeometry":
						case "DodecahedronBufferGeometry":
						case "IcosahedronGeometry":
						case "IcosahedronBufferGeometry":
						case "OctahedronGeometry":
						case "OctahedronBufferGeometry":
						case "TetrahedronGeometry":
						case "TetrahedronBufferGeometry":
							l = new Eo[s.type](s.radius, s.detail);
							break;
						case "RingGeometry":
						case "RingBufferGeometry":
							l = new Eo[s.type](s.innerRadius, s.outerRadius, s.thetaSegments, s.phiSegments, s.thetaStart, s.thetaLength);
							break;
						case "TorusGeometry":
						case "TorusBufferGeometry":
							l = new Eo[s.type](s.radius, s.tube, s.radialSegments, s.tubularSegments, s.arc);
							break;
						case "TorusKnotGeometry":
						case "TorusKnotBufferGeometry":
							l = new Eo[s.type](s.radius, s.tube, s.tubularSegments, s.radialSegments, s.p, s.q);
							break;
						case "LatheGeometry":
						case "LatheBufferGeometry":
							l = new Eo[s.type](s.points, s.segments, s.phiStart, s.phiLength);
							break;
						case "PolyhedronGeometry":
						case "PolyhedronBufferGeometry":
							l = new Eo[s.type](s.vertices, s.indices, s.radius, s.details);
							break;
						case "ShapeGeometry":
						case "ShapeBufferGeometry":
							l = [];
							for (var c = 0, u = s.shapes.length; c < u; c++) {
								var h = e[s.shapes[c]];
								l.push(h)
							}
							l = new Eo[s.type](l, s.curveSegments);
							break;
						case "ExtrudeGeometry":
						case "ExtrudeBufferGeometry":
							l = [];
							c = 0;
							for (u = s.shapes.length; c < u; c++) h = e[s.shapes[c]], l.push(h);
							c = s.options.extrudePath;
							void 0 !== c && (s.options.extrudePath = (new ko[c.type]).fromJSON(c));
							l = new Eo[s.type](l, s.options);
							break;
						case "BufferGeometry":
							l = r.parse(s);
							break;
						case "Geometry":
							l = n.parse(s, this.texturePath).geometry;
							break;
						default:
							console.warn('THREE.ObjectLoader: Unsupported geometry type "' + s.type + '"');
							continue
					}
					l.uuid = s.uuid;
					void 0 !== s.name && (l.name = s.name);
					!0 === l.isBufferGeometry && void 0 !== s.userData && (l.userData = s.userData);
					i[s.uuid] = l
				}
			return i
		},
		parseMaterials: function (t, e) {
			var i = {};
			if (void 0 !== t) {
				var n = new Jn;
				n.setTextures(e);
				e = 0;
				for (var r = t.length; e < r; e++) {
					var o = t[e];
					if ("MultiMaterial" === o.type) {
						for (var a = [], s = 0; s < o.materials.length; s++) a.push(n.parse(o.materials[s]));
						i[o.uuid] = a
					} else i[o.uuid] = n.parse(o)
				}
			}
			return i
		},
		parseAnimations: function (t) {
			for (var e = [], i = 0; i < t.length; i++) {
				var n = t[i],
					r = Zn.parse(n);
				void 0 !== n.uuid && (r.uuid = n.uuid);
				e.push(r)
			}
			return e
		},
		parseImages: function (t, e) {
			function i(t) {
				n.manager.itemStart(t);
				return o.load(t, function () {
					n.manager.itemEnd(t)
				}, void 0, function () {
					n.manager.itemEnd(t);
					n.manager.itemError(t)
				})
			}
			var n = this,
				r = {};
			if (void 0 !== t && 0 < t.length) {
				e = new nn(e);
				var o = new sn(e);
				o.setCrossOrigin(this.crossOrigin);
				e = 0;
				for (var a = t.length; e < a; e++) {
					var s = t[e],
						l = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(s.url) ? s.url : n.texturePath + s.url;
					r[s.uuid] = i(l)
				}
			}
			return r
		},
		parseTextures: function (t, e) {
			function i(t, e) {
				if ("number" === typeof t) return t;
				console.warn("THREE.ObjectLoader.parseTexture: Constant should be in numeric form.", t);
				return e[t]
			}
			var n = {};
			if (void 0 !== t)
				for (var r = 0, o = t.length; r < o; r++) {
					var a = t[r];
					void 0 === a.image && console.warn('THREE.ObjectLoader: No "image" specified for', a.uuid);
					void 0 === e[a.image] && console.warn("THREE.ObjectLoader: Undefined image", a.image);
					var s = new d(e[a.image]);
					s.needsUpdate = !0;
					s.uuid = a.uuid;
					void 0 !== a.name && (s.name = a.name);
					void 0 !== a.mapping && (s.mapping = i(a.mapping, Fo));
					void 0 !== a.offset && s.offset.fromArray(a.offset);
					void 0 !== a.repeat && s.repeat.fromArray(a.repeat);
					void 0 !== a.center && s.center.fromArray(a.center);
					void 0 !== a.rotation && (s.rotation = a.rotation);
					void 0 !== a.wrap && (s.wrapS = i(a.wrap[0], Bo), s.wrapT = i(a.wrap[1], Bo));
					void 0 !== a.format && (s.format = a.format);
					void 0 !== a.minFilter && (s.minFilter = i(a.minFilter, Uo));
					void 0 !== a.magFilter && (s.magFilter = i(a.magFilter, Uo));
					void 0 !== a.anisotropy && (s.anisotropy = a.anisotropy);
					void 0 !== a.flipY && (s.flipY = a.flipY);
					n[a.uuid] = s
				}
			return n
		},
		parseObject: function (t, e, o) {
			function i(t) {
				void 0 === e[t] && console.warn("THREE.ObjectLoader: Undefined geometry", t);
				return e[t]
			}

			function n(t) {
				if (void 0 !== t) {
					if (Array.isArray(t)) {
						for (var e = [], i = 0, n = t.length; i < n; i++) {
							var r = t[i];
							void 0 === o[r] && console.warn("THREE.ObjectLoader: Undefined material", r);
							e.push(o[r])
						}
						return e
					}
					void 0 === o[t] && console.warn("THREE.ObjectLoader: Undefined material", t);
					return o[t]
				}
			}
			switch (t.type) {
				case "Scene":
					var r = new Me;
					void 0 !== t.background && Number.isInteger(t.background) && (r.background = new w(t.background));
					void 0 !== t.fog && ("Fog" === t.fog.type ? r.fog = new Se(t.fog.color, t.fog.near, t.fog.far) : "FogExp2" === t.fog.type && (r.fog = new Ee(t.fog.color, t.fog.density)));
					break;
				case "PerspectiveCamera":
					r = new xe(t.fov, t.aspect, t.near, t.far);
					void 0 !== t.focus && (r.focus = t.focus);
					void 0 !== t.zoom && (r.zoom = t.zoom);
					void 0 !== t.filmGauge && (r.filmGauge = t.filmGauge);
					void 0 !== t.filmOffset && (r.filmOffset = t.filmOffset);
					void 0 !== t.view && (r.view = Object.assign({}, t.view));
					break;
				case "OrthographicCamera":
					r = new f(t.left, t.right, t.top, t.bottom, t.near, t.far);
					void 0 !== t.zoom && (r.zoom = t.zoom);
					void 0 !== t.view && (r.view = Object.assign({}, t.view));
					break;
				case "AmbientLight":
					r = new Dn(t.color, t.intensity);
					break;
				case "DirectionalLight":
					r = new In(t.color, t.intensity);
					break;
				case "PointLight":
					r = new kn(t.color, t.intensity, t.distance, t.decay);
					break;
				case "RectAreaLight":
					r = new Fn(t.color, t.intensity, t.width, t.height);
					break;
				case "SpotLight":
					r = new On(t.color, t.intensity, t.distance, t.angle, t.penumbra, t.decay);
					break;
				case "HemisphereLight":
					r = new Pn(t.color, t.groundColor, t.intensity);
					break;
				case "SkinnedMesh":
					console.warn("THREE.ObjectLoader.parseObject() does not support SkinnedMesh yet.");
				case "Mesh":
					r = i(t.geometry);
					var a = n(t.material);
					r = r.bones && 0 < r.bones.length ? new Oe(r, a) : new z(r, a);
					break;
				case "LOD":
					r = new Pe;
					break;
				case "Line":
					r = new Ne(i(t.geometry), n(t.material), t.mode);
					break;
				case "LineLoop":
					r = new De(i(t.geometry), n(t.material));
					break;
				case "LineSegments":
					r = new Ie(i(t.geometry), n(t.material));
					break;
				case "PointCloud":
				case "Points":
					r = new Be(i(t.geometry), n(t.material));
					break;
				case "Sprite":
					r = new Ce(n(t.material));
					break;
				case "Group":
					r = new Ue;
					break;
				default:
					r = new u
			}
			r.uuid = t.uuid;
			void 0 !== t.name && (r.name = t.name);
			void 0 !== t.matrix ? (r.matrix.fromArray(t.matrix), void 0 !== t.matrixAutoUpdate && (r.matrixAutoUpdate = t.matrixAutoUpdate), r.matrixAutoUpdate && r.matrix.decompose(r.position, r.quaternion, r.scale)) : (void 0 !== t.position && r.position.fromArray(t.position), void 0 !== t.rotation && r.rotation.fromArray(t.rotation), void 0 !== t.quaternion && r.quaternion.fromArray(t.quaternion), void 0 !== t.scale && r.scale.fromArray(t.scale));
			void 0 !== t.castShadow && (r.castShadow = t.castShadow);
			void 0 !== t.receiveShadow && (r.receiveShadow = t.receiveShadow);
			t.shadow && (void 0 !== t.shadow.bias && (r.shadow.bias = t.shadow.bias), void 0 !== t.shadow.radius && (r.shadow.radius = t.shadow.radius), void 0 !== t.shadow.mapSize && r.shadow.mapSize.fromArray(t.shadow.mapSize), void 0 !== t.shadow.camera && (r.shadow.camera = this.parseObject(t.shadow.camera)));
			void 0 !== t.visible && (r.visible = t.visible);
			void 0 !== t.frustumCulled && (r.frustumCulled = t.frustumCulled);
			void 0 !== t.renderOrder && (r.renderOrder = t.renderOrder);
			void 0 !== t.userData && (r.userData = t.userData);
			if (void 0 !== t.children) {
				a = t.children;
				for (var s = 0; s < a.length; s++) r.add(this.parseObject(a[s], e, o))
			}
			if ("LOD" === t.type)
				for (t = t.levels, a = 0; a < t.length; a++) {
					s = t[a];
					var l = r.getObjectByProperty("uuid", s.object);
					void 0 !== l && r.addLevel(l, s.distance)
				}
			return r
		}
	});
	var Fo = {
			UVMapping: 300,
			CubeReflectionMapping: 301,
			CubeRefractionMapping: 302,
			EquirectangularReflectionMapping: 303,
			EquirectangularRefractionMapping: 304,
			SphericalReflectionMapping: 305,
			CubeUVReflectionMapping: 306,
			CubeUVRefractionMapping: 307
		},
		Bo = {
			RepeatWrapping: 1e3,
			ClampToEdgeWrapping: 1001,
			MirroredRepeatWrapping: 1002
		},
		Uo = {
			NearestFilter: 1003,
			NearestMipMapNearestFilter: 1004,
			NearestMipMapLinearFilter: 1005,
			LinearFilter: 1006,
			LinearMipMapNearestFilter: 1007,
			LinearMipMapLinearFilter: 1008
		};
	ir.prototype = {
		constructor: ir,
		setOptions: function (t) {
			this.options = t;
			return this
		},
		load: function (e, i, t, n) {
			void 0 === e && (e = "");
			void 0 !== this.path && (e = this.path + e);
			e = this.manager.resolveURL(e);
			var r = this,
				o = Mo.get(e);
			if (void 0 !== o) return r.manager.itemStart(e), setTimeout(function () {
				i && i(o);
				r.manager.itemEnd(e)
			}, 0), o;
			fetch(e).then(function (t) {
				return t.blob()
			}).then(function (t) {
				return createImageBitmap(t, r.options)
			}).then(function (t) {
				Mo.add(e, t);
				i && i(t);
				r.manager.itemEnd(e)
			}).catch(function (t) {
				n && n(t);
				r.manager.itemEnd(e);
				r.manager.itemError(e)
			})
		},
		setCrossOrigin: function () {
			return this
		},
		setPath: function (t) {
			this.path = t;
			return this
		}
	};
	Object.assign(nr.prototype, {
		moveTo: function (t, e) {
			this.currentPath = new Mn;
			this.subPaths.push(this.currentPath);
			this.currentPath.moveTo(t, e)
		},
		lineTo: function (t, e) {
			this.currentPath.lineTo(t, e)
		},
		quadraticCurveTo: function (t, e, i, n) {
			this.currentPath.quadraticCurveTo(t, e, i, n)
		},
		bezierCurveTo: function (t, e, i, n, r, o) {
			this.currentPath.bezierCurveTo(t, e, i, n, r, o)
		},
		splineThru: function (t) {
			this.currentPath.splineThru(t)
		},
		toShapes: function (t, e) {
			function i(t) {
				for (var e = [], i = 0, n = t.length; i < n; i++) {
					var r = t[i],
						o = new An;
					o.curves = r.curves;
					e.push(o)
				}
				return e
			}

			function n(t, e) {
				for (var i = e.length, n = !1, r = i - 1, o = 0; o < i; r = o++) {
					var a = e[r],
						s = e[o],
						l = s.x - a.x,
						c = s.y - a.y;
					if (Math.abs(c) > Number.EPSILON) {
						if (0 > c && (a = e[o], l = -l, s = e[r], c = -c), !(t.y < a.y || t.y > s.y))
							if (t.y === a.y) {
								if (t.x === a.x) return !0
							} else {
								r = c * (t.x - a.x) - l * (t.y - a.y);
								if (0 === r) return !0;
								0 > r || (n = !n)
							}
					} else if (t.y === a.y && (s.x <= t.x && t.x <= a.x || a.x <= t.x && t.x <= s.x)) return !0
				}
				return n
			}
			var r = wo.isClockWise,
				o = this.subPaths;
			if (0 === o.length) return [];
			if (!0 === e) return i(o);
			e = [];
			if (1 === o.length) {
				var a = o[0];
				var s = new An;
				s.curves = a.curves;
				e.push(s);
				return e
			}
			var l = !r(o[0].getPoints());
			l = t ? !l : l;
			s = [];
			var c = [],
				u = [],
				h = 0;
			c[h] = void 0;
			u[h] = [];
			for (var d = 0, f = o.length; d < f; d++) {
				a = o[d];
				var p = a.getPoints();
				var m = r(p);
				(m = t ? !m : m) ? (!l && c[h] && h++, c[h] = {
					s: new An,
					p: p
				}, c[h].s.curves = a.curves, l && h++, u[h] = []) : u[h].push({
					h: a,
					p: p[0]
				})
			}
			if (!c[0]) return i(o);
			if (1 < c.length) {
				d = !1;
				t = [];
				r = 0;
				for (o = c.length; r < o; r++) s[r] = [];
				r = 0;
				for (o = c.length; r < o; r++)
					for (a = u[r], m = 0; m < a.length; m++) {
						l = a[m];
						h = !0;
						for (p = 0; p < c.length; p++) n(l.p, c[p].p) && (r !== p && t.push({
							froms: r,
							tos: p,
							hole: m
						}), h ? (h = !1, s[p].push(l)) : d = !0);
						h && s[r].push(l)
					}
				0 < t.length && (d || (u = s))
			}
			d = 0;
			for (r = c.length; d < r; d++)
				for (s = c[d].s, e.push(s), t = u[d], o = 0, a = t.length; o < a; o++) s.holes.push(t[o].h);
			return e
		}
	});
	Object.assign(rr.prototype, {
		isFont: !0,
		generateShapes: function (t, e, i) {
			void 0 === e && (e = 100);
			i = [];
			var n = e;
			e = this.data;
			var r = Array.from ? Array.from(t) : String(t).split("");
			n /= e.resolution;
			var o = (e.boundingBox.yMax - e.boundingBox.yMin + e.underlineThickness) * n;
			t = [];
			for (var a = 0, s = 0, l = 0; l < r.length; l++) {
				var c = r[l];
				if ("\n" === c) a = 0, s -= o;
				else {
					var u = n;
					var h = a,
						d = s;
					if (c = e.glyphs[c] || e.glyphs["?"]) {
						var f = new nr;
						if (c.o)
							for (var p = c._cachedOutline || (c._cachedOutline = c.o.split(" ")), m = 0, g = p.length; m < g;) switch (p[m++]) {
								case "m":
									var v = p[m++] * u + h;
									var y = p[m++] * u + d;
									f.moveTo(v, y);
									break;
								case "l":
									v = p[m++] * u + h;
									y = p[m++] * u + d;
									f.lineTo(v, y);
									break;
								case "q":
									var x = p[m++] * u + h;
									var _ = p[m++] * u + d;
									var b = p[m++] * u + h;
									var w = p[m++] * u + d;
									f.quadraticCurveTo(b, w, x, _);
									break;
								case "b":
									x = p[m++] * u + h, _ = p[m++] * u + d, b = p[m++] * u + h, w = p[m++] * u + d, v = p[m++] * u + h, y = p[m++] * u + d, f.bezierCurveTo(b, w, v, y, x, _)
							}
						u = {
							offsetX: c.ha * u,
							path: f
						}
					} else u = void 0;
					a += u.offsetX;
					t.push(u.path)
				}
			}
			e = 0;
			for (r = t.length; e < r; e++) Array.prototype.push.apply(i, t[e].toShapes());
			return i
		}
	});
	Object.assign(or.prototype, {
		load: function (t, n, e, i) {
			var r = this,
				o = new rn(this.manager);
			o.setPath(this.path);
			o.load(t, function (e) {
				try {
					var i = JSON.parse(e)
				} catch (t) {
					console.warn("THREE.FontLoader: typeface.js support is being deprecated. Use typeface.json instead."), i = JSON.parse(e.substring(65, e.length - 2))
				}
				e = r.parse(i);
				n && n(e)
			}, e, i)
		},
		parse: function (t) {
			return new rr(t)
		},
		setPath: function (t) {
			this.path = t;
			return this
		}
	});
	var zo, Go = {
		getContext: function () {
			void 0 === zo && (zo = new(window.AudioContext || window.webkitAudioContext));
			return zo
		},
		setContext: function (t) {
			zo = t
		}
	};
	Object.assign(ar.prototype, {
		load: function (t, e, i, n) {
			var r = new rn(this.manager);
			r.setResponseType("arraybuffer");
			r.load(t, function (t) {
				Go.getContext().decodeAudioData(t, function (t) {
					e(t)
				})
			}, i, n)
		}
	});
	Object.assign(sr.prototype, {
		update: function () {
			var a, s, l, c, u, h, d, f, p = new xt,
				m = new xt;
			return function (t) {
				if (a !== this || s !== t.focus || l !== t.fov || c !== t.aspect * this.aspect || u !== t.near || h !== t.far || d !== t.zoom || f !== this.eyeSep) {
					a = this;
					s = t.focus;
					l = t.fov;
					c = t.aspect * this.aspect;
					u = t.near;
					h = t.far;
					d = t.zoom;
					var e = t.projectionMatrix.clone();
					f = this.eyeSep / 2;
					var i = f * u / s,
						n = u * Math.tan(Kr.DEG2RAD * l * .5) / d;
					m.elements[12] = -f;
					p.elements[12] = f;
					var r = -n * c + i;
					var o = n * c + i;
					e.elements[0] = 2 * u / (o - r);
					e.elements[8] = (o + r) / (o - r);
					this.cameraL.projectionMatrix.copy(e);
					r = -n * c - i;
					o = n * c - i;
					e.elements[0] = 2 * u / (o - r);
					e.elements[8] = (o + r) / (o - r);
					this.cameraR.projectionMatrix.copy(e)
				}
				this.cameraL.matrixWorld.copy(t.matrixWorld).multiply(m);
				this.cameraR.matrixWorld.copy(t.matrixWorld).multiply(p)
			}
		}()
	});
	lr.prototype = Object.create(u.prototype);
	lr.prototype.constructor = lr;
	cr.prototype = Object.assign(Object.create(u.prototype), {
		constructor: cr,
		getInput: function () {
			return this.gain
		},
		removeFilter: function () {
			null !== this.filter && (this.gain.disconnect(this.filter), this.filter.disconnect(this.context.destination), this.gain.connect(this.context.destination), this.filter = null)
		},
		getFilter: function () {
			return this.filter
		},
		setFilter: function (t) {
			null !== this.filter ? (this.gain.disconnect(this.filter), this.filter.disconnect(this.context.destination)) : this.gain.disconnect(this.context.destination);
			this.filter = t;
			this.gain.connect(this.filter);
			this.filter.connect(this.context.destination)
		},
		getMasterVolume: function () {
			return this.gain.gain.value
		},
		setMasterVolume: function (t) {
			this.gain.gain.setTargetAtTime(t, this.context.currentTime, .01)
		},
		updateMatrixWorld: function () {
			var i = new _t,
				n = new j,
				r = new _t,
				o = new _t;
			return function (t) {
				u.prototype.updateMatrixWorld.call(this, t);
				t = this.context.listener;
				var e = this.up;
				this.matrixWorld.decompose(i, n, r);
				o.set(0, 0, -1).applyQuaternion(n);
				t.positionX ? (t.positionX.setValueAtTime(i.x, this.context.currentTime), t.positionY.setValueAtTime(i.y, this.context.currentTime), t.positionZ.setValueAtTime(i.z, this.context.currentTime), t.forwardX.setValueAtTime(o.x, this.context.currentTime), t.forwardY.setValueAtTime(o.y, this.context.currentTime), t.forwardZ.setValueAtTime(o.z, this.context.currentTime), t.upX.setValueAtTime(e.x, this.context.currentTime), t.upY.setValueAtTime(e.y, this.context.currentTime), t.upZ.setValueAtTime(e.z, this.context.currentTime)) : (t.setPosition(i.x, i.y, i.z), t.setOrientation(o.x, o.y, o.z, e.x, e.y, e.z))
			}
		}()
	});
	ur.prototype = Object.assign(Object.create(u.prototype), {
		constructor: ur,
		getOutput: function () {
			return this.gain
		},
		setNodeSource: function (t) {
			this.hasPlaybackControl = !1;
			this.sourceType = "audioNode";
			this.source = t;
			this.connect();
			return this
		},
		setMediaElementSource: function (t) {
			this.hasPlaybackControl = !1;
			this.sourceType = "mediaNode";
			this.source = this.context.createMediaElementSource(t);
			this.connect();
			return this
		},
		setBuffer: function (t) {
			this.buffer = t;
			this.sourceType = "buffer";
			this.autoplay && this.play();
			return this
		},
		play: function () {
			if (!0 === this.isPlaying) console.warn("THREE.Audio: Audio is already playing.");
			else if (!1 === this.hasPlaybackControl) console.warn("THREE.Audio: this Audio has no playback control.");
			else {
				var t = this.context.createBufferSource();
				t.buffer = this.buffer;
				t.loop = this.loop;
				t.onended = this.onEnded.bind(this);
				t.playbackRate.setValueAtTime(this.playbackRate, this.startTime);
				this.startTime = this.context.currentTime;
				t.start(this.startTime, this.offset);
				this.isPlaying = !0;
				this.source = t;
				return this.connect()
			}
		},
		pause: function () {
			if (!1 === this.hasPlaybackControl) console.warn("THREE.Audio: this Audio has no playback control.");
			else return !0 === this.isPlaying && (this.source.stop(), this.offset += (this.context.currentTime - this.startTime) * this.playbackRate, this.isPlaying = !1), this
		},
		stop: function () {
			if (!1 === this.hasPlaybackControl) console.warn("THREE.Audio: this Audio has no playback control.");
			else return this.source.stop(), this.offset = 0, this.isPlaying = !1, this
		},
		connect: function () {
			if (0 < this.filters.length) {
				this.source.connect(this.filters[0]);
				for (var t = 1, e = this.filters.length; t < e; t++) this.filters[t - 1].connect(this.filters[t]);
				this.filters[this.filters.length - 1].connect(this.getOutput())
			} else this.source.connect(this.getOutput());
			return this
		},
		disconnect: function () {
			if (0 < this.filters.length) {
				this.source.disconnect(this.filters[0]);
				for (var t = 1, e = this.filters.length; t < e; t++) this.filters[t - 1].disconnect(this.filters[t]);
				this.filters[this.filters.length - 1].disconnect(this.getOutput())
			} else this.source.disconnect(this.getOutput());
			return this
		},
		getFilters: function () {
			return this.filters
		},
		setFilters: function (t) {
			t || (t = []);
			!0 === this.isPlaying ? (this.disconnect(), this.filters = t, this.connect()) : this.filters = t;
			return this
		},
		getFilter: function () {
			return this.getFilters()[0]
		},
		setFilter: function (t) {
			return this.setFilters(t ? [t] : [])
		},
		setPlaybackRate: function (t) {
			if (!1 === this.hasPlaybackControl) console.warn("THREE.Audio: this Audio has no playback control.");
			else return this.playbackRate = t, !0 === this.isPlaying && this.source.playbackRate.setValueAtTime(this.playbackRate, this.context.currentTime), this
		},
		getPlaybackRate: function () {
			return this.playbackRate
		},
		onEnded: function () {
			this.isPlaying = !1
		},
		getLoop: function () {
			return !1 === this.hasPlaybackControl ? (console.warn("THREE.Audio: this Audio has no playback control."), !1) : this.loop
		},
		setLoop: function (t) {
			if (!1 === this.hasPlaybackControl) console.warn("THREE.Audio: this Audio has no playback control.");
			else return this.loop = t, !0 === this.isPlaying && (this.source.loop = this.loop), this
		},
		getVolume: function () {
			return this.gain.gain.value
		},
		setVolume: function (t) {
			this.gain.gain.setTargetAtTime(t, this.context.currentTime, .01);
			return this
		}
	});
	hr.prototype = Object.assign(Object.create(ur.prototype), {
		constructor: hr,
		getOutput: function () {
			return this.panner
		},
		getRefDistance: function () {
			return this.panner.refDistance
		},
		setRefDistance: function (t) {
			this.panner.refDistance = t
		},
		getRolloffFactor: function () {
			return this.panner.rolloffFactor
		},
		setRolloffFactor: function (t) {
			this.panner.rolloffFactor = t
		},
		getDistanceModel: function () {
			return this.panner.distanceModel
		},
		setDistanceModel: function (t) {
			this.panner.distanceModel = t
		},
		getMaxDistance: function () {
			return this.panner.maxDistance
		},
		setMaxDistance: function (t) {
			this.panner.maxDistance = t
		},
		updateMatrixWorld: function () {
			var e = new _t;
			return function (t) {
				u.prototype.updateMatrixWorld.call(this, t);
				e.setFromMatrixPosition(this.matrixWorld);
				this.panner.setPosition(e.x, e.y, e.z)
			}
		}()
	});
	Object.assign(dr.prototype, {
		getFrequencyData: function () {
			this.analyser.getByteFrequencyData(this.data);
			return this.data
		},
		getAverageFrequency: function () {
			for (var t = 0, e = this.getFrequencyData(), i = 0; i < e.length; i++) t += e[i];
			return t / e.length
		}
	});
	Object.assign(fr.prototype, {
		accumulate: function (t, e) {
			var i = this.buffer,
				n = this.valueSize;
			t = t * n + n;
			var r = this.cumulativeWeight;
			if (0 === r) {
				for (r = 0; r !== n; ++r) i[t + r] = i[r];
				r = e
			} else r += e, this._mixBufferRegion(i, t, 0, e / r, n);
			this.cumulativeWeight = r
		},
		apply: function (t) {
			var e = this.valueSize,
				i = this.buffer;
			t = t * e + e;
			var n = this.cumulativeWeight,
				r = this.binding;
			this.cumulativeWeight = 0;
			1 > n && this._mixBufferRegion(i, t, 3 * e, 1 - n, e);
			n = e;
			for (var o = e + e; n !== o; ++n)
				if (i[n] !== i[n + e]) {
					r.setValue(i, t);
					break
				}
		},
		saveOriginalState: function () {
			var t = this.buffer,
				e = this.valueSize,
				i = 3 * e;
			this.binding.getValue(t, i);
			for (var n = e; n !== i; ++n) t[n] = t[i + n % e];
			this.cumulativeWeight = 0
		},
		restoreOriginalState: function () {
			this.binding.setValue(this.buffer, 3 * this.valueSize)
		},
		_select: function (t, e, i, n, r) {
			if (.5 <= n)
				for (n = 0; n !== r; ++n) t[e + n] = t[i + n]
		},
		_slerp: function (t, e, i, n) {
			j.slerpFlat(t, e, t, e, t, i, n)
		},
		_lerp: function (t, e, i, n, r) {
			for (var o = 1 - n, a = 0; a !== r; ++a) {
				var s = e + a;
				t[s] = t[s] * o + t[i + a] * n
			}
		}
	});
	Object.assign(pr.prototype, {
		getValue: function (t, e) {
			this.bind();
			var i = this._bindings[this._targetGroup.nCachedObjects_];
			void 0 !== i && i.getValue(t, e)
		},
		setValue: function (t, e) {
			for (var i = this._bindings, n = this._targetGroup.nCachedObjects_, r = i.length; n !== r; ++n) i[n].setValue(t, e)
		},
		bind: function () {
			for (var t = this._bindings, e = this._targetGroup.nCachedObjects_, i = t.length; e !== i; ++e) t[e].bind()
		},
		unbind: function () {
			for (var t = this._bindings, e = this._targetGroup.nCachedObjects_, i = t.length; e !== i; ++e) t[e].unbind()
		}
	});
	Object.assign(mr, {
		Composite: pr,
		create: function (t, e, i) {
			return t && t.isAnimationObjectGroup ? new mr.Composite(t, e, i) : new mr(t, e, i)
		},
		sanitizeNodeName: function () {
			var e = /[\[\]\.:\/]/g;
			return function (t) {
				return t.replace(/\s/g, "_").replace(e, "")
			}
		}(),
		parseTrackName: function () {
			var t = "[^" + "\\[\\]\\.:\\/".replace("\\.", "") + "]",
				e = /((?:WC+[\/:])*)/.source.replace("WC", "[^\\[\\]\\.:\\/]");
			t = /(WCOD+)?/.source.replace("WCOD", t);
			var i = /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", "[^\\[\\]\\.:\\/]"),
				n = /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", "[^\\[\\]\\.:\\/]"),
				r = new RegExp("^" + e + t + i + n + "$"),
				o = ["material", "materials", "bones"];
			return function (t) {
				var e = r.exec(t);
				if (!e) throw Error("PropertyBinding: Cannot parse trackName: " + t);
				e = {
					nodeName: e[2],
					objectName: e[3],
					objectIndex: e[4],
					propertyName: e[5],
					propertyIndex: e[6]
				};
				var i = e.nodeName && e.nodeName.lastIndexOf(".");
				if (void 0 !== i && -1 !== i) {
					var n = e.nodeName.substring(i + 1); - 1 !== o.indexOf(n) && (e.nodeName = e.nodeName.substring(0, i), e.objectName = n)
				}
				if (null === e.propertyName || 0 === e.propertyName.length) throw Error("PropertyBinding: can not parse propertyName from trackName: " + t);
				return e
			}
		}(),
		findNode: function (t, n) {
			if (!n || "" === n || "root" === n || "." === n || -1 === n || n === t.name || n === t.uuid) return t;
			if (t.skeleton) {
				var e = t.skeleton.getBoneByName(n);
				if (void 0 !== e) return e
			}
			if (t.children) {
				var r = function (t) {
					for (var e = 0; e < t.length; e++) {
						var i = t[e];
						if (i.name === n || i.uuid === n || (i = r(i.children))) return i
					}
					return null
				};
				if (t = r(t.children)) return t
			}
			return null
		}
	});
	Object.assign(mr.prototype, {
		_getValue_unavailable: function () {},
		_setValue_unavailable: function () {},
		BindingType: {
			Direct: 0,
			EntireArray: 1,
			ArrayElement: 2,
			HasFromToArray: 3
		},
		Versioning: {
			None: 0,
			NeedsUpdate: 1,
			MatrixWorldNeedsUpdate: 2
		},
		GetterByBindingType: [function (t, e) {
			t[e] = this.node[this.propertyName]
		}, function (t, e) {
			for (var i = this.resolvedProperty, n = 0, r = i.length; n !== r; ++n) t[e++] = i[n]
		}, function (t, e) {
			t[e] = this.resolvedProperty[this.propertyIndex]
		}, function (t, e) {
			this.resolvedProperty.toArray(t, e)
		}],
		SetterByBindingTypeAndVersioning: [
			[function (t, e) {
				this.targetObject[this.propertyName] = t[e]
			}, function (t, e) {
				this.targetObject[this.propertyName] = t[e];
				this.targetObject.needsUpdate = !0
			}, function (t, e) {
				this.targetObject[this.propertyName] = t[e];
				this.targetObject.matrixWorldNeedsUpdate = !0
			}],
			[function (t, e) {
				for (var i = this.resolvedProperty, n = 0, r = i.length; n !== r; ++n) i[n] = t[e++]
			}, function (t, e) {
				for (var i = this.resolvedProperty, n = 0, r = i.length; n !== r; ++n) i[n] = t[e++];
				this.targetObject.needsUpdate = !0
			}, function (t, e) {
				for (var i = this.resolvedProperty, n = 0, r = i.length; n !== r; ++n) i[n] = t[e++];
				this.targetObject.matrixWorldNeedsUpdate = !0
			}],
			[function (t, e) {
				this.resolvedProperty[this.propertyIndex] = t[e]
			}, function (t, e) {
				this.resolvedProperty[this.propertyIndex] = t[e];
				this.targetObject.needsUpdate = !0
			}, function (t, e) {
				this.resolvedProperty[this.propertyIndex] = t[e];
				this.targetObject.matrixWorldNeedsUpdate = !0
			}],
			[function (t, e) {
				this.resolvedProperty.fromArray(t, e)
			}, function (t, e) {
				this.resolvedProperty.fromArray(t, e);
				this.targetObject.needsUpdate = !0
			}, function (t, e) {
				this.resolvedProperty.fromArray(t, e);
				this.targetObject.matrixWorldNeedsUpdate = !0
			}]
		],
		getValue: function (t, e) {
			this.bind();
			this.getValue(t, e)
		},
		setValue: function (t, e) {
			this.bind();
			this.setValue(t, e)
		},
		bind: function () {
			var t = this.node,
				e = this.parsedPath,
				i = e.objectName,
				n = e.propertyName,
				r = e.propertyIndex;
			t || (this.node = t = mr.findNode(this.rootNode, e.nodeName) || this.rootNode);
			this.getValue = this._getValue_unavailable;
			this.setValue = this._setValue_unavailable;
			if (t) {
				if (i) {
					var o = e.objectIndex;
					switch (i) {
						case "materials":
							if (!t.material) {
								console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
								return
							}
							if (!t.material.materials) {
								console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
								return
							}
							t = t.material.materials;
							break;
						case "bones":
							if (!t.skeleton) {
								console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
								return
							}
							t = t.skeleton.bones;
							for (i = 0; i < t.length; i++)
								if (t[i].name === o) {
									o = i;
									break
								}
							break;
						default:
							if (void 0 === t[i]) {
								console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
								return
							}
							t = t[i]
					}
					if (void 0 !== o) {
						if (void 0 === t[o]) {
							console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, t);
							return
						}
						t = t[o]
					}
				}
				o = t[n];
				if (void 0 === o) console.error("THREE.PropertyBinding: Trying to update property for track: " + e.nodeName + "." + n + " but it wasn't found.", t);
				else {
					e = this.Versioning.None;
					void 0 !== t.needsUpdate ? (e = this.Versioning.NeedsUpdate, this.targetObject = t) : void 0 !== t.matrixWorldNeedsUpdate && (e = this.Versioning.MatrixWorldNeedsUpdate, this.targetObject = t);
					i = this.BindingType.Direct;
					if (void 0 !== r) {
						if ("morphTargetInfluences" === n) {
							if (!t.geometry) {
								console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
								return
							}
							if (t.geometry.isBufferGeometry) {
								if (!t.geometry.morphAttributes) {
									console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
									return
								}
								for (i = 0; i < this.node.geometry.morphAttributes.position.length; i++)
									if (t.geometry.morphAttributes.position[i].name === r) {
										r = i;
										break
									}
							} else {
								if (!t.geometry.morphTargets) {
									console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphTargets.", this);
									return
								}
								for (i = 0; i < this.node.geometry.morphTargets.length; i++)
									if (t.geometry.morphTargets[i].name === r) {
										r = i;
										break
									}
							}
						}
						i = this.BindingType.ArrayElement;
						this.resolvedProperty = o;
						this.propertyIndex = r
					} else void 0 !== o.fromArray && void 0 !== o.toArray ? (i = this.BindingType.HasFromToArray, this.resolvedProperty = o) : Array.isArray(o) ? (i = this.BindingType.EntireArray, this.resolvedProperty = o) : this.propertyName = n;
					this.getValue = this.GetterByBindingType[i];
					this.setValue = this.SetterByBindingTypeAndVersioning[i][e]
				}
			} else console.error("THREE.PropertyBinding: Trying to update node for track: " + this.path + " but it wasn't found.")
		},
		unbind: function () {
			this.node = null;
			this.getValue = this._getValue_unbound;
			this.setValue = this._setValue_unbound
		}
	});
	Object.assign(mr.prototype, {
		_getValue_unbound: mr.prototype.getValue,
		_setValue_unbound: mr.prototype.setValue
	});
	Object.assign(gr.prototype, {
		isAnimationObjectGroup: !0,
		add: function () {
			for (var t = this._objects, e = t.length, i = this.nCachedObjects_, n = this._indicesByUUID, r = this._paths, o = this._parsedPaths, a = this._bindings, s = a.length, l = void 0, c = 0, u = arguments.length; c !== u; ++c) {
				var h = arguments[c],
					d = h.uuid,
					f = n[d];
				if (void 0 === f) {
					f = e++;
					n[d] = f;
					t.push(h);
					d = 0;
					for (var p = s; d !== p; ++d) a[d].push(new mr(h, r[d], o[d]))
				} else if (f < i) {
					l = t[f];
					var m = --i;
					p = t[m];
					n[p.uuid] = f;
					t[f] = p;
					n[d] = m;
					t[m] = h;
					d = 0;
					for (p = s; d !== p; ++d) {
						var g = a[d],
							v = g[f];
						g[f] = g[m];
						void 0 === v && (v = new mr(h, r[d], o[d]));
						g[m] = v
					}
				} else t[f] !== l && console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.")
			}
			this.nCachedObjects_ = i
		},
		remove: function () {
			for (var t = this._objects, e = this.nCachedObjects_, i = this._indicesByUUID, n = this._bindings, r = n.length, o = 0, a = arguments.length; o !== a; ++o) {
				var s = arguments[o],
					l = s.uuid,
					c = i[l];
				if (void 0 !== c && c >= e) {
					var u = e++,
						h = t[u];
					i[h.uuid] = c;
					t[c] = h;
					i[l] = u;
					t[u] = s;
					s = 0;
					for (l = r; s !== l; ++s) {
						h = n[s];
						var d = h[c];
						h[c] = h[u];
						h[u] = d
					}
				}
			}
			this.nCachedObjects_ = e
		},
		uncache: function () {
			for (var t = this._objects, e = t.length, i = this.nCachedObjects_, n = this._indicesByUUID, r = this._bindings, o = r.length, a = 0, s = arguments.length; a !== s; ++a) {
				var l = arguments[a].uuid,
					c = n[l];
				if (void 0 !== c)
					if (delete n[l], c < i) {
						l = --i;
						var u = t[l],
							h = --e,
							d = t[h];
						n[u.uuid] = c;
						t[c] = u;
						n[d.uuid] = l;
						t[l] = d;
						t.pop();
						u = 0;
						for (d = o; u !== d; ++u) {
							var f = r[u],
								p = f[h];
							f[c] = f[l];
							f[l] = p;
							f.pop()
						}
					} else
						for (h = --e, d = t[h], n[d.uuid] = c, t[c] = d, t.pop(), u = 0, d = o; u !== d; ++u) f = r[u], f[c] = f[h], f.pop()
			}
			this.nCachedObjects_ = i
		},
		subscribe_: function (t, e) {
			var i = this._bindingsIndicesByPath,
				n = i[t],
				r = this._bindings;
			if (void 0 !== n) return r[n];
			var o = this._paths,
				a = this._parsedPaths,
				s = this._objects,
				l = this.nCachedObjects_,
				c = Array(s.length);
			n = r.length;
			i[t] = n;
			o.push(t);
			a.push(e);
			r.push(c);
			i = l;
			for (n = s.length; i !== n; ++i) c[i] = new mr(s[i], t, e);
			return c
		},
		unsubscribe_: function (t) {
			var e = this._bindingsIndicesByPath,
				i = e[t];
			if (void 0 !== i) {
				var n = this._paths,
					r = this._parsedPaths,
					o = this._bindings,
					a = o.length - 1,
					s = o[a];
				e[t[a]] = i;
				o[i] = s;
				o.pop();
				r[i] = r[a];
				r.pop();
				n[i] = n[a];
				n.pop()
			}
		}
	});
	Object.assign(vr.prototype, {
		play: function () {
			this._mixer._activateAction(this);
			return this
		},
		stop: function () {
			this._mixer._deactivateAction(this);
			return this.reset()
		},
		reset: function () {
			this.paused = !1;
			this.enabled = !0;
			this.time = 0;
			this._loopCount = -1;
			this._startTime = null;
			return this.stopFading().stopWarping()
		},
		isRunning: function () {
			return this.enabled && !this.paused && 0 !== this.timeScale && null === this._startTime && this._mixer._isActiveAction(this)
		},
		isScheduled: function () {
			return this._mixer._isActiveAction(this)
		},
		startAt: function (t) {
			this._startTime = t;
			return this
		},
		setLoop: function (t, e) {
			this.loop = t;
			this.repetitions = e;
			return this
		},
		setEffectiveWeight: function (t) {
			this.weight = t;
			this._effectiveWeight = this.enabled ? t : 0;
			return this.stopFading()
		},
		getEffectiveWeight: function () {
			return this._effectiveWeight
		},
		fadeIn: function (t) {
			return this._scheduleFading(t, 0, 1)
		},
		fadeOut: function (t) {
			return this._scheduleFading(t, 1, 0)
		},
		crossFadeFrom: function (t, e, i) {
			t.fadeOut(e);
			this.fadeIn(e);
			if (i) {
				i = this._clip.duration;
				var n = t._clip.duration,
					r = i / n;
				t.warp(1, n / i, e);
				this.warp(r, 1, e)
			}
			return this
		},
		crossFadeTo: function (t, e, i) {
			return t.crossFadeFrom(this, e, i)
		},
		stopFading: function () {
			var t = this._weightInterpolant;
			null !== t && (this._weightInterpolant = null, this._mixer._takeBackControlInterpolant(t));
			return this
		},
		setEffectiveTimeScale: function (t) {
			this.timeScale = t;
			this._effectiveTimeScale = this.paused ? 0 : t;
			return this.stopWarping()
		},
		getEffectiveTimeScale: function () {
			return this._effectiveTimeScale
		},
		setDuration: function (t) {
			this.timeScale = this._clip.duration / t;
			return this.stopWarping()
		},
		syncWith: function (t) {
			this.time = t.time;
			this.timeScale = t.timeScale;
			return this.stopWarping()
		},
		halt: function (t) {
			return this.warp(this._effectiveTimeScale, 0, t)
		},
		warp: function (t, e, i) {
			var n = this._mixer,
				r = n.time,
				o = this._timeScaleInterpolant,
				a = this.timeScale;
			null === o && (this._timeScaleInterpolant = o = n._lendControlInterpolant());
			n = o.parameterPositions;
			o = o.sampleValues;
			n[0] = r;
			n[1] = r + i;
			o[0] = t / a;
			o[1] = e / a;
			return this
		},
		stopWarping: function () {
			var t = this._timeScaleInterpolant;
			null !== t && (this._timeScaleInterpolant = null, this._mixer._takeBackControlInterpolant(t));
			return this
		},
		getMixer: function () {
			return this._mixer
		},
		getClip: function () {
			return this._clip
		},
		getRoot: function () {
			return this._localRoot || this._mixer._root
		},
		_update: function (t, e, i, n) {
			if (this.enabled) {
				var r = this._startTime;
				if (null !== r) {
					e = (t - r) * i;
					if (0 > e || 0 === i) return;
					this._startTime = null;
					e *= i
				}
				e *= this._updateTimeScale(t);
				i = this._updateTime(e);
				t = this._updateWeight(t);
				if (0 < t) {
					e = this._interpolants;
					r = this._propertyBindings;
					for (var o = 0, a = e.length; o !== a; ++o) e[o].evaluate(i), r[o].accumulate(n, t)
				}
			} else this._updateWeight(t)
		},
		_updateWeight: function (t) {
			var e = 0;
			if (this.enabled) {
				e = this.weight;
				var i = this._weightInterpolant;
				if (null !== i) {
					var n = i.evaluate(t)[0];
					e *= n;
					t > i.parameterPositions[1] && (this.stopFading(), 0 === n && (this.enabled = !1))
				}
			}
			return this._effectiveWeight = e
		},
		_updateTimeScale: function (t) {
			var e = 0;
			if (!this.paused) {
				e = this.timeScale;
				var i = this._timeScaleInterpolant;
				if (null !== i) {
					var n = i.evaluate(t)[0];
					e *= n;
					t > i.parameterPositions[1] && (this.stopWarping(), 0 === e ? this.paused = !0 : this.timeScale = e)
				}
			}
			return this._effectiveTimeScale = e
		},
		_updateTime: function (t) {
			var e = this.time + t;
			if (0 === t) return e;
			var i = this._clip.duration,
				n = this.loop,
				r = this._loopCount;
			if (2200 === n) t: {
				if (-1 === r && (this._loopCount = 0, this._setEndings(!0, !0, !1)), e >= i) e = i;
				else if (0 > e) e = 0;
				else break t;this.clampWhenFinished ? this.paused = !0 : this.enabled = !1;this._mixer.dispatchEvent({
					type: "finished",
					action: this,
					direction: 0 > t ? -1 : 1
				})
			}
			else {
				n = 2202 === n; - 1 === r && (0 <= t ? (r = 0, this._setEndings(!0, 0 === this.repetitions, n)) : this._setEndings(0 === this.repetitions, !0, n));
				if (e >= i || 0 > e) {
					var o = Math.floor(e / i);
					e -= i * o;
					r += Math.abs(o);
					var a = this.repetitions - r;
					0 >= a ? (this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, e = 0 < t ? i : 0, this._mixer.dispatchEvent({
						type: "finished",
						action: this,
						direction: 0 < t ? 1 : -1
					})) : (1 === a ? (t = 0 > t, this._setEndings(t, !t, n)) : this._setEndings(!1, !1, n), this._loopCount = r, this._mixer.dispatchEvent({
						type: "loop",
						action: this,
						loopDelta: o
					}))
				}
				if (n && 1 === (r & 1)) return this.time = e, i - e
			}
			return this.time = e
		},
		_setEndings: function (t, e, i) {
			var n = this._interpolantSettings;
			i ? (n.endingStart = 2401, n.endingEnd = 2401) : (n.endingStart = t ? this.zeroSlopeAtStart ? 2401 : 2400 : 2402, n.endingEnd = e ? this.zeroSlopeAtEnd ? 2401 : 2400 : 2402)
		},
		_scheduleFading: function (t, e, i) {
			var n = this._mixer,
				r = n.time,
				o = this._weightInterpolant;
			null === o && (this._weightInterpolant = o = n._lendControlInterpolant());
			n = o.parameterPositions;
			o = o.sampleValues;
			n[0] = r;
			o[0] = e;
			n[1] = r + t;
			o[1] = i;
			return this
		}
	});
	yr.prototype = Object.assign(Object.create(e.prototype), {
		constructor: yr,
		_bindAction: function (t, e) {
			var i = t._localRoot || this._root,
				n = t._clip.tracks,
				r = n.length,
				o = t._propertyBindings;
			t = t._interpolants;
			var a = i.uuid,
				s = this._bindingsByRootAndName,
				l = s[a];
			void 0 === l && (l = {}, s[a] = l);
			for (s = 0; s !== r; ++s) {
				var c = n[s],
					u = c.name,
					h = l[u];
				if (void 0 === h) {
					h = o[s];
					if (void 0 !== h) {
						null === h._cacheIndex && (++h.referenceCount, this._addInactiveBinding(h, a, u));
						continue
					}
					h = new fr(mr.create(i, u, e && e._propertyBindings[s].binding.parsedPath), c.ValueTypeName, c.getValueSize());
					++h.referenceCount;
					this._addInactiveBinding(h, a, u)
				}
				o[s] = h;
				t[s].resultBuffer = h.buffer
			}
		},
		_activateAction: function (t) {
			if (!this._isActiveAction(t)) {
				if (null === t._cacheIndex) {
					var e = (t._localRoot || this._root).uuid,
						i = t._clip.uuid,
						n = this._actionsByClip[i];
					this._bindAction(t, n && n.knownActions[0]);
					this._addInactiveAction(t, i, e)
				}
				e = t._propertyBindings;
				i = 0;
				for (n = e.length; i !== n; ++i) {
					var r = e[i];
					0 === r.useCount++ && (this._lendBinding(r), r.saveOriginalState())
				}
				this._lendAction(t)
			}
		},
		_deactivateAction: function (t) {
			if (this._isActiveAction(t)) {
				for (var e = t._propertyBindings, i = 0, n = e.length; i !== n; ++i) {
					var r = e[i];
					0 === --r.useCount && (r.restoreOriginalState(), this._takeBackBinding(r))
				}
				this._takeBackAction(t)
			}
		},
		_initMemoryManager: function () {
			this._actions = [];
			this._nActiveActions = 0;
			this._actionsByClip = {};
			this._bindings = [];
			this._nActiveBindings = 0;
			this._bindingsByRootAndName = {};
			this._controlInterpolants = [];
			this._nActiveControlInterpolants = 0;
			var t = this;
			this.stats = {
				actions: {get total() {
						return t._actions.length
					},
					get inUse() {
						return t._nActiveActions
					}
				},
				bindings: {get total() {
						return t._bindings.length
					},
					get inUse() {
						return t._nActiveBindings
					}
				},
				controlInterpolants: {get total() {
						return t._controlInterpolants.length
					},
					get inUse() {
						return t._nActiveControlInterpolants
					}
				}
			}
		},
		_isActiveAction: function (t) {
			t = t._cacheIndex;
			return null !== t && t < this._nActiveActions
		},
		_addInactiveAction: function (t, e, i) {
			var n = this._actions,
				r = this._actionsByClip,
				o = r[e];
			void 0 === o ? (o = {
				knownActions: [t],
				actionByRoot: {}
			}, t._byClipCacheIndex = 0, r[e] = o) : (e = o.knownActions, t._byClipCacheIndex = e.length, e.push(t));
			t._cacheIndex = n.length;
			n.push(t);
			o.actionByRoot[i] = t
		},
		_removeInactiveAction: function (t) {
			var e = this._actions,
				i = e[e.length - 1],
				n = t._cacheIndex;
			i._cacheIndex = n;
			e[n] = i;
			e.pop();
			t._cacheIndex = null;
			e = t._clip.uuid;
			i = this._actionsByClip;
			n = i[e];
			var r = n.knownActions,
				o = r[r.length - 1],
				a = t._byClipCacheIndex;
			o._byClipCacheIndex = a;
			r[a] = o;
			r.pop();
			t._byClipCacheIndex = null;
			delete n.actionByRoot[(t._localRoot || this._root).uuid];
			0 === r.length && delete i[e];
			this._removeInactiveBindingsForAction(t)
		},
		_removeInactiveBindingsForAction: function (t) {
			t = t._propertyBindings;
			for (var e = 0, i = t.length; e !== i; ++e) {
				var n = t[e];
				0 === --n.referenceCount && this._removeInactiveBinding(n)
			}
		},
		_lendAction: function (t) {
			var e = this._actions,
				i = t._cacheIndex,
				n = this._nActiveActions++,
				r = e[n];
			t._cacheIndex = n;
			e[n] = t;
			r._cacheIndex = i;
			e[i] = r
		},
		_takeBackAction: function (t) {
			var e = this._actions,
				i = t._cacheIndex,
				n = --this._nActiveActions,
				r = e[n];
			t._cacheIndex = n;
			e[n] = t;
			r._cacheIndex = i;
			e[i] = r
		},
		_addInactiveBinding: function (t, e, i) {
			var n = this._bindingsByRootAndName,
				r = n[e],
				o = this._bindings;
			void 0 === r && (r = {}, n[e] = r);
			r[i] = t;
			t._cacheIndex = o.length;
			o.push(t)
		},
		_removeInactiveBinding: function (t) {
			var e = this._bindings,
				i = t.binding,
				n = i.rootNode.uuid;
			i = i.path;
			var r = this._bindingsByRootAndName,
				o = r[n],
				a = e[e.length - 1];
			t = t._cacheIndex;
			a._cacheIndex = t;
			e[t] = a;
			e.pop();
			delete o[i];
			t: {
				for (var s in o) break t;delete r[n]
			}
		},
		_lendBinding: function (t) {
			var e = this._bindings,
				i = t._cacheIndex,
				n = this._nActiveBindings++,
				r = e[n];
			t._cacheIndex = n;
			e[n] = t;
			r._cacheIndex = i;
			e[i] = r
		},
		_takeBackBinding: function (t) {
			var e = this._bindings,
				i = t._cacheIndex,
				n = --this._nActiveBindings,
				r = e[n];
			t._cacheIndex = n;
			e[n] = t;
			r._cacheIndex = i;
			e[i] = r
		},
		_lendControlInterpolant: function () {
			var t = this._controlInterpolants,
				e = this._nActiveControlInterpolants++,
				i = t[e];
			void 0 === i && (i = new Xn(new Float32Array(2), new Float32Array(2), 1, this._controlInterpolantsResultBuffer), i.__cacheIndex = e, t[e] = i);
			return i
		},
		_takeBackControlInterpolant: function (t) {
			var e = this._controlInterpolants,
				i = t.__cacheIndex,
				n = --this._nActiveControlInterpolants,
				r = e[n];
			t.__cacheIndex = n;
			e[n] = t;
			r.__cacheIndex = i;
			e[i] = r
		},
		_controlInterpolantsResultBuffer: new Float32Array(1),
		clipAction: function (t, e) {
			var i = e || this._root,
				n = i.uuid;
			i = "string" === typeof t ? Zn.findByName(i, t) : t;
			t = null !== i ? i.uuid : t;
			var r = this._actionsByClip[t],
				o = null;
			if (void 0 !== r) {
				o = r.actionByRoot[n];
				if (void 0 !== o) return o;
				o = r.knownActions[0];
				null === i && (i = o._clip)
			}
			if (null === i) return null;
			e = new vr(this, i, e);
			this._bindAction(e, o);
			this._addInactiveAction(e, t, n);
			return e
		},
		existingAction: function (t, e) {
			var i = e || this._root;
			e = i.uuid;
			i = "string" === typeof t ? Zn.findByName(i, t) : t;
			t = this._actionsByClip[i ? i.uuid : t];
			return void 0 !== t ? t.actionByRoot[e] || null : null
		},
		stopAllAction: function () {
			for (var t = this._actions, e = this._nActiveActions, i = this._bindings, n = this._nActiveBindings, r = this._nActiveBindings = this._nActiveActions = 0; r !== e; ++r) t[r].reset();
			for (r = 0; r !== n; ++r) i[r].useCount = 0;
			return this
		},
		update: function (t) {
			t *= this.timeScale;
			for (var e = this._actions, i = this._nActiveActions, n = this.time += t, r = Math.sign(t), o = this._accuIndex ^= 1, a = 0; a !== i; ++a) e[a]._update(n, t, r, o);
			t = this._bindings;
			e = this._nActiveBindings;
			for (a = 0; a !== e; ++a) t[a].apply(o);
			return this
		},
		getRoot: function () {
			return this._root
		},
		uncacheClip: function (t) {
			var e = this._actions;
			t = t.uuid;
			var i = this._actionsByClip,
				n = i[t];
			if (void 0 !== n) {
				n = n.knownActions;
				for (var r = 0, o = n.length; r !== o; ++r) {
					var a = n[r];
					this._deactivateAction(a);
					var s = a._cacheIndex,
						l = e[e.length - 1];
					a._cacheIndex = null;
					a._byClipCacheIndex = null;
					l._cacheIndex = s;
					e[s] = l;
					e.pop();
					this._removeInactiveBindingsForAction(a)
				}
				delete i[t]
			}
		},
		uncacheRoot: function (t) {
			t = t.uuid;
			var e = this._actionsByClip;
			for (n in e) {
				var i = e[n].actionByRoot[t];
				void 0 !== i && (this._deactivateAction(i), this._removeInactiveAction(i))
			}
			var n = this._bindingsByRootAndName[t];
			if (void 0 !== n)
				for (var r in n) t = n[r], t.restoreOriginalState(), this._removeInactiveBinding(t)
		},
		uncacheAction: function (t, e) {
			t = this.existingAction(t, e);
			null !== t && (this._deactivateAction(t), this._removeInactiveAction(t))
		}
	});
	xr.prototype.clone = function () {
		return new xr(void 0 === this.value.clone ? this.value : this.value.clone())
	};
	_r.prototype = Object.assign(Object.create(L.prototype), {
		constructor: _r,
		isInstancedBufferGeometry: !0,
		copy: function (t) {
			L.prototype.copy.call(this, t);
			this.maxInstancedCount = t.maxInstancedCount;
			return this
		},
		clone: function () {
			return (new this.constructor).copy(this)
		}
	});
	Object.defineProperties(br.prototype, {
		count: {
			get: function () {
				return this.data.count
			}
		},
		array: {
			get: function () {
				return this.data.array
			}
		}
	});
	Object.assign(br.prototype, {
		isInterleavedBufferAttribute: !0,
		setX: function (t, e) {
			this.data.array[t * this.data.stride + this.offset] = e;
			return this
		},
		setY: function (t, e) {
			this.data.array[t * this.data.stride + this.offset + 1] = e;
			return this
		},
		setZ: function (t, e) {
			this.data.array[t * this.data.stride + this.offset + 2] = e;
			return this
		},
		setW: function (t, e) {
			this.data.array[t * this.data.stride + this.offset + 3] = e;
			return this
		},
		getX: function (t) {
			return this.data.array[t * this.data.stride + this.offset]
		},
		getY: function (t) {
			return this.data.array[t * this.data.stride + this.offset + 1]
		},
		getZ: function (t) {
			return this.data.array[t * this.data.stride + this.offset + 2]
		},
		getW: function (t) {
			return this.data.array[t * this.data.stride + this.offset + 3]
		},
		setXY: function (t, e, i) {
			t = t * this.data.stride + this.offset;
			this.data.array[t + 0] = e;
			this.data.array[t + 1] = i;
			return this
		},
		setXYZ: function (t, e, i, n) {
			t = t * this.data.stride + this.offset;
			this.data.array[t + 0] = e;
			this.data.array[t + 1] = i;
			this.data.array[t + 2] = n;
			return this
		},
		setXYZW: function (t, e, i, n, r) {
			t = t * this.data.stride + this.offset;
			this.data.array[t + 0] = e;
			this.data.array[t + 1] = i;
			this.data.array[t + 2] = n;
			this.data.array[t + 3] = r;
			return this
		}
	});
	Object.defineProperty(wr.prototype, "needsUpdate", {
		set: function (t) {
			!0 === t && this.version++
		}
	});
	Object.assign(wr.prototype, {
		isInterleavedBuffer: !0,
		onUploadCallback: function () {},
		setArray: function (t) {
			if (Array.isArray(t)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
			this.count = void 0 !== t ? t.length / this.stride : 0;
			this.array = t;
			return this
		},
		setDynamic: function (t) {
			this.dynamic = t;
			return this
		},
		copy: function (t) {
			this.array = new t.array.constructor(t.array);
			this.count = t.count;
			this.stride = t.stride;
			this.dynamic = t.dynamic;
			return this
		},
		copyAt: function (t, e, i) {
			t *= this.stride;
			i *= e.stride;
			for (var n = 0, r = this.stride; n < r; n++) this.array[t + n] = e.array[i + n];
			return this
		},
		set: function (t, e) {
			void 0 === e && (e = 0);
			this.array.set(t, e);
			return this
		},
		clone: function () {
			return (new this.constructor).copy(this)
		},
		onUpload: function (t) {
			this.onUploadCallback = t;
			return this
		}
	});
	Tr.prototype = Object.assign(Object.create(wr.prototype), {
		constructor: Tr,
		isInstancedInterleavedBuffer: !0,
		copy: function (t) {
			wr.prototype.copy.call(this, t);
			this.meshPerAttribute = t.meshPerAttribute;
			return this
		}
	});
	Er.prototype = Object.assign(Object.create(y.prototype), {
		constructor: Er,
		isInstancedBufferAttribute: !0,
		copy: function (t) {
			y.prototype.copy.call(this, t);
			this.meshPerAttribute = t.meshPerAttribute;
			return this
		}
	});
	Object.assign(Sr.prototype, {
		linePrecision: 1,
		set: function (t, e) {
			this.ray.set(t, e)
		},
		setFromCamera: function (t, e) {
			e && e.isPerspectiveCamera ? (this.ray.origin.setFromMatrixPosition(e.matrixWorld), this.ray.direction.set(t.x, t.y, .5).unproject(e).sub(this.ray.origin).normalize()) : e && e.isOrthographicCamera ? (this.ray.origin.set(t.x, t.y, (e.near + e.far) / (e.near - e.far)).unproject(e), this.ray.direction.set(0, 0, -1).transformDirection(e.matrixWorld)) : console.error("THREE.Raycaster: Unsupported camera type.")
		},
		intersectObject: function (t, e, i) {
			i = i || [];
			Ar(t, this, i, e);
			i.sort(Mr);
			return i
		},
		intersectObjects: function (t, e, i) {
			i = i || [];
			if (!1 === Array.isArray(t)) return console.warn("THREE.Raycaster.intersectObjects: objects is not an Array."), i;
			for (var n = 0, r = t.length; n < r; n++) Ar(t[n], this, i, e);
			i.sort(Mr);
			return i
		}
	});
	Object.assign(Cr.prototype, {
		start: function () {
			this.oldTime = this.startTime = ("undefined" === typeof performance ? Date : performance).now();
			this.elapsedTime = 0;
			this.running = !0
		},
		stop: function () {
			this.getElapsedTime();
			this.autoStart = this.running = !1
		},
		getElapsedTime: function () {
			this.getDelta();
			return this.elapsedTime
		},
		getDelta: function () {
			var t = 0;
			if (this.autoStart && !this.running) return this.start(), 0;
			if (this.running) {
				var e = ("undefined" === typeof performance ? Date : performance).now();
				t = (e - this.oldTime) / 1e3;
				this.oldTime = e;
				this.elapsedTime += t
			}
			return t
		}
	});
	Object.assign(Pr.prototype, {
		set: function (t, e, i) {
			this.radius = t;
			this.phi = e;
			this.theta = i;
			return this
		},
		clone: function () {
			return (new this.constructor).copy(this)
		},
		copy: function (t) {
			this.radius = t.radius;
			this.phi = t.phi;
			this.theta = t.theta;
			return this
		},
		makeSafe: function () {
			this.phi = Math.max(1e-6, Math.min(Math.PI - 1e-6, this.phi));
			return this
		},
		setFromVector3: function (t) {
			this.radius = t.length();
			0 === this.radius ? this.phi = this.theta = 0 : (this.theta = Math.atan2(t.x, t.z), this.phi = Math.acos(Kr.clamp(t.y / this.radius, -1, 1)));
			return this
		}
	});
	Object.assign(Lr.prototype, {
		set: function (t, e, i) {
			this.radius = t;
			this.theta = e;
			this.y = i;
			return this
		},
		clone: function () {
			return (new this.constructor).copy(this)
		},
		copy: function (t) {
			this.radius = t.radius;
			this.theta = t.theta;
			this.y = t.y;
			return this
		},
		setFromVector3: function (t) {
			this.radius = Math.sqrt(t.x * t.x + t.z * t.z);
			this.theta = Math.atan2(t.x, t.z);
			this.y = t.y;
			return this
		}
	});
	Object.assign(Rr.prototype, {
		set: function (t, e) {
			this.min.copy(t);
			this.max.copy(e);
			return this
		},
		setFromPoints: function (t) {
			this.makeEmpty();
			for (var e = 0, i = t.length; e < i; e++) this.expandByPoint(t[e]);
			return this
		},
		setFromCenterAndSize: function () {
			var i = new W;
			return function (t, e) {
				e = i.copy(e).multiplyScalar(.5);
				this.min.copy(t).sub(e);
				this.max.copy(t).add(e);
				return this
			}
		}(),
		clone: function () {
			return (new this.constructor).copy(this)
		},
		copy: function (t) {
			this.min.copy(t.min);
			this.max.copy(t.max);
			return this
		},
		makeEmpty: function () {
			this.min.x = this.min.y = Infinity;
			this.max.x = this.max.y = -Infinity;
			return this
		},
		isEmpty: function () {
			return this.max.x < this.min.x || this.max.y < this.min.y
		},
		getCenter: function (t) {
			void 0 === t && (console.warn("THREE.Box2: .getCenter() target is now required"), t = new W);
			return this.isEmpty() ? t.set(0, 0) : t.addVectors(this.min, this.max).multiplyScalar(.5)
		},
		getSize: function (t) {
			void 0 === t && (console.warn("THREE.Box2: .getSize() target is now required"), t = new W);
			return this.isEmpty() ? t.set(0, 0) : t.subVectors(this.max, this.min)
		},
		expandByPoint: function (t) {
			this.min.min(t);
			this.max.max(t);
			return this
		},
		expandByVector: function (t) {
			this.min.sub(t);
			this.max.add(t);
			return this
		},
		expandByScalar: function (t) {
			this.min.addScalar(-t);
			this.max.addScalar(t);
			return this
		},
		containsPoint: function (t) {
			return t.x < this.min.x || t.x > this.max.x || t.y < this.min.y || t.y > this.max.y ? !1 : !0
		},
		containsBox: function (t) {
			return this.min.x <= t.min.x && t.max.x <= this.max.x && this.min.y <= t.min.y && t.max.y <= this.max.y
		},
		getParameter: function (t, e) {
			void 0 === e && (console.warn("THREE.Box2: .getParameter() target is now required"), e = new W);
			return e.set((t.x - this.min.x) / (this.max.x - this.min.x), (t.y - this.min.y) / (this.max.y - this.min.y))
		},
		intersectsBox: function (t) {
			return t.max.x < this.min.x || t.min.x > this.max.x || t.max.y < this.min.y || t.min.y > this.max.y ? !1 : !0
		},
		clampPoint: function (t, e) {
			void 0 === e && (console.warn("THREE.Box2: .clampPoint() target is now required"), e = new W);
			return e.copy(t).clamp(this.min, this.max)
		},
		distanceToPoint: function () {
			var e = new W;
			return function (t) {
				return e.copy(t).clamp(this.min, this.max).sub(t).length()
			}
		}(),
		intersect: function (t) {
			this.min.max(t.min);
			this.max.min(t.max);
			return this
		},
		union: function (t) {
			this.min.min(t.min);
			this.max.max(t.max);
			return this
		},
		translate: function (t) {
			this.min.add(t);
			this.max.add(t);
			return this
		},
		equals: function (t) {
			return t.min.equals(this.min) && t.max.equals(this.max)
		}
	});
	Or.prototype = Object.create(u.prototype);
	Or.prototype.constructor = Or;
	Or.prototype.isImmediateRenderObject = !0;
	kr.prototype = Object.create(Ie.prototype);
	kr.prototype.constructor = kr;
	kr.prototype.update = function () {
		var d = new _t,
			f = new _t,
			p = new g;
		return function () {
			var t = ["a", "b", "c"];
			this.object.updateMatrixWorld(!0);
			p.getNormalMatrix(this.object.matrixWorld);
			var e = this.object.matrixWorld,
				i = this.geometry.attributes.position,
				n = this.object.geometry;
			if (n && n.isGeometry)
				for (var r = n.vertices, o = n.faces, a = n = 0, s = o.length; a < s; a++)
					for (var l = o[a], c = 0, u = l.vertexNormals.length; c < u; c++) {
						var h = l.vertexNormals[c];
						d.copy(r[l[t[c]]]).applyMatrix4(e);
						f.copy(h).applyMatrix3(p).normalize().multiplyScalar(this.size).add(d);
						i.setXYZ(n, d.x, d.y, d.z);
						n += 1;
						i.setXYZ(n, f.x, f.y, f.z);
						n += 1
					} else if (n && n.isBufferGeometry)
						for (t = n.attributes.position, r = n.attributes.normal, c = n = 0, u = t.count; c < u; c++) d.set(t.getX(c), t.getY(c), t.getZ(c)).applyMatrix4(e), f.set(r.getX(c), r.getY(c), r.getZ(c)), f.applyMatrix3(p).normalize().multiplyScalar(this.size).add(d), i.setXYZ(n, d.x, d.y, d.z), n += 1, i.setXYZ(n, f.x, f.y, f.z), n += 1;
			i.needsUpdate = !0
		}
	}();
	Nr.prototype = Object.create(u.prototype);
	Nr.prototype.constructor = Nr;
	Nr.prototype.dispose = function () {
		this.cone.geometry.dispose();
		this.cone.material.dispose()
	};
	Nr.prototype.update = function () {
		var i = new _t,
			n = new _t;
		return function () {
			this.light.updateMatrixWorld();
			var t = this.light.distance ? this.light.distance : 1e3,
				e = t * Math.tan(this.light.angle);
			this.cone.scale.set(e, e, t);
			i.setFromMatrixPosition(this.light.matrixWorld);
			n.setFromMatrixPosition(this.light.target.matrixWorld);
			this.cone.lookAt(n.sub(i));
			void 0 !== this.color ? this.cone.material.color.set(this.color) : this.cone.material.color.copy(this.light.color)
		}
	}();
	Dr.prototype = Object.create(Ie.prototype);
	Dr.prototype.constructor = Dr;
	Dr.prototype.updateMatrixWorld = function () {
		var s = new _t,
			l = new xt,
			c = new xt;
		return function (t) {
			var e = this.bones,
				i = this.geometry,
				n = i.getAttribute("position");
			c.getInverse(this.root.matrixWorld);
			for (var r = 0, o = 0; r < e.length; r++) {
				var a = e[r];
				a.parent && a.parent.isBone && (l.multiplyMatrices(c, a.matrixWorld), s.setFromMatrixPosition(l), n.setXYZ(o, s.x, s.y, s.z), l.multiplyMatrices(c, a.parent.matrixWorld), s.setFromMatrixPosition(l), n.setXYZ(o + 1, s.x, s.y, s.z), o += 2)
			}
			i.getAttribute("position").needsUpdate = !0;
			u.prototype.updateMatrixWorld.call(this, t)
		}
	}();
	Fr.prototype = Object.create(z.prototype);
	Fr.prototype.constructor = Fr;
	Fr.prototype.dispose = function () {
		this.geometry.dispose();
		this.material.dispose()
	};
	Fr.prototype.update = function () {
		void 0 !== this.color ? this.material.color.set(this.color) : this.material.color.copy(this.light.color)
	};
	Br.prototype = Object.create(u.prototype);
	Br.prototype.constructor = Br;
	Br.prototype.dispose = function () {
		this.children[0].geometry.dispose();
		this.children[0].material.dispose()
	};
	Br.prototype.update = function () {
		var t = .5 * this.light.width,
			e = .5 * this.light.height,
			i = this.line.geometry.attributes.position,
			n = i.array;
		n[0] = t;
		n[1] = -e;
		n[2] = 0;
		n[3] = t;
		n[4] = e;
		n[5] = 0;
		n[6] = -t;
		n[7] = e;
		n[8] = 0;
		n[9] = -t;
		n[10] = -e;
		n[11] = 0;
		n[12] = t;
		n[13] = -e;
		n[14] = 0;
		i.needsUpdate = !0;
		void 0 !== this.color ? this.line.material.color.set(this.color) : this.line.material.color.copy(this.light.color)
	};
	Ur.prototype = Object.create(u.prototype);
	Ur.prototype.constructor = Ur;
	Ur.prototype.dispose = function () {
		this.children[0].geometry.dispose();
		this.children[0].material.dispose()
	};
	Ur.prototype.update = function () {
		var o = new _t,
			a = new w,
			s = new w;
		return function () {
			var t = this.children[0];
			if (void 0 !== this.color) this.material.color.set(this.color);
			else {
				var e = t.geometry.getAttribute("color");
				a.copy(this.light.color);
				s.copy(this.light.groundColor);
				for (var i = 0, n = e.count; i < n; i++) {
					var r = i < n / 2 ? a : s;
					e.setXYZ(i, r.r, r.g, r.b)
				}
				e.needsUpdate = !0
			}
			t.lookAt(o.setFromMatrixPosition(this.light.matrixWorld).negate())
		}
	}();
	zr.prototype = Object.create(Ie.prototype);
	zr.prototype.constructor = zr;
	Gr.prototype = Object.create(Ie.prototype);
	Gr.prototype.constructor = Gr;
	Hr.prototype = Object.create(Ie.prototype);
	Hr.prototype.constructor = Hr;
	Hr.prototype.update = function () {
		var c = new _t,
			u = new _t,
			h = new g;
		return function () {
			this.object.updateMatrixWorld(!0);
			h.getNormalMatrix(this.object.matrixWorld);
			var t = this.object.matrixWorld,
				e = this.geometry.attributes.position,
				i = this.object.geometry,
				n = i.vertices;
			i = i.faces;
			for (var r = 0, o = 0, a = i.length; o < a; o++) {
				var s = i[o],
					l = s.normal;
				c.copy(n[s.a]).add(n[s.b]).add(n[s.c]).divideScalar(3).applyMatrix4(t);
				u.copy(l).applyMatrix3(h).normalize().multiplyScalar(this.size).add(c);
				e.setXYZ(r, c.x, c.y, c.z);
				r += 1;
				e.setXYZ(r, u.x, u.y, u.z);
				r += 1
			}
			e.needsUpdate = !0
		}
	}();
	jr.prototype = Object.create(u.prototype);
	jr.prototype.constructor = jr;
	jr.prototype.dispose = function () {
		this.lightPlane.geometry.dispose();
		this.lightPlane.material.dispose();
		this.targetLine.geometry.dispose();
		this.targetLine.material.dispose()
	};
	jr.prototype.update = function () {
		var t = new _t,
			e = new _t,
			i = new _t;
		return function () {
			t.setFromMatrixPosition(this.light.matrixWorld);
			e.setFromMatrixPosition(this.light.target.matrixWorld);
			i.subVectors(e, t);
			this.lightPlane.lookAt(i);
			void 0 !== this.color ? (this.lightPlane.material.color.set(this.color), this.targetLine.material.color.set(this.color)) : (this.lightPlane.material.color.copy(this.light.color), this.targetLine.material.color.copy(this.light.color));
			this.targetLine.lookAt(i);
			this.targetLine.scale.z = i.length()
		}
	}();
	Vr.prototype = Object.create(Ie.prototype);
	Vr.prototype.constructor = Vr;
	Vr.prototype.update = function () {
		function t(t, e, i, n) {
			a.set(e, i, n).unproject(s);
			t = o[t];
			if (void 0 !== t)
				for (e = r.getAttribute("position"), i = 0, n = t.length; i < n; i++) e.setXYZ(t[i], a.x, a.y, a.z)
		}
		var r, o, a = new _t,
			s = new l;
		return function () {
			r = this.geometry;
			o = this.pointMap;
			s.projectionMatrix.copy(this.camera.projectionMatrix);
			t("c", 0, 0, -1);
			t("t", 0, 0, 1);
			t("n1", -1, -1, -1);
			t("n2", 1, -1, -1);
			t("n3", -1, 1, -1);
			t("n4", 1, 1, -1);
			t("f1", -1, -1, 1);
			t("f2", 1, -1, 1);
			t("f3", -1, 1, 1);
			t("f4", 1, 1, 1);
			t("u1", .7, 1.1, -1);
			t("u2", -.7, 1.1, -1);
			t("u3", 0, 2, -1);
			t("cf1", -1, 0, 1);
			t("cf2", 1, 0, 1);
			t("cf3", 0, -1, 1);
			t("cf4", 0, 1, 1);
			t("cn1", -1, 0, -1);
			t("cn2", 1, 0, -1);
			t("cn3", 0, -1, -1);
			t("cn4", 0, 1, -1);
			r.getAttribute("position").needsUpdate = !0
		}
	}();
	Wr.prototype = Object.create(Ie.prototype);
	Wr.prototype.constructor = Wr;
	Wr.prototype.update = function () {
		var r = new i;
		return function (t) {
			void 0 !== t && console.warn("THREE.BoxHelper: .update() has no longer arguments.");
			void 0 !== this.object && r.setFromObject(this.object);
			if (!r.isEmpty()) {
				t = r.min;
				var e = r.max,
					i = this.geometry.attributes.position,
					n = i.array;
				n[0] = e.x;
				n[1] = e.y;
				n[2] = e.z;
				n[3] = t.x;
				n[4] = e.y;
				n[5] = e.z;
				n[6] = t.x;
				n[7] = t.y;
				n[8] = e.z;
				n[9] = e.x;
				n[10] = t.y;
				n[11] = e.z;
				n[12] = e.x;
				n[13] = e.y;
				n[14] = t.z;
				n[15] = t.x;
				n[16] = e.y;
				n[17] = t.z;
				n[18] = t.x;
				n[19] = t.y;
				n[20] = t.z;
				n[21] = e.x;
				n[22] = t.y;
				n[23] = t.z;
				i.needsUpdate = !0;
				this.geometry.computeBoundingSphere()
			}
		}
	}();
	Wr.prototype.setFromObject = function (t) {
		this.object = t;
		this.update();
		return this
	};
	Xr.prototype = Object.create(Ie.prototype);
	Xr.prototype.constructor = Xr;
	Xr.prototype.updateMatrixWorld = function (t) {
		var e = this.box;
		e.isEmpty() || (e.getCenter(this.position), e.getSize(this.scale), this.scale.multiplyScalar(.5), u.prototype.updateMatrixWorld.call(this, t))
	};
	Yr.prototype = Object.create(Ne.prototype);
	Yr.prototype.constructor = Yr;
	Yr.prototype.updateMatrixWorld = function (t) {
		var e = -this.plane.constant;
		1e-8 > Math.abs(e) && (e = 1e-8);
		this.scale.set(.5 * this.size, .5 * this.size, e);
		this.children[0].material.side = 0 > e ? 1 : 0;
		this.lookAt(this.plane.normal);
		u.prototype.updateMatrixWorld.call(this, t)
	};
	var Ho, jo;
	qr.prototype = Object.create(u.prototype);
	qr.prototype.constructor = qr;
	qr.prototype.setDirection = function () {
		var e = new _t,
			i;
		return function (t) {
			.99999 < t.y ? this.quaternion.set(0, 0, 0, 1) : -.99999 > t.y ? this.quaternion.set(1, 0, 0, 0) : (e.set(t.z, 0, -t.x).normalize(), i = Math.acos(t.y), this.quaternion.setFromAxisAngle(e, i))
		}
	}();
	qr.prototype.setLength = function (t, e, i) {
		void 0 === e && (e = .2 * t);
		void 0 === i && (i = .2 * e);
		this.line.scale.set(1, Math.max(0, t - e), 1);
		this.line.updateMatrix();
		this.cone.scale.set(i, e, i);
		this.cone.position.y = t;
		this.cone.updateMatrix()
	};
	qr.prototype.setColor = function (t) {
		this.line.material.color.copy(t);
		this.cone.material.color.copy(t)
	};
	$r.prototype = Object.create(Ie.prototype);
	$r.prototype.constructor = $r;
	un.create = function (t, e) {
		console.log("THREE.Curve.create() has been deprecated");
		t.prototype = Object.create(un.prototype);
		t.prototype.constructor = t;
		t.prototype.getPoint = e;
		return t
	};
	Object.assign(Sn.prototype, {
		createPointsGeometry: function (t) {
			console.warn("THREE.CurvePath: .createPointsGeometry() has been removed. Use new THREE.Geometry().setFromPoints( points ) instead.");
			t = this.getPoints(t);
			return this.createGeometry(t)
		},
		createSpacedPointsGeometry: function (t) {
			console.warn("THREE.CurvePath: .createSpacedPointsGeometry() has been removed. Use new THREE.Geometry().setFromPoints( points ) instead.");
			t = this.getSpacedPoints(t);
			return this.createGeometry(t)
		},
		createGeometry: function (t) {
			console.warn("THREE.CurvePath: .createGeometry() has been removed. Use new THREE.Geometry().setFromPoints( points ) instead.");
			for (var e = new T, i = 0, n = t.length; i < n; i++) {
				var r = t[i];
				e.vertices.push(new _t(r.x, r.y, r.z || 0))
			}
			return e
		}
	});
	Object.assign(Mn.prototype, {
		fromPoints: function (t) {
			console.warn("THREE.Path: .fromPoints() has been renamed to .setFromPoints().");
			this.setFromPoints(t)
		}
	});
	Zr.prototype = Object.create(pn.prototype);
	Jr.prototype = Object.create(pn.prototype);
	Qr.prototype = Object.create(pn.prototype);
	Object.assign(Qr.prototype, {
		initFromArray: function () {
			console.error("THREE.Spline: .initFromArray() has been removed.")
		},
		getControlPointsArray: function () {
			console.error("THREE.Spline: .getControlPointsArray() has been removed.")
		},
		reparametrizeByArcLength: function () {
			console.error("THREE.Spline: .reparametrizeByArcLength() has been removed.")
		}
	});
	zr.prototype.setColors = function () {
		console.error("THREE.GridHelper: setColors() has been deprecated, pass them in the constructor instead.")
	};
	Dr.prototype.update = function () {
		console.error("THREE.SkeletonHelper: update() no longer needs to be called.")
	};
	Object.assign(Kn.prototype, {
		extractUrlBase: function (t) {
			console.warn("THREE.Loader: .extractUrlBase() has been deprecated. Use THREE.LoaderUtils.extractUrlBase() instead.");
			return Do.extractUrlBase(t)
		}
	});
	Object.assign(Rr.prototype, {
		center: function (t) {
			console.warn("THREE.Box2: .center() has been renamed to .getCenter().");
			return this.getCenter(t)
		},
		empty: function () {
			console.warn("THREE.Box2: .empty() has been renamed to .isEmpty().");
			return this.isEmpty()
		},
		isIntersectionBox: function (t) {
			console.warn("THREE.Box2: .isIntersectionBox() has been renamed to .intersectsBox().");
			return this.intersectsBox(t)
		},
		size: function (t) {
			console.warn("THREE.Box2: .size() has been renamed to .getSize().");
			return this.getSize(t)
		}
	});
	Object.assign(i.prototype, {
		center: function (t) {
			console.warn("THREE.Box3: .center() has been renamed to .getCenter().");
			return this.getCenter(t)
		},
		empty: function () {
			console.warn("THREE.Box3: .empty() has been renamed to .isEmpty().");
			return this.isEmpty()
		},
		isIntersectionBox: function (t) {
			console.warn("THREE.Box3: .isIntersectionBox() has been renamed to .intersectsBox().");
			return this.intersectsBox(t)
		},
		isIntersectionSphere: function (t) {
			console.warn("THREE.Box3: .isIntersectionSphere() has been renamed to .intersectsSphere().");
			return this.intersectsSphere(t)
		},
		size: function (t) {
			console.warn("THREE.Box3: .size() has been renamed to .getSize().");
			return this.getSize(t)
		}
	});
	D.prototype.center = function (t) {
		console.warn("THREE.Line3: .center() has been renamed to .getCenter().");
		return this.getCenter(t)
	};
	Object.assign(Kr, {
		random16: function () {
			console.warn("THREE.Math: .random16() has been deprecated. Use Math.random() instead.");
			return Math.random()
		},
		nearestPowerOfTwo: function (t) {
			console.warn("THREE.Math: .nearestPowerOfTwo() has been renamed to .floorPowerOfTwo().");
			return Kr.floorPowerOfTwo(t)
		},
		nextPowerOfTwo: function (t) {
			console.warn("THREE.Math: .nextPowerOfTwo() has been renamed to .ceilPowerOfTwo().");
			return Kr.ceilPowerOfTwo(t)
		}
	});
	Object.assign(g.prototype, {
		flattenToArrayOffset: function (t, e) {
			console.warn("THREE.Matrix3: .flattenToArrayOffset() has been deprecated. Use .toArray() instead.");
			return this.toArray(t, e)
		},
		multiplyVector3: function (t) {
			console.warn("THREE.Matrix3: .multiplyVector3() has been removed. Use vector.applyMatrix3( matrix ) instead.");
			return t.applyMatrix3(this)
		},
		multiplyVector3Array: function () {
			console.error("THREE.Matrix3: .multiplyVector3Array() has been removed.")
		},
		applyToBuffer: function (t) {
			console.warn("THREE.Matrix3: .applyToBuffer() has been removed. Use matrix.applyToBufferAttribute( attribute ) instead.");
			return this.applyToBufferAttribute(t)
		},
		applyToVector3Array: function () {
			console.error("THREE.Matrix3: .applyToVector3Array() has been removed.")
		}
	});
	Object.assign(xt.prototype, {
		extractPosition: function (t) {
			console.warn("THREE.Matrix4: .extractPosition() has been renamed to .copyPosition().");
			return this.copyPosition(t)
		},
		flattenToArrayOffset: function (t, e) {
			console.warn("THREE.Matrix4: .flattenToArrayOffset() has been deprecated. Use .toArray() instead.");
			return this.toArray(t, e)
		},
		getPosition: function () {
			var t;
			return function () {
				void 0 === t && (t = new _t);
				console.warn("THREE.Matrix4: .getPosition() has been removed. Use Vector3.setFromMatrixPosition( matrix ) instead.");
				return t.setFromMatrixColumn(this, 3)
			}
		}(),
		setRotationFromQuaternion: function (t) {
			console.warn("THREE.Matrix4: .setRotationFromQuaternion() has been renamed to .makeRotationFromQuaternion().");
			return this.makeRotationFromQuaternion(t)
		},
		multiplyToArray: function () {
			console.warn("THREE.Matrix4: .multiplyToArray() has been removed.")
		},
		multiplyVector3: function (t) {
			console.warn("THREE.Matrix4: .multiplyVector3() has been removed. Use vector.applyMatrix4( matrix ) instead.");
			return t.applyMatrix4(this)
		},
		multiplyVector4: function (t) {
			console.warn("THREE.Matrix4: .multiplyVector4() has been removed. Use vector.applyMatrix4( matrix ) instead.");
			return t.applyMatrix4(this)
		},
		multiplyVector3Array: function () {
			console.error("THREE.Matrix4: .multiplyVector3Array() has been removed.")
		},
		rotateAxis: function (t) {
			console.warn("THREE.Matrix4: .rotateAxis() has been removed. Use Vector3.transformDirection( matrix ) instead.");
			t.transformDirection(this)
		},
		crossVector: function (t) {
			console.warn("THREE.Matrix4: .crossVector() has been removed. Use vector.applyMatrix4( matrix ) instead.");
			return t.applyMatrix4(this)
		},
		translate: function () {
			console.error("THREE.Matrix4: .translate() has been removed.")
		},
		rotateX: function () {
			console.error("THREE.Matrix4: .rotateX() has been removed.")
		},
		rotateY: function () {
			console.error("THREE.Matrix4: .rotateY() has been removed.")
		},
		rotateZ: function () {
			console.error("THREE.Matrix4: .rotateZ() has been removed.")
		},
		rotateByAxis: function () {
			console.error("THREE.Matrix4: .rotateByAxis() has been removed.")
		},
		applyToBuffer: function (t) {
			console.warn("THREE.Matrix4: .applyToBuffer() has been removed. Use matrix.applyToBufferAttribute( attribute ) instead.");
			return this.applyToBufferAttribute(t)
		},
		applyToVector3Array: function () {
			console.error("THREE.Matrix4: .applyToVector3Array() has been removed.")
		},
		makeFrustum: function (t, e, i, n, r, o) {
			console.warn("THREE.Matrix4: .makeFrustum() has been removed. Use .makePerspective( left, right, top, bottom, near, far ) instead.");
			return this.makePerspective(t, e, n, i, r, o)
		}
	});
	v.prototype.isIntersectionLine = function (t) {
		console.warn("THREE.Plane: .isIntersectionLine() has been renamed to .intersectsLine().");
		return this.intersectsLine(t)
	};
	j.prototype.multiplyVector3 = function (t) {
		console.warn("THREE.Quaternion: .multiplyVector3() has been removed. Use is now vector.applyQuaternion( quaternion ) instead.");
		return t.applyQuaternion(this)
	};
	Object.assign(B.prototype, {
		isIntersectionBox: function (t) {
			console.warn("THREE.Ray: .isIntersectionBox() has been renamed to .intersectsBox().");
			return this.intersectsBox(t)
		},
		isIntersectionPlane: function (t) {
			console.warn("THREE.Ray: .isIntersectionPlane() has been renamed to .intersectsPlane().");
			return this.intersectsPlane(t)
		},
		isIntersectionSphere: function (t) {
			console.warn("THREE.Ray: .isIntersectionSphere() has been renamed to .intersectsSphere().");
			return this.intersectsSphere(t)
		}
	});
	Object.assign(U.prototype, {
		area: function () {
			console.warn("THREE.Triangle: .area() has been renamed to .getArea().");
			return this.getArea()
		},
		barycoordFromPoint: function (t, e) {
			console.warn("THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord().");
			return this.getBarycoord(t, e)
		},
		midpoint: function (t) {
			console.warn("THREE.Triangle: .midpoint() has been renamed to .getMidpoint().");
			return this.getMidpoint(t)
		},
		normal: function (t) {
			console.warn("THREE.Triangle: .normal() has been renamed to .getNormal().");
			return this.getNormal(t)
		},
		plane: function (t) {
			console.warn("THREE.Triangle: .plane() has been renamed to .getPlane().");
			return this.getPlane(t)
		}
	});
	Object.assign(U, {
		barycoordFromPoint: function (t, e, i, n, r) {
			console.warn("THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord().");
			return U.getBarycoord(t, e, i, n, r)
		},
		normal: function (t, e, i, n) {
			console.warn("THREE.Triangle: .normal() has been renamed to .getNormal().");
			return U.getNormal(t, e, i, n)
		}
	});
	Object.assign(An.prototype, {
		extractAllPoints: function (t) {
			console.warn("THREE.Shape: .extractAllPoints() has been removed. Use .extractPoints() instead.");
			return this.extractPoints(t)
		},
		extrude: function (t) {
			console.warn("THREE.Shape: .extrude() has been removed. Use ExtrudeGeometry() instead.");
			return new Mi(this, t)
		},
		makeGeometry: function (t) {
			console.warn("THREE.Shape: .makeGeometry() has been removed. Use ShapeGeometry() instead.");
			return new Fi(this, t)
		}
	});
	Object.assign(W.prototype, {
		fromAttribute: function (t, e, i) {
			console.warn("THREE.Vector2: .fromAttribute() has been renamed to .fromBufferAttribute().");
			return this.fromBufferAttribute(t, e, i)
		},
		distanceToManhattan: function (t) {
			console.warn("THREE.Vector2: .distanceToManhattan() has been renamed to .manhattanDistanceTo().");
			return this.manhattanDistanceTo(t)
		},
		lengthManhattan: function () {
			console.warn("THREE.Vector2: .lengthManhattan() has been renamed to .manhattanLength().");
			return this.manhattanLength()
		}
	});
	Object.assign(_t.prototype, {
		setEulerFromRotationMatrix: function () {
			console.error("THREE.Vector3: .setEulerFromRotationMatrix() has been removed. Use Euler.setFromRotationMatrix() instead.")
		},
		setEulerFromQuaternion: function () {
			console.error("THREE.Vector3: .setEulerFromQuaternion() has been removed. Use Euler.setFromQuaternion() instead.")
		},
		getPositionFromMatrix: function (t) {
			console.warn("THREE.Vector3: .getPositionFromMatrix() has been renamed to .setFromMatrixPosition().");
			return this.setFromMatrixPosition(t)
		},
		getScaleFromMatrix: function (t) {
			console.warn("THREE.Vector3: .getScaleFromMatrix() has been renamed to .setFromMatrixScale().");
			return this.setFromMatrixScale(t)
		},
		getColumnFromMatrix: function (t, e) {
			console.warn("THREE.Vector3: .getColumnFromMatrix() has been renamed to .setFromMatrixColumn().");
			return this.setFromMatrixColumn(e, t)
		},
		applyProjection: function (t) {
			console.warn("THREE.Vector3: .applyProjection() has been removed. Use .applyMatrix4( m ) instead.");
			return this.applyMatrix4(t)
		},
		fromAttribute: function (t, e, i) {
			console.warn("THREE.Vector3: .fromAttribute() has been renamed to .fromBufferAttribute().");
			return this.fromBufferAttribute(t, e, i)
		},
		distanceToManhattan: function (t) {
			console.warn("THREE.Vector3: .distanceToManhattan() has been renamed to .manhattanDistanceTo().");
			return this.manhattanDistanceTo(t)
		},
		lengthManhattan: function () {
			console.warn("THREE.Vector3: .lengthManhattan() has been renamed to .manhattanLength().");
			return this.manhattanLength()
		}
	});
	Object.assign(bt.prototype, {
		fromAttribute: function (t, e, i) {
			console.warn("THREE.Vector4: .fromAttribute() has been renamed to .fromBufferAttribute().");
			return this.fromBufferAttribute(t, e, i)
		},
		lengthManhattan: function () {
			console.warn("THREE.Vector4: .lengthManhattan() has been renamed to .manhattanLength().");
			return this.manhattanLength()
		}
	});
	Object.assign(T.prototype, {
		computeTangents: function () {
			console.error("THREE.Geometry: .computeTangents() has been removed.")
		},
		computeLineDistances: function () {
			console.error("THREE.Geometry: .computeLineDistances() has been removed. Use THREE.Line.computeLineDistances() instead.")
		}
	});
	Object.assign(u.prototype, {
		getChildByName: function (t) {
			console.warn("THREE.Object3D: .getChildByName() has been renamed to .getObjectByName().");
			return this.getObjectByName(t)
		},
		renderDepth: function () {
			console.warn("THREE.Object3D: .renderDepth has been removed. Use .renderOrder, instead.")
		},
		translate: function (t, e) {
			console.warn("THREE.Object3D: .translate() has been removed. Use .translateOnAxis( axis, distance ) instead.");
			return this.translateOnAxis(e, t)
		},
		getWorldRotation: function () {
			console.error("THREE.Object3D: .getWorldRotation() has been removed. Use THREE.Object3D.getWorldQuaternion( target ) instead.")
		}
	});
	Object.defineProperties(u.prototype, {
		eulerOrder: {
			get: function () {
				console.warn("THREE.Object3D: .eulerOrder is now .rotation.order.");
				return this.rotation.order
			},
			set: function (t) {
				console.warn("THREE.Object3D: .eulerOrder is now .rotation.order.");
				this.rotation.order = t
			}
		},
		useQuaternion: {
			get: function () {
				console.warn("THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.")
			},
			set: function () {
				console.warn("THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.")
			}
		}
	});
	Object.defineProperties(Pe.prototype, {
		objects: {
			get: function () {
				console.warn("THREE.LOD: .objects has been renamed to .levels.");
				return this.levels
			}
		}
	});
	Object.defineProperty(Le.prototype, "useVertexTexture", {
		get: function () {
			console.warn("THREE.Skeleton: useVertexTexture has been removed.")
		},
		set: function () {
			console.warn("THREE.Skeleton: useVertexTexture has been removed.")
		}
	});
	Object.defineProperty(un.prototype, "__arcLengthDivisions", {
		get: function () {
			console.warn("THREE.Curve: .__arcLengthDivisions is now .arcLengthDivisions.");
			return this.arcLengthDivisions
		},
		set: function (t) {
			console.warn("THREE.Curve: .__arcLengthDivisions is now .arcLengthDivisions.");
			this.arcLengthDivisions = t
		}
	});
	xe.prototype.setLens = function (t, e) {
		console.warn("THREE.PerspectiveCamera.setLens is deprecated. Use .setFocalLength and .filmGauge for a photographic setup.");
		void 0 !== e && (this.filmGauge = e);
		this.setFocalLength(t)
	};
	Object.defineProperties(Cn.prototype, {
		onlyShadow: {
			set: function () {
				console.warn("THREE.Light: .onlyShadow has been removed.")
			}
		},
		shadowCameraFov: {
			set: function (t) {
				console.warn("THREE.Light: .shadowCameraFov is now .shadow.camera.fov.");
				this.shadow.camera.fov = t
			}
		},
		shadowCameraLeft: {
			set: function (t) {
				console.warn("THREE.Light: .shadowCameraLeft is now .shadow.camera.left.");
				this.shadow.camera.left = t
			}
		},
		shadowCameraRight: {
			set: function (t) {
				console.warn("THREE.Light: .shadowCameraRight is now .shadow.camera.right.");
				this.shadow.camera.right = t
			}
		},
		shadowCameraTop: {
			set: function (t) {
				console.warn("THREE.Light: .shadowCameraTop is now .shadow.camera.top.");
				this.shadow.camera.top = t
			}
		},
		shadowCameraBottom: {
			set: function (t) {
				console.warn("THREE.Light: .shadowCameraBottom is now .shadow.camera.bottom.");
				this.shadow.camera.bottom = t
			}
		},
		shadowCameraNear: {
			set: function (t) {
				console.warn("THREE.Light: .shadowCameraNear is now .shadow.camera.near.");
				this.shadow.camera.near = t
			}
		},
		shadowCameraFar: {
			set: function (t) {
				console.warn("THREE.Light: .shadowCameraFar is now .shadow.camera.far.");
				this.shadow.camera.far = t
			}
		},
		shadowCameraVisible: {
			set: function () {
				console.warn("THREE.Light: .shadowCameraVisible has been removed. Use new THREE.CameraHelper( light.shadow.camera ) instead.")
			}
		},
		shadowBias: {
			set: function (t) {
				console.warn("THREE.Light: .shadowBias is now .shadow.bias.");
				this.shadow.bias = t
			}
		},
		shadowDarkness: {
			set: function () {
				console.warn("THREE.Light: .shadowDarkness has been removed.")
			}
		},
		shadowMapWidth: {
			set: function (t) {
				console.warn("THREE.Light: .shadowMapWidth is now .shadow.mapSize.width.");
				this.shadow.mapSize.width = t
			}
		},
		shadowMapHeight: {
			set: function (t) {
				console.warn("THREE.Light: .shadowMapHeight is now .shadow.mapSize.height.");
				this.shadow.mapSize.height = t
			}
		}
	});
	Object.defineProperties(y.prototype, {
		length: {
			get: function () {
				console.warn("THREE.BufferAttribute: .length has been deprecated. Use .count instead.");
				return this.array.length
			}
		},
		copyIndicesArray: function () {
			console.error("THREE.BufferAttribute: .copyIndicesArray() has been removed.")
		}
	});
	Object.assign(L.prototype, {
		addIndex: function (t) {
			console.warn("THREE.BufferGeometry: .addIndex() has been renamed to .setIndex().");
			this.setIndex(t)
		},
		addDrawCall: function (t, e, i) {
			void 0 !== i && console.warn("THREE.BufferGeometry: .addDrawCall() no longer supports indexOffset.");
			console.warn("THREE.BufferGeometry: .addDrawCall() is now .addGroup().");
			this.addGroup(t, e)
		},
		clearDrawCalls: function () {
			console.warn("THREE.BufferGeometry: .clearDrawCalls() is now .clearGroups().");
			this.clearGroups()
		},
		computeTangents: function () {
			console.warn("THREE.BufferGeometry: .computeTangents() has been removed.")
		},
		computeOffsets: function () {
			console.warn("THREE.BufferGeometry: .computeOffsets() has been removed.")
		}
	});
	Object.defineProperties(L.prototype, {
		drawcalls: {
			get: function () {
				console.error("THREE.BufferGeometry: .drawcalls has been renamed to .groups.");
				return this.groups
			}
		},
		offsets: {
			get: function () {
				console.warn("THREE.BufferGeometry: .offsets has been renamed to .groups.");
				return this.groups
			}
		}
	});
	Object.assign(Ai.prototype, {
		getArrays: function () {
			console.error("THREE.ExtrudeBufferGeometry: .getArrays() has been removed.")
		},
		addShapeList: function () {
			console.error("THREE.ExtrudeBufferGeometry: .addShapeList() has been removed.")
		},
		addShape: function () {
			console.error("THREE.ExtrudeBufferGeometry: .addShape() has been removed.")
		}
	});
	Object.defineProperties(xr.prototype, {
		dynamic: {
			set: function () {
				console.warn("THREE.Uniform: .dynamic has been removed. Use object.onBeforeRender() instead.")
			}
		},
		onUpdate: {
			value: function () {
				console.warn("THREE.Uniform: .onUpdate() has been removed. Use object.onBeforeRender() instead.");
				return this
			}
		}
	});
	Object.defineProperties(k.prototype, {
		wrapAround: {
			get: function () {
				console.warn("THREE.Material: .wrapAround has been removed.")
			},
			set: function () {
				console.warn("THREE.Material: .wrapAround has been removed.")
			}
		},
		wrapRGB: {
			get: function () {
				console.warn("THREE.Material: .wrapRGB has been removed.");
				return new w
			}
		},
		shading: {
			get: function () {
				console.error("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead.")
			},
			set: function (t) {
				console.warn("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead.");
				this.flatShading = 1 === t
			}
		}
	});
	Object.defineProperties(Ji.prototype, {
		metal: {
			get: function () {
				console.warn("THREE.MeshPhongMaterial: .metal has been removed. Use THREE.MeshStandardMaterial instead.");
				return !1
			},
			set: function () {
				console.warn("THREE.MeshPhongMaterial: .metal has been removed. Use THREE.MeshStandardMaterial instead")
			}
		}
	});
	Object.defineProperties(I.prototype, {
		derivatives: {
			get: function () {
				console.warn("THREE.ShaderMaterial: .derivatives has been moved to .extensions.derivatives.");
				return this.extensions.derivatives
			},
			set: function (t) {
				console.warn("THREE. ShaderMaterial: .derivatives has been moved to .extensions.derivatives.");
				this.extensions.derivatives = t
			}
		}
	});
	Object.assign(Te.prototype, {
		animate: function (t) {
			console.warn("THREE.WebGLRenderer: .animate() is now .setAnimationLoop().");
			this.setAnimationLoop(t)
		},
		getCurrentRenderTarget: function () {
			console.warn("THREE.WebGLRenderer: .getCurrentRenderTarget() is now .getRenderTarget().");
			return this.getRenderTarget()
		},
		getMaxAnisotropy: function () {
			console.warn("THREE.WebGLRenderer: .getMaxAnisotropy() is now .capabilities.getMaxAnisotropy().");
			return this.capabilities.getMaxAnisotropy()
		},
		getPrecision: function () {
			console.warn("THREE.WebGLRenderer: .getPrecision() is now .capabilities.precision.");
			return this.capabilities.precision
		},
		resetGLState: function () {
			console.warn("THREE.WebGLRenderer: .resetGLState() is now .state.reset().");
			return this.state.reset()
		},
		supportsFloatTextures: function () {
			console.warn("THREE.WebGLRenderer: .supportsFloatTextures() is now .extensions.get( 'OES_texture_float' ).");
			return this.extensions.get("OES_texture_float")
		},
		supportsHalfFloatTextures: function () {
			console.warn("THREE.WebGLRenderer: .supportsHalfFloatTextures() is now .extensions.get( 'OES_texture_half_float' ).");
			return this.extensions.get("OES_texture_half_float")
		},
		supportsStandardDerivatives: function () {
			console.warn("THREE.WebGLRenderer: .supportsStandardDerivatives() is now .extensions.get( 'OES_standard_derivatives' ).");
			return this.extensions.get("OES_standard_derivatives")
		},
		supportsCompressedTextureS3TC: function () {
			console.warn("THREE.WebGLRenderer: .supportsCompressedTextureS3TC() is now .extensions.get( 'WEBGL_compressed_texture_s3tc' ).");
			return this.extensions.get("WEBGL_compressed_texture_s3tc")
		},
		supportsCompressedTexturePVRTC: function () {
			console.warn("THREE.WebGLRenderer: .supportsCompressedTexturePVRTC() is now .extensions.get( 'WEBGL_compressed_texture_pvrtc' ).");
			return this.extensions.get("WEBGL_compressed_texture_pvrtc")
		},
		supportsBlendMinMax: function () {
			console.warn("THREE.WebGLRenderer: .supportsBlendMinMax() is now .extensions.get( 'EXT_blend_minmax' ).");
			return this.extensions.get("EXT_blend_minmax")
		},
		supportsVertexTextures: function () {
			console.warn("THREE.WebGLRenderer: .supportsVertexTextures() is now .capabilities.vertexTextures.");
			return this.capabilities.vertexTextures
		},
		supportsInstancedArrays: function () {
			console.warn("THREE.WebGLRenderer: .supportsInstancedArrays() is now .extensions.get( 'ANGLE_instanced_arrays' ).");
			return this.extensions.get("ANGLE_instanced_arrays")
		},
		enableScissorTest: function (t) {
			console.warn("THREE.WebGLRenderer: .enableScissorTest() is now .setScissorTest().");
			this.setScissorTest(t)
		},
		initMaterial: function () {
			console.warn("THREE.WebGLRenderer: .initMaterial() has been removed.")
		},
		addPrePlugin: function () {
			console.warn("THREE.WebGLRenderer: .addPrePlugin() has been removed.")
		},
		addPostPlugin: function () {
			console.warn("THREE.WebGLRenderer: .addPostPlugin() has been removed.")
		},
		updateShadowMap: function () {
			console.warn("THREE.WebGLRenderer: .updateShadowMap() has been removed.")
		},
		setFaceCulling: function () {
			console.warn("THREE.WebGLRenderer: .setFaceCulling() has been removed.")
		}
	});
	Object.defineProperties(Te.prototype, {
		shadowMapEnabled: {
			get: function () {
				return this.shadowMap.enabled
			},
			set: function (t) {
				console.warn("THREE.WebGLRenderer: .shadowMapEnabled is now .shadowMap.enabled.");
				this.shadowMap.enabled = t
			}
		},
		shadowMapType: {
			get: function () {
				return this.shadowMap.type
			},
			set: function (t) {
				console.warn("THREE.WebGLRenderer: .shadowMapType is now .shadowMap.type.");
				this.shadowMap.type = t
			}
		},
		shadowMapCullFace: {
			get: function () {
				console.warn("THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.")
			},
			set: function () {
				console.warn("THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.")
			}
		}
	});
	Object.defineProperties(fe.prototype, {
		cullFace: {
			get: function () {
				console.warn("THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.")
			},
			set: function () {
				console.warn("THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.")
			}
		},
		renderReverseSided: {
			get: function () {
				console.warn("THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.")
			},
			set: function () {
				console.warn("THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.")
			}
		},
		renderSingleSided: {
			get: function () {
				console.warn("THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.")
			},
			set: function () {
				console.warn("THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.")
			}
		}
	});
	Object.defineProperties(A.prototype, {
		wrapS: {
			get: function () {
				console.warn("THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.");
				return this.texture.wrapS
			},
			set: function (t) {
				console.warn("THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.");
				this.texture.wrapS = t
			}
		},
		wrapT: {
			get: function () {
				console.warn("THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.");
				return this.texture.wrapT
			},
			set: function (t) {
				console.warn("THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.");
				this.texture.wrapT = t
			}
		},
		magFilter: {
			get: function () {
				console.warn("THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.");
				return this.texture.magFilter
			},
			set: function (t) {
				console.warn("THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.");
				this.texture.magFilter = t
			}
		},
		minFilter: {
			get: function () {
				console.warn("THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.");
				return this.texture.minFilter
			},
			set: function (t) {
				console.warn("THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.");
				this.texture.minFilter = t
			}
		},
		anisotropy: {
			get: function () {
				console.warn("THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.");
				return this.texture.anisotropy
			},
			set: function (t) {
				console.warn("THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.");
				this.texture.anisotropy = t
			}
		},
		offset: {
			get: function () {
				console.warn("THREE.WebGLRenderTarget: .offset is now .texture.offset.");
				return this.texture.offset
			},
			set: function (t) {
				console.warn("THREE.WebGLRenderTarget: .offset is now .texture.offset.");
				this.texture.offset = t
			}
		},
		repeat: {
			get: function () {
				console.warn("THREE.WebGLRenderTarget: .repeat is now .texture.repeat.");
				return this.texture.repeat
			},
			set: function (t) {
				console.warn("THREE.WebGLRenderTarget: .repeat is now .texture.repeat.");
				this.texture.repeat = t
			}
		},
		format: {
			get: function () {
				console.warn("THREE.WebGLRenderTarget: .format is now .texture.format.");
				return this.texture.format
			},
			set: function (t) {
				console.warn("THREE.WebGLRenderTarget: .format is now .texture.format.");
				this.texture.format = t
			}
		},
		type: {
			get: function () {
				console.warn("THREE.WebGLRenderTarget: .type is now .texture.type.");
				return this.texture.type
			},
			set: function (t) {
				console.warn("THREE.WebGLRenderTarget: .type is now .texture.type.");
				this.texture.type = t
			}
		},
		generateMipmaps: {
			get: function () {
				console.warn("THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.");
				return this.texture.generateMipmaps
			},
			set: function (t) {
				console.warn("THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.");
				this.texture.generateMipmaps = t
			}
		}
	});
	Object.defineProperties(be.prototype, {
		standing: {
			set: function () {
				console.warn("THREE.WebVRManager: .standing has been removed.")
			}
		}
	});
	ur.prototype.load = function (t) {
		console.warn("THREE.Audio: .load has been deprecated. Use THREE.AudioLoader instead.");
		var e = this;
		(new ar).load(t, function (t) {
			e.setBuffer(t)
		});
		return this
	};
	dr.prototype.getData = function () {
		console.warn("THREE.AudioAnalyser: .getData() is now .getFrequencyData().");
		return this.getFrequencyData()
	};
	lr.prototype.updateCubeMap = function (t, e) {
		console.warn("THREE.CubeCamera: .updateCubeMap() is now .update().");
		return this.update(t, e)
	};
	t.WebGLRenderTargetCube = n;
	t.WebGLRenderTarget = A;
	t.WebGLRenderer = Te;
	t.ShaderLib = oo;
	t.UniformsLib = ro;
	t.UniformsUtils = io;
	t.ShaderChunk = eo;
	t.FogExp2 = Ee;
	t.Fog = Se;
	t.Scene = Me;
	t.Sprite = Ce;
	t.LOD = Pe;
	t.SkinnedMesh = Oe;
	t.Skeleton = Le;
	t.Bone = Re;
	t.Mesh = z;
	t.LineSegments = Ie;
	t.LineLoop = De;
	t.Line = Ne;
	t.Points = Be;
	t.Group = Ue;
	t.VideoTexture = ze;
	t.DataTexture = wt;
	t.CompressedTexture = Ge;
	t.CubeTexture = H;
	t.CanvasTexture = pe;
	t.DepthTexture = He;
	t.Texture = d;
	t.CompressedTextureLoader = on;
	t.DataTextureLoader = an;
	t.CubeTextureLoader = ln;
	t.TextureLoader = cn;
	t.ObjectLoader = er;
	t.MaterialLoader = Jn;
	t.BufferGeometryLoader = Qn;
	t.DefaultLoadingManager = Ao;
	t.LoadingManager = nn;
	t.JSONLoader = tr;
	t.ImageLoader = sn;
	t.ImageBitmapLoader = ir;
	t.FontLoader = or;
	t.FileLoader = rn;
	t.Loader = Kn;
	t.LoaderUtils = Do;
	t.Cache = Mo;
	t.AudioLoader = ar;
	t.SpotLightShadow = Rn;
	t.SpotLight = On;
	t.PointLight = kn;
	t.RectAreaLight = Fn;
	t.HemisphereLight = Pn;
	t.DirectionalLightShadow = Nn;
	t.DirectionalLight = In;
	t.AmbientLight = Dn;
	t.LightShadow = Ln;
	t.Light = Cn;
	t.StereoCamera = sr;
	t.PerspectiveCamera = xe;
	t.OrthographicCamera = f;
	t.CubeCamera = lr;
	t.ArrayCamera = _e;
	t.Camera = l;
	t.AudioListener = cr;
	t.PositionalAudio = hr;
	t.AudioContext = Go;
	t.AudioAnalyser = dr;
	t.Audio = ur;
	t.VectorKeyframeTrack = $n;
	t.StringKeyframeTrack = Bn;
	t.QuaternionKeyframeTrack = Hn;
	t.NumberKeyframeTrack = Vn;
	t.ColorKeyframeTrack = jn;
	t.BooleanKeyframeTrack = Un;
	t.PropertyMixer = fr;
	t.PropertyBinding = mr;
	t.KeyframeTrack = qn;
	t.AnimationUtils = No;
	t.AnimationObjectGroup = gr;
	t.AnimationMixer = yr;
	t.AnimationClip = Zn;
	t.Uniform = xr;
	t.InstancedBufferGeometry = _r;
	t.BufferGeometry = L;
	t.Geometry = T;
	t.InterleavedBufferAttribute = br;
	t.InstancedInterleavedBuffer = Tr;
	t.InterleavedBuffer = wr;
	t.InstancedBufferAttribute = Er;
	t.Face3 = F;
	t.Object3D = u;
	t.Raycaster = Sr;
	t.Layers = o;
	t.EventDispatcher = e;
	t.Clock = Cr;
	t.QuaternionLinearInterpolant = Gn;
	t.LinearInterpolant = Xn;
	t.DiscreteInterpolant = Yn;
	t.CubicInterpolant = Wn;
	t.Interpolant = zn;
	t.Triangle = U;
	t.Math = Kr;
	t.Spherical = Pr;
	t.Cylindrical = Lr;
	t.Plane = v;
	t.Frustum = Tt;
	t.Sphere = c;
	t.Ray = B;
	t.Matrix4 = xt;
	t.Matrix3 = g;
	t.Box3 = i;
	t.Box2 = Rr;
	t.Line3 = D;
	t.Euler = r;
	t.Vector4 = bt;
	t.Vector3 = _t;
	t.Vector2 = W;
	t.Quaternion = j;
	t.Color = w;
	t.ImmediateRenderObject = Or;
	t.VertexNormalsHelper = kr;
	t.SpotLightHelper = Nr;
	t.SkeletonHelper = Dr;
	t.PointLightHelper = Fr;
	t.RectAreaLightHelper = Br;
	t.HemisphereLightHelper = Ur;
	t.GridHelper = zr;
	t.PolarGridHelper = Gr;
	t.FaceNormalsHelper = Hr;
	t.DirectionalLightHelper = jr;
	t.CameraHelper = Vr;
	t.BoxHelper = Wr;
	t.Box3Helper = Xr;
	t.PlaneHelper = Yr;
	t.ArrowHelper = qr;
	t.AxesHelper = $r;
	t.Shape = An;
	t.Path = Mn;
	t.ShapePath = nr;
	t.Font = rr;
	t.CurvePath = Sn;
	t.Curve = un;
	t.ShapeUtils = wo;
	t.WebGLUtils = ye;
	t.WireframeGeometry = je;
	t.ParametricGeometry = Ve;
	t.ParametricBufferGeometry = We;
	t.TetrahedronGeometry = qe;
	t.TetrahedronBufferGeometry = $e;
	t.OctahedronGeometry = Ze;
	t.OctahedronBufferGeometry = Je;
	t.IcosahedronGeometry = Qe;
	t.IcosahedronBufferGeometry = Ke;
	t.DodecahedronGeometry = ti;
	t.DodecahedronBufferGeometry = ei;
	t.PolyhedronGeometry = Xe;
	t.PolyhedronBufferGeometry = Ye;
	t.TubeGeometry = ii;
	t.TubeBufferGeometry = ni;
	t.TorusKnotGeometry = ri;
	t.TorusKnotBufferGeometry = oi;
	t.TorusGeometry = ai;
	t.TorusBufferGeometry = si;
	t.TextGeometry = Pi;
	t.TextBufferGeometry = Li;
	t.SphereGeometry = Ri;
	t.SphereBufferGeometry = Oi;
	t.RingGeometry = ki;
	t.RingBufferGeometry = Ni;
	t.PlaneGeometry = R;
	t.PlaneBufferGeometry = O;
	t.LatheGeometry = Ii;
	t.LatheBufferGeometry = Di;
	t.ShapeGeometry = Fi;
	t.ShapeBufferGeometry = Bi;
	t.ExtrudeGeometry = Mi;
	t.ExtrudeBufferGeometry = Ai;
	t.EdgesGeometry = zi;
	t.ConeGeometry = ji;
	t.ConeBufferGeometry = Vi;
	t.CylinderGeometry = Gi;
	t.CylinderBufferGeometry = Hi;
	t.CircleGeometry = Wi;
	t.CircleBufferGeometry = Xi;
	t.BoxGeometry = M;
	t.BoxBufferGeometry = C;
	t.ShadowMaterial = Yi;
	t.SpriteMaterial = Ae;
	t.RawShaderMaterial = qi;
	t.ShaderMaterial = I;
	t.PointsMaterial = Fe;
	t.MeshPhysicalMaterial = Zi;
	t.MeshStandardMaterial = $i;
	t.MeshPhongMaterial = Ji;
	t.MeshToonMaterial = Qi;
	t.MeshNormalMaterial = Ki;
	t.MeshLambertMaterial = tn;
	t.MeshDepthMaterial = he;
	t.MeshDistanceMaterial = de;
	t.MeshBasicMaterial = N;
	t.LineDashedMaterial = en;
	t.LineBasicMaterial = ke;
	t.Material = k;
	t.Float64BufferAttribute = b;
	t.Float32BufferAttribute = P;
	t.Uint32BufferAttribute = _;
	t.Int32BufferAttribute = x;
	t.Uint16BufferAttribute = m;
	t.Int16BufferAttribute = p;
	t.Uint8ClampedBufferAttribute = h;
	t.Uint8BufferAttribute = s;
	t.Int8BufferAttribute = a;
	t.BufferAttribute = y;
	t.ArcCurve = dn;
	t.CatmullRomCurve3 = pn;
	t.CubicBezierCurve = yn;
	t.CubicBezierCurve3 = xn;
	t.EllipseCurve = hn;
	t.LineCurve = _n;
	t.LineCurve3 = bn;
	t.QuadraticBezierCurve = wn;
	t.QuadraticBezierCurve3 = Tn;
	t.SplineCurve = En;
	t.REVISION = "93";
	t.MOUSE = {
		LEFT: 0,
		MIDDLE: 1,
		RIGHT: 2
	};
	t.CullFaceNone = 0;
	t.CullFaceBack = 1;
	t.CullFaceFront = 2;
	t.CullFaceFrontBack = 3;
	t.FrontFaceDirectionCW = 0;
	t.FrontFaceDirectionCCW = 1;
	t.BasicShadowMap = 0;
	t.PCFShadowMap = 1;
	t.PCFSoftShadowMap = 2;
	t.FrontSide = 0;
	t.BackSide = 1;
	t.DoubleSide = 2;
	t.FlatShading = 1;
	t.SmoothShading = 2;
	t.NoColors = 0;
	t.FaceColors = 1;
	t.VertexColors = 2;
	t.NoBlending = 0;
	t.NormalBlending = 1;
	t.AdditiveBlending = 2;
	t.SubtractiveBlending = 3;
	t.MultiplyBlending = 4;
	t.CustomBlending = 5;
	t.AddEquation = 100;
	t.SubtractEquation = 101;
	t.ReverseSubtractEquation = 102;
	t.MinEquation = 103;
	t.MaxEquation = 104;
	t.ZeroFactor = 200;
	t.OneFactor = 201;
	t.SrcColorFactor = 202;
	t.OneMinusSrcColorFactor = 203;
	t.SrcAlphaFactor = 204;
	t.OneMinusSrcAlphaFactor = 205;
	t.DstAlphaFactor = 206;
	t.OneMinusDstAlphaFactor = 207;
	t.DstColorFactor = 208;
	t.OneMinusDstColorFactor = 209;
	t.SrcAlphaSaturateFactor = 210;
	t.NeverDepth = 0;
	t.AlwaysDepth = 1;
	t.LessDepth = 2;
	t.LessEqualDepth = 3;
	t.EqualDepth = 4;
	t.GreaterEqualDepth = 5;
	t.GreaterDepth = 6;
	t.NotEqualDepth = 7;
	t.MultiplyOperation = 0;
	t.MixOperation = 1;
	t.AddOperation = 2;
	t.NoToneMapping = 0;
	t.LinearToneMapping = 1;
	t.ReinhardToneMapping = 2;
	t.Uncharted2ToneMapping = 3;
	t.CineonToneMapping = 4;
	t.UVMapping = 300;
	t.CubeReflectionMapping = 301;
	t.CubeRefractionMapping = 302;
	t.EquirectangularReflectionMapping = 303;
	t.EquirectangularRefractionMapping = 304;
	t.SphericalReflectionMapping = 305;
	t.CubeUVReflectionMapping = 306;
	t.CubeUVRefractionMapping = 307;
	t.RepeatWrapping = 1e3;
	t.ClampToEdgeWrapping = 1001;
	t.MirroredRepeatWrapping = 1002;
	t.NearestFilter = 1003;
	t.NearestMipMapNearestFilter = 1004;
	t.NearestMipMapLinearFilter = 1005;
	t.LinearFilter = 1006;
	t.LinearMipMapNearestFilter = 1007;
	t.LinearMipMapLinearFilter = 1008;
	t.UnsignedByteType = 1009;
	t.ByteType = 1010;
	t.ShortType = 1011;
	t.UnsignedShortType = 1012;
	t.IntType = 1013;
	t.UnsignedIntType = 1014;
	t.FloatType = 1015;
	t.HalfFloatType = 1016;
	t.UnsignedShort4444Type = 1017;
	t.UnsignedShort5551Type = 1018;
	t.UnsignedShort565Type = 1019;
	t.UnsignedInt248Type = 1020;
	t.AlphaFormat = 1021;
	t.RGBFormat = 1022;
	t.RGBAFormat = 1023;
	t.LuminanceFormat = 1024;
	t.LuminanceAlphaFormat = 1025;
	t.RGBEFormat = 1023;
	t.DepthFormat = 1026;
	t.DepthStencilFormat = 1027;
	t.RGB_S3TC_DXT1_Format = 33776;
	t.RGBA_S3TC_DXT1_Format = 33777;
	t.RGBA_S3TC_DXT3_Format = 33778;
	t.RGBA_S3TC_DXT5_Format = 33779;
	t.RGB_PVRTC_4BPPV1_Format = 35840;
	t.RGB_PVRTC_2BPPV1_Format = 35841;
	t.RGBA_PVRTC_4BPPV1_Format = 35842;
	t.RGBA_PVRTC_2BPPV1_Format = 35843;
	t.RGB_ETC1_Format = 36196;
	t.RGBA_ASTC_4x4_Format = 37808;
	t.RGBA_ASTC_5x4_Format = 37809;
	t.RGBA_ASTC_5x5_Format = 37810;
	t.RGBA_ASTC_6x5_Format = 37811;
	t.RGBA_ASTC_6x6_Format = 37812;
	t.RGBA_ASTC_8x5_Format = 37813;
	t.RGBA_ASTC_8x6_Format = 37814;
	t.RGBA_ASTC_8x8_Format = 37815;
	t.RGBA_ASTC_10x5_Format = 37816;
	t.RGBA_ASTC_10x6_Format = 37817;
	t.RGBA_ASTC_10x8_Format = 37818;
	t.RGBA_ASTC_10x10_Format = 37819;
	t.RGBA_ASTC_12x10_Format = 37820;
	t.RGBA_ASTC_12x12_Format = 37821;
	t.LoopOnce = 2200;
	t.LoopRepeat = 2201;
	t.LoopPingPong = 2202;
	t.InterpolateDiscrete = 2300;
	t.InterpolateLinear = 2301;
	t.InterpolateSmooth = 2302;
	t.ZeroCurvatureEnding = 2400;
	t.ZeroSlopeEnding = 2401;
	t.WrapAroundEnding = 2402;
	t.TrianglesDrawMode = 0;
	t.TriangleStripDrawMode = 1;
	t.TriangleFanDrawMode = 2;
	t.LinearEncoding = 3e3;
	t.sRGBEncoding = 3001;
	t.GammaEncoding = 3007;
	t.RGBEEncoding = 3002;
	t.LogLuvEncoding = 3003;
	t.RGBM7Encoding = 3004;
	t.RGBM16Encoding = 3005;
	t.RGBDEncoding = 3006;
	t.BasicDepthPacking = 3200;
	t.RGBADepthPacking = 3201;
	t.CubeGeometry = M;
	t.Face4 = function (t, e, i, n, r, o, a) {
		console.warn("THREE.Face4 has been removed. A THREE.Face3 will be created instead.");
		return new F(t, e, i, r, o, a)
	};
	t.LineStrip = 0;
	t.LinePieces = 1;
	t.MeshFaceMaterial = function (t) {
		console.warn("THREE.MeshFaceMaterial has been removed. Use an Array instead.");
		return t
	};
	t.MultiMaterial = function (t) {
		void 0 === t && (t = []);
		console.warn("THREE.MultiMaterial has been removed. Use an Array instead.");
		t.isMultiMaterial = !0;
		t.materials = t;
		t.clone = function () {
			return t.slice()
		};
		return t
	};
	t.PointCloud = function (t, e) {
		console.warn("THREE.PointCloud has been renamed to THREE.Points.");
		return new Be(t, e)
	};
	t.Particle = function (t) {
		console.warn("THREE.Particle has been renamed to THREE.Sprite.");
		return new Ce(t)
	};
	t.ParticleSystem = function (t, e) {
		console.warn("THREE.ParticleSystem has been renamed to THREE.Points.");
		return new Be(t, e)
	};
	t.PointCloudMaterial = function (t) {
		console.warn("THREE.PointCloudMaterial has been renamed to THREE.PointsMaterial.");
		return new Fe(t)
	};
	t.ParticleBasicMaterial = function (t) {
		console.warn("THREE.ParticleBasicMaterial has been renamed to THREE.PointsMaterial.");
		return new Fe(t)
	};
	t.ParticleSystemMaterial = function (t) {
		console.warn("THREE.ParticleSystemMaterial has been renamed to THREE.PointsMaterial.");
		return new Fe(t)
	};
	t.Vertex = function (t, e, i) {
		console.warn("THREE.Vertex has been removed. Use THREE.Vector3 instead.");
		return new _t(t, e, i)
	};
	t.DynamicBufferAttribute = function (t, e) {
		console.warn("THREE.DynamicBufferAttribute has been removed. Use new THREE.BufferAttribute().setDynamic( true ) instead.");
		return new y(t, e).setDynamic(!0)
	};
	t.Int8Attribute = function (t, e) {
		console.warn("THREE.Int8Attribute has been removed. Use new THREE.Int8BufferAttribute() instead.");
		return new a(t, e)
	};
	t.Uint8Attribute = function (t, e) {
		console.warn("THREE.Uint8Attribute has been removed. Use new THREE.Uint8BufferAttribute() instead.");
		return new s(t, e)
	};
	t.Uint8ClampedAttribute = function (t, e) {
		console.warn("THREE.Uint8ClampedAttribute has been removed. Use new THREE.Uint8ClampedBufferAttribute() instead.");
		return new h(t, e)
	};
	t.Int16Attribute = function (t, e) {
		console.warn("THREE.Int16Attribute has been removed. Use new THREE.Int16BufferAttribute() instead.");
		return new p(t, e)
	};
	t.Uint16Attribute = function (t, e) {
		console.warn("THREE.Uint16Attribute has been removed. Use new THREE.Uint16BufferAttribute() instead.");
		return new m(t, e)
	};
	t.Int32Attribute = function (t, e) {
		console.warn("THREE.Int32Attribute has been removed. Use new THREE.Int32BufferAttribute() instead.");
		return new x(t, e)
	};
	t.Uint32Attribute = function (t, e) {
		console.warn("THREE.Uint32Attribute has been removed. Use new THREE.Uint32BufferAttribute() instead.");
		return new _(t, e)
	};
	t.Float32Attribute = function (t, e) {
		console.warn("THREE.Float32Attribute has been removed. Use new THREE.Float32BufferAttribute() instead.");
		return new P(t, e)
	};
	t.Float64Attribute = function (t, e) {
		console.warn("THREE.Float64Attribute has been removed. Use new THREE.Float64BufferAttribute() instead.");
		return new b(t, e)
	};
	t.ClosedSplineCurve3 = Zr;
	t.SplineCurve3 = Jr;
	t.Spline = Qr;
	t.AxisHelper = function (t) {
		console.warn("THREE.AxisHelper has been renamed to THREE.AxesHelper.");
		return new $r(t)
	};
	t.BoundingBoxHelper = function (t, e) {
		console.warn("THREE.BoundingBoxHelper has been deprecated. Creating a THREE.BoxHelper instead.");
		return new Wr(t, e)
	};
	t.EdgesHelper = function (t, e) {
		console.warn("THREE.EdgesHelper has been removed. Use THREE.EdgesGeometry instead.");
		return new Ie(new zi(t.geometry), new ke({
			color: void 0 !== e ? e : 16777215
		}))
	};
	t.WireframeHelper = function (t, e) {
		console.warn("THREE.WireframeHelper has been removed. Use THREE.WireframeGeometry instead.");
		return new Ie(new je(t.geometry), new ke({
			color: void 0 !== e ? e : 16777215
		}))
	};
	t.XHRLoader = function (t) {
		console.warn("THREE.XHRLoader has been renamed to THREE.FileLoader.");
		return new rn(t)
	};
	t.BinaryTextureLoader = function (t) {
		console.warn("THREE.BinaryTextureLoader has been renamed to THREE.DataTextureLoader.");
		return new an(t)
	};
	t.GeometryUtils = {
		merge: function (t, e, i) {
			console.warn("THREE.GeometryUtils: .merge() has been moved to Geometry. Use geometry.merge( geometry2, matrix, materialIndexOffset ) instead.");
			if (e.isMesh) {
				e.matrixAutoUpdate && e.updateMatrix();
				var n = e.matrix;
				e = e.geometry
			}
			t.merge(e, n, i)
		},
		center: function (t) {
			console.warn("THREE.GeometryUtils: .center() has been moved to Geometry. Use geometry.center() instead.");
			return t.center()
		}
	};
	t.ImageUtils = {
		crossOrigin: void 0,
		loadTexture: function (t, e, i, n) {
			console.warn("THREE.ImageUtils.loadTexture has been deprecated. Use THREE.TextureLoader() instead.");
			var r = new cn;
			r.setCrossOrigin(this.crossOrigin);
			t = r.load(t, i, void 0, n);
			e && (t.mapping = e);
			return t
		},
		loadTextureCube: function (t, e, i, n) {
			console.warn("THREE.ImageUtils.loadTextureCube has been deprecated. Use THREE.CubeTextureLoader() instead.");
			var r = new ln;
			r.setCrossOrigin(this.crossOrigin);
			t = r.load(t, i, void 0, n);
			e && (t.mapping = e);
			return t
		},
		loadCompressedTexture: function () {
			console.error("THREE.ImageUtils.loadCompressedTexture has been removed. Use THREE.DDSLoader instead.")
		},
		loadCompressedTextureCube: function () {
			console.error("THREE.ImageUtils.loadCompressedTextureCube has been removed. Use THREE.DDSLoader instead.")
		}
	};
	t.Projector = function () {
		console.error("THREE.Projector has been moved to /examples/js/renderers/Projector.js.");
		this.projectVector = function (t, e) {
			console.warn("THREE.Projector: .projectVector() is now vector.project().");
			t.project(e)
		};
		this.unprojectVector = function (t, e) {
			console.warn("THREE.Projector: .unprojectVector() is now vector.unproject().");
			t.unproject(e)
		};
		this.pickingRay = function () {
			console.error("THREE.Projector: .pickingRay() is now raycaster.setFromCamera().")
		}
	};
	t.CanvasRenderer = function () {
		console.error("THREE.CanvasRenderer has been moved to /examples/js/renderers/CanvasRenderer.js");
		this.domElement = document.createElementNS("http://www.w3.org/1999/xhtml", "canvas");
		this.clear = function () {};
		this.render = function () {};
		this.setClearColor = function () {};
		this.setSize = function () {}
	};
	t.SceneUtils = {
		createMultiMaterialObject: function () {
			console.error("THREE.SceneUtils has been moved to /examples/js/utils/SceneUtils.js")
		},
		detach: function () {
			console.error("THREE.SceneUtils has been moved to /examples/js/utils/SceneUtils.js")
		},
		attach: function () {
			console.error("THREE.SceneUtils has been moved to /examples/js/utils/SceneUtils.js")
		}
	};
	t.LensFlare = function () {
		console.error("THREE.LensFlare has been moved to /examples/js/objects/Lensflare.js")
	};
	Object.defineProperty(t, "__esModule", {
		value: !0
	})
});
"use strict";
! function (x) {
	function t() {
		var t = r();
		t !== o && (o = t, l.trigger("orientationchange"))
	}

	function _(t, e, i, n) {
		var r = i.type;
		i.type = e, x.event.dispatch.call(t, i, n), i.type = r
	}
	x.attrFn = x.attrFn || {};
	var e = navigator.userAgent.toLowerCase(),
		i = e.indexOf("chrome") > -1 && (e.indexOf("windows") > -1 || e.indexOf("macintosh") > -1 || e.indexOf("linux") > -1) && e.indexOf("mobile") < 0 && e.indexOf("android") < 0,
		b = {
			tap_pixel_range: 5,
			swipe_h_threshold: 50,
			swipe_v_threshold: 50,
			taphold_threshold: 750,
			doubletap_int: 500,
			touch_capable: "ontouchstart" in window && !i,
			orientation_support: "orientation" in window && "onorientationchange" in window,
			startevent: "ontouchstart" in window && !i ? "touchstart" : "mousedown",
			endevent: "ontouchstart" in window && !i ? "touchend" : "mouseup",
			moveevent: "ontouchstart" in window && !i ? "touchmove" : "mousemove",
			tapevent: "ontouchstart" in window && !i ? "tap" : "click",
			scrollevent: "ontouchstart" in window && !i ? "touchmove" : "scroll",
			hold_timer: null,
			tap_timer: null
		};
	x.isTouchCapable = function () {
		return b.touch_capable
	}, x.getStartEvent = function () {
		return b.startevent
	}, x.getEndEvent = function () {
		return b.endevent
	}, x.getMoveEvent = function () {
		return b.moveevent
	}, x.getTapEvent = function () {
		return b.tapevent
	}, x.getScrollEvent = function () {
		return b.scrollevent
	}, x.each(["tapstart", "tapend", "tapmove", "tap", "tap2", "tap3", "tap4", "singletap", "doubletap", "taphold", "swipe", "swipeup", "swiperight", "swipedown", "swipeleft", "swipeend", "scrollstart", "scrollend", "orientationchange"], function (t, e) {
		x.fn[e] = function (t) {
			return t ? this.on(e, t) : this.trigger(e)
		}, x.attrFn[e] = !0
	}), x.event.special.tapstart = {
		setup: function () {
			var r = this,
				o = x(r);
			o.on(b.startevent, function t(e) {
				if (o.data("callee", t), e.which && 1 !== e.which) return !1;
				var i = e.originalEvent,
					n = {
						position: {
							x: b.touch_capable ? i.touches[0].screenX : e.screenX,
							y: b.touch_capable ? i.touches[0].screenY : e.screenY
						},
						offset: {
							x: Math.round(b.touch_capable ? i.changedTouches[0].pageX - o.offset().left : e.pageX - o.offset().left),
							y: Math.round(b.touch_capable ? i.changedTouches[0].pageY - o.offset().top : e.pageY - o.offset().top)
						},
						time: Date.now(),
						target: e.target
					};
				return _(r, "tapstart", e, n), !0
			})
		},
		remove: function () {
			x(this).off(b.startevent, x(this).data.callee)
		}
	}, x.event.special.tapmove = {
		setup: function () {
			var r = this,
				o = x(r);
			o.on(b.moveevent, function t(e) {
				o.data("callee", t);
				var i = e.originalEvent,
					n = {
						position: {
							x: b.touch_capable ? i.touches[0].screenX : e.screenX,
							y: b.touch_capable ? i.touches[0].screenY : e.screenY
						},
						offset: {
							x: Math.round(b.touch_capable ? i.changedTouches[0].pageX - o.offset().left : e.pageX - o.offset().left),
							y: Math.round(b.touch_capable ? i.changedTouches[0].pageY - o.offset().top : e.pageY - o.offset().top)
						},
						time: Date.now(),
						target: e.target
					};
				return _(r, "tapmove", e, n), !0
			})
		},
		remove: function () {
			x(this).off(b.moveevent, x(this).data.callee)
		}
	}, x.event.special.tapend = {
		setup: function () {
			var r = this,
				o = x(r);
			o.on(b.endevent, function t(e) {
				o.data("callee", t);
				var i = e.originalEvent,
					n = {
						position: {
							x: b.touch_capable ? i.changedTouches[0].screenX : e.screenX,
							y: b.touch_capable ? i.changedTouches[0].screenY : e.screenY
						},
						offset: {
							x: Math.round(b.touch_capable ? i.changedTouches[0].pageX - o.offset().left : e.pageX - o.offset().left),
							y: Math.round(b.touch_capable ? i.changedTouches[0].pageY - o.offset().top : e.pageY - o.offset().top)
						},
						time: Date.now(),
						target: e.target
					};
				return _(r, "tapend", e, n), !0
			})
		},
		remove: function () {
			x(this).off(b.endevent, x(this).data.callee)
		}
	}, x.event.special.taphold = {
		setup: function () {
			var f, p = this,
				m = x(p),
				g = {
					x: 0,
					y: 0
				},
				v = 0,
				y = 0;
			m.on(b.startevent, function s(l) {
				if (l.which && 1 !== l.which) return !1;
				m.data("tapheld", !1), f = l.target;
				var c = l.originalEvent,
					u = Date.now(),
					h = {
						x: b.touch_capable ? c.touches[0].screenX : l.screenX,
						y: b.touch_capable ? c.touches[0].screenY : l.screenY
					},
					d = {
						x: b.touch_capable ? c.touches[0].pageX - c.touches[0].target.offsetLeft : l.offsetX,
						y: b.touch_capable ? c.touches[0].pageY - c.touches[0].target.offsetTop : l.offsetY
					};
				return g.x = l.originalEvent.targetTouches ? l.originalEvent.targetTouches[0].pageX : l.pageX, g.y = l.originalEvent.targetTouches ? l.originalEvent.targetTouches[0].pageY : l.pageY, v = g.x, y = g.y, b.hold_timer = window.setTimeout(function () {
					var t = g.x - v,
						e = g.y - y;
					if (l.target == f && (g.x == v && g.y == y || t >= -b.tap_pixel_range && t <= b.tap_pixel_range && e >= -b.tap_pixel_range && e <= b.tap_pixel_range)) {
						m.data("tapheld", !0);
						var i = Date.now(),
							n = {
								x: b.touch_capable ? c.touches[0].screenX : l.screenX,
								y: b.touch_capable ? c.touches[0].screenY : l.screenY
							},
							r = {
								x: Math.round(b.touch_capable ? c.changedTouches[0].pageX - m.offset().left : l.pageX - m.offset().left),
								y: Math.round(b.touch_capable ? c.changedTouches[0].pageY - m.offset().top : l.pageY - m.offset().top)
							},
							o = i - u,
							a = {
								startTime: u,
								endTime: i,
								startPosition: h,
								startOffset: d,
								endPosition: n,
								endOffset: r,
								duration: o,
								target: l.target
							};
						m.data("callee1", s), _(p, "taphold", l, a)
					}
				}, b.taphold_threshold), !0
			}).on(b.endevent, function t() {
				m.data("callee2", t), m.data("tapheld", !1), window.clearTimeout(b.hold_timer)
			}).on(b.moveevent, function t(e) {
				m.data("callee3", t), v = e.originalEvent.targetTouches ? e.originalEvent.targetTouches[0].pageX : e.pageX, y = e.originalEvent.targetTouches ? e.originalEvent.targetTouches[0].pageY : e.pageY
			})
		},
		remove: function () {
			x(this).off(b.startevent, x(this).data.callee1).off(b.endevent, x(this).data.callee2).off(b.moveevent, x(this).data.callee3)
		}
	}, x.event.special.doubletap = {
		setup: function () {
			var s, l, c, u, h = this,
				d = x(h),
				f = null,
				p = !1;
			d.on(b.startevent, function t(e) {
				return e.which && 1 !== e.which ? !1 : (d.data("doubletapped", !1), s = e.target, d.data("callee1", t), c = e.originalEvent, f || (f = {
					position: {
						x: b.touch_capable ? c.touches[0].screenX : e.screenX,
						y: b.touch_capable ? c.touches[0].screenY : e.screenY
					},
					offset: {
						x: Math.round(b.touch_capable ? c.changedTouches[0].pageX - d.offset().left : e.pageX - d.offset().left),
						y: Math.round(b.touch_capable ? c.changedTouches[0].pageY - d.offset().top : e.pageY - d.offset().top)
					},
					time: Date.now(),
					target: e.target
				}), !0)
			}).on(b.endevent, function t(e) {
				var i = Date.now(),
					n = d.data("lastTouch") || i + 1,
					r = i - n;
				if (window.clearTimeout(l), d.data("callee2", t), r < b.doubletap_int && e.target == s && r > 100) {
					d.data("doubletapped", !0), window.clearTimeout(b.tap_timer);
					var o = {
							position: {
								x: b.touch_capable ? e.originalEvent.changedTouches[0].screenX : e.screenX,
								y: b.touch_capable ? e.originalEvent.changedTouches[0].screenY : e.screenY
							},
							offset: {
								x: Math.round(b.touch_capable ? c.changedTouches[0].pageX - d.offset().left : e.pageX - d.offset().left),
								y: Math.round(b.touch_capable ? c.changedTouches[0].pageY - d.offset().top : e.pageY - d.offset().top)
							},
							time: Date.now(),
							target: e.target
						},
						a = {
							firstTap: f,
							secondTap: o,
							interval: o.time - f.time
						};
					p || (_(h, "doubletap", e, a), f = null), p = !0, u = window.setTimeout(function () {
						p = !1
					}, b.doubletap_int)
				} else d.data("lastTouch", i), l = window.setTimeout(function () {
					f = null, window.clearTimeout(l)
				}, b.doubletap_int, [e]);
				d.data("lastTouch", i)
			})
		},
		remove: function () {
			x(this).off(b.startevent, x(this).data.callee1).off(b.endevent, x(this).data.callee2)
		}
	}, x.event.special.singletap = {
		setup: function () {
			var o = this,
				a = x(o),
				s = null,
				l = null,
				c = {
					x: 0,
					y: 0
				};
			a.on(b.startevent, function t(e) {
				return e.which && 1 !== e.which ? !1 : (l = Date.now(), s = e.target, a.data("callee1", t), c.x = e.originalEvent.targetTouches ? e.originalEvent.targetTouches[0].pageX : e.pageX, c.y = e.originalEvent.targetTouches ? e.originalEvent.targetTouches[0].pageY : e.pageY, !0)
			}).on(b.endevent, function t(i) {
				if (a.data("callee2", t), i.target == s) {
					var n = i.originalEvent.changedTouches ? i.originalEvent.changedTouches[0].pageX : i.pageX,
						r = i.originalEvent.changedTouches ? i.originalEvent.changedTouches[0].pageY : i.pageY;
					b.tap_timer = window.setTimeout(function () {
						if (!a.data("doubletapped") && !a.data("tapheld") && c.x == n && c.y == r) {
							var t = i.originalEvent,
								e = {
									position: {
										x: b.touch_capable ? t.changedTouches[0].screenX : i.screenX,
										y: b.touch_capable ? t.changedTouches[0].screenY : i.screenY
									},
									offset: {
										x: Math.round(b.touch_capable ? t.changedTouches[0].pageX - a.offset().left : i.pageX - a.offset().left),
										y: Math.round(b.touch_capable ? t.changedTouches[0].pageY - a.offset().top : i.pageY - a.offset().top)
									},
									time: Date.now(),
									target: i.target
								};
							e.time - l < b.taphold_threshold && _(o, "singletap", i, e)
						}
					}, b.doubletap_int)
				}
			})
		},
		remove: function () {
			x(this).off(b.startevent, x(this).data.callee1).off(b.endevent, x(this).data.callee2)
		}
	}, x.event.special.tap = {
		setup: function () {
			var u, h, d = this,
				f = x(d),
				p = !1,
				m = null,
				g = {
					x: 0,
					y: 0
				};
			f.on(b.startevent, function t(e) {
				return f.data("callee1", t), e.which && 1 !== e.which ? !1 : (p = !0, g.x = e.originalEvent.targetTouches ? e.originalEvent.targetTouches[0].pageX : e.pageX, g.y = e.originalEvent.targetTouches ? e.originalEvent.targetTouches[0].pageY : e.pageY, u = Date.now(), m = e.target, h = e.originalEvent.targetTouches ? e.originalEvent.targetTouches : [e], !0)
			}).on(b.endevent, function t(e) {
				f.data("callee2", t);
				var i = e.originalEvent.targetTouches ? e.originalEvent.changedTouches[0].pageX : e.pageX,
					n = e.originalEvent.targetTouches ? e.originalEvent.changedTouches[0].pageY : e.pageY,
					r = g.x - i,
					o = g.y - n;
				if (m == e.target && p && Date.now() - u < b.taphold_threshold && (g.x == i && g.y == n || r >= -b.tap_pixel_range && r <= b.tap_pixel_range && o >= -b.tap_pixel_range && o <= b.tap_pixel_range)) {
					for (var a = e.originalEvent, s = [], l = 0; l < h.length; l++) {
						var c = {
							position: {
								x: b.touch_capable ? a.changedTouches[l].screenX : e.screenX,
								y: b.touch_capable ? a.changedTouches[l].screenY : e.screenY
							},
							offset: {
								x: Math.round(b.touch_capable ? a.changedTouches[l].pageX - f.offset().left : e.pageX - f.offset().left),
								y: Math.round(b.touch_capable ? a.changedTouches[l].pageY - f.offset().top : e.pageY - f.offset().top)
							},
							time: Date.now(),
							target: e.target
						};
						s.push(c)
					}
					_(d, "tap", e, s)
				}
			})
		},
		remove: function () {
			x(this).off(b.startevent, x(this).data.callee1).off(b.endevent, x(this).data.callee2)
		}
	}, x.event.special.swipe = {
		setup: function () {
			function i(t) {
				p = x(t.currentTarget), p.data("callee1", i), v.x = t.originalEvent.targetTouches ? t.originalEvent.targetTouches[0].pageX : t.pageX, v.y = t.originalEvent.targetTouches ? t.originalEvent.targetTouches[0].pageY : t.pageY, y.x = v.x, y.y = v.y, m = !0;
				var e = t.originalEvent;
				f = {
					position: {
						x: b.touch_capable ? e.touches[0].screenX : t.screenX,
						y: b.touch_capable ? e.touches[0].screenY : t.screenY
					},
					offset: {
						x: Math.round(b.touch_capable ? e.changedTouches[0].pageX - p.offset().left : t.pageX - p.offset().left),
						y: Math.round(b.touch_capable ? e.changedTouches[0].pageY - p.offset().top : t.pageY - p.offset().top)
					},
					time: Date.now(),
					target: t.target
				}
			}

			function h(t) {
				p = x(t.currentTarget), p.data("callee2", h), y.x = t.originalEvent.targetTouches ? t.originalEvent.targetTouches[0].pageX : t.pageX, y.y = t.originalEvent.targetTouches ? t.originalEvent.targetTouches[0].pageY : t.pageY;
				var e, i = p.parent().data("xthreshold") ? p.parent().data("xthreshold") : p.data("xthreshold"),
					n = p.parent().data("ythreshold") ? p.parent().data("ythreshold") : p.data("ythreshold"),
					r = "undefined" != typeof i && i !== !1 && parseInt(i) ? parseInt(i) : b.swipe_h_threshold,
					o = "undefined" != typeof n && n !== !1 && parseInt(n) ? parseInt(n) : b.swipe_v_threshold;
				if (v.y > y.y && v.y - y.y > o && (e = "swipeup"), v.x < y.x && y.x - v.x > r && (e = "swiperight"), v.y < y.y && y.y - v.y > o && (e = "swipedown"), v.x > y.x && v.x - y.x > r && (e = "swipeleft"), void 0 != e && m) {
					v.x = 0, v.y = 0, y.x = 0, y.y = 0, m = !1;
					var a = t.originalEvent,
						s = {
							position: {
								x: b.touch_capable ? a.touches[0].screenX : t.screenX,
								y: b.touch_capable ? a.touches[0].screenY : t.screenY
							},
							offset: {
								x: Math.round(b.touch_capable ? a.changedTouches[0].pageX - p.offset().left : t.pageX - p.offset().left),
								y: Math.round(b.touch_capable ? a.changedTouches[0].pageY - p.offset().top : t.pageY - p.offset().top)
							},
							time: Date.now(),
							target: t.target
						},
						l = Math.abs(f.position.x - s.position.x),
						c = Math.abs(f.position.y - s.position.y),
						u = {
							startEvnt: f,
							endEvnt: s,
							direction: e.replace("swipe", ""),
							xAmount: l,
							yAmount: c,
							duration: s.time - f.time
						};
					g = !0, p.trigger("swipe", u).trigger(e, u)
				}
			}

			function d(t) {
				p = x(t.currentTarget);
				var e = "";
				if (p.data("callee3", d), g) {
					var i = p.data("xthreshold"),
						n = p.data("ythreshold"),
						r = "undefined" != typeof i && i !== !1 && parseInt(i) ? parseInt(i) : b.swipe_h_threshold,
						o = "undefined" != typeof n && n !== !1 && parseInt(n) ? parseInt(n) : b.swipe_v_threshold,
						a = t.originalEvent,
						s = {
							position: {
								x: b.touch_capable ? a.changedTouches[0].screenX : t.screenX,
								y: b.touch_capable ? a.changedTouches[0].screenY : t.screenY
							},
							offset: {
								x: Math.round(b.touch_capable ? a.changedTouches[0].pageX - p.offset().left : t.pageX - p.offset().left),
								y: Math.round(b.touch_capable ? a.changedTouches[0].pageY - p.offset().top : t.pageY - p.offset().top)
							},
							time: Date.now(),
							target: t.target
						};
					f.position.y > s.position.y && f.position.y - s.position.y > o && (e = "swipeup"), f.position.x < s.position.x && s.position.x - f.position.x > r && (e = "swiperight"), f.position.y < s.position.y && s.position.y - f.position.y > o && (e = "swipedown"), f.position.x > s.position.x && f.position.x - s.position.x > r && (e = "swipeleft");
					var l = Math.abs(f.position.x - s.position.x),
						c = Math.abs(f.position.y - s.position.y),
						u = {
							startEvnt: f,
							endEvnt: s,
							direction: e.replace("swipe", ""),
							xAmount: l,
							yAmount: c,
							duration: s.time - f.time
						};
					p.trigger("swipeend", u)
				}
				m = !1, g = !1
			}
			var f, t = this,
				p = x(t),
				m = !1,
				g = !1,
				v = {
					x: 0,
					y: 0
				},
				y = {
					x: 0,
					y: 0
				};
			p.on(b.startevent, i), p.on(b.moveevent, h), p.on(b.endevent, d)
		},
		remove: function () {
			x(this).off(b.startevent, x(this).data.callee1).off(b.moveevent, x(this).data.callee2).off(b.endevent, x(this).data.callee3)
		}
	}, x.event.special.scrollstart = {
		setup: function () {
			function i(t, e) {
				n = e, _(o, n ? "scrollstart" : "scrollend", t)
			}
			var n, r, o = this,
				a = x(o);
			a.on(b.scrollevent, function t(e) {
				a.data("callee", t), n || i(e, !0), clearTimeout(r), r = setTimeout(function () {
					i(e, !1)
				}, 50)
			})
		},
		remove: function () {
			x(this).off(b.scrollevent, x(this).data.callee)
		}
	};
	var n, r, o, a, s, l = x(window),
		c = {
			0: !0,
			180: !0
		};
	if (b.orientation_support) {
		var u = window.innerWidth || l.width(),
			h = window.innerHeight || l.height(),
			d = 50;
		a = u > h && u - h > d, s = c[window.orientation], (a && s || !a && !s) && (c = {
			"-90": !0,
			90: !0
		})
	}
	x.event.special.orientationchange = n = {
		setup: function () {
			return b.orientation_support ? !1 : (o = r(), l.on("throttledresize", t), !0)
		},
		teardown: function () {
			return b.orientation_support ? !1 : (l.off("throttledresize", t), !0)
		},
		add: function (t) {
			var e = t.handler;
			t.handler = function (t) {
				return t.orientation = r(), e.apply(this, arguments)
			}
		}
	}, x.event.special.orientationchange.orientation = r = function () {
		var t = !0,
			e = document.documentElement;
		return t = b.orientation_support ? c[window.orientation] : e && e.clientWidth / e.clientHeight < 1.1, t ? "portrait" : "landscape"
	}, x.event.special.throttledresize = {
		setup: function () {
			x(this).on("resize", v)
		},
		teardown: function () {
			x(this).off("resize", v)
		}
	};
	var f, p, m, g = 250,
		v = function () {
			p = Date.now(), m = p - y, m >= g ? (y = p, x(this).trigger("throttledresize")) : (f && window.clearTimeout(f), f = window.setTimeout(t, g - m))
		},
		y = 0;
	x.each({
		scrollend: "scrollstart",
		swipeup: "swipe",
		swiperight: "swipe",
		swipedown: "swipe",
		swipeleft: "swipe",
		swipeend: "swipe",
		tap2: "tap"
	}, function (t, e) {
		x.event.special[t] = {
			setup: function () {
				x(this).on(e, x.noop)
			}
		}
	})
}(jQuery);

function embed(t, e, i) {
	if (i) {
		var n = document.createDocumentFragment();
		var r = !e.hasAttribute("viewBox") && i.getAttribute("viewBox");
		if (r) {
			e.setAttribute("viewBox", r)
		}
		var o = i.cloneNode(true);
		while (o.childNodes.length) {
			n.appendChild(o.firstChild)
		}
		t.appendChild(n)
	}
}

function loadreadystatechange(n) {
	n.onreadystatechange = function () {
		if (n.readyState === 4) {
			var i = n._cachedDocument;
			if (!i) {
				i = n._cachedDocument = document.implementation.createHTMLDocument("");
				i.body.innerHTML = n.responseText;
				n._cachedTarget = {}
			}
			n._embeds.splice(0).map(function (t) {
				var e = n._cachedTarget[t.id];
				if (!e) {
					e = n._cachedTarget[t.id] = i.getElementById(t.id)
				}
				embed(t.parent, t.svg, e)
			})
		}
	};
	n.onreadystatechange()
}

function svg4everybody(t) {
	var u = Object(t);
	var h;
	var d;
	if (LEGACY_SUPPORT) {
		d = u.fallback || function (t) {
			return t.replace(/\?[^#]+/, "").replace("#", ".").replace(/^\./, "") + ".png" + (/\?[^#]+/.exec(t) || [""])[0]
		};
		h = "nosvg" in u ? u.nosvg : /\bMSIE [1-8]\b/.test(navigator.userAgent);
		if (h) {
			document.createElement("svg");
			document.createElement("use")
		}
	}
	var f;
	var e = /\bMSIE [1-8]\.0\b/;
	var i = /\bTrident\/[567]\b|\bMSIE (?:9|10)\.0\b/;
	var n = /\bAppleWebKit\/(\d+)\b/;
	var r = /\bEdge\/12\.(\d+)\b/;
	var o = /\bEdge\/.(\d+)\b/;
	var a = window.top !== window.self;
	if ("polyfill" in u) {
		f = u.polyfill
	} else if (LEGACY_SUPPORT) {
		f = e.test(navigator.userAgent) || i.test(navigator.userAgent) || (navigator.userAgent.match(r) || [])[1] < 10547 || (navigator.userAgent.match(n) || [])[1] < 537 || o.test(navigator.userAgent) && a
	} else {
		f = i.test(navigator.userAgent) || (navigator.userAgent.match(r) || [])[1] < 10547 || (navigator.userAgent.match(n) || [])[1] < 537 || o.test(navigator.userAgent) && a
	}
	var p = {};
	var m = window.requestAnimationFrame || setTimeout;
	var g = document.getElementsByTagName("use");
	var v = 0;

	function y() {
		var t = 0;
		while (t < g.length) {
			var e = g[t];
			var i = e.parentNode;
			var n = getSVGAncestor(i);
			var r = e.getAttribute("xlink:href") || e.getAttribute("href");
			if (!r && u.attributeName) {
				r = e.getAttribute(u.attributeName)
			}
			if (n && r) {
				if (LEGACY_SUPPORT && h) {
					var o = document.createElement("img");
					o.style.cssText = "display:inline-block;height:100%;width:100%";
					o.setAttribute("width", n.getAttribute("width") || n.clientWidth);
					o.setAttribute("height", n.getAttribute("height") || n.clientHeight);
					o.src = d(r, n, e);
					i.replaceChild(o, e)
				} else if (f) {
					if (!u.validate || u.validate(r, n, e)) {
						i.removeChild(e);
						var a = r.split("#");
						var s = a.shift();
						var l = a.join("#");
						if (s.length) {
							var c = p[s];
							if (!c) {
								c = p[s] = new XMLHttpRequest;
								c.open("GET", s);
								c.send();
								c._embeds = []
							}
							c._embeds.push({
								parent: i,
								svg: n,
								id: l
							});
							loadreadystatechange(c)
						} else {
							embed(i, n, document.getElementById(l))
						}
					} else {
						++t;
						++v
					}
				}
			} else {
				++t
			}
		}
		if (!g.length || g.length - v > 0) {
			m(y, 67)
		}
	}
	if (f) {
		y()
	}
}

function getSVGAncestor(t) {
	var e = t;
	while (e.nodeName.toLowerCase() !== "svg") {
		e = e.parentNode;
		if (!e) {
			break
		}
	}
	return e
}! function (t, e, i) {
	if (typeof module != "undefined" && module["exports"]) module["exports"] = i();
	else t[e] = i()
}(this, "verge", function () {
	var t = {},
		i = typeof window != "undefined" && window,
		e = typeof document != "undefined" && document,
		n = e && e.documentElement,
		r = i["matchMedia"] || i["msMatchMedia"],
		o = r ? function (t) {
			return !!r.call(i, t).matches
		} : function () {
			return false
		},
		a = t["viewportW"] = function () {
			var t = n["clientWidth"],
				e = i["innerWidth"];
			return t < e ? e : t
		},
		s = t["viewportH"] = function () {
			var t = n["clientHeight"],
				e = i["innerHeight"];
			return t < e ? e : t
		};
	t["mq"] = o;
	t["matchMedia"] = r ? function () {
		return r.apply(i, arguments)
	} : function () {
		return {}
	};

	function l() {
		return {
			width: a(),
			height: s()
		}
	}
	t["viewport"] = l;
	t["scrollX"] = function () {
		return i.pageXOffset || n.scrollLeft
	};
	t["scrollY"] = function () {
		return i.pageYOffset || n.scrollTop
	};

	function c(t, e) {
		var i = {};
		e = +e || 0;
		i["width"] = (i["right"] = t["right"] + e) - (i["left"] = t["left"] - e);
		i["height"] = (i["bottom"] = t["bottom"] + e) - (i["top"] = t["top"] - e);
		return i
	}

	function u(t, e) {
		t = t && !t.nodeType ? t[0] : t;
		if (!t || 1 !== t.nodeType) return false;
		return c(t.getBoundingClientRect(), e)
	}
	t["rectangle"] = u;

	function h(t) {
		t = null == t ? l() : 1 === t.nodeType ? u(t) : t;
		var e = t["height"],
			i = t["width"];
		e = typeof e == "function" ? e.call(t) : e;
		i = typeof i == "function" ? i.call(t) : i;
		return i / e
	}
	t["aspect"] = h;
	t["inX"] = function (t, e) {
		var i = u(t, e);
		return !!i && i.right >= 0 && i.left <= a()
	};
	t["inY"] = function (t, e) {
		var i = u(t, e);
		return !!i && i.bottom >= 0 && i.top <= s()
	};
	t["inViewport"] = function (t, e) {
		var i = u(t, e);
		return !!i && i.bottom >= 0 && i.right >= 0 && i.top <= s() && i.left <= a()
	};
	return t
});
(function () {
	(function (t, e) {
		"use strict";
		if (typeof define === "function" && define.amd) {
			define([], e)
		} else if (typeof exports === "object") {
			module.exports = e()
		} else {
			t.viewportUnitsBuggyfill = e()
		}
	})(this, function () {
		"use strict";
		var e = false;
		var a;
		var n = window.navigator.userAgent;
		var s = /([+-]?[0-9.]+)(vh|vw|vmin|vmax)/g;
		var r = /(https?:)?\/\//;
		var o = [].forEach;
		var l;
		var c;
		var i;
		var u = /MSIE [0-9]\./i.test(n);
		var h = /MSIE [0-8]\./i.test(n);
		var d = n.indexOf("Opera Mini") > -1;
		var f = /(iPhone|iPod|iPad).+AppleWebKit/i.test(n) && function () {
			var t = n.match(/OS (\d)/);
			return t && t.length > 1 && parseInt(t[1]) < 10
		}();
		var p = function () {
			var t = n.indexOf(" Android ") > -1;
			if (!t) {
				return false
			}
			var e = n.indexOf("Version/") > -1;
			if (!e) {
				return false
			}
			var i = parseFloat((n.match("Android ([0-9.]+)") || [])[1]);
			return i <= 4.4
		}();
		if (!u) {
			u = !!navigator.userAgent.match(/MSIE 10\.|Trident.*rv[ :]*1[01]\.| Edge\/1\d\./)
		}
		try {
			new m("test")
		} catch (t) {
			var m = function (t, e) {
				var i;
				e = e || {
					bubbles: false,
					cancelable: false,
					detail: undefined
				};
				i = document.createEvent("CustomEvent");
				i.initCustomEvent(t, e.bubbles, e.cancelable, e.detail);
				return i
			};
			m.prototype = window.Event.prototype;
			window.CustomEvent = m
		}

		function g(n, r) {
			var o;
			return function () {
				var t = this;
				var e = arguments;
				var i = function () {
					n.apply(t, e)
				};
				clearTimeout(o);
				o = setTimeout(i, r)
			}
		}

		function v() {
			try {
				return window.self !== window.top
			} catch (t) {
				return true
			}
		}

		function t(t) {
			if (e) {
				return
			}
			if (t === true) {
				t = {
					force: true
				}
			}
			a = t || {};
			a.isMobileSafari = f;
			a.isBadStockAndroid = p;
			if (a.ignoreVmax && !a.force && !h) {
				u = false
			}
			if (h || !a.force && !f && !u && !p && !d && (!a.hacks || !a.hacks.required(a))) {
				if (window.console && h) {
					console.info("viewport-units-buggyfill requires a proper CSSOM and basic viewport unit support, which are not available in IE8 and below")
				}
				return {
					init: function () {}
				}
			}
			window.dispatchEvent(new m("viewport-units-buggyfill-init"));
			a.hacks && a.hacks.initialize(a);
			e = true;
			i = document.createElement("style");
			i.id = "patched-viewport";
			document[a.appendToBody ? "body" : "head"].appendChild(i);
			A(function () {
				var t = g(x, a.refreshDebounceWait || 100);
				window.addEventListener("orientationchange", t, true);
				window.addEventListener("pageshow", t, true);
				if (a.force || u || v()) {
					window.addEventListener("resize", t, true);
					a._listeningToResize = true
				}
				a.hacks && a.hacks.initializeEvents(a, x, t);
				x()
			})
		}

		function y() {
			i.textContent = T();
			i.parentNode.appendChild(i);
			window.dispatchEvent(new m("viewport-units-buggyfill-style"))
		}

		function x() {
			if (!e) {
				return
			}
			b();
			setTimeout(function () {
				y()
			}, 1)
		}

		function _(t) {
			try {
				if (!t.cssRules) {
					return
				}
			} catch (t) {
				if (t.name !== "SecurityError") {
					throw t
				}
				return
			}
			var e = [];
			for (var i = 0; i < t.cssRules.length; i++) {
				var n = t.cssRules[i];
				e.push(n)
			}
			return e
		}

		function b() {
			c = [];
			o.call(document.styleSheets, function (t) {
				var e = _(t);
				if (!e || t.ownerNode.id === "patched-viewport" || t.ownerNode.getAttribute("data-viewport-units-buggyfill") === "ignore") {
					return
				}
				if (t.media && t.media.mediaText && window.matchMedia && !window.matchMedia(t.media.mediaText).matches) {
					return
				}
				o.call(e, w)
			});
			return c
		}

		function w(i) {
			if (i.type === 7) {
				var t;
				try {
					t = i.cssText
				} catch (t) {
					return
				}
				s.lastIndex = 0;
				if (s.test(t) && !r.test(t)) {
					c.push([i, null, t]);
					a.hacks && a.hacks.findDeclarations(c, i, null, t)
				}
				return
			}
			if (!i.style) {
				if (!i.cssRules) {
					return
				}
				o.call(i.cssRules, function (t) {
					w(t)
				});
				return
			}
			o.call(i.style, function (t) {
				var e = i.style.getPropertyValue(t);
				if (i.style.getPropertyPriority(t)) {
					e += " !important"
				}
				s.lastIndex = 0;
				if (s.test(e)) {
					c.push([i, t, e]);
					a.hacks && a.hacks.findDeclarations(c, i, t, e)
				}
			})
		}

		function T() {
			l = M();
			var r = [];
			var o = [];
			var a;
			var s;
			c.forEach(function (t) {
				var e = E.apply(null, t);
				var i = e.selector.length ? e.selector.join(" {\n") + " {\n" : "";
				var n = new Array(e.selector.length + 1).join("\n}");
				if (!i || i !== a) {
					if (o.length) {
						r.push(a + o.join("\n") + s);
						o.length = 0
					}
					if (i) {
						a = i;
						s = n;
						o.push(e.content)
					} else {
						r.push(e.content);
						a = null;
						s = null
					}
					return
				}
				if (i && !a) {
					a = i;
					s = n
				}
				o.push(e.content)
			});
			if (o.length) {
				r.push(a + o.join("\n") + s)
			}
			if (d) {
				r.push("* { content: normal !important; }")
			}
			return r.join("\n\n")
		}

		function E(t, e, i) {
			var n;
			var r = [];
			n = i.replace(s, S);
			if (a.hacks) {
				n = a.hacks.overwriteDeclaration(t, e, n)
			}
			if (e) {
				r.push(t.selectorText);
				n = e + ": " + n + ";"
			}
			var o = t.parentRule;
			while (o) {
				if (o.media) {
					r.unshift("@media " + o.media.mediaText)
				} else if (o.conditionText) {
					r.unshift("@supports " + o.conditionText)
				}
				o = o.parentRule
			}
			return {
				selector: r,
				content: n
			}
		}

		function S(t, e, i) {
			var n = l[i];
			var r = parseFloat(e) / 100;
			return r * n + "px"
		}

		function M() {
			var t = window.innerHeight;
			var e = window.innerWidth;
			return {
				vh: t,
				vw: e,
				vmax: Math.max(e, t),
				vmin: Math.min(e, t)
			}
		}

		function A(t) {
			var e = 0;
			var i = function () {
				e--;
				if (!e) {
					t()
				}
			};
			o.call(document.styleSheets, function (t) {
				if (!t.href || C(t.href) === C(location.href) || t.ownerNode.getAttribute("data-viewport-units-buggyfill") === "ignore") {
					return
				}
				e++;
				P(t.ownerNode, i)
			});
			if (!e) {
				t()
			}
		}

		function C(t) {
			return t.slice(0, t.indexOf("/", t.indexOf("://") + 3))
		}

		function P(e, i) {
			L(e.href, function () {
				var t = document.createElement("style");
				t.media = e.media;
				t.setAttribute("data-href", e.href);
				t.textContent = this.responseText;
				e.parentNode.replaceChild(t, e);
				i()
			}, i)
		}

		function L(t, e, i) {
			var n = new XMLHttpRequest;
			if ("withCredentials" in n) {
				n.open("GET", t, true)
			} else if (typeof XDomainRequest !== "undefined") {
				n = new XDomainRequest;
				n.open("GET", t)
			} else {
				throw new Error("cross-domain XHR not supported")
			}
			n.onload = e;
			n.onerror = i;
			n.send();
			return n
		}
		return {
			version: "0.6.1",
			findProperties: b,
			getCss: T,
			init: t,
			refresh: x
		}
	})
})();
! function (a, s, c) {
	"use strict";

	function u(t) {
		return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "")
	}

	function e() {
		var t;
		j = !1, X = a.devicePixelRatio, V = {}, W = {}, t = (X || 1) * P.xQuant, P.uT || (P.maxX = Math.max(1.3, P.maxX), t = Math.min(t, P.maxX), C.DPR = t), Y.width = Math.max(a.innerWidth || 0, y.clientWidth), Y.height = Math.max(a.innerHeight || 0, y.clientHeight), Y.vw = Y.width / 100, Y.vh = Y.height / 100, Y.em = C.getEmValue(), Y.rem = Y.em, E = P.lazyFactor / 2, E = E * t + E, M = .4 + .1 * t, w = .5 + .2 * t, T = .5 + .25 * t, S = t + 1.3, (r = Y.width > Y.height) || (E *= .9), N && (E *= .9), A = [Y.width, Y.height, t].join("-")
	}

	function x(t, e, i) {
		var n = e * Math.pow(t - .4, 1.9);
		return r || (n /= 1.3), t += n, t > i
	}

	function o(t) {
		var e, i = C.getSet(t),
			n = !1;
		"pending" != i && (n = A, i && (e = C.setRes(i), n = C.applySetCandidate(e, t))), t[C.ns].evaled = n
	}

	function _(t, e) {
		return t.res - e.res
	}

	function b(t, e, i) {
		var n;
		return !i && e && (i = t[C.ns].sets, i = i && i[i.length - 1]), n = h(e, i), n && (e = C.makeUrl(e), t[C.ns].curSrc = e, t[C.ns].curCan = n, n.res || K(n, n.set.sizes)), n
	}

	function h(t, e) {
		var i, n, r;
		if (t && e)
			for (r = C.parseSet(e), t = C.makeUrl(t), i = 0; i < r.length; i++)
				if (t == C.makeUrl(r[i].url)) {
					n = r[i];
					break
				}
		return n
	}

	function d(t, e) {
		var i, n, r, o, a = t.getElementsByTagName("source");
		for (i = 0, n = a.length; n > i; i++) r = a[i], r[C.ns] = !0, o = r.getAttribute("srcset"), o && e.push({
			srcset: o,
			media: r.getAttribute("media"),
			type: r.getAttribute("type"),
			sizes: r.getAttribute("sizes")
		})
	}
	var w, T, r, E, S, M, l, f, p, A, C = {},
		t = function () {},
		i = s.createElement("img"),
		m = i.getAttribute,
		g = i.setAttribute,
		v = i.removeAttribute,
		y = s.documentElement,
		n = {},
		P = {
			xQuant: 1,
			lazyFactor: .4,
			maxX: 2
		},
		L = "data-pfsrc",
		R = L + "set",
		O = "webkitBackfaceVisibility" in y.style,
		k = navigator.userAgent,
		N = /rident/.test(k) || /ecko/.test(k) && k.match(/rv\:(\d+)/) && RegExp.$1 > 35,
		I = "currentSrc",
		D = /\s+\+?\d+(e\d+)?w/,
		F = /((?:\([^)]+\)(?:\s*and\s*|\s*or\s*|\s*not\s*)?)+)?\s*(.+)/,
		B = /^([\+eE\d\.]+)(w|x)$/,
		U = /\s*\d+h\s*/,
		z = a.respimgCFG,
		G = ("https:" == location.protocol, "position:absolute;left:0;visibility:hidden;display:block;padding:0;border:none;font-size:1em;width:1em;overflow:hidden;clip:rect(0px, 0px, 0px, 0px)"),
		H = "font-size:100%!important;",
		j = !0,
		V = {},
		W = {},
		X = a.devicePixelRatio,
		Y = {
			px: 1,
			in: 96
		},
		q = s.createElement("a"),
		$ = !1,
		Z = function (t, e, i, n) {
			t.addEventListener ? t.addEventListener(e, i, n || !1) : t.attachEvent && t.attachEvent("on" + e, i)
		},
		J = function (e) {
			var i = {};
			return function (t) {
				return t in i || (i[t] = e(t)), i[t]
			}
		},
		Q = function () {
			var n = /^([\d\.]+)(em|vw|px)$/,
				e = function () {
					for (var t = arguments, e = 0, i = t[0]; ++e in t;) i = i.replace(t[e], t[++e]);
					return i
				},
				r = J(function (t) {
					return "return " + e((t || "").toLowerCase(), /\band\b/g, "&&", /,/g, "||", /min-([a-z-\s]+):/g, "e.$1>=", /max-([a-z-\s]+):/g, "e.$1<=", /calc([^)]+)/g, "($1)", /(\d+[\.]*[\d]*)([a-z]+)/g, "($1 * e.$2)", /^(?!(e.[a-z]|[0-9\.&=|><\+\-\*\(\)\/])).*/gi, "")
				});
			return function (t, e) {
				var i;
				if (!(t in V))
					if (V[t] = !1, e && (i = t.match(n))) V[t] = i[1] * Y[i[2]];
					else try {
						V[t] = new Function("e", r(t))(Y)
					} catch (t) {}
					return V[t]
			}
		}(),
		K = function (t, e) {
			return t.w ? (t.cWidth = C.calcListLength(e || "100vw"), t.res = t.w / t.cWidth) : t.res = t.x, t
		},
		tt = function (t) {
			var e, i, n, r = t || {};
			if (r.elements && 1 == r.elements.nodeType && ("IMG" == r.elements.nodeName.toUpperCase() ? r.elements = [r.elements] : (r.context = r.elements, r.elements = null)), r.reparse && (r.reevaluate = !0, a.console && console.warn && console.warn("reparse was renamed to reevaluate!")), e = r.elements || C.qsa(r.context || s, r.reevaluate || r.reselect ? C.sel : C.selShort), n = e.length) {
				for (C.setupRun(r), $ = !0, i = 0; n > i; i++) C.fillImg(e[i], r);
				C.teardownRun(r)
			}
		},
		et = J(function (t) {
			var e = [1, "x"],
				i = u(t || "");
			return i && (i = i.replace(U, ""), e = i.match(B) ? [1 * RegExp.$1, RegExp.$2] : !1), e
		});
	if (I in i || (I = "src"), n["image/jpeg"] = !0, n["image/gif"] = !0, n["image/png"] = !0, n["image/svg+xml"] = s.implementation.hasFeature("http://wwwindow.w3.org/TR/SVG11/feature#Image", "1.1"), C.ns = ("ri" + (new Date).getTime()).substr(0, 9), C.supSrcset = "srcset" in i, C.supSizes = "sizes" in i, C.supPicture = !!a.HTMLPictureElement, C.supSrcset && C.supPicture && !C.supSizes && ! function (t) {
			i.srcset = "data:,a", t.src = "data:,a", C.supSrcset = i.complete === t.complete, C.supPicture = C.supSrcset && C.supPicture
		}(s.createElement("img")), C.selShort = "picture>img,img[srcset]", C.sel = C.selShort, C.cfg = P, C.supSrcset && (C.sel += ",img[" + R + "]"), C.DPR = X || 1, C.u = Y, C.types = n, f = C.supSrcset && !C.supSizes, C.setSize = t, C.makeUrl = J(function (t) {
			return q.href = t, q.href
		}), C.qsa = function (t, e) {
			return t.querySelectorAll(e)
		}, C.matchesMedia = function () {
			return C.matchesMedia = a.matchMedia && (matchMedia("(min-width: 0.1em)") || {}).matches ? function (t) {
				return !t || matchMedia(t).matches
			} : C.mMQ, C.matchesMedia.apply(this, arguments)
		}, C.mMQ = function (t) {
			return t ? Q(t) : !0
		}, C.calcLength = function (t) {
			var e = Q(t, !0) || !1;
			return 0 > e && (e = !1), e
		}, C.supportsType = function (t) {
			return t ? n[t] : !0
		}, C.parseSize = J(function (t) {
			var e = (t || "").match(F);
			return {
				media: e && e[1],
				length: e && e[2]
			}
		}), C.parseSet = function (t) {
			if (!t.cands) {
				var e, i, n, r, o, a, s = t.srcset;
				for (t.cands = []; s;) s = s.replace(/^\s+/g, ""), e = s.search(/\s/g), n = null, -1 != e ? (i = s.slice(0, e), r = i.charAt(i.length - 1), "," != r && i || (i = i.replace(/,+$/, ""), n = ""), s = s.slice(e + 1), null == n && (o = s.indexOf(","), -1 != o ? (n = s.slice(0, o), s = s.slice(o + 1)) : (n = s, s = ""))) : (i = s, s = ""), i && (n = et(n)) && (a = {
					url: i.replace(/^,+/, ""),
					set: t
				}, a[n[1]] = n[0], "x" == n[1] && 1 == n[0] && (t.has1x = !0), t.cands.push(a))
			}
			return t.cands
		}, C.getEmValue = function () {
			var t;
			if (!l && (t = s.body)) {
				var e = s.createElement("div"),
					i = y.style.cssText,
					n = t.style.cssText;
				e.style.cssText = G, y.style.cssText = H, t.style.cssText = H, t.appendChild(e), l = e.offsetWidth, t.removeChild(e), l = parseFloat(l, 10), y.style.cssText = i, t.style.cssText = n
			}
			return l || 16
		}, C.calcListLength = function (t) {
			if (!(t in W) || P.uT) {
				var e, i, n, r, o, a, s = u(t).split(/\s*,\s*/),
					l = !1;
				for (o = 0, a = s.length; a > o && (e = s[o], i = C.parseSize(e), n = i.length, r = i.media, !n || !C.matchesMedia(r) || (l = C.calcLength(n)) === !1); o++);
				W[t] = l ? l : Y.width
			}
			return W[t]
		}, C.setRes = function (t) {
			var e;
			if (t) {
				e = C.parseSet(t);
				for (var i = 0, n = e.length; n > i; i++) K(e[i], t.sizes)
			}
			return e
		}, C.setRes.res = K, C.applySetCandidate = function (t, e) {
			if (t.length) {
				var i, n, r, o, a, s, l, c, u, h, d, f, p, m = e[C.ns],
					g = A,
					v = E,
					y = M;
				if (c = m.curSrc || e[I], u = m.curCan || b(e, c, t[0].set), n = C.DPR, p = u && u.res, !l && c && (f = N && !e.complete && u && p - .2 > n, f || u && !(S > p) || (u && n > p && p > w && (T > p && (v *= .8, y += .04 * n), u.res += v * Math.pow(p - y, 2)), h = !m.pic || u && u.set == t[0].set, u && h && u.res >= n && (l = u))), !l)
					for (p && (u.res = u.res - (u.res - p) / 2), t.sort(_), s = t.length, l = t[s - 1], r = 0; s > r; r++)
						if (i = t[r], i.res >= n) {
							o = r - 1, l = t[o] && (a = i.res - n) && (f || c != C.makeUrl(i.url)) && x(t[o].res, a, n) ? t[o] : i;
							break
						}
				return p && (u.res = p), l && (d = C.makeUrl(l.url), m.curSrc = d, m.curCan = l, d != c && C.setSrc(e, l), C.setSize(e)), g
			}
		}, C.setSrc = function (t, e) {
			var i;
			t.src = e.url, O && (i = t.style.zoom, t.style.zoom = "0.999", t.style.zoom = i)
		}, C.getSet = function (t) {
			var e, i, n, r = !1,
				o = t[C.ns].sets;
			for (e = 0; e < o.length && !r; e++)
				if (i = o[e], i.srcset && C.matchesMedia(i.media) && (n = C.supportsType(i.type))) {
					"pending" == n && (i = n), r = i;
					break
				}
			return r
		}, C.parseSets = function (t, e, i) {
			var n, r, o, a, s = "PICTURE" == e.nodeName.toUpperCase(),
				l = t[C.ns];
			(l.src === c || i.src) && (l.src = m.call(t, "src"), l.src ? g.call(t, L, l.src) : v.call(t, L)), (l.srcset === c || !C.supSrcset || t.srcset || i.srcset) && (n = m.call(t, "srcset"), l.srcset = n, a = !0), l.sets = [], s && (l.pic = !0, d(e, l.sets)), l.srcset ? (r = {
				srcset: l.srcset,
				sizes: m.call(t, "sizes")
			}, l.sets.push(r), o = (f || l.src) && D.test(l.srcset || ""), o || !l.src || h(l.src, r) || r.has1x || (r.srcset += ", " + l.src, r.cands.push({
				url: l.src,
				x: 1,
				set: r
			}))) : l.src && l.sets.push({
				srcset: l.src,
				sizes: null
			}), l.curCan = null, l.curSrc = c, l.supported = !(s || r && !C.supSrcset || o), a && C.supSrcset && !l.supported && (n ? (g.call(t, R, n), t.srcset = "") : v.call(t, R)), l.supported && !l.srcset && (!l.src && t.src || t.src != C.makeUrl(l.src)) && (null == l.src ? t.removeAttribute("src") : t.src = l.src), l.parsed = !0
		}, C.fillImg = function (t, e) {
			var i, n, r = e.reselect || e.reevaluate;
			if (t[C.ns] || (t[C.ns] = {}), n = t[C.ns], r || n.evaled != A) {
				if (!n.parsed || e.reevaluate) {
					if (i = t.parentNode, !i) return;
					C.parseSets(t, i, e)
				}
				n.supported ? n.evaled = A : o(t)
			}
		}, C.setupRun = function (t) {
			(!$ || j || X != a.devicePixelRatio) && (e(), t.elements || t.context || clearTimeout(p))
		}, C.supPicture ? (tt = t, C.fillImg = t) : (s.createElement("picture"), function () {
			var e, i = a.attachEvent ? /d$|^c/ : /d$|^c|^i/,
				n = function () {
					var t = s.readyState || "";
					o = setTimeout(n, "loading" == t ? 200 : 999), s.body && (e = e || i.test(t), C.fillImgs(), e && clearTimeout(o))
				},
				t = function () {
					C.fillImgs()
				},
				r = function () {
					clearTimeout(p), j = !0, p = setTimeout(t, 99)
				},
				o = setTimeout(n, s.body ? 0 : 20);
			Z(a, "resize", r), Z(s, "readystatechange", n)
		}()), C.respimage = tt, C.fillImgs = tt, C.teardownRun = t, tt._ = C, a.respimage = a.picturefill || tt, !a.picturefill)
		for (a.respimgCFG = {
				ri: C,
				push: function (t) {
					var e = t.shift();
					"function" == typeof C[e] ? C[e].apply(C, t) : (P[e] = t[0], $ && C.fillImgs({
						reselect: !0
					}))
				}
			}; z && z.length;) a.respimgCFG.push(z.shift());
	a.picturefill || (a.picturefill = a.respimage, a.picturefillCFG || (a.picturefillCFG = a.respimgCFG))
}(window, document);
! function (t, e) {
	"object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.Scrollbar = e() : t.Scrollbar = e()
}(this, function () {
	return function (i) {
		function n(t) {
			if (r[t]) return r[t].exports;
			var e = r[t] = {
				exports: {},
				id: t,
				loaded: !1
			};
			return i[t].call(e.exports, e, e.exports, n), e.loaded = !0, e.exports
		}
		var r = {};
		return n.m = i, n.c = r, n.p = "", n(0)
	}([function (t, e, i) {
		t.exports = i(1)
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}

		function o(t) {
			if (Array.isArray(t)) {
				for (var e = 0, i = Array(t.length); e < t.length; e++) i[e] = t[e];
				return i
			}
			return (0, a.default)(t)
		}
		var r = i(2),
			a = n(r),
			s = i(55),
			l = n(s),
			c = i(62),
			u = n(c);
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		var h = "function" == typeof u.default && "symbol" == typeof l.default ? function (t) {
				return typeof t
			} : function (t) {
				return t && "function" == typeof u.default && t.constructor === u.default && t !== u.default.prototype ? "symbol" : typeof t
			},
			d = i(78),
			f = i(89);
		i(129), i(145), i(158), i(173), i(187), e.default = d.SmoothScrollbar, d.SmoothScrollbar.version = "7.4.1", d.SmoothScrollbar.init = function (e, t) {
			if (!e || 1 !== e.nodeType) throw new TypeError("expect element to be DOM Element, but got " + ("undefined" == typeof e ? "undefined" : h(e)));
			if (f.sbList.has(e)) return f.sbList.get(e);
			e.setAttribute("data-scrollbar", "");
			var i = [].concat(o(e.childNodes)),
				n = document.createElement("div");
			n.innerHTML = '\n        <div class="scroll-content"></div>\n        <div class="scrollbar-track scrollbar-track-x">\n            <div class="scrollbar-thumb scrollbar-thumb-x"></div>\n        </div>\n        <div class="scrollbar-track scrollbar-track-y">\n            <div class="scrollbar-thumb scrollbar-thumb-y"></div>\n        </div>\n        <canvas class="overscroll-glow"></canvas>\n    ';
			var r = n.querySelector(".scroll-content");
			return [].concat(o(n.childNodes)).forEach(function (t) {
				return e.appendChild(t)
			}), i.forEach(function (t) {
				return r.appendChild(t)
			}), new d.SmoothScrollbar(e, t)
		}, d.SmoothScrollbar.initAll = function (e) {
			return [].concat(o(document.querySelectorAll(f.selectors))).map(function (t) {
				return d.SmoothScrollbar.init(t, e)
			})
		}, d.SmoothScrollbar.has = function (t) {
			return f.sbList.has(t)
		}, d.SmoothScrollbar.get = function (t) {
			return f.sbList.get(t)
		}, d.SmoothScrollbar.getAll = function () {
			return [].concat(o(f.sbList.values()))
		}, d.SmoothScrollbar.destroy = function (t, e) {
			return d.SmoothScrollbar.has(t) && d.SmoothScrollbar.get(t).destroy(e)
		}, d.SmoothScrollbar.destroyAll = function (e) {
			f.sbList.forEach(function (t) {
				t.destroy(e)
			})
		}, t.exports = e.default
	}, function (t, e, i) {
		t.exports = {
			default: i(3),
			__esModule: !0
		}
	}, function (t, e, i) {
		i(4), i(48), t.exports = i(12).Array.from
	}, function (t, e, i) {
		"use strict";
		var n = i(5)(!0);
		i(8)(String, "String", function (t) {
			this._t = String(t), this._i = 0
		}, function () {
			var t, e = this._t,
				i = this._i;
			return i >= e.length ? {
				value: void 0,
				done: !0
			} : (t = n(e, i), this._i += t.length, {
				value: t,
				done: !1
			})
		})
	}, function (t, e, i) {
		var l = i(6),
			c = i(7);
		t.exports = function (s) {
			return function (t, e) {
				var i, n, r = String(c(t)),
					o = l(e),
					a = r.length;
				return o < 0 || o >= a ? s ? "" : void 0 : (i = r.charCodeAt(o), i < 55296 || i > 56319 || o + 1 === a || (n = r.charCodeAt(o + 1)) < 56320 || n > 57343 ? s ? r.charAt(o) : i : s ? r.slice(o, o + 2) : (i - 55296 << 10) + (n - 56320) + 65536)
			}
		}
	}, function (t, e) {
		var i = Math.ceil,
			n = Math.floor;
		t.exports = function (t) {
			return isNaN(t = +t) ? 0 : (t > 0 ? n : i)(t)
		}
	}, function (t, e) {
		t.exports = function (t) {
			if (void 0 == t) throw TypeError("Can't call method on  " + t);
			return t
		}
	}, function (t, e, i) {
		"use strict";
		var x = i(9),
			_ = i(10),
			b = i(25),
			w = i(15),
			T = i(26),
			E = i(27),
			S = i(28),
			M = i(44),
			A = i(46),
			C = i(45)("iterator"),
			P = !([].keys && "next" in [].keys()),
			L = "@@iterator",
			R = "keys",
			O = "values",
			k = function () {
				return this
			};
		t.exports = function (t, e, i, n, r, o, a) {
			S(i, e, n);
			var s, l, c, u = function (t) {
					if (!P && t in p) return p[t];
					switch (t) {
						case R:
							return function () {
								return new i(this, t)
							};
						case O:
							return function () {
								return new i(this, t)
							}
					}
					return function () {
						return new i(this, t)
					}
				},
				h = e + " Iterator",
				d = r == O,
				f = !1,
				p = t.prototype,
				m = p[C] || p[L] || r && p[r],
				g = m || u(r),
				v = r ? d ? u("entries") : g : void 0,
				y = "Array" == e ? p.entries || m : m;
			if (y && (c = A(y.call(new t)), c !== Object.prototype && (M(c, h, !0), x || T(c, C) || w(c, C, k))), d && m && m.name !== O && (f = !0, g = function () {
					return m.call(this)
				}), x && !a || !P && !f && p[C] || w(p, C, g), E[e] = g, E[h] = k, r)
				if (s = {
						values: d ? g : u(O),
						keys: o ? g : u(R),
						entries: v
					}, a)
					for (l in s) l in p || b(p, l, s[l]);
				else _(_.P + _.F * (P || f), e, s);
			return s
		}
	}, function (t, e) {
		t.exports = !0
	}, function (t, e, i) {
		var m = i(11),
			g = i(12),
			v = i(13),
			y = i(15),
			x = "prototype",
			_ = function (t, e, i) {
				var n, r, o, a = t & _.F,
					s = t & _.G,
					l = t & _.S,
					c = t & _.P,
					u = t & _.B,
					h = t & _.W,
					d = s ? g : g[e] || (g[e] = {}),
					f = d[x],
					p = s ? m : l ? m[e] : (m[e] || {})[x];
				s && (i = e);
				for (n in i) r = !a && p && void 0 !== p[n], r && n in d || (o = r ? p[n] : i[n], d[n] = s && "function" != typeof p[n] ? i[n] : u && r ? v(o, m) : h && p[n] == o ? function (n) {
					var t = function (t, e, i) {
						if (this instanceof n) {
							switch (arguments.length) {
								case 0:
									return new n;
								case 1:
									return new n(t);
								case 2:
									return new n(t, e)
							}
							return new n(t, e, i)
						}
						return n.apply(this, arguments)
					};
					return t[x] = n[x], t
				}(o) : c && "function" == typeof o ? v(Function.call, o) : o, c && ((d.virtual || (d.virtual = {}))[n] = o, t & _.R && f && !f[n] && y(f, n, o)))
			};
		_.F = 1, _.G = 2, _.S = 4, _.P = 8, _.B = 16, _.W = 32, _.U = 64, _.R = 128, t.exports = _
	}, function (t, e) {
		var i = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
		"number" == typeof __g && (__g = i)
	}, function (t, e) {
		var i = t.exports = {
			version: "2.4.0"
		};
		"number" == typeof __e && (__e = i)
	}, function (t, e, i) {
		var o = i(14);
		t.exports = function (n, r, t) {
			if (o(n), void 0 === r) return n;
			switch (t) {
				case 1:
					return function (t) {
						return n.call(r, t)
					};
				case 2:
					return function (t, e) {
						return n.call(r, t, e)
					};
				case 3:
					return function (t, e, i) {
						return n.call(r, t, e, i)
					}
			}
			return function () {
				return n.apply(r, arguments)
			}
		}
	}, function (t, e) {
		t.exports = function (t) {
			if ("function" != typeof t) throw TypeError(t + " is not a function!");
			return t
		}
	}, function (t, e, i) {
		var n = i(16),
			r = i(24);
		t.exports = i(20) ? function (t, e, i) {
			return n.f(t, e, r(1, i))
		} : function (t, e, i) {
			return t[e] = i, t
		}
	}, function (t, e, i) {
		var n = i(17),
			r = i(19),
			o = i(23),
			a = Object.defineProperty;
		e.f = i(20) ? Object.defineProperty : function (t, e, i) {
			if (n(t), e = o(e, !0), n(i), r) try {
				return a(t, e, i)
			} catch (t) {}
			if ("get" in i || "set" in i) throw TypeError("Accessors not supported!");
			return "value" in i && (t[e] = i.value), t
		}
	}, function (t, e, i) {
		var n = i(18);
		t.exports = function (t) {
			if (!n(t)) throw TypeError(t + " is not an object!");
			return t
		}
	}, function (t, e) {
		t.exports = function (t) {
			return "object" == typeof t ? null !== t : "function" == typeof t
		}
	}, function (t, e, i) {
		t.exports = !i(20) && !i(21)(function () {
			return 7 != Object.defineProperty(i(22)("div"), "a", {
				get: function () {
					return 7
				}
			}).a
		})
	}, function (t, e, i) {
		t.exports = !i(21)(function () {
			return 7 != Object.defineProperty({}, "a", {
				get: function () {
					return 7
				}
			}).a
		})
	}, function (t, e) {
		t.exports = function (t) {
			try {
				return !!t()
			} catch (t) {
				return !0
			}
		}
	}, function (t, e, i) {
		var n = i(18),
			r = i(11).document,
			o = n(r) && n(r.createElement);
		t.exports = function (t) {
			return o ? r.createElement(t) : {}
		}
	}, function (t, e, i) {
		var r = i(18);
		t.exports = function (t, e) {
			if (!r(t)) return t;
			var i, n;
			if (e && "function" == typeof (i = t.toString) && !r(n = i.call(t))) return n;
			if ("function" == typeof (i = t.valueOf) && !r(n = i.call(t))) return n;
			if (!e && "function" == typeof (i = t.toString) && !r(n = i.call(t))) return n;
			throw TypeError("Can't convert object to primitive value")
		}
	}, function (t, e) {
		t.exports = function (t, e) {
			return {
				enumerable: !(1 & t),
				configurable: !(2 & t),
				writable: !(4 & t),
				value: e
			}
		}
	}, function (t, e, i) {
		t.exports = i(15)
	}, function (t, e) {
		var i = {}.hasOwnProperty;
		t.exports = function (t, e) {
			return i.call(t, e)
		}
	}, function (t, e) {
		t.exports = {}
	}, function (t, e, i) {
		"use strict";
		var n = i(29),
			r = i(24),
			o = i(44),
			a = {};
		i(15)(a, i(45)("iterator"), function () {
			return this
		}), t.exports = function (t, e, i) {
			t.prototype = n(a, {
				next: r(1, i)
			}), o(t, e + " Iterator")
		}
	}, function (t, e, o) {
		var n = o(17),
			r = o(30),
			a = o(42),
			s = o(39)("IE_PROTO"),
			l = function () {},
			c = "prototype",
			u = function () {
				var t, e = o(22)("iframe"),
					i = a.length,
					n = "<",
					r = ">";
				for (e.style.display = "none", o(43).appendChild(e), e.src = "javascript:", t = e.contentWindow.document, t.open(), t.write(n + "script" + r + "document.F=Object" + n + "/script" + r), t.close(), u = t.F; i--;) delete u[c][a[i]];
				return u()
			};
		t.exports = Object.create || function (t, e) {
			var i;
			return null !== t ? (l[c] = n(t), i = new l, l[c] = null, i[s] = t) : i = u(), void 0 === e ? i : r(i, e)
		}
	}, function (t, e, i) {
		var a = i(16),
			s = i(17),
			l = i(31);
		t.exports = i(20) ? Object.defineProperties : function (t, e) {
			s(t);
			for (var i, n = l(e), r = n.length, o = 0; r > o;) a.f(t, i = n[o++], e[i]);
			return t
		}
	}, function (t, e, i) {
		var n = i(32),
			r = i(42);
		t.exports = Object.keys || function (t) {
			return n(t, r)
		}
	}, function (t, e, i) {
		var a = i(26),
			s = i(33),
			l = i(36)(!1),
			c = i(39)("IE_PROTO");
		t.exports = function (t, e) {
			var i, n = s(t),
				r = 0,
				o = [];
			for (i in n) i != c && a(n, i) && o.push(i);
			for (; e.length > r;) a(n, i = e[r++]) && (~l(o, i) || o.push(i));
			return o
		}
	}, function (t, e, i) {
		var n = i(34),
			r = i(7);
		t.exports = function (t) {
			return n(r(t))
		}
	}, function (t, e, i) {
		var n = i(35);
		t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
			return "String" == n(t) ? t.split("") : Object(t)
		}
	}, function (t, e) {
		var i = {}.toString;
		t.exports = function (t) {
			return i.call(t).slice(8, -1)
		}
	}, function (t, e, i) {
		var l = i(33),
			c = i(37),
			u = i(38);
		t.exports = function (s) {
			return function (t, e, i) {
				var n, r = l(t),
					o = c(r.length),
					a = u(i, o);
				if (s && e != e) {
					for (; o > a;)
						if (n = r[a++], n != n) return !0
				} else
					for (; o > a; a++)
						if ((s || a in r) && r[a] === e) return s || a || 0; return !s && -1
			}
		}
	}, function (t, e, i) {
		var n = i(6),
			r = Math.min;
		t.exports = function (t) {
			return t > 0 ? r(n(t), 9007199254740991) : 0
		}
	}, function (t, e, i) {
		var n = i(6),
			r = Math.max,
			o = Math.min;
		t.exports = function (t, e) {
			return t = n(t), t < 0 ? r(t + e, 0) : o(t, e)
		}
	}, function (t, e, i) {
		var n = i(40)("keys"),
			r = i(41);
		t.exports = function (t) {
			return n[t] || (n[t] = r(t))
		}
	}, function (t, e, i) {
		var n = i(11),
			r = "__core-js_shared__",
			o = n[r] || (n[r] = {});
		t.exports = function (t) {
			return o[t] || (o[t] = {})
		}
	}, function (t, e) {
		var i = 0,
			n = Math.random();
		t.exports = function (t) {
			return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++i + n).toString(36))
		}
	}, function (t, e) {
		t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")
	}, function (t, e, i) {
		t.exports = i(11).document && document.documentElement
	}, function (t, e, i) {
		var n = i(16).f,
			r = i(26),
			o = i(45)("toStringTag");
		t.exports = function (t, e, i) {
			t && !r(t = i ? t : t.prototype, o) && n(t, o, {
				configurable: !0,
				value: e
			})
		}
	}, function (t, e, i) {
		var n = i(40)("wks"),
			r = i(41),
			o = i(11).Symbol,
			a = "function" == typeof o,
			s = t.exports = function (t) {
				return n[t] || (n[t] = a && o[t] || (a ? o : r)("Symbol." + t))
			};
		s.store = n
	}, function (t, e, i) {
		var n = i(26),
			r = i(47),
			o = i(39)("IE_PROTO"),
			a = Object.prototype;
		t.exports = Object.getPrototypeOf || function (t) {
			return t = r(t), n(t, o) ? t[o] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? a : null
		}
	}, function (t, e, i) {
		var n = i(7);
		t.exports = function (t) {
			return Object(n(t))
		}
	}, function (t, e, i) {
		"use strict";
		var d = i(13),
			n = i(10),
			f = i(47),
			p = i(49),
			m = i(50),
			g = i(37),
			v = i(51),
			y = i(52);
		n(n.S + n.F * !i(54)(function (t) {
			Array.from(t)
		}), "Array", {
			from: function (t) {
				var e, i, n, r, o = f(t),
					a = "function" == typeof this ? this : Array,
					s = arguments.length,
					l = s > 1 ? arguments[1] : void 0,
					c = void 0 !== l,
					u = 0,
					h = y(o);
				if (c && (l = d(l, s > 2 ? arguments[2] : void 0, 2)), void 0 == h || a == Array && m(h))
					for (e = g(o.length), i = new a(e); e > u; u++) v(i, u, c ? l(o[u], u) : o[u]);
				else
					for (r = h.call(o), i = new a; !(n = r.next()).done; u++) v(i, u, c ? p(r, l, [n.value, u], !0) : n.value);
				return i.length = u, i
			}
		})
	}, function (t, e, i) {
		var o = i(17);
		t.exports = function (t, e, i, n) {
			try {
				return n ? e(o(i)[0], i[1]) : e(i)
			} catch (e) {
				var r = t.return;
				throw void 0 !== r && o(r.call(t)), e
			}
		}
	}, function (t, e, i) {
		var n = i(27),
			r = i(45)("iterator"),
			o = Array.prototype;
		t.exports = function (t) {
			return void 0 !== t && (n.Array === t || o[r] === t)
		}
	}, function (t, e, i) {
		"use strict";
		var n = i(16),
			r = i(24);
		t.exports = function (t, e, i) {
			e in t ? n.f(t, e, r(0, i)) : t[e] = i
		}
	}, function (t, e, i) {
		var n = i(53),
			r = i(45)("iterator"),
			o = i(27);
		t.exports = i(12).getIteratorMethod = function (t) {
			if (void 0 != t) return t[r] || t["@@iterator"] || o[n(t)]
		}
	}, function (t, e, i) {
		var r = i(35),
			o = i(45)("toStringTag"),
			a = "Arguments" == r(function () {
				return arguments
			}()),
			s = function (t, e) {
				try {
					return t[e]
				} catch (t) {}
			};
		t.exports = function (t) {
			var e, i, n;
			return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (i = s(e = Object(t), o)) ? i : a ? r(e) : "Object" == (n = r(e)) && "function" == typeof e.callee ? "Arguments" : n
		}
	}, function (t, e, i) {
		var o = i(45)("iterator"),
			a = !1;
		try {
			var n = [7][o]();
			n.return = function () {
				a = !0
			}, Array.from(n, function () {
				throw 2
			})
		} catch (t) {}
		t.exports = function (t, e) {
			if (!e && !a) return !1;
			var i = !1;
			try {
				var n = [7],
					r = n[o]();
				r.next = function () {
					return {
						done: i = !0
					}
				}, n[o] = function () {
					return r
				}, t(n)
			} catch (t) {}
			return i
		}
	}, function (t, e, i) {
		t.exports = {
			default: i(56),
			__esModule: !0
		}
	}, function (t, e, i) {
		i(4), i(57), t.exports = i(61).f("iterator")
	}, function (t, e, i) {
		i(58);
		for (var n = i(11), r = i(15), o = i(27), a = i(45)("toStringTag"), s = ["NodeList", "DOMTokenList", "MediaList", "StyleSheetList", "CSSRuleList"], l = 0; l < 5; l++) {
			var c = s[l],
				u = n[c],
				h = u && u.prototype;
			h && !h[a] && r(h, a, c), o[c] = o.Array
		}
	}, function (t, e, i) {
		"use strict";
		var n = i(59),
			r = i(60),
			o = i(27),
			a = i(33);
		t.exports = i(8)(Array, "Array", function (t, e) {
			this._t = a(t), this._i = 0, this._k = e
		}, function () {
			var t = this._t,
				e = this._k,
				i = this._i++;
			return !t || i >= t.length ? (this._t = void 0, r(1)) : "keys" == e ? r(0, i) : "values" == e ? r(0, t[i]) : r(0, [i, t[i]])
		}, "values"), o.Arguments = o.Array, n("keys"), n("values"), n("entries")
	}, function (t, e) {
		t.exports = function () {}
	}, function (t, e) {
		t.exports = function (t, e) {
			return {
				value: e,
				done: !!t
			}
		}
	}, function (t, e, i) {
		e.f = i(45)
	}, function (t, e, i) {
		t.exports = {
			default: i(63),
			__esModule: !0
		}
	}, function (t, e, i) {
		i(64), i(75), i(76), i(77), t.exports = i(12).Symbol
	}, function (t, e, i) {
		"use strict";
		var n = i(11),
			a = i(26),
			r = i(20),
			o = i(10),
			s = i(25),
			l = i(65).KEY,
			c = i(21),
			u = i(40),
			h = i(44),
			d = i(41),
			f = i(45),
			p = i(61),
			m = i(66),
			g = i(67),
			v = i(68),
			y = i(71),
			x = i(17),
			_ = i(33),
			b = i(23),
			w = i(24),
			T = i(29),
			E = i(72),
			S = i(74),
			M = i(16),
			A = i(31),
			C = S.f,
			P = M.f,
			L = E.f,
			R = n.Symbol,
			O = n.JSON,
			k = O && O.stringify,
			N = "prototype",
			I = f("_hidden"),
			D = f("toPrimitive"),
			F = {}.propertyIsEnumerable,
			B = u("symbol-registry"),
			U = u("symbols"),
			z = u("op-symbols"),
			G = Object[N],
			H = "function" == typeof R,
			j = n.QObject,
			V = !j || !j[N] || !j[N].findChild,
			W = r && c(function () {
				return 7 != T(P({}, "a", {
					get: function () {
						return P(this, "a", {
							value: 7
						}).a
					}
				})).a
			}) ? function (t, e, i) {
				var n = C(G, e);
				n && delete G[e], P(t, e, i), n && t !== G && P(G, e, n)
			} : P,
			X = function (t) {
				var e = U[t] = T(R[N]);
				return e._k = t, e
			},
			Y = H && "symbol" == typeof R.iterator ? function (t) {
				return "symbol" == typeof t
			} : function (t) {
				return t instanceof R
			},
			q = function (t, e, i) {
				return t === G && q(z, e, i), x(t), e = b(e, !0), x(i), a(U, e) ? (i.enumerable ? (a(t, I) && t[I][e] && (t[I][e] = !1), i = T(i, {
					enumerable: w(0, !1)
				})) : (a(t, I) || P(t, I, w(1, {})), t[I][e] = !0), W(t, e, i)) : P(t, e, i)
			},
			$ = function (t, e) {
				x(t);
				for (var i, n = v(e = _(e)), r = 0, o = n.length; o > r;) q(t, i = n[r++], e[i]);
				return t
			},
			Z = function (t, e) {
				return void 0 === e ? T(t) : $(T(t), e)
			},
			J = function (t) {
				var e = F.call(this, t = b(t, !0));
				return !(this === G && a(U, t) && !a(z, t)) && (!(e || !a(this, t) || !a(U, t) || a(this, I) && this[I][t]) || e)
			},
			Q = function (t, e) {
				if (t = _(t), e = b(e, !0), t !== G || !a(U, e) || a(z, e)) {
					var i = C(t, e);
					return !i || !a(U, e) || a(t, I) && t[I][e] || (i.enumerable = !0), i
				}
			},
			K = function (t) {
				for (var e, i = L(_(t)), n = [], r = 0; i.length > r;) a(U, e = i[r++]) || e == I || e == l || n.push(e);
				return n
			},
			tt = function (t) {
				for (var e, i = t === G, n = L(i ? z : _(t)), r = [], o = 0; n.length > o;) !a(U, e = n[o++]) || i && !a(G, e) || r.push(U[e]);
				return r
			};
		H || (R = function () {
			if (this instanceof R) throw TypeError("Symbol is not a constructor!");
			var e = d(arguments.length > 0 ? arguments[0] : void 0),
				i = function (t) {
					this === G && i.call(z, t), a(this, I) && a(this[I], e) && (this[I][e] = !1), W(this, e, w(1, t))
				};
			return r && V && W(G, e, {
				configurable: !0,
				set: i
			}), X(e)
		}, s(R[N], "toString", function () {
			return this._k
		}), S.f = Q, M.f = q, i(73).f = E.f = K, i(70).f = J, i(69).f = tt, r && !i(9) && s(G, "propertyIsEnumerable", J, !0), p.f = function (t) {
			return X(f(t))
		}), o(o.G + o.W + o.F * !H, {
			Symbol: R
		});
		for (var et = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), it = 0; et.length > it;) f(et[it++]);
		for (var et = A(f.store), it = 0; et.length > it;) m(et[it++]);
		o(o.S + o.F * !H, "Symbol", {
			for: function (t) {
				return a(B, t += "") ? B[t] : B[t] = R(t)
			},
			keyFor: function (t) {
				if (Y(t)) return g(B, t);
				throw TypeError(t + " is not a symbol!")
			},
			useSetter: function () {
				V = !0
			},
			useSimple: function () {
				V = !1
			}
		}), o(o.S + o.F * !H, "Object", {
			create: Z,
			defineProperty: q,
			defineProperties: $,
			getOwnPropertyDescriptor: Q,
			getOwnPropertyNames: K,
			getOwnPropertySymbols: tt
		}), O && o(o.S + o.F * (!H || c(function () {
			var t = R();
			return "[null]" != k([t]) || "{}" != k({
				a: t
			}) || "{}" != k(Object(t))
		})), "JSON", {
			stringify: function (t) {
				if (void 0 !== t && !Y(t)) {
					for (var e, i, n = [t], r = 1; arguments.length > r;) n.push(arguments[r++]);
					return e = n[1], "function" == typeof e && (i = e), !i && y(e) || (e = function (t, e) {
						if (i && (e = i.call(this, t, e)), !Y(e)) return e
					}), n[1] = e, k.apply(O, n)
				}
			}
		}), R[N][D] || i(15)(R[N], D, R[N].valueOf), h(R, "Symbol"), h(Math, "Math", !0), h(n.JSON, "JSON", !0)
	}, function (t, e, i) {
		var n = i(41)("meta"),
			r = i(18),
			o = i(26),
			a = i(16).f,
			s = 0,
			l = Object.isExtensible || function () {
				return !0
			},
			c = !i(21)(function () {
				return l(Object.preventExtensions({}))
			}),
			u = function (t) {
				a(t, n, {
					value: {
						i: "O" + ++s,
						w: {}
					}
				})
			},
			h = function (t, e) {
				if (!r(t)) return "symbol" == typeof t ? t : ("string" == typeof t ? "S" : "P") + t;
				if (!o(t, n)) {
					if (!l(t)) return "F";
					if (!e) return "E";
					u(t)
				}
				return t[n].i
			},
			d = function (t, e) {
				if (!o(t, n)) {
					if (!l(t)) return !0;
					if (!e) return !1;
					u(t)
				}
				return t[n].w
			},
			f = function (t) {
				return c && p.NEED && l(t) && !o(t, n) && u(t), t
			},
			p = t.exports = {
				KEY: n,
				NEED: !1,
				fastKey: h,
				getWeak: d,
				onFreeze: f
			}
	}, function (t, e, i) {
		var n = i(11),
			r = i(12),
			o = i(9),
			a = i(61),
			s = i(16).f;
		t.exports = function (t) {
			var e = r.Symbol || (r.Symbol = o ? {} : n.Symbol || {});
			"_" == t.charAt(0) || t in e || s(e, t, {
				value: a.f(t)
			})
		}
	}, function (t, e, i) {
		var s = i(31),
			l = i(33);
		t.exports = function (t, e) {
			for (var i, n = l(t), r = s(n), o = r.length, a = 0; o > a;)
				if (n[i = r[a++]] === e) return i
		}
	}, function (t, e, i) {
		var s = i(31),
			l = i(69),
			c = i(70);
		t.exports = function (t) {
			var e = s(t),
				i = l.f;
			if (i)
				for (var n, r = i(t), o = c.f, a = 0; r.length > a;) o.call(t, n = r[a++]) && e.push(n);
			return e
		}
	}, function (t, e) {
		e.f = Object.getOwnPropertySymbols
	}, function (t, e) {
		e.f = {}.propertyIsEnumerable
	}, function (t, e, i) {
		var n = i(35);
		t.exports = Array.isArray || function (t) {
			return "Array" == n(t)
		}
	}, function (t, e, i) {
		var n = i(33),
			r = i(73).f,
			o = {}.toString,
			a = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [],
			s = function (t) {
				try {
					return r(t)
				} catch (t) {
					return a.slice()
				}
			};
		t.exports.f = function (t) {
			return a && "[object Window]" == o.call(t) ? s(t) : r(n(t))
		}
	}, function (t, e, i) {
		var n = i(32),
			r = i(42).concat("length", "prototype");
		e.f = Object.getOwnPropertyNames || function (t) {
			return n(t, r)
		}
	}, function (t, e, i) {
		var n = i(70),
			r = i(24),
			o = i(33),
			a = i(23),
			s = i(26),
			l = i(19),
			c = Object.getOwnPropertyDescriptor;
		e.f = i(20) ? c : function (t, e) {
			if (t = o(t), e = a(e, !0), l) try {
				return c(t, e)
			} catch (t) {}
			if (s(t, e)) return r(!n.f.call(t, e), t[e])
		}
	}, function (t, e) {}, function (t, e, i) {
		i(66)("asyncIterator")
	}, function (t, e, i) {
		i(66)("observable")
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}

		function h(t, e) {
			if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
		}
		var r = i(79),
			d = n(r),
			o = i(82),
			f = n(o),
			a = i(86),
			s = n(a);
		Object.defineProperty(e, "__esModule", {
			value: !0
		}), e.SmoothScrollbar = void 0;
		var l = function () {
				function n(t, e) {
					for (var i = 0; i < e.length; i++) {
						var n = e[i];
						n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), (0, s.default)(t, n.key, n)
					}
				}
				return function (t, e, i) {
					return e && n(t.prototype, e), i && n(t, i), t
				}
			}(),
			p = i(89),
			m = i(112);
		e.SmoothScrollbar = function () {
			function u(t) {
				var e = this,
					i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
				h(this, u), t.setAttribute("tabindex", "1");
				var n = (0, m.findChild)(t, "scroll-content"),
					r = (0, m.findChild)(t, "overscroll-glow"),
					o = (0, m.findChild)(t, "scrollbar-track-x"),
					a = (0, m.findChild)(t, "scrollbar-track-y");
				(0, m.setStyle)(t, {
					overflow: "hidden",
					outline: "none"
				}), (0, m.setStyle)(r, {
					display: "none",
					"pointer-events": "none"
				}), this.__readonly("targets", (0, f.default)({
					container: t,
					content: n,
					canvas: {
						elem: r,
						context: r.getContext("2d")
					},
					xAxis: (0, f.default)({
						track: o,
						thumb: (0, m.findChild)(o, "scrollbar-thumb-x")
					}),
					yAxis: (0, f.default)({
						track: a,
						thumb: (0, m.findChild)(a, "scrollbar-thumb-y")
					})
				})).__readonly("offset", {
					x: 0,
					y: 0
				}).__readonly("thumbOffset", {
					x: 0,
					y: 0
				}).__readonly("limit", {
					x: 1 / 0,
					y: 1 / 0
				}).__readonly("movement", {
					x: 0,
					y: 0
				}).__readonly("movementLocked", {
					x: !1,
					y: !1
				}).__readonly("overscrollRendered", {
					x: 0,
					y: 0
				}).__readonly("overscrollBack", !1).__readonly("thumbSize", {
					x: 0,
					y: 0,
					realX: 0,
					realY: 0
				}).__readonly("bounding", {
					top: 0,
					right: 0,
					bottom: 0,
					left: 0
				}).__readonly("children", []).__readonly("parents", []).__readonly("size", this.getSize()).__readonly("isNestedScrollbar", !1), (0, d.default)(this, {
					__hideTrackThrottle: {
						value: (0, m.debounce)(this.hideTrack.bind(this), 1e3, !1)
					},
					__updateThrottle: {
						value: (0, m.debounce)(this.update.bind(this))
					},
					__touchRecord: {
						value: new m.TouchRecord
					},
					__listeners: {
						value: []
					},
					__handlers: {
						value: []
					},
					__children: {
						value: []
					},
					__timerID: {
						value: {}
					}
				}), this.__initOptions(i), this.__initScrollbar();
				var s = t.scrollLeft,
					l = t.scrollTop;
				if (t.scrollLeft = t.scrollTop = 0, this.setPosition(s, l, !0), p.sbList.set(t, this), "function" == typeof p.GLOBAL_ENV.MutationObserver) {
					var c = new p.GLOBAL_ENV.MutationObserver(function () {
						e.update(!0)
					});
					c.observe(n, {
						childList: !0
					}), Object.defineProperty(this, "__observer", {
						value: c
					})
				}
			}
			return l(u, [{
				key: "MAX_OVERSCROLL",
				get: function () {
					var t = this.options,
						e = this.size;
					switch (t.overscrollEffect) {
						case "bounce":
							var i = Math.floor(Math.sqrt(Math.pow(e.container.width, 2) + Math.pow(e.container.height, 2))),
								n = this.__isMovementLocked() ? 2 : 10;
							return p.GLOBAL_ENV.TOUCH_SUPPORTED ? (0, m.pickInRange)(i / n, 100, 1e3) : (0, m.pickInRange)(i / 10, 25, 50);
						case "glow":
							return 150;
						default:
							return 0
					}
				}
			}, {
				key: "scrollTop",
				get: function () {
					return this.offset.y
				}
			}, {
				key: "scrollLeft",
				get: function () {
					return this.offset.x
				}
			}]), u
		}()
	}, function (t, e, i) {
		t.exports = {
			default: i(80),
			__esModule: !0
		}
	}, function (t, e, i) {
		i(81);
		var n = i(12).Object;
		t.exports = function (t, e) {
			return n.defineProperties(t, e)
		}
	}, function (t, e, i) {
		var n = i(10);
		n(n.S + n.F * !i(20), "Object", {
			defineProperties: i(30)
		})
	}, function (t, e, i) {
		t.exports = {
			default: i(83),
			__esModule: !0
		}
	}, function (t, e, i) {
		i(84), t.exports = i(12).Object.freeze
	}, function (t, e, i) {
		var n = i(18),
			r = i(65).onFreeze;
		i(85)("freeze", function (e) {
			return function (t) {
				return e && n(t) ? e(r(t)) : t
			}
		})
	}, function (t, e, i) {
		var r = i(10),
			o = i(12),
			a = i(21);
		t.exports = function (t, e) {
			var i = (o.Object || {})[t] || Object[t],
				n = {};
			n[t] = e(i), r(r.S + r.F * a(function () {
				i(1)
			}), "Object", n)
		}
	}, function (t, e, i) {
		t.exports = {
			default: i(87),
			__esModule: !0
		}
	}, function (t, e, i) {
		i(88);
		var n = i(12).Object;
		t.exports = function (t, e, i) {
			return n.defineProperty(t, e, i)
		}
	}, function (t, e, i) {
		var n = i(10);
		n(n.S + n.F * !i(20), "Object", {
			defineProperty: i(16).f
		})
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}
		var r = i(86),
			o = n(r),
			a = i(90),
			s = n(a);
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		var l = i(93);
		(0, s.default)(l).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return l[t]
				}
			})
		})
	}, function (t, e, i) {
		t.exports = {
			default: i(91),
			__esModule: !0
		}
	}, function (t, e, i) {
		i(92), t.exports = i(12).Object.keys
	}, function (t, e, i) {
		var n = i(47),
			r = i(31);
		i(85)("keys", function () {
			return function (t) {
				return r(n(t))
			}
		})
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}
		var r = i(86),
			o = n(r),
			a = i(90),
			s = n(a);
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		var l = i(94);
		(0, s.default)(l).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return l[t]
				}
			})
		});
		var c = i(95);
		(0, s.default)(c).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return c[t]
				}
			})
		});
		var u = i(111);
		(0, s.default)(u).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return u[t]
				}
			})
		})
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}
		var r = i(86),
			o = n(r),
			a = i(90),
			s = n(a);
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		var l = function (i) {
				var t = {},
					n = {};
				return (0, s.default)(i).forEach(function (e) {
					(0, o.default)(t, e, {
						get: function () {
							if (!n.hasOwnProperty(e)) {
								var t = i[e];
								n[e] = t()
							}
							return n[e]
						}
					})
				}), t
			},
			c = {
				MutationObserver: function () {
					return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver
				},
				TOUCH_SUPPORTED: function () {
					return "ontouchstart" in document
				},
				EASING_MULTIPLIER: function () {
					return navigator.userAgent.match(/Android/) ? .5 : .25
				},
				WHEEL_EVENT: function () {
					return "onwheel" in window ? "wheel" : "mousewheel"
				}
			};
		e.GLOBAL_ENV = l(c)
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}
		var r = i(96),
			o = n(r);
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		var a = new o.default,
			s = a.set.bind(a),
			l = a.delete.bind(a);
		a.update = function () {
			a.forEach(function (t) {
				t.__updateTree()
			})
		}, a.delete = function () {
			var t = l.apply(void 0, arguments);
			return a.update(), t
		}, a.set = function () {
			var t = s.apply(void 0, arguments);
			return a.update(), t
		}, e.sbList = a
	}, function (t, e, i) {
		t.exports = {
			default: i(97),
			__esModule: !0
		}
	}, function (t, e, i) {
		i(75), i(4), i(57), i(98), i(108), t.exports = i(12).Map
	}, function (t, e, i) {
		"use strict";
		var n = i(99);
		t.exports = i(104)("Map", function (t) {
			return function () {
				return t(this, arguments.length > 0 ? arguments[0] : void 0)
			}
		}, {
			get: function (t) {
				var e = n.getEntry(this, t);
				return e && e.v
			},
			set: function (t, e) {
				return n.def(this, 0 === t ? 0 : t, e)
			}
		}, n, !0)
	}, function (t, e, i) {
		"use strict";
		var a = i(16).f,
			s = i(29),
			l = i(100),
			c = i(13),
			u = i(101),
			h = i(7),
			d = i(102),
			n = i(8),
			r = i(60),
			o = i(103),
			f = i(20),
			p = i(65).fastKey,
			m = f ? "_s" : "size",
			g = function (t, e) {
				var i, n = p(e);
				if ("F" !== n) return t._i[n];
				for (i = t._f; i; i = i.n)
					if (i.k == e) return i
			};
		t.exports = {
			getConstructor: function (t, i, n, r) {
				var o = t(function (t, e) {
					u(t, o, i, "_i"), t._i = s(null), t._f = void 0, t._l = void 0, t[m] = 0, void 0 != e && d(e, n, t[r], t)
				});
				return l(o.prototype, {
					clear: function () {
						for (var t = this, e = t._i, i = t._f; i; i = i.n) i.r = !0, i.p && (i.p = i.p.n = void 0), delete e[i.i];
						t._f = t._l = void 0, t[m] = 0
					},
					delete: function (t) {
						var e = this,
							i = g(e, t);
						if (i) {
							var n = i.n,
								r = i.p;
							delete e._i[i.i], i.r = !0, r && (r.n = n), n && (n.p = r), e._f == i && (e._f = n), e._l == i && (e._l = r), e[m]--
						}
						return !!i
					},
					forEach: function (t) {
						u(this, o, "forEach");
						for (var e, i = c(t, arguments.length > 1 ? arguments[1] : void 0, 3); e = e ? e.n : this._f;)
							for (i(e.v, e.k, this); e && e.r;) e = e.p
					},
					has: function (t) {
						return !!g(this, t)
					}
				}), f && a(o.prototype, "size", {
					get: function () {
						return h(this[m])
					}
				}), o
			},
			def: function (t, e, i) {
				var n, r, o = g(t, e);
				return o ? o.v = i : (t._l = o = {
					i: r = p(e, !0),
					k: e,
					v: i,
					p: n = t._l,
					n: void 0,
					r: !1
				}, t._f || (t._f = o), n && (n.n = o), t[m]++, "F" !== r && (t._i[r] = o)), t
			},
			getEntry: g,
			setStrong: function (t, e, i) {
				n(t, e, function (t, e) {
					this._t = t, this._k = e, this._l = void 0
				}, function () {
					for (var t = this, e = t._k, i = t._l; i && i.r;) i = i.p;
					return t._t && (t._l = i = i ? i.n : t._t._f) ? "keys" == e ? r(0, i.k) : "values" == e ? r(0, i.v) : r(0, [i.k, i.v]) : (t._t = void 0, r(1))
				}, i ? "entries" : "values", !i, !0), o(e)
			}
		}
	}, function (t, e, i) {
		var r = i(15);
		t.exports = function (t, e, i) {
			for (var n in e) i && t[n] ? t[n] = e[n] : r(t, n, e[n]);
			return t
		}
	}, function (t, e) {
		t.exports = function (t, e, i, n) {
			if (!(t instanceof e) || void 0 !== n && n in t) throw TypeError(i + ": incorrect invocation!");
			return t
		}
	}, function (t, e, i) {
		var d = i(13),
			f = i(49),
			p = i(50),
			m = i(17),
			g = i(37),
			v = i(52),
			y = {},
			x = {},
			e = t.exports = function (t, e, i, n, r) {
				var o, a, s, l, c = r ? function () {
						return t
					} : v(t),
					u = d(i, n, e ? 2 : 1),
					h = 0;
				if ("function" != typeof c) throw TypeError(t + " is not iterable!");
				if (p(c)) {
					for (o = g(t.length); o > h; h++)
						if (l = e ? u(m(a = t[h])[0], a[1]) : u(t[h]), l === y || l === x) return l
				} else
					for (s = c.call(t); !(a = s.next()).done;)
						if (l = f(s, u, a.value, e), l === y || l === x) return l
			};
		e.BREAK = y, e.RETURN = x
	}, function (t, e, i) {
		"use strict";
		var n = i(11),
			r = i(12),
			o = i(16),
			a = i(20),
			s = i(45)("species");
		t.exports = function (t) {
			var e = "function" == typeof r[t] ? r[t] : n[t];
			a && e && !e[s] && o.f(e, s, {
				configurable: !0,
				get: function () {
					return this
				}
			})
		}
	}, function (t, e, i) {
		"use strict";
		var h = i(11),
			d = i(10),
			f = i(65),
			p = i(21),
			m = i(15),
			g = i(100),
			v = i(102),
			y = i(101),
			x = i(18),
			_ = i(44),
			b = i(16).f,
			w = i(105)(0),
			T = i(20);
		t.exports = function (i, t, e, n, r, o) {
			var a = h[i],
				s = a,
				l = r ? "set" : "add",
				c = s && s.prototype,
				u = {};
			return T && "function" == typeof s && (o || c.forEach && !p(function () {
				(new s).entries().next()
			})) ? (s = t(function (t, e) {
				y(t, s, i, "_c"), t._c = new a, void 0 != e && v(e, r, t[l], t)
			}), w("add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON".split(","), function (n) {
				var r = "add" == n || "set" == n;
				n in c && (!o || "clear" != n) && m(s.prototype, n, function (t, e) {
					if (y(this, s, n), !r && o && !x(t)) return "get" == n && void 0;
					var i = this._c[n](0 === t ? 0 : t, e);
					return r ? this : i
				})
			}), "size" in c && b(s.prototype, "size", {
				get: function () {
					return this._c.size
				}
			})) : (s = n.getConstructor(t, i, r, l), g(s.prototype, e), f.NEED = !0), _(s, i), u[i] = s, d(d.G + d.W + d.F, u), o || n.setStrong(s, i, r), s
		}
	}, function (t, e, i) {
		var x = i(13),
			_ = i(34),
			b = i(47),
			w = i(37),
			n = i(106);
		t.exports = function (h, t) {
			var d = 1 == h,
				f = 2 == h,
				p = 3 == h,
				m = 4 == h,
				g = 6 == h,
				v = 5 == h || g,
				y = t || n;
			return function (t, e, i) {
				for (var n, r, o = b(t), a = _(o), s = x(e, i, 3), l = w(a.length), c = 0, u = d ? y(t, l) : f ? y(t, 0) : void 0; l > c; c++)
					if ((v || c in a) && (n = a[c], r = s(n, c, o), h))
						if (d) u[c] = r;
						else if (r) switch (h) {
					case 3:
						return !0;
					case 5:
						return n;
					case 6:
						return c;
					case 2:
						u.push(n)
				} else if (m) return !1;
				return g ? -1 : p || m ? m : u
			}
		}
	}, function (t, e, i) {
		var n = i(107);
		t.exports = function (t, e) {
			return new(n(t))(e)
		}
	}, function (t, e, i) {
		var n = i(18),
			r = i(71),
			o = i(45)("species");
		t.exports = function (t) {
			var e;
			return r(t) && (e = t.constructor, "function" != typeof e || e !== Array && !r(e.prototype) || (e = void 0), n(e) && (e = e[o], null === e && (e = void 0))), void 0 === e ? Array : e
		}
	}, function (t, e, i) {
		var n = i(10);
		n(n.P + n.R, "Map", {
			toJSON: i(109)("Map")
		})
	}, function (t, e, i) {
		var n = i(53),
			r = i(110);
		t.exports = function (t) {
			return function () {
				if (n(this) != t) throw TypeError(t + "#toJSON isn't generic");
				return r(this)
			}
		}
	}, function (t, e, i) {
		var n = i(102);
		t.exports = function (t, e) {
			var i = [];
			return n(t, !1, i.push, i, e), i
		}
	}, function (t, e) {
		"use strict";
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		e.selectors = "scrollbar, [scrollbar], [data-scrollbar]"
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}
		var r = i(86),
			o = n(r),
			a = i(90),
			s = n(a);
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		var l = i(113);
		(0, s.default)(l).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return l[t]
				}
			})
		})
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}
		var r = i(86),
			o = n(r),
			a = i(90),
			s = n(a);
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		var l = i(114);
		(0, s.default)(l).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return l[t]
				}
			})
		});
		var c = i(115);
		(0, s.default)(c).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return c[t]
				}
			})
		});
		var u = i(116);
		(0, s.default)(u).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return u[t]
				}
			})
		});
		var h = i(117);
		(0, s.default)(h).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return h[t]
				}
			})
		});
		var d = i(118);
		(0, s.default)(d).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return d[t]
				}
			})
		});
		var f = i(119);
		(0, s.default)(f).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return f[t]
				}
			})
		});
		var p = i(120);
		(0, s.default)(p).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return p[t]
				}
			})
		});
		var m = i(121);
		(0, s.default)(m).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return m[t]
				}
			})
		});
		var g = i(122);
		(0, s.default)(g).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return g[t]
				}
			})
		});
		var v = i(123);
		(0, s.default)(v).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return v[t]
				}
			})
		});
		var y = i(124);
		(0, s.default)(y).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return y[t]
				}
			})
		})
	}, function (t, e) {
		"use strict";
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		e.buildCurve = function (t, e) {
			if (e <= 0) return [t];
			for (var i = [], n = Math.round(e / 1e3 * 60) - 1, r = t ? Math.pow(1 / Math.abs(t), 1 / n) : 0, o = 1; o <= n; o++) i.push(t - t * Math.pow(r, o));
			return i.push(t), i
		}
	}, function (t, e) {
		"use strict";
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		var i = 100;
		e.debounce = function (n) {
			var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : i,
				o = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
			if ("function" == typeof n) {
				var a = void 0;
				return function () {
					for (var t = arguments.length, e = Array(t), i = 0; i < t; i++) e[i] = arguments[i];
					!a && o && setTimeout(function () {
						return n.apply(void 0, e)
					}), clearTimeout(a), a = setTimeout(function () {
						a = void 0, n.apply(void 0, e)
					}, r)
				}
			}
		}
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}

		function r(t) {
			if (Array.isArray(t)) {
				for (var e = 0, i = Array(t.length); e < t.length; e++) i[e] = t[e];
				return i
			}
			return (0, a.default)(t)
		}
		var o = i(2),
			a = n(o);
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		e.findChild = function (t, e) {
			var i = t.children,
				n = null;
			return i && [].concat(r(i)).some(function (t) {
				if (t.className.match(e)) return n = t, !0
			}), n
		}
	}, function (t, e) {
		"use strict";
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		var i = {
				STANDARD: 1,
				OTHERS: -3
			},
			n = [1, 28, 500],
			r = function (t) {
				return n[t] || n[0]
			};
		e.getDelta = function (t) {
			if ("deltaX" in t) {
				var e = r(t.deltaMode);
				return {
					x: t.deltaX / i.STANDARD * e,
					y: t.deltaY / i.STANDARD * e
				}
			}
			return "wheelDeltaX" in t ? {
				x: t.wheelDeltaX / i.OTHERS,
				y: t.wheelDeltaY / i.OTHERS
			} : {
				x: 0,
				y: t.wheelDelta / i.OTHERS
			}
		}
	}, function (t, e) {
		"use strict";
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		e.getPointerData = function (t) {
			return t.touches ? t.touches[t.touches.length - 1] : t
		}
	}, function (t, e, i) {
		"use strict";
		Object.defineProperty(e, "__esModule", {
			value: !0
		}), e.getPosition = void 0;
		var n = i(118);
		e.getPosition = function (t) {
			var e = (0, n.getPointerData)(t);
			return {
				x: e.clientX,
				y: e.clientY
			}
		}
	}, function (t, e, i) {
		"use strict";
		Object.defineProperty(e, "__esModule", {
			value: !0
		}), e.getTouchID = void 0;
		var n = i(118);
		e.getTouchID = function (t) {
			var e = (0, n.getPointerData)(t);
			return e.identifier
		}
	}, function (t, e) {
		"use strict";
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		e.isOneOf = function (e) {
			var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
			return t.some(function (t) {
				return e === t
			})
		}
	}, function (t, e) {
		"use strict";
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		e.pickInRange = function (t) {
			var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -(1 / 0),
				i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1 / 0;
			return Math.max(e, Math.min(t, i))
		}
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}
		var r = i(90),
			o = n(r);
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		var a = ["webkit", "moz", "ms", "o"],
			s = new RegExp("^-(?!(?:" + a.join("|") + ")-)"),
			l = function (t) {
				var n = {};
				return (0, o.default)(t).forEach(function (e) {
					if (!s.test(e)) return void(n[e] = t[e]);
					var i = t[e];
					e = e.replace(/^-/, ""), n[e] = i, a.forEach(function (t) {
						n["-" + t + "-" + e] = i
					})
				}), n
			};
		e.setStyle = function (i, n) {
			n = l(n), (0, o.default)(n).forEach(function (t) {
				var e = t.replace(/^-/, "").replace(/-([a-z])/g, function (t, e) {
					return e.toUpperCase()
				});
				i.style[e] = n[t]
			})
		}
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}

		function r(t) {
			if (Array.isArray(t)) {
				for (var e = 0, i = Array(t.length); e < t.length; e++) i[e] = t[e];
				return i
			}
			return (0, s.default)(t)
		}

		function o(t, e) {
			if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
		}
		var a = i(2),
			s = n(a),
			l = i(86),
			c = n(l),
			u = i(125),
			h = n(u);
		Object.defineProperty(e, "__esModule", {
			value: !0
		}), e.TouchRecord = void 0;
		var d = h.default || function (t) {
				for (var e = 1; e < arguments.length; e++) {
					var i = arguments[e];
					for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n])
				}
				return t
			},
			f = function () {
				function n(t, e) {
					for (var i = 0; i < e.length; i++) {
						var n = e[i];
						n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), (0, c.default)(t, n.key, n)
					}
				}
				return function (t, e, i) {
					return e && n(t.prototype, e), i && n(t, i), t
				}
			}(),
			p = i(119),
			m = function () {
				function e(t) {
					o(this, e), this.updateTime = Date.now(), this.delta = {
						x: 0,
						y: 0
					}, this.velocity = {
						x: 0,
						y: 0
					}, this.lastPosition = (0, p.getPosition)(t)
				}
				return f(e, [{
					key: "update",
					value: function (t) {
						var e = this.velocity,
							i = this.updateTime,
							n = this.lastPosition,
							r = Date.now(),
							o = (0, p.getPosition)(t),
							a = {
								x: -(o.x - n.x),
								y: -(o.y - n.y)
							},
							s = r - i || 16,
							l = a.x / s * 1e3,
							c = a.y / s * 1e3;
						e.x = .8 * l + .2 * e.x, e.y = .8 * c + .2 * e.y, this.delta = a, this.updateTime = r, this.lastPosition = o
					}
				}]), e
			}();
		e.TouchRecord = function () {
			function t() {
				o(this, t), this.touchList = {}, this.lastTouch = null, this.activeTouchID = void 0
			}
			return f(t, [{
				key: "__add",
				value: function (t) {
					if (this.__has(t)) return null;
					var e = new m(t);
					return this.touchList[t.identifier] = e, e
				}
			}, {
				key: "__renew",
				value: function (t) {
					if (!this.__has(t)) return null;
					var e = this.touchList[t.identifier];
					return e.update(t), e
				}
			}, {
				key: "__delete",
				value: function (t) {
					return delete this.touchList[t.identifier]
				}
			}, {
				key: "__has",
				value: function (t) {
					return this.touchList.hasOwnProperty(t.identifier)
				}
			}, {
				key: "__setActiveID",
				value: function (t) {
					this.activeTouchID = t[t.length - 1].identifier, this.lastTouch = this.touchList[this.activeTouchID]
				}
			}, {
				key: "__getActiveTracker",
				value: function () {
					var t = this.touchList,
						e = this.activeTouchID;
					return t[e]
				}
			}, {
				key: "isActive",
				value: function () {
					return void 0 !== this.activeTouchID
				}
			}, {
				key: "getDelta",
				value: function () {
					var t = this.__getActiveTracker();
					return t ? d({}, t.delta) : this.__primitiveValue
				}
			}, {
				key: "getVelocity",
				value: function () {
					var t = this.__getActiveTracker();
					return t ? d({}, t.velocity) : this.__primitiveValue
				}
			}, {
				key: "getLastPosition",
				value: function () {
					var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
						e = this.__getActiveTracker() || this.lastTouch,
						i = e ? e.lastPosition : this.__primitiveValue;
					return t ? i.hasOwnProperty(t) ? i[t] : 0 : d({}, i)
				}
			}, {
				key: "updatedRecently",
				value: function () {
					var t = this.__getActiveTracker();
					return t && Date.now() - t.updateTime < 30
				}
			}, {
				key: "track",
				value: function (t) {
					var e = this,
						i = t.targetTouches;
					return [].concat(r(i)).forEach(function (t) {
						e.__add(t)
					}), this.touchList
				}
			}, {
				key: "update",
				value: function (t) {
					var e = this,
						i = t.touches,
						n = t.changedTouches;
					return [].concat(r(i)).forEach(function (t) {
						e.__renew(t)
					}), this.__setActiveID(n), this.touchList
				}
			}, {
				key: "release",
				value: function (t) {
					var e = this;
					return this.activeTouchID = void 0, [].concat(r(t.changedTouches)).forEach(function (t) {
						e.__delete(t)
					}), this.touchList
				}
			}, {
				key: "__primitiveValue",
				get: function () {
					return {
						x: 0,
						y: 0
					}
				}
			}]), t
		}()
	}, function (t, e, i) {
		t.exports = {
			default: i(126),
			__esModule: !0
		}
	}, function (t, e, i) {
		i(127), t.exports = i(12).Object.assign
	}, function (t, e, i) {
		var n = i(10);
		n(n.S + n.F, "Object", {
			assign: i(128)
		})
	}, function (t, e, i) {
		"use strict";
		var d = i(31),
			f = i(69),
			p = i(70),
			m = i(47),
			g = i(34),
			r = Object.assign;
		t.exports = !r || i(21)(function () {
			var t = {},
				e = {},
				i = Symbol(),
				n = "abcdefghijklmnopqrst";
			return t[i] = 7, n.split("").forEach(function (t) {
				e[t] = t
			}), 7 != r({}, t)[i] || Object.keys(r({}, e)).join("") != n
		}) ? function (t, e) {
			for (var i = m(t), n = arguments.length, r = 1, o = f.f, a = p.f; n > r;)
				for (var s, l = g(arguments[r++]), c = o ? d(l).concat(o(l)) : d(l), u = c.length, h = 0; u > h;) a.call(l, s = c[h++]) && (i[s] = l[s]);
			return i
		} : r
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}
		var r = i(86),
			o = n(r),
			a = i(90),
			s = n(a);
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		var l = i(130);
		(0, s.default)(l).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return l[t]
				}
			})
		})
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}
		var r = i(86),
			o = n(r),
			a = i(90),
			s = n(a);
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		var l = i(131);
		(0, s.default)(l).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return l[t]
				}
			})
		});
		var c = i(132);
		(0, s.default)(c).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return c[t]
				}
			})
		});
		var u = i(133);
		(0, s.default)(u).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return u[t]
				}
			})
		});
		var h = i(134);
		(0, s.default)(h).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return h[t]
				}
			})
		});
		var d = i(135);
		(0, s.default)(d).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return d[t]
				}
			})
		});
		var f = i(136);
		(0, s.default)(f).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return f[t]
				}
			})
		});
		var p = i(137);
		(0, s.default)(p).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return p[t]
				}
			})
		});
		var m = i(138);
		(0, s.default)(m).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return m[t]
				}
			})
		});
		var g = i(139);
		(0, s.default)(g).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return g[t]
				}
			})
		});
		var v = i(140);
		(0, s.default)(v).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return v[t]
				}
			})
		});
		var y = i(141);
		(0, s.default)(y).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return y[t]
				}
			})
		});
		var x = i(142);
		(0, s.default)(x).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return x[t]
				}
			})
		});
		var _ = i(143);
		(0, s.default)(_).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return _[t]
				}
			})
		});
		var b = i(144);
		(0, s.default)(b).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return b[t]
				}
			})
		})
	}, function (t, e, i) {
		"use strict";
		var n = i(78);
		n.SmoothScrollbar.prototype.clearMovement = n.SmoothScrollbar.prototype.stop = function () {
			this.movement.x = this.movement.y = 0, cancelAnimationFrame(this.__timerID.scrollTo)
		}
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}

		function l(t) {
			if (Array.isArray(t)) {
				for (var e = 0, i = Array(t.length); e < t.length; e++) i[e] = t[e];
				return i
			}
			return (0, o.default)(t)
		}
		var r = i(2),
			o = n(r),
			a = i(78),
			c = i(112),
			u = i(89);
		a.SmoothScrollbar.prototype.destroy = function (t) {
			var e = this.__listeners,
				i = this.__handlers,
				n = this.__observer,
				r = this.targets,
				o = r.container,
				a = r.content;
			if (i.forEach(function (t) {
					var e = t.evt,
						i = t.elem,
						n = t.fn;
					i.removeEventListener(e, n)
				}), i.length = e.length = 0, this.stop(), cancelAnimationFrame(this.__timerID.render), n && n.disconnect(), u.sbList.delete(o), !t && o.parentNode) {
				for (var s = [].concat(l(a.childNodes)); o.firstChild;) o.removeChild(o.firstChild);
				s.forEach(function (t) {
					return o.appendChild(t)
				}), (0, c.setStyle)(o, {
					overflow: ""
				}), o.scrollTop = this.scrollTop, o.scrollLeft = this.scrollLeft
			}
		}
	}, function (t, e, i) {
		"use strict";
		var n = i(78);
		n.SmoothScrollbar.prototype.getContentElem = function () {
			return this.targets.content
		}
	}, function (t, e, i) {
		"use strict";
		var n = i(78);
		n.SmoothScrollbar.prototype.getSize = function () {
			var t = this.targets.container,
				e = this.targets.content;
			return {
				container: {
					width: t.clientWidth,
					height: t.clientHeight
				},
				content: {
					width: e.offsetWidth - e.clientWidth + e.scrollWidth,
					height: e.offsetHeight - e.clientHeight + e.scrollHeight
				}
			}
		}
	}, function (t, e, i) {
		"use strict";
		var n = i(78);
		n.SmoothScrollbar.prototype.infiniteScroll = function (n) {
			var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 50;
			if ("function" == typeof n) {
				var o = {
						x: 0,
						y: 0
					},
					a = !1;
				this.addListener(function (t) {
					var e = t.offset,
						i = t.limit;
					i.y - e.y <= r && e.y > o.y && !a && (a = !0, setTimeout(function () {
						return n(t)
					})), i.y - e.y > r && (a = !1), o = e
				})
			}
		}
	}, function (t, e, i) {
		"use strict";
		var n = i(78);
		n.SmoothScrollbar.prototype.isVisible = function (t) {
			var e = this.bounding,
				i = t.getBoundingClientRect(),
				n = Math.max(e.top, i.top),
				r = Math.max(e.left, i.left),
				o = Math.min(e.right, i.right),
				a = Math.min(e.bottom, i.bottom);
			return n < a && r < o
		}
	}, function (t, e, i) {
		"use strict";
		var n = i(78);
		n.SmoothScrollbar.prototype.addListener = function (t) {
			"function" == typeof t && this.__listeners.push(t)
		}, n.SmoothScrollbar.prototype.removeListener = function (n) {
			"function" == typeof n && this.__listeners.some(function (t, e, i) {
				return t === n && i.splice(e, 1)
			})
		}
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}

		function r(t, e, i) {
			return e in t ? (0, c.default)(t, e, {
				value: i,
				enumerable: !0,
				configurable: !0,
				writable: !0
			}) : t[e] = i, t
		}

		function l(e, t) {
			return !!t.length && t.some(function (t) {
				return e.match(t)
			})
		}

		function o() {
			var a = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : h.REGIESTER,
				s = d[a];
			return function () {
				for (var t = arguments.length, o = Array(t), e = 0; e < t; e++) o[e] = arguments[e];
				this.__handlers.forEach(function (t) {
					var e = t.elem,
						i = t.evt,
						n = t.fn,
						r = t.hasRegistered;
					r && a === h.REGIESTER || !r && a === h.UNREGIESTER || l(i, o) && (e[s](i, n), t.hasRegistered = !r)
				})
			}
		}
		var a, s = i(86),
			c = n(s),
			u = i(78),
			h = {
				REGIESTER: 0,
				UNREGIESTER: 1
			},
			d = (a = {}, r(a, h.REGIESTER, "addEventListener"), r(a, h.UNREGIESTER, "removeEventListener"), a);
		u.SmoothScrollbar.prototype.registerEvents = o(h.REGIESTER), u.SmoothScrollbar.prototype.unregisterEvents = o(h.UNREGIESTER)
	}, function (t, e, i) {
		"use strict";
		var n = i(78);
		n.SmoothScrollbar.prototype.scrollIntoView = function (t) {
			var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
				i = e.alignToTop,
				n = void 0 === i || i,
				r = e.onlyScrollIfNeeded,
				o = void 0 !== r && r,
				a = e.offsetTop,
				s = void 0 === a ? 0 : a,
				l = e.offsetLeft,
				c = void 0 === l ? 0 : l,
				u = e.offsetBottom,
				h = void 0 === u ? 0 : u,
				d = this.targets,
				f = this.bounding;
			if (t && d.container.contains(t)) {
				var p = t.getBoundingClientRect();
				o && this.isVisible(t) || this.__setMovement(p.left - f.left - c, n ? p.top - f.top - s : p.bottom - f.bottom - h)
			}
		}
	}, function (t, e, i) {
		"use strict";
		var y = i(112),
			n = i(78);
		n.SmoothScrollbar.prototype.scrollTo = function () {
			var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.offset.x,
				e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.offset.y,
				i = this,
				n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
				r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
				o = this.options,
				a = this.offset,
				s = this.limit,
				l = this.__timerID;
			cancelAnimationFrame(l.scrollTo), r = "function" == typeof r ? r : function () {}, o.renderByPixels && (t = Math.round(t), e = Math.round(e));
			var c = a.x,
				u = a.y,
				h = (0, y.pickInRange)(t, 0, s.x) - c,
				d = (0, y.pickInRange)(e, 0, s.y) - u,
				f = (0, y.buildCurve)(h, n),
				p = (0, y.buildCurve)(d, n),
				m = f.length,
				g = 0,
				v = function t() {
					i.setPosition(c + f[g], u + p[g]), g++, g === m ? requestAnimationFrame(function () {
						r(i)
					}) : l.scrollTo = requestAnimationFrame(t)
				};
			v()
		}
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}
		var r = i(90),
			o = n(r),
			a = i(78);
		a.SmoothScrollbar.prototype.setOptions = function () {
			var e = this,
				i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
			(0, o.default)(i).forEach(function (t) {
				e.options.hasOwnProperty(t) && void 0 !== i[t] && (e.options[t] = i[t])
			})
		}
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}
		var r = i(125),
			o = n(r),
			c = o.default || function (t) {
				for (var e = 1; e < arguments.length; e++) {
					var i = arguments[e];
					for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n])
				}
				return t
			},
			u = i(112),
			a = i(78);
		a.SmoothScrollbar.prototype.setPosition = function () {
			var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.offset.x,
				e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.offset.y,
				i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
			this.__hideTrackThrottle();
			var n = {},
				r = this.options,
				o = this.offset,
				a = this.limit,
				s = this.targets,
				l = this.__listeners;
			r.renderByPixels && (t = Math.round(t), e = Math.round(e)), t !== o.x && this.showTrack("x"), e !== o.y && this.showTrack("y"), t = (0, u.pickInRange)(t, 0, a.x), e = (0, u.pickInRange)(e, 0, a.y), t === o.x && e === o.y || (n.direction = {
				x: t === o.x ? "none" : t > o.x ? "right" : "left",
				y: e === o.y ? "none" : e > o.y ? "down" : "up"
			}, this.__readonly("offset", {
				x: t,
				y: e
			}), n.limit = c({}, a), n.offset = c({}, this.offset), this.__setThumbPosition(), (0, u.setStyle)(s.content, {
				"-transform": "translate3d(" + -t + "px, " + -e + "px, 0)"
			}), i || l.forEach(function (t) {
				r.syncCallbacks ? t(n) : requestAnimationFrame(function () {
					t(n)
				})
			}))
		}
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}

		function r(t, e, i) {
			return e in t ? (0, l.default)(t, e, {
				value: i,
				enumerable: !0,
				configurable: !0,
				writable: !0
			}) : t[e] = i, t
		}

		function o() {
			var s = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : u.SHOW,
				l = d[s];
			return function () {
				var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "both",
					e = this.options,
					i = this.movement,
					n = this.targets,
					r = n.container,
					o = n.xAxis,
					a = n.yAxis;
				i.x || i.y ? r.classList.add(h.CONTAINER) : r.classList.remove(h.CONTAINER), e.alwaysShowTracks && s === u.HIDE || (t = t.toLowerCase(), "both" === t && (o.track.classList[l](h.TRACK), a.track.classList[l](h.TRACK)), "x" === t && o.track.classList[l](h.TRACK), "y" === t && a.track.classList[l](h.TRACK))
			}
		}
		var a, s = i(86),
			l = n(s),
			c = i(78),
			u = {
				SHOW: 0,
				HIDE: 1
			},
			h = {
				TRACK: "show",
				CONTAINER: "scrolling"
			},
			d = (a = {}, r(a, u.SHOW, "add"), r(a, u.HIDE, "remove"), a);
		c.SmoothScrollbar.prototype.showTrack = o(u.SHOW), c.SmoothScrollbar.prototype.hideTrack = o(u.HIDE)
	}, function (t, e, i) {
		"use strict";

		function r() {
			if ("glow" === this.options.overscrollEffect) {
				var t = this.targets,
					e = this.size,
					i = t.canvas,
					n = i.elem,
					r = i.context,
					o = window.devicePixelRatio || 1,
					a = e.container.width * o,
					s = e.container.height * o;
				a === n.width && s === n.height || (n.width = a, n.height = s, r.scale(o, o))
			}
		}

		function o() {
			var t = this.size,
				e = this.thumbSize,
				i = this.targets,
				n = i.xAxis,
				r = i.yAxis;
			(0, a.setStyle)(n.track, {
				display: t.content.width <= t.container.width ? "none" : "block"
			}), (0, a.setStyle)(r.track, {
				display: t.content.height <= t.container.height ? "none" : "block"
			}), (0, a.setStyle)(n.thumb, {
				width: e.x + "px"
			}), (0, a.setStyle)(r.thumb, {
				height: e.y + "px"
			})
		}

		function n() {
			var t = this.options;
			this.__updateBounding();
			var e = this.getSize(),
				i = {
					x: Math.max(e.content.width - e.container.width, 0),
					y: Math.max(e.content.height - e.container.height, 0)
				},
				n = {
					realX: e.container.width / e.content.width * e.container.width,
					realY: e.container.height / e.content.height * e.container.height
				};
			n.x = Math.max(n.realX, t.thumbMinSize), n.y = Math.max(n.realY, t.thumbMinSize), this.__readonly("size", e).__readonly("limit", i).__readonly("thumbSize", n), o.call(this), r.call(this), this.setPosition(), this.__setThumbPosition()
		}
		var a = i(112),
			s = i(78);
		s.SmoothScrollbar.prototype.update = function (t) {
			t ? requestAnimationFrame(n.bind(this)) : n.call(this)
		}
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}
		var r = i(86),
			o = n(r),
			a = i(90),
			s = n(a);
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		var l = i(146);
		(0, s.default)(l).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return l[t]
				}
			})
		})
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}
		var r = i(86),
			o = n(r),
			a = i(90),
			s = n(a);
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		var l = i(147);
		(0, s.default)(l).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return l[t]
				}
			})
		});
		var c = i(148);
		(0, s.default)(c).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return c[t]
				}
			})
		});
		var u = i(149);
		(0, s.default)(u).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return u[t]
				}
			})
		});
		var h = i(154);
		(0, s.default)(h).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return h[t]
				}
			})
		});
		var d = i(155);
		(0, s.default)(d).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return d[t]
				}
			})
		});
		var f = i(156);
		(0, s.default)(f).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return f[t]
				}
			})
		});
		var p = i(157);
		(0, s.default)(p).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return p[t]
				}
			})
		})
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}

		function c(t) {
			if (Array.isArray(t)) {
				for (var e = 0, i = Array(t.length); e < t.length; e++) i[e] = t[e];
				return i
			}
			return (0, a.default)(t)
		}

		function r() {
			var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
				e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
				i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
				n = this.limit,
				r = this.options,
				o = this.movement;
			this.__updateThrottle(), r.renderByPixels && (t = Math.round(t), e = Math.round(e));
			var a = o.x + t,
				s = o.y + e;
			0 === n.x && (a = 0), 0 === n.y && (s = 0);
			var l = this.__getDeltaLimit(i);
			o.x = u.pickInRange.apply(void 0, [a].concat(c(l.x))), o.y = u.pickInRange.apply(void 0, [s].concat(c(l.y)))
		}
		var o = i(2),
			a = n(o),
			u = i(112),
			s = i(78);
		Object.defineProperty(s.SmoothScrollbar.prototype, "__addMovement", {
			value: r,
			writable: !0,
			configurable: !0
		})
	}, function (t, e, i) {
		"use strict";

		function n() {
			var e = this,
				i = this.movement,
				n = this.movementLocked;
			s.forEach(function (t) {
				n[t] = i[t] && e.__willOverscroll(t, i[t])
			})
		}

		function r() {
			var e = this.movementLocked;
			s.forEach(function (t) {
				e[t] = !1
			})
		}

		function o() {
			var t = this.movementLocked;
			return t.x || t.y
		}
		var a = i(78),
			s = ["x", "y"];
		Object.defineProperty(a.SmoothScrollbar.prototype, "__autoLockMovement", {
			value: n,
			writable: !0,
			configurable: !0
		}), Object.defineProperty(a.SmoothScrollbar.prototype, "__unlockMovement", {
			value: r,
			writable: !0,
			configurable: !0
		}), Object.defineProperty(a.SmoothScrollbar.prototype, "__isMovementLocked", {
			value: o,
			writable: !0,
			configurable: !0
		})
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}

		function o() {
			var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
			if (t) {
				var e = this.options,
					i = this.movement,
					n = this.overscrollRendered,
					r = this.MAX_OVERSCROLL,
					o = i[t] = (0, f.pickInRange)(i[t], -r, r),
					a = e.overscrollDamping,
					s = n[t] + (o - n[t]) * a;
				e.renderByPixels && (s |= 0), !this.__isMovementLocked() && Math.abs(s - n[t]) < .1 && (s -= o / Math.abs(o || 1)), Math.abs(s) < Math.abs(n[t]) && this.__readonly("overscrollBack", !0), (s * n[t] < 0 || Math.abs(s) <= 1) && (s = 0, this.__readonly("overscrollBack", !1)), n[t] = s
			}
		}

		function a(t) {
			var e = this.__touchRecord,
				i = this.overscrollRendered;
			return i.x !== t.x || i.y !== t.y || !(!d.GLOBAL_ENV.TOUCH_SUPPORTED || !e.updatedRecently())
		}

		function r() {
			var e = this,
				t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
			if (t.length && this.options.overscrollEffect) {
				var i = this.options,
					n = this.overscrollRendered,
					r = c({}, n);
				if (t.forEach(function (t) {
						return o.call(e, t)
					}), a.call(this, r)) switch (i.overscrollEffect) {
					case "bounce":
						return h.overscrollBounce.call(this, n.x, n.y);
					case "glow":
						return h.overscrollGlow.call(this, n.x, n.y);
					default:
						return
				}
			}
		}
		var s = i(125),
			l = n(s),
			c = l.default || function (t) {
				for (var e = 1; e < arguments.length; e++) {
					var i = arguments[e];
					for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n])
				}
				return t
			},
			u = i(78),
			h = i(150),
			d = i(89),
			f = i(112);
		Object.defineProperty(u.SmoothScrollbar.prototype, "__renderOverscroll", {
			value: r,
			writable: !0,
			configurable: !0
		})
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}
		var r = i(86),
			o = n(r),
			a = i(90),
			s = n(a);
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		var l = i(151);
		(0, s.default)(l).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return l[t]
				}
			})
		})
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}
		var r = i(86),
			o = n(r),
			a = i(90),
			s = n(a);
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		var l = i(152);
		(0, s.default)(l).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return l[t]
				}
			})
		});
		var c = i(153);
		(0, s.default)(c).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return c[t]
				}
			})
		})
	}, function (t, e, i) {
		"use strict";

		function n(t, e) {
			var i = this.size,
				n = this.offset,
				r = this.targets,
				o = this.thumbOffset,
				a = r.xAxis,
				s = r.yAxis,
				l = r.content;
			if ((0, h.setStyle)(l, {
					"-transform": "translate3d(" + -(n.x + t) + "px, " + -(n.y + e) + "px, 0)"
				}), t) {
				var c = i.container.width / (i.container.width + Math.abs(t));
				(0, h.setStyle)(a.thumb, {
					"-transform": "translate3d(" + o.x + "px, 0, 0) scale3d(" + c + ", 1, 1)",
					"-transform-origin": t < 0 ? "left" : "right"
				})
			}
			if (e) {
				var u = i.container.height / (i.container.height + Math.abs(e));
				(0, h.setStyle)(s.thumb, {
					"-transform": "translate3d(0, " + o.y + "px, 0) scale3d(1, " + u + ", 1)",
					"-transform-origin": e < 0 ? "top" : "bottom"
				})
			}
		}
		Object.defineProperty(e, "__esModule", {
			value: !0
		}), e.overscrollBounce = n;
		var h = i(112)
	}, function (t, e, i) {
		"use strict";

		function n(t, e) {
			var i = this.size,
				n = this.targets,
				r = this.options,
				o = n.canvas,
				a = o.elem,
				s = o.context;
			return t || e ? ((0, f.setStyle)(a, {
				display: "block"
			}), s.clearRect(0, 0, i.content.width, i.container.height), s.fillStyle = r.overscrollEffectColor, l.call(this, t), void c.call(this, e)) : (0, f.setStyle)(a, {
				display: "none"
			})
		}

		function l(t) {
			var e = this.size,
				i = this.targets,
				n = this.__touchRecord,
				r = this.MAX_OVERSCROLL,
				o = e.container,
				a = o.width,
				s = o.height,
				l = i.canvas.context;
			l.save(), t > 0 && l.transform(-1, 0, 0, 1, a, 0);
			var c = (0, f.pickInRange)(Math.abs(t) / r, 0, p),
				u = (0, f.pickInRange)(c, 0, m) * a,
				h = Math.abs(t),
				d = n.getLastPosition("y") || s / 2;
			l.globalAlpha = c, l.beginPath(), l.moveTo(0, -u), l.quadraticCurveTo(h, d, 0, s + u), l.fill(), l.closePath(), l.restore()
		}

		function c(t) {
			var e = this.size,
				i = this.targets,
				n = this.__touchRecord,
				r = this.MAX_OVERSCROLL,
				o = e.container,
				a = o.width,
				s = o.height,
				l = i.canvas.context;
			l.save(), t > 0 && l.transform(1, 0, 0, -1, 0, s);
			var c = (0, f.pickInRange)(Math.abs(t) / r, 0, p),
				u = (0, f.pickInRange)(c, 0, m) * a,
				h = n.getLastPosition("x") || a / 2,
				d = Math.abs(t);
			l.globalAlpha = c, l.beginPath(), l.moveTo(-u, 0), l.quadraticCurveTo(h, d, a + u, 0), l.fill(), l.closePath(), l.restore()
		}
		Object.defineProperty(e, "__esModule", {
			value: !0
		}), e.overscrollGlow = n;
		var f = i(112),
			p = .75,
			m = .25
	}, function (t, e, i) {
		"use strict";

		function h(t) {
			var e = this.options,
				i = this.offset,
				n = this.movement,
				r = this.__touchRecord,
				o = e.damping,
				a = e.renderByPixels,
				s = e.overscrollDamping,
				l = i[t],
				c = n[t],
				u = o;
			if (this.__willOverscroll(t, c) ? u = s : r.isActive() && (u = .5), Math.abs(c) < 1) {
				var h = l + c;
				return {
					movement: 0,
					position: c > 0 ? Math.ceil(h) : Math.floor(h)
				}
			}
			var d = c * (1 - u);
			return a && (d |= 0), {
				movement: d,
				position: l + c - d
			}
		}

		function d() {
			var t = this.options,
				e = this.offset,
				i = this.limit,
				n = this.movement,
				r = this.overscrollRendered,
				o = this.__timerID;
			if (n.x || n.y || r.x || r.y) {
				var a = h.call(this, "x"),
					s = h.call(this, "y"),
					l = [];
				if (t.overscrollEffect) {
					var c = (0, f.pickInRange)(a.position, 0, i.x),
						u = (0, f.pickInRange)(s.position, 0, i.y);
					(r.x || c === e.x && n.x) && l.push("x"), (r.y || u === e.y && n.y) && l.push("y")
				}
				this.movementLocked.x || (n.x = a.movement), this.movementLocked.y || (n.y = s.movement), this.setPosition(a.position, s.position), this.__renderOverscroll(l)
			}
			o.render = requestAnimationFrame(d.bind(this))
		}
		var n = i(78),
			f = i(112);
		Object.defineProperty(n.SmoothScrollbar.prototype, "__render", {
			value: d,
			writable: !0,
			configurable: !0
		})
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}

		function a(t) {
			if (Array.isArray(t)) {
				for (var e = 0, i = Array(t.length); e < t.length; e++) i[e] = t[e];
				return i
			}
			return (0, s.default)(t)
		}

		function r() {
			var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
				e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
				i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
				n = this.options,
				r = this.movement;
			this.__updateThrottle();
			var o = this.__getDeltaLimit(i);
			n.renderByPixels && (t = Math.round(t), e = Math.round(e)), r.x = l.pickInRange.apply(void 0, [t].concat(a(o.x))), r.y = l.pickInRange.apply(void 0, [e].concat(a(o.y)))
		}
		var o = i(2),
			s = n(o),
			l = i(112),
			c = i(78);
		Object.defineProperty(c.SmoothScrollbar.prototype, "__setMovement", {
			value: r,
			writable: !0,
			configurable: !0
		})
	}, function (t, e, i) {
		"use strict";

		function n() {
			var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
				e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
				i = this.options,
				n = this.offset,
				r = this.limit;
			if (!i.continuousScrolling) return !1;
			var o = (0, l.pickInRange)(t + n.x, 0, r.x),
				a = (0, l.pickInRange)(e + n.y, 0, r.y),
				s = !0;
			return s &= o === n.x, s &= a === n.y, s &= o === r.x || 0 === o || a === r.y || 0 === a
		}
		var r = i(78),
			l = i(112);
		Object.defineProperty(r.SmoothScrollbar.prototype, "__shouldPropagateMovement", {
			value: n,
			writable: !0,
			configurable: !0
		})
	}, function (t, e, i) {
		"use strict";

		function n() {
			var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
				e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
			if (!t) return !1;
			var i = this.offset,
				n = this.limit,
				r = i[t];
			return (0, o.pickInRange)(e + r, 0, n[t]) === r && (0 === r || r === n[t])
		}
		var r = i(78),
			o = i(112);
		Object.defineProperty(r.SmoothScrollbar.prototype, "__willOverscroll", {
			value: n,
			writable: !0,
			configurable: !0
		})
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}
		var r = i(86),
			o = n(r),
			a = i(90),
			s = n(a);
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		var l = i(159);
		(0, s.default)(l).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return l[t]
				}
			})
		})
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}
		var r = i(86),
			o = n(r),
			a = i(90),
			s = n(a);
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		var l = i(160);
		(0, s.default)(l).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return l[t]
				}
			})
		});
		var c = i(161);
		(0, s.default)(c).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return c[t]
				}
			})
		});
		var u = i(168);
		(0, s.default)(u).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return u[t]
				}
			})
		});
		var h = i(169);
		(0, s.default)(h).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return h[t]
				}
			})
		});
		var d = i(170);
		(0, s.default)(d).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return d[t]
				}
			})
		});
		var f = i(171);
		(0, s.default)(f).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return f[t]
				}
			})
		});
		var p = i(172);
		(0, s.default)(p).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return p[t]
				}
			})
		})
	}, function (t, e, i) {
		"use strict";

		function n() {
			var o = this,
				t = this.targets,
				e = t.container,
				i = t.content,
				n = !1,
				a = void 0,
				r = void 0;
			Object.defineProperty(this, "__isDrag", {
				get: function () {
					return n
				},
				enumerable: !1
			});
			var s = function t(e) {
				var i = e.x,
					n = e.y;
				if (i || n) {
					var r = o.options.speed;
					o.__setMovement(i * r, n * r), a = requestAnimationFrame(function () {
						t({
							x: i,
							y: n
						})
					})
				}
			};
			this.__addEvent(e, "dragstart", function (t) {
				o.__eventFromChildScrollbar(t) || (n = !0, r = t.target.clientHeight, (0, l.setStyle)(i, {
					"pointer-events": "auto"
				}), cancelAnimationFrame(a), o.__updateBounding())
			}), this.__addEvent(document, "dragover mousemove touchmove", function (t) {
				if (n && !o.__eventFromChildScrollbar(t)) {
					cancelAnimationFrame(a), t.preventDefault();
					var e = o.__getPointerTrend(t, r);
					s(e)
				}
			}), this.__addEvent(document, "dragend mouseup touchend blur", function () {
				cancelAnimationFrame(a), n = !1
			})
		}
		var r = i(78),
			l = i(112);
		Object.defineProperty(r.SmoothScrollbar.prototype, "__dragHandler", {
			value: n,
			writable: !0,
			configurable: !0
		})
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}

		function r() {
			var c = this,
				t = this.targets,
				u = function (t) {
					var e = c.size,
						i = c.offset,
						n = c.limit,
						r = c.movement;
					switch (t) {
						case f.SPACE:
							return [0, 200];
						case f.PAGE_UP:
							return [0, -e.container.height + 40];
						case f.PAGE_DOWN:
							return [0, e.container.height - 40];
						case f.END:
							return [0, Math.abs(r.y) + n.y - i.y];
						case f.HOME:
							return [0, -Math.abs(r.y) - i.y];
						case f.LEFT:
							return [-40, 0];
						case f.UP:
							return [0, -40];
						case f.RIGHT:
							return [40, 0];
						case f.DOWN:
							return [0, 40];
						default:
							return null
					}
				},
				h = t.container;
			this.__addEvent(h, "keydown", function (t) {
				if (document.activeElement === h) {
					var e = c.options,
						i = c.parents,
						n = c.movementLocked,
						r = u(t.keyCode || t.which);
					if (r) {
						var o = d(r, 2),
							a = o[0],
							s = o[1];
						if (c.__shouldPropagateMovement(a, s)) return h.blur(), i.length && i[0].focus(), c.__updateThrottle();
						t.preventDefault(), c.__unlockMovement(), a && c.__willOverscroll("x", a) && (n.x = !0), s && c.__willOverscroll("y", s) && (n.y = !0);
						var l = e.speed;
						c.__addMovement(a * l, s * l)
					}
				}
			}), this.__addEvent(h, "keyup", function () {
				c.__unlockMovement()
			})
		}
		var o = i(162),
			a = n(o),
			s = i(165),
			l = n(s),
			d = function () {
				function i(t, e) {
					var i = [],
						n = !0,
						r = !1,
						o = void 0;
					try {
						for (var a, s = (0, l.default)(t); !(n = (a = s.next()).done) && (i.push(a.value), !e || i.length !== e); n = !0);
					} catch (t) {
						r = !0, o = t
					} finally {
						try {
							!n && s.return && s.return()
						} finally {
							if (r) throw o
						}
					}
					return i
				}
				return function (t, e) {
					if (Array.isArray(t)) return t;
					if ((0, a.default)(Object(t))) return i(t, e);
					throw new TypeError("Invalid attempt to destructure non-iterable instance")
				}
			}(),
			c = i(78),
			f = {
				SPACE: 32,
				PAGE_UP: 33,
				PAGE_DOWN: 34,
				END: 35,
				HOME: 36,
				LEFT: 37,
				UP: 38,
				RIGHT: 39,
				DOWN: 40
			};
		Object.defineProperty(c.SmoothScrollbar.prototype, "__keyboardHandler", {
			value: r,
			writable: !0,
			configurable: !0
		})
	}, function (t, e, i) {
		t.exports = {
			default: i(163),
			__esModule: !0
		}
	}, function (t, e, i) {
		i(57), i(4), t.exports = i(164)
	}, function (t, e, i) {
		var n = i(53),
			r = i(45)("iterator"),
			o = i(27);
		t.exports = i(12).isIterable = function (t) {
			var e = Object(t);
			return void 0 !== e[r] || "@@iterator" in e || o.hasOwnProperty(n(e))
		}
	}, function (t, e, i) {
		t.exports = {
			default: i(166),
			__esModule: !0
		}
	}, function (t, e, i) {
		i(57), i(4), t.exports = i(167)
	}, function (t, e, i) {
		var n = i(17),
			r = i(52);
		t.exports = i(12).getIterator = function (t) {
			var e = r(t);
			if ("function" != typeof e) throw TypeError(t + " is not iterable!");
			return n(e.call(t))
		}
	}, function (t, e, i) {
		"use strict";

		function n() {
			var c = this,
				t = this.targets,
				e = t.container,
				u = t.xAxis,
				h = t.yAxis,
				d = function (t, e) {
					var i = c.size,
						n = c.thumbSize;
					if ("x" === t) {
						var r = i.container.width - (n.x - n.realX);
						return e / r * i.content.width
					}
					if ("y" === t) {
						var o = i.container.height - (n.y - n.realY);
						return e / o * i.content.height
					}
					return 0
				},
				f = function (t) {
					return (0, m.isOneOf)(t, [u.track, u.thumb]) ? "x" : (0, m.isOneOf)(t, [h.track, h.thumb]) ? "y" : void 0
				},
				o = void 0,
				p = void 0,
				a = void 0,
				s = void 0,
				l = void 0;
			this.__addEvent(e, "click", function (t) {
				if (!p && (0, m.isOneOf)(t.target, [u.track, h.track])) {
					var e = t.target,
						i = f(e),
						n = e.getBoundingClientRect(),
						r = (0, m.getPosition)(t),
						o = c.offset,
						a = c.thumbSize;
					if ("x" === i) {
						var s = r.x - n.left - a.x / 2;
						c.__setMovement(d(i, s) - o.x, 0)
					} else {
						var l = r.y - n.top - a.y / 2;
						c.__setMovement(0, d(i, l) - o.y)
					}
				}
			}), this.__addEvent(e, "mousedown", function (t) {
				if ((0, m.isOneOf)(t.target, [u.thumb, h.thumb])) {
					o = !0;
					var e = (0, m.getPosition)(t),
						i = t.target.getBoundingClientRect();
					s = f(t.target), a = {
						x: e.x - i.left,
						y: e.y - i.top
					}, l = c.targets.container.getBoundingClientRect()
				}
			}), this.__addEvent(window, "mousemove", function (t) {
				if (o) {
					t.preventDefault(), p = !0;
					var e = c.offset,
						i = (0, m.getPosition)(t);
					if ("x" === s) {
						var n = i.x - a.x - l.left;
						c.setPosition(d(s, n), e.y)
					}
					if ("y" === s) {
						var r = i.y - a.y - l.top;
						c.setPosition(e.x, d(s, r))
					}
				}
			}), this.__addEvent(window, "mouseup blur", function () {
				o = p = !1
			})
		}
		var r = i(78),
			m = i(112);
		Object.defineProperty(r.SmoothScrollbar.prototype, "__mouseHandler", {
			value: n,
			writable: !0,
			configurable: !0
		})
	}, function (t, e, i) {
		"use strict";

		function n() {
			this.__addEvent(window, "resize", this.__updateThrottle)
		}
		var r = i(78);
		Object.defineProperty(r.SmoothScrollbar.prototype, "__resizeHandler", {
			value: n,
			writable: !0,
			configurable: !0
		})
	}, function (t, e, i) {
		"use strict";

		function n() {
			var o = this,
				i = !1,
				a = void 0,
				t = this.targets,
				e = t.container,
				n = t.content,
				r = function t(e) {
					var i = e.x,
						n = e.y;
					if (i || n) {
						var r = o.options.speed;
						o.__setMovement(i * r, n * r), a = requestAnimationFrame(function () {
							t({
								x: i,
								y: n
							})
						})
					}
				},
				s = function () {
					var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
					(0, l.setStyle)(e, {
						"-user-select": t
					})
				};
			this.__addEvent(window, "mousemove", function (t) {
				if (i) {
					cancelAnimationFrame(a);
					var e = o.__getPointerTrend(t);
					r(e)
				}
			}), this.__addEvent(n, "selectstart", function (t) {
				return o.__eventFromChildScrollbar(t) ? s("none") : (cancelAnimationFrame(a), o.__updateBounding(), void(i = !0))
			}), this.__addEvent(window, "mouseup blur", function () {
				cancelAnimationFrame(a), s(), i = !1
			}), this.__addEvent(e, "scroll", function (t) {
				t.preventDefault(), e.scrollTop = e.scrollLeft = 0
			})
		}
		var r = i(78),
			l = i(112);
		Object.defineProperty(r.SmoothScrollbar.prototype, "__selectHandler", {
			value: n,
			writable: !0,
			configurable: !0
		})
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}

		function r() {
			var c = this,
				t = this.targets,
				u = this.__touchRecord,
				e = t.container;
			this.__addEvent(e, "touchstart", function (t) {
				if (!c.__isDrag) {
					var e = c.__timerID,
						i = c.movement;
					cancelAnimationFrame(e.scrollTo), c.__willOverscroll("x") || (i.x = 0), c.__willOverscroll("y") || (i.y = 0), u.track(t), c.__autoLockMovement()
				}
			}), this.__addEvent(e, "touchmove", function (t) {
				if (!(c.__isDrag || f && f !== c)) {
					u.update(t);
					var e = u.getDelta(),
						i = e.x,
						n = e.y;
					if (c.__shouldPropagateMovement(i, n)) return c.__updateThrottle();
					var r = c.movement,
						o = c.MAX_OVERSCROLL,
						a = c.options;
					if (r.x && c.__willOverscroll("x", i)) {
						var s = 2;
						"bounce" === a.overscrollEffect && (s += Math.abs(10 * r.x / o)), Math.abs(r.x) >= o ? i = 0 : i /= s
					}
					if (r.y && c.__willOverscroll("y", n)) {
						var l = 2;
						"bounce" === a.overscrollEffect && (l += Math.abs(10 * r.y / o)), Math.abs(r.y) >= o ? n = 0 : n /= l
					}
					c.__autoLockMovement(), t.preventDefault(), c.__addMovement(i, n, !0), f = c
				}
			}), this.__addEvent(e, "touchcancel touchend", function (t) {
				if (!c.__isDrag) {
					var i = c.options.speed,
						n = u.getVelocity(),
						r = {};
					(0, a.default)(n).forEach(function (t) {
						var e = (0, h.pickInRange)(n[t] * l.GLOBAL_ENV.EASING_MULTIPLIER, -1e3, 1e3);
						r[t] = Math.abs(e) > d ? e * i : 0
					}), c.__addMovement(r.x, r.y, !0), c.__unlockMovement(), u.release(t), f = null
				}
			})
		}
		var o = i(90),
			a = n(o),
			s = i(78),
			l = i(89),
			h = i(112),
			d = 100,
			f = null;
		Object.defineProperty(s.SmoothScrollbar.prototype, "__touchHandler", {
			value: r,
			writable: !0,
			configurable: !0
		})
	}, function (t, e, i) {
		"use strict";

		function n() {
			var o = this,
				t = this.targets.container,
				a = !1,
				s = (0, l.debounce)(function () {
					a = !1
				}, 30, !1);
			this.__addEvent(t, c.GLOBAL_ENV.WHEEL_EVENT, function (t) {
				var e = o.options,
					i = (0, l.getDelta)(t),
					n = i.x,
					r = i.y;
				return n *= e.speed, r *= e.speed, o.__shouldPropagateMovement(n, r) ? o.__updateThrottle() : (t.preventDefault(), s(), o.overscrollBack && (a = !0), a && (o.__willOverscroll("x", n) && (n = 0), o.__willOverscroll("y", r) && (r = 0)), void o.__addMovement(n, r, !0))
			})
		}
		var r = i(78),
			l = i(112),
			c = i(89);
		Object.defineProperty(r.SmoothScrollbar.prototype, "__wheelHandler", {
			value: n,
			writable: !0,
			configurable: !0
		})
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}
		var r = i(86),
			o = n(r),
			a = i(90),
			s = n(a);
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		var l = i(174);
		(0, s.default)(l).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return l[t]
				}
			})
		})
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}
		var r = i(86),
			o = n(r),
			a = i(90),
			s = n(a);
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		var l = i(175);
		(0, s.default)(l).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return l[t]
				}
			})
		});
		var c = i(176);
		(0, s.default)(c).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return c[t]
				}
			})
		});
		var u = i(177);
		(0, s.default)(u).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return u[t]
				}
			})
		});
		var h = i(178);
		(0, s.default)(h).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return h[t]
				}
			})
		});
		var d = i(179);
		(0, s.default)(d).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return d[t]
				}
			})
		});
		var f = i(182);
		(0, s.default)(f).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return f[t]
				}
			})
		});
		var p = i(183);
		(0, s.default)(p).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return p[t]
				}
			})
		});
		var m = i(184);
		(0, s.default)(m).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return m[t]
				}
			})
		});
		var g = i(185);
		(0, s.default)(g).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return g[t]
				}
			})
		});
		var v = i(186);
		(0, s.default)(v).forEach(function (t) {
			"default" !== t && "__esModule" !== t && (0, o.default)(e, t, {
				enumerable: !0,
				get: function () {
					return v[t]
				}
			})
		})
	}, function (t, e, i) {
		"use strict";

		function n(e, t, r) {
			var i = this;
			if (!e || "function" != typeof e.addEventListener) throw new TypeError("expect elem to be a DOM element, but got " + e);
			var n = function (t) {
				for (var e = arguments.length, i = Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++) i[n - 1] = arguments[n];
				!t.type.match(/drag/) && t.defaultPrevented || r.apply(void 0, [t].concat(i))
			};
			t.split(/\s+/g).forEach(function (t) {
				i.__handlers.push({
					evt: t,
					elem: e,
					fn: n,
					hasRegistered: !0
				}), e.addEventListener(t, n)
			})
		}
		var r = i(78);
		Object.defineProperty(r.SmoothScrollbar.prototype, "__addEvent", {
			value: n,
			writable: !0,
			configurable: !0
		})
	}, function (t, e, i) {
		"use strict";

		function n() {
			var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
				e = t.target;
			return this.children.some(function (t) {
				return t.contains(e)
			})
		}
		var r = i(78);
		Object.defineProperty(r.SmoothScrollbar.prototype, "__eventFromChildScrollbar", {
			value: n,
			writable: !0,
			configurable: !0
		})
	}, function (t, e, i) {
		"use strict";

		function n() {
			var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
				e = this.options,
				i = this.offset,
				n = this.limit;
			return t && (e.continuousScrolling || e.overscrollEffect) ? {
				x: [-(1 / 0), 1 / 0],
				y: [-(1 / 0), 1 / 0]
			} : {
				x: [-i.x, n.x - i.x],
				y: [-i.y, n.y - i.y]
			}
		}
		var r = i(78);
		Object.defineProperty(r.SmoothScrollbar.prototype, "__getDeltaLimit", {
			value: n,
			writable: !0,
			configurable: !0
		})
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
				i = this.bounding,
				n = i.top,
				r = i.right,
				o = i.bottom,
				a = i.left,
				s = (0, h.getPosition)(t),
				l = s.x,
				c = s.y,
				u = {
					x: 0,
					y: 0
				};
			return 0 === l && 0 === c ? u : (l > r - e ? u.x = l - r + e : l < a + e && (u.x = l - a - e), c > o - e ? u.y = c - o + e : c < n + e && (u.y = c - n - e), u)
		}
		var r = i(78),
			h = i(112);
		Object.defineProperty(r.SmoothScrollbar.prototype, "__getPointerTrend", {
			value: n,
			writable: !0,
			configurable: !0
		})
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}

		function a(t) {
			if (Array.isArray(t)) {
				for (var e = 0, i = Array(t.length); e < t.length; e++) i[e] = t[e];
				return i
			}
			return (0, f.default)(t)
		}

		function r(t) {
			var i = this,
				n = {
					speed: 1,
					damping: .1,
					thumbMinSize: 20,
					syncCallbacks: !1,
					renderByPixels: !0,
					alwaysShowTracks: !1,
					continuousScrolling: "auto",
					overscrollEffect: !1,
					overscrollEffectColor: "#87ceeb",
					overscrollDamping: .2
				},
				r = {
					damping: [0, 1],
					speed: [0, 1 / 0],
					thumbMinSize: [0, 1 / 0],
					overscrollEffect: [!1, "bounce", "glow"],
					overscrollDamping: [0, 1]
				},
				e = function () {
					var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "auto";
					if (n.overscrollEffect !== !1) return !1;
					switch (t) {
						case "auto":
							return i.isNestedScrollbar;
						default:
							return !!t
					}
				},
				o = {set ignoreEvents(t) {
						console.warn("`options.ignoreEvents` parameter is deprecated, use `instance#unregisterEvents()` method instead. https://github.com/idiotWu/smooth-scrollbar/wiki/Instance-Methods#instanceunregisterevents-regex--regex-regex--")
					},
					set friction(t) {
						console.warn("`options.friction=" + t + "` is deprecated, use `options.damping=" + t / 100 + "` instead."), this.damping = t / 100
					},
					get syncCallbacks() {
						return n.syncCallbacks
					},
					set syncCallbacks(t) {
						n.syncCallbacks = !!t
					},
					get renderByPixels() {
						return n.renderByPixels
					},
					set renderByPixels(t) {
						n.renderByPixels = !!t
					},
					get alwaysShowTracks() {
						return n.alwaysShowTracks
					},
					set alwaysShowTracks(t) {
						t = !!t, n.alwaysShowTracks = t;
						var e = i.targets.container;
						t ? (i.showTrack(), e.classList.add("sticky")) : (i.hideTrack(), e.classList.remove("sticky"))
					},
					get continuousScrolling() {
						return e(n.continuousScrolling)
					},
					set continuousScrolling(t) {
						"auto" === t ? n.continuousScrolling = t : n.continuousScrolling = !!t
					},
					get overscrollEffect() {
						return n.overscrollEffect
					},
					set overscrollEffect(t) {
						t && !~r.overscrollEffect.indexOf(t) && (console.warn("`overscrollEffect` should be one of " + (0, h.default)(r.overscrollEffect) + ", but got " + (0, h.default)(t) + ". It will be set to `false` now."), t = !1), n.overscrollEffect = t
					},
					get overscrollEffectColor() {
						return n.overscrollEffectColor
					},
					set overscrollEffectColor(t) {
						n.overscrollEffectColor = t
					}
				};
			(0, c.default)(n).filter(function (t) {
				return !o.hasOwnProperty(t)
			}).forEach(function (e) {
				(0, s.default)(o, e, {
					enumerable: !0,
					get: function () {
						return n[e]
					},
					set: function (t) {
						if (isNaN(parseFloat(t))) throw new TypeError("expect `options." + e + "` to be a number, but got " + ("undefined" == typeof t ? "undefined" : y(t)));
						n[e] = x.pickInRange.apply(void 0, [t].concat(a(r[e])))
					}
				})
			}), this.__readonly("options", o), this.setOptions(t)
		}
		var o = i(86),
			s = n(o),
			l = i(90),
			c = n(l),
			u = i(180),
			h = n(u),
			d = i(2),
			f = n(d),
			p = i(55),
			m = n(p),
			g = i(62),
			v = n(g),
			y = "function" == typeof v.default && "symbol" == typeof m.default ? function (t) {
				return typeof t
			} : function (t) {
				return t && "function" == typeof v.default && t.constructor === v.default && t !== v.default.prototype ? "symbol" : typeof t
			},
			x = i(112),
			_ = i(78);
		Object.defineProperty(_.SmoothScrollbar.prototype, "__initOptions", {
			value: r,
			writable: !0,
			configurable: !0
		})
	}, function (t, e, i) {
		t.exports = {
			default: i(181),
			__esModule: !0
		}
	}, function (t, e, i) {
		var n = i(12),
			r = n.JSON || (n.JSON = {
				stringify: JSON.stringify
			});
		t.exports = function (t) {
			return r.stringify.apply(r, arguments)
		}
	}, function (t, e, i) {
		"use strict";

		function n() {
			this.update(), this.__keyboardHandler(), this.__resizeHandler(), this.__selectHandler(), this.__mouseHandler(), this.__touchHandler(), this.__wheelHandler(), this.__dragHandler(), this.__render()
		}
		var r = i(78);
		Object.defineProperty(r.SmoothScrollbar.prototype, "__initScrollbar", {
			value: n,
			writable: !0,
			configurable: !0
		})
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}

		function r(t, e) {
			return (0, a.default)(this, t, {
				value: e,
				enumerable: !0,
				configurable: !0
			})
		}
		var o = i(86),
			a = n(o),
			s = i(78);
		Object.defineProperty(s.SmoothScrollbar.prototype, "__readonly", {
			value: r,
			writable: !0,
			configurable: !0
		})
	}, function (t, e, i) {
		"use strict";

		function n() {
			var t = this.targets,
				e = this.size,
				i = this.offset,
				n = this.thumbOffset,
				r = this.thumbSize;
			n.x = i.x / e.content.width * (e.container.width - (r.x - r.realX)), n.y = i.y / e.content.height * (e.container.height - (r.y - r.realY)), (0, o.setStyle)(t.xAxis.thumb, {
				"-transform": "translate3d(" + n.x + "px, 0, 0)"
			}), (0, o.setStyle)(t.yAxis.thumb, {
				"-transform": "translate3d(0, " + n.y + "px, 0)"
			})
		}
		var o = i(112),
			r = i(78);
		Object.defineProperty(r.SmoothScrollbar.prototype, "__setThumbPosition", {
			value: n,
			writable: !0,
			configurable: !0
		})
	}, function (t, e, i) {
		"use strict";

		function n() {
			var t = this.targets.container,
				e = t.getBoundingClientRect(),
				i = e.top,
				n = e.right,
				r = e.bottom,
				o = e.left,
				a = window,
				s = a.innerHeight,
				l = a.innerWidth;
			this.__readonly("bounding", {
				top: Math.max(i, 0),
				right: Math.min(n, l),
				bottom: Math.min(r, s),
				left: Math.max(o, 0)
			})
		}
		var r = i(78);
		Object.defineProperty(r.SmoothScrollbar.prototype, "__updateBounding", {
			value: n,
			writable: !0,
			configurable: !0
		})
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}

		function o(t) {
			if (Array.isArray(t)) {
				for (var e = 0, i = Array(t.length); e < t.length; e++) i[e] = t[e];
				return i
			}
			return (0, s.default)(t)
		}

		function r() {
			var t = this.targets,
				e = t.container,
				i = t.content;
			this.__readonly("children", [].concat(o(i.querySelectorAll(c.selectors)))), this.__readonly("isNestedScrollbar", !1);
			for (var n = [], r = e; r = r.parentElement;) c.sbList.has(r) && (this.__readonly("isNestedScrollbar", !0), n.push(r));
			this.__readonly("parents", n)
		}
		var a = i(2),
			s = n(a),
			l = i(78),
			c = i(89);
		Object.defineProperty(l.SmoothScrollbar.prototype, "__updateTree", {
			value: r,
			writable: !0,
			configurable: !0
		})
	}, function (t, e) {}])
});
var outdatedBrowser = function (t) {
	function e(t) {
		s.style.opacity = t / 100, s.style.filter = "alpha(opacity=" + t + ")"
	}

	function i(t) {
		e(t), 1 == t && (s.style.display = "block"), 100 == t && (l = !0)
	}

	function n() {
		var t = document.getElementById("btnCloseUpdateBrowser"),
			e = document.getElementById("btnUpdateBrowser");
		s.style.backgroundColor = bkgColor, s.style.color = txtColor, s.children[0].style.color = txtColor, s.children[1].style.color = txtColor, e.style.color = txtColor, e.style.borderColor && (e.style.borderColor = txtColor), t.style.color = txtColor, t.onmousedown = function () {
			return s.style.display = "none", !1
		}, e.onmouseover = function () {
			this.style.color = bkgColor, this.style.backgroundColor = txtColor
		}, e.onmouseout = function () {
			this.style.color = txtColor, this.style.backgroundColor = bkgColor
		}
	}

	function r() {
		var e = !1;
		if (window.XMLHttpRequest) e = new XMLHttpRequest;
		else if (window.ActiveXObject) try {
			e = new ActiveXObject("Msxml2.XMLHTTP")
		} catch (t) {
			try {
				e = new ActiveXObject("Microsoft.XMLHTTP")
			} catch (t) {
				e = !1
			}
		}
		return e
	}

	function o(t) {
		var e = r();
		return e && (e.onreadystatechange = function () {
			a(e)
		}, e.open("GET", t, !0), e.send(null)), !1
	}

	function a(t) {
		var e = document.getElementById("outdated");
		return 4 == t.readyState && (e.innerHTML = 200 == t.status || 304 == t.status ? t.responseText : h, n()), !1
	}
	var s = document.getElementById("outdated");
	this.defaultOpts = {
		bgColor: "#f25648",
		color: "#ffffff",
		lowerThan: "transform",
		languagePath: "../outdatedbrowser/lang/en.html"
	}, t ? ("IE8" == t.lowerThan || "borderSpacing" == t.lowerThan ? t.lowerThan = "borderSpacing" : "IE9" == t.lowerThan || "boxShadow" == t.lowerThan ? t.lowerThan = "boxShadow" : "IE10" == t.lowerThan || "transform" == t.lowerThan || "" == t.lowerThan || "undefined" == typeof t.lowerThan ? t.lowerThan = "transform" : ("IE11" == t.lowerThan || "borderImage" == t.lowerThan) && (t.lowerThan = "borderImage"), this.defaultOpts.bgColor = t.bgColor, this.defaultOpts.color = t.color, this.defaultOpts.lowerThan = t.lowerThan, this.defaultOpts.languagePath = t.languagePath, bkgColor = this.defaultOpts.bgColor, txtColor = this.defaultOpts.color, cssProp = this.defaultOpts.lowerThan, languagePath = this.defaultOpts.languagePath) : (bkgColor = this.defaultOpts.bgColor, txtColor = this.defaultOpts.color, cssProp = this.defaultOpts.lowerThan, languagePath = this.defaultOpts.languagePath);
	var l = !0,
		c = function () {
			var e = document.createElement("div"),
				i = "Khtml Ms O Moz Webkit".split(" "),
				n = i.length;
			return function (t) {
				if (t in e.style) return !0;
				for (t = t.replace(/^[a-z]/, function (t) {
						return t.toUpperCase()
					}); n--;)
					if (i[n] + t in e.style) return !0;
				return !1
			}
		}();
	if (!c("" + cssProp)) {
		if (l && "1" !== s.style.opacity) {
			l = !1;
			for (var u = 1; 100 >= u; u++) setTimeout(function (t) {
				return function () {
					i(t)
				}
			}(u), 8 * u)
		}
		" " === languagePath || 0 == languagePath.length ? n() : o(languagePath);
		var h = '<h6>Your browser is out-of-date!</h6><p>Update your browser to view this website correctly. <a id="btnUpdateBrowser" href="http://outdatedbrowser.com/">Update my browser now </a></p><p class="last"><a href="#" id="btnCloseUpdateBrowser" title="Close">&times;</a></p>'
	}
};
! function (t, e) {
	"object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.IntersectionObserver = e() : t.IntersectionObserver = e()
}(this, function () {
	return function (i) {
		function n(t) {
			if (r[t]) return r[t].exports;
			var e = r[t] = {
				exports: {},
				id: t,
				loaded: !1
			};
			return i[t].call(e.exports, e, e.exports, n), e.loaded = !0, e.exports
		}
		var r = {};
		return n.m = i, n.c = r, n.p = "", n(0)
	}([function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		var r = i(1),
			o = n(r),
			a = void 0;
		a = "function" == typeof window.IntersectionObserver ? window.IntersectionObserver : o["default"], e["default"] = a, t.exports = e["default"]
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}

		function r(t, e) {
			if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
		}
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		var o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
				return typeof t
			} : function (t) {
				return t && "function" == typeof Symbol && t.constructor === Symbol ? "symbol" : typeof t
			},
			a = function () {
				function n(t, e) {
					for (var i = 0; i < e.length; i++) {
						var n = e[i];
						n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
					}
				}
				return function (t, e, i) {
					return e && n(t.prototype, e), i && n(t, i), t
				}
			}(),
			s = i(2),
			l = i(3),
			c = n(l),
			u = i(5),
			h = n(u),
			d = new c["default"],
			f = new s.WeakMap,
			p = function () {
				function n(t, e) {
					if (r(this, n), !arguments.length) throw new TypeError("1 argument required, but only 0 present.");
					var i = new h["default"](t, e, d, this);
					Object.defineProperties(this, {
						root: {
							value: i.root
						},
						thresholds: {
							value: i.thresholds
						},
						rootMargin: {
							value: i.rootMargin
						}
					}), f.set(this, i)
				}
				return a(n, null, [{
					key: "idleTimeout",
					get: function () {
						return d.idleTimeout
					},
					set: function (t) {
						if ("number" != typeof t) throw new TypeError('type of "idleTimeout" value must be a number.');
						if (("undefined" == typeof t ? "undefined" : o(t)) < 0) throw new TypeError('"idleTimeout" value must be greater than 0.');
						d.idleTimeout = t
					}
				}, {
					key: "trackHovers",
					get: function () {
						return d.isHoverEnabled()
					},
					set: function (t) {
						if ("boolean" != typeof t) throw new TypeError('type of "trackHovers" value must be a boolean.');
						t ? d.enableHover() : d.disableHover()
					}
				}]), n
			}();
		["observe", "unobserve", "disconnect", "takeRecords"].forEach(function (e) {
			p.prototype[e] = function () {
				var t;
				return (t = f.get(this))[e].apply(t, arguments)
			}
		}), e["default"] = p, t.exports = e["default"]
	}, function (t, e) {
		"use strict";

		function i(t, e) {
			if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
			return !e || "object" != typeof e && "function" != typeof e ? t : e
		}

		function n(t, e) {
			if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
			t.prototype = Object.create(e && e.prototype, {
				constructor: {
					value: t,
					enumerable: !1,
					writable: !0,
					configurable: !0
				}
			}), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e)
		}

		function r(t, e) {
			if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
		}
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		var o = function () {
				function n(t, e) {
					for (var i = 0; i < e.length; i++) {
						var n = e[i];
						n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
					}
				}
				return function (t, e, i) {
					return e && n(t.prototype, e), i && n(t, i), t
				}
			}(),
			a = "function" == typeof window.WeakMap && "function" == typeof window.Map,
			s = function () {
				function n(t, n) {
					var r = -1;
					return t.some(function (t, e) {
						var i = t[0] === n;
						return i && (r = e), i
					}), r
				}
				return a ? window.WeakMap : function () {
					function t() {
						r(this, t), this.__entries__ = []
					}
					return t.prototype.get = function (t) {
						var e = n(this.__entries__, t);
						return this.__entries__[e][1]
					}, t.prototype.set = function (t, e) {
						var i = n(this.__entries__, t);
						~i ? this.__entries__[i][1] = e : this.__entries__.push([t, e])
					}, t.prototype["delete"] = function (t) {
						var e = this.__entries__,
							i = n(e, t);
						~i && e.splice(i, 1)
					}, t.prototype.has = function (t) {
						return !!~n(this.__entries__, t)
					}, t
				}()
			}(),
			l = function () {
				return a ? window.Map : function (t) {
					function e() {
						return r(this, e), i(this, t.apply(this, arguments))
					}
					return n(e, t), e.prototype.clear = function () {
						this.__entries__.splice(0, this.__entries__.length)
					}, e.prototype.entries = function () {
						return this.__entries__.slice()
					}, e.prototype.keys = function () {
						return this.__entries__.map(function (t) {
							return t[0]
						})
					}, e.prototype.values = function () {
						return this.__entries__.map(function (t) {
							return t[1]
						})
					}, e.prototype.forEach = function (t) {
						for (var e = arguments.length <= 1 || void 0 === arguments[1] ? null : arguments[1], i = this.__entries__, n = Array.isArray(i), r = 0, i = n ? i : i[Symbol.iterator]();;) {
							var o;
							if (n) {
								if (r >= i.length) break;
								o = i[r++]
							} else {
								if (r = i.next(), r.done) break;
								o = r.value
							}
							var a = o;
							t.call(e, a[1], a[0])
						}
					}, o(e, [{
						key: "size",
						get: function () {
							return this.__entries__.length
						}
					}]), e
				}(s)
			}();
		e.Map = l, e.WeakMap = s
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}

		function r(t, e) {
			if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
		}

		function o(r) {
			var o = arguments.length <= 1 || void 0 === arguments[1] ? 0 : arguments[1],
				a = !1;
			return function () {
				for (var t = this, e = arguments.length, i = Array(e), n = 0; n < e; n++) i[n] = arguments[n];
				a !== !1 && clearTimeout(a), a = setTimeout(function () {
					a = !1, r.apply(t, i)
				}, o)
			}
		}
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		var a = function () {
				function n(t, e) {
					for (var i = 0; i < e.length; i++) {
						var n = e[i];
						n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
					}
				}
				return function (t, e, i) {
					return e && n(t.prototype, e), i && n(t, i), t
				}
			}(),
			s = i(4),
			l = n(s),
			c = "function" == typeof window.MutationObserver,
			u = function () {
				return window.requestAnimationFrame ? window.requestAnimationFrame : function (t) {
					return setTimeout(function () {
						return t((0, l["default"])())
					}, 1e3 / 60)
				}
			}(),
			h = function () {
				function i() {
					var t = arguments.length <= 0 || void 0 === arguments[0] ? 50 : arguments[0],
						e = !(arguments.length <= 1 || void 0 === arguments[1]) && arguments[1];
					r(this, i), this._idleTimeout = t, this._trackHovers = e, this._cycleStartTime = -1, this._isUpdateScheduled = !1, this._repeatCycle = !1, this._hoverInitiated = !1, this._mutationsObserver = null, this._isListening = !1, this._observers = [], this.startUpdateCycle = this.startUpdateCycle.bind(this), this.scheduleUpdate = this.scheduleUpdate.bind(this), this._onMutation = this._onMutation.bind(this), this._repeatHandler = o(this.scheduleUpdate, 200), this._onMouseOver = o(this.startUpdateCycle, 200)
				}
				return i.prototype.connect = function (t) {
					this.isConnected(t) || this._observers.push(t), this._isListening || this._initListeners()
				}, i.prototype.disconnect = function (t) {
					var e = this._observers,
						i = e.indexOf(t);
					~i && e.splice(i, 1), !e.length && this._isListening && this._removeListeners()
				}, i.prototype.isConnected = function (t) {
					return !!~this._observers.indexOf(t)
				}, i.prototype._updateObservers = function () {
					for (var t = !1, e = this._observers, i = Array.isArray(e), n = 0, e = i ? e : e[Symbol.iterator]();;) {
						var r;
						if (i) {
							if (n >= e.length) break;
							r = e[n++]
						} else {
							if (n = e.next(), n.done) break;
							r = n.value
						}
						var o = r;
						o.updateObservations() && (t = !0), o.hasEntries() && o.notifySubscriber()
					}
					return t
				}, i.prototype.startUpdateCycle = function () {
					this._cycleStartTime = (0, l["default"])(), this.scheduleUpdate()
				}, i.prototype.scheduleUpdate = function (t) {
					var e = "number" == typeof t;
					if (e) {
						var i = this._updateObservers();
						if (this._isUpdateScheduled = !1, !this._wasCycleStarted()) return;
						i ? this.startUpdateCycle() : this._hasIdleTimeEnded() ? this._onCycleEnded() : this.scheduleUpdate()
					} else this._isUpdateScheduled || (u(this.scheduleUpdate), this._isUpdateScheduled = !0)
				}, i.prototype._hasIdleTimeEnded = function () {
					return (0, l["default"])() - this._cycleStartTime > this._idleTimeout
				}, i.prototype._wasCycleStarted = function () {
					return this._cycleStartTime !== -1
				}, i.prototype._onCycleEnded = function () {
					this._cycleStartTime = -1, this._repeatCycle && (this._cycleStartTime = 0, this._repeatHandler())
				}, i.prototype._initListeners = function () {
					this._isListening || (this._isListening = !0, window.addEventListener("resize", this.startUpdateCycle, !0), window.addEventListener("scroll", this.scheduleUpdate, !0), this._trackHovers && this._addHoverListener(), c ? (this._mutationsObserver = new MutationObserver(this._onMutation), this._mutationsObserver.observe(document, {
						attributes: !0,
						childList: !0,
						characterData: !0,
						subtree: !0
					})) : (this._repeatCycle = !0, window.addEventListener("click", this.startUpdateCycle, !0), this.startUpdateCycle()))
				}, i.prototype._removeListeners = function () {
					this._isListening && (window.removeEventListener("resize", this.startUpdateCycle, !0), window.removeEventListener("scroll", this.scheduleUpdate, !0), this._removeHoverListener(), c ? this._mutationsObserver && (this._mutationsObserver.disconnect(), this._mutationsObserver = null) : (this._repeatCycle = !1, window.removeEventListener("click", this.startUpdateCycle, !0)), this._isListening = !1)
				}, i.prototype.enableHover = function () {
					this._trackHovers = !0, this._isListening && this._addHoverListener()
				}, i.prototype.disableHover = function () {
					this._trackHovers = !1, this._removeHoverListener()
				}, i.prototype.isHoverEnabled = function () {
					return this._trackHovers
				}, i.prototype._addHoverListener = function () {
					this._hoverInitiated || (window.addEventListener("mouseover", this._onMouseOver, !0), this._hoverInitiated = !0)
				}, i.prototype._removeHoverListener = function () {
					this._hoverInitiated && (window.removeEventListener("mouseover", this._onMouseOver, !0), this._hoverInitiated = !1)
				}, i.prototype._onMutation = function (t) {
					var e = t.every(function (t) {
						return "attributes" !== t.type
					});
					e ? this.scheduleUpdate() : this.startUpdateCycle()
				}, a(i, [{
					key: "idleTimeout",
					get: function () {
						return this._idleTimeout
					},
					set: function (t) {
						this._idleTimeout = t
					}
				}]), i
			}();
		e["default"] = h, t.exports = e["default"]
	}, function (t, e) {
		"use strict";
		Object.defineProperty(e, "__esModule", {
			value: !0
		}), e["default"] = function () {
			return window.performance && window.performance.now ? function () {
				return window.performance.now()
			} : function () {
				return Date.now()
			}
		}(), t.exports = e["default"]
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}

		function s(t, e) {
			if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
		}

		function l() {
			var t = arguments.length <= 0 || void 0 === arguments[0] ? 0 : arguments[0],
				e = t;
			return Array.isArray(t) ? t.length || (e = [0]) : e = [t], e.map(function (t) {
				if (t = Number(t), !window.isFinite(t)) throw new TypeError("The provided double value is non-finite.");
				if (t < 0 || t > 1) throw new RangeError("Threshold values must be between 0 and 1.");
				return t
			}).sort()
		}

		function c() {
			var t = arguments.length <= 0 || void 0 === arguments[0] ? "0px" : arguments[0];
			if (t = (t + "").split(/\s+/), t.length > 4) throw new Error("Extra text found at the end of rootMargin.");
			t[0] = t[0] || "0px", t[1] = t[1] || t[0], t[2] = t[2] || t[0], t[3] = t[3] || t[1];
			var e = t.join(" "),
				i = t.map(function (t) {
					var e = /^(-?\d*\.?\d+)(px|%)$/.exec(t) || [],
						i = e[1],
						n = e[2],
						r = "px" === n;
					if (i = parseFloat(i), !window.isFinite(i)) throw new Error("rootMargin must be specified in pixels or percent.");
					return r || (i /= 100), {
						value: i,
						pixels: r
					}
				});
			return {
				rawData: e,
				parsedData: i
			}
		}

		function r(n, t) {
			t = t.map(function (t, e) {
				var i = t.value;
				return t.pixels || (i *= e % 2 ? n.width : n.height), i
			});
			var e = {
				top: n.top - t[0],
				right: n.right + t[1],
				bottom: n.bottom + t[2],
				left: n.left - t[3]
			};
			return e.width = e.right - e.left, e.height = e.bottom - e.top, e
		}
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		var u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
				return typeof t
			} : function (t) {
				return t && "function" == typeof Symbol && t.constructor === Symbol ? "symbol" : typeof t
			},
			h = i(2),
			o = i(6),
			a = i(7),
			d = n(a),
			f = function () {
				function a(t) {
					var e = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1],
						i = arguments[2],
						n = arguments[3];
					if (s(this, a), "function" != typeof t) throw new TypeError("The callback provided as parameter 1 is not a function.");
					if ("object" !== ("undefined" == typeof e ? "undefined" : u(e))) throw new TypeError("parameter 2 is not an object.");
					if ("root" in e && !(e.root instanceof Element)) throw new TypeError("member root is not of type Element.");
					var r = l(e.threshold),
						o = c(e.rootMargin);
					this.root = e.root || null, this.rootMargin = o.rawData, this.thresholds = Object.freeze(r), this._root = e.root || document.documentElement, this._callback = t, this._rootMargin = o.parsedData, this._targets = new h.Map, this._quedEntries = [], this._publicObserver = n || this, this.controller = i
				}
				return a.prototype.observe = function (t) {
					if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
					if (!(t instanceof Element)) throw new TypeError('parameter 1 is not of type "Element".');
					var e = this._targets;
					e.has(t) || (e.set(t, new d["default"](t, this)), this.controller.isConnected(this) || this.controller.connect(this), this.controller.startUpdateCycle())
				}, a.prototype.unobserve = function (t) {
					if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
					if (!(t instanceof Element)) throw new TypeError('parameter 1 is not of type "Element".');
					var e = this._targets;
					e.has(t) && e["delete"](t), e.size || this.disconnect()
				}, a.prototype.disconnect = function () {
					this._targets.clear(), this.controller.disconnect(this)
				}, a.prototype.takeRecords = function () {
					return this._quedEntries.splice(0)
				}, a.prototype.notifySubscriber = function () {
					var t = this.takeRecords(),
						e = this._publicObserver;
					t.length && this._callback.call(e, t, e)
				}, a.prototype.queueEntry = function (t) {
					this._quedEntries.push(t)
				}, a.prototype.hasEntries = function () {
					return !!this._quedEntries.length
				}, a.prototype.updateObservations = function () {
					var i = this._root,
						n = this.getRootRect(),
						r = !1;
					return this._targets.forEach(function (t) {
						var e = t.updateIntersection(i, n);
						(e.ratioChanged || e.targetRectChanged) && (r = !0)
					}), r
				}, a.prototype.getThresholdGreaterThan = function (t) {
					for (var e = this.thresholds, i = e.length, n = 0; n < i && e[n] <= t;) ++n;
					return n
				}, a.prototype.getRootRect = function () {
					var t = (0, o.getRectangle)(this._root);
					return r(t, this._rootMargin)
				}, a
			}();
		e["default"] = f, t.exports = e["default"]
	}, function (t, e) {
		"use strict";

		function i(t) {
			for (var e = {}, i = Object.keys(t), n = Array.isArray(i), r = 0, i = n ? i : i[Symbol.iterator]();;) {
				var o;
				if (n) {
					if (r >= i.length) break;
					o = i[r++]
				} else {
					if (r = i.next(), r.done) break;
					o = r.value
				}
				var a = o;
				e[a] = {
					value: t[a]
				}
			}
			return Object.defineProperties({}, e)
		}

		function n() {
			var t = arguments.length <= 0 || void 0 === arguments[0] ? 0 : arguments[0],
				e = arguments.length <= 1 || void 0 === arguments[1] ? 0 : arguments[1],
				i = arguments.length <= 2 || void 0 === arguments[2] ? 0 : arguments[2],
				n = arguments.length <= 3 || void 0 === arguments[3] ? 0 : arguments[3];
			return {
				left: t,
				top: e,
				width: i,
				height: n,
				bottom: e + n,
				right: t + i
			}
		}

		function r(t) {
			return t === document.documentElement ? n(0, 0, t.clientWidth, t.clientHeight) : t.getBoundingClientRect()
		}

		function o(t) {
			return t.width * t.height
		}

		function a(t) {
			return 0 === t.height && 0 === t.width
		}

		function s(t, e) {
			return t.top === e.top && t.left === e.left && t.right === e.right && t.bottom === e.bottom
		}
		Object.defineProperty(e, "__esModule", {
			value: !0
		}), e.mapToClientRect = i, e.createRectangle = n, e.getRectangle = r, e.getArea = o, e.isEmpty = a, e.isEqual = s
	}, function (t, e, i) {
		"use strict";

		function n(t) {
			return t && t.__esModule ? t : {
				default: t
			}
		}

		function r(t, e) {
			if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
		}

		function l(t, e) {
			var i = document.documentElement;
			return t !== i && !i.contains(t) || !t.contains(e)
		}

		function c(t, e) {
			var i = Math.max(e.left, t.left),
				n = Math.min(e.right, t.right),
				r = Math.max(e.top, t.top),
				o = Math.min(e.bottom, t.bottom),
				a = n - i,
				s = o - r;
			return (0, d.createRectangle)(i, r, a, s)
		}

		function u(t, e, i, n) {
			for (var r = n, o = e.parentNode, a = !1; !a;) {
				var s = null;
				o === t || 1 !== o.nodeType ? (a = !0, s = i) : "visible" !== window.getComputedStyle(o).overflow && (s = (0, d.getRectangle)(o)), s && (r = c(r, s)), o = o.parentNode
			}
			return r
		}
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		var o = i(4),
			h = n(o),
			d = i(6),
			a = i(8),
			f = n(a),
			p = (0, d.createRectangle)(),
			s = function () {
				function i(t, e) {
					r(this, i), this.target = t, this.observer = e, this.prevTargetRect = p, this.prevThreshold = 0, this.prevRatio = 0
				}
				return i.prototype.updateIntersection = function (t, e) {
					var i = (0, d.getRectangle)(this.target),
						n = this.getIntersectionData(t, e, i),
						r = +n.exists,
						o = n.ratio !== this.prevRatio,
						a = !(0, d.isEqual)(i, this.prevTargetRect),
						s = void 0;
					if (n.exists && !(0, d.isEmpty)(i) && (r = this.observer.getThresholdGreaterThan(n.ratio)), s = r !== this.prevThreshold, this.prevTargetRect = i, this.prevThreshold = r, this.prevRatio = n.ratio, n.exists || (n.ratio = 0, n.rect = p), s) {
						var l = new f["default"](this.target, i, n.rect, n.ratio, e, (0, h["default"])());
						this.observer.queueEntry(l)
					}
					return {
						ratioChanged: o,
						thresholdChanged: s,
						targetRectChanged: a
					}
				}, i.prototype.getIntersectionData = function (t, e, i) {
					var n = this.target;
					i || (i = (0, d.getRectangle)(this.target)), e || (e = (0, d.getRectangle)(t));
					var r = l(t, n),
						o = r ? p : u(t, n, e, i),
						a = !r && o.width >= 0 && o.height >= 0,
						s = (0, d.getArea)(o) / (0, d.getArea)(i) || 0;
					return {
						rect: o,
						ratio: s,
						exists: a
					}
				}, i
			}();
		e["default"] = s, t.exports = e["default"]
	}, function (t, e, i) {
		"use strict";

		function s(t, e) {
			if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
		}
		Object.defineProperty(e, "__esModule", {
			value: !0
		});
		var l = i(6),
			n = function t(e, i, n, r, o, a) {
				s(this, t), Object.defineProperties(this, {
					boundingClientRect: {
						value: i
					},
					intersectionRatio: {
						value: r
					},
					intersectionRect: {
						value: (0, l.mapToClientRect)(n)
					},
					rootBounds: {
						value: (0, l.mapToClientRect)(o)
					},
					target: {
						value: e
					},
					time: {
						value: a
					}
				})
			};
		e["default"] = n, t.exports = e["default"]
	}])
});
(function (t) {
	var e = "0.5.0",
		f = "hasOwnProperty",
		p = /[\.\/]/,
		m = /\s*,\s*/,
		g = "*",
		i = function () {},
		v = function (t, e) {
			return t - e
		},
		y, x, _ = {
			n: {}
		},
		b = function () {
			for (var t = 0, e = this.length; t < e; t++) {
				if (typeof this[t] != "undefined") {
					return this[t]
				}
			}
		},
		w = function () {
			var t = this.length;
			while (--t) {
				if (typeof this[t] != "undefined") {
					return this[t]
				}
			}
		},
		n = Object.prototype.toString,
		T = String,
		E = Array.isArray || function (t) {
			return t instanceof Array || n.call(t) == "[object Array]"
		};
	eve = function (t, e) {
		var i = _,
			n = x,
			r = Array.prototype.slice.call(arguments, 2),
			o = eve.listeners(t),
			a = 0,
			s = false,
			l, c = [],
			u = {},
			h = [],
			d = y,
			f = [];
		h.firstDefined = b;
		h.lastDefined = w;
		y = t;
		x = 0;
		for (var p = 0, m = o.length; p < m; p++)
			if ("zIndex" in o[p]) {
				c.push(o[p].zIndex);
				if (o[p].zIndex < 0) {
					u[o[p].zIndex] = o[p]
				}
			}
		c.sort(v);
		while (c[a] < 0) {
			l = u[c[a++]];
			h.push(l.apply(e, r));
			if (x) {
				x = n;
				return h
			}
		}
		for (p = 0; p < m; p++) {
			l = o[p];
			if ("zIndex" in l) {
				if (l.zIndex == c[a]) {
					h.push(l.apply(e, r));
					if (x) {
						break
					}
					do {
						a++;
						l = u[c[a]];
						l && h.push(l.apply(e, r));
						if (x) {
							break
						}
					} while (l)
				} else {
					u[l.zIndex] = l
				}
			} else {
				h.push(l.apply(e, r));
				if (x) {
					break
				}
			}
		}
		x = n;
		y = d;
		return h
	};
	eve._events = _;
	eve.listeners = function (t) {
		var e = E(t) ? t : t.split(p),
			i = _,
			n, r, o, a, s, l, c, u, h = [i],
			d = [];
		for (a = 0, s = e.length; a < s; a++) {
			u = [];
			for (l = 0, c = h.length; l < c; l++) {
				i = h[l].n;
				r = [i[e[a]], i[g]];
				o = 2;
				while (o--) {
					n = r[o];
					if (n) {
						u.push(n);
						d = d.concat(n.f || [])
					}
				}
			}
			h = u
		}
		return d
	};
	eve.separator = function (t) {
		if (t) {
			t = T(t).replace(/(?=[\.\^\]\[\-])/g, "\\");
			t = "[" + t + "]";
			p = new RegExp(t)
		} else {
			p = /[\.\/]/
		}
	};
	eve.on = function (t, a) {
		if (typeof a != "function") {
			return function () {}
		}
		var e = E(t) ? E(t[0]) ? t : [t] : T(t).split(m);
		for (var i = 0, n = e.length; i < n; i++) {
			(function (t) {
				var e = E(t) ? t : T(t).split(p),
					i = _,
					n;
				for (var r = 0, o = e.length; r < o; r++) {
					i = i.n;
					i = i.hasOwnProperty(e[r]) && i[e[r]] || (i[e[r]] = {
						n: {}
					})
				}
				i.f = i.f || [];
				for (r = 0, o = i.f.length; r < o; r++)
					if (i.f[r] == a) {
						n = true;
						break
					}!n && i.f.push(a)
			})(e[i])
		}
		return function (t) {
			if (+t == +t) {
				a.zIndex = +t
			}
		}
	};
	eve.f = function (t) {
		var e = [].slice.call(arguments, 1);
		return function () {
			eve.apply(null, [t, null].concat(e).concat([].slice.call(arguments, 0)))
		}
	};
	eve.stop = function () {
		x = 1
	};
	eve.nt = function (t) {
		var e = E(y) ? y.join(".") : y;
		if (t) {
			return new RegExp("(?:\\.|\\/|^)" + t + "(?:\\.|\\/|$)").test(e)
		}
		return e
	};
	eve.nts = function () {
		return E(y) ? y : y.split(p)
	};
	eve.off = eve.unbind = function (t, e) {
		if (!t) {
			eve._events = _ = {
				n: {}
			};
			return
		}
		var i = E(t) ? E(t[0]) ? t : [t] : T(t).split(m);
		if (i.length > 1) {
			for (var n = 0, r = i.length; n < r; n++) {
				eve.off(i[n], e)
			}
			return
		}
		i = E(t) ? t : T(t).split(p);
		var o, a, s, n, r, l, c, u = [_],
			h = [];
		for (n = 0, r = i.length; n < r; n++) {
			for (l = 0; l < u.length; l += s.length - 2) {
				s = [l, 1];
				o = u[l].n;
				if (i[n] != g) {
					if (o[i[n]]) {
						s.push(o[i[n]]);
						h.unshift({
							n: o,
							name: i[n]
						})
					}
				} else {
					for (a in o)
						if (o[f](a)) {
							s.push(o[a]);
							h.unshift({
								n: o,
								name: a
							})
						}
				}
				u.splice.apply(u, s)
			}
		}
		for (n = 0, r = u.length; n < r; n++) {
			o = u[n];
			while (o.n) {
				if (e) {
					if (o.f) {
						for (l = 0, c = o.f.length; l < c; l++)
							if (o.f[l] == e) {
								o.f.splice(l, 1);
								break
							}!o.f.length && delete o.f
					}
					for (a in o.n)
						if (o.n[f](a) && o.n[a].f) {
							var d = o.n[a].f;
							for (l = 0, c = d.length; l < c; l++)
								if (d[l] == e) {
									d.splice(l, 1);
									break
								}!d.length && delete o.n[a].f
						}
				} else {
					delete o.f;
					for (a in o.n)
						if (o.n[f](a) && o.n[a].f) {
							delete o.n[a].f
						}
				}
				o = o.n
			}
		}
		t: for (n = 0, r = h.length; n < r; n++) {
			o = h[n];
			for (a in o.n[o.name].f) {
				continue t
			}
			for (a in o.n[o.name].n) {
				continue t
			}
			delete o.n[o.name]
		}
	};
	eve.once = function (t, e) {
		var i = function () {
			eve.off(t, i);
			return e.apply(this, arguments)
		};
		return eve.on(t, i)
	};
	eve.version = e;
	eve.toString = function () {
		return "You are running Eve " + e
	};
	typeof module != "undefined" && module.exports ? module.exports = eve : typeof define === "function" && define.amd ? define("eve", [], function () {
		return eve
	}) : t.eve = eve
})(this);
(function (e, i) {
	if (typeof define == "function" && define.amd) {
		define(["eve"], function (t) {
			return i(e, t)
		})
	} else if (typeof exports != "undefined") {
		var t = require("eve");
		module.exports = i(e, t)
	} else {
		i(e, e.eve)
	}
})(window || this, function (E, pt) {
	var b = function (a) {
		var u = {},
			s = E.requestAnimationFrame || E.webkitRequestAnimationFrame || E.mozRequestAnimationFrame || E.oRequestAnimationFrame || E.msRequestAnimationFrame || function (t) {
				setTimeout(t, 16, (new Date).getTime());
				return true
			},
			l, c = Array.isArray || function (t) {
				return t instanceof Array || Object.prototype.toString.call(t) == "[object Array]"
			},
			t = 0,
			e = "M" + (+new Date).toString(36),
			h = function () {
				return e + (t++).toString(36)
			},
			d = function (e, i, t, n) {
				if (c(e)) {
					res = [];
					for (var r = 0, o = e.length; r < o; r++) {
						res[r] = d(e[r], i, t[r], n)
					}
					return res
				}
				var a = (t - e) / (n - i);
				return function (t) {
					return e + a * (t - i)
				}
			},
			i = Date.now || function () {
				return +new Date
			},
			f = function (t) {
				var e = this;
				if (t == null) {
					return e.s
				}
				var i = e.s - t;
				e.b += e.dur * i;
				e.B += e.dur * i;
				e.s = t
			},
			p = function (t) {
				var e = this;
				if (t == null) {
					return e.spd
				}
				e.spd = t
			},
			m = function (t) {
				var e = this;
				if (t == null) {
					return e.dur
				}
				e.s = e.s * t / e.dur;
				e.dur = t
			},
			g = function () {
				var t = this;
				delete u[t.id];
				t.update();
				a("mina.stop." + t.id, t)
			},
			v = function () {
				var t = this;
				if (t.pdif) {
					return
				}
				delete u[t.id];
				t.update();
				t.pdif = t.get() - t.b
			},
			y = function () {
				var t = this;
				if (!t.pdif) {
					return
				}
				t.b = t.get() - t.pdif;
				delete t.pdif;
				u[t.id] = t;
				_()
			},
			x = function () {
				var t = this,
					e;
				if (c(t.start)) {
					e = [];
					for (var i = 0, n = t.start.length; i < n; i++) {
						e[i] = +t.start[i] + (t.end[i] - t.start[i]) * t.easing(t.s)
					}
				} else {
					e = +t.start + (t.end - t.start) * t.easing(t.s)
				}
				t.set(e)
			},
			_ = function (t) {
				if (!t) {
					if (!l) {
						l = s(_)
					}
					return
				}
				var e = 0;
				for (var i in u)
					if (u.hasOwnProperty(i)) {
						var n = u[i],
							r = n.get(),
							o;
						e++;
						n.s = (r - n.b) / (n.dur / n.spd);
						if (n.s >= 1) {
							delete u[i];
							n.s = 1;
							e--;
							(function (t) {
								setTimeout(function () {
									a("mina.finish." + t.id, t)
								})
							})(n)
						}
						n.update()
					}
				l = e ? s(_) : false
			},
			b = function (t, e, i, n, r, o, a) {
				var s = {
					id: h(),
					start: t,
					end: e,
					b: i,
					s: 0,
					dur: n - i,
					spd: 1,
					get: r,
					set: o,
					easing: a || b.linear,
					status: f,
					speed: p,
					duration: m,
					stop: g,
					pause: v,
					resume: y,
					update: x
				};
				u[s.id] = s;
				var l = 0,
					c;
				for (c in u)
					if (u.hasOwnProperty(c)) {
						l++;
						if (l == 2) {
							break
						}
					}
				l == 1 && _();
				return s
			};
		b.time = i;
		b.getById = function (t) {
			return u[t] || null
		};
		b.linear = function (t) {
			return t
		};
		b.easeout = function (t) {
			return Math.pow(t, 1.7)
		};
		b.easein = function (t) {
			return Math.pow(t, .48)
		};
		b.easeinout = function (t) {
			if (t == 1) {
				return 1
			}
			if (t == 0) {
				return 0
			}
			var e = .48 - t / 1.04,
				i = Math.sqrt(.1734 + e * e),
				n = i - e,
				r = Math.pow(Math.abs(n), 1 / 3) * (n < 0 ? -1 : 1),
				o = -i - e,
				a = Math.pow(Math.abs(o), 1 / 3) * (o < 0 ? -1 : 1),
				s = r + a + .5;
			return (1 - s) * 3 * s * s + s * s * s
		};
		b.backin = function (t) {
			if (t == 1) {
				return 1
			}
			var e = 1.70158;
			return t * t * ((e + 1) * t - e)
		};
		b.backout = function (t) {
			if (t == 0) {
				return 0
			}
			t = t - 1;
			var e = 1.70158;
			return t * t * ((e + 1) * t + e) + 1
		};
		b.elastic = function (t) {
			if (t == !!t) {
				return t
			}
			return Math.pow(2, -10 * t) * Math.sin((t - .075) * (2 * Math.PI) / .3) + 1
		};
		b.bounce = function (t) {
			var e = 7.5625,
				i = 2.75,
				n;
			if (t < 1 / i) {
				n = e * t * t
			} else {
				if (t < 2 / i) {
					t -= 1.5 / i;
					n = e * t * t + .75
				} else {
					if (t < 2.5 / i) {
						t -= 2.25 / i;
						n = e * t * t + .9375
					} else {
						t -= 2.625 / i;
						n = e * t * t + .984375
					}
				}
			}
			return n
		};
		E.mina = b;
		return b
	}(typeof pt == "undefined" ? function () {} : pt);
	var t = function (t) {
		v.version = "0.5.1";

		function v(t, e) {
			if (t) {
				if (t.nodeType) {
					return ut(t)
				}
				if (F(t, "array") && v.set) {
					return v.set.apply(v, t)
				}
				if (t instanceof at) {
					return t
				}
				if (e == null) {
					t = l.doc.querySelector(String(t));
					return ut(t)
				}
			}
			t = t == null ? "100%" : t;
			e = e == null ? "100%" : e;
			return new ct(t, e)
		}
		v.toString = function () {
			return "Snap v" + this.version
		};
		v._ = {};
		var l = {
			win: t.window,
			doc: t.window.document
		};
		v._.glob = l;
		var u = "hasOwnProperty",
			y = String,
			c = parseFloat,
			h = parseInt,
			d = Math,
			f = d.max,
			p = d.min,
			m = d.abs,
			e = d.pow,
			x = d.PI,
			i = d.round,
			_ = "",
			n = " ",
			r = Object.prototype.toString,
			o = /^url\(['"]?([^\)]+?)['"]?\)$/i,
			b = /^\s*((#[a-f\d]{6})|(#[a-f\d]{3})|rgba?\(\s*([\d\.]+%?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+%?(?:\s*,\s*[\d\.]+%?)?)\s*\)|hsba?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\)|hsla?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\))\s*$/i,
			a = /^(?:cubic-)?bezier\(([^,]+),([^,]+),([^,]+),([^\)]+)\)/,
			s = v._.separator = /[,\s]+/,
			w = /[\s]/g,
			T = /[\s]*,[\s]*/,
			E = {
				hs: 1,
				rg: 1
			},
			S = /([a-z])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/gi,
			M = /([rstm])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/gi,
			A = /(-?\d*\.?\d*(?:e[\-+]?\d+)?)[\s]*,?[\s]*/gi,
			C = 0,
			P = "S" + (+new Date).toString(36),
			L = function (t) {
				return (t && t.type ? t.type : _) + P + (C++).toString(36)
			},
			R = "http://www.w3.org/1999/xlink",
			O = "http://www.w3.org/2000/svg",
			k = {},
			N = v.url = function (t) {
				return "url('#" + t + "')"
			};

		function I(t, e) {
			if (e) {
				if (t == "#text") {
					t = l.doc.createTextNode(e.text || e["#text"] || "")
				}
				if (t == "#comment") {
					t = l.doc.createComment(e.text || e["#text"] || "")
				}
				if (typeof t == "string") {
					t = I(t)
				}
				if (typeof e == "string") {
					if (t.nodeType == 1) {
						if (e.substring(0, 6) == "xlink:") {
							return t.getAttributeNS(R, e.substring(6))
						}
						if (e.substring(0, 4) == "xml:") {
							return t.getAttributeNS(O, e.substring(4))
						}
						return t.getAttribute(e)
					} else if (e == "text") {
						return t.nodeValue
					} else {
						return null
					}
				}
				if (t.nodeType == 1) {
					for (var i in e)
						if (e[u](i)) {
							var n = y(e[i]);
							if (n) {
								if (i.substring(0, 6) == "xlink:") {
									t.setAttributeNS(R, i.substring(6), n)
								} else if (i.substring(0, 4) == "xml:") {
									t.setAttributeNS(O, i.substring(4), n)
								} else {
									t.setAttribute(i, n)
								}
							} else {
								t.removeAttribute(i)
							}
						}
				} else if ("text" in e) {
					t.nodeValue = e.text
				}
			} else {
				t = l.doc.createElementNS(O, t)
			}
			return t
		}
		v._.$ = I;
		v._.id = L;

		function D(t) {
			var e = t.attributes,
				i, n = {};
			for (var r = 0; r < e.length; r++) {
				if (e[r].namespaceURI == R) {
					i = "xlink:"
				} else {
					i = ""
				}
				i += e[r].name;
				n[i] = e[r].textContent
			}
			return n
		}

		function F(t, e) {
			e = y.prototype.toLowerCase.call(e);
			if (e == "finite") {
				return isFinite(t)
			}
			if (e == "array" && (t instanceof Array || Array.isArray && Array.isArray(t))) {
				return true
			}
			return e == "null" && t === null || e == typeof t && t !== null || e == "object" && t === Object(t) || r.call(t).slice(8, -1).toLowerCase() == e
		}
		v.format = function () {
			var e = /\{([^\}]+)\}/g,
				n = /(?:(?:^|\.)(.+?)(?=\[|\.|$|\()|\[('|")(.+?)\2\])(\(\))?/g,
				r = function (t, e, i) {
					var o = i;
					e.replace(n, function (t, e, i, n, r) {
						e = e || n;
						if (o) {
							if (e in o) {
								o = o[e]
							}
							typeof o == "function" && r && (o = o())
						}
					});
					o = (o == null || o == i ? t : o) + "";
					return o
				};
			return function (t, i) {
				return y(t).replace(e, function (t, e) {
					return r(t, e, i)
				})
			}
		}();

		function B(t) {
			if (typeof t == "function" || Object(t) !== t) {
				return t
			}
			var e = new t.constructor;
			for (var i in t)
				if (t[u](i)) {
					e[i] = B(t[i])
				}
			return e
		}
		v._.clone = B;

		function U(t, e) {
			for (var i = 0, n = t.length; i < n; i++)
				if (t[i] === e) {
					return t.push(t.splice(i, 1)[0])
				}
		}

		function z(r, o, a) {
			function s() {
				var t = Array.prototype.slice.call(arguments, 0),
					e = t.join("␀"),
					i = s.cache = s.cache || {},
					n = s.count = s.count || [];
				if (i[u](e)) {
					U(n, e);
					return a ? a(i[e]) : i[e]
				}
				n.length >= 1e3 && delete i[n.shift()];
				n.push(e);
				i[e] = r.apply(o, t);
				return a ? a(i[e]) : i[e]
			}
			return s
		}
		v._.cacher = z;

		function G(t, e, i, n, r, o) {
			if (r == null) {
				var a = t - i,
					s = e - n;
				if (!a && !s) {
					return 0
				}
				return (180 + d.atan2(-s, -a) * 180 / x + 360) % 360
			} else {
				return G(t, e, r, o) - G(i, n, r, o)
			}
		}

		function H(t) {
			return t % 360 * x / 180
		}

		function j(t) {
			return t * 180 / x % 360
		}

		function V() {
			return this.x + n + this.y
		}

		function W() {
			return this.x + n + this.y + n + this.width + " × " + this.height
		}
		v.rad = H;
		v.deg = j;
		v.sin = function (t) {
			return d.sin(v.rad(t))
		};
		v.tan = function (t) {
			return d.tan(v.rad(t))
		};
		v.cos = function (t) {
			return d.cos(v.rad(t))
		};
		v.asin = function (t) {
			return v.deg(d.asin(t))
		};
		v.acos = function (t) {
			return v.deg(d.acos(t))
		};
		v.atan = function (t) {
			return v.deg(d.atan(t))
		};
		v.atan2 = function (t) {
			return v.deg(d.atan2(t))
		};
		v.angle = G;
		v.len = function (t, e, i, n) {
			return Math.sqrt(v.len2(t, e, i, n))
		};
		v.len2 = function (t, e, i, n) {
			return (t - i) * (t - i) + (e - n) * (e - n)
		};
		v.closestPoint = function (t, n, r) {
			function e(t) {
				var e = t.x - n,
					i = t.y - r;
				return e * e + i * i
			}
			var i = t.node,
				o = i.getTotalLength(),
				a = o / i.pathSegList.numberOfItems * .125,
				s, l, c = Infinity;
			for (var u, h = 0, d; h <= o; h += a) {
				if ((d = e(u = i.getPointAtLength(h))) < c) {
					s = u;
					l = h;
					c = d
				}
			}
			a *= .5;
			while (a > .5) {
				var f, p, m, g, v, y;
				if ((m = l - a) >= 0 && (v = e(f = i.getPointAtLength(m))) < c) {
					s = f;
					l = m;
					c = v
				} else if ((g = l + a) <= o && (y = e(p = i.getPointAtLength(g))) < c) {
					s = p;
					l = g;
					c = y
				} else {
					a *= .5
				}
			}
			s = {
				x: s.x,
				y: s.y,
				length: l,
				distance: Math.sqrt(c)
			};
			return s
		};
		v.is = F;
		v.snapTo = function (t, e, i) {
			i = F(i, "finite") ? i : 10;
			if (F(t, "array")) {
				var n = t.length;
				while (n--)
					if (m(t[n] - e) <= i) {
						return t[n]
					}
			} else {
				t = +t;
				var r = e % t;
				if (r < i) {
					return e - r
				}
				if (r > t - i) {
					return e - r + t
				}
			}
			return e
		};
		v.getRGB = z(function (t) {
			if (!t || !!((t = y(t)).indexOf("-") + 1)) {
				return {
					r: -1,
					g: -1,
					b: -1,
					hex: "none",
					error: 1,
					toString: $
				}
			}
			if (t == "none") {
				return {
					r: -1,
					g: -1,
					b: -1,
					hex: "none",
					toString: $
				}
			}!(E[u](t.toLowerCase().substring(0, 2)) || t.charAt() == "#") && (t = X(t));
			if (!t) {
				return {
					r: -1,
					g: -1,
					b: -1,
					hex: "none",
					error: 1,
					toString: $
				}
			}
			var e, i, n, r, o, a, s, l = t.match(b);
			if (l) {
				if (l[2]) {
					r = h(l[2].substring(5), 16);
					n = h(l[2].substring(3, 5), 16);
					i = h(l[2].substring(1, 3), 16)
				}
				if (l[3]) {
					r = h((a = l[3].charAt(3)) + a, 16);
					n = h((a = l[3].charAt(2)) + a, 16);
					i = h((a = l[3].charAt(1)) + a, 16)
				}
				if (l[4]) {
					s = l[4].split(T);
					i = c(s[0]);
					s[0].slice(-1) == "%" && (i *= 2.55);
					n = c(s[1]);
					s[1].slice(-1) == "%" && (n *= 2.55);
					r = c(s[2]);
					s[2].slice(-1) == "%" && (r *= 2.55);
					l[1].toLowerCase().slice(0, 4) == "rgba" && (o = c(s[3]));
					s[3] && s[3].slice(-1) == "%" && (o /= 100)
				}
				if (l[5]) {
					s = l[5].split(T);
					i = c(s[0]);
					s[0].slice(-1) == "%" && (i /= 100);
					n = c(s[1]);
					s[1].slice(-1) == "%" && (n /= 100);
					r = c(s[2]);
					s[2].slice(-1) == "%" && (r /= 100);
					(s[0].slice(-3) == "deg" || s[0].slice(-1) == "°") && (i /= 360);
					l[1].toLowerCase().slice(0, 4) == "hsba" && (o = c(s[3]));
					s[3] && s[3].slice(-1) == "%" && (o /= 100);
					return v.hsb2rgb(i, n, r, o)
				}
				if (l[6]) {
					s = l[6].split(T);
					i = c(s[0]);
					s[0].slice(-1) == "%" && (i /= 100);
					n = c(s[1]);
					s[1].slice(-1) == "%" && (n /= 100);
					r = c(s[2]);
					s[2].slice(-1) == "%" && (r /= 100);
					(s[0].slice(-3) == "deg" || s[0].slice(-1) == "°") && (i /= 360);
					l[1].toLowerCase().slice(0, 4) == "hsla" && (o = c(s[3]));
					s[3] && s[3].slice(-1) == "%" && (o /= 100);
					return v.hsl2rgb(i, n, r, o)
				}
				i = p(d.round(i), 255);
				n = p(d.round(n), 255);
				r = p(d.round(r), 255);
				o = p(f(o, 0), 1);
				l = {
					r: i,
					g: n,
					b: r,
					toString: $
				};
				l.hex = "#" + (16777216 | r | n << 8 | i << 16).toString(16).slice(1);
				l.opacity = F(o, "finite") ? o : 1;
				return l
			}
			return {
				r: -1,
				g: -1,
				b: -1,
				hex: "none",
				error: 1,
				toString: $
			}
		}, v);
		v.hsb = z(function (t, e, i) {
			return v.hsb2rgb(t, e, i).hex
		});
		v.hsl = z(function (t, e, i) {
			return v.hsl2rgb(t, e, i).hex
		});
		v.rgb = z(function (t, e, i, n) {
			if (F(n, "finite")) {
				var r = d.round;
				return "rgba(" + [r(t), r(e), r(i), +n.toFixed(2)] + ")"
			}
			return "#" + (16777216 | i | e << 8 | t << 16).toString(16).slice(1)
		});
		var X = function (t) {
				var i = l.doc.getElementsByTagName("head")[0] || l.doc.getElementsByTagName("svg")[0],
					n = "rgb(255, 0, 0)";
				X = z(function (t) {
					if (t.toLowerCase() == "red") {
						return n
					}
					i.style.color = n;
					i.style.color = t;
					var e = l.doc.defaultView.getComputedStyle(i, _).getPropertyValue("color");
					return e == n ? null : e
				});
				return X(t)
			},
			Y = function () {
				return "hsb(" + [this.h, this.s, this.b] + ")"
			},
			q = function () {
				return "hsl(" + [this.h, this.s, this.l] + ")"
			},
			$ = function () {
				return this.opacity == 1 || this.opacity == null ? this.hex : "rgba(" + [this.r, this.g, this.b, this.opacity] + ")"
			},
			Z = function (t, e, i) {
				if (e == null && F(t, "object") && "r" in t && "g" in t && "b" in t) {
					i = t.b;
					e = t.g;
					t = t.r
				}
				if (e == null && F(t, string)) {
					var n = v.getRGB(t);
					t = n.r;
					e = n.g;
					i = n.b
				}
				if (t > 1 || e > 1 || i > 1) {
					t /= 255;
					e /= 255;
					i /= 255
				}
				return [t, e, i]
			},
			J = function (t, e, i, n) {
				t = d.round(t * 255);
				e = d.round(e * 255);
				i = d.round(i * 255);
				var r = {
					r: t,
					g: e,
					b: i,
					opacity: F(n, "finite") ? n : 1,
					hex: v.rgb(t, e, i),
					toString: $
				};
				F(n, "finite") && (r.opacity = n);
				return r
			};
		v.color = function (t) {
			var e;
			if (F(t, "object") && "h" in t && "s" in t && "b" in t) {
				e = v.hsb2rgb(t);
				t.r = e.r;
				t.g = e.g;
				t.b = e.b;
				t.opacity = 1;
				t.hex = e.hex
			} else if (F(t, "object") && "h" in t && "s" in t && "l" in t) {
				e = v.hsl2rgb(t);
				t.r = e.r;
				t.g = e.g;
				t.b = e.b;
				t.opacity = 1;
				t.hex = e.hex
			} else {
				if (F(t, "string")) {
					t = v.getRGB(t)
				}
				if (F(t, "object") && "r" in t && "g" in t && "b" in t && !("error" in t)) {
					e = v.rgb2hsl(t);
					t.h = e.h;
					t.s = e.s;
					t.l = e.l;
					e = v.rgb2hsb(t);
					t.v = e.b
				} else {
					t = {
						hex: "none"
					};
					t.r = t.g = t.b = t.h = t.s = t.v = t.l = -1;
					t.error = 1
				}
			}
			t.toString = $;
			return t
		};
		v.hsb2rgb = function (t, e, i, n) {
			if (F(t, "object") && "h" in t && "s" in t && "b" in t) {
				i = t.b;
				e = t.s;
				n = t.o;
				t = t.h
			}
			t *= 360;
			var r, o, a, s, l;
			t = t % 360 / 60;
			l = i * e;
			s = l * (1 - m(t % 2 - 1));
			r = o = a = i - l;
			t = ~~t;
			r += [l, s, 0, 0, s, l][t];
			o += [s, l, l, s, 0, 0][t];
			a += [0, 0, s, l, l, s][t];
			return J(r, o, a, n)
		};
		v.hsl2rgb = function (t, e, i, n) {
			if (F(t, "object") && "h" in t && "s" in t && "l" in t) {
				i = t.l;
				e = t.s;
				t = t.h
			}
			if (t > 1 || e > 1 || i > 1) {
				t /= 360;
				e /= 100;
				i /= 100
			}
			t *= 360;
			var r, o, a, s, l;
			t = t % 360 / 60;
			l = 2 * e * (i < .5 ? i : 1 - i);
			s = l * (1 - m(t % 2 - 1));
			r = o = a = i - l / 2;
			t = ~~t;
			r += [l, s, 0, 0, s, l][t];
			o += [s, l, l, s, 0, 0][t];
			a += [0, 0, s, l, l, s][t];
			return J(r, o, a, n)
		};
		v.rgb2hsb = function (t, e, i) {
			i = Z(t, e, i);
			t = i[0];
			e = i[1];
			i = i[2];
			var n, r, o, a;
			o = f(t, e, i);
			a = o - p(t, e, i);
			n = a == 0 ? null : o == t ? (e - i) / a : o == e ? (i - t) / a + 2 : (t - e) / a + 4;
			n = (n + 360) % 6 * 60 / 360;
			r = a == 0 ? 0 : a / o;
			return {
				h: n,
				s: r,
				b: o,
				toString: Y
			}
		};
		v.rgb2hsl = function (t, e, i) {
			i = Z(t, e, i);
			t = i[0];
			e = i[1];
			i = i[2];
			var n, r, o, a, s, l;
			a = f(t, e, i);
			s = p(t, e, i);
			l = a - s;
			n = l == 0 ? null : a == t ? (e - i) / l : a == e ? (i - t) / l + 2 : (t - e) / l + 4;
			n = (n + 360) % 6 * 60 / 360;
			o = (a + s) / 2;
			r = l == 0 ? 0 : o < .5 ? l / (2 * o) : l / (2 - 2 * o);
			return {
				h: n,
				s: r,
				l: o,
				toString: q
			}
		};
		v.parsePathString = function (t) {
			if (!t) {
				return null
			}
			var e = v.path(t);
			if (e.arr) {
				return v.path.clone(e.arr)
			}
			var o = {
					a: 7,
					c: 6,
					o: 2,
					h: 1,
					l: 2,
					m: 2,
					r: 4,
					q: 4,
					s: 4,
					t: 2,
					v: 1,
					u: 3,
					z: 0
				},
				a = [];
			if (F(t, "array") && F(t[0], "array")) {
				a = v.path.clone(t)
			}
			if (!a.length) {
				y(t).replace(S, function (t, e, i) {
					var n = [],
						r = e.toLowerCase();
					i.replace(A, function (t, e) {
						e && n.push(+e)
					});
					if (r == "m" && n.length > 2) {
						a.push([e].concat(n.splice(0, 2)));
						r = "l";
						e = e == "m" ? "l" : "L"
					}
					if (r == "o" && n.length == 1) {
						a.push([e, n[0]])
					}
					if (r == "r") {
						a.push([e].concat(n))
					} else
						while (n.length >= o[r]) {
							a.push([e].concat(n.splice(0, o[r])));
							if (!o[r]) {
								break
							}
						}
				})
			}
			a.toString = v.path.toString;
			e.arr = v.path.clone(a);
			return a
		};
		var Q = v.parseTransformString = function (t) {
			if (!t) {
				return null
			}
			var e = {
					r: 3,
					s: 4,
					t: 2,
					m: 6
				},
				o = [];
			if (F(t, "array") && F(t[0], "array")) {
				o = v.path.clone(t)
			}
			if (!o.length) {
				y(t).replace(M, function (t, e, i) {
					var n = [],
						r = e.toLowerCase();
					i.replace(A, function (t, e) {
						e && n.push(+e)
					});
					o.push([e].concat(n))
				})
			}
			o.toString = v.path.toString;
			return o
		};

		function K(t) {
			var n = [];
			t = t.replace(/(?:^|\s)(\w+)\(([^)]+)\)/g, function (t, e, i) {
				i = i.split(/\s*,\s*|\s+/);
				if (e == "rotate" && i.length == 1) {
					i.push(0, 0)
				}
				if (e == "scale") {
					if (i.length > 2) {
						i = i.slice(0, 2)
					} else if (i.length == 2) {
						i.push(0, 0)
					}
					if (i.length == 1) {
						i.push(i[0], 0, 0)
					}
				}
				if (e == "skewX") {
					n.push(["m", 1, 0, d.tan(H(i[0])), 1, 0, 0])
				} else if (e == "skewY") {
					n.push(["m", 1, d.tan(H(i[0])), 0, 1, 0, 0])
				} else {
					n.push([e.charAt(0)].concat(i))
				}
				return t
			});
			return n
		}
		v._.svgTransform2string = K;
		v._.rgTransform = /^[a-z][\s]*-?\.?\d/i;

		function tt(t, e) {
			var i = Q(t),
				n = new v.Matrix;
			if (i) {
				for (var r = 0, o = i.length; r < o; r++) {
					var a = i[r],
						s = a.length,
						l = y(a[0]).toLowerCase(),
						c = a[0] != l,
						u = c ? n.invert() : 0,
						h, d, f, p, m;
					if (l == "t" && s == 2) {
						n.translate(a[1], 0)
					} else if (l == "t" && s == 3) {
						if (c) {
							h = u.x(0, 0);
							d = u.y(0, 0);
							f = u.x(a[1], a[2]);
							p = u.y(a[1], a[2]);
							n.translate(f - h, p - d)
						} else {
							n.translate(a[1], a[2])
						}
					} else if (l == "r") {
						if (s == 2) {
							m = m || e;
							n.rotate(a[1], m.x + m.width / 2, m.y + m.height / 2)
						} else if (s == 4) {
							if (c) {
								f = u.x(a[2], a[3]);
								p = u.y(a[2], a[3]);
								n.rotate(a[1], f, p)
							} else {
								n.rotate(a[1], a[2], a[3])
							}
						}
					} else if (l == "s") {
						if (s == 2 || s == 3) {
							m = m || e;
							n.scale(a[1], a[s - 1], m.x + m.width / 2, m.y + m.height / 2)
						} else if (s == 4) {
							if (c) {
								f = u.x(a[2], a[3]);
								p = u.y(a[2], a[3]);
								n.scale(a[1], a[1], f, p)
							} else {
								n.scale(a[1], a[1], a[2], a[3])
							}
						} else if (s == 5) {
							if (c) {
								f = u.x(a[3], a[4]);
								p = u.y(a[3], a[4]);
								n.scale(a[1], a[2], f, p)
							} else {
								n.scale(a[1], a[2], a[3], a[4])
							}
						}
					} else if (l == "m" && s == 7) {
						n.add(a[1], a[2], a[3], a[4], a[5], a[6])
					}
				}
			}
			return n
		}
		v._.transform2matrix = tt;
		v._unit2px = rt;
		var et = l.doc.contains || l.doc.compareDocumentPosition ? function (t, e) {
			var i = t.nodeType == 9 ? t.documentElement : t,
				n = e && e.parentNode;
			return t == n || !!(n && n.nodeType == 1 && (i.contains ? i.contains(n) : t.compareDocumentPosition && t.compareDocumentPosition(n) & 16))
		} : function (t, e) {
			if (e) {
				while (e) {
					e = e.parentNode;
					if (e == t) {
						return true
					}
				}
			}
			return false
		};

		function it(t) {
			var e = t.node.ownerSVGElement && ut(t.node.ownerSVGElement) || t.node.parentNode && ut(t.node.parentNode) || v.select("svg") || v(0, 0),
				i = e.select("defs"),
				n = i == null ? false : i.node;
			if (!n) {
				n = lt("defs", e.node).node
			}
			return n
		}

		function nt(t) {
			return t.node.ownerSVGElement && ut(t.node.ownerSVGElement) || v.select("svg")
		}
		v._.getSomeDefs = it;
		v._.getSomeSVG = nt;

		function rt(i, n, r) {
			var t = nt(i).node,
				o = {},
				e = t.querySelector(".svg---mgr");
			if (!e) {
				e = I("rect");
				I(e, {
					x: -9e9,
					y: -9e9,
					width: 10,
					height: 10,
					class: "svg---mgr",
					fill: "none"
				});
				t.appendChild(e)
			}

			function a(t) {
				if (t == null) {
					return _
				}
				if (t == +t) {
					return t
				}
				I(e, {
					width: t
				});
				try {
					return e.getBBox().width
				} catch (t) {
					return 0
				}
			}

			function s(t) {
				if (t == null) {
					return _
				}
				if (t == +t) {
					return t
				}
				I(e, {
					height: t
				});
				try {
					return e.getBBox().height
				} catch (t) {
					return 0
				}
			}

			function l(t, e) {
				if (n == null) {
					o[t] = e(i.attr(t) || 0)
				} else if (t == n) {
					o = e(r == null ? i.attr(t) || 0 : r)
				}
			}
			switch (i.type) {
				case "rect":
					l("rx", a);
					l("ry", s);
				case "image":
					l("width", a);
					l("height", s);
				case "text":
					l("x", a);
					l("y", s);
					break;
				case "circle":
					l("cx", a);
					l("cy", s);
					l("r", a);
					break;
				case "ellipse":
					l("cx", a);
					l("cy", s);
					l("rx", a);
					l("ry", s);
					break;
				case "line":
					l("x1", a);
					l("x2", a);
					l("y1", s);
					l("y2", s);
					break;
				case "marker":
					l("refX", a);
					l("markerWidth", a);
					l("refY", s);
					l("markerHeight", s);
					break;
				case "radialGradient":
					l("fx", a);
					l("fy", s);
					break;
				case "tspan":
					l("dx", a);
					l("dy", s);
					break;
				default:
					l(n, a)
			}
			t.removeChild(e);
			return o
		}
		v.select = function (t) {
			t = y(t).replace(/([^\\]):/g, "$1\\:");
			return ut(l.doc.querySelector(t))
		};
		v.selectAll = function (t) {
			var e = l.doc.querySelectorAll(t),
				i = (v.set || Array)();
			for (var n = 0; n < e.length; n++) {
				i.push(ut(e[n]))
			}
			return i
		};

		function ot(t) {
			if (!F(t, "array")) {
				t = Array.prototype.slice.call(arguments, 0)
			}
			var e = 0,
				i = 0,
				n = this.node;
			while (this[e]) delete this[e++];
			for (e = 0; e < t.length; e++) {
				if (t[e].type == "set") {
					t[e].forEach(function (t) {
						n.appendChild(t.node)
					})
				} else {
					n.appendChild(t[e].node)
				}
			}
			var r = n.childNodes;
			for (e = 0; e < r.length; e++) {
				this[i++] = ut(r[e])
			}
			return this
		}
		setInterval(function () {
			for (var t in k)
				if (k[u](t)) {
					var e = k[t],
						i = e.node;
					if (e.type != "svg" && !i.ownerSVGElement || e.type == "svg" && (!i.parentNode || "ownerSVGElement" in i.parentNode && !i.ownerSVGElement)) {
						delete k[t]
					}
				}
		}, 1e4);

		function at(t) {
			if (t.snap in k) {
				return k[t.snap]
			}
			var e;
			try {
				e = t.ownerSVGElement
			} catch (t) {}
			this.node = t;
			if (e) {
				this.paper = new ct(e)
			}
			this.type = t.tagName || t.nodeName;
			var i = this.id = L(this);
			this.anims = {};
			this._ = {
				transform: []
			};
			t.snap = i;
			k[i] = this;
			if (this.type == "g") {
				this.add = ot
			}
			if (this.type in {
					g: 1,
					mask: 1,
					pattern: 1,
					symbol: 1
				}) {
				for (var n in ct.prototype)
					if (ct.prototype[u](n)) {
						this[n] = ct.prototype[n]
					}
			}
		}
		at.prototype.attr = function (t, e) {
			var i = this,
				n = i.node;
			if (!t) {
				if (n.nodeType != 1) {
					return {
						text: n.nodeValue
					}
				}
				var r = n.attributes,
					o = {};
				for (var a = 0, s = r.length; a < s; a++) {
					o[r[a].nodeName] = r[a].nodeValue
				}
				return o
			}
			if (F(t, "string")) {
				if (arguments.length > 1) {
					var l = {};
					l[t] = e;
					t = l
				} else {
					return pt("snap.util.getattr." + t, i).firstDefined()
				}
			}
			for (var c in t) {
				if (t[u](c)) {
					pt("snap.util.attr." + c, i, t[c])
				}
			}
			return i
		};
		v.parse = function (t) {
			var e = l.doc.createDocumentFragment(),
				i = true,
				n = l.doc.createElement("div");
			t = y(t);
			if (!t.match(/^\s*<\s*svg(?:\s|>)/)) {
				t = "<svg>" + t + "</svg>";
				i = false
			}
			n.innerHTML = t;
			t = n.getElementsByTagName("svg")[0];
			if (t) {
				if (i) {
					e = t
				} else {
					while (t.firstChild) {
						e.appendChild(t.firstChild)
					}
				}
			}
			return new st(e)
		};

		function st(t) {
			this.node = t
		}
		v.fragment = function () {
			var t = Array.prototype.slice.call(arguments, 0),
				e = l.doc.createDocumentFragment();
			for (var i = 0, n = t.length; i < n; i++) {
				var r = t[i];
				if (r.node && r.node.nodeType) {
					e.appendChild(r.node)
				}
				if (r.nodeType) {
					e.appendChild(r)
				}
				if (typeof r == "string") {
					e.appendChild(v.parse(r).node)
				}
			}
			return new st(e)
		};

		function lt(t, e) {
			var i = I(t);
			e.appendChild(i);
			var n = ut(i);
			return n
		}

		function ct(t, e) {
			var i, n, r, o = ct.prototype;
			if (t && t.tagName && t.tagName.toLowerCase() == "svg") {
				if (t.snap in k) {
					return k[t.snap]
				}
				var a = t.ownerDocument;
				i = new at(t);
				n = t.getElementsByTagName("desc")[0];
				r = t.getElementsByTagName("defs")[0];
				if (!n) {
					n = I("desc");
					n.appendChild(a.createTextNode("Created with Snap"));
					i.node.appendChild(n)
				}
				if (!r) {
					r = I("defs");
					i.node.appendChild(r)
				}
				i.defs = r;
				for (var s in o)
					if (o[u](s)) {
						i[s] = o[s]
					}
				i.paper = i.root = i
			} else {
				i = lt("svg", l.doc.body);
				I(i.node, {
					height: e,
					version: 1.1,
					width: t,
					xmlns: O
				})
			}
			return i
		}

		function ut(t) {
			if (!t) {
				return t
			}
			if (t instanceof at || t instanceof st) {
				return t
			}
			if (t.tagName && t.tagName.toLowerCase() == "svg") {
				return new ct(t)
			}
			if (t.tagName && t.tagName.toLowerCase() == "object" && t.type == "image/svg+xml") {
				return new ct(t.contentDocument.getElementsByTagName("svg")[0])
			}
			return new at(t)
		}
		v._.make = lt;
		v._.wrap = ut;
		ct.prototype.el = function (t, e) {
			var i = lt(t, this.node);
			e && i.attr(e);
			return i
		};
		at.prototype.children = function () {
			var t = [],
				e = this.node.childNodes;
			for (var i = 0, n = e.length; i < n; i++) {
				t[i] = v(e[i])
			}
			return t
		};

		function ht(t, e) {
			for (var i = 0, n = t.length; i < n; i++) {
				var r = {
						type: t[i].type,
						attr: t[i].attr()
					},
					o = t[i].children();
				e.push(r);
				if (o.length) {
					ht(o, r.childNodes = [])
				}
			}
		}
		at.prototype.toJSON = function () {
			var t = [];
			ht([this], t);
			return t[0]
		};
		pt.on("snap.util.getattr", function () {
			var t = pt.nt();
			t = t.substring(t.lastIndexOf(".") + 1);
			var e = t.replace(/[A-Z]/g, function (t) {
				return "-" + t.toLowerCase()
			});
			if (dt[u](e)) {
				return this.node.ownerDocument.defaultView.getComputedStyle(this.node, null).getPropertyValue(e)
			} else {
				return I(this.node, t)
			}
		});
		var dt = {
			"alignment-baseline": 0,
			"baseline-shift": 0,
			clip: 0,
			"clip-path": 0,
			"clip-rule": 0,
			color: 0,
			"color-interpolation": 0,
			"color-interpolation-filters": 0,
			"color-profile": 0,
			"color-rendering": 0,
			cursor: 0,
			direction: 0,
			display: 0,
			"dominant-baseline": 0,
			"enable-background": 0,
			fill: 0,
			"fill-opacity": 0,
			"fill-rule": 0,
			filter: 0,
			"flood-color": 0,
			"flood-opacity": 0,
			font: 0,
			"font-family": 0,
			"font-size": 0,
			"font-size-adjust": 0,
			"font-stretch": 0,
			"font-style": 0,
			"font-variant": 0,
			"font-weight": 0,
			"glyph-orientation-horizontal": 0,
			"glyph-orientation-vertical": 0,
			"image-rendering": 0,
			kerning: 0,
			"letter-spacing": 0,
			"lighting-color": 0,
			marker: 0,
			"marker-end": 0,
			"marker-mid": 0,
			"marker-start": 0,
			mask: 0,
			opacity: 0,
			overflow: 0,
			"pointer-events": 0,
			"shape-rendering": 0,
			"stop-color": 0,
			"stop-opacity": 0,
			stroke: 0,
			"stroke-dasharray": 0,
			"stroke-dashoffset": 0,
			"stroke-linecap": 0,
			"stroke-linejoin": 0,
			"stroke-miterlimit": 0,
			"stroke-opacity": 0,
			"stroke-width": 0,
			"text-anchor": 0,
			"text-decoration": 0,
			"text-rendering": 0,
			"unicode-bidi": 0,
			visibility: 0,
			"word-spacing": 0,
			"writing-mode": 0
		};
		pt.on("snap.util.attr", function (t) {
			var e = pt.nt(),
				i = {};
			e = e.substring(e.lastIndexOf(".") + 1);
			i[e] = t;
			var n = e.replace(/-(\w)/gi, function (t, e) {
					return e.toUpperCase()
				}),
				r = e.replace(/[A-Z]/g, function (t) {
					return "-" + t.toLowerCase()
				});
			if (dt[u](r)) {
				this.node.style[n] = t == null ? _ : t
			} else {
				I(this.node, i)
			}
		});
		(function (t) {})(ct.prototype);
		v.ajax = function (t, e, i, n) {
			var r = new XMLHttpRequest,
				o = L();
			if (r) {
				if (F(e, "function")) {
					n = i;
					i = e;
					e = null
				} else if (F(e, "object")) {
					var a = [];
					for (var s in e)
						if (e.hasOwnProperty(s)) {
							a.push(encodeURIComponent(s) + "=" + encodeURIComponent(e[s]))
						}
					e = a.join("&")
				}
				r.open(e ? "POST" : "GET", t, true);
				if (e) {
					r.setRequestHeader("X-Requested-With", "XMLHttpRequest");
					r.setRequestHeader("Content-type", "application/x-www-form-urlencoded")
				}
				if (i) {
					pt.once("snap.ajax." + o + ".0", i);
					pt.once("snap.ajax." + o + ".200", i);
					pt.once("snap.ajax." + o + ".304", i)
				}
				r.onreadystatechange = function () {
					if (r.readyState != 4) return;
					pt("snap.ajax." + o + "." + r.status, n, r)
				};
				if (r.readyState == 4) {
					return r
				}
				r.send(e);
				return r
			}
		};
		v.load = function (t, i, n) {
			v.ajax(t, function (t) {
				var e = v.parse(t.responseText);
				n ? i.call(n, e) : i(e)
			})
		};
		var ft = function (t) {
			var e = t.getBoundingClientRect(),
				i = t.ownerDocument,
				n = i.body,
				r = i.documentElement,
				o = r.clientTop || n.clientTop || 0,
				a = r.clientLeft || n.clientLeft || 0,
				s = e.top + (g.win.pageYOffset || r.scrollTop || n.scrollTop) - o,
				l = e.left + (g.win.pageXOffset || r.scrollLeft || n.scrollLeft) - a;
			return {
				y: s,
				x: l
			}
		};
		v.getElementByPoint = function (t, e) {
			var i = this,
				n = i.canvas,
				r = l.doc.elementFromPoint(t, e);
			if (l.win.opera && r.tagName == "svg") {
				var o = ft(r),
					a = r.createSVGRect();
				a.x = t - o.x;
				a.y = e - o.y;
				a.width = a.height = 1;
				var s = r.getIntersectionList(a, null);
				if (s.length) {
					r = s[s.length - 1]
				}
			}
			if (!r) {
				return null
			}
			return ut(r)
		};
		v.plugin = function (t) {
			t(v, at, ct, l, st)
		};
		l.win.Snap = v;
		return v
	}(E || this);
	t.plugin(function (p, t, e, i, n) {
		var r = t.prototype,
			s = p.is,
			u = String,
			o = p._unit2px,
			m = p._.$,
			l = p._.make,
			c = p._.getSomeDefs,
			a = "hasOwnProperty",
			h = p._.wrap;
		r.getBBox = function (t) {
			if (this.type == "tspan") {
				return p._.box(this.node.getClientRects().item(0))
			}
			if (!p.Matrix || !p.path) {
				return this.node.getBBox()
			}
			var e = this,
				i = new p.Matrix;
			if (e.removed) {
				return p._.box()
			}
			while (e.type == "use") {
				if (!t) {
					i = i.add(e.transform().localMatrix.translate(e.attr("x") || 0, e.attr("y") || 0))
				}
				if (e.original) {
					e = e.original
				} else {
					var n = e.attr("xlink:href");
					e = e.original = e.node.ownerDocument.getElementById(n.substring(n.indexOf("#") + 1))
				}
			}
			var r = e._,
				o = p.path.get[e.type] || p.path.get.deflt;
			try {
				if (t) {
					r.bboxwt = o ? p.path.getBBox(e.realPath = o(e)) : p._.box(e.node.getBBox());
					return p._.box(r.bboxwt)
				} else {
					e.realPath = o(e);
					e.matrix = e.transform().localMatrix;
					r.bbox = p.path.getBBox(p.path.map(e.realPath, i.add(e.matrix)));
					return p._.box(r.bbox)
				}
			} catch (t) {
				return p._.box()
			}
		};
		var d = function () {
			return this.string
		};

		function f(t, e) {
			if (e == null) {
				var i = true;
				if (t.type == "linearGradient" || t.type == "radialGradient") {
					e = t.node.getAttribute("gradientTransform")
				} else if (t.type == "pattern") {
					e = t.node.getAttribute("patternTransform")
				} else {
					e = t.node.getAttribute("transform")
				}
				if (!e) {
					return new p.Matrix
				}
				e = p._.svgTransform2string(e)
			} else {
				if (!p._.rgTransform.test(e)) {
					e = p._.svgTransform2string(e)
				} else {
					e = u(e).replace(/\.{3}|\u2026/g, t._.transform || "")
				}
				if (s(e, "array")) {
					e = p.path ? p.path.toString.call(e) : u(e)
				}
				t._.transform = e
			}
			var n = p._.transform2matrix(e, t.getBBox(1));
			if (i) {
				return n
			} else {
				t.matrix = n
			}
		}
		r.transform = function (t) {
			var e = this._;
			if (t == null) {
				var i = this,
					n = new p.Matrix(this.node.getCTM()),
					r = f(this),
					o = [r],
					a = new p.Matrix,
					s, l = r.toTransformString(),
					c = u(r) == u(this.matrix) ? u(e.transform) : l;
				while (i.type != "svg" && (i = i.parent())) {
					o.push(f(i))
				}
				s = o.length;
				while (s--) {
					a.add(o[s])
				}
				return {
					string: c,
					globalMatrix: n,
					totalMatrix: a,
					localMatrix: r,
					diffMatrix: n.clone().add(r.invert()),
					global: n.toTransformString(),
					total: a.toTransformString(),
					local: l,
					toString: d
				}
			}
			if (t instanceof p.Matrix) {
				this.matrix = t;
				this._.transform = t.toTransformString()
			} else {
				f(this, t)
			}
			if (this.node) {
				if (this.type == "linearGradient" || this.type == "radialGradient") {
					m(this.node, {
						gradientTransform: this.matrix
					})
				} else if (this.type == "pattern") {
					m(this.node, {
						patternTransform: this.matrix
					})
				} else {
					m(this.node, {
						transform: this.matrix
					})
				}
			}
			return this
		};
		r.parent = function () {
			return h(this.node.parentNode)
		};
		r.append = r.add = function (t) {
			if (t) {
				if (t.type == "set") {
					var e = this;
					t.forEach(function (t) {
						e.add(t)
					});
					return this
				}
				t = h(t);
				this.node.appendChild(t.node);
				t.paper = this.paper
			}
			return this
		};
		r.appendTo = function (t) {
			if (t) {
				t = h(t);
				t.append(this)
			}
			return this
		};
		r.prepend = function (t) {
			if (t) {
				if (t.type == "set") {
					var e = this,
						i;
					t.forEach(function (t) {
						if (i) {
							i.after(t)
						} else {
							e.prepend(t)
						}
						i = t
					});
					return this
				}
				t = h(t);
				var n = t.parent();
				this.node.insertBefore(t.node, this.node.firstChild);
				this.add && this.add();
				t.paper = this.paper;
				this.parent() && this.parent().add();
				n && n.add()
			}
			return this
		};
		r.prependTo = function (t) {
			t = h(t);
			t.prepend(this);
			return this
		};
		r.before = function (t) {
			if (t.type == "set") {
				var i = this;
				t.forEach(function (t) {
					var e = t.parent();
					i.node.parentNode.insertBefore(t.node, i.node);
					e && e.add()
				});
				this.parent().add();
				return this
			}
			t = h(t);
			var e = t.parent();
			this.node.parentNode.insertBefore(t.node, this.node);
			this.parent() && this.parent().add();
			e && e.add();
			t.paper = this.paper;
			return this
		};
		r.after = function (t) {
			t = h(t);
			var e = t.parent();
			if (this.node.nextSibling) {
				this.node.parentNode.insertBefore(t.node, this.node.nextSibling)
			} else {
				this.node.parentNode.appendChild(t.node)
			}
			this.parent() && this.parent().add();
			e && e.add();
			t.paper = this.paper;
			return this
		};
		r.insertBefore = function (t) {
			t = h(t);
			var e = this.parent();
			t.node.parentNode.insertBefore(this.node, t.node);
			this.paper = t.paper;
			e && e.add();
			t.parent() && t.parent().add();
			return this
		};
		r.insertAfter = function (t) {
			t = h(t);
			var e = this.parent();
			t.node.parentNode.insertBefore(this.node, t.node.nextSibling);
			this.paper = t.paper;
			e && e.add();
			t.parent() && t.parent().add();
			return this
		};
		r.remove = function () {
			var t = this.parent();
			this.node.parentNode && this.node.parentNode.removeChild(this.node);
			delete this.paper;
			this.removed = true;
			t && t.add();
			return this
		};
		r.select = function (t) {
			return h(this.node.querySelector(t))
		};
		r.selectAll = function (t) {
			var e = this.node.querySelectorAll(t),
				i = (p.set || Array)();
			for (var n = 0; n < e.length; n++) {
				i.push(h(e[n]))
			}
			return i
		};
		r.asPX = function (t, e) {
			if (e == null) {
				e = this.attr(t)
			}
			return +o(this, t, e)
		};
		r.use = function () {
			var t, e = this.node.id;
			if (!e) {
				e = this.id;
				m(this.node, {
					id: e
				})
			}
			if (this.type == "linearGradient" || this.type == "radialGradient" || this.type == "pattern") {
				t = l(this.type, this.node.parentNode)
			} else {
				t = l("use", this.node.parentNode)
			}
			m(t.node, {
				"xlink:href": "#" + e
			});
			t.original = this;
			return t
		};

		function g(t) {
			var e = t.selectAll("*"),
				i, r = /^\s*url\(("|'|)(.*)\1\)\s*$/,
				n = [],
				o = {};

			function a(i, n) {
				var t = m(i.node, n);
				t = t && t.match(r);
				t = t && t[2];
				if (t && t.charAt() == "#") {
					t = t.substring(1)
				} else {
					return
				}
				if (t) {
					o[t] = (o[t] || []).concat(function (t) {
						var e = {};
						e[n] = p.url(t);
						m(i.node, e)
					})
				}
			}

			function s(e) {
				var t = m(e.node, "xlink:href");
				if (t && t.charAt() == "#") {
					t = t.substring(1)
				} else {
					return
				}
				if (t) {
					o[t] = (o[t] || []).concat(function (t) {
						e.attr("xlink:href", "#" + t)
					})
				}
			}
			for (var l = 0, c = e.length; l < c; l++) {
				i = e[l];
				a(i, "fill");
				a(i, "stroke");
				a(i, "filter");
				a(i, "mask");
				a(i, "clip-path");
				s(i);
				var u = m(i.node, "id");
				if (u) {
					m(i.node, {
						id: i.id
					});
					n.push({
						old: u,
						id: i.id
					})
				}
			}
			for (l = 0, c = n.length; l < c; l++) {
				var h = o[n[l].old];
				if (h) {
					for (var d = 0, f = h.length; d < f; d++) {
						h[d](n[l].id)
					}
				}
			}
		}
		r.clone = function () {
			var t = h(this.node.cloneNode(true));
			if (m(t.node, "id")) {
				m(t.node, {
					id: t.id
				})
			}
			g(t);
			t.insertAfter(this);
			return t
		};
		r.toDefs = function () {
			var t = c(this);
			t.appendChild(this.node);
			return this
		};
		r.pattern = r.toPattern = function (t, e, i, n) {
			var r = l("pattern", c(this));
			if (t == null) {
				t = this.getBBox()
			}
			if (s(t, "object") && "x" in t) {
				e = t.y;
				i = t.width;
				n = t.height;
				t = t.x
			}
			m(r.node, {
				x: t,
				y: e,
				width: i,
				height: n,
				patternUnits: "userSpaceOnUse",
				id: r.id,
				viewBox: [t, e, i, n].join(" ")
			});
			r.node.appendChild(this.node);
			return r
		};
		r.marker = function (t, e, i, n, r, o) {
			var a = l("marker", c(this));
			if (t == null) {
				t = this.getBBox()
			}
			if (s(t, "object") && "x" in t) {
				e = t.y;
				i = t.width;
				n = t.height;
				r = t.refX || t.cx;
				o = t.refY || t.cy;
				t = t.x
			}
			m(a.node, {
				viewBox: [t, e, i, n].join(" "),
				markerWidth: i,
				markerHeight: n,
				orient: "auto",
				refX: r || 0,
				refY: o || 0,
				id: a.id
			});
			a.node.appendChild(this.node);
			return a
		};
		var v = {};
		r.data = function (t, e) {
			var i = v[this.id] = v[this.id] || {};
			if (arguments.length == 0) {
				pt("snap.data.get." + this.id, this, i, null);
				return i
			}
			if (arguments.length == 1) {
				if (p.is(t, "object")) {
					for (var n in t)
						if (t[a](n)) {
							this.data(n, t[n])
						}
					return this
				}
				pt("snap.data.get." + this.id, this, i[t], t);
				return i[t]
			}
			i[t] = e;
			pt("snap.data.set." + this.id, this, e, t);
			return this
		};
		r.removeData = function (t) {
			if (t == null) {
				v[this.id] = {}
			} else {
				v[this.id] && delete v[this.id][t]
			}
			return this
		};
		r.outerSVG = r.toString = y(1);
		r.innerSVG = y();

		function y(o) {
			return function () {
				var t = o ? "<" + this.type : "",
					e = this.node.attributes,
					i = this.node.childNodes;
				if (o) {
					for (var n = 0, r = e.length; n < r; n++) {
						t += " " + e[n].name + '="' + e[n].value.replace(/"/g, '\\"') + '"'
					}
				}
				if (i.length) {
					o && (t += ">");
					for (n = 0, r = i.length; n < r; n++) {
						if (i[n].nodeType == 3) {
							t += i[n].nodeValue
						} else if (i[n].nodeType == 1) {
							t += h(i[n]).toString()
						}
					}
					o && (t += "</" + this.type + ">")
				} else {
					o && (t += "/>")
				}
				return t
			}
		}
		r.toDataURL = function () {
			if (E && E.btoa) {
				var t = this.getBBox(),
					e = p.format('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="{width}" height="{height}" viewBox="{x} {y} {width} {height}">{contents}</svg>', {
						x: +t.x.toFixed(3),
						y: +t.y.toFixed(3),
						width: +t.width.toFixed(3),
						height: +t.height.toFixed(3),
						contents: this.outerSVG()
					});
				return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(e)))
			}
		};
		n.prototype.select = r.select;
		n.prototype.selectAll = r.selectAll
	});
	t.plugin(function (t, e, i, n, r) {
		var o = e.prototype,
			g = t.is,
			v = String,
			y = "hasOwnProperty";

		function x(i, n, r) {
			return function (t) {
				var e = t.slice(i, n);
				if (e.length == 1) {
					e = e[0]
				}
				return r ? r(e) : e
			}
		}
		var _ = function (t, e, i, n) {
			if (typeof i == "function" && !i.length) {
				n = i;
				i = b.linear
			}
			this.attr = t;
			this.dur = e;
			i && (this.easing = i);
			n && (this.callback = n)
		};
		t._.Animation = _;
		t.animation = function (t, e, i, n) {
			return new _(t, e, i, n)
		};
		o.inAnim = function () {
			var t = this,
				i = [];
			for (var e in t.anims)
				if (t.anims[y](e)) {
					(function (e) {
						i.push({
							anim: new _(e._attrs, e.dur, e.easing, e._callback),
							mina: e,
							curStatus: e.status(),
							status: function (t) {
								return e.status(t)
							},
							stop: function () {
								e.stop()
							}
						})
					})(t.anims[e])
				}
			return i
		};
		t.animate = function (t, e, i, n, r, o) {
			if (typeof r == "function" && !r.length) {
				o = r;
				r = b.linear
			}
			var a = b.time(),
				s = b(t, e, a, a + n, b.time, i, r);
			o && pt.once("mina.finish." + s.id, o);
			return s
		};
		o.stop = function () {
			var t = this.inAnim();
			for (var e = 0, i = t.length; e < i; e++) {
				t[e].stop()
			}
			return this
		};
		o.animate = function (t, e, i, n) {
			if (typeof i == "function" && !i.length) {
				n = i;
				i = b.linear
			}
			if (t instanceof _) {
				n = t.callback;
				i = t.easing;
				e = t.dur;
				t = t.attr
			}
			var r = [],
				o = [],
				a = {},
				s, l, c, u, h = this;
			for (var d in t)
				if (t[y](d)) {
					if (h.equal) {
						u = h.equal(d, v(t[d]));
						s = u.from;
						l = u.to;
						c = u.f
					} else {
						s = +h.attr(d);
						l = +t[d]
					}
					var f = g(s, "array") ? s.length : 1;
					a[d] = x(r.length, r.length + f, c);
					r = r.concat(s);
					o = o.concat(l)
				}
			var p = b.time(),
				m = b(r, o, p, p + e, b.time, function (t) {
					var e = {};
					for (var i in a)
						if (a[y](i)) {
							e[i] = a[i](t)
						}
					h.attr(e)
				}, i);
			h.anims[m.id] = m;
			m._attrs = t;
			m._callback = n;
			pt("snap.animcreated." + h.id, m);
			pt.once("mina.finish." + m.id, function () {
				pt.off("mina.*." + m.id);
				delete h.anims[m.id];
				n && n.call(h)
			});
			pt.once("mina.stop." + m.id, function () {
				pt.off("mina.*." + m.id);
				delete h.anims[m.id]
			});
			return h
		}
	});
	t.plugin(function (a, t, e, i, n) {
		var s = Object.prototype.toString,
			l = String,
			c = Math,
			u = "";

		function h(t, e, i, n, r, o) {
			if (e == null && s.call(t) == "[object SVGMatrix]") {
				this.a = t.a;
				this.b = t.b;
				this.c = t.c;
				this.d = t.d;
				this.e = t.e;
				this.f = t.f;
				return
			}
			if (t != null) {
				this.a = +t;
				this.b = +e;
				this.c = +i;
				this.d = +n;
				this.e = +r;
				this.f = +o
			} else {
				this.a = 1;
				this.b = 0;
				this.c = 0;
				this.d = 1;
				this.e = 0;
				this.f = 0
			}
		}(function (t) {
			t.add = function (t, e, i, n, r, o) {
				if (t && t instanceof h) {
					return this.add(t.a, t.b, t.c, t.d, t.e, t.f)
				}
				var a = t * this.a + e * this.c,
					s = t * this.b + e * this.d;
				this.e += r * this.a + o * this.c;
				this.f += r * this.b + o * this.d;
				this.c = i * this.a + n * this.c;
				this.d = i * this.b + n * this.d;
				this.a = a;
				this.b = s;
				return this
			};
			h.prototype.multLeft = function (t, e, i, n, r, o) {
				if (t && t instanceof h) {
					return this.multLeft(t.a, t.b, t.c, t.d, t.e, t.f)
				}
				var a = t * this.a + i * this.b,
					s = t * this.c + i * this.d,
					l = t * this.e + i * this.f + r;
				this.b = e * this.a + n * this.b;
				this.d = e * this.c + n * this.d;
				this.f = e * this.e + n * this.f + o;
				this.a = a;
				this.c = s;
				this.e = l;
				return this
			};
			t.invert = function () {
				var t = this,
					e = t.a * t.d - t.b * t.c;
				return new h(t.d / e, -t.b / e, -t.c / e, t.a / e, (t.c * t.f - t.d * t.e) / e, (t.b * t.e - t.a * t.f) / e)
			};
			t.clone = function () {
				return new h(this.a, this.b, this.c, this.d, this.e, this.f)
			};
			t.translate = function (t, e) {
				this.e += t * this.a + e * this.c;
				this.f += t * this.b + e * this.d;
				return this
			};
			t.scale = function (t, e, i, n) {
				e == null && (e = t);
				(i || n) && this.translate(i, n);
				this.a *= t;
				this.b *= t;
				this.c *= e;
				this.d *= e;
				(i || n) && this.translate(-i, -n);
				return this
			};
			t.rotate = function (t, e, i) {
				t = a.rad(t);
				e = e || 0;
				i = i || 0;
				var n = +c.cos(t).toFixed(9),
					r = +c.sin(t).toFixed(9);
				this.add(n, r, -r, n, e, i);
				return this.add(1, 0, 0, 1, -e, -i)
			};
			t.skewX = function (t) {
				return this.skew(t, 0)
			};
			t.skewY = function (t) {
				return this.skew(0, t)
			};
			t.skew = function (t, e) {
				t = t || 0;
				e = e || 0;
				t = a.rad(t);
				e = a.rad(e);
				var i = c.tan(t).toFixed(9);
				var n = c.tan(e).toFixed(9);
				return this.add(1, n, i, 1, 0, 0)
			};
			t.x = function (t, e) {
				return t * this.a + e * this.c + this.e
			};
			t.y = function (t, e) {
				return t * this.b + e * this.d + this.f
			};
			t.get = function (t) {
				return +this[l.fromCharCode(97 + t)].toFixed(4)
			};
			t.toString = function () {
				return "matrix(" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)].join() + ")"
			};
			t.offset = function () {
				return [this.e.toFixed(4), this.f.toFixed(4)]
			};

			function r(t) {
				return t[0] * t[0] + t[1] * t[1]
			}

			function o(t) {
				var e = c.sqrt(r(t));
				t[0] && (t[0] /= e);
				t[1] && (t[1] /= e)
			}
			t.determinant = function () {
				return this.a * this.d - this.b * this.c
			};
			t.split = function () {
				var t = {};
				t.dx = this.e;
				t.dy = this.f;
				var e = [
					[this.a, this.b],
					[this.c, this.d]
				];
				t.scalex = c.sqrt(r(e[0]));
				o(e[0]);
				t.shear = e[0][0] * e[1][0] + e[0][1] * e[1][1];
				e[1] = [e[1][0] - e[0][0] * t.shear, e[1][1] - e[0][1] * t.shear];
				t.scaley = c.sqrt(r(e[1]));
				o(e[1]);
				t.shear /= t.scaley;
				if (this.determinant() < 0) {
					t.scalex = -t.scalex
				}
				var i = e[0][1],
					n = e[1][1];
				if (n < 0) {
					t.rotate = a.deg(c.acos(n));
					if (i < 0) {
						t.rotate = 360 - t.rotate
					}
				} else {
					t.rotate = a.deg(c.asin(i))
				}
				t.isSimple = !+t.shear.toFixed(9) && (t.scalex.toFixed(9) == t.scaley.toFixed(9) || !t.rotate);
				t.isSuperSimple = !+t.shear.toFixed(9) && t.scalex.toFixed(9) == t.scaley.toFixed(9) && !t.rotate;
				t.noRotation = !+t.shear.toFixed(9) && !t.rotate;
				return t
			};
			t.toTransformString = function (t) {
				var e = t || this.split();
				if (!+e.shear.toFixed(9)) {
					e.scalex = +e.scalex.toFixed(4);
					e.scaley = +e.scaley.toFixed(4);
					e.rotate = +e.rotate.toFixed(4);
					return (e.dx || e.dy ? "t" + [+e.dx.toFixed(4), +e.dy.toFixed(4)] : u) + (e.rotate ? "r" + [+e.rotate.toFixed(4), 0, 0] : u) + (e.scalex != 1 || e.scaley != 1 ? "s" + [e.scalex, e.scaley, 0, 0] : u)
				} else {
					return "m" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)]
				}
			}
		})(h.prototype);
		a.Matrix = h;
		a.matrix = function (t, e, i, n, r, o) {
			return new h(t, e, i, n, r, o)
		}
	});
	t.plugin(function (o, a, t, s, l) {
		var e = "hasOwnProperty",
			n = o._.make,
			c = o._.wrap,
			u = o.is,
			h = o._.getSomeDefs,
			i = /^url\((['"]?)([^)]+)\1\)$/,
			d = o._.$,
			f = o.url,
			p = String,
			r = o._.separator,
			m = "";
		o.deurl = function (t) {
			var e = String(t).match(i);
			return e ? e[2] : t
		};
		pt.on("snap.util.attr.mask", function (t) {
			if (t instanceof a || t instanceof l) {
				pt.stop();
				if (t instanceof l && t.node.childNodes.length == 1) {
					t = t.node.firstChild;
					h(this).appendChild(t);
					t = c(t)
				}
				if (t.type == "mask") {
					var e = t
				} else {
					e = n("mask", h(this));
					e.node.appendChild(t.node)
				}!e.node.id && d(e.node, {
					id: e.id
				});
				d(this.node, {
					mask: f(e.id)
				})
			}
		});
		(function (t) {
			pt.on("snap.util.attr.clip", t);
			pt.on("snap.util.attr.clip-path", t);
			pt.on("snap.util.attr.clipPath", t)
		})(function (t) {
			if (t instanceof a || t instanceof l) {
				pt.stop();
				var e, i = t.node;
				while (i) {
					if (i.nodeName === "clipPath") {
						e = new a(i);
						break
					}
					if (i.nodeName === "svg") {
						e = undefined;
						break
					}
					i = i.parentNode
				}
				if (!e) {
					e = n("clipPath", h(this));
					e.node.appendChild(t.node);
					!e.node.id && d(e.node, {
						id: e.id
					})
				}
				d(this.node, {
					"clip-path": f(e.node.id || e.id)
				})
			}
		});

		function g(r) {
			return function (t) {
				pt.stop();
				if (t instanceof l && t.node.childNodes.length == 1 && (t.node.firstChild.tagName == "radialGradient" || t.node.firstChild.tagName == "linearGradient" || t.node.firstChild.tagName == "pattern")) {
					t = t.node.firstChild;
					h(this).appendChild(t);
					t = c(t)
				}
				if (t instanceof a) {
					if (t.type == "radialGradient" || t.type == "linearGradient" || t.type == "pattern") {
						if (!t.node.id) {
							d(t.node, {
								id: t.id
							})
						}
						var e = f(t.node.id)
					} else {
						e = t.attr(r)
					}
				} else {
					e = o.color(t);
					if (e.error) {
						var i = o(h(this).ownerSVGElement).gradient(t);
						if (i) {
							if (!i.node.id) {
								d(i.node, {
									id: i.id
								})
							}
							e = f(i.node.id)
						} else {
							e = t
						}
					} else {
						e = p(e)
					}
				}
				var n = {};
				n[r] = e;
				d(this.node, n);
				this.node.style[r] = m
			}
		}
		pt.on("snap.util.attr.fill", g("fill"));
		pt.on("snap.util.attr.stroke", g("stroke"));
		var v = /^([lr])(?:\(([^)]*)\))?(.*)$/i;
		pt.on("snap.util.grad.parse", function t(e) {
			e = p(e);
			var i = e.match(v);
			if (!i) {
				return null
			}
			var n = i[1],
				r = i[2],
				o = i[3];
			r = r.split(/\s*,\s*/).map(function (t) {
				return +t == t ? +t : t
			});
			if (r.length == 1 && r[0] == 0) {
				r = []
			}
			o = o.split("-");
			o = o.map(function (t) {
				t = t.split(":");
				var e = {
					color: t[0]
				};
				if (t[1]) {
					e.offset = parseFloat(t[1])
				}
				return e
			});
			var a = o.length,
				s = 0,
				l = 0;

			function c(t, e) {
				var i = (e - s) / (t - l);
				for (var n = l; n < t; n++) {
					o[n].offset = +(+s + i * (n - l)).toFixed(2)
				}
				l = t;
				s = e
			}
			a--;
			for (var u = 0; u < a; u++)
				if ("offset" in o[u]) {
					c(u, o[u].offset)
				}
			o[a].offset = o[a].offset || 100;
			c(a, o[a].offset);
			return {
				type: n,
				params: r,
				stops: o
			}
		});
		pt.on("snap.util.attr.d", function (t) {
			pt.stop();
			if (u(t, "array") && u(t[0], "array")) {
				t = o.path.toString.call(t)
			}
			t = p(t);
			if (t.match(/[ruo]/i)) {
				t = o.path.toAbsolute(t)
			}
			d(this.node, {
				d: t
			})
		})(-1);
		pt.on("snap.util.attr.#text", function (t) {
			pt.stop();
			t = p(t);
			var e = s.doc.createTextNode(t);
			while (this.node.firstChild) {
				this.node.removeChild(this.node.firstChild)
			}
			this.node.appendChild(e)
		})(-1);
		pt.on("snap.util.attr.path", function (t) {
			pt.stop();
			this.attr({
				d: t
			})
		})(-1);
		pt.on("snap.util.attr.class", function (t) {
			pt.stop();
			this.node.className.baseVal = t
		})(-1);
		pt.on("snap.util.attr.viewBox", function (t) {
			var e;
			if (u(t, "object") && "x" in t) {
				e = [t.x, t.y, t.width, t.height].join(" ")
			} else if (u(t, "array")) {
				e = t.join(" ")
			} else {
				e = t
			}
			d(this.node, {
				viewBox: e
			});
			pt.stop()
		})(-1);
		pt.on("snap.util.attr.transform", function (t) {
			this.transform(t);
			pt.stop()
		})(-1);
		pt.on("snap.util.attr.r", function (t) {
			if (this.type == "rect") {
				pt.stop();
				d(this.node, {
					rx: t,
					ry: t
				})
			}
		})(-1);
		pt.on("snap.util.attr.textpath", function (t) {
			pt.stop();
			if (this.type == "text") {
				var e, i, n;
				if (!t && this.textPath) {
					i = this.textPath;
					while (i.node.firstChild) {
						this.node.appendChild(i.node.firstChild)
					}
					i.remove();
					delete this.textPath;
					return
				}
				if (u(t, "string")) {
					var r = h(this),
						o = c(r.parentNode).path(t);
					r.appendChild(o.node);
					e = o.id;
					o.attr({
						id: e
					})
				} else {
					t = c(t);
					if (t instanceof a) {
						e = t.attr("id");
						if (!e) {
							e = t.id;
							t.attr({
								id: e
							})
						}
					}
				}
				if (e) {
					i = this.textPath;
					n = this.node;
					if (i) {
						i.attr({
							"xlink:href": "#" + e
						})
					} else {
						i = d("textPath", {
							"xlink:href": "#" + e
						});
						while (n.firstChild) {
							i.appendChild(n.firstChild)
						}
						n.appendChild(i);
						this.textPath = c(i)
					}
				}
			}
		})(-1);
		pt.on("snap.util.attr.text", function (t) {
			if (this.type == "text") {
				var e = 0,
					i = this.node,
					n = function (t) {
						var e = d("tspan");
						if (u(t, "array")) {
							for (var i = 0; i < t.length; i++) {
								e.appendChild(n(t[i]))
							}
						} else {
							e.appendChild(s.doc.createTextNode(t))
						}
						e.normalize && e.normalize();
						return e
					};
				while (i.firstChild) {
					i.removeChild(i.firstChild)
				}
				var r = n(t);
				while (r.firstChild) {
					i.appendChild(r.firstChild)
				}
			}
			pt.stop()
		})(-1);

		function y(t) {
			pt.stop();
			if (t == +t) {
				t += "px"
			}
			this.node.style.fontSize = t
		}
		pt.on("snap.util.attr.fontSize", y)(-1);
		pt.on("snap.util.attr.font-size", y)(-1);
		pt.on("snap.util.getattr.transform", function () {
			pt.stop();
			return this.transform()
		})(-1);
		pt.on("snap.util.getattr.textpath", function () {
			pt.stop();
			return this.textPath
		})(-1);
		(function () {
			function t(e) {
				return function () {
					pt.stop();
					var t = s.doc.defaultView.getComputedStyle(this.node, null).getPropertyValue("marker-" + e);
					if (t == "none") {
						return t
					} else {
						return o(s.doc.getElementById(t.match(i)[1]))
					}
				}
			}

			function e(n) {
				return function (t) {
					pt.stop();
					var e = "marker" + n.charAt(0).toUpperCase() + n.substring(1);
					if (t == "" || !t) {
						this.node.style[e] = "none";
						return
					}
					if (t.type == "marker") {
						var i = t.node.id;
						if (!i) {
							d(t.node, {
								id: t.id
							})
						}
						this.node.style[e] = f(i);
						return
					}
				}
			}
			pt.on("snap.util.getattr.marker-end", t("end"))(-1);
			pt.on("snap.util.getattr.markerEnd", t("end"))(-1);
			pt.on("snap.util.getattr.marker-start", t("start"))(-1);
			pt.on("snap.util.getattr.markerStart", t("start"))(-1);
			pt.on("snap.util.getattr.marker-mid", t("mid"))(-1);
			pt.on("snap.util.getattr.markerMid", t("mid"))(-1);
			pt.on("snap.util.attr.marker-end", e("end"))(-1);
			pt.on("snap.util.attr.markerEnd", e("end"))(-1);
			pt.on("snap.util.attr.marker-start", e("start"))(-1);
			pt.on("snap.util.attr.markerStart", e("start"))(-1);
			pt.on("snap.util.attr.marker-mid", e("mid"))(-1);
			pt.on("snap.util.attr.markerMid", e("mid"))(-1)
		})();
		pt.on("snap.util.getattr.r", function () {
			if (this.type == "rect" && d(this.node, "rx") == d(this.node, "ry")) {
				pt.stop();
				return d(this.node, "rx")
			}
		})(-1);

		function x(t) {
			var e = [];
			var i = t.childNodes;
			for (var n = 0, r = i.length; n < r; n++) {
				var o = i[n];
				if (o.nodeType == 3) {
					e.push(o.nodeValue)
				}
				if (o.tagName == "tspan") {
					if (o.childNodes.length == 1 && o.firstChild.nodeType == 3) {
						e.push(o.firstChild.nodeValue)
					} else {
						e.push(x(o))
					}
				}
			}
			return e
		}
		pt.on("snap.util.getattr.text", function () {
			if (this.type == "text" || this.type == "tspan") {
				pt.stop();
				var t = x(this.node);
				return t.length == 1 ? t[0] : t
			}
		})(-1);
		pt.on("snap.util.getattr.#text", function () {
			return this.node.textContent
		})(-1);
		pt.on("snap.util.getattr.fill", function (t) {
			if (t) {
				return
			}
			pt.stop();
			var e = pt("snap.util.getattr.fill", this, true).firstDefined();
			return o(o.deurl(e)) || e
		})(-1);
		pt.on("snap.util.getattr.stroke", function (t) {
			if (t) {
				return
			}
			pt.stop();
			var e = pt("snap.util.getattr.stroke", this, true).firstDefined();
			return o(o.deurl(e)) || e
		})(-1);
		pt.on("snap.util.getattr.viewBox", function () {
			pt.stop();
			var t = d(this.node, "viewBox");
			if (t) {
				t = t.split(r);
				return o._.box(+t[0], +t[1], +t[2], +t[3])
			} else {
				return
			}
		})(-1);
		pt.on("snap.util.getattr.points", function () {
			var t = d(this.node, "points");
			pt.stop();
			if (t) {
				return t.split(r)
			} else {
				return
			}
		})(-1);
		pt.on("snap.util.getattr.path", function () {
			var t = d(this.node, "d");
			pt.stop();
			return t
		})(-1);
		pt.on("snap.util.getattr.class", function () {
			return this.node.className.baseVal
		})(-1);

		function _() {
			pt.stop();
			return this.node.style.fontSize
		}
		pt.on("snap.util.getattr.fontSize", _)(-1);
		pt.on("snap.util.getattr.font-size", _)(-1)
	});
	t.plugin(function (t, e, i, n, r) {
		var u = /\S+/g,
			o = /[\t\r\n\f]/g,
			a = /(^\s+|\s+$)/g,
			c = String,
			s = e.prototype;
		s.addClass = function (t) {
			var e = c(t || "").match(u) || [],
				i = this.node,
				n = i.className.baseVal,
				r = n.match(u) || [],
				o, a, s, l;
			if (e.length) {
				o = 0;
				while (s = e[o++]) {
					a = r.indexOf(s);
					if (!~a) {
						r.push(s)
					}
				}
				l = r.join(" ");
				if (n != l) {
					i.className.baseVal = l
				}
			}
			return this
		};
		s.removeClass = function (t) {
			var e = c(t || "").match(u) || [],
				i = this.node,
				n = i.className.baseVal,
				r = n.match(u) || [],
				o, a, s, l;
			if (r.length) {
				o = 0;
				while (s = e[o++]) {
					a = r.indexOf(s);
					if (~a) {
						r.splice(a, 1)
					}
				}
				l = r.join(" ");
				if (n != l) {
					i.className.baseVal = l
				}
			}
			return this
		};
		s.hasClass = function (t) {
			var e = this.node,
				i = e.className.baseVal,
				n = i.match(u) || [];
			return !!~n.indexOf(t)
		};
		s.toggleClass = function (t, e) {
			if (e != null) {
				if (e) {
					return this.addClass(t)
				} else {
					return this.removeClass(t)
				}
			}
			var i = (t || "").match(u) || [],
				n = this.node,
				r = n.className.baseVal,
				o = r.match(u) || [],
				a, s, l, c;
			a = 0;
			while (l = i[a++]) {
				s = o.indexOf(l);
				if (~s) {
					o.splice(s, 1)
				} else {
					o.push(l)
				}
			}
			c = o.join(" ");
			if (r != c) {
				n.className.baseVal = c
			}
			return this
		}
	});
	t.plugin(function (t, e, i, n, r) {
		var u = {
				"+": function (t, e) {
					return t + e
				},
				"-": function (t, e) {
					return t - e
				},
				"/": function (t, e) {
					return t / e
				},
				"*": function (t, e) {
					return t * e
				}
			},
			h = String,
			d = /[a-z]+$/i,
			f = /^\s*([+\-\/*])\s*=\s*([\d.eE+\-]+)\s*([^\d\s]+)?\s*$/;

		function p(t) {
			return t
		}

		function m(e) {
			return function (t) {
				return +t.toFixed(3) + e
			}
		}
		pt.on("snap.util.attr", function (t) {
			var e = h(t).match(f);
			if (e) {
				var i = pt.nt(),
					n = i.substring(i.lastIndexOf(".") + 1),
					r = this.attr(n),
					o = {};
				pt.stop();
				var a = e[3] || "",
					s = r.match(d),
					l = u[e[1]];
				if (s && s == a) {
					t = l(parseFloat(r), +e[2])
				} else {
					r = this.asPX(n);
					t = l(this.asPX(n), this.asPX(n, e[2] + a))
				}
				if (isNaN(r) || isNaN(t)) {
					return
				}
				o[n] = t;
				this.attr(o)
			}
		})(-10);
		pt.on("snap.util.equal", function (t, e) {
			var i, n, r = h(this.attr(t) || ""),
				o = this,
				a = h(e).match(f);
			if (a) {
				pt.stop();
				var s = a[3] || "",
					l = r.match(d),
					c = u[a[1]];
				if (l && l == s) {
					return {
						from: parseFloat(r),
						to: c(parseFloat(r), +a[2]),
						f: m(l)
					}
				} else {
					r = this.asPX(t);
					return {
						from: r,
						to: c(r, this.asPX(t, a[2] + s)),
						f: p
					}
				}
			}
		})(-10)
	});
	t.plugin(function (f, e, t, o, i) {
		var n = t.prototype,
			c = f.is;
		n.rect = function (t, e, i, n, r, o) {
			var a;
			if (o == null) {
				o = r
			}
			if (c(t, "object") && t == "[object Object]") {
				a = t
			} else if (t != null) {
				a = {
					x: t,
					y: e,
					width: i,
					height: n
				};
				if (r != null) {
					a.rx = r;
					a.ry = o
				}
			}
			return this.el("rect", a)
		};
		n.circle = function (t, e, i) {
			var n;
			if (c(t, "object") && t == "[object Object]") {
				n = t
			} else if (t != null) {
				n = {
					cx: t,
					cy: e,
					r: i
				}
			}
			return this.el("circle", n)
		};
		var s = function () {
			function r() {
				this.parentNode.removeChild(this)
			}
			return function (t, e) {
				var i = o.doc.createElement("img"),
					n = o.doc.body;
				i.style.cssText = "position:absolute;left:-9999em;top:-9999em";
				i.onload = function () {
					e.call(i);
					i.onload = i.onerror = null;
					n.removeChild(i)
				};
				i.onerror = r;
				n.appendChild(i);
				i.src = t
			}
		}();
		n.image = function (t, e, i, n, r) {
			var o = this.el("image");
			if (c(t, "object") && "src" in t) {
				o.attr(t)
			} else if (t != null) {
				var a = {
					"xlink:href": t,
					preserveAspectRatio: "none"
				};
				if (e != null && i != null) {
					a.x = e;
					a.y = i
				}
				if (n != null && r != null) {
					a.width = n;
					a.height = r
				} else {
					s(t, function () {
						f._.$(o.node, {
							width: this.offsetWidth,
							height: this.offsetHeight
						})
					})
				}
				f._.$(o.node, a)
			}
			return o
		};
		n.ellipse = function (t, e, i, n) {
			var r;
			if (c(t, "object") && t == "[object Object]") {
				r = t
			} else if (t != null) {
				r = {
					cx: t,
					cy: e,
					rx: i,
					ry: n
				}
			}
			return this.el("ellipse", r)
		};
		n.path = function (t) {
			var e;
			if (c(t, "object") && !c(t, "array")) {
				e = t
			} else if (t) {
				e = {
					d: t
				}
			}
			return this.el("path", e)
		};
		n.group = n.g = function (t) {
			var e, i = this.el("g");
			if (arguments.length == 1 && t && !t.type) {
				i.attr(t)
			} else if (arguments.length) {
				i.add(Array.prototype.slice.call(arguments, 0))
			}
			return i
		};
		n.svg = function (t, e, i, n, r, o, a, s) {
			var l = {};
			if (c(t, "object") && e == null) {
				l = t
			} else {
				if (t != null) {
					l.x = t
				}
				if (e != null) {
					l.y = e
				}
				if (i != null) {
					l.width = i
				}
				if (n != null) {
					l.height = n
				}
				if (r != null && o != null && a != null && s != null) {
					l.viewBox = [r, o, a, s]
				}
			}
			return this.el("svg", l)
		};
		n.mask = function (t) {
			var e, i = this.el("mask");
			if (arguments.length == 1 && t && !t.type) {
				i.attr(t)
			} else if (arguments.length) {
				i.add(Array.prototype.slice.call(arguments, 0))
			}
			return i
		};
		n.ptrn = function (t, e, i, n, r, o, a, s) {
			if (c(t, "object")) {
				var l = t
			} else {
				l = {
					patternUnits: "userSpaceOnUse"
				};
				if (t) {
					l.x = t
				}
				if (e) {
					l.y = e
				}
				if (i != null) {
					l.width = i
				}
				if (n != null) {
					l.height = n
				}
				if (r != null && o != null && a != null && s != null) {
					l.viewBox = [r, o, a, s]
				} else {
					l.viewBox = [t || 0, e || 0, i || 0, n || 0]
				}
			}
			return this.el("pattern", l)
		};
		n.use = function (t) {
			if (t != null) {
				if (t instanceof e) {
					if (!t.attr("id")) {
						t.attr({
							id: f._.id(t)
						})
					}
					t = t.attr("id")
				}
				if (String(t).charAt() == "#") {
					t = t.substring(1)
				}
				return this.el("use", {
					"xlink:href": "#" + t
				})
			} else {
				return e.prototype.use.call(this)
			}
		};
		n.symbol = function (t, e, i, n) {
			var r = {};
			if (t != null && e != null && i != null && n != null) {
				r.viewBox = [t, e, i, n]
			}
			return this.el("symbol", r)
		};
		n.text = function (t, e, i) {
			var n = {};
			if (c(t, "object")) {
				n = t
			} else if (t != null) {
				n = {
					x: t,
					y: e,
					text: i || ""
				}
			}
			return this.el("text", n)
		};
		n.line = function (t, e, i, n) {
			var r = {};
			if (c(t, "object")) {
				r = t
			} else if (t != null) {
				r = {
					x1: t,
					x2: i,
					y1: e,
					y2: n
				}
			}
			return this.el("line", r)
		};
		n.polyline = function (t) {
			if (arguments.length > 1) {
				t = Array.prototype.slice.call(arguments, 0)
			}
			var e = {};
			if (c(t, "object") && !c(t, "array")) {
				e = t
			} else if (t != null) {
				e = {
					points: t
				}
			}
			return this.el("polyline", e)
		};
		n.polygon = function (t) {
			if (arguments.length > 1) {
				t = Array.prototype.slice.call(arguments, 0)
			}
			var e = {};
			if (c(t, "object") && !c(t, "array")) {
				e = t
			} else if (t != null) {
				e = {
					points: t
				}
			}
			return this.el("polygon", e)
		};
		(function () {
			var l = f._.$;

			function s() {
				return this.selectAll("stop")
			}

			function c(t, e) {
				var i = l("stop"),
					n = {
						offset: +e + "%"
					};
				t = f.color(t);
				n["stop-color"] = t.hex;
				if (t.opacity < 1) {
					n["stop-opacity"] = t.opacity
				}
				l(i, n);
				var r = this.stops(),
					o;
				for (var a = 0; a < r.length; a++) {
					var s = parseFloat(r[a].attr("offset"));
					if (s > e) {
						this.node.insertBefore(i, r[a].node);
						o = true;
						break
					}
				}
				if (!o) {
					this.node.appendChild(i)
				}
				return this
			}

			function u() {
				if (this.type == "linearGradient") {
					var t = l(this.node, "x1") || 0,
						e = l(this.node, "x2") || 1,
						i = l(this.node, "y1") || 0,
						n = l(this.node, "y2") || 0;
					return f._.box(t, i, math.abs(e - t), math.abs(n - i))
				} else {
					var r = this.node.cx || .5,
						o = this.node.cy || .5,
						a = this.node.r || 0;
					return f._.box(r - a, o - a, a * 2, a * 2)
				}
			}

			function a(t) {
				var e = t,
					i = this.stops();
				if (typeof t == "string") {
					e = pt("snap.util.grad.parse", null, "l(0,0,0,1)" + t).firstDefined().stops
				}
				if (!f.is(e, "array")) {
					return
				}
				for (var n = 0; n < i.length; n++) {
					if (e[n]) {
						var r = f.color(e[n].color),
							o = {
								offset: e[n].offset + "%"
							};
						o["stop-color"] = r.hex;
						if (r.opacity < 1) {
							o["stop-opacity"] = r.opacity
						}
						i[n].attr(o)
					} else {
						i[n].remove()
					}
				}
				for (n = i.length; n < e.length; n++) {
					this.addStop(e[n].color, e[n].offset)
				}
				return this
			}

			function e(t, e) {
				var i = pt("snap.util.grad.parse", null, e).firstDefined(),
					n;
				if (!i) {
					return null
				}
				i.params.unshift(t);
				if (i.type.toLowerCase() == "l") {
					n = h.apply(0, i.params)
				} else {
					n = d.apply(0, i.params)
				}
				if (i.type != i.type.toLowerCase()) {
					l(n.node, {
						gradientUnits: "userSpaceOnUse"
					})
				}
				var r = i.stops,
					o = r.length;
				for (var a = 0; a < o; a++) {
					var s = r[a];
					n.addStop(s.color, s.offset)
				}
				return n
			}

			function h(t, e, i, n, r) {
				var o = f._.make("linearGradient", t);
				o.stops = s;
				o.addStop = c;
				o.getBBox = u;
				o.setStops = a;
				if (e != null) {
					l(o.node, {
						x1: e,
						y1: i,
						x2: n,
						y2: r
					})
				}
				return o
			}

			function d(t, e, i, n, r, o) {
				var a = f._.make("radialGradient", t);
				a.stops = s;
				a.addStop = c;
				a.getBBox = u;
				if (e != null) {
					l(a.node, {
						cx: e,
						cy: i,
						r: n
					})
				}
				if (r != null && o != null) {
					l(a.node, {
						fx: r,
						fy: o
					})
				}
				return a
			}
			n.gradient = function (t) {
				return e(this.defs, t)
			};
			n.gradientLinear = function (t, e, i, n) {
				return h(this.defs, t, e, i, n)
			};
			n.gradientRadial = function (t, e, i, n, r) {
				return d(this.defs, t, e, i, n, r)
			};
			n.toString = function () {
				var t = this.node.ownerDocument,
					e = t.createDocumentFragment(),
					i = t.createElement("div"),
					n = this.node.cloneNode(true),
					r;
				e.appendChild(i);
				i.appendChild(n);
				f._.$(n, {
					xmlns: "http://www.w3.org/2000/svg"
				});
				r = i.innerHTML;
				e.removeChild(e.firstChild);
				return r
			};
			n.toDataURL = function () {
				if (E && E.btoa) {
					return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(this)))
				}
			};
			n.clear = function () {
				var t = this.node.firstChild,
					e;
				while (t) {
					e = t.nextSibling;
					if (t.tagName != "defs") {
						t.parentNode.removeChild(t)
					} else {
						n.clear.call({
							node: t
						})
					}
					t = e
				}
			}
		})()
	});
	t.plugin(function (W, g, t, e) {
		var i = g.prototype,
			x = W.is,
			m = W._.clone,
			n = "hasOwnProperty",
			r = /,?([a-z]),?/gi,
			_ = parseFloat,
			X = Math,
			Y = X.PI,
			E = X.min,
			S = X.max,
			M = X.pow,
			q = X.abs;

		function b(e) {
			var i = b.ps = b.ps || {};
			if (i[e]) {
				i[e].sleep = 100
			} else {
				i[e] = {
					sleep: 100
				}
			}
			setTimeout(function () {
				for (var t in i)
					if (i[n](t) && t != e) {
						i[t].sleep--;
						!i[t].sleep && delete i[t]
					}
			});
			return i[e]
		}

		function v(t, e, i, n) {
			if (t == null) {
				t = e = i = n = 0
			}
			if (e == null) {
				e = t.y;
				i = t.width;
				n = t.height;
				t = t.x
			}
			return {
				x: t,
				y: e,
				width: i,
				w: i,
				height: n,
				h: n,
				x2: t + i,
				y2: e + n,
				cx: t + i / 2,
				cy: e + n / 2,
				r1: X.min(i, n) / 2,
				r2: X.max(i, n) / 2,
				r0: X.sqrt(i * i + n * n) / 2,
				path: F(t, e, i, n),
				vb: [t, e, i, n].join(" ")
			}
		}

		function w() {
			return this.join(",").replace(r, "$1")
		}

		function T(t) {
			var e = m(t);
			e.toString = w;
			return e
		}

		function y(t, e, i, n, r, o, a, s, l) {
			if (l == null) {
				return O(t, e, i, n, r, o, a, s)
			} else {
				return A(t, e, i, n, r, o, a, s, c(t, e, i, n, r, o, a, s, l))
			}
		}

		function o(f, p) {
			function m(t) {
				return +(+t).toFixed(3)
			}
			return W._.cacher(function (t, e, i) {
				if (t instanceof g) {
					t = t.attr("d")
				}
				t = Q(t);
				var n, r, o, a, s = "",
					l = {},
					c, u = 0;
				for (var h = 0, d = t.length; h < d; h++) {
					o = t[h];
					if (o[0] == "M") {
						n = +o[1];
						r = +o[2]
					} else {
						a = y(n, r, o[1], o[2], o[3], o[4], o[5], o[6]);
						if (u + a > e) {
							if (p && !l.start) {
								c = y(n, r, o[1], o[2], o[3], o[4], o[5], o[6], e - u);
								s += ["C" + m(c.start.x), m(c.start.y), m(c.m.x), m(c.m.y), m(c.x), m(c.y)];
								if (i) {
									return s
								}
								l.start = s;
								s = ["M" + m(c.x), m(c.y) + "C" + m(c.n.x), m(c.n.y), m(c.end.x), m(c.end.y), m(o[5]), m(o[6])].join();
								u += a;
								n = +o[5];
								r = +o[6];
								continue
							}
							if (!f && !p) {
								c = y(n, r, o[1], o[2], o[3], o[4], o[5], o[6], e - u);
								return c
							}
						}
						u += a;
						n = +o[5];
						r = +o[6]
					}
					s += o.shift() + o
				}
				l.end = s;
				c = f ? u : p ? l : A(n, r, o[0], o[1], o[2], o[3], o[4], o[5], 1);
				return c
			}, null, W._.clone)
		}
		var a = o(1),
			s = o(),
			l = o(0, 1);

		function A(t, e, i, n, r, o, a, s, l) {
			var c = 1 - l,
				u = M(c, 3),
				h = M(c, 2),
				d = l * l,
				f = d * l,
				p = u * t + h * 3 * l * i + c * 3 * l * l * r + f * a,
				m = u * e + h * 3 * l * n + c * 3 * l * l * o + f * s,
				g = t + 2 * l * (i - t) + d * (r - 2 * i + t),
				v = e + 2 * l * (n - e) + d * (o - 2 * n + e),
				y = i + 2 * l * (r - i) + d * (a - 2 * r + i),
				x = n + 2 * l * (o - n) + d * (s - 2 * o + n),
				_ = c * t + l * i,
				b = c * e + l * n,
				w = c * r + l * a,
				T = c * o + l * s,
				E = 90 - X.atan2(g - y, v - x) * 180 / Y;
			return {
				x: p,
				y: m,
				m: {
					x: g,
					y: v
				},
				n: {
					x: y,
					y: x
				},
				start: {
					x: _,
					y: b
				},
				end: {
					x: w,
					y: T
				},
				alpha: E
			}
		}

		function C(t, e, i, n, r, o, a, s) {
			if (!W.is(t, "array")) {
				t = [t, e, i, n, r, o, a, s]
			}
			var l = J.apply(null, t);
			return v(l.min.x, l.min.y, l.max.x - l.min.x, l.max.y - l.min.y)
		}

		function P(t, e, i) {
			return e >= t.x && e <= t.x + t.width && i >= t.y && i <= t.y + t.height
		}

		function L(t, e) {
			t = v(t);
			e = v(e);
			return P(e, t.x, t.y) || P(e, t.x2, t.y) || P(e, t.x, t.y2) || P(e, t.x2, t.y2) || P(t, e.x, e.y) || P(t, e.x2, e.y) || P(t, e.x, e.y2) || P(t, e.x2, e.y2) || (t.x < e.x2 && t.x > e.x || e.x < t.x2 && e.x > t.x) && (t.y < e.y2 && t.y > e.y || e.y < t.y2 && e.y > t.y)
		}

		function R(t, e, i, n, r) {
			var o = -3 * e + 9 * i - 9 * n + 3 * r,
				a = t * o + 6 * e - 12 * i + 6 * n;
			return t * a - 3 * e + 3 * i
		}

		function O(t, e, i, n, r, o, a, s, l) {
			if (l == null) {
				l = 1
			}
			l = l > 1 ? 1 : l < 0 ? 0 : l;
			var c = l / 2,
				u = 12,
				h = [-.1252, .1252, -.3678, .3678, -.5873, .5873, -.7699, .7699, -.9041, .9041, -.9816, .9816],
				d = [.2491, .2491, .2335, .2335, .2032, .2032, .1601, .1601, .1069, .1069, .0472, .0472],
				f = 0;
			for (var p = 0; p < u; p++) {
				var m = c * h[p] + c,
					g = R(m, t, i, r, a),
					v = R(m, e, n, o, s),
					y = g * g + v * v;
				f += d[p] * X.sqrt(y)
			}
			return c * f
		}

		function c(t, e, i, n, r, o, a, s, l) {
			if (l < 0 || O(t, e, i, n, r, o, a, s) < l) {
				return
			}
			var c = 1,
				u = c / 2,
				h = c - u,
				d, f = .01;
			d = O(t, e, i, n, r, o, a, s, h);
			while (q(d - l) > f) {
				u /= 2;
				h += (d < l ? 1 : -1) * u;
				d = O(t, e, i, n, r, o, a, s, h)
			}
			return h
		}

		function k(t, e, i, n, r, o, a, s) {
			if (S(t, i) < E(r, a) || E(t, i) > S(r, a) || S(e, n) < E(o, s) || E(e, n) > S(o, s)) {
				return
			}
			var l = (t * n - e * i) * (r - a) - (t - i) * (r * s - o * a),
				c = (t * n - e * i) * (o - s) - (e - n) * (r * s - o * a),
				u = (t - i) * (o - s) - (e - n) * (r - a);
			if (!u) {
				return
			}
			var h = l / u,
				d = c / u,
				f = +h.toFixed(2),
				p = +d.toFixed(2);
			if (f < +E(t, i).toFixed(2) || f > +S(t, i).toFixed(2) || f < +E(r, a).toFixed(2) || f > +S(r, a).toFixed(2) || p < +E(e, n).toFixed(2) || p > +S(e, n).toFixed(2) || p < +E(o, s).toFixed(2) || p > +S(o, s).toFixed(2)) {
				return
			}
			return {
				x: h,
				y: d
			}
		}

		function u(t, e) {
			return N(t, e)
		}

		function h(t, e) {
			return N(t, e, 1)
		}

		function N(t, e, i) {
			var n = C(t),
				r = C(e);
			if (!L(n, r)) {
				return i ? 0 : []
			}
			var o = O.apply(0, t),
				a = O.apply(0, e),
				s = ~~(o / 8),
				l = ~~(a / 8),
				c = [],
				u = [],
				h = {},
				d = i ? 0 : [];
			for (var f = 0; f < s + 1; f++) {
				var p = A.apply(0, t.concat(f / s));
				c.push({
					x: p.x,
					y: p.y,
					t: f / s
				})
			}
			for (f = 0; f < l + 1; f++) {
				p = A.apply(0, e.concat(f / l));
				u.push({
					x: p.x,
					y: p.y,
					t: f / l
				})
			}
			for (f = 0; f < s; f++) {
				for (var m = 0; m < l; m++) {
					var g = c[f],
						v = c[f + 1],
						y = u[m],
						x = u[m + 1],
						_ = q(v.x - g.x) < .001 ? "y" : "x",
						b = q(x.x - y.x) < .001 ? "y" : "x",
						w = k(g.x, g.y, v.x, v.y, y.x, y.y, x.x, x.y);
					if (w) {
						if (h[w.x.toFixed(4)] == w.y.toFixed(4)) {
							continue
						}
						h[w.x.toFixed(4)] = w.y.toFixed(4);
						var T = g.t + q((w[_] - g[_]) / (v[_] - g[_])) * (v.t - g.t),
							E = y.t + q((w[b] - y[b]) / (x[b] - y[b])) * (x.t - y.t);
						if (T >= 0 && T <= 1 && E >= 0 && E <= 1) {
							if (i) {
								d++
							} else {
								d.push({
									x: w.x,
									y: w.y,
									t1: T,
									t2: E
								})
							}
						}
					}
				}
			}
			return d
		}

		function d(t, e) {
			return p(t, e)
		}

		function f(t, e) {
			return p(t, e, 1)
		}

		function p(t, e, i) {
			t = Q(t);
			e = Q(e);
			var n, r, o, a, s, l, c, u, h, d, f = i ? 0 : [];
			for (var p = 0, m = t.length; p < m; p++) {
				var g = t[p];
				if (g[0] == "M") {
					n = s = g[1];
					r = l = g[2]
				} else {
					if (g[0] == "C") {
						h = [n, r].concat(g.slice(1));
						n = h[6];
						r = h[7]
					} else {
						h = [n, r, n, r, s, l, s, l];
						n = s;
						r = l
					}
					for (var v = 0, y = e.length; v < y; v++) {
						var x = e[v];
						if (x[0] == "M") {
							o = c = x[1];
							a = u = x[2]
						} else {
							if (x[0] == "C") {
								d = [o, a].concat(x.slice(1));
								o = d[6];
								a = d[7]
							} else {
								d = [o, a, o, a, c, u, c, u];
								o = c;
								a = u
							}
							var _ = N(h, d, i);
							if (i) {
								f += _
							} else {
								for (var b = 0, w = _.length; b < w; b++) {
									_[b].segment1 = p;
									_[b].segment2 = v;
									_[b].bez1 = h;
									_[b].bez2 = d
								}
								f = f.concat(_)
							}
						}
					}
				}
			}
			return f
		}

		function I(t, e, i) {
			var n = D(t);
			return P(n, e, i) && p(t, [
				["M", e, i],
				["H", n.x2 + 10]
			], 1) % 2 == 1
		}

		function D(t) {
			var e = b(t);
			if (e.bbox) {
				return m(e.bbox)
			}
			if (!t) {
				return v()
			}
			t = Q(t);
			var i = 0,
				n = 0,
				r = [],
				o = [],
				a;
			for (var s = 0, l = t.length; s < l; s++) {
				a = t[s];
				if (a[0] == "M") {
					i = a[1];
					n = a[2];
					r.push(i);
					o.push(n)
				} else {
					var c = J(i, n, a[1], a[2], a[3], a[4], a[5], a[6]);
					r = r.concat(c.min.x, c.max.x);
					o = o.concat(c.min.y, c.max.y);
					i = a[5];
					n = a[6]
				}
			}
			var u = E.apply(0, r),
				h = E.apply(0, o),
				d = S.apply(0, r),
				f = S.apply(0, o),
				p = v(u, h, d - u, f - h);
			e.bbox = m(p);
			return p
		}

		function F(t, e, i, n, r) {
			if (r) {
				return [
					["M", +t + +r, e],
					["l", i - r * 2, 0],
					["a", r, r, 0, 0, 1, r, r],
					["l", 0, n - r * 2],
					["a", r, r, 0, 0, 1, -r, r],
					["l", r * 2 - i, 0],
					["a", r, r, 0, 0, 1, -r, -r],
					["l", 0, r * 2 - n],
					["a", r, r, 0, 0, 1, r, -r],
					["z"]
				]
			}
			var o = [
				["M", t, e],
				["l", i, 0],
				["l", 0, n],
				["l", -i, 0],
				["z"]
			];
			o.toString = w;
			return o
		}

		function B(t, e, i, n, r) {
			if (r == null && n == null) {
				n = i
			}
			t = +t;
			e = +e;
			i = +i;
			n = +n;
			if (r != null) {
				var o = Math.PI / 180,
					a = t + i * Math.cos(-n * o),
					s = t + i * Math.cos(-r * o),
					l = e + i * Math.sin(-n * o),
					c = e + i * Math.sin(-r * o),
					u = [
						["M", a, l],
						["A", i, i, 0, +(r - n > 180), 0, s, c]
					]
			} else {
				u = [
					["M", t, e],
					["m", 0, -n],
					["a", i, n, 0, 1, 1, 0, 2 * n],
					["a", i, n, 0, 1, 1, 0, -2 * n],
					["z"]
				]
			}
			u.toString = w;
			return u
		}
		var U = W._unit2px,
			z = {
				path: function (t) {
					return t.attr("path")
				},
				circle: function (t) {
					var e = U(t);
					return B(e.cx, e.cy, e.r)
				},
				ellipse: function (t) {
					var e = U(t);
					return B(e.cx || 0, e.cy || 0, e.rx, e.ry)
				},
				rect: function (t) {
					var e = U(t);
					return F(e.x || 0, e.y || 0, e.width, e.height, e.rx, e.ry)
				},
				image: function (t) {
					var e = U(t);
					return F(e.x || 0, e.y || 0, e.width, e.height)
				},
				line: function (t) {
					return "M" + [t.attr("x1") || 0, t.attr("y1") || 0, t.attr("x2"), t.attr("y2")]
				},
				polyline: function (t) {
					return "M" + t.attr("points")
				},
				polygon: function (t) {
					return "M" + t.attr("points") + "z"
				},
				deflt: function (t) {
					var e = t.node.getBBox();
					return F(e.x, e.y, e.width, e.height)
				}
			};

		function G(t) {
			var e = b(t),
				i = String.prototype.toLowerCase;
			if (e.rel) {
				return T(e.rel)
			}
			if (!W.is(t, "array") || !W.is(t && t[0], "array")) {
				t = W.parsePathString(t)
			}
			var n = [],
				r = 0,
				o = 0,
				a = 0,
				s = 0,
				l = 0;
			if (t[0][0] == "M") {
				r = t[0][1];
				o = t[0][2];
				a = r;
				s = o;
				l++;
				n.push(["M", r, o])
			}
			for (var c = l, u = t.length; c < u; c++) {
				var h = n[c] = [],
					d = t[c];
				if (d[0] != i.call(d[0])) {
					h[0] = i.call(d[0]);
					switch (h[0]) {
						case "a":
							h[1] = d[1];
							h[2] = d[2];
							h[3] = d[3];
							h[4] = d[4];
							h[5] = d[5];
							h[6] = +(d[6] - r).toFixed(3);
							h[7] = +(d[7] - o).toFixed(3);
							break;
						case "v":
							h[1] = +(d[1] - o).toFixed(3);
							break;
						case "m":
							a = d[1];
							s = d[2];
						default:
							for (var f = 1, p = d.length; f < p; f++) {
								h[f] = +(d[f] - (f % 2 ? r : o)).toFixed(3)
							}
					}
				} else {
					h = n[c] = [];
					if (d[0] == "m") {
						a = d[1] + r;
						s = d[2] + o
					}
					for (var m = 0, g = d.length; m < g; m++) {
						n[c][m] = d[m]
					}
				}
				var v = n[c].length;
				switch (n[c][0]) {
					case "z":
						r = a;
						o = s;
						break;
					case "h":
						r += +n[c][v - 1];
						break;
					case "v":
						o += +n[c][v - 1];
						break;
					default:
						r += +n[c][v - 2];
						o += +n[c][v - 1]
				}
			}
			n.toString = w;
			e.rel = T(n);
			return n
		}

		function H(t) {
			var e = b(t);
			if (e.abs) {
				return T(e.abs)
			}
			if (!x(t, "array") || !x(t && t[0], "array")) {
				t = W.parsePathString(t)
			}
			if (!t || !t.length) {
				return [
					["M", 0, 0]
				]
			}
			var i = [],
				n = 0,
				r = 0,
				o = 0,
				a = 0,
				s = 0,
				l;
			if (t[0][0] == "M") {
				n = +t[0][1];
				r = +t[0][2];
				o = n;
				a = r;
				s++;
				i[0] = ["M", n, r]
			}
			var c = t.length == 3 && t[0][0] == "M" && t[1][0].toUpperCase() == "R" && t[2][0].toUpperCase() == "Z";
			for (var u, h, d = s, f = t.length; d < f; d++) {
				i.push(u = []);
				h = t[d];
				l = h[0];
				if (l != l.toUpperCase()) {
					u[0] = l.toUpperCase();
					switch (u[0]) {
						case "A":
							u[1] = h[1];
							u[2] = h[2];
							u[3] = h[3];
							u[4] = h[4];
							u[5] = h[5];
							u[6] = +h[6] + n;
							u[7] = +h[7] + r;
							break;
						case "V":
							u[1] = +h[1] + r;
							break;
						case "H":
							u[1] = +h[1] + n;
							break;
						case "R":
							var p = [n, r].concat(h.slice(1));
							for (var m = 2, g = p.length; m < g; m++) {
								p[m] = +p[m] + n;
								p[++m] = +p[m] + r
							}
							i.pop();
							i = i.concat(tt(p, c));
							break;
						case "O":
							i.pop();
							p = B(n, r, h[1], h[2]);
							p.push(p[0]);
							i = i.concat(p);
							break;
						case "U":
							i.pop();
							i = i.concat(B(n, r, h[1], h[2], h[3]));
							u = ["U"].concat(i[i.length - 1].slice(-2));
							break;
						case "M":
							o = +h[1] + n;
							a = +h[2] + r;
						default:
							for (m = 1, g = h.length; m < g; m++) {
								u[m] = +h[m] + (m % 2 ? n : r)
							}
					}
				} else if (l == "R") {
					p = [n, r].concat(h.slice(1));
					i.pop();
					i = i.concat(tt(p, c));
					u = ["R"].concat(h.slice(-2))
				} else if (l == "O") {
					i.pop();
					p = B(n, r, h[1], h[2]);
					p.push(p[0]);
					i = i.concat(p)
				} else if (l == "U") {
					i.pop();
					i = i.concat(B(n, r, h[1], h[2], h[3]));
					u = ["U"].concat(i[i.length - 1].slice(-2))
				} else {
					for (var v = 0, y = h.length; v < y; v++) {
						u[v] = h[v]
					}
				}
				l = l.toUpperCase();
				if (l != "O") {
					switch (u[0]) {
						case "Z":
							n = +o;
							r = +a;
							break;
						case "H":
							n = u[1];
							break;
						case "V":
							r = u[1];
							break;
						case "M":
							o = u[u.length - 2];
							a = u[u.length - 1];
						default:
							n = u[u.length - 2];
							r = u[u.length - 1]
					}
				}
			}
			i.toString = w;
			e.abs = T(i);
			return i
		}

		function j(t, e, i, n) {
			return [t, e, i, n, i, n]
		}

		function V(t, e, i, n, r, o) {
			var a = 1 / 3,
				s = 2 / 3;
			return [a * t + s * i, a * e + s * n, a * r + s * i, a * o + s * n, r, o]
		}

		function $(t, e, i, n, r, o, a, s, l, c) {
			var u = Y * 120 / 180,
				h = Y / 180 * (+r || 0),
				d = [],
				f, p = W._.cacher(function (t, e, i) {
					var n = t * X.cos(i) - e * X.sin(i),
						r = t * X.sin(i) + e * X.cos(i);
					return {
						x: n,
						y: r
					}
				});
			if (!i || !n) {
				return [t, e, s, l, s, l]
			}
			if (!c) {
				f = p(t, e, -h);
				t = f.x;
				e = f.y;
				f = p(s, l, -h);
				s = f.x;
				l = f.y;
				var m = X.cos(Y / 180 * r),
					g = X.sin(Y / 180 * r),
					v = (t - s) / 2,
					y = (e - l) / 2;
				var x = v * v / (i * i) + y * y / (n * n);
				if (x > 1) {
					x = X.sqrt(x);
					i = x * i;
					n = x * n
				}
				var _ = i * i,
					b = n * n,
					w = (o == a ? -1 : 1) * X.sqrt(q((_ * b - _ * y * y - b * v * v) / (_ * y * y + b * v * v))),
					T = w * i * y / n + (t + s) / 2,
					E = w * -n * v / i + (e + l) / 2,
					S = X.asin(((e - E) / n).toFixed(9)),
					M = X.asin(((l - E) / n).toFixed(9));
				S = t < T ? Y - S : S;
				M = s < T ? Y - M : M;
				S < 0 && (S = Y * 2 + S);
				M < 0 && (M = Y * 2 + M);
				if (a && S > M) {
					S = S - Y * 2
				}
				if (!a && M > S) {
					M = M - Y * 2
				}
			} else {
				S = c[0];
				M = c[1];
				T = c[2];
				E = c[3]
			}
			var A = M - S;
			if (q(A) > u) {
				var C = M,
					P = s,
					L = l;
				M = S + u * (a && M > S ? 1 : -1);
				s = T + i * X.cos(M);
				l = E + n * X.sin(M);
				d = $(s, l, i, n, r, 0, a, P, L, [M, C, T, E])
			}
			A = M - S;
			var R = X.cos(S),
				O = X.sin(S),
				k = X.cos(M),
				N = X.sin(M),
				I = X.tan(A / 4),
				D = 4 / 3 * i * I,
				F = 4 / 3 * n * I,
				B = [t, e],
				U = [t + D * O, e - F * R],
				z = [s + D * N, l - F * k],
				G = [s, l];
			U[0] = 2 * B[0] - U[0];
			U[1] = 2 * B[1] - U[1];
			if (c) {
				return [U, z, G].concat(d)
			} else {
				d = [U, z, G].concat(d).join().split(",");
				var H = [];
				for (var j = 0, V = d.length; j < V; j++) {
					H[j] = j % 2 ? p(d[j - 1], d[j], h).y : p(d[j], d[j + 1], h).x
				}
				return H
			}
		}

		function Z(t, e, i, n, r, o, a, s, l) {
			var c = 1 - l;
			return {
				x: M(c, 3) * t + M(c, 2) * 3 * l * i + c * 3 * l * l * r + M(l, 3) * a,
				y: M(c, 3) * e + M(c, 2) * 3 * l * n + c * 3 * l * l * o + M(l, 3) * s
			}
		}

		function J(t, e, i, n, r, o, a, s) {
			var l = [],
				c = [
					[],
					[]
				],
				u, h, d, f, p, m, g, v;
			for (var y = 0; y < 2; ++y) {
				if (y == 0) {
					h = 6 * t - 12 * i + 6 * r;
					u = -3 * t + 9 * i - 9 * r + 3 * a;
					d = 3 * i - 3 * t
				} else {
					h = 6 * e - 12 * n + 6 * o;
					u = -3 * e + 9 * n - 9 * o + 3 * s;
					d = 3 * n - 3 * e
				}
				if (q(u) < 1e-12) {
					if (q(h) < 1e-12) {
						continue
					}
					f = -d / h;
					if (0 < f && f < 1) {
						l.push(f)
					}
					continue
				}
				g = h * h - 4 * d * u;
				v = X.sqrt(g);
				if (g < 0) {
					continue
				}
				p = (-h + v) / (2 * u);
				if (0 < p && p < 1) {
					l.push(p)
				}
				m = (-h - v) / (2 * u);
				if (0 < m && m < 1) {
					l.push(m)
				}
			}
			var x, _, b = l.length,
				w = b,
				T;
			while (b--) {
				f = l[b];
				T = 1 - f;
				c[0][b] = T * T * T * t + 3 * T * T * f * i + 3 * T * f * f * r + f * f * f * a;
				c[1][b] = T * T * T * e + 3 * T * T * f * n + 3 * T * f * f * o + f * f * f * s
			}
			c[0][w] = t;
			c[1][w] = e;
			c[0][w + 1] = a;
			c[1][w + 1] = s;
			c[0].length = c[1].length = w + 2;
			return {
				min: {
					x: E.apply(0, c[0]),
					y: E.apply(0, c[1])
				},
				max: {
					x: S.apply(0, c[0]),
					y: S.apply(0, c[1])
				}
			}
		}

		function Q(t, e) {
			var i = !e && b(t);
			if (!e && i.curve) {
				return T(i.curve)
			}
			var o = H(t),
				a = e && H(e),
				n = {
					x: 0,
					y: 0,
					bx: 0,
					by: 0,
					X: 0,
					Y: 0,
					qx: null,
					qy: null
				},
				r = {
					x: 0,
					y: 0,
					bx: 0,
					by: 0,
					X: 0,
					Y: 0,
					qx: null,
					qy: null
				},
				s = function (t, e, i) {
					var n, r;
					if (!t) {
						return ["C", e.x, e.y, e.x, e.y, e.x, e.y]
					}!(t[0] in {
						T: 1,
						Q: 1
					}) && (e.qx = e.qy = null);
					switch (t[0]) {
						case "M":
							e.X = t[1];
							e.Y = t[2];
							break;
						case "A":
							t = ["C"].concat($.apply(0, [e.x, e.y].concat(t.slice(1))));
							break;
						case "S":
							if (i == "C" || i == "S") {
								n = e.x * 2 - e.bx;
								r = e.y * 2 - e.by
							} else {
								n = e.x;
								r = e.y
							}
							t = ["C", n, r].concat(t.slice(1));
							break;
						case "T":
							if (i == "Q" || i == "T") {
								e.qx = e.x * 2 - e.qx;
								e.qy = e.y * 2 - e.qy
							} else {
								e.qx = e.x;
								e.qy = e.y
							}
							t = ["C"].concat(V(e.x, e.y, e.qx, e.qy, t[1], t[2]));
							break;
						case "Q":
							e.qx = t[1];
							e.qy = t[2];
							t = ["C"].concat(V(e.x, e.y, t[1], t[2], t[3], t[4]));
							break;
						case "L":
							t = ["C"].concat(j(e.x, e.y, t[1], t[2]));
							break;
						case "H":
							t = ["C"].concat(j(e.x, e.y, t[1], e.y));
							break;
						case "V":
							t = ["C"].concat(j(e.x, e.y, e.x, t[1]));
							break;
						case "Z":
							t = ["C"].concat(j(e.x, e.y, e.X, e.Y));
							break
					}
					return t
				},
				l = function (t, e) {
					if (t[e].length > 7) {
						t[e].shift();
						var i = t[e];
						while (i.length) {
							u[e] = "A";
							a && (h[e] = "A");
							t.splice(e++, 0, ["C"].concat(i.splice(0, 6)))
						}
						t.splice(e, 1);
						m = S(o.length, a && a.length || 0)
					}
				},
				c = function (t, e, i, n, r) {
					if (t && e && t[r][0] == "M" && e[r][0] != "M") {
						e.splice(r, 0, ["M", n.x, n.y]);
						i.bx = 0;
						i.by = 0;
						i.x = t[r][1];
						i.y = t[r][2];
						m = S(o.length, a && a.length || 0)
					}
				},
				u = [],
				h = [],
				d = "",
				f = "";
			for (var p = 0, m = S(o.length, a && a.length || 0); p < m; p++) {
				o[p] && (d = o[p][0]);
				if (d != "C") {
					u[p] = d;
					p && (f = u[p - 1])
				}
				o[p] = s(o[p], n, f);
				if (u[p] != "A" && d == "C") u[p] = "C";
				l(o, p);
				if (a) {
					a[p] && (d = a[p][0]);
					if (d != "C") {
						h[p] = d;
						p && (f = h[p - 1])
					}
					a[p] = s(a[p], r, f);
					if (h[p] != "A" && d == "C") {
						h[p] = "C"
					}
					l(a, p)
				}
				c(o, a, n, r, p);
				c(a, o, r, n, p);
				var g = o[p],
					v = a && a[p],
					y = g.length,
					x = a && v.length;
				n.x = g[y - 2];
				n.y = g[y - 1];
				n.bx = _(g[y - 4]) || n.x;
				n.by = _(g[y - 3]) || n.y;
				r.bx = a && (_(v[x - 4]) || r.x);
				r.by = a && (_(v[x - 3]) || r.y);
				r.x = a && v[x - 2];
				r.y = a && v[x - 1]
			}
			if (!a) {
				i.curve = T(o)
			}
			return a ? [o, a] : o
		}

		function K(t, e) {
			if (!e) {
				return t
			}
			var i, n, r, o, a, s, l;
			t = Q(t);
			for (r = 0, a = t.length; r < a; r++) {
				l = t[r];
				for (o = 1, s = l.length; o < s; o += 2) {
					i = e.x(l[o], l[o + 1]);
					n = e.y(l[o], l[o + 1]);
					l[o] = i;
					l[o + 1] = n
				}
			}
			return t
		}

		function tt(t, e) {
			var i = [];
			for (var n = 0, r = t.length; r - 2 * !e > n; n += 2) {
				var o = [{
					x: +t[n - 2],
					y: +t[n - 1]
				}, {
					x: +t[n],
					y: +t[n + 1]
				}, {
					x: +t[n + 2],
					y: +t[n + 3]
				}, {
					x: +t[n + 4],
					y: +t[n + 5]
				}];
				if (e) {
					if (!n) {
						o[0] = {
							x: +t[r - 2],
							y: +t[r - 1]
						}
					} else if (r - 4 == n) {
						o[3] = {
							x: +t[0],
							y: +t[1]
						}
					} else if (r - 2 == n) {
						o[2] = {
							x: +t[0],
							y: +t[1]
						};
						o[3] = {
							x: +t[2],
							y: +t[3]
						}
					}
				} else {
					if (r - 4 == n) {
						o[3] = o[2]
					} else if (!n) {
						o[0] = {
							x: +t[n],
							y: +t[n + 1]
						}
					}
				}
				i.push(["C", (-o[0].x + 6 * o[1].x + o[2].x) / 6, (-o[0].y + 6 * o[1].y + o[2].y) / 6, (o[1].x + 6 * o[2].x - o[3].x) / 6, (o[1].y + 6 * o[2].y - o[3].y) / 6, o[2].x, o[2].y])
			}
			return i
		}
		W.path = b;
		W.path.getTotalLength = a;
		W.path.getPointAtLength = s;
		W.path.getSubpath = function (t, e, i) {
			if (this.getTotalLength(t) - i < 1e-6) {
				return l(t, e).end
			}
			var n = l(t, i, 1);
			return e ? l(n, e).end : n
		};
		i.getTotalLength = function () {
			if (this.node.getTotalLength) {
				return this.node.getTotalLength()
			}
		};
		i.getPointAtLength = function (t) {
			return s(this.attr("d"), t)
		};
		i.getSubpath = function (t, e) {
			return W.path.getSubpath(this.attr("d"), t, e)
		};
		W._.box = v;
		W.path.findDotsAtSegment = A;
		W.path.bezierBBox = C;
		W.path.isPointInsideBBox = P;
		W.closest = function (t, e, i, n) {
			var r = 100,
				o = v(t - r / 2, e - r / 2, r, r),
				a = [],
				s = i[0].hasOwnProperty("x") ? function (t) {
					return {
						x: i[t].x,
						y: i[t].y
					}
				} : function (t) {
					return {
						x: i[t],
						y: n[t]
					}
				},
				l = 0;
			while (r <= 1e6 && !l) {
				for (var c = 0, u = i.length; c < u; c++) {
					var h = s(c);
					if (P(o, h.x, h.y)) {
						l++;
						a.push(h);
						break
					}
				}
				if (!l) {
					r *= 2;
					o = v(t - r / 2, e - r / 2, r, r)
				}
			}
			if (r == 1e6) {
				return
			}
			var d = Infinity,
				f;
			for (c = 0, u = a.length; c < u; c++) {
				var p = W.len(t, e, a[c].x, a[c].y);
				if (d > p) {
					d = p;
					a[c].len = p;
					f = a[c]
				}
			}
			return f
		};
		W.path.isBBoxIntersect = L;
		W.path.intersection = d;
		W.path.intersectionNumber = f;
		W.path.isPointInside = I;
		W.path.getBBox = D;
		W.path.get = z;
		W.path.toRelative = G;
		W.path.toAbsolute = H;
		W.path.toCubic = Q;
		W.path.map = K;
		W.path.toString = w;
		W.path.clone = T
	});
	t.plugin(function (h, t, e, i) {
		var l = Math.max,
			c = Math.min;
		var u = function (t) {
				this.items = [];
				this.bindings = {};
				this.length = 0;
				this.type = "set";
				if (t) {
					for (var e = 0, i = t.length; e < i; e++) {
						if (t[e]) {
							this[this.items.length] = this.items[this.items.length] = t[e];
							this.length++
						}
					}
				}
			},
			n = u.prototype;
		n.push = function () {
			var t, e;
			for (var i = 0, n = arguments.length; i < n; i++) {
				t = arguments[i];
				if (t) {
					e = this.items.length;
					this[e] = this.items[e] = t;
					this.length++
				}
			}
			return this
		};
		n.pop = function () {
			this.length && delete this[this.length--];
			return this.items.pop()
		};
		n.forEach = function (t, e) {
			for (var i = 0, n = this.items.length; i < n; i++) {
				if (t.call(e, this.items[i], i) === false) {
					return this
				}
			}
			return this
		};
		n.animate = function (i, n, r, t) {
			if (typeof r == "function" && !r.length) {
				t = r;
				r = b.linear
			}
			if (i instanceof h._.Animation) {
				t = i.callback;
				r = i.easing;
				n = r.dur;
				i = i.attr
			}
			var o = arguments;
			if (h.is(i, "array") && h.is(o[o.length - 1], "array")) {
				var a = true
			}
			var e, s = function () {
					if (e) {
						this.b = e
					} else {
						e = this.b
					}
				},
				l = 0,
				c = this,
				u = t && function () {
					if (++l == c.length) {
						t.call(this)
					}
				};
			return this.forEach(function (t, e) {
				pt.once("snap.animcreated." + t.id, s);
				if (a) {
					o[e] && t.animate.apply(t, o[e])
				} else {
					t.animate(i, n, r, u)
				}
			})
		};
		n.remove = function () {
			while (this.length) {
				this.pop().remove()
			}
			return this
		};
		n.bind = function (t, e, i) {
			var n = {};
			if (typeof e == "function") {
				this.bindings[t] = e
			} else {
				var r = i || t;
				this.bindings[t] = function (t) {
					n[r] = t;
					e.attr(n)
				}
			}
			return this
		};
		n.attr = function (t) {
			var e = {};
			for (var i in t) {
				if (this.bindings[i]) {
					this.bindings[i](t[i])
				} else {
					e[i] = t[i]
				}
			}
			for (var n = 0, r = this.items.length; n < r; n++) {
				this.items[n].attr(e)
			}
			return this
		};
		n.clear = function () {
			while (this.length) {
				this.pop()
			}
		};
		n.splice = function (t, e, i) {
			t = t < 0 ? l(this.length + t, 0) : t;
			e = l(0, c(this.length - t, e));
			var n = [],
				r = [],
				o = [],
				a;
			for (a = 2; a < arguments.length; a++) {
				o.push(arguments[a])
			}
			for (a = 0; a < e; a++) {
				r.push(this[t + a])
			}
			for (; a < this.length - t; a++) {
				n.push(this[t + a])
			}
			var s = o.length;
			for (a = 0; a < s + n.length; a++) {
				this.items[t + a] = this[t + a] = a < s ? o[a] : n[a - s]
			}
			a = this.items.length = this.length -= e - s;
			while (this[a]) {
				delete this[a++]
			}
			return new u(r)
		};
		n.exclude = function (t) {
			for (var e = 0, i = this.length; e < i; e++)
				if (this[e] == t) {
					this.splice(e, 1);
					return true
				}
			return false
		};
		n.insertAfter = function (t) {
			var e = this.items.length;
			while (e--) {
				this.items[e].insertAfter(t)
			}
			return this
		};
		n.getBBox = function () {
			var t = [],
				e = [],
				i = [],
				n = [];
			for (var r = this.items.length; r--;)
				if (!this.items[r].removed) {
					var o = this.items[r].getBBox();
					t.push(o.x);
					e.push(o.y);
					i.push(o.x + o.width);
					n.push(o.y + o.height)
				}
			t = c.apply(0, t);
			e = c.apply(0, e);
			i = l.apply(0, i);
			n = l.apply(0, n);
			return {
				x: t,
				y: e,
				x2: i,
				y2: n,
				width: i - t,
				height: n - e,
				cx: t + (i - t) / 2,
				cy: e + (n - e) / 2
			}
		};
		n.clone = function (t) {
			t = new u;
			for (var e = 0, i = this.items.length; e < i; e++) {
				t.push(this.items[e].clone())
			}
			return t
		};
		n.toString = function () {
			return "Snap‘s set"
		};
		n.type = "set";
		h.Set = u;
		h.set = function () {
			var t = new u;
			if (arguments.length) {
				t.push.apply(t, Array.prototype.slice.call(arguments, 0))
			}
			return t
		}
	});
	t.plugin(function (h, t, e, i) {
		var l = {},
			c = /[%a-z]+$/i,
			u = String;
		l.stroke = l.fill = "colour";

		function d(t) {
			var e = t[0];
			switch (e.toLowerCase()) {
				case "t":
					return [e, 0, 0];
				case "m":
					return [e, 1, 0, 0, 1, 0, 0];
				case "r":
					if (t.length == 4) {
						return [e, 0, t[2], t[3]]
					} else {
						return [e, 0]
					}
				case "s":
					if (t.length == 5) {
						return [e, 1, 1, t[3], t[4]]
					} else if (t.length == 3) {
						return [e, 1, 1]
					} else {
						return [e, 1]
					}
			}
		}

		function f(t, e, i) {
			t = t || new h.Matrix;
			e = e || new h.Matrix;
			t = h.parseTransformString(t.toTransformString()) || [];
			e = h.parseTransformString(e.toTransformString()) || [];
			var n = Math.max(t.length, e.length),
				r = [],
				o = [],
				a = 0,
				s, l, c, u;
			for (; a < n; a++) {
				c = t[a] || d(e[a]);
				u = e[a] || d(c);
				if (c[0] != u[0] || c[0].toLowerCase() == "r" && (c[2] != u[2] || c[3] != u[3]) || c[0].toLowerCase() == "s" && (c[3] != u[3] || c[4] != u[4])) {
					t = h._.transform2matrix(t, i());
					e = h._.transform2matrix(e, i());
					r = [
						["m", t.a, t.b, t.c, t.d, t.e, t.f]
					];
					o = [
						["m", e.a, e.b, e.c, e.d, e.e, e.f]
					];
					break
				}
				r[a] = [];
				o[a] = [];
				for (s = 0, l = Math.max(c.length, u.length); s < l; s++) {
					s in c && (r[a][s] = c[s]);
					s in u && (o[a][s] = u[s])
				}
			}
			return {
				from: x(r),
				to: x(o),
				f: y(r)
			}
		}

		function p(t) {
			return t
		}

		function m(e) {
			return function (t) {
				return +t.toFixed(3) + e
			}
		}

		function g(t) {
			return t.join(" ")
		}

		function v(t) {
			return h.rgb(t[0], t[1], t[2], t[3])
		}

		function y(t) {
			var e = 0,
				i, n, r, o, a, s, l = [];
			for (i = 0, n = t.length; i < n; i++) {
				a = "[";
				s = ['"' + t[i][0] + '"'];
				for (r = 1, o = t[i].length; r < o; r++) {
					s[r] = "val[" + e++ + "]"
				}
				a += s + "]";
				l[i] = a
			}
			return Function("val", "return Snap.path.toString.call([" + l + "])")
		}

		function x(t) {
			var e = [];
			for (var i = 0, n = t.length; i < n; i++) {
				for (var r = 1, o = t[i].length; r < o; r++) {
					e.push(t[i][r])
				}
			}
			return e
		}

		function _(t) {
			return isFinite(t)
		}

		function b(t, e) {
			if (!h.is(t, "array") || !h.is(e, "array")) {
				return false
			}
			return t.toString() == e.toString()
		}
		t.prototype.equal = function (t, e) {
			return pt("snap.util.equal", this, t, e).firstDefined()
		};
		pt.on("snap.util.equal", function (t, e) {
			var i, n, r = u(this.attr(t) || ""),
				o = this;
			if (l[t] == "colour") {
				i = h.color(r);
				n = h.color(e);
				return {
					from: [i.r, i.g, i.b, i.opacity],
					to: [n.r, n.g, n.b, n.opacity],
					f: v
				}
			}
			if (t == "viewBox") {
				i = this.attr(t).vb.split(" ").map(Number);
				n = e.split(" ").map(Number);
				return {
					from: i,
					to: n,
					f: g
				}
			}
			if (t == "transform" || t == "gradientTransform" || t == "patternTransform") {
				if (typeof e == "string") {
					e = u(e).replace(/\.{3}|\u2026/g, r)
				}
				r = this.matrix;
				if (!h._.rgTransform.test(e)) {
					e = h._.transform2matrix(h._.svgTransform2string(e), this.getBBox())
				} else {
					e = h._.transform2matrix(e, this.getBBox())
				}
				return f(r, e, function () {
					return o.getBBox(1)
				})
			}
			if (t == "d" || t == "path") {
				i = h.path.toCubic(r, e);
				return {
					from: x(i[0]),
					to: x(i[1]),
					f: y(i[0])
				}
			}
			if (t == "points") {
				i = u(r).split(h._.separator);
				n = u(e).split(h._.separator);
				return {
					from: i,
					to: n,
					f: function (t) {
						return t
					}
				}
			}
			if (_(r) && _(e)) {
				return {
					from: parseFloat(r),
					to: parseFloat(e),
					f: p
				}
			}
			var a = r.match(c),
				s = u(e).match(c);
			if (a && b(a, s)) {
				return {
					from: parseFloat(r),
					to: parseFloat(e),
					f: m(a)
				}
			} else {
				return {
					from: this.asPX(t),
					to: this.asPX(t, e),
					f: p
				}
			}
		})
	});
	t.plugin(function (u, t, e, r) {
		var i = t.prototype,
			d = "hasOwnProperty",
			p = "createTouch" in r.doc,
			n = ["click", "dblclick", "mousedown", "mousemove", "mouseout", "mouseover", "mouseup", "touchstart", "touchmove", "touchend", "touchcancel"],
			f = {
				mousedown: "touchstart",
				mousemove: "touchmove",
				mouseup: "touchend"
			},
			m = function (t, e) {
				var i = t == "y" ? "scrollTop" : "scrollLeft",
					n = e && e.node ? e.node.ownerDocument : r.doc;
				return n[i in n.documentElement ? "documentElement" : "body"][i]
			},
			o = function () {
				this.returnValue = false
			},
			g = function () {
				return this.originalEvent.preventDefault()
			},
			a = function () {
				this.cancelBubble = true
			},
			v = function () {
				return this.originalEvent.stopPropagation()
			},
			s = function (l, c, u, h) {
				var t = p && f[c] ? f[c] : c,
					e = function (t) {
						var e = m("y", h),
							i = m("x", h);
						if (p && f[d](c)) {
							for (var n = 0, r = t.targetTouches && t.targetTouches.length; n < r; n++) {
								if (t.targetTouches[n].target == l || l.contains(t.targetTouches[n].target)) {
									var o = t;
									t = t.targetTouches[n];
									t.originalEvent = o;
									t.preventDefault = g;
									t.stopPropagation = v;
									break
								}
							}
						}
						var a = t.clientX + i,
							s = t.clientY + e;
						return u.call(h, t, a, s)
					};
				if (c !== t) {
					l.addEventListener(c, e, false)
				}
				l.addEventListener(t, e, false);
				return function () {
					if (c !== t) {
						l.removeEventListener(c, e, false)
					}
					l.removeEventListener(t, e, false);
					return true
				}
			},
			y = [],
			h = function (t) {
				var e = t.clientX,
					i = t.clientY,
					n = m("y"),
					r = m("x"),
					o, a = y.length;
				while (a--) {
					o = y[a];
					if (p) {
						var s = t.touches && t.touches.length,
							l;
						while (s--) {
							l = t.touches[s];
							if (l.identifier == o.el._drag.id || o.el.node.contains(l.target)) {
								e = l.clientX;
								i = l.clientY;
								(t.originalEvent ? t.originalEvent : t).preventDefault();
								break
							}
						}
					} else {
						t.preventDefault()
					}
					var c = o.el.node,
						u, h = c.nextSibling,
						d = c.parentNode,
						f = c.style.display;
					e += r;
					i += n;
					pt("snap.drag.move." + o.el.id, o.move_scope || o.el, e - o.el._drag.x, i - o.el._drag.y, e, i, t)
				}
			},
			x = function (t) {
				u.unmousemove(h).unmouseup(x);
				var e = y.length,
					i;
				while (e--) {
					i = y[e];
					i.el._drag = {};
					pt("snap.drag.end." + i.el.id, i.end_scope || i.start_scope || i.move_scope || i.el, t);
					pt.off("snap.drag.*." + i.el.id)
				}
				y = []
			};
		for (var l = n.length; l--;) {
			(function (r) {
				u[r] = i[r] = function (t, e) {
					if (u.is(t, "function")) {
						this.events = this.events || [];
						this.events.push({
							name: r,
							f: t,
							unbind: s(this.node || document, r, t, e || this)
						})
					} else {
						for (var i = 0, n = this.events.length; i < n; i++)
							if (this.events[i].name == r) {
								try {
									this.events[i].f.call(this)
								} catch (t) {}
							}
					}
					return this
				};
				u["un" + r] = i["un" + r] = function (t) {
					var e = this.events || [],
						i = e.length;
					while (i--)
						if (e[i].name == r && (e[i].f == t || !t)) {
							e[i].unbind();
							e.splice(i, 1);
							!e.length && delete this.events;
							return this
						}
					return this
				}
			})(n[l])
		}
		i.hover = function (t, e, i, n) {
			return this.mouseover(t, i).mouseout(e, n || i)
		};
		i.unhover = function (t, e) {
			return this.unmouseover(t).unmouseout(e)
		};
		var _ = [];
		i.drag = function (n, r, o, a, s, l) {
			var c = this;
			if (!arguments.length) {
				var i;
				return c.drag(function (t, e) {
					this.attr({
						transform: i + (i ? "T" : "t") + [t, e]
					})
				}, function () {
					i = this.transform().local
				})
			}

			function t(t, e, i) {
				(t.originalEvent || t).preventDefault();
				c._drag.x = e;
				c._drag.y = i;
				c._drag.id = t.identifier;
				!y.length && u.mousemove(h).mouseup(x);
				y.push({
					el: c,
					move_scope: a,
					start_scope: s,
					end_scope: l
				});
				r && pt.on("snap.drag.start." + c.id, r);
				n && pt.on("snap.drag.move." + c.id, n);
				o && pt.on("snap.drag.end." + c.id, o);
				pt("snap.drag.start." + c.id, s || a || c, e, i, t)
			}

			function e(t, e, i) {
				pt("snap.draginit." + c.id, c, t, e, i)
			}
			pt.on("snap.draginit." + c.id, t);
			c._drag = {};
			_.push({
				el: c,
				start: t,
				init: e
			});
			c.mousedown(e);
			return c
		};
		i.undrag = function () {
			var t = _.length;
			while (t--)
				if (_[t].el == this) {
					this.unmousedown(_[t].init);
					_.splice(t, 1);
					pt.unbind("snap.drag.*." + this.id);
					pt.unbind("snap.draginit." + this.id)
				}!_.length && u.unmousemove(h).unmouseup(x);
			return this
		}
	});
	t.plugin(function (s, l, t, e) {
		var i = l.prototype,
			n = t.prototype,
			r = /^\s*url\((.+)\)/,
			c = String,
			u = s._.$;
		s.filter = {};
		n.filter = function (t) {
			var e = this;
			if (e.type != "svg") {
				e = e.paper
			}
			var i = s.parse(c(t)),
				n = s._.id(),
				r = e.node.offsetWidth,
				o = e.node.offsetHeight,
				a = u("filter");
			u(a, {
				id: n,
				filterUnits: "userSpaceOnUse"
			});
			a.appendChild(i.node);
			e.defs.appendChild(a);
			return new l(a)
		};
		pt.on("snap.util.getattr.filter", function () {
			pt.stop();
			var t = u(this.node, "filter");
			if (t) {
				var e = c(t).match(r);
				return e && s.select(e[1])
			}
		});
		pt.on("snap.util.attr.filter", function (t) {
			if (t instanceof l && t.type == "filter") {
				pt.stop();
				var e = t.node.id;
				if (!e) {
					u(t.node, {
						id: t.id
					});
					e = t.id
				}
				u(this.node, {
					filter: s.url(e)
				})
			}
			if (!t || t == "none") {
				pt.stop();
				this.node.removeAttribute("filter")
			}
		});
		s.filter.blur = function (t, e) {
			if (t == null) {
				t = 2
			}
			var i = e == null ? t : [t, e];
			return s.format('<feGaussianBlur stdDeviation="{def}"/>', {
				def: i
			})
		};
		s.filter.blur.toString = function () {
			return this()
		};
		s.filter.shadow = function (t, e, i, n, r) {
			if (r == null) {
				if (n == null) {
					r = i;
					i = 4;
					n = "#000"
				} else {
					r = n;
					n = i;
					i = 4
				}
			}
			if (i == null) {
				i = 4
			}
			if (r == null) {
				r = 1
			}
			if (t == null) {
				t = 0;
				e = 2
			}
			if (e == null) {
				e = t
			}
			n = s.color(n);
			return s.format('<feGaussianBlur in="SourceAlpha" stdDeviation="{blur}"/><feOffset dx="{dx}" dy="{dy}" result="offsetblur"/><feFlood flood-color="{color}"/><feComposite in2="offsetblur" operator="in"/><feComponentTransfer><feFuncA type="linear" slope="{opacity}"/></feComponentTransfer><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>', {
				color: n,
				dx: t,
				dy: e,
				blur: i,
				opacity: r
			})
		};
		s.filter.shadow.toString = function () {
			return this()
		};
		s.filter.grayscale = function (t) {
			if (t == null) {
				t = 1
			}
			return s.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {b} {h} 0 0 0 0 0 1 0"/>', {
				a: .2126 + .7874 * (1 - t),
				b: .7152 - .7152 * (1 - t),
				c: .0722 - .0722 * (1 - t),
				d: .2126 - .2126 * (1 - t),
				e: .7152 + .2848 * (1 - t),
				f: .0722 - .0722 * (1 - t),
				g: .2126 - .2126 * (1 - t),
				h: .0722 + .9278 * (1 - t)
			})
		};
		s.filter.grayscale.toString = function () {
			return this()
		};
		s.filter.sepia = function (t) {
			if (t == null) {
				t = 1
			}
			return s.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {h} {i} 0 0 0 0 0 1 0"/>', {
				a: .393 + .607 * (1 - t),
				b: .769 - .769 * (1 - t),
				c: .189 - .189 * (1 - t),
				d: .349 - .349 * (1 - t),
				e: .686 + .314 * (1 - t),
				f: .168 - .168 * (1 - t),
				g: .272 - .272 * (1 - t),
				h: .534 - .534 * (1 - t),
				i: .131 + .869 * (1 - t)
			})
		};
		s.filter.sepia.toString = function () {
			return this()
		};
		s.filter.saturate = function (t) {
			if (t == null) {
				t = 1
			}
			return s.format('<feColorMatrix type="saturate" values="{amount}"/>', {
				amount: 1 - t
			})
		};
		s.filter.saturate.toString = function () {
			return this()
		};
		s.filter.hueRotate = function (t) {
			t = t || 0;
			return s.format('<feColorMatrix type="hueRotate" values="{angle}"/>', {
				angle: t
			})
		};
		s.filter.hueRotate.toString = function () {
			return this()
		};
		s.filter.invert = function (t) {
			if (t == null) {
				t = 1
			}
			return s.format('<feComponentTransfer><feFuncR type="table" tableValues="{amount} {amount2}"/><feFuncG type="table" tableValues="{amount} {amount2}"/><feFuncB type="table" tableValues="{amount} {amount2}"/></feComponentTransfer>', {
				amount: t,
				amount2: 1 - t
			})
		};
		s.filter.invert.toString = function () {
			return this()
		};
		s.filter.brightness = function (t) {
			if (t == null) {
				t = 1
			}
			return s.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}"/><feFuncG type="linear" slope="{amount}"/><feFuncB type="linear" slope="{amount}"/></feComponentTransfer>', {
				amount: t
			})
		};
		s.filter.brightness.toString = function () {
			return this()
		};
		s.filter.contrast = function (t) {
			if (t == null) {
				t = 1
			}
			return s.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}" intercept="{amount2}"/><feFuncG type="linear" slope="{amount}" intercept="{amount2}"/><feFuncB type="linear" slope="{amount}" intercept="{amount2}"/></feComponentTransfer>', {
				amount: t,
				amount2: .5 - t / 2
			})
		};
		s.filter.contrast.toString = function () {
			return this()
		}
	});
	t.plugin(function (t, e, i, n, r) {
		var o = t._.box,
			a = t.is,
			s = /^[^a-z]*([tbmlrc])/i,
			l = function () {
				return "T" + this.dx + "," + this.dy
			};
		e.prototype.getAlign = function (t, e) {
			if (e == null && a(t, "string")) {
				e = t;
				t = null
			}
			t = t || this.paper;
			var i = t.getBBox ? t.getBBox() : o(t),
				n = this.getBBox(),
				r = {};
			e = e && e.match(s);
			e = e ? e[1].toLowerCase() : "c";
			switch (e) {
				case "t":
					r.dx = 0;
					r.dy = i.y - n.y;
					break;
				case "b":
					r.dx = 0;
					r.dy = i.y2 - n.y2;
					break;
				case "m":
					r.dx = 0;
					r.dy = i.cy - n.cy;
					break;
				case "l":
					r.dx = i.x - n.x;
					r.dy = 0;
					break;
				case "r":
					r.dx = i.x2 - n.x2;
					r.dy = 0;
					break;
				default:
					r.dx = i.cx - n.cx;
					r.dy = 0;
					break
			}
			r.toString = l;
			return r
		};
		e.prototype.align = function (t, e) {
			return this.transform("..." + this.getAlign(t, e))
		}
	});
	t.plugin(function (e, t, i, n) {
		var r = "#ffebee#ffcdd2#ef9a9a#e57373#ef5350#f44336#e53935#d32f2f#c62828#b71c1c#ff8a80#ff5252#ff1744#d50000",
			o = "#FCE4EC#F8BBD0#F48FB1#F06292#EC407A#E91E63#D81B60#C2185B#AD1457#880E4F#FF80AB#FF4081#F50057#C51162",
			a = "#F3E5F5#E1BEE7#CE93D8#BA68C8#AB47BC#9C27B0#8E24AA#7B1FA2#6A1B9A#4A148C#EA80FC#E040FB#D500F9#AA00FF",
			s = "#EDE7F6#D1C4E9#B39DDB#9575CD#7E57C2#673AB7#5E35B1#512DA8#4527A0#311B92#B388FF#7C4DFF#651FFF#6200EA",
			l = "#E8EAF6#C5CAE9#9FA8DA#7986CB#5C6BC0#3F51B5#3949AB#303F9F#283593#1A237E#8C9EFF#536DFE#3D5AFE#304FFE",
			c = "#E3F2FD#BBDEFB#90CAF9#64B5F6#64B5F6#2196F3#1E88E5#1976D2#1565C0#0D47A1#82B1FF#448AFF#2979FF#2962FF",
			u = "#E1F5FE#B3E5FC#81D4FA#4FC3F7#29B6F6#03A9F4#039BE5#0288D1#0277BD#01579B#80D8FF#40C4FF#00B0FF#0091EA",
			h = "#E0F7FA#B2EBF2#80DEEA#4DD0E1#26C6DA#00BCD4#00ACC1#0097A7#00838F#006064#84FFFF#18FFFF#00E5FF#00B8D4",
			d = "#E0F2F1#B2DFDB#80CBC4#4DB6AC#26A69A#009688#00897B#00796B#00695C#004D40#A7FFEB#64FFDA#1DE9B6#00BFA5",
			f = "#E8F5E9#C8E6C9#A5D6A7#81C784#66BB6A#4CAF50#43A047#388E3C#2E7D32#1B5E20#B9F6CA#69F0AE#00E676#00C853",
			p = "#F1F8E9#DCEDC8#C5E1A5#AED581#9CCC65#8BC34A#7CB342#689F38#558B2F#33691E#CCFF90#B2FF59#76FF03#64DD17",
			m = "#F9FBE7#F0F4C3#E6EE9C#DCE775#D4E157#CDDC39#C0CA33#AFB42B#9E9D24#827717#F4FF81#EEFF41#C6FF00#AEEA00",
			g = "#FFFDE7#FFF9C4#FFF59D#FFF176#FFEE58#FFEB3B#FDD835#FBC02D#F9A825#F57F17#FFFF8D#FFFF00#FFEA00#FFD600",
			v = "#FFF8E1#FFECB3#FFE082#FFD54F#FFCA28#FFC107#FFB300#FFA000#FF8F00#FF6F00#FFE57F#FFD740#FFC400#FFAB00",
			y = "#FFF3E0#FFE0B2#FFCC80#FFB74D#FFA726#FF9800#FB8C00#F57C00#EF6C00#E65100#FFD180#FFAB40#FF9100#FF6D00",
			x = "#FBE9E7#FFCCBC#FFAB91#FF8A65#FF7043#FF5722#F4511E#E64A19#D84315#BF360C#FF9E80#FF6E40#FF3D00#DD2C00",
			_ = "#EFEBE9#D7CCC8#BCAAA4#A1887F#8D6E63#795548#6D4C41#5D4037#4E342E#3E2723",
			b = "#FAFAFA#F5F5F5#EEEEEE#E0E0E0#BDBDBD#9E9E9E#757575#616161#424242#212121",
			w = "#ECEFF1#CFD8DC#B0BEC5#90A4AE#78909C#607D8B#546E7A#455A64#37474F#263238";
		e.mui = {};
		e.flat = {};

		function T(t) {
			t = t.split(/(?=#)/);
			var e = new String(t[5]);
			e[50] = t[0];
			e[100] = t[1];
			e[200] = t[2];
			e[300] = t[3];
			e[400] = t[4];
			e[500] = t[5];
			e[600] = t[6];
			e[700] = t[7];
			e[800] = t[8];
			e[900] = t[9];
			if (t[10]) {
				e.A100 = t[10];
				e.A200 = t[11];
				e.A400 = t[12];
				e.A700 = t[13]
			}
			return e
		}
		e.mui.red = T(r);
		e.mui.pink = T(o);
		e.mui.purple = T(a);
		e.mui.deeppurple = T(s);
		e.mui.indigo = T(l);
		e.mui.blue = T(c);
		e.mui.lightblue = T(u);
		e.mui.cyan = T(h);
		e.mui.teal = T(d);
		e.mui.green = T(f);
		e.mui.lightgreen = T(p);
		e.mui.lime = T(m);
		e.mui.yellow = T(g);
		e.mui.amber = T(v);
		e.mui.orange = T(y);
		e.mui.deeporange = T(x);
		e.mui.brown = T(_);
		e.mui.grey = T(b);
		e.mui.bluegrey = T(w);
		e.flat.turquoise = "#1abc9c";
		e.flat.greensea = "#16a085";
		e.flat.sunflower = "#f1c40f";
		e.flat.orange = "#f39c12";
		e.flat.emerland = "#2ecc71";
		e.flat.nephritis = "#27ae60";
		e.flat.carrot = "#e67e22";
		e.flat.pumpkin = "#d35400";
		e.flat.peterriver = "#3498db";
		e.flat.belizehole = "#2980b9";
		e.flat.alizarin = "#e74c3c";
		e.flat.pomegranate = "#c0392b";
		e.flat.amethyst = "#9b59b6";
		e.flat.wisteria = "#8e44ad";
		e.flat.clouds = "#ecf0f1";
		e.flat.silver = "#bdc3c7";
		e.flat.wetasphalt = "#34495e";
		e.flat.midnightblue = "#2c3e50";
		e.flat.concrete = "#95a5a6";
		e.flat.asbestos = "#7f8c8d";
		e.importMUIColors = function () {
			for (var t in e.mui) {
				if (e.mui.hasOwnProperty(t)) {
					E[t] = e.mui[t]
				}
			}
		}
	});
	return t
});
(function (t, e) {
	typeof define == "function" ? define(e) : typeof module != "undefined" ? module.exports = e : this[t] = e
})("easing", {
	easeInQuad: function (t) {
		return Math.pow(t, 2)
	},
	easeOutQuad: function (t) {
		return -(Math.pow(t - 1, 2) - 1)
	},
	easeInOutQuad: function (t) {
		return (t /= .5) < 1 ? .5 * Math.pow(t, 2) : -.5 * ((t -= 2) * t - 2)
	},
	easeInCubic: function (t) {
		return Math.pow(t, 3)
	},
	easeOutCubic: function (t) {
		return Math.pow(t - 1, 3) + 1
	},
	easeInOutCubic: function (t) {
		return (t /= .5) < 1 ? .5 * Math.pow(t, 3) : .5 * (Math.pow(t - 2, 3) + 2)
	},
	easeInQuart: function (t) {
		return Math.pow(t, 4)
	},
	easeOutQuart: function (t) {
		return -(Math.pow(t - 1, 4) - 1)
	},
	easeInOutQuart: function (t) {
		return (t /= .5) < 1 ? .5 * Math.pow(t, 4) : -.5 * ((t -= 2) * Math.pow(t, 3) - 2)
	},
	easeInQuint: function (t) {
		return Math.pow(t, 5)
	},
	easeOutQuint: function (t) {
		return Math.pow(t - 1, 5) + 1
	},
	easeInOutQuint: function (t) {
		return (t /= .5) < 1 ? .5 * Math.pow(t, 5) : .5 * (Math.pow(t - 2, 5) + 2)
	},
	easeInSine: function (t) {
		return -Math.cos(t * (Math.PI / 2)) + 1
	},
	easeOutSine: function (t) {
		return Math.sin(t * (Math.PI / 2))
	},
	easeInOutSine: function (t) {
		return -.5 * (Math.cos(Math.PI * t) - 1)
	},
	easeInExpo: function (t) {
		return t === 0 ? 0 : Math.pow(2, 10 * (t - 1))
	},
	easeOutExpo: function (t) {
		return t === 1 ? 1 : -Math.pow(2, -10 * t) + 1
	},
	easeInOutExpo: function (t) {
		return t === 0 ? 0 : t === 1 ? 1 : (t /= .5) < 1 ? .5 * Math.pow(2, 10 * (t - 1)) : .5 * (-Math.pow(2, -10 * --t) + 2)
	},
	easeInCirc: function (t) {
		return -(Math.sqrt(1 - t * t) - 1)
	},
	easeOutCirc: function (t) {
		return Math.sqrt(1 - Math.pow(t - 1, 2))
	},
	easeInOutCirc: function (t) {
		return (t /= .5) < 1 ? -.5 * (Math.sqrt(1 - t * t) - 1) : .5 * (Math.sqrt(1 - (t -= 2) * t) + 1)
	},
	easeOutBounce: function (t) {
		return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375
	},
	easeInBack: function (t) {
		var e = 1.70158;
		return t * t * ((e + 1) * t - e)
	},
	easeOutBack: function (t) {
		var e = 1.70158;
		return (t -= 1) * t * ((e + 1) * t + e) + 1
	},
	easeInOutBack: function (t) {
		var e = 1.70158;
		return (t /= .5) < 1 ? .5 * t * t * (((e *= 1.525) + 1) * t - e) : .5 * ((t -= 2) * t * (((e *= 1.525) + 1) * t + e) + 2)
	},
	elastic: function (t) {
		return -1 * Math.pow(4, -8 * t) * Math.sin((t * 6 - 1) * 2 * Math.PI / 2) + 1
	},
	swingFromTo: function (t) {
		var e = 1.70158;
		return (t /= .5) < 1 ? .5 * t * t * (((e *= 1.525) + 1) * t - e) : .5 * ((t -= 2) * t * (((e *= 1.525) + 1) * t + e) + 2)
	},
	swingFrom: function (t) {
		var e = 1.70158;
		return t * t * ((e + 1) * t - e)
	},
	swingTo: function (t) {
		var e = 1.70158;
		return (t -= 1) * t * ((e + 1) * t + e) + 1
	},
	bounce: function (t) {
		return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375
	},
	bouncePast: function (t) {
		return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 2 - (7.5625 * (t -= 1.5 / 2.75) * t + .75) : t < 2.5 / 2.75 ? 2 - (7.5625 * (t -= 2.25 / 2.75) * t + .9375) : 2 - (7.5625 * (t -= 2.625 / 2.75) * t + .984375)
	},
	easeFromTo: function (t) {
		return (t /= .5) < 1 ? .5 * Math.pow(t, 4) : -.5 * ((t -= 2) * Math.pow(t, 3) - 2)
	},
	easeFrom: function (t) {
		return Math.pow(t, 4)
	},
	easeTo: function (t) {
		return Math.pow(t, .25)
	}
});
! function (t, e) {
	"object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t.Vimeo = t.Vimeo || {}, t.Vimeo.Player = e())
}(this, function () {
	"use strict";

	function r(t, e) {
		for (var i = 0; i < e.length; i++) {
			var n = e[i];
			n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
		}
	}
	var t = "undefined" != typeof global && "[object global]" === {}.toString.call(global);

	function o(t, e) {
		return 0 === t.indexOf(e.toLowerCase()) ? t : "".concat(e.toLowerCase()).concat(t.substr(0, 1).toUpperCase()).concat(t.substr(1))
	}

	function l(t) {
		return /^(https?:)?\/\/((player|www).)?vimeo.com(?=$|\/)/.test(t)
	}

	function s() {
		var t, e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
			i = e.id,
			n = e.url,
			r = i || n;
		if (!r) throw new Error("An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.");
		if (t = r, !isNaN(parseFloat(t)) && isFinite(t) && Math.floor(t) == t) return "https://vimeo.com/".concat(r);
		if (l(r)) return r.replace("http:", "https:");
		if (i) throw new TypeError("“".concat(i, "” is not a valid video id."));
		throw new TypeError("“".concat(r, "” is not a vimeo.com url."))
	}
	var e = void 0 !== Array.prototype.indexOf,
		i = "undefined" != typeof window && void 0 !== window.postMessage;
	if (!(t || e && i)) throw new Error("Sorry, the Vimeo Player API is not available in this browser.");
	var a = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
	! function (t) {
		if (!t.WeakMap) {
			var i = Object.prototype.hasOwnProperty,
				r = function (t, e, i) {
					Object.defineProperty ? Object.defineProperty(t, e, {
						configurable: !0,
						writable: !0,
						value: i
					}) : t[e] = i
				};
			t.WeakMap = function () {
				function t() {
					if (void 0 === this) throw new TypeError("Constructor WeakMap requires 'new'");
					if (r(this, "_id", "_WeakMap" + "_" + e() + "." + e()), 0 < arguments.length) throw new TypeError("WeakMap iterable is not supported")
				}

				function n(t, e) {
					if (!o(t) || !i.call(t, "_id")) throw new TypeError(e + " method called on incompatible receiver " + typeof t)
				}

				function e() {
					return Math.random().toString().substring(2)
				}
				return r(t.prototype, "delete", function (t) {
					if (n(this, "delete"), !o(t)) return !1;
					var e = t[this._id];
					return !(!e || e[0] !== t) && (delete t[this._id], !0)
				}), r(t.prototype, "get", function (t) {
					if (n(this, "get"), o(t)) {
						var e = t[this._id];
						return e && e[0] === t ? e[1] : void 0
					}
				}), r(t.prototype, "has", function (t) {
					if (n(this, "has"), !o(t)) return !1;
					var e = t[this._id];
					return !(!e || e[0] !== t)
				}), r(t.prototype, "set", function (t, e) {
					if (n(this, "set"), !o(t)) throw new TypeError("Invalid value used as weak map key");
					var i = t[this._id];
					return i && i[0] === t ? i[1] = e : r(t, this._id, [t, e]), this
				}), r(t, "_polyfill", !0), t
			}()
		}

		function o(t) {
			return Object(t) === t
		}
	}("undefined" != typeof self ? self : "undefined" != typeof window ? window : a);
	var n, c = (function (t) {
			var e, i, n;
			n = function () {
				var t, a, i, r = Object.prototype.toString,
					n = "undefined" != typeof setImmediate ? function (t) {
						return setImmediate(t)
					} : setTimeout;
				try {
					Object.defineProperty({}, "x", {}), t = function (t, e, i, n) {
						return Object.defineProperty(t, e, {
							value: i,
							writable: !0,
							configurable: !1 !== n
						})
					}
				} catch (r) {
					t = function (t, e, i) {
						return t[e] = i, t
					}
				}

				function o(t, e) {
					i.add(t, e), a || (a = n(i.drain))
				}

				function s(t) {
					var e, i = typeof t;
					return null == t || "object" != i && "function" != i || (e = t.then), "function" == typeof e && e
				}

				function l() {
					for (var t = 0; t < this.chain.length; t++) e(this, 1 === this.state ? this.chain[t].success : this.chain[t].failure, this.chain[t]);
					this.chain.length = 0
				}

				function e(t, e, i) {
					var n, r;
					try {
						!1 === e ? i.reject(t.msg) : (n = !0 === e ? t.msg : e.call(void 0, t.msg)) === i.promise ? i.reject(TypeError("Promise-chain cycle")) : (r = s(n)) ? r.call(n, i.resolve, i.reject) : i.resolve(n)
					} catch (t) {
						i.reject(t)
					}
				}

				function c(t) {
					var e = this;
					e.triggered || (e.triggered = !0, e.def && (e = e.def), e.msg = t, e.state = 2, 0 < e.chain.length && o(l, e))
				}

				function u(t, i, n, r) {
					for (var e = 0; e < i.length; e++) ! function (e) {
						t.resolve(i[e]).then(function (t) {
							n(e, t)
						}, r)
					}(e)
				}

				function h(t) {
					this.def = t, this.triggered = !1
				}

				function d(t) {
					this.promise = t, this.state = 0, this.triggered = !1, this.chain = [], this.msg = void 0
				}

				function f(t) {
					if ("function" != typeof t) throw TypeError("Not a function");
					if (0 !== this.__NPO__) throw TypeError("Not a promise");
					this.__NPO__ = 1;
					var n = new d(this);
					this.then = function (t, e) {
						var i = {
							success: "function" != typeof t || t,
							failure: "function" == typeof e && e
						};
						return i.promise = new this.constructor(function (t, e) {
							if ("function" != typeof t || "function" != typeof e) throw TypeError("Not a function");
							i.resolve = t, i.reject = e
						}), n.chain.push(i), 0 !== n.state && o(l, n), i.promise
					}, this.catch = function (t) {
						return this.then(void 0, t)
					};
					try {
						t.call(void 0, function (t) {
							(function t(i) {
								var n, r = this;
								if (!r.triggered) {
									r.triggered = !0, r.def && (r = r.def);
									try {
										(n = s(i)) ? o(function () {
											var e = new h(r);
											try {
												n.call(i, function () {
													t.apply(e, arguments)
												}, function () {
													c.apply(e, arguments)
												})
											} catch (t) {
												c.call(e, t)
											}
										}): (r.msg = i, r.state = 1, 0 < r.chain.length && o(l, r))
									} catch (t) {
										c.call(new h(r), t)
									}
								}
							}).call(n, t)
						}, function (t) {
							c.call(n, t)
						})
					} catch (t) {
						c.call(n, t)
					}
				}
				i = function () {
					var i, n, r;

					function o(t, e) {
						this.fn = t, this.self = e, this.next = void 0
					}
					return {
						add: function (t, e) {
							r = new o(t, e), n ? n.next = r : i = r, n = r, r = void 0
						},
						drain: function () {
							var t = i;
							for (i = n = a = void 0; t;) t.fn.call(t.self), t = t.next
						}
					}
				}();
				var p = t({}, "constructor", f, !1);
				return t(f.prototype = p, "__NPO__", 0, !1), t(f, "resolve", function (i) {
					return i && "object" == typeof i && 1 === i.__NPO__ ? i : new this(function (t, e) {
						if ("function" != typeof t || "function" != typeof e) throw TypeError("Not a function");
						t(i)
					})
				}), t(f, "reject", function (i) {
					return new this(function (t, e) {
						if ("function" != typeof t || "function" != typeof e) throw TypeError("Not a function");
						e(i)
					})
				}), t(f, "all", function (e) {
					var a = this;
					return "[object Array]" != r.call(e) ? a.reject(TypeError("Not an array")) : 0 === e.length ? a.resolve([]) : new a(function (i, t) {
						if ("function" != typeof i || "function" != typeof t) throw TypeError("Not a function");
						var n = e.length,
							r = Array(n),
							o = 0;
						u(a, e, function (t, e) {
							r[t] = e, ++o === n && i(r)
						}, t)
					})
				}), t(f, "race", function (e) {
					var n = this;
					return "[object Array]" != r.call(e) ? n.reject(TypeError("Not an array")) : new n(function (i, t) {
						if ("function" != typeof i || "function" != typeof t) throw TypeError("Not a function");
						u(n, e, function (t, e) {
							i(e)
						}, t)
					})
				}), f
			}, (i = a)[e = "Promise"] = i[e] || n(), t.exports && (t.exports = i[e])
		}(n = {
			exports: {}
		}, n.exports), n.exports),
		u = new WeakMap;

	function h(t, e, i) {
		var n = u.get(t.element) || {};
		e in n || (n[e] = []), n[e].push(i), u.set(t.element, n)
	}

	function d(t, e) {
		return (u.get(t.element) || {})[e] || []
	}

	function f(t, e, i) {
		var n = u.get(t.element) || {};
		if (!n[e]) return !0;
		if (!i) return n[e] = [], u.set(t.element, n), !0;
		var r = n[e].indexOf(i);
		return -1 !== r && n[e].splice(r, 1), u.set(t.element, n), n[e] && 0 === n[e].length
	}
	var p = ["autopause", "autoplay", "background", "byline", "color", "height", "id", "loop", "maxheight", "maxwidth", "muted", "playsinline", "portrait", "responsive", "speed", "title", "transparent", "url", "width"];

	function m(n) {
		var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
		return p.reduce(function (t, e) {
			var i = n.getAttribute("data-vimeo-".concat(e));
			return (i || "" === i) && (t[e] = "" === i ? 1 : i), t
		}, t)
	}

	function g(t, e) {
		var i = t.html;
		if (!e) throw new TypeError("An element must be provided");
		if (null !== e.getAttribute("data-vimeo-initialized")) return e.querySelector("iframe");
		var n = document.createElement("div");
		return n.innerHTML = i, e.appendChild(n.firstChild), e.setAttribute("data-vimeo-initialized", "true"), e.querySelector("iframe")
	}

	function v(o) {
		var a = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
			s = 2 < arguments.length ? arguments[2] : void 0;
		return new Promise(function (e, i) {
			if (!l(o)) throw new TypeError("“".concat(o, "” is not a vimeo.com url."));
			var t = "https://vimeo.com/api/oembed.json?url=".concat(encodeURIComponent(o), "&domain=").concat(window.location.hostname);
			for (var n in a) a.hasOwnProperty(n) && (t += "&".concat(n, "=").concat(encodeURIComponent(a[n])));
			var r = "XDomainRequest" in window ? new XDomainRequest : new XMLHttpRequest;
			r.open("GET", t, !0), r.onload = function () {
				if (404 !== r.status)
					if (403 !== r.status) try {
						var t = JSON.parse(r.responseText);
						if (403 === t.domain_status_code) return g(t, s), void i(new Error("“".concat(o, "” is not embeddable.")));
						e(t)
					} catch (t) {
						i(t)
					} else i(new Error("“".concat(o, "” is not embeddable.")));
					else i(new Error("“".concat(o, "” was not found.")))
			}, r.onerror = function () {
				var t = r.status ? " (".concat(r.status, ")") : "";
				i(new Error("There was an error fetching the embed code from Vimeo".concat(t, ".")))
			}, r.send()
		})
	}

	function y(t) {
		return "string" == typeof t && (t = JSON.parse(t)), t
	}

	function x(t, e, i) {
		if (t.element.contentWindow && t.element.contentWindow.postMessage) {
			var n = {
				method: e
			};
			void 0 !== i && (n.value = i);
			var r = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, "$1"));
			8 <= r && r < 10 && (n = JSON.stringify(n)), t.element.contentWindow.postMessage(n, t.origin)
		}
	}

	function _(i, n) {
		var e, t = [];
		if ((n = y(n)).event) {
			if ("error" === n.event) d(i, n.data.method).forEach(function (t) {
				var e = new Error(n.data.message);
				e.name = n.data.name, t.reject(e), f(i, n.data.method, t)
			});
			t = d(i, "event:".concat(n.event)), e = n.data
		} else if (n.method) {
			var r = function (t, e) {
				var i = d(t, e);
				if (i.length < 1) return !1;
				var n = i.shift();
				return f(t, e, n), n
			}(i, n.method);
			r && (t.push(r), e = n.value)
		}
		t.forEach(function (t) {
			try {
				if ("function" == typeof t) return void t.call(i, e);
				t.resolve(e)
			} catch (t) {}
		})
	}
	var b = new WeakMap,
		w = new WeakMap,
		T = function () {
			function i(o) {
				var a = this,
					n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
				if (function (t, e) {
						if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
					}(this, i), window.jQuery && o instanceof jQuery && (1 < o.length && window.console && console.warn && console.warn("A jQuery object with multiple elements was passed, using the first element."), o = o[0]), "undefined" != typeof document && "string" == typeof o && (o = document.getElementById(o)), !(o instanceof window.HTMLElement)) throw new TypeError("You must pass either a valid element or a valid id.");
				if ("IFRAME" !== o.nodeName) {
					var t = o.querySelector("iframe");
					t && (o = t)
				}
				if ("IFRAME" === o.nodeName && !l(o.getAttribute("src") || "")) throw new Error("The player element passed isn’t a Vimeo embed.");
				if (b.has(o)) return b.get(o);
				this.element = o, this.origin = "*";
				var e = new c(function (r, e) {
					var t = function (t) {
						if (l(t.origin) && a.element.contentWindow === t.source) {
							"*" === a.origin && (a.origin = t.origin);
							var e = y(t.data),
								i = "event" in e && "ready" === e.event,
								n = "method" in e && "ping" === e.method;
							if (i || n) return a.element.setAttribute("data-ready", "true"), void r();
							_(a, e)
						}
					};
					if (window.addEventListener ? window.addEventListener("message", t, !1) : window.attachEvent && window.attachEvent("onmessage", t), "IFRAME" !== a.element.nodeName) {
						var i = m(o, n);
						v(s(i), i, o).then(function (t) {
							var e, i, n, r = g(t, o);
							return a.element = r, a._originalElement = o, e = o, i = r, n = u.get(e), u.set(i, n), u.delete(e), b.set(a.element, a), t
						}).catch(function (t) {
							return e(t)
						})
					}
				});
				return w.set(this, e), b.set(this.element, this), "IFRAME" === this.element.nodeName && x(this, "ping"), this
			}
			var t, e, n;
			return t = i, (e = [{
				key: "callMethod",
				value: function (i) {
					var n = this,
						r = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
					return new c(function (t, e) {
						return n.ready().then(function () {
							h(n, i, {
								resolve: t,
								reject: e
							}), x(n, i, r)
						}).catch(function (t) {
							e(t)
						})
					})
				}
			}, {
				key: "get",
				value: function (i) {
					var n = this;
					return new c(function (t, e) {
						return i = o(i, "get"), n.ready().then(function () {
							h(n, i, {
								resolve: t,
								reject: e
							}), x(n, i)
						})
					})
				}
			}, {
				key: "set",
				value: function (n, t) {
					var r = this;
					return c.resolve(t).then(function (i) {
						if (n = o(n, "set"), null == i) throw new TypeError("There must be a value to set.");
						return r.ready().then(function () {
							return new c(function (t, e) {
								h(r, n, {
									resolve: t,
									reject: e
								}), x(r, n, i)
							})
						})
					})
				}
			}, {
				key: "on",
				value: function (t, e) {
					if (!t) throw new TypeError("You must pass an event name.");
					if (!e) throw new TypeError("You must pass a callback function.");
					if ("function" != typeof e) throw new TypeError("The callback must be a function.");
					0 === d(this, "event:".concat(t)).length && this.callMethod("addEventListener", t).catch(function () {}), h(this, "event:".concat(t), e)
				}
			}, {
				key: "off",
				value: function (t, e) {
					if (!t) throw new TypeError("You must pass an event name.");
					if (e && "function" != typeof e) throw new TypeError("The callback must be a function.");
					f(this, "event:".concat(t), e) && this.callMethod("removeEventListener", t).catch(function (t) {})
				}
			}, {
				key: "loadVideo",
				value: function (t) {
					return this.callMethod("loadVideo", t)
				}
			}, {
				key: "ready",
				value: function () {
					var t = w.get(this) || new c(function (t, e) {
						e(new Error("Unknown player. Probably unloaded."))
					});
					return c.resolve(t)
				}
			}, {
				key: "addCuePoint",
				value: function (t) {
					var e = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
					return this.callMethod("addCuePoint", {
						time: t,
						data: e
					})
				}
			}, {
				key: "removeCuePoint",
				value: function (t) {
					return this.callMethod("removeCuePoint", t)
				}
			}, {
				key: "enableTextTrack",
				value: function (t, e) {
					if (!t) throw new TypeError("You must pass a language.");
					return this.callMethod("enableTextTrack", {
						language: t,
						kind: e
					})
				}
			}, {
				key: "disableTextTrack",
				value: function () {
					return this.callMethod("disableTextTrack")
				}
			}, {
				key: "pause",
				value: function () {
					return this.callMethod("pause")
				}
			}, {
				key: "play",
				value: function () {
					return this.callMethod("play")
				}
			}, {
				key: "unload",
				value: function () {
					return this.callMethod("unload")
				}
			}, {
				key: "destroy",
				value: function () {
					var e = this;
					return new c(function (t) {
						w.delete(e), b.delete(e.element), e._originalElement && (b.delete(e._originalElement), e._originalElement.removeAttribute("data-vimeo-initialized")), e.element && "IFRAME" === e.element.nodeName && e.element.remove(), t()
					})
				}
			}, {
				key: "getAutopause",
				value: function () {
					return this.get("autopause")
				}
			}, {
				key: "setAutopause",
				value: function (t) {
					return this.set("autopause", t)
				}
			}, {
				key: "getColor",
				value: function () {
					return this.get("color")
				}
			}, {
				key: "setColor",
				value: function (t) {
					return this.set("color", t)
				}
			}, {
				key: "getCuePoints",
				value: function () {
					return this.get("cuePoints")
				}
			}, {
				key: "getCurrentTime",
				value: function () {
					return this.get("currentTime")
				}
			}, {
				key: "setCurrentTime",
				value: function (t) {
					return this.set("currentTime", t)
				}
			}, {
				key: "getDuration",
				value: function () {
					return this.get("duration")
				}
			}, {
				key: "getEnded",
				value: function () {
					return this.get("ended")
				}
			}, {
				key: "getLoop",
				value: function () {
					return this.get("loop")
				}
			}, {
				key: "setLoop",
				value: function (t) {
					return this.set("loop", t)
				}
			}, {
				key: "getPaused",
				value: function () {
					return this.get("paused")
				}
			}, {
				key: "getPlaybackRate",
				value: function () {
					return this.get("playbackRate")
				}
			}, {
				key: "setPlaybackRate",
				value: function (t) {
					return this.set("playbackRate", t)
				}
			}, {
				key: "getTextTracks",
				value: function () {
					return this.get("textTracks")
				}
			}, {
				key: "getVideoEmbedCode",
				value: function () {
					return this.get("videoEmbedCode")
				}
			}, {
				key: "getVideoId",
				value: function () {
					return this.get("videoId")
				}
			}, {
				key: "getVideoTitle",
				value: function () {
					return this.get("videoTitle")
				}
			}, {
				key: "getVideoWidth",
				value: function () {
					return this.get("videoWidth")
				}
			}, {
				key: "getVideoHeight",
				value: function () {
					return this.get("videoHeight")
				}
			}, {
				key: "getVideoUrl",
				value: function () {
					return this.get("videoUrl")
				}
			}, {
				key: "getVolume",
				value: function () {
					return this.get("volume")
				}
			}, {
				key: "setVolume",
				value: function (t) {
					return this.set("volume", t)
				}
			}]) && r(t.prototype, e), n && r(t, n), i
		}();
	return t || !window.Vimeo || window.Vimeo.Player || (function () {
		var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document,
			e = [].slice.call(t.querySelectorAll("[data-vimeo-id], [data-vimeo-url]")),
			i = function (t) {
				"console" in window && console.error && console.error("There was an error creating an embed: ".concat(t))
			};
		e.forEach(function (e) {
			try {
				if (null !== e.getAttribute("data-vimeo-defer")) return;
				var t = m(e);
				v(s(t), t, e).then(function (t) {
					return g(t, e)
				}).catch(i)
			} catch (t) {
				i(t)
			}
		})
	}(), function () {
		var n = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document,
			t = function (t) {
				if (l(t.origin) && t.data && "spacechange" === t.data.event)
					for (var e = n.querySelectorAll("iframe"), i = 0; i < e.length; i++)
						if (e[i].contentWindow === t.source) {
							e[i].parentElement.style.paddingBottom = "".concat(t.data.data[0].bottom, "px");
							break
						}
			};
		window.addEventListener ? window.addEventListener("message", t, !1) : window.attachEvent && window.attachEvent("onmessage", t)
	}()), T
});
(function (t, e) {
	"object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.tippy = e()
})(this, function () {
	"use strict";

	function o(t) {
		return "[object Object]" === {}.toString.call(t)
	}

	function r(t) {
		return [].slice.call(t)
	}

	function a(t) {
		if (t instanceof Element || o(t)) return [t];
		if (t instanceof NodeList) return r(t);
		if (Array.isArray(t)) return t;
		try {
			return r(document.querySelectorAll(t))
		} catch (t) {
			return []
		}
	}

	function s(i) {
		i.refObj = !0, i.attributes = i.attributes || {}, i.setAttribute = function (t, e) {
			i.attributes[t] = e
		}, i.getAttribute = function (t) {
			return i.attributes[t]
		}, i.removeAttribute = function (t) {
			delete i.attributes[t]
		}, i.hasAttribute = function (t) {
			return t in i.attributes
		}, i.addEventListener = function () {}, i.removeEventListener = function () {}, i.classList = {
			classNames: {},
			add: function (t) {
				return i.classList.classNames[t] = !0
			},
			remove: function (t) {
				return delete i.classList.classNames[t], !0
			},
			contains: function (t) {
				return t in i.classList.classNames
			}
		}
	}

	function h(t) {
		for (var e = ["", "webkit"], i = t.charAt(0).toUpperCase() + t.slice(1), n = 0; n < e.length; n++) {
			var r = e[n],
				o = r ? r + i : t;
			if ("undefined" != typeof document.body.style[o]) return o
		}
		return null
	}

	function u() {
		return document.createElement("div")
	}

	function c(t, e, i) {
		var n = u();
		n.setAttribute("class", "tippy-popper"), n.setAttribute("role", "tooltip"), n.setAttribute("id", "tippy-" + t), n.style.zIndex = i.zIndex, n.style.maxWidth = i.maxWidth;
		var r = u();
		r.setAttribute("class", "tippy-tooltip"), r.setAttribute("data-size", i.size), r.setAttribute("data-animation", i.animation), r.setAttribute("data-state", "hidden"), i.theme.split(" ").forEach(function (t) {
			r.classList.add(t + "-theme")
		});
		var o = u();
		if (o.setAttribute("class", "tippy-content"), i.arrow) {
			var a = u();
			a.style[h("transform")] = i.arrowTransform, "round" === i.arrowType ? (a.classList.add("tippy-roundarrow"), a.innerHTML = '<svg viewBox="0 0 24 8" xmlns="http://www.w3.org/2000/svg"><path d="M3 8s2.021-.015 5.253-4.218C9.584 2.051 10.797 1.007 12 1c1.203-.007 2.416 1.035 3.761 2.782C19.012 8.005 21 8 21 8H3z"/></svg>') : a.classList.add("tippy-arrow"), r.appendChild(a)
		}
		if (i.animateFill) {
			r.setAttribute("data-animatefill", "");
			var s = u();
			s.classList.add("tippy-backdrop"), s.setAttribute("data-state", "hidden"), r.appendChild(s)
		}
		i.inertia && r.setAttribute("data-inertia", ""), i.interactive && r.setAttribute("data-interactive", "");
		var l = i.html;
		if (l) {
			var c;
			l instanceof Element ? (o.appendChild(l), c = "#" + (l.id || "tippy-html-template")) : (o.innerHTML = document.querySelector(l).innerHTML, c = l), n.setAttribute("data-html", ""), r.setAttribute("data-template-id", c), i.interactive && n.setAttribute("tabindex", "-1")
		} else o[i.allowTitleHTML ? "innerHTML" : "textContent"] = e;
		return r.appendChild(o), n.appendChild(r), n
	}

	function d(t, i, e, n) {
		var r = e.onTrigger,
			o = e.onMouseLeave,
			a = e.onBlur,
			s = e.onDelegateShow,
			l = e.onDelegateHide,
			c = [];
		if ("manual" === t) return c;
		var u = function (t, e) {
			i.addEventListener(t, e), c.push({
				event: t,
				handler: e
			})
		};
		return n.target ? (jt.supportsTouch && n.touchHold && (u("touchstart", s), u("touchend", l)), "mouseenter" === t && (u("mouseover", s), u("mouseout", l)), "focus" === t && (u("focusin", s), u("focusout", l)), "click" === t && u("click", s)) : (u(t, r), jt.supportsTouch && n.touchHold && (u("touchstart", r), u("touchend", o)), "mouseenter" === t && u("mouseleave", o), "focus" === t && u(Ht ? "focusout" : "blur", a)), c
	}

	function f(n, r) {
		var t = Xt.reduce(function (t, e) {
			var i = n.getAttribute("data-tippy-" + e.toLowerCase()) || r[e];
			return "false" === i && (i = !1), "true" === i && (i = !0), isFinite(i) && !isNaN(parseFloat(i)) && (i = parseFloat(i)), "target" !== e && "string" == typeof i && "[" === i.trim().charAt(0) && (i = JSON.parse(i)), t[e] = i, t
		}, {});
		return $t({}, r, t)
	}

	function p(t, e) {
		return e.arrow && (e.animateFill = !1), e.appendTo && "function" == typeof e.appendTo && (e.appendTo = e.appendTo()), "function" == typeof e.html && (e.html = e.html(t)), e
	}

	function m(e) {
		var t = function (t) {
			return e.querySelector(t)
		};
		return {
			tooltip: t(Vt.TOOLTIP),
			backdrop: t(Vt.BACKDROP),
			content: t(Vt.CONTENT),
			arrow: t(Vt.ARROW) || t(Vt.ROUND_ARROW)
		}
	}

	function g(t) {
		var e = t.getAttribute("title");
		e && t.setAttribute("data-original-title", e), t.removeAttribute("title")
	}

	function l(t) {
		return t && "[object Function]" === {}.toString.call(t)
	}

	function _(t, e) {
		if (1 !== t.nodeType) return [];
		var i = getComputedStyle(t, null);
		return e ? i[e] : i
	}

	function v(t) {
		return "HTML" === t.nodeName ? t : t.parentNode || t.host
	}

	function y(t) {
		if (!t) return document.body;
		switch (t.nodeName) {
			case "HTML":
			case "BODY":
				return t.ownerDocument.body;
			case "#document":
				return t.body
		}
		var e = _(t),
			i = e.overflow,
			n = e.overflowX,
			r = e.overflowY;
		return /(auto|scroll|overlay)/.test(i + r + n) ? t : y(v(t))
	}

	function x(t) {
		return 11 === t ? ie : 10 === t ? ne : ie || ne
	}

	function b(t) {
		if (!t) return document.documentElement;
		for (var e = x(10) ? document.body : null, i = t.offsetParent; i === e && t.nextElementSibling;) i = (t = t.nextElementSibling).offsetParent;
		var n = i && i.nodeName;
		return n && "BODY" !== n && "HTML" !== n ? -1 !== ["TD", "TABLE"].indexOf(i.nodeName) && "static" === _(i, "position") ? b(i) : i : t ? t.ownerDocument.documentElement : document.documentElement
	}

	function w(t) {
		var e = t.nodeName;
		return "BODY" !== e && ("HTML" === e || b(t.firstElementChild) === t)
	}

	function T(t) {
		return null === t.parentNode ? t : T(t.parentNode)
	}

	function E(t, e) {
		if (!t || !t.nodeType || !e || !e.nodeType) return document.documentElement;
		var i = t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_FOLLOWING,
			n = i ? t : e,
			r = i ? e : t,
			o = document.createRange();
		o.setStart(n, 0), o.setEnd(r, 0);
		var a = o.commonAncestorContainer;
		if (t !== a && e !== a || n.contains(r)) return w(a) ? a : b(a);
		var s = T(t);
		return s.host ? E(s.host, e) : E(t, T(e).host)
	}

	function S(t) {
		var e = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "top",
			i = "top" === e ? "scrollTop" : "scrollLeft",
			n = t.nodeName;
		if ("BODY" === n || "HTML" === n) {
			var r = t.ownerDocument.documentElement,
				o = t.ownerDocument.scrollingElement || r;
			return o[i]
		}
		return t[i]
	}

	function M(t, e) {
		var i = !!(2 < arguments.length && void 0 !== arguments[2]) && arguments[2],
			n = S(e, "top"),
			r = S(e, "left"),
			o = i ? -1 : 1;
		return t.top += n * o, t.bottom += n * o, t.left += r * o, t.right += r * o, t
	}

	function A(t, e) {
		var i = "x" === e ? "Left" : "Top",
			n = "Left" === i ? "Right" : "Bottom";
		return parseFloat(t["border" + i + "Width"], 10) + parseFloat(t["border" + n + "Width"], 10)
	}

	function n(t, e, i, n) {
		return zt(e["offset" + t], e["scroll" + t], i["client" + t], i["offset" + t], i["scroll" + t], x(10) ? i["offset" + t] + n["margin" + ("Height" === t ? "Top" : "Left")] + n["margin" + ("Height" === t ? "Bottom" : "Right")] : 0)
	}

	function C() {
		var t = document.body,
			e = document.documentElement,
			i = x(10) && getComputedStyle(e);
		return {
			height: n("Height", t, e, i),
			width: n("Width", t, e, i)
		}
	}

	function P(t) {
		return se({}, t, {
			right: t.left + t.width,
			bottom: t.top + t.height
		})
	}

	function L(t) {
		var e = {};
		try {
			if (x(10)) {
				e = t.getBoundingClientRect();
				var i = S(t, "top"),
					n = S(t, "left");
				e.top += i, e.left += n, e.bottom += i, e.right += n
			} else e = t.getBoundingClientRect()
		} catch (t) {}
		var r = {
				left: e.left,
				top: e.top,
				width: e.right - e.left,
				height: e.bottom - e.top
			},
			o = "HTML" === t.nodeName ? C() : {},
			a = o.width || t.clientWidth || r.right - r.left,
			s = o.height || t.clientHeight || r.bottom - r.top,
			l = t.offsetWidth - a,
			c = t.offsetHeight - s;
		if (l || c) {
			var u = _(t);
			l -= A(u, "x"), c -= A(u, "y"), r.width -= l, r.height -= c
		}
		return P(r)
	}

	function R(t, e) {
		var i = !!(2 < arguments.length && void 0 !== arguments[2]) && arguments[2],
			n = x(10),
			r = "HTML" === e.nodeName,
			o = L(t),
			a = L(e),
			s = y(t),
			l = _(e),
			c = parseFloat(l.borderTopWidth, 10),
			u = parseFloat(l.borderLeftWidth, 10);
		i && "HTML" === e.nodeName && (a.top = zt(a.top, 0), a.left = zt(a.left, 0));
		var h = P({
			top: o.top - a.top - c,
			left: o.left - a.left - u,
			width: o.width,
			height: o.height
		});
		if (h.marginTop = 0, h.marginLeft = 0, !n && r) {
			var d = parseFloat(l.marginTop, 10),
				f = parseFloat(l.marginLeft, 10);
			h.top -= c - d, h.bottom -= c - d, h.left -= u - f, h.right -= u - f, h.marginTop = d, h.marginLeft = f
		}
		return (n && !i ? e.contains(s) : e === s && "BODY" !== s.nodeName) && (h = M(h, e)), h
	}

	function O(t) {
		var e = !!(1 < arguments.length && void 0 !== arguments[1]) && arguments[1],
			i = t.ownerDocument.documentElement,
			n = R(t, i),
			r = zt(i.clientWidth, window.innerWidth || 0),
			o = zt(i.clientHeight, window.innerHeight || 0),
			a = e ? 0 : S(i),
			s = e ? 0 : S(i, "left"),
			l = {
				top: a - n.top + n.marginTop,
				left: s - n.left + n.marginLeft,
				width: r,
				height: o
			};
		return P(l)
	}

	function k(t) {
		var e = t.nodeName;
		return "BODY" !== e && "HTML" !== e && ("fixed" === _(t, "position") || k(v(t)))
	}

	function N(t) {
		if (!t || !t.parentElement || x()) return document.documentElement;
		for (var e = t.parentElement; e && "none" === _(e, "transform");) e = e.parentElement;
		return e || document.documentElement
	}

	function I(t, e, i, n) {
		var r = !!(4 < arguments.length && void 0 !== arguments[4]) && arguments[4],
			o = {
				top: 0,
				left: 0
			},
			a = r ? N(t) : E(t, e);
		if ("viewport" === n) o = O(a, r);
		else {
			var s;
			"scrollParent" === n ? (s = y(v(e)), "BODY" === s.nodeName && (s = t.ownerDocument.documentElement)) : "window" === n ? s = t.ownerDocument.documentElement : s = n;
			var l = R(s, a, r);
			if ("HTML" === s.nodeName && !k(a)) {
				var c = C(),
					u = c.height,
					h = c.width;
				o.top += l.top - l.marginTop, o.bottom = u + l.top, o.left += l.left - l.marginLeft, o.right = h + l.left
			} else o = l
		}
		return o.left += i, o.top += i, o.right -= i, o.bottom -= i, o
	}

	function D(t) {
		var e = t.width,
			i = t.height;
		return e * i
	}

	function F(t, e, n, i, r) {
		var o = 5 < arguments.length && void 0 !== arguments[5] ? arguments[5] : 0;
		if (-1 === t.indexOf("auto")) return t;
		var a = I(n, i, o, r),
			s = {
				top: {
					width: a.width,
					height: e.top - a.top
				},
				right: {
					width: a.right - e.right,
					height: a.height
				},
				bottom: {
					width: a.width,
					height: a.bottom - e.bottom
				},
				left: {
					width: e.left - a.left,
					height: a.height
				}
			},
			l = Object.keys(s).map(function (t) {
				return se({
					key: t
				}, s[t], {
					area: D(s[t])
				})
			}).sort(function (t, e) {
				return e.area - t.area
			}),
			c = l.filter(function (t) {
				var e = t.width,
					i = t.height;
				return e >= n.clientWidth && i >= n.clientHeight
			}),
			u = 0 < c.length ? c[0].key : l[0].key,
			h = t.split("-")[1];
		return u + (h ? "-" + h : "")
	}

	function B(t, e, i) {
		var n = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null,
			r = n ? N(e) : E(e, i);
		return R(i, r, n)
	}

	function U(t) {
		var e = getComputedStyle(t),
			i = parseFloat(e.marginTop) + parseFloat(e.marginBottom),
			n = parseFloat(e.marginLeft) + parseFloat(e.marginRight),
			r = {
				width: t.offsetWidth + n,
				height: t.offsetHeight + i
			};
		return r
	}

	function z(t) {
		var e = {
			left: "right",
			right: "left",
			bottom: "top",
			top: "bottom"
		};
		return t.replace(/left|right|bottom|top/g, function (t) {
			return e[t]
		})
	}

	function G(t, e, i) {
		i = i.split("-")[0];
		var n = U(t),
			r = {
				width: n.width,
				height: n.height
			},
			o = -1 !== ["right", "left"].indexOf(i),
			a = o ? "top" : "left",
			s = o ? "left" : "top",
			l = o ? "height" : "width",
			c = o ? "width" : "height";
		return r[a] = e[a] + e[l] / 2 - n[l] / 2, r[s] = i === s ? e[s] - n[c] : e[z(s)], r
	}

	function H(t, e) {
		return Array.prototype.find ? t.find(e) : t.filter(e)[0]
	}

	function j(t, e, i) {
		if (Array.prototype.findIndex) return t.findIndex(function (t) {
			return t[e] === i
		});
		var n = H(t, function (t) {
			return t[e] === i
		});
		return t.indexOf(n)
	}

	function V(t, i, e) {
		var n = void 0 === e ? t : t.slice(0, j(t, "name", e));
		return n.forEach(function (t) {
			t["function"] && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
			var e = t["function"] || t.fn;
			t.enabled && l(e) && (i.offsets.popper = P(i.offsets.popper), i.offsets.reference = P(i.offsets.reference), i = e(i, t))
		}), i
	}

	function t() {
		if (!this.state.isDestroyed) {
			var t = {
				instance: this,
				styles: {},
				arrowStyles: {},
				attributes: {},
				flipped: !1,
				offsets: {}
			};
			t.offsets.reference = B(this.state, this.popper, this.reference, this.options.positionFixed), t.placement = F(this.options.placement, t.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), t.originalPlacement = t.placement, t.positionFixed = this.options.positionFixed, t.offsets.popper = G(this.popper, t.offsets.reference, t.placement), t.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute", t = V(this.modifiers, t), this.state.isCreated ? this.options.onUpdate(t) : (this.state.isCreated = !0, this.options.onCreate(t))
		}
	}

	function e(t, n) {
		return t.some(function (t) {
			var e = t.name,
				i = t.enabled;
			return i && e === n
		})
	}

	function W(t) {
		for (var e = [!1, "ms", "Webkit", "Moz", "O"], i = t.charAt(0).toUpperCase() + t.slice(1), n = 0; n < e.length; n++) {
			var r = e[n],
				o = r ? "" + r + i : t;
			if ("undefined" != typeof document.body.style[o]) return o
		}
		return null
	}

	function i() {
		return this.state.isDestroyed = !0, e(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), this.popper.style.position = "", this.popper.style.top = "", this.popper.style.left = "", this.popper.style.right = "", this.popper.style.bottom = "", this.popper.style.willChange = "", this.popper.style[W("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this
	}

	function X(t) {
		var e = t.ownerDocument;
		return e ? e.defaultView : window
	}

	function Y(t, e, i, n) {
		var r = "BODY" === t.nodeName,
			o = r ? t.ownerDocument.defaultView : t;
		o.addEventListener(e, i, {
			passive: !0
		}), r || Y(y(o.parentNode), e, i, n), n.push(o)
	}

	function q(t, e, i, n) {
		i.updateBound = n, X(t).addEventListener("resize", i.updateBound, {
			passive: !0
		});
		var r = y(t);
		return Y(r, "scroll", i.updateBound, i.scrollParents), i.scrollElement = r, i.eventsEnabled = !0, i
	}

	function $() {
		this.state.eventsEnabled || (this.state = q(this.reference, this.options, this.state, this.scheduleUpdate))
	}

	function Z(t, e) {
		return X(t).removeEventListener("resize", e.updateBound), e.scrollParents.forEach(function (t) {
			t.removeEventListener("scroll", e.updateBound)
		}), e.updateBound = null, e.scrollParents = [], e.scrollElement = null, e.eventsEnabled = !1, e
	}

	function J() {
		this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = Z(this.reference, this.state))
	}

	function Q(t) {
		return "" !== t && !isNaN(parseFloat(t)) && isFinite(t)
	}

	function K(i, n) {
		Object.keys(n).forEach(function (t) {
			var e = ""; - 1 !== ["width", "height", "top", "right", "bottom", "left"].indexOf(t) && Q(n[t]) && (e = "px"), i.style[t] = n[t] + e
		})
	}

	function tt(i, n) {
		Object.keys(n).forEach(function (t) {
			var e = n[t];
			!1 === e ? i.removeAttribute(t) : i.setAttribute(t, n[t])
		})
	}

	function et(t, i, e) {
		var n = H(t, function (t) {
				var e = t.name;
				return e === i
			}),
			r = !!n && t.some(function (t) {
				return t.name === e && t.enabled && t.order < n.order
			});
		if (!r) {
			var o = "`" + i + "`";
			console.warn("`" + e + "`" + " modifier is required by " + o + " modifier in order to work, be sure to include it before " + o + "!")
		}
		return r
	}

	function it(t) {
		return "end" === t ? "start" : "start" === t ? "end" : t
	}

	function nt(t) {
		var e = !!(1 < arguments.length && void 0 !== arguments[1]) && arguments[1],
			i = ce.indexOf(t),
			n = ce.slice(i + 1).concat(ce.slice(0, i));
		return e ? n.reverse() : n
	}

	function rt(t, e, i, n) {
		var r = t.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),
			o = +r[1],
			a = r[2];
		if (!o) return t;
		if (0 === a.indexOf("%")) {
			var s;
			switch (a) {
				case "%p":
					s = i;
					break;
				case "%":
				case "%r":
				default:
					s = n
			}
			var l = P(s);
			return l[e] / 100 * o
		}
		if ("vh" === a || "vw" === a) {
			var c;
			return c = "vh" === a ? zt(document.documentElement.clientHeight, window.innerHeight || 0) : zt(document.documentElement.clientWidth, window.innerWidth || 0), c / 100 * o
		}
		return o
	}

	function ot(t, r, o, e) {
		var a = [0, 0],
			s = -1 !== ["right", "left"].indexOf(e),
			i = t.split(/(\+|\-)/).map(function (t) {
				return t.trim()
			}),
			n = i.indexOf(H(i, function (t) {
				return -1 !== t.search(/,|\s/)
			}));
		i[n] && -1 === i[n].indexOf(",") && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
		var l = /\s*,\s*|\s+/,
			c = -1 === n ? [i] : [i.slice(0, n).concat([i[n].split(l)[0]]), [i[n].split(l)[1]].concat(i.slice(n + 1))];
		return c = c.map(function (t, e) {
			var i = (1 === e ? !s : s) ? "height" : "width",
				n = !1;
			return t.reduce(function (t, e) {
				return "" === t[t.length - 1] && -1 !== ["+", "-"].indexOf(e) ? (t[t.length - 1] = e, n = !0, t) : n ? (t[t.length - 1] += e, n = !1, t) : t.concat(e)
			}, []).map(function (t) {
				return rt(t, i, r, o)
			})
		}), c.forEach(function (i, n) {
			i.forEach(function (t, e) {
				Q(t) && (a[n] += t * ("-" === i[e - 1] ? -1 : 1))
			})
		}), a
	}

	function at(t, e) {
		var i = e.offset,
			n = t.placement,
			r = t.offsets,
			o = r.popper,
			a = r.reference,
			s = n.split("-")[0],
			l = void 0;
		return l = Q(+i) ? [+i, 0] : ot(i, o, a, s), "left" === s ? (o.top += l[0], o.left -= l[1]) : "right" === s ? (o.top += l[0], o.left += l[1]) : "top" === s ? (o.left += l[0], o.top -= l[1]) : "bottom" === s && (o.left += l[0], o.top += l[1]), t.popper = o, t
	}

	function st(t) {
		void t.offsetHeight
	}

	function lt(t, e, i) {
		var n = t.popper,
			r = t.options,
			o = r.onCreate,
			a = r.onUpdate;
		r.onCreate = r.onUpdate = function () {
			st(n), e && e(), a(), r.onCreate = o, r.onUpdate = a
		}, i || t.scheduleUpdate()
	}

	function ct(t) {
		return t.getAttribute("x-placement").replace(/-.+/, "")
	}

	function ut(t, e, i) {
		if (!e.getAttribute("x-placement")) return !0;
		var n = t.clientX,
			r = t.clientY,
			o = i.interactiveBorder,
			a = i.distance,
			s = e.getBoundingClientRect(),
			l = ct(e),
			c = o + a,
			u = {
				top: s.top - r > o,
				bottom: r - s.bottom > o,
				left: s.left - n > o,
				right: n - s.right > o
			};
		return "top" === l ? u.top = s.top - r > c : "bottom" === l ? u.bottom = r - s.bottom > c : "left" === l ? u.left = s.left - n > c : "right" === l ? u.right = n - s.right > c : void 0, u.top || u.bottom || u.left || u.right
	}

	function ht(t, e, i, n) {
		if (!e.length) return "";
		var r = {
			scale: function () {
				return 1 === e.length ? "" + e[0] : i ? e[0] + ", " + e[1] : e[1] + ", " + e[0]
			}(),
			translate: function () {
				return 1 === e.length ? n ? -e[0] + "px" : e[0] + "px" : i ? n ? e[0] + "px, " + -e[1] + "px" : e[0] + "px, " + e[1] + "px" : n ? -e[1] + "px, " + e[0] + "px" : e[1] + "px, " + e[0] + "px"
			}()
		};
		return r[t]
	}

	function dt(t, e) {
		if (!t) return "";
		return e ? t : {
			X: "Y",
			Y: "X"
		}[t]
	}

	function ft(t, e, i) {
		var n = ct(t),
			r = "top" === n || "bottom" === n,
			o = "right" === n || "bottom" === n,
			a = function (t) {
				var e = i.match(t);
				return e ? e[1] : ""
			},
			s = function (t) {
				var e = i.match(t);
				return e ? e[1].split(",").map(parseFloat) : []
			},
			l = {
				translate: /translateX?Y?\(([^)]+)\)/,
				scale: /scaleX?Y?\(([^)]+)\)/
			},
			c = {
				translate: {
					axis: a(/translate([XY])/),
					numbers: s(l.translate)
				},
				scale: {
					axis: a(/scale([XY])/),
					numbers: s(l.scale)
				}
			},
			u = i.replace(l.translate, "translate" + dt(c.translate.axis, r) + "(" + ht("translate", c.translate.numbers, r, o) + ")").replace(l.scale, "scale" + dt(c.scale.axis, r) + "(" + ht("scale", c.scale.numbers, r, o) + ")");
		e.style[h("transform")] = u
	}

	function pt(t) {
		return -(t - Wt.distance) + "px"
	}

	function mt(t) {
		requestAnimationFrame(function () {
			setTimeout(t, 1)
		})
	}

	function gt(t, e) {
		var i = Element.prototype.closest || function (t) {
			for (var e = this; e;) {
				if (pe.call(e, t)) return e;
				e = e.parentElement
			}
		};
		return i.call(t, e)
	}

	function vt(t, e) {
		return Array.isArray(t) ? t[e] : t
	}

	function yt(t, e) {
		t.forEach(function (t) {
			t && t.setAttribute("data-state", e)
		})
	}

	function xt(t, e) {
		t.filter(Boolean).forEach(function (t) {
			t.style[h("transitionDuration")] = e + "ms"
		})
	}

	function _t(t) {
		var e = window.scrollX || window.pageXOffset,
			i = window.scrollY || window.pageYOffset;
		t.focus(), scroll(e, i)
	}

	function bt() {
		var t = this._(me).lastTriggerEvent;
		return this.options.followCursor && !jt.usingTouch && t && "focus" !== t.type
	}

	function wt(t) {
		var e = gt(t.target, this.options.target);
		if (e && !e._tippy) {
			var i = e.getAttribute("title") || this.title;
			i && (e.setAttribute("title", i), Dt(e, $t({}, this.options, {
				target: null
			})), Tt.call(e._tippy, t))
		}
	}

	function Tt(t) {
		var e = this,
			i = this.options;
		if (Ct.call(this), !this.state.visible) {
			if (i.target) return void wt.call(this, t);
			if (this._(me).isPreparingToShow = !0, i.wait) return void i.wait.call(this.popper, this.show.bind(this), t);
			if (bt.call(this)) {
				this._(me).followCursorListener || Pt.call(this);
				var n = m(this.popper),
					r = n.arrow;
				r && (r.style.margin = "0"), document.addEventListener("mousemove", this._(me).followCursorListener)
			}
			var o = vt(i.delay, 0);
			o ? this._(me).showTimeout = setTimeout(function () {
				e.show()
			}, o) : this.show()
		}
	}

	function Et() {
		var t = this;
		if (Ct.call(this), !!this.state.visible) {
			this._(me).isPreparingToShow = !1;
			var e = vt(this.options.delay, 1);
			e ? this._(me).hideTimeout = setTimeout(function () {
				t.state.visible && t.hide()
			}, e) : this.hide()
		}
	}

	function St() {
		var a = this;
		return {
			onTrigger: function (t) {
				if (a.state.enabled) {
					var e = jt.supportsTouch && jt.usingTouch && -1 < ["mouseenter", "mouseover", "focus"].indexOf(t.type);
					e && a.options.touchHold || (a._(me).lastTriggerEvent = t, "click" === t.type && "persistent" !== a.options.hideOnClick && a.state.visible ? Et.call(a) : Tt.call(a, t))
				}
			},
			onMouseLeave: function (t) {
				if (!(-1 < ["mouseleave", "mouseout"].indexOf(t.type) && jt.supportsTouch && jt.usingTouch && a.options.touchHold)) {
					if (a.options.interactive) {
						var o = Et.bind(a),
							e = function t(e) {
								var i = gt(e.target, Vt.REFERENCE),
									n = gt(e.target, Vt.POPPER) === a.popper,
									r = i === a.reference;
								n || r || ut(e, a.popper, a.options) && (document.body.removeEventListener("mouseleave", o), document.removeEventListener("mousemove", t), Et.call(a, t))
							};
						return document.body.addEventListener("mouseleave", o), void document.addEventListener("mousemove", e)
					}
					Et.call(a)
				}
			},
			onBlur: function (t) {
				if (!(t.target !== a.reference || jt.usingTouch)) {
					if (a.options.interactive) {
						if (!t.relatedTarget) return;
						if (gt(t.relatedTarget, Vt.POPPER)) return
					}
					Et.call(a)
				}
			},
			onDelegateShow: function (t) {
				gt(t.target, a.options.target) && Tt.call(a, t)
			},
			onDelegateHide: function (t) {
				gt(t.target, a.options.target) && Et.call(a)
			}
		}
	}

	function Mt() {
		var t = this,
			e = this.popper,
			i = this.reference,
			n = this.options,
			r = m(e),
			o = r.tooltip,
			a = n.popperOptions,
			s = "round" === n.arrowType ? Vt.ROUND_ARROW : Vt.ARROW,
			l = o.querySelector(s),
			c = $t({
				placement: n.placement
			}, a || {}, {
				modifiers: $t({}, a ? a.modifiers : {}, {
					arrow: $t({
						element: s
					}, a && a.modifiers ? a.modifiers.arrow : {}),
					flip: $t({
						enabled: n.flip,
						padding: n.distance + 5,
						behavior: n.flipBehavior
					}, a && a.modifiers ? a.modifiers.flip : {}),
					offset: $t({
						offset: n.offset
					}, a && a.modifiers ? a.modifiers.offset : {})
				}),
				onCreate: function () {
					o.style[ct(e)] = pt(n.distance), l && n.arrowTransform && ft(e, l, n.arrowTransform)
				},
				onUpdate: function () {
					var t = o.style;
					t.top = "", t.bottom = "", t.left = "", t.right = "", t[ct(e)] = pt(n.distance), l && n.arrowTransform && ft(e, l, n.arrowTransform)
				}
			});
		return Rt.call(this, {
			target: e,
			callback: function () {
				t.popperInstance.update()
			},
			options: {
				childList: !0,
				subtree: !0,
				characterData: !0
			}
		}), new he(i, e, c)
	}

	function At(t) {
		var e = this.options;
		if (this.popperInstance ? (this.popperInstance.scheduleUpdate(), e.livePlacement && !bt.call(this) && this.popperInstance.enableEventListeners()) : (this.popperInstance = Mt.call(this), !e.livePlacement && this.popperInstance.disableEventListeners()), !bt.call(this)) {
			var i = m(this.popper),
				n = i.arrow;
			n && (n.style.margin = ""), this.popperInstance.reference = this.reference
		}
		lt(this.popperInstance, t, !0), e.appendTo.contains(this.popper) || e.appendTo.appendChild(this.popper)
	}

	function Ct() {
		var t = this._(me),
			e = t.showTimeout,
			i = t.hideTimeout;
		clearTimeout(e), clearTimeout(i)
	}

	function Pt() {
		var r = this;
		this._(me).followCursorListener = function (t) {
			var e = r._(me).lastMouseMoveEvent = t,
				i = e.clientX,
				n = e.clientY;
			r.popperInstance && (r.popperInstance.reference = {
				getBoundingClientRect: function () {
					return {
						width: 0,
						height: 0,
						top: n,
						left: i,
						right: i,
						bottom: n
					}
				},
				clientWidth: 0,
				clientHeight: 0
			}, r.popperInstance.scheduleUpdate())
		}
	}

	function Lt() {
		var e = this,
			i = function () {
				e.popper.style[h("transitionDuration")] = e.options.updateDuration + "ms"
			},
			n = function () {
				e.popper.style[h("transitionDuration")] = ""
			};
		(function t() {
			e.popperInstance && e.popperInstance.update(), i(), e.state.visible ? requestAnimationFrame(t) : n()
		})()
	}

	function Rt(t) {
		var e = t.target,
			i = t.callback,
			n = t.options;
		if (window.MutationObserver) {
			var r = new MutationObserver(i);
			r.observe(e, n), this._(me).mutationObservers.push(r)
		}
	}

	function Ot(t, i) {
		if (!t) return i();
		var e = m(this.popper),
			n = e.tooltip,
			r = function (t, e) {
				e && n[t + "EventListener"]("transition" in document.body.style ? "transitionend" : "webkitTransitionEnd", e)
			},
			o = function t(e) {
				e.target === n && (r("remove", t), i())
			};
		r("remove", this._(me).transitionendListener), r("add", o), this._(me).transitionendListener = o
	}

	function kt(t, l) {
		return t.reduce(function (t, n) {
			var e = ye,
				r = p(n, l.performance ? l : f(n, l)),
				i = n.getAttribute("title");
			if (!i && !r.target && !r.html && !r.dynamicTitle) return t;
			n.setAttribute(r.target ? "data-tippy-delegate" : "data-tippy", ""), g(n);
			var o = c(e, i, r),
				a = new ve({
					id: e,
					reference: n,
					popper: o,
					options: r,
					title: i,
					popperInstance: null
				});
			r.createPopperInstanceOnInit && (a.popperInstance = Mt.call(a), a.popperInstance.disableEventListeners());
			var s = St.call(a);
			return a.listeners = r.trigger.trim().split(" ").reduce(function (t, e) {
				return t.concat(d(e, n, s, r))
			}, []), r.dynamicTitle && Rt.call(a, {
				target: n,
				callback: function () {
					var t = m(o),
						e = t.content,
						i = n.getAttribute("title");
					i && (e[r.allowTitleHTML ? "innerHTML" : "textContent"] = a.title = i, g(n))
				},
				options: {
					attributes: !0
				}
			}), n._tippy = a, o._tippy = a, o._reference = n, t.push(a), ye++, t
		}, [])
	}

	function Nt(n) {
		var t = r(document.querySelectorAll(Vt.POPPER));
		t.forEach(function (t) {
			var e = t._tippy;
			if (e) {
				var i = e.options;
				(!0 === i.hideOnClick || -1 < i.trigger.indexOf("focus")) && (!n || t !== n.popper) && e.hide()
			}
		})
	}

	function It() {
		var t = function () {
				jt.usingTouch || (jt.usingTouch = !0, jt.iOS && document.body.classList.add("tippy-touch"), jt.dynamicInputDetection && window.performance && document.addEventListener("mousemove", i), jt.onUserInputChange("touch"))
			},
			i = function () {
				var e;
				return function () {
					var t = performance.now();
					20 > t - e && (jt.usingTouch = !1, document.removeEventListener("mousemove", i), !jt.iOS && document.body.classList.remove("tippy-touch"), jt.onUserInputChange("mouse")), e = t
				}
			}();
		document.addEventListener("click", function (t) {
			if (!(t.target instanceof Element)) return Nt();
			var e = gt(t.target, Vt.REFERENCE),
				i = gt(t.target, Vt.POPPER);
			if (!(i && i._tippy && i._tippy.options.interactive)) {
				if (e && e._tippy) {
					var n = e._tippy.options,
						r = -1 < n.trigger.indexOf("click"),
						o = n.multiple;
					if (!o && jt.usingTouch || !o && r) return Nt(e._tippy);
					if (!0 !== n.hideOnClick || r) return
				}
				Nt()
			}
		}), document.addEventListener("touchstart", t), window.addEventListener("blur", function () {
			var t = document,
				e = t.activeElement;
			e && e.blur && pe.call(e, Vt.REFERENCE) && e.blur()
		}), window.addEventListener("resize", function () {
			r(document.querySelectorAll(Vt.POPPER)).forEach(function (t) {
				var e = t._tippy;
				e && !e.options.livePlacement && e.popperInstance.scheduleUpdate()
			})
		}), !jt.supportsTouch && (navigator.maxTouchPoints || navigator.msMaxTouchPoints) && document.addEventListener("pointerdown", t)
	}

	function Dt(t, e, i) {
		jt.supported && !xe && (It(), xe = !0), o(t) && s(t), e = $t({}, Wt, e);
		var n = a(t),
			r = n[0];
		return {
			selector: t,
			options: e,
			tooltips: jt.supported ? kt(i && r ? [r] : n, e) : [],
			destroyAll: function () {
				this.tooltips.forEach(function (t) {
					return t.destroy()
				}), this.tooltips = []
			}
		}
	}
	var Ft = Math.min,
		Bt = Math.round,
		Ut = Math.floor,
		zt = Math.max,
		Gt = "undefined" != typeof window,
		Ht = Gt && /MSIE |Trident\//.test(navigator.userAgent),
		jt = {};
	Gt && (jt.supported = "requestAnimationFrame" in window, jt.supportsTouch = "ontouchstart" in window, jt.usingTouch = !1, jt.dynamicInputDetection = !0, jt.iOS = /iPhone|iPad|iPod/.test(navigator.platform) && !window.MSStream, jt.onUserInputChange = function () {});
	for (var Vt = {
			POPPER: ".tippy-popper",
			TOOLTIP: ".tippy-tooltip",
			CONTENT: ".tippy-content",
			BACKDROP: ".tippy-backdrop",
			ARROW: ".tippy-arrow",
			ROUND_ARROW: ".tippy-roundarrow",
			REFERENCE: "[data-tippy]"
		}, Wt = {
			placement: "top",
			livePlacement: !0,
			trigger: "mouseenter focus",
			animation: "shift-away",
			html: !1,
			animateFill: !0,
			arrow: !1,
			delay: 0,
			duration: [350, 300],
			interactive: !1,
			interactiveBorder: 2,
			theme: "dark",
			size: "regular",
			distance: 10,
			offset: 0,
			hideOnClick: !0,
			multiple: !1,
			followCursor: !1,
			inertia: !1,
			updateDuration: 350,
			sticky: !1,
			appendTo: function () {
				return document.body
			},
			zIndex: 9999,
			touchHold: !1,
			performance: !1,
			dynamicTitle: !1,
			flip: !0,
			flipBehavior: "flip",
			arrowType: "sharp",
			arrowTransform: "",
			maxWidth: "",
			target: null,
			allowTitleHTML: !0,
			popperOptions: {},
			createPopperInstanceOnInit: !1,
			onShow: function () {},
			onShown: function () {},
			onHide: function () {},
			onHidden: function () {}
		}, Xt = jt.supported && Object.keys(Wt), Yt = function (t, e) {
			if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
		}, qt = function () {
			function n(t, e) {
				for (var i, n = 0; n < e.length; n++) i = e[n], i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
			}
			return function (t, e, i) {
				return e && n(t.prototype, e), i && n(t, i), t
			}
		}(), $t = Object.assign || function (t) {
			for (var e, i = 1; i < arguments.length; i++)
				for (var n in e = arguments[i], e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
			return t
		}, Zt = "undefined" != typeof window && "undefined" != typeof document, Jt = ["Edge", "Trident", "Firefox"], Qt = 0, Kt = 0; Kt < Jt.length; Kt += 1)
		if (Zt && 0 <= navigator.userAgent.indexOf(Jt[Kt])) {
			Qt = 1;
			break
		}
	var te = Zt && window.Promise,
		ee = te ? function (t) {
			var e = !1;
			return function () {
				e || (e = !0, window.Promise.resolve().then(function () {
					e = !1, t()
				}))
			}
		} : function (t) {
			var e = !1;
			return function () {
				e || (e = !0, setTimeout(function () {
					e = !1, t()
				}, Qt))
			}
		},
		ie = Zt && !!(window.MSInputMethodContext && document.documentMode),
		ne = Zt && /MSIE 10/.test(navigator.userAgent),
		re = function (t, e) {
			if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
		},
		oe = function () {
			function n(t, e) {
				for (var i, n = 0; n < e.length; n++) i = e[n], i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
			}
			return function (t, e, i) {
				return e && n(t.prototype, e), i && n(t, i), t
			}
		}(),
		ae = function (t, e, i) {
			return e in t ? Object.defineProperty(t, e, {
				value: i,
				enumerable: !0,
				configurable: !0,
				writable: !0
			}) : t[e] = i, t
		},
		se = Object.assign || function (t) {
			for (var e, i = 1; i < arguments.length; i++)
				for (var n in e = arguments[i], e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
			return t
		},
		le = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"],
		ce = le.slice(3),
		ue = {
			FLIP: "flip",
			CLOCKWISE: "clockwise",
			COUNTERCLOCKWISE: "counterclockwise"
		},
		he = function () {
			function o(t, e) {
				var i = this,
					n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {};
				re(this, o), this.scheduleUpdate = function () {
					return requestAnimationFrame(i.update)
				}, this.update = ee(this.update.bind(this)), this.options = se({}, o.Defaults, n), this.state = {
					isDestroyed: !1,
					isCreated: !1,
					scrollParents: []
				}, this.reference = t && t.jquery ? t[0] : t, this.popper = e && e.jquery ? e[0] : e, this.options.modifiers = {}, Object.keys(se({}, o.Defaults.modifiers, n.modifiers)).forEach(function (t) {
					i.options.modifiers[t] = se({}, o.Defaults.modifiers[t] || {}, n.modifiers ? n.modifiers[t] : {})
				}), this.modifiers = Object.keys(this.options.modifiers).map(function (t) {
					return se({
						name: t
					}, i.options.modifiers[t])
				}).sort(function (t, e) {
					return t.order - e.order
				}), this.modifiers.forEach(function (t) {
					t.enabled && l(t.onLoad) && t.onLoad(i.reference, i.popper, i.options, t, i.state)
				}), this.update();
				var r = this.options.eventsEnabled;
				r && this.enableEventListeners(), this.state.eventsEnabled = r
			}
			return oe(o, [{
				key: "update",
				value: function () {
					return t.call(this)
				}
			}, {
				key: "destroy",
				value: function () {
					return i.call(this)
				}
			}, {
				key: "enableEventListeners",
				value: function () {
					return $.call(this)
				}
			}, {
				key: "disableEventListeners",
				value: function () {
					return J.call(this)
				}
			}]), o
		}();
	he.Utils = ("undefined" == typeof window ? global : window).PopperUtils, he.placements = le, he.Defaults = {
		placement: "bottom",
		positionFixed: !1,
		eventsEnabled: !0,
		removeOnDestroy: !1,
		onCreate: function () {},
		onUpdate: function () {},
		modifiers: {
			shift: {
				order: 100,
				enabled: !0,
				fn: function (t) {
					var e = t.placement,
						i = e.split("-")[0],
						n = e.split("-")[1];
					if (n) {
						var r = t.offsets,
							o = r.reference,
							a = r.popper,
							s = -1 !== ["bottom", "top"].indexOf(i),
							l = s ? "left" : "top",
							c = s ? "width" : "height",
							u = {
								start: ae({}, l, o[l]),
								end: ae({}, l, o[l] + o[c] - a[c])
							};
						t.offsets.popper = se({}, a, u[n])
					}
					return t
				}
			},
			offset: {
				order: 200,
				enabled: !0,
				fn: at,
				offset: 0
			},
			preventOverflow: {
				order: 300,
				enabled: !0,
				fn: function (t, n) {
					var e = n.boundariesElement || b(t.instance.popper);
					t.instance.reference === e && (e = b(e));
					var i = W("transform"),
						r = t.instance.popper.style,
						o = r.top,
						a = r.left,
						s = r[i];
					r.top = "", r.left = "", r[i] = "";
					var l = I(t.instance.popper, t.instance.reference, n.padding, e, t.positionFixed);
					r.top = o, r.left = a, r[i] = s, n.boundaries = l;
					var c = n.priority,
						u = t.offsets.popper,
						h = {
							primary: function (t) {
								var e = u[t];
								return u[t] < l[t] && !n.escapeWithReference && (e = zt(u[t], l[t])), ae({}, t, e)
							},
							secondary: function (t) {
								var e = "right" === t ? "left" : "top",
									i = u[e];
								return u[t] > l[t] && !n.escapeWithReference && (i = Ft(u[e], l[t] - ("right" === t ? u.width : u.height))), ae({}, e, i)
							}
						};
					return c.forEach(function (t) {
						var e = -1 === ["left", "top"].indexOf(t) ? "secondary" : "primary";
						u = se({}, u, h[e](t))
					}), t.offsets.popper = u, t
				},
				priority: ["left", "right", "top", "bottom"],
				padding: 5,
				boundariesElement: "scrollParent"
			},
			keepTogether: {
				order: 400,
				enabled: !0,
				fn: function (t) {
					var e = t.offsets,
						i = e.popper,
						n = e.reference,
						r = t.placement.split("-")[0],
						o = Ut,
						a = -1 !== ["top", "bottom"].indexOf(r),
						s = a ? "right" : "bottom",
						l = a ? "left" : "top",
						c = a ? "width" : "height";
					return i[s] < o(n[l]) && (t.offsets.popper[l] = o(n[l]) - i[c]), i[l] > o(n[s]) && (t.offsets.popper[l] = o(n[s])), t
				}
			},
			arrow: {
				order: 500,
				enabled: !0,
				fn: function (t, e) {
					var i;
					if (!et(t.instance.modifiers, "arrow", "keepTogether")) return t;
					var n = e.element;
					if ("string" == typeof n) {
						if (n = t.instance.popper.querySelector(n), !n) return t
					} else if (!t.instance.popper.contains(n)) return console.warn("WARNING: `arrow.element` must be child of its popper element!"), t;
					var r = t.placement.split("-")[0],
						o = t.offsets,
						a = o.popper,
						s = o.reference,
						l = -1 !== ["left", "right"].indexOf(r),
						c = l ? "height" : "width",
						u = l ? "Top" : "Left",
						h = u.toLowerCase(),
						d = l ? "left" : "top",
						f = l ? "bottom" : "right",
						p = U(n)[c];
					s[f] - p < a[h] && (t.offsets.popper[h] -= a[h] - (s[f] - p)), s[h] + p > a[f] && (t.offsets.popper[h] += s[h] + p - a[f]), t.offsets.popper = P(t.offsets.popper);
					var m = s[h] + s[c] / 2 - p / 2,
						g = _(t.instance.popper),
						v = parseFloat(g["margin" + u], 10),
						y = parseFloat(g["border" + u + "Width"], 10),
						x = m - t.offsets.popper[h] - v - y;
					return x = zt(Ft(a[c] - p, x), 0), t.arrowElement = n, t.offsets.arrow = (i = {}, ae(i, h, Bt(x)), ae(i, d, ""), i), t
				},
				element: "[x-arrow]"
			},
			flip: {
				order: 600,
				enabled: !0,
				fn: function (f, p) {
					if (e(f.instance.modifiers, "inner")) return f;
					if (f.flipped && f.placement === f.originalPlacement) return f;
					var m = I(f.instance.popper, f.instance.reference, p.padding, p.boundariesElement, f.positionFixed),
						g = f.placement.split("-")[0],
						v = z(g),
						y = f.placement.split("-")[1] || "",
						x = [];
					switch (p.behavior) {
						case ue.FLIP:
							x = [g, v];
							break;
						case ue.CLOCKWISE:
							x = nt(g);
							break;
						case ue.COUNTERCLOCKWISE:
							x = nt(g, !0);
							break;
						default:
							x = p.behavior
					}
					return x.forEach(function (t, e) {
						if (g !== t || x.length === e + 1) return f;
						g = f.placement.split("-")[0], v = z(g);
						var i = f.offsets.popper,
							n = f.offsets.reference,
							r = Ut,
							o = "left" === g && r(i.right) > r(n.left) || "right" === g && r(i.left) < r(n.right) || "top" === g && r(i.bottom) > r(n.top) || "bottom" === g && r(i.top) < r(n.bottom),
							a = r(i.left) < r(m.left),
							s = r(i.right) > r(m.right),
							l = r(i.top) < r(m.top),
							c = r(i.bottom) > r(m.bottom),
							u = "left" === g && a || "right" === g && s || "top" === g && l || "bottom" === g && c,
							h = -1 !== ["top", "bottom"].indexOf(g),
							d = !!p.flipVariations && (h && "start" === y && a || h && "end" === y && s || !h && "start" === y && l || !h && "end" === y && c);
						(o || u || d) && (f.flipped = !0, (o || u) && (g = x[e + 1]), d && (y = it(y)), f.placement = g + (y ? "-" + y : ""), f.offsets.popper = se({}, f.offsets.popper, G(f.instance.popper, f.offsets.reference, f.placement)), f = V(f.instance.modifiers, f, "flip"))
					}), f
				},
				behavior: "flip",
				padding: 5,
				boundariesElement: "viewport"
			},
			inner: {
				order: 700,
				enabled: !1,
				fn: function (t) {
					var e = t.placement,
						i = e.split("-")[0],
						n = t.offsets,
						r = n.popper,
						o = n.reference,
						a = -1 !== ["left", "right"].indexOf(i),
						s = -1 === ["top", "left"].indexOf(i);
					return r[a ? "left" : "top"] = o[i] - (s ? r[a ? "width" : "height"] : 0), t.placement = z(e), t.offsets.popper = P(r), t
				}
			},
			hide: {
				order: 800,
				enabled: !0,
				fn: function (t) {
					if (!et(t.instance.modifiers, "hide", "preventOverflow")) return t;
					var e = t.offsets.reference,
						i = H(t.instance.modifiers, function (t) {
							return "preventOverflow" === t.name
						}).boundaries;
					if (e.bottom < i.top || e.left > i.right || e.top > i.bottom || e.right < i.left) {
						if (!0 === t.hide) return t;
						t.hide = !0, t.attributes["x-out-of-boundaries"] = ""
					} else {
						if (!1 === t.hide) return t;
						t.hide = !1, t.attributes["x-out-of-boundaries"] = !1
					}
					return t
				}
			},
			computeStyle: {
				order: 850,
				enabled: !0,
				fn: function (t, e) {
					var i = e.x,
						n = e.y,
						r = t.offsets.popper,
						o = H(t.instance.modifiers, function (t) {
							return "applyStyle" === t.name
						}).gpuAcceleration;
					void 0 !== o && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
					var a = void 0 === o ? e.gpuAcceleration : o,
						s = b(t.instance.popper),
						l = L(s),
						c = {
							position: r.position
						},
						u = {
							left: Ut(r.left),
							top: Bt(r.top),
							bottom: Bt(r.bottom),
							right: Ut(r.right)
						},
						h = "bottom" === i ? "top" : "bottom",
						d = "right" === n ? "left" : "right",
						f = W("transform"),
						p = void 0,
						m = void 0;
					if (m = "bottom" == h ? -l.height + u.bottom : u.top, p = "right" == d ? -l.width + u.right : u.left, a && f) c[f] = "translate3d(" + p + "px, " + m + "px, 0)", c[h] = 0, c[d] = 0, c.willChange = "transform";
					else {
						var g = "bottom" == h ? -1 : 1,
							v = "right" == d ? -1 : 1;
						c[h] = m * g, c[d] = p * v, c.willChange = h + ", " + d
					}
					var y = {
						"x-placement": t.placement
					};
					return t.attributes = se({}, y, t.attributes), t.styles = se({}, c, t.styles), t.arrowStyles = se({}, t.offsets.arrow, t.arrowStyles), t
				},
				gpuAcceleration: !0,
				x: "bottom",
				y: "right"
			},
			applyStyle: {
				order: 900,
				enabled: !0,
				fn: function (t) {
					return K(t.instance.popper, t.styles), tt(t.instance.popper, t.attributes), t.arrowElement && Object.keys(t.arrowStyles).length && K(t.arrowElement, t.arrowStyles), t
				},
				onLoad: function (t, e, i, n, r) {
					var o = B(r, e, t, i.positionFixed),
						a = F(i.placement, o, e, t, i.modifiers.flip.boundariesElement, i.modifiers.flip.padding);
					return e.setAttribute("x-placement", a), K(e, {
						position: i.positionFixed ? "fixed" : "absolute"
					}), i
				},
				gpuAcceleration: void 0
			}
		}
	};
	var de = {};
	if (Gt) {
		var fe = Element.prototype;
		de = fe.matches || fe.matchesSelector || fe.webkitMatchesSelector || fe.mozMatchesSelector || fe.msMatchesSelector || function (t) {
			for (var e = (this.document || this.ownerDocument).querySelectorAll(t), i = e.length; 0 <= --i && e.item(i) !== this;);
			return -1 < i
		}
	}
	var pe = de,
		me = {},
		ge = function (e) {
			return function (t) {
				return t === me && e
			}
		},
		ve = function () {
			function i(t) {
				for (var e in Yt(this, i), t) this[e] = t[e];
				this.state = {
					destroyed: !1,
					visible: !1,
					enabled: !0
				}, this._ = ge({
					mutationObservers: []
				})
			}
			return qt(i, [{
				key: "enable",
				value: function () {
					this.state.enabled = !0
				}
			}, {
				key: "disable",
				value: function () {
					this.state.enabled = !1
				}
			}, {
				key: "show",
				value: function (i) {
					var n = this;
					if (!this.state.destroyed && this.state.enabled) {
						var r = this.popper,
							o = this.reference,
							a = this.options,
							t = m(r),
							s = t.tooltip,
							l = t.backdrop,
							c = t.content;
						return a.dynamicTitle && !o.getAttribute("data-original-title") || o.hasAttribute("disabled") ? void 0 : o.refObj || document.documentElement.contains(o) ? void(a.onShow.call(r, this), i = vt(void 0 === i ? a.duration : i, 0), xt([r, s, l], 0), r.style.visibility = "visible", this.state.visible = !0, At.call(this, function () {
							if (n.state.visible) {
								if (bt.call(n) || n.popperInstance.scheduleUpdate(), bt.call(n)) {
									n.popperInstance.disableEventListeners();
									var t = vt(a.delay, 0),
										e = n._(me).lastTriggerEvent;
									e && n._(me).followCursorListener(t && n._(me).lastMouseMoveEvent ? n._(me).lastMouseMoveEvent : e)
								}
								xt([s, l, l ? c : null], i), l && getComputedStyle(l)[h("transform")], a.interactive && o.classList.add("tippy-active"), a.sticky && Lt.call(n), yt([s, l], "visible"), Ot.call(n, i, function () {
									a.updateDuration || s.classList.add("tippy-notransition"), a.interactive && _t(r), o.setAttribute("aria-describedby", "tippy-" + n.id), a.onShown.call(r, n)
								})
							}
						})) : void this.destroy()
					}
				}
			}, {
				key: "hide",
				value: function (t) {
					var e = this;
					if (!this.state.destroyed && this.state.enabled) {
						var i = this.popper,
							n = this.reference,
							r = this.options,
							o = m(i),
							a = o.tooltip,
							s = o.backdrop,
							l = o.content;
						r.onHide.call(i, this), t = vt(void 0 === t ? r.duration : t, 1), r.updateDuration || a.classList.remove("tippy-notransition"), r.interactive && n.classList.remove("tippy-active"), i.style.visibility = "hidden", this.state.visible = !1, xt([a, s, s ? l : null], t), yt([a, s], "hidden"), r.interactive && -1 < r.trigger.indexOf("click") && _t(n), mt(function () {
							Ot.call(e, t, function () {
								e.state.visible || !r.appendTo.contains(i) || (!e._(me).isPreparingToShow && (document.removeEventListener("mousemove", e._(me).followCursorListener), e._(me).lastMouseMoveEvent = null), e.popperInstance && e.popperInstance.disableEventListeners(), n.removeAttribute("aria-describedby"), r.appendTo.removeChild(i), r.onHidden.call(i, e))
							})
						})
					}
				}
			}, {
				key: "destroy",
				value: function () {
					var e = this,
						t = !(0 < arguments.length && void 0 !== arguments[0]) || arguments[0];
					if (!this.state.destroyed) {
						this.state.visible && this.hide(0), this.listeners.forEach(function (t) {
							e.reference.removeEventListener(t.event, t.handler)
						}), this.title && this.reference.setAttribute("title", this.title), delete this.reference._tippy;
						["data-original-title", "data-tippy", "data-tippy-delegate"].forEach(function (t) {
							e.reference.removeAttribute(t)
						}), this.options.target && t && r(this.reference.querySelectorAll(this.options.target)).forEach(function (t) {
							return t._tippy && t._tippy.destroy()
						}), this.popperInstance && this.popperInstance.destroy(), this._(me).mutationObservers.forEach(function (t) {
							t.disconnect()
						}), this.state.destroyed = !0
					}
				}
			}]), i
		}(),
		ye = 1,
		xe = !1;
	return Dt.version = "2.5.4", Dt.browser = jt, Dt.defaults = Wt, Dt.one = function (t, e) {
			return Dt(t, e, !0).tooltips[0]
		}, Dt.disableAnimations = function () {
			Wt.updateDuration = Wt.duration = 0, Wt.animateFill = !1
		},
		function () {
			var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : "";
			if (Gt && jt.supported) {
				var e = document.head || document.querySelector("head"),
					i = document.createElement("style");
				i.type = "text/css", e.insertBefore(i, e.firstChild), i.styleSheet ? i.styleSheet.cssText = t : i.appendChild(document.createTextNode(t))
			}
		}('.tippy-touch{cursor:pointer!important}.tippy-notransition{transition:none!important}.tippy-popper{max-width:350px;-webkit-perspective:700px;perspective:700px;z-index:9999;outline:0;transition-timing-function:cubic-bezier(.165,.84,.44,1);pointer-events:none;line-height:1.4}.tippy-popper[data-html]{max-width:96%;max-width:calc(100% - 20px)}.tippy-popper[x-placement^=top] .tippy-backdrop{border-radius:40% 40% 0 0}.tippy-popper[x-placement^=top] .tippy-roundarrow{bottom:-8px;-webkit-transform-origin:50% 0;transform-origin:50% 0}.tippy-popper[x-placement^=top] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(180deg);transform:rotate(180deg)}.tippy-popper[x-placement^=top] .tippy-arrow{border-top:7px solid #333;border-right:7px solid transparent;border-left:7px solid transparent;bottom:-7px;margin:0 6px;-webkit-transform-origin:50% 0;transform-origin:50% 0}.tippy-popper[x-placement^=top] .tippy-backdrop{-webkit-transform-origin:0 90%;transform-origin:0 90%}.tippy-popper[x-placement^=top] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(6) translate(-50%,25%);transform:scale(6) translate(-50%,25%);opacity:1}.tippy-popper[x-placement^=top] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(1) translate(-50%,25%);transform:scale(1) translate(-50%,25%);opacity:0}.tippy-popper[x-placement^=top] [data-animation=shift-toward][data-state=visible]{opacity:1;-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateY(-20px);transform:translateY(-20px)}.tippy-popper[x-placement^=top] [data-animation=perspective]{-webkit-transform-origin:bottom;transform-origin:bottom}.tippy-popper[x-placement^=top] [data-animation=perspective][data-state=visible]{opacity:1;-webkit-transform:translateY(-10px) rotateX(0);transform:translateY(-10px) rotateX(0)}.tippy-popper[x-placement^=top] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:translateY(0) rotateX(90deg);transform:translateY(0) rotateX(90deg)}.tippy-popper[x-placement^=top] [data-animation=fade][data-state=visible]{opacity:1;-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-away][data-state=visible]{opacity:1;-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-away][data-state=hidden]{opacity:0;-webkit-transform:translateY(0);transform:translateY(0)}.tippy-popper[x-placement^=top] [data-animation=scale][data-state=visible]{opacity:1;-webkit-transform:translateY(-10px) scale(1);transform:translateY(-10px) scale(1)}.tippy-popper[x-placement^=top] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateY(0) scale(0);transform:translateY(0) scale(0)}.tippy-popper[x-placement^=bottom] .tippy-backdrop{border-radius:0 0 30% 30%}.tippy-popper[x-placement^=bottom] .tippy-roundarrow{top:-8px;-webkit-transform-origin:50% 100%;transform-origin:50% 100%}.tippy-popper[x-placement^=bottom] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(0);transform:rotate(0)}.tippy-popper[x-placement^=bottom] .tippy-arrow{border-bottom:7px solid #333;border-right:7px solid transparent;border-left:7px solid transparent;top:-7px;margin:0 6px;-webkit-transform-origin:50% 100%;transform-origin:50% 100%}.tippy-popper[x-placement^=bottom] .tippy-backdrop{-webkit-transform-origin:0 -90%;transform-origin:0 -90%}.tippy-popper[x-placement^=bottom] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(6) translate(-50%,-125%);transform:scale(6) translate(-50%,-125%);opacity:1}.tippy-popper[x-placement^=bottom] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(1) translate(-50%,-125%);transform:scale(1) translate(-50%,-125%);opacity:0}.tippy-popper[x-placement^=bottom] [data-animation=shift-toward][data-state=visible]{opacity:1;-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateY(20px);transform:translateY(20px)}.tippy-popper[x-placement^=bottom] [data-animation=perspective]{-webkit-transform-origin:top;transform-origin:top}.tippy-popper[x-placement^=bottom] [data-animation=perspective][data-state=visible]{opacity:1;-webkit-transform:translateY(10px) rotateX(0);transform:translateY(10px) rotateX(0)}.tippy-popper[x-placement^=bottom] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:translateY(0) rotateX(-90deg);transform:translateY(0) rotateX(-90deg)}.tippy-popper[x-placement^=bottom] [data-animation=fade][data-state=visible]{opacity:1;-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-away][data-state=visible]{opacity:1;-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-away][data-state=hidden]{opacity:0;-webkit-transform:translateY(0);transform:translateY(0)}.tippy-popper[x-placement^=bottom] [data-animation=scale][data-state=visible]{opacity:1;-webkit-transform:translateY(10px) scale(1);transform:translateY(10px) scale(1)}.tippy-popper[x-placement^=bottom] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateY(0) scale(0);transform:translateY(0) scale(0)}.tippy-popper[x-placement^=left] .tippy-backdrop{border-radius:50% 0 0 50%}.tippy-popper[x-placement^=left] .tippy-roundarrow{right:-16px;-webkit-transform-origin:33.33333333% 50%;transform-origin:33.33333333% 50%}.tippy-popper[x-placement^=left] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(90deg);transform:rotate(90deg)}.tippy-popper[x-placement^=left] .tippy-arrow{border-left:7px solid #333;border-top:7px solid transparent;border-bottom:7px solid transparent;right:-7px;margin:3px 0;-webkit-transform-origin:0 50%;transform-origin:0 50%}.tippy-popper[x-placement^=left] .tippy-backdrop{-webkit-transform-origin:100% 0;transform-origin:100% 0}.tippy-popper[x-placement^=left] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(6) translate(40%,-50%);transform:scale(6) translate(40%,-50%);opacity:1}.tippy-popper[x-placement^=left] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(1.5) translate(40%,-50%);transform:scale(1.5) translate(40%,-50%);opacity:0}.tippy-popper[x-placement^=left] [data-animation=shift-toward][data-state=visible]{opacity:1;-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateX(-20px);transform:translateX(-20px)}.tippy-popper[x-placement^=left] [data-animation=perspective]{-webkit-transform-origin:right;transform-origin:right}.tippy-popper[x-placement^=left] [data-animation=perspective][data-state=visible]{opacity:1;-webkit-transform:translateX(-10px) rotateY(0);transform:translateX(-10px) rotateY(0)}.tippy-popper[x-placement^=left] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:translateX(0) rotateY(-90deg);transform:translateX(0) rotateY(-90deg)}.tippy-popper[x-placement^=left] [data-animation=fade][data-state=visible]{opacity:1;-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-away][data-state=visible]{opacity:1;-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-away][data-state=hidden]{opacity:0;-webkit-transform:translateX(0);transform:translateX(0)}.tippy-popper[x-placement^=left] [data-animation=scale][data-state=visible]{opacity:1;-webkit-transform:translateX(-10px) scale(1);transform:translateX(-10px) scale(1)}.tippy-popper[x-placement^=left] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateX(0) scale(0);transform:translateX(0) scale(0)}.tippy-popper[x-placement^=right] .tippy-backdrop{border-radius:0 50% 50% 0}.tippy-popper[x-placement^=right] .tippy-roundarrow{left:-16px;-webkit-transform-origin:66.66666666% 50%;transform-origin:66.66666666% 50%}.tippy-popper[x-placement^=right] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.tippy-popper[x-placement^=right] .tippy-arrow{border-right:7px solid #333;border-top:7px solid transparent;border-bottom:7px solid transparent;left:-7px;margin:3px 0;-webkit-transform-origin:100% 50%;transform-origin:100% 50%}.tippy-popper[x-placement^=right] .tippy-backdrop{-webkit-transform-origin:-100% 0;transform-origin:-100% 0}.tippy-popper[x-placement^=right] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(6) translate(-140%,-50%);transform:scale(6) translate(-140%,-50%);opacity:1}.tippy-popper[x-placement^=right] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(1.5) translate(-140%,-50%);transform:scale(1.5) translate(-140%,-50%);opacity:0}.tippy-popper[x-placement^=right] [data-animation=shift-toward][data-state=visible]{opacity:1;-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateX(20px);transform:translateX(20px)}.tippy-popper[x-placement^=right] [data-animation=perspective]{-webkit-transform-origin:left;transform-origin:left}.tippy-popper[x-placement^=right] [data-animation=perspective][data-state=visible]{opacity:1;-webkit-transform:translateX(10px) rotateY(0);transform:translateX(10px) rotateY(0)}.tippy-popper[x-placement^=right] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:translateX(0) rotateY(90deg);transform:translateX(0) rotateY(90deg)}.tippy-popper[x-placement^=right] [data-animation=fade][data-state=visible]{opacity:1;-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-away][data-state=visible]{opacity:1;-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-away][data-state=hidden]{opacity:0;-webkit-transform:translateX(0);transform:translateX(0)}.tippy-popper[x-placement^=right] [data-animation=scale][data-state=visible]{opacity:1;-webkit-transform:translateX(10px) scale(1);transform:translateX(10px) scale(1)}.tippy-popper[x-placement^=right] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateX(0) scale(0);transform:translateX(0) scale(0)}.tippy-tooltip{position:relative;color:#fff;border-radius:4px;font-size:.9rem;padding:.3rem .6rem;text-align:center;will-change:transform;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#333}.tippy-tooltip[data-size=small]{padding:.2rem .4rem;font-size:.75rem}.tippy-tooltip[data-size=large]{padding:.4rem .8rem;font-size:1rem}.tippy-tooltip[data-animatefill]{overflow:hidden;background-color:transparent}.tippy-tooltip[data-animatefill] .tippy-content{transition:-webkit-clip-path cubic-bezier(.46,.1,.52,.98);transition:clip-path cubic-bezier(.46,.1,.52,.98);transition:clip-path cubic-bezier(.46,.1,.52,.98),-webkit-clip-path cubic-bezier(.46,.1,.52,.98)}.tippy-tooltip[data-interactive],.tippy-tooltip[data-interactive] path{pointer-events:auto}.tippy-tooltip[data-inertia][data-state=visible]{transition-timing-function:cubic-bezier(.53,2,.36,.85)}.tippy-tooltip[data-inertia][data-state=hidden]{transition-timing-function:ease}.tippy-arrow,.tippy-roundarrow{position:absolute;width:0;height:0}.tippy-roundarrow{width:24px;height:8px;fill:#333;pointer-events:none}.tippy-backdrop{position:absolute;will-change:transform;background-color:#333;border-radius:50%;width:26%;left:50%;top:50%;z-index:-1;transition:all cubic-bezier(.46,.1,.52,.98);-webkit-backface-visibility:hidden;backface-visibility:hidden}.tippy-backdrop:after{content:"";float:left;padding-top:100%}body:not(.tippy-touch) .tippy-tooltip[data-animatefill][data-state=visible] .tippy-content{-webkit-clip-path:ellipse(100% 100% at 50% 50%);clip-path:ellipse(100% 100% at 50% 50%)}body:not(.tippy-touch) .tippy-tooltip[data-animatefill][data-state=hidden] .tippy-content{-webkit-clip-path:ellipse(5% 50% at 50% 50%);clip-path:ellipse(5% 50% at 50% 50%)}body:not(.tippy-touch) .tippy-popper[x-placement=right] .tippy-tooltip[data-animatefill][data-state=visible] .tippy-content{-webkit-clip-path:ellipse(135% 100% at 0 50%);clip-path:ellipse(135% 100% at 0 50%)}body:not(.tippy-touch) .tippy-popper[x-placement=right] .tippy-tooltip[data-animatefill][data-state=hidden] .tippy-content{-webkit-clip-path:ellipse(40% 100% at 0 50%);clip-path:ellipse(40% 100% at 0 50%)}body:not(.tippy-touch) .tippy-popper[x-placement=left] .tippy-tooltip[data-animatefill][data-state=visible] .tippy-content{-webkit-clip-path:ellipse(135% 100% at 100% 50%);clip-path:ellipse(135% 100% at 100% 50%)}body:not(.tippy-touch) .tippy-popper[x-placement=left] .tippy-tooltip[data-animatefill][data-state=hidden] .tippy-content{-webkit-clip-path:ellipse(40% 100% at 100% 50%);clip-path:ellipse(40% 100% at 100% 50%)}@media (max-width:360px){.tippy-popper{max-width:96%;max-width:calc(100% - 20px)}}'), Dt
});
(function (t) {
	"use strict";
	if (typeof define === "function" && define.amd) {
		define(["jquery"], t)
	} else if (typeof exports !== "undefined") {
		module.exports = t(require("jquery"))
	} else {
		t(jQuery)
	}
})(function (u) {
	"use strict";
	var a = window.Slick || {};
	a = function () {
		var r = 0;

		function t(t, e) {
			var i = this,
				n;
			i.defaults = {
				accessibility: true,
				adaptiveHeight: false,
				appendArrows: u(t),
				appendDots: u(t),
				arrows: true,
				asNavFor: null,
				prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
				nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
				autoplay: false,
				autoplaySpeed: 3e3,
				centerMode: false,
				centerPadding: "50px",
				cssEase: "ease",
				customPaging: function (t, e) {
					return u('<button type="button" />').text(e + 1)
				},
				dots: false,
				dotsClass: "slick-dots",
				draggable: true,
				easing: "linear",
				edgeFriction: .35,
				fade: false,
				focusOnSelect: false,
				focusOnChange: false,
				infinite: true,
				initialSlide: 0,
				lazyLoad: "ondemand",
				mobileFirst: false,
				pauseOnHover: true,
				pauseOnFocus: true,
				pauseOnDotsHover: false,
				respondTo: "window",
				responsive: null,
				rows: 1,
				rtl: false,
				slide: "",
				slidesPerRow: 1,
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 500,
				swipe: true,
				swipeToSlide: false,
				touchMove: true,
				touchThreshold: 5,
				useCSS: true,
				useTransform: true,
				variableWidth: false,
				vertical: false,
				verticalSwiping: false,
				waitForAnimate: true,
				zIndex: 1e3
			};
			i.initials = {
				animating: false,
				dragging: false,
				autoPlayTimer: null,
				currentDirection: 0,
				currentLeft: null,
				currentSlide: 0,
				direction: 1,
				$dots: null,
				listWidth: null,
				listHeight: null,
				loadIndex: 0,
				$nextArrow: null,
				$prevArrow: null,
				scrolling: false,
				slideCount: null,
				slideWidth: null,
				$slideTrack: null,
				$slides: null,
				sliding: false,
				slideOffset: 0,
				swipeLeft: null,
				swiping: false,
				$list: null,
				touchObject: {},
				transformsEnabled: false,
				unslicked: false
			};
			u.extend(i, i.initials);
			i.activeBreakpoint = null;
			i.animType = null;
			i.animProp = null;
			i.breakpoints = [];
			i.breakpointSettings = [];
			i.cssTransitions = false;
			i.focussed = false;
			i.interrupted = false;
			i.hidden = "hidden";
			i.paused = true;
			i.positionProp = null;
			i.respondTo = null;
			i.rowCount = 1;
			i.shouldClick = true;
			i.$slider = u(t);
			i.$slidesCache = null;
			i.transformType = null;
			i.transitionType = null;
			i.visibilityChange = "visibilitychange";
			i.windowWidth = 0;
			i.windowTimer = null;
			n = u(t).data("slick") || {};
			i.options = u.extend({}, i.defaults, e, n);
			i.currentSlide = i.options.initialSlide;
			i.originalSettings = i.options;
			if (typeof document.mozHidden !== "undefined") {
				i.hidden = "mozHidden";
				i.visibilityChange = "mozvisibilitychange"
			} else if (typeof document.webkitHidden !== "undefined") {
				i.hidden = "webkitHidden";
				i.visibilityChange = "webkitvisibilitychange"
			}
			i.autoPlay = u.proxy(i.autoPlay, i);
			i.autoPlayClear = u.proxy(i.autoPlayClear, i);
			i.autoPlayIterator = u.proxy(i.autoPlayIterator, i);
			i.changeSlide = u.proxy(i.changeSlide, i);
			i.clickHandler = u.proxy(i.clickHandler, i);
			i.selectHandler = u.proxy(i.selectHandler, i);
			i.setPosition = u.proxy(i.setPosition, i);
			i.swipeHandler = u.proxy(i.swipeHandler, i);
			i.dragHandler = u.proxy(i.dragHandler, i);
			i.keyHandler = u.proxy(i.keyHandler, i);
			i.instanceUid = r++;
			i.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;
			i.registerBreakpoints();
			i.init(true)
		}
		return t
	}();
	a.prototype.activateADA = function () {
		var t = this;
		t.$slideTrack.find(".slick-active").attr({
			"aria-hidden": "false"
		}).find("a, input, button, select").attr({
			tabindex: "0"
		})
	};
	a.prototype.addSlide = a.prototype.slickAdd = function (t, e, i) {
		var n = this;
		if (typeof e === "boolean") {
			i = e;
			e = null
		} else if (e < 0 || e >= n.slideCount) {
			return false
		}
		n.unload();
		if (typeof e === "number") {
			if (e === 0 && n.$slides.length === 0) {
				u(t).appendTo(n.$slideTrack)
			} else if (i) {
				u(t).insertBefore(n.$slides.eq(e))
			} else {
				u(t).insertAfter(n.$slides.eq(e))
			}
		} else {
			if (i === true) {
				u(t).prependTo(n.$slideTrack)
			} else {
				u(t).appendTo(n.$slideTrack)
			}
		}
		n.$slides = n.$slideTrack.children(this.options.slide);
		n.$slideTrack.children(this.options.slide).detach();
		n.$slideTrack.append(n.$slides);
		n.$slides.each(function (t, e) {
			u(e).attr("data-slick-index", t)
		});
		n.$slidesCache = n.$slides;
		n.reinit()
	};
	a.prototype.animateHeight = function () {
		var t = this;
		if (t.options.slidesToShow === 1 && t.options.adaptiveHeight === true && t.options.vertical === false) {
			var e = t.$slides.eq(t.currentSlide).outerHeight(true);
			t.$list.animate({
				height: e
			}, t.options.speed)
		}
	};
	a.prototype.animateSlide = function (t, e) {
		var i = {},
			n = this;
		n.animateHeight();
		if (n.options.rtl === true && n.options.vertical === false) {
			t = -t
		}
		if (n.transformsEnabled === false) {
			if (n.options.vertical === false) {
				n.$slideTrack.animate({
					left: t
				}, n.options.speed, n.options.easing, e)
			} else {
				n.$slideTrack.animate({
					top: t
				}, n.options.speed, n.options.easing, e)
			}
		} else {
			if (n.cssTransitions === false) {
				if (n.options.rtl === true) {
					n.currentLeft = -n.currentLeft
				}
				u({
					animStart: n.currentLeft
				}).animate({
					animStart: t
				}, {
					duration: n.options.speed,
					easing: n.options.easing,
					step: function (t) {
						t = Math.ceil(t);
						if (n.options.vertical === false) {
							i[n.animType] = "translate(" + t + "px, 0px)";
							n.$slideTrack.css(i)
						} else {
							i[n.animType] = "translate(0px," + t + "px)";
							n.$slideTrack.css(i)
						}
					},
					complete: function () {
						if (e) {
							e.call()
						}
					}
				})
			} else {
				n.applyTransition();
				t = Math.ceil(t);
				if (n.options.vertical === false) {
					i[n.animType] = "translate3d(" + t + "px, 0px, 0px)"
				} else {
					i[n.animType] = "translate3d(0px," + t + "px, 0px)"
				}
				n.$slideTrack.css(i);
				if (e) {
					setTimeout(function () {
						n.disableTransition();
						e.call()
					}, n.options.speed)
				}
			}
		}
	};
	a.prototype.getNavTarget = function () {
		var t = this,
			e = t.options.asNavFor;
		if (e && e !== null) {
			e = u(e).not(t.$slider)
		}
		return e
	};
	a.prototype.asNavFor = function (e) {
		var t = this,
			i = t.getNavTarget();
		if (i !== null && typeof i === "object") {
			i.each(function () {
				var t = u(this).slick("getSlick");
				if (!t.unslicked) {
					t.slideHandler(e, true)
				}
			})
		}
	};
	a.prototype.applyTransition = function (t) {
		var e = this,
			i = {};
		if (e.options.fade === false) {
			i[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase
		} else {
			i[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase
		}
		if (e.options.fade === false) {
			e.$slideTrack.css(i)
		} else {
			e.$slides.eq(t).css(i)
		}
	};
	a.prototype.autoPlay = function () {
		var t = this;
		t.autoPlayClear();
		if (t.slideCount > t.options.slidesToShow) {
			t.autoPlayTimer = setInterval(t.autoPlayIterator, t.options.autoplaySpeed)
		}
	};
	a.prototype.autoPlayClear = function () {
		var t = this;
		if (t.autoPlayTimer) {
			clearInterval(t.autoPlayTimer)
		}
	};
	a.prototype.autoPlayIterator = function () {
		var t = this,
			e = t.currentSlide + t.options.slidesToScroll;
		if (!t.paused && !t.interrupted && !t.focussed) {
			if (t.options.infinite === false) {
				if (t.direction === 1 && t.currentSlide + 1 === t.slideCount - 1) {
					t.direction = 0
				} else if (t.direction === 0) {
					e = t.currentSlide - t.options.slidesToScroll;
					if (t.currentSlide - 1 === 0) {
						t.direction = 1
					}
				}
			}
			t.slideHandler(e)
		}
	};
	a.prototype.buildArrows = function () {
		var t = this;
		if (t.options.arrows === true) {
			t.$prevArrow = u(t.options.prevArrow).addClass("slick-arrow");
			t.$nextArrow = u(t.options.nextArrow).addClass("slick-arrow");
			if (t.slideCount > t.options.slidesToShow) {
				t.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex");
				t.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex");
				if (t.htmlExpr.test(t.options.prevArrow)) {
					t.$prevArrow.prependTo(t.options.appendArrows)
				}
				if (t.htmlExpr.test(t.options.nextArrow)) {
					t.$nextArrow.appendTo(t.options.appendArrows)
				}
				if (t.options.infinite !== true) {
					t.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")
				}
			} else {
				t.$prevArrow.add(t.$nextArrow).addClass("slick-hidden").attr({
					"aria-disabled": "true",
					tabindex: "-1"
				})
			}
		}
	};
	a.prototype.buildDots = function () {
		var t = this,
			e, i;
		if (t.options.dots === true && t.slideCount > t.options.slidesToShow) {
			t.$slider.addClass("slick-dotted");
			i = u("<ul />").addClass(t.options.dotsClass);
			for (e = 0; e <= t.getDotCount(); e += 1) {
				i.append(u("<li />").append(t.options.customPaging.call(this, t, e)))
			}
			t.$dots = i.appendTo(t.options.appendDots);
			t.$dots.find("li").first().addClass("slick-active")
		}
	};
	a.prototype.buildOut = function () {
		var t = this;
		t.$slides = t.$slider.children(t.options.slide + ":not(.slick-cloned)").addClass("slick-slide");
		t.slideCount = t.$slides.length;
		t.$slides.each(function (t, e) {
			u(e).attr("data-slick-index", t).data("originalStyling", u(e).attr("style") || "")
		});
		t.$slider.addClass("slick-slider");
		t.$slideTrack = t.slideCount === 0 ? u('<div class="slick-track"/>').appendTo(t.$slider) : t.$slides.wrapAll('<div class="slick-track"/>').parent();
		t.$list = t.$slideTrack.wrap('<div class="slick-list"/>').parent();
		t.$slideTrack.css("opacity", 0);
		if (t.options.centerMode === true || t.options.swipeToSlide === true) {
			t.options.slidesToScroll = 1
		}
		u("img[data-lazy]", t.$slider).not("[src]").addClass("slick-loading");
		t.setupInfinite();
		t.buildArrows();
		t.buildDots();
		t.updateDots();
		t.setSlideClasses(typeof t.currentSlide === "number" ? t.currentSlide : 0);
		if (t.options.draggable === true) {
			t.$list.addClass("draggable")
		}
	};
	a.prototype.buildRows = function () {
		var t = this,
			e, i, n, r, o, a, s;
		r = document.createDocumentFragment();
		a = t.$slider.children();
		if (t.options.rows > 0) {
			s = t.options.slidesPerRow * t.options.rows;
			o = Math.ceil(a.length / s);
			for (e = 0; e < o; e++) {
				var l = document.createElement("div");
				for (i = 0; i < t.options.rows; i++) {
					var c = document.createElement("div");
					for (n = 0; n < t.options.slidesPerRow; n++) {
						var u = e * s + (i * t.options.slidesPerRow + n);
						if (a.get(u)) {
							c.appendChild(a.get(u))
						}
					}
					l.appendChild(c)
				}
				r.appendChild(l)
			}
			t.$slider.empty().append(r);
			t.$slider.children().children().children().css({
				width: 100 / t.options.slidesPerRow + "%",
				display: "inline-block"
			})
		}
	};
	a.prototype.checkResponsive = function (t, e) {
		var i = this,
			n, r, o, a = false;
		var s = i.$slider.width();
		var l = window.innerWidth || u(window).width();
		if (i.respondTo === "window") {
			o = l
		} else if (i.respondTo === "slider") {
			o = s
		} else if (i.respondTo === "min") {
			o = Math.min(l, s)
		}
		if (i.options.responsive && i.options.responsive.length && i.options.responsive !== null) {
			r = null;
			for (n in i.breakpoints) {
				if (i.breakpoints.hasOwnProperty(n)) {
					if (i.originalSettings.mobileFirst === false) {
						if (o < i.breakpoints[n]) {
							r = i.breakpoints[n]
						}
					} else {
						if (o > i.breakpoints[n]) {
							r = i.breakpoints[n]
						}
					}
				}
			}
			if (r !== null) {
				if (i.activeBreakpoint !== null) {
					if (r !== i.activeBreakpoint || e) {
						i.activeBreakpoint = r;
						if (i.breakpointSettings[r] === "unslick") {
							i.unslick(r)
						} else {
							i.options = u.extend({}, i.originalSettings, i.breakpointSettings[r]);
							if (t === true) {
								i.currentSlide = i.options.initialSlide
							}
							i.refresh(t)
						}
						a = r
					}
				} else {
					i.activeBreakpoint = r;
					if (i.breakpointSettings[r] === "unslick") {
						i.unslick(r)
					} else {
						i.options = u.extend({}, i.originalSettings, i.breakpointSettings[r]);
						if (t === true) {
							i.currentSlide = i.options.initialSlide
						}
						i.refresh(t)
					}
					a = r
				}
			} else {
				if (i.activeBreakpoint !== null) {
					i.activeBreakpoint = null;
					i.options = i.originalSettings;
					if (t === true) {
						i.currentSlide = i.options.initialSlide
					}
					i.refresh(t);
					a = r
				}
			}
			if (!t && a !== false) {
				i.$slider.trigger("breakpoint", [i, a])
			}
		}
	};
	a.prototype.changeSlide = function (t, e) {
		var i = this,
			n = u(t.currentTarget),
			r, o, a;
		if (n.is("a")) {
			t.preventDefault()
		}
		if (!n.is("li")) {
			n = n.closest("li")
		}
		a = i.slideCount % i.options.slidesToScroll !== 0;
		r = a ? 0 : (i.slideCount - i.currentSlide) % i.options.slidesToScroll;
		switch (t.data.message) {
			case "previous":
				o = r === 0 ? i.options.slidesToScroll : i.options.slidesToShow - r;
				if (i.slideCount > i.options.slidesToShow) {
					i.slideHandler(i.currentSlide - o, false, e)
				}
				break;
			case "next":
				o = r === 0 ? i.options.slidesToScroll : r;
				if (i.slideCount > i.options.slidesToShow) {
					i.slideHandler(i.currentSlide + o, false, e)
				}
				break;
			case "index":
				var s = t.data.index === 0 ? 0 : t.data.index || n.index() * i.options.slidesToScroll;
				i.slideHandler(i.checkNavigable(s), false, e);
				n.children().trigger("focus");
				break;
			default:
				return
		}
	};
	a.prototype.checkNavigable = function (t) {
		var e = this,
			i, n;
		i = e.getNavigableIndexes();
		n = 0;
		if (t > i[i.length - 1]) {
			t = i[i.length - 1]
		} else {
			for (var r in i) {
				if (t < i[r]) {
					t = n;
					break
				}
				n = i[r]
			}
		}
		return t
	};
	a.prototype.cleanUpEvents = function () {
		var t = this;
		if (t.options.dots && t.$dots !== null) {
			u("li", t.$dots).off("click.slick", t.changeSlide).off("mouseenter.slick", u.proxy(t.interrupt, t, true)).off("mouseleave.slick", u.proxy(t.interrupt, t, false));
			if (t.options.accessibility === true) {
				t.$dots.off("keydown.slick", t.keyHandler)
			}
		}
		t.$slider.off("focus.slick blur.slick");
		if (t.options.arrows === true && t.slideCount > t.options.slidesToShow) {
			t.$prevArrow && t.$prevArrow.off("click.slick", t.changeSlide);
			t.$nextArrow && t.$nextArrow.off("click.slick", t.changeSlide);
			if (t.options.accessibility === true) {
				t.$prevArrow && t.$prevArrow.off("keydown.slick", t.keyHandler);
				t.$nextArrow && t.$nextArrow.off("keydown.slick", t.keyHandler)
			}
		}
		t.$list.off("touchstart.slick mousedown.slick", t.swipeHandler);
		t.$list.off("touchmove.slick mousemove.slick", t.swipeHandler);
		t.$list.off("touchend.slick mouseup.slick", t.swipeHandler);
		t.$list.off("touchcancel.slick mouseleave.slick", t.swipeHandler);
		t.$list.off("click.slick", t.clickHandler);
		u(document).off(t.visibilityChange, t.visibility);
		t.cleanUpSlideEvents();
		if (t.options.accessibility === true) {
			t.$list.off("keydown.slick", t.keyHandler)
		}
		if (t.options.focusOnSelect === true) {
			u(t.$slideTrack).children().off("click.slick", t.selectHandler)
		}
		u(window).off("orientationchange.slick.slick-" + t.instanceUid, t.orientationChange);
		u(window).off("resize.slick.slick-" + t.instanceUid, t.resize);
		u("[draggable!=true]", t.$slideTrack).off("dragstart", t.preventDefault);
		u(window).off("load.slick.slick-" + t.instanceUid, t.setPosition)
	};
	a.prototype.cleanUpSlideEvents = function () {
		var t = this;
		t.$list.off("mouseenter.slick", u.proxy(t.interrupt, t, true));
		t.$list.off("mouseleave.slick", u.proxy(t.interrupt, t, false))
	};
	a.prototype.cleanUpRows = function () {
		var t = this,
			e;
		if (t.options.rows > 0) {
			e = t.$slides.children().children();
			e.removeAttr("style");
			t.$slider.empty().append(e)
		}
	};
	a.prototype.clickHandler = function (t) {
		var e = this;
		if (e.shouldClick === false) {
			t.stopImmediatePropagation();
			t.stopPropagation();
			t.preventDefault()
		}
	};
	a.prototype.destroy = function (t) {
		var e = this;
		e.autoPlayClear();
		e.touchObject = {};
		e.cleanUpEvents();
		u(".slick-cloned", e.$slider).detach();
		if (e.$dots) {
			e.$dots.remove()
		}
		if (e.$prevArrow && e.$prevArrow.length) {
			e.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", "");
			if (e.htmlExpr.test(e.options.prevArrow)) {
				e.$prevArrow.remove()
			}
		}
		if (e.$nextArrow && e.$nextArrow.length) {
			e.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", "");
			if (e.htmlExpr.test(e.options.nextArrow)) {
				e.$nextArrow.remove()
			}
		}
		if (e.$slides) {
			e.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function () {
				u(this).attr("style", u(this).data("originalStyling"))
			});
			e.$slideTrack.children(this.options.slide).detach();
			e.$slideTrack.detach();
			e.$list.detach();
			e.$slider.append(e.$slides)
		}
		e.cleanUpRows();
		e.$slider.removeClass("slick-slider");
		e.$slider.removeClass("slick-initialized");
		e.$slider.removeClass("slick-dotted");
		e.unslicked = true;
		if (!t) {
			e.$slider.trigger("destroy", [e])
		}
	};
	a.prototype.disableTransition = function (t) {
		var e = this,
			i = {};
		i[e.transitionType] = "";
		if (e.options.fade === false) {
			e.$slideTrack.css(i)
		} else {
			e.$slides.eq(t).css(i)
		}
	};
	a.prototype.fadeSlide = function (t, e) {
		var i = this;
		if (i.cssTransitions === false) {
			i.$slides.eq(t).css({
				zIndex: i.options.zIndex
			});
			i.$slides.eq(t).animate({
				opacity: 1
			}, i.options.speed, i.options.easing, e)
		} else {
			i.applyTransition(t);
			i.$slides.eq(t).css({
				opacity: 1,
				zIndex: i.options.zIndex
			});
			if (e) {
				setTimeout(function () {
					i.disableTransition(t);
					e.call()
				}, i.options.speed)
			}
		}
	};
	a.prototype.fadeSlideOut = function (t) {
		var e = this;
		if (e.cssTransitions === false) {
			e.$slides.eq(t).animate({
				opacity: 0,
				zIndex: e.options.zIndex - 2
			}, e.options.speed, e.options.easing)
		} else {
			e.applyTransition(t);
			e.$slides.eq(t).css({
				opacity: 0,
				zIndex: e.options.zIndex - 2
			})
		}
	};
	a.prototype.filterSlides = a.prototype.slickFilter = function (t) {
		var e = this;
		if (t !== null) {
			e.$slidesCache = e.$slides;
			e.unload();
			e.$slideTrack.children(this.options.slide).detach();
			e.$slidesCache.filter(t).appendTo(e.$slideTrack);
			e.reinit()
		}
	};
	a.prototype.focusHandler = function () {
		var i = this;
		i.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function (t) {
			t.stopImmediatePropagation();
			var e = u(this);
			setTimeout(function () {
				if (i.options.pauseOnFocus) {
					i.focussed = e.is(":focus");
					i.autoPlay()
				}
			}, 0)
		})
	};
	a.prototype.getCurrent = a.prototype.slickCurrentSlide = function () {
		var t = this;
		return t.currentSlide
	};
	a.prototype.getDotCount = function () {
		var t = this;
		var e = 0;
		var i = 0;
		var n = 0;
		if (t.options.infinite === true) {
			if (t.slideCount <= t.options.slidesToShow) {
				++n
			} else {
				while (e < t.slideCount) {
					++n;
					e = i + t.options.slidesToScroll;
					i += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow
				}
			}
		} else if (t.options.centerMode === true) {
			n = t.slideCount
		} else if (!t.options.asNavFor) {
			n = 1 + Math.ceil((t.slideCount - t.options.slidesToShow) / t.options.slidesToScroll)
		} else {
			while (e < t.slideCount) {
				++n;
				e = i + t.options.slidesToScroll;
				i += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow
			}
		}
		return n - 1
	};
	a.prototype.getLeft = function (t) {
		var e = this,
			i, n, r = 0,
			o, a;
		e.slideOffset = 0;
		n = e.$slides.first().outerHeight(true);
		if (e.options.infinite === true) {
			if (e.slideCount > e.options.slidesToShow) {
				e.slideOffset = e.slideWidth * e.options.slidesToShow * -1;
				a = -1;
				if (e.options.vertical === true && e.options.centerMode === true) {
					if (e.options.slidesToShow === 2) {
						a = -1.5
					} else if (e.options.slidesToShow === 1) {
						a = -2
					}
				}
				r = n * e.options.slidesToShow * a
			}
			if (e.slideCount % e.options.slidesToScroll !== 0) {
				if (t + e.options.slidesToScroll > e.slideCount && e.slideCount > e.options.slidesToShow) {
					if (t > e.slideCount) {
						e.slideOffset = (e.options.slidesToShow - (t - e.slideCount)) * e.slideWidth * -1;
						r = (e.options.slidesToShow - (t - e.slideCount)) * n * -1
					} else {
						e.slideOffset = e.slideCount % e.options.slidesToScroll * e.slideWidth * -1;
						r = e.slideCount % e.options.slidesToScroll * n * -1
					}
				}
			}
		} else {
			if (t + e.options.slidesToShow > e.slideCount) {
				e.slideOffset = (t + e.options.slidesToShow - e.slideCount) * e.slideWidth;
				r = (t + e.options.slidesToShow - e.slideCount) * n
			}
		}
		if (e.slideCount <= e.options.slidesToShow) {
			e.slideOffset = 0;
			r = 0
		}
		if (e.options.centerMode === true && e.slideCount <= e.options.slidesToShow) {
			e.slideOffset = e.slideWidth * Math.floor(e.options.slidesToShow) / 2 - e.slideWidth * e.slideCount / 2
		} else if (e.options.centerMode === true && e.options.infinite === true) {
			e.slideOffset += e.slideWidth * Math.floor(e.options.slidesToShow / 2) - e.slideWidth
		} else if (e.options.centerMode === true) {
			e.slideOffset = 0;
			e.slideOffset += e.slideWidth * Math.floor(e.options.slidesToShow / 2)
		}
		if (e.options.vertical === false) {
			i = t * e.slideWidth * -1 + e.slideOffset
		} else {
			i = t * n * -1 + r
		}
		if (e.options.variableWidth === true) {
			if (e.slideCount <= e.options.slidesToShow || e.options.infinite === false) {
				o = e.$slideTrack.children(".slick-slide").eq(t)
			} else {
				o = e.$slideTrack.children(".slick-slide").eq(t + e.options.slidesToShow)
			}
			if (e.options.rtl === true) {
				if (o[0]) {
					i = (e.$slideTrack.width() - o[0].offsetLeft - o.width()) * -1
				} else {
					i = 0
				}
			} else {
				i = o[0] ? o[0].offsetLeft * -1 : 0
			}
			if (e.options.centerMode === true) {
				if (e.slideCount <= e.options.slidesToShow || e.options.infinite === false) {
					o = e.$slideTrack.children(".slick-slide").eq(t)
				} else {
					o = e.$slideTrack.children(".slick-slide").eq(t + e.options.slidesToShow + 1)
				}
				if (e.options.rtl === true) {
					if (o[0]) {
						i = (e.$slideTrack.width() - o[0].offsetLeft - o.width()) * -1
					} else {
						i = 0
					}
				} else {
					i = o[0] ? o[0].offsetLeft * -1 : 0
				}
				i += (e.$list.width() - o.outerWidth()) / 2
			}
		}
		return i
	};
	a.prototype.getOption = a.prototype.slickGetOption = function (t) {
		var e = this;
		return e.options[t]
	};
	a.prototype.getNavigableIndexes = function () {
		var t = this,
			e = 0,
			i = 0,
			n = [],
			r;
		if (t.options.infinite === false) {
			r = t.slideCount
		} else {
			e = t.options.slidesToScroll * -1;
			i = t.options.slidesToScroll * -1;
			r = t.slideCount * 2
		}
		while (e < r) {
			n.push(e);
			e = i + t.options.slidesToScroll;
			i += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow
		}
		return n
	};
	a.prototype.getSlick = function () {
		return this
	};
	a.prototype.getSlideCount = function () {
		var i = this,
			t, n, r;
		r = i.options.centerMode === true ? i.slideWidth * Math.floor(i.options.slidesToShow / 2) : 0;
		if (i.options.swipeToSlide === true) {
			i.$slideTrack.find(".slick-slide").each(function (t, e) {
				if (e.offsetLeft - r + u(e).outerWidth() / 2 > i.swipeLeft * -1) {
					n = e;
					return false
				}
			});
			t = Math.abs(u(n).attr("data-slick-index") - i.currentSlide) || 1;
			return t
		} else {
			return i.options.slidesToScroll
		}
	};
	a.prototype.goTo = a.prototype.slickGoTo = function (t, e) {
		var i = this;
		i.changeSlide({
			data: {
				message: "index",
				index: parseInt(t)
			}
		}, e)
	};
	a.prototype.init = function (t) {
		var e = this;
		if (!u(e.$slider).hasClass("slick-initialized")) {
			u(e.$slider).addClass("slick-initialized");
			e.buildRows();
			e.buildOut();
			e.setProps();
			e.startLoad();
			e.loadSlider();
			e.initializeEvents();
			e.updateArrows();
			e.updateDots();
			e.checkResponsive(true);
			e.focusHandler()
		}
		if (t) {
			e.$slider.trigger("init", [e])
		}
		if (e.options.accessibility === true) {
			e.initADA()
		}
		if (e.options.autoplay) {
			e.paused = false;
			e.autoPlay()
		}
	};
	a.prototype.initADA = function () {
		var n = this,
			i = Math.ceil(n.slideCount / n.options.slidesToShow),
			r = n.getNavigableIndexes().filter(function (t) {
				return t >= 0 && t < n.slideCount
			});
		n.$slides.add(n.$slideTrack.find(".slick-cloned")).attr({
			"aria-hidden": "true",
			tabindex: "-1"
		}).find("a, input, button, select").attr({
			tabindex: "-1"
		});
		if (n.$dots !== null) {
			n.$slides.not(n.$slideTrack.find(".slick-cloned")).each(function (t) {
				var e = r.indexOf(t);
				u(this).attr({
					role: "tabpanel",
					id: "slick-slide" + n.instanceUid + t,
					tabindex: -1
				});
				if (e !== -1) {
					var i = "slick-slide-control" + n.instanceUid + e;
					if (u("#" + i).length) {
						u(this).attr({
							"aria-describedby": i
						})
					}
				}
			});
			n.$dots.attr("role", "tablist").find("li").each(function (t) {
				var e = r[t];
				u(this).attr({
					role: "presentation"
				});
				u(this).find("button").first().attr({
					role: "tab",
					id: "slick-slide-control" + n.instanceUid + t,
					"aria-controls": "slick-slide" + n.instanceUid + e,
					"aria-label": t + 1 + " of " + i,
					"aria-selected": null,
					tabindex: "-1"
				})
			}).eq(n.currentSlide).find("button").attr({
				"aria-selected": "true",
				tabindex: "0"
			}).end()
		}
		for (var t = n.currentSlide, e = t + n.options.slidesToShow; t < e; t++) {
			if (n.options.focusOnChange) {
				n.$slides.eq(t).attr({
					tabindex: "0"
				})
			} else {
				n.$slides.eq(t).removeAttr("tabindex")
			}
		}
		n.activateADA()
	};
	a.prototype.initArrowEvents = function () {
		var t = this;
		if (t.options.arrows === true && t.slideCount > t.options.slidesToShow) {
			t.$prevArrow.off("click.slick").on("click.slick", {
				message: "previous"
			}, t.changeSlide);
			t.$nextArrow.off("click.slick").on("click.slick", {
				message: "next"
			}, t.changeSlide);
			if (t.options.accessibility === true) {
				t.$prevArrow.on("keydown.slick", t.keyHandler);
				t.$nextArrow.on("keydown.slick", t.keyHandler)
			}
		}
	};
	a.prototype.initDotEvents = function () {
		var t = this;
		if (t.options.dots === true && t.slideCount > t.options.slidesToShow) {
			u("li", t.$dots).on("click.slick", {
				message: "index"
			}, t.changeSlide);
			if (t.options.accessibility === true) {
				t.$dots.on("keydown.slick", t.keyHandler)
			}
		}
		if (t.options.dots === true && t.options.pauseOnDotsHover === true && t.slideCount > t.options.slidesToShow) {
			u("li", t.$dots).on("mouseenter.slick", u.proxy(t.interrupt, t, true)).on("mouseleave.slick", u.proxy(t.interrupt, t, false))
		}
	};
	a.prototype.initSlideEvents = function () {
		var t = this;
		if (t.options.pauseOnHover) {
			t.$list.on("mouseenter.slick", u.proxy(t.interrupt, t, true));
			t.$list.on("mouseleave.slick", u.proxy(t.interrupt, t, false))
		}
	};
	a.prototype.initializeEvents = function () {
		var t = this;
		t.initArrowEvents();
		t.initDotEvents();
		t.initSlideEvents();
		t.$list.on("touchstart.slick mousedown.slick", {
			action: "start"
		}, t.swipeHandler);
		t.$list.on("touchmove.slick mousemove.slick", {
			action: "move"
		}, t.swipeHandler);
		t.$list.on("touchend.slick mouseup.slick", {
			action: "end"
		}, t.swipeHandler);
		t.$list.on("touchcancel.slick mouseleave.slick", {
			action: "end"
		}, t.swipeHandler);
		t.$list.on("click.slick", t.clickHandler);
		u(document).on(t.visibilityChange, u.proxy(t.visibility, t));
		if (t.options.accessibility === true) {
			t.$list.on("keydown.slick", t.keyHandler)
		}
		if (t.options.focusOnSelect === true) {
			u(t.$slideTrack).children().on("click.slick", t.selectHandler)
		}
		u(window).on("orientationchange.slick.slick-" + t.instanceUid, u.proxy(t.orientationChange, t));
		u(window).on("resize.slick.slick-" + t.instanceUid, u.proxy(t.resize, t));
		u("[draggable!=true]", t.$slideTrack).on("dragstart", t.preventDefault);
		u(window).on("load.slick.slick-" + t.instanceUid, t.setPosition);
		u(t.setPosition)
	};
	a.prototype.initUI = function () {
		var t = this;
		if (t.options.arrows === true && t.slideCount > t.options.slidesToShow) {
			t.$prevArrow.show();
			t.$nextArrow.show()
		}
		if (t.options.dots === true && t.slideCount > t.options.slidesToShow) {
			t.$dots.show()
		}
	};
	a.prototype.keyHandler = function (t) {
		var e = this;
		if (!t.target.tagName.match("TEXTAREA|INPUT|SELECT")) {
			if (t.keyCode === 37 && e.options.accessibility === true) {
				e.changeSlide({
					data: {
						message: e.options.rtl === true ? "next" : "previous"
					}
				})
			} else if (t.keyCode === 39 && e.options.accessibility === true) {
				e.changeSlide({
					data: {
						message: e.options.rtl === true ? "previous" : "next"
					}
				})
			}
		}
	};
	a.prototype.lazyLoad = function () {
		var o = this,
			t, e, i, n;

		function r(t) {
			u("img[data-lazy]", t).each(function () {
				var t = u(this),
					e = u(this).attr("data-lazy"),
					i = u(this).attr("data-srcset"),
					n = u(this).attr("data-sizes") || o.$slider.attr("data-sizes"),
					r = document.createElement("img");
				r.onload = function () {
					t.animate({
						opacity: 0
					}, 100, function () {
						if (i) {
							t.attr("srcset", i);
							if (n) {
								t.attr("sizes", n)
							}
						}
						t.attr("src", e).animate({
							opacity: 1
						}, 200, function () {
							t.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")
						});
						o.$slider.trigger("lazyLoaded", [o, t, e])
					})
				};
				r.onerror = function () {
					t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error");
					o.$slider.trigger("lazyLoadError", [o, t, e])
				};
				r.src = e
			})
		}
		if (o.options.centerMode === true) {
			if (o.options.infinite === true) {
				i = o.currentSlide + (o.options.slidesToShow / 2 + 1);
				n = i + o.options.slidesToShow + 2
			} else {
				i = Math.max(0, o.currentSlide - (o.options.slidesToShow / 2 + 1));
				n = 2 + (o.options.slidesToShow / 2 + 1) + o.currentSlide
			}
		} else {
			i = o.options.infinite ? o.options.slidesToShow + o.currentSlide : o.currentSlide;
			n = Math.ceil(i + o.options.slidesToShow);
			if (o.options.fade === true) {
				if (i > 0) i--;
				if (n <= o.slideCount) n++
			}
		}
		t = o.$slider.find(".slick-slide").slice(i, n);
		if (o.options.lazyLoad === "anticipated") {
			var a = i - 1,
				s = n,
				l = o.$slider.find(".slick-slide");
			for (var c = 0; c < o.options.slidesToScroll; c++) {
				if (a < 0) a = o.slideCount - 1;
				t = t.add(l.eq(a));
				t = t.add(l.eq(s));
				a--;
				s++
			}
		}
		r(t);
		if (o.slideCount <= o.options.slidesToShow) {
			e = o.$slider.find(".slick-slide");
			r(e)
		} else if (o.currentSlide >= o.slideCount - o.options.slidesToShow) {
			e = o.$slider.find(".slick-cloned").slice(0, o.options.slidesToShow);
			r(e)
		} else if (o.currentSlide === 0) {
			e = o.$slider.find(".slick-cloned").slice(o.options.slidesToShow * -1);
			r(e)
		}
	};
	a.prototype.loadSlider = function () {
		var t = this;
		t.setPosition();
		t.$slideTrack.css({
			opacity: 1
		});
		t.$slider.removeClass("slick-loading");
		t.initUI();
		if (t.options.lazyLoad === "progressive") {
			t.progressiveLazyLoad()
		}
	};
	a.prototype.next = a.prototype.slickNext = function () {
		var t = this;
		t.changeSlide({
			data: {
				message: "next"
			}
		})
	};
	a.prototype.orientationChange = function () {
		var t = this;
		t.checkResponsive();
		t.setPosition()
	};
	a.prototype.pause = a.prototype.slickPause = function () {
		var t = this;
		t.autoPlayClear();
		t.paused = true
	};
	a.prototype.play = a.prototype.slickPlay = function () {
		var t = this;
		t.autoPlay();
		t.options.autoplay = true;
		t.paused = false;
		t.focussed = false;
		t.interrupted = false
	};
	a.prototype.postSlide = function (t) {
		var e = this;
		if (!e.unslicked) {
			e.$slider.trigger("afterChange", [e, t]);
			e.animating = false;
			if (e.slideCount > e.options.slidesToShow) {
				e.setPosition()
			}
			e.swipeLeft = null;
			if (e.options.autoplay) {
				e.autoPlay()
			}
			if (e.options.accessibility === true) {
				e.initADA();
				if (e.options.focusOnChange) {
					var i = u(e.$slides.get(e.currentSlide));
					i.attr("tabindex", 0).focus()
				}
			}
		}
	};
	a.prototype.prev = a.prototype.slickPrev = function () {
		var t = this;
		t.changeSlide({
			data: {
				message: "previous"
			}
		})
	};
	a.prototype.preventDefault = function (t) {
		t.preventDefault()
	};
	a.prototype.progressiveLazyLoad = function (t) {
		t = t || 1;
		var e = this,
			i = u("img[data-lazy]", e.$slider),
			n, r, o, a, s;
		if (i.length) {
			n = i.first();
			r = n.attr("data-lazy");
			o = n.attr("data-srcset");
			a = n.attr("data-sizes") || e.$slider.attr("data-sizes");
			s = document.createElement("img");
			s.onload = function () {
				if (o) {
					n.attr("srcset", o);
					if (a) {
						n.attr("sizes", a)
					}
				}
				n.attr("src", r).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading");
				if (e.options.adaptiveHeight === true) {
					e.setPosition()
				}
				e.$slider.trigger("lazyLoaded", [e, n, r]);
				e.progressiveLazyLoad()
			};
			s.onerror = function () {
				if (t < 3) {
					setTimeout(function () {
						e.progressiveLazyLoad(t + 1)
					}, 500)
				} else {
					n.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error");
					e.$slider.trigger("lazyLoadError", [e, n, r]);
					e.progressiveLazyLoad()
				}
			};
			s.src = r
		} else {
			e.$slider.trigger("allImagesLoaded", [e])
		}
	};
	a.prototype.refresh = function (t) {
		var e = this,
			i, n;
		n = e.slideCount - e.options.slidesToShow;
		if (!e.options.infinite && e.currentSlide > n) {
			e.currentSlide = n
		}
		if (e.slideCount <= e.options.slidesToShow) {
			e.currentSlide = 0
		}
		i = e.currentSlide;
		e.destroy(true);
		u.extend(e, e.initials, {
			currentSlide: i
		});
		e.init();
		if (!t) {
			e.changeSlide({
				data: {
					message: "index",
					index: i
				}
			}, false)
		}
	};
	a.prototype.registerBreakpoints = function () {
		var i = this,
			t, e, n, r = i.options.responsive || null;
		if (u.type(r) === "array" && r.length) {
			i.respondTo = i.options.respondTo || "window";
			for (t in r) {
				n = i.breakpoints.length - 1;
				if (r.hasOwnProperty(t)) {
					e = r[t].breakpoint;
					while (n >= 0) {
						if (i.breakpoints[n] && i.breakpoints[n] === e) {
							i.breakpoints.splice(n, 1)
						}
						n--
					}
					i.breakpoints.push(e);
					i.breakpointSettings[e] = r[t].settings
				}
			}
			i.breakpoints.sort(function (t, e) {
				return i.options.mobileFirst ? t - e : e - t
			})
		}
	};
	a.prototype.reinit = function () {
		var t = this;
		t.$slides = t.$slideTrack.children(t.options.slide).addClass("slick-slide");
		t.slideCount = t.$slides.length;
		if (t.currentSlide >= t.slideCount && t.currentSlide !== 0) {
			t.currentSlide = t.currentSlide - t.options.slidesToScroll
		}
		if (t.slideCount <= t.options.slidesToShow) {
			t.currentSlide = 0
		}
		t.registerBreakpoints();
		t.setProps();
		t.setupInfinite();
		t.buildArrows();
		t.updateArrows();
		t.initArrowEvents();
		t.buildDots();
		t.updateDots();
		t.initDotEvents();
		t.cleanUpSlideEvents();
		t.initSlideEvents();
		t.checkResponsive(false, true);
		if (t.options.focusOnSelect === true) {
			u(t.$slideTrack).children().on("click.slick", t.selectHandler)
		}
		t.setSlideClasses(typeof t.currentSlide === "number" ? t.currentSlide : 0);
		t.setPosition();
		t.focusHandler();
		t.paused = !t.options.autoplay;
		t.autoPlay();
		t.$slider.trigger("reInit", [t])
	};
	a.prototype.resize = function () {
		var t = this;
		if (u(window).width() !== t.windowWidth) {
			clearTimeout(t.windowDelay);
			t.windowDelay = window.setTimeout(function () {
				t.windowWidth = u(window).width();
				t.checkResponsive();
				if (!t.unslicked) {
					t.setPosition()
				}
			}, 50)
		}
	};
	a.prototype.removeSlide = a.prototype.slickRemove = function (t, e, i) {
		var n = this;
		if (typeof t === "boolean") {
			e = t;
			t = e === true ? 0 : n.slideCount - 1
		} else {
			t = e === true ? --t : t
		}
		if (n.slideCount < 1 || t < 0 || t > n.slideCount - 1) {
			return false
		}
		n.unload();
		if (i === true) {
			n.$slideTrack.children().remove()
		} else {
			n.$slideTrack.children(this.options.slide).eq(t).remove()
		}
		n.$slides = n.$slideTrack.children(this.options.slide);
		n.$slideTrack.children(this.options.slide).detach();
		n.$slideTrack.append(n.$slides);
		n.$slidesCache = n.$slides;
		n.reinit()
	};
	a.prototype.setCSS = function (t) {
		var e = this,
			i = {},
			n, r;
		if (e.options.rtl === true) {
			t = -t
		}
		n = e.positionProp == "left" ? Math.ceil(t) + "px" : "0px";
		r = e.positionProp == "top" ? Math.ceil(t) + "px" : "0px";
		i[e.positionProp] = t;
		if (e.transformsEnabled === false) {
			e.$slideTrack.css(i)
		} else {
			i = {};
			if (e.cssTransitions === false) {
				i[e.animType] = "translate(" + n + ", " + r + ")";
				e.$slideTrack.css(i)
			} else {
				i[e.animType] = "translate3d(" + n + ", " + r + ", 0px)";
				e.$slideTrack.css(i)
			}
		}
	};
	a.prototype.setDimensions = function () {
		var t = this;
		if (t.options.vertical === false) {
			if (t.options.centerMode === true) {
				t.$list.css({
					padding: "0px " + t.options.centerPadding
				})
			}
		} else {
			t.$list.height(t.$slides.first().outerHeight(true) * t.options.slidesToShow);
			if (t.options.centerMode === true) {
				t.$list.css({
					padding: t.options.centerPadding + " 0px"
				})
			}
		}
		t.listWidth = t.$list.width();
		t.listHeight = t.$list.height();
		if (t.options.vertical === false && t.options.variableWidth === false) {
			t.slideWidth = Math.ceil(t.listWidth / t.options.slidesToShow);
			t.$slideTrack.width(Math.ceil(t.slideWidth * t.$slideTrack.children(".slick-slide").length))
		} else if (t.options.variableWidth === true) {
			t.$slideTrack.width(5e3 * t.slideCount)
		} else {
			t.slideWidth = Math.ceil(t.listWidth);
			t.$slideTrack.height(Math.ceil(t.$slides.first().outerHeight(true) * t.$slideTrack.children(".slick-slide").length))
		}
		var e = t.$slides.first().outerWidth(true) - t.$slides.first().width();
		if (t.options.variableWidth === false) t.$slideTrack.children(".slick-slide").width(t.slideWidth - e)
	};
	a.prototype.setFade = function () {
		var i = this,
			n;
		i.$slides.each(function (t, e) {
			n = i.slideWidth * t * -1;
			if (i.options.rtl === true) {
				u(e).css({
					position: "relative",
					right: n,
					top: 0,
					zIndex: i.options.zIndex - 2,
					opacity: 0
				})
			} else {
				u(e).css({
					position: "relative",
					left: n,
					top: 0,
					zIndex: i.options.zIndex - 2,
					opacity: 0
				})
			}
		});
		i.$slides.eq(i.currentSlide).css({
			zIndex: i.options.zIndex - 1,
			opacity: 1
		})
	};
	a.prototype.setHeight = function () {
		var t = this;
		if (t.options.slidesToShow === 1 && t.options.adaptiveHeight === true && t.options.vertical === false) {
			var e = t.$slides.eq(t.currentSlide).outerHeight(true);
			t.$list.css("height", e)
		}
	};
	a.prototype.setOption = a.prototype.slickSetOption = function () {
		var i = this,
			t, e, n, r, o = false,
			a;
		if (u.type(arguments[0]) === "object") {
			n = arguments[0];
			o = arguments[1];
			a = "multiple"
		} else if (u.type(arguments[0]) === "string") {
			n = arguments[0];
			r = arguments[1];
			o = arguments[2];
			if (arguments[0] === "responsive" && u.type(arguments[1]) === "array") {
				a = "responsive"
			} else if (typeof arguments[1] !== "undefined") {
				a = "single"
			}
		}
		if (a === "single") {
			i.options[n] = r
		} else if (a === "multiple") {
			u.each(n, function (t, e) {
				i.options[t] = e
			})
		} else if (a === "responsive") {
			for (e in r) {
				if (u.type(i.options.responsive) !== "array") {
					i.options.responsive = [r[e]]
				} else {
					t = i.options.responsive.length - 1;
					while (t >= 0) {
						if (i.options.responsive[t].breakpoint === r[e].breakpoint) {
							i.options.responsive.splice(t, 1)
						}
						t--
					}
					i.options.responsive.push(r[e])
				}
			}
		}
		if (o) {
			i.unload();
			i.reinit()
		}
	};
	a.prototype.setPosition = function () {
		var t = this;
		t.setDimensions();
		t.setHeight();
		if (t.options.fade === false) {
			t.setCSS(t.getLeft(t.currentSlide))
		} else {
			t.setFade()
		}
		t.$slider.trigger("setPosition", [t])
	};
	a.prototype.setProps = function () {
		var t = this,
			e = document.body.style;
		t.positionProp = t.options.vertical === true ? "top" : "left";
		if (t.positionProp === "top") {
			t.$slider.addClass("slick-vertical")
		} else {
			t.$slider.removeClass("slick-vertical")
		}
		if (e.WebkitTransition !== undefined || e.MozTransition !== undefined || e.msTransition !== undefined) {
			if (t.options.useCSS === true) {
				t.cssTransitions = true
			}
		}
		if (t.options.fade) {
			if (typeof t.options.zIndex === "number") {
				if (t.options.zIndex < 3) {
					t.options.zIndex = 3
				}
			} else {
				t.options.zIndex = t.defaults.zIndex
			}
		}
		if (e.OTransform !== undefined) {
			t.animType = "OTransform";
			t.transformType = "-o-transform";
			t.transitionType = "OTransition";
			if (e.perspectiveProperty === undefined && e.webkitPerspective === undefined) t.animType = false
		}
		if (e.MozTransform !== undefined) {
			t.animType = "MozTransform";
			t.transformType = "-moz-transform";
			t.transitionType = "MozTransition";
			if (e.perspectiveProperty === undefined && e.MozPerspective === undefined) t.animType = false
		}
		if (e.webkitTransform !== undefined) {
			t.animType = "webkitTransform";
			t.transformType = "-webkit-transform";
			t.transitionType = "webkitTransition";
			if (e.perspectiveProperty === undefined && e.webkitPerspective === undefined) t.animType = false
		}
		if (e.msTransform !== undefined) {
			t.animType = "msTransform";
			t.transformType = "-ms-transform";
			t.transitionType = "msTransition";
			if (e.msTransform === undefined) t.animType = false
		}
		if (e.transform !== undefined && t.animType !== false) {
			t.animType = "transform";
			t.transformType = "transform";
			t.transitionType = "transition"
		}
		t.transformsEnabled = t.options.useTransform && (t.animType !== null && t.animType !== false)
	};
	a.prototype.setSlideClasses = function (t) {
		var e = this,
			i, n, r, o;
		n = e.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true");
		e.$slides.eq(t).addClass("slick-current");
		if (e.options.centerMode === true) {
			var a = e.options.slidesToShow % 2 === 0 ? 1 : 0;
			i = Math.floor(e.options.slidesToShow / 2);
			if (e.options.infinite === true) {
				if (t >= i && t <= e.slideCount - 1 - i) {
					e.$slides.slice(t - i + a, t + i + 1).addClass("slick-active").attr("aria-hidden", "false")
				} else {
					r = e.options.slidesToShow + t;
					n.slice(r - i + 1 + a, r + i + 2).addClass("slick-active").attr("aria-hidden", "false")
				}
				if (t === 0) {
					n.eq(n.length - 1 - e.options.slidesToShow).addClass("slick-center")
				} else if (t === e.slideCount - 1) {
					n.eq(e.options.slidesToShow).addClass("slick-center")
				}
			}
			e.$slides.eq(t).addClass("slick-center")
		} else {
			if (t >= 0 && t <= e.slideCount - e.options.slidesToShow) {
				e.$slides.slice(t, t + e.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false")
			} else if (n.length <= e.options.slidesToShow) {
				n.addClass("slick-active").attr("aria-hidden", "false")
			} else {
				o = e.slideCount % e.options.slidesToShow;
				r = e.options.infinite === true ? e.options.slidesToShow + t : t;
				if (e.options.slidesToShow == e.options.slidesToScroll && e.slideCount - t < e.options.slidesToShow) {
					n.slice(r - (e.options.slidesToShow - o), r + o).addClass("slick-active").attr("aria-hidden", "false")
				} else {
					n.slice(r, r + e.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false")
				}
			}
		}
		if (e.options.lazyLoad === "ondemand" || e.options.lazyLoad === "anticipated") {
			e.lazyLoad()
		}
	};
	a.prototype.setupInfinite = function () {
		var t = this,
			e, i, n;
		if (t.options.fade === true) {
			t.options.centerMode = false
		}
		if (t.options.infinite === true && t.options.fade === false) {
			i = null;
			if (t.slideCount > t.options.slidesToShow) {
				if (t.options.centerMode === true) {
					n = t.options.slidesToShow + 1
				} else {
					n = t.options.slidesToShow
				}
				for (e = t.slideCount; e > t.slideCount - n; e -= 1) {
					i = e - 1;
					u(t.$slides[i]).clone(true).attr("id", "").attr("data-slick-index", i - t.slideCount).prependTo(t.$slideTrack).addClass("slick-cloned")
				}
				for (e = 0; e < n + t.slideCount; e += 1) {
					i = e;
					u(t.$slides[i]).clone(true).attr("id", "").attr("data-slick-index", i + t.slideCount).appendTo(t.$slideTrack).addClass("slick-cloned")
				}
				t.$slideTrack.find(".slick-cloned").find("[id]").each(function () {
					u(this).attr("id", "")
				})
			}
		}
	};
	a.prototype.interrupt = function (t) {
		var e = this;
		if (!t) {
			e.autoPlay()
		}
		e.interrupted = t
	};
	a.prototype.selectHandler = function (t) {
		var e = this;
		var i = u(t.target).is(".slick-slide") ? u(t.target) : u(t.target).parents(".slick-slide");
		var n = parseInt(i.attr("data-slick-index"));
		if (!n) n = 0;
		if (e.slideCount <= e.options.slidesToShow) {
			e.slideHandler(n, false, true);
			return
		}
		e.slideHandler(n)
	};
	a.prototype.slideHandler = function (t, e, i) {
		var n, r, o, a, s = null,
			l = this,
			c;
		e = e || false;
		if (l.animating === true && l.options.waitForAnimate === true) {
			return
		}
		if (l.options.fade === true && l.currentSlide === t) {
			return
		}
		if (e === false) {
			l.asNavFor(t)
		}
		n = t;
		s = l.getLeft(n);
		a = l.getLeft(l.currentSlide);
		l.currentLeft = l.swipeLeft === null ? a : l.swipeLeft;
		if (l.options.infinite === false && l.options.centerMode === false && (t < 0 || t > l.getDotCount() * l.options.slidesToScroll)) {
			if (l.options.fade === false) {
				n = l.currentSlide;
				if (i !== true && l.slideCount > l.options.slidesToShow) {
					l.animateSlide(a, function () {
						l.postSlide(n)
					})
				} else {
					l.postSlide(n)
				}
			}
			return
		} else if (l.options.infinite === false && l.options.centerMode === true && (t < 0 || t > l.slideCount - l.options.slidesToScroll)) {
			if (l.options.fade === false) {
				n = l.currentSlide;
				if (i !== true && l.slideCount > l.options.slidesToShow) {
					l.animateSlide(a, function () {
						l.postSlide(n)
					})
				} else {
					l.postSlide(n)
				}
			}
			return
		}
		if (l.options.autoplay) {
			clearInterval(l.autoPlayTimer)
		}
		if (n < 0) {
			if (l.slideCount % l.options.slidesToScroll !== 0) {
				r = l.slideCount - l.slideCount % l.options.slidesToScroll
			} else {
				r = l.slideCount + n
			}
		} else if (n >= l.slideCount) {
			if (l.slideCount % l.options.slidesToScroll !== 0) {
				r = 0
			} else {
				r = n - l.slideCount
			}
		} else {
			r = n
		}
		l.animating = true;
		l.$slider.trigger("beforeChange", [l, l.currentSlide, r]);
		o = l.currentSlide;
		l.currentSlide = r;
		l.setSlideClasses(l.currentSlide);
		if (l.options.asNavFor) {
			c = l.getNavTarget();
			c = c.slick("getSlick");
			if (c.slideCount <= c.options.slidesToShow) {
				c.setSlideClasses(l.currentSlide)
			}
		}
		l.updateDots();
		l.updateArrows();
		if (l.options.fade === true) {
			if (i !== true) {
				l.fadeSlideOut(o);
				l.fadeSlide(r, function () {
					l.postSlide(r)
				})
			} else {
				l.postSlide(r)
			}
			l.animateHeight();
			return
		}
		if (i !== true && l.slideCount > l.options.slidesToShow) {
			l.animateSlide(s, function () {
				l.postSlide(r)
			})
		} else {
			l.postSlide(r)
		}
	};
	a.prototype.startLoad = function () {
		var t = this;
		if (t.options.arrows === true && t.slideCount > t.options.slidesToShow) {
			t.$prevArrow.hide();
			t.$nextArrow.hide()
		}
		if (t.options.dots === true && t.slideCount > t.options.slidesToShow) {
			t.$dots.hide()
		}
		t.$slider.addClass("slick-loading")
	};
	a.prototype.swipeDirection = function () {
		var t, e, i, n, r = this;
		t = r.touchObject.startX - r.touchObject.curX;
		e = r.touchObject.startY - r.touchObject.curY;
		i = Math.atan2(e, t);
		n = Math.round(i * 180 / Math.PI);
		if (n < 0) {
			n = 360 - Math.abs(n)
		}
		if (n <= 45 && n >= 0) {
			return r.options.rtl === false ? "left" : "right"
		}
		if (n <= 360 && n >= 315) {
			return r.options.rtl === false ? "left" : "right"
		}
		if (n >= 135 && n <= 225) {
			return r.options.rtl === false ? "right" : "left"
		}
		if (r.options.verticalSwiping === true) {
			if (n >= 35 && n <= 135) {
				return "down"
			} else {
				return "up"
			}
		}
		return "vertical"
	};
	a.prototype.swipeEnd = function (t) {
		var e = this,
			i, n;
		e.dragging = false;
		e.swiping = false;
		if (e.scrolling) {
			e.scrolling = false;
			return false
		}
		e.interrupted = false;
		e.shouldClick = e.touchObject.swipeLength > 10 ? false : true;
		if (e.touchObject.curX === undefined) {
			return false
		}
		if (e.touchObject.edgeHit === true) {
			e.$slider.trigger("edge", [e, e.swipeDirection()])
		}
		if (e.touchObject.swipeLength >= e.touchObject.minSwipe) {
			n = e.swipeDirection();
			switch (n) {
				case "left":
				case "down":
					i = e.options.swipeToSlide ? e.checkNavigable(e.currentSlide + e.getSlideCount()) : e.currentSlide + e.getSlideCount();
					e.currentDirection = 0;
					break;
				case "right":
				case "up":
					i = e.options.swipeToSlide ? e.checkNavigable(e.currentSlide - e.getSlideCount()) : e.currentSlide - e.getSlideCount();
					e.currentDirection = 1;
					break;
				default:
			}
			if (n != "vertical") {
				e.slideHandler(i);
				e.touchObject = {};
				e.$slider.trigger("swipe", [e, n])
			}
		} else {
			if (e.touchObject.startX !== e.touchObject.curX) {
				e.slideHandler(e.currentSlide);
				e.touchObject = {}
			}
		}
	};
	a.prototype.swipeHandler = function (t) {
		var e = this;
		if (e.options.swipe === false || "ontouchend" in document && e.options.swipe === false) {
			return
		} else if (e.options.draggable === false && t.type.indexOf("mouse") !== -1) {
			return
		}
		e.touchObject.fingerCount = t.originalEvent && t.originalEvent.touches !== undefined ? t.originalEvent.touches.length : 1;
		e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold;
		if (e.options.verticalSwiping === true) {
			e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold
		}
		switch (t.data.action) {
			case "start":
				e.swipeStart(t);
				break;
			case "move":
				e.swipeMove(t);
				break;
			case "end":
				e.swipeEnd(t);
				break
		}
	};
	a.prototype.swipeMove = function (t) {
		var e = this,
			i = false,
			n, r, o, a, s, l;
		s = t.originalEvent !== undefined ? t.originalEvent.touches : null;
		if (!e.dragging || e.scrolling || s && s.length !== 1) {
			return false
		}
		n = e.getLeft(e.currentSlide);
		e.touchObject.curX = s !== undefined ? s[0].pageX : t.clientX;
		e.touchObject.curY = s !== undefined ? s[0].pageY : t.clientY;
		e.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(e.touchObject.curX - e.touchObject.startX, 2)));
		l = Math.round(Math.sqrt(Math.pow(e.touchObject.curY - e.touchObject.startY, 2)));
		if (!e.options.verticalSwiping && !e.swiping && l > 4) {
			e.scrolling = true;
			return false
		}
		if (e.options.verticalSwiping === true) {
			e.touchObject.swipeLength = l
		}
		r = e.swipeDirection();
		if (t.originalEvent !== undefined && e.touchObject.swipeLength > 4) {
			e.swiping = true;
			t.preventDefault()
		}
		a = (e.options.rtl === false ? 1 : -1) * (e.touchObject.curX > e.touchObject.startX ? 1 : -1);
		if (e.options.verticalSwiping === true) {
			a = e.touchObject.curY > e.touchObject.startY ? 1 : -1
		}
		o = e.touchObject.swipeLength;
		e.touchObject.edgeHit = false;
		if (e.options.infinite === false) {
			if (e.currentSlide === 0 && r === "right" || e.currentSlide >= e.getDotCount() && r === "left") {
				o = e.touchObject.swipeLength * e.options.edgeFriction;
				e.touchObject.edgeHit = true
			}
		}
		if (e.options.vertical === false) {
			e.swipeLeft = n + o * a
		} else {
			e.swipeLeft = n + o * (e.$list.height() / e.listWidth) * a
		}
		if (e.options.verticalSwiping === true) {
			e.swipeLeft = n + o * a
		}
		if (e.options.fade === true || e.options.touchMove === false) {
			return false
		}
		if (e.animating === true) {
			e.swipeLeft = null;
			return false
		}
		e.setCSS(e.swipeLeft)
	};
	a.prototype.swipeStart = function (t) {
		var e = this,
			i;
		e.interrupted = true;
		if (e.touchObject.fingerCount !== 1 || e.slideCount <= e.options.slidesToShow) {
			e.touchObject = {};
			return false
		}
		if (t.originalEvent !== undefined && t.originalEvent.touches !== undefined) {
			i = t.originalEvent.touches[0]
		}
		e.touchObject.startX = e.touchObject.curX = i !== undefined ? i.pageX : t.clientX;
		e.touchObject.startY = e.touchObject.curY = i !== undefined ? i.pageY : t.clientY;
		e.dragging = true
	};
	a.prototype.unfilterSlides = a.prototype.slickUnfilter = function () {
		var t = this;
		if (t.$slidesCache !== null) {
			t.unload();
			t.$slideTrack.children(this.options.slide).detach();
			t.$slidesCache.appendTo(t.$slideTrack);
			t.reinit()
		}
	};
	a.prototype.unload = function () {
		var t = this;
		u(".slick-cloned", t.$slider).remove();
		if (t.$dots) {
			t.$dots.remove()
		}
		if (t.$prevArrow && t.htmlExpr.test(t.options.prevArrow)) {
			t.$prevArrow.remove()
		}
		if (t.$nextArrow && t.htmlExpr.test(t.options.nextArrow)) {
			t.$nextArrow.remove()
		}
		t.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
	};
	a.prototype.unslick = function (t) {
		var e = this;
		e.$slider.trigger("unslick", [e, t]);
		e.destroy()
	};
	a.prototype.updateArrows = function () {
		var t = this,
			e;
		e = Math.floor(t.options.slidesToShow / 2);
		if (t.options.arrows === true && t.slideCount > t.options.slidesToShow && !t.options.infinite) {
			t.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false");
			t.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false");
			if (t.currentSlide === 0) {
				t.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true");
				t.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")
			} else if (t.currentSlide >= t.slideCount - t.options.slidesToShow && t.options.centerMode === false) {
				t.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true");
				t.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")
			} else if (t.currentSlide >= t.slideCount - 1 && t.options.centerMode === true) {
				t.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true");
				t.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")
			}
		}
	};
	a.prototype.updateDots = function () {
		var t = this;
		if (t.$dots !== null) {
			t.$dots.find("li").removeClass("slick-active").end();
			t.$dots.find("li").eq(Math.floor(t.currentSlide / t.options.slidesToScroll)).addClass("slick-active")
		}
	};
	a.prototype.visibility = function () {
		var t = this;
		if (t.options.autoplay) {
			if (document[t.hidden]) {
				t.interrupted = true
			} else {
				t.interrupted = false
			}
		}
	};
	u.fn.slick = function () {
		var t = this,
			e = arguments[0],
			i = Array.prototype.slice.call(arguments, 1),
			n = t.length,
			r, o;
		for (r = 0; r < n; r++) {
			if (typeof e == "object" || typeof e == "undefined") t[r].slick = new a(t[r], e);
			else o = t[r].slick[e].apply(t[r].slick, i);
			if (typeof o != "undefined") return o
		}
		return t
	}
});
(function () {
	var t, u, l, e, C, f, r, c, i, p, m, n, a, o, s, h, d, P, g, v, y, x, _, b, w, T, L, E, S, M, A, R, O = [].slice;
	d = '<span class="odometer-value"></span>', o = '<span class="odometer-ribbon"><span class="odometer-ribbon-inner">' + d + "</span></span>", e = '<span class="odometer-digit"><span class="odometer-digit-spacer">8</span><span class="odometer-digit-inner">' + o + "</span></span>", r = '<span class="odometer-formatting-mark"></span>', l = "(,ddd).dd", c = /^\(?([^)]*)\)?(?:(.)(d+))?$/, i = 30, f = 2e3, t = 20, p = 2, C = .5, m = 1e3 / i, u = 1e3 / t, s = "transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd", w = document.createElement("div").style, h = null != w.transition || null != w.webkitTransition || null != w.mozTransition || null != w.oTransition, _ = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame, n = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver, g = function (t) {
		var e;
		return e = document.createElement("div"), e.innerHTML = t, e.children[0]
	}, x = function (t, e) {
		return t.className = t.className.replace(new RegExp("(^| )" + e.split(" ").join("|") + "( |$)", "gi"), " ")
	}, P = function (t, e) {
		return x(t, e), t.className += " " + e
	}, T = function (t, e) {
		var i;
		return null != document.createEvent ? (i = document.createEvent("HTMLEvents"), i.initEvent(e, !0, !0), t.dispatchEvent(i)) : void 0
	}, y = function () {
		var t, e;
		return null != (t = null != (e = window.performance) && "function" == typeof e.now ? e.now() : void 0) ? t : +new Date
	}, b = function (t, e) {
		return null == e && (e = 0), e ? (t *= Math.pow(10, e), t += .5, t = Math.floor(t), t /= Math.pow(10, e)) : Math.round(t)
	}, L = function (t) {
		return 0 > t ? Math.ceil(t) : Math.floor(t)
	}, v = function (t) {
		return t - b(t)
	}, S = !1, (E = function () {
		var t, e, i, n, r;
		if (!S && null != window.jQuery) {
			for (S = !0, n = ["html", "text"], r = [], e = 0, i = n.length; i > e; e++) t = n[e], r.push(function (t) {
				var i;
				return i = window.jQuery.fn[t], window.jQuery.fn[t] = function (t) {
					var e;
					return null == t || null == (null != (e = this[0]) ? e.odometer : void 0) ? i.apply(this, arguments) : this[0].odometer.update(t)
				}
			}(t));
			return r
		}
	})(), setTimeout(E, 0), a = function () {
		function d(t) {
			var e, i, n, r, o, a, s, l, c, u, h = this;
			if (this.options = t, this.el = this.options.el, null != this.el.odometer) return this.el.odometer;
			this.el.odometer = this, l = d.options;
			for (i in l) r = l[i], null == this.options[i] && (this.options[i] = r);
			null == (o = this.options).duration && (o.duration = f), this.MAX_VALUES = this.options.duration / m / p | 0, this.resetFormat(), this.value = this.cleanValue(null != (c = this.options.value) ? c : ""), this.renderInside(), this.render();
			try {
				for (u = ["innerHTML", "innerText", "textContent"], a = 0, s = u.length; s > a; a++) n = u[a], null != this.el[n] && ! function (e) {
					return Object.defineProperty(h.el, e, {
						get: function () {
							var t;
							return "innerHTML" === e ? h.inside.outerHTML : null != (t = h.inside.innerText) ? t : h.inside.textContent
						},
						set: function (t) {
							return h.update(t)
						}
					})
				}(n)
			} catch (t) {
				e = t, this.watchForMutations()
			}
		}
		return d.prototype.renderInside = function () {
			return this.inside = document.createElement("div"), this.inside.className = "odometer-inside", this.el.innerHTML = "", this.el.appendChild(this.inside)
		}, d.prototype.watchForMutations = function () {
			var e, i = this;
			if (null != n) try {
				return null == this.observer && (this.observer = new n(function (t) {
					var e;
					return e = i.el.innerText, i.renderInside(), i.render(i.value), i.update(e)
				})), this.watchMutations = !0, this.startWatchingMutations()
			} catch (t) {
				e = t
			}
		}, d.prototype.startWatchingMutations = function () {
			return this.watchMutations ? this.observer.observe(this.el, {
				childList: !0
			}) : void 0
		}, d.prototype.stopWatchingMutations = function () {
			var t;
			return null != (t = this.observer) ? t.disconnect() : void 0
		}, d.prototype.cleanValue = function (t) {
			var e;
			return "string" == typeof t && (t = t.replace(null != (e = this.format.radix) ? e : ".", "<radix>"), t = t.replace(/[.,]/g, ""), t = t.replace("<radix>", "."), t = parseFloat(t, 10) || 0), b(t, this.format.precision)
		}, d.prototype.bindTransitionEnd = function () {
			var t, e, i, n, r, o, a = this;
			if (!this.transitionEndBound) {
				for (this.transitionEndBound = !0, e = !1, r = s.split(" "), o = [], i = 0, n = r.length; n > i; i++) t = r[i], o.push(this.el.addEventListener(t, function () {
					return e ? !0 : (e = !0, setTimeout(function () {
						return a.render(), e = !1, T(a.el, "odometerdone")
					}, 0), !0)
				}, !1));
				return o
			}
		}, d.prototype.resetFormat = function () {
			var t, e, i, n, r, o, a, s;
			if (t = null != (a = this.options.format) ? a : l, t || (t = "d"), i = c.exec(t), !i) throw new Error("Odometer: Unparsable digit format");
			return s = i.slice(1, 4), o = s[0], r = s[1], e = s[2], n = (null != e ? e.length : void 0) || 0, this.format = {
				repeating: o,
				radix: r,
				precision: n
			}
		}, d.prototype.render = function (t) {
			var e, i, n, r, o, a, s;
			for (null == t && (t = this.value), this.stopWatchingMutations(), this.resetFormat(), this.inside.innerHTML = "", o = this.options.theme, e = this.el.className.split(" "), r = [], a = 0, s = e.length; s > a; a++) i = e[a], i.length && ((n = /^odometer-theme-(.+)$/.exec(i)) ? o = n[1] : /^odometer(-|$)/.test(i) || r.push(i));
			return r.push("odometer"), h || r.push("odometer-no-transitions"), o ? r.push("odometer-theme-" + o) : r.push("odometer-auto-theme"), this.el.className = r.join(" "), this.ribbons = {}, this.formatDigits(t), this.startWatchingMutations()
		}, d.prototype.formatDigits = function (t) {
			var e, i, n, r, o, a, s, l, c, u;
			if (this.digits = [], this.options.formatFunction)
				for (n = this.options.formatFunction(t), c = n.split("").reverse(), o = 0, s = c.length; s > o; o++) i = c[o], i.match(/0-9/) ? (e = this.renderDigit(), e.querySelector(".odometer-value").innerHTML = i, this.digits.push(e), this.insertDigit(e)) : this.addSpacer(i);
			else
				for (r = !this.format.precision || !v(t) || !1, u = t.toString().split("").reverse(), a = 0, l = u.length; l > a; a++) e = u[a], "." === e && (r = !0), this.addDigit(e, r)
		}, d.prototype.update = function (t) {
			var e, i = this;
			return t = this.cleanValue(t), (e = t - this.value) ? (x(this.el, "odometer-animating-up odometer-animating-down odometer-animating"), e > 0 ? P(this.el, "odometer-animating-up") : P(this.el, "odometer-animating-down"), this.stopWatchingMutations(), this.animate(t), this.startWatchingMutations(), setTimeout(function () {
				return i.el.offsetHeight, P(i.el, "odometer-animating")
			}, 0), this.value = t) : void 0
		}, d.prototype.renderDigit = function () {
			return g(e)
		}, d.prototype.insertDigit = function (t, e) {
			return null != e ? this.inside.insertBefore(t, e) : this.inside.children.length ? this.inside.insertBefore(t, this.inside.children[0]) : this.inside.appendChild(t)
		}, d.prototype.addSpacer = function (t, e, i) {
			var n;
			return n = g(r), n.innerHTML = t, i && P(n, i), this.insertDigit(n, e)
		}, d.prototype.addDigit = function (t, e) {
			var i, n, r, o;
			if (null == e && (e = !0), "-" === t) return this.addSpacer(t, null, "odometer-negation-mark");
			if ("." === t) return this.addSpacer(null != (o = this.format.radix) ? o : ".", null, "odometer-radix-mark");
			if (e)
				for (r = !1;;) {
					if (!this.format.repeating.length) {
						if (r) throw new Error("Bad odometer format without digits");
						this.resetFormat(), r = !0
					}
					if (i = this.format.repeating[this.format.repeating.length - 1], this.format.repeating = this.format.repeating.substring(0, this.format.repeating.length - 1), "d" === i) break;
					this.addSpacer(i)
				}
			return n = this.renderDigit(), n.querySelector(".odometer-value").innerHTML = t, this.digits.push(n), this.insertDigit(n)
		}, d.prototype.animate = function (t) {
			return h && "count" !== this.options.animation ? this.animateSlide(t) : this.animateCount(t)
		}, d.prototype.animateCount = function (n) {
			var r, o, a, s, l, c = this;
			if (o = +n - this.value) return s = a = y(), r = this.value, (l = function () {
				var t, e, i;
				return y() - s > c.options.duration ? (c.value = n, c.render(), void T(c.el, "odometerdone")) : (t = y() - a, t > u && (a = y(), i = t / c.options.duration, e = o * i, r += e, c.render(Math.round(r))), null != _ ? _(l) : setTimeout(l, u))
			})()
		}, d.prototype.getDigitCount = function () {
			var t, e, i, n, r, o;
			for (n = 1 <= arguments.length ? O.call(arguments, 0) : [], t = r = 0, o = n.length; o > r; t = ++r) i = n[t], n[t] = Math.abs(i);
			return e = Math.max.apply(Math, n), Math.ceil(Math.log(e + 1) / Math.log(10))
		}, d.prototype.getFractionalDigitCount = function () {
			var t, e, i, n, r, o, a;
			for (r = 1 <= arguments.length ? O.call(arguments, 0) : [], e = /^\-?\d*\.(\d*?)0*$/, t = o = 0, a = r.length; a > o; t = ++o) n = r[t], r[t] = n.toString(), i = e.exec(r[t]), null == i ? r[t] = 0 : r[t] = i[1].length;
			return Math.max.apply(Math, r)
		}, d.prototype.resetDigits = function () {
			return this.digits = [], this.ribbons = [], this.inside.innerHTML = "", this.resetFormat()
		}, d.prototype.animateSlide = function (t) {
			var e, i, n, r, o, a, s, l, c, u, h, d, f, p, m, g, v, y, x, _, b, w, T, E, S, M, A;
			if (g = this.value, l = this.getFractionalDigitCount(g, t), l && (t *= Math.pow(10, l), g *= Math.pow(10, l)), n = t - g) {
				for (this.bindTransitionEnd(), r = this.getDigitCount(g, t), o = [], e = 0, h = x = 0; r >= 0 ? r > x : x > r; h = r >= 0 ? ++x : --x) {
					if (v = L(g / Math.pow(10, r - h - 1)), s = L(t / Math.pow(10, r - h - 1)), a = s - v, Math.abs(a) > this.MAX_VALUES) {
						for (u = [], d = a / (this.MAX_VALUES + this.MAX_VALUES * e * C), i = v; a > 0 && s > i || 0 > a && i > s;) u.push(Math.round(i)), i += d;
						u[u.length - 1] !== s && u.push(s), e++
					} else u = function () {
						A = [];
						for (var t = v; s >= v ? s >= t : t >= s; s >= v ? t++ : t--) A.push(t);
						return A
					}.apply(this);
					for (h = _ = 0, w = u.length; w > _; h = ++_) c = u[h], u[h] = Math.abs(c % 10);
					o.push(u)
				}
				for (this.resetDigits(), M = o.reverse(), h = b = 0, T = M.length; T > b; h = ++b)
					for (u = M[h], this.digits[h] || this.addDigit(" ", h >= l), null == (y = this.ribbons)[h] && (y[h] = this.digits[h].querySelector(".odometer-ribbon-inner")), this.ribbons[h].innerHTML = "", 0 > n && (u = u.reverse()), f = S = 0, E = u.length; E > S; f = ++S) c = u[f], m = document.createElement("div"), m.className = "odometer-value", m.innerHTML = c, this.ribbons[h].appendChild(m), f === u.length - 1 && P(m, "odometer-last-value"), 0 === f && P(m, "odometer-first-value");
				return 0 > v && this.addDigit("-"), p = this.inside.querySelector(".odometer-radix-mark"), null != p && p.parent.removeChild(p), l ? this.addSpacer(this.format.radix, this.digits[l - 1], "odometer-radix-mark") : void 0
			}
		}, d
	}(), a.options = null != (A = window.odometerOptions) ? A : {}, setTimeout(function () {
		var t, e, i, n, r;
		if (window.odometerOptions) {
			n = window.odometerOptions, r = [];
			for (t in n) e = n[t], r.push(null != (i = a.options)[t] ? (i = a.options)[t] : i[t] = e);
			return r
		}
	}, 0), a.init = function () {
		var t, e, i, n, r, o;
		if (null != document.querySelectorAll) {
			for (e = document.querySelectorAll(a.options.selector || ".odometer"), o = [], i = 0, n = e.length; n > i; i++) t = e[i], o.push(t.odometer = new a({
				el: t,
				value: null != (r = t.innerText) ? r : t.textContent
			}));
			return o
		}
	}, null != (null != (R = document.documentElement) ? R.doScroll : void 0) && null != document.createEventObject ? (M = document.onreadystatechange, document.onreadystatechange = function () {
		return "complete" === document.readyState && a.options.auto !== !1 && a.init(), null != M ? M.apply(this, arguments) : void 0
	}) : document.addEventListener("DOMContentLoaded", function () {
		return a.options.auto !== !1 ? a.init() : void 0
	}, !1), "function" == typeof define && define.amd ? define([], function () {
		return a
	}) : "undefined" != typeof exports && null !== exports ? module.exports = a : window.Odometer = a
}).call(this);
! function (t) {
	"use strict";

	function e(t, e) {
		this.options = {}, t = t || this.options;
		var i = {
			frequency: 350,
			peak: 1
		};
		this.inputNode = this.filterNode = m.context.createBiquadFilter(), this.filterNode.type = e, this.outputNode = p.context.createGain(), this.filterNode.connect(this.outputNode);
		for (var n in i) this[n] = t[n], this[n] = void 0 === this[n] || null === this[n] ? i[n] : this[n]
	}

	function n() {
		var t, e, i = m.context.sampleRate * this.time,
			n = p.context.createBuffer(2, i, m.context.sampleRate),
			r = n.getChannelData(0),
			o = n.getChannelData(1);
		for (e = 0; i > e; e++) t = this.reverse ? i - e : e, r[e] = (2 * Math.random() - 1) * Math.pow(1 - t / i, this.decay), o[e] = (2 * Math.random() - 1) * Math.pow(1 - t / i, this.decay);
		this.reverbNode.buffer = n
	}

	function o(t) {
		for (var e = m.context.sampleRate, i = new Float32Array(e), n = Math.PI / 180, r = 0; e > r; r++) {
			var o = 2 * r / e - 1;
			i[r] = (3 + t) * o * 20 * n / (Math.PI + t * Math.abs(o))
		}
		return i
	}
	var p = {},
		m = p,
		i = "object" == typeof module && module.exports,
		r = "function" == typeof define && define.amd;
	i ? module.exports = p : r ? define([], p) : t.Pizzicato = t.Pz = p;
	var a = t.AudioContext || t.webkitAudioContext;
	if (!a) return void console.error("No AudioContext found in this environment. Please ensure your window or global object contains a working AudioContext constructor function.");
	p.context = new a;
	var s = p.context.createGain();
	s.connect(p.context.destination), p.Util = {
		isString: function (t) {
			return "[object String]" === toString.call(t)
		},
		isObject: function (t) {
			return "[object Object]" === toString.call(t)
		},
		isFunction: function (t) {
			return "[object Function]" === toString.call(t)
		},
		isNumber: function (t) {
			return "[object Number]" === toString.call(t) && t === +t
		},
		isArray: function (t) {
			return "[object Array]" === toString.call(t)
		},
		isInRange: function (t, e, i) {
			return m.Util.isNumber(t) && m.Util.isNumber(e) && m.Util.isNumber(i) ? t >= e && i >= t : !1
		},
		isBool: function (t) {
			return "boolean" == typeof t
		},
		isOscillator: function (t) {
			return t && "[object OscillatorNode]" === t.toString()
		},
		isAudioBufferSourceNode: function (t) {
			return t && "[object AudioBufferSourceNode]" === t.toString()
		},
		isSound: function (t) {
			return t instanceof m.Sound
		},
		isEffect: function (t) {
			for (var e in p.Effects)
				if (t instanceof p.Effects[e]) return !0;
			return !1
		},
		normalize: function (t, e, i) {
			return m.Util.isNumber(t) && m.Util.isNumber(e) && m.Util.isNumber(i) ? (i - e) * t / 1 + e : void 0
		},
		getDryLevel: function (t) {
			return !m.Util.isNumber(t) || t > 1 || 0 > t ? 0 : .5 >= t ? 1 : 1 - 2 * (t - .5)
		},
		getWetLevel: function (t) {
			return !m.Util.isNumber(t) || t > 1 || 0 > t ? 0 : t >= .5 ? 1 : 1 - 2 * (.5 - t)
		}
	};
	var l = p.context.createGain(),
		c = Object.getPrototypeOf(Object.getPrototypeOf(l)),
		u = c.connect;
	c.connect = function (t) {
		var e = m.Util.isEffect(t) ? t.inputNode : t;
		return u.call(this, e), t
	}, Object.defineProperty(p, "volume", {
		enumerable: !0,
		get: function () {
			return s.gain.value
		},
		set: function (t) {
			m.Util.isInRange(t, 0, 1) && s && (s.gain.value = t)
		}
	}), Object.defineProperty(p, "masterGainNode", {
		enumerable: !1,
		get: function () {
			return s
		},
		set: function (t) {
			console.error("Can't set the master gain node")
		}
	}), p.Events = {
		on: function (t, e, i) {
			if (t && e) {
				this._events = this._events || {};
				var n = this._events[t] || (this._events[t] = []);
				n.push({
					callback: e,
					context: i || this,
					handler: this
				})
			}
		},
		trigger: function (t) {
			if (t) {
				var e, i, n, r;
				if (this._events = this._events || {}, e = this._events[t] || (this._events[t] = [])) {
					for (i = Math.max(0, arguments.length - 1), n = [], r = 0; i > r; r++) n[r] = arguments[r + 1];
					for (r = 0; r < e.length; r++) e[r].callback.apply(e[r].context, n)
				}
			}
		},
		off: function (t) {
			t ? this._events[t] = void 0 : this._events = {}
		}
	}, p.Sound = function (t, e) {
		function i(t) {
			var e = ["wave", "file", "input", "script", "sound"];
			if (t && !c.isFunction(t) && !c.isString(t) && !c.isObject(t)) return "Description type not supported. Initialize a sound using an object, a function or a string.";
			if (c.isObject(t)) {
				if (!c.isString(t.source) || -1 === e.indexOf(t.source)) return "Specified source not supported. Sources can be wave, file, input or script";
				if (!("file" !== t.source || t.options && t.options.path)) return "A path is needed for sounds with a file source";
				if (!("script" !== t.source || t.options && t.options.audioFunction)) return "An audio function is needed for sounds with a script source"
			}
		}

		function n(i, t) {
			i = i || {}, this.getRawSourceNode = function () {
				var t = this.sourceNode ? this.sourceNode.frequency.value : i.frequency,
					e = p.context.createOscillator();
				return e.type = i.type || "sine", e.frequency.value = t || 440, e
			}, this.sourceNode = this.getRawSourceNode(), this.sourceNode.gainSuccessor = m.context.createGain(), this.sourceNode.connect(this.sourceNode.gainSuccessor), c.isFunction(t) && t()
		}

		function r(e, i) {
			e = c.isArray(e) ? e : [e];
			var n = new XMLHttpRequest;
			n.open("GET", e[0], !0), n.responseType = "arraybuffer", n.onload = function (t) {
				p.context.decodeAudioData(t.target.response, function (e) {
					l.getRawSourceNode = function () {
						var t = p.context.createBufferSource();
						return t.loop = this.loop, t.buffer = e, t
					}, c.isFunction(i) && i()
				}.bind(l), function (t) {
					return console.error("Error decoding audio file " + e[0]), e.length > 1 ? (e.shift(), void r(e, i)) : (t = t || new Error("Error decoding audio file " + e[0]), void(c.isFunction(i) && i(t)))
				}.bind(l))
			}, n.onreadystatechange = function (t) {
				4 === n.readyState && 200 !== n.status && console.error("Error while fetching " + e[0] + ". " + n.statusText)
			}, n.send()
		}

		function o(t, e) {
			if (navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia, !navigator.getUserMedia && !navigator.mediaDevices.getUserMedia) return void console.error("Your browser does not support getUserMedia");
			var i = function (t) {
					l.getRawSourceNode = function () {
						return p.context.createMediaStreamSource(t)
					}, c.isFunction(e) && e()
				}.bind(l),
				n = function (t) {
					c.isFunction(e) && e(t)
				};
			navigator.mediaDevices.getUserMedia ? navigator.mediaDevices.getUserMedia({
				audio: !0
			}).then(i)["catch"](n) : navigator.getUserMedia({
				audio: !0
			}, i, n)
		}

		function a(t, e) {
			var i = c.isFunction(t) ? t : t.audioFunction,
				n = c.isObject(t) && t.bufferSize ? t.bufferSize : null;
			if (!n) try {
				p.context.createScriptProcessor()
			} catch (t) {
				n = 2048
			}
			this.getRawSourceNode = function () {
				var t = p.context.createScriptProcessor(n, 1, 1);
				return t.onaudioprocess = i, t
			}
		}

		function s(t, e) {
			this.getRawSourceNode = t.sound.getRawSourceNode, t.sound.sourceNode && m.Util.isOscillator(t.sound.sourceNode) && (this.sourceNode = this.getRawSourceNode(), this.frequency = t.sound.frequency)
		}
		var l = this,
			c = p.Util,
			u = i(t),
			h = c.isObject(t) && c.isObject(t.options),
			d = .04,
			f = .04;
		if (u) throw console.error(u), new Error("Error initializing Pizzicato Sound: " + u);
		this.detached = h && t.options.detached, this.masterVolume = p.context.createGain(), this.fadeNode = p.context.createGain(), this.fadeNode.gain.value = 0, this.detached || this.masterVolume.connect(p.masterGainNode), this.lastTimePlayed = 0, this.effects = [], this.effectConnectors = [], this.playing = this.paused = !1, this.loop = h && t.options.loop, this.attack = h && c.isNumber(t.options.attack) ? t.options.attack : d, this.volume = h && c.isNumber(t.options.volume) ? t.options.volume : 1, h && c.isNumber(t.options.release) ? this.release = t.options.release : h && c.isNumber(t.options.sustain) ? (console.warn("'sustain' is deprecated. Use 'release' instead."), this.release = t.options.sustain) : this.release = f, t ? c.isString(t) ? r.bind(this)(t, e) : c.isFunction(t) ? a.bind(this)(t, e) : "file" === t.source ? r.bind(this)(t.options.path, e) : "wave" === t.source ? n.bind(this)(t.options, e) : "input" === t.source ? o.bind(this)(t, e) : "script" === t.source ? a.bind(this)(t.options, e) : "sound" === t.source && s.bind(this)(t.options, e) : n.bind(this)({}, e)
	}, p.Sound.prototype = Object.create(p.Events, {
		play: {
			enumerable: !0,
			value: function (t, e) {
				this.playing || (m.Util.isNumber(e) || (e = this.offsetTime || 0), m.Util.isNumber(t) || (t = 0), this.playing = !0, this.paused = !1, this.sourceNode = this.getSourceNode(), this.applyAttack(), m.Util.isFunction(this.sourceNode.start) && (this.lastTimePlayed = p.context.currentTime - e, this.sourceNode.start(m.context.currentTime + t, e)), this.trigger("play"))
			}
		},
		stop: {
			enumerable: !0,
			value: function () {
				(this.paused || this.playing) && (this.paused = this.playing = !1, this.stopWithRelease(), this.offsetTime = 0, this.trigger("stop"))
			}
		},
		pause: {
			enumerable: !0,
			value: function () {
				if (!this.paused && this.playing) {
					this.paused = !0, this.playing = !1, this.stopWithRelease();
					var t = m.context.currentTime - this.lastTimePlayed;
					this.sourceNode.buffer ? this.offsetTime = t % (this.sourceNode.buffer.length / m.context.sampleRate) : this.offsetTime = t, this.trigger("pause")
				}
			}
		},
		clone: {
			enumerable: !0,
			value: function () {
				for (var t = new p.Sound({
						source: "sound",
						options: {
							loop: this.loop,
							attack: this.attack,
							release: this.release,
							volume: this.volume,
							sound: this
						}
					}), e = 0; e < this.effects.length; e++) t.addEffect(this.effects[e]);
				return t
			}
		},
		onEnded: {
			enumerable: !0,
			value: function (t) {
				return function () {
					this.sourceNode && this.sourceNode !== t || (this.playing && this.stop(), this.paused || this.trigger("end"))
				}
			}
		},
		addEffect: {
			enumerable: !0,
			value: function (t) {
				if (!m.Util.isEffect(t)) return console.error("The object provided is not a Pizzicato effect."), this;
				this.effects.push(t);
				var e = this.effectConnectors.length > 0 ? this.effectConnectors[this.effectConnectors.length - 1] : this.fadeNode;
				e.disconnect(), e.connect(t);
				var i = m.context.createGain();
				return this.effectConnectors.push(i), t.connect(i), i.connect(this.masterVolume), this
			}
		},
		removeEffect: {
			enumerable: !0,
			value: function (t) {
				var e = this.effects.indexOf(t);
				if (-1 === e) return console.warn("Cannot remove effect that is not applied to this sound."), this;
				var i = this.playing;
				i && this.pause();
				var n = 0 === e ? this.fadeNode : this.effectConnectors[e - 1];
				n.disconnect();
				var r = this.effectConnectors[e];
				r.disconnect(), t.disconnect(r), this.effectConnectors.splice(e, 1), this.effects.splice(e, 1);
				var o;
				return o = e > this.effects.length - 1 || 0 === this.effects.length ? this.masterVolume : this.effects[e], n.connect(o), i && this.play(), this
			}
		},
		connect: {
			enumerable: !0,
			value: function (t) {
				return this.masterVolume.connect(t), this
			}
		},
		disconnect: {
			enumerable: !0,
			value: function (t) {
				return this.masterVolume.disconnect(t), this
			}
		},
		connectEffects: {
			enumerable: !0,
			value: function () {
				for (var t = [], e = 0; e < this.effects.length; e++) {
					var i = e === this.effects.length - 1,
						n = i ? this.masterVolume : this.effects[e + 1].inputNode;
					t[e] = m.context.createGain(), this.effects[e].outputNode.disconnect(this.effectConnectors[e]), this.effects[e].outputNode.connect(n)
				}
			}
		},
		volume: {
			enumerable: !0,
			get: function () {
				return this.masterVolume ? this.masterVolume.gain.value : void 0
			},
			set: function (t) {
				m.Util.isInRange(t, 0, 1) && this.masterVolume && (this.masterVolume.gain.value = t)
			}
		},
		frequency: {
			enumerable: !0,
			get: function () {
				return this.sourceNode && m.Util.isOscillator(this.sourceNode) ? this.sourceNode.frequency.value : null
			},
			set: function (t) {
				this.sourceNode && m.Util.isOscillator(this.sourceNode) && (this.sourceNode.frequency.value = t)
			}
		},
		sustain: {
			enumerable: !0,
			get: function () {
				return console.warn("'sustain' is deprecated. Use 'release' instead."), this.release
			},
			set: function (t) {
				console.warn("'sustain' is deprecated. Use 'release' instead."), m.Util.isInRange(t, 0, 10) && (this.release = t)
			}
		},
		getSourceNode: {
			enumerable: !0,
			value: function () {
				if (this.sourceNode) {
					var t = this.sourceNode;
					t.gainSuccessor.gain.setValueAtTime(t.gainSuccessor.gain.value, m.context.currentTime), t.gainSuccessor.gain.linearRampToValueAtTime(1e-4, m.context.currentTime + .2), setTimeout(function () {
						t.disconnect(), t.gainSuccessor.disconnect()
					}, 200)
				}
				var e = this.getRawSourceNode();
				return e.gainSuccessor = m.context.createGain(), e.connect(e.gainSuccessor), e.gainSuccessor.connect(this.fadeNode), this.fadeNode.connect(this.getInputNode()), m.Util.isAudioBufferSourceNode(e) && (e.onended = this.onEnded(e).bind(this)), e
			}
		},
		getInputNode: {
			enumerable: !0,
			value: function () {
				return this.effects.length > 0 ? this.effects[0].inputNode : this.masterVolume
			}
		},
		applyAttack: {
			enumerable: !1,
			value: function () {
				this.fadeNode.gain.value;
				if (this.fadeNode.gain.cancelScheduledValues(m.context.currentTime), !this.attack) return void this.fadeNode.gain.setTargetAtTime(1, m.context.currentTime, .001);
				var t = navigator.userAgent.toLowerCase().indexOf("firefox") > -1,
					e = this.attack;
				t || (e = (1 - this.fadeNode.gain.value) * this.attack), this.fadeNode.gain.setTargetAtTime(1, m.context.currentTime, 2 * e)
			}
		},
		stopWithRelease: {
			enumerable: !1,
			value: function (t) {
				var e = this.sourceNode,
					i = function () {
						return m.Util.isFunction(e.stop) ? e.stop(0) : e.disconnect()
					};
				this.fadeNode.gain.value;
				if (this.fadeNode.gain.cancelScheduledValues(m.context.currentTime), !this.release) return this.fadeNode.gain.setTargetAtTime(0, m.context.currentTime, .001), void i();
				var n = navigator.userAgent.toLowerCase().indexOf("firefox") > -1,
					r = this.release;
				n || (r = this.fadeNode.gain.value * this.release), this.fadeNode.gain.setTargetAtTime(1e-5, m.context.currentTime, r / 5), window.setTimeout(function () {
					i()
				}, 1e3 * r)
			}
		}
	}), p.Group = function (t) {
		t = t || [], this.mergeGainNode = m.context.createGain(), this.masterVolume = m.context.createGain(), this.sounds = [], this.effects = [], this.effectConnectors = [], this.mergeGainNode.connect(this.masterVolume), this.masterVolume.connect(m.masterGainNode);
		for (var e = 0; e < t.length; e++) this.addSound(t[e])
	}, p.Group.prototype = Object.create(m.Events, {
		connect: {
			enumerable: !0,
			value: function (t) {
				return this.masterVolume.connect(t), this
			}
		},
		disconnect: {
			enumerable: !0,
			value: function (t) {
				return this.masterVolume.disconnect(t), this
			}
		},
		addSound: {
			enumerable: !0,
			value: function (t) {
				return m.Util.isSound(t) ? this.sounds.indexOf(t) > -1 ? void console.warn("The Pizzicato.Sound object was already added to this group") : t.detached ? void console.warn("Groups do not support detached sounds. You can manually create an audio graph to group detached sounds together.") : (t.disconnect(m.masterGainNode), t.connect(this.mergeGainNode), void this.sounds.push(t)) : void console.error("You can only add Pizzicato.Sound objects")
			}
		},
		removeSound: {
			enumerable: !0,
			value: function (t) {
				var e = this.sounds.indexOf(t);
				return -1 === e ? void console.warn("Cannot remove a sound that is not part of this group.") : (t.disconnect(this.mergeGainNode), t.connect(m.masterGainNode), void this.sounds.splice(e, 1))
			}
		},
		volume: {
			enumerable: !0,
			get: function () {
				return this.masterVolume ? this.masterVolume.gain.value : void 0
			},
			set: function (t) {
				m.Util.isInRange(t, 0, 1) && (this.masterVolume.gain.value = t)
			}
		},
		play: {
			enumerable: !0,
			value: function () {
				for (var t = 0; t < this.sounds.length; t++) this.sounds[t].play();
				this.trigger("play")
			}
		},
		stop: {
			enumerable: !0,
			value: function () {
				for (var t = 0; t < this.sounds.length; t++) this.sounds[t].stop();
				this.trigger("stop")
			}
		},
		pause: {
			enumerable: !0,
			value: function () {
				for (var t = 0; t < this.sounds.length; t++) this.sounds[t].pause();
				this.trigger("pause")
			}
		},
		addEffect: {
			enumerable: !0,
			value: function (t) {
				if (!m.Util.isEffect(t)) return console.error("The object provided is not a Pizzicato effect."), this;
				this.effects.push(t);
				var e = this.effectConnectors.length > 0 ? this.effectConnectors[this.effectConnectors.length - 1] : this.mergeGainNode;
				e.disconnect(), e.connect(t);
				var i = m.context.createGain();
				return this.effectConnectors.push(i), t.connect(i), i.connect(this.masterVolume), this
			}
		},
		removeEffect: {
			enumerable: !0,
			value: function (t) {
				var e = this.effects.indexOf(t);
				if (-1 === e) return console.warn("Cannot remove effect that is not applied to this group."), this;
				var i = 0 === e ? this.mergeGainNode : this.effectConnectors[e - 1];
				i.disconnect();
				var n = this.effectConnectors[e];
				n.disconnect(), t.disconnect(n), this.effectConnectors.splice(e, 1), this.effects.splice(e, 1);
				var r;
				return r = e > this.effects.length - 1 || 0 === this.effects.length ? this.masterVolume : this.effects[e], i.connect(r), this
			}
		}
	}), p.Effects = {};
	var h = Object.create(null, {
		connect: {
			enumerable: !0,
			value: function (t) {
				return this.outputNode.connect(t), this
			}
		},
		disconnect: {
			enumerable: !0,
			value: function (t) {
				return this.outputNode.disconnect(t), this
			}
		}
	});
	p.Effects.Delay = function (t) {
		this.options = {}, t = t || this.options;
		var e = {
			feedback: .5,
			time: .3,
			mix: .5
		};
		this.inputNode = p.context.createGain(), this.outputNode = p.context.createGain(), this.dryGainNode = p.context.createGain(), this.wetGainNode = p.context.createGain(), this.feedbackGainNode = p.context.createGain(), this.delayNode = p.context.createDelay(), this.inputNode.connect(this.dryGainNode), this.dryGainNode.connect(this.outputNode), this.delayNode.connect(this.feedbackGainNode), this.feedbackGainNode.connect(this.delayNode), this.inputNode.connect(this.delayNode), this.delayNode.connect(this.wetGainNode), this.wetGainNode.connect(this.outputNode);
		for (var i in e) this[i] = t[i], this[i] = void 0 === this[i] || null === this[i] ? e[i] : this[i]
	}, p.Effects.Delay.prototype = Object.create(h, {
		mix: {
			enumerable: !0,
			get: function () {
				return this.options.mix
			},
			set: function (t) {
				m.Util.isInRange(t, 0, 1) && (this.options.mix = t, this.dryGainNode.gain.value = p.Util.getDryLevel(this.mix), this.wetGainNode.gain.value = p.Util.getWetLevel(this.mix))
			}
		},
		time: {
			enumerable: !0,
			get: function () {
				return this.options.time
			},
			set: function (t) {
				m.Util.isInRange(t, 0, 180) && (this.options.time = t, this.delayNode.delayTime.value = t)
			}
		},
		feedback: {
			enumerable: !0,
			get: function () {
				return this.options.feedback
			},
			set: function (t) {
				m.Util.isInRange(t, 0, 1) && (this.options.feedback = parseFloat(t, 10), this.feedbackGainNode.gain.value = this.feedback)
			}
		}
	}), p.Effects.Compressor = function (t) {
		this.options = {}, t = t || this.options;
		var e = {
			threshold: -24,
			knee: 30,
			attack: .003,
			release: .25,
			ratio: 12
		};
		this.inputNode = this.compressorNode = p.context.createDynamicsCompressor(), this.outputNode = p.context.createGain(), this.compressorNode.connect(this.outputNode);
		for (var i in e) this[i] = t[i], this[i] = void 0 === this[i] || null === this[i] ? e[i] : this[i]
	}, p.Effects.Compressor.prototype = Object.create(h, {
		threshold: {
			enumerable: !0,
			get: function () {
				return this.compressorNode.threshold.value
			},
			set: function (t) {
				p.Util.isInRange(t, -100, 0) && (this.compressorNode.threshold.value = t)
			}
		},
		knee: {
			enumerable: !0,
			get: function () {
				return this.compressorNode.knee.value
			},
			set: function (t) {
				p.Util.isInRange(t, 0, 40) && (this.compressorNode.knee.value = t)
			}
		},
		attack: {
			enumerable: !0,
			get: function () {
				return this.compressorNode.attack.value
			},
			set: function (t) {
				p.Util.isInRange(t, 0, 1) && (this.compressorNode.attack.value = t)
			}
		},
		release: {
			enumerable: !0,
			get: function () {
				return this.compressorNode.release.value
			},
			set: function (t) {
				p.Util.isInRange(t, 0, 1) && (this.compressorNode.release.value = t)
			}
		},
		ratio: {
			enumerable: !0,
			get: function () {
				return this.compressorNode.ratio.value
			},
			set: function (t) {
				p.Util.isInRange(t, 1, 20) && (this.compressorNode.ratio.value = t)
			}
		},
		getCurrentGainReduction: function () {
			return this.compressorNode.reduction
		}
	}), p.Effects.LowPassFilter = function (t) {
		e.call(this, t, "lowpass")
	}, p.Effects.HighPassFilter = function (t) {
		e.call(this, t, "highpass")
	};
	var d = Object.create(h, {
		frequency: {
			enumerable: !0,
			get: function () {
				return this.filterNode.frequency.value
			},
			set: function (t) {
				p.Util.isInRange(t, 10, 22050) && (this.filterNode.frequency.value = t)
			}
		},
		peak: {
			enumerable: !0,
			get: function () {
				return this.filterNode.Q.value
			},
			set: function (t) {
				p.Util.isInRange(t, 1e-4, 1e3) && (this.filterNode.Q.value = t)
			}
		}
	});
	p.Effects.LowPassFilter.prototype = d, p.Effects.HighPassFilter.prototype = d, p.Effects.Distortion = function (t) {
		this.options = {}, t = t || this.options;
		var e = {
			gain: .5
		};
		this.waveShaperNode = p.context.createWaveShaper(), this.inputNode = this.outputNode = this.waveShaperNode;
		for (var i in e) this[i] = t[i], this[i] = void 0 === this[i] || null === this[i] ? e[i] : this[i]
	}, p.Effects.Distortion.prototype = Object.create(h, {
		gain: {
			enumerable: !0,
			get: function () {
				return this.options.gain
			},
			set: function (t) {
				m.Util.isInRange(t, 0, 1) && (this.options.gain = t, this.adjustGain())
			}
		},
		adjustGain: {
			writable: !1,
			configurable: !1,
			enumerable: !1,
			value: function () {
				for (var t, e = m.Util.isNumber(this.options.gain) ? parseInt(100 * this.options.gain, 10) : 50, i = 44100, n = new Float32Array(i), r = Math.PI / 180, o = 0; i > o; ++o) t = 2 * o / i - 1, n[o] = (3 + e) * t * 20 * r / (Math.PI + e * Math.abs(t));
				this.waveShaperNode.curve = n
			}
		}
	}), p.Effects.Flanger = function (t) {
		this.options = {}, t = t || this.options;
		var e = {
			time: .45,
			speed: .2,
			depth: .1,
			feedback: .1,
			mix: .5
		};
		this.inputNode = p.context.createGain(), this.outputNode = p.context.createGain(), this.inputFeedbackNode = p.context.createGain(), this.wetGainNode = p.context.createGain(), this.dryGainNode = p.context.createGain(), this.delayNode = p.context.createDelay(), this.oscillatorNode = p.context.createOscillator(), this.gainNode = p.context.createGain(), this.feedbackNode = p.context.createGain(), this.oscillatorNode.type = "sine", this.inputNode.connect(this.inputFeedbackNode), this.inputNode.connect(this.dryGainNode), this.inputFeedbackNode.connect(this.delayNode), this.inputFeedbackNode.connect(this.wetGainNode), this.delayNode.connect(this.wetGainNode), this.delayNode.connect(this.feedbackNode), this.feedbackNode.connect(this.inputFeedbackNode), this.oscillatorNode.connect(this.gainNode), this.gainNode.connect(this.delayNode.delayTime), this.dryGainNode.connect(this.outputNode), this.wetGainNode.connect(this.outputNode), this.oscillatorNode.start(0);
		for (var i in e) this[i] = t[i], this[i] = void 0 === this[i] || null === this[i] ? e[i] : this[i]
	}, p.Effects.Flanger.prototype = Object.create(h, {
		time: {
			enumberable: !0,
			get: function () {
				return this.options.time
			},
			set: function (t) {
				m.Util.isInRange(t, 0, 1) && (this.options.time = t, this.delayNode.delayTime.value = m.Util.normalize(t, .001, .02))
			}
		},
		speed: {
			enumberable: !0,
			get: function () {
				return this.options.speed
			},
			set: function (t) {
				m.Util.isInRange(t, 0, 1) && (this.options.speed = t, this.oscillatorNode.frequency.value = m.Util.normalize(t, .5, 5))
			}
		},
		depth: {
			enumberable: !0,
			get: function () {
				return this.options.depth
			},
			set: function (t) {
				m.Util.isInRange(t, 0, 1) && (this.options.depth = t, this.gainNode.gain.value = m.Util.normalize(t, 5e-4, .005))
			}
		},
		feedback: {
			enumberable: !0,
			get: function () {
				return this.options.feedback
			},
			set: function (t) {
				m.Util.isInRange(t, 0, 1) && (this.options.feedback = t, this.feedbackNode.gain.value = m.Util.normalize(t, 0, .8))
			}
		},
		mix: {
			enumberable: !0,
			get: function () {
				return this.options.mix
			},
			set: function (t) {
				m.Util.isInRange(t, 0, 1) && (this.options.mix = t, this.dryGainNode.gain.value = p.Util.getDryLevel(this.mix), this.wetGainNode.gain.value = p.Util.getWetLevel(this.mix))
			}
		}
	}), p.Effects.StereoPanner = function (t) {
		this.options = {}, t = t || this.options;
		var e = {
			pan: 0
		};
		this.inputNode = p.context.createGain(), this.outputNode = p.context.createGain(), p.context.createStereoPanner ? (this.pannerNode = p.context.createStereoPanner(), this.inputNode.connect(this.pannerNode), this.pannerNode.connect(this.outputNode)) : p.context.createPanner ? (console.warn("Your browser does not support the StereoPannerNode. Will use PannerNode instead."), this.pannerNode = p.context.createPanner(), this.pannerNode.type = "equalpower", this.inputNode.connect(this.pannerNode), this.pannerNode.connect(this.outputNode)) : (console.warn("Your browser does not support the Panner effect."), this.inputNode.connect(this.outputNode));
		for (var i in e) this[i] = t[i], this[i] = void 0 === this[i] || null === this[i] ? e[i] : this[i]
	}, p.Effects.StereoPanner.prototype = Object.create(h, {
		pan: {
			enumerable: !0,
			get: function () {
				return this.options.pan
			},
			set: function (t) {
				if (m.Util.isInRange(t, -1, 1) && (this.options.pan = t, this.pannerNode)) {
					var e = this.pannerNode.toString().indexOf("StereoPannerNode") > -1;
					e ? this.pannerNode.pan.value = t : this.pannerNode.setPosition(t, 0, 1 - Math.abs(t))
				}
			}
		}
	}), p.Effects.Convolver = function (e, t) {
		this.options = {}, e = e || this.options;
		var i = this,
			n = new XMLHttpRequest,
			r = {
				mix: .5
			};
		this.callback = t, this.inputNode = p.context.createGain(), this.convolverNode = p.context.createConvolver(), this.outputNode = p.context.createGain(), this.wetGainNode = p.context.createGain(), this.dryGainNode = p.context.createGain(), this.inputNode.connect(this.convolverNode), this.convolverNode.connect(this.wetGainNode), this.inputNode.connect(this.dryGainNode), this.dryGainNode.connect(this.outputNode), this.wetGainNode.connect(this.outputNode);
		for (var o in r) this[o] = e[o], this[o] = void 0 === this[o] || null === this[o] ? r[o] : this[o];
		return e.impulse ? (n.open("GET", e.impulse, !0), n.responseType = "arraybuffer", n.onload = function (t) {
			var e = t.target.response;
			p.context.decodeAudioData(e, function (t) {
				i.convolverNode.buffer = t, i.callback && m.Util.isFunction(i.callback) && i.callback()
			}, function (t) {
				t = t || new Error("Error decoding impulse file"), i.callback && m.Util.isFunction(i.callback) && i.callback(t)
			})
		}, n.onreadystatechange = function (t) {
			4 === n.readyState && 200 !== n.status && console.error("Error while fetching " + e.impulse + ". " + n.statusText)
		}, void n.send()) : void console.error("No impulse file specified.")
	}, p.Effects.Convolver.prototype = Object.create(h, {
		mix: {
			enumerable: !0,
			get: function () {
				return this.options.mix
			},
			set: function (t) {
				m.Util.isInRange(t, 0, 1) && (this.options.mix = t, this.dryGainNode.gain.value = p.Util.getDryLevel(this.mix), this.wetGainNode.gain.value = p.Util.getWetLevel(this.mix))
			}
		}
	}), p.Effects.PingPongDelay = function (t) {
		this.options = {}, t = t || this.options;
		var e = {
			feedback: .5,
			time: .3,
			mix: .5
		};
		this.inputNode = p.context.createGain(), this.outputNode = p.context.createGain(), this.delayNodeLeft = p.context.createDelay(), this.delayNodeRight = p.context.createDelay(), this.dryGainNode = p.context.createGain(), this.wetGainNode = p.context.createGain(), this.feedbackGainNode = p.context.createGain(), this.channelMerger = p.context.createChannelMerger(2), this.inputNode.connect(this.dryGainNode), this.dryGainNode.connect(this.outputNode), this.delayNodeLeft.connect(this.channelMerger, 0, 0), this.delayNodeRight.connect(this.channelMerger, 0, 1), this.delayNodeLeft.connect(this.delayNodeRight), this.feedbackGainNode.connect(this.delayNodeLeft), this.delayNodeRight.connect(this.feedbackGainNode), this.inputNode.connect(this.feedbackGainNode), this.channelMerger.connect(this.wetGainNode), this.wetGainNode.connect(this.outputNode);
		for (var i in e) this[i] = t[i], this[i] = void 0 === this[i] || null === this[i] ? e[i] : this[i]
	}, p.Effects.PingPongDelay.prototype = Object.create(h, {
		mix: {
			enumerable: !0,
			get: function () {
				return this.options.mix
			},
			set: function (t) {
				m.Util.isInRange(t, 0, 1) && (this.options.mix = t, this.dryGainNode.gain.value = p.Util.getDryLevel(this.mix), this.wetGainNode.gain.value = p.Util.getWetLevel(this.mix))
			}
		},
		time: {
			enumerable: !0,
			get: function () {
				return this.options.time
			},
			set: function (t) {
				m.Util.isInRange(t, 0, 180) && (this.options.time = t, this.delayNodeLeft.delayTime.value = t, this.delayNodeRight.delayTime.value = t)
			}
		},
		feedback: {
			enumerable: !0,
			get: function () {
				return this.options.feedback
			},
			set: function (t) {
				m.Util.isInRange(t, 0, 1) && (this.options.feedback = parseFloat(t, 10), this.feedbackGainNode.gain.value = this.feedback)
			}
		}
	}), p.Effects.Reverb = function (t) {
		this.options = {}, t = t || this.options;
		var e = {
			mix: .5,
			time: .01,
			decay: .01,
			reverse: !1
		};
		this.inputNode = p.context.createGain(), this.reverbNode = p.context.createConvolver(), this.outputNode = p.context.createGain(), this.wetGainNode = p.context.createGain(), this.dryGainNode = p.context.createGain(), this.inputNode.connect(this.reverbNode), this.reverbNode.connect(this.wetGainNode), this.inputNode.connect(this.dryGainNode), this.dryGainNode.connect(this.outputNode), this.wetGainNode.connect(this.outputNode);
		for (var i in e) this[i] = t[i], this[i] = void 0 === this[i] || null === this[i] ? e[i] : this[i];
		n.bind(this)()
	}, p.Effects.Reverb.prototype = Object.create(h, {
		mix: {
			enumerable: !0,
			get: function () {
				return this.options.mix
			},
			set: function (t) {
				m.Util.isInRange(t, 0, 1) && (this.options.mix = t, this.dryGainNode.gain.value = p.Util.getDryLevel(this.mix), this.wetGainNode.gain.value = p.Util.getWetLevel(this.mix))
			}
		},
		time: {
			enumerable: !0,
			get: function () {
				return this.options.time
			},
			set: function (t) {
				m.Util.isInRange(t, 1e-4, 10) && (this.options.time = t, n.bind(this)())
			}
		},
		decay: {
			enumerable: !0,
			get: function () {
				return this.options.decay
			},
			set: function (t) {
				m.Util.isInRange(t, 1e-4, 10) && (this.options.decay = t, n.bind(this)())
			}
		},
		reverse: {
			enumerable: !0,
			get: function () {
				return this.options.reverse
			},
			set: function (t) {
				m.Util.isBool(t) && (this.options.reverse = t, n.bind(this)())
			}
		}
	}), p.Effects.Tremolo = function (t) {
		this.options = {}, t = t || this.options;
		var e = {
			speed: 4,
			depth: 1,
			mix: .8
		};
		this.inputNode = p.context.createGain(), this.outputNode = p.context.createGain(), this.dryGainNode = p.context.createGain(), this.wetGainNode = p.context.createGain(), this.tremoloGainNode = p.context.createGain(), this.tremoloGainNode.gain.value = 0, this.lfoNode = p.context.createOscillator(), this.shaperNode = p.context.createWaveShaper(), this.shaperNode.curve = new Float32Array([0, 1]), this.shaperNode.connect(this.tremoloGainNode.gain), this.inputNode.connect(this.dryGainNode), this.dryGainNode.connect(this.outputNode), this.lfoNode.connect(this.shaperNode), this.lfoNode.type = "sine", this.lfoNode.start(0), this.inputNode.connect(this.tremoloGainNode), this.tremoloGainNode.connect(this.wetGainNode), this.wetGainNode.connect(this.outputNode);
		for (var i in e) this[i] = t[i], this[i] = void 0 === this[i] || null === this[i] ? e[i] : this[i]
	}, p.Effects.Tremolo.prototype = Object.create(h, {
		mix: {
			enumerable: !0,
			get: function () {
				return this.options.mix
			},
			set: function (t) {
				m.Util.isInRange(t, 0, 1) && (this.options.mix = t, this.dryGainNode.gain.value = p.Util.getDryLevel(this.mix), this.wetGainNode.gain.value = p.Util.getWetLevel(this.mix))
			}
		},
		speed: {
			enumerable: !0,
			get: function () {
				return this.options.speed
			},
			set: function (t) {
				m.Util.isInRange(t, 0, 20) && (this.options.speed = t, this.lfoNode.frequency.value = t)
			}
		},
		depth: {
			enumerable: !0,
			get: function () {
				return this.options.depth
			},
			set: function (t) {
				m.Util.isInRange(t, 0, 1) && (this.options.depth = t, this.shaperNode.curve = new Float32Array([1 - t, 1]))
			}
		}
	}), p.Effects.DubDelay = function (t) {
		this.options = {}, t = t || this.options;
		var e = {
			feedback: .6,
			time: .7,
			mix: .5,
			cutoff: 700
		};
		this.inputNode = p.context.createGain(), this.outputNode = p.context.createGain(), this.dryGainNode = p.context.createGain(), this.wetGainNode = p.context.createGain(), this.feedbackGainNode = p.context.createGain(), this.delayNode = p.context.createDelay(), this.bqFilterNode = p.context.createBiquadFilter(), this.inputNode.connect(this.dryGainNode), this.dryGainNode.connect(this.outputNode), this.inputNode.connect(this.wetGainNode), this.inputNode.connect(this.feedbackGainNode), this.feedbackGainNode.connect(this.bqFilterNode), this.bqFilterNode.connect(this.delayNode), this.delayNode.connect(this.feedbackGainNode), this.delayNode.connect(this.wetGainNode), this.wetGainNode.connect(this.outputNode);
		for (var i in e) this[i] = t[i], this[i] = void 0 === this[i] || null === this[i] ? e[i] : this[i]
	}, p.Effects.DubDelay.prototype = Object.create(h, {
		mix: {
			enumerable: !0,
			get: function () {
				return this.options.mix
			},
			set: function (t) {
				m.Util.isInRange(t, 0, 1) && (this.options.mix = t, this.dryGainNode.gain.value = p.Util.getDryLevel(this.mix), this.wetGainNode.gain.value = p.Util.getWetLevel(this.mix))
			}
		},
		time: {
			enumerable: !0,
			get: function () {
				return this.options.time
			},
			set: function (t) {
				m.Util.isInRange(t, 0, 180) && (this.options.time = t, this.delayNode.delayTime.value = t)
			}
		},
		feedback: {
			enumerable: !0,
			get: function () {
				return this.options.feedback
			},
			set: function (t) {
				m.Util.isInRange(t, 0, 1) && (this.options.feedback = parseFloat(t, 10), this.feedbackGainNode.gain.value = this.feedback)
			}
		},
		cutoff: {
			enumerable: !0,
			get: function () {
				return this.options.cutoff
			},
			set: function (t) {
				m.Util.isInRange(t, 0, 4e3) && (this.options.cutoff = t, this.bqFilterNode.frequency.value = this.cutoff)
			}
		}
	}), p.Effects.RingModulator = function (t) {
		this.options = {}, t = t || this.options;
		var e = {
			speed: 30,
			distortion: 1,
			mix: .5
		};
		this.inputNode = p.context.createGain(), this.outputNode = p.context.createGain(), this.dryGainNode = p.context.createGain(), this.wetGainNode = p.context.createGain(), this.vIn = p.context.createOscillator(), this.vIn.start(0), this.vInGain = p.context.createGain(), this.vInGain.gain.value = .5, this.vInInverter1 = p.context.createGain(), this.vInInverter1.gain.value = -1, this.vInInverter2 = p.context.createGain(), this.vInInverter2.gain.value = -1, this.vInDiode1 = new f(p.context), this.vInDiode2 = new f(p.context), this.vInInverter3 = p.context.createGain(), this.vInInverter3.gain.value = -1, this.vcInverter1 = p.context.createGain(), this.vcInverter1.gain.value = -1, this.vcDiode3 = new f(p.context), this.vcDiode4 = new f(p.context), this.outGain = p.context.createGain(), this.outGain.gain.value = 3, this.compressor = p.context.createDynamicsCompressor(), this.compressor.threshold.value = -24, this.compressor.ratio.value = 16, this.inputNode.connect(this.dryGainNode), this.dryGainNode.connect(this.outputNode), this.inputNode.connect(this.vcInverter1), this.inputNode.connect(this.vcDiode4.node), this.vcInverter1.connect(this.vcDiode3.node), this.vIn.connect(this.vInGain), this.vInGain.connect(this.vInInverter1), this.vInGain.connect(this.vcInverter1), this.vInGain.connect(this.vcDiode4.node), this.vInInverter1.connect(this.vInInverter2), this.vInInverter1.connect(this.vInDiode2.node), this.vInInverter2.connect(this.vInDiode1.node), this.vInDiode1.connect(this.vInInverter3), this.vInDiode2.connect(this.vInInverter3), this.vInInverter3.connect(this.compressor), this.vcDiode3.connect(this.compressor), this.vcDiode4.connect(this.compressor), this.compressor.connect(this.outGain), this.outGain.connect(this.wetGainNode), this.wetGainNode.connect(this.outputNode);
		for (var i in e) this[i] = t[i], this[i] = void 0 === this[i] || null === this[i] ? e[i] : this[i]
	};
	var f = function (t) {
		this.context = t, this.node = this.context.createWaveShaper(), this.vb = .2, this.vl = .4, this.h = 1, this.setCurve()
	};
	return f.prototype.setDistortion = function (t) {
		return this.h = t, this.setCurve()
	}, f.prototype.setCurve = function () {
		var t, e, i, n, r, o, a, s;
		for (e = 1024, r = new Float32Array(e), t = o = 0, a = r.length; a >= 0 ? a > o : o > a; t = a >= 0 ? ++o : --o) i = (t - e / 2) / (e / 2), i = Math.abs(i), n = i <= this.vb ? 0 : this.vb < i && i <= this.vl ? this.h * (Math.pow(i - this.vb, 2) / (2 * this.vl - 2 * this.vb)) : this.h * i - this.h * this.vl + this.h * (Math.pow(this.vl - this.vb, 2) / (2 * this.vl - 2 * this.vb)), r[t] = n;
		return s = this.node.curve = r
	}, f.prototype.connect = function (t) {
		return this.node.connect(t)
	}, p.Effects.RingModulator.prototype = Object.create(h, {
		mix: {
			enumerable: !0,
			get: function () {
				return this.options.mix
			},
			set: function (t) {
				m.Util.isInRange(t, 0, 1) && (this.options.mix = t, this.dryGainNode.gain.value = p.Util.getDryLevel(this.mix), this.wetGainNode.gain.value = p.Util.getWetLevel(this.mix))
			}
		},
		speed: {
			enumerable: !0,
			get: function () {
				return this.options.speed
			},
			set: function (t) {
				m.Util.isInRange(t, 0, 2e3) && (this.options.speed = t, this.vIn.frequency.value = t)
			}
		},
		distortion: {
			enumerable: !0,
			get: function () {
				return this.options.distortion
			},
			set: function (t) {
				if (m.Util.isInRange(t, .2, 50)) {
					this.options.distortion = parseFloat(t, 10);
					for (var e = [this.vInDiode1, this.vInDiode2, this.vcDiode3, this.vcDiode4], i = 0, n = e.length; n > i; i++) e[i].setDistortion(t)
				}
			}
		}
	}), p.Effects.Quadrafuzz = function (t) {
		this.options = {}, t = t || this.options;
		var e = {
			lowGain: .6,
			midLowGain: .8,
			midHighGain: .5,
			highGain: .6
		};
		this.inputNode = m.context.createGain(), this.outputNode = m.context.createGain(), this.dryGainNode = m.context.createGain(), this.wetGainNode = m.context.createGain(), this.lowpassLeft = m.context.createBiquadFilter(), this.lowpassLeft.type = "lowpass", this.lowpassLeft.frequency.value = 147, this.lowpassLeft.Q.value = .7071, this.bandpass1Left = m.context.createBiquadFilter(), this.bandpass1Left.type = "bandpass", this.bandpass1Left.frequency.value = 587, this.bandpass1Left.Q.value = .7071, this.bandpass2Left = m.context.createBiquadFilter(), this.bandpass2Left.type = "bandpass", this.bandpass2Left.frequency.value = 2490, this.bandpass2Left.Q.value = .7071, this.highpassLeft = m.context.createBiquadFilter(), this.highpassLeft.type = "highpass", this.highpassLeft.frequency.value = 4980, this.highpassLeft.Q.value = .7071, this.overdrives = [];
		for (var i = 0; 4 > i; i++) this.overdrives[i] = m.context.createWaveShaper(), this.overdrives[i].curve = o();
		this.inputNode.connect(this.wetGainNode), this.inputNode.connect(this.dryGainNode), this.dryGainNode.connect(this.outputNode);
		var n = [this.lowpassLeft, this.bandpass1Left, this.bandpass2Left, this.highpassLeft];
		for (i = 0; i < n.length; i++) this.wetGainNode.connect(n[i]), n[i].connect(this.overdrives[i]), this.overdrives[i].connect(this.outputNode);
		for (var r in e) this[r] = t[r], this[r] = void 0 === this[r] || null === this[r] ? e[r] : this[r]
	}, p.Effects.Quadrafuzz.prototype = Object.create(h, {
		lowGain: {
			enumerable: !0,
			get: function () {
				return this.options.lowGain
			},
			set: function (t) {
				m.Util.isInRange(t, 0, 1) && (this.options.lowGain = t, this.overdrives[0].curve = o(m.Util.normalize(this.lowGain, 0, 150)))
			}
		},
		midLowGain: {
			enumerable: !0,
			get: function () {
				return this.options.midLowGain
			},
			set: function (t) {
				m.Util.isInRange(t, 0, 1) && (this.options.midLowGain = t, this.overdrives[1].curve = o(m.Util.normalize(this.midLowGain, 0, 150)))
			}
		},
		midHighGain: {
			enumerable: !0,
			get: function () {
				return this.options.midHighGain
			},
			set: function (t) {
				m.Util.isInRange(t, 0, 1) && (this.options.midHighGain = t, this.overdrives[2].curve = o(m.Util.normalize(this.midHighGain, 0, 150)))
			}
		},
		highGain: {
			enumerable: !0,
			get: function () {
				return this.options.highGain
			},
			set: function (t) {
				m.Util.isInRange(t, 0, 1) && (this.options.highGain = t, this.overdrives[3].curve = o(m.Util.normalize(this.highGain, 0, 150)))
			}
		}
	}), p
}("undefined" != typeof window ? window : global);
! function (t, e) {
	var i = e(t, t.document);
	t.lazySizes = i, "object" == typeof module && module.exports && (module.exports = i)
}(window, function (s, D) {
	"use strict";
	if (D.getElementsByClassName) {
		var F, B, U = D.documentElement,
			l = s.Date,
			n = s.HTMLPictureElement,
			c = "addEventListener",
			z = "getAttribute",
			G = s[c],
			H = s.setTimeout,
			u = s.requestAnimationFrame || H,
			h = s.requestIdleCallback,
			j = /^picture$/i,
			r = ["load", "error", "lazyincluded", "_lazyloaded"],
			i = {},
			V = Array.prototype.forEach,
			W = function (t, e) {
				return i[e] || (i[e] = new RegExp("(\\s|^)" + e + "(\\s|$)")), i[e].test(t[z]("class") || "") && i[e]
			},
			X = function (t, e) {
				W(t, e) || t.setAttribute("class", (t[z]("class") || "").trim() + " " + e)
			},
			Y = function (t, e) {
				var i;
				(i = W(t, e)) && t.setAttribute("class", (t[z]("class") || "").replace(i, " "))
			},
			q = function (e, i, t) {
				var n = t ? c : "removeEventListener";
				t && q(e, i), r.forEach(function (t) {
					e[n](t, i)
				})
			},
			$ = function (t, e, i, n, r) {
				var o = D.createEvent("CustomEvent");
				return i || (i = {}), i.instance = F, o.initCustomEvent(e, !n, !r, i), t.dispatchEvent(o), o
			},
			Z = function (t, e) {
				var i;
				!n && (i = s.picturefill || B.pf) ? (e && e.src && !t[z]("srcset") && t.setAttribute("srcset", e.src), i({
					reevaluate: !0,
					elements: [t]
				})) : e && e.src && (t.src = e.src)
			},
			J = function (t, e) {
				return (getComputedStyle(t, null) || {})[e]
			},
			a = function (t, e, i) {
				for (i = i || t.offsetWidth; i < B.minSize && e && !t._lazysizesWidth;) i = e.offsetWidth, e = e.parentNode;
				return i
			},
			Q = function () {
				var i, n, e = [],
					r = [],
					o = e,
					a = function () {
						var t = o;
						for (o = e.length ? r : e, i = !0, n = !1; t.length;) t.shift()();
						i = !1
					},
					t = function (t, e) {
						i && !e ? t.apply(this, arguments) : (o.push(t), n || (n = !0, (D.hidden ? H : u)(a)))
					};
				return t._lsFlush = a, t
			}(),
			K = function (i, t) {
				return t ? function () {
					Q(i)
				} : function () {
					var t = this,
						e = arguments;
					Q(function () {
						i.apply(t, e)
					})
				}
			},
			tt = function (t) {
				var i, n = 0,
					r = B.throttleDelay,
					o = B.ricTimeout,
					e = function () {
						i = !1, n = l.now(), t()
					},
					a = h && o > 49 ? function () {
						h(e, {
							timeout: o
						}), o !== B.ricTimeout && (o = B.ricTimeout)
					} : K(function () {
						H(e)
					}, !0);
				return function (t) {
					var e;
					(t = t === !0) && (o = 33), i || (i = !0, e = r - (l.now() - n), 0 > e && (e = 0), t || 9 > e ? a() : H(a, e))
				}
			},
			et = function (t) {
				var e, i, n = 99,
					r = function () {
						e = null, t()
					},
					o = function () {
						var t = l.now() - i;
						n > t ? H(o, n - t) : (h || r)(r)
					};
				return function () {
					i = l.now(), e || (e = H(o, n))
				}
			};
		! function () {
			var t, e = {
				lazyClass: "lazyload",
				loadedClass: "lazyloaded",
				loadingClass: "lazyloading",
				preloadClass: "lazypreload",
				errorClass: "lazyerror",
				autosizesClass: "lazyautosizes",
				srcAttr: "data-src",
				srcsetAttr: "data-srcset",
				sizesAttr: "data-sizes",
				minSize: 40,
				customMedia: {},
				init: !0,
				expFactor: 1.5,
				hFac: .8,
				loadMode: 2,
				loadHidden: !0,
				ricTimeout: 0,
				throttleDelay: 125
			};
			B = s.lazySizesConfig || s.lazysizesConfig || {};
			for (t in e) t in B || (B[t] = e[t]);
			s.lazySizesConfig = B, H(function () {
				B.init && o()
			})
		}();
		var t = function () {
				var u, h, d, f, e, p, m, g, v, y, x, _, b, w, o = /^img$/i,
					T = /^iframe$/i,
					E = "onscroll" in s && !/(gle|ing)bot/.test(navigator.userAgent),
					S = 0,
					M = 0,
					A = 0,
					C = -1,
					P = function (t) {
						A--, t && t.target && q(t.target, P), (!t || 0 > A || !t.target) && (A = 0)
					},
					L = function (t, e) {
						var i, n = t,
							r = "hidden" == J(D.body, "visibility") || "hidden" != J(t.parentNode, "visibility") && "hidden" != J(t, "visibility");
						for (g -= e, x += e, v -= e, y += e; r && (n = n.offsetParent) && n != D.body && n != U;) r = (J(n, "opacity") || 1) > 0, r && "visible" != J(n, "overflow") && (i = n.getBoundingClientRect(), r = y > i.left && v < i.right && x > i.top - 1 && g < i.bottom + 1);
						return r
					},
					t = function () {
						var t, e, i, n, r, o, a, s, l, c = F.elements;
						if ((f = B.loadMode) && 8 > A && (t = c.length)) {
							e = 0, C++, null == b && ("expand" in B || (B.expand = U.clientHeight > 500 && U.clientWidth > 500 ? 500 : 370), _ = B.expand, b = _ * B.expFactor), b > M && 1 > A && C > 2 && f > 2 && !D.hidden ? (M = b, C = 0) : M = f > 1 && C > 1 && 6 > A ? _ : S;
							for (; t > e; e++)
								if (c[e] && !c[e]._lazyRace)
									if (E)
										if ((s = c[e][z]("data-expand")) && (o = 1 * s) || (o = M), l !== o && (p = innerWidth + o * w, m = innerHeight + o, a = -1 * o, l = o), i = c[e].getBoundingClientRect(), (x = i.bottom) >= a && (g = i.top) <= m && (y = i.right) >= a * w && (v = i.left) <= p && (x || y || v || g) && (B.loadHidden || "hidden" != J(c[e], "visibility")) && (h && 3 > A && !s && (3 > f || 4 > C) || L(c[e], o))) {
											if (I(c[e]), r = !0, A > 9) break
										} else !r && h && !n && 4 > A && 4 > C && f > 2 && (u[0] || B.preloadAfterLoad) && (u[0] || !s && (x || y || v || g || "auto" != c[e][z](B.sizesAttr))) && (n = u[0] || c[e]);
							else I(c[e]);
							n && !r && I(n)
						}
					},
					i = tt(t),
					R = function (t) {
						X(t.target, B.loadedClass), Y(t.target, B.loadingClass), q(t.target, O), $(t.target, "lazyloaded")
					},
					n = K(R),
					O = function (t) {
						n({
							target: t.target
						})
					},
					k = function (e, i) {
						try {
							e.contentWindow.location.replace(i)
						} catch (t) {
							e.src = i
						}
					},
					N = function (t) {
						var e, i = t[z](B.srcsetAttr);
						(e = B.customMedia[t[z]("data-media") || t[z]("media")]) && t.setAttribute("media", e), i && t.setAttribute("srcset", i)
					},
					a = K(function (t, e, i, n, r) {
						var o, a, s, l, c, u;
						(c = $(t, "lazybeforeunveil", e)).defaultPrevented || (n && (i ? X(t, B.autosizesClass) : t.setAttribute("sizes", n)), a = t[z](B.srcsetAttr), o = t[z](B.srcAttr), r && (s = t.parentNode, l = s && j.test(s.nodeName || "")), u = e.firesLoad || "src" in t && (a || o || l), c = {
							target: t
						}, u && (q(t, P, !0), clearTimeout(d), d = H(P, 2500), X(t, B.loadingClass), q(t, O, !0)), l && V.call(s.getElementsByTagName("source"), N), a ? t.setAttribute("srcset", a) : o && !l && (T.test(t.nodeName) ? k(t, o) : t.src = o), r && (a || l) && Z(t, {
							src: o
						})), t._lazyRace && delete t._lazyRace, Y(t, B.lazyClass), Q(function () {
							(!u || t.complete && t.naturalWidth > 1) && (u ? P(c) : A--, R(c))
						}, !0)
					}),
					I = function (t) {
						var e, i = o.test(t.nodeName),
							n = i && (t[z](B.sizesAttr) || t[z]("sizes")),
							r = "auto" == n;
						(!r && h || !i || !t[z]("src") && !t.srcset || t.complete || W(t, B.errorClass) || !W(t, B.lazyClass)) && (e = $(t, "lazyunveilread").detail, r && it.updateElem(t, !0, t.offsetWidth), t._lazyRace = !0, A++, a(t, e, r, n, i))
					},
					r = function () {
						if (!h) {
							if (l.now() - e < 999) return void H(r, 999);
							var t = et(function () {
								B.loadMode = 3, i()
							});
							h = !0, B.loadMode = 3, i(), G("scroll", function () {
								3 == B.loadMode && (B.loadMode = 2), t()
							}, !0)
						}
					};
				return {
					_: function () {
						e = l.now(), F.elements = D.getElementsByClassName(B.lazyClass), u = D.getElementsByClassName(B.lazyClass + " " + B.preloadClass), w = B.hFac, G("scroll", i, !0), G("resize", i, !0), s.MutationObserver ? new MutationObserver(i).observe(U, {
							childList: !0,
							subtree: !0,
							attributes: !0
						}) : (U[c]("DOMNodeInserted", i, !0), U[c]("DOMAttrModified", i, !0), setInterval(i, 999)), G("hashchange", i, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (t) {
							D[c](t, i, !0)
						}), /d$|^c/.test(D.readyState) ? r() : (G("load", r), D[c]("DOMContentLoaded", i), H(r, 2e4)), F.elements.length ? (t(), Q._lsFlush()) : i()
					},
					checkElems: i,
					unveil: I
				}
			}(),
			it = function () {
				var i, o = K(function (t, e, i, n) {
						var r, o, a;
						if (t._lazysizesWidth = n, n += "px", t.setAttribute("sizes", n), j.test(e.nodeName || ""))
							for (r = e.getElementsByTagName("source"), o = 0, a = r.length; a > o; o++) r[o].setAttribute("sizes", n);
						i.detail.dataAttr || Z(t, i.detail)
					}),
					n = function (t, e, i) {
						var n, r = t.parentNode;
						r && (i = a(t, r, i), n = $(t, "lazybeforesizes", {
							width: i,
							dataAttr: !!e
						}), n.defaultPrevented || (i = n.detail.width, i && i !== t._lazysizesWidth && o(t, r, n, i)))
					},
					t = function () {
						var t, e = i.length;
						if (e)
							for (t = 0; e > t; t++) n(i[t])
					},
					e = et(t);
				return {
					_: function () {
						i = D.getElementsByClassName(B.autosizesClass), G("resize", e)
					},
					checkElems: e,
					updateElem: n
				}
			}(),
			o = function () {
				o.i || (o.i = !0, it._(), t._())
			};
		return F = {
			cfg: B,
			autoSizer: it,
			loader: t,
			init: o,
			uP: Z,
			aC: X,
			rC: Y,
			hC: W,
			fire: $,
			gW: a,
			rAF: Q
		}
	}
});

function elementSupportsAttribute(t, e) {
	var i = document.createElement(t);
	if (e in i) {
		return true
	} else {
		return false
	}
}
$.event.special.clickTouchEvent = {
	setup: function () {
		var t = "ontouchend" in document ? "touchend" : "click";
		$(this).on(t + ".myclickTouchEvent", function (t) {
			t.type = "clickTouchEvent";
			$.event.handle.apply(this, [t])
		})
	},
	teardown: function () {
		$(this).off(".clickTouchEvent")
	}
};
(function (d) {
	var f = {},
		i = "doTimeout",
		p = Array.prototype.slice;
	d[i] = function () {
		return n.apply(window, [0].concat(p.call(arguments)))
	};
	d.fn[i] = function () {
		var t = p.call(arguments),
			e = n.apply(this, [i + t[0]].concat(t));
		return typeof t[0] === "number" || typeof t[1] === "number" ? this : e
	};

	function n(t) {
		var e = this,
			i, n = {},
			r = t ? d.fn : d,
			o = arguments,
			a = 4,
			s = o[1],
			l = o[2],
			c = o[3];
		if (typeof s !== "string") {
			a--;
			s = t = 0;
			l = o[1];
			c = o[2]
		}
		if (t) {
			i = e.eq(0);
			i.data(t, n = i.data(t) || {})
		} else {
			if (s) {
				n = f[s] || (f[s] = {})
			}
		}
		n.id && clearTimeout(n.id);
		delete n.id;

		function u() {
			if (t) {
				i.removeData(t)
			} else {
				if (s) {
					delete f[s]
				}
			}
		}

		function h() {
			n.id = setTimeout(function () {
				n.fn()
			}, l)
		}
		if (c) {
			n.fn = function (t) {
				if (typeof c === "string") {
					c = r[c]
				}
				c.apply(e, p.call(o, a)) === true && !t ? h() : u()
			};
			h()
		} else {
			if (n.fn) {
				l === undefined ? u() : n.fn(l === false);
				return true
			} else {
				u()
			}
		}
	}
})(jQuery);
(function (t, h) {
	var e = t.jQuery || t.Cowboy || (t.Cowboy = {}),
		n;
	e.throttle = n = function (o, a, s, l) {
		var c, u = 0;
		if (typeof a !== "boolean") {
			l = s;
			s = a;
			a = h
		}

		function t() {
			var t = this,
				e = +new Date - u,
				i = arguments;

			function n() {
				u = +new Date;
				s.apply(t, i)
			}

			function r() {
				c = h
			}
			if (l && !c) {
				n()
			}
			c && clearTimeout(c);
			if (l === h && e > o) {
				n()
			} else {
				if (a !== true) {
					c = setTimeout(l ? r : n, l === h ? o - e : o)
				}
			}
		}
		if (e.guid) {
			t.guid = s.guid = s.guid || e.guid++
		}
		return t
	};
	e.debounce = function (t, e, i) {
		return i === h ? n(t, e, false) : n(t, i, e !== false)
	}
})(this);
(function (o, a, s) {
	o.map("click dblclick mousemove mousedown mouseup mouseover mouseout change select submit keydown keypress keyup".split(" "), function (t) {
		e(t)
	});
	e("focusin", "focus" + s);
	e("focusout", "blur" + s);
	o.addOutsideEvent = e;

	function e(t, i) {
		i = i || t + s;
		var n = o(),
			e = t + "." + i + "-special-event";
		o.event.special[i] = {
			setup: function () {
				n = n.add(this);
				if (n.length === 1) {
					o(a).bind(e, r)
				}
			},
			teardown: function () {
				n = n.not(this);
				if (n.length === 0) {
					o(a).unbind(e)
				}
			},
			add: function (t) {
				var i = t.handler;
				t.handler = function (t, e) {
					t.target = e;
					i.apply(this, arguments)
				}
			}
		};

		function r(e) {
			o(n).each(function () {
				var t = o(this);
				if (this !== e.target && !t.has(e.target).length) {
					t.triggerHandler(i, [e.target])
				}
			})
		}
	}
})(jQuery, document, "outside");
(function (s) {
	s.fn.animatePNG = function (i, n, r, o) {
		var a = 0;
		this.each(function () {
			var t = s(this),
				e = n;
			t.doTimeout("loop", r, function () {
				a++;
				if (a == e) {
					if (o == 0) {
						return false
					} else {
						a = 0
					}
				}
				t.css("backgroundPosition", "-" + a * i + "px 0px");
				return true
			});
			if (i == null) {
				t.doTimeout("loop")
			}
		})
	}
})(jQuery);
(function (i, s, t, e, n) {
	"use strict";
	s.extend({}).fn.extend({
		animateSpriteIMG: function (a) {
			a = s.extend({}, i, a);
			return s(this).each(function () {
				var t = s(this),
					e = 0,
					i = 0,
					n = 1,
					r = 1,
					o = 1;
				t.doTimeout("animation", a.speed, function () {
					if (n <= a.totalRow) {
						if (r < a.totalColumn) {
							if (o >= a.totalFrames) {
								o = 1;
								e = 0;
								i = 0;
								n = 1;
								r = 1;
								if (!a.loop) {
									t.attr("style", "");
									return false
								}
							}
							e = e + a.widthFrame;
							t.css({
								transform: "translate3d(-" + e + "px, -" + i + "px, 0px)"
							});
							r += 1
						} else {
							r = 1;
							n += 1;
							i = i + a.heightFrame;
							e = 0
						}
					} else {
						e = 0;
						i = 0;
						n = 1;
						r = 1
					}
					o += 1;
					return true
				});
				if (a.pause) {
					t.doTimeout("animation")
				}
				if (a.destroy) {
					t.doTimeout("animation");
					t.attr("style", "")
				}
			})
		},
		pause: function (t) {
			var e = s(this);
			e.animateSpriteIMG({
				pause: true
			});
			return s.extend(i, t)
		},
		destroy: function (t) {
			var e = s(this);
			e.animateSpriteIMG({
				destroy: true
			});
			return s.extend(i, t)
		}
	})
})({
	widthFrame: 0,
	heightFrame: 0,
	totalFrames: 0,
	totalRow: 1,
	totalColumn: 1,
	speed: 50,
	loop: false,
	pause: false,
	play: false,
	destroy: false
}, jQuery, window, document);
$(document).on("click", ".js-btn-goto", function () {
	var t = $(this);
	var e = t.attr("data-go");
	var i = $("" + e + "");
	can_scroll = false;
	goTo(i, 280);
	$.doTimeout(1500, function () {
		can_scroll = true
	});
	return false
});

function calculateHeight() {
	var t = $(window).height();
	return t
}

function calculateWidth() {
	var t = $(window).width();
	return t
}

function reloadPage() {
	location.reload();
	return false
}

function stopPlayScroll(t) {
	if (t) {
		$(document).on("mousewheel DOMMouseScroll", function (t) {
			preventDefault(t)
		});
		var e = $(document).scrollTop();
		$(document).on("scroll", function (t) {
			$(document).scrollTop(e);
			preventDefault(t)
		});
		$(document).on("touchmove", function (t) {
			preventDefault(t)
		})
	} else {
		$(document).off("mousewheel DOMMouseScroll");
		$(document).unbind("scroll");
		$(document).off("touchmove")
	}
}

function preventDefault(t) {
	t = t || window.event;
	if (t.preventDefault) {
		t.preventDefault()
	}
	t.returnValue = false
}

function goTo(t) {
	TweenMax.to(window, 1.5, {
		scrollTo: {
			y: t
		},
		ease: Power4.easeOut
	})
}

function resizeLikeCover(t) {
	t.each(function () {
		var t = $(this);
		var e = t.width(),
			i = t.height(),
			n = e / i;
		var r = t.parent(),
			o = r.width(),
			a = r.height(),
			s = o / a;
		if (o > a && s >= n) {
			t.css({
				width: o,
				height: "auto"
			});
			var l = parseInt(t.css("height")) - a;
			var c = parseInt(l / 2);
			t.css({
				top: -c,
				left: 0
			})
		} else {
			t.css({
				width: "auto",
				height: a
			});
			var u = parseInt(t.css("width")) - o;
			var h = parseInt(u / 2);
			t.css({
				left: -h,
				top: 0
			})
		}
	})
}(function (d) {
	d.fn.hoverIntent = function (t, e, i) {
		var n = {
			interval: 100,
			sensitivity: 6,
			timeout: 0
		};
		if (typeof t === "object") {
			n = d.extend(n, t)
		} else {
			if (d.isFunction(e)) {
				n = d.extend(n, {
					over: t,
					out: e,
					selector: i
				})
			} else {
				n = d.extend(n, {
					over: t,
					out: t,
					selector: e
				})
			}
		}
		var r, o, a, s;
		var l = function (t) {
			r = t.pageX;
			o = t.pageY
		};
		var c = function (t, e) {
			e.hoverIntent_t = clearTimeout(e.hoverIntent_t);
			if (Math.sqrt((a - r) * (a - r) + (s - o) * (s - o)) < n.sensitivity) {
				d(e).off("mousemove.hoverIntent", l);
				e.hoverIntent_s = true;
				return n.over.apply(e, [t])
			} else {
				a = r;
				s = o;
				e.hoverIntent_t = setTimeout(function () {
					c(t, e)
				}, n.interval)
			}
		};
		var u = function (t, e) {
			e.hoverIntent_t = clearTimeout(e.hoverIntent_t);
			e.hoverIntent_s = false;
			return n.out.apply(e, [t])
		};
		var h = function (t) {
			var e = d.extend({}, t);
			var i = this;
			if (i.hoverIntent_t) {
				i.hoverIntent_t = clearTimeout(i.hoverIntent_t)
			}
			if (t.type === "mouseenter") {
				a = e.pageX;
				s = e.pageY;
				d(i).on("mousemove.hoverIntent", l);
				if (!i.hoverIntent_s) {
					i.hoverIntent_t = setTimeout(function () {
						c(e, i)
					}, n.interval)
				}
			} else {
				d(i).off("mousemove.hoverIntent", l);
				if (i.hoverIntent_s) {
					i.hoverIntent_t = setTimeout(function () {
						u(e, i)
					}, n.timeout)
				}
			}
		};
		return this.on({
			"mouseenter.hoverIntent": h,
			"mouseleave.hoverIntent": h
		}, n.selector)
	}
})(jQuery);
var keys = {
	37: 1,
	38: 1,
	39: 1,
	40: 1
};

function preventDefault(t) {
	t = t || window.event;
	if (t.preventDefault) t.preventDefault();
	t.returnValue = false
}

function preventDefaultForScrollKeys(t) {
	if (keys[t.keyCode]) {
		preventDefault(t);
		return false
	}
}

function disableScroll() {
	if (window.addEventListener) window.addEventListener("DOMMouseScroll", preventDefault, false);
	window.onwheel = preventDefault;
	window.onmousewheel = document.onmousewheel = preventDefault;
	window.ontouchmove = preventDefault;
	document.onkeydown = preventDefaultForScrollKeys
}

function enableScroll() {
	if (window.removeEventListener) window.removeEventListener("DOMMouseScroll", preventDefault, false);
	window.onmousewheel = document.onmousewheel = null;
	window.onwheel = null;
	window.ontouchmove = null;
	document.onkeydown = null
}

function validateForm(e) {
	e.find(".formMsg").hide();
	var i = 0;
	e.find(".required").each(function () {
		var t = $(this);
		var e = this.defaultValue;
		i += check(t, e, i)
	});
	if (e.find(".password-confirm").length > 0) {
		e.find(".password-confirm").each(function () {
			var t = $(this);
			i += validatePasswords(e, t)
		})
	}
	if (i > 0) {
		return false
	} else {
		return true
	}
}

function resetForm(t) {
	var e = t.find("input"),
		i = t.find("textarea");
	i.each(function () {
		var t = $(this);
		t.removeClass("erro");
		t.attr("value", "")
	});
	e.each(function () {
		var t = $(this);
		t.removeClass("erro");
		t.attr("value", "")
	})
}

function check(t, e, i) {
	var i = 0;
	if (t.hasClass("check-box")) {
		if (!validateCheckBox(t)) {
			i += 1
		}
	}
	if (t.hasClass("min-length")) {
		if (!validateLength(t)) {
			i += 1
		}
	}
	if (t.hasClass("exact-length")) {
		if (!validateExactLength(t)) {
			i += 1
		}
	}
	if (t.hasClass("month-credit-card")) {
		if (!validateCreditCardMonth(t)) {
			i += 1
		}
	}
	if (t.hasClass("year-credit-card")) {
		if (!validateCreditCardYear(t)) {
			i += 1
		}
	}
	if (t.hasClass("email")) {
		if (!validateEmail(t)) {
			i += 1
		}
	}
	if (t.hasClass("phone")) {
		if (!validatePhone(t)) {
			i += 1
		}
	}
	if (t.hasClass("birthdate")) {
		if (!validateBirthdate(t)) {
			i += 1
		}
	}
	if (t.hasClass("number")) {
		if (!validateNumbers(t)) {
			i += 1
		}
	}
	if (t.hasClass("select")) {
		if (!validateSelect(t)) {
			i += 1;
			t.parent().addClass("erro");
			return i
		} else {
			t.parent().removeClass("erro");
			return i
		}
	}
	if (t.hasClass("cap")) {
		if (t.val() == "" || t.val() == e) {
			t.parent().children("span").addClass("on");
			i += 1;
			t.parent().addClass("erro")
		} else {
			t.parent().children("span").removeClass("on");
			t.parent().removeClass("erro")
		}
	}
	if (t.val() == "" || t.val() == e) {
		i += 1
	}
	if (i > 0) {
		t.addClass("erro");
		t.parent(".input").addClass("erro")
	} else {
		t.removeClass("erro");
		t.parent(".input").removeClass("erro")
	}
	return i
}

function validatePasswords(t, e) {
	var i = "",
		n = 0;
	if (e.length > 0) e.addClass("first-focus");
	t.find(".password-confirm").each(function () {
		var t = $(this);
		if (t.val() == "" && !t.hasClass("required")) n = 0;
		if (t.val() == "" && t.hasClass("required")) n += 1;
		if (t.hasClass("min-length") && !validateLength(t)) {
			n += 1
		}
		if (i == "") i = t.val();
		else if (i == t.val())
			if (n > 0) n -= 1;
			else n = 0;
		else n += 1;
		if (t.hasClass("first-focus")) {
			if (n > 0) t.addClass("erro");
			else t.removeClass("erro")
		}
	});
	return n
}

function validateCheckBox(t) {
	if (t.is(":checked")) return true;
	else return false
}

function validateLength(t) {
	var e = t.val(),
		i = t.attr("data-length");
	if (e.length >= i) return true;
	else return false
}

function validateExactLength(t) {
	var e = t.val(),
		i = t.attr("data-length");
	if (e.length == i) return true;
	else return false
}

function validateCreditCardMonth(t) {
	var e = t.val();
	if (e <= 12) return true;
	else return false
}

function validateCreditCardYear(t) {
	var e = t.val(),
		i = new Date;
	n = i.getFullYear();
	n = n.toString().substr(2);
	if (e >= n && n <= 99) return true;
	else return false
}

function validateEmail(t) {
	var e = t.val();
	var i = new RegExp(/^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,15}$/i);
	if (i.test(e)) {
		return true
	} else {
		return false
	}
}

function validatePhone(t) {
	var e = t.val();
	console.log(t);
	var i = /^[+]?[0-9 ]{9,}$/;
	if (i.test(e)) {
		return true
	} else {
		return false
	}
}

function validateBirthdate(t) {
	var e = t.val();
	var i = /^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/g;
	if (i.test(e)) {
		return true
	} else {
		return false
	}
}

function validateNumbers(t) {
	var e = t.val();
	var i = /^[+-]?[0-9]{1,9}(?:\.[0-9]{1,2})?$/i;
	if (i.test(e)) {
		return true
	} else {
		return false
	}
}

function validateSelect(e) {
	e.each(function () {
		var t = e.attr("checked");
		if (t == "checked") {
			return true
		} else {
			return false
		}
	})
}

function onlyNumber(t) {
	if (t.shiftKey) {
		t.preventDefault()
	}
	if (t.keyCode == 46 || t.keyCode == 8 || t.keyCode == 190 || t.keyCode == 188) {} else {
		if (t.keyCode < 95) {
			if (t.keyCode < 48 || t.keyCode > 57) {
				t.preventDefault()
			}
		} else {
			if (t.keyCode < 96 || t.keyCode > 105) {
				t.preventDefault()
			}
		}
	}
}
